var T6 = Object.defineProperty, k6 = Object.defineProperties;
var E6 = Object.getOwnPropertyDescriptors;
var Bi = Object.getOwnPropertySymbols;
var Ch = Object.prototype.hasOwnProperty, wh = Object.prototype.propertyIsEnumerable;
var _h = (e, t, n) => t in e ? T6(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, ae = (e, t) => {
  for (var n in t || (t = {}))
    Ch.call(t, n) && _h(e, n, t[n]);
  if (Bi)
    for (var n of Bi(t))
      wh.call(t, n) && _h(e, n, t[n]);
  return e;
}, ge = (e, t) => k6(e, E6(t));
var ia = (e, t) => {
  var n = {};
  for (var r in e)
    Ch.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && Bi)
    for (var r of Bi(e))
      t.indexOf(r) < 0 && wh.call(e, r) && (n[r] = e[r]);
  return n;
};
import { createElementBlock as f, openBlock as d, Fragment as J, renderList as ne, createElementVNode as c, createBlock as L, resolveDynamicComponent as Y, resolveComponent as V, normalizeStyle as Z, renderSlot as M, createVNode as j, normalizeClass as _, createCommentVNode as T, toDisplayString as k, createTextVNode as H, withCtx as S, TransitionGroup as Zn, resolveDirective as ze, withDirectives as we, withKeys as K, withModifiers as W, Transition as Le, vModelText as S6, unref as po, getCurrentScope as ag, onScopeDispose as s0, ref as zt, computed as Re, watch as ko, vShow as qn, nextTick as ri, normalizeProps as M6, guardReactiveProps as A6, mergeProps as Se, onMounted as Ts, getCurrentInstance as a0, hasInjectionContext as lg, inject as I6, toValue as Dr, shallowRef as kc, watchEffect as L6, useTemplateRef as D6, createSlots as ug, defineComponent as $6, h as oo, onUnmounted as dg } from "vue";
function Th(e) {
  return e.type.indexOf("mouse") !== -1 ? e.clientX : e.touches[0].clientX;
}
function kh(e) {
  return e.type.indexOf("mouse") !== -1 ? e.clientY : e.touches[0].clientY;
}
var O6 = function() {
  var e = !1;
  try {
    var t = Object.defineProperty({}, "passive", {
      get: function() {
        e = !0;
      }
    });
    window.addEventListener("test", null, t);
  } catch (n) {
  }
  return e;
}(), P6 = {
  install: function(e, t) {
    var n = Object.assign({}, {
      disableClick: !1,
      tapTolerance: 10,
      // px
      swipeTolerance: 30,
      // px
      touchHoldTolerance: 400,
      // ms
      longTapTimeInterval: 400,
      // ms
      touchClass: "",
      dragFrequency: 100,
      // ms
      rollOverFrequency: 100,
      // ms
      namespace: "touch"
    }, t);
    function r(C) {
      var A = this.$$touchObj, R = C.type.indexOf("touch") >= 0, P = C.type.indexOf("mouse") >= 0, F = this;
      R && (A.lastTouchStartTime = C.timeStamp), !(P && A.lastTouchStartTime && C.timeStamp - A.lastTouchStartTime < 350) && (A.touchStarted || (v(this), A.touchStarted = !0, A.touchMoved = !1, A.swipeOutBounded = !1, A.startX = Th(C), A.startY = kh(C), A.currentX = 0, A.currentY = 0, A.touchStartTime = C.timeStamp, A.hasSwipe = u(this, "swipe") || u(this, "swipe.left") || u(this, "swipe.right") || u(this, "swipe.top") || u(this, "swipe.bottom"), u(this, "hold") && (A.touchHoldTimer = setTimeout(function() {
        A.touchHoldTimer = null, m(C, F, "hold");
      }, A.options.touchHoldTolerance)), m(C, this, "press")));
    }
    function o(C) {
      var A = this.$$touchObj, R = Th(C), P = kh(C), F = A.currentX != R || A.currentY != P;
      if (A.currentX = R, A.currentY = P, A.touchMoved) {
        if (A.hasSwipe && !A.swipeOutBounded) {
          var D = A.options.swipeTolerance;
          A.swipeOutBounded = Math.abs(A.startX - A.currentX) > D && Math.abs(A.startY - A.currentY) > D;
        }
      } else {
        var I = A.options.tapTolerance;
        A.touchMoved = Math.abs(A.startX - A.currentX) > I || Math.abs(A.startY - A.currentY) > I, A.touchMoved && (h(A), m(C, this, "drag.once"));
      }
      if (u(this, "rollover") && F) {
        var O = C.timeStamp, U = A.options.rollOverFrequency;
        (A.touchRollTime == null || O > A.touchRollTime + U) && (A.touchRollTime = O, m(C, this, "rollover"));
      }
      if (u(this, "drag") && A.touchStarted && A.touchMoved && F) {
        var O = C.timeStamp, U = A.options.dragFrequency;
        (A.touchDragTime == null || O > A.touchDragTime + U) && (A.touchDragTime = O, m(C, this, "drag"));
      }
    }
    function i() {
      var C = this.$$touchObj;
      h(C), g(this), C.touchStarted = C.touchMoved = !1, C.startX = C.startY = 0;
    }
    function a(C) {
      var A = this.$$touchObj, R = C.type.indexOf("touch") >= 0, P = C.type.indexOf("mouse") >= 0;
      R && (A.lastTouchEndTime = C.timeStamp);
      var F = R && !A.touchHoldTimer;
      if (h(A), A.touchStarted = !1, g(this), !(P && A.lastTouchEndTime && C.timeStamp - A.lastTouchEndTime < 350))
        if (m(C, this, "release"), A.touchMoved) {
          if (A.hasSwipe && !A.swipeOutBounded) {
            var I = A.options.swipeTolerance, D, O = Math.abs(A.startY - A.currentY), U = Math.abs(A.startX - A.currentX);
            (O > I || U > I) && (O > U ? D = A.startY > A.currentY ? "top" : "bottom" : D = A.startX > A.currentX ? "left" : "right", u(this, "swipe." + D) ? m(C, this, "swipe." + D, D) : m(C, this, "swipe", D));
          }
        } else if (u(this, "longtap") && C.timeStamp - A.touchStartTime > A.options.longTapTimeInterval)
          C.cancelable && C.preventDefault(), m(C, this, "longtap");
        else if (u(this, "hold") && F) {
          C.cancelable && C.preventDefault();
          return;
        } else
          m(C, this, "tap");
    }
    function s() {
      v(this);
    }
    function l() {
      g(this);
    }
    function u(C, A) {
      var R = C.$$touchObj.callbacks[A];
      return R != null && R.length > 0;
    }
    function m(C, A, R, P) {
      var F = A.$$touchObj, I = F.callbacks[R];
      if (I == null || I.length === 0)
        return null;
      for (var D = 0; D < I.length; D++) {
        var O = I[D];
        O.modifiers.stop && C.stopPropagation(), O.modifiers.prevent && C.preventDefault(), !(O.modifiers.self && C.target !== C.currentTarget) && typeof O.value == "function" && (P ? O.value(P, C) : O.value(C));
      }
    }
    function v(C) {
      var A = C.$$touchObj.options.touchClass;
      A && C.classList.add(A);
    }
    function g(C) {
      var A = C.$$touchObj.options.touchClass;
      A && C.classList.remove(A);
    }
    function h(C) {
      C && C.touchHoldTimer && (clearTimeout(C.touchHoldTimer), C.touchHoldTimer = null);
    }
    function E(C, A) {
      var R = C.$$touchObj || {
        // an object contains all callbacks registered,
        // key is event name, value is an array
        callbacks: {},
        // prevent bind twice, set to true when event bound
        hasBindTouchEvents: !1,
        // default options, would be override by v-touch-options
        options: n
      };
      return A && (R.options = Object.assign({}, R.options, A)), C.$$touchObj = R, C.$$touchObj;
    }
    e.directive(n.namespace, {
      beforeMount: function(C, A) {
        var R = E(C), P = O6 ? { passive: !0 } : !1, F = A.arg || "tap";
        switch (F) {
          case "swipe":
            var I = A.modifiers;
            if (I.left || I.right || I.top || I.bottom) {
              for (var D in A.modifiers)
                if (["left", "right", "top", "bottom"].indexOf(D) >= 0) {
                  var O = "swipe." + D;
                  R.callbacks[O] = R.callbacks[O] || [], R.callbacks[O].push(A);
                }
            } else
              R.callbacks.swipe = R.callbacks.swipe || [], R.callbacks.swipe.push(A);
            break;
          case "press":
          case "drag":
            A.modifiers.disablePassive && (P = !1);
          default:
            R.callbacks[F] = R.callbacks[F] || [], R.callbacks[F].push(A);
        }
        R.hasBindTouchEvents || (C.addEventListener("touchstart", r, P), C.addEventListener("touchmove", o, P), C.addEventListener("touchcancel", i), C.addEventListener("touchend", a), R.options.disableClick || (C.addEventListener("mousedown", r), C.addEventListener("mousemove", o), C.addEventListener("mouseup", a), C.addEventListener("mouseenter", s), C.addEventListener("mouseleave", l)), R.hasBindTouchEvents = !0);
      },
      unmounted: function(C) {
        h(C.$$touchObj), C.removeEventListener("touchstart", r), C.removeEventListener("touchmove", o), C.removeEventListener("touchcancel", i), C.removeEventListener("touchend", a), C.$$touchObj && !C.$$touchObj.options.disableClick && (C.removeEventListener("mousedown", r), C.removeEventListener("mousemove", o), C.removeEventListener("mouseup", a), C.removeEventListener("mouseenter", s), C.removeEventListener("mouseleave", l)), delete C.$$touchObj;
      }
    }), e.directive(`${n.namespace}-class`, {
      beforeMount: function(C, A) {
        E(C, {
          touchClass: A.value
        });
      }
    }), e.directive(`${n.namespace}-options`, {
      beforeMount: function(C, A) {
        E(C, A.value);
      }
    });
  }
}, ji = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function Eo(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var sa, Eh;
function Br() {
  if (Eh) return sa;
  Eh = 1;
  var e = Array.isArray;
  return sa = e, sa;
}
var aa, Sh;
function cg() {
  if (Sh) return aa;
  Sh = 1;
  var e = typeof ji == "object" && ji && ji.Object === Object && ji;
  return aa = e, aa;
}
var la, Mh;
function hn() {
  if (Mh) return la;
  Mh = 1;
  var e = cg(), t = typeof self == "object" && self && self.Object === Object && self, n = e || t || Function("return this")();
  return la = n, la;
}
var ua, Ah;
function ks() {
  if (Ah) return ua;
  Ah = 1;
  var e = hn(), t = e.Symbol;
  return ua = t, ua;
}
var da, Ih;
function N6() {
  if (Ih) return da;
  Ih = 1;
  var e = ks(), t = Object.prototype, n = t.hasOwnProperty, r = t.toString, o = e ? e.toStringTag : void 0;
  function i(a) {
    var s = n.call(a, o), l = a[o];
    try {
      a[o] = void 0;
      var u = !0;
    } catch (v) {
    }
    var m = r.call(a);
    return u && (s ? a[o] = l : delete a[o]), m;
  }
  return da = i, da;
}
var ca, Lh;
function H6() {
  if (Lh) return ca;
  Lh = 1;
  var e = Object.prototype, t = e.toString;
  function n(r) {
    return t.call(r);
  }
  return ca = n, ca;
}
var ha, Dh;
function pi() {
  if (Dh) return ha;
  Dh = 1;
  var e = ks(), t = N6(), n = H6(), r = "[object Null]", o = "[object Undefined]", i = e ? e.toStringTag : void 0;
  function a(s) {
    return s == null ? s === void 0 ? o : r : i && i in Object(s) ? t(s) : n(s);
  }
  return ha = a, ha;
}
var ma, $h;
function So() {
  if ($h) return ma;
  $h = 1;
  function e(t) {
    return t != null && typeof t == "object";
  }
  return ma = e, ma;
}
var fa, Oh;
function Es() {
  if (Oh) return fa;
  Oh = 1;
  var e = pi(), t = So(), n = "[object Symbol]";
  function r(o) {
    return typeof o == "symbol" || t(o) && e(o) == n;
  }
  return fa = r, fa;
}
var pa, Ph;
function F6() {
  if (Ph) return pa;
  Ph = 1;
  var e = Br(), t = Es(), n = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, r = /^\w*$/;
  function o(i, a) {
    if (e(i))
      return !1;
    var s = typeof i;
    return s == "number" || s == "symbol" || s == "boolean" || i == null || t(i) ? !0 : r.test(i) || !n.test(i) || a != null && i in Object(a);
  }
  return pa = o, pa;
}
var ga, Nh;
function dr() {
  if (Nh) return ga;
  Nh = 1;
  function e(t) {
    var n = typeof t;
    return t != null && (n == "object" || n == "function");
  }
  return ga = e, ga;
}
var va, Hh;
function hg() {
  if (Hh) return va;
  Hh = 1;
  var e = pi(), t = dr(), n = "[object AsyncFunction]", r = "[object Function]", o = "[object GeneratorFunction]", i = "[object Proxy]";
  function a(s) {
    if (!t(s))
      return !1;
    var l = e(s);
    return l == r || l == o || l == n || l == i;
  }
  return va = a, va;
}
var ba, Fh;
function R6() {
  if (Fh) return ba;
  Fh = 1;
  var e = hn(), t = e["__core-js_shared__"];
  return ba = t, ba;
}
var ya, Rh;
function V6() {
  if (Rh) return ya;
  Rh = 1;
  var e = R6(), t = function() {
    var r = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return r ? "Symbol(src)_1." + r : "";
  }();
  function n(r) {
    return !!t && t in r;
  }
  return ya = n, ya;
}
var _a, Vh;
function mg() {
  if (Vh) return _a;
  Vh = 1;
  var e = Function.prototype, t = e.toString;
  function n(r) {
    if (r != null) {
      try {
        return t.call(r);
      } catch (o) {
      }
      try {
        return r + "";
      } catch (o) {
      }
    }
    return "";
  }
  return _a = n, _a;
}
var Ca, Bh;
function B6() {
  if (Bh) return Ca;
  Bh = 1;
  var e = hg(), t = V6(), n = dr(), r = mg(), o = /[\\^$.*+?()[\]{}|]/g, i = /^\[object .+?Constructor\]$/, a = Function.prototype, s = Object.prototype, l = a.toString, u = s.hasOwnProperty, m = RegExp(
    "^" + l.call(u).replace(o, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function v(g) {
    if (!n(g) || t(g))
      return !1;
    var h = e(g) ? m : i;
    return h.test(r(g));
  }
  return Ca = v, Ca;
}
var wa, jh;
function j6() {
  if (jh) return wa;
  jh = 1;
  function e(t, n) {
    return t == null ? void 0 : t[n];
  }
  return wa = e, wa;
}
var Ta, Uh;
function jr() {
  if (Uh) return Ta;
  Uh = 1;
  var e = B6(), t = j6();
  function n(r, o) {
    var i = t(r, o);
    return e(i) ? i : void 0;
  }
  return Ta = n, Ta;
}
var ka, qh;
function Ss() {
  if (qh) return ka;
  qh = 1;
  var e = jr(), t = e(Object, "create");
  return ka = t, ka;
}
var Ea, Gh;
function U6() {
  if (Gh) return Ea;
  Gh = 1;
  var e = Ss();
  function t() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return Ea = t, Ea;
}
var Sa, Kh;
function q6() {
  if (Kh) return Sa;
  Kh = 1;
  function e(t) {
    var n = this.has(t) && delete this.__data__[t];
    return this.size -= n ? 1 : 0, n;
  }
  return Sa = e, Sa;
}
var Ma, zh;
function G6() {
  if (zh) return Ma;
  zh = 1;
  var e = Ss(), t = "__lodash_hash_undefined__", n = Object.prototype, r = n.hasOwnProperty;
  function o(i) {
    var a = this.__data__;
    if (e) {
      var s = a[i];
      return s === t ? void 0 : s;
    }
    return r.call(a, i) ? a[i] : void 0;
  }
  return Ma = o, Ma;
}
var Aa, Zh;
function K6() {
  if (Zh) return Aa;
  Zh = 1;
  var e = Ss(), t = Object.prototype, n = t.hasOwnProperty;
  function r(o) {
    var i = this.__data__;
    return e ? i[o] !== void 0 : n.call(i, o);
  }
  return Aa = r, Aa;
}
var Ia, xh;
function z6() {
  if (xh) return Ia;
  xh = 1;
  var e = Ss(), t = "__lodash_hash_undefined__";
  function n(r, o) {
    var i = this.__data__;
    return this.size += this.has(r) ? 0 : 1, i[r] = e && o === void 0 ? t : o, this;
  }
  return Ia = n, Ia;
}
var La, Wh;
function Z6() {
  if (Wh) return La;
  Wh = 1;
  var e = U6(), t = q6(), n = G6(), r = K6(), o = z6();
  function i(a) {
    var s = -1, l = a == null ? 0 : a.length;
    for (this.clear(); ++s < l; ) {
      var u = a[s];
      this.set(u[0], u[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = t, i.prototype.get = n, i.prototype.has = r, i.prototype.set = o, La = i, La;
}
var Da, Yh;
function x6() {
  if (Yh) return Da;
  Yh = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return Da = e, Da;
}
var $a, Xh;
function l0() {
  if (Xh) return $a;
  Xh = 1;
  function e(t, n) {
    return t === n || t !== t && n !== n;
  }
  return $a = e, $a;
}
var Oa, Qh;
function Ms() {
  if (Qh) return Oa;
  Qh = 1;
  var e = l0();
  function t(n, r) {
    for (var o = n.length; o--; )
      if (e(n[o][0], r))
        return o;
    return -1;
  }
  return Oa = t, Oa;
}
var Pa, Jh;
function W6() {
  if (Jh) return Pa;
  Jh = 1;
  var e = Ms(), t = Array.prototype, n = t.splice;
  function r(o) {
    var i = this.__data__, a = e(i, o);
    if (a < 0)
      return !1;
    var s = i.length - 1;
    return a == s ? i.pop() : n.call(i, a, 1), --this.size, !0;
  }
  return Pa = r, Pa;
}
var Na, e2;
function Y6() {
  if (e2) return Na;
  e2 = 1;
  var e = Ms();
  function t(n) {
    var r = this.__data__, o = e(r, n);
    return o < 0 ? void 0 : r[o][1];
  }
  return Na = t, Na;
}
var Ha, t2;
function X6() {
  if (t2) return Ha;
  t2 = 1;
  var e = Ms();
  function t(n) {
    return e(this.__data__, n) > -1;
  }
  return Ha = t, Ha;
}
var Fa, n2;
function Q6() {
  if (n2) return Fa;
  n2 = 1;
  var e = Ms();
  function t(n, r) {
    var o = this.__data__, i = e(o, n);
    return i < 0 ? (++this.size, o.push([n, r])) : o[i][1] = r, this;
  }
  return Fa = t, Fa;
}
var Ra, r2;
function As() {
  if (r2) return Ra;
  r2 = 1;
  var e = x6(), t = W6(), n = Y6(), r = X6(), o = Q6();
  function i(a) {
    var s = -1, l = a == null ? 0 : a.length;
    for (this.clear(); ++s < l; ) {
      var u = a[s];
      this.set(u[0], u[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = t, i.prototype.get = n, i.prototype.has = r, i.prototype.set = o, Ra = i, Ra;
}
var Va, o2;
function u0() {
  if (o2) return Va;
  o2 = 1;
  var e = jr(), t = hn(), n = e(t, "Map");
  return Va = n, Va;
}
var Ba, i2;
function J6() {
  if (i2) return Ba;
  i2 = 1;
  var e = Z6(), t = As(), n = u0();
  function r() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (n || t)(),
      string: new e()
    };
  }
  return Ba = r, Ba;
}
var ja, s2;
function e7() {
  if (s2) return ja;
  s2 = 1;
  function e(t) {
    var n = typeof t;
    return n == "string" || n == "number" || n == "symbol" || n == "boolean" ? t !== "__proto__" : t === null;
  }
  return ja = e, ja;
}
var Ua, a2;
function Is() {
  if (a2) return Ua;
  a2 = 1;
  var e = e7();
  function t(n, r) {
    var o = n.__data__;
    return e(r) ? o[typeof r == "string" ? "string" : "hash"] : o.map;
  }
  return Ua = t, Ua;
}
var qa, l2;
function t7() {
  if (l2) return qa;
  l2 = 1;
  var e = Is();
  function t(n) {
    var r = e(this, n).delete(n);
    return this.size -= r ? 1 : 0, r;
  }
  return qa = t, qa;
}
var Ga, u2;
function n7() {
  if (u2) return Ga;
  u2 = 1;
  var e = Is();
  function t(n) {
    return e(this, n).get(n);
  }
  return Ga = t, Ga;
}
var Ka, d2;
function r7() {
  if (d2) return Ka;
  d2 = 1;
  var e = Is();
  function t(n) {
    return e(this, n).has(n);
  }
  return Ka = t, Ka;
}
var za, c2;
function o7() {
  if (c2) return za;
  c2 = 1;
  var e = Is();
  function t(n, r) {
    var o = e(this, n), i = o.size;
    return o.set(n, r), this.size += o.size == i ? 0 : 1, this;
  }
  return za = t, za;
}
var Za, h2;
function fg() {
  if (h2) return Za;
  h2 = 1;
  var e = J6(), t = t7(), n = n7(), r = r7(), o = o7();
  function i(a) {
    var s = -1, l = a == null ? 0 : a.length;
    for (this.clear(); ++s < l; ) {
      var u = a[s];
      this.set(u[0], u[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = t, i.prototype.get = n, i.prototype.has = r, i.prototype.set = o, Za = i, Za;
}
var xa, m2;
function i7() {
  if (m2) return xa;
  m2 = 1;
  var e = fg(), t = "Expected a function";
  function n(r, o) {
    if (typeof r != "function" || o != null && typeof o != "function")
      throw new TypeError(t);
    var i = function() {
      var a = arguments, s = o ? o.apply(this, a) : a[0], l = i.cache;
      if (l.has(s))
        return l.get(s);
      var u = r.apply(this, a);
      return i.cache = l.set(s, u) || l, u;
    };
    return i.cache = new (n.Cache || e)(), i;
  }
  return n.Cache = e, xa = n, xa;
}
var Wa, f2;
function s7() {
  if (f2) return Wa;
  f2 = 1;
  var e = i7(), t = 500;
  function n(r) {
    var o = e(r, function(a) {
      return i.size === t && i.clear(), a;
    }), i = o.cache;
    return o;
  }
  return Wa = n, Wa;
}
var Ya, p2;
function a7() {
  if (p2) return Ya;
  p2 = 1;
  var e = s7(), t = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, n = /\\(\\)?/g, r = e(function(o) {
    var i = [];
    return o.charCodeAt(0) === 46 && i.push(""), o.replace(t, function(a, s, l, u) {
      i.push(l ? u.replace(n, "$1") : s || a);
    }), i;
  });
  return Ya = r, Ya;
}
var Xa, g2;
function l7() {
  if (g2) return Xa;
  g2 = 1;
  function e(t, n) {
    for (var r = -1, o = t == null ? 0 : t.length, i = Array(o); ++r < o; )
      i[r] = n(t[r], r, t);
    return i;
  }
  return Xa = e, Xa;
}
var Qa, v2;
function u7() {
  if (v2) return Qa;
  v2 = 1;
  var e = ks(), t = l7(), n = Br(), r = Es(), o = e ? e.prototype : void 0, i = o ? o.toString : void 0;
  function a(s) {
    if (typeof s == "string")
      return s;
    if (n(s))
      return t(s, a) + "";
    if (r(s))
      return i ? i.call(s) : "";
    var l = s + "";
    return l == "0" && 1 / s == -1 / 0 ? "-0" : l;
  }
  return Qa = a, Qa;
}
var Ja, b2;
function d7() {
  if (b2) return Ja;
  b2 = 1;
  var e = u7();
  function t(n) {
    return n == null ? "" : e(n);
  }
  return Ja = t, Ja;
}
var el, y2;
function c7() {
  if (y2) return el;
  y2 = 1;
  var e = Br(), t = F6(), n = a7(), r = d7();
  function o(i, a) {
    return e(i) ? i : t(i, a) ? [i] : n(r(i));
  }
  return el = o, el;
}
var tl, _2;
function h7() {
  if (_2) return tl;
  _2 = 1;
  var e = Es();
  function t(n) {
    if (typeof n == "string" || e(n))
      return n;
    var r = n + "";
    return r == "0" && 1 / n == -1 / 0 ? "-0" : r;
  }
  return tl = t, tl;
}
var nl, C2;
function m7() {
  if (C2) return nl;
  C2 = 1;
  var e = c7(), t = h7();
  function n(r, o) {
    o = e(o, r);
    for (var i = 0, a = o.length; r != null && i < a; )
      r = r[t(o[i++])];
    return i && i == a ? r : void 0;
  }
  return nl = n, nl;
}
var rl, w2;
function f7() {
  if (w2) return rl;
  w2 = 1;
  var e = m7();
  function t(n, r, o) {
    var i = n == null ? void 0 : e(n, r);
    return i === void 0 ? o : i;
  }
  return rl = t, rl;
}
var p7 = f7();
const $ = /* @__PURE__ */ Eo(p7);
function as(e) {
  "@babel/helpers - typeof";
  return as = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, as(e);
}
var g7 = /^\s+/, v7 = /\s+$/;
function ue(e, t) {
  if (e = e || "", t = t || {}, e instanceof ue)
    return e;
  if (!(this instanceof ue))
    return new ue(e, t);
  var n = b7(e);
  this._originalInput = e, this._r = n.r, this._g = n.g, this._b = n.b, this._a = n.a, this._roundA = Math.round(100 * this._a) / 100, this._format = t.format || n.format, this._gradientType = t.gradientType, this._r < 1 && (this._r = Math.round(this._r)), this._g < 1 && (this._g = Math.round(this._g)), this._b < 1 && (this._b = Math.round(this._b)), this._ok = n.ok;
}
ue.prototype = {
  isDark: function() {
    return this.getBrightness() < 128;
  },
  isLight: function() {
    return !this.isDark();
  },
  isValid: function() {
    return this._ok;
  },
  getOriginalInput: function() {
    return this._originalInput;
  },
  getFormat: function() {
    return this._format;
  },
  getAlpha: function() {
    return this._a;
  },
  getBrightness: function() {
    var t = this.toRgb();
    return (t.r * 299 + t.g * 587 + t.b * 114) / 1e3;
  },
  getLuminance: function() {
    var t = this.toRgb(), n, r, o, i, a, s;
    return n = t.r / 255, r = t.g / 255, o = t.b / 255, n <= 0.03928 ? i = n / 12.92 : i = Math.pow((n + 0.055) / 1.055, 2.4), r <= 0.03928 ? a = r / 12.92 : a = Math.pow((r + 0.055) / 1.055, 2.4), o <= 0.03928 ? s = o / 12.92 : s = Math.pow((o + 0.055) / 1.055, 2.4), 0.2126 * i + 0.7152 * a + 0.0722 * s;
  },
  setAlpha: function(t) {
    return this._a = pg(t), this._roundA = Math.round(100 * this._a) / 100, this;
  },
  toHsv: function() {
    var t = k2(this._r, this._g, this._b);
    return {
      h: t.h * 360,
      s: t.s,
      v: t.v,
      a: this._a
    };
  },
  toHsvString: function() {
    var t = k2(this._r, this._g, this._b), n = Math.round(t.h * 360), r = Math.round(t.s * 100), o = Math.round(t.v * 100);
    return this._a == 1 ? "hsv(" + n + ", " + r + "%, " + o + "%)" : "hsva(" + n + ", " + r + "%, " + o + "%, " + this._roundA + ")";
  },
  toHsl: function() {
    var t = T2(this._r, this._g, this._b);
    return {
      h: t.h * 360,
      s: t.s,
      l: t.l,
      a: this._a
    };
  },
  toHslString: function() {
    var t = T2(this._r, this._g, this._b), n = Math.round(t.h * 360), r = Math.round(t.s * 100), o = Math.round(t.l * 100);
    return this._a == 1 ? "hsl(" + n + ", " + r + "%, " + o + "%)" : "hsla(" + n + ", " + r + "%, " + o + "%, " + this._roundA + ")";
  },
  toHex: function(t) {
    return E2(this._r, this._g, this._b, t);
  },
  toHexString: function(t) {
    return "#" + this.toHex(t);
  },
  toHex8: function(t) {
    return w7(this._r, this._g, this._b, this._a, t);
  },
  toHex8String: function(t) {
    return "#" + this.toHex8(t);
  },
  toRgb: function() {
    return {
      r: Math.round(this._r),
      g: Math.round(this._g),
      b: Math.round(this._b),
      a: this._a
    };
  },
  toRgbString: function() {
    return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
  },
  toPercentageRgb: function() {
    return {
      r: Math.round(Ge(this._r, 255) * 100) + "%",
      g: Math.round(Ge(this._g, 255) * 100) + "%",
      b: Math.round(Ge(this._b, 255) * 100) + "%",
      a: this._a
    };
  },
  toPercentageRgbString: function() {
    return this._a == 1 ? "rgb(" + Math.round(Ge(this._r, 255) * 100) + "%, " + Math.round(Ge(this._g, 255) * 100) + "%, " + Math.round(Ge(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(Ge(this._r, 255) * 100) + "%, " + Math.round(Ge(this._g, 255) * 100) + "%, " + Math.round(Ge(this._b, 255) * 100) + "%, " + this._roundA + ")";
  },
  toName: function() {
    return this._a === 0 ? "transparent" : this._a < 1 ? !1 : P7[E2(this._r, this._g, this._b, !0)] || !1;
  },
  toFilter: function(t) {
    var n = "#" + S2(this._r, this._g, this._b, this._a), r = n, o = this._gradientType ? "GradientType = 1, " : "";
    if (t) {
      var i = ue(t);
      r = "#" + S2(i._r, i._g, i._b, i._a);
    }
    return "progid:DXImageTransform.Microsoft.gradient(" + o + "startColorstr=" + n + ",endColorstr=" + r + ")";
  },
  toString: function(t) {
    var n = !!t;
    t = t || this._format;
    var r = !1, o = this._a < 1 && this._a >= 0, i = !n && o && (t === "hex" || t === "hex6" || t === "hex3" || t === "hex4" || t === "hex8" || t === "name");
    return i ? t === "name" && this._a === 0 ? this.toName() : this.toRgbString() : (t === "rgb" && (r = this.toRgbString()), t === "prgb" && (r = this.toPercentageRgbString()), (t === "hex" || t === "hex6") && (r = this.toHexString()), t === "hex3" && (r = this.toHexString(!0)), t === "hex4" && (r = this.toHex8String(!0)), t === "hex8" && (r = this.toHex8String()), t === "name" && (r = this.toName()), t === "hsl" && (r = this.toHslString()), t === "hsv" && (r = this.toHsvString()), r || this.toHexString());
  },
  clone: function() {
    return ue(this.toString());
  },
  _applyModification: function(t, n) {
    var r = t.apply(null, [this].concat([].slice.call(n)));
    return this._r = r._r, this._g = r._g, this._b = r._b, this.setAlpha(r._a), this;
  },
  lighten: function() {
    return this._applyModification(S7, arguments);
  },
  brighten: function() {
    return this._applyModification(M7, arguments);
  },
  darken: function() {
    return this._applyModification(A7, arguments);
  },
  desaturate: function() {
    return this._applyModification(T7, arguments);
  },
  saturate: function() {
    return this._applyModification(k7, arguments);
  },
  greyscale: function() {
    return this._applyModification(E7, arguments);
  },
  spin: function() {
    return this._applyModification(I7, arguments);
  },
  _applyCombination: function(t, n) {
    return t.apply(null, [this].concat([].slice.call(n)));
  },
  analogous: function() {
    return this._applyCombination($7, arguments);
  },
  complement: function() {
    return this._applyCombination(L7, arguments);
  },
  monochromatic: function() {
    return this._applyCombination(O7, arguments);
  },
  splitcomplement: function() {
    return this._applyCombination(D7, arguments);
  },
  // Disabled until https://github.com/bgrins/TinyColor/issues/254
  // polyad: function (number) {
  //   return this._applyCombination(polyad, [number]);
  // },
  triad: function() {
    return this._applyCombination(M2, [3]);
  },
  tetrad: function() {
    return this._applyCombination(M2, [4]);
  }
};
ue.fromRatio = function(e, t) {
  if (as(e) == "object") {
    var n = {};
    for (var r in e)
      e.hasOwnProperty(r) && (r === "a" ? n[r] = e[r] : n[r] = Zo(e[r]));
    e = n;
  }
  return ue(e, t);
};
function b7(e) {
  var t = {
    r: 0,
    g: 0,
    b: 0
  }, n = 1, r = null, o = null, i = null, a = !1, s = !1;
  return typeof e == "string" && (e = R7(e)), as(e) == "object" && (Rn(e.r) && Rn(e.g) && Rn(e.b) ? (t = y7(e.r, e.g, e.b), a = !0, s = String(e.r).substr(-1) === "%" ? "prgb" : "rgb") : Rn(e.h) && Rn(e.s) && Rn(e.v) ? (r = Zo(e.s), o = Zo(e.v), t = C7(e.h, r, o), a = !0, s = "hsv") : Rn(e.h) && Rn(e.s) && Rn(e.l) && (r = Zo(e.s), i = Zo(e.l), t = _7(e.h, r, i), a = !0, s = "hsl"), e.hasOwnProperty("a") && (n = e.a)), n = pg(n), {
    ok: a,
    format: e.format || s,
    r: Math.min(255, Math.max(t.r, 0)),
    g: Math.min(255, Math.max(t.g, 0)),
    b: Math.min(255, Math.max(t.b, 0)),
    a: n
  };
}
function y7(e, t, n) {
  return {
    r: Ge(e, 255) * 255,
    g: Ge(t, 255) * 255,
    b: Ge(n, 255) * 255
  };
}
function T2(e, t, n) {
  e = Ge(e, 255), t = Ge(t, 255), n = Ge(n, 255);
  var r = Math.max(e, t, n), o = Math.min(e, t, n), i, a, s = (r + o) / 2;
  if (r == o)
    i = a = 0;
  else {
    var l = r - o;
    switch (a = s > 0.5 ? l / (2 - r - o) : l / (r + o), r) {
      case e:
        i = (t - n) / l + (t < n ? 6 : 0);
        break;
      case t:
        i = (n - e) / l + 2;
        break;
      case n:
        i = (e - t) / l + 4;
        break;
    }
    i /= 6;
  }
  return {
    h: i,
    s: a,
    l: s
  };
}
function _7(e, t, n) {
  var r, o, i;
  e = Ge(e, 360), t = Ge(t, 100), n = Ge(n, 100);
  function a(u, m, v) {
    return v < 0 && (v += 1), v > 1 && (v -= 1), v < 1 / 6 ? u + (m - u) * 6 * v : v < 1 / 2 ? m : v < 2 / 3 ? u + (m - u) * (2 / 3 - v) * 6 : u;
  }
  if (t === 0)
    r = o = i = n;
  else {
    var s = n < 0.5 ? n * (1 + t) : n + t - n * t, l = 2 * n - s;
    r = a(l, s, e + 1 / 3), o = a(l, s, e), i = a(l, s, e - 1 / 3);
  }
  return {
    r: r * 255,
    g: o * 255,
    b: i * 255
  };
}
function k2(e, t, n) {
  e = Ge(e, 255), t = Ge(t, 255), n = Ge(n, 255);
  var r = Math.max(e, t, n), o = Math.min(e, t, n), i, a, s = r, l = r - o;
  if (a = r === 0 ? 0 : l / r, r == o)
    i = 0;
  else {
    switch (r) {
      case e:
        i = (t - n) / l + (t < n ? 6 : 0);
        break;
      case t:
        i = (n - e) / l + 2;
        break;
      case n:
        i = (e - t) / l + 4;
        break;
    }
    i /= 6;
  }
  return {
    h: i,
    s: a,
    v: s
  };
}
function C7(e, t, n) {
  e = Ge(e, 360) * 6, t = Ge(t, 100), n = Ge(n, 100);
  var r = Math.floor(e), o = e - r, i = n * (1 - t), a = n * (1 - o * t), s = n * (1 - (1 - o) * t), l = r % 6, u = [n, a, i, i, s, n][l], m = [s, n, n, a, i, i][l], v = [i, i, s, n, n, a][l];
  return {
    r: u * 255,
    g: m * 255,
    b: v * 255
  };
}
function E2(e, t, n, r) {
  var o = [cn(Math.round(e).toString(16)), cn(Math.round(t).toString(16)), cn(Math.round(n).toString(16))];
  return r && o[0].charAt(0) == o[0].charAt(1) && o[1].charAt(0) == o[1].charAt(1) && o[2].charAt(0) == o[2].charAt(1) ? o[0].charAt(0) + o[1].charAt(0) + o[2].charAt(0) : o.join("");
}
function w7(e, t, n, r, o) {
  var i = [cn(Math.round(e).toString(16)), cn(Math.round(t).toString(16)), cn(Math.round(n).toString(16)), cn(gg(r))];
  return o && i[0].charAt(0) == i[0].charAt(1) && i[1].charAt(0) == i[1].charAt(1) && i[2].charAt(0) == i[2].charAt(1) && i[3].charAt(0) == i[3].charAt(1) ? i[0].charAt(0) + i[1].charAt(0) + i[2].charAt(0) + i[3].charAt(0) : i.join("");
}
function S2(e, t, n, r) {
  var o = [cn(gg(r)), cn(Math.round(e).toString(16)), cn(Math.round(t).toString(16)), cn(Math.round(n).toString(16))];
  return o.join("");
}
ue.equals = function(e, t) {
  return !e || !t ? !1 : ue(e).toRgbString() == ue(t).toRgbString();
};
ue.random = function() {
  return ue.fromRatio({
    r: Math.random(),
    g: Math.random(),
    b: Math.random()
  });
};
function T7(e, t) {
  t = t === 0 ? 0 : t || 10;
  var n = ue(e).toHsl();
  return n.s -= t / 100, n.s = Ls(n.s), ue(n);
}
function k7(e, t) {
  t = t === 0 ? 0 : t || 10;
  var n = ue(e).toHsl();
  return n.s += t / 100, n.s = Ls(n.s), ue(n);
}
function E7(e) {
  return ue(e).desaturate(100);
}
function S7(e, t) {
  t = t === 0 ? 0 : t || 10;
  var n = ue(e).toHsl();
  return n.l += t / 100, n.l = Ls(n.l), ue(n);
}
function M7(e, t) {
  t = t === 0 ? 0 : t || 10;
  var n = ue(e).toRgb();
  return n.r = Math.max(0, Math.min(255, n.r - Math.round(255 * -(t / 100)))), n.g = Math.max(0, Math.min(255, n.g - Math.round(255 * -(t / 100)))), n.b = Math.max(0, Math.min(255, n.b - Math.round(255 * -(t / 100)))), ue(n);
}
function A7(e, t) {
  t = t === 0 ? 0 : t || 10;
  var n = ue(e).toHsl();
  return n.l -= t / 100, n.l = Ls(n.l), ue(n);
}
function I7(e, t) {
  var n = ue(e).toHsl(), r = (n.h + t) % 360;
  return n.h = r < 0 ? 360 + r : r, ue(n);
}
function L7(e) {
  var t = ue(e).toHsl();
  return t.h = (t.h + 180) % 360, ue(t);
}
function M2(e, t) {
  if (isNaN(t) || t <= 0)
    throw new Error("Argument to polyad must be a positive number");
  for (var n = ue(e).toHsl(), r = [ue(e)], o = 360 / t, i = 1; i < t; i++)
    r.push(ue({
      h: (n.h + i * o) % 360,
      s: n.s,
      l: n.l
    }));
  return r;
}
function D7(e) {
  var t = ue(e).toHsl(), n = t.h;
  return [ue(e), ue({
    h: (n + 72) % 360,
    s: t.s,
    l: t.l
  }), ue({
    h: (n + 216) % 360,
    s: t.s,
    l: t.l
  })];
}
function $7(e, t, n) {
  t = t || 6, n = n || 30;
  var r = ue(e).toHsl(), o = 360 / n, i = [ue(e)];
  for (r.h = (r.h - (o * t >> 1) + 720) % 360; --t; )
    r.h = (r.h + o) % 360, i.push(ue(r));
  return i;
}
function O7(e, t) {
  t = t || 6;
  for (var n = ue(e).toHsv(), r = n.h, o = n.s, i = n.v, a = [], s = 1 / t; t--; )
    a.push(ue({
      h: r,
      s: o,
      v: i
    })), i = (i + s) % 1;
  return a;
}
ue.mix = function(e, t, n) {
  n = n === 0 ? 0 : n || 50;
  var r = ue(e).toRgb(), o = ue(t).toRgb(), i = n / 100, a = {
    r: (o.r - r.r) * i + r.r,
    g: (o.g - r.g) * i + r.g,
    b: (o.b - r.b) * i + r.b,
    a: (o.a - r.a) * i + r.a
  };
  return ue(a);
};
ue.readability = function(e, t) {
  var n = ue(e), r = ue(t);
  return (Math.max(n.getLuminance(), r.getLuminance()) + 0.05) / (Math.min(n.getLuminance(), r.getLuminance()) + 0.05);
};
ue.isReadable = function(e, t, n) {
  var r = ue.readability(e, t), o, i;
  switch (i = !1, o = V7(n), o.level + o.size) {
    case "AAsmall":
    case "AAAlarge":
      i = r >= 4.5;
      break;
    case "AAlarge":
      i = r >= 3;
      break;
    case "AAAsmall":
      i = r >= 7;
      break;
  }
  return i;
};
ue.mostReadable = function(e, t, n) {
  var r = null, o = 0, i, a, s, l;
  n = n || {}, a = n.includeFallbackColors, s = n.level, l = n.size;
  for (var u = 0; u < t.length; u++)
    i = ue.readability(e, t[u]), i > o && (o = i, r = ue(t[u]));
  return ue.isReadable(e, r, {
    level: s,
    size: l
  }) || !a ? r : (n.includeFallbackColors = !1, ue.mostReadable(e, ["#fff", "#000"], n));
};
var Ec = ue.names = {
  aliceblue: "f0f8ff",
  antiquewhite: "faebd7",
  aqua: "0ff",
  aquamarine: "7fffd4",
  azure: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "000",
  blanchedalmond: "ffebcd",
  blue: "00f",
  blueviolet: "8a2be2",
  brown: "a52a2a",
  burlywood: "deb887",
  burntsienna: "ea7e5d",
  cadetblue: "5f9ea0",
  chartreuse: "7fff00",
  chocolate: "d2691e",
  coral: "ff7f50",
  cornflowerblue: "6495ed",
  cornsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "0ff",
  darkblue: "00008b",
  darkcyan: "008b8b",
  darkgoldenrod: "b8860b",
  darkgray: "a9a9a9",
  darkgreen: "006400",
  darkgrey: "a9a9a9",
  darkkhaki: "bdb76b",
  darkmagenta: "8b008b",
  darkolivegreen: "556b2f",
  darkorange: "ff8c00",
  darkorchid: "9932cc",
  darkred: "8b0000",
  darksalmon: "e9967a",
  darkseagreen: "8fbc8f",
  darkslateblue: "483d8b",
  darkslategray: "2f4f4f",
  darkslategrey: "2f4f4f",
  darkturquoise: "00ced1",
  darkviolet: "9400d3",
  deeppink: "ff1493",
  deepskyblue: "00bfff",
  dimgray: "696969",
  dimgrey: "696969",
  dodgerblue: "1e90ff",
  firebrick: "b22222",
  floralwhite: "fffaf0",
  forestgreen: "228b22",
  fuchsia: "f0f",
  gainsboro: "dcdcdc",
  ghostwhite: "f8f8ff",
  gold: "ffd700",
  goldenrod: "daa520",
  gray: "808080",
  green: "008000",
  greenyellow: "adff2f",
  grey: "808080",
  honeydew: "f0fff0",
  hotpink: "ff69b4",
  indianred: "cd5c5c",
  indigo: "4b0082",
  ivory: "fffff0",
  khaki: "f0e68c",
  lavender: "e6e6fa",
  lavenderblush: "fff0f5",
  lawngreen: "7cfc00",
  lemonchiffon: "fffacd",
  lightblue: "add8e6",
  lightcoral: "f08080",
  lightcyan: "e0ffff",
  lightgoldenrodyellow: "fafad2",
  lightgray: "d3d3d3",
  lightgreen: "90ee90",
  lightgrey: "d3d3d3",
  lightpink: "ffb6c1",
  lightsalmon: "ffa07a",
  lightseagreen: "20b2aa",
  lightskyblue: "87cefa",
  lightslategray: "789",
  lightslategrey: "789",
  lightsteelblue: "b0c4de",
  lightyellow: "ffffe0",
  lime: "0f0",
  limegreen: "32cd32",
  linen: "faf0e6",
  magenta: "f0f",
  maroon: "800000",
  mediumaquamarine: "66cdaa",
  mediumblue: "0000cd",
  mediumorchid: "ba55d3",
  mediumpurple: "9370db",
  mediumseagreen: "3cb371",
  mediumslateblue: "7b68ee",
  mediumspringgreen: "00fa9a",
  mediumturquoise: "48d1cc",
  mediumvioletred: "c71585",
  midnightblue: "191970",
  mintcream: "f5fffa",
  mistyrose: "ffe4e1",
  moccasin: "ffe4b5",
  navajowhite: "ffdead",
  navy: "000080",
  oldlace: "fdf5e6",
  olive: "808000",
  olivedrab: "6b8e23",
  orange: "ffa500",
  orangered: "ff4500",
  orchid: "da70d6",
  palegoldenrod: "eee8aa",
  palegreen: "98fb98",
  paleturquoise: "afeeee",
  palevioletred: "db7093",
  papayawhip: "ffefd5",
  peachpuff: "ffdab9",
  peru: "cd853f",
  pink: "ffc0cb",
  plum: "dda0dd",
  powderblue: "b0e0e6",
  purple: "800080",
  rebeccapurple: "663399",
  red: "f00",
  rosybrown: "bc8f8f",
  royalblue: "4169e1",
  saddlebrown: "8b4513",
  salmon: "fa8072",
  sandybrown: "f4a460",
  seagreen: "2e8b57",
  seashell: "fff5ee",
  sienna: "a0522d",
  silver: "c0c0c0",
  skyblue: "87ceeb",
  slateblue: "6a5acd",
  slategray: "708090",
  slategrey: "708090",
  snow: "fffafa",
  springgreen: "00ff7f",
  steelblue: "4682b4",
  tan: "d2b48c",
  teal: "008080",
  thistle: "d8bfd8",
  tomato: "ff6347",
  turquoise: "40e0d0",
  violet: "ee82ee",
  wheat: "f5deb3",
  white: "fff",
  whitesmoke: "f5f5f5",
  yellow: "ff0",
  yellowgreen: "9acd32"
}, P7 = ue.hexNames = N7(Ec);
function N7(e) {
  var t = {};
  for (var n in e)
    e.hasOwnProperty(n) && (t[e[n]] = n);
  return t;
}
function pg(e) {
  return e = parseFloat(e), (isNaN(e) || e < 0 || e > 1) && (e = 1), e;
}
function Ge(e, t) {
  H7(e) && (e = "100%");
  var n = F7(e);
  return e = Math.min(t, Math.max(0, parseFloat(e))), n && (e = parseInt(e * t, 10) / 100), Math.abs(e - t) < 1e-6 ? 1 : e % t / parseFloat(t);
}
function Ls(e) {
  return Math.min(1, Math.max(0, e));
}
function Bt(e) {
  return parseInt(e, 16);
}
function H7(e) {
  return typeof e == "string" && e.indexOf(".") != -1 && parseFloat(e) === 1;
}
function F7(e) {
  return typeof e == "string" && e.indexOf("%") != -1;
}
function cn(e) {
  return e.length == 1 ? "0" + e : "" + e;
}
function Zo(e) {
  return e <= 1 && (e = e * 100 + "%"), e;
}
function gg(e) {
  return Math.round(parseFloat(e) * 255).toString(16);
}
function A2(e) {
  return Bt(e) / 255;
}
var un = function() {
  var e = "[-\\+]?\\d+%?", t = "[-\\+]?\\d*\\.\\d+%?", n = "(?:" + t + ")|(?:" + e + ")", r = "[\\s|\\(]+(" + n + ")[,|\\s]+(" + n + ")[,|\\s]+(" + n + ")\\s*\\)?", o = "[\\s|\\(]+(" + n + ")[,|\\s]+(" + n + ")[,|\\s]+(" + n + ")[,|\\s]+(" + n + ")\\s*\\)?";
  return {
    CSS_UNIT: new RegExp(n),
    rgb: new RegExp("rgb" + r),
    rgba: new RegExp("rgba" + o),
    hsl: new RegExp("hsl" + r),
    hsla: new RegExp("hsla" + o),
    hsv: new RegExp("hsv" + r),
    hsva: new RegExp("hsva" + o),
    hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
    hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
  };
}();
function Rn(e) {
  return !!un.CSS_UNIT.exec(e);
}
function R7(e) {
  e = e.replace(g7, "").replace(v7, "").toLowerCase();
  var t = !1;
  if (Ec[e])
    e = Ec[e], t = !0;
  else if (e == "transparent")
    return {
      r: 0,
      g: 0,
      b: 0,
      a: 0,
      format: "name"
    };
  var n;
  return (n = un.rgb.exec(e)) ? {
    r: n[1],
    g: n[2],
    b: n[3]
  } : (n = un.rgba.exec(e)) ? {
    r: n[1],
    g: n[2],
    b: n[3],
    a: n[4]
  } : (n = un.hsl.exec(e)) ? {
    h: n[1],
    s: n[2],
    l: n[3]
  } : (n = un.hsla.exec(e)) ? {
    h: n[1],
    s: n[2],
    l: n[3],
    a: n[4]
  } : (n = un.hsv.exec(e)) ? {
    h: n[1],
    s: n[2],
    v: n[3]
  } : (n = un.hsva.exec(e)) ? {
    h: n[1],
    s: n[2],
    v: n[3],
    a: n[4]
  } : (n = un.hex8.exec(e)) ? {
    r: Bt(n[1]),
    g: Bt(n[2]),
    b: Bt(n[3]),
    a: A2(n[4]),
    format: t ? "name" : "hex8"
  } : (n = un.hex6.exec(e)) ? {
    r: Bt(n[1]),
    g: Bt(n[2]),
    b: Bt(n[3]),
    format: t ? "name" : "hex"
  } : (n = un.hex4.exec(e)) ? {
    r: Bt(n[1] + "" + n[1]),
    g: Bt(n[2] + "" + n[2]),
    b: Bt(n[3] + "" + n[3]),
    a: A2(n[4] + "" + n[4]),
    format: t ? "name" : "hex8"
  } : (n = un.hex3.exec(e)) ? {
    r: Bt(n[1] + "" + n[1]),
    g: Bt(n[2] + "" + n[2]),
    b: Bt(n[3] + "" + n[3]),
    format: t ? "name" : "hex"
  } : !1;
}
function V7(e) {
  var t, n;
  return e = e || {
    level: "AA",
    size: "small"
  }, t = (e.level || "AA").toUpperCase(), n = (e.size || "small").toLowerCase(), t !== "AA" && t !== "AAA" && (t = "AA"), n !== "small" && n !== "large" && (n = "small"), {
    level: t,
    size: n
  };
}
var ol, I2;
function B7() {
  if (I2) return ol;
  I2 = 1;
  var e = hn(), t = function() {
    return e.Date.now();
  };
  return ol = t, ol;
}
var il, L2;
function j7() {
  if (L2) return il;
  L2 = 1;
  var e = /\s/;
  function t(n) {
    for (var r = n.length; r-- && e.test(n.charAt(r)); )
      ;
    return r;
  }
  return il = t, il;
}
var sl, D2;
function U7() {
  if (D2) return sl;
  D2 = 1;
  var e = j7(), t = /^\s+/;
  function n(r) {
    return r && r.slice(0, e(r) + 1).replace(t, "");
  }
  return sl = n, sl;
}
var al, $2;
function vg() {
  if ($2) return al;
  $2 = 1;
  var e = U7(), t = dr(), n = Es(), r = NaN, o = /^[-+]0x[0-9a-f]+$/i, i = /^0b[01]+$/i, a = /^0o[0-7]+$/i, s = parseInt;
  function l(u) {
    if (typeof u == "number")
      return u;
    if (n(u))
      return r;
    if (t(u)) {
      var m = typeof u.valueOf == "function" ? u.valueOf() : u;
      u = t(m) ? m + "" : m;
    }
    if (typeof u != "string")
      return u === 0 ? u : +u;
    u = e(u);
    var v = i.test(u);
    return v || a.test(u) ? s(u.slice(2), v ? 2 : 8) : o.test(u) ? r : +u;
  }
  return al = l, al;
}
var ll, O2;
function q7() {
  if (O2) return ll;
  O2 = 1;
  var e = dr(), t = B7(), n = vg(), r = "Expected a function", o = Math.max, i = Math.min;
  function a(s, l, u) {
    var m, v, g, h, E, C, A = 0, R = !1, P = !1, F = !0;
    if (typeof s != "function")
      throw new TypeError(r);
    l = n(l) || 0, e(u) && (R = !!u.leading, P = "maxWait" in u, g = P ? o(n(u.maxWait) || 0, l) : g, F = "trailing" in u ? !!u.trailing : F);
    function I(N) {
      var G = m, X = v;
      return m = v = void 0, A = N, h = s.apply(X, G), h;
    }
    function D(N) {
      return A = N, E = setTimeout(q, l), R ? I(N) : h;
    }
    function O(N) {
      var G = N - C, X = N - A, Q = l - G;
      return P ? i(Q, g - X) : Q;
    }
    function U(N) {
      var G = N - C, X = N - A;
      return C === void 0 || G >= l || G < 0 || P && X >= g;
    }
    function q() {
      var N = t();
      if (U(N))
        return z(N);
      E = setTimeout(q, O(N));
    }
    function z(N) {
      return E = void 0, F && m ? I(N) : (m = v = void 0, h);
    }
    function te() {
      E !== void 0 && clearTimeout(E), A = 0, m = C = v = E = void 0;
    }
    function ee() {
      return E === void 0 ? h : z(t());
    }
    function x() {
      var N = t(), G = U(N);
      if (m = arguments, v = this, C = N, G) {
        if (E === void 0)
          return D(C);
        if (P)
          return clearTimeout(E), E = setTimeout(q, l), I(C);
      }
      return E === void 0 && (E = setTimeout(q, l)), h;
    }
    return x.cancel = te, x.flush = ee, x;
  }
  return ll = a, ll;
}
var G7 = q7();
const go = /* @__PURE__ */ Eo(G7), Wt = {
  data() {
    return {
      screenSize: "",
      debouncedSetScreenSize: () => {
      }
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.setScreenSize();
    }), this.debouncedSetScreenSize = go(this.setScreenSize, 100), window.addEventListener("resize", this.debouncedSetScreenSize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.debouncedSetScreenSize);
  },
  methods: {
    setScreenSize() {
      this.screenSize = document.documentElement.clientWidth;
    }
  }
}, B = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [r, o] of t)
    n[r] = o;
  return n;
}, K7 = {
  name: "LinesAccent"
}, z7 = { class: "lines-accent" };
function Z7(e, t, n, r, o, i) {
  return d(), f("div", z7, [
    (d(), f(J, null, ne(3, (a, s) => c("div", {
      key: s,
      class: "accent"
    })), 64))
  ]);
}
const x7 = /* @__PURE__ */ B(K7, [["render", Z7], ["__scopeId", "data-v-0477e467"]]), W7 = {
  name: "DotsAccent",
  methods: {
    yOffset(e) {
      return e * 8 + 1;
    }
  }
}, Y7 = { class: "dots-accent" }, X7 = {
  width: "4000",
  height: "18",
  viewBox: "0 0 4000 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Q7 = ["y1", "y2"];
function J7(e, t, n, r, o, i) {
  return d(), f("div", Y7, [
    (d(), f("svg", X7, [
      (d(), f(J, null, ne(3, (a, s) => c("line", {
        key: s,
        x1: "0",
        y1: i.yOffset(s),
        x2: "4000",
        y2: i.yOffset(s),
        "stroke-dasharray": "2, 6",
        "stroke-width": "2"
      }, null, 8, Q7)), 64))
    ]))
  ]);
}
const ev = /* @__PURE__ */ B(W7, [["render", J7], ["__scopeId", "data-v-49a600d6"]]), tv = {
  name: "HeaderAccent",
  components: { LinesAccent: x7, DotsAccent: ev },
  props: {
    version: {
      type: String,
      default: ""
    }
  },
  computed: {
    accentType() {
      return this.version === "dot" ? "DotsAccent" : "LinesAccent";
    }
  }
}, nv = { class: "header-accent" };
function rv(e, t, n, r, o, i) {
  return d(), f("div", nv, [
    (d(), L(Y(i.accentType)))
  ]);
}
const ov = /* @__PURE__ */ B(tv, [["render", rv], ["__scopeId", "data-v-8bc0e22c"]]), iv = {
  name: "SeeAllContainer",
  components: { HeaderAccent: ov },
  mixins: [Wt],
  props: {
    themeOptions: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      headerWidth: 32
    };
  },
  computed: {
    cssVars() {
      return {
        "--width-header": `${this.headerWidth}px`
      };
    },
    accentType() {
      return $(this.themeOptions, "globalThemeSettings.accentType", "dot");
    }
  },
  watch: {
    screenSize() {
      this.resize("watch");
    }
  },
  mounted() {
    this.resize("mounted");
  },
  methods: {
    resize() {
      this.$nextTick(() => {
        if (!this.$refs["header-slot-container"]) return;
        const e = this.$refs["header-slot-container"];
        e.firstElementChild && e.firstElementChild.offsetWidth !== null && e.firstElementChild.offsetWidth > 32 && (this.headerWidth = e.firstElementChild.offsetWidth);
      });
    }
  }
}, sv = {
  ref: "header-slot-container",
  class: "header-slot-container"
}, av = {
  class: "purple-header-accent",
  "data-testid": "purple-header-accent"
};
function lv(e, t, n, r, o, i) {
  const a = V("HeaderAccent");
  return d(), f("div", {
    class: "see-all-container",
    "data-testid": "header",
    style: Z(i.cssVars)
  }, [
    t[0] || (t[0] = c("span", {
      "data-testid": "monterrey-header-accent-left",
      class: "monterrey-header-accent-left"
    }, null, -1)),
    c("div", sv, [
      M(e.$slots, "header", { ref: "header-slot" })
    ], 512),
    c("div", av, [
      j(a, { version: i.accentType }, null, 8, ["version"])
    ]),
    t[1] || (t[1] = c("span", {
      "data-testid": "light-header-accent",
      class: "light-header-accent"
    }, null, -1)),
    t[2] || (t[2] = c("span", {
      "data-testid": "monterrey-header-accent",
      class: "monterrey-header-accent"
    }, null, -1)),
    M(e.$slots, "default")
  ], 4);
}
const uv = /* @__PURE__ */ B(iv, [["render", lv], ["__scopeId", "data-v-5a17ac72"]]), St = {
  components: { SeeAllContainer: uv },
  mixins: [Wt],
  methods: {
    getColorOption(e, ...t) {
      const n = t.find((r) => e[r]);
      return n ? e[n] : { hex: "" };
    },
    link(e = "") {
      return this.isPreview ? "#" : `${this.pathPrefix}/${e}`;
    },
    sharedThemeColors() {
      const e = this.theme.style, n = ["light", "purple", "monterrey", "sydney"].includes(e), r = $(this.theme, "bg_color.hex", "none"), o = $(this.theme, "heading_color.hex", "#000"), i = $(this.theme, "top_heading_color.hex", "#000"), a = $(this.theme, "see_all_link_color.hex", o), s = $(this.theme, "see_all_bg_color.hex", "#000"), l = $(this.theme, "see_all_text_color.hex", "#fff"), u = $(this.theme, "button_border_color.hex", "#000"), m = n ? $(this.theme, "button_bg_color.hex", s) : "none", v = n ? $(this.theme, "button_text_color.hex", l) : a, g = $(this.theme, "header_accent_color.hex", "#000");
      return {
        "--bg-color": r,
        "--heading-color": o,
        "--top-heading-color": i,
        "--button-bg-color": m,
        "--button-text-color": v,
        "--button-border-color": u,
        "--header-accent-color": g,
        "--focus-visible-outline": ue.mostReadable(r, ["#0000FF", "#FFFFFF"], { includeFallbackColors: !0 }).toHexString(),
        "--focus-visible-box-shadow": "#FFFFFF"
      };
    }
  }
};
function bg(e = "", t = 180) {
  return e.length <= t ? e : e.slice(0, t).concat("...");
}
const P2 = (e = "") => e.replace(/<[^>]*>/g, "").trim(), Sc = (e = "") => {
  const t = {
    "&amp;": "&",
    "&nbsp;": " ",
    "&apos;": "'",
    "&#39;": "'",
    "&quot;": '"',
    "&#44;": ",",
    "&gt;": ">",
    "&lt;": "<"
  }, n = new RegExp(Object.keys(t).join("|"), "gi");
  return e.replace(n, (r) => t[r.toLowerCase()]);
}, dv = (e = "", t = 180) => t ? bg(P2(Sc(e)), t) : P2(Sc(e)), cv = (e = "") => e.toLowerCase().replace(/ /g, "-"), hv = (e = "") => {
  const n = (e.match(/<[^>]*>*/g) || []).pop() || "</>";
  return n.startsWith("</") ? e : e.replace(n, "...");
}, cr = {
  mixins: [St],
  props: {
    theme: {
      type: Object,
      required: !0
    },
    articles: {
      type: Array,
      default: () => []
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    isPreview: Boolean,
    fallbackImage: {
      type: Object,
      default: () => ({})
    },
    isIFrame: Boolean,
    newsConfig: {
      type: Object,
      default: () => ({})
    },
    componentId: {
      type: String,
      default: null
    },
    isEditing: Boolean
  },
  computed: {
    isPurpleStyle() {
      return this.theme.style === "purple";
    },
    isMonterreyStyle() {
      return this.theme.style === "monterrey";
    },
    isBoldStyle() {
      return this.theme.style === "bold";
    },
    cssVars() {
      const e = this.sharedThemeColors(), t = e["--heading-color"];
      return ge(ae({}, e), {
        "--article-title-color": $(this.theme, "article_title_color.hex", t),
        "--article-date-color": $(this.theme, "article_date_color.hex", "#757575"),
        "--article-link-color": $(this.theme, "article_link_color.hex", "#CC314B"),
        "--snippet-color": $(this.theme, "snippet_color.hex", "#333"),
        "--news-accent-border-color": $(
          this.theme,
          "news_image_borders_color.hex",
          this.theme.globalThemeSettings.secondaryColor
        ),
        "--news-accent-image-bar": $(
          this.theme,
          "news_image_color_bar.hex",
          this.theme.globalThemeSettings.secondaryColor
        ),
        "--top-heading-color": $(this.theme, "top_heading_color.hex", this.theme.globalThemeSettings.secondaryColor),
        "--button-border-color": $(
          this.theme,
          "button_border_color.hex",
          this.theme.globalThemeSettings.secondaryColor
        ),
        "--pager-color": $(this.theme, "pager_color.hex", "#CC314B"),
        "--arrow-background-color": $(this.theme, "arrow_background_color.hex", "#CC314B"),
        "--event-arrow-color": $(this.theme, "event_arrow_color.hex", "#fff"),
        "--scrollbar-color": $(this.theme, "scrollbar_color.hex", "#000"),
        "--scrollbar-bg_color": $(
          this.theme,
          "scrollbar_bg_color.hex",
          this.theme.globalThemeSettings.secondaryColor
        ),
        "--scrollbar-arrow-color": $(this.theme, "scrollbar_arrow_color.hex", "#000"),
        "--arrow-icon-color": $(this.theme, "arrow_icon_color.hex", "#fff"),
        "--overlay-color": $(this.theme, "overlay_color.hex", "#000"),
        "--arrow-border-color": $(this.theme, "arrow_border_color.hex", "#000"),
        "--focus-outline-width": "2px",
        "--focus-outline-offset": "1px",
        "--focus-outline-margin": "calc(var(--focus-outline-width) + var(--focus-outline-offset))",
        "--focus-outline-shadow": "0 0 0 calc(var(--focus-outline-margin) * 2)"
      });
    },
    translations() {
      return this.theme.translations;
    },
    seeAllLinkHref() {
      var e, t;
      return ((t = (e = this.newsConfig[this.componentId]) == null ? void 0 : e.see_all_link) == null ? void 0 : t.href) || this.link("news");
    },
    seeAllLinkName() {
      var e, t;
      return ((t = (e = this.newsConfig[this.componentId]) == null ? void 0 : e.see_all_link) == null ? void 0 : t.name) || this.translations.see_all;
    },
    seeAllLinkTarget() {
      var e, t;
      return ((t = (e = this.newsConfig[this.componentId]) == null ? void 0 : e.see_all_link) == null ? void 0 : t.target) || "_self";
    },
    sectionHeader() {
      var e;
      return ((e = this.newsConfig[this.componentId]) == null ? void 0 : e.component_header) || this.translations.title;
    },
    sectionHeaderTop() {
      var e, t;
      return (t = (e = this.newsConfig[this.componentId]) == null ? void 0 : e.component_header_top) != null ? t : this.translations.latest;
    }
  },
  methods: {
    saniTruncate: dv,
    replaceHTMLEntities: Sc,
    calculateFocalPoints(e) {
      var r, o;
      if (!(e != null && e.cover_image)) return "50% 50%";
      const t = (r = e == null ? void 0 : e.image_focal_point_x) != null ? r : 50, n = (o = e == null ? void 0 : e.image_focal_point_y) != null ? o : 50;
      return `${t}% ${n}%`;
    }
  }
}, mv = {
  name: "NewsStory",
  mixins: [cr],
  props: {
    item: {
      type: Object,
      required: !0
    },
    showSnippet: {
      type: Boolean,
      default: !0
    },
    showTitle: {
      type: Boolean,
      default: !0
    },
    variant: {
      type: String,
      required: !0
    },
    showPublishedTime: {
      type: Boolean,
      default: !1
    },
    totalCards: {
      type: Number,
      default: 0
    },
    cardNumber: {
      type: Number,
      default: 0
    }
  },
  computed: {
    hasAccentStyling() {
      return this.theme.globalThemeSettings.accentStyling;
    },
    showSliderAriaLabels() {
      return ["N6-story", "N5-story"].includes(this.variant);
    },
    renderSeeAllButtonOverImage() {
      return this.seeAllButtonOverImage && this.theme.style !== "bold" && this.screenSize < 481;
    }
  },
  methods: {
    formatDate(e) {
      const t = e !== void 0 ? new Date(e) : /* @__PURE__ */ new Date();
      return new Intl.DateTimeFormat("en-US", { dateStyle: "medium", timeStyle: "short" }).format(t);
    }
  }
}, fv = ["role", "aria-roledescription", "aria-label"], pv = ["href"], gv = { class: "news-image-container" }, vv = { class: "news-image" }, bv = ["src"], yv = {
  key: 0,
  class: "news-date",
  "data-testid": "news-date"
};
function _v(e, t, n, r, o, i) {
  return d(), f("div", {
    role: i.showSliderAriaLabels ? "group" : void 0,
    "aria-roledescription": i.showSliderAriaLabels ? "slide" : void 0,
    "aria-label": i.showSliderAriaLabels ? `${n.cardNumber} of ${n.totalCards}` : void 0,
    class: _(["story", e.theme.style, n.variant])
  }, [
    c("a", {
      href: e.link(`article/${n.item.id}`),
      class: "news-image-title-link"
    }, [
      c("div", gv, [
        c("div", vv, [
          c("div", {
            class: _(["image-hidden-wrapper", { "accent-styling": i.hasAccentStyling }])
          }, [
            c("img", {
              alt: "",
              src: n.item.cover_image ? n.item.cover_image : e.fallbackImage.url,
              style: Z({ objectPosition: e.calculateFocalPoints(n.item) }),
              loading: "lazy"
            }, null, 12, bv),
            t[0] || (t[0] = c("div", { class: "news-backdrop" }, null, -1))
          ], 2)
        ])
      ]),
      n.showPublishedTime ? (d(), f("div", yv, k(i.formatDate(n.item.published_at)), 1)) : T("", !0),
      n.showTitle ? (d(), f("div", {
        key: 1,
        class: _(["news-title", [e.theme.style, { "accent-styling": i.hasAccentStyling }]])
      }, [
        H(k(e.saniTruncate(n.item.title)) + " ", 1),
        c("div", {
          class: _(["news-snippet inner-snippet", e.theme.style])
        }, k(e.replaceHTMLEntities(n.item.snippet)), 3)
      ], 2)) : T("", !0)
    ], 8, pv),
    n.showSnippet ? (d(), f("div", {
      key: 0,
      class: _(["news-snippet outer-snippet", e.theme.style])
    }, k(e.replaceHTMLEntities(n.item.snippet)), 3)) : T("", !0)
  ], 10, fv);
}
const Ur = /* @__PURE__ */ B(mv, [["render", _v], ["__scopeId", "data-v-8769d942"]]), Cv = {
  name: "N1",
  components: { NewsStory: Ur },
  mixins: [cr]
}, wv = ["data-testid"], Tv = { class: "news-content" };
function kv(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("NewsStory");
  return d(), f("div", {
    id: "news-n1",
    style: Z(e.cssVars),
    class: _([e.theme.style, { "is-editing": e.isEditing }]),
    "data-testid": "n1"
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        e.isMonterreyStyle ? (d(), f("h3", {
          key: 0,
          "data-testid": `header-${e.theme.style}-top`
        }, [
          M(e.$slots, "header-top", {}, () => [
            H(k(e.sectionHeaderTop), 1)
          ], !0)
        ], 8, wv)) : T("", !0),
        (d(), L(Y(e.isMonterreyStyle ? "h1" : "h2"), {
          "data-testid": `header-${e.theme.style}-top`
        }, {
          default: S(() => [
            M(e.$slots, "header", {}, () => [
              H(k(e.sectionHeader), 1)
            ], !0)
          ]),
          _: 3
        }, 8, ["data-testid"]))
      ]),
      default: S(() => [
        e.theme.style === "bold" && e.screenSize >= 600 ? (d(), L(Y(e.isEditing ? "button" : "a"), {
          key: 0,
          class: _(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (l) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : T("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    c("div", Tv, [
      (d(!0), f(J, null, ne(e.articles.slice(0, 4), (l, u) => (d(), L(s, {
        key: u,
        item: l,
        theme: e.theme,
        variant: "N1-story",
        class: _({ "is-editing": e.isEditing }),
        "is-preview": e.isPreview,
        "fallback-image": e.fallbackImage,
        "path-prefix": e.pathPrefix,
        "data-testid": "news-story"
      }, null, 8, ["item", "theme", "class", "is-preview", "fallback-image", "path-prefix"]))), 128))
    ]),
    e.theme.style !== "bold" || e.screenSize < 600 ? (d(), L(a, {
      key: 0,
      class: _([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme
    }, {
      default: S(() => [
        (d(), L(Y(e.isEditing ? "button" : "a"), {
          class: _(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-bottom`,
          onClick: t[1] || (t[1] = (l) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options"])) : T("", !0)
  ], 6);
}
const Ev = /* @__PURE__ */ B(Cv, [["render", kv], ["__scopeId", "data-v-9c532a68"]]), Sv = {
  name: "N2",
  components: { NewsStory: Ur },
  mixins: [cr]
}, Mv = ["data-testid"], Av = { class: "news-content" }, Iv = {
  "data-testid": "more-headlines",
  class: "more-headlines-header"
};
function Lv(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("NewsStory");
  return d(), f("div", {
    id: "news-n2",
    class: _([e.theme.style, { "is-editing": e.isEditing }]),
    style: Z(e.cssVars)
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        e.isMonterreyStyle ? (d(), f("h3", {
          key: 0,
          "data-testid": `header-${e.theme.style}-top`
        }, [
          M(e.$slots, "header-top", {}, () => [
            H(k(e.sectionHeaderTop), 1)
          ], !0)
        ], 8, Mv)) : T("", !0),
        (d(), L(Y(e.isMonterreyStyle ? "h1" : "h2"), {
          "data-testid": `header-${e.theme.style}-top`
        }, {
          default: S(() => [
            M(e.$slots, "header", {}, () => [
              H(k(e.sectionHeader), 1)
            ], !0)
          ]),
          _: 3
        }, 8, ["data-testid"]))
      ]),
      default: S(() => [
        e.theme.style === "bold" && e.screenSize >= 600 ? (d(), L(Y(e.isEditing ? "button" : "a"), {
          key: 0,
          class: _(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (l) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : T("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    c("div", Av, [
      (d(!0), f(J, null, ne(e.articles.slice(0, 2), (l, u) => (d(), L(s, {
        key: u,
        item: l,
        theme: e.theme,
        variant: "N2-story",
        class: _({ "is-editing": e.isEditing }),
        "is-preview": e.isPreview,
        "fallback-image": e.fallbackImage,
        "path-prefix": e.pathPrefix,
        "data-testid": "news-story"
      }, null, 8, ["item", "theme", "class", "is-preview", "fallback-image", "path-prefix"]))), 128))
    ]),
    c("div", Iv, k(e.translations.more_headlines), 1),
    c("div", {
      class: _([e.theme.style, "more-headlines-content news-content"])
    }, [
      (d(!0), f(J, null, ne(e.articles.slice(2, 6), (l, u) => (d(), L(s, {
        key: u,
        item: l,
        theme: e.theme,
        variant: "N2-more-story",
        class: _({ "is-editing": e.isEditing }),
        "is-preview": e.isPreview,
        "fallback-image": e.fallbackImage,
        "show-snippet": !1,
        "path-prefix": e.pathPrefix,
        "data-testid": "news-story"
      }, null, 8, ["item", "theme", "class", "is-preview", "fallback-image", "path-prefix"]))), 128))
    ], 2),
    e.theme.style !== "bold" || e.screenSize < 600 ? (d(), L(a, {
      key: 0,
      class: _([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme
    }, {
      default: S(() => [
        (d(), L(Y(e.isEditing ? "button" : "a"), {
          class: _(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-bottom`,
          onClick: t[1] || (t[1] = (l) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options"])) : T("", !0)
  ], 6);
}
const Dv = /* @__PURE__ */ B(Sv, [["render", Lv], ["__scopeId", "data-v-8889f982"]]), $v = {
  name: "N3",
  components: { NewsStory: Ur },
  mixins: [cr]
}, Ov = ["data-testid"], Pv = { class: "news-content" };
function Nv(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("NewsStory");
  return d(), f("div", {
    id: "news-n3",
    class: _([e.theme.style, { "is-editing": e.isEditing }]),
    style: Z(e.cssVars)
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        e.isMonterreyStyle ? (d(), f("h3", {
          key: 0,
          "data-testid": `header-${e.theme.style}-top`
        }, [
          M(e.$slots, "header-top", {}, () => [
            H(k(e.sectionHeaderTop), 1)
          ], !0)
        ], 8, Ov)) : T("", !0),
        (d(), L(Y(e.isMonterreyStyle ? "h1" : "h2"), {
          "data-testid": `header-${e.theme.style}-top`
        }, {
          default: S(() => [
            M(e.$slots, "header", {}, () => [
              H(k(e.sectionHeader), 1)
            ], !0)
          ]),
          _: 3
        }, 8, ["data-testid"]))
      ]),
      default: S(() => [
        e.theme.style === "bold" && e.screenSize >= 600 ? (d(), L(Y(e.isEditing ? "button" : "a"), {
          key: 0,
          class: _(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (l) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : T("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    c("div", Pv, [
      (d(!0), f(J, null, ne(e.articles.slice(0, 4), (l, u) => (d(), L(s, {
        key: u,
        item: l,
        theme: e.theme,
        variant: "N3-story",
        class: _({ "is-editing": e.isEditing }),
        "is-preview": e.isPreview,
        "fallback-image": e.fallbackImage,
        "show-snippet": !1,
        "path-prefix": e.pathPrefix,
        "data-testid": "news-story"
      }, null, 8, ["item", "theme", "class", "is-preview", "fallback-image", "path-prefix"]))), 128))
    ]),
    e.theme.style !== "bold" || e.screenSize < 600 ? (d(), L(a, {
      key: 0,
      class: _([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme
    }, {
      default: S(() => [
        (d(), L(Y(e.isEditing ? "button" : "a"), {
          class: _(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-bottom`,
          onClick: t[1] || (t[1] = (l) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options"])) : T("", !0)
  ], 6);
}
const Hv = /* @__PURE__ */ B($v, [["render", Nv], ["__scopeId", "data-v-cf8b1b78"]]), Fv = {
  name: "N4",
  components: { NewsStory: Ur },
  mixins: [cr]
}, Rv = ["data-testid"], Vv = { class: "news-content" };
function Bv(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("NewsStory");
  return d(), f("div", {
    id: "news-n4",
    style: Z(e.cssVars),
    class: _([e.theme.style, { "is-editing": e.isEditing }])
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        e.isMonterreyStyle ? (d(), f("h3", {
          key: 0,
          "data-testid": `header-${e.theme.style}-top`
        }, [
          M(e.$slots, "header-top", {}, () => [
            H(k(e.sectionHeaderTop), 1)
          ], !0)
        ], 8, Rv)) : T("", !0),
        (d(), L(Y(e.isMonterreyStyle ? "h1" : "h2"), {
          "data-testid": `header-${e.theme.style}-top`
        }, {
          default: S(() => [
            M(e.$slots, "header", {}, () => [
              H(k(e.sectionHeader), 1)
            ], !0)
          ]),
          _: 3
        }, 8, ["data-testid"]))
      ]),
      default: S(() => [
        !e.isPurpleStyle && e.screenSize >= 600 ? (d(), L(Y(e.isEditing ? "button" : "a"), {
          key: 0,
          class: _(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (l) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : T("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    c("div", Vv, [
      (d(!0), f(J, null, ne(e.articles.slice(0, 3), (l, u) => (d(), L(s, {
        key: u,
        item: l,
        theme: e.theme,
        variant: "N4-story",
        class: _({ "is-editing": e.isEditing }),
        "is-preview": e.isPreview,
        "fallback-image": e.fallbackImage,
        "path-prefix": e.pathPrefix,
        "data-testid": "news-story"
      }, null, 8, ["item", "theme", "class", "is-preview", "fallback-image", "path-prefix"]))), 128))
    ]),
    e.isPurpleStyle || e.screenSize < 600 ? (d(), L(a, {
      key: 0,
      class: _([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme
    }, {
      default: S(() => [
        (d(), L(Y(e.isEditing ? "button" : "a"), {
          class: _(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-bottom`,
          onClick: t[1] || (t[1] = (l) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options"])) : T("", !0)
  ], 6);
}
const jv = /* @__PURE__ */ B(Fv, [["render", Bv], ["__scopeId", "data-v-4b721186"]]), Uv = {
  props: {
    fillColor: {
      type: String,
      default: "#fff"
    }
  }
}, qv = ["fill"], Gv = ["stroke"];
function Kv(e, t, n, r, o, i) {
  return d(), f("svg", {
    width: "13",
    height: "13",
    viewBox: "0 0 13 13",
    fill: n.fillColor,
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true"
  }, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M6.21582 1.18164L6.21582 14.1816M6.21582 1.18164L1.21582 5.97111M6.21582 1.18164L11.2158 5.97112",
      stroke: n.fillColor,
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, 8, Gv)
  ], 8, qv);
}
const zv = /* @__PURE__ */ B(Uv, [["render", Kv]]), _t = {
  data() {
    return {
      currentCard: 0,
      visibleCardNum: 0,
      allCardsVisible: !1
    };
  },
  computed: {
    pagerSectionCount() {
      return Math.ceil(this.content.length / (this.visibleCardNum <= 0 ? 1 : this.visibleCardNum));
    },
    sliderCenterElements() {
      return this.sliderCenterSize && this.sliderCenterSize >= this.screenSize;
    },
    sliderReady() {
      return !!(this.$refs[`sliderCard-${this.currentCard}`] && this.$refs["sliderCard-0"] && this.$refs[`sliderCard-${this.content.length - 1}`]);
    }
  },
  mixins: [Wt],
  mounted() {
    this.$nextTick(() => {
      this.sliderReady && this.setVisibleCardNumber();
    }), window.addEventListener("resize", this.setVisibleCardNumber);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.setVisibleCardNumber);
  },
  methods: {
    setVisibleCardNumber() {
      const e = this.lastVisibleCard(), t = this.firstVisibleCard();
      this.allCardsVisible = e < 0 && t === 0, this.visibleCardNum = e - t || 1, this.calculateScroll();
    },
    calculateScroll() {
      if (this.sliderReady) {
        const e = this.getHTMLElement(this.$refs[`sliderCard-${this.currentCard}`]), t = this.getHTMLElement(this.$refs["sliderCard-0"]), n = this.getHTMLElement(this.$refs[`sliderCard-${this.content.length - 1}`]), r = this.getHTMLElement(this.$refs.scrollWrapper);
        t.style["margin-left"] = this.sliderCenterElements ? "50vw" : "0px", n.style["margin-right"] = this.sliderCenterElements ? "50vw" : "0px";
        const o = e.getBoundingClientRect().left, i = this.sliderCenterElements ? e.offsetWidth / 2 : 0, a = this.sliderCenterElements ? (r.getBoundingClientRect().left + r.getBoundingClientRect().right) / 2 : r.getBoundingClientRect().left, s = o - (a - i);
        r.scrollLeft += s;
      }
    },
    lastVisibleCard() {
      if (!this.$refs) return;
      const e = this.getHTMLElement(this.$refs.scrollWrapper);
      if (!e || !this.sliderReady)
        return null;
      const t = e.getBoundingClientRect().right;
      return this.content.findIndex((n, r) => {
        var i, a;
        return ((a = this.getHTMLElement((i = this.$refs) == null ? void 0 : i[`sliderCard-${r}`])) == null ? void 0 : a.getBoundingClientRect().right) > t;
      });
    },
    firstVisibleCard() {
      if (!this.$refs) return;
      const e = this.getHTMLElement(this.$refs.scrollWrapper);
      if (!e || !this.sliderReady)
        return null;
      const t = e.getBoundingClientRect().left;
      return this.content.findIndex((n, r) => {
        var i, a;
        const o = (a = this.getHTMLElement((i = this.$refs) == null ? void 0 : i[`sliderCard-${r}`])) == null ? void 0 : a.getBoundingClientRect().left;
        return Math.round(o) >= t;
      });
    },
    scrollLeft() {
      if (this.sliderCenterElements)
        this.currentCard = this.currentCard === 0 ? this.content.length - 1 : this.currentCard - 1;
      else {
        const e = this.firstVisibleCard() - 1;
        this.currentCard = e < 0 ? this.content.length - 1 : e;
      }
      this.calculateScroll();
    },
    scrollRight() {
      this.sliderCenterElements ? this.currentCard = this.currentCard === this.content.length - 1 ? 0 : this.currentCard + 1 : this.currentCard = this.lastVisibleCard() < 0 || this.currentCard === this.content.length - this.visibleCardNum ? 0 : this.currentCard + 1, this.calculateScroll();
    },
    goToSection(e) {
      this.currentCard = (e - 1) * this.visibleCardNum, this.calculateScroll();
    },
    getHTMLElement(e) {
      if (!this.sliderReady)
        return;
      const t = Array.isArray(e) ? e[0] : e;
      return t instanceof Element ? t : t.$el;
    }
  }
}, Zv = {
  name: "Pager",
  props: {
    pagerColor: {
      type: String,
      default: "#0F0F0F"
    },
    totalCards: {
      type: Number,
      default: 0
    },
    currentCard: {
      type: Number,
      default: 0
    },
    themeStyles: {
      type: Object,
      required: !0
    },
    pagerSectionCount: {
      type: Number,
      default: 4
    }
  },
  computed: {
    pagerStyles() {
      return {
        "--total-sections": this.pagerSectionCount,
        "--pager-color": this.pagerColor
      };
    },
    cardsPerSection() {
      return Math.ceil(this.totalCards / this.pagerSectionCount);
    }
  },
  methods: {
    activeCard(e) {
      const t = (e - 1) * this.cardsPerSection, n = e * this.cardsPerSection - 1;
      return this.currentCard >= t && this.currentCard <= n;
    },
    ariaLabel(e) {
      return this.activeCard(e) ? $(this.themeStyles, "translations.active", "Active") : $(this.themeStyles, "translations.inactive", "Inactive");
    },
    ariaText(e) {
      return `Display slide ${this.cardsPerSection * e - this.cardsPerSection + 1} through ${this.cardsPerSection * e}`;
    }
  }
}, xv = ["aria-current", "aria-label", "onClick"];
function Wv(e, t, n, r, o, i) {
  return d(), f("div", {
    class: "pager",
    style: Z(i.pagerStyles)
  }, [
    (d(!0), f(J, null, ne(n.pagerSectionCount, (a, s) => (d(), f("button", {
      key: s,
      class: _([{ active: i.activeCard(a) }, "section"]),
      "aria-current": i.ariaLabel(a),
      "aria-label": i.ariaText(a),
      onClick: (l) => e.$emit("go-to-section", a)
    }, null, 10, xv))), 128))
  ], 4);
}
const d0 = /* @__PURE__ */ B(Zv, [["render", Wv], ["__scopeId", "data-v-627c6375"]]), Yv = {
  name: "SliderLeftButton",
  props: {
    arrowBackgroundColor: {
      type: String,
      default: "#FFFFFF"
    },
    arrowIconColor: {
      type: String,
      default: "#FFFFFF"
    },
    translatedAria: {
      type: String,
      default: ""
    }
  }
}, Xv = ["aria-label"], Qv = {
  width: "15",
  height: "12",
  viewBox: "0 0 15 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Jv = ["stroke"];
function eb(e, t, n, r, o, i) {
  return d(), f("button", {
    class: "scroll-left",
    "aria-label": n.translatedAria,
    style: Z({ "background-color": n.arrowBackgroundColor }),
    onClick: t[0] || (t[0] = (a) => e.$emit("scroll-left"))
  }, [
    (d(), f("svg", Qv, [
      c("path", {
        d: "M1 6L14 6M1 6L5.78947 11M1 6L5.78947 0.999999",
        stroke: n.arrowIconColor,
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, Jv)
    ]))
  ], 12, Xv);
}
const tb = /* @__PURE__ */ B(Yv, [["render", eb], ["__scopeId", "data-v-766a4ad9"]]), nb = {
  name: "SliderRightButton",
  props: {
    arrowBackgroundColor: {
      type: String,
      default: "#FFFFFF"
    },
    arrowIconColor: {
      type: String,
      default: "#FFFFFF"
    },
    translatedAria: {
      type: String,
      default: ""
    }
  }
}, rb = ["aria-label"], ob = {
  width: "15",
  height: "12",
  viewBox: "0 0 15 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, ib = ["stroke"];
function sb(e, t, n, r, o, i) {
  return d(), f("button", {
    class: "scroll-right",
    "aria-label": n.translatedAria,
    style: Z({ "background-color": n.arrowBackgroundColor }),
    onClick: t[0] || (t[0] = (a) => e.$emit("scroll-right"))
  }, [
    (d(), f("svg", ob, [
      c("path", {
        d: "M14 6H1M14 6L9.21053 1M14 6L9.21053 11",
        stroke: n.arrowIconColor,
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, ib)
    ]))
  ], 12, rb);
}
const ab = /* @__PURE__ */ B(nb, [["render", sb], ["__scopeId", "data-v-e7f3ab3f"]]), lb = {
  name: "NavSection",
  components: {
    Pager: d0,
    LeftSliderButton: tb,
    RightSliderButton: ab
  },
  props: {
    hasPager: Boolean,
    hasAccent: Boolean,
    themeStyles: {
      type: Object,
      default: () => ({})
    },
    navOrientation: {
      type: String,
      default: "bottom"
    },
    pagerOrientation: {
      type: String,
      default: "right"
    },
    totalCards: {
      type: Number,
      default: 0
    },
    currentCard: {
      type: Number,
      default: 0
    },
    pagerSectionCount: {
      type: Number,
      default: 4
    },
    sectionHeader: {
      type: String,
      default: ""
    },
    screenSize: {
      type: Number,
      default: 0
    }
  },
  computed: {
    navStyles() {
      return {
        "--nav-margin-bottom": this.navOrientation === "top" ? "32px" : "0",
        "--nav-margin-top": this.navMarginTop,
        "--button-section-margin": this.navOrientation === "top" || this.navOrientation === "wide" ? "0" : "40px"
      };
    },
    eventArrowColor() {
      return $(this.themeStyles, "event_arrow_color.hex", "#fff");
    },
    arrowIconColor() {
      return $(this.themeStyles, "arrow_icon_color.hex", this.eventArrowColor);
    },
    arrowBackgroundColor() {
      return this.themeStyles.style === "texas" ? "transparent" : $(this.themeStyles, "arrow_background_color.hex", "#000");
    },
    pagerColor() {
      return $(this.themeStyles, "pager_color.hex", "#000");
    },
    accentColor() {
      return {
        "--accent-color": $(this.themeStyles, "accent_color.hex", "#000")
      };
    },
    navMarginTop() {
      switch (this.navOrientation) {
        case "wide":
          return this.themeStyles.version === "S5" ? this.screenSize < 600 ? "0" : "80px" : "32px";
        case "bottom":
          return "32px";
        default:
          return "0";
      }
    },
    nextSlideText() {
      return $(this.themeStyles, "translations.next_item", "Next Item").split(" ").join(` ${this.sectionHeader} `);
    },
    previousSlideText() {
      return $(this.themeStyles, "translations.previous_item", "Previous Item").split(" ").join(` ${this.sectionHeader} `);
    }
  }
}, ub = {
  class: "button-section",
  "data-testid": "slider-buttons"
}, db = {
  key: 0,
  class: "pager-section"
}, cb = {
  key: 1,
  class: "accent-border",
  "data-testid": "accent-border"
};
function hb(e, t, n, r, o, i) {
  const a = V("LeftSliderButton"), s = V("RightSliderButton"), l = V("Pager");
  return d(), f("div", {
    class: _(["nav", `pager-${n.pagerOrientation}`]),
    style: Z([n.themeStyles, i.navStyles]),
    role: "group",
    "aria-label": "slide controls"
  }, [
    c("div", ub, [
      j(a, {
        class: "button",
        "arrow-background-color": i.arrowBackgroundColor,
        "arrow-icon-color": i.arrowIconColor,
        "translated-aria": i.previousSlideText,
        onScrollLeft: t[0] || (t[0] = (u) => e.$emit("scroll-left"))
      }, null, 8, ["arrow-background-color", "arrow-icon-color", "translated-aria"]),
      j(s, {
        class: "button",
        "arrow-background-color": i.arrowBackgroundColor,
        "arrow-icon-color": i.arrowIconColor,
        "translated-aria": i.nextSlideText,
        onScrollRight: t[1] || (t[1] = (u) => e.$emit("scroll-right"))
      }, null, 8, ["arrow-background-color", "arrow-icon-color", "translated-aria"])
    ]),
    n.hasPager ? (d(), f("div", db, [
      j(l, {
        "total-cards": n.totalCards,
        "pager-color": i.pagerColor,
        "theme-styles": n.themeStyles,
        "current-card": n.currentCard,
        "pager-section-count": n.pagerSectionCount,
        onGoToSection: t[2] || (t[2] = (u) => e.$emit("go-to-section", u))
      }, null, 8, ["total-cards", "pager-color", "theme-styles", "current-card", "pager-section-count"])
    ])) : T("", !0),
    n.hasAccent ? (d(), f("div", cb)) : T("", !0)
  ], 6);
}
const mb = /* @__PURE__ */ B(lb, [["render", hb], ["__scopeId", "data-v-670020bb"]]), fb = {
  name: "CardSlider",
  components: { NavSection: mb },
  props: {
    navOrientation: {
      type: String,
      default: "bottom"
    },
    pagerOrientation: {
      type: String,
      default: "right"
    },
    hasPager: {
      type: Boolean,
      default: !0
    },
    hasAccent: Boolean,
    totalCards: {
      type: Number,
      default: 0
    },
    themeStyles: {
      type: Object,
      default: () => ({})
    },
    currentCard: {
      type: Number,
      default: 0
    },
    allCardsVisible: Boolean,
    screenSize: {
      type: Number,
      default: 0
    },
    pagerSectionCount: {
      type: Number,
      default: 4
    },
    sectionHeader: {
      type: String,
      required: !0
    }
  },
  emits: ["go-to-section", "scroll-left", "scroll-right"]
}, pb = ["aria-label"];
function gb(e, t, n, r, o, i) {
  const a = V("NavSection");
  return d(), f("div", {
    class: _([n.navOrientation, "card-slider"]),
    "aria-label": n.sectionHeader,
    role: "region",
    "aria-roledescription": "carousel"
  }, [
    n.allCardsVisible ? T("", !0) : (d(), L(a, {
      key: 0,
      "nav-orientation": n.navOrientation,
      "pager-orientation": n.pagerOrientation,
      "pager-section-count": n.pagerSectionCount,
      "has-accent": n.hasAccent,
      "current-card": n.currentCard,
      "total-cards": n.totalCards,
      "theme-styles": n.themeStyles,
      "has-pager": n.hasPager,
      "screen-size": n.screenSize,
      "section-header": n.sectionHeader,
      onGoToSection: t[0] || (t[0] = (s) => e.$emit("go-to-section", s)),
      onScrollLeft: t[1] || (t[1] = (s) => e.$emit("scroll-left")),
      onScrollRight: t[2] || (t[2] = (s) => e.$emit("scroll-right"))
    }, null, 8, ["nav-orientation", "pager-orientation", "pager-section-count", "has-accent", "current-card", "total-cards", "theme-styles", "has-pager", "screen-size", "section-header"])),
    M(e.$slots, "default")
  ], 10, pb);
}
const mn = /* @__PURE__ */ B(fb, [["render", gb], ["__scopeId", "data-v-fbf2997e"]]), vb = {
  name: "N5",
  components: { NewsStory: Ur, ArrowIcon: zv, CardSlider: mn },
  mixins: [cr, _t],
  data: () => ({
    activeNewsContainer: 0,
    newsArticles: []
  }),
  computed: {
    scrollbarArrowColor() {
      var e;
      return ((e = this.theme) == null ? void 0 : e.scrollbar_arrow_color) || { hex: "#FFF" };
    },
    cardSliderStyles() {
      var e, t;
      return ge(ae({}, this.theme), {
        arrow_background_color: ((e = this.theme) == null ? void 0 : e.scrollbar_bg_color) || this.cssVars["--scrollbar-bg_color"],
        arrow_icon_color: ((t = this.theme) == null ? void 0 : t.scrollbar_arrow_color) || this.cssVars["--scrollbar-arrow-color"]
      });
    },
    totalArticles() {
      return { "--total-articles": this.articles.slice(0, 6).length };
    },
    content() {
      return this.newsArticles;
    },
    sliderCenterSize() {
      return 959;
    },
    responsiveSliderImage() {
      return {
        "--responsive-width": this.newsArticles.length > 1 && this.screenSize >= 960 ? `${this.screenSize - 80}px` : "100%"
      };
    },
    hasAccentStyling() {
      return this.theme.globalThemeSettings.accentStyling;
    },
    overviewImage() {
      var e;
      return ((e = this.newsArticles[0]) == null ? void 0 : e.cover_image) || this.fallbackImage.url;
    },
    overviewTitle() {
      var e;
      return ((e = this.newsArticles[0]) == null ? void 0 : e.title) || "";
    },
    articleTitle() {
      var e;
      return ((e = this.newsArticles[this.currentCard]) == null ? void 0 : e.title) || "";
    },
    overviewPublishedTime() {
      var t;
      const e = (t = this.newsArticles[0]) != null && t.published_at ? new Date(this.newsArticles[0].published_at) : /* @__PURE__ */ new Date();
      return new Intl.DateTimeFormat("en-US", { dateStyle: "medium", timeStyle: "short" }).format(e);
    },
    overviewLink() {
      var e;
      return ((e = this.newsArticles[0]) == null ? void 0 : e.id) || "";
    },
    overviewStyles() {
      return {
        "--overview-width": this.newsArticles.length === 1 ? "100%" : "70%",
        "--overview-width-md": this.newsArticles.length === 1 ? "100%" : "55%",
        "--overview-body-width": this.newsArticles.length === 1 ? "auto" : "90%",
        "--overview-body-margin": this.newsArticles.length === 1 ? "48px" : "0",
        "--overview-margin-md": this.newsArticles.length === 1 ? "0" : "35px"
      };
    },
    scrollStyles() {
      return {
        "--wrapper-margin-bottom": this.newsArticles.length < 5 ? "0" : "-32px"
      };
    },
    articleLink() {
      var e;
      return ((e = this.newsArticles[this.currentCard]) == null ? void 0 : e.id) || "";
    },
    nextSlideText() {
      return $(this.translations, "next_item", "Next Item").split(" ").join(` ${this.sectionHeader} `);
    },
    previousSlideText() {
      return $(this.translations, "previous_item", "Previous Item").split(" ").join(` ${this.sectionHeader} `);
    },
    displaySeeAllBottom() {
      return this.isPurpleStyle || this.screenSize < 960 && !this.isBoldStyle || this.screenSize < 600;
    },
    displaySeeAllTop() {
      return !this.isPurpleStyle && this.screenSize >= 960 || this.isBoldStyle && this.screenSize < 959 && this.screenSize >= 600;
    },
    n5PagerStyle() {
      return {
        "--pager-width": `${this.screenSize / this.newsArticles.length * 0.8}px`
      };
    }
  },
  created() {
    this.newsArticles = this.articles.slice(0, 6);
  },
  methods: {
    /**
     * @name scrollUp
     * First it triggers the moveUp function.
     * Then, after the animation has ended, it re arrenges the order of the news list, removing the last element in the list and pushing it at the beginning.
     * Finally, updates the activeNewsContainer variable to update the scroll position and calls the resetTranslate function.
     */
    scrollUp() {
      const e = this.newsArticles, t = e.pop();
      e.unshift(t), this.newsArticles = e, this.activeNewsContainer === 0 ? this.activeNewsContainer = this.newsArticles.length - 1 : this.activeNewsContainer -= 1;
    },
    /**
     * @name scrollDown
     * First it triggers the moveDown function.
     * Then, after the animation has ended, it re arrenges the order of the news list, removing the first element in the list and pushing it at the end.
     * After that, it calls the function setOverviewNews to change the overview news on the left.
     * Finally, updates the activeNewsContainer variable to update the scroll position and calls the resetTranslate function.
     */
    scrollDown() {
      const e = this.newsArticles, t = e.shift();
      e.push(t), this.newsArticles = e, this.activeNewsContainer === this.newsArticles.length - 1 ? this.activeNewsContainer = 0 : this.activeNewsContainer += 1;
    }
  }
}, bb = { class: "news-v5-title" }, yb = ["data-testid"], _b = ["data-testid"], Cb = { class: "news-overview" }, wb = { class: "news-overview-body" }, Tb = ["href"], kb = ["src"], Eb = { class: "news-overview-published-time" }, Sb = { class: "news-overview-title" }, Mb = { class: "news-overview-link" }, Ab = ["aria-label"], Ib = {
  key: 0,
  class: "news-scroll",
  role: "group",
  "aria-label": "slide controls"
}, Lb = ["aria-label"], Db = ["aria-label"], $b = ["aria-current"], Ob = { class: "article-title" }, Pb = ["href"], Nb = ["href"];
function Hb(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("arrow-icon"), l = V("NewsStory"), u = V("CardSlider");
  return d(), f("div", {
    id: "news-n5",
    style: Z(e.cssVars),
    class: _([e.theme.style, { "is-editing": e.isEditing }]),
    "data-testid": "n5"
  }, [
    c("div", bb, [
      j(a, {
        class: _([e.theme.style, "see-all-top"]),
        "theme-options": e.theme
      }, {
        header: S(() => [
          c("h2", {
            "data-testid": `header-${e.theme.style}-top`
          }, [
            e.isMonterreyStyle ? (d(), f("span", {
              key: 0,
              "data-testid": `header-${e.theme.style}-top`,
              class: "header-top"
            }, [
              M(e.$slots, "header-top", {}, () => [
                H(k(e.sectionHeaderTop), 1)
              ], !0)
            ], 8, _b)) : T("", !0),
            M(e.$slots, "header", {}, () => [
              H(k(e.sectionHeader), 1)
            ], !0)
          ], 8, yb)
        ]),
        default: S(() => [
          i.displaySeeAllTop ? (d(), L(Y(e.isEditing ? "button" : "a"), {
            key: 0,
            class: _(["see-all-button hide-on-xs", e.theme.style]),
            href: e.seeAllLinkHref,
            target: e.seeAllLinkTarget,
            "data-testid": `see-all-${e.theme.style}-top`,
            onClick: t[0] || (t[0] = (m) => e.$emit("open-modal"))
          }, {
            default: S(() => [
              H(k(e.seeAllLinkName), 1)
            ]),
            _: 1
          }, 8, ["class", "href", "target", "data-testid"])) : T("", !0)
        ]),
        _: 3
      }, 8, ["class", "theme-options"])
    ]),
    e.screenSize >= 960 ? (d(), f("div", {
      key: 0,
      class: _(["news-content", { "is-editing": e.isEditing }]),
      style: Z(i.overviewStyles)
    }, [
      c("div", Cb, [
        c("div", wb, [
          c("a", {
            href: e.link(`article/${i.overviewLink}`)
          }, [
            c("div", {
              class: _([{ "accent-styling": i.hasAccentStyling }, "news-overview-image-container"])
            }, [
              (d(), f("img", {
                key: e.activeNewsContainer,
                src: i.overviewImage,
                style: Z({ objectPosition: e.calculateFocalPoints(e.newsArticles[0]) }),
                alt: "",
                class: "news-overview-image"
              }, null, 12, kb)),
              t[4] || (t[4] = c("div", { class: "news-backdrop" }, null, -1))
            ], 2),
            c("p", Eb, k(i.overviewPublishedTime), 1),
            c("h3", Sb, k(i.overviewTitle), 1),
            c("div", Mb, [
              c("p", null, k(e.translations.read_article), 1)
            ])
          ], 8, Tb)
        ])
      ]),
      c("div", {
        "aria-label": e.sectionHeader,
        class: "news-scroll-wrapper",
        role: "region",
        "aria-roledescription": "carousel"
      }, [
        e.newsArticles.length > 4 ? (d(), f("div", Ib, [
          c("button", {
            class: "news-scroll-up",
            "aria-label": i.previousSlideText,
            onClick: t[1] || (t[1] = (...m) => i.scrollUp && i.scrollUp(...m))
          }, [
            j(s, {
              "fill-color": i.scrollbarArrowColor.hex,
              class: "arrow"
            }, null, 8, ["fill-color"])
          ], 8, Lb),
          c("button", {
            class: "news-scroll-down",
            "aria-label": i.nextSlideText,
            onClick: t[2] || (t[2] = (...m) => i.scrollDown && i.scrollDown(...m))
          }, [
            j(s, {
              "fill-color": i.scrollbarArrowColor.hex,
              class: "arrow",
              "dropdown-class": "open"
            }, null, 8, ["fill-color"])
          ], 8, Db),
          c("div", {
            class: "progress-bar",
            style: Z(i.totalArticles)
          }, [
            (d(!0), f(J, null, ne(e.newsArticles, (m, v) => (d(), f("div", {
              key: m.id,
              class: _(["progress-section", { active: e.activeNewsContainer === v }]),
              "aria-current": e.activeNewsContainer === v ? e.translations.active : e.translations.inactive
            }, null, 10, $b))), 128))
          ], 4)
        ])) : T("", !0),
        c("div", {
          class: "news-list",
          "data-testid": "list",
          style: Z({ "margin-right": e.newsArticles.length < 5 ? "15px" : 0 })
        }, [
          j(Zn, {
            name: "scroll-wrapper",
            tag: "div",
            class: "scroll-wrapper",
            style: Z(i.scrollStyles)
          }, {
            default: S(() => [
              (d(!0), f(J, null, ne(e.newsArticles, (m, v) => (d(), L(l, {
                key: m.id,
                item: m,
                theme: e.theme,
                class: _([{ "is-editing": e.isEditing, "has-scroll": e.newsArticles.length > 4 }, "article-container"]),
                "show-snippet": !1,
                "is-preview": e.isPreview,
                "fallback-image": e.fallbackImage,
                "path-prefix": e.pathPrefix,
                "total-cards": e.newsArticles.length,
                "card-number": v + 1,
                variant: "N5-story",
                "data-testid": "news-story"
              }, null, 8, ["item", "theme", "class", "is-preview", "fallback-image", "path-prefix", "total-cards", "card-number"]))), 128))
            ]),
            _: 1
          }, 8, ["style"])
        ], 4)
      ], 8, Ab)
    ], 6)) : (d(), L(u, {
      key: 1,
      "current-card": e.currentCard,
      "pager-section-count": e.newsArticles.length,
      "all-cards-visible": e.newsArticles.length === 1,
      "total-cards": e.newsArticles.length,
      "theme-styles": i.cardSliderStyles,
      "section-header": e.sectionHeader,
      "pager-orientation": "right",
      class: _({ "all-cards-visible": e.allCardsVisible }),
      style: Z(i.n5PagerStyle),
      onScrollRight: e.scrollRight,
      onScrollLeft: e.scrollLeft,
      onGoToSection: e.goToSection
    }, {
      default: S(() => [
        c("div", {
          ref: "scrollWrapper",
          class: _(["scroll-wrapper", { "all-cards-visible": e.allCardsVisible }]),
          "data-testid": "blocks-array"
        }, [
          (d(), L(l, {
            ref: "`sliderCard-0",
            key: e.newsArticles[e.currentCard].id,
            item: e.newsArticles[e.currentCard],
            theme: e.theme,
            "show-snippet": !1,
            "show-title": !1,
            "show-published-time": !0,
            "is-preview": e.isPreview,
            "fallback-image": e.fallbackImage,
            "path-prefix": e.pathPrefix,
            "total-cards": e.newsArticles.length,
            "card-number": e.currentCard,
            "aria-label": `${e.currentCard} of ${e.newsArticles.length}`,
            class: _([{ "is-editing": e.isEditing }, "article"]),
            "aria-roledescription": "slide",
            role: "group",
            variant: "N5-story",
            "data-testid": "news-story",
            style: Z(i.responsiveSliderImage)
          }, null, 8, ["item", "theme", "is-preview", "fallback-image", "path-prefix", "total-cards", "card-number", "aria-label", "class", "style"])),
          c("h3", Ob, [
            c("a", {
              href: e.link(`article/${e.newsArticles[e.currentCard].id}`)
            }, k(i.articleTitle), 9, Pb)
          ]),
          c("a", {
            href: e.link(`article/${e.newsArticles[e.currentCard].id}`),
            class: "article-link"
          }, [
            c("p", null, k(e.translations.read_article), 1)
          ], 8, Nb)
        ], 2)
      ]),
      _: 1
    }, 8, ["current-card", "pager-section-count", "all-cards-visible", "total-cards", "theme-styles", "section-header", "class", "style", "onScrollRight", "onScrollLeft", "onGoToSection"])),
    i.displaySeeAllBottom ? (d(), L(a, {
      key: 2,
      class: _([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme,
      "data-testid": `see-all-${e.theme.style}-bottom`
    }, {
      default: S(() => [
        (d(), L(Y(e.isEditing ? "button" : "a"), {
          class: _(["see-all-events see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          onClick: t[3] || (t[3] = (m) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options", "data-testid"])) : T("", !0)
  ], 6);
}
const Fb = /* @__PURE__ */ B(vb, [["render", Hb], ["__scopeId", "data-v-c67050fe"]]), Rb = {
  name: "N6",
  components: { NewsStory: Ur, CardSlider: mn },
  mixins: [cr, _t],
  data() {
    const e = this.articles.slice(0, 6);
    return {
      newsArticles: e,
      newsArticlesLength: e.length
    };
  },
  computed: {
    content() {
      return this.newsArticles;
    },
    themeStyles() {
      return ge(ae({}, this.theme), {
        arrow_background_color: { hex: this.cssVars["--arrow-background-color"] },
        pager_color: { hex: this.cssVars["--pager-color"] },
        arrow_icon_color: { hex: this.cssVars["--arrow-icon-color"] }
      });
    }
  }
}, Vb = ["data-testid"], Bb = ["data-testid"], jb = {
  ref: "scrollWrapper",
  class: "news-wrapper"
};
function Ub(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("NewsStory"), l = V("CardSlider");
  return d(), f("div", {
    id: "news-n6",
    "data-testid": "news-v6",
    style: Z(e.cssVars),
    class: _([e.theme.style, { "is-editing": e.isEditing }])
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        c("h2", {
          "data-testid": `header-${e.theme.style}-top`
        }, [
          e.isMonterreyStyle ? (d(), f("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            M(e.$slots, "header-top", {}, () => [
              H(k(e.sectionHeaderTop), 1)
            ], !0)
          ], 8, Bb)) : T("", !0),
          M(e.$slots, "header", {}, () => [
            H(k(e.sectionHeader), 1)
          ], !0)
        ], 8, Vb)
      ]),
      default: S(() => [
        e.theme.style !== "purple" && e.screenSize >= 600 ? (d(), L(Y(e.isEditing ? "button" : "a"), {
          key: 0,
          class: _(["hide-on-xs see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (u) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : T("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    j(l, {
      "nav-orientation": "bottom",
      "pager-orientation": "right",
      "current-card": e.currentCard,
      "pager-section-count": e.pagerSectionCount,
      "total-cards": o.newsArticles.length,
      class: _({ "is-editing": e.isEditing }),
      "theme-styles": i.themeStyles,
      "section-header": e.sectionHeader,
      onScrollRight: e.scrollRight,
      onScrollLeft: e.scrollLeft,
      onGoToSection: e.goToSection
    }, {
      default: S(() => [
        c("div", jb, [
          (d(!0), f(J, null, ne(o.newsArticles, (u, m) => (d(), L(s, {
            ref_for: !0,
            ref: `sliderCard-${m}`,
            key: u.id,
            item: u,
            theme: e.theme,
            class: _({ "is-editing": e.isEditing }),
            "is-preview": e.isPreview,
            "fallback-image": e.fallbackImage,
            "path-prefix": e.pathPrefix,
            "total-cards": o.newsArticles.length,
            "card-number": m + 1,
            "show-published-time": "",
            variant: "N6-story",
            "data-testid": "news-story"
          }, null, 8, ["item", "theme", "class", "is-preview", "fallback-image", "path-prefix", "total-cards", "card-number"]))), 128))
        ], 512)
      ]),
      _: 1
    }, 8, ["current-card", "pager-section-count", "total-cards", "class", "theme-styles", "section-header", "onScrollRight", "onScrollLeft", "onGoToSection"]),
    e.theme.style === "purple" || e.screenSize < 600 ? (d(), L(a, {
      key: 0,
      class: _([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme,
      "data-testid": `see-all-${e.theme.style}-bottom`
    }, {
      default: S(() => [
        (d(), L(Y(e.isEditing ? "button" : "a"), {
          class: _(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          onClick: t[1] || (t[1] = (u) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options", "data-testid"])) : T("", !0)
  ], 6);
}
const qb = /* @__PURE__ */ B(Rb, [["render", Ub], ["__scopeId", "data-v-5893c0e6"]]), Gb = {
  name: "N7",
  components: { NewsStory: Ur, CardSlider: mn },
  mixins: [cr, _t],
  data() {
    return {
      newsArticles: this.articles.slice(0, 6)
    };
  },
  computed: {
    content() {
      return this.newsArticles;
    },
    themeStyles() {
      return ge(ae({}, this.theme), {
        arrow_background_color: { hex: this.cssVars["--arrow-background-color"] },
        pager_color: { hex: this.cssVars["--pager-color"] },
        arrow_icon_color: { hex: this.cssVars["--arrow-icon-color"] }
      });
    }
  }
}, Kb = ["data-testid"], zb = ["data-testid"], Zb = { class: "color-overlay" }, xb = {
  ref: "scrollWrapper",
  class: "news-wrapper"
};
function Wb(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("NewsStory"), l = V("CardSlider");
  return d(), f("div", {
    "data-testid": "news-v7",
    style: Z(e.cssVars),
    class: _([e.theme.style, "news-n7"])
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        c("h2", {
          "data-testid": `header-${e.theme.style}-top`
        }, [
          e.isMonterreyStyle ? (d(), f("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            M(e.$slots, "header-top", {}, () => [
              H(k(e.sectionHeaderTop), 1)
            ], !0)
          ], 8, zb)) : T("", !0),
          M(e.$slots, "header", {}, () => [
            H(k(e.sectionHeader), 1)
          ], !0)
        ], 8, Kb)
      ]),
      default: S(() => [
        e.theme.style === "bold" && e.screenSize > 480 ? (d(), L(Y(e.isEditing ? "button" : "a"), {
          key: 0,
          class: _(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (u) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : T("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    c("div", Zb, [
      j(l, {
        "nav-orientation": "bottom",
        "pager-orientation": "right",
        "has-pager": !1,
        "current-card": e.currentCard,
        "total-cards": o.newsArticles.length,
        "section-header": e.sectionHeader,
        "theme-styles": i.themeStyles,
        onScrollRight: e.scrollRight,
        onScrollLeft: e.scrollLeft
      }, {
        default: S(() => [
          c("div", xb, [
            (d(!0), f(J, null, ne(o.newsArticles, (u, m) => (d(), L(s, {
              ref_for: !0,
              ref: `sliderCard-${m}`,
              key: u.id,
              item: u,
              theme: e.theme,
              "is-preview": e.isPreview,
              "fallback-image": e.fallbackImage,
              "path-prefix": e.pathPrefix,
              "total-cards": e.articles.length,
              "card-number": m + 1,
              "show-published-time": "",
              variant: "N7-story",
              "data-testid": "news-story"
            }, null, 8, ["item", "theme", "is-preview", "fallback-image", "path-prefix", "total-cards", "card-number"]))), 128))
          ], 512)
        ]),
        _: 1
      }, 8, ["current-card", "total-cards", "section-header", "theme-styles", "onScrollRight", "onScrollLeft"]),
      e.theme.style !== "bold" || e.screenSize < 960 ? (d(), L(a, {
        key: 0,
        class: _([e.theme.style, "see-all-bottom"]),
        "theme-options": e.theme
      }, {
        default: S(() => [
          (d(), L(Y(e.isEditing ? "button" : "a"), {
            class: _(["see-all-button", e.theme.style]),
            href: e.seeAllLinkHref,
            target: e.seeAllLinkTarget,
            "data-testid": `see-all-${e.theme.style}-bottom`,
            onClick: t[1] || (t[1] = (u) => e.$emit("open-modal"))
          }, {
            default: S(() => [
              H(k(e.seeAllLinkName), 1)
            ]),
            _: 1
          }, 8, ["class", "href", "target", "data-testid"]))
        ]),
        _: 1
      }, 8, ["class", "theme-options"])) : T("", !0)
    ])
  ], 6);
}
const Yb = /* @__PURE__ */ B(Gb, [["render", Wb], ["__scopeId", "data-v-68a98c6a"]]);
var ul, N2;
function Ds() {
  if (N2) return ul;
  N2 = 1;
  var e = Object.prototype;
  function t(n) {
    var r = n && n.constructor, o = typeof r == "function" && r.prototype || e;
    return n === o;
  }
  return ul = t, ul;
}
var dl, H2;
function yg() {
  if (H2) return dl;
  H2 = 1;
  function e(t, n) {
    return function(r) {
      return t(n(r));
    };
  }
  return dl = e, dl;
}
var cl, F2;
function Xb() {
  if (F2) return cl;
  F2 = 1;
  var e = yg(), t = e(Object.keys, Object);
  return cl = t, cl;
}
var hl, R2;
function _g() {
  if (R2) return hl;
  R2 = 1;
  var e = Ds(), t = Xb(), n = Object.prototype, r = n.hasOwnProperty;
  function o(i) {
    if (!e(i))
      return t(i);
    var a = [];
    for (var s in Object(i))
      r.call(i, s) && s != "constructor" && a.push(s);
    return a;
  }
  return hl = o, hl;
}
var ml, V2;
function Qb() {
  if (V2) return ml;
  V2 = 1;
  var e = jr(), t = hn(), n = e(t, "DataView");
  return ml = n, ml;
}
var fl, B2;
function Jb() {
  if (B2) return fl;
  B2 = 1;
  var e = jr(), t = hn(), n = e(t, "Promise");
  return fl = n, fl;
}
var pl, j2;
function ey() {
  if (j2) return pl;
  j2 = 1;
  var e = jr(), t = hn(), n = e(t, "Set");
  return pl = n, pl;
}
var gl, U2;
function ty() {
  if (U2) return gl;
  U2 = 1;
  var e = jr(), t = hn(), n = e(t, "WeakMap");
  return gl = n, gl;
}
var vl, q2;
function $s() {
  if (q2) return vl;
  q2 = 1;
  var e = Qb(), t = u0(), n = Jb(), r = ey(), o = ty(), i = pi(), a = mg(), s = "[object Map]", l = "[object Object]", u = "[object Promise]", m = "[object Set]", v = "[object WeakMap]", g = "[object DataView]", h = a(e), E = a(t), C = a(n), A = a(r), R = a(o), P = i;
  return (e && P(new e(new ArrayBuffer(1))) != g || t && P(new t()) != s || n && P(n.resolve()) != u || r && P(new r()) != m || o && P(new o()) != v) && (P = function(F) {
    var I = i(F), D = I == l ? F.constructor : void 0, O = D ? a(D) : "";
    if (O)
      switch (O) {
        case h:
          return g;
        case E:
          return s;
        case C:
          return u;
        case A:
          return m;
        case R:
          return v;
      }
    return I;
  }), vl = P, vl;
}
var bl, G2;
function ny() {
  if (G2) return bl;
  G2 = 1;
  var e = pi(), t = So(), n = "[object Arguments]";
  function r(o) {
    return t(o) && e(o) == n;
  }
  return bl = r, bl;
}
var yl, K2;
function Cg() {
  if (K2) return yl;
  K2 = 1;
  var e = ny(), t = So(), n = Object.prototype, r = n.hasOwnProperty, o = n.propertyIsEnumerable, i = e(/* @__PURE__ */ function() {
    return arguments;
  }()) ? e : function(a) {
    return t(a) && r.call(a, "callee") && !o.call(a, "callee");
  };
  return yl = i, yl;
}
var _l, z2;
function wg() {
  if (z2) return _l;
  z2 = 1;
  var e = 9007199254740991;
  function t(n) {
    return typeof n == "number" && n > -1 && n % 1 == 0 && n <= e;
  }
  return _l = t, _l;
}
var Cl, Z2;
function Os() {
  if (Z2) return Cl;
  Z2 = 1;
  var e = hg(), t = wg();
  function n(r) {
    return r != null && t(r.length) && !e(r);
  }
  return Cl = n, Cl;
}
var xo = { exports: {} }, wl, x2;
function ry() {
  if (x2) return wl;
  x2 = 1;
  function e() {
    return !1;
  }
  return wl = e, wl;
}
xo.exports;
var W2;
function c0() {
  return W2 || (W2 = 1, function(e, t) {
    var n = hn(), r = ry(), o = t && !t.nodeType && t, i = o && !0 && e && !e.nodeType && e, a = i && i.exports === o, s = a ? n.Buffer : void 0, l = s ? s.isBuffer : void 0, u = l || r;
    e.exports = u;
  }(xo, xo.exports)), xo.exports;
}
var Tl, Y2;
function oy() {
  if (Y2) return Tl;
  Y2 = 1;
  var e = pi(), t = wg(), n = So(), r = "[object Arguments]", o = "[object Array]", i = "[object Boolean]", a = "[object Date]", s = "[object Error]", l = "[object Function]", u = "[object Map]", m = "[object Number]", v = "[object Object]", g = "[object RegExp]", h = "[object Set]", E = "[object String]", C = "[object WeakMap]", A = "[object ArrayBuffer]", R = "[object DataView]", P = "[object Float32Array]", F = "[object Float64Array]", I = "[object Int8Array]", D = "[object Int16Array]", O = "[object Int32Array]", U = "[object Uint8Array]", q = "[object Uint8ClampedArray]", z = "[object Uint16Array]", te = "[object Uint32Array]", ee = {};
  ee[P] = ee[F] = ee[I] = ee[D] = ee[O] = ee[U] = ee[q] = ee[z] = ee[te] = !0, ee[r] = ee[o] = ee[A] = ee[i] = ee[R] = ee[a] = ee[s] = ee[l] = ee[u] = ee[m] = ee[v] = ee[g] = ee[h] = ee[E] = ee[C] = !1;
  function x(N) {
    return n(N) && t(N.length) && !!ee[e(N)];
  }
  return Tl = x, Tl;
}
var kl, X2;
function h0() {
  if (X2) return kl;
  X2 = 1;
  function e(t) {
    return function(n) {
      return t(n);
    };
  }
  return kl = e, kl;
}
var Wo = { exports: {} };
Wo.exports;
var Q2;
function m0() {
  return Q2 || (Q2 = 1, function(e, t) {
    var n = cg(), r = t && !t.nodeType && t, o = r && !0 && e && !e.nodeType && e, i = o && o.exports === r, a = i && n.process, s = function() {
      try {
        var l = o && o.require && o.require("util").types;
        return l || a && a.binding && a.binding("util");
      } catch (u) {
      }
    }();
    e.exports = s;
  }(Wo, Wo.exports)), Wo.exports;
}
var El, J2;
function Tg() {
  if (J2) return El;
  J2 = 1;
  var e = oy(), t = h0(), n = m0(), r = n && n.isTypedArray, o = r ? t(r) : e;
  return El = o, El;
}
var Sl, em;
function iy() {
  if (em) return Sl;
  em = 1;
  var e = _g(), t = $s(), n = Cg(), r = Br(), o = Os(), i = c0(), a = Ds(), s = Tg(), l = "[object Map]", u = "[object Set]", m = Object.prototype, v = m.hasOwnProperty;
  function g(h) {
    if (h == null)
      return !0;
    if (o(h) && (r(h) || typeof h == "string" || typeof h.splice == "function" || i(h) || s(h) || n(h)))
      return !h.length;
    var E = t(h);
    if (E == l || E == u)
      return !h.size;
    if (a(h))
      return !e(h).length;
    for (var C in h)
      if (v.call(h, C))
        return !1;
    return !0;
  }
  return Sl = g, Sl;
}
var sy = iy();
const qr = /* @__PURE__ */ Eo(sy), ay = {
  name: "News",
  components: {
    N1: Ev,
    N2: Dv,
    N3: Hv,
    N4: jv,
    N5: Fb,
    N6: qb,
    N7: Yb
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Array,
      default: () => []
    },
    newsConfig: {
      type: Object,
      default: () => ({})
    },
    componentId: {
      type: String,
      default: null
    },
    isPreview: {
      type: Boolean,
      default: !1
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    sidebarOffset: {
      type: Number,
      default: 0
    },
    fallbackImage: {
      type: Object,
      default: () => {
      }
    },
    isIFrame: {
      type: Boolean,
      default: !1
    },
    pathPrefix: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      fallbackImageDefault: {
        url: "https://d2kzwze52p8717.cloudfront.net/gallery_01.png",
        alt: "news default image"
      }
    };
  },
  computed: {
    cssVars() {
      return {
        "--sidebar-offset": `${this.sidebarOffset}px`
      };
    },
    fallbackImg() {
      return qr(this.fallbackImage) ? this.fallbackImageDefault : this.fallbackImage;
    }
  }
}, ly = { id: "view-news" };
function uy(e, t, n, r, o, i) {
  return d(), f("div", ly, [
    (d(), L(Y(n.theme.version), {
      style: Z(i.cssVars),
      theme: n.theme,
      articles: n.content,
      "news-config": n.newsConfig,
      "component-id": n.componentId,
      "is-preview": n.isPreview,
      "is-editing": n.isEditing,
      "is-i-frame": n.isIFrame,
      "fallback-image": i.fallbackImg,
      "path-prefix": n.pathPrefix,
      onOpenModal: t[0] || (t[0] = (a) => e.$emit("open-modal"))
    }, {
      "header-top": S(() => [
        M(e.$slots, "header-top", {}, void 0, !0)
      ]),
      header: S(() => [
        M(e.$slots, "header", {}, void 0, !0)
      ]),
      _: 3
    }, 40, ["style", "theme", "articles", "news-config", "component-id", "is-preview", "is-editing", "is-i-frame", "fallback-image", "path-prefix"]))
  ]);
}
const dy = /* @__PURE__ */ B(ay, [["render", uy], ["__scopeId", "data-v-b303fa92"]]);
function Bn(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function kg(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.__proto__ = t;
}
/*!
 * GSAP 3.13.0
 * https://gsap.com
 *
 * @license Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/
var Kt = {
  autoSleep: 120,
  force3D: "auto",
  nullTargetWarn: 1,
  units: {
    lineHeight: ""
  }
}, vo = {
  duration: 0.5,
  overwrite: !1,
  delay: 0
}, f0, ht, Ke, nn = 1e8, Fe = 1 / nn, Mc = Math.PI * 2, cy = Mc / 4, hy = 0, Eg = Math.sqrt, my = Math.cos, fy = Math.sin, lt = function(t) {
  return typeof t == "string";
}, Xe = function(t) {
  return typeof t == "function";
}, Kn = function(t) {
  return typeof t == "number";
}, p0 = function(t) {
  return typeof t == "undefined";
}, In = function(t) {
  return typeof t == "object";
}, Pt = function(t) {
  return t !== !1;
}, g0 = function() {
  return typeof window != "undefined";
}, Ui = function(t) {
  return Xe(t) || lt(t);
}, Sg = typeof ArrayBuffer == "function" && ArrayBuffer.isView || function() {
}, bt = Array.isArray, Ac = /(?:-?\.?\d|\.)+/gi, Mg = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, io = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, Ml = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, Ag = /[+-]=-?[.\d]+/, Ig = /[^,'"\[\]\s]+/gi, py = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, We, En, Ic, v0, Zt = {}, ls = {}, Lg, Dg = function(t) {
  return (ls = bo(t, Zt)) && Rt;
}, b0 = function(t, n) {
  return console.warn("Invalid property", t, "set to", n, "Missing plugin? gsap.registerPlugin()");
}, oi = function(t, n) {
  return !n && console.warn(t);
}, $g = function(t, n) {
  return t && (Zt[t] = n) && ls && (ls[t] = n) || Zt;
}, ii = function() {
  return 0;
}, gy = {
  suppressEvents: !0,
  isStart: !0,
  kill: !1
}, Wi = {
  suppressEvents: !0,
  kill: !1
}, vy = {
  suppressEvents: !0
}, y0 = {}, sr = [], Lc = {}, Og, Ut = {}, Al = {}, tm = 30, Yi = [], _0 = "", C0 = function(t) {
  var n = t[0], r, o;
  if (In(n) || Xe(n) || (t = [t]), !(r = (n._gsap || {}).harness)) {
    for (o = Yi.length; o-- && !Yi[o].targetTest(n); )
      ;
    r = Yi[o];
  }
  for (o = t.length; o--; )
    t[o] && (t[o]._gsap || (t[o]._gsap = new r4(t[o], r))) || t.splice(o, 1);
  return t;
}, $r = function(t) {
  return t._gsap || C0(rn(t))[0]._gsap;
}, Pg = function(t, n, r) {
  return (r = t[n]) && Xe(r) ? t[n]() : p0(r) && t.getAttribute && t.getAttribute(n) || r;
}, Nt = function(t, n) {
  return (t = t.split(",")).forEach(n) || t;
}, Qe = function(t) {
  return Math.round(t * 1e5) / 1e5 || 0;
}, it = function(t) {
  return Math.round(t * 1e7) / 1e7 || 0;
}, lo = function(t, n) {
  var r = n.charAt(0), o = parseFloat(n.substr(2));
  return t = parseFloat(t), r === "+" ? t + o : r === "-" ? t - o : r === "*" ? t * o : t / o;
}, by = function(t, n) {
  for (var r = n.length, o = 0; t.indexOf(n[o]) < 0 && ++o < r; )
    ;
  return o < r;
}, us = function() {
  var t = sr.length, n = sr.slice(0), r, o;
  for (Lc = {}, sr.length = 0, r = 0; r < t; r++)
    o = n[r], o && o._lazy && (o.render(o._lazy[0], o._lazy[1], !0)._lazy = 0);
}, w0 = function(t) {
  return !!(t._initted || t._startAt || t.add);
}, Ng = function(t, n, r, o) {
  sr.length && !ht && us(), t.render(n, r, !!(ht && n < 0 && w0(t))), sr.length && !ht && us();
}, Hg = function(t) {
  var n = parseFloat(t);
  return (n || n === 0) && (t + "").match(Ig).length < 2 ? n : lt(t) ? t.trim() : t;
}, Fg = function(t) {
  return t;
}, xt = function(t, n) {
  for (var r in n)
    r in t || (t[r] = n[r]);
  return t;
}, yy = function(t) {
  return function(n, r) {
    for (var o in r)
      o in n || o === "duration" && t || o === "ease" || (n[o] = r[o]);
  };
}, bo = function(t, n) {
  for (var r in n)
    t[r] = n[r];
  return t;
}, nm = function e(t, n) {
  for (var r in n)
    r !== "__proto__" && r !== "constructor" && r !== "prototype" && (t[r] = In(n[r]) ? e(t[r] || (t[r] = {}), n[r]) : n[r]);
  return t;
}, ds = function(t, n) {
  var r = {}, o;
  for (o in t)
    o in n || (r[o] = t[o]);
  return r;
}, Jo = function(t) {
  var n = t.parent || We, r = t.keyframes ? yy(bt(t.keyframes)) : xt;
  if (Pt(t.inherit))
    for (; n; )
      r(t, n.vars.defaults), n = n.parent || n._dp;
  return t;
}, _y = function(t, n) {
  for (var r = t.length, o = r === n.length; o && r-- && t[r] === n[r]; )
    ;
  return r < 0;
}, Rg = function(t, n, r, o, i) {
  var a = t[o], s;
  if (i)
    for (s = n[i]; a && a[i] > s; )
      a = a._prev;
  return a ? (n._next = a._next, a._next = n) : (n._next = t[r], t[r] = n), n._next ? n._next._prev = n : t[o] = n, n._prev = a, n.parent = n._dp = t, n;
}, Ps = function(t, n, r, o) {
  r === void 0 && (r = "_first"), o === void 0 && (o = "_last");
  var i = n._prev, a = n._next;
  i ? i._next = a : t[r] === n && (t[r] = a), a ? a._prev = i : t[o] === n && (t[o] = i), n._next = n._prev = n.parent = null;
}, lr = function(t, n) {
  t.parent && (!n || t.parent.autoRemoveChildren) && t.parent.remove && t.parent.remove(t), t._act = 0;
}, Or = function(t, n) {
  if (t && (!n || n._end > t._dur || n._start < 0))
    for (var r = t; r; )
      r._dirty = 1, r = r.parent;
  return t;
}, Cy = function(t) {
  for (var n = t.parent; n && n.parent; )
    n._dirty = 1, n.totalDuration(), n = n.parent;
  return t;
}, Dc = function(t, n, r, o) {
  return t._startAt && (ht ? t._startAt.revert(Wi) : t.vars.immediateRender && !t.vars.autoRevert || t._startAt.render(n, !0, o));
}, wy = function e(t) {
  return !t || t._ts && e(t.parent);
}, rm = function(t) {
  return t._repeat ? yo(t._tTime, t = t.duration() + t._rDelay) * t : 0;
}, yo = function(t, n) {
  var r = Math.floor(t = it(t / n));
  return t && r === t ? r - 1 : r;
}, cs = function(t, n) {
  return (t - n._start) * n._ts + (n._ts >= 0 ? 0 : n._dirty ? n.totalDuration() : n._tDur);
}, Ns = function(t) {
  return t._end = it(t._start + (t._tDur / Math.abs(t._ts || t._rts || Fe) || 0));
}, Hs = function(t, n) {
  var r = t._dp;
  return r && r.smoothChildTiming && t._ts && (t._start = it(r._time - (t._ts > 0 ? n / t._ts : ((t._dirty ? t.totalDuration() : t._tDur) - n) / -t._ts)), Ns(t), r._dirty || Or(r, t)), t;
}, Vg = function(t, n) {
  var r;
  if ((n._time || !n._dur && n._initted || n._start < t._time && (n._dur || !n.add)) && (r = cs(t.rawTime(), n), (!n._dur || gi(0, n.totalDuration(), r) - n._tTime > Fe) && n.render(r, !0)), Or(t, n)._dp && t._initted && t._time >= t._dur && t._ts) {
    if (t._dur < t.duration())
      for (r = t; r._dp; )
        r.rawTime() >= 0 && r.totalTime(r._tTime), r = r._dp;
    t._zTime = -Fe;
  }
}, Mn = function(t, n, r, o) {
  return n.parent && lr(n), n._start = it((Kn(r) ? r : r || t !== We ? tn(t, r, n) : t._time) + n._delay), n._end = it(n._start + (n.totalDuration() / Math.abs(n.timeScale()) || 0)), Rg(t, n, "_first", "_last", t._sort ? "_start" : 0), $c(n) || (t._recent = n), o || Vg(t, n), t._ts < 0 && Hs(t, t._tTime), t;
}, Bg = function(t, n) {
  return (Zt.ScrollTrigger || b0("scrollTrigger", n)) && Zt.ScrollTrigger.create(n, t);
}, jg = function(t, n, r, o, i) {
  if (k0(t, n, i), !t._initted)
    return 1;
  if (!r && t._pt && !ht && (t._dur && t.vars.lazy !== !1 || !t._dur && t.vars.lazy) && Og !== qt.frame)
    return sr.push(t), t._lazy = [i, o], 1;
}, Ty = function e(t) {
  var n = t.parent;
  return n && n._ts && n._initted && !n._lock && (n.rawTime() < 0 || e(n));
}, $c = function(t) {
  var n = t.data;
  return n === "isFromStart" || n === "isStart";
}, ky = function(t, n, r, o) {
  var i = t.ratio, a = n < 0 || !n && (!t._start && Ty(t) && !(!t._initted && $c(t)) || (t._ts < 0 || t._dp._ts < 0) && !$c(t)) ? 0 : 1, s = t._rDelay, l = 0, u, m, v;
  if (s && t._repeat && (l = gi(0, t._tDur, n), m = yo(l, s), t._yoyo && m & 1 && (a = 1 - a), m !== yo(t._tTime, s) && (i = 1 - a, t.vars.repeatRefresh && t._initted && t.invalidate())), a !== i || ht || o || t._zTime === Fe || !n && t._zTime) {
    if (!t._initted && jg(t, n, o, r, l))
      return;
    for (v = t._zTime, t._zTime = n || (r ? Fe : 0), r || (r = n && !v), t.ratio = a, t._from && (a = 1 - a), t._time = 0, t._tTime = l, u = t._pt; u; )
      u.r(a, u.d), u = u._next;
    n < 0 && Dc(t, n, r, !0), t._onUpdate && !r && Gt(t, "onUpdate"), l && t._repeat && !r && t.parent && Gt(t, "onRepeat"), (n >= t._tDur || n < 0) && t.ratio === a && (a && lr(t, 1), !r && !ht && (Gt(t, a ? "onComplete" : "onReverseComplete", !0), t._prom && t._prom()));
  } else t._zTime || (t._zTime = n);
}, Ey = function(t, n, r) {
  var o;
  if (r > n)
    for (o = t._first; o && o._start <= r; ) {
      if (o.data === "isPause" && o._start > n)
        return o;
      o = o._next;
    }
  else
    for (o = t._last; o && o._start >= r; ) {
      if (o.data === "isPause" && o._start < n)
        return o;
      o = o._prev;
    }
}, _o = function(t, n, r, o) {
  var i = t._repeat, a = it(n) || 0, s = t._tTime / t._tDur;
  return s && !o && (t._time *= a / t._dur), t._dur = a, t._tDur = i ? i < 0 ? 1e10 : it(a * (i + 1) + t._rDelay * i) : a, s > 0 && !o && Hs(t, t._tTime = t._tDur * s), t.parent && Ns(t), r || Or(t.parent, t), t;
}, om = function(t) {
  return t instanceof kt ? Or(t) : _o(t, t._dur);
}, Sy = {
  _start: 0,
  endTime: ii,
  totalDuration: ii
}, tn = function e(t, n, r) {
  var o = t.labels, i = t._recent || Sy, a = t.duration() >= nn ? i.endTime(!1) : t._dur, s, l, u;
  return lt(n) && (isNaN(n) || n in o) ? (l = n.charAt(0), u = n.substr(-1) === "%", s = n.indexOf("="), l === "<" || l === ">" ? (s >= 0 && (n = n.replace(/=/, "")), (l === "<" ? i._start : i.endTime(i._repeat >= 0)) + (parseFloat(n.substr(1)) || 0) * (u ? (s < 0 ? i : r).totalDuration() / 100 : 1)) : s < 0 ? (n in o || (o[n] = a), o[n]) : (l = parseFloat(n.charAt(s - 1) + n.substr(s + 1)), u && r && (l = l / 100 * (bt(r) ? r[0] : r).totalDuration()), s > 1 ? e(t, n.substr(0, s - 1), r) + l : a + l)) : n == null ? a : +n;
}, ei = function(t, n, r) {
  var o = Kn(n[1]), i = (o ? 2 : 1) + (t < 2 ? 0 : 1), a = n[i], s, l;
  if (o && (a.duration = n[1]), a.parent = r, t) {
    for (s = a, l = r; l && !("immediateRender" in s); )
      s = l.vars.defaults || {}, l = Pt(l.vars.inherit) && l.parent;
    a.immediateRender = Pt(s.immediateRender), t < 2 ? a.runBackwards = 1 : a.startAt = n[i - 1];
  }
  return new ot(n[0], a, n[i + 1]);
}, hr = function(t, n) {
  return t || t === 0 ? n(t) : n;
}, gi = function(t, n, r) {
  return r < t ? t : r > n ? n : r;
}, gt = function(t, n) {
  return !lt(t) || !(n = py.exec(t)) ? "" : n[1];
}, My = function(t, n, r) {
  return hr(r, function(o) {
    return gi(t, n, o);
  });
}, Oc = [].slice, Ug = function(t, n) {
  return t && In(t) && "length" in t && (!n && !t.length || t.length - 1 in t && In(t[0])) && !t.nodeType && t !== En;
}, Ay = function(t, n, r) {
  return r === void 0 && (r = []), t.forEach(function(o) {
    var i;
    return lt(o) && !n || Ug(o, 1) ? (i = r).push.apply(i, rn(o)) : r.push(o);
  }) || r;
}, rn = function(t, n, r) {
  return Ke && !n && Ke.selector ? Ke.selector(t) : lt(t) && !r && (Ic || !Co()) ? Oc.call((n || v0).querySelectorAll(t), 0) : bt(t) ? Ay(t, r) : Ug(t) ? Oc.call(t, 0) : t ? [t] : [];
}, Pc = function(t) {
  return t = rn(t)[0] || oi("Invalid scope") || {}, function(n) {
    var r = t.current || t.nativeElement || t;
    return rn(n, r.querySelectorAll ? r : r === t ? oi("Invalid scope") || v0.createElement("div") : t);
  };
}, qg = function(t) {
  return t.sort(function() {
    return 0.5 - Math.random();
  });
}, Gg = function(t) {
  if (Xe(t))
    return t;
  var n = In(t) ? t : {
    each: t
  }, r = Pr(n.ease), o = n.from || 0, i = parseFloat(n.base) || 0, a = {}, s = o > 0 && o < 1, l = isNaN(o) || s, u = n.axis, m = o, v = o;
  return lt(o) ? m = v = {
    center: 0.5,
    edges: 0.5,
    end: 1
  }[o] || 0 : !s && l && (m = o[0], v = o[1]), function(g, h, E) {
    var C = (E || n).length, A = a[C], R, P, F, I, D, O, U, q, z;
    if (!A) {
      if (z = n.grid === "auto" ? 0 : (n.grid || [1, nn])[1], !z) {
        for (U = -nn; U < (U = E[z++].getBoundingClientRect().left) && z < C; )
          ;
        z < C && z--;
      }
      for (A = a[C] = [], R = l ? Math.min(z, C) * m - 0.5 : o % z, P = z === nn ? 0 : l ? C * v / z - 0.5 : o / z | 0, U = 0, q = nn, O = 0; O < C; O++)
        F = O % z - R, I = P - (O / z | 0), A[O] = D = u ? Math.abs(u === "y" ? I : F) : Eg(F * F + I * I), D > U && (U = D), D < q && (q = D);
      o === "random" && qg(A), A.max = U - q, A.min = q, A.v = C = (parseFloat(n.amount) || parseFloat(n.each) * (z > C ? C - 1 : u ? u === "y" ? C / z : z : Math.max(z, C / z)) || 0) * (o === "edges" ? -1 : 1), A.b = C < 0 ? i - C : i, A.u = gt(n.amount || n.each) || 0, r = r && C < 0 ? e4(r) : r;
    }
    return C = (A[g] - A.min) / A.max || 0, it(A.b + (r ? r(C) : C) * A.v) + A.u;
  };
}, Nc = function(t) {
  var n = Math.pow(10, ((t + "").split(".")[1] || "").length);
  return function(r) {
    var o = it(Math.round(parseFloat(r) / t) * t * n);
    return (o - o % 1) / n + (Kn(r) ? 0 : gt(r));
  };
}, Kg = function(t, n) {
  var r = bt(t), o, i;
  return !r && In(t) && (o = r = t.radius || nn, t.values ? (t = rn(t.values), (i = !Kn(t[0])) && (o *= o)) : t = Nc(t.increment)), hr(n, r ? Xe(t) ? function(a) {
    return i = t(a), Math.abs(i - a) <= o ? i : a;
  } : function(a) {
    for (var s = parseFloat(i ? a.x : a), l = parseFloat(i ? a.y : 0), u = nn, m = 0, v = t.length, g, h; v--; )
      i ? (g = t[v].x - s, h = t[v].y - l, g = g * g + h * h) : g = Math.abs(t[v] - s), g < u && (u = g, m = v);
    return m = !o || u <= o ? t[m] : a, i || m === a || Kn(a) ? m : m + gt(a);
  } : Nc(t));
}, zg = function(t, n, r, o) {
  return hr(bt(t) ? !n : r === !0 ? !!(r = 0) : !o, function() {
    return bt(t) ? t[~~(Math.random() * t.length)] : (r = r || 1e-5) && (o = r < 1 ? Math.pow(10, (r + "").length - 2) : 1) && Math.floor(Math.round((t - r / 2 + Math.random() * (n - t + r * 0.99)) / r) * r * o) / o;
  });
}, Iy = function() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  return function(o) {
    return n.reduce(function(i, a) {
      return a(i);
    }, o);
  };
}, Ly = function(t, n) {
  return function(r) {
    return t(parseFloat(r)) + (n || gt(r));
  };
}, Dy = function(t, n, r) {
  return xg(t, n, 0, 1, r);
}, Zg = function(t, n, r) {
  return hr(r, function(o) {
    return t[~~n(o)];
  });
}, $y = function e(t, n, r) {
  var o = n - t;
  return bt(t) ? Zg(t, e(0, t.length), n) : hr(r, function(i) {
    return (o + (i - t) % o) % o + t;
  });
}, Oy = function e(t, n, r) {
  var o = n - t, i = o * 2;
  return bt(t) ? Zg(t, e(0, t.length - 1), n) : hr(r, function(a) {
    return a = (i + (a - t) % i) % i || 0, t + (a > o ? i - a : a);
  });
}, si = function(t) {
  for (var n = 0, r = "", o, i, a, s; ~(o = t.indexOf("random(", n)); )
    a = t.indexOf(")", o), s = t.charAt(o + 7) === "[", i = t.substr(o + 7, a - o - 7).match(s ? Ig : Ac), r += t.substr(n, o - n) + zg(s ? i : +i[0], s ? 0 : +i[1], +i[2] || 1e-5), n = a + 1;
  return r + t.substr(n, t.length - n);
}, xg = function(t, n, r, o, i) {
  var a = n - t, s = o - r;
  return hr(i, function(l) {
    return r + ((l - t) / a * s || 0);
  });
}, Py = function e(t, n, r, o) {
  var i = isNaN(t + n) ? 0 : function(h) {
    return (1 - h) * t + h * n;
  };
  if (!i) {
    var a = lt(t), s = {}, l, u, m, v, g;
    if (r === !0 && (o = 1) && (r = null), a)
      t = {
        p: t
      }, n = {
        p: n
      };
    else if (bt(t) && !bt(n)) {
      for (m = [], v = t.length, g = v - 2, u = 1; u < v; u++)
        m.push(e(t[u - 1], t[u]));
      v--, i = function(E) {
        E *= v;
        var C = Math.min(g, ~~E);
        return m[C](E - C);
      }, r = n;
    } else o || (t = bo(bt(t) ? [] : {}, t));
    if (!m) {
      for (l in n)
        T0.call(s, t, l, "get", n[l]);
      i = function(E) {
        return M0(E, s) || (a ? t.p : t);
      };
    }
  }
  return hr(r, i);
}, im = function(t, n, r) {
  var o = t.labels, i = nn, a, s, l;
  for (a in o)
    s = o[a] - n, s < 0 == !!r && s && i > (s = Math.abs(s)) && (l = a, i = s);
  return l;
}, Gt = function(t, n, r) {
  var o = t.vars, i = o[n], a = Ke, s = t._ctx, l, u, m;
  if (i)
    return l = o[n + "Params"], u = o.callbackScope || t, r && sr.length && us(), s && (Ke = s), m = l ? i.apply(u, l) : i.call(u), Ke = a, m;
}, Yo = function(t) {
  return lr(t), t.scrollTrigger && t.scrollTrigger.kill(!!ht), t.progress() < 1 && Gt(t, "onInterrupt"), t;
}, so, Wg = [], Yg = function(t) {
  if (t)
    if (t = !t.name && t.default || t, g0() || t.headless) {
      var n = t.name, r = Xe(t), o = n && !r && t.init ? function() {
        this._props = [];
      } : t, i = {
        init: ii,
        render: M0,
        add: T0,
        kill: Yy,
        modifier: Wy,
        rawVars: 0
      }, a = {
        targetTest: 0,
        get: 0,
        getSetter: S0,
        aliases: {},
        register: 0
      };
      if (Co(), t !== o) {
        if (Ut[n])
          return;
        xt(o, xt(ds(t, i), a)), bo(o.prototype, bo(i, ds(t, a))), Ut[o.prop = n] = o, t.targetTest && (Yi.push(o), y0[n] = 1), n = (n === "css" ? "CSS" : n.charAt(0).toUpperCase() + n.substr(1)) + "Plugin";
      }
      $g(n, o), t.register && t.register(Rt, o, Ht);
    } else
      Wg.push(t);
}, He = 255, Xo = {
  aqua: [0, He, He],
  lime: [0, He, 0],
  silver: [192, 192, 192],
  black: [0, 0, 0],
  maroon: [128, 0, 0],
  teal: [0, 128, 128],
  blue: [0, 0, He],
  navy: [0, 0, 128],
  white: [He, He, He],
  olive: [128, 128, 0],
  yellow: [He, He, 0],
  orange: [He, 165, 0],
  gray: [128, 128, 128],
  purple: [128, 0, 128],
  green: [0, 128, 0],
  red: [He, 0, 0],
  pink: [He, 192, 203],
  cyan: [0, He, He],
  transparent: [He, He, He, 0]
}, Il = function(t, n, r) {
  return t += t < 0 ? 1 : t > 1 ? -1 : 0, (t * 6 < 1 ? n + (r - n) * t * 6 : t < 0.5 ? r : t * 3 < 2 ? n + (r - n) * (2 / 3 - t) * 6 : n) * He + 0.5 | 0;
}, Xg = function(t, n, r) {
  var o = t ? Kn(t) ? [t >> 16, t >> 8 & He, t & He] : 0 : Xo.black, i, a, s, l, u, m, v, g, h, E;
  if (!o) {
    if (t.substr(-1) === "," && (t = t.substr(0, t.length - 1)), Xo[t])
      o = Xo[t];
    else if (t.charAt(0) === "#") {
      if (t.length < 6 && (i = t.charAt(1), a = t.charAt(2), s = t.charAt(3), t = "#" + i + i + a + a + s + s + (t.length === 5 ? t.charAt(4) + t.charAt(4) : "")), t.length === 9)
        return o = parseInt(t.substr(1, 6), 16), [o >> 16, o >> 8 & He, o & He, parseInt(t.substr(7), 16) / 255];
      t = parseInt(t.substr(1), 16), o = [t >> 16, t >> 8 & He, t & He];
    } else if (t.substr(0, 3) === "hsl") {
      if (o = E = t.match(Ac), !n)
        l = +o[0] % 360 / 360, u = +o[1] / 100, m = +o[2] / 100, a = m <= 0.5 ? m * (u + 1) : m + u - m * u, i = m * 2 - a, o.length > 3 && (o[3] *= 1), o[0] = Il(l + 1 / 3, i, a), o[1] = Il(l, i, a), o[2] = Il(l - 1 / 3, i, a);
      else if (~t.indexOf("="))
        return o = t.match(Mg), r && o.length < 4 && (o[3] = 1), o;
    } else
      o = t.match(Ac) || Xo.transparent;
    o = o.map(Number);
  }
  return n && !E && (i = o[0] / He, a = o[1] / He, s = o[2] / He, v = Math.max(i, a, s), g = Math.min(i, a, s), m = (v + g) / 2, v === g ? l = u = 0 : (h = v - g, u = m > 0.5 ? h / (2 - v - g) : h / (v + g), l = v === i ? (a - s) / h + (a < s ? 6 : 0) : v === a ? (s - i) / h + 2 : (i - a) / h + 4, l *= 60), o[0] = ~~(l + 0.5), o[1] = ~~(u * 100 + 0.5), o[2] = ~~(m * 100 + 0.5)), r && o.length < 4 && (o[3] = 1), o;
}, Qg = function(t) {
  var n = [], r = [], o = -1;
  return t.split(ar).forEach(function(i) {
    var a = i.match(io) || [];
    n.push.apply(n, a), r.push(o += a.length + 1);
  }), n.c = r, n;
}, sm = function(t, n, r) {
  var o = "", i = (t + o).match(ar), a = n ? "hsla(" : "rgba(", s = 0, l, u, m, v;
  if (!i)
    return t;
  if (i = i.map(function(g) {
    return (g = Xg(g, n, 1)) && a + (n ? g[0] + "," + g[1] + "%," + g[2] + "%," + g[3] : g.join(",")) + ")";
  }), r && (m = Qg(t), l = r.c, l.join(o) !== m.c.join(o)))
    for (u = t.replace(ar, "1").split(io), v = u.length - 1; s < v; s++)
      o += u[s] + (~l.indexOf(s) ? i.shift() || a + "0,0,0,0)" : (m.length ? m : i.length ? i : r).shift());
  if (!u)
    for (u = t.split(ar), v = u.length - 1; s < v; s++)
      o += u[s] + i[s];
  return o + u[v];
}, ar = function() {
  var e = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", t;
  for (t in Xo)
    e += "|" + t + "\\b";
  return new RegExp(e + ")", "gi");
}(), Ny = /hsl[a]?\(/, Jg = function(t) {
  var n = t.join(" "), r;
  if (ar.lastIndex = 0, ar.test(n))
    return r = Ny.test(n), t[1] = sm(t[1], r), t[0] = sm(t[0], r, Qg(t[1])), !0;
}, ai, qt = function() {
  var e = Date.now, t = 500, n = 33, r = e(), o = r, i = 1e3 / 240, a = i, s = [], l, u, m, v, g, h, E = function C(A) {
    var R = e() - o, P = A === !0, F, I, D, O;
    if ((R > t || R < 0) && (r += R - n), o += R, D = o - r, F = D - a, (F > 0 || P) && (O = ++v.frame, g = D - v.time * 1e3, v.time = D = D / 1e3, a += F + (F >= i ? 4 : i - F), I = 1), P || (l = u(C)), I)
      for (h = 0; h < s.length; h++)
        s[h](D, g, O, A);
  };
  return v = {
    time: 0,
    frame: 0,
    tick: function() {
      E(!0);
    },
    deltaRatio: function(A) {
      return g / (1e3 / (A || 60));
    },
    wake: function() {
      Lg && (!Ic && g0() && (En = Ic = window, v0 = En.document || {}, Zt.gsap = Rt, (En.gsapVersions || (En.gsapVersions = [])).push(Rt.version), Dg(ls || En.GreenSockGlobals || !En.gsap && En || {}), Wg.forEach(Yg)), m = typeof requestAnimationFrame != "undefined" && requestAnimationFrame, l && v.sleep(), u = m || function(A) {
        return setTimeout(A, a - v.time * 1e3 + 1 | 0);
      }, ai = 1, E(2));
    },
    sleep: function() {
      (m ? cancelAnimationFrame : clearTimeout)(l), ai = 0, u = ii;
    },
    lagSmoothing: function(A, R) {
      t = A || 1 / 0, n = Math.min(R || 33, t);
    },
    fps: function(A) {
      i = 1e3 / (A || 240), a = v.time * 1e3 + i;
    },
    add: function(A, R, P) {
      var F = R ? function(I, D, O, U) {
        A(I, D, O, U), v.remove(F);
      } : A;
      return v.remove(A), s[P ? "unshift" : "push"](F), Co(), F;
    },
    remove: function(A, R) {
      ~(R = s.indexOf(A)) && s.splice(R, 1) && h >= R && h--;
    },
    _listeners: s
  }, v;
}(), Co = function() {
  return !ai && qt.wake();
}, Ee = {}, Hy = /^[\d.\-M][\d.\-,\s]/, Fy = /["']/g, Ry = function(t) {
  for (var n = {}, r = t.substr(1, t.length - 3).split(":"), o = r[0], i = 1, a = r.length, s, l, u; i < a; i++)
    l = r[i], s = i !== a - 1 ? l.lastIndexOf(",") : l.length, u = l.substr(0, s), n[o] = isNaN(u) ? u.replace(Fy, "").trim() : +u, o = l.substr(s + 1).trim();
  return n;
}, Vy = function(t) {
  var n = t.indexOf("(") + 1, r = t.indexOf(")"), o = t.indexOf("(", n);
  return t.substring(n, ~o && o < r ? t.indexOf(")", r + 1) : r);
}, By = function(t) {
  var n = (t + "").split("("), r = Ee[n[0]];
  return r && n.length > 1 && r.config ? r.config.apply(null, ~t.indexOf("{") ? [Ry(n[1])] : Vy(t).split(",").map(Hg)) : Ee._CE && Hy.test(t) ? Ee._CE("", t) : r;
}, e4 = function(t) {
  return function(n) {
    return 1 - t(1 - n);
  };
}, t4 = function e(t, n) {
  for (var r = t._first, o; r; )
    r instanceof kt ? e(r, n) : r.vars.yoyoEase && (!r._yoyo || !r._repeat) && r._yoyo !== n && (r.timeline ? e(r.timeline, n) : (o = r._ease, r._ease = r._yEase, r._yEase = o, r._yoyo = n)), r = r._next;
}, Pr = function(t, n) {
  return t && (Xe(t) ? t : Ee[t] || By(t)) || n;
}, Gr = function(t, n, r, o) {
  r === void 0 && (r = function(l) {
    return 1 - n(1 - l);
  }), o === void 0 && (o = function(l) {
    return l < 0.5 ? n(l * 2) / 2 : 1 - n((1 - l) * 2) / 2;
  });
  var i = {
    easeIn: n,
    easeOut: r,
    easeInOut: o
  }, a;
  return Nt(t, function(s) {
    Ee[s] = Zt[s] = i, Ee[a = s.toLowerCase()] = r;
    for (var l in i)
      Ee[a + (l === "easeIn" ? ".in" : l === "easeOut" ? ".out" : ".inOut")] = Ee[s + "." + l] = i[l];
  }), i;
}, n4 = function(t) {
  return function(n) {
    return n < 0.5 ? (1 - t(1 - n * 2)) / 2 : 0.5 + t((n - 0.5) * 2) / 2;
  };
}, Ll = function e(t, n, r) {
  var o = n >= 1 ? n : 1, i = (r || (t ? 0.3 : 0.45)) / (n < 1 ? n : 1), a = i / Mc * (Math.asin(1 / o) || 0), s = function(m) {
    return m === 1 ? 1 : o * Math.pow(2, -10 * m) * fy((m - a) * i) + 1;
  }, l = t === "out" ? s : t === "in" ? function(u) {
    return 1 - s(1 - u);
  } : n4(s);
  return i = Mc / i, l.config = function(u, m) {
    return e(t, u, m);
  }, l;
}, Dl = function e(t, n) {
  n === void 0 && (n = 1.70158);
  var r = function(a) {
    return a ? --a * a * ((n + 1) * a + n) + 1 : 0;
  }, o = t === "out" ? r : t === "in" ? function(i) {
    return 1 - r(1 - i);
  } : n4(r);
  return o.config = function(i) {
    return e(t, i);
  }, o;
};
Nt("Linear,Quad,Cubic,Quart,Quint,Strong", function(e, t) {
  var n = t < 5 ? t + 1 : t;
  Gr(e + ",Power" + (n - 1), t ? function(r) {
    return Math.pow(r, n);
  } : function(r) {
    return r;
  }, function(r) {
    return 1 - Math.pow(1 - r, n);
  }, function(r) {
    return r < 0.5 ? Math.pow(r * 2, n) / 2 : 1 - Math.pow((1 - r) * 2, n) / 2;
  });
});
Ee.Linear.easeNone = Ee.none = Ee.Linear.easeIn;
Gr("Elastic", Ll("in"), Ll("out"), Ll());
(function(e, t) {
  var n = 1 / t, r = 2 * n, o = 2.5 * n, i = function(s) {
    return s < n ? e * s * s : s < r ? e * Math.pow(s - 1.5 / t, 2) + 0.75 : s < o ? e * (s -= 2.25 / t) * s + 0.9375 : e * Math.pow(s - 2.625 / t, 2) + 0.984375;
  };
  Gr("Bounce", function(a) {
    return 1 - i(1 - a);
  }, i);
})(7.5625, 2.75);
Gr("Expo", function(e) {
  return Math.pow(2, 10 * (e - 1)) * e + e * e * e * e * e * e * (1 - e);
});
Gr("Circ", function(e) {
  return -(Eg(1 - e * e) - 1);
});
Gr("Sine", function(e) {
  return e === 1 ? 1 : -my(e * cy) + 1;
});
Gr("Back", Dl("in"), Dl("out"), Dl());
Ee.SteppedEase = Ee.steps = Zt.SteppedEase = {
  config: function(t, n) {
    t === void 0 && (t = 1);
    var r = 1 / t, o = t + (n ? 0 : 1), i = n ? 1 : 0, a = 1 - Fe;
    return function(s) {
      return ((o * gi(0, a, s) | 0) + i) * r;
    };
  }
};
vo.ease = Ee["quad.out"];
Nt("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(e) {
  return _0 += e + "," + e + "Params,";
});
var r4 = function(t, n) {
  this.id = hy++, t._gsap = this, this.target = t, this.harness = n, this.get = n ? n.get : Pg, this.set = n ? n.getSetter : S0;
}, li = /* @__PURE__ */ function() {
  function e(n) {
    this.vars = n, this._delay = +n.delay || 0, (this._repeat = n.repeat === 1 / 0 ? -2 : n.repeat || 0) && (this._rDelay = n.repeatDelay || 0, this._yoyo = !!n.yoyo || !!n.yoyoEase), this._ts = 1, _o(this, +n.duration, 1, 1), this.data = n.data, Ke && (this._ctx = Ke, Ke.data.push(this)), ai || qt.wake();
  }
  var t = e.prototype;
  return t.delay = function(r) {
    return r || r === 0 ? (this.parent && this.parent.smoothChildTiming && this.startTime(this._start + r - this._delay), this._delay = r, this) : this._delay;
  }, t.duration = function(r) {
    return arguments.length ? this.totalDuration(this._repeat > 0 ? r + (r + this._rDelay) * this._repeat : r) : this.totalDuration() && this._dur;
  }, t.totalDuration = function(r) {
    return arguments.length ? (this._dirty = 0, _o(this, this._repeat < 0 ? r : (r - this._repeat * this._rDelay) / (this._repeat + 1))) : this._tDur;
  }, t.totalTime = function(r, o) {
    if (Co(), !arguments.length)
      return this._tTime;
    var i = this._dp;
    if (i && i.smoothChildTiming && this._ts) {
      for (Hs(this, r), !i._dp || i.parent || Vg(i, this); i && i.parent; )
        i.parent._time !== i._start + (i._ts >= 0 ? i._tTime / i._ts : (i.totalDuration() - i._tTime) / -i._ts) && i.totalTime(i._tTime, !0), i = i.parent;
      !this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && r < this._tDur || this._ts < 0 && r > 0 || !this._tDur && !r) && Mn(this._dp, this, this._start - this._delay);
    }
    return (this._tTime !== r || !this._dur && !o || this._initted && Math.abs(this._zTime) === Fe || !r && !this._initted && (this.add || this._ptLookup)) && (this._ts || (this._pTime = r), Ng(this, r, o)), this;
  }, t.time = function(r, o) {
    return arguments.length ? this.totalTime(Math.min(this.totalDuration(), r + rm(this)) % (this._dur + this._rDelay) || (r ? this._dur : 0), o) : this._time;
  }, t.totalProgress = function(r, o) {
    return arguments.length ? this.totalTime(this.totalDuration() * r, o) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() >= 0 && this._initted ? 1 : 0;
  }, t.progress = function(r, o) {
    return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - r : r) + rm(this), o) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0;
  }, t.iteration = function(r, o) {
    var i = this.duration() + this._rDelay;
    return arguments.length ? this.totalTime(this._time + (r - 1) * i, o) : this._repeat ? yo(this._tTime, i) + 1 : 1;
  }, t.timeScale = function(r, o) {
    if (!arguments.length)
      return this._rts === -Fe ? 0 : this._rts;
    if (this._rts === r)
      return this;
    var i = this.parent && this._ts ? cs(this.parent._time, this) : this._tTime;
    return this._rts = +r || 0, this._ts = this._ps || r === -Fe ? 0 : this._rts, this.totalTime(gi(-Math.abs(this._delay), this.totalDuration(), i), o !== !1), Ns(this), Cy(this);
  }, t.paused = function(r) {
    return arguments.length ? (this._ps !== r && (this._ps = r, r ? (this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()), this._ts = this._act = 0) : (Co(), this._ts = this._rts, this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== Fe && (this._tTime -= Fe)))), this) : this._ps;
  }, t.startTime = function(r) {
    if (arguments.length) {
      this._start = r;
      var o = this.parent || this._dp;
      return o && (o._sort || !this.parent) && Mn(o, this, r - this._delay), this;
    }
    return this._start;
  }, t.endTime = function(r) {
    return this._start + (Pt(r) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
  }, t.rawTime = function(r) {
    var o = this.parent || this._dp;
    return o ? r && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : this._ts ? cs(o.rawTime(r), this) : this._tTime : this._tTime;
  }, t.revert = function(r) {
    r === void 0 && (r = vy);
    var o = ht;
    return ht = r, w0(this) && (this.timeline && this.timeline.revert(r), this.totalTime(-0.01, r.suppressEvents)), this.data !== "nested" && r.kill !== !1 && this.kill(), ht = o, this;
  }, t.globalTime = function(r) {
    for (var o = this, i = arguments.length ? r : o.rawTime(); o; )
      i = o._start + i / (Math.abs(o._ts) || 1), o = o._dp;
    return !this.parent && this._sat ? this._sat.globalTime(r) : i;
  }, t.repeat = function(r) {
    return arguments.length ? (this._repeat = r === 1 / 0 ? -2 : r, om(this)) : this._repeat === -2 ? 1 / 0 : this._repeat;
  }, t.repeatDelay = function(r) {
    if (arguments.length) {
      var o = this._time;
      return this._rDelay = r, om(this), o ? this.time(o) : this;
    }
    return this._rDelay;
  }, t.yoyo = function(r) {
    return arguments.length ? (this._yoyo = r, this) : this._yoyo;
  }, t.seek = function(r, o) {
    return this.totalTime(tn(this, r), Pt(o));
  }, t.restart = function(r, o) {
    return this.play().totalTime(r ? -this._delay : 0, Pt(o)), this._dur || (this._zTime = -Fe), this;
  }, t.play = function(r, o) {
    return r != null && this.seek(r, o), this.reversed(!1).paused(!1);
  }, t.reverse = function(r, o) {
    return r != null && this.seek(r || this.totalDuration(), o), this.reversed(!0).paused(!1);
  }, t.pause = function(r, o) {
    return r != null && this.seek(r, o), this.paused(!0);
  }, t.resume = function() {
    return this.paused(!1);
  }, t.reversed = function(r) {
    return arguments.length ? (!!r !== this.reversed() && this.timeScale(-this._rts || (r ? -Fe : 0)), this) : this._rts < 0;
  }, t.invalidate = function() {
    return this._initted = this._act = 0, this._zTime = -Fe, this;
  }, t.isActive = function() {
    var r = this.parent || this._dp, o = this._start, i;
    return !!(!r || this._ts && this._initted && r.isActive() && (i = r.rawTime(!0)) >= o && i < this.endTime(!0) - Fe);
  }, t.eventCallback = function(r, o, i) {
    var a = this.vars;
    return arguments.length > 1 ? (o ? (a[r] = o, i && (a[r + "Params"] = i), r === "onUpdate" && (this._onUpdate = o)) : delete a[r], this) : a[r];
  }, t.then = function(r) {
    var o = this;
    return new Promise(function(i) {
      var a = Xe(r) ? r : Fg, s = function() {
        var u = o.then;
        o.then = null, Xe(a) && (a = a(o)) && (a.then || a === o) && (o.then = u), i(a), o.then = u;
      };
      o._initted && o.totalProgress() === 1 && o._ts >= 0 || !o._tTime && o._ts < 0 ? s() : o._prom = s;
    });
  }, t.kill = function() {
    Yo(this);
  }, e;
}();
xt(li.prototype, {
  _time: 0,
  _start: 0,
  _end: 0,
  _tTime: 0,
  _tDur: 0,
  _dirty: 0,
  _repeat: 0,
  _yoyo: !1,
  parent: null,
  _initted: !1,
  _rDelay: 0,
  _ts: 1,
  _dp: 0,
  ratio: 0,
  _zTime: -Fe,
  _prom: 0,
  _ps: !1,
  _rts: 1
});
var kt = /* @__PURE__ */ function(e) {
  kg(t, e);
  function t(r, o) {
    var i;
    return r === void 0 && (r = {}), i = e.call(this, r) || this, i.labels = {}, i.smoothChildTiming = !!r.smoothChildTiming, i.autoRemoveChildren = !!r.autoRemoveChildren, i._sort = Pt(r.sortChildren), We && Mn(r.parent || We, Bn(i), o), r.reversed && i.reverse(), r.paused && i.paused(!0), r.scrollTrigger && Bg(Bn(i), r.scrollTrigger), i;
  }
  var n = t.prototype;
  return n.to = function(o, i, a) {
    return ei(0, arguments, this), this;
  }, n.from = function(o, i, a) {
    return ei(1, arguments, this), this;
  }, n.fromTo = function(o, i, a, s) {
    return ei(2, arguments, this), this;
  }, n.set = function(o, i, a) {
    return i.duration = 0, i.parent = this, Jo(i).repeatDelay || (i.repeat = 0), i.immediateRender = !!i.immediateRender, new ot(o, i, tn(this, a), 1), this;
  }, n.call = function(o, i, a) {
    return Mn(this, ot.delayedCall(0, o, i), a);
  }, n.staggerTo = function(o, i, a, s, l, u, m) {
    return a.duration = i, a.stagger = a.stagger || s, a.onComplete = u, a.onCompleteParams = m, a.parent = this, new ot(o, a, tn(this, l)), this;
  }, n.staggerFrom = function(o, i, a, s, l, u, m) {
    return a.runBackwards = 1, Jo(a).immediateRender = Pt(a.immediateRender), this.staggerTo(o, i, a, s, l, u, m);
  }, n.staggerFromTo = function(o, i, a, s, l, u, m, v) {
    return s.startAt = a, Jo(s).immediateRender = Pt(s.immediateRender), this.staggerTo(o, i, s, l, u, m, v);
  }, n.render = function(o, i, a) {
    var s = this._time, l = this._dirty ? this.totalDuration() : this._tDur, u = this._dur, m = o <= 0 ? 0 : it(o), v = this._zTime < 0 != o < 0 && (this._initted || !u), g, h, E, C, A, R, P, F, I, D, O, U;
    if (this !== We && m > l && o >= 0 && (m = l), m !== this._tTime || a || v) {
      if (s !== this._time && u && (m += this._time - s, o += this._time - s), g = m, I = this._start, F = this._ts, R = !F, v && (u || (s = this._zTime), (o || !i) && (this._zTime = o)), this._repeat) {
        if (O = this._yoyo, A = u + this._rDelay, this._repeat < -1 && o < 0)
          return this.totalTime(A * 100 + o, i, a);
        if (g = it(m % A), m === l ? (C = this._repeat, g = u) : (D = it(m / A), C = ~~D, C && C === D && (g = u, C--), g > u && (g = u)), D = yo(this._tTime, A), !s && this._tTime && D !== C && this._tTime - D * A - this._dur <= 0 && (D = C), O && C & 1 && (g = u - g, U = 1), C !== D && !this._lock) {
          var q = O && D & 1, z = q === (O && C & 1);
          if (C < D && (q = !q), s = q ? 0 : m % u ? u : m, this._lock = 1, this.render(s || (U ? 0 : it(C * A)), i, !u)._lock = 0, this._tTime = m, !i && this.parent && Gt(this, "onRepeat"), this.vars.repeatRefresh && !U && (this.invalidate()._lock = 1), s && s !== this._time || R !== !this._ts || this.vars.onRepeat && !this.parent && !this._act)
            return this;
          if (u = this._dur, l = this._tDur, z && (this._lock = 2, s = q ? u : -1e-4, this.render(s, !0), this.vars.repeatRefresh && !U && this.invalidate()), this._lock = 0, !this._ts && !R)
            return this;
          t4(this, U);
        }
      }
      if (this._hasPause && !this._forcing && this._lock < 2 && (P = Ey(this, it(s), it(g)), P && (m -= g - (g = P._start))), this._tTime = m, this._time = g, this._act = !F, this._initted || (this._onUpdate = this.vars.onUpdate, this._initted = 1, this._zTime = o, s = 0), !s && m && !i && !D && (Gt(this, "onStart"), this._tTime !== m))
        return this;
      if (g >= s && o >= 0)
        for (h = this._first; h; ) {
          if (E = h._next, (h._act || g >= h._start) && h._ts && P !== h) {
            if (h.parent !== this)
              return this.render(o, i, a);
            if (h.render(h._ts > 0 ? (g - h._start) * h._ts : (h._dirty ? h.totalDuration() : h._tDur) + (g - h._start) * h._ts, i, a), g !== this._time || !this._ts && !R) {
              P = 0, E && (m += this._zTime = -Fe);
              break;
            }
          }
          h = E;
        }
      else {
        h = this._last;
        for (var te = o < 0 ? o : g; h; ) {
          if (E = h._prev, (h._act || te <= h._end) && h._ts && P !== h) {
            if (h.parent !== this)
              return this.render(o, i, a);
            if (h.render(h._ts > 0 ? (te - h._start) * h._ts : (h._dirty ? h.totalDuration() : h._tDur) + (te - h._start) * h._ts, i, a || ht && w0(h)), g !== this._time || !this._ts && !R) {
              P = 0, E && (m += this._zTime = te ? -Fe : Fe);
              break;
            }
          }
          h = E;
        }
      }
      if (P && !i && (this.pause(), P.render(g >= s ? 0 : -Fe)._zTime = g >= s ? 1 : -1, this._ts))
        return this._start = I, Ns(this), this.render(o, i, a);
      this._onUpdate && !i && Gt(this, "onUpdate", !0), (m === l && this._tTime >= this.totalDuration() || !m && s) && (I === this._start || Math.abs(F) !== Math.abs(this._ts)) && (this._lock || ((o || !u) && (m === l && this._ts > 0 || !m && this._ts < 0) && lr(this, 1), !i && !(o < 0 && !s) && (m || s || !l) && (Gt(this, m === l && o >= 0 ? "onComplete" : "onReverseComplete", !0), this._prom && !(m < l && this.timeScale() > 0) && this._prom())));
    }
    return this;
  }, n.add = function(o, i) {
    var a = this;
    if (Kn(i) || (i = tn(this, i, o)), !(o instanceof li)) {
      if (bt(o))
        return o.forEach(function(s) {
          return a.add(s, i);
        }), this;
      if (lt(o))
        return this.addLabel(o, i);
      if (Xe(o))
        o = ot.delayedCall(0, o);
      else
        return this;
    }
    return this !== o ? Mn(this, o, i) : this;
  }, n.getChildren = function(o, i, a, s) {
    o === void 0 && (o = !0), i === void 0 && (i = !0), a === void 0 && (a = !0), s === void 0 && (s = -nn);
    for (var l = [], u = this._first; u; )
      u._start >= s && (u instanceof ot ? i && l.push(u) : (a && l.push(u), o && l.push.apply(l, u.getChildren(!0, i, a)))), u = u._next;
    return l;
  }, n.getById = function(o) {
    for (var i = this.getChildren(1, 1, 1), a = i.length; a--; )
      if (i[a].vars.id === o)
        return i[a];
  }, n.remove = function(o) {
    return lt(o) ? this.removeLabel(o) : Xe(o) ? this.killTweensOf(o) : (o.parent === this && Ps(this, o), o === this._recent && (this._recent = this._last), Or(this));
  }, n.totalTime = function(o, i) {
    return arguments.length ? (this._forcing = 1, !this._dp && this._ts && (this._start = it(qt.time - (this._ts > 0 ? o / this._ts : (this.totalDuration() - o) / -this._ts))), e.prototype.totalTime.call(this, o, i), this._forcing = 0, this) : this._tTime;
  }, n.addLabel = function(o, i) {
    return this.labels[o] = tn(this, i), this;
  }, n.removeLabel = function(o) {
    return delete this.labels[o], this;
  }, n.addPause = function(o, i, a) {
    var s = ot.delayedCall(0, i || ii, a);
    return s.data = "isPause", this._hasPause = 1, Mn(this, s, tn(this, o));
  }, n.removePause = function(o) {
    var i = this._first;
    for (o = tn(this, o); i; )
      i._start === o && i.data === "isPause" && lr(i), i = i._next;
  }, n.killTweensOf = function(o, i, a) {
    for (var s = this.getTweensOf(o, a), l = s.length; l--; )
      rr !== s[l] && s[l].kill(o, i);
    return this;
  }, n.getTweensOf = function(o, i) {
    for (var a = [], s = rn(o), l = this._first, u = Kn(i), m; l; )
      l instanceof ot ? by(l._targets, s) && (u ? (!rr || l._initted && l._ts) && l.globalTime(0) <= i && l.globalTime(l.totalDuration()) > i : !i || l.isActive()) && a.push(l) : (m = l.getTweensOf(s, i)).length && a.push.apply(a, m), l = l._next;
    return a;
  }, n.tweenTo = function(o, i) {
    i = i || {};
    var a = this, s = tn(a, o), l = i, u = l.startAt, m = l.onStart, v = l.onStartParams, g = l.immediateRender, h, E = ot.to(a, xt({
      ease: i.ease || "none",
      lazy: !1,
      immediateRender: !1,
      time: s,
      overwrite: "auto",
      duration: i.duration || Math.abs((s - (u && "time" in u ? u.time : a._time)) / a.timeScale()) || Fe,
      onStart: function() {
        if (a.pause(), !h) {
          var A = i.duration || Math.abs((s - (u && "time" in u ? u.time : a._time)) / a.timeScale());
          E._dur !== A && _o(E, A, 0, 1).render(E._time, !0, !0), h = 1;
        }
        m && m.apply(E, v || []);
      }
    }, i));
    return g ? E.render(0) : E;
  }, n.tweenFromTo = function(o, i, a) {
    return this.tweenTo(i, xt({
      startAt: {
        time: tn(this, o)
      }
    }, a));
  }, n.recent = function() {
    return this._recent;
  }, n.nextLabel = function(o) {
    return o === void 0 && (o = this._time), im(this, tn(this, o));
  }, n.previousLabel = function(o) {
    return o === void 0 && (o = this._time), im(this, tn(this, o), 1);
  }, n.currentLabel = function(o) {
    return arguments.length ? this.seek(o, !0) : this.previousLabel(this._time + Fe);
  }, n.shiftChildren = function(o, i, a) {
    a === void 0 && (a = 0);
    for (var s = this._first, l = this.labels, u; s; )
      s._start >= a && (s._start += o, s._end += o), s = s._next;
    if (i)
      for (u in l)
        l[u] >= a && (l[u] += o);
    return Or(this);
  }, n.invalidate = function(o) {
    var i = this._first;
    for (this._lock = 0; i; )
      i.invalidate(o), i = i._next;
    return e.prototype.invalidate.call(this, o);
  }, n.clear = function(o) {
    o === void 0 && (o = !0);
    for (var i = this._first, a; i; )
      a = i._next, this.remove(i), i = a;
    return this._dp && (this._time = this._tTime = this._pTime = 0), o && (this.labels = {}), Or(this);
  }, n.totalDuration = function(o) {
    var i = 0, a = this, s = a._last, l = nn, u, m, v;
    if (arguments.length)
      return a.timeScale((a._repeat < 0 ? a.duration() : a.totalDuration()) / (a.reversed() ? -o : o));
    if (a._dirty) {
      for (v = a.parent; s; )
        u = s._prev, s._dirty && s.totalDuration(), m = s._start, m > l && a._sort && s._ts && !a._lock ? (a._lock = 1, Mn(a, s, m - s._delay, 1)._lock = 0) : l = m, m < 0 && s._ts && (i -= m, (!v && !a._dp || v && v.smoothChildTiming) && (a._start += m / a._ts, a._time -= m, a._tTime -= m), a.shiftChildren(-m, !1, -1 / 0), l = 0), s._end > i && s._ts && (i = s._end), s = u;
      _o(a, a === We && a._time > i ? a._time : i, 1, 1), a._dirty = 0;
    }
    return a._tDur;
  }, t.updateRoot = function(o) {
    if (We._ts && (Ng(We, cs(o, We)), Og = qt.frame), qt.frame >= tm) {
      tm += Kt.autoSleep || 120;
      var i = We._first;
      if ((!i || !i._ts) && Kt.autoSleep && qt._listeners.length < 2) {
        for (; i && !i._ts; )
          i = i._next;
        i || qt.sleep();
      }
    }
  }, t;
}(li);
xt(kt.prototype, {
  _lock: 0,
  _hasPause: 0,
  _forcing: 0
});
var jy = function(t, n, r, o, i, a, s) {
  var l = new Ht(this._pt, t, n, 0, 1, u4, null, i), u = 0, m = 0, v, g, h, E, C, A, R, P;
  for (l.b = r, l.e = o, r += "", o += "", (R = ~o.indexOf("random(")) && (o = si(o)), a && (P = [r, o], a(P, t, n), r = P[0], o = P[1]), g = r.match(Ml) || []; v = Ml.exec(o); )
    E = v[0], C = o.substring(u, v.index), h ? h = (h + 1) % 5 : C.substr(-5) === "rgba(" && (h = 1), E !== g[m++] && (A = parseFloat(g[m - 1]) || 0, l._pt = {
      _next: l._pt,
      p: C || m === 1 ? C : ",",
      //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
      s: A,
      c: E.charAt(1) === "=" ? lo(A, E) - A : parseFloat(E) - A,
      m: h && h < 4 ? Math.round : 0
    }, u = Ml.lastIndex);
  return l.c = u < o.length ? o.substring(u, o.length) : "", l.fp = s, (Ag.test(o) || R) && (l.e = 0), this._pt = l, l;
}, T0 = function(t, n, r, o, i, a, s, l, u, m) {
  Xe(o) && (o = o(i || 0, t, a));
  var v = t[n], g = r !== "get" ? r : Xe(v) ? u ? t[n.indexOf("set") || !Xe(t["get" + n.substr(3)]) ? n : "get" + n.substr(3)](u) : t[n]() : v, h = Xe(v) ? u ? zy : a4 : E0, E;
  if (lt(o) && (~o.indexOf("random(") && (o = si(o)), o.charAt(1) === "=" && (E = lo(g, o) + (gt(g) || 0), (E || E === 0) && (o = E))), !m || g !== o || Hc)
    return !isNaN(g * o) && o !== "" ? (E = new Ht(this._pt, t, n, +g || 0, o - (g || 0), typeof v == "boolean" ? xy : l4, 0, h), u && (E.fp = u), s && E.modifier(s, this, t), this._pt = E) : (!v && !(n in t) && b0(n, o), jy.call(this, t, n, g, o, h, l || Kt.stringFilter, u));
}, Uy = function(t, n, r, o, i) {
  if (Xe(t) && (t = ti(t, i, n, r, o)), !In(t) || t.style && t.nodeType || bt(t) || Sg(t))
    return lt(t) ? ti(t, i, n, r, o) : t;
  var a = {}, s;
  for (s in t)
    a[s] = ti(t[s], i, n, r, o);
  return a;
}, o4 = function(t, n, r, o, i, a) {
  var s, l, u, m;
  if (Ut[t] && (s = new Ut[t]()).init(i, s.rawVars ? n[t] : Uy(n[t], o, i, a, r), r, o, a) !== !1 && (r._pt = l = new Ht(r._pt, i, t, 0, 1, s.render, s, 0, s.priority), r !== so))
    for (u = r._ptLookup[r._targets.indexOf(i)], m = s._props.length; m--; )
      u[s._props[m]] = l;
  return s;
}, rr, Hc, k0 = function e(t, n, r) {
  var o = t.vars, i = o.ease, a = o.startAt, s = o.immediateRender, l = o.lazy, u = o.onUpdate, m = o.runBackwards, v = o.yoyoEase, g = o.keyframes, h = o.autoRevert, E = t._dur, C = t._startAt, A = t._targets, R = t.parent, P = R && R.data === "nested" ? R.vars.targets : A, F = t._overwrite === "auto" && !f0, I = t.timeline, D, O, U, q, z, te, ee, x, N, G, X, Q, re;
  if (I && (!g || !i) && (i = "none"), t._ease = Pr(i, vo.ease), t._yEase = v ? e4(Pr(v === !0 ? i : v, vo.ease)) : 0, v && t._yoyo && !t._repeat && (v = t._yEase, t._yEase = t._ease, t._ease = v), t._from = !I && !!o.runBackwards, !I || g && !o.stagger) {
    if (x = A[0] ? $r(A[0]).harness : 0, Q = x && o[x.prop], D = ds(o, y0), C && (C._zTime < 0 && C.progress(1), n < 0 && m && s && !h ? C.render(-1, !0) : C.revert(m && E ? Wi : gy), C._lazy = 0), a) {
      if (lr(t._startAt = ot.set(A, xt({
        data: "isStart",
        overwrite: !1,
        parent: R,
        immediateRender: !0,
        lazy: !C && Pt(l),
        startAt: null,
        delay: 0,
        onUpdate: u && function() {
          return Gt(t, "onUpdate");
        },
        stagger: 0
      }, a))), t._startAt._dp = 0, t._startAt._sat = t, n < 0 && (ht || !s && !h) && t._startAt.revert(Wi), s && E && n <= 0 && r <= 0) {
        n && (t._zTime = n);
        return;
      }
    } else if (m && E && !C) {
      if (n && (s = !1), U = xt({
        overwrite: !1,
        data: "isFromStart",
        //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
        lazy: s && !C && Pt(l),
        immediateRender: s,
        //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
        stagger: 0,
        parent: R
        //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})
      }, D), Q && (U[x.prop] = Q), lr(t._startAt = ot.set(A, U)), t._startAt._dp = 0, t._startAt._sat = t, n < 0 && (ht ? t._startAt.revert(Wi) : t._startAt.render(-1, !0)), t._zTime = n, !s)
        e(t._startAt, Fe, Fe);
      else if (!n)
        return;
    }
    for (t._pt = t._ptCache = 0, l = E && Pt(l) || l && !E, O = 0; O < A.length; O++) {
      if (z = A[O], ee = z._gsap || C0(A)[O]._gsap, t._ptLookup[O] = G = {}, Lc[ee.id] && sr.length && us(), X = P === A ? O : P.indexOf(z), x && (N = new x()).init(z, Q || D, t, X, P) !== !1 && (t._pt = q = new Ht(t._pt, z, N.name, 0, 1, N.render, N, 0, N.priority), N._props.forEach(function(se) {
        G[se] = q;
      }), N.priority && (te = 1)), !x || Q)
        for (U in D)
          Ut[U] && (N = o4(U, D, t, X, z, P)) ? N.priority && (te = 1) : G[U] = q = T0.call(t, z, U, "get", D[U], X, P, 0, o.stringFilter);
      t._op && t._op[O] && t.kill(z, t._op[O]), F && t._pt && (rr = t, We.killTweensOf(z, G, t.globalTime(n)), re = !t.parent, rr = 0), t._pt && l && (Lc[ee.id] = 1);
    }
    te && d4(t), t._onInit && t._onInit(t);
  }
  t._onUpdate = u, t._initted = (!t._op || t._pt) && !re, g && n <= 0 && I.render(nn, !0, !0);
}, qy = function(t, n, r, o, i, a, s, l) {
  var u = (t._pt && t._ptCache || (t._ptCache = {}))[n], m, v, g, h;
  if (!u)
    for (u = t._ptCache[n] = [], g = t._ptLookup, h = t._targets.length; h--; ) {
      if (m = g[h][n], m && m.d && m.d._pt)
        for (m = m.d._pt; m && m.p !== n && m.fp !== n; )
          m = m._next;
      if (!m)
        return Hc = 1, t.vars[n] = "+=0", k0(t, s), Hc = 0, l ? oi(n + " not eligible for reset") : 1;
      u.push(m);
    }
  for (h = u.length; h--; )
    v = u[h], m = v._pt || v, m.s = (o || o === 0) && !i ? o : m.s + (o || 0) + a * m.c, m.c = r - m.s, v.e && (v.e = Qe(r) + gt(v.e)), v.b && (v.b = m.s + gt(v.b));
}, Gy = function(t, n) {
  var r = t[0] ? $r(t[0]).harness : 0, o = r && r.aliases, i, a, s, l;
  if (!o)
    return n;
  i = bo({}, n);
  for (a in o)
    if (a in i)
      for (l = o[a].split(","), s = l.length; s--; )
        i[l[s]] = i[a];
  return i;
}, Ky = function(t, n, r, o) {
  var i = n.ease || o || "power1.inOut", a, s;
  if (bt(n))
    s = r[t] || (r[t] = []), n.forEach(function(l, u) {
      return s.push({
        t: u / (n.length - 1) * 100,
        v: l,
        e: i
      });
    });
  else
    for (a in n)
      s = r[a] || (r[a] = []), a === "ease" || s.push({
        t: parseFloat(t),
        v: n[a],
        e: i
      });
}, ti = function(t, n, r, o, i) {
  return Xe(t) ? t.call(n, r, o, i) : lt(t) && ~t.indexOf("random(") ? si(t) : t;
}, i4 = _0 + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert", s4 = {};
Nt(i4 + ",id,stagger,delay,duration,paused,scrollTrigger", function(e) {
  return s4[e] = 1;
});
var ot = /* @__PURE__ */ function(e) {
  kg(t, e);
  function t(r, o, i, a) {
    var s;
    typeof o == "number" && (i.duration = o, o = i, i = null), s = e.call(this, a ? o : Jo(o)) || this;
    var l = s.vars, u = l.duration, m = l.delay, v = l.immediateRender, g = l.stagger, h = l.overwrite, E = l.keyframes, C = l.defaults, A = l.scrollTrigger, R = l.yoyoEase, P = o.parent || We, F = (bt(r) || Sg(r) ? Kn(r[0]) : "length" in o) ? [r] : rn(r), I, D, O, U, q, z, te, ee;
    if (s._targets = F.length ? C0(F) : oi("GSAP target " + r + " not found. https://gsap.com", !Kt.nullTargetWarn) || [], s._ptLookup = [], s._overwrite = h, E || g || Ui(u) || Ui(m)) {
      if (o = s.vars, I = s.timeline = new kt({
        data: "nested",
        defaults: C || {},
        targets: P && P.data === "nested" ? P.vars.targets : F
      }), I.kill(), I.parent = I._dp = Bn(s), I._start = 0, g || Ui(u) || Ui(m)) {
        if (U = F.length, te = g && Gg(g), In(g))
          for (q in g)
            ~i4.indexOf(q) && (ee || (ee = {}), ee[q] = g[q]);
        for (D = 0; D < U; D++)
          O = ds(o, s4), O.stagger = 0, R && (O.yoyoEase = R), ee && bo(O, ee), z = F[D], O.duration = +ti(u, Bn(s), D, z, F), O.delay = (+ti(m, Bn(s), D, z, F) || 0) - s._delay, !g && U === 1 && O.delay && (s._delay = m = O.delay, s._start += m, O.delay = 0), I.to(z, O, te ? te(D, z, F) : 0), I._ease = Ee.none;
        I.duration() ? u = m = 0 : s.timeline = 0;
      } else if (E) {
        Jo(xt(I.vars.defaults, {
          ease: "none"
        })), I._ease = Pr(E.ease || o.ease || "none");
        var x = 0, N, G, X;
        if (bt(E))
          E.forEach(function(Q) {
            return I.to(F, Q, ">");
          }), I.duration();
        else {
          O = {};
          for (q in E)
            q === "ease" || q === "easeEach" || Ky(q, E[q], O, E.easeEach);
          for (q in O)
            for (N = O[q].sort(function(Q, re) {
              return Q.t - re.t;
            }), x = 0, D = 0; D < N.length; D++)
              G = N[D], X = {
                ease: G.e,
                duration: (G.t - (D ? N[D - 1].t : 0)) / 100 * u
              }, X[q] = G.v, I.to(F, X, x), x += X.duration;
          I.duration() < u && I.to({}, {
            duration: u - I.duration()
          });
        }
      }
      u || s.duration(u = I.duration());
    } else
      s.timeline = 0;
    return h === !0 && !f0 && (rr = Bn(s), We.killTweensOf(F), rr = 0), Mn(P, Bn(s), i), o.reversed && s.reverse(), o.paused && s.paused(!0), (v || !u && !E && s._start === it(P._time) && Pt(v) && wy(Bn(s)) && P.data !== "nested") && (s._tTime = -Fe, s.render(Math.max(0, -m) || 0)), A && Bg(Bn(s), A), s;
  }
  var n = t.prototype;
  return n.render = function(o, i, a) {
    var s = this._time, l = this._tDur, u = this._dur, m = o < 0, v = o > l - Fe && !m ? l : o < Fe ? 0 : o, g, h, E, C, A, R, P, F, I;
    if (!u)
      ky(this, o, i, a);
    else if (v !== this._tTime || !o || a || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== m || this._lazy) {
      if (g = v, F = this.timeline, this._repeat) {
        if (C = u + this._rDelay, this._repeat < -1 && m)
          return this.totalTime(C * 100 + o, i, a);
        if (g = it(v % C), v === l ? (E = this._repeat, g = u) : (A = it(v / C), E = ~~A, E && E === A ? (g = u, E--) : g > u && (g = u)), R = this._yoyo && E & 1, R && (I = this._yEase, g = u - g), A = yo(this._tTime, C), g === s && !a && this._initted && E === A)
          return this._tTime = v, this;
        E !== A && (F && this._yEase && t4(F, R), this.vars.repeatRefresh && !R && !this._lock && g !== C && this._initted && (this._lock = a = 1, this.render(it(C * E), !0).invalidate()._lock = 0));
      }
      if (!this._initted) {
        if (jg(this, m ? o : g, a, i, v))
          return this._tTime = 0, this;
        if (s !== this._time && !(a && this.vars.repeatRefresh && E !== A))
          return this;
        if (u !== this._dur)
          return this.render(o, i, a);
      }
      if (this._tTime = v, this._time = g, !this._act && this._ts && (this._act = 1, this._lazy = 0), this.ratio = P = (I || this._ease)(g / u), this._from && (this.ratio = P = 1 - P), !s && v && !i && !A && (Gt(this, "onStart"), this._tTime !== v))
        return this;
      for (h = this._pt; h; )
        h.r(P, h.d), h = h._next;
      F && F.render(o < 0 ? o : F._dur * F._ease(g / this._dur), i, a) || this._startAt && (this._zTime = o), this._onUpdate && !i && (m && Dc(this, o, i, a), Gt(this, "onUpdate")), this._repeat && E !== A && this.vars.onRepeat && !i && this.parent && Gt(this, "onRepeat"), (v === this._tDur || !v) && this._tTime === v && (m && !this._onUpdate && Dc(this, o, !0, !0), (o || !u) && (v === this._tDur && this._ts > 0 || !v && this._ts < 0) && lr(this, 1), !i && !(m && !s) && (v || s || R) && (Gt(this, v === l ? "onComplete" : "onReverseComplete", !0), this._prom && !(v < l && this.timeScale() > 0) && this._prom()));
    }
    return this;
  }, n.targets = function() {
    return this._targets;
  }, n.invalidate = function(o) {
    return (!o || !this.vars.runBackwards) && (this._startAt = 0), this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0, this._ptLookup = [], this.timeline && this.timeline.invalidate(o), e.prototype.invalidate.call(this, o);
  }, n.resetTo = function(o, i, a, s, l) {
    ai || qt.wake(), this._ts || this.play();
    var u = Math.min(this._dur, (this._dp._time - this._start) * this._ts), m;
    return this._initted || k0(this, u), m = this._ease(u / this._dur), qy(this, o, i, a, s, m, u, l) ? this.resetTo(o, i, a, s, 1) : (Hs(this, 0), this.parent || Rg(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0), this.render(0));
  }, n.kill = function(o, i) {
    if (i === void 0 && (i = "all"), !o && (!i || i === "all"))
      return this._lazy = this._pt = 0, this.parent ? Yo(this) : this.scrollTrigger && this.scrollTrigger.kill(!!ht), this;
    if (this.timeline) {
      var a = this.timeline.totalDuration();
      return this.timeline.killTweensOf(o, i, rr && rr.vars.overwrite !== !0)._first || Yo(this), this.parent && a !== this.timeline.totalDuration() && _o(this, this._dur * this.timeline._tDur / a, 0, 1), this;
    }
    var s = this._targets, l = o ? rn(o) : s, u = this._ptLookup, m = this._pt, v, g, h, E, C, A, R;
    if ((!i || i === "all") && _y(s, l))
      return i === "all" && (this._pt = 0), Yo(this);
    for (v = this._op = this._op || [], i !== "all" && (lt(i) && (C = {}, Nt(i, function(P) {
      return C[P] = 1;
    }), i = C), i = Gy(s, i)), R = s.length; R--; )
      if (~l.indexOf(s[R])) {
        g = u[R], i === "all" ? (v[R] = i, E = g, h = {}) : (h = v[R] = v[R] || {}, E = i);
        for (C in E)
          A = g && g[C], A && ((!("kill" in A.d) || A.d.kill(C) === !0) && Ps(this, A, "_pt"), delete g[C]), h !== "all" && (h[C] = 1);
      }
    return this._initted && !this._pt && m && Yo(this), this;
  }, t.to = function(o, i) {
    return new t(o, i, arguments[2]);
  }, t.from = function(o, i) {
    return ei(1, arguments);
  }, t.delayedCall = function(o, i, a, s) {
    return new t(i, 0, {
      immediateRender: !1,
      lazy: !1,
      overwrite: !1,
      delay: o,
      onComplete: i,
      onReverseComplete: i,
      onCompleteParams: a,
      onReverseCompleteParams: a,
      callbackScope: s
    });
  }, t.fromTo = function(o, i, a) {
    return ei(2, arguments);
  }, t.set = function(o, i) {
    return i.duration = 0, i.repeatDelay || (i.repeat = 0), new t(o, i);
  }, t.killTweensOf = function(o, i, a) {
    return We.killTweensOf(o, i, a);
  }, t;
}(li);
xt(ot.prototype, {
  _targets: [],
  _lazy: 0,
  _startAt: 0,
  _op: 0,
  _onInit: 0
});
Nt("staggerTo,staggerFrom,staggerFromTo", function(e) {
  ot[e] = function() {
    var t = new kt(), n = Oc.call(arguments, 0);
    return n.splice(e === "staggerFromTo" ? 5 : 4, 0, 0), t[e].apply(t, n);
  };
});
var E0 = function(t, n, r) {
  return t[n] = r;
}, a4 = function(t, n, r) {
  return t[n](r);
}, zy = function(t, n, r, o) {
  return t[n](o.fp, r);
}, Zy = function(t, n, r) {
  return t.setAttribute(n, r);
}, S0 = function(t, n) {
  return Xe(t[n]) ? a4 : p0(t[n]) && t.setAttribute ? Zy : E0;
}, l4 = function(t, n) {
  return n.set(n.t, n.p, Math.round((n.s + n.c * t) * 1e6) / 1e6, n);
}, xy = function(t, n) {
  return n.set(n.t, n.p, !!(n.s + n.c * t), n);
}, u4 = function(t, n) {
  var r = n._pt, o = "";
  if (!t && n.b)
    o = n.b;
  else if (t === 1 && n.e)
    o = n.e;
  else {
    for (; r; )
      o = r.p + (r.m ? r.m(r.s + r.c * t) : Math.round((r.s + r.c * t) * 1e4) / 1e4) + o, r = r._next;
    o += n.c;
  }
  n.set(n.t, n.p, o, n);
}, M0 = function(t, n) {
  for (var r = n._pt; r; )
    r.r(t, r.d), r = r._next;
}, Wy = function(t, n, r, o) {
  for (var i = this._pt, a; i; )
    a = i._next, i.p === o && i.modifier(t, n, r), i = a;
}, Yy = function(t) {
  for (var n = this._pt, r, o; n; )
    o = n._next, n.p === t && !n.op || n.op === t ? Ps(this, n, "_pt") : n.dep || (r = 1), n = o;
  return !r;
}, Xy = function(t, n, r, o) {
  o.mSet(t, n, o.m.call(o.tween, r, o.mt), o);
}, d4 = function(t) {
  for (var n = t._pt, r, o, i, a; n; ) {
    for (r = n._next, o = i; o && o.pr > n.pr; )
      o = o._next;
    (n._prev = o ? o._prev : a) ? n._prev._next = n : i = n, (n._next = o) ? o._prev = n : a = n, n = r;
  }
  t._pt = i;
}, Ht = /* @__PURE__ */ function() {
  function e(n, r, o, i, a, s, l, u, m) {
    this.t = r, this.s = i, this.c = a, this.p = o, this.r = s || l4, this.d = l || this, this.set = u || E0, this.pr = m || 0, this._next = n, n && (n._prev = this);
  }
  var t = e.prototype;
  return t.modifier = function(r, o, i) {
    this.mSet = this.mSet || this.set, this.set = Xy, this.m = r, this.mt = i, this.tween = o;
  }, e;
}();
Nt(_0 + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function(e) {
  return y0[e] = 1;
});
Zt.TweenMax = Zt.TweenLite = ot;
Zt.TimelineLite = Zt.TimelineMax = kt;
We = new kt({
  sortChildren: !1,
  defaults: vo,
  autoRemoveChildren: !0,
  id: "root",
  smoothChildTiming: !0
});
Kt.stringFilter = Jg;
var Nr = [], Xi = {}, Qy = [], am = 0, Jy = 0, $l = function(t) {
  return (Xi[t] || Qy).map(function(n) {
    return n();
  });
}, Fc = function() {
  var t = Date.now(), n = [];
  t - am > 2 && ($l("matchMediaInit"), Nr.forEach(function(r) {
    var o = r.queries, i = r.conditions, a, s, l, u;
    for (s in o)
      a = En.matchMedia(o[s]).matches, a && (l = 1), a !== i[s] && (i[s] = a, u = 1);
    u && (r.revert(), l && n.push(r));
  }), $l("matchMediaRevert"), n.forEach(function(r) {
    return r.onMatch(r, function(o) {
      return r.add(null, o);
    });
  }), am = t, $l("matchMedia"));
}, c4 = /* @__PURE__ */ function() {
  function e(n, r) {
    this.selector = r && Pc(r), this.data = [], this._r = [], this.isReverted = !1, this.id = Jy++, n && this.add(n);
  }
  var t = e.prototype;
  return t.add = function(r, o, i) {
    Xe(r) && (i = o, o = r, r = Xe);
    var a = this, s = function() {
      var u = Ke, m = a.selector, v;
      return u && u !== a && u.data.push(a), i && (a.selector = Pc(i)), Ke = a, v = o.apply(a, arguments), Xe(v) && a._r.push(v), Ke = u, a.selector = m, a.isReverted = !1, v;
    };
    return a.last = s, r === Xe ? s(a, function(l) {
      return a.add(null, l);
    }) : r ? a[r] = s : s;
  }, t.ignore = function(r) {
    var o = Ke;
    Ke = null, r(this), Ke = o;
  }, t.getTweens = function() {
    var r = [];
    return this.data.forEach(function(o) {
      return o instanceof e ? r.push.apply(r, o.getTweens()) : o instanceof ot && !(o.parent && o.parent.data === "nested") && r.push(o);
    }), r;
  }, t.clear = function() {
    this._r.length = this.data.length = 0;
  }, t.kill = function(r, o) {
    var i = this;
    if (r ? function() {
      for (var s = i.getTweens(), l = i.data.length, u; l--; )
        u = i.data[l], u.data === "isFlip" && (u.revert(), u.getChildren(!0, !0, !1).forEach(function(m) {
          return s.splice(s.indexOf(m), 1);
        }));
      for (s.map(function(m) {
        return {
          g: m._dur || m._delay || m._sat && !m._sat.vars.immediateRender ? m.globalTime(0) : -1 / 0,
          t: m
        };
      }).sort(function(m, v) {
        return v.g - m.g || -1 / 0;
      }).forEach(function(m) {
        return m.t.revert(r);
      }), l = i.data.length; l--; )
        u = i.data[l], u instanceof kt ? u.data !== "nested" && (u.scrollTrigger && u.scrollTrigger.revert(), u.kill()) : !(u instanceof ot) && u.revert && u.revert(r);
      i._r.forEach(function(m) {
        return m(r, i);
      }), i.isReverted = !0;
    }() : this.data.forEach(function(s) {
      return s.kill && s.kill();
    }), this.clear(), o)
      for (var a = Nr.length; a--; )
        Nr[a].id === this.id && Nr.splice(a, 1);
  }, t.revert = function(r) {
    this.kill(r || {});
  }, e;
}(), e_ = /* @__PURE__ */ function() {
  function e(n) {
    this.contexts = [], this.scope = n, Ke && Ke.data.push(this);
  }
  var t = e.prototype;
  return t.add = function(r, o, i) {
    In(r) || (r = {
      matches: r
    });
    var a = new c4(0, i || this.scope), s = a.conditions = {}, l, u, m;
    Ke && !a.selector && (a.selector = Ke.selector), this.contexts.push(a), o = a.add("onMatch", o), a.queries = r;
    for (u in r)
      u === "all" ? m = 1 : (l = En.matchMedia(r[u]), l && (Nr.indexOf(a) < 0 && Nr.push(a), (s[u] = l.matches) && (m = 1), l.addListener ? l.addListener(Fc) : l.addEventListener("change", Fc)));
    return m && o(a, function(v) {
      return a.add(null, v);
    }), this;
  }, t.revert = function(r) {
    this.kill(r || {});
  }, t.kill = function(r) {
    this.contexts.forEach(function(o) {
      return o.kill(r, !0);
    });
  }, e;
}(), hs = {
  registerPlugin: function() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    n.forEach(function(o) {
      return Yg(o);
    });
  },
  timeline: function(t) {
    return new kt(t);
  },
  getTweensOf: function(t, n) {
    return We.getTweensOf(t, n);
  },
  getProperty: function(t, n, r, o) {
    lt(t) && (t = rn(t)[0]);
    var i = $r(t || {}).get, a = r ? Fg : Hg;
    return r === "native" && (r = ""), t && (n ? a((Ut[n] && Ut[n].get || i)(t, n, r, o)) : function(s, l, u) {
      return a((Ut[s] && Ut[s].get || i)(t, s, l, u));
    });
  },
  quickSetter: function(t, n, r) {
    if (t = rn(t), t.length > 1) {
      var o = t.map(function(m) {
        return Rt.quickSetter(m, n, r);
      }), i = o.length;
      return function(m) {
        for (var v = i; v--; )
          o[v](m);
      };
    }
    t = t[0] || {};
    var a = Ut[n], s = $r(t), l = s.harness && (s.harness.aliases || {})[n] || n, u = a ? function(m) {
      var v = new a();
      so._pt = 0, v.init(t, r ? m + r : m, so, 0, [t]), v.render(1, v), so._pt && M0(1, so);
    } : s.set(t, l);
    return a ? u : function(m) {
      return u(t, l, r ? m + r : m, s, 1);
    };
  },
  quickTo: function(t, n, r) {
    var o, i = Rt.to(t, xt((o = {}, o[n] = "+=0.1", o.paused = !0, o.stagger = 0, o), r || {})), a = function(l, u, m) {
      return i.resetTo(n, l, u, m);
    };
    return a.tween = i, a;
  },
  isTweening: function(t) {
    return We.getTweensOf(t, !0).length > 0;
  },
  defaults: function(t) {
    return t && t.ease && (t.ease = Pr(t.ease, vo.ease)), nm(vo, t || {});
  },
  config: function(t) {
    return nm(Kt, t || {});
  },
  registerEffect: function(t) {
    var n = t.name, r = t.effect, o = t.plugins, i = t.defaults, a = t.extendTimeline;
    (o || "").split(",").forEach(function(s) {
      return s && !Ut[s] && !Zt[s] && oi(n + " effect requires " + s + " plugin.");
    }), Al[n] = function(s, l, u) {
      return r(rn(s), xt(l || {}, i), u);
    }, a && (kt.prototype[n] = function(s, l, u) {
      return this.add(Al[n](s, In(l) ? l : (u = l) && {}, this), u);
    });
  },
  registerEase: function(t, n) {
    Ee[t] = Pr(n);
  },
  parseEase: function(t, n) {
    return arguments.length ? Pr(t, n) : Ee;
  },
  getById: function(t) {
    return We.getById(t);
  },
  exportRoot: function(t, n) {
    t === void 0 && (t = {});
    var r = new kt(t), o, i;
    for (r.smoothChildTiming = Pt(t.smoothChildTiming), We.remove(r), r._dp = 0, r._time = r._tTime = We._time, o = We._first; o; )
      i = o._next, (n || !(!o._dur && o instanceof ot && o.vars.onComplete === o._targets[0])) && Mn(r, o, o._start - o._delay), o = i;
    return Mn(We, r, 0), r;
  },
  context: function(t, n) {
    return t ? new c4(t, n) : Ke;
  },
  matchMedia: function(t) {
    return new e_(t);
  },
  matchMediaRefresh: function() {
    return Nr.forEach(function(t) {
      var n = t.conditions, r, o;
      for (o in n)
        n[o] && (n[o] = !1, r = 1);
      r && t.revert();
    }) || Fc();
  },
  addEventListener: function(t, n) {
    var r = Xi[t] || (Xi[t] = []);
    ~r.indexOf(n) || r.push(n);
  },
  removeEventListener: function(t, n) {
    var r = Xi[t], o = r && r.indexOf(n);
    o >= 0 && r.splice(o, 1);
  },
  utils: {
    wrap: $y,
    wrapYoyo: Oy,
    distribute: Gg,
    random: zg,
    snap: Kg,
    normalize: Dy,
    getUnit: gt,
    clamp: My,
    splitColor: Xg,
    toArray: rn,
    selector: Pc,
    mapRange: xg,
    pipe: Iy,
    unitize: Ly,
    interpolate: Py,
    shuffle: qg
  },
  install: Dg,
  effects: Al,
  ticker: qt,
  updateRoot: kt.updateRoot,
  plugins: Ut,
  globalTimeline: We,
  core: {
    PropTween: Ht,
    globals: $g,
    Tween: ot,
    Timeline: kt,
    Animation: li,
    getCache: $r,
    _removeLinkedListItem: Ps,
    reverting: function() {
      return ht;
    },
    context: function(t) {
      return t && Ke && (Ke.data.push(t), t._ctx = Ke), Ke;
    },
    suppressOverwrites: function(t) {
      return f0 = t;
    }
  }
};
Nt("to,from,fromTo,delayedCall,set,killTweensOf", function(e) {
  return hs[e] = ot[e];
});
qt.add(kt.updateRoot);
so = hs.to({}, {
  duration: 0
});
var t_ = function(t, n) {
  for (var r = t._pt; r && r.p !== n && r.op !== n && r.fp !== n; )
    r = r._next;
  return r;
}, n_ = function(t, n) {
  var r = t._targets, o, i, a;
  for (o in n)
    for (i = r.length; i--; )
      a = t._ptLookup[i][o], a && (a = a.d) && (a._pt && (a = t_(a, o)), a && a.modifier && a.modifier(n[o], t, r[i], o));
}, Ol = function(t, n) {
  return {
    name: t,
    headless: 1,
    rawVars: 1,
    //don't pre-process function-based values or "random()" strings.
    init: function(o, i, a) {
      a._onInit = function(s) {
        var l, u;
        if (lt(i) && (l = {}, Nt(i, function(m) {
          return l[m] = 1;
        }), i = l), n) {
          l = {};
          for (u in i)
            l[u] = n(i[u]);
          i = l;
        }
        n_(s, i);
      };
    }
  };
}, Rt = hs.registerPlugin({
  name: "attr",
  init: function(t, n, r, o, i) {
    var a, s, l;
    this.tween = r;
    for (a in n)
      l = t.getAttribute(a) || "", s = this.add(t, "setAttribute", (l || 0) + "", n[a], o, i, 0, 0, a), s.op = a, s.b = l, this._props.push(a);
  },
  render: function(t, n) {
    for (var r = n._pt; r; )
      ht ? r.set(r.t, r.p, r.b, r) : r.r(t, r.d), r = r._next;
  }
}, {
  name: "endArray",
  headless: 1,
  init: function(t, n) {
    for (var r = n.length; r--; )
      this.add(t, r, t[r] || 0, n[r], 0, 0, 0, 0, 0, 1);
  }
}, Ol("roundProps", Nc), Ol("modifiers"), Ol("snap", Kg)) || hs;
ot.version = kt.version = Rt.version = "3.13.0";
Lg = 1;
g0() && Co();
Ee.Power0;
Ee.Power1;
Ee.Power2;
Ee.Power3;
Ee.Power4;
Ee.Linear;
Ee.Quad;
Ee.Cubic;
Ee.Quart;
Ee.Quint;
Ee.Strong;
Ee.Elastic;
Ee.Back;
Ee.SteppedEase;
Ee.Bounce;
Ee.Sine;
Ee.Expo;
Ee.Circ;
/*!
 * CSSPlugin 3.13.0
 * https://gsap.com
 *
 * Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/
var lm, or, uo, A0, Ar, um, I0, r_ = function() {
  return typeof window != "undefined";
}, zn = {}, kr = 180 / Math.PI, co = Math.PI / 180, eo = Math.atan2, dm = 1e8, L0 = /([A-Z])/g, o_ = /(left|right|width|margin|padding|x)/i, i_ = /[\s,\(]\S/, An = {
  autoAlpha: "opacity,visibility",
  scale: "scaleX,scaleY",
  alpha: "opacity"
}, Rc = function(t, n) {
  return n.set(n.t, n.p, Math.round((n.s + n.c * t) * 1e4) / 1e4 + n.u, n);
}, s_ = function(t, n) {
  return n.set(n.t, n.p, t === 1 ? n.e : Math.round((n.s + n.c * t) * 1e4) / 1e4 + n.u, n);
}, a_ = function(t, n) {
  return n.set(n.t, n.p, t ? Math.round((n.s + n.c * t) * 1e4) / 1e4 + n.u : n.b, n);
}, l_ = function(t, n) {
  var r = n.s + n.c * t;
  n.set(n.t, n.p, ~~(r + (r < 0 ? -0.5 : 0.5)) + n.u, n);
}, h4 = function(t, n) {
  return n.set(n.t, n.p, t ? n.e : n.b, n);
}, m4 = function(t, n) {
  return n.set(n.t, n.p, t !== 1 ? n.b : n.e, n);
}, u_ = function(t, n, r) {
  return t.style[n] = r;
}, d_ = function(t, n, r) {
  return t.style.setProperty(n, r);
}, c_ = function(t, n, r) {
  return t._gsap[n] = r;
}, h_ = function(t, n, r) {
  return t._gsap.scaleX = t._gsap.scaleY = r;
}, m_ = function(t, n, r, o, i) {
  var a = t._gsap;
  a.scaleX = a.scaleY = r, a.renderTransform(i, a);
}, f_ = function(t, n, r, o, i) {
  var a = t._gsap;
  a[n] = r, a.renderTransform(i, a);
}, Ye = "transform", Ft = Ye + "Origin", p_ = function e(t, n) {
  var r = this, o = this.target, i = o.style, a = o._gsap;
  if (t in zn && i) {
    if (this.tfm = this.tfm || {}, t !== "transform")
      t = An[t] || t, ~t.indexOf(",") ? t.split(",").forEach(function(s) {
        return r.tfm[s] = Un(o, s);
      }) : this.tfm[t] = a.x ? a[t] : Un(o, t), t === Ft && (this.tfm.zOrigin = a.zOrigin);
    else
      return An.transform.split(",").forEach(function(s) {
        return e.call(r, s, n);
      });
    if (this.props.indexOf(Ye) >= 0)
      return;
    a.svg && (this.svgo = o.getAttribute("data-svg-origin"), this.props.push(Ft, n, "")), t = Ye;
  }
  (i || n) && this.props.push(t, n, i[t]);
}, f4 = function(t) {
  t.translate && (t.removeProperty("translate"), t.removeProperty("scale"), t.removeProperty("rotate"));
}, g_ = function() {
  var t = this.props, n = this.target, r = n.style, o = n._gsap, i, a;
  for (i = 0; i < t.length; i += 3)
    t[i + 1] ? t[i + 1] === 2 ? n[t[i]](t[i + 2]) : n[t[i]] = t[i + 2] : t[i + 2] ? r[t[i]] = t[i + 2] : r.removeProperty(t[i].substr(0, 2) === "--" ? t[i] : t[i].replace(L0, "-$1").toLowerCase());
  if (this.tfm) {
    for (a in this.tfm)
      o[a] = this.tfm[a];
    o.svg && (o.renderTransform(), n.setAttribute("data-svg-origin", this.svgo || "")), i = I0(), (!i || !i.isStart) && !r[Ye] && (f4(r), o.zOrigin && r[Ft] && (r[Ft] += " " + o.zOrigin + "px", o.zOrigin = 0, o.renderTransform()), o.uncache = 1);
  }
}, p4 = function(t, n) {
  var r = {
    target: t,
    props: [],
    revert: g_,
    save: p_
  };
  return t._gsap || Rt.core.getCache(t), n && t.style && t.nodeType && n.split(",").forEach(function(o) {
    return r.save(o);
  }), r;
}, g4, Vc = function(t, n) {
  var r = or.createElementNS ? or.createElementNS((n || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), t) : or.createElement(t);
  return r && r.style ? r : or.createElement(t);
}, on = function e(t, n, r) {
  var o = getComputedStyle(t);
  return o[n] || o.getPropertyValue(n.replace(L0, "-$1").toLowerCase()) || o.getPropertyValue(n) || !r && e(t, wo(n) || n, 1) || "";
}, cm = "O,Moz,ms,Ms,Webkit".split(","), wo = function(t, n, r) {
  var o = n || Ar, i = o.style, a = 5;
  if (t in i && !r)
    return t;
  for (t = t.charAt(0).toUpperCase() + t.substr(1); a-- && !(cm[a] + t in i); )
    ;
  return a < 0 ? null : (a === 3 ? "ms" : a >= 0 ? cm[a] : "") + t;
}, Bc = function() {
  r_() && window.document && (lm = window, or = lm.document, uo = or.documentElement, Ar = Vc("div") || {
    style: {}
  }, Vc("div"), Ye = wo(Ye), Ft = Ye + "Origin", Ar.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0", g4 = !!wo("perspective"), I0 = Rt.core.reverting, A0 = 1);
}, hm = function(t) {
  var n = t.ownerSVGElement, r = Vc("svg", n && n.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), o = t.cloneNode(!0), i;
  o.style.display = "block", r.appendChild(o), uo.appendChild(r);
  try {
    i = o.getBBox();
  } catch (a) {
  }
  return r.removeChild(o), uo.removeChild(r), i;
}, mm = function(t, n) {
  for (var r = n.length; r--; )
    if (t.hasAttribute(n[r]))
      return t.getAttribute(n[r]);
}, v4 = function(t) {
  var n, r;
  try {
    n = t.getBBox();
  } catch (o) {
    n = hm(t), r = 1;
  }
  return n && (n.width || n.height) || r || (n = hm(t)), n && !n.width && !n.x && !n.y ? {
    x: +mm(t, ["x", "cx", "x1"]) || 0,
    y: +mm(t, ["y", "cy", "y1"]) || 0,
    width: 0,
    height: 0
  } : n;
}, b4 = function(t) {
  return !!(t.getCTM && (!t.parentNode || t.ownerSVGElement) && v4(t));
}, Hr = function(t, n) {
  if (n) {
    var r = t.style, o;
    n in zn && n !== Ft && (n = Ye), r.removeProperty ? (o = n.substr(0, 2), (o === "ms" || n.substr(0, 6) === "webkit") && (n = "-" + n), r.removeProperty(o === "--" ? n : n.replace(L0, "-$1").toLowerCase())) : r.removeAttribute(n);
  }
}, ir = function(t, n, r, o, i, a) {
  var s = new Ht(t._pt, n, r, 0, 1, a ? m4 : h4);
  return t._pt = s, s.b = o, s.e = i, t._props.push(r), s;
}, fm = {
  deg: 1,
  rad: 1,
  turn: 1
}, v_ = {
  grid: 1,
  flex: 1
}, ur = function e(t, n, r, o) {
  var i = parseFloat(r) || 0, a = (r + "").trim().substr((i + "").length) || "px", s = Ar.style, l = o_.test(n), u = t.tagName.toLowerCase() === "svg", m = (u ? "client" : "offset") + (l ? "Width" : "Height"), v = 100, g = o === "px", h = o === "%", E, C, A, R;
  if (o === a || !i || fm[o] || fm[a])
    return i;
  if (a !== "px" && !g && (i = e(t, n, r, "px")), R = t.getCTM && b4(t), (h || a === "%") && (zn[n] || ~n.indexOf("adius")))
    return E = R ? t.getBBox()[l ? "width" : "height"] : t[m], Qe(h ? i / E * v : i / 100 * E);
  if (s[l ? "width" : "height"] = v + (g ? a : o), C = o !== "rem" && ~n.indexOf("adius") || o === "em" && t.appendChild && !u ? t : t.parentNode, R && (C = (t.ownerSVGElement || {}).parentNode), (!C || C === or || !C.appendChild) && (C = or.body), A = C._gsap, A && h && A.width && l && A.time === qt.time && !A.uncache)
    return Qe(i / A.width * v);
  if (h && (n === "height" || n === "width")) {
    var P = t.style[n];
    t.style[n] = v + o, E = t[m], P ? t.style[n] = P : Hr(t, n);
  } else
    (h || a === "%") && !v_[on(C, "display")] && (s.position = on(t, "position")), C === t && (s.position = "static"), C.appendChild(Ar), E = Ar[m], C.removeChild(Ar), s.position = "absolute";
  return l && h && (A = $r(C), A.time = qt.time, A.width = C[m]), Qe(g ? E * i / v : E && i ? v / E * i : 0);
}, Un = function(t, n, r, o) {
  var i;
  return A0 || Bc(), n in An && n !== "transform" && (n = An[n], ~n.indexOf(",") && (n = n.split(",")[0])), zn[n] && n !== "transform" ? (i = di(t, o), i = n !== "transformOrigin" ? i[n] : i.svg ? i.origin : fs(on(t, Ft)) + " " + i.zOrigin + "px") : (i = t.style[n], (!i || i === "auto" || o || ~(i + "").indexOf("calc(")) && (i = ms[n] && ms[n](t, n, r) || on(t, n) || Pg(t, n) || (n === "opacity" ? 1 : 0))), r && !~(i + "").trim().indexOf(" ") ? ur(t, n, i, r) + r : i;
}, b_ = function(t, n, r, o) {
  if (!r || r === "none") {
    var i = wo(n, t, 1), a = i && on(t, i, 1);
    a && a !== r ? (n = i, r = a) : n === "borderColor" && (r = on(t, "borderTopColor"));
  }
  var s = new Ht(this._pt, t.style, n, 0, 1, u4), l = 0, u = 0, m, v, g, h, E, C, A, R, P, F, I, D;
  if (s.b = r, s.e = o, r += "", o += "", o.substring(0, 6) === "var(--" && (o = on(t, o.substring(4, o.indexOf(")")))), o === "auto" && (C = t.style[n], t.style[n] = o, o = on(t, n) || o, C ? t.style[n] = C : Hr(t, n)), m = [r, o], Jg(m), r = m[0], o = m[1], g = r.match(io) || [], D = o.match(io) || [], D.length) {
    for (; v = io.exec(o); )
      A = v[0], P = o.substring(l, v.index), E ? E = (E + 1) % 5 : (P.substr(-5) === "rgba(" || P.substr(-5) === "hsla(") && (E = 1), A !== (C = g[u++] || "") && (h = parseFloat(C) || 0, I = C.substr((h + "").length), A.charAt(1) === "=" && (A = lo(h, A) + I), R = parseFloat(A), F = A.substr((R + "").length), l = io.lastIndex - F.length, F || (F = F || Kt.units[n] || I, l === o.length && (o += F, s.e += F)), I !== F && (h = ur(t, n, C, F) || 0), s._pt = {
        _next: s._pt,
        p: P || u === 1 ? P : ",",
        //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
        s: h,
        c: R - h,
        m: E && E < 4 || n === "zIndex" ? Math.round : 0
      });
    s.c = l < o.length ? o.substring(l, o.length) : "";
  } else
    s.r = n === "display" && o === "none" ? m4 : h4;
  return Ag.test(o) && (s.e = 0), this._pt = s, s;
}, pm = {
  top: "0%",
  bottom: "100%",
  left: "0%",
  right: "100%",
  center: "50%"
}, y_ = function(t) {
  var n = t.split(" "), r = n[0], o = n[1] || "50%";
  return (r === "top" || r === "bottom" || o === "left" || o === "right") && (t = r, r = o, o = t), n[0] = pm[r] || r, n[1] = pm[o] || o, n.join(" ");
}, __ = function(t, n) {
  if (n.tween && n.tween._time === n.tween._dur) {
    var r = n.t, o = r.style, i = n.u, a = r._gsap, s, l, u;
    if (i === "all" || i === !0)
      o.cssText = "", l = 1;
    else
      for (i = i.split(","), u = i.length; --u > -1; )
        s = i[u], zn[s] && (l = 1, s = s === "transformOrigin" ? Ft : Ye), Hr(r, s);
    l && (Hr(r, Ye), a && (a.svg && r.removeAttribute("transform"), o.scale = o.rotate = o.translate = "none", di(r, 1), a.uncache = 1, f4(o)));
  }
}, ms = {
  clearProps: function(t, n, r, o, i) {
    if (i.data !== "isFromStart") {
      var a = t._pt = new Ht(t._pt, n, r, 0, 0, __);
      return a.u = o, a.pr = -10, a.tween = i, t._props.push(r), 1;
    }
  }
  /* className feature (about 0.4kb gzipped).
  , className(plugin, target, property, endValue, tween) {
  	let _renderClassName = (ratio, data) => {
  			data.css.render(ratio, data.css);
  			if (!ratio || ratio === 1) {
  				let inline = data.rmv,
  					target = data.t,
  					p;
  				target.setAttribute("class", ratio ? data.e : data.b);
  				for (p in inline) {
  					_removeProperty(target, p);
  				}
  			}
  		},
  		_getAllStyles = (target) => {
  			let styles = {},
  				computed = getComputedStyle(target),
  				p;
  			for (p in computed) {
  				if (isNaN(p) && p !== "cssText" && p !== "length") {
  					styles[p] = computed[p];
  				}
  			}
  			_setDefaults(styles, _parseTransform(target, 1));
  			return styles;
  		},
  		startClassList = target.getAttribute("class"),
  		style = target.style,
  		cssText = style.cssText,
  		cache = target._gsap,
  		classPT = cache.classPT,
  		inlineToRemoveAtEnd = {},
  		data = {t:target, plugin:plugin, rmv:inlineToRemoveAtEnd, b:startClassList, e:(endValue.charAt(1) !== "=") ? endValue : startClassList.replace(new RegExp("(?:\\s|^)" + endValue.substr(2) + "(?![\\w-])"), "") + ((endValue.charAt(0) === "+") ? " " + endValue.substr(2) : "")},
  		changingVars = {},
  		startVars = _getAllStyles(target),
  		transformRelated = /(transform|perspective)/i,
  		endVars, p;
  	if (classPT) {
  		classPT.r(1, classPT.d);
  		_removeLinkedListItem(classPT.d.plugin, classPT, "_pt");
  	}
  	target.setAttribute("class", data.e);
  	endVars = _getAllStyles(target, true);
  	target.setAttribute("class", startClassList);
  	for (p in endVars) {
  		if (endVars[p] !== startVars[p] && !transformRelated.test(p)) {
  			changingVars[p] = endVars[p];
  			if (!style[p] && style[p] !== "0") {
  				inlineToRemoveAtEnd[p] = 1;
  			}
  		}
  	}
  	cache.classPT = plugin._pt = new PropTween(plugin._pt, target, "className", 0, 0, _renderClassName, data, 0, -11);
  	if (style.cssText !== cssText) { //only apply if things change. Otherwise, in cases like a background-image that's pulled dynamically, it could cause a refresh. See https://gsap.com/forums/topic/20368-possible-gsap-bug-switching-classnames-in-chrome/.
  		style.cssText = cssText; //we recorded cssText before we swapped classes and ran _getAllStyles() because in cases when a className tween is overwritten, we remove all the related tweening properties from that class change (otherwise class-specific stuff can't override properties we've directly set on the target's style object due to specificity).
  	}
  	_parseTransform(target, true); //to clear the caching of transforms
  	data.css = new gsap.plugins.css();
  	data.css.init(target, changingVars, tween);
  	plugin._props.push(...data.css._props);
  	return 1;
  }
  */
}, ui = [1, 0, 0, 1, 0, 0], y4 = {}, _4 = function(t) {
  return t === "matrix(1, 0, 0, 1, 0, 0)" || t === "none" || !t;
}, gm = function(t) {
  var n = on(t, Ye);
  return _4(n) ? ui : n.substr(7).match(Mg).map(Qe);
}, D0 = function(t, n) {
  var r = t._gsap || $r(t), o = t.style, i = gm(t), a, s, l, u;
  return r.svg && t.getAttribute("transform") ? (l = t.transform.baseVal.consolidate().matrix, i = [l.a, l.b, l.c, l.d, l.e, l.f], i.join(",") === "1,0,0,1,0,0" ? ui : i) : (i === ui && !t.offsetParent && t !== uo && !r.svg && (l = o.display, o.display = "block", a = t.parentNode, (!a || !t.offsetParent && !t.getBoundingClientRect().width) && (u = 1, s = t.nextElementSibling, uo.appendChild(t)), i = gm(t), l ? o.display = l : Hr(t, "display"), u && (s ? a.insertBefore(t, s) : a ? a.appendChild(t) : uo.removeChild(t))), n && i.length > 6 ? [i[0], i[1], i[4], i[5], i[12], i[13]] : i);
}, jc = function(t, n, r, o, i, a) {
  var s = t._gsap, l = i || D0(t, !0), u = s.xOrigin || 0, m = s.yOrigin || 0, v = s.xOffset || 0, g = s.yOffset || 0, h = l[0], E = l[1], C = l[2], A = l[3], R = l[4], P = l[5], F = n.split(" "), I = parseFloat(F[0]) || 0, D = parseFloat(F[1]) || 0, O, U, q, z;
  r ? l !== ui && (U = h * A - E * C) && (q = I * (A / U) + D * (-C / U) + (C * P - A * R) / U, z = I * (-E / U) + D * (h / U) - (h * P - E * R) / U, I = q, D = z) : (O = v4(t), I = O.x + (~F[0].indexOf("%") ? I / 100 * O.width : I), D = O.y + (~(F[1] || F[0]).indexOf("%") ? D / 100 * O.height : D)), o || o !== !1 && s.smooth ? (R = I - u, P = D - m, s.xOffset = v + (R * h + P * C) - R, s.yOffset = g + (R * E + P * A) - P) : s.xOffset = s.yOffset = 0, s.xOrigin = I, s.yOrigin = D, s.smooth = !!o, s.origin = n, s.originIsAbsolute = !!r, t.style[Ft] = "0px 0px", a && (ir(a, s, "xOrigin", u, I), ir(a, s, "yOrigin", m, D), ir(a, s, "xOffset", v, s.xOffset), ir(a, s, "yOffset", g, s.yOffset)), t.setAttribute("data-svg-origin", I + " " + D);
}, di = function(t, n) {
  var r = t._gsap || new r4(t);
  if ("x" in r && !n && !r.uncache)
    return r;
  var o = t.style, i = r.scaleX < 0, a = "px", s = "deg", l = getComputedStyle(t), u = on(t, Ft) || "0", m, v, g, h, E, C, A, R, P, F, I, D, O, U, q, z, te, ee, x, N, G, X, Q, re, se, de, me, he, _e, De, Ae, Ze;
  return m = v = g = C = A = R = P = F = I = 0, h = E = 1, r.svg = !!(t.getCTM && b4(t)), l.translate && ((l.translate !== "none" || l.scale !== "none" || l.rotate !== "none") && (o[Ye] = (l.translate !== "none" ? "translate3d(" + (l.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (l.rotate !== "none" ? "rotate(" + l.rotate + ") " : "") + (l.scale !== "none" ? "scale(" + l.scale.split(" ").join(",") + ") " : "") + (l[Ye] !== "none" ? l[Ye] : "")), o.scale = o.rotate = o.translate = "none"), U = D0(t, r.svg), r.svg && (r.uncache ? (se = t.getBBox(), u = r.xOrigin - se.x + "px " + (r.yOrigin - se.y) + "px", re = "") : re = !n && t.getAttribute("data-svg-origin"), jc(t, re || u, !!re || r.originIsAbsolute, r.smooth !== !1, U)), D = r.xOrigin || 0, O = r.yOrigin || 0, U !== ui && (ee = U[0], x = U[1], N = U[2], G = U[3], m = X = U[4], v = Q = U[5], U.length === 6 ? (h = Math.sqrt(ee * ee + x * x), E = Math.sqrt(G * G + N * N), C = ee || x ? eo(x, ee) * kr : 0, P = N || G ? eo(N, G) * kr + C : 0, P && (E *= Math.abs(Math.cos(P * co))), r.svg && (m -= D - (D * ee + O * N), v -= O - (D * x + O * G))) : (Ze = U[6], De = U[7], me = U[8], he = U[9], _e = U[10], Ae = U[11], m = U[12], v = U[13], g = U[14], q = eo(Ze, _e), A = q * kr, q && (z = Math.cos(-q), te = Math.sin(-q), re = X * z + me * te, se = Q * z + he * te, de = Ze * z + _e * te, me = X * -te + me * z, he = Q * -te + he * z, _e = Ze * -te + _e * z, Ae = De * -te + Ae * z, X = re, Q = se, Ze = de), q = eo(-N, _e), R = q * kr, q && (z = Math.cos(-q), te = Math.sin(-q), re = ee * z - me * te, se = x * z - he * te, de = N * z - _e * te, Ae = G * te + Ae * z, ee = re, x = se, N = de), q = eo(x, ee), C = q * kr, q && (z = Math.cos(q), te = Math.sin(q), re = ee * z + x * te, se = X * z + Q * te, x = x * z - ee * te, Q = Q * z - X * te, ee = re, X = se), A && Math.abs(A) + Math.abs(C) > 359.9 && (A = C = 0, R = 180 - R), h = Qe(Math.sqrt(ee * ee + x * x + N * N)), E = Qe(Math.sqrt(Q * Q + Ze * Ze)), q = eo(X, Q), P = Math.abs(q) > 2e-4 ? q * kr : 0, I = Ae ? 1 / (Ae < 0 ? -Ae : Ae) : 0), r.svg && (re = t.getAttribute("transform"), r.forceCSS = t.setAttribute("transform", "") || !_4(on(t, Ye)), re && t.setAttribute("transform", re))), Math.abs(P) > 90 && Math.abs(P) < 270 && (i ? (h *= -1, P += C <= 0 ? 180 : -180, C += C <= 0 ? 180 : -180) : (E *= -1, P += P <= 0 ? 180 : -180)), n = n || r.uncache, r.x = m - ((r.xPercent = m && (!n && r.xPercent || (Math.round(t.offsetWidth / 2) === Math.round(-m) ? -50 : 0))) ? t.offsetWidth * r.xPercent / 100 : 0) + a, r.y = v - ((r.yPercent = v && (!n && r.yPercent || (Math.round(t.offsetHeight / 2) === Math.round(-v) ? -50 : 0))) ? t.offsetHeight * r.yPercent / 100 : 0) + a, r.z = g + a, r.scaleX = Qe(h), r.scaleY = Qe(E), r.rotation = Qe(C) + s, r.rotationX = Qe(A) + s, r.rotationY = Qe(R) + s, r.skewX = P + s, r.skewY = F + s, r.transformPerspective = I + a, (r.zOrigin = parseFloat(u.split(" ")[2]) || !n && r.zOrigin || 0) && (o[Ft] = fs(u)), r.xOffset = r.yOffset = 0, r.force3D = Kt.force3D, r.renderTransform = r.svg ? w_ : g4 ? C4 : C_, r.uncache = 0, r;
}, fs = function(t) {
  return (t = t.split(" "))[0] + " " + t[1];
}, Pl = function(t, n, r) {
  var o = gt(n);
  return Qe(parseFloat(n) + parseFloat(ur(t, "x", r + "px", o))) + o;
}, C_ = function(t, n) {
  n.z = "0px", n.rotationY = n.rotationX = "0deg", n.force3D = 0, C4(t, n);
}, _r = "0deg", Vo = "0px", Cr = ") ", C4 = function(t, n) {
  var r = n || this, o = r.xPercent, i = r.yPercent, a = r.x, s = r.y, l = r.z, u = r.rotation, m = r.rotationY, v = r.rotationX, g = r.skewX, h = r.skewY, E = r.scaleX, C = r.scaleY, A = r.transformPerspective, R = r.force3D, P = r.target, F = r.zOrigin, I = "", D = R === "auto" && t && t !== 1 || R === !0;
  if (F && (v !== _r || m !== _r)) {
    var O = parseFloat(m) * co, U = Math.sin(O), q = Math.cos(O), z;
    O = parseFloat(v) * co, z = Math.cos(O), a = Pl(P, a, U * z * -F), s = Pl(P, s, -Math.sin(O) * -F), l = Pl(P, l, q * z * -F + F);
  }
  A !== Vo && (I += "perspective(" + A + Cr), (o || i) && (I += "translate(" + o + "%, " + i + "%) "), (D || a !== Vo || s !== Vo || l !== Vo) && (I += l !== Vo || D ? "translate3d(" + a + ", " + s + ", " + l + ") " : "translate(" + a + ", " + s + Cr), u !== _r && (I += "rotate(" + u + Cr), m !== _r && (I += "rotateY(" + m + Cr), v !== _r && (I += "rotateX(" + v + Cr), (g !== _r || h !== _r) && (I += "skew(" + g + ", " + h + Cr), (E !== 1 || C !== 1) && (I += "scale(" + E + ", " + C + Cr), P.style[Ye] = I || "translate(0, 0)";
}, w_ = function(t, n) {
  var r = n || this, o = r.xPercent, i = r.yPercent, a = r.x, s = r.y, l = r.rotation, u = r.skewX, m = r.skewY, v = r.scaleX, g = r.scaleY, h = r.target, E = r.xOrigin, C = r.yOrigin, A = r.xOffset, R = r.yOffset, P = r.forceCSS, F = parseFloat(a), I = parseFloat(s), D, O, U, q, z;
  l = parseFloat(l), u = parseFloat(u), m = parseFloat(m), m && (m = parseFloat(m), u += m, l += m), l || u ? (l *= co, u *= co, D = Math.cos(l) * v, O = Math.sin(l) * v, U = Math.sin(l - u) * -g, q = Math.cos(l - u) * g, u && (m *= co, z = Math.tan(u - m), z = Math.sqrt(1 + z * z), U *= z, q *= z, m && (z = Math.tan(m), z = Math.sqrt(1 + z * z), D *= z, O *= z)), D = Qe(D), O = Qe(O), U = Qe(U), q = Qe(q)) : (D = v, q = g, O = U = 0), (F && !~(a + "").indexOf("px") || I && !~(s + "").indexOf("px")) && (F = ur(h, "x", a, "px"), I = ur(h, "y", s, "px")), (E || C || A || R) && (F = Qe(F + E - (E * D + C * U) + A), I = Qe(I + C - (E * O + C * q) + R)), (o || i) && (z = h.getBBox(), F = Qe(F + o / 100 * z.width), I = Qe(I + i / 100 * z.height)), z = "matrix(" + D + "," + O + "," + U + "," + q + "," + F + "," + I + ")", h.setAttribute("transform", z), P && (h.style[Ye] = z);
}, T_ = function(t, n, r, o, i) {
  var a = 360, s = lt(i), l = parseFloat(i) * (s && ~i.indexOf("rad") ? kr : 1), u = l - o, m = o + u + "deg", v, g;
  return s && (v = i.split("_")[1], v === "short" && (u %= a, u !== u % (a / 2) && (u += u < 0 ? a : -a)), v === "cw" && u < 0 ? u = (u + a * dm) % a - ~~(u / a) * a : v === "ccw" && u > 0 && (u = (u - a * dm) % a - ~~(u / a) * a)), t._pt = g = new Ht(t._pt, n, r, o, u, s_), g.e = m, g.u = "deg", t._props.push(r), g;
}, vm = function(t, n) {
  for (var r in n)
    t[r] = n[r];
  return t;
}, k_ = function(t, n, r) {
  var o = vm({}, r._gsap), i = "perspective,force3D,transformOrigin,svgOrigin", a = r.style, s, l, u, m, v, g, h, E;
  o.svg ? (u = r.getAttribute("transform"), r.setAttribute("transform", ""), a[Ye] = n, s = di(r, 1), Hr(r, Ye), r.setAttribute("transform", u)) : (u = getComputedStyle(r)[Ye], a[Ye] = n, s = di(r, 1), a[Ye] = u);
  for (l in zn)
    u = o[l], m = s[l], u !== m && i.indexOf(l) < 0 && (h = gt(u), E = gt(m), v = h !== E ? ur(r, l, u, E) : parseFloat(u), g = parseFloat(m), t._pt = new Ht(t._pt, s, l, v, g - v, Rc), t._pt.u = E || 0, t._props.push(l));
  vm(s, o);
};
Nt("padding,margin,Width,Radius", function(e, t) {
  var n = "Top", r = "Right", o = "Bottom", i = "Left", a = (t < 3 ? [n, r, o, i] : [n + i, n + r, o + r, o + i]).map(function(s) {
    return t < 2 ? e + s : "border" + s + e;
  });
  ms[t > 1 ? "border" + e : e] = function(s, l, u, m, v) {
    var g, h;
    if (arguments.length < 4)
      return g = a.map(function(E) {
        return Un(s, E, u);
      }), h = g.join(" "), h.split(g[0]).length === 5 ? g[0] : h;
    g = (m + "").split(" "), h = {}, a.forEach(function(E, C) {
      return h[E] = g[C] = g[C] || g[(C - 1) / 2 | 0];
    }), s.init(l, h, v);
  };
});
var w4 = {
  name: "css",
  register: Bc,
  targetTest: function(t) {
    return t.style && t.nodeType;
  },
  init: function(t, n, r, o, i) {
    var a = this._props, s = t.style, l = r.vars.startAt, u, m, v, g, h, E, C, A, R, P, F, I, D, O, U, q;
    A0 || Bc(), this.styles = this.styles || p4(t), q = this.styles.props, this.tween = r;
    for (C in n)
      if (C !== "autoRound" && (m = n[C], !(Ut[C] && o4(C, n, r, o, t, i)))) {
        if (h = typeof m, E = ms[C], h === "function" && (m = m.call(r, o, t, i), h = typeof m), h === "string" && ~m.indexOf("random(") && (m = si(m)), E)
          E(this, t, C, m, r) && (U = 1);
        else if (C.substr(0, 2) === "--")
          u = (getComputedStyle(t).getPropertyValue(C) + "").trim(), m += "", ar.lastIndex = 0, ar.test(u) || (A = gt(u), R = gt(m)), R ? A !== R && (u = ur(t, C, u, R) + R) : A && (m += A), this.add(s, "setProperty", u, m, o, i, 0, 0, C), a.push(C), q.push(C, 0, s[C]);
        else if (h !== "undefined") {
          if (l && C in l ? (u = typeof l[C] == "function" ? l[C].call(r, o, t, i) : l[C], lt(u) && ~u.indexOf("random(") && (u = si(u)), gt(u + "") || u === "auto" || (u += Kt.units[C] || gt(Un(t, C)) || ""), (u + "").charAt(1) === "=" && (u = Un(t, C))) : u = Un(t, C), g = parseFloat(u), P = h === "string" && m.charAt(1) === "=" && m.substr(0, 2), P && (m = m.substr(2)), v = parseFloat(m), C in An && (C === "autoAlpha" && (g === 1 && Un(t, "visibility") === "hidden" && v && (g = 0), q.push("visibility", 0, s.visibility), ir(this, s, "visibility", g ? "inherit" : "hidden", v ? "inherit" : "hidden", !v)), C !== "scale" && C !== "transform" && (C = An[C], ~C.indexOf(",") && (C = C.split(",")[0]))), F = C in zn, F) {
            if (this.styles.save(C), h === "string" && m.substring(0, 6) === "var(--" && (m = on(t, m.substring(4, m.indexOf(")"))), v = parseFloat(m)), I || (D = t._gsap, D.renderTransform && !n.parseTransform || di(t, n.parseTransform), O = n.smoothOrigin !== !1 && D.smooth, I = this._pt = new Ht(this._pt, s, Ye, 0, 1, D.renderTransform, D, 0, -1), I.dep = 1), C === "scale")
              this._pt = new Ht(this._pt, D, "scaleY", D.scaleY, (P ? lo(D.scaleY, P + v) : v) - D.scaleY || 0, Rc), this._pt.u = 0, a.push("scaleY", C), C += "X";
            else if (C === "transformOrigin") {
              q.push(Ft, 0, s[Ft]), m = y_(m), D.svg ? jc(t, m, 0, O, 0, this) : (R = parseFloat(m.split(" ")[2]) || 0, R !== D.zOrigin && ir(this, D, "zOrigin", D.zOrigin, R), ir(this, s, C, fs(u), fs(m)));
              continue;
            } else if (C === "svgOrigin") {
              jc(t, m, 1, O, 0, this);
              continue;
            } else if (C in y4) {
              T_(this, D, C, g, P ? lo(g, P + m) : m);
              continue;
            } else if (C === "smoothOrigin") {
              ir(this, D, "smooth", D.smooth, m);
              continue;
            } else if (C === "force3D") {
              D[C] = m;
              continue;
            } else if (C === "transform") {
              k_(this, m, t);
              continue;
            }
          } else C in s || (C = wo(C) || C);
          if (F || (v || v === 0) && (g || g === 0) && !i_.test(m) && C in s)
            A = (u + "").substr((g + "").length), v || (v = 0), R = gt(m) || (C in Kt.units ? Kt.units[C] : A), A !== R && (g = ur(t, C, u, R)), this._pt = new Ht(this._pt, F ? D : s, C, g, (P ? lo(g, P + v) : v) - g, !F && (R === "px" || C === "zIndex") && n.autoRound !== !1 ? l_ : Rc), this._pt.u = R || 0, A !== R && R !== "%" && (this._pt.b = u, this._pt.r = a_);
          else if (C in s)
            b_.call(this, t, C, u, P ? P + m : m);
          else if (C in t)
            this.add(t, C, u || t[C], P ? P + m : m, o, i);
          else if (C !== "parseTransform") {
            b0(C, m);
            continue;
          }
          F || (C in s ? q.push(C, 0, s[C]) : typeof t[C] == "function" ? q.push(C, 2, t[C]()) : q.push(C, 1, u || t[C])), a.push(C);
        }
      }
    U && d4(this);
  },
  render: function(t, n) {
    if (n.tween._time || !I0())
      for (var r = n._pt; r; )
        r.r(t, r.d), r = r._next;
    else
      n.styles.revert();
  },
  get: Un,
  aliases: An,
  getSetter: function(t, n, r) {
    var o = An[n];
    return o && o.indexOf(",") < 0 && (n = o), n in zn && n !== Ft && (t._gsap.x || Un(t, "x")) ? r && um === r ? n === "scale" ? h_ : c_ : (um = r || {}) && (n === "scale" ? m_ : f_) : t.style && !p0(t.style[n]) ? u_ : ~n.indexOf("-") ? d_ : S0(t, n);
  },
  core: {
    _removeProperty: Hr,
    _getMatrix: D0
  }
};
Rt.utils.checkPrefix = wo;
Rt.core.getStyleSaver = p4;
(function(e, t, n, r) {
  var o = Nt(e + "," + t + "," + n, function(i) {
    zn[i] = 1;
  });
  Nt(t, function(i) {
    Kt.units[i] = "deg", y4[i] = 1;
  }), An[o[13]] = e + "," + t, Nt(r, function(i) {
    var a = i.split(":");
    An[a[1]] = o[a[0]];
  });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
Nt("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(e) {
  Kt.units[e] = "px";
});
Rt.registerPlugin(w4);
var nr = Rt.registerPlugin(w4) || Rt;
nr.core.Tween;
const E_ = (e, t) => {
  const r = (() => {
    if (typeof t != "number")
      return "";
    switch (!0) {
      case t < 600:
        return "px600";
      case (t >= 600 && t < 960):
        return "px960";
      case (t >= 960 && t < 1280):
        return "px1280";
      case (t >= 1280 && t < 1600):
        return "px1600";
      case (t >= 1600 && t < 1920):
        return "px1920";
      case (t >= 1920 && t < 2560):
        return "px2560";
      default:
        return "";
    }
  })();
  e.forEach((o) => {
    var a;
    const i = new Image();
    i.src = r && ((a = o.sizes) == null ? void 0 : a[r]) || o.url;
  });
}, xn = {
  mixins: [St],
  props: {
    theme: {
      type: Object,
      required: !0
    },
    gallery: {
      type: Object,
      default: () => ({})
    },
    isPreview: Boolean,
    isIFrame: Boolean,
    hidePager: Boolean
  },
  data() {
    return {
      playSlideshow: !0,
      playVideo: !0,
      index: 0,
      activeImageIdx: 0,
      timer: null,
      transition: "right"
    };
  },
  computed: {
    imageHeight() {
      if (this.theme.version === "G1")
        return "";
      const e = this.theme.version === "G4";
      let t = "42.9vw";
      switch (this.theme.image_size) {
        case "small":
          t = e ? "47vw" : "31vw";
          break;
        case "medium":
          t = e ? "52vw" : "37vw";
          break;
        case "large":
          t = e ? "59vw" : "42.9vw";
          break;
        default:
          t = e ? "59vw" : "42.9vw";
      }
      return {
        "--image-height": t
      };
    },
    accentColor() {
      var e;
      return {
        "--gallery-accent-color": $(
          this.theme,
          "gallery_image_border_color.hex",
          (e = this.theme.globalThemeSettings) == null ? void 0 : e.secondaryColor
        )
      };
    },
    linkStyle() {
      return {
        "--link-color": this.theme.link_color.hex
      };
    },
    bgColor() {
      var e, t;
      return {
        "--bg-color": (t = (e = this.theme) == null ? void 0 : e.bg_color) == null ? void 0 : t.hex
      };
    },
    slides() {
      var e;
      return ((e = this.gallery) == null ? void 0 : e.slides) || [];
    },
    widget() {
      var e;
      return ((e = this.gallery) == null ? void 0 : e.widget) || {};
    },
    currentTransition() {
      return this.theme.fade_transition ? `${this.transition}-fade` : this.transition;
    },
    hasSmoothTransition() {
      return ["G7"].includes(this.theme.version);
    }
  },
  mounted() {
    this.preloadImages(), this.$refs.title && this.$refs.title.children[0] && (this.$refs.title.children[0].id = "galleryheading"), !(this.theme.version === "G2" && this.theme.use_video) && this.restartSlideTimer();
  },
  methods: {
    async preloadImages() {
      await this.$nextTick(), E_(this.slides, this.screenSize);
    },
    togglePlay() {
      this.playSlideshow = !this.playSlideshow, this.restartSlideTimer();
    },
    toggleVideoPlay() {
      if (this.togglePlay(), this.playVideo = !this.playVideo, this.$refs.videoPlayer)
        return this.playVideo ? this.$refs.videoPlayer.play() : this.$refs.videoPlayer.pause();
    },
    jump(e) {
      this.activeImageIdx = e, this.restartSlideTimer();
    },
    moveForward() {
      this.transition = "right", this.activeImageIdx = (this.activeImageIdx + 1) % this.slides.length, this.restartSlideTimer();
    },
    moveBack() {
      this.transition = "left", this.activeImageIdx === 0 ? (this.activeImageIdx = this.slides.length - 1, this.restartSlideTimer()) : (this.activeImageIdx = (this.activeImageIdx - 1) % this.slides.length, this.restartSlideTimer());
    },
    smoothForward() {
      if (this.slides.length <= 1) return;
      this.transition = "right";
      const e = [this.$refs.title, this.$refs.description, this.$refs.link].filter(Boolean);
      if (e.length === 0) {
        this.activeImageIdx = (this.activeImageIdx + 1) % this.slides.length, this.$nextTick(() => {
          const r = [this.$refs.title, this.$refs.description, this.$refs.link].filter(Boolean);
          r.length > 0 && (nr.set(r, { opacity: 0 }), nr.to(r, {
            opacity: 1,
            duration: 0.5,
            ease: "sine.in"
          }));
        });
        return;
      }
      const t = () => {
        this.activeImageIdx = (this.activeImageIdx + 1) % this.slides.length, this.$nextTick(() => {
          const r = [this.$refs.title, this.$refs.description, this.$refs.link].filter(Boolean);
          r.length > 0 && nr.set(r, { opacity: 0 });
        });
      }, n = 650;
      nr.to(e, {
        opacity: 0,
        duration: 0.5,
        ease: "sine.out",
        onComplete: () => {
          t(), setTimeout(() => {
            this.$nextTick(() => {
              const r = [this.$refs.title, this.$refs.description, this.$refs.link].filter(Boolean);
              r.length > 0 && nr.to(r, {
                opacity: 1,
                duration: 0.5,
                ease: "sine.in"
              });
            });
          }, n);
        },
        onError: (r) => {
          console.warn("GSAP animation error:", r);
        }
      });
    },
    restartSlideTimer() {
      var e;
      this.isEditing || (clearTimeout(this.timer), this.playSlideshow && (this.timer = setTimeout(() => {
        this.hasSmoothTransition ? this.smoothForward() : this.moveForward(), this.restartSlideTimer();
      }, ((e = this.theme) == null ? void 0 : e.gallery_speed) || 5e3)));
    },
    handleJump(e) {
      this.isEditing ? (this.$emit("jumpTo", e), this.activeImageIdx = e) : this.jump(e);
    },
    handleScrollLeft() {
      this.isEditing ? (this.activeImageIdx = (this.activeImageIdx - 1 + this.slides.length) % this.slides.length, this.$emit("scrollLeft")) : this.moveBack();
    },
    handleScrollRight() {
      this.isEditing ? (this.activeImageIdx = (this.activeImageIdx + 1) % this.slides.length, this.$emit("scrollRight")) : this.moveForward();
    }
  }
}, S_ = {
  props: {
    image: {
      type: Object,
      required: !0
    },
    altText: {
      type: String,
      required: !0
    },
    idx: {
      type: Number,
      required: !0
    }
  },
  computed: {
    sizes() {
      return this.image.sizes || {};
    }
  }
}, M_ = ["srcset"], A_ = ["srcset"], I_ = ["srcset"], L_ = ["srcset"], D_ = ["srcset"], $_ = ["srcset"], O_ = ["src", "alt"];
function P_(e, t, n, r, o, i) {
  return d(), f("div", { key: n.idx }, [
    c("picture", null, [
      c("source", {
        srcset: i.sizes.px600,
        media: "(max-width: 600px)"
      }, null, 8, M_),
      c("source", {
        srcset: i.sizes.px960,
        media: "(max-width: 960px)"
      }, null, 8, A_),
      c("source", {
        srcset: i.sizes.px1280,
        media: "(max-width: 1280px)"
      }, null, 8, I_),
      c("source", {
        srcset: i.sizes.px1600,
        media: "(max-width: 1600px)"
      }, null, 8, L_),
      c("source", {
        srcset: i.sizes.px1920,
        media: "(max-width: 1920px)"
      }, null, 8, D_),
      c("source", {
        srcset: i.sizes.px2560,
        media: "(max-width: 2560px)"
      }, null, 8, $_),
      c("img", {
        src: n.image.url,
        alt: n.altText
      }, null, 8, O_)
    ])
  ]);
}
const Kr = /* @__PURE__ */ B(S_, [["render", P_]]), N_ = {
  name: "SvgPause",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, H_ = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, F_ = ["fill"], R_ = ["fill"];
function V_(e, t, n, r, o, i) {
  return d(), f("svg", H_, [
    c("circle", {
      cx: "16",
      cy: "16",
      r: "16",
      fill: n.buttonBgColor.hex
    }, null, 8, F_),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M15 10H12V22H15V10ZM20 10H17V22H20V10Z",
      fill: n.buttonIconColor.hex
    }, null, 8, R_)
  ]);
}
const B_ = /* @__PURE__ */ B(N_, [["render", V_]]), j_ = {
  name: "SvgPlay",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, U_ = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, q_ = ["fill"], G_ = ["fill"];
function K_(e, t, n, r, o, i) {
  return d(), f("svg", U_, [
    c("circle", {
      cx: "16",
      cy: "16",
      r: "16",
      fill: n.buttonBgColor.hex
    }, null, 8, q_),
    c("path", {
      d: "M14 22L20 16L14 10V22Z",
      fill: n.buttonIconColor.hex
    }, null, 8, G_)
  ]);
}
const z_ = /* @__PURE__ */ B(j_, [["render", K_]]), Z_ = {
  name: "SvgReverse",
  mixins: [xn],
  props: {
    theme: {
      type: Object,
      required: !0
    }
  }
}, x_ = ["fill"], W_ = ["fill"];
function Y_(e, t, n, r, o, i) {
  return d(), f("svg", {
    width: "8",
    height: "13",
    viewBox: "0 0 8 13",
    fill: e.getColorOption(n.theme, "pager_arrow_color", "button_icon_color").hex,
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2.82843 6.50008L7.62132 1.70718L6.20711 0.292969L0 6.50008L6.20711 12.7072L7.62132 11.293L2.82843 6.50008Z",
      fill: e.getColorOption(n.theme, "pager_arrow_color", "button_icon_color").hex
    }, null, 8, W_)
  ], 8, x_);
}
const X_ = /* @__PURE__ */ B(Z_, [["render", Y_]]), Q_ = {
  name: "SvgAdvance",
  mixins: [xn],
  props: {
    theme: {
      type: Object,
      required: !0
    }
  }
}, J_ = ["fill"], eC = ["fill"];
function tC(e, t, n, r, o, i) {
  return d(), f("svg", {
    width: "9",
    height: "13",
    viewBox: "0 0 9 13",
    fill: e.getColorOption(n.theme, "pager_arrow_color", "button_icon_color").hex,
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M5.4997 6.49992L0.706805 11.2928L2.12102 12.707L8.32813 6.49992L2.12102 0.292818L0.706806 1.70703L5.4997 6.49992Z",
      fill: e.getColorOption(n.theme, "pager_arrow_color", "button_icon_color").hex
    }, null, 8, eC)
  ], 8, J_);
}
const nC = /* @__PURE__ */ B(Q_, [["render", tC]]), rC = {
  name: "G1",
  components: {
    ResponsiveImage: Kr,
    PauseSvg: B_,
    PlaySvg: z_,
    ReverseSvg: X_,
    AdvanceSvg: nC
  },
  mixins: [xn]
}, oC = { class: "text" }, iC = ["innerHTML"], sC = ["innerHTML"], aC = { class: "image-wrapper" }, lC = {
  key: 0,
  class: "navigation"
}, uC = { class: "button-action-content" }, dC = { class: "button-action-content" }, cC = { class: "arrow-position" }, hC = { class: "button-action-content" }, mC = { class: "position" }, fC = ["aria-label", "aria-current", "onClick", "onKeydown"], pC = { class: "button-action-content" }, gC = { class: "button-action-content" };
function vC(e, t, n, r, o, i) {
  const a = V("responsive-image"), s = V("PlaySvg"), l = V("PauseSvg"), u = V("ReverseSvg"), m = V("AdvanceSvg"), v = ze("touch");
  return d(), f("div", {
    id: "g1",
    "data-testid": "G1",
    style: Z([e.linkStyle, e.accentColor])
  }, [
    c("div", {
      style: Z(`background-color: ${e.theme.bg_color.hex}`),
      class: "slide"
    }, [
      c("div", oC, [
        c("div", {
          ref: "title",
          class: _(["title", e.theme.style]),
          "data-testid": "gallery-title"
        }, [
          c("div", {
            style: Z(`color: ${e.theme.heading_color.hex}`),
            innerHTML: e.slides[0].title
          }, null, 12, iC)
        ], 2),
        c("div", {
          class: _(["description", e.theme.style])
        }, [
          c("div", {
            style: Z(`color: ${e.theme.text_color.hex}`),
            innerHTML: e.slides[0].content
          }, null, 12, sC)
        ], 2)
      ]),
      c("div", aC, [
        we((d(), L(Zn, {
          tag: "div",
          class: "img-slider",
          name: e.currentTransition,
          "data-testid": "gallery-transition-group"
        }, {
          default: S(() => [
            (d(), L(a, {
              key: e.activeImageIdx,
              idx: e.activeImageIdx,
              class: "responsive-image",
              "data-testid": "gallery-image",
              image: e.slides[e.activeImageIdx],
              "alt-text": e.slides[e.activeImageIdx].alt_text
            }, null, 8, ["idx", "image", "alt-text"]))
          ]),
          _: 1
        }, 8, ["name"])), [
          [
            v,
            e.moveForward,
            "swipe",
            { left: !0 }
          ],
          [
            v,
            e.moveBack,
            "swipe",
            { right: !0 }
          ]
        ]),
        e.slides.length > 1 ? (d(), f("div", lC, [
          e.playSlideshow ? (d(), f("button", {
            key: 1,
            "aria-label": "Pause Gallery",
            "data-testid": "pause-button",
            class: "pause button-action",
            onClick: t[2] || (t[2] = (...g) => e.togglePlay && e.togglePlay(...g)),
            onKeydown: t[3] || (t[3] = K(W((...g) => e.togglePlay && e.togglePlay(...g), ["exact", "prevent"]), ["enter"]))
          }, [
            c("div", dC, [
              j(l, {
                "button-bg-color": e.theme.button_bg_color,
                "button-icon-color": e.theme.button_icon_color
              }, null, 8, ["button-bg-color", "button-icon-color"])
            ])
          ], 32)) : (d(), f("button", {
            key: 0,
            "aria-label": "Play Gallery",
            "data-testid": "play-button",
            class: "play button-action",
            onClick: t[0] || (t[0] = (...g) => e.togglePlay && e.togglePlay(...g)),
            onKeydown: t[1] || (t[1] = K(W((...g) => e.togglePlay && e.togglePlay(...g), ["exact", "prevent"]), ["enter"]))
          }, [
            c("div", uC, [
              j(s, {
                "button-bg-color": e.theme.button_bg_color,
                "button-icon-color": e.theme.button_icon_color
              }, null, 8, ["button-bg-color", "button-icon-color"])
            ])
          ], 32)),
          c("div", cC, [
            c("button", {
              class: "left-arrow button-action",
              "aria-label": "Previous Image",
              "data-testid": "gallery-left-button",
              onClick: t[4] || (t[4] = (...g) => e.moveBack && e.moveBack(...g)),
              onKeydown: t[5] || (t[5] = K(W((...g) => e.moveBack && e.moveBack(...g), ["exact", "prevent"]), ["enter"]))
            }, [
              c("div", hC, [
                j(u, { theme: e.theme }, null, 8, ["theme"])
              ])
            ], 32),
            c("p", {
              style: Z(`color: ${e.theme.text_color.hex}`)
            }, "1", 4),
            c("div", mC, [
              (d(!0), f(J, null, ne(e.slides, (g, h) => (d(), f("button", {
                key: g.url,
                class: "button-action",
                "aria-label": `Image ${h + 1}`,
                "aria-current": e.activeImageIdx === h ? "active" : null,
                "data-testid": "gallery-pager-button",
                onClick: (E) => e.jump(h),
                onKeydown: K(W((E) => e.jump(h), ["exact", "prevent"]), ["enter"])
              }, [
                c("div", pC, [
                  c("div", {
                    class: _(["rectangle button-action-content", { active: e.activeImageIdx === h }]),
                    style: Z({
                      "background-color": e.theme.pager_color.hex,
                      height: e.activeImageIdx === h ? "4px" : "1px"
                    })
                  }, null, 6)
                ])
              ], 40, fC))), 128))
            ]),
            c("p", {
              style: Z(`color: ${e.theme.text_color.hex}`)
            }, k(e.slides.length), 5),
            c("button", {
              "aria-label": "Next Image",
              class: "right-arrow button-action",
              "data-testid": "gallery-right-button",
              onClick: t[6] || (t[6] = (...g) => e.moveForward && e.moveForward(...g)),
              onKeydown: t[7] || (t[7] = K(W((...g) => e.moveForward && e.moveForward(...g), ["exact", "prevent"]), ["enter"]))
            }, [
              c("div", gC, [
                j(m, { theme: e.theme }, null, 8, ["theme"])
              ])
            ], 32)
          ])
        ])) : T("", !0)
      ])
    ], 4)
  ], 4);
}
const bC = /* @__PURE__ */ B(rC, [["render", vC], ["__scopeId", "data-v-11dc02a2"]]), yC = {
  name: "SvgPause",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, _C = {
  class: "pause_icon",
  width: "32",
  height: "32",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, CC = ["fill"], wC = ["fill"];
function TC(e, t, n, r, o, i) {
  return d(), f("svg", _C, [
    c("rect", {
      class: "icon-background",
      width: "40",
      height: "40",
      fill: n.buttonBgColor.hex
    }, null, 8, CC),
    c("path", {
      class: "icon-button",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M19 14H16V26H19V14ZM24 14H21V26H24V14Z",
      fill: n.buttonIconColor.hex
    }, null, 8, wC)
  ]);
}
const kC = /* @__PURE__ */ B(yC, [["render", TC]]), EC = {
  name: "SvgPlay",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, SC = {
  class: "play_icon",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, MC = ["fill"], AC = ["fill"];
function IC(e, t, n, r, o, i) {
  return d(), f("svg", SC, [
    c("rect", {
      class: "icon-background",
      width: "32",
      height: "32",
      fill: n.buttonBgColor.hex
    }, null, 8, MC),
    c("path", {
      class: "icon-button",
      d: "M14 22L20 16L14 10V22Z",
      fill: n.buttonIconColor.hex
    }, null, 8, AC)
  ]);
}
const LC = /* @__PURE__ */ B(EC, [["render", IC]]), DC = {
  name: "SvgReverse",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, $C = {
  width: "64",
  height: "64",
  viewBox: "0 0 64 64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, OC = ["fill"], PC = ["fill"];
function NC(e, t, n, r, o, i) {
  return d(), f("svg", $C, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M-6.10352e-05 0L64 0L64 64L-6.10352e-05 64L-6.10352e-05 0Z",
      fill: n.buttonBgColor.hex,
      "fill-opacity": "0.9"
    }, null, 8, OC),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M25 32L37 19.5L35.5 18L21.9999 32.0428L35.5 46L37 44.5L25 32Z",
      fill: n.buttonIconColor.hex
    }, null, 8, PC)
  ]);
}
const HC = /* @__PURE__ */ B(DC, [["render", NC]]), FC = {
  name: "SvgAdvance",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, RC = {
  width: "64",
  height: "64",
  viewBox: "0 0 64 64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, VC = ["fill"], BC = ["fill"];
function jC(e, t, n, r, o, i) {
  return d(), f("svg", RC, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M64 64L-7.62939e-06 64L-2.03434e-06 -1.78036e-06L64 3.8147e-06L64 64Z",
      fill: n.buttonBgColor.hex,
      "fill-opacity": "0.9"
    }, null, 8, VC),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M39 32L27 44.5L28.5 46L42 31.9572L28.5 18L27 19.5L39 32Z",
      fill: n.buttonIconColor.hex
    }, null, 8, BC)
  ]);
}
const UC = /* @__PURE__ */ B(FC, [["render", jC]]), qC = {
  name: "G2",
  components: {
    PauseSvg: kC,
    PlaySvg: LC,
    ReverseSvg: HC,
    AdvanceSvg: UC,
    ResponsiveImage: Kr
  },
  mixins: [xn],
  computed: {
    titleText() {
      var e, t;
      return ((t = (e = this.slides) == null ? void 0 : e[this.activeImageIdx]) == null ? void 0 : t.title) || "";
    },
    descriptionText() {
      var e, t;
      return ((t = (e = this.slides) == null ? void 0 : e[this.activeImageIdx]) == null ? void 0 : t.content) || "";
    },
    colors() {
      var e, t, n, r;
      return {
        "--button-bg-color": ((t = (e = this.theme) == null ? void 0 : e.button_bg_color) == null ? void 0 : t.hex) || "",
        "--button-color": ((r = (n = this.theme) == null ? void 0 : n.button_icon_color) == null ? void 0 : r.hex) || ""
      };
    },
    arrowsVisible() {
      return this.slides.length > 1 && !this.theme.use_video && !this.theme.hasFloatingNav;
    },
    videoAltText() {
      var e, t;
      return ((t = (e = this.slides) == null ? void 0 : e[0]) == null ? void 0 : t.alt_text) || "";
    },
    videoUrl() {
      var e, t;
      return ((t = (e = this.slides) == null ? void 0 : e[0]) == null ? void 0 : t.url) || "";
    },
    showPauseButton() {
      return this.theme.use_video && this.playVideo || !this.theme.use_video && this.playSlideshow && this.slides.length > 1;
    },
    showPlayButton() {
      return this.theme.use_video && !this.playVideo || !this.theme.use_video && !this.playSlideshow && this.slides.length > 1;
    }
  },
  watch: {
    "theme.use_video": {
      handler() {
        this.theme.use_video ? (this.playSlideshow = !1, this.toggleVideoPlay()) : (this.playVideo = !1, this.togglePlay());
      }
    }
  }
}, GC = { class: "image-wrapper" }, KC = {
  key: 1,
  class: "video-wrapper"
}, zC = ["aria-label", "src"], ZC = { "data-testid": "video-play-pause-wrapper" }, xC = ["data-testid"], WC = { class: "button-action-content" }, YC = ["data-testid"], XC = { class: "button-action-content" }, QC = { class: "button-action-content" }, JC = { class: "button-action-content" }, ew = {
  key: 4,
  class: "position"
}, tw = ["aria-current", "aria-label", "onClick", "onKeydown"], nw = ["innerHTML"], rw = ["innerHTML"];
function ow(e, t, n, r, o, i) {
  const a = V("responsive-image"), s = V("PauseSvg"), l = V("PlaySvg"), u = V("ReverseSvg"), m = V("AdvanceSvg"), v = ze("touch");
  return d(), f("div", {
    id: "g2",
    style: Z([e.linkStyle, i.colors, e.imageHeight])
  }, [
    c("div", {
      class: "slide",
      style: Z(`background: ${e.theme.bg_color.hex}`)
    }, [
      c("div", GC, [
        e.theme.use_video ? T("", !0) : we((d(), L(Zn, {
          key: 0,
          class: "img-slider",
          tag: "div",
          name: e.currentTransition,
          "data-testid": "gallery-transition-group"
        }, {
          default: S(() => [
            (d(), L(a, {
              key: e.activeImageIdx,
              idx: e.activeImageIdx,
              class: "responsive-image",
              "data-testid": "gallery-image",
              image: e.slides[e.activeImageIdx],
              "alt-text": e.slides[e.activeImageIdx].alt_text
            }, null, 8, ["idx", "image", "alt-text"]))
          ]),
          _: 1
        }, 8, ["name"])), [
          [
            v,
            e.moveForward,
            "swipe",
            { left: !0 }
          ],
          [
            v,
            e.moveBack,
            "swipe",
            { right: !0 }
          ]
        ]),
        e.theme.use_video ? (d(), f("div", KC, [
          c("video", {
            ref: "videoPlayer",
            "aria-label": i.videoAltText,
            src: i.videoUrl,
            class: "video",
            autoplay: "",
            muted: "",
            loop: "",
            playsinline: "",
            "data-testid": "gallery-video"
          }, " Your browser does not support videos. ", 8, zC)
        ])) : T("", !0),
        c("div", ZC, [
          i.showPauseButton ? (d(), f("button", {
            key: 0,
            "aria-label": "Pause Gallery",
            "data-testid": e.theme.use_video ? "video-pause-button" : "pause-button",
            class: "pause button-action",
            onClick: t[0] || (t[0] = (g) => e.theme.use_video ? e.toggleVideoPlay() : e.togglePlay()),
            onKeydown: t[1] || (t[1] = K(W((g) => e.theme.use_video ? e.toggleVideoPlay() : e.togglePlay(), ["exact", "prevent"]), ["enter"]))
          }, [
            c("div", WC, [
              j(s, {
                "button-bg-color": e.theme.button_bg_color,
                "button-icon-color": e.theme.button_icon_color
              }, null, 8, ["button-bg-color", "button-icon-color"])
            ])
          ], 40, xC)) : i.showPlayButton ? (d(), f("button", {
            key: 1,
            "aria-label": "Play Gallery",
            "data-testid": e.theme.use_video ? "video-play-button" : "play-button",
            class: "play button-action",
            onClick: t[2] || (t[2] = (g) => e.theme.use_video ? e.toggleVideoPlay() : e.togglePlay()),
            onKeydown: t[3] || (t[3] = K(W((g) => e.theme.use_video ? e.toggleVideoPlay() : e.togglePlay(), ["exact", "prevent"]), ["enter"]))
          }, [
            c("div", XC, [
              j(l, {
                "button-bg-color": e.theme.button_bg_color,
                "button-icon-color": e.theme.button_icon_color
              }, null, 8, ["button-bg-color", "button-icon-color"])
            ])
          ], 40, YC)) : T("", !0)
        ]),
        i.arrowsVisible ? (d(), f("button", {
          key: 2,
          class: "left-arrow button-action",
          "data-testid": "gallery-left-button",
          "aria-label": "Previous Image",
          onClick: t[4] || (t[4] = (...g) => e.moveBack && e.moveBack(...g)),
          onKeydown: t[5] || (t[5] = K(W((...g) => e.moveBack && e.moveBack(...g), ["exact", "prevent"]), ["enter"]))
        }, [
          c("div", QC, [
            j(u, {
              "button-bg-color": e.theme.button_bg_color,
              "button-icon-color": e.theme.button_icon_color
            }, null, 8, ["button-bg-color", "button-icon-color"])
          ])
        ], 32)) : T("", !0),
        i.arrowsVisible ? (d(), f("button", {
          key: 3,
          class: "right-arrow button-action",
          "data-testid": "gallery-right-button",
          "aria-label": "Next Image",
          onClick: t[6] || (t[6] = (...g) => e.moveForward && e.moveForward(...g)),
          onKeydown: t[7] || (t[7] = K(W((...g) => e.moveForward && e.moveForward(...g), ["exact", "prevent"]), ["enter"]))
        }, [
          c("div", JC, [
            j(m, {
              "button-bg-color": e.theme.button_bg_color,
              "button-icon-color": e.theme.button_icon_color
            }, null, 8, ["button-bg-color", "button-icon-color"])
          ])
        ], 32)) : T("", !0),
        e.slides.length > 1 && !e.theme.use_video ? (d(), f("div", ew, [
          (d(!0), f(J, null, ne(e.slides, (g, h) => (d(), f("div", {
            key: g.url
          }, [
            c("button", {
              class: _(["square button-action", { active: e.activeImageIdx === h }]),
              "aria-current": e.activeImageIdx === h ? "active" : null,
              "aria-label": `Image ${h + 1}`,
              style: Z({
                "background-color": e.activeImageIdx === h ? e.theme.pager_active_color.hex : e.theme.pager_color.hex
              }),
              "data-testid": "gallery-pager-button",
              onClick: (E) => e.jump(h),
              onKeydown: K(W((E) => e.jump(h), ["exact", "prevent"]), ["enter"])
            }, t[8] || (t[8] = [
              c("div", { class: "button-action-content" }, null, -1)
            ]), 46, tw)
          ]))), 128))
        ])) : T("", !0)
      ]),
      i.titleText || i.descriptionText ? (d(), f("div", {
        key: 0,
        class: "text",
        style: Z(`background: ${e.theme.overlay_color.hex}CC`)
      }, [
        i.titleText ? (d(), f("div", {
          key: 0,
          class: _(["title", e.theme.style]),
          "data-testid": "gallery-title"
        }, [
          c("div", {
            ref: "title",
            style: Z(`color: ${e.theme.heading_color.hex}`),
            innerHTML: i.titleText
          }, null, 12, nw)
        ], 2)) : T("", !0),
        i.descriptionText ? (d(), f("div", {
          key: 1,
          class: _(["description", e.theme.style])
        }, [
          c("div", {
            style: Z(`color: ${e.theme.text_color.hex}`),
            innerHTML: i.descriptionText
          }, null, 12, rw)
        ], 2)) : T("", !0)
      ], 4)) : T("", !0)
    ], 4)
  ], 4);
}
const iw = /* @__PURE__ */ B(qC, [["render", ow], ["__scopeId", "data-v-45b9921b"]]), sw = {
  name: "SvgPause",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, aw = {
  width: "46",
  height: "46",
  viewBox: "0 0 46 46",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, lw = ["fill", "stroke"], uw = ["fill"];
function dw(e, t, n, r, o, i) {
  return d(), f("svg", aw, [
    c("path", {
      d: "M0.5 0.5H45.5V45.4999H0.5V0.5Z",
      fill: n.buttonBgColor.hex,
      "fill-opacity": "0.9",
      stroke: n.buttonIconColor.hex
    }, null, 8, lw),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M23 18H20V30H23V18ZM28 18H25V30H28V18Z",
      fill: n.buttonIconColor.hex
    }, null, 8, uw)
  ]);
}
const cw = /* @__PURE__ */ B(sw, [["render", dw]]), hw = {
  name: "SvgPlay",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, mw = {
  width: "46",
  height: "46",
  viewBox: "0 0 46 46",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, fw = ["fill", "stroke"], pw = ["fill"];
function gw(e, t, n, r, o, i) {
  return d(), f("svg", mw, [
    c("path", {
      d: "M0.5 0.5H45.5V45.4999H0.5V0.5Z",
      fill: n.buttonBgColor.hex,
      "fill-opacity": "0.9",
      stroke: n.buttonIconColor.hex
    }, null, 8, fw),
    c("path", {
      d: "M21 29L27 23L21 17V29Z",
      fill: n.buttonIconColor.hex
    }, null, 8, pw)
  ]);
}
const vw = /* @__PURE__ */ B(hw, [["render", gw]]), bw = {
  name: "SvgReverse",
  props: {
    buttonIconColor: {
      type: Object,
      required: !0
    },
    buttonBgColor: {
      type: Object,
      required: !0
    }
  }
}, yw = ["stroke"], _w = ["fill"];
function Cw(e, t, n, r, o, i) {
  return d(), f("svg", {
    style: Z({ backgroundColor: n.buttonBgColor.hex }),
    width: "46",
    height: "46",
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    c("path", {
      d: "M45.5 45.4999L0.5 45.4999L0.500004 0.500007L45.5 0.500011L45.5 45.4999Z",
      fill: "black",
      "fill-opacity": "0.01",
      stroke: n.buttonIconColor.hex
    }, null, 8, yw),
    c("path", {
      d: "M19.5 33.9999L8 22.9999L19.5 10.9999L21 12.4999L12 21.9999L38 21.9999L38 23.9999L12 23.9999L21 32.4999L19.5 33.9999Z",
      fill: n.buttonIconColor.hex
    }, null, 8, _w)
  ], 4);
}
const ww = /* @__PURE__ */ B(bw, [["render", Cw]]), Tw = {
  name: "SvgAdvance",
  props: {
    buttonIconColor: {
      type: Object,
      required: !0
    },
    buttonBgColor: {
      type: Object,
      required: !0
    }
  }
}, kw = ["stroke"], Ew = ["fill"];
function Sw(e, t, n, r, o, i) {
  return d(), f("svg", {
    style: Z({ backgroundColor: n.buttonBgColor.hex }),
    width: "46",
    height: "46",
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    c("path", {
      d: "M0.5 0.5H45.5V45.4999H0.5V0.5Z",
      fill: "black",
      "fill-opacity": "0.01",
      stroke: n.buttonIconColor.hex
    }, null, 8, kw),
    c("path", {
      d: "M26.5 12L38 23L26.5 35L25 33.5L34 24H8V22H34L25 13.5L26.5 12Z",
      fill: n.buttonIconColor.hex
    }, null, 8, Ew)
  ], 4);
}
const Mw = /* @__PURE__ */ B(Tw, [["render", Sw]]), Aw = {
  name: "G3",
  components: {
    ResponsiveImage: Kr,
    PauseSvg: cw,
    ReverseSvg: ww,
    PlaySvg: vw,
    AdvanceSvg: Mw
  },
  mixins: [xn],
  computed: {
    cssVars() {
      return {
        "--gradient-color": `linear-gradient(180deg, rgba(1, 73, 145, 0) 0%, ${this.theme.overlay_color.hex} 80.73%)`
      };
    }
  }
}, Iw = { class: "image-wrapper" }, Lw = { class: "button-action-content" }, Dw = { class: "button-action-content" }, $w = { class: "position-tablet" }, Ow = ["aria-current", "aria-label", "onKeydown", "onClick"], Pw = { class: "button-action-content" }, Nw = { class: "button-action-content" }, Hw = ["innerHTML"], Fw = {
  key: 0,
  class: "navigation"
}, Rw = { class: "button-action-content" }, Vw = { class: "button-action-content" }, Bw = { class: "info" }, jw = {
  key: 0,
  class: "position"
}, Uw = ["aria-label", "aria-current", "onClick", "onKeydown"], qw = ["innerHTML"], Gw = ["innerHTML"], Kw = {
  key: 1,
  class: "arrows"
}, zw = { class: "button-action-content" }, Zw = { class: "button-action-content" };
function xw(e, t, n, r, o, i) {
  const a = V("responsive-image"), s = V("PlaySvg"), l = V("PauseSvg"), u = V("ReverseSvg"), m = V("AdvanceSvg"), v = ze("touch");
  return d(), f("div", {
    id: "g3",
    style: Z([e.linkStyle, e.imageHeight, i.cssVars])
  }, [
    c("div", {
      class: "slide",
      style: Z({ "background-color": e.theme.overlay_color.hex })
    }, [
      c("div", Iw, [
        we((d(), L(Zn, {
          tag: "div",
          class: "image",
          name: e.currentTransition,
          "data-testid": "gallery-transition-group"
        }, {
          default: S(() => [
            (d(), L(a, {
              key: e.activeImageIdx,
              idx: e.activeImageIdx,
              class: "responsive-image",
              "data-testid": "gallery-image",
              image: e.slides[e.activeImageIdx],
              "alt-text": e.slides[e.activeImageIdx].alt_text
            }, null, 8, ["idx", "image", "alt-text"]))
          ]),
          _: 1
        }, 8, ["name"])), [
          [
            v,
            e.moveForward,
            "swipe",
            { left: !0 }
          ],
          [
            v,
            e.moveBack,
            "swipe",
            { right: !0 }
          ]
        ]),
        e.slides.length > 1 ? (d(), f("div", {
          key: 0,
          class: _(["navigation-small", { "gradient-background": e.slides[e.activeImageIdx].title || e.slides[e.activeImageIdx].content }])
        }, [
          e.playSlideshow ? (d(), f("button", {
            key: 1,
            "aria-label": "Pause Gallery",
            "data-testid": "pause-button",
            class: "pause button-action",
            onClick: t[2] || (t[2] = (...g) => e.togglePlay && e.togglePlay(...g)),
            onKeydown: t[3] || (t[3] = K(W((...g) => e.togglePlay && e.togglePlay(...g), ["exact", "prevent"]), ["enter"]))
          }, [
            c("div", Dw, [
              j(l, {
                "button-bg-color": e.theme.button_bg_color,
                "button-icon-color": e.theme.button_icon_color
              }, null, 8, ["button-bg-color", "button-icon-color"])
            ])
          ], 32)) : (d(), f("button", {
            key: 0,
            "aria-label": "Play Gallery",
            "data-testid": "play-button",
            class: "play button-action",
            onClick: t[0] || (t[0] = (...g) => e.togglePlay && e.togglePlay(...g)),
            onKeydown: t[1] || (t[1] = K(W((...g) => e.togglePlay && e.togglePlay(...g), ["exact", "prevent"]), ["enter"]))
          }, [
            c("div", Lw, [
              j(s, {
                "button-icon-color": e.theme.button_icon_color,
                "button-bg-color": e.theme.button_bg_color
              }, null, 8, ["button-icon-color", "button-bg-color"])
            ])
          ], 32)),
          c("div", $w, [
            (d(!0), f(J, null, ne(e.slides, (g, h) => (d(), f("div", {
              key: g.url
            }, [
              c("button", {
                class: "square button-action",
                style: Z({
                  "background-color": e.activeImageIdx === h ? e.theme.pager_active_color.hex : e.theme.pager_color.hex
                }),
                "aria-current": e.activeImageIdx === h ? "active" : "inactive",
                "aria-label": `Image ${h + 1}`,
                "data-testid": "gallery-pager-button",
                onKeydown: K(W((E) => e.jump(h), ["exact", "prevent"]), ["enter"]),
                onClick: (E) => e.jump(h)
              }, null, 44, Ow)
            ]))), 128))
          ]),
          c("button", {
            class: "left-arrow button-action",
            "data-testid": "gallery-left-button",
            "aria-label": "Previous Image",
            onClick: t[4] || (t[4] = (...g) => e.moveBack && e.moveBack(...g)),
            onKeydown: t[5] || (t[5] = K(W((...g) => e.moveBack && e.moveBack(...g), ["exact", "prevent"]), ["enter"]))
          }, [
            c("div", Pw, [
              j(u, {
                "button-icon-color": e.theme.button_icon_color,
                "button-bg-color": e.theme.button_bg_color
              }, null, 8, ["button-icon-color", "button-bg-color"])
            ])
          ], 32),
          c("button", {
            class: "right-arrow button-action",
            "data-testid": "gallery-right-button",
            "aria-label": "Next Image",
            onClick: t[6] || (t[6] = (...g) => e.moveForward && e.moveForward(...g)),
            onKeydown: t[7] || (t[7] = K(W((...g) => e.moveForward && e.moveForward(...g), ["exact", "prevent"]), ["enter"]))
          }, [
            c("div", Nw, [
              j(m, {
                "button-icon-color": e.theme.button_icon_color,
                "button-bg-color": e.theme.button_bg_color
              }, null, 8, ["button-icon-color", "button-bg-color"])
            ])
          ], 32)
        ], 2)) : T("", !0),
        c("div", {
          class: _(["title-on-image", [
            e.theme.style,
            { "gradient-background": e.slides[e.activeImageIdx].title || e.slides[e.activeImageIdx].content }
          ]])
        }, [
          c("div", {
            ref: "title",
            style: Z(`color: ${e.theme.heading_color.hex}`),
            "data-testid": "gallery-title",
            innerHTML: e.slides[e.activeImageIdx].title
          }, null, 12, Hw)
        ], 2)
      ]),
      e.slides.length > 1 ? (d(), f("div", Fw, [
        e.playSlideshow ? (d(), f("button", {
          key: 1,
          "aria-label": "Pause Gallery",
          "data-testid": "pause-button",
          class: "pause button-action",
          onClick: t[10] || (t[10] = (...g) => e.togglePlay && e.togglePlay(...g)),
          onKeydown: t[11] || (t[11] = K(W((...g) => e.togglePlay && e.togglePlay(...g), ["exact", "prevent"]), ["enter"]))
        }, [
          c("div", Vw, [
            j(l, {
              "button-bg-color": e.theme.button_bg_color,
              "button-icon-color": e.theme.button_icon_color
            }, null, 8, ["button-bg-color", "button-icon-color"])
          ])
        ], 32)) : (d(), f("button", {
          key: 0,
          "aria-label": "Play Gallery",
          "data-testid": "play-button",
          class: "play button-action",
          onClick: t[8] || (t[8] = (...g) => e.togglePlay && e.togglePlay(...g)),
          onKeydown: t[9] || (t[9] = K(W((...g) => e.togglePlay && e.togglePlay(...g), ["exact", "prevent"]), ["enter"]))
        }, [
          c("div", Rw, [
            j(s, {
              "button-bg-color": e.theme.button_bg_color,
              "button-icon-color": e.theme.button_icon_color
            }, null, 8, ["button-bg-color", "button-icon-color"])
          ])
        ], 32))
      ])) : T("", !0),
      c("div", Bw, [
        e.slides.length > 1 ? (d(), f("div", jw, [
          (d(!0), f(J, null, ne(e.slides, (g, h) => (d(), f("div", {
            key: g.url
          }, [
            c("button", {
              class: "square",
              style: Z({
                "background-color": e.activeImageIdx === h ? e.theme.pager_active_color.hex : e.theme.pager_color.hex
              }),
              "aria-label": `Image ${h + 1}`,
              "aria-current": e.activeImageIdx === h ? "active" : null,
              onClick: (E) => e.jump(h),
              onKeydown: K(W((E) => e.jump(h), ["exact", "prevent"]), ["enter"])
            }, null, 44, Uw)
          ]))), 128))
        ])) : T("", !0),
        c("div", {
          class: _(["gradient", { "show-background": e.slides[e.activeImageIdx].title || e.slides[e.activeImageIdx].content }])
        }, [
          c("div", {
            class: _(["title", e.theme.style])
          }, [
            c("div", {
              style: Z(`color: ${e.theme.heading_color.hex}`),
              innerHTML: e.slides[e.activeImageIdx].title
            }, null, 12, qw)
          ], 2),
          c("div", {
            class: _(["description", e.theme.style])
          }, [
            c("div", {
              style: Z(`color: ${e.theme.text_color.hex}`),
              innerHTML: e.slides[e.activeImageIdx].content
            }, null, 12, Gw)
          ], 2)
        ], 2)
      ]),
      e.slides.length > 1 ? (d(), f("div", Kw, [
        c("button", {
          class: "left-arrow button-action",
          "data-testid": "gallery-left-button",
          "aria-label": "Previous Image",
          onClick: t[12] || (t[12] = (...g) => e.moveBack && e.moveBack(...g)),
          onKeydown: t[13] || (t[13] = K(W((...g) => e.moveBack && e.moveBack(...g), ["exact", "prevent"]), ["enter"]))
        }, [
          c("div", zw, [
            j(u, {
              "button-bg-color": e.theme.button_bg_color,
              "button-icon-color": e.theme.button_icon_color
            }, null, 8, ["button-bg-color", "button-icon-color"])
          ])
        ], 32),
        c("button", {
          class: "right-arrow button-action",
          "data-testid": "gallery-right-button",
          "aria-label": "Next Image",
          onClick: t[14] || (t[14] = (...g) => e.moveForward && e.moveForward(...g)),
          onKeydown: t[15] || (t[15] = K(W((...g) => e.moveForward && e.moveForward(...g), ["exact", "prevent"]), ["enter"]))
        }, [
          c("div", Zw, [
            j(m, {
              "button-bg-color": e.theme.button_bg_color,
              "button-icon-color": e.theme.button_icon_color
            }, null, 8, ["button-bg-color", "button-icon-color"])
          ])
        ], 32)
      ])) : T("", !0)
    ], 4)
  ], 4);
}
const Ww = /* @__PURE__ */ B(Aw, [["render", xw], ["__scopeId", "data-v-b8acb151"]]), Yw = {
  name: "SvgPause",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, Xw = {
  class: "pause_icon",
  width: "32",
  height: "32",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Qw = ["fill"], Jw = ["fill"];
function eT(e, t, n, r, o, i) {
  return d(), f("svg", Xw, [
    c("rect", {
      class: "icon-background",
      width: "40",
      height: "40",
      fill: n.buttonBgColor.hex
    }, null, 8, Qw),
    c("path", {
      class: "icon-button",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M19 14H16V26H19V14ZM24 14H21V26H24V14Z",
      fill: n.buttonIconColor.hex
    }, null, 8, Jw)
  ]);
}
const tT = /* @__PURE__ */ B(Yw, [["render", eT]]), nT = {
  name: "SvgPlay",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, rT = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, oT = ["fill"], iT = ["fill"];
function sT(e, t, n, r, o, i) {
  return d(), f("svg", rT, [
    c("circle", {
      cx: "16",
      cy: "16",
      r: "16",
      fill: n.buttonBgColor.hex
    }, null, 8, oT),
    c("path", {
      d: "M14 22L20 16L14 10V22Z",
      fill: n.buttonIconColor.hex
    }, null, 8, iT)
  ]);
}
const aT = /* @__PURE__ */ B(nT, [["render", sT]]), lT = {
  name: "SvgReverse",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, uT = {
  width: "64",
  height: "63",
  viewBox: "0 0 64 63",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, dT = ["fill"], cT = ["fill"];
function hT(e, t, n, r, o, i) {
  return d(), f("svg", uT, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M-0.00012207 0H63.9999V62.9999H-0.00012207V0Z",
      fill: n.buttonBgColor.hex,
      "fill-opacity": "0.9"
    }, null, 8, dT),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M24.7803 31.209L37.1333 43.8414L35.7324 45.265L21.9999 31.2222L35.9117 17L37.2991 18.4104L24.7803 31.209Z",
      fill: n.buttonIconColor.hex
    }, null, 8, cT)
  ]);
}
const mT = /* @__PURE__ */ B(lT, [["render", hT]]), fT = {
  name: "SvgAdvance",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, pT = {
  width: "64",
  height: "63",
  viewBox: "0 0 64 63",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, gT = ["fill"], vT = ["fill"];
function bT(e, t, n, r, o, i) {
  return d(), f("svg", pT, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M0 0H63.9999V62.9999H0V0Z",
      fill: n.buttonBgColor.hex,
      "fill-opacity": "0.9"
    }, null, 8, gT),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M38.5191 31.209L26.1659 43.8414L27.5668 45.265L41.2995 31.2222L27.3874 17L26 18.4104L38.5191 31.209Z",
      fill: n.buttonIconColor.hex
    }, null, 8, vT)
  ]);
}
const yT = /* @__PURE__ */ B(fT, [["render", bT]]), _T = {
  name: "G4",
  components: {
    ResponsiveImage: Kr,
    PauseSvg: tT,
    PlaySvg: aT,
    ReverseSvg: mT,
    AdvanceSvg: yT
  },
  mixins: [xn]
}, CT = { class: "image-and-nav" }, wT = { class: "image-wrapper" }, TT = {
  key: 0,
  class: "position-and-play"
}, kT = { class: "button-action-content" }, ET = { class: "button-action-content" }, ST = { class: "position" }, MT = ["aria-current", "aria-label", "onClick", "onKeydown"], AT = {
  key: 0,
  class: "navigation"
}, IT = { class: "arrows" }, LT = { class: "button-action-content" }, DT = { class: "button-action-content" }, $T = { class: "text" }, OT = ["innerHTML"], PT = ["innerHTML"];
function NT(e, t, n, r, o, i) {
  const a = V("PlaySvg"), s = V("PauseSvg"), l = V("responsive-image"), u = V("ReverseSvg"), m = V("AdvanceSvg"), v = ze("touch");
  return d(), f("div", {
    id: "g4",
    style: Z([e.linkStyle, e.imageHeight])
  }, [
    c("div", {
      class: "slide",
      style: Z(`background: ${e.theme.bg_color.hex}`)
    }, [
      c("div", CT, [
        c("div", wT, [
          e.slides.length > 1 ? (d(), f("div", TT, [
            e.playSlideshow ? (d(), f("button", {
              key: 1,
              "aria-label": "Pause Gallery",
              "data-testid": "pause-button",
              class: "pause button-action",
              onClick: t[2] || (t[2] = (...g) => e.togglePlay && e.togglePlay(...g)),
              onKeydown: t[3] || (t[3] = K(W((...g) => e.togglePlay && e.togglePlay(...g), ["exact", "prevent"]), ["enter"]))
            }, [
              c("div", ET, [
                j(s, {
                  "button-bg-color": e.theme.button_bg_color,
                  "button-icon-color": e.theme.button_icon_color
                }, null, 8, ["button-bg-color", "button-icon-color"])
              ])
            ], 32)) : (d(), f("button", {
              key: 0,
              "aria-label": "Play Gallery",
              "data-testid": "play-button",
              class: "play button-action",
              onClick: t[0] || (t[0] = (...g) => e.togglePlay && e.togglePlay(...g)),
              onKeydown: t[1] || (t[1] = K(W((...g) => e.togglePlay && e.togglePlay(...g), ["exact", "prevent"]), ["enter"]))
            }, [
              c("div", kT, [
                j(a, {
                  "button-bg-color": e.theme.button_bg_color,
                  "button-icon-color": e.theme.button_icon_color
                }, null, 8, ["button-bg-color", "button-icon-color"])
              ])
            ], 32)),
            c("div", ST, [
              (d(!0), f(J, null, ne(e.slides, (g, h) => (d(), f("div", {
                key: g.url
              }, [
                c("button", {
                  class: _(["square", { active: e.activeImageIdx === h }]),
                  style: Z({
                    "background-color": e.activeImageIdx === h ? e.theme.pager_active_color.hex : e.theme.pager_color.hex
                  }),
                  "aria-current": e.activeImageIdx === h ? "active" : null,
                  "aria-label": `Image ${h + 1}`,
                  "data-testid": "gallery-pager-button",
                  onClick: (E) => e.jump(h),
                  onKeydown: K(W((E) => e.jump(h), ["exact", "prevent"]), ["enter"])
                }, null, 46, MT)
              ]))), 128))
            ])
          ])) : T("", !0),
          we((d(), L(Zn, {
            tag: "div",
            class: "img-slider",
            name: e.currentTransition,
            "data-testid": "gallery-transition-group"
          }, {
            default: S(() => [
              (d(), L(l, {
                key: e.activeImageIdx,
                idx: e.activeImageIdx,
                class: "responsive-image",
                "data-testid": "gallery-image",
                image: e.slides[e.activeImageIdx],
                "alt-text": e.slides[e.activeImageIdx].alt_text
              }, null, 8, ["idx", "image", "alt-text"]))
            ]),
            _: 1
          }, 8, ["name"])), [
            [
              v,
              e.moveForward,
              "swipe",
              { left: !0 }
            ],
            [
              v,
              e.moveBack,
              "swipe",
              { right: !0 }
            ]
          ])
        ]),
        e.slides.length > 1 ? (d(), f("div", AT, [
          c("div", IT, [
            c("button", {
              class: "left-arrow button-action",
              "data-testid": "gallery-left-button",
              "aria-label": "Previous Image",
              onClick: t[4] || (t[4] = (...g) => e.moveBack && e.moveBack(...g)),
              onKeydown: t[5] || (t[5] = K(W((...g) => e.moveBack && e.moveBack(...g), ["exact", "prevent"]), ["enter"]))
            }, [
              c("div", LT, [
                j(u, {
                  "button-bg-color": e.theme.button_bg_color,
                  "button-icon-color": e.theme.button_icon_color
                }, null, 8, ["button-bg-color", "button-icon-color"])
              ])
            ], 32),
            c("button", {
              class: "right-arrow button-action",
              "data-testid": "gallery-right-button",
              "aria-label": "Next Image",
              onClick: t[6] || (t[6] = (...g) => e.moveForward && e.moveForward(...g)),
              onKeydown: t[7] || (t[7] = K(W((...g) => e.moveForward && e.moveForward(...g), ["exact", "prevent"]), ["enter"]))
            }, [
              c("div", DT, [
                j(m, {
                  "button-bg-color": e.theme.button_bg_color,
                  "button-icon-color": e.theme.button_icon_color
                }, null, 8, ["button-bg-color", "button-icon-color"])
              ])
            ], 32)
          ])
        ])) : T("", !0)
      ]),
      c("div", $T, [
        c("div", {
          class: _(["title", e.theme.style])
        }, [
          c("div", {
            ref: "title",
            style: Z(`color: ${e.theme.heading_color.hex}`),
            "data-testid": "gallery-title",
            innerHTML: e.slides[0].title
          }, null, 12, OT)
        ], 2),
        c("div", {
          class: _(["description", e.theme.style])
        }, [
          c("div", {
            style: Z(`color: ${e.theme.text_color.hex}`),
            innerHTML: e.slides[0].content
          }, null, 12, PT)
        ], 2)
      ])
    ], 4)
  ], 4);
}
const HT = /* @__PURE__ */ B(_T, [["render", NT], ["__scopeId", "data-v-958685b9"]]), FT = {
  name: "SvgReverse",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, RT = {
  width: "67",
  height: "65",
  viewBox: "0 0 67 65",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, VT = ["fill"], BT = ["fill"];
function jT(e, t, n, r, o, i) {
  return d(), f("svg", RT, [
    c("path", {
      fill: n.buttonBgColor.hex,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M0.0700684 0.910156L66.2576 0.910156L66.2576 65.0005L0.0700684 65.0005L0.0700684 0.910156Z"
    }, null, 8, VT),
    c("path", {
      fill: n.buttonIconColor.hex,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M25.9246 32.9568L38.3347 20.4391L36.7834 18.937L22.822 32.9997L36.7834 46.9766L38.3347 45.4744L25.9246 32.9568Z"
    }, null, 8, BT)
  ]);
}
const UT = /* @__PURE__ */ B(FT, [["render", jT]]), qT = {
  name: "SvgReverse",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, GT = {
  width: "46",
  height: "46",
  viewBox: "0 0 46 46",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, KT = ["fill"], zT = ["stroke"];
function ZT(e, t, n, r, o, i) {
  return d(), f("svg", GT, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.88353 22.6238L8.11814 22.8624L7.57617 23.4133L19.2807 35.3118L20.6718 33.899L10.9346 23.9994H38.3765V21.9993H11.2035L20.6718 12.373L19.3191 10.998L7.88353 22.6238Z",
      fill: n.buttonIconColor.hex
    }, null, 8, KT),
    c("path", {
      stroke: n.buttonBgColor.hex,
      d: "M0.5 0.5H45.5V45.5H0.5V0.5Z",
      fill: "black",
      "fill-opacity": "0.01"
    }, null, 8, zT)
  ]);
}
const xT = /* @__PURE__ */ B(qT, [["render", ZT]]), WT = {
  name: "SvgAdvance",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, YT = {
  width: "46",
  height: "46",
  viewBox: "0 0 46 46",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, XT = ["fill"], QT = ["stroke"];
function JT(e, t, n, r, o, i) {
  return d(), f("svg", YT, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M38.361 22.6238L38.1264 22.8624L38.6684 23.4133L26.9641 35.3118L25.5731 33.899L35.3101 23.9994H7.86816V21.9993H35.0411L25.5731 12.373L26.9257 10.998L38.361 22.6238Z",
      fill: n.buttonIconColor.hex
    }, null, 8, XT),
    c("path", {
      stroke: n.buttonBgColor.hex,
      d: "M0.5 0.5H45.5V45.5H0.5V0.5Z",
      fill: "black",
      "fill-opacity": "0.01"
    }, null, 8, QT)
  ]);
}
const ek = /* @__PURE__ */ B(WT, [["render", JT]]), tk = {
  name: "SvgAdvance",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, nk = {
  width: "67",
  height: "65",
  viewBox: "0 0 67 65",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, rk = ["fill"], ok = ["fill"];
function ik(e, t, n, r, o, i) {
  return d(), f("svg", nk, [
    c("path", {
      fill: n.buttonBgColor.hex,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M66.6326 65L0.445007 65L0.445013 0.909601L66.6326 0.909607L66.6326 65Z"
    }, null, 8, rk),
    c("path", {
      fill: n.buttonIconColor.hex,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M40.7781 32.9534L28.3679 45.471L29.9192 46.9731L43.8806 32.9105L29.9192 18.9336L28.3679 20.4357L40.7781 32.9534Z"
    }, null, 8, ok)
  ]);
}
const sk = /* @__PURE__ */ B(tk, [["render", ik]]), ak = {
  name: "SvgPlayPause",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    },
    paused: Boolean
  }
}, lk = {
  width: "46",
  height: "46",
  viewBox: "0 0 46 46",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, uk = ["stroke"], dk = ["fill"], ck = ["fill"];
function hk(e, t, n, r, o, i) {
  return d(), f("svg", lk, [
    c("path", {
      stroke: n.buttonBgColor.hex,
      d: "M0.5 0.5H45.5V45.4999H0.5V0.5Z",
      fill: "black",
      "fill-opacity": "0.01"
    }, null, 8, uk),
    n.paused ? (d(), f("path", {
      key: 0,
      d: "M21 29L27 23L21 17V29Z",
      fill: n.buttonIconColor.hex
    }, null, 8, dk)) : (d(), f("path", {
      key: 1,
      d: "M23 18H20V30H23V18ZM28 18H25V30H28V18Z",
      fill: n.buttonIconColor.hex,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd"
    }, null, 8, ck))
  ]);
}
const mk = /* @__PURE__ */ B(ak, [["render", hk]]), fk = {
  name: "SvgPlayPause",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    },
    paused: Boolean
  }
}, pk = {
  width: "67",
  height: "65",
  viewBox: "0 0 67 65",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, gk = ["fill"], vk = ["fill"], bk = ["fill"];
function yk(e, t, n, r, o, i) {
  return d(), f("svg", pk, [
    c("rect", {
      fill: n.buttonBgColor.hex,
      x: "0.257568",
      y: "0.910156",
      width: "66.1876",
      height: "64.0904"
    }, null, 8, gk),
    n.paused ? (d(), f("path", {
      key: 0,
      fill: n.buttonIconColor.hex,
      d: "M29.2146 44.9734L41.6248 32.9564L29.2146 20.9395V44.9734Z"
    }, null, 8, vk)) : (d(), f("path", {
      key: 1,
      fill: n.buttonIconColor.hex,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M31 20H25V44H31V20ZM41 20H35V44H41V20Z"
    }, null, 8, bk))
  ]);
}
const _k = /* @__PURE__ */ B(fk, [["render", yk]]), Ck = {
  name: "G5Buttons",
  components: { ReverseASvg: xT, ReverseBSvg: UT, AdvanceASvg: ek, AdvanceBSvg: sk, PlayPauseASvg: mk, PlayPauseBSvg: _k },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    activeImageIdx: {
      type: Number,
      default: 0
    },
    pagerNumber: {
      type: Number,
      default: 0
    },
    hidePager: Boolean,
    playSlideshow: Boolean,
    onlyPlayButton: Boolean,
    smallPager: Boolean,
    isEditing: Boolean
  },
  computed: {
    cssVars() {
      var e, t, n, r;
      return {
        "--gallery-button-color": ((e = this.theme.button_icon_color) == null ? void 0 : e.hex) || "#FFFFFF",
        "--gallery-button-bg-color": ((t = this.theme.button_bg_color) == null ? void 0 : t.hex) || "#333333",
        "--gallery-pager-color": ((n = this.theme.pager_color) == null ? void 0 : n.hex) || "#333333",
        "--gallery-pager-active-color": ((r = this.theme.pager_active_color) == null ? void 0 : r.hex) || "#0000FF"
      };
    }
  }
}, wk = { class: "gallery-buttons" }, Tk = ["aria-label", "data-testid", "disabled"], kk = {
  key: 0,
  class: "gallery-pager"
}, Ek = ["aria-label", "aria-current", "onClick"], Sk = {
  key: 0,
  class: "pager-bottom"
}, Mk = {
  key: 1,
  class: "gallery-small-pager"
}, Ak = ["aria-label", "aria-current", "onClick"];
function Ik(e, t, n, r, o, i) {
  const a = V("PlayPauseASvg"), s = V("PlayPauseBSvg"), l = V("ReverseASvg"), u = V("ReverseBSvg"), m = V("AdvanceASvg"), v = V("AdvanceBSvg");
  return d(), f("div", {
    style: Z(i.cssVars),
    class: _(["gallery-button-wrapper", `type-${n.theme.type}`])
  }, [
    c("div", wk, [
      c("button", {
        style: { order: 2 },
        "aria-label": n.playSlideshow ? "Pause Gallery" : "Play Gallery",
        "data-testid": n.playSlideshow ? "pause-button" : "play-button ",
        class: _(["pause-play-button", { hasWidget: n.theme.cta_widget }]),
        disabled: n.isEditing,
        onClick: t[0] || (t[0] = (g) => e.$emit("togglePlay")),
        onKeydown: t[1] || (t[1] = K(W((g) => e.$emit("togglePlay"), ["exact", "prevent"]), ["enter"]))
      }, [
        n.theme.type === "A" ? (d(), L(a, {
          key: 0,
          "button-bg-color": n.theme.button_bg_color,
          "button-icon-color": n.theme.button_icon_color,
          paused: !n.playSlideshow
        }, null, 8, ["button-bg-color", "button-icon-color", "paused"])) : (d(), L(s, {
          key: 1,
          "button-bg-color": n.theme.button_bg_color,
          "button-icon-color": n.theme.button_icon_color,
          paused: !n.playSlideshow
        }, null, 8, ["button-bg-color", "button-icon-color", "paused"]))
      ], 42, Tk),
      n.onlyPlayButton ? T("", !0) : (d(), f("button", {
        key: 0,
        "aria-label": "Previous Image",
        "data-testid": "gallery-left-button",
        style: { order: 1 },
        onClick: t[2] || (t[2] = (g) => e.$emit("scrollLeft")),
        onKeydown: t[3] || (t[3] = K(W((g) => e.$emit("scrollLeft"), ["exact", "prevent"]), ["enter"]))
      }, [
        n.theme.type === "A" ? (d(), L(l, {
          key: 0,
          "button-bg-color": n.theme.button_bg_color,
          "button-icon-color": n.theme.button_icon_color
        }, null, 8, ["button-bg-color", "button-icon-color"])) : (d(), L(u, {
          key: 1,
          "button-bg-color": n.theme.button_bg_color,
          "button-icon-color": n.theme.button_icon_color
        }, null, 8, ["button-bg-color", "button-icon-color"]))
      ], 32)),
      n.onlyPlayButton ? T("", !0) : (d(), f("button", {
        key: 1,
        "aria-label": "Next Image",
        "data-testid": "gallery-right-button",
        style: { order: 3 },
        onClick: t[4] || (t[4] = (g) => e.$emit("scrollRight")),
        onKeydown: t[5] || (t[5] = K(W((g) => e.$emit("scrollRight"), ["exact", "prevent"]), ["enter"]))
      }, [
        n.theme.type === "A" ? (d(), L(m, {
          key: 0,
          "button-bg-color": n.theme.button_bg_color,
          "button-icon-color": n.theme.button_icon_color
        }, null, 8, ["button-bg-color", "button-icon-color"])) : (d(), L(v, {
          key: 1,
          "button-bg-color": n.theme.button_bg_color,
          "button-icon-color": n.theme.button_icon_color
        }, null, 8, ["button-bg-color", "button-icon-color"]))
      ], 32))
    ]),
    n.hidePager ? T("", !0) : (d(), f(J, { key: 0 }, [
      n.pagerNumber && !n.smallPager ? (d(), f("div", kk, [
        (d(!0), f(J, null, ne(n.pagerNumber, (g, h) => (d(), f("button", {
          key: g,
          class: _({ active: n.activeImageIdx === h }),
          "aria-label": `Image ${h + 1}`,
          "aria-current": n.activeImageIdx === h ? "active" : null,
          "data-testid": "gallery-pager-button",
          onClick: (E) => e.$emit("jumpTo", h)
        }, [
          c("span", null, k(g), 1),
          n.theme.type === "A" ? (d(), f("div", Sk)) : T("", !0)
        ], 10, Ek))), 128))
      ])) : (d(), f("div", Mk, [
        (d(!0), f(J, null, ne(n.pagerNumber, (g, h) => (d(), f("button", {
          key: g,
          "aria-label": `Image ${h + 1}`,
          "aria-current": n.activeImageIdx === h,
          class: _([{ active: n.activeImageIdx === h }, "circle"]),
          "data-testid": "gallery-pager-button",
          onClick: (E) => e.$emit("jumpTo", h)
        }, null, 10, Ak))), 128))
      ]))
    ], 64))
  ], 6);
}
const Lk = /* @__PURE__ */ B(Ck, [["render", Ik], ["__scopeId", "data-v-099308b8"]]), Dk = {
  name: "G5",
  components: {
    ResponsiveImage: Kr,
    G5Buttons: Lk
  },
  mixins: [xn],
  props: {
    isEditing: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    cssVars() {
      return {
        "--gallery-heading-color": $(this.theme, "heading_color.hex", "#fff"),
        "--gallery-link-color": $(this.theme, "link_color.hex", "#fff"),
        "--gradient-color": `linear-gradient(0deg, ${this.theme.overlay_color.hex} 0%, rgba(19, 19, 19, 0) 71.87%)`
      };
    }
  }
}, $k = { class: "slide-wrapper" }, Ok = { class: "bottom-content gradient" }, Pk = ["innerHTML"], Nk = {
  key: 0,
  class: "navigation"
};
function Hk(e, t, n, r, o, i) {
  const a = V("responsive-image"), s = V("G5Buttons"), l = ze("touch");
  return d(), f("div", {
    id: "g5",
    "data-testid": "G5",
    class: _(`type-${e.theme.type}`),
    style: Z([i.cssVars, e.imageHeight])
  }, [
    c("div", {
      class: "slide",
      style: Z({ "background-color": e.theme.overlay_color.hex })
    }, [
      c("div", $k, [
        M(e.$slots, "controls"),
        M(e.$slots, "image", {}, () => [
          we((d(), L(Zn, {
            tag: "div",
            class: "image",
            name: e.currentTransition,
            "data-testid": "gallery-transition-group"
          }, {
            default: S(() => [
              (d(), L(a, {
                key: e.activeImageIdx,
                idx: e.activeImageIdx,
                class: "responsive-image",
                "data-testid": "gallery-image",
                image: e.slides[e.activeImageIdx],
                "alt-text": e.slides[e.activeImageIdx].alt_text
              }, null, 8, ["idx", "image", "alt-text"]))
            ]),
            _: 1
          }, 8, ["name"])), [
            [
              l,
              e.moveForward,
              "swipe",
              { left: !0 }
            ],
            [
              l,
              e.moveBack,
              "swipe",
              { right: !0 }
            ]
          ])
        ])
      ]),
      c("div", Ok, [
        c("div", {
          class: _(["left-text", e.theme.style])
        }, [
          M(e.$slots, "title", {}, () => [
            c("div", {
              class: "title",
              "data-testid": "gallery-title",
              innerHTML: e.slides[e.activeImageIdx].title
            }, null, 8, Pk)
          ])
        ], 2),
        e.slides.length > 1 ? (d(), f("div", Nk, [
          j(s, {
            theme: e.theme,
            "pager-number": e.slides.length,
            "active-image-idx": e.activeImageIdx,
            "play-slideshow": e.playSlideshow,
            "is-editing": n.isEditing,
            "hide-pager": e.screenSize < 600,
            onJumpTo: e.handleJump,
            onScrollLeft: e.handleScrollLeft,
            onScrollRight: e.handleScrollRight,
            onTogglePlay: e.togglePlay
          }, null, 8, ["theme", "pager-number", "active-image-idx", "play-slideshow", "is-editing", "hide-pager", "onJumpTo", "onScrollLeft", "onScrollRight", "onTogglePlay"])
        ])) : T("", !0)
      ])
    ], 4)
  ], 6);
}
const Fk = /* @__PURE__ */ B(Dk, [["render", Hk], ["__scopeId", "data-v-5e12fa68"]]), Rk = {
  name: "SvgReverse",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, Vk = ["fill"], Bk = ["stroke"];
function jk(e, t, n, r, o, i) {
  return d(), f("svg", {
    width: "46",
    height: "46",
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: Z({ backgroundColor: n.buttonBgColor.hex })
  }, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.88353 22.6238L8.11814 22.8624L7.57617 23.4133L19.2807 35.3118L20.6718 33.899L10.9346 23.9994H38.3765V21.9993H11.2035L20.6718 12.373L19.3191 10.998L7.88353 22.6238Z",
      fill: n.buttonIconColor.hex
    }, null, 8, Vk),
    c("path", {
      stroke: n.buttonBgColor.hex,
      d: "M0.5 0.5H45.5V45.5H0.5V0.5Z",
      fill: "black",
      "fill-opacity": "0.01"
    }, null, 8, Bk)
  ], 4);
}
const Uk = /* @__PURE__ */ B(Rk, [["render", jk]]), qk = {
  name: "SvgAdvance",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, Gk = ["fill"], Kk = ["stroke"];
function zk(e, t, n, r, o, i) {
  return d(), f("svg", {
    width: "46",
    height: "46",
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: Z({ backgroundColor: n.buttonBgColor.hex })
  }, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M38.361 22.6238L38.1264 22.8624L38.6684 23.4133L26.9641 35.3118L25.5731 33.899L35.3101 23.9994H7.86816V21.9993H35.0411L25.5731 12.373L26.9257 10.998L38.361 22.6238Z",
      fill: n.buttonIconColor.hex
    }, null, 8, Gk),
    c("path", {
      stroke: n.buttonBgColor.hex,
      d: "M0.5 0.5H45.5V45.5H0.5V0.5Z",
      fill: "black",
      "fill-opacity": "0.01"
    }, null, 8, Kk)
  ], 4);
}
const Zk = /* @__PURE__ */ B(qk, [["render", zk]]), xk = {
  name: "SvgPlayPause",
  props: {
    buttonBgColor: {
      type: Object,
      required: !0
    },
    buttonIconColor: {
      type: Object,
      required: !0
    },
    paused: Boolean
  }
}, Wk = ["stroke"], Yk = ["fill"], Xk = ["fill"];
function Qk(e, t, n, r, o, i) {
  return d(), f("svg", {
    width: "46",
    height: "46",
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: Z({ backgroundColor: n.buttonBgColor.hex })
  }, [
    c("path", {
      stroke: n.buttonBgColor.hex,
      d: "M0.5 0.5H45.5V45.4999H0.5V0.5Z",
      fill: "black",
      "fill-opacity": "0.01"
    }, null, 8, Wk),
    n.paused ? (d(), f("path", {
      key: 0,
      d: "M21 29L27 23L21 17V29Z",
      fill: n.buttonIconColor.hex
    }, null, 8, Yk)) : (d(), f("path", {
      key: 1,
      d: "M23 18H20V30H23V18ZM28 18H25V30H28V18Z",
      fill: n.buttonIconColor.hex,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd"
    }, null, 8, Xk))
  ], 4);
}
const Jk = /* @__PURE__ */ B(xk, [["render", Qk]]), eE = {
  name: "G6Buttons",
  components: { ReverseSvg: Uk, AdvanceSvg: Zk, PlayPauseSvg: Jk },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    pagerNumber: {
      type: Number,
      default: 0
    },
    activeImageIdx: {
      type: Number,
      default: 0
    },
    hidePager: Boolean,
    playSlideshow: Boolean,
    isEditing: Boolean
  },
  computed: {
    cssVars() {
      return {
        "--gallery-button-color": $(this.theme, "button_icon_color.hex", "#FFFFFF"),
        "--gallery-button-bg-color": $(this.theme, "button_bg_color.hex", "#333333"),
        "--gallery-pager-color": $(this.theme, "pager_color.hex", "#333333"),
        "--gallery-pager-active-color": $(this.theme, "pager_active_color.hex", "#0000FF")
      };
    }
  }
}, tE = ["aria-label", "data-testid", "disabled"], nE = {
  key: 0,
  class: "gallery-pager"
}, rE = ["aria-label", "aria-current", "onClick"];
function oE(e, t, n, r, o, i) {
  const a = V("PlayPauseSvg"), s = V("ReverseSvg"), l = V("AdvanceSvg");
  return d(), f("div", {
    style: Z(i.cssVars),
    class: _(["gallery-button-wrapper"])
  }, [
    c("div", {
      class: _(["gallery-buttons", { hasWidget: n.theme.cta_widget }])
    }, [
      c("button", {
        style: { order: 2 },
        "aria-label": n.playSlideshow ? "Pause Gallery" : "Play Gallery",
        "data-testid": n.playSlideshow ? "pause-button" : "play-button ",
        class: "pause-play-button",
        disabled: n.isEditing,
        onClick: t[0] || (t[0] = (u) => e.$emit("togglePlay")),
        onKeydown: t[1] || (t[1] = K(W((u) => e.$emit("togglePlay"), ["exact", "prevent"]), ["enter"]))
      }, [
        j(a, {
          "button-bg-color": n.theme.button_bg_color,
          "button-icon-color": n.theme.button_icon_color,
          paused: !n.playSlideshow
        }, null, 8, ["button-bg-color", "button-icon-color", "paused"])
      ], 40, tE),
      c("button", {
        "aria-label": "Previous Image",
        "data-testid": "gallery-left-button",
        style: { order: 1 },
        onClick: t[2] || (t[2] = (u) => e.$emit("scrollLeft")),
        onKeydown: t[3] || (t[3] = K(W((u) => e.$emit("scrollLeft"), ["exact", "prevent"]), ["enter"]))
      }, [
        j(s, {
          "button-bg-color": n.theme.button_bg_color,
          "button-icon-color": n.theme.button_icon_color
        }, null, 8, ["button-bg-color", "button-icon-color"])
      ], 32),
      c("button", {
        "aria-label": "Next Image",
        "data-testid": "gallery-right-button",
        style: { order: 3 },
        onClick: t[4] || (t[4] = (u) => e.$emit("scrollRight")),
        onKeydown: t[5] || (t[5] = K(W((u) => e.$emit("scrollRight"), ["exact", "prevent"]), ["enter"]))
      }, [
        j(l, {
          "button-bg-color": n.theme.button_bg_color,
          "button-icon-color": n.theme.button_icon_color
        }, null, 8, ["button-bg-color", "button-icon-color"])
      ], 32)
    ], 2),
    n.hidePager ? T("", !0) : (d(), f("div", nE, [
      (d(!0), f(J, null, ne(n.pagerNumber, (u, m) => (d(), f("button", {
        key: u,
        class: _({ active: n.activeImageIdx === m }),
        "aria-label": `Image ${m + 1}`,
        "aria-current": n.activeImageIdx === m ? "active" : null,
        "data-testid": "gallery-pager-button",
        onClick: (v) => e.$emit("jumpTo", m)
      }, [
        c("span", null, k(u), 1),
        t[6] || (t[6] = c("div", { class: "pager-bottom" }, null, -1))
      ], 10, rE))), 128))
    ]))
  ], 4);
}
const iE = /* @__PURE__ */ B(eE, [["render", oE], ["__scopeId", "data-v-b6c5f932"]]), sE = {
  name: "G6",
  components: {
    ResponsiveImage: Kr,
    G6Buttons: iE
  },
  mixins: [xn],
  props: {
    isEditing: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    displayWidget() {
      return this.theme.cta_widget && (!qr(this.widget) || this.isEditing);
    },
    cssVars() {
      var e, t;
      return {
        "--gallery-heading-color": $(this.theme, "heading_color.hex", "#fff"),
        "--gallery-link-color": $(this.theme, "link_color.hex", "#fff"),
        "--gradient-color": `radial-gradient( ${(t = (e = this.theme) == null ? void 0 : e.overlay_color) == null ? void 0 : t.hex}, rgba(255, 255, 255, 0) 75%)`,
        "--widget-line-color": $(this.theme, "widget_line_color.hex", "#B9770E"),
        "--widget-background-color": $(this.theme, "widget_background_color.hex", "#fff"),
        "--widget-text-color": $(this.theme, "widget_text_color.hex", "#000000"),
        "--widget-button-icon-color": $(this.theme, "widget_button_icon_color.hex", "#fff"),
        "--widget-button-background-color": $(this.theme, "widget_button_background_color.hex", "#B9770E")
      };
    },
    widgetLinkName() {
      var e, t;
      return (t = (e = this.widget) == null ? void 0 : e.link) != null && t.name ? this.widget.link.name : this.widgetLinkHref;
    },
    widgetBody() {
      var e;
      return ((e = this.widget) == null ? void 0 : e.body) || "";
    },
    widgetLinkHref() {
      var e, t;
      return ((t = (e = this.widget) == null ? void 0 : e.link) == null ? void 0 : t.href) || "";
    },
    widgetLinkTarget() {
      var e, t;
      return ((t = (e = this.widget) == null ? void 0 : e.link) == null ? void 0 : t.target) || "_blank";
    }
  }
}, aE = { class: "slide" }, lE = ["innerHTML"], uE = {
  key: 0,
  class: "main-content-button"
}, dE = { class: "slide-wrapper" }, cE = {
  key: 0,
  class: "widget",
  "data-testid": "cta-widget"
}, hE = ["innerHTML"];
function mE(e, t, n, r, o, i) {
  const a = V("G6Buttons"), s = V("responsive-image"), l = ze("touch");
  return d(), f("div", {
    class: "g6",
    "data-testid": "G6",
    style: Z([i.cssVars, e.imageHeight, e.bgColor])
  }, [
    c("div", aE, [
      c("div", {
        class: _(["main-content", { "has-widget": e.theme.cta_widget }])
      }, [
        c("div", {
          class: _([
            e.slides[e.activeImageIdx].title ? "main-content-title" : "main-content-title-empty",
            "left-text",
            e.theme.style
          ])
        }, [
          M(e.$slots, "title", {}, () => [
            c("div", {
              class: "title",
              "data-testid": "gallery-title",
              innerHTML: e.slides[e.activeImageIdx].title
            }, null, 8, lE)
          ])
        ], 2),
        e.slides.length > 1 ? (d(), f("div", uE, [
          j(a, {
            theme: e.theme,
            "pager-number": e.slides.length,
            "active-image-idx": e.activeImageIdx,
            "hide-pager": e.screenSize < 600,
            "play-slideshow": e.playSlideshow,
            "is-editing": n.isEditing,
            onJumpTo: e.handleJump,
            onScrollLeft: e.handleScrollLeft,
            onScrollRight: e.handleScrollRight,
            onTogglePlay: e.togglePlay
          }, null, 8, ["theme", "pager-number", "active-image-idx", "hide-pager", "play-slideshow", "is-editing", "onJumpTo", "onScrollLeft", "onScrollRight", "onTogglePlay"])
        ])) : T("", !0)
      ], 2),
      c("div", dE, [
        i.displayWidget ? (d(), f("div", cE, [
          M(e.$slots, "widget", {}, () => [
            c("div", {
              class: _(["widget-body", e.theme.style]),
              "data-testid": "cta-widget-body",
              innerHTML: i.widgetBody
            }, null, 10, hE)
          ]),
          (d(), L(Y(n.isEditing ? "button" : "a"), {
            class: "widget-button",
            "aria-label": i.widgetLinkName,
            href: i.widgetLinkHref,
            target: i.widgetLinkTarget,
            "data-testid": "cta-widget-button",
            onClick: t[0] || (t[0] = (u) => e.$emit("openLinkModal"))
          }, {
            default: S(() => t[1] || (t[1] = [
              c("svg", {
                width: "15",
                height: "12",
                viewBox: "0 0 15 12",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                c("path", {
                  d: "M14 6H1M14 6L9.21053 1M14 6L9.21053 11",
                  stroke: "var(--widget-button-icon-color)",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                })
              ], -1)
            ])),
            _: 1,
            __: [1]
          }, 8, ["aria-label", "href", "target"]))
        ])) : T("", !0),
        t[2] || (t[2] = c("div", { class: "gallery-decoration" }, [
          c("div", { class: "gallery-decoration-left" }),
          c("div", { class: "gallery-decoration-right" })
        ], -1)),
        M(e.$slots, "controls"),
        M(e.$slots, "image", {}, () => [
          we((d(), L(Zn, {
            tag: "div",
            class: "image",
            name: e.currentTransition,
            "data-testid": "gallery-transition-group"
          }, {
            default: S(() => [
              (d(), L(s, {
                key: e.activeImageIdx,
                idx: e.activeImageIdx,
                class: "responsive-image",
                "data-testid": "gallery-image",
                image: e.slides[e.activeImageIdx],
                "alt-text": e.slides[e.activeImageIdx].alt_text
              }, null, 8, ["idx", "image", "alt-text"]))
            ]),
            _: 1
          }, 8, ["name"])), [
            [
              l,
              e.moveForward,
              "swipe",
              { left: !0 }
            ],
            [
              l,
              e.moveBack,
              "swipe",
              { right: !0 }
            ]
          ])
        ])
      ])
    ])
  ], 4);
}
const fE = /* @__PURE__ */ B(sE, [["render", mE], ["__scopeId", "data-v-c1112145"]]), pE = {
  name: "PauseSvg",
  props: {
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, gE = {
  viewBox: "0 0 64 64",
  "aria-hidden": "true"
}, vE = { id: "Layer_1" }, bE = ["fill"], yE = ["fill"];
function _E(e, t, n, r, o, i) {
  return d(), f("svg", gE, [
    c("g", null, [
      c("g", vE, [
        c("g", null, [
          c("rect", {
            x: "26",
            y: "24",
            width: "3",
            height: "16",
            fill: n.buttonIconColor.hex
          }, null, 8, bE),
          c("rect", {
            x: "34",
            y: "24",
            width: "3",
            height: "16",
            fill: n.buttonIconColor.hex
          }, null, 8, yE)
        ])
      ])
    ])
  ]);
}
const CE = /* @__PURE__ */ B(pE, [["render", _E]]), wE = {
  name: "PlaySVG",
  props: {
    buttonIconColor: {
      type: Object,
      required: !0
    }
  }
}, TE = {
  viewBox: "0 0 64 64",
  "aria-hidden": "true"
}, kE = ["fill"];
function EE(e, t, n, r, o, i) {
  return d(), f("svg", TE, [
    c("g", null, [
      c("g", null, [
        c("path", {
          d: "M26,39.8l11-8-11-8v16Z",
          fill: n.buttonIconColor.hex
        }, null, 8, kE)
      ])
    ])
  ]);
}
const SE = /* @__PURE__ */ B(wE, [["render", EE]]), ME = {
  name: "ArrowSvg",
  props: {
    buttonIconColor: {
      type: Object,
      required: !0
    },
    forward: {
      type: Boolean,
      default: !1
    }
  }
}, AE = {
  id: "Layer_11",
  "data-name": "Layer_1"
}, IE = ["fill"];
function LE(e, t, n, r, o, i) {
  return d(), f("svg", {
    id: "Layer_1",
    class: _({ forward: n.forward }),
    xmlns: "http://www.w3.org/2000/svg",
    width: "64",
    height: "64",
    version: "1.1",
    viewBox: "0 0 64 64",
    "aria-hidden": "true"
  }, [
    c("g", AE, [
      c("polygon", {
        fill: n.buttonIconColor.hex,
        points: "25.5 38.5 19 32 25.5 25.5 26.5 26.5 21.8 31.2 44 31.2 44 32.8 21.8 32.8 26.5 37.5 25.5 38.5"
      }, null, 8, IE)
    ])
  ], 2);
}
const DE = /* @__PURE__ */ B(ME, [["render", LE], ["__scopeId", "data-v-ccc04a6e"]]), $E = {
  name: "G7",
  components: {
    PauseSvg: CE,
    PlaySvg: SE,
    ArrowSvg: DE,
    ResponsiveImage: Kr
  },
  mixins: [xn],
  props: {
    isEditing: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["openLinkModal"],
  data() {
    return {
      headerHeight: 0
    };
  },
  computed: {
    titleText() {
      var e, t;
      return ((t = (e = this.slides) == null ? void 0 : e[this.activeImageIdx]) == null ? void 0 : t.title) || "";
    },
    descriptionText() {
      var e, t;
      return ((t = (e = this.slides) == null ? void 0 : e[this.activeImageIdx]) == null ? void 0 : t.content) || "";
    },
    link() {
      var e, t;
      return ((t = (e = this.slides) == null ? void 0 : e[this.activeImageIdx]) == null ? void 0 : t.href) || "";
    },
    linkName() {
      var e, t;
      return ((t = (e = this.slides) == null ? void 0 : e[this.activeImageIdx]) == null ? void 0 : t.name) || "";
    },
    linkTarget() {
      var e, t;
      return ((t = (e = this.slides) == null ? void 0 : e[this.activeImageIdx]) == null ? void 0 : t.target) || "";
    },
    arrowsVisible() {
      return this.slides.length > 1 && !this.theme.hasFloatingNav;
    },
    videoAltText() {
      var e, t;
      return ((t = (e = this.slides) == null ? void 0 : e[0]) == null ? void 0 : t.alt_text) || "";
    },
    videoUrl() {
      var e, t;
      return ((t = (e = this.slides) == null ? void 0 : e[0]) == null ? void 0 : t.url) || "";
    },
    isPlaying() {
      return this.theme.use_video ? this.playVideo : this.playSlideshow;
    },
    displayButton() {
      return this.theme.use_video || !this.theme.use_video && this.slides.length > 1;
    },
    colors() {
      var e, t, n, r, o, i, a, s, l, u, m, v, g, h, E, C, A, R, P, F, I, D, O, U, q, z, te, ee;
      return {
        "--image-height": `calc(100vh - ${this.headerHeight}px)`,
        "--image-brightness": `${(t = (e = this.theme) == null ? void 0 : e.image_brightness) != null ? t : 60}%`,
        "--bg-color": ((r = (n = this.theme) == null ? void 0 : n.bg_color) == null ? void 0 : r.hex) || "",
        "--heading-color": ((i = (o = this.theme) == null ? void 0 : o.heading_color) == null ? void 0 : i.hex) || "",
        "--text-color": ((s = (a = this.theme) == null ? void 0 : a.text_color) == null ? void 0 : s.hex) || "",
        "--button-text-color": ((u = (l = this.theme) == null ? void 0 : l.widget_button_text_color) == null ? void 0 : u.hex) || "",
        "--button-bg-color": ((v = (m = this.theme) == null ? void 0 : m.widget_button_background_color) == null ? void 0 : v.hex) || "",
        "--button-bg-hover-color": ((h = (g = this.theme) == null ? void 0 : g.widget_button_background_hover_color) == null ? void 0 : h.hex) || "",
        "--pager-border-color": ((C = (E = this.theme) == null ? void 0 : E.pager_border_color) == null ? void 0 : C.hex) || "",
        "--pager-active-color": ((R = (A = this.theme) == null ? void 0 : A.pager_active_color) == null ? void 0 : R.hex) || "",
        "--play-pause-border-color": ((F = (P = this.theme) == null ? void 0 : P.button_border_color) == null ? void 0 : F.hex) || "",
        "--play-pause-border-hover-color": ((D = (I = this.theme) == null ? void 0 : I.button_border_hover_color) == null ? void 0 : D.hex) || "",
        "--play-pause-icon-color": ((U = (O = this.theme) == null ? void 0 : O.button_icon_color) == null ? void 0 : U.hex) || "",
        "--play-pause-icon-hover-color": ((z = (q = this.theme) == null ? void 0 : q.button_icon_hover_color) == null ? void 0 : z.hex) || "",
        "--play-pause-hover-color": ((ee = (te = this.theme) == null ? void 0 : te.button_hover_color) == null ? void 0 : ee.hex) || ""
      };
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.isPreview || this.isEditing) return;
      const e = document.getElementById("cms-header");
      if (!e) return;
      window.getComputedStyle(e).position !== "absolute" && (this.headerHeight = e.offsetHeight);
    });
  },
  methods: {
    handleClick() {
      if (!this.isPreview) {
        if (this.isEditing) {
          this.$emit("openLinkModal");
          return;
        }
        this.link && window.open(this.link, this.linkTarget || "_self");
      }
    }
  }
}, OE = {
  ref: "galleryContainer",
  class: "gallery-container"
}, PE = {
  key: 1,
  class: "video-wrapper"
}, NE = ["aria-label", "src"], HE = { class: "gallery-content" }, FE = ["innerHTML"], RE = ["innerHTML"], VE = {
  key: 2,
  ref: "link",
  class: "button-link"
}, BE = ["aria-label"], jE = {
  key: 0,
  class: "gallery-controls"
}, UE = {
  key: 2,
  class: "pager"
}, qE = ["aria-current", "aria-label", "onClick"];
function GE(e, t, n, r, o, i) {
  const a = V("responsive-image"), s = V("PauseSvg"), l = V("PlaySvg"), u = V("ArrowSvg"), m = ze("touch");
  return d(), f("div", {
    id: "G7",
    class: _(["gallery-v7", { "is-editing": n.isEditing }]),
    style: Z([e.linkStyle, i.colors])
  }, [
    c("div", OE, [
      M(e.$slots, "controls", {}, void 0, !0),
      M(e.$slots, "image", {}, () => [
        e.theme.use_video ? T("", !0) : we((d(), L(Zn, {
          key: 0,
          class: "image-wrapper",
          tag: "div",
          name: e.currentTransition,
          "data-testid": "gallery-transition-group"
        }, {
          default: S(() => [
            (d(), L(a, {
              key: e.activeImageIdx,
              idx: e.activeImageIdx,
              class: "responsive-image",
              "data-testid": "gallery-image",
              image: e.slides[e.activeImageIdx]
            }, null, 8, ["idx", "image"]))
          ]),
          _: 1
        }, 8, ["name"])), [
          [
            m,
            e.moveForward,
            "swipe",
            { left: !0 }
          ],
          [
            m,
            e.moveBack,
            "swipe",
            { right: !0 }
          ]
        ]),
        e.theme.use_video ? (d(), f("div", PE, [
          c("video", {
            ref: "videoPlayer",
            "aria-label": i.videoAltText,
            src: i.videoUrl,
            class: "video",
            autoplay: "",
            muted: "",
            loop: "",
            playsinline: "",
            "data-testid": "gallery-video"
          }, " Your browser does not support videos. ", 8, NE)
        ])) : T("", !0)
      ], !0),
      c("div", HE, [
        i.titleText || n.isEditing ? (d(), f("div", {
          key: 0,
          class: _(["title", e.theme.style]),
          "data-testid": "gallery-title"
        }, [
          M(e.$slots, "title", {}, () => [
            c("div", {
              ref: "title",
              tabindex: "0",
              innerHTML: i.titleText
            }, null, 8, FE)
          ], !0)
        ], 2)) : T("", !0),
        i.descriptionText || n.isEditing ? (d(), f("div", {
          key: 1,
          class: _(["description", e.theme.style])
        }, [
          M(e.$slots, "description", {}, () => [
            c("div", {
              ref: "description",
              tabindex: "0",
              innerHTML: i.descriptionText
            }, null, 8, RE)
          ], !0)
        ], 2)) : T("", !0),
        i.link || n.isEditing ? (d(), f("div", VE, [
          c("button", {
            type: "button",
            "aria-label": `Link to ${i.linkName}`,
            onClick: t[0] || (t[0] = (...v) => i.handleClick && i.handleClick(...v))
          }, [
            M(e.$slots, "link", {}, () => [
              H(k(i.linkName), 1)
            ], !0)
          ], 8, BE)
        ], 512)) : T("", !0)
      ]),
      n.isEditing ? T("", !0) : (d(), f("div", jE, [
        i.displayButton ? (d(), f("button", {
          key: 0,
          "aria-label": "Play Pause Gallery",
          "data-testid": "pause-button",
          class: "pause button",
          onClick: t[1] || (t[1] = (v) => e.theme.use_video ? e.toggleVideoPlay() : e.togglePlay())
        }, [
          i.isPlaying ? (d(), L(s, {
            key: 0,
            "button-icon-color": e.theme.button_icon_color
          }, null, 8, ["button-icon-color"])) : (d(), L(l, {
            key: 1,
            "button-icon-color": e.theme.button_icon_color
          }, null, 8, ["button-icon-color"]))
        ])) : T("", !0),
        i.arrowsVisible ? (d(), f("button", {
          key: 1,
          class: "left-arrow button",
          "data-testid": "gallery-left-button",
          "aria-label": "Previous Image",
          onClick: t[2] || (t[2] = (...v) => e.moveBack && e.moveBack(...v))
        }, [
          j(u, {
            "button-icon-color": e.theme.pager_arrow_color
          }, null, 8, ["button-icon-color"])
        ])) : T("", !0),
        e.slides.length > 1 ? (d(), f("div", UE, [
          (d(!0), f(J, null, ne(e.slides, (v, g) => (d(), f("button", {
            key: v.url,
            class: _(["item", { active: e.activeImageIdx === g }]),
            "aria-current": e.activeImageIdx === g ? "active" : null,
            "aria-label": `Image ${g + 1}`,
            "data-testid": "gallery-pager-button",
            onClick: (h) => e.jump(g)
          }, null, 10, qE))), 128))
        ])) : T("", !0),
        i.arrowsVisible ? (d(), f("button", {
          key: 3,
          class: "right-arrow button",
          "data-testid": "gallery-right-button",
          "aria-label": "Next Image",
          onClick: t[3] || (t[3] = (...v) => e.moveForward && e.moveForward(...v))
        }, [
          j(u, {
            forward: "",
            "button-icon-color": e.theme.pager_arrow_color
          }, null, 8, ["button-icon-color"])
        ])) : T("", !0)
      ]))
    ], 512)
  ], 6);
}
const KE = /* @__PURE__ */ B($E, [["render", GE], ["__scopeId", "data-v-aa32b36f"]]), zE = {
  name: "CmsGallery",
  components: {
    G1: bC,
    G2: iw,
    G3: Ww,
    G4: HT,
    G5: Fk,
    G6: fE,
    G7: KE
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    gallery: {
      type: Object,
      default: () => ({})
    },
    isPreview: Boolean,
    isIFrame: Boolean,
    isEditing: Boolean
  },
  computed: {
    skipButtonText() {
      var e, t;
      return ((t = (e = this.theme) == null ? void 0 : e.translations) == null ? void 0 : t.skipButtonText) || "Skip Gallery";
    },
    galleryEndText() {
      var e, t;
      return ((t = (e = this.theme) == null ? void 0 : e.translations) == null ? void 0 : t.galleryEndText) || "End of Gallery";
    }
  },
  methods: {
    jumpTo(e) {
      this.$emit("jumpTo", e);
    },
    focusEnd() {
      this.$refs.galleryEnd.focus();
    }
  }
}, ZE = { id: "cms-gallery" };
function xE(e, t, n, r, o, i) {
  return d(), f("div", ZE, [
    c("button", {
      class: "skip-button",
      type: "button",
      tabindex: "0",
      onKeydown: t[0] || (t[0] = K(W((...a) => i.focusEnd && i.focusEnd(...a), ["exact", "prevent"]), ["enter"]))
    }, k(i.skipButtonText), 33),
    (d(), L(Y(n.theme.version), {
      theme: n.theme,
      gallery: n.gallery,
      "is-preview": n.isPreview,
      "is-iframe": n.isIFrame,
      "is-editing": n.isEditing,
      onScrollLeft: t[1] || (t[1] = (a) => e.$emit("scrollLeft")),
      onScrollRight: t[2] || (t[2] = (a) => e.$emit("scrollRight")),
      onJumpTo: i.jumpTo,
      onOpenLinkModal: t[3] || (t[3] = (a) => e.$emit("openLinkModal"))
    }, {
      widget: S(({ widget: a }) => [
        M(e.$slots, "widget", { widget: a }, void 0, !0)
      ]),
      controls: S(({ controls: a }) => [
        M(e.$slots, "controls", { controls: a }, void 0, !0)
      ]),
      image: S(({ image: a }) => [
        M(e.$slots, "image", { image: a }, void 0, !0)
      ]),
      title: S(({ title: a }) => [
        M(e.$slots, "title", { title: a }, void 0, !0)
      ]),
      description: S(({ description: a }) => [
        M(e.$slots, "description", { description: a }, void 0, !0)
      ]),
      link: S(({ link: a }) => [
        M(e.$slots, "link", { link: a }, void 0, !0)
      ]),
      _: 3
    }, 40, ["theme", "gallery", "is-preview", "is-iframe", "is-editing", "onJumpTo"])),
    c("div", {
      ref: "galleryEnd",
      class: "gallery-end",
      tabindex: "-1"
    }, k(i.galleryEndText), 513)
  ]);
}
const WE = /* @__PURE__ */ B(zE, [["render", xE], ["__scopeId", "data-v-0316ae22"]]), T4 = function() {
  return document.ontouchstart !== null ? "click" : "touchstart";
}, ps = "__vue_click_away__", k4 = function(e, t, n) {
  E4(e);
  let r = n.context, o = t.value, i = !1;
  setTimeout(function() {
    i = !0;
  }, 0), e[ps] = function(a) {
    if ((!e || !e.contains(a.target)) && o && i && typeof o == "function")
      return o.call(r, a);
  }, document.addEventListener(T4(), e[ps], !1);
}, E4 = function(e) {
  document.removeEventListener(T4(), e[ps], !1), delete e[ps];
}, YE = function(e, t, n) {
  t.value !== t.oldValue && k4(e, t, n);
}, XE = {
  mounted: k4,
  updated: YE,
  unmounted: E4
}, Et = {
  directives: {
    ClickAway: XE
  }
}, QE = {
  name: "HamburgerIcon",
  props: {
    themeStyle: {
      type: String,
      default: null
    },
    fillColor: {
      type: String,
      default: "#000"
    },
    fillPathColor: {
      type: String,
      default: "#fff"
    },
    rx: {
      type: [String, Number],
      default: null
    }
  }
}, JE = { "clip-path": "url(#clip0)" }, eS = ["fill", "rx"], tS = ["fill"];
function nS(e, t, n, r, o, i) {
  return d(), f("svg", {
    class: _(n.themeStyle),
    fill: "#fff",
    width: "23",
    height: "23",
    viewBox: "0 0 23 23",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true"
  }, [
    c("g", JE, [
      c("rect", {
        fill: n.fillColor,
        rx: n.rx,
        width: "23",
        height: "23"
      }, null, 8, eS),
      c("path", {
        fill: n.fillPathColor,
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M6.00195 7H17V8H6.00195V7ZM6.00195 11H17V12H6.00195V11ZM17 15H6.00195V16H17V15Z"
      }, null, 8, tS)
    ]),
    t[0] || (t[0] = c("defs", null, [
      c("clipPath", { id: "clip0" }, [
        c("rect", {
          width: "23",
          height: "23",
          fill: "#fff"
        })
      ])
    ], -1))
  ], 2);
}
const $0 = /* @__PURE__ */ B(QE, [["render", nS]]), rS = {
  name: "PlusIcon",
  props: {
    fillColor: {
      type: String,
      default: "#000"
    },
    fillPathColor: {
      type: String,
      default: "#fff"
    },
    rx: {
      type: [String, Number],
      default: null
    }
  }
}, oS = {
  width: "23",
  height: "23",
  viewBox: "0 0 23 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
}, iS = ["fill", "rx"], sS = ["fill"], aS = ["fill"];
function lS(e, t, n, r, o, i) {
  return d(), f("svg", oS, [
    c("rect", {
      fill: n.fillColor,
      rx: n.rx,
      width: "23",
      height: "23"
    }, null, 8, iS),
    c("path", {
      fill: n.fillPathColor,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M11 18L11 5L12 5L12 18L11 18Z"
    }, null, 8, sS),
    c("path", {
      fill: n.fillPathColor,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M5 11L18 11L18 12L5 12L5 11Z"
    }, null, 8, aS)
  ]);
}
const O0 = /* @__PURE__ */ B(rS, [["render", lS]]), uS = {
  name: "MenuSearchIcon",
  props: {
    iconColor: {
      type: String,
      default: "#fff"
    }
  }
}, dS = ["fill"];
function cS(e, t, n, r, o, i) {
  return d(), f("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: n.iconColor,
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    "data-cy": "search-icon"
  }, t[0] || (t[0] = [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M9.03661 17.8C13.362 17.8 16.8683 14.3078 16.8683 10C16.8683 5.69218 13.362 2.2 9.03661 2.2C4.71127 2.2 1.20488 5.69218 1.20488 10C1.20488 14.3078 4.71127 17.8 9.03661 17.8ZM9.03661 19C14.0274 19 18.0732 14.9706 18.0732 10C18.0732 5.02944 14.0274 1 9.03661 1C4.04583 1 0 5.02944 0 10C0 14.9706 4.04583 19 9.03661 19Z"
    }, null, -1),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M23.3011 24L15.1138 16.1179L15.8128 15.3968L24.0001 23.2789L23.3011 24Z"
    }, null, -1)
  ]), 8, dS);
}
const hS = /* @__PURE__ */ B(uS, [["render", cS]]), mS = {
  props: {
    fillColor: {
      type: String,
      default: "#000"
    }
  }
}, fS = {
  width: "22",
  height: "22",
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, pS = ["fill"], gS = ["fill"];
function vS(e, t, n, r, o, i) {
  return d(), f("svg", fS, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12.9503 17.7175L11.5 19.1679V15.875H14.3893C13.996 16.5319 13.5163 17.1516 12.9503 17.7175ZM18.5666 15.875C17.1619 18.0508 14.8443 19.5819 12.1556 19.9265L13.6575 18.4247C14.4285 17.6536 15.0546 16.7924 15.5357 15.875H18.5666ZM19.125 14.875H15.9945C16.4244 13.7905 16.6666 12.6489 16.721 11.5H19.9863C19.9204 12.7035 19.6181 13.844 19.125 14.8758V14.875ZM11.5 11.5H15.7198C15.6593 12.6546 15.3892 13.8002 14.9094 14.875H11.5V11.5ZM11.5 10.5H15.7198C15.6593 9.34543 15.3892 8.19979 14.9094 7.125H11.5V10.5ZM19.9863 10.5H16.721C16.6666 9.35113 16.4244 8.20949 15.9945 7.125H19.125V7.12417C19.6181 8.15604 19.9204 9.29654 19.9863 10.5ZM18.5666 6.125H15.5357C15.0546 5.20762 14.4285 4.34646 13.6574 3.57538L12.1555 2.07349C14.8443 2.41811 17.1619 3.9492 18.5666 6.125ZM11.5 6.125H14.3892C13.996 5.46809 13.5163 4.84847 12.9503 4.28249L11.5 2.83217V6.125ZM10.5 19.1679V15.875H7.61071C8.00401 16.5319 8.48364 17.1515 9.04962 17.7175L10.5 19.1679ZM9.84439 19.9265C7.15566 19.5819 4.83807 18.0508 3.43337 15.875H6.46427C6.94536 16.7924 7.57144 17.6535 8.34252 18.4246L9.84439 19.9265ZM7.09055 14.875H10.5V11.5H6.28022C6.3407 12.6546 6.61081 13.8002 7.09055 14.875ZM5.27898 11.5C5.33341 12.6489 5.57557 13.7905 6.00545 14.875H2.875V14.8758C2.38189 13.844 2.07955 12.7035 2.01365 11.5H5.27898ZM6.28022 10.5H10.5V7.125H7.09055C6.61081 8.19979 6.3407 9.34543 6.28022 10.5ZM6.00545 7.125C5.57556 8.20949 5.33341 9.35113 5.27898 10.5H2.01365C2.07955 9.29654 2.38189 8.15604 2.875 7.12417V7.125H6.00545ZM7.61071 6.125H10.5V2.83211L9.04962 4.28248C8.48364 4.84846 8.004 5.46809 7.61071 6.125ZM9.84439 2.0735L8.34251 3.57538C7.57144 4.34646 6.94536 5.20762 6.46427 6.125H3.43337C4.83807 3.94922 7.15566 2.41814 9.84439 2.0735ZM11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z",
      fill: n.fillColor
    }, null, 8, pS),
    c("path", {
      fill: n.fillColor,
      d: "M11.5 19.1679H11.35V19.53L11.6061 19.274L11.5 19.1679ZM11.5 15.875V15.725H11.35V15.875H11.5ZM14.3893 15.875L14.518 15.9521L14.6539 15.725H14.3893V15.875ZM12.1556 19.9265L12.0495 19.8204L11.7388 20.1311L12.1747 20.0753L12.1556 19.9265ZM18.5666 15.875L18.6926 15.9564L18.842 15.725H18.5666V15.875ZM15.5357 15.875V15.725H15.445L15.4029 15.8053L15.5357 15.875ZM15.9945 14.875L15.8551 14.8197L15.7737 15.025H15.9945V14.875ZM19.125 14.875H19.275V14.725H19.125V14.875ZM16.721 11.5V11.35H16.5779L16.5712 11.4929L16.721 11.5ZM19.9863 11.5L20.1361 11.5082L20.1448 11.35H19.9863V11.5ZM19.125 14.8758H18.975L19.2603 14.9405L19.125 14.8758ZM15.7198 11.5L15.8695 11.5078L15.8778 11.35H15.7198V11.5ZM11.5 11.5V11.35H11.35V11.5H11.5ZM14.9094 14.875V15.025H15.0067L15.0464 14.9361L14.9094 14.875ZM11.5 14.875H11.35V15.025H11.5V14.875ZM15.7198 10.5V10.65H15.8778L15.8695 10.4922L15.7198 10.5ZM11.5 10.5H11.35V10.65H11.5V10.5ZM14.9094 7.125L15.0464 7.06386L15.0067 6.975H14.9094V7.125ZM11.5 7.125V6.975H11.35V7.125H11.5ZM16.721 10.5L16.5712 10.5071L16.5779 10.65H16.721V10.5ZM19.9863 10.5V10.65H20.1448L20.1361 10.4918L19.9863 10.5ZM15.9945 7.125V6.975H15.7737L15.8551 7.18027L15.9945 7.125ZM19.125 7.125V7.275H19.275V7.125H19.125ZM19.125 7.12417L19.2603 7.0595L18.975 7.12417H19.125ZM15.5357 6.125L15.4028 6.19466L15.445 6.275H15.5357V6.125ZM18.5666 6.125V6.275H18.842L18.6926 6.04364L18.5666 6.125ZM13.6574 3.57538L13.5514 3.68144L13.6574 3.57538ZM12.1555 2.07349L12.1746 1.92471L11.7388 1.86885L12.0495 2.17956L12.1555 2.07349ZM14.3892 6.125V6.275H14.6539L14.5179 6.04795L14.3892 6.125ZM11.5 6.125H11.35V6.275H11.5V6.125ZM12.9503 4.28249L12.8443 4.38855L12.9503 4.28249ZM11.5 2.83217L11.6061 2.7261L11.35 2.47004V2.83217H11.5ZM10.5 15.875H10.65V15.725H10.5V15.875ZM10.5 19.1679L10.3939 19.274L10.65 19.53V19.1679H10.5ZM7.61071 15.875V15.725H7.34608L7.48202 15.9521L7.61071 15.875ZM9.04962 17.7175L9.15569 17.6115L9.04962 17.7175ZM9.84439 19.9265L9.82532 20.0753L10.2612 20.1311L9.95046 19.8204L9.84439 19.9265ZM3.43337 15.875V15.725H3.15798L3.30735 15.9564L3.43337 15.875ZM6.46427 15.875L6.59711 15.8053L6.55499 15.725H6.46427V15.875ZM8.34252 18.4246L8.44858 18.3186L8.34252 18.4246ZM7.09055 14.875L6.95358 14.9361L6.99324 15.025H7.09055V14.875ZM10.5 14.875V15.025H10.65V14.875H10.5ZM10.5 11.5H10.65V11.35H10.5V11.5ZM6.28022 11.5V11.35H6.12216L6.13043 11.5078L6.28022 11.5ZM5.27898 11.5L5.42881 11.4929L5.42204 11.35H5.27898V11.5ZM6.00545 14.875V15.025H6.22626L6.14489 14.8197L6.00545 14.875ZM2.875 14.875V14.725H2.725V14.875H2.875ZM2.875 14.8758L2.73966 14.9405L3.025 14.8758H2.875ZM2.01365 11.5V11.35H1.85522L1.86388 11.5082L2.01365 11.5ZM6.28022 10.5L6.13043 10.4922L6.12216 10.65H6.28022V10.5ZM10.5 10.5V10.65H10.65V10.5H10.5ZM10.5 7.125H10.65V6.975H10.5V7.125ZM7.09055 7.125V6.975H6.99324L6.95358 7.06386L7.09055 7.125ZM6.00545 7.125L6.14489 7.18027L6.22626 6.975H6.00545V7.125ZM5.27898 10.5V10.65H5.42204L5.42881 10.5071L5.27898 10.5ZM2.01365 10.5L1.86388 10.4918L1.85522 10.65H2.01365V10.5ZM2.875 7.12417H3.025L2.73966 7.05949L2.875 7.12417ZM2.875 7.125H2.725V7.275H2.875V7.125ZM7.61071 6.125L7.48201 6.04795L7.34608 6.275H7.61071V6.125ZM10.5 6.125V6.275H10.65V6.125H10.5ZM10.5 2.83211H10.65V2.46997L10.3939 2.72604L10.5 2.83211ZM9.04962 4.28248L8.94356 4.17642H8.94356L9.04962 4.28248ZM9.84439 2.0735L9.95046 2.17957L10.2612 1.86885L9.82532 1.92472L9.84439 2.0735ZM8.34251 3.57538L8.44858 3.68144L8.34251 3.57538ZM6.46427 6.125V6.275H6.55499L6.59711 6.19466L6.46427 6.125ZM3.43337 6.125L3.30735 6.04364L3.15798 6.275H3.43337V6.125ZM11.6061 19.274L13.0564 17.8236L12.8443 17.6115L11.3939 19.0618L11.6061 19.274ZM11.35 15.875V19.1679H11.65V15.875H11.35ZM14.3893 15.725H11.5V16.025H14.3893V15.725ZM13.0564 17.8236C13.6312 17.2488 14.1184 16.6194 14.518 15.9521L14.2606 15.7979C13.8736 16.4444 13.4015 17.0543 12.8443 17.6115L13.0564 17.8236ZM12.1747 20.0753C14.9087 19.7248 17.2648 18.1681 18.6926 15.9564L18.4406 15.7936C17.0591 17.9335 14.78 19.4389 12.1365 19.7777L12.1747 20.0753ZM13.5514 18.3186L12.0495 19.8204L12.2617 20.0326L13.7635 18.5307L13.5514 18.3186ZM15.4029 15.8053C14.9287 16.7095 14.3116 17.5583 13.5514 18.3186L13.7635 18.5307C14.5454 17.7488 15.1805 16.8753 15.6686 15.9447L15.4029 15.8053ZM18.5666 15.725H15.5357V16.025H18.5666V15.725ZM15.9945 15.025H19.125V14.725H15.9945V15.025ZM16.5712 11.4929C16.5175 12.6255 16.2788 13.7508 15.8551 14.8197L16.134 14.9303C16.57 13.8302 16.8156 12.6723 16.8708 11.5071L16.5712 11.4929ZM19.9863 11.35H16.721V11.65H19.9863V11.35ZM19.2603 14.9405C19.7617 13.8913 20.0691 12.7316 20.1361 11.5082L19.8366 11.4918C19.7718 12.6753 19.4745 13.7966 18.9897 14.8112L19.2603 14.9405ZM18.975 14.875V14.8758H19.275V14.875H18.975ZM15.7198 11.35H11.5V11.65H15.7198V11.35ZM15.0464 14.9361C15.5338 13.8443 15.8081 12.6805 15.8695 11.5078L15.57 11.4922C15.5104 12.6286 15.2446 13.7562 14.7725 14.8139L15.0464 14.9361ZM11.5 15.025H14.9094V14.725H11.5V15.025ZM11.35 11.5V14.875H11.65V11.5H11.35ZM15.7198 10.35H11.5V10.65H15.7198V10.35ZM14.7724 7.18614C15.2446 8.24383 15.5104 9.37137 15.57 10.5078L15.8695 10.4922C15.8081 9.31948 15.5338 8.15574 15.0464 7.06386L14.7724 7.18614ZM11.5 7.275H14.9094V6.975H11.5V7.275ZM11.65 10.5V7.125H11.35V10.5H11.65ZM16.721 10.65H19.9863V10.35H16.721V10.65ZM15.8551 7.18027C16.2788 8.24918 16.5175 9.37452 16.5712 10.5071L16.8708 10.4929C16.8156 9.32773 16.57 8.1698 16.134 7.06973L15.8551 7.18027ZM19.125 6.975H15.9945V7.275H19.125V6.975ZM18.975 7.12417V7.125H19.275V7.12417H18.975ZM20.1361 10.4918C20.0691 9.26836 19.7617 8.10871 19.2603 7.0595L18.9897 7.18885C19.4745 8.20338 19.7718 9.32472 19.8366 10.5082L20.1361 10.4918ZM15.5357 6.275H18.5666V5.975H15.5357V6.275ZM13.5514 3.68144C14.3116 4.44169 14.9287 5.29055 15.4028 6.19466L15.6685 6.05534C15.1805 5.1247 14.5454 4.25122 13.7635 3.46931L13.5514 3.68144ZM12.0495 2.17956L13.5514 3.68144L13.7635 3.46931L12.2616 1.96742L12.0495 2.17956ZM18.6926 6.04364C17.2647 3.83192 14.9086 2.27513 12.1746 1.92471L12.1365 2.22227C14.78 2.56109 17.0591 4.06648 18.4406 6.20636L18.6926 6.04364ZM14.3892 5.975H11.5V6.275H14.3892V5.975ZM12.8443 4.38855C13.4015 4.94576 13.8735 5.55562 14.2606 6.20205L14.5179 6.04795C14.1184 5.38056 13.6312 4.75118 13.0564 4.17642L12.8443 4.38855ZM11.3939 2.93823L12.8443 4.38855L13.0564 4.17642L11.6061 2.7261L11.3939 2.93823ZM11.65 6.125V2.83217H11.35V6.125H11.65ZM10.35 15.875V19.1679H10.65V15.875H10.35ZM7.61071 16.025H10.5V15.725H7.61071V16.025ZM9.15569 17.6115C8.59848 17.0542 8.12643 16.4444 7.73941 15.7979L7.48202 15.9521C7.88158 16.6194 8.3688 17.2488 8.94356 17.8236L9.15569 17.6115ZM10.6061 19.0618L9.15569 17.6115L8.94356 17.8236L10.3939 19.274L10.6061 19.0618ZM9.86346 19.7777C7.21998 19.4389 4.9409 17.9335 3.55939 15.7936L3.30735 15.9564C4.73524 18.1681 7.09133 19.7248 9.82532 20.0753L9.86346 19.7777ZM3.43337 16.025H6.46427V15.725H3.43337V16.025ZM6.33143 15.9447C6.81947 16.8753 7.45454 17.7488 8.23645 18.5307L8.44858 18.3186C7.68834 17.5583 7.07124 16.7094 6.59711 15.8053L6.33143 15.9447ZM8.23645 18.5307L9.73833 20.0326L9.95046 19.8204L8.44858 18.3186L8.23645 18.5307ZM7.09055 15.025H10.5V14.725H7.09055V15.025ZM10.65 14.875V11.5H10.35V14.875H10.65ZM10.5 11.35H6.28022V11.65H10.5V11.35ZM7.22753 14.8139C6.75542 13.7562 6.48955 12.6286 6.43002 11.4922L6.13043 11.5078C6.19185 12.6805 6.46621 13.8443 6.95358 14.9361L7.22753 14.8139ZM5.12914 11.5071C5.18435 12.6723 5.42994 13.8302 5.866 14.9303L6.14489 14.8197C5.72119 13.7508 5.48247 12.6255 5.42881 11.4929L5.12914 11.5071ZM2.875 15.025H6.00545V14.725H2.875V15.025ZM3.025 14.8758V14.875H2.725V14.8758H3.025ZM1.86388 11.5082C1.93087 12.7316 2.23826 13.8913 2.73966 14.9405L3.01034 14.8112C2.52552 13.7966 2.22823 12.6753 2.16343 11.4918L1.86388 11.5082ZM5.27898 11.35H2.01365V11.65H5.27898V11.35ZM6.28022 10.65H10.5V10.35H6.28022V10.65ZM10.65 10.5V7.125H10.35V10.5H10.65ZM10.5 6.975H7.09055V7.275H10.5V6.975ZM6.43002 10.5078C6.48955 9.37137 6.75542 8.24383 7.22753 7.18614L6.95358 7.06386C6.4662 8.15575 6.19185 9.31948 6.13043 10.4922L6.43002 10.5078ZM5.866 7.06973C5.42994 8.1698 5.18435 9.32773 5.12914 10.4929L5.42881 10.5071C5.48247 9.37452 5.72119 8.24918 6.14489 7.18027L5.866 7.06973ZM2.01365 10.65H5.27898V10.35H2.01365V10.65ZM2.73966 7.05949C2.23826 8.10871 1.93087 9.26836 1.86388 10.4918L2.16343 10.5082C2.22823 9.32472 2.52552 8.20337 3.01034 7.18885L2.73966 7.05949ZM3.025 7.125V7.12417H2.725V7.125H3.025ZM6.00545 6.975H2.875V7.275H6.00545V6.975ZM7.61071 6.275H10.5V5.975H7.61071V6.275ZM10.65 6.125V2.83211H10.35V6.125H10.65ZM9.15569 4.38855L10.6061 2.93817L10.3939 2.72604L8.94356 4.17642L9.15569 4.38855ZM7.73941 6.20205C8.12643 5.55562 8.59848 4.94576 9.15569 4.38855L8.94356 4.17642C8.3688 4.75117 7.88158 5.38056 7.48201 6.04795L7.73941 6.20205ZM9.73833 1.96743L8.23645 3.46931L8.44858 3.68144L9.95046 2.17957L9.73833 1.96743ZM8.23645 3.46931C7.45454 4.25122 6.81947 5.1247 6.33143 6.05534L6.59711 6.19466C7.07124 5.29055 7.68834 4.44169 8.44858 3.68144L8.23645 3.46931ZM3.43337 6.275H6.46427V5.975H3.43337V6.275ZM9.82532 1.92472C7.09133 2.27516 4.73524 3.83194 3.30735 6.04364L3.55939 6.20636C4.9409 4.0665 7.21998 2.56112 9.86346 2.22228L9.82532 1.92472ZM20.85 11C20.85 16.44 16.44 20.85 11 20.85V21.15C16.6057 21.15 21.15 16.6057 21.15 11H20.85ZM11 1.15C16.44 1.15 20.85 5.56 20.85 11H21.15C21.15 5.39431 16.6057 0.85 11 0.85V1.15ZM1.15 11C1.15 5.56 5.56 1.15 11 1.15V0.85C5.39431 0.85 0.85 5.39431 0.85 11H1.15ZM11 20.85C5.56 20.85 1.15 16.44 1.15 11H0.85C0.85 16.6057 5.39431 21.15 11 21.15V20.85Z"
    }, null, 8, gS)
  ]);
}
const bS = /* @__PURE__ */ B(mS, [["render", vS], ["__scopeId", "data-v-ffbe6fac"]]), yS = {
  props: {
    fillColor: {
      type: String,
      default: "#fff"
    },
    fillPathColor: {
      type: String,
      default: "#000"
    },
    dropdownClass: {
      type: String,
      default: "close"
    },
    circleBackground: {
      type: Boolean
    }
  }
}, _S = {
  width: "23",
  height: "23",
  viewBox: "0 0 23 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
}, CS = ["fill", "rx"], wS = ["fill"];
function TS(e, t, n, r, o, i) {
  return d(), f("svg", _S, [
    c("rect", {
      fill: n.fillColor,
      rx: n.circleBackground ? 50 : 4,
      width: "23",
      height: "23"
    }, null, 8, CS),
    c("path", {
      class: _([n.dropdownClass, "arrow"]),
      fill: n.fillPathColor,
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M5.14645 8.14645C5.34171 7.95118 5.65829 7.95118 5.85355 8.14645L11.5 13.7929L17.1464 8.14645C17.3417 7.95118 17.6583 7.95118 17.8536 8.14645C18.0488 8.34171 18.0488 8.65829 17.8536 8.85355L11.8536 14.8536C11.6583 15.0488 11.3417 15.0488 11.1464 14.8536L5.14645 8.85355C4.95118 8.65829 4.95118 8.34171 5.14645 8.14645Z"
    }, null, 10, wS)
  ]);
}
const kS = /* @__PURE__ */ B(yS, [["render", TS], ["__scopeId", "data-v-964bccff"]]), ES = {
  props: {
    fillColor: {
      type: String,
      default: "#fff"
    },
    dropdownClass: {
      type: String,
      default: "close"
    },
    isOpen: {
      type: Boolean,
      default: !1
    }
  }
}, SS = ["fill"];
function MS(e, t, n, r, o, i) {
  return d(), f("svg", {
    class: _({
      [n.dropdownClass]: !0,
      open: n.isOpen,
      close: !n.isOpen
    }),
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 14 11",
    fill: "none"
  }, [
    c("path", {
      d: "M7.86603 10.5C7.48112 11.1667 6.51888 11.1667 6.13397 10.5L0.937822 1.5C0.552922 0.833332 1.03405 -1.22094e-06 1.80385 -1.15364e-06L12.1962 -2.4512e-07C12.966 -1.77822e-07 13.4471 0.833333 13.0622 1.5L7.86603 10.5Z",
      fill: n.fillColor
    }, null, 8, SS)
  ], 2);
}
const S4 = /* @__PURE__ */ B(ES, [["render", MS], ["__scopeId", "data-v-174954e1"]]), AS = {
  name: "SvgClose",
  props: {
    fillColor: {
      type: String,
      default: "#fff"
    }
  }
}, IS = ["fill"], LS = ["fill"], DS = ["fill"];
function $S(e, t, n, r, o, i) {
  return d(), f("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: n.fillColor,
    "aria-label": "Close icon"
  }, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M0.439341 0.43934C1.02513 -0.146447 1.97488 -0.146447 2.56066 0.43934L23.5607 21.4393C24.1464 22.0251 24.1464 22.9749 23.5607 23.5607C22.9749 24.1464 22.0251 24.1464 21.4393 23.5607L0.439341 2.56066C-0.146445 1.97487 -0.146445 1.02513 0.439341 0.43934Z",
      fill: n.fillColor
    }, null, 8, LS),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M23.5607 0.43934C24.1464 1.02513 24.1464 1.97487 23.5607 2.56066L2.56066 23.5607C1.97487 24.1464 1.02513 24.1464 0.43934 23.5607C-0.146447 22.9749 -0.146447 22.0251 0.43934 21.4393L21.4393 0.43934C22.0251 -0.146447 22.9749 -0.146447 23.5607 0.43934Z",
      fill: n.fillColor
    }, null, 8, DS)
  ], 8, IS);
}
const vi = /* @__PURE__ */ B(AS, [["render", $S]]), OS = {
  name: "MenuItem",
  components: {
    FilledDropdownArrow: kS,
    HamburgerIcon: $0,
    PlusIcon: O0,
    SearchIcon: hS,
    LanguageIcon: bS,
    TriangleIcon: S4,
    Close: vi
  },
  props: {
    item: {
      type: String,
      required: !0
    },
    theme: {
      type: Object,
      required: !0
    },
    themeOverrides: {
      type: Object,
      default: () => ({})
    },
    content: {
      type: Object,
      required: !0
    },
    focusVisibleColor: {
      type: String,
      default: "#0000FF"
    },
    mobileTextColor: {
      type: String,
      default: "#0000FF"
    },
    isMobile: Boolean,
    dropdownOpen: Boolean,
    showText: {
      type: Boolean,
      default: !0
    },
    screenSize: {
      type: Number,
      default: 0
    }
  },
  emits: ["toggle-dropdown", "toggle-search"],
  computed: {
    showTitleTop() {
      return this.showText && ["schoolsbutton", "explore-button", "languagebutton"].includes(this.menuItem.id) || this.menuItem.id === "searchbutton" && ["H6", "H7", "H8"].includes(this.theme.version) && this.screenSize > 599;
    },
    showTitleBottom() {
      return this.showText && this.menuItem.id === "menubutton" && !this.isMobile || this.menuItem.id === "searchbutton";
    },
    focusColor() {
      return { "--focus-visible-color": this.focusVisibleColor };
    },
    menuItem() {
      const t = [
        this.menuButton,
        this.exploreButton,
        this.schoolsButton,
        this.languagesButton,
        this.searchButton,
        this.closeButton
      ].find((n) => n.id === this.item);
      return ge(ae(ae({}, t), this.themeOverrides), {
        colors: ae(ae({}, t.colors), this.themeOverrides.colors)
      });
    },
    menuButton() {
      var e, t, n, r;
      return {
        id: "menubutton",
        class: ["menu", { "m4-menu": this.content.menuOptions.version === "M4" }, "button-action", this.theme.style],
        iconClass: this.theme.menu_icon,
        dataTestId: "menu-button",
        ariaExpanded: this.content.showMenu,
        ariaControls: this.content.showMenu ? "mainmenu" : null,
        ariaLabel: this.content.newMobileHeader && this.screenSize < 600 ? this.theme.translations.open_mobile_menu : null,
        translatedTitle: this.theme.translations.menu_dropdown_title || "Menu",
        icon: this.theme.menu_icon === "plus" ? "PlusIcon" : "HamburgerIcon",
        colors: {
          "--fill-color": (e = this.theme.navigation_color) == null ? void 0 : e.hex,
          "--fill-path-color": (t = this.theme.navigation_icon_color) == null ? void 0 : t.hex,
          "--bg-color": (n = this.theme.bg_color) == null ? void 0 : n.hex,
          "--nav-color": (r = this.theme.navigation_color) == null ? void 0 : r.hex
        }
      };
    },
    exploreButton() {
      var e, t, n, r, o, i;
      return {
        id: "explore-button",
        ref: "explore-button",
        class: ["explore", "button-action", "menu", this.theme.style],
        dataTestId: "explore-button",
        ariaExpanded: this.dropdownOpen,
        ariaControls: this.dropdownOpen ? "explore-menu" : null,
        translatedTitle: ((e = this.theme.translations) == null ? void 0 : e.menu_dropdown_title) || ((t = this.theme.translations) == null ? void 0 : t.explore_dropdown_title) || "Explore",
        icon: "FilledDropdownArrow",
        colors: {
          "--fill-color": (n = this.theme.navigation_color) == null ? void 0 : n.hex,
          "--fill-path-color": (r = this.theme.navigation_icon_color) == null ? void 0 : r.hex,
          "--bg-color": (o = this.theme.bg_color) == null ? void 0 : o.hex,
          "--dropdown-class": this.dropdownOpen ? "open" : "close",
          "--nav-color": (i = this.theme.navigation_color) == null ? void 0 : i.hex
        }
      };
    },
    schoolsButton() {
      var e, t, n, r;
      return {
        id: "schoolsbutton",
        ref: "schoolsbutton",
        class: ["schools", "button-action", "menu", this.theme.style],
        dataTestId: "schools-button",
        ariaExpanded: this.dropdownOpen,
        ariaControls: this.ariaControlsSchoolsMenu,
        icon: "FilledDropdownArrow",
        translatedTitle: this.content.orgDropdownTitle,
        colors: {
          "--fill-color": (e = this.theme.navigation_color) == null ? void 0 : e.hex,
          "--fill-path-color": (t = this.theme.navigation_icon_color) == null ? void 0 : t.hex,
          "--bg-color": (n = this.theme.bg_color) == null ? void 0 : n.hex,
          "--dropdown-class": this.dropdownOpen ? "open" : "close",
          "--nav-color": (r = this.theme.navigation_color) == null ? void 0 : r.hex
        }
      };
    },
    ariaControlsSchoolsMenu() {
      return this.dropdownOpen ? this.content.hasCustomSchoolsMenu ? "schools-menu-sm1" : "schoolsmenu" : null;
    },
    languagesButton() {
      var e, t, n, r, o, i;
      return {
        id: "languagebutton",
        class: ["languages", "button-action", "menu", this.theme.style],
        dataTestId: "language-button",
        menuItemType: "languagebutton",
        ariaExpanded: this.dropdownOpen,
        ariaControls: this.dropdownOpen ? "languagesmenu" : null,
        icon: this.isMobile && this.content.newMobileHeader || this.isMobile && this.theme.version === "H3" ? "LanguageIcon" : "FilledDropdownArrow",
        ariaLabel: this.theme.translations.translate_site,
        translatedTitle: ((e = this.theme.translations) == null ? void 0 : e.translate_dropdown_title) || ((n = (t = this.theme.translations) == null ? void 0 : t.header) == null ? void 0 : n.translate_dropdown_title) || "Translate",
        colors: {
          "--fill-color": this.languageButtonColor,
          "--fill-path-color": ((r = this.theme.navigation_icon_color) == null ? void 0 : r.hex) || "#FFFFFF",
          "--bg-color": (o = this.theme.bg_color) == null ? void 0 : o.hex,
          "--dropdown-class": this.dropdownOpen ? "open" : "close",
          "--nav-color": ((i = this.theme.navigation_color) == null ? void 0 : i.hex) || "#0000FF"
        }
      };
    },
    languageButtonColor() {
      var e, t;
      return this.isMobile && this.theme.version === "H3" ? this.mobileTextColor : this.theme.version === "H2" ? (e = this.theme.navigation_icon_bg_color) == null ? void 0 : e.hex : (t = this.theme.navigation_color) == null ? void 0 : t.hex;
    },
    searchButton() {
      var e, t;
      return {
        id: "searchbutton",
        class: [
          "search",
          "focus-search-icon",
          "button-action",
          "menu",
          this.theme.style,
          { shrinkCSSClass: !this.isMobile || !this.content.newMobileHeader }
        ],
        dataTestId: this.searchTestIdByHeader,
        icon: "SearchIcon",
        translatedTitle: this.theme.translations.search_title || "Search Site",
        colors: {
          "--icon-color": this.isMobile ? this.mobileTextColor : (e = this.theme.search_icon_color) == null ? void 0 : e.hex,
          "--bg-color": (t = this.theme.bg_color) == null ? void 0 : t.hex
        }
      };
    },
    closeButton() {
      var e;
      return {
        id: "closebutton",
        class: ["menu", this.theme.style, "close-icon"],
        dataTestId: "close-button",
        icon: "Close",
        ariaLabel: this.content.newMobileHeader && this.screenSize < 600 ? this.theme.translations.close_mobile_menu : null,
        colors: {
          "--fill-color": (e = this.theme.navigation_color) == null ? void 0 : e.hex
        }
      };
    },
    searchTestIdByHeader() {
      return this.theme.version === "H2" ? this.isMobile ? "small-utilities-search-button" : "large-utilities-search-button" : "search-button";
    }
  },
  methods: {
    itemAction(e) {
      e === "searchbutton" ? this.$emit("toggle-search") : this.$emit("toggle-dropdown", e);
    }
  }
}, PS = ["id", "data-testid", "aria-expanded", "aria-controls", "aria-label"], NS = { class: "button-action-content" };
function HS(e, t, n, r, o, i) {
  return d(), f("button", {
    id: i.menuItem.id,
    "data-testid": i.menuItem.dataTestId,
    "aria-haspopup": "true",
    "aria-expanded": i.menuItem.ariaExpanded,
    "aria-controls": i.menuItem.ariaControls,
    "aria-label": i.menuItem.ariaLabel,
    class: _(["menu-item", i.menuItem.class]),
    style: Z(i.focusColor),
    onClick: t[0] || (t[0] = (a) => i.itemAction(i.menuItem.id))
  }, [
    c("span", NS, [
      i.showTitleTop ? (d(), f("span", {
        key: 0,
        class: "menu-field",
        style: Z({
          color: i.menuItem.colors["--nav-color"]
        })
      }, k(i.menuItem.translatedTitle), 5)) : T("", !0),
      (d(), L(Y(i.menuItem.icon), {
        class: _(i.menuItem.iconClass),
        "theme-style": n.theme.style,
        "bg-color": i.menuItem.colors["--bg-color"] || null,
        "icon-color": i.menuItem.colors["--icon-color"] || null,
        rx: n.theme.style === "purple" ? "50" : "4",
        "fill-color": i.menuItem.colors["--fill-color"] || null,
        "fill-path-color": i.menuItem.colors["--fill-path-color"] || null,
        "fill-background": i.menuItem.colors["--fill-background"] || null,
        "circle-background": i.menuItem.colors["--circle-background"] || null,
        "dropdown-class": i.menuItem.colors["--dropdown-class"],
        "nav-color": i.menuItem.colors["--nav-color"]
      }, null, 8, ["class", "theme-style", "bg-color", "icon-color", "rx", "fill-color", "fill-path-color", "fill-background", "circle-background", "dropdown-class", "nav-color"])),
      i.showTitleBottom ? (d(), f("span", {
        key: 1,
        class: _(["menu-field", { "sr-only": i.menuItem.id === "searchbutton" && n.theme.version !== "H4" }])
      }, k(i.menuItem.translatedTitle), 3)) : T("", !0)
    ])
  ], 14, PS);
}
const Yt = /* @__PURE__ */ B(OS, [["render", HS], ["__scopeId", "data-v-5573ec1c"]]), FS = {
  props: {
    fillColor: {
      type: String,
      default: "#fff"
    },
    dropdownClass: {
      type: String,
      default: "close"
    }
  }
}, RS = ["fill"];
function VS(e, t, n, r, o, i) {
  return d(), f("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: n.fillColor,
    xmlns: "http://www.w3.org/2000/svg",
    class: _(n.dropdownClass),
    "aria-hidden": "true"
  }, t[0] || (t[0] = [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M17.7144 9L11.5003 14.3919L5.28389 9L4 10.4956L11.5003 17L18.9997 10.4956L17.7144 9Z"
    }, null, -1)
  ]), 10, RS);
}
const Mo = /* @__PURE__ */ B(FS, [["render", VS], ["__scopeId", "data-v-5678f690"]]), BS = {
  name: "SchoolsMenuHeader",
  components: {
    DropdownArrowIcon: Mo
  },
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    theme: {
      type: Object,
      required: !0
    },
    isMobile: Boolean,
    isMobileActive: Boolean
  }
}, jS = ["tabindex"];
function US(e, t, n, r, o, i) {
  const a = V("DropdownArrowIcon");
  return d(), f("div", {
    class: _({ "mobile-cursor": n.isMobile }),
    style: Z(`color: ${n.theme.schools_menu_text_color.hex}`),
    tabindex: n.isMobile ? "0" : "-1",
    onKeydown: [
      t[0] || (t[0] = K(W((s) => e.$emit("set-active-header"), ["exact", "prevent"]), ["enter"])),
      t[1] || (t[1] = K(W((s) => e.$emit("set-active-header"), ["exact", "prevent"]), ["space"])),
      t[2] || (t[2] = K(W((s) => e.$emit("hide-on-esc"), ["exact", "prevent"]), ["esc"])),
      t[3] || (t[3] = K((s) => e.$emit("tab-action", s), ["tab"]))
    ]
  }, [
    c("h2", {
      class: _(["schools-menu-header", n.theme.style])
    }, k(n.item.name), 3),
    n.isMobile && n.item.children ? (d(), L(a, {
      key: 0,
      class: "schools-menu-arrow",
      "fill-color": `${n.theme.schools_menu_text_color.hex}`,
      "dropdown-class": n.isMobileActive ? "open" : "close"
    }, null, 8, ["fill-color", "dropdown-class"])) : T("", !0)
  ], 46, jS);
}
const qS = /* @__PURE__ */ B(BS, [["render", US], ["__scopeId", "data-v-0ee6ab64"]]), GS = "sites.thrillshare.com", KS = "sites.thrillshare.ca", zS = "develop.thrillshare.com", ZS = "qa.thrillshare.com", xS = "localhost:4000", WS = [GS, KS, zS, ZS, xS], Nl = "/", YS = (e) => !!WS.find((t) => e && !!e.toLowerCase().includes(t)), zr = (e, { isPreview: t, currentDomain: n }) => e ? YS(n) || t ? e.path_prefix || Nl : e.org_url ? e.org_url === e.path_prefix ? e.path_prefix || Nl : `https://${e.org_url}` : e.path_prefix || Nl : "#", P0 = (e, t, { isPreview: n }) => {
  const r = cv(e.link), o = t.find(
    (a) => a && a.alias && e.alias && a.alias.toLowerCase() === e.alias.toLowerCase()
  ), i = {
    isPreview: n,
    currentDomain: window.location.href
  };
  return o ? zr(o, i) : r;
}, XS = {
  name: "SchoolsMenuOrg",
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    theme: {
      type: Object,
      required: !0
    },
    organizations: {
      type: Array,
      default: () => []
    },
    isPreview: Boolean
  },
  computed: {
    link() {
      return P0(this.item, this.organizations, {
        isPreview: this.isPreview
      });
    }
  }
}, QS = ["href"];
function JS(e, t, n, r, o, i) {
  return d(), f("a", {
    href: i.link,
    style: Z(`color: ${n.theme.schools_menu_text_color.hex}`),
    onKeydown: [
      t[0] || (t[0] = K(W((a) => e.$emit("hide-on-esc"), ["exact", "prevent"]), ["esc"])),
      t[1] || (t[1] = K((a) => e.$emit("tab-action", a), ["tab"]))
    ]
  }, k(n.item.name), 45, QS);
}
const eM = /* @__PURE__ */ B(XS, [["render", JS], ["__scopeId", "data-v-40d9da4e"]]), tM = {
  name: "SchoolsMenuOrg",
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    theme: {
      type: Object,
      required: !0
    },
    organizations: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    linkTarget() {
      return this.item.opens_in_new_tab ? "_blank" : "_self";
    }
  }
}, nM = ["href", "target"];
function rM(e, t, n, r, o, i) {
  return d(), f("a", {
    href: n.item.link,
    target: i.linkTarget,
    style: Z(`color: ${n.theme.schools_menu_text_color.hex}`),
    onKeydown: [
      t[0] || (t[0] = K(W((a) => e.$emit("hide-on-esc"), ["exact", "prevent"]), ["esc"])),
      t[1] || (t[1] = K((a) => e.$emit("tab-action", a), ["tab"]))
    ]
  }, k(n.item.name), 45, nM);
}
const oM = /* @__PURE__ */ B(tM, [["render", rM], ["__scopeId", "data-v-ca9c8a65"]]), iM = {
  name: "SchoolsMenuImage",
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    theme: {
      type: Object,
      required: !0
    }
  },
  computed: {
    opensInNewTab() {
      return this.item.open_in_new_tab ? "_blank" : "_self";
    },
    width() {
      return this.item.display === "percentage" ? `${this.item.set_ratio * 100}%` : `${this.item.preferred_width}px`;
    },
    height() {
      let e = `max-height: ${this.item.preferred_height}px`;
      return this.item.display === "percentage" && (e = "auto"), e;
    },
    isDecorativeImage() {
      return !!this.item.decorative_image;
    }
  }
}, sM = { key: 0 }, aM = ["src", "alt"], lM = { key: 1 }, uM = ["href", "target"], dM = ["src", "alt"];
function cM(e, t, n, r, o, i) {
  return d(), f("div", {
    class: _([n.item.image_alignment, "image-container"])
  }, [
    n.item.action_on_click === "no_action" ? (d(), f("div", sM, [
      c("img", {
        src: n.item.url,
        alt: i.isDecorativeImage ? "" : n.item.alt_text,
        style: Z({ width: i.width, height: i.height })
      }, null, 12, aM)
    ])) : (d(), f("div", lM, [
      c("a", {
        href: n.item.link_url,
        target: i.opensInNewTab,
        onKeydown: [
          t[0] || (t[0] = K(W((a) => e.$emit("hide-on-esc"), ["exact", "prevent"]), ["esc"])),
          t[1] || (t[1] = K((a) => e.$emit("tab-action", a), ["tab"]))
        ]
      }, [
        c("img", {
          src: n.item.url,
          alt: i.isDecorativeImage ? "" : n.item.alt_text,
          style: Z({ width: i.width, height: i.height })
        }, null, 12, dM)
      ], 40, uM)
    ]))
  ], 2);
}
const hM = /* @__PURE__ */ B(iM, [["render", cM], ["__scopeId", "data-v-92129cf0"]]), mM = {
  name: "SM1",
  components: {
    SchoolsMenuHeader: qS,
    SchoolsMenuOrg: eM,
    SchoolsMenuLink: oM,
    SchoolsMenuImage: hM
  },
  props: {
    headerTheme: {
      type: Object,
      required: !0
    },
    columns: {
      type: Array,
      default: () => []
    },
    organizations: {
      type: Array,
      default: () => []
    },
    stickyHeader: Boolean,
    shrinkHeader: Boolean,
    isPreview: Boolean
  },
  data() {
    return {
      debounceSetScreenSize: () => {
      },
      screenSize: "",
      activeHeader: "",
      allFocusableElements: []
    };
  },
  computed: {
    isMobile() {
      return this.screenSize < 540;
    },
    styles() {
      return {
        background: this.headerTheme.version === "H4" ? "transparent" : this.headerTheme.schools_menu_bg_color.hex
      };
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.setScreenSize();
    }), this.debounceSetScreenSize = go(this.setScreenSize, 100), window.addEventListener("resize", this.debounceSetScreenSize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.debounceSetScreenSize);
  },
  methods: {
    setScreenSize() {
      this.screenSize = window.innerWidth;
    },
    setActiveHeader(e) {
      this.activeHeader = e === this.activeHeader ? "" : e;
    },
    determineFocusableElements() {
      this.allFocusableElements = this.$refs["menu-wrapper"].querySelectorAll("[href], .mobile-cursor");
    },
    tabAction(e, t) {
      var u, m;
      this.determineFocusableElements();
      const n = t.shiftKey, r = this.allFocusableElements[0], o = this.allFocusableElements[this.allFocusableElements.length - 1];
      let i = "", a = "";
      e.type === "SchoolsMenuImage" && (i = (u = r == null ? void 0 : r.href) == null ? void 0 : u.toString().slice(0, -1), a = (m = o == null ? void 0 : o.href) == null ? void 0 : m.toString().slice(0, -1));
      const s = r.innerText === e.name || i === e.link_url, l = o.innerText === e.name || a === e.link_url;
      s && n && this.$emit("focus-lost"), l && !n && this.$emit("focus-lost");
    }
  }
}, fM = {
  ref: "menu-wrapper",
  class: "wrapper"
}, pM = ["id", "onClick"], gM = ["aria-describedby"];
function vM(e, t, n, r, o, i) {
  return d(), f("div", {
    id: "schools-menu-sm1",
    class: _([
      n.headerTheme.version,
      {
        sticky: n.stickyHeader,
        shrink: n.shrinkHeader
      }
    ]),
    style: Z(i.styles)
  }, [
    c("div", fM, [
      (d(!0), f(J, null, ne(n.columns, (a, s) => (d(), f("div", {
        key: `sm1-col-${s}`,
        class: "column"
      }, [
        c("ul", null, [
          (d(!0), f(J, null, ne(a, (l, u) => (d(), f("li", {
            id: `parent-item-${s}-${u}`,
            key: `parent-item-${s}-${u}`,
            class: _(["parent-item", l.type]),
            onClick: (m) => i.setActiveHeader(`${s}-${u}`)
          }, [
            (d(), L(Y(l.type), {
              item: l,
              organizations: n.organizations,
              theme: n.headerTheme,
              "is-mobile": i.isMobile,
              "is-preview": n.isPreview,
              "is-mobile-active": o.activeHeader === `${s}-${u}`,
              onHideOnEsc: t[0] || (t[0] = (m) => e.$emit("hide-on-esc")),
              onSetActiveHeader: (m) => i.setActiveHeader(`${s}-${u}`),
              onTabAction: (m) => i.tabAction(l, m)
            }, null, 40, ["item", "organizations", "theme", "is-mobile", "is-preview", "is-mobile-active", "onSetActiveHeader", "onTabAction"])),
            j(Le, {
              name: i.isMobile ? "slide" : ""
            }, {
              default: S(() => [
                l.type === "SchoolsMenuHeader" && !i.isMobile || i.isMobile && o.activeHeader === `${s}-${u}` ? (d(), f("ul", {
                  key: 0,
                  class: "child-ul",
                  "aria-describedby": `parent-item-${s}-${u}`
                }, [
                  (d(!0), f(J, null, ne(l.children, (m, v) => (d(), f("li", {
                    key: `child-item-${s}-${u}-${v}`,
                    class: "child-item"
                  }, [
                    (d(), L(Y(m.type), {
                      organizations: n.organizations,
                      item: m,
                      theme: n.headerTheme,
                      onHideOnEsc: t[1] || (t[1] = (g) => e.$emit("hide-on-esc")),
                      onTabAction: (g) => i.tabAction(m, g)
                    }, null, 40, ["organizations", "item", "theme", "onTabAction"]))
                  ]))), 128))
                ], 8, gM)) : T("", !0)
              ]),
              _: 2
            }, 1032, ["name"])
          ], 10, pM))), 128))
        ])
      ]))), 128))
    ], 512)
  ], 6);
}
const bM = /* @__PURE__ */ B(mM, [["render", vM], ["__scopeId", "data-v-fa1c07e4"]]), yM = {
  name: "SchoolsMenu",
  components: {
    SM1: bM
  },
  mixins: [Et],
  props: {
    headerTheme: {
      type: Object,
      required: !0
    },
    orgMenuContent: {
      type: Array,
      default: () => []
    },
    organizations: {
      type: Array,
      default: () => []
    },
    showCustomSchoolsMenu: Boolean,
    stickyHeader: Boolean,
    shrinkHeader: Boolean,
    isPreview: Boolean,
    isIFrame: Boolean
  },
  methods: {
    hideOnClickaway() {
      this.$emit("hide-on-clickaway");
    },
    onFocusLost() {
      this.$emit("focus-lost");
    }
  }
};
function _M(e, t, n, r, o, i) {
  const a = ze("click-away");
  return d(), f("div", {
    onKeydown: t[0] || (t[0] = K(W((...s) => i.hideOnClickaway && i.hideOnClickaway(...s), ["exact", "prevent"]), ["esc"]))
  }, [
    j(Le, { name: "slide" }, {
      default: S(() => [
        n.showCustomSchoolsMenu ? we((d(), L(Y("SM1"), {
          key: 0,
          "header-theme": n.headerTheme,
          columns: n.orgMenuContent,
          organizations: n.organizations,
          "sticky-header": n.stickyHeader,
          "shrink-header": n.shrinkHeader,
          "is-preview": n.isPreview,
          onHideOnEsc: i.hideOnClickaway,
          onFocusLost: i.onFocusLost
        }, null, 40, ["header-theme", "columns", "organizations", "sticky-header", "shrink-header", "is-preview", "onHideOnEsc", "onFocusLost"])), [
          [a, i.hideOnClickaway]
        ]) : T("", !0)
      ]),
      _: 1
    })
  ], 32);
}
const mr = /* @__PURE__ */ B(yM, [["render", _M], ["__scopeId", "data-v-e9ebd598"]]), CM = {
  name: "HeaderDropdown",
  props: {
    id: {
      type: String,
      default: ""
    },
    role: {
      type: String,
      default: ""
    },
    labelledby: {
      type: String,
      default: ""
    },
    styles: {
      type: Object,
      default: () => {
      }
    },
    data: {
      type: Array,
      default: () => []
    },
    isVisible: Boolean,
    menuV4Enabled: Boolean,
    isPreview: Boolean,
    isLanguageMenuHidden: Boolean,
    pathPrefix: {
      type: String,
      default: ""
    },
    isShrink: Boolean
  },
  data() {
    return {
      focusedIndex: 0,
      headerHeight: 200
    };
  },
  computed: {
    colors() {
      const e = this.isShrink ? 46 : this.headerHeight;
      return {
        "--school-bg-color": this.styles.schools_menu_bg_color.hex,
        "--school-text-color": this.styles.schools_menu_text_color.hex,
        "--explore-bg-color": $(
          this.styles,
          "explore_menu_bg_color.hex",
          this.styles.language_menu_dropdown_color.hex
        ),
        "--explore-text-color": $(
          this.styles,
          "explore_menu_text_color.hex",
          this.styles.language_menu_text_color.hex
        ),
        "--lang-bg-color": this.styles.language_menu_dropdown_color.hex,
        "--lang-text-color": this.styles.language_menu_text_color.hex,
        "--header-height": `${e + 12}px`
      };
    },
    isSchoolMenu() {
      return this.id === "schoolsmenu";
    },
    isMenuV4() {
      return this.menuV4Enabled && this.id === "explore-menu";
    }
  },
  mounted() {
    typeof window != "undefined" && window.addEventListener("resize", this.calculateParentHeight);
  },
  beforeUnmount() {
    typeof window != "undefined" && window.removeEventListener("resize", this.calculateParentHeight);
  },
  beforeUpdate() {
    this.calculateParentHeight();
  },
  updated() {
    this.isVisible && this.$refs.dropdown && (this.focusedIndex = 0);
  },
  methods: {
    calculateParentHeight() {
      this.$parent.$parent.$refs.cmsHeader && (this.headerHeight = this.$parent.$parent.$refs.cmsHeader.clientHeight);
    },
    getLink(e) {
      return e && e[0] === "/" ? `${this.pathPrefix}${e}` : e;
    },
    targetWindow(e) {
      return e.opens_in_new_tab ? "_blank" : "_self";
    },
    changeFocus(e, t) {
      const n = this.focusedIndex + e;
      if (n < 0 || n > this.data.length - 1) {
        this.closeDropdown();
        return;
      }
      this.focusedIndex = n, t ? this.focusItem() : this.focusArrowNavigation();
    },
    focusPrevious(e, t) {
      this.changeFocus(-1, t);
    },
    focusNext(e, t) {
      this.changeFocus(1, t);
    },
    focusItem() {
      this.$refs.dropdown.children[this.focusedIndex].focus();
    },
    focusArrowNavigation() {
      this.$refs.dropdown.children[this.focusedIndex].children[0].focus();
    },
    updateLanguageCode(e) {
      this.$emit("setLanguage", e);
    },
    closeDropdown(e) {
      this.$emit("close-dropdown", e);
    },
    orgLink(e) {
      return zr(e, {
        isPreview: this.isPreview,
        currentDomain: window.location.href
      });
    }
  }
}, wM = ["id", "role", "aria-labelledby"], TM = { ref: "dropdown" }, kM = ["href", "target"], EM = ["href"], SM = ["onKeydown"], MM = ["onClick"], AM = {
  class: "button-action-content",
  tabindex: "-1"
};
function IM(e, t, n, r, o, i) {
  return d(), L(Le, { name: "fade" }, {
    default: S(() => [
      n.isVisible ? (d(), f("div", {
        key: 0,
        class: "header--dropdown-wrapper",
        style: Z(i.colors)
      }, [
        c("div", {
          id: n.id,
          role: n.role,
          "aria-labelledby": n.labelledby,
          class: _(["dropdown", {
            "dropdown--school": i.isSchoolMenu,
            "dropdown--explore": i.isMenuV4,
            "dropdown--lang": !i.isSchoolMenu && !i.isMenuV4,
            "no-language-menu": n.isLanguageMenuHidden
          }]),
          onClick: W(() => {
          }, ["stop"]),
          onKeydown: t[14] || (t[14] = K(W((a) => i.closeDropdown(!0), ["exact", "prevent"]), ["esc"]))
        }, [
          c("ul", TM, [
            i.isMenuV4 ? (d(!0), f(J, { key: 0 }, ne(n.data, (a) => (d(), f("li", {
              key: a.id,
              role: "menuitem",
              onKeydown: [
                t[0] || (t[0] = K(W((...s) => i.focusPrevious && i.focusPrevious(...s), ["exact", "prevent"]), ["up"])),
                t[1] || (t[1] = K(W((...s) => i.focusNext && i.focusNext(...s), ["exact", "prevent"]), ["down"])),
                t[2] || (t[2] = K(W((s) => i.focusPrevious(s, !0), ["shift", "exact"]), ["tab"])),
                t[3] || (t[3] = K(W((s) => i.focusNext(s, !0), ["exact"]), ["tab"]))
              ],
              onClick: t[4] || (t[4] = (...s) => i.closeDropdown && i.closeDropdown(...s))
            }, [
              c("a", {
                href: i.getLink(a.url),
                class: "link-explore",
                target: i.targetWindow(a)
              }, k(a.name), 9, kM)
            ], 32))), 128)) : i.isSchoolMenu ? (d(!0), f(J, { key: 1 }, ne(n.data, (a, s) => (d(), f("li", {
              key: s,
              role: "menuitem",
              onKeydown: [
                t[5] || (t[5] = K(W((...l) => i.focusPrevious && i.focusPrevious(...l), ["exact", "prevent"]), ["up"])),
                t[6] || (t[6] = K(W((...l) => i.focusNext && i.focusNext(...l), ["exact", "prevent"]), ["down"])),
                t[7] || (t[7] = K(W((l) => i.focusPrevious(l, !0), ["shift", "exact"]), ["tab"])),
                t[8] || (t[8] = K(W((l) => i.focusNext(l, !0), ["exact"]), ["tab"]))
              ],
              onClick: t[9] || (t[9] = (...l) => i.closeDropdown && i.closeDropdown(...l))
            }, [
              c("a", {
                href: i.orgLink(a),
                class: "link-school"
              }, k(a.name), 9, EM)
            ], 32))), 128)) : (d(!0), f(J, { key: 2 }, ne(n.data, (a, s) => (d(), f("li", {
              key: s,
              role: "menuitem",
              onKeydown: [
                K(W((l) => i.updateLanguageCode(a), ["exact", "prevent"]), ["enter"]),
                t[10] || (t[10] = K(W((...l) => i.focusPrevious && i.focusPrevious(...l), ["exact", "prevent"]), ["up"])),
                t[11] || (t[11] = K(W((...l) => i.focusNext && i.focusNext(...l), ["exact", "prevent"]), ["down"])),
                t[12] || (t[12] = K(W((l) => i.focusPrevious(l, !0), ["shift", "exact"]), ["tab"])),
                t[13] || (t[13] = K(W((l) => i.focusNext(l, !0), ["exact"]), ["tab"]))
              ]
            }, [
              c("button", {
                class: "button-action link-lang",
                onClick: (l) => i.updateLanguageCode(a)
              }, [
                c("div", AM, k(a.language), 1)
              ], 8, MM)
            ], 40, SM))), 128))
          ], 512)
        ], 42, wM)
      ], 4)) : T("", !0)
    ]),
    _: 1
  });
}
const LM = /* @__PURE__ */ B(CM, [["render", IM], ["__scopeId", "data-v-49b8bc7d"]]), DM = {
  props: {
    color: {
      type: String,
      default: ""
    }
  }
}, $M = {
  width: "176",
  height: "16",
  viewBox: "0 0 176 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  role: "img",
  "aria-labelledby": "googleTranslateLogoID"
}, OM = ["fill"], PM = ["fill"], NM = ["fill"], HM = ["fill"], FM = ["fill"], RM = ["fill"], VM = ["fill"], BM = ["fill"], jM = ["fill"], UM = ["fill"], qM = ["fill"], GM = ["fill"], KM = ["fill"], zM = ["fill"], ZM = ["fill"], xM = ["fill"], WM = ["fill"], YM = ["fill"], XM = ["fill"], QM = ["fill"], JM = ["fill"], eA = ["fill"], tA = ["fill"], nA = ["fill"];
function rA(e, t, n, r, o, i) {
  return d(), f("svg", $M, [
    t[0] || (t[0] = c("title", { id: "googleTranslateLogoID" }, "powered by Google Translate", -1)),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M128.97 4.67C128.23 4.67 127.2 5.19 126.91 6H126.85V4.78H125.58V11.88H126.91V8.06C126.91 6.76 127.84 5.99 128.75 5.99C129.04 5.99 129.27 6.02 129.46 6.09L129.97 4.84C129.69 4.72 129.4 4.67 128.97 4.67",
      fill: n.color || "#757575"
    }, null, 8, OM),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M152.98 1.33H154.31V11.87H152.98V1.33Z",
      fill: n.color || "#757575"
    }, null, 8, PM),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M148.84 4.67C147.41 4.67 146.07 5.47 146.07 6.72C146.07 7.97 147.28 8.48 147.91 8.63L149.34 8.97C150.07 9.15 150.32 9.53 150.32 9.88C150.32 10.46 149.7 10.83 148.9 10.83C148.1 10.83 147.36 10.43 146.99 9.54L145.84 10.02C146.25 11.02 147.23 12 148.89 12C150.55 12 151.64 11.06 151.64 9.84C151.64 9 151.07 8.15 149.7 7.83L148.3 7.51C147.75 7.38 147.39 7.15 147.39 6.71C147.39 6.15 148.06 5.84 148.79 5.84C149.46 5.84 150.14 6.11 150.4 6.75L151.52 6.29C151.1 5.24 150.02 4.67 148.82 4.67",
      fill: n.color || "#757575"
    }, null, 8, NM),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M158.76 10.8C158.09 10.8 157.25 10.45 157.25 9.72C157.25 9.09 157.86 8.4 159.22 8.4C160.32 8.4 160.84 8.81 160.84 8.81C160.84 9.93 159.78 10.8 158.75 10.8M159.03 4.67C157.3 4.67 156.33 5.68 156.09 6.31L157.27 6.82C157.51 6.17 158.34 5.87 159.06 5.87C160.03 5.87 160.84 6.47 160.84 7.56V7.76C160.57 7.61 159.92 7.34 158.99 7.34C157.37 7.34 155.87 8.14 155.87 9.7C155.87 11.13 157.13 12 158.54 12C159.72 12 160.4 11.36 160.78 10.79H160.84V11.87H162.1V7.61C162.1 5.67 160.72 4.66 159.04 4.66",
      fill: n.color || "#757575"
    }, null, 8, HM),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M133.5 10.8C132.83 10.8 131.99 10.45 131.99 9.72C131.99 9.09 132.6 8.4 133.96 8.4C135.06 8.4 135.58 8.81 135.58 8.81C135.58 9.93 134.52 10.8 133.49 10.8M133.77 4.67C132.04 4.67 131.07 5.68 130.83 6.31L132.01 6.82C132.25 6.17 133.08 5.87 133.8 5.87C134.77 5.87 135.58 6.47 135.58 7.56V7.76C135.31 7.61 134.66 7.34 133.73 7.34C132.11 7.34 130.61 8.14 130.61 9.7C130.61 11.13 131.87 12 133.28 12C134.46 12 135.14 11.36 135.52 10.79H135.58V11.87H136.84V7.61C136.84 5.67 135.46 4.66 133.78 4.66",
      fill: n.color || "#757575"
    }, null, 8, FM),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M169.58 7.5C169.84 6.5 170.61 5.87 171.58 5.87C173.08 5.87 173.59 6.91 173.63 7.5H169.58ZM171.61 4.67C169.56 4.67 168.19 6.38 168.19 8.34C168.19 10.42 169.62 12.01 171.76 12.01C173.37 12.01 174.4 11.11 174.81 10.13L173.64 9.65C173.27 10.52 172.5 10.81 171.73 10.81C170.65 10.81 169.58 10.04 169.5 8.59H175.02C175.02 8.59 175.03 8.44 175.03 8.34C175.03 6.12 173.69 4.67 171.61 4.67",
      fill: n.color || "#757575"
    }, null, 8, RM),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M141.96 4.67C140.99 4.67 140.09 5.23 139.71 5.89H139.65V4.78H138.38V11.88H139.71V8.08C139.71 6.99 140.42 5.89 141.58 5.89C142.59 5.89 143.33 6.38 143.33 7.86V11.88H144.66V7.66C144.66 5.91 143.76 4.68 141.95 4.68",
      fill: n.color || "#757575"
    }, null, 8, VM),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M165.58 2.67H164.25V4.78H163V6.01H164.25V9.73C164.25 11.18 165.05 12 166.54 12C166.99 12 167.31 11.94 167.61 11.81L167.15 10.67C166.96 10.76 166.79 10.79 166.54 10.79C165.92 10.79 165.58 10.43 165.58 9.63V6.01H167.32V4.78H165.58V2.67",
      fill: n.color || "#757575"
    }, null, 8, BM),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M125.13 1.33H117.91V2.7H120.84V11.87H122.19V2.7H125.12V1.33",
      fill: n.color || "#757575"
    }, null, 8, jM),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M72.34 5.46V7.1H76.26C76.14 8.02 75.84 8.7 75.37 9.16C74.8 9.73 73.91 10.36 72.34 10.36C69.92 10.36 68.04 8.41 68.04 6C68.04 3.59 69.93 1.64 72.34 1.64C73.64 1.64 74.59 2.15 75.3 2.81L76.46 1.65C75.48 0.71 74.18 0 72.35 0C69.04 0 66.26 2.69 66.26 6C66.26 9.31 69.04 12 72.35 12C74.13 12 75.48 11.41 76.54 10.32C77.62 9.24 77.96 7.71 77.96 6.49C77.96 6.11 77.93 5.76 77.87 5.47H72.35",
      fill: n.color || "#4285F4"
    }, null, 8, UM),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M82.85 4.13C80.71 4.13 78.96 5.76 78.96 8C78.96 10.24 80.71 11.87 82.85 11.87C84.99 11.87 86.74 10.23 86.74 8C86.74 5.77 84.99 4.13 82.85 4.13ZM82.85 10.35C81.68 10.35 80.66 9.38 80.66 8C80.66 6.62 81.67 5.65 82.85 5.65C84.03 5.65 85.04 6.6 85.04 8C85.04 9.4 84.03 10.35 82.85 10.35Z",
      fill: n.color || "#EB4335"
    }, null, 8, qM),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M101.9 4.99H101.84C101.46 4.53 100.72 4.12 99.8001 4.12C97.8601 4.12 96.1801 5.81 96.1801 7.99C96.1801 10.17 97.8701 11.86 99.8001 11.86C100.72 11.86 101.46 11.45 101.84 10.98H101.9V11.52C101.9 13 101.11 13.79 99.8301 13.79C98.7901 13.79 98.1401 13.04 97.8801 12.41L96.4001 13.03C96.8301 14.06 97.9501 15.32 99.8301 15.32C101.83 15.32 103.51 14.15 103.51 11.29V4.32H101.9V4.99V4.99ZM99.9501 10.34C98.7801 10.34 97.8801 9.34 97.8801 7.99C97.8801 6.64 98.7701 5.64 99.9501 5.64C101.13 5.64 102.02 6.64 102.02 8C102.02 9.36 101.11 10.33 99.9501 10.33V10.34Z",
      fill: n.color || "#4285F4"
    }, null, 8, GM),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M91.51 4.13C89.37 4.13 87.62 5.76 87.62 8C87.62 10.24 89.37 11.87 91.51 11.87C93.65 11.87 95.4 10.23 95.4 8C95.4 5.77 93.65 4.13 91.51 4.13ZM91.51 10.35C90.34 10.35 89.32 9.38 89.32 8C89.32 6.62 90.33 5.65 91.51 5.65C92.69 5.65 93.7 6.6 93.7 8C93.7 9.4 92.69 10.35 91.51 10.35Z",
      fill: n.color || "#FBBC05"
    }, null, 8, KM),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M104.85 0.160004H106.52V11.87H104.85V0.160004Z",
      fill: n.color || "#34A853"
    }, null, 8, zM),
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M111.69 10.35C110.82 10.35 110.21 9.95 109.81 9.18L114.99 7.04L114.81 6.6C114.49 5.73 113.5 4.14 111.5 4.14C109.5 4.14 107.85 5.71 107.85 8.01C107.85 10.18 109.49 11.88 111.69 11.88C113.46 11.88 114.49 10.79 114.92 10.16L113.6 9.28C113.16 9.93 112.56 10.35 111.69 10.35V10.35ZM111.56 5.58C112.25 5.58 112.83 5.93 113.03 6.43L109.53 7.88C109.53 6.25 110.68 5.58 111.56 5.58Z",
      fill: n.color || "#EB4335"
    }, null, 8, ZM),
    c("path", {
      d: "M5.36 8.77C5.36 9.73 5.14 10.51 4.7 11.1C4.26 11.69 3.66 11.98 2.91 11.98C2.16 11.98 1.53 11.74 1.09 11.25V14.3H0V5.53H0.99L1.04 6.23C1.48 5.68 2.09 5.41 2.88 5.41C3.67 5.41 4.24 5.7 4.69 6.27C5.14 6.84 5.36 7.64 5.36 8.67V8.77V8.77ZM4.28 8.65C4.28 7.94 4.13 7.37 3.82 6.96C3.51 6.55 3.1 6.34 2.57 6.34C1.91 6.34 1.42 6.63 1.09 7.21V10.24C1.41 10.82 1.91 11.11 2.58 11.11C3.1 11.11 3.51 10.9 3.82 10.49C4.13 10.08 4.28 9.47 4.28 8.65Z",
      fill: n.color || "black"
    }, null, 8, xM),
    c("path", {
      d: "M6.44995 8.64C6.44995 8.02 6.56995 7.46 6.81995 6.96C7.06995 6.46 7.39995 6.08 7.83995 5.81C8.27995 5.54 8.76995 5.41 9.32995 5.41C10.19 5.41 10.89 5.71 11.42 6.31C11.95 6.91 12.22 7.7 12.22 8.69V8.77C12.22 9.39 12.1 9.94 11.87 10.43C11.64 10.92 11.3 11.3 10.86 11.58C10.42 11.86 9.91995 11.99 9.34995 11.99C8.48995 11.99 7.78995 11.69 7.25995 11.09C6.72995 10.49 6.45995 9.7 6.45995 8.72V8.64H6.44995ZM7.53995 8.77C7.53995 9.47 7.69995 10.04 8.02995 10.46C8.35995 10.88 8.78995 11.1 9.33995 11.1C9.88995 11.1 10.33 10.88 10.65 10.45C10.97 10.02 11.14 9.41 11.14 8.64C11.14 7.94 10.97 7.38 10.64 6.95C10.31 6.52 9.86995 6.3 9.31995 6.3C8.76995 6.3 8.34995 6.51 8.02995 6.94C7.70995 7.37 7.53995 7.98 7.53995 8.77V8.77Z",
      fill: n.color || "black"
    }, null, 8, WM),
    c("path", {
      d: "M19.19 10.38L20.41 5.53H21.49L19.64 11.87H18.76L17.22 7.07L15.72 11.87H14.84L13 5.53H14.08L15.33 10.28L16.81 5.53H17.68L19.19 10.38V10.38Z",
      fill: n.color || "black"
    }, null, 8, YM),
    c("path", {
      d: "M25.2201 11.99C24.3601 11.99 23.6601 11.71 23.1201 11.14C22.5801 10.57 22.3101 9.82 22.3101 8.88V8.68C22.3101 8.05 22.4301 7.49 22.6701 7C22.9101 6.51 23.2501 6.12 23.6801 5.84C24.1101 5.56 24.5801 5.42 25.0801 5.42C25.9001 5.42 26.5401 5.69 27.0001 6.23C27.4601 6.77 27.6901 7.55 27.6901 8.56V9.01H23.4001C23.4201 9.63 23.6001 10.14 23.9501 10.52C24.3001 10.9 24.7401 11.1 25.2801 11.1C25.6601 11.1 25.9901 11.02 26.2501 10.87C26.5101 10.72 26.7501 10.51 26.9501 10.25L27.6101 10.77C27.0801 11.59 26.2801 11.99 25.2201 11.99V11.99ZM25.0901 6.31C24.6501 6.31 24.2901 6.47 23.9901 6.79C23.6901 7.11 23.5101 7.55 23.4401 8.13H26.6201V8.05C26.5901 7.5 26.4401 7.07 26.1701 6.77C25.9001 6.47 25.5501 6.32 25.0901 6.32V6.31Z",
      fill: n.color || "black"
    }, null, 8, XM),
    c("path", {
      d: "M32.02 6.51C31.86 6.48 31.68 6.47 31.49 6.47C30.78 6.47 30.3 6.77 30.04 7.38V11.88H28.96V5.54H30.01L30.03 6.27C30.39 5.7 30.89 5.42 31.54 5.42C31.75 5.42 31.91 5.45 32.02 5.5V6.51Z",
      fill: n.color || "black"
    }, null, 8, QM),
    c("path", {
      d: "M35.64 11.99C34.78 11.99 34.08 11.71 33.54 11.14C33 10.57 32.73 9.82 32.73 8.88V8.68C32.73 8.05 32.85 7.49 33.09 7C33.33 6.51 33.67 6.12 34.1 5.84C34.53 5.56 35 5.42 35.5 5.42C36.32 5.42 36.96 5.69 37.42 6.23C37.88 6.77 38.11 7.55 38.11 8.56V9.01H33.82C33.84 9.63 34.02 10.14 34.37 10.52C34.72 10.9 35.16 11.1 35.7 11.1C36.08 11.1 36.41 11.02 36.67 10.87C36.93 10.72 37.17 10.51 37.37 10.25L38.03 10.77C37.5 11.59 36.7 11.99 35.64 11.99V11.99ZM35.51 6.31C35.07 6.31 34.71 6.47 34.41 6.79C34.11 7.11 33.93 7.55 33.86 8.13H37.04V8.05C37.01 7.5 36.86 7.07 36.59 6.77C36.32 6.47 35.97 6.32 35.51 6.32V6.31Z",
      fill: n.color || "black"
    }, null, 8, JM),
    c("path", {
      d: "M39.11 8.64999C39.11 7.67999 39.34 6.9 39.8 6.3C40.26 5.7 40.86 5.41 41.61 5.41C42.36 5.41 42.94 5.66 43.37 6.17V2.87H44.45V11.87H43.45L43.4 11.19C42.97 11.72 42.36 11.99 41.59 11.99C40.82 11.99 40.26 11.69 39.79 11.09C39.32 10.49 39.1 9.69999 39.1 8.72999V8.64999H39.11ZM40.19 8.77C40.19 9.49 40.34 10.05 40.64 10.46C40.94 10.87 41.35 11.07 41.87 11.07C42.56 11.07 43.06 10.76 43.38 10.14V7.23C43.06 6.63 42.56 6.33 41.89 6.33C41.36 6.33 40.94 6.54 40.65 6.95C40.36 7.36 40.2 7.97 40.2 8.77H40.19Z",
      fill: n.color || "black"
    }, null, 8, eA),
    c("path", {
      d: "M54.47 8.77C54.47 9.74 54.25 10.52 53.8 11.1C53.35 11.68 52.76 11.98 52.01 11.98C51.21 11.98 50.59 11.7 50.15 11.13L50.1 11.86H49.1V2.87H50.18V6.23C50.62 5.69 51.22 5.42 51.99 5.42C52.76 5.42 53.36 5.71 53.8 6.29C54.24 6.87 54.46 7.67 54.46 8.68V8.77H54.47ZM53.39 8.64999C53.39 7.90999 53.25 7.34 52.96 6.94C52.67 6.54 52.26 6.34 51.73 6.34C51.02 6.34 50.5 6.67 50.19 7.34V10.08C50.52 10.74 51.04 11.08 51.74 11.08C52.26 11.08 52.66 10.88 52.95 10.48C53.24 10.08 53.38 9.47 53.38 8.66L53.39 8.64999Z",
      fill: n.color || "black"
    }, null, 8, tA),
    c("path", {
      d: "M57.91 10.29L59.39 5.53999H60.55L58 12.86C57.61 13.91 56.98 14.44 56.12 14.44L55.91 14.42L55.51 14.34V13.46L55.8 13.48C56.17 13.48 56.45 13.41 56.66 13.26C56.87 13.11 57.03 12.84 57.17 12.45L57.41 11.81L55.15 5.53999H56.33L57.91 10.29V10.29Z",
      fill: n.color || "black"
    }, null, 8, nA)
  ]);
}
const oA = /* @__PURE__ */ B(DM, [["render", rA]]), iA = {
  props: {
    color: {
      type: String,
      default: "#662E80"
    }
  }
}, sA = {
  width: "12",
  height: "10",
  viewBox: "0 0 12 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, aA = ["stroke"];
function lA(e, t, n, r, o, i) {
  return d(), f("svg", sA, [
    c("path", {
      d: "M1 5.53089L4.75 8.95946L11 0.959457",
      stroke: n.color,
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, 8, aA)
  ]);
}
const uA = /* @__PURE__ */ B(iA, [["render", lA]]), dA = {
  name: "LanguageDropdown",
  components: {
    SelectedIcon: uA,
    PoweredByGoogle: oA
  },
  props: {
    id: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: "All Languages"
    },
    data: {
      type: Array,
      default: () => []
    },
    styles: {
      type: Object,
      default: () => {
      }
    },
    currentLanguage: {
      type: String,
      default: "en"
    },
    role: {
      type: String,
      default: ""
    },
    isVisible: Boolean
  },
  data() {
    return {
      bottomListReached: !1,
      focusedIndex: 0,
      inputValue: "",
      selectedLanguage: ""
    };
  },
  computed: {
    colors() {
      return {
        "--lang-bg-color": this.styles.language_menu_dropdown_color.hex || "#fff",
        "--lang-text-color": this.langTextColor || "#000",
        "--column-count": this.data.length < 5 ? 2 : 3,
        "--inner-shadow-height": this.data.length > 18 && !this.bottomListReached ? "35px" : "0px"
      };
    },
    googleLogoColor() {
      return this.colors["--lang-bg-color"] === "#fff" ? "" : ue(this.colors["--lang-bg-color"]).isLight() ? "#000" : "#fff";
    },
    langTextColor() {
      return this.styles.language_menu_text_color.hex || "#000";
    },
    filteredLanguages() {
      const e = this.inputValue.trim().toLowerCase();
      return e.length === 0 ? this.data : this.data.filter(
        ({ language: t, code: n }) => t.toLowerCase().includes(e) || n.toLowerCase().includes(e)
      );
    }
  },
  mounted() {
    this.selectedLanguage = this.currentLanguage;
  },
  methods: {
    listScroll(e) {
      const { scrollTop: t, offsetHeight: n, scrollHeight: r } = e.target, o = 10;
      this.bottomListReached = t + n + o >= r;
    },
    inputSearch() {
      var e;
      !this.inputValue.trim().length || !this.filteredLanguages.length || (this.selectedLanguage = (e = this.filteredLanguages[0]) == null ? void 0 : e.code, this.confirmLanguageSelection(this.selectedLanguage));
    },
    selectLanguage(e) {
      this.selectedLanguage = e, this.confirmLanguageSelection(this.selectedLanguage);
    },
    confirmLanguageSelection(e) {
      this.$emit("set-language", { code: e });
    },
    changeFocus(e, t = !1) {
      const n = this.focusedIndex + e;
      if (n < 0) {
        this.focusedIndex = 0, this.$refs["language-input"].focus();
        return;
      }
      if (n > this.filteredLanguages.length - 1) {
        this.focusedIndex = 0, this.$emit("close-dropdown");
        return;
      }
      this.focusedIndex = n, t || this.$refs["languages-list"].children[this.focusedIndex].focus();
    }
  }
}, cA = ["id", "role"], hA = { class: "header" }, mA = { class: "title" }, fA = { class: "body" }, pA = {
  ref: "languages-list",
  class: "languages-list"
}, gA = ["onClick", "onKeydown"], vA = { class: "language-text" }, bA = { class: "footer" };
function yA(e, t, n, r, o, i) {
  const a = V("selected-icon"), s = V("powered-by-google");
  return d(), L(Le, { name: "fade" }, {
    default: S(() => [
      n.isVisible ? (d(), f("div", {
        key: 0,
        id: n.id,
        style: Z(i.colors),
        role: n.role,
        class: "dropdown-wrapper"
      }, [
        c("div", hA, [
          c("h1", mA, k(n.title), 1),
          we(c("input", {
            ref: "language-input",
            "onUpdate:modelValue": t[0] || (t[0] = (l) => o.inputValue = l),
            class: "search-input",
            type: "text",
            placeholder: "search languages...",
            onKeydown: [
              t[1] || (t[1] = K(W((...l) => i.inputSearch && i.inputSearch(...l), ["exact", "prevent"]), ["enter"])),
              t[2] || (t[2] = K(W((l) => e.$emit("close-dropdown"), ["shift", "exact"]), ["tab"]))
            ],
            onFocus: t[3] || (t[3] = (l) => o.focusedIndex = 0)
          }, null, 544), [
            [S6, o.inputValue]
          ])
        ]),
        c("div", fA, [
          c("div", {
            class: "languages-container",
            onScroll: t[8] || (t[8] = (...l) => i.listScroll && i.listScroll(...l))
          }, [
            c("ul", pA, [
              (d(!0), f(J, null, ne(i.filteredLanguages, ({ language: l, code: u }) => (d(), f("li", {
                key: u,
                role: "menuitem",
                tabindex: "0",
                class: "language",
                onClick: (m) => i.selectLanguage(u),
                onKeydown: [
                  K(W((m) => i.selectLanguage(u), ["exact", "prevent"]), ["enter"]),
                  t[4] || (t[4] = K(W((m) => i.changeFocus(-1), ["exact", "prevent"]), ["up"])),
                  t[5] || (t[5] = K(W((m) => i.changeFocus(1), ["exact", "prevent"]), ["down"])),
                  t[6] || (t[6] = K(W((m) => i.changeFocus(-1), ["shift", "exact", "prevent"]), ["tab"])),
                  t[7] || (t[7] = K(W((m) => i.changeFocus(1, !0), ["exact"]), ["tab"]))
                ]
              }, [
                o.selectedLanguage === u ? (d(), L(a, {
                  key: 0,
                  color: i.langTextColor,
                  class: "selected-icon"
                }, null, 8, ["color"])) : T("", !0),
                c("div", vA, k(l), 1)
              ], 40, gA))), 128))
            ], 512)
          ], 32)
        ]),
        c("div", bA, [
          j(s, { color: i.googleLogoColor }, null, 8, ["color"])
        ])
      ], 12, cA)) : T("", !0)
    ]),
    _: 1
  });
}
const Fs = /* @__PURE__ */ B(dA, [["render", yA], ["__scopeId", "data-v-f1cc0f89"]]), _A = [[{ type: "SchoolsMenuOrg", name: "School District", link: "#" }, { type: "SchoolsMenuHeader", name: "High Schools", children: [{ type: "SchoolsMenuOrg", name: "Bella High School", link: "#" }, { type: "SchoolsMenuOrg", name: "Northside High School", link: "#" }, { type: "SchoolsMenuOrg", name: "No-Link High School" }] }], [{ type: "SchoolsMenuHeader", name: "Middle Schools", children: [{ type: "SchoolsMenuOrg", name: "Bella Middle School", link: "#" }, { type: "SchoolsMenuOrg", name: "Northside Intermediate", link: "#" }, { type: "SchoolsMenuOrg", name: "Parkway Middle School", link: "#" }, { type: "SchoolsMenuOrg", name: "Bohr Science Magnet", link: "#" }] }], [{ type: "SchoolsMenuHeader", name: "Elementary Schools", children: [{ type: "SchoolsMenuOrg", name: "Bella Elementary School", link: "#" }, { type: "SchoolsMenuOrg", name: "Northside Elementary", link: "#" }, { type: "SchoolsMenuOrg", name: "Parkway Elementary", link: "#" }, { type: "SchoolsMenuOrg", name: "Eastside Elementary", link: "#" }, { type: "SchoolsMenuOrg", name: "Southside Elementary", link: "#" }, { type: "SchoolsMenuOrg", name: "Burnside Elementary", link: "#" }, { type: "SchoolsMenuOrg", name: "Gibbs Magnet School", link: "#" }] }], [{ url: "https://d2kzwze52p8717.cloudfront.net/youth_program.jpeg", type: "SchoolsMenuImage", caption: "Girl walking up steps to school", display: "actual-size", alt_text: "Girl walking up steps to school", asset_id: 206, link_url: "", set_ratio: 1, cropped_width: {}, cropped_height: {}, action_on_click: "no_action", image_alignment: "center", preferred_width: null, preferred_height: null, caption_alignment: "center", open_link_in_new_tab: !1 }]], M4 = {
  menu: _A
}, ut = {
  components: {
    HeaderDropdown: LM,
    LanguageDropdown: Fs
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      required: !0
    },
    shouldShrink: Boolean,
    shouldBeSticky: Boolean,
    isMobile: Boolean,
    isHomepage: Boolean,
    showSignInButton: Boolean,
    signInUrl: {
      type: String,
      default: ""
    }
  },
  emits: ["language-change", "toggle-search", "toggle-menu", "toggle-mobile-menu"],
  data() {
    return {
      customSchoolsMenuVisible: !1,
      schoolDropdownVisible: !1,
      exploreMenuVisible: !1,
      languageDropdownVisible: !1,
      containerHeight: "auto"
    };
  },
  computed: {
    isCustomSchoolsMenuVisible() {
      return this.content.hasCustomSchoolsMenu && this.customSchoolsMenuVisible;
    },
    isSchoolDropdownVisible() {
      return !this.content.hasCustomSchoolsMenu && this.schoolDropdownVisible;
    },
    logoLink() {
      const e = this.content.pathPrefix ? this.content.pathPrefix : "/";
      return this.content.isIFrame ? "" : e;
    },
    shrinkCSSClass() {
      return this.shouldShrink && !this.content.isIFrame ? "shrink" : "";
    },
    logoCircleCSSClass() {
      return this.theme.logo_circle ? "logo-circle" : "";
    },
    menuV4Enabled() {
      var e;
      return ((e = this.content.menuOptions) == null ? void 0 : e.version) === "M4";
    },
    menuV5Enabled() {
      var e;
      return ((e = this.content.menuOptions) == null ? void 0 : e.version) === "M5";
    },
    menuV6Enabled() {
      var e;
      return ((e = this.content.menuOptions) == null ? void 0 : e.version) === "M6";
    },
    shouldDisplaySchoolsDropdown() {
      var e;
      return ((e = this.content.organizations) == null ? void 0 : e.length) > 1 || this.content.hasCustomSchoolsMenu;
    },
    shouldDisplayLanguagesDropdown() {
      var e;
      return ((e = this.content.languages) == null ? void 0 : e.length) > 1;
    },
    customSchoolsMenu() {
      var e, t;
      return this.content.isPreview || this.content.isIFrame ? M4 : (t = (e = this.content.globals) == null ? void 0 : e.homepage) == null ? void 0 : t.schools_menu;
    },
    menuIdByType() {
      let e = null;
      return this.isSchoolDropdownVisible ? e = "schoolsmenu" : this.isCustomSchoolsMenuVisible && (e = "schools-menu-sm1"), e;
    },
    mobileHeaderBgColor() {
      var e, t, n, r;
      return this.menuV4Enabled && this.theme.version !== "H3" ? (t = (e = this.content.menuOptions) == null ? void 0 : e.dropdown_bg_color) == null ? void 0 : t.hex : this.menuV5Enabled && this.theme.version === "H3" ? "transparent" : ((r = (n = this.content.menuOptions) == null ? void 0 : n.bg_color) == null ? void 0 : r.hex) || "#fff";
    },
    mobileMenuBgColor() {
      var e, t, n, r;
      return this.menuV4Enabled || this.menuV5Enabled ? (t = (e = this.content.menuOptions) == null ? void 0 : e.dropdown_bg_color) == null ? void 0 : t.hex : ((r = (n = this.content.menuOptions) == null ? void 0 : n.bg_color) == null ? void 0 : r.hex) || "#fff";
    },
    mobileMenuTextColor() {
      var e, t, n, r;
      return this.menuV4Enabled || this.menuV5Enabled ? (t = (e = this.content.menuOptions) == null ? void 0 : e.dropdown_text_color) == null ? void 0 : t.hex : ((r = (n = this.content.menuOptions) == null ? void 0 : n.text_color) == null ? void 0 : r.hex) || "#000";
    },
    hasLanguages() {
      var e;
      return ((e = this.content.languages) == null ? void 0 : e.length) > 0;
    },
    signInColors() {
      var e, t, n, r;
      return {
        "--sign-in-border": (e = this.theme.sign_in_button_border) == null ? void 0 : e.hex,
        "--sign-in-color": (t = this.theme.sign_in_button_color) == null ? void 0 : t.hex,
        "--sign-in-bg": (n = this.theme.sign_in_button_bg) == null ? void 0 : n.hex,
        "--sign-in-bg-hover": `${(r = this.theme.sign_in_button_bg) == null ? void 0 : r.hex}CC`
      };
    },
    signInText() {
      var e, t;
      return ((t = (e = this.content) == null ? void 0 : e.translations) == null ? void 0 : t.sign_in_button_title) || "Sign in";
    },
    hasExploreMenuContent() {
      var e, t;
      return ((t = (e = this.content) == null ? void 0 : e.customMenuItems) == null ? void 0 : t.length) >= 1;
    },
    colors() {
      var e, t, n, r, o;
      return ae({
        "--bg-color": this.theme.bg_color ? this.theme.bg_color.hex : "#014990",
        "--logo-container-height": this.containerHeight,
        "--mobile-logo-height": (t = (e = this.content.globals) == null ? void 0 : e.info) != null && t.customHeader ? "auto" : "100%",
        "--more-text-color": this.theme.more_text_color ? this.theme.more_text_color.hex : "FFFFFF",
        "--more-bg-color": this.theme.more_bg_color ? this.theme.more_bg_color.hex : "#014990",
        "--dropdown-text-color": this.theme.dropdown_text_color ? this.theme.dropdown_text_color.hex : "#000000",
        "--dropdown-bg-color": this.theme.dropdown_bg_color ? this.theme.dropdown_bg_color.hex : "#FFFFFF",
        "--explore-menu-text-color": this.theme.explore_menu_text_color ? this.theme.explore_menu_text_color.hex : "#333333",
        "--explore-menu-bg-color": this.theme.explore_menu_bg_color ? this.theme.explore_menu_bg_color.hex : "#FFFFFF",
        "--schools-menu-text-color": this.theme.schools_menu_text_color ? this.theme.schools_menu_text_color.hex : "#333333",
        "--schools-menu-bg-color": this.theme.schools_menu_bg_color ? this.theme.schools_menu_bg_color.hex : "#FFFFFF",
        "--icon-bg-color": this.theme.icon_bg_color ? this.theme.icon_bg_color.hex : "#014990",
        "--icon-text-color": this.theme.icon_bg_color ? this.theme.icon_text_color.hex : "#014990",
        "--icon-color": this.theme.icon_color ? this.theme.icon_color.hex : "#014990",
        "--nav-color": this.theme.navigation_color ? this.theme.navigation_color.hex : "#014990",
        "--nav-icon-color": this.theme.navigation_icon_color ? this.theme.navigation_icon_color.hex : "#FFFFFF",
        "--text-color": this.theme.text_color ? this.theme.text_color.hex : "#FFFFFF",
        "--menu-heading-line-color": (r = (n = this.theme) == null ? void 0 : n.menu_heading_line_color) == null ? void 0 : r.hex,
        "--utility-link-color": this.theme.utility_link_color ? this.theme.utility_link_color.hex : "#000000",
        "--utility-bg-color": this.theme.utility_bg_color ? this.theme.utility_bg_color.hex : "#FFFFFF",
        searchIcon: (o = this.theme.search_icon_color) == null ? void 0 : o.hex,
        "--mobile-header-bg-color": this.mobileHeaderBgColor,
        "--mobile-menu-bg-color": this.mobileMenuBgColor,
        "--mobile-menu-text-color": this.mobileMenuTextColor,
        "--logo-container-height": this.containerHeight,
        "--mobile-logo-height": this.content.globals.info.customHeader ? "auto" : "100%"
      }, this.signInColors);
    }
  },
  mounted() {
    typeof window != "undefined" && (this.resizeLogoContainer(), window.addEventListener("resize", this.resizeLogoContainer));
  },
  beforeUnmount() {
    typeof window != "undefined" && window.removeEventListener("resize", this.resizeLogoContainer);
  },
  methods: {
    resizeLogoContainer() {
      var e, t, n;
      (n = (t = (e = this.content) == null ? void 0 : e.globals) == null ? void 0 : t.info) != null && n.customHeader ? this.containerHeight = `${window.document.getElementsByClassName("logo")[0].offsetHeight + 15}px` : this.containerHeight = "auto";
    },
    setLanguage(e) {
      this.languageDropdownVisible = !1, this.$emit("language-change", e);
    },
    toggleSearch() {
      this.schoolDropdownVisible = !1, this.customSchoolsMenuVisible = !1, this.languageDropdownVisible = !1, this.$emit("toggle-search");
    },
    clickedMenu(e) {
      this.setDropdownVisibility(e);
    },
    setDropdownVisibility(e) {
      switch (e) {
        case "menubutton":
          this.schoolDropdownVisible = !1, this.customSchoolsMenuVisible = !1, this.languageDropdownVisible = !1, this.$emit("toggle-menu", !this.content.showMenu);
          break;
        case "explore-button":
          this.schoolDropdownVisible = !1, this.customSchoolsMenuVisible = !1, this.languageDropdownVisible = !1, this.exploreMenuVisible = !this.exploreMenuVisible;
          break;
        case "schoolsbutton":
          this.exploreMenuVisible = !1, this.languageDropdownVisible = !1, this.content.hasCustomSchoolsMenu ? this.customSchoolsMenuVisible = !this.customSchoolsMenuVisible : this.schoolDropdownVisible = !this.schoolDropdownVisible;
          break;
        case "languagebutton":
          this.exploreMenuVisible = !1, this.schoolDropdownVisible = !1, this.customSchoolsMenuVisible = !1, this.languageDropdownVisible = !this.languageDropdownVisible;
          break;
        case "closebutton":
          this.$emit("toggle-menu", !1);
      }
    },
    closeAllMenus() {
      this.schoolDropdownVisible = !1, this.customSchoolsMenuVisible = !1, this.languageDropdownVisible = !1, this.exploreMenuVisible = !1;
    }
  }
};
function CA(e) {
  return ag() ? (s0(e), !0) : !1;
}
function Uc(e) {
  return typeof e == "function" ? e() : po(e);
}
typeof WorkerGlobalScope != "undefined" && globalThis instanceof WorkerGlobalScope;
const wA = (e) => e != null;
function A4(e) {
  var t;
  const n = Uc(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var I4 = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], gs = /* @__PURE__ */ I4.join(","), L4 = typeof Element == "undefined", Fr = L4 ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, vs = !L4 && Element.prototype.getRootNode ? function(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
} : function(e) {
  return e == null ? void 0 : e.ownerDocument;
}, bs = function e(t, n) {
  var r;
  n === void 0 && (n = !0);
  var o = t == null || (r = t.getAttribute) === null || r === void 0 ? void 0 : r.call(t, "inert"), i = o === "" || o === "true", a = i || n && t && e(t.parentNode);
  return a;
}, TA = function(t) {
  var n, r = t == null || (n = t.getAttribute) === null || n === void 0 ? void 0 : n.call(t, "contenteditable");
  return r === "" || r === "true";
}, D4 = function(t, n, r) {
  if (bs(t))
    return [];
  var o = Array.prototype.slice.apply(t.querySelectorAll(gs));
  return n && Fr.call(t, gs) && o.unshift(t), o = o.filter(r), o;
}, $4 = function e(t, n, r) {
  for (var o = [], i = Array.from(t); i.length; ) {
    var a = i.shift();
    if (!bs(a, !1))
      if (a.tagName === "SLOT") {
        var s = a.assignedElements(), l = s.length ? s : a.children, u = e(l, !0, r);
        r.flatten ? o.push.apply(o, u) : o.push({
          scopeParent: a,
          candidates: u
        });
      } else {
        var m = Fr.call(a, gs);
        m && r.filter(a) && (n || !t.includes(a)) && o.push(a);
        var v = a.shadowRoot || // check for an undisclosed shadow
        typeof r.getShadowRoot == "function" && r.getShadowRoot(a), g = !bs(v, !1) && (!r.shadowRootFilter || r.shadowRootFilter(a));
        if (v && g) {
          var h = e(v === !0 ? a.children : v.children, !0, r);
          r.flatten ? o.push.apply(o, h) : o.push({
            scopeParent: a,
            candidates: h
          });
        } else
          i.unshift.apply(i, a.children);
      }
  }
  return o;
}, O4 = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, Mr = function(t) {
  if (!t)
    throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || TA(t)) && !O4(t) ? 0 : t.tabIndex;
}, kA = function(t, n) {
  var r = Mr(t);
  return r < 0 && n && !O4(t) ? 0 : r;
}, EA = function(t, n) {
  return t.tabIndex === n.tabIndex ? t.documentOrder - n.documentOrder : t.tabIndex - n.tabIndex;
}, P4 = function(t) {
  return t.tagName === "INPUT";
}, SA = function(t) {
  return P4(t) && t.type === "hidden";
}, MA = function(t) {
  var n = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(r) {
    return r.tagName === "SUMMARY";
  });
  return n;
}, AA = function(t, n) {
  for (var r = 0; r < t.length; r++)
    if (t[r].checked && t[r].form === n)
      return t[r];
}, IA = function(t) {
  if (!t.name)
    return !0;
  var n = t.form || vs(t), r = function(s) {
    return n.querySelectorAll('input[type="radio"][name="' + s + '"]');
  }, o;
  if (typeof window != "undefined" && typeof window.CSS != "undefined" && typeof window.CSS.escape == "function")
    o = r(window.CSS.escape(t.name));
  else
    try {
      o = r(t.name);
    } catch (a) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", a.message), !1;
    }
  var i = AA(o, t.form);
  return !i || i === t;
}, LA = function(t) {
  return P4(t) && t.type === "radio";
}, DA = function(t) {
  return LA(t) && !IA(t);
}, $A = function(t) {
  var n, r = t && vs(t), o = (n = r) === null || n === void 0 ? void 0 : n.host, i = !1;
  if (r && r !== t) {
    var a, s, l;
    for (i = !!((a = o) !== null && a !== void 0 && (s = a.ownerDocument) !== null && s !== void 0 && s.contains(o) || t != null && (l = t.ownerDocument) !== null && l !== void 0 && l.contains(t)); !i && o; ) {
      var u, m, v;
      r = vs(o), o = (u = r) === null || u === void 0 ? void 0 : u.host, i = !!((m = o) !== null && m !== void 0 && (v = m.ownerDocument) !== null && v !== void 0 && v.contains(o));
    }
  }
  return i;
}, bm = function(t) {
  var n = t.getBoundingClientRect(), r = n.width, o = n.height;
  return r === 0 && o === 0;
}, OA = function(t, n) {
  var r = n.displayCheck, o = n.getShadowRoot;
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  var i = Fr.call(t, "details>summary:first-of-type"), a = i ? t.parentElement : t;
  if (Fr.call(a, "details:not([open]) *"))
    return !0;
  if (!r || r === "full" || r === "legacy-full") {
    if (typeof o == "function") {
      for (var s = t; t; ) {
        var l = t.parentElement, u = vs(t);
        if (l && !l.shadowRoot && o(l) === !0)
          return bm(t);
        t.assignedSlot ? t = t.assignedSlot : !l && u !== t.ownerDocument ? t = u.host : t = l;
      }
      t = s;
    }
    if ($A(t))
      return !t.getClientRects().length;
    if (r !== "legacy-full")
      return !0;
  } else if (r === "non-zero-area")
    return bm(t);
  return !1;
}, PA = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var n = t.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var r = 0; r < n.children.length; r++) {
          var o = n.children.item(r);
          if (o.tagName === "LEGEND")
            return Fr.call(n, "fieldset[disabled] *") ? !0 : !o.contains(t);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, ys = function(t, n) {
  return !(n.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  bs(n) || SA(n) || OA(n, t) || // For a details element with a summary, the summary element gets the focus
  MA(n) || PA(n));
}, qc = function(t, n) {
  return !(DA(n) || Mr(n) < 0 || !ys(t, n));
}, NA = function(t) {
  var n = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, HA = function e(t) {
  var n = [], r = [];
  return t.forEach(function(o, i) {
    var a = !!o.scopeParent, s = a ? o.scopeParent : o, l = kA(s, a), u = a ? e(o.candidates) : s;
    l === 0 ? a ? n.push.apply(n, u) : n.push(s) : r.push({
      documentOrder: i,
      tabIndex: l,
      item: o,
      isScope: a,
      content: u
    });
  }), r.sort(EA).reduce(function(o, i) {
    return i.isScope ? o.push.apply(o, i.content) : o.push(i.content), o;
  }, []).concat(n);
}, FA = function(t, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = $4([t], n.includeContainer, {
    filter: qc.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: NA
  }) : r = D4(t, n.includeContainer, qc.bind(null, n)), HA(r);
}, RA = function(t, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = $4([t], n.includeContainer, {
    filter: ys.bind(null, n),
    flatten: !0,
    getShadowRoot: n.getShadowRoot
  }) : r = D4(t, n.includeContainer, ys.bind(null, n)), r;
}, to = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return Fr.call(t, gs) === !1 ? !1 : qc(n, t);
}, VA = /* @__PURE__ */ I4.concat("iframe").join(","), Hl = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return Fr.call(t, VA) === !1 ? !1 : ys(n, t);
};
/*!
* focus-trap 7.6.4
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/
function Gc(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function BA(e) {
  if (Array.isArray(e)) return Gc(e);
}
function jA(e, t, n) {
  return (t = zA(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function UA(e) {
  if (typeof Symbol != "undefined" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function qA() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ym(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function _m(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ym(Object(n), !0).forEach(function(r) {
      jA(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ym(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function GA(e) {
  return BA(e) || UA(e) || ZA(e) || qA();
}
function KA(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function zA(e) {
  var t = KA(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function ZA(e, t) {
  if (e) {
    if (typeof e == "string") return Gc(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Gc(e, t) : void 0;
  }
}
var Cm = {
  activateTrap: function(t, n) {
    if (t.length > 0) {
      var r = t[t.length - 1];
      r !== n && r._setPausedState(!0);
    }
    var o = t.indexOf(n);
    o === -1 || t.splice(o, 1), t.push(n);
  },
  deactivateTrap: function(t, n) {
    var r = t.indexOf(n);
    r !== -1 && t.splice(r, 1), t.length > 0 && !t[t.length - 1]._isManuallyPaused() && t[t.length - 1]._setPausedState(!1);
  }
}, xA = function(t) {
  return t.tagName && t.tagName.toLowerCase() === "input" && typeof t.select == "function";
}, WA = function(t) {
  return (t == null ? void 0 : t.key) === "Escape" || (t == null ? void 0 : t.key) === "Esc" || (t == null ? void 0 : t.keyCode) === 27;
}, ni = function(t) {
  return (t == null ? void 0 : t.key) === "Tab" || (t == null ? void 0 : t.keyCode) === 9;
}, YA = function(t) {
  return ni(t) && !t.shiftKey;
}, XA = function(t) {
  return ni(t) && t.shiftKey;
}, wm = function(t) {
  return setTimeout(t, 0);
}, Bo = function(t) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)
    r[o - 1] = arguments[o];
  return typeof t == "function" ? t.apply(void 0, r) : t;
}, qi = function(t) {
  return t.target.shadowRoot && typeof t.composedPath == "function" ? t.composedPath()[0] : t.target;
}, QA = [], N4 = function(t, n) {
  var r = (n == null ? void 0 : n.document) || document, o = (n == null ? void 0 : n.trapStack) || QA, i = _m({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0,
    isKeyForward: YA,
    isKeyBackward: XA
  }, n), a = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   posTabIndexesFound: boolean,
    //   firstTabbableNode: HTMLElement|undefined,
    //   lastTabbableNode: HTMLElement|undefined,
    //   firstDomTabbableNode: HTMLElement|undefined,
    //   lastDomTabbableNode: HTMLElement|undefined,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    manuallyPaused: !1,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0,
    // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
    recentNavEvent: void 0
  }, s, l = function(N, G, X) {
    return N && N[G] !== void 0 ? N[G] : i[X || G];
  }, u = function(N, G) {
    var X = typeof (G == null ? void 0 : G.composedPath) == "function" ? G.composedPath() : void 0;
    return a.containerGroups.findIndex(function(Q) {
      var re = Q.container, se = Q.tabbableNodes;
      return re.contains(N) || // fall back to explicit tabbable search which will take into consideration any
      //  web components if the `tabbableOptions.getShadowRoot` option was used for
      //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
      //  look inside web components even if open)
      (X == null ? void 0 : X.includes(re)) || se.find(function(de) {
        return de === N;
      });
    });
  }, m = function(N) {
    var G = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, X = G.hasFallback, Q = X === void 0 ? !1 : X, re = G.params, se = re === void 0 ? [] : re, de = i[N];
    if (typeof de == "function" && (de = de.apply(void 0, GA(se))), de === !0 && (de = void 0), !de) {
      if (de === void 0 || de === !1)
        return de;
      throw new Error("`".concat(N, "` was specified but was not a node, or did not return a node"));
    }
    var me = de;
    if (typeof de == "string") {
      try {
        me = r.querySelector(de);
      } catch (he) {
        throw new Error("`".concat(N, '` appears to be an invalid selector; error="').concat(he.message, '"'));
      }
      if (!me && !Q)
        throw new Error("`".concat(N, "` as selector refers to no known node"));
    }
    return me;
  }, v = function() {
    var N = m("initialFocus", {
      hasFallback: !0
    });
    if (N === !1)
      return !1;
    if (N === void 0 || N && !Hl(N, i.tabbableOptions))
      if (u(r.activeElement) >= 0)
        N = r.activeElement;
      else {
        var G = a.tabbableGroups[0], X = G && G.firstTabbableNode;
        N = X || m("fallbackFocus");
      }
    else N === null && (N = m("fallbackFocus"));
    if (!N)
      throw new Error("Your focus-trap needs to have at least one focusable element");
    return N;
  }, g = function() {
    if (a.containerGroups = a.containers.map(function(N) {
      var G = FA(N, i.tabbableOptions), X = RA(N, i.tabbableOptions), Q = G.length > 0 ? G[0] : void 0, re = G.length > 0 ? G[G.length - 1] : void 0, se = X.find(function(he) {
        return to(he);
      }), de = X.slice().reverse().find(function(he) {
        return to(he);
      }), me = !!G.find(function(he) {
        return Mr(he) > 0;
      });
      return {
        container: N,
        tabbableNodes: G,
        focusableNodes: X,
        /** True if at least one node with positive `tabindex` was found in this container. */
        posTabIndexesFound: me,
        /** First tabbable node in container, __tabindex__ order; `undefined` if none. */
        firstTabbableNode: Q,
        /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */
        lastTabbableNode: re,
        // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
        //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
        //  because that API doesn't work with Shadow DOM as well as it should (@see
        //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
        //  to address an edge case related to positive tabindex support, this seems like a much easier,
        //  "close enough most of the time" alternative for positive tabindexes which should generally
        //  be avoided anyway...
        /** First tabbable node in container, __DOM__ order; `undefined` if none. */
        firstDomTabbableNode: se,
        /** Last tabbable node in container, __DOM__ order; `undefined` if none. */
        lastDomTabbableNode: de,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function(_e) {
          var De = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, Ae = G.indexOf(_e);
          return Ae < 0 ? De ? X.slice(X.indexOf(_e) + 1).find(function(Ze) {
            return to(Ze);
          }) : X.slice(0, X.indexOf(_e)).reverse().find(function(Ze) {
            return to(Ze);
          }) : G[Ae + (De ? 1 : -1)];
        }
      };
    }), a.tabbableGroups = a.containerGroups.filter(function(N) {
      return N.tabbableNodes.length > 0;
    }), a.tabbableGroups.length <= 0 && !m("fallbackFocus"))
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    if (a.containerGroups.find(function(N) {
      return N.posTabIndexesFound;
    }) && a.containerGroups.length > 1)
      throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
  }, h = function(N) {
    var G = N.activeElement;
    if (G)
      return G.shadowRoot && G.shadowRoot.activeElement !== null ? h(G.shadowRoot) : G;
  }, E = function(N) {
    if (N !== !1 && N !== h(document)) {
      if (!N || !N.focus) {
        E(v());
        return;
      }
      N.focus({
        preventScroll: !!i.preventScroll
      }), a.mostRecentlyFocusedNode = N, xA(N) && N.select();
    }
  }, C = function(N) {
    var G = m("setReturnFocus", {
      params: [N]
    });
    return G || (G === !1 ? !1 : N);
  }, A = function(N) {
    var G = N.target, X = N.event, Q = N.isBackward, re = Q === void 0 ? !1 : Q;
    G = G || qi(X), g();
    var se = null;
    if (a.tabbableGroups.length > 0) {
      var de = u(G, X), me = de >= 0 ? a.containerGroups[de] : void 0;
      if (de < 0)
        re ? se = a.tabbableGroups[a.tabbableGroups.length - 1].lastTabbableNode : se = a.tabbableGroups[0].firstTabbableNode;
      else if (re) {
        var he = a.tabbableGroups.findIndex(function(Mt) {
          var Vt = Mt.firstTabbableNode;
          return G === Vt;
        });
        if (he < 0 && (me.container === G || Hl(G, i.tabbableOptions) && !to(G, i.tabbableOptions) && !me.nextTabbableNode(G, !1)) && (he = de), he >= 0) {
          var _e = he === 0 ? a.tabbableGroups.length - 1 : he - 1, De = a.tabbableGroups[_e];
          se = Mr(G) >= 0 ? De.lastTabbableNode : De.lastDomTabbableNode;
        } else ni(X) || (se = me.nextTabbableNode(G, !1));
      } else {
        var Ae = a.tabbableGroups.findIndex(function(Mt) {
          var Vt = Mt.lastTabbableNode;
          return G === Vt;
        });
        if (Ae < 0 && (me.container === G || Hl(G, i.tabbableOptions) && !to(G, i.tabbableOptions) && !me.nextTabbableNode(G)) && (Ae = de), Ae >= 0) {
          var Ze = Ae === a.tabbableGroups.length - 1 ? 0 : Ae + 1, Je = a.tabbableGroups[Ze];
          se = Mr(G) >= 0 ? Je.firstTabbableNode : Je.firstDomTabbableNode;
        } else ni(X) || (se = me.nextTabbableNode(G));
      }
    } else
      se = m("fallbackFocus");
    return se;
  }, R = function(N) {
    var G = qi(N);
    if (!(u(G, N) >= 0)) {
      if (Bo(i.clickOutsideDeactivates, N)) {
        s.deactivate({
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked (and if not focusable, to "nothing"); by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node), whether the
          //  outside click was on a focusable node or not
          returnFocus: i.returnFocusOnDeactivate
        });
        return;
      }
      Bo(i.allowOutsideClick, N) || N.preventDefault();
    }
  }, P = function(N) {
    var G = qi(N), X = u(G, N) >= 0;
    if (X || G instanceof Document)
      X && (a.mostRecentlyFocusedNode = G);
    else {
      N.stopImmediatePropagation();
      var Q, re = !0;
      if (a.mostRecentlyFocusedNode)
        if (Mr(a.mostRecentlyFocusedNode) > 0) {
          var se = u(a.mostRecentlyFocusedNode), de = a.containerGroups[se].tabbableNodes;
          if (de.length > 0) {
            var me = de.findIndex(function(he) {
              return he === a.mostRecentlyFocusedNode;
            });
            me >= 0 && (i.isKeyForward(a.recentNavEvent) ? me + 1 < de.length && (Q = de[me + 1], re = !1) : me - 1 >= 0 && (Q = de[me - 1], re = !1));
          }
        } else
          a.containerGroups.some(function(he) {
            return he.tabbableNodes.some(function(_e) {
              return Mr(_e) > 0;
            });
          }) || (re = !1);
      else
        re = !1;
      re && (Q = A({
        // move FROM the MRU node, not event-related node (which will be the node that is
        //  outside the trap causing the focus escape we're trying to fix)
        target: a.mostRecentlyFocusedNode,
        isBackward: i.isKeyBackward(a.recentNavEvent)
      })), E(Q || a.mostRecentlyFocusedNode || v());
    }
    a.recentNavEvent = void 0;
  }, F = function(N) {
    var G = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    a.recentNavEvent = N;
    var X = A({
      event: N,
      isBackward: G
    });
    X && (ni(N) && N.preventDefault(), E(X));
  }, I = function(N) {
    (i.isKeyForward(N) || i.isKeyBackward(N)) && F(N, i.isKeyBackward(N));
  }, D = function(N) {
    WA(N) && Bo(i.escapeDeactivates, N) !== !1 && (N.preventDefault(), s.deactivate());
  }, O = function(N) {
    var G = qi(N);
    u(G, N) >= 0 || Bo(i.clickOutsideDeactivates, N) || Bo(i.allowOutsideClick, N) || (N.preventDefault(), N.stopImmediatePropagation());
  }, U = function() {
    if (a.active)
      return Cm.activateTrap(o, s), a.delayInitialFocusTimer = i.delayInitialFocus ? wm(function() {
        E(v());
      }) : E(v()), r.addEventListener("focusin", P, !0), r.addEventListener("mousedown", R, {
        capture: !0,
        passive: !1
      }), r.addEventListener("touchstart", R, {
        capture: !0,
        passive: !1
      }), r.addEventListener("click", O, {
        capture: !0,
        passive: !1
      }), r.addEventListener("keydown", I, {
        capture: !0,
        passive: !1
      }), r.addEventListener("keydown", D), s;
  }, q = function() {
    if (a.active)
      return r.removeEventListener("focusin", P, !0), r.removeEventListener("mousedown", R, !0), r.removeEventListener("touchstart", R, !0), r.removeEventListener("click", O, !0), r.removeEventListener("keydown", I, !0), r.removeEventListener("keydown", D), s;
  }, z = function(N) {
    var G = N.some(function(X) {
      var Q = Array.from(X.removedNodes);
      return Q.some(function(re) {
        return re === a.mostRecentlyFocusedNode;
      });
    });
    G && E(v());
  }, te = typeof window != "undefined" && "MutationObserver" in window ? new MutationObserver(z) : void 0, ee = function() {
    te && (te.disconnect(), a.active && !a.paused && a.containers.map(function(N) {
      te.observe(N, {
        subtree: !0,
        childList: !0
      });
    }));
  };
  return s = {
    get active() {
      return a.active;
    },
    get paused() {
      return a.paused;
    },
    activate: function(N) {
      if (a.active)
        return this;
      var G = l(N, "onActivate"), X = l(N, "onPostActivate"), Q = l(N, "checkCanFocusTrap");
      Q || g(), a.active = !0, a.paused = !1, a.nodeFocusedBeforeActivation = r.activeElement, G == null || G();
      var re = function() {
        Q && g(), U(), ee(), X == null || X();
      };
      return Q ? (Q(a.containers.concat()).then(re, re), this) : (re(), this);
    },
    deactivate: function(N) {
      if (!a.active)
        return this;
      var G = _m({
        onDeactivate: i.onDeactivate,
        onPostDeactivate: i.onPostDeactivate,
        checkCanReturnFocus: i.checkCanReturnFocus
      }, N);
      clearTimeout(a.delayInitialFocusTimer), a.delayInitialFocusTimer = void 0, q(), a.active = !1, a.paused = !1, ee(), Cm.deactivateTrap(o, s);
      var X = l(G, "onDeactivate"), Q = l(G, "onPostDeactivate"), re = l(G, "checkCanReturnFocus"), se = l(G, "returnFocus", "returnFocusOnDeactivate");
      X == null || X();
      var de = function() {
        wm(function() {
          se && E(C(a.nodeFocusedBeforeActivation)), Q == null || Q();
        });
      };
      return se && re ? (re(C(a.nodeFocusedBeforeActivation)).then(de, de), this) : (de(), this);
    },
    pause: function(N) {
      return a.active ? (a.manuallyPaused = !0, this._setPausedState(!0, N)) : this;
    },
    unpause: function(N) {
      return a.active ? (a.manuallyPaused = !1, o[o.length - 1] !== this ? this : this._setPausedState(!1, N)) : this;
    },
    updateContainerElements: function(N) {
      var G = [].concat(N).filter(Boolean);
      return a.containers = G.map(function(X) {
        return typeof X == "string" ? r.querySelector(X) : X;
      }), a.active && g(), ee(), this;
    }
  }, Object.defineProperties(s, {
    _isManuallyPaused: {
      value: function() {
        return a.manuallyPaused;
      }
    },
    _setPausedState: {
      value: function(N, G) {
        if (a.paused === N)
          return this;
        if (a.paused = N, N) {
          var X = l(G, "onPause"), Q = l(G, "onPostPause");
          X == null || X(), q(), ee(), Q == null || Q();
        } else {
          var re = l(G, "onUnpause"), se = l(G, "onPostUnpause");
          re == null || re(), g(), U(), ee(), se == null || se();
        }
        return this;
      }
    }
  }), s.updateContainerElements(t), s;
};
function JA(e, t = {}) {
  let n;
  const g = t, { immediate: r } = g, o = ia(g, ["immediate"]), i = zt(!1), a = zt(!1), s = (h) => n && n.activate(h), l = (h) => n && n.deactivate(h), u = () => {
    n && (n.pause(), a.value = !0);
  }, m = () => {
    n && (n.unpause(), a.value = !1);
  }, v = Re(() => {
    const h = Uc(e);
    return (Array.isArray(h) ? h : [h]).map((E) => {
      const C = Uc(E);
      return typeof C == "string" ? C : A4(C);
    }).filter(wA);
  });
  return ko(
    v,
    (h) => {
      h.length && (n = N4(h, ge(ae({}, o), {
        onActivate() {
          i.value = !0, t.onActivate && t.onActivate();
        },
        onDeactivate() {
          i.value = !1, t.onDeactivate && t.onDeactivate();
        }
      })), r && s());
    },
    { flush: "post" }
  ), CA(() => l()), {
    hasFocus: i,
    isPaused: a,
    activate: s,
    deactivate: l,
    pause: u,
    unpause: m
  };
}
const eI = {
  name: "MenuElement",
  props: {
    element: {
      type: Object,
      default: () => ({})
    },
    theme: {
      type: Object,
      default: () => ({})
    },
    toggleFn: {
      type: Function,
      default: () => {
      }
    },
    isParent: {
      type: Boolean,
      default: !1
    },
    isSubParent: {
      type: Boolean,
      default: !1
    },
    pathPrefix: {
      type: String,
      default: null
    },
    cursorPointer: {
      type: Boolean,
      default: !1
    }
  }
}, tI = ["href"], nI = {
  class: "link-content",
  tabindex: "-1"
}, rI = ["href"], oI = {
  class: "link-content",
  tabindex: "-1"
}, iI = ["href", "target"], sI = {
  class: "link-content",
  tabindex: "-1"
}, aI = ["href", "target"], lI = {
  class: "link-content",
  tabindex: "-1"
};
function uI(e, t, n, r, o, i) {
  return d(), f("span", {
    class: "menu-element",
    style: Z(n.theme),
    onClick: t[5] || (t[5] = (a) => n.toggleFn(n.element.id, n.isParent))
  }, [
    n.element.type === "page" ? (d(), f("a", {
      key: 0,
      href: `${n.pathPrefix}/page/${n.element.slug}`,
      class: "link",
      style: { color: "inherit", "text-decoration": "none" },
      tabindex: "0",
      onClick: t[0] || (t[0] = W(() => {
      }, ["stop"])),
      onKeydown: t[1] || (t[1] = K(W(() => {
      }, ["stop"]), ["enter"]))
    }, [
      c("span", nI, k(n.element.name), 1)
    ], 40, tI)) : n.element.mailto ? (d(), f("a", {
      key: 1,
      href: `mailto:${n.element.email_address}`,
      class: "link",
      style: { color: "inherit", "text-decoration": "none" }
    }, [
      c("span", oI, k(n.element.name), 1)
    ], 8, rI)) : n.element.type === "link" && n.element.ipAddress ? (d(), f("a", {
      key: 2,
      href: `http://${n.element.url}`,
      target: n.element.opens_in_new_tab ? "_blank" : "",
      style: { color: "inherit", "text-decoration": "none" },
      tabindex: "0",
      onClick: t[2] || (t[2] = W(() => {
      }, ["stop"]))
    }, [
      c("span", sI, k(n.element.name), 1)
    ], 8, iI)) : n.element.type === "link" && !n.element.ipAddress ? (d(), f("a", {
      key: 3,
      href: n.element.url,
      class: "link",
      target: n.element.opens_in_new_tab ? "_blank" : "",
      style: { color: "inherit", "text-decoration": "none" },
      tabindex: "0",
      onClick: t[3] || (t[3] = W(() => {
      }, ["stop"])),
      onKeydown: t[4] || (t[4] = K(W(() => {
      }, ["stop"]), ["enter"]))
    }, [
      c("span", lI, k(n.element.name), 1)
    ], 40, aI)) : (d(), f("span", {
      key: 4,
      style: Z({
        color: "inherit",
        "text-decoration": "none",
        cursor: n.isSubParent || n.cursorPointer ? "pointer" : "initial"
      })
    }, k(n.element.name), 5))
  ], 4);
}
const dI = /* @__PURE__ */ B(eI, [["render", uI], ["__scopeId", "data-v-90cb0a6b"]]), Rs = {
  components: {
    MenuElement: dI
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      required: !0
    },
    isPreview: Boolean
  },
  data() {
    return {
      activeIds: []
    };
  },
  computed: {
    menuIconStyle() {
      return {
        "--icon-color": this.theme.icon_color.hex
      };
    },
    translations() {
      return this.theme.translations;
    }
  },
  methods: {
    getLink(e) {
      return e[0] === "/" ? `${this.content.pathPrefix}${e}` : e;
    },
    toggleOpen(e, t) {
      const n = this.activeIds.indexOf(e);
      n > -1 ? this.activeIds.splice(n, 1) : (t && (this.activeIds = []), this.activeIds.length > 1 && this.activeIds.splice(1, 1), this.activeIds.push(e));
    },
    clickStaticLink(e) {
      this.$route.fullPath !== e && this.$router.push({ path: `${e}` });
    },
    clickGeneratedLink(e, t) {
      e.type === "page" && this.$route.fullPath !== `/page/${e.slug}` ? this.$router.push({ path: `/page/${e.slug}` }) : e.type === "link" ? document.getElementById(`${e.slug || e.id}-${e.type}`).getElementsByTagName("a")[0].click() : e.children.length && this.toggleOpen(e.id, t);
    },
    getUrl(e) {
      return !e || e.type === "header" ? "" : e.type === "page" ? `${this.content.pathPrefix}/page/${e.slug}` : e.mailto && e.email_address ? `mailto:${e.email_address}` : e.ipAddress ? `http://${e.url}` : e.url;
    },
    closeMenu() {
      this.$emit("close-menu");
    }
  }
}, H4 = {
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      required: !0
    },
    currentDomain: {
      type: String,
      default: null
    },
    showSignInButton: Boolean,
    signInUrl: {
      type: String,
      default: ""
    }
  },
  components: {
    Close: vi
  },
  mixins: [Et],
  emits: ["close-menu", "toggle-search"],
  data() {
    return {
      displayMoreButton: !0,
      isMoreDropdownVisible: !1,
      isTemporarilyHideMenu: !1,
      visibleItems: [],
      underLappedItems: [],
      activeItem: null,
      parentWidth: 0,
      totalElementsWidth: 0,
      timer: null,
      moreMenuTimeout: null,
      hideMenuTimeOut: null,
      menuTimeout: null,
      debounceParentWidth: () => {
      },
      openMoreMenuDropDown: null,
      loadingMenu: !0,
      preventMouseLeaveClose: !1
    };
  },
  computed: {
    colors() {
      var e;
      return {
        "--text-color": this.theme.text_color ? this.theme.text_color.hex : "#FFFFFF",
        "--bg-color": this.theme.bg_color ? this.theme.bg_color.hex : "#014990",
        "--more-text-color": this.theme.more_text_color ? this.theme.more_text_color.hex : "FFFFFF",
        "--more-bg-color": this.theme.more_bg_color ? this.theme.more_bg_color.hex : "#014990",
        "--dropdown-text-color": this.theme.dropdown_text_color ? this.theme.dropdown_text_color.hex : "#333",
        "--dropdown-bg-color": this.theme.dropdown_bg_color ? this.theme.dropdown_bg_color.hex : "#FFFFFF",
        "--explore-menu-text-color": this.theme.explore_menu_text_color ? this.theme.explore_menu_text_color.hex : "#333333",
        "--explore-menu-bg-color": this.theme.explore_menu_bg_color ? this.theme.explore_menu_bg_color.hex : "#FFFFFF",
        "--schools-menu-text-color": this.theme.schools_menu_text_color ? this.theme.schools_menu_text_color.hex : "#333333",
        "--schools-menu-bg-color": this.theme.schools_menu_bg_color ? this.theme.schools_menu_bg_color.hex : "#FFFFFF",
        "--icon-bg-color": this.theme.icon_bg_color ? this.theme.icon_bg_color.hex : "#014990",
        "--icon-text-color": this.theme.icon_bg_color ? this.theme.icon_text_color.hex : "#014990",
        "--icon-color": this.theme.icon_color ? this.theme.icon_color.hex : "#014990",
        "--nav-color": this.theme.navigation_color ? this.theme.navigation_color.hex : "#014990",
        "--nav-icon-color": this.theme.navigation_icon_color ? this.theme.navigation_icon_color.hex : "#FFFFFF",
        "--nav-icon-bg-color": this.theme.navigation_icon_bg_color ? (e = this.theme.navigation_icon_bg_color) == null ? void 0 : e.hex : "#014990",
        "--utility-link-color": this.theme.utility_link_color ? this.theme.utility_link_color.hex : "#000000",
        "--utility-bg-color": this.theme.utility_bg_color ? this.theme.utility_bg_color.hex : "#FFFFFF"
      };
    },
    mobileMenuItems() {
      return [
        {
          id: "explore-header",
          name: "Explore",
          slug: "explore",
          type: "header",
          children: this.content.customMenuItems.map((e) => ({
            id: `explore-${e.id}`,
            name: e.name,
            slug: e.url,
            type: "explore",
            children: []
          }))
        },
        ...this.content.sitemapMenuItems
      ];
    },
    barNavOptions() {
      return ge(ae(ae({}, this.theme), this.content.menuOptions), {
        translations: this.theme.translations || this.content.menuOptions.translations
      });
    },
    signInText() {
      var e, t;
      return ((t = (e = this.content) == null ? void 0 : e.translations) == null ? void 0 : t.sign_in_button_title) || "Sign in";
    }
  },
  watch: {
    parentWidth() {
      this.displayMoreButton = !0, this.debounceParentWidth.flush(), this.$nextTick(this.calculateUnderlappedItems.bind(this));
    },
    isMoreDropdownVisible() {
      this.isMoreDropdownVisible && this.handleDrawerToggle();
    }
  },
  mounted() {
    this.loadingMenu = !1;
    let e = 0;
    if (this.isMobile) return;
    const t = this.$refs["bar-nav-item-wrapper"];
    Object.entries(t.childNodes).forEach((n) => {
      var r;
      if (this.theme.version === "M5") {
        const i = Array.from(n[1].childNodes).find((a) => a.className === "bar-menu-item");
        i && (e += i.clientWidth);
      } else ((r = n[1]) == null ? void 0 : r.className) === "m4--menu-item" && (e += n[1].clientWidth);
    }), this.totalElementsWidth = e, this.updateParentWidth(), this.debounceParentWidth = go(this.updateParentWidth.bind(this), 30), window.addEventListener("resize", this.debounceParentWidth), window.addEventListener("keydown", this.onKeydown);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.debounceParentWidth), window.removeEventListener("keydown", this.onKeydown);
  },
  created() {
    this.visibleItems = this.content.sitemapMenuItems;
  },
  methods: {
    canTriggerCloseFirstItem(e, t, n) {
      const r = (i) => n === "exploreButton" || n === "schoolsButton" || i.type !== "header" && i.children.length === 0 || i.type !== "header" && i.children.length > 0 && !t || i.type === "header" && t && i.children.length > 0, o = this.activeItem.children.findIndex(r);
      if (o !== -1) {
        const i = this.activeItem.children[o];
        return e === i.id;
      }
      return !1;
    },
    canTriggerCloseLastItem(e, t, n) {
      const r = (u) => n === "exploreButton" || n === "schoolsButton" || u.type !== "header" && u.children.length === 0 || !!u.children.length, o = this.activeItem.children.findLastIndex(r), i = this.activeItem.children[o];
      if (n === "exploreButton" || n === "schoolsButton")
        return e === i.id;
      const a = e === i.id && !i.children.length, s = e === i.id && t && !i.childrenVisible, l = e === i.id && t && (i.children.length === 0 || i.children.findLastIndex(r) === -1);
      if (a || s || l)
        return e === i.id;
      if (i.childrenVisible && i.children.findLastIndex(r) !== -1) {
        const u = i.children.findLastIndex(r), m = i.children[u].id;
        return e == m;
      }
    },
    toggleParentCollapsible({ itemId: e }) {
      const t = this.activeItem.children.findIndex((r) => r.id === e);
      this.activeItem.children.filter((r) => r.id !== e).forEach(
        (r) => this.activeItem.children[this.activeItem.children.indexOf(r)].childrenVisible = !1
      ), this.activeItem.children[t].childrenVisible = !this.activeItem.children[t].childrenVisible;
    },
    nextTabAction({ itemId: e, isIconButton: t, isBackwardsTab: n }, r) {
      const o = this.canTriggerCloseFirstItem(e, t, r), i = this.canTriggerCloseLastItem(e, t, r);
      if (o && n) {
        this.handleClose();
        return;
      }
      if (i && !n) {
        this.handleClose();
        return;
      }
    },
    onKeydown(e) {
      e.key === "Escape" && !qr(this.activeItem) && this.handleClose();
    },
    temporalHide() {
      this.isMoreDropdownVisible = !1, this.isTemporarilyHideMenu = !0;
    },
    handleDropdownMenuOpen(e) {
      clearTimeout(this.openMoreMenuDropDown), this.openMoreMenuDropDown = setTimeout(() => {
        this.onMenuItemClick(e);
      }, 300);
    },
    preventClose(e) {
      this.preventMouseLeaveClose = !1, clearTimeout(this.moreMenuTimeout), clearTimeout(this.menuTimeout), clearTimeout(this.hideMenuTimeOut), clearTimeout(this.openMoreMenuDropDown), this.onMenuItemClick(e, !0);
    },
    preventCloseDrawer() {
      this.preventMouseLeaveClose = !0;
    },
    onMenuItemClick(e, t) {
      if (t && this.hideMoreMenu(), !e) {
        this.hideDrawer();
        return;
      }
      this.$emit("close-menu"), this.activeItem = e;
    },
    focusSubMenu(e) {
      this.activeItem = e;
      const n = this.$refs[`drawer-${e.id}`][0].$refs["drawer-wrapper"];
      n.tabIndex = 0, n.focus(), this.hideMoreMenu();
    },
    handleDrawerToggle(e) {
      if (e) {
        if (e.id === "schoolsbutton" && this.content.hasCustomSchoolsMenu && this.customSchoolsMenuVisible === !1 ? this.showItem(e) : this.customSchoolsMenuVisible = !1, !this.activeItem) {
          this.hideDrawer(), this.activeItem = e;
          return;
        }
        if (!e || !e.children || !e.children.length) {
          this.hideDrawer();
          return;
        }
        e.id === this.activeItem.id ? this.hideDrawer() : this.activeItem = e;
      }
    },
    handleMoreMenuToggle(e) {
      clearTimeout(this.moreMenuTimeout), clearTimeout(this.hideMenuTimeOut), clearTimeout(this.menuTimeout), this.moreMenuTimeout = setTimeout(() => {
        this.$emit("close-menu"), e ? this.isMoreDropdownVisible = e : this.isMoreDropdownVisible = !this.isMoreDropdownVisible;
      }, 220);
    },
    handleClose(e) {
      this.hideDrawer(e), this.hideMoreMenu();
    },
    hideMoreMenu() {
      this.isMoreDropdownVisible = !1;
    },
    showDrawer(e) {
      var t, n, r;
      return ((t = this.activeItem) == null ? void 0 : t.id) === e.id && ((r = (n = this.activeItem) == null ? void 0 : n.children) == null ? void 0 : r.length) > 0;
    },
    hideDrawer(e) {
      (!this.preventMouseLeaveClose || e !== "mouseleave") && (this.activeItem = null);
    },
    updateParentWidth() {
      this.parentWidth = this.getWrapperWidth();
    },
    getWrapperWidth() {
      const e = this.theme.version === "M5" ? this.$refs["bar-nav-menu-bar"] : this.$refs["m4-menu--bar"], t = window.getComputedStyle(e, null).getPropertyValue("padding-left"), n = window.getComputedStyle(e, null).getPropertyValue("padding-right");
      return e.clientWidth - parseInt(t, 10) - parseInt(n, 10);
    },
    calculateUnderlappedItems() {
      var o;
      let e = 0;
      const t = {}, n = this.$refs["bar-nav-item-wrapper"];
      let r = this.getWrapperWidth();
      if (this.theme.version === "M5") {
        this.$refs["bar-end-options"];
        const i = ((o = this.$refs["bar-end-options"]) == null ? void 0 : o.clientWidth) || 0;
        r -= i;
      }
      this.visibleItems = this.content.sitemapMenuItems, clearTimeout(this.timer), this.timer = setTimeout(() => {
        this.totalElementsWidth > r ? (this.displayMoreButton = !0, r -= this.moreBtnWidth) : this.displayMoreButton = !1, Object.entries(n.childNodes).forEach((s) => {
          if (this.theme.version === "M5") {
            const u = Array.from(s[1].childNodes).find((m) => m.className === "bar-menu-item");
            u && (e += u.clientWidth, e > r && (t[u.id] = u));
          } else s[1].className === "m4--menu-item" && (e += s[1].clientWidth, e > r && (t[s[1].id] = s[1]));
        });
        const i = Object.entries(t).map(([s, l]) => this.content.sitemapMenuItems.find((u) => +u.id == +s)).sort((s, l) => s.position - l.position), a = this.content.sitemapMenuItems.filter((s) => !i.find((l) => s && l && s.id === l.id)).sort((s, l) => s.position - l.position);
        this.underLappedItems = i, this.visibleItems = a;
      }, 50);
    },
    navigate(e) {
      let t;
      if (!e)
        return null;
      switch (e.type) {
        case "page":
          t = `${this.content.pathPrefix}/page/${e.slug}`;
          break;
        case "link":
          e.mailto && e.email_address ? t = `mailto:${e.email_address}` : t = e.url;
          break;
        case "explore":
          t = this.content.pathPrefix + e.slug;
          break;
        default:
          return null;
      }
      return e.opens_in_new_tab ? window.open(t) : window.location.href = t, null;
    },
    showItem(e) {
      this.customSchoolsMenuVisible = !1, e.id === "schoolsbutton" && this.content.hasCustomSchoolsMenu && (this.customSchoolsMenuVisible = !0), clearTimeout(this.menuTimeout), this.menuTimeout = setTimeout(() => {
        this.onMenuItemClick(e, !0);
      }, 220);
    },
    mouseLeaveMenu() {
      clearTimeout(this.menuTimeout), clearTimeout(this.moreMenuTimeout), clearTimeout(this.hideMenuTimeOut), this.hideMenuTimeOut = setTimeout(() => {
        this.content.hasCustomSchoolsMenu && (this.customSchoolsMenuVisible = !1), this.handleClose("mouseleave");
      }, 600);
    },
    mouseEnterMenu() {
      this.hideMenuTimeOut && clearTimeout(this.hideMenuTimeOut);
    }
  }
}, cI = {
  name: "MenuItemType",
  props: {
    item: {
      type: Object,
      default: () => ({}),
      required: !0
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    moreMenuTitle: {
      type: String,
      default: null
    },
    fillColor: {
      type: String,
      default: "#000"
    }
  },
  emits: ["handle-header-click"],
  computed: {
    href() {
      if (!this.item)
        return null;
      switch (this.item.type) {
        case "page":
          return `${this.pathPrefix}/page/${this.item.slug}`;
        case "link":
          return this.getLinkHref;
        case "explore":
          return this.getExploreHref;
        case "header":
          return null;
        default:
          return null;
      }
    },
    iconVisible() {
      return (this.item.icon || this.item.icon_cms) && this.item.id !== "explore-button" && this.item.id !== "schoolsbutton";
    },
    noChildren() {
      var e;
      return ((e = this.item.children) == null ? void 0 : e.length) === 0;
    },
    getExploreHref() {
      var e;
      return (e = this.item.slug) != null && e.includes("http") ? this.item.slug : this.pathPrefix + this.item.slug;
    },
    getLinkHref() {
      return this.item ? this.item.mailto && this.item.email_address ? `mailto:${this.item.email_address}` : this.item.ipAddress ? `http://${this.item.url}` : this.item.url : null;
    },
    colors() {
      return {
        "--icon-fill-color": this.fillColor
      };
    }
  }
}, hI = { class: "m4--menu-item-focusable" }, mI = ["innerHTML"], fI = ["href", "target"], pI = { key: 0 };
function gI(e, t, n, r, o, i) {
  return d(), f("span", hI, [
    i.iconVisible ? (d(), f("div", {
      key: 0,
      class: _(["item-icon", { "global-icon": n.item.cms_icon_id }]),
      style: Z(i.colors),
      innerHTML: n.item.cms_icon_id ? n.item.icon_cms : n.item.icon
    }, null, 14, mI)) : i.href ? (d(), f("a", {
      key: 1,
      href: i.href,
      target: n.item.opens_in_new_tab ? "_blank" : void 0,
      class: "m4--menu-item-link"
    }, k(n.item.name), 9, fI)) : (d(), f(J, { key: 2 }, [
      n.moreMenuTitle ? (d(), f("span", pI, k(n.moreMenuTitle), 1)) : (d(), f("span", {
        key: 1,
        class: _(["item-type-header", { "no-children": i.noChildren }]),
        onClick: t[0] || (t[0] = (a) => e.$emit("handle-header-click"))
      }, k(n.item.translatedTitle || n.item.name), 3))
    ], 64))
  ]);
}
const F4 = /* @__PURE__ */ B(cI, [["render", gI], ["__scopeId", "data-v-09de12df"]]), vI = {
  name: "M4MainItem",
  components: { MenuItemType: F4, DropdownArrowIcon: Mo },
  props: {
    item: {
      type: Object,
      default: void 0
    },
    forceShow: Boolean,
    moreMenuItem: {
      type: String,
      default: null
    },
    moreMenuVisible: Boolean,
    isMoreMenuItem: Boolean,
    themeStyle: {
      type: String,
      default: null
    },
    colors: {
      type: Object,
      default: null
    },
    activeId: {
      type: [String, Number],
      default: null
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    firstItemId: {
      type: Number,
      default: 0
    },
    lastItemId: {
      type: Number,
      default: 0
    }
  },
  emits: ["toggle-more-menu", "close", "toggle-drawer", "navigate", "mouseover", "focus-sub-menu"],
  computed: {
    isActive() {
      var e;
      return this.moreMenuItem ? this.moreMenuVisible : ((e = this.item) == null ? void 0 : e.id) === this.activeId;
    },
    iconClass() {
      return this.isActive ? "open" : void 0;
    },
    iconColor() {
      if (this.colors)
        return this.isMoreMenuItem ? this.colors["--more-text-color"] : this.colors["--text-color"];
    },
    itemId() {
      return this.moreMenuItem ? "more-menu-item" : this.item ? this.item.id : "";
    },
    hasChildren() {
      var e, t;
      return !!((t = (e = this.item) == null ? void 0 : e.children) != null && t.length);
    },
    hasFocusableChildren() {
      var t, n, r;
      const e = (o) => {
        var i;
        return [o, ...((i = o.children) == null ? void 0 : i.map((a) => e(a))) || []].flat();
      };
      return (r = (n = (t = this.item.children) == null ? void 0 : t.map((o) => e(o))) == null ? void 0 : n.flat()) == null ? void 0 : r.filter((o) => o.type !== "header").length;
    },
    isHeader() {
      var e;
      return ((e = this.item) == null ? void 0 : e.type) === "header";
    },
    hasSlug() {
      var e;
      return (e = this.item) == null ? void 0 : e.slug;
    },
    ariaId() {
      return this.moreMenuItem ? "menu-button-more" : `menu-button-${this.item ? this.item.id : ""}`;
    },
    ariaHasPopup() {
      return this.moreMenuItem ? "true" : this.hasChildren ? "dialog" : "false";
    },
    ariaControls() {
      return this.moreMenuItem ? "more-menu-dropdown" : this.hasChildren ? `drawer-${this.item ? this.item.id : ""}` : void 0;
    },
    ariaExpanded() {
      if (this.moreMenuItem)
        return this.moreMenuVisible ? "true" : "false";
      if (this.hasChildren)
        return this.isActive ? "true" : "false";
    },
    ariaLabel() {
      if (!this.isHeader && this.hasChildren)
        return `Toggle ${this.item.name} Submenu`;
    },
    showTransition() {
      var e, t;
      return ((t = (e = this.item) == null ? void 0 : e.children) == null ? void 0 : t.length) > 0 && !this.isMoreMenuItem && !this.moreMenuItem && this.isActive;
    }
  },
  methods: {
    handleEnterEvent(e) {
      if (this.moreMenuItem) {
        this.$emit("toggle-more-menu", !this.moreMenuVisible);
        return;
      }
      if (!this.item) {
        this.$emit("close");
        return;
      }
      if (this.isHeader || e === !0) {
        this.$emit("toggle-drawer", this.item);
        return;
      }
      this.$emit("navigate", this.item);
    },
    /**  handling this behavior here because M4MainItem is shared.
     M4MainItem is found in the top level of the Menu Items in the bar
     and within the More Dropdown**/
    handleNextTab(e, t) {
      var s, l;
      const n = e.shiftKey, r = this.isActive, o = this.activeId && r, i = ((s = this.item) == null ? void 0 : s.id) === this.firstItemId, a = ((l = this.item) == null ? void 0 : l.id) === this.lastItemId;
      if (n) {
        if (this.isMoreMenuItem && i && !t) {
          this.$emit("close");
          return;
        }
        if (!this.isMoreMenuItem && r) {
          this.$emit("close");
          return;
        }
        if (a && t && this.hasChildren && o) {
          this.$emit("close");
          return;
        }
      } else {
        if (o && (t && this.hasFocusableChildren || this.isHeader)) {
          this.$emit("focus-sub-menu", this.item);
          return;
        }
        if (this.moreMenuItem === "More") return;
        this.hasFocusableChildren === 0 && !this.isMoreMenuItem && r && this.$emit("close"), a && (!this.hasChildren || t && this.hasChildren && !o) && this.$emit("close");
      }
    }
  }
}, bI = ["id"], yI = ["id", "aria-controls", "aria-expanded", "aria-haspopup", "aria-label"], _I = ["id"], CI = ["aria-expanded", "aria-label", "aria-haspopup", "aria-controls"], wI = {
  class: "m4--menu-item-focusable",
  tabindex: "-1"
}, TI = { class: "sr-only" }, kI = { class: "sr-only" }, EI = {
  key: 0,
  class: "m4--menu-item-active-line"
};
function SI(e, t, n, r, o, i) {
  const a = V("MenuItemType"), s = V("DropdownArrowIcon");
  return n.forceShow || n.moreMenuItem || n.item ? (d(), f("div", {
    key: 0,
    id: i.itemId,
    ref: i.itemId,
    class: _(["m4--menu-item", {
      "m4--menu-dropdown-item": n.isMoreMenuItem,
      "m4--menu-item-active": !n.isMoreMenuItem && i.isActive
    }]),
    onMouseover: t[13] || (t[13] = W((l) => e.$emit("mouseover", n.item), ["stop", "prevent"])),
    onClick: t[14] || (t[14] = W((...l) => i.handleEnterEvent && i.handleEnterEvent(...l), ["exact", "stop", "prevent"])),
    onTouchstart: t[15] || (t[15] = W((...l) => i.handleEnterEvent && i.handleEnterEvent(...l), ["exact", "stop", "prevent"]))
  }, [
    n.item && n.item.type === "header" && i.hasChildren || n.moreMenuItem === "More" ? (d(), f("button", {
      key: 0,
      id: i.ariaId,
      "aria-controls": i.ariaControls,
      "aria-expanded": i.ariaExpanded,
      "aria-haspopup": i.ariaHasPopup,
      class: _(["m4--menu-item-text", {
        "m4--menu-dropdown-item-active": i.isActive,
        [n.themeStyle]: !!n.themeStyle
      }]),
      "aria-label": n.moreMenuItem === "More" ? "Show submenu for More" : `Show submenu for ${n.item && n.item.name}`,
      onKeydown: [
        t[0] || (t[0] = K(W((l) => i.handleEnterEvent(!0), ["exact", "stop", "prevent"]), ["enter"])),
        t[1] || (t[1] = K((l) => i.handleNextTab(l, !0), ["tab"]))
      ],
      onTouchstart: t[2] || (t[2] = W((...l) => i.handleEnterEvent && i.handleEnterEvent(...l), ["exact", "stop", "prevent"]))
    }, [
      j(a, {
        "path-prefix": n.pathPrefix,
        "more-menu-title": n.moreMenuItem,
        item: n.item
      }, null, 8, ["path-prefix", "more-menu-title", "item"])
    ], 42, yI)) : (d(), f("div", {
      key: 1,
      id: i.ariaId,
      class: _(["m4--menu-item-text", {
        "m4--menu-dropdown-item-active": i.isActive,
        [n.themeStyle]: !!n.themeStyle
      }])
    }, [
      j(a, {
        "path-prefix": n.pathPrefix,
        "more-menu-title": n.moreMenuItem,
        item: n.item,
        onKeydown: t[3] || (t[3] = K((l) => i.handleNextTab(l), ["tab"]))
      }, null, 8, ["path-prefix", "more-menu-title", "item"])
    ], 10, _I)),
    i.isHeader ? T("", !0) : (d(), f(J, { key: 2 }, [
      i.hasChildren ? (d(), f("button", {
        key: 0,
        class: "m4--menu-item-icon",
        "aria-expanded": i.ariaExpanded,
        "aria-label": i.ariaLabel,
        "aria-haspopup": i.ariaHasPopup,
        "aria-controls": i.ariaControls,
        onKeydown: [
          t[4] || (t[4] = K(W((l) => i.handleEnterEvent(!0), ["exact", "stop", "prevent"]), ["enter"])),
          t[5] || (t[5] = K((l) => i.handleNextTab(l, !0), ["tab"]))
        ],
        onTouchstart: t[6] || (t[6] = W((l) => i.handleEnterEvent(!0), ["exact", "stop", "prevent"])),
        onClick: t[7] || (t[7] = W((l) => i.handleEnterEvent(!0), ["stop", "prevent"]))
      }, [
        c("span", wI, [
          j(s, {
            "dropdown-class": i.iconClass,
            "fill-color": i.iconColor
          }, null, 8, ["dropdown-class", "fill-color"]),
          c("span", TI, " Show submenu for " + k(n.item && n.item.name), 1)
        ])
      ], 40, CI)) : T("", !0)
    ], 64)),
    i.isHeader || n.moreMenuItem ? (d(), f(J, { key: 3 }, [
      n.moreMenuItem || i.hasChildren ? (d(), f("span", {
        key: 0,
        class: "m4--menu-item-icon",
        onMouseover: t[8] || (t[8] = W(() => {
        }, ["stop", "prevent"])),
        onTouchstart: t[9] || (t[9] = W((...l) => i.handleEnterEvent && i.handleEnterEvent(...l), ["exact", "stop", "prevent"])),
        onKeydown: [
          t[10] || (t[10] = K((l) => i.handleNextTab(l, !0), ["tab"])),
          t[12] || (t[12] = K(W((l) => i.handleEnterEvent(!0), ["exact", "stop", "prevent"]), ["enter"]))
        ],
        onClick: t[11] || (t[11] = W((...l) => i.handleEnterEvent && i.handleEnterEvent(...l), ["exact", "stop", "prevent"]))
      }, [
        j(s, {
          "dropdown-class": i.iconClass,
          "fill-color": i.iconColor
        }, null, 8, ["dropdown-class", "fill-color"]),
        c("span", kI, " Show submenu for " + k(n.item && n.item.name), 1)
      ], 32)) : T("", !0)
    ], 64)) : T("", !0),
    j(Le, { name: "slide-fade-up" }, {
      default: S(() => [
        i.showTransition ? (d(), f("hr", EI)) : T("", !0)
      ]),
      _: 1
    })
  ], 42, bI)) : T("", !0);
}
const R4 = /* @__PURE__ */ B(vI, [["render", SI], ["__scopeId", "data-v-b1ec7e1d"]]), MI = {
  props: {
    fillColor: {
      type: String,
      default: "#fff"
    }
  }
}, AI = ["fill"];
function II(e, t, n, r, o, i) {
  return d(), f("svg", {
    class: "plus",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: n.fillColor,
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true"
  }, t[0] || (t[0] = [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.85721 0H7.14293V7.14283H0V7.85714H7.14293V15H7.85721V7.85714H15V7.14283H7.85721V0Z"
    }, null, -1)
  ]), 8, AI);
}
const V4 = /* @__PURE__ */ B(MI, [["render", II]]), LI = {
  props: {
    fillColor: {
      type: String,
      default: "#fff"
    }
  }
}, DI = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}, $I = ["fill"];
function OI(e, t, n, r, o, i) {
  return d(), f("svg", DI, [
    c("path", {
      fill: n.fillColor,
      d: "M2 7.5V8.5H14V7.5H2Z"
    }, null, 8, $I)
  ]);
}
const B4 = /* @__PURE__ */ B(LI, [["render", OI]]), PI = {
  name: "ImageElement",
  props: {
    item: {
      type: Object,
      required: !0
    }
  },
  computed: {
    href() {
      return this.item ? this.item.url : null;
    }
  }
}, NI = {
  class: "m4--menu-item-focusable",
  tabindex: "-1"
}, HI = ["src", "alt"];
function FI(e, t, n, r, o, i) {
  return d(), f("span", NI, [
    (d(), L(Y(i.href ? "a" : "div"), {
      href: i.href,
      target: n.item.opens_in_new_tab ? "_blank" : void 0,
      class: "m4--menu-item-link",
      tabindex: "-1"
    }, {
      default: S(() => [
        c("img", {
          src: n.item.imgSrc,
          alt: n.item.altText
        }, null, 8, HI)
      ]),
      _: 1
    }, 8, ["href", "target"]))
  ]);
}
const RI = /* @__PURE__ */ B(PI, [["render", FI], ["__scopeId", "data-v-a0cf2cf9"]]), VI = {
  name: "M4DrawerElement",
  components: { MenuItemType: F4, ImageElement: RI, MenuPlusIcon: V4, MenuMinusIcon: B4, DropdownArrowIcon: Mo },
  props: {
    elemData: {
      type: Object,
      default: null
    },
    themeStyle: {
      type: String,
      default: ""
    },
    isMobile: Boolean,
    colors: {
      type: Object,
      default: void 0
    },
    activeParent: {
      type: [String, Number],
      default: null
    },
    activeChild: {
      type: [String, Number],
      default: null
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    nestLevel: {
      type: Number,
      default: 0
    },
    newMobileHeaderElement: Boolean
  },
  emits: ["navigate", "toggle-child", "toggle-parent", "next-tab"],
  computed: {
    iconColor() {
      if (this.colors)
        return this.isMobile && this.newMobileHeaderElement ? this.colors["--mobile-menu-text-color"] : this.colors["--dropdown-text-color"];
    },
    hasChildren() {
      var e;
      return !!((e = this.elemData) != null && e.children.length);
    },
    showChildren() {
      return Number.isNaN(+this.activeParent) ? this.activeParent === this.elemData.id : +this.activeParent == +this.elemData.id;
    },
    isChild() {
      return this.nestLevel >= 1;
    },
    isSubChild() {
      return this.nestLevel >= 2;
    },
    ariaParentId() {
      return `menu-button-${this.elemData.id}`;
    },
    ariaExpanded() {
      if (this.hasChildren)
        return this.showChildren ? "true" : "false";
    },
    ariaControls() {
      if (this.hasChildren)
        return this.ariaChildId;
    },
    ariaChildId() {
      return `${this.elemData.id}-collapsible`;
    },
    ariaHasPopup() {
      return this.hasChildren ? "true" : "false";
    }
  },
  methods: {
    toggleParentCollapsible() {
      this.$emit("toggle-parent", this.elemData);
    },
    handleEnterEvent() {
      this.$emit("navigate", this.elemData);
    },
    handleNextTab(e, t, n) {
      this.$emit("next-tab", { itemId: e, isIconButton: t, isBackwardsTab: n });
    }
  }
}, BI = ["id"], jI = ["id"], UI = ["aria-expanded", "aria-controls", "aria-haspopup"], qI = {
  class: "m4--drawer-element-focusable",
  tabindex: "-1"
}, GI = {
  key: 3,
  class: "sr-only"
}, KI = ["id", "aria-labelledby"];
function zI(e, t, n, r, o, i) {
  const a = V("ImageElement"), s = V("MenuItemType"), l = V("MenuPlusIcon"), u = V("MenuMinusIcon"), m = V("DropdownArrowIcon"), v = V("M4DrawerElement", !0);
  return d(), f("div", {
    role: "menuitem",
    class: _(["m4--drawer-element", {
      "mobile-element": n.isMobile,
      "new-mobile-header": n.newMobileHeaderElement,
      "child-element": i.isChild,
      "has-children": i.hasChildren,
      "has-icon": n.elemData.icon || n.elemData.icon_cms,
      "sub-child": i.isSubChild,
      "image-element": n.elemData.type === "image"
    }]),
    style: Z(n.colors)
  }, [
    c("div", {
      id: n.elemData.id,
      class: "m4--drawer-element-title",
      onClick: t[4] || (t[4] = (...g) => i.toggleParentCollapsible && i.toggleParentCollapsible(...g))
    }, [
      c("div", {
        id: i.ariaParentId,
        class: _(["m4--drawer-element-title-text", n.themeStyle]),
        onClick: t[1] || (t[1] = W(() => {
        }, ["stop"]))
      }, [
        n.elemData.type === "image" ? (d(), L(a, {
          key: 0,
          item: n.elemData
        }, null, 8, ["item"])) : (d(), L(s, {
          key: 1,
          "path-prefix": n.pathPrefix,
          item: n.elemData,
          "fill-color": i.iconColor,
          onHandleHeaderClick: i.toggleParentCollapsible,
          onKeydown: [
            t[0] || (t[0] = K((g) => i.handleNextTab(n.elemData.id, !1, g.shiftKey), ["tab"])),
            K(i.handleEnterEvent, ["enter"])
          ]
        }, null, 8, ["path-prefix", "item", "fill-color", "onHandleHeaderClick", "onKeydown"]))
      ], 10, jI),
      n.elemData.children.length ? (d(), f(J, { key: 0 }, [
        n.elemData.children.length ? (d(), f("button", {
          key: 0,
          "aria-expanded": i.ariaExpanded,
          "aria-controls": i.ariaControls,
          "aria-haspopup": i.ariaHasPopup,
          class: "m4--drawer-element-title-icon",
          onClick: t[2] || (t[2] = W((...g) => i.toggleParentCollapsible && i.toggleParentCollapsible(...g), ["stop", "prevent"])),
          onKeydown: t[3] || (t[3] = K((g) => i.handleNextTab(n.elemData.id, !0, g.shiftKey), ["tab"]))
        }, [
          c("span", qI, [
            n.isMobile && !i.showChildren ? (d(), L(l, {
              key: 0,
              "fill-color": i.iconColor
            }, null, 8, ["fill-color"])) : n.isMobile && i.showChildren ? (d(), L(u, {
              key: 1,
              "fill-color": i.iconColor
            }, null, 8, ["fill-color"])) : T("", !0),
            n.isMobile ? T("", !0) : (d(), L(m, {
              key: 2,
              "fill-color": i.iconColor,
              "dropdown-class": i.showChildren ? "open" : "close"
            }, null, 8, ["fill-color", "dropdown-class"])),
            n.elemData && n.elemData.name ? (d(), f("span", GI, " Show submenu for " + k(n.elemData.name), 1)) : T("", !0)
          ])
        ], 40, UI)) : T("", !0)
      ], 64)) : T("", !0)
    ], 8, BI),
    j(Le, { name: "collapse-in" }, {
      default: S(() => [
        i.hasChildren ? we((d(), f("div", {
          key: 0,
          id: i.ariaChildId,
          "aria-labelledby": i.ariaParentId,
          class: _(["m4--drawer-children", { "show-children": i.showChildren }])
        }, [
          (d(!0), f(J, null, ne(n.elemData.children, (g) => (d(), L(v, {
            key: g.id,
            "elem-data": g,
            "is-mobile": n.isMobile,
            "theme-style": n.themeStyle,
            "active-parent": n.activeChild,
            "path-prefix": n.pathPrefix,
            colors: n.colors,
            "new-mobile-header-element": n.newMobileHeaderElement,
            "nest-level": n.nestLevel + 1,
            onToggleParent: t[5] || (t[5] = (h) => e.$emit("toggle-child", h)),
            onNextTab: (h) => i.handleNextTab(g.id, !1, h.isBackwardsTab),
            onNavigate: t[6] || (t[6] = (h) => e.$emit("navigate", h))
          }, null, 8, ["elem-data", "is-mobile", "theme-style", "active-parent", "path-prefix", "colors", "new-mobile-header-element", "nest-level", "onNextTab"]))), 128))
        ], 10, KI)), [
          [qn, i.showChildren]
        ]) : T("", !0)
      ]),
      _: 1
    })
  ], 6);
}
const j4 = /* @__PURE__ */ B(VI, [["render", zI], ["__scopeId", "data-v-4331a2f6"]]), ZI = {
  name: "M4MobileMenu",
  components: { M4DrawerElement: j4 },
  props: {
    isVisible: {
      type: Boolean,
      default: !1
    },
    menuItems: {
      type: Array,
      default: () => []
    },
    colors: {
      type: Object,
      default: void 0
    },
    pathPrefix: {
      type: String,
      default: ""
    }
  },
  emits: ["navigate", "close-menu"],
  data() {
    return {
      activeParent: null,
      activeChild: null,
      localItems: []
    };
  },
  computed: {
    styles() {
      return ae({}, this.colors);
    }
  },
  beforeUpdate() {
    this.isVisible || (this.activeParent = null, this.activeChild = null);
  },
  mounted() {
    this.localItems = this.menuItems.filter((e) => e.name === "Explore" ? e.children && e.children.length >= 1 : !0), this.$parent.$parent.$refs.schoolsbutton && this.$parent.$parent.$refs.schoolsbutton.$el.addEventListener("focus", this.$emit("close-menu")), this.$parent.$parent.$refs.schoolsbuttonMobile && this.$parent.$parent.$refs.schoolsbuttonMobile.$el.addEventListener("focus", this.$emit("close-menu"));
  },
  beforeUnmount() {
    this.$parent.$parent.$refs.schoolsbutton && this.$parent.$parent.$refs.schoolsbutton.$el.removeEventListener("focus", this.$emit("close-menu")), this.$parent.$parent.$refs.schoolsbuttonMobile && this.$parent.$parent.$refs.schoolsbuttonMobile.$el.removeEventListener("focus", this.$emit("close-menu"));
  },
  methods: {
    handleToggleParent(e) {
      if (!e) {
        this.activeParent = null;
        return;
      }
      if (e.id === this.activeParent) {
        this.activeParent = null;
        return;
      }
      this.activeParent = e.id;
    },
    handleToggleChild(e) {
      if (!e) {
        this.activeChild = null;
        return;
      }
      if (e.id === this.activeChild) {
        this.activeChild = null;
        return;
      }
      this.activeChild = e.id;
    },
    handleNavigate(e) {
      this.$emit("navigate", e);
    }
  }
};
function xI(e, t, n, r, o, i) {
  const a = V("M4DrawerElement");
  return d(), L(Le, { name: "slide-fade-up" }, {
    default: S(() => [
      we(c("div", {
        style: Z(i.styles),
        class: "m4-menu--mobile-wrapper"
      }, [
        (d(!0), f(J, null, ne(o.localItems, (s) => (d(), L(a, {
          ref_for: !0,
          ref: "drawerElement",
          key: `${s.name}-${s.id}`,
          "elem-data": s,
          "is-mobile": !0,
          colors: n.colors,
          "active-parent": o.activeParent,
          "active-child": o.activeChild,
          "path-prefix": n.pathPrefix,
          onToggleParent: i.handleToggleParent,
          onToggleChild: i.handleToggleChild,
          onNavigate: i.handleNavigate
        }, null, 8, ["elem-data", "colors", "active-parent", "active-child", "path-prefix", "onToggleParent", "onToggleChild", "onNavigate"]))), 128))
      ], 4), [
        [qn, n.isVisible]
      ])
    ]),
    _: 1
  });
}
const WI = /* @__PURE__ */ B(ZI, [["render", xI], ["__scopeId", "data-v-5d2991ec"]]), YI = {
  name: "M4MoreMenuDropdown",
  components: { M4MainItem: R4 },
  props: {
    isVisible: {
      type: Boolean,
      default: !1
    },
    dropdownId: {
      type: String,
      default: "h4-menu--dropdown"
    },
    moreItems: {
      type: Array,
      default: () => []
    },
    activeId: {
      type: [String, Number],
      default: null
    },
    colors: {
      type: Object,
      default: null
    },
    pathPrefix: {
      type: String,
      default: ""
    }
  },
  emits: ["mouseleave", "toggle-drawer", "navigate", "open", "close", "toggle-more-menu", "focus-sub-menu"],
  computed: {
    ariaId() {
      return "more-menu-dropdown";
    },
    ariaLabelledBy() {
      return "menu-button-more";
    },
    ariaExpanded() {
      return this.isVisible ? "true" : "false";
    },
    lastItemId() {
      const e = (n) => {
        var r;
        return n.type !== "header" || ((r = n.children) == null ? void 0 : r.length) > 0;
      }, t = this.moreItems.findLastIndex(e);
      return this.moreItems[t].id;
    },
    firstItemId() {
      var n;
      const e = (r) => {
        var o;
        return r.type !== "header" || ((o = r.children) == null ? void 0 : o.length) > 0;
      }, t = this.moreItems.findIndex(e);
      return (n = this.moreItems[t]) == null ? void 0 : n.id;
    }
  }
}, XI = ["id", "aria-labelledby", "aria-expanded"];
function QI(e, t, n, r, o, i) {
  const a = V("M4MainItem");
  return d(), f("div", {
    id: i.ariaId,
    "aria-labelledby": i.ariaLabelledBy,
    "aria-expanded": i.ariaExpanded,
    class: "m4-menu--dropdown-item-wrapper",
    onMouseleave: t[4] || (t[4] = (s) => e.$emit("mouseleave"))
  }, [
    (d(!0), f(J, null, ne(n.moreItems, (s) => (d(), f(J, null, [
      s ? (d(), L(a, {
        ref_for: !0,
        ref: `more-${s.id}`,
        key: s.id,
        item: s,
        "force-show": !0,
        "is-more-menu-item": !0,
        "first-item-id": i.firstItemId,
        "last-item-id": i.lastItemId,
        "active-id": n.activeId,
        "is-active": s.id === n.activeId,
        colors: n.colors,
        "path-prefix": n.pathPrefix,
        onNavigate: (l) => e.$emit("navigate", s),
        onMouseover: (l) => e.$emit("open", s),
        onToggleMoreMenu: t[0] || (t[0] = (l) => e.$emit("toggle-more-menu", l)),
        onToggleDrawer: t[1] || (t[1] = (l) => e.$emit("toggle-drawer", l)),
        onClose: t[2] || (t[2] = (l) => e.$emit("close")),
        onFocusSubMenu: t[3] || (t[3] = (l) => e.$emit("focus-sub-menu", l))
      }, null, 8, ["item", "first-item-id", "last-item-id", "active-id", "is-active", "colors", "path-prefix", "onNavigate", "onMouseover"])) : T("", !0)
    ], 64))), 256))
  ], 40, XI);
}
const JI = /* @__PURE__ */ B(YI, [["render", QI], ["__scopeId", "data-v-b58cb58f"]]), eL = {
  name: "M4Drawer",
  components: { M4DrawerElement: j4 },
  props: {
    activeItem: {
      type: Object,
      default: void 0
    },
    themeStyle: {
      type: String,
      default: "light"
    },
    colors: {
      type: Object,
      default: void 0
    },
    isMoreMenuActive: {
      type: Boolean,
      default: !1
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    isOpen: {
      type: Boolean,
      default: !1
    },
    isTemporarilyHideMenu: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["mouseenter", "mouseleave", "hide-drawer", "close", "prevent-close", "toggle-parent", "next-tab", "navigate"],
  data() {
    return {
      activeParent: null,
      scrollWidth: !1
    };
  },
  computed: {
    itemId() {
      return `drawer-${this.activeItem.id}`;
    }
  },
  watch: {
    isOpen(e) {
      if (e) {
        const { scrollWidth: t, clientWidth: n } = this.$refs["drawer-wrapper"];
        t > n && (this.scrollWidth = !0);
      }
    }
  },
  methods: {
    hideDrawer() {
      this.$emit("hide-drawer");
    },
    handleToggleParent(e) {
      if (!e) {
        this.activeParent = null;
        return;
      }
      if (e.id === this.activeParent) {
        this.activeParent = null, this.$emit("toggle-parent", { itemId: e.id });
        return;
      }
      this.$emit("prevent-close"), this.activeParent = e.id, this.$emit("toggle-parent", { itemId: e.id });
    }
  }
}, tL = ["id", "aria-labelledby"], nL = { class: "m4-menu--drawer-title" };
function rL(e, t, n, r, o, i) {
  const a = V("M4DrawerElement");
  return d(), f("div", {
    id: i.itemId,
    ref: i.itemId,
    "aria-labelledby": `menu-button-${n.activeItem.id}`,
    "aria-modal": "true",
    class: "m4-menu--drawer",
    style: Z({ flexDirection: o.scrollWidth ? "column" : "row" }),
    onMouseleave: t[2] || (t[2] = W((s) => e.$emit("mouseleave"), ["exact", "stop", "prevent"])),
    onMouseenter: t[3] || (t[3] = (s) => e.$emit("mouseenter"))
  }, [
    c("div", nL, [
      c("h2", {
        class: _(n.themeStyle)
      }, k(n.activeItem.name), 3)
    ]),
    c("div", {
      ref: "drawer-wrapper",
      class: _(["m4-menu--drawer-content-wrapper", { scrollWidth: o.scrollWidth }])
    }, [
      (d(!0), f(J, null, ne(n.activeItem.children, (s) => (d(), L(a, {
        key: s.id,
        "elem-data": s,
        colors: n.colors,
        "theme-style": n.themeStyle,
        "active-parent": o.activeParent,
        "path-prefix": n.pathPrefix,
        onToggleParent: i.handleToggleParent,
        onNextTab: t[0] || (t[0] = (l) => e.$emit("next-tab", l)),
        onNavigate: t[1] || (t[1] = (l) => e.$emit("navigate", l))
      }, null, 8, ["elem-data", "colors", "theme-style", "active-parent", "path-prefix", "onToggleParent"]))), 128))
    ], 2)
  ], 44, tL);
}
const oL = /* @__PURE__ */ B(eL, [["render", rL], ["__scopeId", "data-v-6a36474b"]]), iL = {
  name: "M4",
  components: {
    M4Drawer: oL,
    M4MobileMenu: WI,
    M4MoreMenuDropdown: JI,
    M4MainItem: R4
  },
  mixins: [Rs, H4],
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      required: !0
    },
    isPreview: Boolean,
    isMobile: Boolean
  },
  emits: ["close-menus", "toggle-mobile-menu"],
  setup() {
    const e = zt(), { hasFocus: t, activate: n, deactivate: r } = JA(e);
    return {
      activate: n,
      deactivate: r,
      hasFocus: t,
      m4MobileMenu: e
    };
  },
  computed: {
    showMobileMenu() {
      return this.content.showMenu;
    },
    moreBtnWidth() {
      var e, t;
      return ((t = (e = this.$refs) == null ? void 0 : e["m4-menu--more-wrapper"]) == null ? void 0 : t.clientWidth) || 10;
    },
    mobileMenuItems() {
      return [
        {
          id: "explore-header",
          name: "Explore",
          slug: "explore",
          type: "header",
          children: this.content.customMenuItems.map((e) => ({
            id: `explore-${e.id}`,
            name: e.name,
            slug: e.url,
            type: "explore",
            children: []
          }))
        },
        ...this.content.sitemapMenuItems
      ];
    }
  },
  watch: {
    async showMobileMenu() {
      this.isMobile && (this.showMobileMenu ? (await ri(), this.activate()) : (await ri(), this.deactivate()));
    }
  }
}, sL = { class: "m4-menu--align-right" }, aL = {
  ref: "bar-nav-item-wrapper",
  class: "m4-menu--bar-item-wrapper"
}, lL = {
  ref: "m4-menu--more-wrapper",
  class: "m4-menu--bar-dropdown-wrapper"
}, uL = { ref: "m4MobileMenu" };
function dL(e, t, n, r, o, i) {
  const a = V("M4MainItem"), s = V("M4Drawer"), l = V("M4MoreMenuDropdown"), u = V("Close"), m = V("M4MobileMenu"), v = ze("click-away");
  return d(), f("div", {
    id: "m4",
    style: Z(e.colors),
    class: _(["m4-menu", { loadingMenu: e.loadingMenu }])
  }, [
    c("div", {
      ref: "m4-menu--bar",
      class: "m4-menu--bar",
      onMouseleave: t[13] || (t[13] = (g) => e.mouseLeaveMenu()),
      onMouseenter: t[14] || (t[14] = (g) => e.mouseEnterMenu())
    }, [
      c("div", sL, [
        we((d(), f("div", aL, [
          (d(!0), f(J, null, ne(n.content.sitemapMenuItems, (g) => (d(), f(J, {
            key: g.id
          }, [
            we(j(a, {
              item: g,
              "active-id": e.activeItem ? e.activeItem.id : null,
              "theme-style": n.theme.style,
              colors: e.colors,
              "path-prefix": n.content.pathPrefix,
              onNavigate: e.navigate,
              onMouseover: (h) => e.showItem(g),
              onToggleDrawer: (h) => e.handleDrawerToggle(g),
              onClose: e.handleClose
            }, null, 8, ["item", "active-id", "theme-style", "colors", "path-prefix", "onNavigate", "onMouseover", "onToggleDrawer", "onClose"]), [
              [qn, e.visibleItems.find(({ id: h }) => h === g.id)]
            ]),
            j(Le, { name: "slide-fade-up" }, {
              default: S(() => [
                c("div", {
                  onMousemove: t[5] || (t[5] = (h) => e.preventMouseLeaveClose = !1)
                }, [
                  we(j(s, {
                    id: `drawer-${g.id}`,
                    ref_for: !0,
                    ref: `drawer-${g.id}`,
                    "active-item": g,
                    "theme-style": n.theme.style,
                    colors: e.colors,
                    "is-more-menu-active": e.isMoreDropdownVisible,
                    "is-open": e.activeItem && e.activeItem.id === g.id,
                    "path-prefix": n.content.pathPrefix,
                    "is-temporarily-hide-menu": e.isTemporarilyHideMenu,
                    onToggleParent: e.toggleParentCollapsible,
                    onPreventClose: t[0] || (t[0] = (h) => e.preventCloseDrawer(h)),
                    onNavigate: t[1] || (t[1] = (h) => e.navigate(h)),
                    onMouseleave: t[2] || (t[2] = (h) => e.hideDrawer("mouseleave")),
                    onClose: e.handleClose,
                    onHideDrawer: e.hideDrawer,
                    onMouseenter: t[3] || (t[3] = (h) => e.preventClose(e.activeItem)),
                    onNextTab: t[4] || (t[4] = (h) => e.nextTabAction(h))
                  }, null, 8, ["id", "active-item", "theme-style", "colors", "is-more-menu-active", "is-open", "path-prefix", "is-temporarily-hide-menu", "onToggleParent", "onClose", "onHideDrawer"]), [
                    [qn, e.showDrawer(g)]
                  ])
                ], 32)
              ]),
              _: 2
            }, 1024)
          ], 64))), 128))
        ])), [
          [v, e.hideDrawer]
        ]),
        we(c("div", lL, [
          j(a, {
            id: "m4-menu--bar-dropdown-button",
            "more-menu-item": e.translations.more_dropdown_title,
            "more-menu-visible": e.isMoreDropdownVisible,
            "force-show": !0,
            "theme-style": n.theme.style,
            colors: e.colors,
            "path-prefix": n.content.pathPrefix,
            onNavigate: e.navigate,
            onToggleMoreMenu: t[6] || (t[6] = (g) => e.handleMoreMenuToggle(g)),
            onMouseover: t[7] || (t[7] = (g) => e.handleMoreMenuToggle(!0)),
            onClose: e.handleClose
          }, null, 8, ["more-menu-item", "more-menu-visible", "theme-style", "colors", "path-prefix", "onNavigate", "onClose"]),
          j(Le, { name: "slide-fade-up" }, {
            default: S(() => [
              e.underLappedItems && e.isMoreDropdownVisible ? we((d(), L(l, {
                key: 0,
                ref: "moreDropdown",
                "active-id": e.activeItem ? e.activeItem.id : null,
                "is-visible": e.isMoreDropdownVisible,
                "more-items": e.underLappedItems,
                "theme-style": n.theme.style,
                colors: e.colors,
                "path-prefix": n.content.pathPrefix,
                onNavigate: e.navigate,
                onOpen: t[8] || (t[8] = (g) => e.handleDropdownMenuOpen(g)),
                onToggleMoreMenu: t[9] || (t[9] = (g) => e.handleMoreMenuToggle(g)),
                onToggleDrawer: t[10] || (t[10] = (g) => e.handleDrawerToggle(g)),
                onMouseleave: t[11] || (t[11] = (g) => e.preventClose(e.activeItem)),
                onFocusSubMenu: t[12] || (t[12] = (g) => e.focusSubMenu(g)),
                onClose: e.handleClose,
                onTemporarilyHideMenu: e.temporalHide
              }, null, 8, ["active-id", "is-visible", "more-items", "theme-style", "colors", "path-prefix", "onNavigate", "onClose", "onTemporarilyHideMenu"])), [
                [v, e.hideMoreMenu]
              ]) : T("", !0)
            ]),
            _: 1
          })
        ], 512), [
          [qn, e.displayMoreButton]
        ])
      ])
    ], 544),
    n.isMobile ? (d(), f("div", {
      key: 0,
      id: "mainmenu",
      ref: "mainmenu",
      "aria-labelledby": "menubutton",
      "aria-modal": "true",
      class: _(["m4-menu--mobile", n.content.showMenu && "is-visible"])
    }, [
      c("div", uL, [
        c("button", {
          ref: "closeButton",
          class: "close-icon",
          "aria-label": "close",
          onClick: t[15] || (t[15] = (g) => e.$emit("toggle-mobile-menu", !1))
        }, [
          j(u, {
            tabindex: "-1",
            "fill-color": e.colors["--dropdown-text-color"]
          }, null, 8, ["fill-color"])
        ], 512),
        j(m, {
          "menu-items": i.mobileMenuItems,
          "is-visible": n.content.showMenu,
          colors: e.colors,
          "path-prefix": n.content.pathPrefix,
          onNavigate: e.navigate,
          onCloseMenu: t[16] || (t[16] = (g) => e.$emit("close-menus"))
        }, null, 8, ["menu-items", "is-visible", "colors", "path-prefix", "onNavigate"])
      ], 512)
    ], 2)) : T("", !0)
  ], 6);
}
const N0 = /* @__PURE__ */ B(iL, [["render", dL], ["__scopeId", "data-v-d6ea7a9e"]]), cL = {
  props: {
    theme: {
      type: Object,
      required: !0
    },
    globals: {
      type: Object,
      required: !0
    },
    logoLink: {
      type: String,
      required: !0
    },
    shouldShrink: {
      type: Boolean,
      default: !1
    },
    isMobile: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    colors() {
      return {
        "--nav-color": this.theme.navigation_color.hex,
        "--bg-color": this.theme.bg_color.hex,
        "--school-name-color": this.theme.school_name_color.hex,
        "--school-tagline-color": this.theme.school_tagline_color.hex
      };
    },
    aClass() {
      return {
        "logo-circle": this.theme.logo_circle && ["H1", "H2"].includes(this.theme.version),
        shrink: this.shouldShrink,
        mobile: this.isMobile
      };
    },
    slogan() {
      const e = $(this.theme, "translations.school_tag_line"), t = $(this.globals, "info.school_tag_line");
      return e || t;
    }
  }
}, hL = ["href"], mL = {
  key: 0,
  class: "clipping-rect"
}, fL = { class: "logo" }, pL = ["src"], gL = {
  key: 0,
  class: "circle"
}, vL = { class: "school-info" }, bL = {
  key: 1,
  class: "name"
};
function yL(e, t, n, r, o, i) {
  return d(), f("a", {
    href: n.logoLink,
    class: _(i.aClass),
    style: Z(i.colors)
  }, [
    n.theme.logo_circle ? (d(), f("div", mL)) : T("", !0),
    c("div", fL, [
      c("img", {
        src: n.globals.logo.url,
        alt: "Return to Home"
      }, null, 8, pL),
      n.theme.logo_circle ? (d(), f("div", gL)) : T("", !0)
    ]),
    c("div", vL, [
      n.globals.info.customHeader ? (d(), f("h1", {
        key: 0,
        class: _({ "sr-only": n.globals.info.customHeader })
      }, k(n.globals.info.school_name) + " - " + k(i.slogan), 3)) : T("", !0),
      n.globals.info.customHeader ? T("", !0) : (d(), f("div", bL, [
        c("h1", {
          class: _([n.theme.style, "org-name"])
        }, k(n.globals.info.school_name), 3),
        c("div", {
          class: _(["slogan", { [n.theme.style]: n.theme.style }])
        }, k(i.slogan), 3)
      ]))
    ])
  ], 14, hL);
}
const fr = /* @__PURE__ */ B(cL, [["render", yL], ["__scopeId", "data-v-a845ad16"]]), _L = {
  name: "MenuElementType",
  props: {
    item: {
      type: Object,
      default: () => ({}),
      required: !0
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    moreMenuTitle: {
      type: String,
      default: null
    },
    fillColor: {
      type: String,
      default: "#000"
    },
    moreMenuVisible: Boolean,
    ariaExpanded: {
      type: String,
      default: "false"
    },
    ariaHasPopup: {
      type: String,
      default: "false"
    },
    ariaControls: {
      type: String,
      default: ""
    }
  },
  emits: ["handle-header-click"],
  computed: {
    href() {
      if (!this.item)
        return null;
      switch (this.item.type) {
        case "page":
          return `${this.pathPrefix}/page/${this.item.slug}`;
        case "link":
          return this.getLinkHref;
        case "explore":
          return this.getExploreHref;
        case "header":
          return null;
        default:
          return null;
      }
    },
    iconVisible() {
      return (this.item.icon || this.item.icon_cms) && this.item.id !== "explore-button" && this.item.id !== "schoolsbutton";
    },
    noChildren() {
      var e;
      return ((e = this.item.children) == null ? void 0 : e.length) === 0;
    },
    getExploreHref() {
      var e;
      return (e = this.item.slug) != null && e.includes("http") ? this.item.slug : this.pathPrefix + this.item.slug;
    },
    getLinkHref() {
      return this.item ? this.item.mailto && this.item.email_address ? `mailto:${this.item.email_address}` : this.item.ipAddress ? `http://${this.item.url}` : this.item.url : null;
    },
    colors() {
      return {
        "--icon-fill-color": this.fillColor
      };
    }
  }
}, CL = { class: "bar-nav-element" }, wL = ["innerHTML"], TL = ["href", "target"], kL = { key: 0 };
function EL(e, t, n, r, o, i) {
  return d(), f("div", CL, [
    i.href ? (d(), f(J, { key: 0 }, [
      i.iconVisible ? (d(), f("div", {
        key: 0,
        class: _(["item-icon", { "global-icon": n.item.cms_icon_id }]),
        style: Z(i.colors),
        innerHTML: n.item.cms_icon_id ? n.item.icon_cms : n.item.icon
      }, null, 14, wL)) : T("", !0),
      c("a", {
        href: i.href,
        target: n.item.opens_in_new_tab ? "_blank" : void 0,
        class: "link"
      }, k(n.item.translatedTitle || n.item.name), 9, TL)
    ], 64)) : (d(), f(J, { key: 1 }, [
      n.moreMenuTitle && n.item.name === "more" ? (d(), f("span", kL, k(n.moreMenuTitle), 1)) : (d(), f("span", {
        key: 1,
        class: _(["item-type-header", { "no-children": i.noChildren }]),
        onClick: t[0] || (t[0] = (a) => e.$emit("handle-header-click"))
      }, k(n.item.translatedTitle || n.item.name), 3))
    ], 64))
  ]);
}
const U4 = /* @__PURE__ */ B(_L, [["render", EL], ["__scopeId", "data-v-5589e202"]]), SL = {
  name: "ImageElement",
  props: {
    item: {
      type: Object,
      required: !0
    }
  },
  computed: {
    href() {
      return this.item ? this.item.url : null;
    }
  }
}, ML = {
  class: "menu-item-focusable",
  tabindex: "-1"
}, AL = ["src", "alt"];
function IL(e, t, n, r, o, i) {
  return d(), f("span", ML, [
    (d(), L(Y(i.href ? "a" : "div"), {
      href: i.href,
      target: n.item.opens_in_new_tab ? "_blank" : void 0,
      class: "menu-item-link",
      tabindex: "-1"
    }, {
      default: S(() => [
        c("img", {
          src: n.item.imgSrc,
          alt: n.item.altText
        }, null, 8, AL)
      ]),
      _: 1
    }, 8, ["href", "target"]))
  ]);
}
const LL = /* @__PURE__ */ B(SL, [["render", IL], ["__scopeId", "data-v-e7e5596a"]]), DL = {
  name: "BarNavDrawerItem",
  components: { MenuElementType: U4, ImageElement: LL, MenuPlusIcon: V4, MenuMinusIcon: B4, DropdownArrowIcon: Mo },
  props: {
    elemData: {
      type: Object,
      default: null
    },
    themeStyle: {
      type: String,
      default: ""
    },
    isMobile: Boolean,
    colors: {
      type: Object,
      default: void 0
    },
    activeParent: {
      type: [String, Number],
      default: null
    },
    activeChild: {
      type: [String, Number],
      default: null
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    nestLevel: {
      type: Number,
      default: 0
    },
    newMobileHeaderElement: Boolean
  },
  emits: ["toggle-child", "toggle-parent", "next-tab", "navigate"],
  computed: {
    iconColor() {
      return this.isMobile && this.newMobileHeaderElement ? this.colors["--mobile-menu-text-color"] : this.colors["--dropdown-text-color"];
    },
    itemBgColor() {
      return {
        "--item-bg-color": this.isMobile ? this.colors["--mobile-menu-bg-color"] : this.colors["--dropdown-bg-color"]
      };
    },
    itemTextColor() {
      return {
        "--item-text-color": this.isMobile ? this.colors["--mobile-menu-text-color"] : this.colors["--dropdown-text-color"]
      };
    },
    hasChildren() {
      var e;
      return !!((e = this.elemData) != null && e.children.length);
    },
    showChildren() {
      return Number.isNaN(+this.activeParent) ? this.activeParent === this.elemData.id : +this.activeParent == +this.elemData.id;
    },
    isChild() {
      return this.nestLevel >= 1;
    },
    isSubChild() {
      return this.nestLevel >= 2;
    },
    ariaParentId() {
      return `menu-button-${this.elemData.id}`;
    },
    ariaExpanded() {
      if (this.hasChildren)
        return this.showChildren ? "true" : "false";
    },
    ariaControls() {
      if (this.hasChildren)
        return this.ariaChildId;
    },
    ariaChildId() {
      return `${this.elemData.id}-collapsible`;
    },
    ariaHasPopup() {
      return this.hasChildren ? "true" : "false";
    }
  },
  methods: {
    toggleParentCollapsible() {
      this.$emit("toggle-parent", this.elemData);
    },
    handleEnterEvent() {
      this.$emit("navigate", this.elemData);
    },
    handleNextTab(e, t, n) {
      this.$emit("next-tab", { itemId: e, isIconButton: t, isBackwardsTab: n });
    }
  }
}, $L = ["id"], OL = ["id"], PL = ["aria-expanded", "aria-controls", "aria-haspopup"], NL = {
  class: "bar-nav--drawer-element-focusable",
  tabindex: "-1"
}, HL = {
  key: 3,
  class: "sr-only"
}, FL = ["id", "aria-labelledby"];
function RL(e, t, n, r, o, i) {
  const a = V("ImageElement"), s = V("MenuElementType"), l = V("MenuPlusIcon"), u = V("MenuMinusIcon"), m = V("DropdownArrowIcon"), v = V("BarNavDrawerItem", !0);
  return d(), f("div", {
    role: "menuitem",
    class: _(["bar-nav--drawer-element", {
      "mobile-element": n.isMobile,
      "new-mobile-header": n.newMobileHeaderElement,
      "child-element": i.isChild,
      "has-children": i.hasChildren,
      "has-icon": n.elemData.icon || n.elemData.icon_cms,
      "sub-child": i.isSubChild,
      "image-element": n.elemData.type === "image"
    }]),
    style: Z([i.itemBgColor, i.itemTextColor]),
    onClick: t[7] || (t[7] = (...g) => i.toggleParentCollapsible && i.toggleParentCollapsible(...g))
  }, [
    c("div", {
      id: n.elemData.id,
      class: "bar-nav--drawer-element-title"
    }, [
      c("div", {
        id: i.ariaParentId,
        class: _(["bar-nav--drawer-element-title-text", n.themeStyle]),
        onClick: t[1] || (t[1] = W(() => {
        }, ["stop"]))
      }, [
        n.elemData.type === "image" ? (d(), L(a, {
          key: 0,
          item: n.elemData
        }, null, 8, ["item"])) : (d(), L(s, {
          key: 1,
          "path-prefix": n.pathPrefix,
          item: n.elemData,
          "fill-color": i.iconColor,
          "aria-expanded": i.ariaExpanded,
          "aria-has-popup": i.ariaHasPopup,
          "aria-controls": i.ariaControls,
          onHandleHeaderClick: i.toggleParentCollapsible,
          onKeydown: [
            K(i.handleEnterEvent, ["enter"]),
            t[0] || (t[0] = K((g) => i.handleNextTab(n.elemData.id, !1, g.shiftKey), ["tab"]))
          ]
        }, null, 8, ["path-prefix", "item", "fill-color", "aria-expanded", "aria-has-popup", "aria-controls", "onHandleHeaderClick", "onKeydown"]))
      ], 10, OL),
      n.elemData.children.length ? (d(), f(J, { key: 0 }, [
        n.elemData.children.length ? (d(), f("button", {
          key: 0,
          "aria-expanded": i.ariaExpanded,
          "aria-controls": i.ariaControls,
          "aria-haspopup": i.ariaHasPopup,
          class: "bar-nav--drawer-element-title-icon",
          onClick: t[2] || (t[2] = W((...g) => i.toggleParentCollapsible && i.toggleParentCollapsible(...g), ["stop", "prevent"])),
          onKeydown: t[3] || (t[3] = K((g) => i.handleNextTab(n.elemData.id, !0, g.shiftKey), ["tab"]))
        }, [
          c("span", NL, [
            n.isMobile && !i.showChildren ? (d(), L(l, {
              key: 0,
              "fill-color": i.iconColor
            }, null, 8, ["fill-color"])) : n.isMobile && i.showChildren ? (d(), L(u, {
              key: 1,
              "fill-color": i.iconColor
            }, null, 8, ["fill-color"])) : T("", !0),
            n.isMobile ? T("", !0) : (d(), L(m, {
              key: 2,
              "fill-color": i.iconColor,
              "dropdown-class": i.showChildren ? "open" : "close"
            }, null, 8, ["fill-color", "dropdown-class"])),
            n.elemData ? (d(), f("span", HL, " Show submenu for " + k(n.elemData.name || n.elemData.translatedTitle), 1)) : T("", !0)
          ])
        ], 40, PL)) : T("", !0)
      ], 64)) : T("", !0)
    ], 8, $L),
    j(Le, { name: "collapse-in" }, {
      default: S(() => [
        we(c("div", {
          id: i.ariaChildId,
          "aria-labelledby": i.ariaParentId,
          class: _(["bar-nav--drawer-children", { "show-children": i.showChildren }])
        }, [
          (d(!0), f(J, null, ne(n.elemData.children, (g) => (d(), L(v, {
            key: g.id,
            "elem-data": g,
            "is-mobile": n.isMobile,
            "theme-style": n.themeStyle,
            "active-parent": n.activeChild,
            "path-prefix": n.pathPrefix,
            colors: n.colors,
            "new-mobile-header-element": n.newMobileHeaderElement,
            "nest-level": n.nestLevel + 1,
            onToggleParent: t[4] || (t[4] = (h) => e.$emit("toggle-child", h)),
            onNextTab: t[5] || (t[5] = (h) => e.$emit("next-tab", h)),
            onNavigate: t[6] || (t[6] = (h) => e.$emit("navigate", h))
          }, null, 8, ["elem-data", "is-mobile", "theme-style", "active-parent", "path-prefix", "colors", "new-mobile-header-element", "nest-level"]))), 128))
        ], 10, FL), [
          [qn, i.hasChildren & i.showChildren]
        ])
      ]),
      _: 1
    })
  ], 6);
}
const q4 = /* @__PURE__ */ B(DL, [["render", RL], ["__scopeId", "data-v-1e9b1b42"]]), VL = {
  name: "MobileMenu",
  components: {
    BarNavDrawerItem: q4,
    MenuItem: Yt,
    LanguageDropdown: Fs
  },
  mixins: [Et],
  props: {
    theme: {
      type: Object,
      default: () => ({})
    },
    content: {
      type: Object,
      default: () => ({})
    },
    colors: {
      type: Object,
      default: () => ({})
    },
    showUtilities: Boolean,
    signInColors: {
      type: Object,
      default: () => ({})
    },
    signInUrl: {
      type: String,
      default: ""
    },
    signInText: {
      type: String,
      default: ""
    },
    showSignInButton: Boolean,
    showMenuButtons: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["close-menu", "set-language", "toggle-search"],
  data() {
    return {
      activeParent: null,
      activeChild: null,
      languageDropdownVisible: !1
    };
  },
  mounted() {
    window.addEventListener("keydown", this.keydownHandler);
  },
  unmounted() {
    window.removeEventListener("keydown", this.keydownHandler);
  },
  methods: {
    keydownHandler(e) {
      e.key === "Escape" && this.$emit("close-menu");
    },
    setLanguage(e) {
      this.toggleLanguageDropdown(), this.$emit("set-language", e);
    },
    toggleLanguageDropdown() {
      this.languageDropdownVisible = !this.languageDropdownVisible;
    },
    handleToggleParent(e) {
      if (!e) {
        this.activeParent = null;
        return;
      }
      if (e.id === this.activeParent) {
        this.activeParent = null;
        return;
      }
      this.activeParent = e.id;
    },
    handleToggleChild(e) {
      if (!e) {
        this.activeChild = null;
        return;
      }
      if (e.id === this.activeChild) {
        this.activeChild = null;
        return;
      }
      this.activeChild = e.id;
    }
  }
}, BL = {
  key: 0,
  class: "mobile-menu-wrapper"
}, jL = {
  key: 0,
  class: "search-translate-buttons"
}, UL = ["href"], qL = {
  key: 1,
  class: "utilities-wrapper"
}, GL = ["href", ":href", "target"], KL = {
  key: 2,
  class: "icon-links-container"
}, zL = ["href", ":href", "target", "aria-label"], ZL = ["innerHTML"];
function xL(e, t, n, r, o, i) {
  const a = V("MenuItem"), s = V("LanguageDropdown"), l = V("BarNavDrawerItem"), u = ze("click-away");
  return d(), L(Le, { name: "slide-fade-up" }, {
    default: S(() => [
      n.content.showMenu ? (d(), f("nav", BL, [
        n.showMenuButtons ? (d(), f("div", jL, [
          j(a, {
            item: "searchbutton",
            theme: n.theme,
            content: n.content,
            "is-mobile": "",
            "theme-overrides": {
              colors: {
                "--icon-color": n.colors["--mobile-menu-text-color"],
                "--bg-color": "transparent"
              }
            },
            "mobile-text-color": n.colors["--mobile-menu-text-color"],
            onToggleSearch: t[0] || (t[0] = (m) => e.$emit("toggle-search"))
          }, null, 8, ["theme", "content", "theme-overrides", "mobile-text-color"]),
          n.content.languages.length > 1 ? (d(), L(a, {
            key: 0,
            item: "languagebutton",
            theme: n.theme,
            content: n.content,
            "is-mobile": "",
            "theme-overrides": {
              colors: {
                "--fill-color": n.colors["--mobile-menu-text-color"],
                "--fill-path-color": n.colors["--mobile-menu-text-color"],
                "--nav-color": n.colors["--mobile-menu-text-color"]
              }
            },
            "mobile-text-color": n.colors["--mobile-menu-text-color"],
            onToggleDropdown: i.toggleLanguageDropdown
          }, null, 8, ["theme", "content", "theme-overrides", "mobile-text-color", "onToggleDropdown"])) : T("", !0),
          we(j(s, {
            id: "languagesmenu",
            data: n.content.languages,
            styles: n.theme,
            "is-visible": o.languageDropdownVisible,
            "current-language": n.content.langCode,
            class: "language-dropdown",
            onSetLanguage: i.setLanguage,
            onCloseDropdown: i.toggleLanguageDropdown
          }, null, 8, ["data", "styles", "is-visible", "current-language", "onSetLanguage", "onCloseDropdown"]), [
            [
              u,
              () => {
                o.languageDropdownVisible = !1;
              }
            ]
          ]),
          n.showSignInButton ? (d(), f("a", {
            key: 1,
            href: n.signInUrl,
            class: "sign-in-button",
            target: "_blank"
          }, k(n.signInText), 9, UL)) : T("", !0)
        ])) : T("", !0),
        M(e.$slots, "menu-top", {}, void 0, !0),
        n.showUtilities ? (d(), f("div", qL, [
          (d(!0), f(J, null, ne(n.content.utilities, (m, v) => (d(), f("a", {
            key: v,
            href: m.link,
            ":href": m.link,
            target: m.opens_in_new_tab ? "_blank" : "",
            class: "utility",
            style: Z({ color: n.colors["--mobile-menu-text-color"] })
          }, k(m.name), 13, GL))), 128))
        ])) : T("", !0),
        n.theme.version === "H8" && n.theme.style === "texas" ? (d(), f("div", KL, [
          (d(!0), f(J, null, ne(n.content.iconLinks, (m) => (d(), f("a", {
            key: m.icon_id,
            href: m.link,
            ":href": m.link,
            target: m.opens_in_new_tab ? "_blank" : "",
            class: "icon-link",
            "aria-label": m.name,
            style: Z({ color: n.colors["--mobile-menu-text-color"] })
          }, [
            c("span", {
              "data-testid": "svg",
              innerHTML: m.icon
            }, null, 8, ZL)
          ], 12, zL))), 128))
        ])) : T("", !0),
        (d(!0), f(J, null, ne(n.content.menuItems, (m) => (d(), L(l, {
          key: `${m.name}-${m.id}`,
          "elem-data": m,
          "is-mobile": "",
          colors: n.colors,
          "active-parent": o.activeParent,
          "active-child": o.activeChild,
          "path-prefix": n.content.pathPrefix,
          "new-mobile-header-element": "",
          onToggleParent: i.handleToggleParent,
          onToggleChild: i.handleToggleChild
        }, null, 8, ["elem-data", "colors", "active-parent", "active-child", "path-prefix", "onToggleParent", "onToggleChild"]))), 128))
      ])) : T("", !0)
    ]),
    _: 3
  });
}
const WL = /* @__PURE__ */ B(VL, [["render", xL], ["__scopeId", "data-v-912cfa21"]]), YL = {
  name: "MobileHeader",
  components: {
    MenuItem: Yt,
    OrgBanner: fr,
    MobileMenu: WL
  },
  mixins: [ut],
  props: {
    isShrink: Boolean,
    showUtilities: Boolean,
    showSignInButton: Boolean,
    hideMenuButton: Boolean,
    signInUrl: {
      type: String,
      default: ""
    },
    menuButtonBgColor: {
      type: String,
      default: ""
    },
    menuButtonIconColor: {
      type: String,
      default: ""
    },
    showMenuButtons: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["toggle-mobile-menu", "toggle-search", "set-language"],
  computed: {
    mobileContent() {
      return ge(ae({}, this.content), { menuItems: this.mobileMenuItems });
    },
    mobileMenuItems() {
      return [
        ...this.shouldDisplaySchoolsDropdown ? [
          {
            id: "schools-header",
            name: this.theme.schools_field || "Schools",
            slug: "schools",
            type: "header",
            children: this.buildSchoolsMenu(
              this.content.hasCustomSchoolsMenu ? this.content.orgMenuContent.flat() : this.content.organizations
            )
          }
        ] : [{}],
        {
          id: "explore-header",
          name: this.theme.menu_field || "Explore",
          slug: "explore",
          type: "header",
          children: this.content.customMenuItems.map((e) => ({
            id: `explore-${e.id}`,
            name: e.name,
            slug: e.url,
            icon: e.icon,
            cms_icon_id: e.cms_icon_id,
            icon_cms: e.icon_cms,
            opens_in_new_tab: e.opens_in_new_tab,
            type: "explore",
            children: []
          }))
        },
        ...this.content.sitemapMenuItems
      ];
    },
    mobileHeaderBgColor() {
      var e, t, n, r;
      return this.menuV4Enabled || this.content.newMobileHeader && this.theme.version !== "H3" ? (t = (e = this.content.menuOptions) == null ? void 0 : e.dropdown_bg_color) == null ? void 0 : t.hex : this.menuV5Enabled && this.theme.version === "H3" ? "transparent" : ((r = (n = this.content.menuOptions) == null ? void 0 : n.bg_color) == null ? void 0 : r.hex) || "#fff";
    },
    mobileMenuBgColor() {
      var e, t, n, r;
      return this.menuV4Enabled || this.menuV5Enabled ? (t = (e = this.content.menuOptions) == null ? void 0 : e.dropdown_bg_color) == null ? void 0 : t.hex : ((r = (n = this.content.menuOptions) == null ? void 0 : n.bg_color) == null ? void 0 : r.hex) || "#fff";
    },
    mobileMenuTextColor() {
      var e, t, n, r;
      return this.menuV4Enabled || this.menuV5Enabled ? (t = (e = this.content.menuOptions) == null ? void 0 : e.dropdown_text_color) == null ? void 0 : t.hex : ((r = (n = this.content.menuOptions) == null ? void 0 : n.text_color) == null ? void 0 : r.hex) || "#000";
    },
    colors() {
      var e, t, n, r, o, i, a, s, l, u;
      return {
        "--nav-color": ((e = this.theme.navigation_color) == null ? void 0 : e.hex) || "#fff",
        searchIcon: (t = this.theme.search_icon_color) == null ? void 0 : t.hex,
        "--mobile-menu-bg-color": (this.menuV4Enabled ? (r = (n = this.content.menuOptions) == null ? void 0 : n.dropdown_bg_color) == null ? void 0 : r.hex : (i = (o = this.content.menuOptions) == null ? void 0 : o.bg_color) == null ? void 0 : i.hex) || "#fff",
        "--mobile-menu-text-color": (this.menuV4Enabled ? (s = (a = this.content.menuOptions) == null ? void 0 : a.dropdown_text_color) == null ? void 0 : s.hex : (u = (l = this.content.menuOptions) == null ? void 0 : l.text_color) == null ? void 0 : u.hex) || "#000"
      };
    },
    focusHighlightColor() {
      return ue.mostReadable(this.mobileHeaderBgColor, ["#0000FF", "#FFFFFF"]).toHexString();
    },
    isSearchOpen() {
      return this.$route.query.openSearch === "true";
    }
  },
  // watch: {
  //   'content.showMenu': {
  //     async handler(showMenu) {
  //       if (showMenu) {
  //         await nextTick();
  //         this.activate();
  //       } else {
  //         await nextTick();
  //         this.deactivate();
  //       }
  //     },
  //   },
  // },
  methods: {
    async toggleSearch() {
      this.$emit("toggle-search");
    },
    buildSchoolsMenu(e) {
      if (qr(e))
        return [];
      const t = (r) => {
        let o = "";
        switch (r) {
          case "SchoolsMenuOrg":
            o = "link";
            break;
          case "SchoolsMenuLink":
            o = "link";
            break;
          case "SchoolsMenuImage":
            o = "image";
            break;
          case "SchoolsMenuHeader":
            o = "header";
            break;
          default:
            o = "link";
            break;
        }
        return o;
      }, n = (r) => r.type === "SchoolsMenuLink" ? r.link : r.type === "SchoolsMenuOrg" && this.content.hasCustomSchoolsMenu ? P0(r, this.content.organizations, {
        isPreview: this.content.isPreview
      }) : zr(r, {
        isPreview: this.content.isPreview,
        currentDomain: window.location.href
      });
      return e.map((r, o) => ({
        id: `schools-${o}`,
        name: r.name,
        slug: r.link || r.path_prefix,
        url: n(r),
        imgSrc: r.url,
        altText: r.alt_text,
        imgHasLink: r.action_on_click === "no_action",
        opens_in_new_tab: r.opens_in_new_tab,
        type: t(r.type),
        children: this.buildSchoolsMenu(r.children)
      }));
    }
  }
}, XL = {
  key: 0,
  class: "left-icon"
}, QL = { class: "main-content" }, JL = {
  key: 0,
  class: "right-icon"
}, eD = {
  key: 0,
  id: "mainmenu",
  "aria-labelledby": "menubutton",
  "aria-modal": "true",
  class: "menu-mobile"
};
function tD(e, t, n, r, o, i) {
  const a = V("MenuItem"), s = V("OrgBanner"), l = V("MobileMenu");
  return d(), f("div", {
    "data-testid": "mobile-header",
    class: _(["mobile-header", e.theme.version, { "menu-open": e.content.showMenu, shrink: n.isShrink }]),
    style: Z(i.colors)
  }, [
    M(e.$slots, "default", {}, () => [
      n.hideMenuButton ? T("", !0) : (d(), f("div", XL, [
        e.content.showMenu ? (d(), L(a, {
          key: 1,
          item: "closebutton",
          "show-text": !1,
          theme: e.theme,
          content: e.content,
          "theme-overrides": {
            colors: {
              "--fill-color": n.menuButtonIconColor
            }
          },
          "is-mobile-header": "",
          "focus-visible-color": i.focusHighlightColor,
          onToggleDropdown: t[1] || (t[1] = (u) => e.$emit("toggle-mobile-menu", !1))
        }, null, 8, ["theme", "content", "theme-overrides", "focus-visible-color"])) : (d(), L(a, {
          key: 0,
          item: "menubutton",
          theme: e.theme,
          content: e.content,
          "show-text": !1,
          "theme-overrides": {
            colors: {
              "--fill-color": n.menuButtonBgColor,
              "--fill-path-color": n.menuButtonIconColor
            }
          },
          "is-mobile-header": "",
          "focus-visible-color": i.focusHighlightColor,
          onToggleDropdown: t[0] || (t[0] = (u) => e.$emit("toggle-mobile-menu", !0))
        }, null, 8, ["theme", "content", "theme-overrides", "focus-visible-color"]))
      ])),
      c("div", QL, [
        j(s, {
          "logo-link": e.logoLink,
          "should-shrink": n.isShrink,
          theme: e.theme,
          globals: e.content.globals,
          "is-mobile": e.theme.version !== "H3",
          class: _(e.theme.version)
        }, null, 8, ["logo-link", "should-shrink", "theme", "globals", "is-mobile", "class"]),
        e.theme.version === "H3" ? (d(), f("div", JL, [
          e.content.showMenu ? (d(), L(a, {
            key: 1,
            item: "closebutton",
            theme: e.theme,
            content: e.content,
            "focus-visible-color": i.focusHighlightColor,
            onToggleDropdown: t[3] || (t[3] = (u) => e.$emit("toggle-mobile-menu", !1))
          }, null, 8, ["theme", "content", "focus-visible-color"])) : (d(), L(a, {
            key: 0,
            item: "menubutton",
            theme: e.theme,
            content: e.content,
            "is-mobile": "",
            "focus-visible-color": i.focusHighlightColor,
            onToggleDropdown: t[2] || (t[2] = (u) => e.$emit("toggle-mobile-menu", !0))
          }, null, 8, ["theme", "content", "focus-visible-color"]))
        ])) : T("", !0)
      ])
    ], !0),
    M(e.$slots, "bottom", {}, void 0, !0),
    e.content.showMenu ? (d(), f("div", eD, [
      j(l, {
        theme: e.theme,
        "show-utilities": n.showUtilities,
        utilities: e.content.utilities,
        "lang-code": e.content.langCode,
        "show-menu-buttons": n.showMenuButtons,
        content: i.mobileContent,
        colors: i.colors,
        "sign-in-colors": e.signInColors,
        "sigin-in-url": n.signInUrl,
        "show-sign-in-button": n.showSignInButton,
        "sign-in-text": e.signInText,
        "sign-in-url": n.signInUrl,
        onCloseMenu: t[4] || (t[4] = (u) => e.$emit("toggle-mobile-menu", !1)),
        onToggleSearch: t[5] || (t[5] = (u) => e.$emit("toggle-search")),
        onSetLanguage: t[6] || (t[6] = (u) => e.$emit("set-language", u))
      }, {
        "menu-top": S(() => [
          M(e.$slots, "menu-top", {}, void 0, !0)
        ]),
        _: 3
      }, 8, ["theme", "show-utilities", "utilities", "lang-code", "show-menu-buttons", "content", "colors", "sign-in-colors", "sigin-in-url", "show-sign-in-button", "sign-in-text", "sign-in-url"])
    ])) : T("", !0)
  ], 6);
}
const Zr = /* @__PURE__ */ B(YL, [["render", tD], ["__scopeId", "data-v-6a611167"]]), nD = {
  name: "Header1",
  components: {
    CmsSchoolsMenu: mr,
    M4: N0,
    OrgBanner: fr,
    MobileHeader: Zr,
    MenuItem: Yt
  },
  mixins: [ut, Et],
  emits: ["language-change", "toggle-search"]
}, rD = { class: "left" }, oD = { class: "right" }, iD = { class: "explore-menu-container" }, sD = {
  key: 0,
  class: "schools-menu-container"
}, aD = { key: 0 }, lD = ["href"];
function uD(e, t, n, r, o, i) {
  var E, C, A, R, P;
  const a = V("OrgBanner"), s = V("MenuItem"), l = V("HeaderDropdown"), u = V("M4"), m = V("cms-schools-menu"), v = V("LanguageDropdown"), g = V("MobileHeader"), h = ze("click-away");
  return we((d(), f("div", {
    id: "h1",
    style: Z(e.colors)
  }, [
    !e.isMobile || !e.content.newMobileHeader ? (d(), f("div", {
      key: 0,
      "data-testid": "large-screen-header",
      class: _(["header-container", e.shrinkCSSClass, e.logoCircleCSSClass, { "show-sign-in-button": e.showSignInButton }])
    }, [
      c("div", rD, [
        j(a, {
          "logo-link": e.logoLink,
          "should-shrink": e.shouldShrink,
          theme: e.theme,
          globals: e.content.globals
        }, null, 8, ["logo-link", "should-shrink", "theme", "globals"])
      ]),
      c("div", oD, [
        c("div", {
          class: _(["right-left-menu", { "show-sign-in-button": e.showSignInButton }])
        }, [
          c("div", iD, [
            j(s, {
              item: "menubutton",
              theme: e.theme,
              content: e.content,
              "theme-overrides": {
                colors: {
                  "--bg-color": "transparent",
                  "--fill-color": "transparent",
                  "--fill-path-color": (E = e.theme.navigation_color) == null ? void 0 : E.hex
                }
              },
              "dropdown-open": e.exploreMenuVisible,
              onToggleDropdown: e.setDropdownVisibility
            }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"]),
            e.menuV4Enabled && e.hasExploreMenuContent && !e.isMobile ? (d(), L(s, {
              key: 0,
              item: "explore-button",
              theme: e.theme,
              content: e.content,
              "theme-overrides": {
                colors: {
                  "--bg-color": "transparent",
                  "--fill-color": "transparent",
                  "--fill-path-color": (C = e.theme.navigation_color) == null ? void 0 : C.hex
                }
              },
              "dropdown-open": e.exploreMenuVisible,
              onToggleDropdown: e.setDropdownVisibility,
              onKeydown: t[0] || (t[0] = K(W((F) => e.exploreMenuVisible = !1, ["shift", "exact"]), ["tab"]))
            }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"])) : T("", !0),
            e.menuV4Enabled && e.exploreMenuVisible ? we((d(), L(l, {
              key: 1,
              id: "explore-menu",
              "data-testid": "explore-menu",
              role: "menu",
              "aria-labelledby": "explore-button",
              styles: e.theme,
              data: e.content.customMenuItems,
              "menu-v4-enabled": e.menuV4Enabled,
              "is-visible": e.exploreMenuVisible,
              "path-prefix": e.content.pathPrefix,
              "is-shrink": e.shrinkCSSClass === "shrink",
              onCloseDropdown: t[1] || (t[1] = (F) => e.exploreMenuVisible = !1)
            }, null, 8, ["styles", "data", "menu-v4-enabled", "is-visible", "path-prefix", "is-shrink"])), [
              [
                h,
                () => {
                  e.exploreMenuVisible = !1;
                }
              ]
            ]) : T("", !0),
            e.menuV4Enabled && e.isMobile ? (d(), L(u, {
              key: 2,
              "show-menu": e.content.showMenu,
              theme: e.theme,
              content: e.content,
              "is-preview": e.content.isPreview,
              "is-mobile": e.isMobile,
              "is-shrink": e.shrinkCSSClass === "shrink",
              onCloseMenus: e.closeAllMenus,
              onToggleMobileMenu: t[2] || (t[2] = (F) => e.$emit("toggle-mobile-menu", F))
            }, null, 8, ["show-menu", "theme", "content", "is-preview", "is-mobile", "is-shrink", "onCloseMenus"])) : T("", !0)
          ]),
          e.shouldDisplaySchoolsDropdown ? (d(), f("div", sD, [
            j(s, {
              item: "schoolsbutton",
              theme: e.theme,
              content: e.content,
              "theme-overrides": {
                colors: {
                  "--bg-color": "transparent",
                  "--fill-color": "transparent",
                  "--fill-path-color": (A = e.theme.navigation_color) == null ? void 0 : A.hex
                }
              },
              "dropdown-open": e.isSchoolDropdownVisible || e.isCustomSchoolsMenuVisible,
              onKeydown: t[3] || (t[3] = K(W((F) => {
                e.schoolDropdownVisible = !1, e.customSchoolsMenuVisible = !1;
              }, ["shift", "exact"]), ["tab"])),
              onToggleDropdown: e.setDropdownVisibility
            }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"]),
            e.content.hasCustomSchoolsMenu ? T("", !0) : (d(), L(l, {
              key: 0,
              id: "schoolsmenu",
              "data-testid": "schools-menu",
              "aria-labelledby": "schoolsbutton",
              styles: e.theme,
              data: e.content.organizations,
              "is-visible": e.schoolDropdownVisible,
              "is-preview": e.content.isPreview,
              "is-language-menu-hidden": !e.shouldDisplayLanguagesDropdown,
              "is-shrink": e.shrinkCSSClass === "shrink",
              onCloseDropdown: t[4] || (t[4] = (F) => e.schoolDropdownVisible = !1)
            }, null, 8, ["styles", "data", "is-visible", "is-preview", "is-language-menu-hidden", "is-shrink"])),
            j(Le, { name: "slide" }, {
              default: S(() => [
                e.content.hasCustomSchoolsMenu ? (d(), L(m, {
                  key: 0,
                  id: "schoolsmenu",
                  ref: "schoolsmenu",
                  "data-testid": "custom-schools-menu",
                  "header-theme": e.theme,
                  "org-menu-content": e.content.orgMenuContent,
                  organizations: e.content.organizations,
                  "show-custom-schools-menu": e.customSchoolsMenuVisible,
                  "sticky-header": e.shouldBeSticky,
                  "shrink-header": e.shouldShrink,
                  "is-preview": e.content.isPreview,
                  onHideOnClickaway: t[5] || (t[5] = (F) => e.customSchoolsMenuVisible = !1),
                  onFocusLost: t[6] || (t[6] = (F) => e.customSchoolsMenuVisible = !1)
                }, null, 8, ["header-theme", "org-menu-content", "organizations", "show-custom-schools-menu", "sticky-header", "shrink-header", "is-preview"])) : T("", !0)
              ]),
              _: 1
            })
          ])) : T("", !0)
        ], 2),
        c("div", {
          class: _(["right-right-menu", { "show-sign-in-button": e.showSignInButton }])
        }, [
          e.shouldDisplayLanguagesDropdown ? (d(), f("div", aD, [
            j(s, {
              item: "languagebutton",
              theme: e.theme,
              content: e.content,
              "theme-overrides": {
                colors: {
                  "--bg-color": "transparent",
                  "--fill-color": "transparent",
                  "--fill-path-color": (R = e.theme.navigation_color) == null ? void 0 : R.hex
                }
              },
              "dropdown-open": e.languageDropdownVisible,
              onKeydown: t[7] || (t[7] = K(W((F) => e.languageDropdownVisible = !1, ["shift", "exact"]), ["tab"])),
              onToggleDropdown: e.setDropdownVisibility
            }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"]),
            we(j(v, {
              id: "languagesmenu",
              "data-testid": "languages-menu",
              role: "menu",
              data: e.content.languages,
              styles: e.theme,
              "is-visible": e.languageDropdownVisible,
              "current-language": e.content.langCode,
              onSetLanguage: e.setLanguage,
              onCloseDropdown: t[8] || (t[8] = (F) => e.languageDropdownVisible = !1)
            }, null, 8, ["data", "styles", "is-visible", "current-language", "onSetLanguage"]), [
              [
                h,
                () => {
                  e.languageDropdownVisible = !1;
                }
              ]
            ])
          ])) : T("", !0),
          j(s, {
            item: "searchbutton",
            theme: e.theme,
            content: e.content,
            "theme-overrides": {
              colors: {
                "--bg-color": "transparent",
                "--fill-color": "transparent"
              }
            },
            onToggleSearch: e.toggleSearch
          }, null, 8, ["theme", "content", "onToggleSearch"]),
          e.showSignInButton ? (d(), f("a", {
            key: 1,
            href: e.signInUrl,
            class: "sign-in-button",
            target: "_blank"
          }, k(e.signInText), 9, lD)) : T("", !0)
        ], 2)
      ])
    ], 2)) : (d(), L(g, {
      key: 1,
      theme: e.theme,
      content: e.content,
      "menu-button-bg-color": "transparent",
      "menu-button-icon-color": (P = e.theme.navigation_color) == null ? void 0 : P.hex,
      "is-shrink": e.shrinkCSSClass === "shrink",
      "show-sign-in-button": e.showSignInButton,
      "sign-in-url": e.signInUrl,
      onToggleMobileMenu: t[9] || (t[9] = (F) => e.$emit("toggle-mobile-menu", F)),
      onToggleSearch: e.toggleSearch,
      onSetLanguage: e.setLanguage,
      onCloseMenu: e.closeAllMenus
    }, null, 8, ["theme", "content", "menu-button-icon-color", "is-shrink", "show-sign-in-button", "sign-in-url", "onToggleSearch", "onSetLanguage", "onCloseMenu"]))
  ], 4)), [
    [h, e.closeAllMenus]
  ]);
}
const dD = /* @__PURE__ */ B(nD, [["render", uD], ["__scopeId", "data-v-6259d7a1"]]), cD = {
  name: "DraggableWrapper",
  props: {
    modelValue: {
      type: Array,
      required: !0
    },
    itemKey: {
      type: String,
      required: !0
    }
  }
};
function hD(e, t, n, r, o, i) {
  return d(), f("div", M6(A6(e.$attrs)), [
    (d(!0), f(J, null, ne(n.modelValue, (a, s) => M(e.$slots, "item", {
      key: s,
      element: a,
      index: s
    })), 128))
  ], 16);
}
const yt = /* @__PURE__ */ B(cD, [["render", hD]]), mD = {
  name: "UtilityBar",
  props: {
    utilities: {
      type: Array,
      required: !0
    },
    textColor: {
      type: String,
      required: !0
    },
    bgColor: {
      type: String,
      required: !0
    },
    themeVersion: {
      type: String,
      default: ""
    },
    translatedTitle: {
      type: String,
      default: ""
    },
    languageDropdownOpen: Boolean,
    hasLanguages: Boolean,
    isEditing: Boolean,
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["update:utilities"],
  components: {
    DropdownArrowIcon: Mo,
    DraggableWrapper: yt
  },
  computed: {
    iconClass() {
      return this.languageDropdownOpen ? "open" : void 0;
    }
  }
};
function fD(e, t, n, r, o, i) {
  const a = V("DropdownArrowIcon");
  return d(), f(J, null, [
    (d(), L(Y(n.wrapperComponent), Se({ "item-key": "idx" }, n.wrapperProps, {
      "model-value": n.utilities,
      style: [{ color: n.textColor }, { background: n.bgColor }],
      class: ["utility-bar", [n.themeVersion, e.$attrs.class, { "is-editing": n.isEditing }]],
      "onUpdate:modelValue": t[0] || (t[0] = (s) => e.$emit("update:utilities", s))
    }), {
      item: S(({ element: s, index: l }) => [
        (d(), L(Y(n.isEditing ? "div" : "a"), {
          class: "utilities",
          href: n.isEditing ? "" : s.link,
          target: s.opens_in_new_tab ? "_blank" : ""
        }, {
          default: S(() => [
            M(e.$slots, "utility", { idx: l }, () => [
              H(k(s.name), 1)
            ], !0)
          ]),
          _: 2
        }, 1032, ["href", "target"]))
      ]),
      _: 3
    }, 16, ["model-value", "style", "class"])),
    n.themeVersion === "H3" && n.hasLanguages ? (d(), f("button", {
      key: 0,
      class: "translate-button",
      "data-testid": "language-dropdown-button",
      onClick: t[1] || (t[1] = (s) => e.$emit("toggle-language-dropdown"))
    }, [
      c("span", {
        class: "translate-text",
        style: Z({ color: n.textColor })
      }, k(n.translatedTitle), 5),
      j(a, {
        "dropdown-class": i.iconClass,
        "fill-color": n.textColor
      }, null, 8, ["dropdown-class", "fill-color"])
    ])) : T("", !0)
  ], 64);
}
const G4 = /* @__PURE__ */ B(mD, [["render", fD], ["__scopeId", "data-v-6e681a3d"]]), pD = {
  name: "Header2",
  components: {
    CmsSchoolsMenu: mr,
    MenuItem: Yt,
    M4: N0,
    OrgBanner: fr,
    UtilityBar: G4,
    MobileHeader: Zr
  },
  mixins: [ut, Et],
  emits: ["toggle-menu", "toggle-mobile-menu", "close-menu", "language-change", "toggle-search", "update:utilities"]
}, gD = { class: "left" }, vD = { class: "right" }, bD = ["fill"], yD = { class: "right-menu-items" }, _D = { key: 0 }, CD = { key: 1 }, wD = ["href"], TD = { class: "right-mobile" }, kD = { class: "right-left-menu" }, ED = { class: "explore-menu-container" }, SD = {
  key: 0,
  class: "schools-menu-container"
}, MD = {
  key: 0,
  class: "language-icon"
}, AD = ["href"];
function ID(e, t, n, r, o, i) {
  var C, A, R, P, F, I, D, O, U, q;
  const a = V("UtilityBar"), s = V("MenuItem"), l = V("OrgBanner"), u = V("HeaderDropdown"), m = V("M4"), v = V("cms-schools-menu"), g = V("LanguageDropdown"), h = V("MobileHeader"), E = ze("click-away");
  return we((d(), f("div", {
    id: "h2",
    style: Z(e.colors)
  }, [
    c("div", {
      "data-testid": "small-utilities-bar",
      class: _([e.shrinkCSSClass, "utilities utilities-top"])
    }, [
      j(a, {
        class: _([[{ "is-mobile": e.isMobile }, e.shrinkCSSClass], "utility-bar-items"]),
        utilities: e.content.utilities,
        "theme-version": e.theme.version,
        "text-color": e.colors["--utility-link-color"],
        "bg-color": e.colors["--utility-bg-color"]
      }, null, 8, ["class", "utilities", "theme-version", "text-color", "bg-color"]),
      !e.isMobile || !e.content.newMobileHeader ? (d(), L(s, {
        key: 0,
        item: "searchbutton",
        class: _(e.shrinkCSSClass),
        theme: e.theme,
        content: e.content,
        "theme-overrides": {
          colors: {
            "--icon-color": (C = e.theme.search_icon_color) == null ? void 0 : C.hex
          }
        },
        "is-mobile": "",
        onToggleSearch: e.toggleSearch
      }, null, 8, ["class", "theme", "content", "theme-overrides", "onToggleSearch"])) : T("", !0)
    ], 2),
    !e.isMobile || !e.content.newMobileHeader ? (d(), f("div", {
      key: 0,
      "data-testid": "large-screen-header",
      class: _(["header-container", e.shrinkCSSClass, e.logoCircleCSSClass])
    }, [
      c("div", gD, [
        j(l, {
          "logo-link": e.logoLink,
          "should-shrink": e.shouldShrink,
          theme: e.theme,
          globals: e.content.globals
        }, null, 8, ["logo-link", "should-shrink", "theme", "globals"])
      ]),
      c("div", vD, [
        c("div", {
          "data-testid": "large-utilities-bar",
          class: _([e.shrinkCSSClass, "utilities utilities-right"])
        }, [
          (d(), f("svg", {
            class: _([e.shrinkCSSClass, "sloped-edge"]),
            width: "97",
            height: "56",
            viewBox: "0 0 97 56",
            preserveAspectRatio: "none",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "aria-hidden": "true"
          }, [
            c("path", {
              d: "M94.5015 56H97V0H1.00114C0.188275 0 -0.284554 0.919373 0.187909 1.58124L6.79574 10.8378C27.0277 39.1796 59.6932 56 94.5015 56Z",
              fill: e.colors["--utility-bg-color"]
            }, null, 8, bD)
          ], 2)),
          j(a, {
            utilities: e.content.utilities,
            class: _([e.shrinkCSSClass, "utility-bar-items"]),
            "theme-version": e.theme.version,
            "text-color": e.colors["--utility-link-color"],
            "bg-color": e.colors["--utility-bg-color"]
          }, null, 8, ["utilities", "class", "theme-version", "text-color", "bg-color"]),
          j(s, {
            item: "searchbutton",
            class: _(e.shrinkCSSClass),
            theme: e.theme,
            content: e.content,
            "theme-overrides": {
              colors: {
                "--icon-color": (A = e.theme.search_icon_color) == null ? void 0 : A.hex
              }
            },
            onToggleSearch: e.toggleSearch
          }, null, 8, ["class", "theme", "content", "theme-overrides", "onToggleSearch"])
        ], 2),
        c("div", yD, [
          c("div", null, [
            j(s, {
              item: "menubutton",
              theme: e.theme,
              content: e.content,
              "theme-overrides": {
                colors: {
                  "--fill-color": (R = e.theme.navigation_icon_bg_color) == null ? void 0 : R.hex
                }
              },
              "dropdown-open": e.exploreMenuVisible,
              onToggleDropdown: e.setDropdownVisibility
            }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"]),
            e.menuV4Enabled && e.hasExploreMenuContent && !e.isMobile ? (d(), L(s, {
              key: 0,
              item: "explore-button",
              theme: e.theme,
              content: e.content,
              "theme-overrides": {
                colors: {
                  "--fill-color": (P = e.theme.navigation_icon_bg_color) == null ? void 0 : P.hex
                }
              },
              "dropdown-open": e.exploreMenuVisible,
              onKeydown: t[0] || (t[0] = K(W((z) => e.exploreMenuVisible = !1, ["shift", "exact"]), ["tab"])),
              onToggleDropdown: e.setDropdownVisibility
            }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"])) : T("", !0),
            e.menuV4Enabled && e.exploreMenuVisible ? (d(), L(u, {
              key: 1,
              id: "explore-menu",
              "data-testid": "explore-menu",
              "aria-labelledby": "explore-button",
              styles: e.theme,
              data: e.content.customMenuItems,
              "menu-v4-enabled": e.menuV4Enabled,
              "is-visible": e.exploreMenuVisible,
              "path-prefix": e.content.pathPrefix,
              "is-shrink": e.shrinkCSSClass === "shrink",
              onCloseDropdown: t[1] || (t[1] = (z) => e.exploreMenuVisible = !1)
            }, null, 8, ["styles", "data", "menu-v4-enabled", "is-visible", "path-prefix", "is-shrink"])) : T("", !0),
            e.menuV4Enabled && e.isMobile ? (d(), L(m, {
              key: 2,
              "show-menu": e.content.showMenu,
              theme: e.theme,
              content: e.content,
              "is-preview": e.content.isPreview,
              "is-mobile": e.isMobile,
              "is-shrink": e.shrinkCSSClass === "shrink",
              onCloseMenus: e.closeAllMenus,
              onToggleMobileMenu: t[2] || (t[2] = (z) => e.$emit("toggle-mobile-menu", z))
            }, null, 8, ["show-menu", "theme", "content", "is-preview", "is-mobile", "is-shrink", "onCloseMenus"])) : T("", !0)
          ]),
          e.shouldDisplaySchoolsDropdown ? (d(), f("div", _D, [
            j(s, {
              item: "schoolsbutton",
              theme: e.theme,
              content: e.content,
              "theme-overrides": {
                colors: {
                  "--fill-color": (F = e.theme.navigation_icon_bg_color) == null ? void 0 : F.hex
                }
              },
              "dropdown-open": e.isSchoolDropdownVisible || e.isCustomSchoolsMenuVisible,
              onKeydown: t[3] || (t[3] = K(W((z) => {
                e.schoolDropdownVisible = !1, e.customSchoolsMenuVisible = !1;
              }, ["shift", "exact"]), ["tab"])),
              onToggleDropdown: e.setDropdownVisibility
            }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"]),
            e.content.hasCustomSchoolsMenu ? T("", !0) : (d(), L(u, {
              key: 0,
              id: "schoolsmenu",
              "data-testid": "schools-menu",
              "aria-labelledby": "schoolsbutton",
              styles: e.theme,
              data: e.content.organizations,
              "is-visible": e.schoolDropdownVisible,
              "is-language-menu-hidden": !e.shouldDisplayLanguagesDropdown,
              "is-shrink": e.shrinkCSSClass === "shrink",
              onCloseDropdown: t[4] || (t[4] = (z) => e.schoolDropdownVisible = !1)
            }, null, 8, ["styles", "data", "is-visible", "is-language-menu-hidden", "is-shrink"])),
            j(Le, { name: "slide" }, {
              default: S(() => [
                e.content.hasCustomSchoolsMenu ? (d(), L(v, {
                  key: 0,
                  id: "schoolsmenu",
                  ref: "schoolsmenu",
                  "data-testid": "custom-schools-menu",
                  "header-theme": e.theme,
                  "org-menu-content": e.content.orgMenuContent,
                  organizations: e.content.organizations,
                  "show-custom-schools-menu": e.isCustomSchoolsMenuVisible,
                  "sticky-header": e.shouldBeSticky,
                  "shrink-header": e.shouldShrink,
                  "is-preview": e.content.isPreview,
                  onFocusLost: t[5] || (t[5] = (z) => e.customSchoolsMenuVisible = !1)
                }, null, 8, ["header-theme", "org-menu-content", "organizations", "show-custom-schools-menu", "sticky-header", "shrink-header", "is-preview"])) : T("", !0)
              ]),
              _: 1
            })
          ])) : T("", !0),
          e.shouldDisplayLanguagesDropdown ? (d(), f("div", CD, [
            j(s, {
              item: "languagebutton",
              theme: e.theme,
              content: e.content,
              "theme-overrides": {
                colors: {
                  "--fill-color": (I = e.theme.navigation_icon_bg_color) == null ? void 0 : I.hex
                }
              },
              "dropdown-open": e.languageDropdownVisible,
              onKeydown: t[6] || (t[6] = K(W((z) => e.languageDropdownVisible = !1, ["shift", "exact"]), ["tab"])),
              onToggleDropdown: e.setDropdownVisibility
            }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"]),
            j(g, {
              id: "languagesmenu",
              "data-testid": "languages-menu",
              role: "menu",
              data: e.content.languages,
              styles: e.theme,
              "is-visible": e.languageDropdownVisible,
              "current-language": e.content.langCode,
              onSetLanguage: e.setLanguage,
              onCloseDropdown: t[7] || (t[7] = (z) => e.languageDropdownVisible = !1)
            }, null, 8, ["data", "styles", "is-visible", "current-language", "onSetLanguage"])
          ])) : T("", !0),
          e.showSignInButton ? (d(), f("a", {
            key: 2,
            href: e.signInUrl,
            class: "sign-in-button",
            target: "_blank"
          }, k(e.signInText), 9, wD)) : T("", !0)
        ])
      ]),
      c("div", TD, [
        c("div", kD, [
          c("div", ED, [
            j(s, {
              item: "menubutton",
              theme: e.theme,
              content: e.content,
              "theme-overrides": {
                colors: {
                  "--fill-color": (D = e.theme.navigation_icon_bg_color) == null ? void 0 : D.hex
                }
              },
              "dropdown-open": e.exploreMenuVisible,
              onKeydown: t[8] || (t[8] = K(W((z) => e.exploreMenuVisible = !1, ["shift", "exact"]), ["tab"])),
              onToggleDropdown: e.setDropdownVisibility
            }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"]),
            e.menuV4Enabled && e.exploreMenuVisible ? (d(), L(u, {
              key: 0,
              id: "explore-menu",
              "data-testid": "explore-menu",
              "aria-labelledby": "explore-button",
              styles: e.theme,
              data: e.content.sitemapMenuItems,
              "menu-v4-enabled": e.menuV4Enabled,
              "is-visible": e.exploreMenuVisible,
              "path-prefix": e.content.pathPrefix,
              "is-shrink": e.shrinkCSSClass === "shrink",
              onCloseDropdown: t[9] || (t[9] = (z) => e.exploreMenuVisible = !1)
            }, null, 8, ["styles", "data", "menu-v4-enabled", "is-visible", "path-prefix", "is-shrink"])) : T("", !0),
            e.menuV4Enabled && e.isMobile ? (d(), L(m, {
              key: 1,
              "show-menu": e.content.showMenu,
              theme: e.theme,
              content: e.content,
              "is-preview": e.content.isPreview,
              "is-mobile": e.isMobile,
              "is-shrink": e.shrinkCSSClass === "shrink",
              onCloseMenus: e.closeAllMenus,
              onToggleMobileMenu: t[10] || (t[10] = (z) => e.$emit("toggle-mobile-menu", z))
            }, null, 8, ["show-menu", "theme", "content", "is-preview", "is-mobile", "is-shrink", "onCloseMenus"])) : T("", !0)
          ]),
          e.shouldDisplaySchoolsDropdown ? (d(), f("div", SD, [
            j(s, {
              item: "schoolsbutton",
              theme: e.theme,
              content: e.content,
              "theme-overrides": {
                colors: {
                  "--fill-color": (O = e.theme.navigation_icon_bg_color) == null ? void 0 : O.hex
                }
              },
              "dropdown-open": e.isSchoolDropdownVisible || e.isCustomSchoolsMenuVisible,
              onKeydown: t[11] || (t[11] = K(W((z) => {
                e.schoolDropdownVisible = !1, e.customSchoolsMenuVisible = !1;
              }, ["shift", "exact"]), ["tab"])),
              onToggleDropdown: e.setDropdownVisibility
            }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"]),
            e.content.hasCustomSchoolsMenu ? T("", !0) : (d(), L(u, {
              key: 0,
              id: "schoolsmenu",
              "data-testid": "schools-menu",
              "aria-labelledby": "schoolsbutton",
              styles: e.theme,
              data: e.content.organizations,
              "is-visible": e.schoolDropdownVisible,
              "is-preview": e.content.isPreview,
              "is-language-menu-hidden": !e.shouldDisplayLanguagesDropdown,
              "is-shrink": e.shrinkCSSClass === "shrink",
              onCloseDropdown: t[12] || (t[12] = (z) => e.schoolDropdownVisible = !1)
            }, null, 8, ["styles", "data", "is-visible", "is-preview", "is-language-menu-hidden", "is-shrink"])),
            j(Le, { name: "slide" }, {
              default: S(() => [
                e.content.hasCustomSchoolsMenu ? (d(), L(v, {
                  key: 0,
                  id: "schoolsmenu",
                  ref: "schoolsmenu",
                  "data-testid": "schools-menu",
                  "header-theme": e.theme,
                  content: e.content.globals.homepage,
                  "org-menu-content": e.content.orgMenuContent,
                  organizations: e.content.organizations,
                  "show-custom-schools-menu": e.isCustomSchoolsMenuVisible,
                  "sticky-header": e.shouldBeSticky,
                  "shrink-header": e.shouldShrink,
                  "is-preview": e.content.isPreview,
                  onFocusLost: t[13] || (t[13] = (z) => e.customSchoolsMenuVisible = !1)
                }, null, 8, ["header-theme", "content", "org-menu-content", "organizations", "show-custom-schools-menu", "sticky-header", "shrink-header", "is-preview"])) : T("", !0)
              ]),
              _: 1
            })
          ])) : T("", !0)
        ]),
        c("div", {
          class: _(["right-right-menu", { "show-sign-in-button": e.showSignInButton }])
        }, [
          e.shouldDisplayLanguagesDropdown ? (d(), f("div", MD, [
            j(s, {
              item: "languagebutton",
              theme: e.theme,
              content: e.content,
              "theme-overrides": {
                colors: {
                  "--fill-color": (U = e.theme.navigation_icon_bg_color) == null ? void 0 : U.hex
                }
              },
              "is-mobile": "",
              "dropdown-open": e.languageDropdownVisible,
              onKeydown: t[14] || (t[14] = K(W((z) => e.languageDropdownVisible = !1, ["shift", "exact"]), ["tab"])),
              onToggleDropdown: e.setDropdownVisibility
            }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"]),
            j(g, {
              id: "languagesmenu",
              "data-testid": "languages-menu",
              role: "menu",
              data: e.content.languages,
              styles: e.theme,
              "is-visible": e.languageDropdownVisible,
              "current-language": e.content.langCode,
              onSetLanguage: e.setLanguage,
              onCloseDropdown: t[15] || (t[15] = (z) => e.languageDropdownVisible = !1)
            }, null, 8, ["data", "styles", "is-visible", "current-language", "onSetLanguage"])
          ])) : T("", !0),
          e.showSignInButton ? (d(), f("a", {
            key: 1,
            href: e.signInUrl,
            class: "sign-in-button",
            target: "_blank"
          }, k(e.signInText), 9, AD)) : T("", !0)
        ], 2)
      ])
    ], 2)) : (d(), L(h, {
      key: 1,
      theme: e.theme,
      content: e.content,
      "menu-button-bg-color": "transparent",
      "menu-button-icon-color": (q = e.theme.navigation_color) == null ? void 0 : q.hex,
      "is-shrink": e.shrinkCSSClass === "shrink",
      "show-sign-in-button": e.showSignInButton,
      "sign-in-url": e.signInUrl,
      onToggleMobileMenu: t[16] || (t[16] = (z) => e.$emit("toggle-mobile-menu", z)),
      onToggleSearch: t[17] || (t[17] = (z) => e.$emit("toggle-search")),
      onSetLanguage: e.setLanguage,
      onCloseMenu: e.closeAllMenus
    }, null, 8, ["theme", "content", "menu-button-icon-color", "is-shrink", "show-sign-in-button", "sign-in-url", "onSetLanguage", "onCloseMenu"]))
  ], 4)), [
    [E, e.closeAllMenus]
  ]);
}
const LD = /* @__PURE__ */ B(pD, [["render", ID], ["__scopeId", "data-v-6ba1f947"]]), DD = {
  mixins: [ut, Et],
  props: {
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["update:utilities", "toggle-language-dropdown"],
  components: {
    OrgBanner: fr,
    UtilityBar: G4,
    LanguageDropdown: Fs,
    MobileHeader: Zr
  },
  mixins: [ut, Et]
};
function $D(e, t, n, r, o, i) {
  var v, g;
  const a = V("MobileHeader"), s = V("OrgBanner"), l = V("UtilityBar"), u = V("LanguageDropdown"), m = ze("click-away");
  return we((d(), f("div", {
    id: "h3",
    style: Z(e.colors)
  }, [
    e.isMobile ? (d(), L(a, {
      key: 0,
      theme: e.theme,
      content: e.content,
      "menu-button-bg-color": (v = e.theme.navigation_icon_bg_color) == null ? void 0 : v.hex,
      "menu-button-icon-color": (g = e.theme.navigation_icon_color) == null ? void 0 : g.hex,
      "show-utilities": !0,
      "show-sign-in-button": e.showSignInButton,
      "sign-in-url": e.signInUrl,
      "is-shrink": e.shrinkCSSClass === "shrink",
      "hide-menu-button": "",
      onToggleMenu: t[0] || (t[0] = (h) => e.$emit("toggle-menu")),
      onToggleMobileMenu: t[1] || (t[1] = (h) => e.$emit("toggle-mobile-menu", h)),
      onToggleSearch: t[2] || (t[2] = (h) => e.$emit("toggle-search")),
      onLanguageChange: t[3] || (t[3] = (h) => e.$emit("language-change")),
      onCloseMenu: e.closeAllMenus
    }, null, 8, ["theme", "content", "menu-button-bg-color", "menu-button-icon-color", "show-sign-in-button", "sign-in-url", "is-shrink", "onCloseMenu"])) : (d(), f("div", {
      key: 1,
      class: _(["utility-menu", [e.theme.shadow_type, { isIframe: e.content.isIFrame }]])
    }, [
      j(s, {
        "logo-link": e.logoLink,
        "should-shrink": e.shouldShrink,
        theme: e.theme,
        globals: e.content.globals
      }, null, 8, ["logo-link", "should-shrink", "theme", "globals"]),
      c("div", {
        "data-testid": "utilities-bar",
        class: _([e.shrinkCSSClass, "utilities-bar"])
      }, [
        j(l, {
          class: _([[e.theme.style, e.theme.version, e.shrinkCSSClass], "utility-bar-items"]),
          utilities: e.content.utilities,
          "is-editing": e.content.isEditing,
          "theme-version": e.theme.version,
          "translated-title": e.theme.translations.translate_dropdown_title,
          "wrapper-component": n.wrapperComponent,
          "wrapper-props": n.wrapperProps,
          "text-color": e.colors["--utility-link-color"],
          "bg-color": "transparent",
          "language-dropdown-open": e.languageDropdownVisible,
          "has-languages": e.hasLanguages,
          onToggleLanguageDropdown: t[4] || (t[4] = (h) => e.setDropdownVisibility("languagebutton")),
          "onUpdate:utilities": t[5] || (t[5] = (h) => e.$emit("update:utilities", h))
        }, {
          utility: S(({ idx: h }) => [
            M(e.$slots, "utility", { idx: h }, void 0, !0)
          ]),
          _: 3
        }, 8, ["class", "utilities", "is-editing", "theme-version", "translated-title", "wrapper-component", "wrapper-props", "text-color", "language-dropdown-open", "has-languages"]),
        j(u, {
          id: "languagesmenu",
          "data-testid": "languages-menu",
          role: "menu",
          data: e.content.languages,
          styles: e.theme,
          "is-visible": e.languageDropdownVisible,
          "current-language": e.content.langCode,
          onSetLanguage: e.setLanguage,
          onCloseDropdown: t[6] || (t[6] = (h) => e.languageDropdownVisible = !1)
        }, null, 8, ["data", "styles", "is-visible", "current-language", "onSetLanguage"])
      ], 2)
    ], 2))
  ], 4)), [
    [m, e.closeAllMenus]
  ]);
}
const OD = /* @__PURE__ */ B(DD, [["render", $D], ["__scopeId", "data-v-04771afc"]]), PD = {
  name: "UtilityBar",
  components: {
    DraggableWrapper: yt
  },
  props: {
    utilities: {
      type: Array,
      required: !0
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    textColor: {
      type: String,
      required: !0
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["update:utilities"]
};
function ND(e, t, n, r, o, i) {
  return d(), L(Y(n.wrapperComponent), Se(n.wrapperProps, {
    "model-value": n.utilities,
    "item-key": "idx",
    class: "utility-bar",
    "onUpdate:modelValue": t[0] || (t[0] = (a) => e.$emit("update:utilities", a))
  }), {
    item: S(({ element: a, index: s }) => [
      (d(), L(Y(n.isEditing ? "div" : "a"), {
        class: "utilities",
        href: a.link,
        style: Z({ color: n.textColor }),
        target: a.opens_in_new_tab ? "_blank" : ""
      }, {
        default: S(() => [
          M(e.$slots, "utility", { idx: s }, () => [
            H(k(a.name), 1)
          ], !0)
        ]),
        _: 2
      }, 1032, ["href", "style", "target"]))
    ]),
    _: 3
  }, 16, ["model-value"]);
}
const HD = /* @__PURE__ */ B(PD, [["render", ND], ["__scopeId", "data-v-f4ecbd63"]]), FD = {
  name: "MenuIcon",
  props: {
    type: {
      type: String,
      default: "arrow-1"
    }
  }
}, RD = {
  key: 0,
  class: "menu-icon",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}, VD = {
  key: 1,
  class: "menu-icon",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
};
function BD(e, t, n, r, o, i) {
  return d(), f(J, null, [
    n.type === "arrow-2" ? (d(), f("svg", RD, t[0] || (t[0] = [
      c("path", {
        d: "M6 13L11 8L6 3",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)
    ]))) : T("", !0),
    n.type === "arrow-1" ? (d(), f("svg", VD, t[1] || (t[1] = [
      c("g", null, [
        c("path", {
          d: "M1.5 8L14.5 8M14.5 8L10.4375 12.875M14.5 8L10.4375 3.125",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        })
      ], -1)
    ]))) : T("", !0)
  ], 64);
}
const jD = /* @__PURE__ */ B(FD, [["render", BD]]), UD = {
  name: "M6",
  components: {
    MenuIcon: jD
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      required: !0
    },
    isMobile: Boolean
  },
  data() {
    return {
      currentPath: []
    };
  },
  computed: {
    breadcrumbTrail() {
      return this.currentPath;
    },
    currentLevelItems() {
      return this.currentPath.length === 0 ? this.isMobile ? this.mobileMenuItems : this.content.sitemapMenuItems : this.currentPath[this.currentPath.length - 1].children || [];
    },
    mobileContent() {
      return ge(ae({}, this.content), { menuItems: this.mobileMenuItems });
    },
    shouldDisplaySchoolsDropdown() {
      var e;
      return ((e = this.content.organizations) == null ? void 0 : e.length) > 1 || this.content.hasCustomSchoolsMenu;
    },
    shouldDisplayUtilities() {
      return this.isMobile ? this.currentPath.length === 0 : !0;
    },
    mobileMenuItems() {
      return [
        ...this.shouldDisplaySchoolsDropdown ? [
          {
            id: "schools-header",
            name: this.theme.schools_field || "Schools",
            slug: "schools",
            type: "header",
            children: this.buildSchoolsMenu(
              this.content.hasCustomSchoolsMenu ? this.content.orgMenuContent.flat() : this.content.organizations
            )
          }
        ] : [{}],
        {
          id: "explore-header",
          name: this.theme.menu_field || "Explore",
          slug: "explore",
          type: "header",
          children: this.content.customMenuItems.map((e) => ({
            id: `explore-${e.id}`,
            name: e.name,
            slug: e.url,
            icon: e.icon,
            cms_icon_id: e.cms_icon_id,
            icon_cms: e.icon_cms,
            url: e.url,
            opens_in_new_tab: e.opens_in_new_tab,
            type: "explore",
            children: []
          }))
        },
        ...this.content.sitemapMenuItems
      ];
    },
    colors() {
      return {
        "--heading-color": this.theme.menu_heading_color.hex,
        "--heading-line-color": this.theme.menu_heading_line_color.hex,
        "--icon-color": this.content.menuOptions.icon_color.hex,
        "--icon-bg-color": this.content.menuOptions.icon_bg_color.hex,
        "--icon-text-color": this.content.menuOptions.icon_text_color.hex,
        "--icon-text-hover-color": this.content.menuOptions.icon_text_hover_color.hex,
        "--text-color": this.content.menuOptions.text_color.hex,
        "--text-hover-color": this.content.menuOptions.text_hover_color.hex,
        "--utilities-color": this.theme.utility_link_color.hex
      };
    }
  },
  methods: {
    getPageUrl(e) {
      return e ? `${this.content.pathPrefix}/page/${e.slug}` : "";
    },
    getLinkUrl(e) {
      return e ? e.mailto && e.email_address ? `mailto:${e.email_address}` : e.ipAddress ? `http://${e.url}` : e.url : "";
    },
    targetWindow(e) {
      return e.opens_in_new_tab ? "_blank" : "_self";
    },
    getLink(e) {
      return e && e[0] === "/" ? `${this.content.pathPrefix}${e}` : e;
    },
    selectItem(e) {
      e.children && e.children.length > 0 && this.currentPath.push(e);
    },
    navigateTo(e) {
      this.currentPath = this.currentPath.slice(0, e + 1);
    },
    resetToMenu() {
      this.currentPath = [];
    },
    buildSchoolsMenu(e) {
      if (qr(e))
        return [];
      const t = (r) => {
        let o = "";
        switch (r) {
          case "SchoolsMenuOrg":
            o = "link";
            break;
          case "SchoolsMenuLink":
            o = "link";
            break;
          case "SchoolsMenuImage":
            o = "image";
            break;
          case "SchoolsMenuHeader":
            o = "header";
            break;
          default:
            o = "link";
            break;
        }
        return o;
      }, n = (r) => r.type === "SchoolsMenuLink" ? r.link : r.type === "SchoolsMenuOrg" && this.content.hasCustomSchoolsMenu ? P0(r, this.content.organizations, {
        isPreview: this.content.isPreview
      }) : zr(r, {
        isPreview: this.content.isPreview,
        currentDomain: window.location.href
      });
      return e.map((r, o) => ({
        id: `schools-${o}`,
        name: r.name,
        slug: r.link || r.path_prefix,
        url: n(r),
        imgSrc: r.url,
        altText: r.alt_text,
        imgHasLink: r.action_on_click === "no_action",
        opens_in_new_tab: r.opens_in_new_tab,
        type: t(r.type),
        children: this.buildSchoolsMenu(r.children)
      }));
    },
    getCustomMenuItemHref(e) {
      return e.type === "page" ? this.getPageUrl(e) : e.type === "explore" ? this.getLink(e.url) : this.getLinkUrl(e);
    }
  }
}, qD = {
  key: 0,
  class: "heading"
}, GD = ["onClick", "onKeydown"], KD = { key: 1 }, zD = { class: "custom-menu-items" }, ZD = ["innerHTML"], xD = ["href", "target"], WD = {
  key: 1,
  class: "utilities"
}, YD = ["href", "target"], XD = {
  key: 2,
  class: "heading-mobile"
}, QD = ["onClick", "onKeydown"], JD = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}, e$ = {
  key: 1,
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
}, t$ = ["onClick", "onKeydown"], n$ = { class: "name" }, r$ = ["src", "alt"], o$ = ["innerHTML"], i$ = ["href", "target"], s$ = ["onClick", "onKeydown"];
function a$(e, t, n, r, o, i) {
  const a = V("MenuIcon");
  return d(), f("div", {
    id: "m6",
    class: "menu",
    style: Z(i.colors)
  }, [
    n.content.menuOptions.menu_titles ? (d(), f("div", qD, [
      c("div", {
        class: _(["breadcrumb", { [n.theme.style]: n.theme.style }])
      }, [
        c("div", {
          class: _(["breadcrumb-item", { active: o.currentPath.length === 0 }])
        }, [
          c("div", {
            tabindex: "0",
            role: "button",
            class: "home",
            onClick: t[0] || (t[0] = (...s) => i.resetToMenu && i.resetToMenu(...s)),
            onKeydown: [
              t[1] || (t[1] = K((...s) => i.resetToMenu && i.resetToMenu(...s), ["enter"])),
              t[2] || (t[2] = K((...s) => i.resetToMenu && i.resetToMenu(...s), ["space"]))
            ]
          }, [
            o.currentPath.length > 0 ? (d(), L(a, {
              key: 0,
              type: n.content.menuOptions.link_icon
            }, null, 8, ["type"])) : T("", !0),
            H(" " + k(n.theme.translations.menu_dropdown_title), 1)
          ], 32)
        ], 2),
        (d(!0), f(J, null, ne(i.breadcrumbTrail, (s, l) => (d(), f("div", {
          key: s.id,
          class: _(["breadcrumb-item", { active: l === i.breadcrumbTrail.length - 1 }])
        }, [
          l !== i.breadcrumbTrail.length - 1 ? (d(), f("div", {
            key: 0,
            tabindex: "0",
            role: "button",
            onClick: (u) => i.navigateTo(l),
            onKeydown: [
              K((u) => i.navigateTo(l), ["enter"]),
              K((u) => i.navigateTo(l), ["space"])
            ]
          }, k(s.name), 41, GD)) : (d(), f("span", KD, k(s.name), 1))
        ], 2))), 128))
      ], 2),
      t[3] || (t[3] = c("div", { class: "line" }, null, -1))
    ])) : T("", !0),
    c("div", zD, [
      (d(!0), f(J, null, ne(n.content.customMenuItems, (s) => (d(), f("div", {
        key: s.id,
        class: "item"
      }, [
        s.icon || s.icon_cms ? (d(), f("span", {
          key: 0,
          class: _(["icon", s.icon_cms && "global-icon"]),
          innerHTML: s.icon || s.icon_cms
        }, null, 10, ZD)) : T("", !0),
        c("a", {
          class: "name",
          href: i.getLink(s.url),
          target: i.targetWindow(s)
        }, k(s.name), 9, xD)
      ]))), 128))
    ]),
    i.shouldDisplayUtilities ? (d(), f("div", WD, [
      (d(!0), f(J, null, ne(n.content.utilities, (s) => (d(), f("a", {
        key: s.id,
        href: s.link,
        target: s.opens_in_new_tab ? "_blank" : "",
        class: "utility"
      }, k(s.name), 9, YD))), 128))
    ])) : T("", !0),
    o.currentPath.length > 0 && n.isMobile ? (d(), f("div", XD, [
      (d(!0), f(J, null, ne(i.breadcrumbTrail, (s, l) => (d(), f("div", {
        key: s.id,
        class: _(["breadcrumb", { [n.theme.style]: n.theme.style }])
      }, [
        c("div", {
          tabindex: "0",
          role: "button",
          class: _(["breadcrumb-item", { active: l === i.breadcrumbTrail.length - 1 }]),
          onClick: (u) => i.navigateTo(l - 1),
          onKeydown: [
            K((u) => i.navigateTo(l - 1), ["enter"]),
            K((u) => i.navigateTo(l - 1), ["space"])
          ]
        }, [
          n.content.menuOptions.link_icon === "arrow-2" ? (d(), f("svg", JD, t[4] || (t[4] = [
            c("path", {
              d: "M6 13L11 8L6 3",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, -1)
          ]))) : (d(), f("svg", e$, t[5] || (t[5] = [
            c("g", null, [
              c("path", {
                d: "M1.5 8L14.5 8M14.5 8L10.4375 12.875M14.5 8L10.4375 3.125",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              })
            ], -1)
          ]))),
          c("span", null, k(s.name), 1)
        ], 42, QD)
      ], 2))), 128)),
      t[6] || (t[6] = c("div", { class: "line" }, null, -1))
    ])) : T("", !0),
    c("div", {
      class: _(["sitemap-menu-items", { "first-level": o.currentPath.length === 0 && n.isMobile }])
    }, [
      (d(!0), f(J, null, ne(i.currentLevelItems, (s) => (d(), f("div", {
        key: s.id,
        class: _(["item", s.type])
      }, [
        s.type === "header" ? (d(), f("div", {
          key: 0,
          class: "wrapper",
          role: "button",
          tabindex: "0",
          onClick: (l) => i.selectItem(s),
          onKeydown: [
            K((l) => i.selectItem(s), ["enter"]),
            K((l) => i.selectItem(s), ["space"])
          ]
        }, [
          c("span", n$, k(s.name), 1),
          j(a, {
            type: n.content.menuOptions.link_icon
          }, null, 8, ["type"])
        ], 40, t$)) : s.type === "image" ? (d(), f("img", {
          key: 1,
          src: s.imgSrc,
          alt: s.altText
        }, null, 8, r$)) : (d(), f(J, { key: 2 }, [
          s.icon || s.icon_cms ? (d(), f("span", {
            key: 0,
            class: _(["icon", s.icon_cms && "global-icon"]),
            innerHTML: s.icon || s.icon_cms
          }, null, 10, o$)) : T("", !0),
          c("a", {
            class: "name",
            href: i.getCustomMenuItemHref(s),
            target: i.targetWindow(s)
          }, k(s.name), 9, i$),
          s.children && s.children.length > 0 ? (d(), f("div", {
            key: 1,
            class: "icon-wrapper",
            role: "button",
            tabindex: "0",
            onClick: (l) => i.selectItem(s),
            onKeydown: [
              K((l) => i.selectItem(s), ["enter"]),
              K((l) => i.selectItem(s), ["space"])
            ]
          }, [
            j(a, {
              type: n.content.menuOptions.link_icon
            }, null, 8, ["type"])
          ], 40, s$)) : T("", !0)
        ], 64))
      ], 2))), 128))
    ], 2)
  ], 4);
}
const l$ = /* @__PURE__ */ B(UD, [["render", a$], ["__scopeId", "data-v-9da1feb8"]]), u$ = {
  components: {
    UtilityBar: HD,
    LanguageDropdown: Fs,
    MenuItem: Yt,
    CmsSchoolsMenu: mr,
    M6: l$
  },
  mixins: [ut, Et],
  mixins: [ut, Et],
  props: {
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["update:utilities"],
  computed: {
    slogan() {
      var n, r, o, i, a;
      const e = (r = (n = this.theme) == null ? void 0 : n.translations) == null ? void 0 : r.school_tag_line, t = (a = (i = (o = this.content) == null ? void 0 : o.globals) == null ? void 0 : i.info) == null ? void 0 : a.school_tag_line;
      return e || t;
    },
    bgTypeClass() {
      return this.isMobile ? "solid" : this.theme.bg_type;
    },
    menuButtonIcon() {
      return {
        arrow: "TriangleIcon",
        plus: "PlusIcon",
        hamburger: "HamburgerIcon"
      }[this.theme.menu_icon];
    },
    menuButtonColors() {
      var n, r, o;
      const e = {
        "--dropdown-class": this.content.showMenu ? "open" : "close"
      }, t = {
        plus: {
          "--fill-color": "transparent",
          "--fill-path-color": (n = this.theme.navigation_color) == null ? void 0 : n.hex
        },
        hamburger: {
          "--fill-color": "transparent",
          "--fill-path-color": (r = this.theme.navigation_color) == null ? void 0 : r.hex
        },
        arrow: {
          "--fill-color": (o = this.theme.navigation_color) == null ? void 0 : o.hex
        }
      };
      return ae(ae({}, e), t[this.theme.menu_icon]);
    },
    colors() {
      var e, t, n, r, o, i, a, s, l, u, m, v, g, h, E, C, A, R, P, F, I, D;
      return ae({
        "--bg-color": this.theme.bg_color.hex,
        "--nav-color": (t = (e = this.theme) == null ? void 0 : e.navigation_color) == null ? void 0 : t.hex,
        "--menu-heading-color": (r = (n = this.theme) == null ? void 0 : n.menu_heading_color) == null ? void 0 : r.hex,
        "--menu-heading-line-color": (i = (o = this.theme) == null ? void 0 : o.menu_heading_line_color) == null ? void 0 : i.hex,
        "--school-name-color": (s = (a = this.theme) == null ? void 0 : a.school_name_color) == null ? void 0 : s.hex,
        "--school-menu-text-color": (u = (l = this.theme) == null ? void 0 : l.schools_menu_text_color) == null ? void 0 : u.hex,
        "--school-tagline-color": (v = (m = this.theme) == null ? void 0 : m.school_tagline_color) == null ? void 0 : v.hex,
        "--school-tagline-bg-color": (h = (g = this.theme) == null ? void 0 : g.utility_bg_color) == null ? void 0 : h.hex,
        "--navigation-links": (C = (E = this.theme) == null ? void 0 : E.utility_link_color) == null ? void 0 : C.hex,
        "--language-color": (R = (A = this.theme) == null ? void 0 : A.language_color) == null ? void 0 : R.hex,
        "--search-color": (F = (P = this.theme) == null ? void 0 : P.search_color) == null ? void 0 : F.hex,
        "--background-opacity": `${(D = (I = this.theme) == null ? void 0 : I.background_opacity) != null ? D : "80"}%`
      }, this.signInColors);
    }
  },
  methods: {
    orgLink(e) {
      return zr(e, {
        isPreview: this.isPreview,
        currentDomain: window.location.href
      });
    },
    schoolButtonClick() {
      this.setDropdownVisibility("schoolsbutton"), this.content.showMenu && this.$emit("toggle-menu", !1);
    }
  }
}, d$ = { class: "top-header" }, c$ = { class: "slogan" }, h$ = { class: "menu" }, m$ = { class: "wrapper" }, f$ = { class: "org-banner" }, p$ = ["href"], g$ = ["src"], v$ = { class: "school-info" }, b$ = ["href"], y$ = { class: "menu-buttons" }, _$ = {
  key: 0,
  id: "sign-in-button-wrapper"
}, C$ = ["href"], w$ = { class: "menus" }, T$ = {
  key: 1,
  class: "schools-menu",
  "data-testid": "schools-menu"
}, k$ = { class: "school-links" }, E$ = ["href"], S$ = {
  key: 2,
  class: "schools-menu",
  "data-testid": "schools-menu"
};
function M$(e, t, n, r, o, i) {
  var g, h, E, C;
  const a = V("MenuItem"), s = V("LanguageDropdown"), l = V("UtilityBar"), u = V("M6"), m = V("CmsSchoolsMenu"), v = ze("click-away");
  return we((d(), f("div", {
    class: _(["h4", { expanded: e.isCustomSchoolsMenuVisible || e.schoolDropdownVisible || e.content.showMenu }]),
    style: Z(i.colors)
  }, [
    c("div", d$, [
      c("span", c$, k(i.slogan), 1),
      c("div", h$, [
        j(a, {
          item: "languagebutton",
          theme: e.theme,
          content: e.content,
          "is-uppercase": !0,
          "dropdown-open": e.languageDropdownVisible,
          "theme-overrides": {
            icon: "TriangleIcon",
            colors: {
              "--fill-color": (g = e.theme.language_color) == null ? void 0 : g.hex,
              "--nav-color": (h = e.theme.language_color) == null ? void 0 : h.hex
            }
          },
          onToggleDropdown: e.setDropdownVisibility
        }, null, 8, ["theme", "content", "dropdown-open", "theme-overrides", "onToggleDropdown"]),
        j(s, {
          id: "languagesmenu",
          "data-testid": "languages-menu",
          role: "menu",
          data: e.content.languages,
          styles: e.theme,
          "is-visible": e.languageDropdownVisible,
          "current-language": e.content.langCode,
          onSetLanguage: e.setLanguage,
          onCloseDropdown: t[0] || (t[0] = (A) => e.languageDropdownVisible = !1)
        }, null, 8, ["data", "styles", "is-visible", "current-language", "onSetLanguage"]),
        j(a, {
          item: "searchbutton",
          class: "search-button",
          theme: e.theme,
          content: e.content,
          "theme-overrides": {
            colors: {
              "--icon-color": (E = e.theme.search_color) == null ? void 0 : E.hex,
              "--nav-color": (C = e.theme.search_color) == null ? void 0 : C.hex
            }
          },
          onToggleSearch: e.toggleSearch
        }, null, 8, ["theme", "content", "theme-overrides", "onToggleSearch"])
      ])
    ]),
    c("div", {
      class: _(["bottom-header", [
        e.theme.shadow_type,
        i.bgTypeClass,
        { expanded: e.isCustomSchoolsMenuVisible || e.schoolDropdownVisible || e.content.showMenu }
      ]])
    }, [
      c("div", m$, [
        c("div", f$, [
          c("a", {
            href: e.logoLink,
            class: "logo"
          }, [
            c("img", {
              src: e.content.globals.logo.url,
              alt: "Return to Home"
            }, null, 8, g$)
          ], 8, p$),
          c("div", v$, [
            e.content.globals.info.customHeader ? (d(), f("h1", {
              key: 0,
              class: _({ "sr-only": e.content.globals.info.customHeader })
            }, k(e.content.globals.info.school_name) + " - " + k(i.slogan), 3)) : T("", !0),
            e.content.globals.info.customHeader ? T("", !0) : (d(), f("a", {
              key: 1,
              href: e.logoLink,
              class: "name"
            }, [
              c("h1", {
                class: _([e.theme.style, "org-name"])
              }, k(e.content.globals.info.school_name), 3),
              c("div", {
                class: _(["slogan", { [e.theme.style]: e.theme.style }])
              }, k(i.slogan), 3)
            ], 8, b$)),
            c("div", y$, [
              j(a, {
                item: "schoolsbutton",
                class: "schools-button",
                theme: e.theme,
                content: e.content,
                "dropdown-open": e.isSchoolDropdownVisible || e.isCustomSchoolsMenuVisible,
                "theme-overrides": {
                  icon: "TriangleIcon"
                },
                onToggleDropdown: i.schoolButtonClick
              }, null, 8, ["theme", "content", "dropdown-open", "onToggleDropdown"]),
              j(a, {
                item: "menubutton",
                class: "desktop-menu-button",
                theme: e.theme,
                content: e.content,
                "theme-overrides": {
                  icon: i.menuButtonIcon,
                  colors: i.menuButtonColors
                },
                onToggleDropdown: e.setDropdownVisibility
              }, null, 8, ["theme", "content", "theme-overrides", "onToggleDropdown"])
            ])
          ])
        ]),
        j(a, {
          item: "menubutton",
          class: "mobile-menu-button",
          theme: e.theme,
          content: e.content,
          "theme-overrides": {
            icon: i.menuButtonIcon,
            colors: i.menuButtonColors
          },
          onToggleDropdown: e.setDropdownVisibility
        }, null, 8, ["theme", "content", "theme-overrides", "onToggleDropdown"]),
        j(l, {
          class: _([[e.theme.style, e.theme.version, e.shrinkCSSClass], "utility-bar-items"]),
          "data-testid": "utility-bar",
          utilities: e.content.utilities,
          "is-editing": e.content.isEditing,
          "wrapper-component": n.wrapperComponent,
          "wrapper-props": n.wrapperProps,
          "text-color": e.theme.utility_link_color.hex,
          "onUpdate:utilities": t[1] || (t[1] = (A) => e.$emit("update:utilities", A))
        }, {
          utility: S(({ idx: A }) => [
            M(e.$slots, "utility", { idx: A }, void 0, !0)
          ]),
          _: 3
        }, 8, ["class", "utilities", "is-editing", "wrapper-component", "wrapper-props", "text-color"]),
        e.showSignInButton ? (d(), f("div", _$, [
          c("a", {
            href: e.signInUrl,
            class: "sign-in-button",
            target: "_blank"
          }, k(e.signInText), 9, C$)
        ])) : T("", !0)
      ]),
      c("div", w$, [
        e.menuV6Enabled && e.content.showMenu ? (d(), L(u, {
          key: 0,
          theme: e.theme,
          content: e.content,
          "is-mobile": e.isMobile
        }, null, 8, ["theme", "content", "is-mobile"])) : T("", !0),
        !e.content.hasCustomSchoolsMenu && e.schoolDropdownVisible ? (d(), f("div", T$, [
          c("div", {
            class: _(["heading", { [e.theme.style]: e.theme.style }])
          }, [
            c("div", null, k(e.theme.translations.schools_dropdown_title), 1),
            t[3] || (t[3] = c("div", { class: "line" }, null, -1))
          ], 2),
          c("div", k$, [
            (d(!0), f(J, null, ne(e.content.organizations, (A, R) => (d(), f("a", {
              key: R,
              href: i.orgLink(A),
              class: "link"
            }, k(A.name), 9, E$))), 128))
          ])
        ])) : T("", !0),
        e.content.hasCustomSchoolsMenu && e.isCustomSchoolsMenuVisible ? (d(), f("div", S$, [
          c("div", {
            class: _(["heading", { [e.theme.style]: e.theme.style }])
          }, [
            c("div", null, k(e.theme.translations.schools_dropdown_title), 1),
            t[4] || (t[4] = c("div", { class: "line" }, null, -1))
          ], 2),
          j(m, {
            id: "schoolsmenu",
            ref: "schoolsmenu",
            "data-testid": "custom-schools-menu",
            role: "menu",
            "header-theme": e.theme,
            "org-menu-content": e.content.orgMenuContent,
            organizations: e.content.organizations,
            "show-custom-schools-menu": e.isCustomSchoolsMenuVisible,
            "shrink-header": e.shouldShrink,
            "is-preview": e.content.isPreview,
            onFocusLost: t[2] || (t[2] = (A) => e.customSchoolsMenuVisible = !1)
          }, null, 8, ["header-theme", "org-menu-content", "organizations", "show-custom-schools-menu", "shrink-header", "is-preview"])
        ])) : T("", !0)
      ])
    ], 2)
  ], 6)), [
    [v, e.closeAllMenus]
  ]);
}
const A$ = /* @__PURE__ */ B(u$, [["render", M$], ["__scopeId", "data-v-c10146bf"]]), I$ = ["fill"], L$ = {
  __name: "FilledTriangleArrow",
  props: {
    iconColor: {
      type: String,
      default: null
    },
    isOpen: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return (t, n) => (d(), f("svg", {
      class: _(e.isOpen ? "open" : "close"),
      xmlns: "http://www.w3.org/2000/svg",
      width: "16",
      height: "16",
      viewBox: "0 0 14 11",
      fill: "none"
    }, [
      c("path", {
        d: "M7.86603 10.5C7.48112 11.1667 6.51888 11.1667 6.13397 10.5L0.937822 1.5C0.552922 0.833332 1.03405 -1.22094e-06 1.80385 -1.15364e-06L12.1962 -2.4512e-07C12.966 -1.77822e-07 13.4471 0.833333 13.0622 1.5L7.86603 10.5Z",
        fill: e.iconColor
      }, null, 8, I$)
    ], 2));
  }
}, D$ = /* @__PURE__ */ B(L$, [["__scopeId", "data-v-23478d63"]]), $$ = {
  components: {
    DraggableWrapper: yt,
    HamburgerIcon: $0,
    TriangleIcon: S4,
    FilledTriangleArrow: D$,
    PlusIcon: O0,
    MenuItem: Yt,
    CmsSchoolsMenu: mr
  },
  mixins: [ut, Et],
  props: {
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["update:utilities"],
  computed: {
    colors() {
      return ae({
        "--utility-bg-color": this.theme.main_nav_bg === "solid" || !this.isHomepage ? this.theme.utility_bg_color.hex : ue(this.theme.utility_bg_color.hex).setAlpha(0.75).toRgbString(),
        "--utility-text-color": this.theme.utility_link_color.hex,
        "--utility-nav-position": this.theme.main_nav_bg === "solid" || !this.isHomepage ? "block" : "absolute",
        "--box-shadow": this.theme.nav_inner_drop_shadow ? "0px 2px 4px 0px rgba(0, 0, 0, 0.25) inset" : "unset",
        "--utility-nav-overflow": this.exploreMenuVisible || this.schoolDropdownVisible || this.customSchoolsMenuVisible || this.isMobile ? "unset" : "auto"
      }, this.signInColors);
    },
    menuDropdownIcon() {
      switch (this.theme.menu_icon) {
        case "arrow":
          return "FilledTriangleArrow";
        case "hamburger":
          return "HamburgerIcon";
        case "plus":
          return "PlusIcon";
        default:
          return "FilledTriangleArrow";
      }
    },
    showTemplateWithSignInButton() {
      return this.showSignInButton && this.isMobile && !this.content.isEditing;
    },
    schoolDropdownAriaControlsValue() {
      return (this.isSchoolDropdownVisible || this.isCustomSchoolsMenuVisible) && this.content.hasCustomSchoolsMenu ? "schoolsmenu" : void 0;
    },
    getExploreDropdownText() {
      var e, t, n, r, o;
      return ((t = (e = this.theme) == null ? void 0 : e.translations) == null ? void 0 : t.menu_dropdown_title) || ((o = (r = (n = this.theme) == null ? void 0 : n.translations) == null ? void 0 : r.header) == null ? void 0 : o.explore_dropdown_title) || "Explore";
    }
  }
}, O$ = ["aria-expanded", "aria-controls"], P$ = ["href"], N$ = { class: "bottom-bar-item schools-dropdown-wrapper" }, H$ = ["aria-expanded", "aria-controls"], F$ = { class: "bottom-bar-item mobile-right" }, R$ = ["aria-expanded", "aria-controls"], V$ = { class: "bottom-bar-item mobile-right" }, B$ = ["aria-expanded", "aria-controls"], j$ = { class: "bottom-bar-item schools-dropdown-wrapper" }, U$ = ["aria-expanded", "aria-controls"];
function q$(e, t, n, r, o, i) {
  const a = V("TriangleIcon"), s = V("HeaderDropdown"), l = V("cms-schools-menu"), u = V("MenuItem"), m = V("LanguageDropdown"), v = ze("click-away");
  return d(), f("div", {
    style: Z(i.colors),
    class: _(["bottom-bar", { "show-sign-in-button": e.showSignInButton }]),
    "data-testid": "utility-bar"
  }, [
    i.showTemplateWithSignInButton ? (d(), f(J, { key: 0 }, [
      e.isMobile ? (d(), f("button", {
        key: 0,
        id: "menubutton",
        "aria-expanded": e.content.showMenu || e.exploreMenuVisible,
        "aria-controls": e.content.showMenu ? "mainmenu" : void 0,
        class: "bottom-bar-item",
        onClick: t[0] || (t[0] = (g) => e.clickedMenu("menubutton"))
      }, [
        H(k(i.getExploreDropdownText) + " ", 1),
        j(a, {
          "fill-color": i.colors["--utility-text-color"],
          "is-open": e.exploreMenuVisible || e.content.showMenu
        }, null, 8, ["fill-color", "is-open"])
      ], 8, O$)) : T("", !0),
      e.showSignInButton ? (d(), f("a", {
        key: 1,
        href: e.signInUrl,
        class: "sign-in-button",
        target: "_blank"
      }, k(e.signInText), 9, P$)) : T("", !0),
      c("div", N$, [
        c("button", {
          id: "schoolsbutton",
          "aria-expanded": e.isSchoolDropdownVisible || e.isCustomSchoolsMenuVisible,
          "aria-controls": i.schoolDropdownAriaControlsValue,
          class: "bottom-bar-item",
          "aria-haspopup": "true",
          onClick: t[1] || (t[1] = (g) => e.clickedMenu("schoolsbutton"))
        }, [
          H(k(e.content.orgDropdownTitle) + " ", 1),
          j(a, {
            "fill-color": i.colors["--utility-text-color"],
            "is-open": e.isSchoolDropdownVisible || e.isCustomSchoolsMenuVisible
          }, null, 8, ["fill-color", "is-open"])
        ], 8, H$),
        e.content.hasCustomSchoolsMenu ? T("", !0) : (d(), L(s, {
          key: 0,
          id: "schoolsmenu",
          "data-testid": "schools-menu",
          "aria-labelledby": "schoolsbutton",
          styles: e.theme,
          data: e.content.organizations,
          "is-visible": e.schoolDropdownVisible,
          "is-preview": e.content.isPreview,
          "is-language-menu-hidden": !e.shouldDisplayLanguagesDropdown,
          onCloseDropdown: t[2] || (t[2] = (g) => e.schoolDropdownVisible = !1)
        }, null, 8, ["styles", "data", "is-visible", "is-preview", "is-language-menu-hidden"])),
        j(Le, { name: "slide" }, {
          default: S(() => [
            e.content.hasCustomSchoolsMenu ? (d(), L(l, {
              key: 0,
              id: "schoolsmenu",
              ref: "schoolsmenu",
              "data-testid": "custom-schools-menu",
              "header-theme": e.theme,
              content: e.customSchoolsMenu,
              "org-menu-content": e.content.orgMenuContent,
              organizations: e.content.organizations,
              "show-custom-schools-menu": e.customSchoolsMenuVisible,
              "is-preview": e.content.isPreview,
              onHideOnClickaway: t[3] || (t[3] = (g) => e.customSchoolsMenuVisible = !1),
              onFocusLost: t[4] || (t[4] = (g) => e.customSchoolsMenuVisible = !1)
            }, null, 8, ["header-theme", "content", "org-menu-content", "organizations", "show-custom-schools-menu", "is-preview"])) : T("", !0)
          ]),
          _: 1
        })
      ]),
      c("div", F$, [
        e.shouldDisplayLanguagesDropdown ? (d(), L(u, {
          key: 0,
          theme: e.theme,
          content: e.content,
          "theme-overrides": {
            colors: {
              "--nav-color": void 0
            }
          },
          item: "languagebutton",
          "dropdown-open": e.languageDropdownVisible,
          onToggleDropdown: t[5] || (t[5] = (g) => e.clickedMenu("languagebutton"))
        }, null, 8, ["theme", "content", "dropdown-open"])) : T("", !0),
        we(j(m, {
          id: "languagesmenu",
          "data-testid": "languages-menu",
          role: "menu",
          data: e.content.languages,
          styles: e.theme,
          "is-visible": e.languageDropdownVisible,
          "current-language": e.content.langCode,
          onSetLanguage: e.setLanguage,
          onCloseDropdown: t[6] || (t[6] = (g) => e.languageDropdownVisible = !1)
        }, null, 8, ["data", "styles", "is-visible", "current-language", "onSetLanguage"]), [
          [
            v,
            () => {
              e.languageDropdownVisible = !1;
            }
          ]
        ]),
        j(u, {
          theme: e.theme,
          content: e.content,
          "is-mobile-header": e.isMobile,
          item: "searchbutton",
          onToggleSearch: e.toggleSearch
        }, null, 8, ["theme", "content", "is-mobile-header", "onToggleSearch"])
      ])
    ], 64)) : e.isMobile && !e.content.isEditing ? (d(), f(J, { key: 1 }, [
      e.isMobile ? (d(), f("button", {
        key: 0,
        id: "menubutton",
        "aria-expanded": e.content.showMenu || e.exploreMenuVisible,
        "aria-controls": e.content.showMenu ? "mainmenu" : void 0,
        class: "bottom-bar-item",
        onClick: t[7] || (t[7] = (g) => e.clickedMenu("menubutton"))
      }, [
        H(k(i.getExploreDropdownText) + " ", 1),
        j(a, {
          "fill-color": i.colors["--utility-text-color"],
          "is-open": e.exploreMenuVisible || e.content.showMenu
        }, null, 8, ["fill-color", "is-open"])
      ], 8, R$)) : T("", !0),
      c("div", V$, [
        e.shouldDisplayLanguagesDropdown ? (d(), L(u, {
          key: 0,
          theme: e.theme,
          content: e.content,
          "theme-overrides": {
            colors: {
              "--nav-color": void 0
            }
          },
          item: "languagebutton",
          "dropdown-open": e.languageDropdownVisible,
          onToggleDropdown: t[8] || (t[8] = (g) => e.clickedMenu("languagebutton"))
        }, null, 8, ["theme", "content", "dropdown-open"])) : T("", !0),
        we(j(m, {
          id: "languagesmenu",
          "data-testid": "languages-menu",
          role: "menu",
          data: e.content.languages,
          styles: e.theme,
          "is-visible": e.languageDropdownVisible,
          "current-language": e.content.langCode,
          onSetLanguage: e.setLanguage,
          onCloseDropdown: t[9] || (t[9] = (g) => e.languageDropdownVisible = !1)
        }, null, 8, ["data", "styles", "is-visible", "current-language", "onSetLanguage"]), [
          [
            v,
            () => {
              e.languageDropdownVisible = !1;
            }
          ]
        ]),
        j(u, {
          theme: e.theme,
          content: e.content,
          "is-mobile-header": e.isMobile,
          item: "searchbutton",
          onToggleSearch: e.toggleSearch
        }, null, 8, ["theme", "content", "is-mobile-header", "onToggleSearch"])
      ])
    ], 64)) : (d(), f(J, { key: 2 }, [
      c("button", {
        id: "menubutton",
        "aria-expanded": e.content.showMenu || e.exploreMenuVisible,
        "aria-controls": e.content.showMenu ? "mainmenu" : void 0,
        class: "bottom-bar-item",
        "aria-haspopup": "true",
        onClick: t[10] || (t[10] = (g) => e.clickedMenu("menubutton"))
      }, [
        H(k(e.theme.translations.menu_dropdown_title || "Menu") + " ", 1),
        (d(), L(Y(i.menuDropdownIcon), {
          "theme-style": e.theme.style,
          "bg-color": i.colors["--utility-bg-color"],
          "icon-color": i.colors["--utility-text-color"],
          "fill-color": "transparent",
          "fill-path-color": i.colors["--utility-text-color"],
          rx: e.theme.style === "purple" ? "50" : "4",
          "is-open": e.content.showMenu || e.exploreMenuVisible
        }, null, 8, ["theme-style", "bg-color", "icon-color", "fill-path-color", "rx", "is-open"]))
      ], 8, B$),
      c("div", j$, [
        c("button", {
          id: "schoolsbutton",
          "aria-expanded": e.isSchoolDropdownVisible || e.isCustomSchoolsMenuVisible,
          "aria-controls": i.schoolDropdownAriaControlsValue,
          class: "bottom-bar-item",
          "aria-haspopup": "true",
          onClick: t[11] || (t[11] = (g) => e.clickedMenu("schoolsbutton"))
        }, [
          H(k(e.content.orgDropdownTitle) + " ", 1),
          (d(), L(Y(i.menuDropdownIcon), {
            "theme-style": e.theme.style,
            "bg-color": i.colors["--utility-bg-color"],
            "icon-color": i.colors["--utility-text-color"],
            "fill-color": "transparent",
            "fill-path-color": i.colors["--utility-text-color"],
            rx: e.theme.style === "purple" ? "50" : "4",
            "is-open": e.isSchoolDropdownVisible || e.customSchoolsMenuVisible
          }, null, 8, ["theme-style", "bg-color", "icon-color", "fill-path-color", "rx", "is-open"]))
        ], 8, U$),
        e.content.hasCustomSchoolsMenu ? T("", !0) : (d(), L(s, {
          key: 0,
          id: "schoolsmenu",
          "data-testid": "schools-menu",
          "aria-labelledby": "schoolsbutton",
          styles: e.theme,
          data: e.content.organizations,
          "is-visible": e.schoolDropdownVisible,
          "is-preview": e.content.isPreview,
          "is-language-menu-hidden": !e.shouldDisplayLanguagesDropdown,
          onCloseDropdown: t[12] || (t[12] = (g) => e.schoolDropdownVisible = !1)
        }, null, 8, ["styles", "data", "is-visible", "is-preview", "is-language-menu-hidden"])),
        j(Le, { name: "slide" }, {
          default: S(() => [
            e.content.hasCustomSchoolsMenu ? (d(), L(l, {
              key: 0,
              id: "schoolsmenu",
              ref: "schoolsmenu",
              "data-testid": "custom-schools-menu",
              "header-theme": e.theme,
              content: e.customSchoolsMenu,
              "org-menu-content": e.content.orgMenuContent,
              organizations: e.content.organizations,
              "show-custom-schools-menu": e.customSchoolsMenuVisible,
              "is-preview": e.content.isPreview,
              onHideOnClickaway: t[13] || (t[13] = (g) => e.customSchoolsMenuVisible = !1),
              onFocusLost: t[14] || (t[14] = (g) => e.customSchoolsMenuVisible = !1)
            }, null, 8, ["header-theme", "content", "org-menu-content", "organizations", "show-custom-schools-menu", "is-preview"])) : T("", !0)
          ]),
          _: 1
        })
      ]),
      (d(), L(Y(n.wrapperComponent), Se(n.wrapperProps, {
        "model-value": e.content.utilities,
        "item-key": "idx",
        class: "bottom-bar-utilities-wrapper",
        "onUpdate:modelValue": t[15] || (t[15] = (g) => e.$emit("update:utilities", g))
      }), {
        item: S(({ element: g, index: h }) => [
          (d(), L(Y(e.content.isEditing ? "div" : "a"), {
            class: "bottom-bar-item utilities",
            href: g.link,
            target: g.opens_in_new_tab ? "_blank" : ""
          }, {
            default: S(() => [
              M(e.$slots, "utility", { idx: h }, () => [
                H(k(g.name), 1)
              ], !0)
            ]),
            _: 2
          }, 1032, ["href", "target"]))
        ]),
        _: 3
      }, 16, ["model-value"]))
    ], 64))
  ], 6);
}
const G$ = /* @__PURE__ */ B($$, [["render", q$], ["__scopeId", "data-v-2e458f1f"]]), K$ = {
  name: "Header5",
  components: {
    UtilityBar: G$,
    OrgBanner: fr,
    MobileHeader: Zr,
    MenuItem: Yt
  },
  mixins: [ut, Et],
  props: {
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["update:utilities"],
  computed: {
    colors() {
      var e, t;
      return ae({
        "--top-bar": this.theme.show_top_bar ? `8px solid ${this.theme.top_bar_color.hex}` : "none",
        "--bg-color": this.theme.bg_color.hex,
        "--nav-color": (t = (e = this.theme) == null ? void 0 : e.navigation_color) == null ? void 0 : t.hex
      }, this.signInColors);
    }
  }
}, z$ = {
  key: 0,
  "data-testid": "large-screen-header",
  class: "header-container"
}, Z$ = { class: "left" }, x$ = { class: "right" }, W$ = { class: "right-right-menu" }, Y$ = { key: 0 }, X$ = ["href"];
function Q$(e, t, n, r, o, i) {
  var g, h, E;
  const a = V("OrgBanner"), s = V("MenuItem"), l = V("LanguageDropdown"), u = V("UtilityBar"), m = V("MobileHeader"), v = ze("click-away");
  return d(), f("div", {
    style: Z(i.colors),
    class: "h5"
  }, [
    !e.isMobile || e.isEditing ? (d(), f("div", z$, [
      c("div", Z$, [
        j(a, {
          "logo-link": e.logoLink,
          theme: e.theme,
          globals: e.content.globals
        }, null, 8, ["logo-link", "theme", "globals"])
      ]),
      c("div", x$, [
        c("div", W$, [
          e.shouldDisplayLanguagesDropdown ? (d(), f("div", Y$, [
            j(s, {
              theme: e.theme,
              content: e.content,
              item: "languagebutton",
              "theme-overrides": {
                colors: {
                  "--bg-color": "transparent",
                  "--icon-color": (g = e.theme.navigation_color) == null ? void 0 : g.hex,
                  "--fill-color": "transparent",
                  "--fill-path-color": (h = e.theme.navigation_color) == null ? void 0 : h.hex
                }
              },
              "dropdown-open": e.languageDropdownVisible,
              onToggleDropdown: t[0] || (t[0] = (C) => e.clickedMenu("languagebutton"))
            }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open"]),
            we(j(l, {
              id: "languagesmenu",
              "data-testid": "languages-menu",
              role: "menu",
              data: e.content.languages,
              styles: e.theme,
              "is-visible": e.languageDropdownVisible,
              "current-language": e.content.langCode,
              onSetLanguage: e.setLanguage,
              onCloseDropdown: t[1] || (t[1] = (C) => e.languageDropdownVisible = !1)
            }, null, 8, ["data", "styles", "is-visible", "current-language", "onSetLanguage"]), [
              [
                v,
                () => {
                  e.languageDropdownVisible = !1;
                }
              ]
            ])
          ])) : T("", !0),
          j(s, {
            theme: e.theme,
            content: e.content,
            item: "searchbutton",
            "theme-overrides": {
              colors: {
                "--bg-color": "transparent",
                "--fill-color": "transparent",
                "--fill-path-color": (E = e.theme.navigation_color) == null ? void 0 : E.hex
              }
            },
            onToggleSearch: e.toggleSearch
          }, null, 8, ["theme", "content", "theme-overrides", "onToggleSearch"]),
          e.showSignInButton ? (d(), f("a", {
            key: 1,
            href: e.signInUrl,
            class: "sign-in-button",
            target: "_blank"
          }, k(e.signInText), 9, X$)) : T("", !0)
        ])
      ])
    ])) : (d(), L(m, {
      key: 1,
      theme: e.theme,
      content: e.content,
      "show-tagline": "",
      "hide-menu-button": "",
      "show-utilities": "",
      "show-menu-buttons": !1,
      onCloseMenu: e.closeAllMenus
    }, {
      bottom: S(() => [
        j(u, {
          content: e.content,
          "is-homepage": e.isHomepage,
          "is-mobile": e.isMobile,
          theme: e.theme,
          "show-sign-in-button": e.showSignInButton,
          onToggleMenu: t[2] || (t[2] = (C) => e.$emit("toggle-mobile-menu", C)),
          onToggleSearch: e.toggleSearch,
          onLanguageChange: t[3] || (t[3] = (C) => e.$emit("language-change", C))
        }, null, 8, ["content", "is-homepage", "is-mobile", "theme", "show-sign-in-button", "onToggleSearch"])
      ]),
      _: 1
    }, 8, ["theme", "content", "onCloseMenu"])),
    !e.isMobile || e.isEditing ? (d(), L(u, {
      key: 2,
      content: e.content,
      "is-homepage": e.isHomepage,
      "is-mobile": e.isMobile,
      theme: e.theme,
      "wrapper-component": n.wrapperComponent,
      "wrapper-props": n.wrapperProps,
      onToggleMenu: t[4] || (t[4] = (C) => e.$emit("toggle-menu", C)),
      "onUpdate:utilities": t[5] || (t[5] = (C) => e.$emit("update:utilities", C))
    }, {
      utility: S(({ idx: C }) => [
        M(e.$slots, "utility", { idx: C }, void 0, !0)
      ]),
      _: 3
    }, 8, ["content", "is-homepage", "is-mobile", "theme", "wrapper-component", "wrapper-props"])) : T("", !0)
  ], 4);
}
const J$ = /* @__PURE__ */ B(K$, [["render", Q$], ["__scopeId", "data-v-da475bf3"]]), eO = {
  components: {
    CmsSchoolsMenu: mr,
    MenuItem: Yt
  },
  mixins: [ut, Et, Wt],
  props: {
    textColor: {
      type: String,
      required: !0
    },
    largeSize: {
      type: Boolean,
      default: !1
    }
  }
}, tO = { class: "header-nav-wrapper" }, nO = { class: "left button-group" }, rO = {
  key: 1,
  class: "language-button-wrapper"
}, oO = { class: "center" }, iO = {
  key: 0,
  class: "schools-menu-container"
}, sO = ["href"];
function aO(e, t, n, r, o, i) {
  var v, g, h, E, C, A, R, P, F, I, D, O, U;
  const a = V("MenuItem"), s = V("LanguageDropdown"), l = V("HeaderDropdown"), u = V("CmsSchoolsMenu"), m = ze("click-away");
  return d(), f("div", tO, [
    c("div", nO, [
      n.largeSize ? T("", !0) : (d(), L(a, {
        key: 0,
        theme: e.theme,
        content: e.content,
        "theme-overrides": {
          colors: {
            "--icon-color": (v = e.theme.utility_link_color) == null ? void 0 : v.hex
          }
        },
        item: "searchbutton",
        "screen-size": e.screenSize,
        onToggleSearch: e.toggleSearch
      }, null, 8, ["theme", "content", "theme-overrides", "screen-size", "onToggleSearch"])),
      e.shouldDisplayLanguagesDropdown ? (d(), f("div", rO, [
        j(a, {
          theme: e.theme,
          content: e.content,
          "theme-overrides": {
            colors: {
              "--fill-color": "transparent",
              "--fill-path-color": n.largeSize ? (g = e.theme.navigation_color) == null ? void 0 : g.hex : (h = e.theme.utility_link_color) == null ? void 0 : h.hex,
              "--nav-color": n.largeSize ? (E = e.theme.navigation_color) == null ? void 0 : E.hex : (C = e.theme.utility_link_color) == null ? void 0 : C.hex
            }
          },
          item: "languagebutton",
          "dropdown-open": e.languageDropdownVisible,
          onToggleDropdown: t[0] || (t[0] = (q) => e.clickedMenu("languagebutton"))
        }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open"]),
        we(j(s, {
          id: "languagesmenu",
          "data-testid": "languages-menu",
          role: "menu",
          data: e.content.languages,
          styles: e.theme,
          "is-visible": e.languageDropdownVisible,
          "current-language": e.content.langCode,
          onSetLanguage: e.setLanguage,
          onCloseDropdown: t[1] || (t[1] = (q) => e.languageDropdownVisible = !1)
        }, null, 8, ["data", "styles", "is-visible", "current-language", "onSetLanguage"]), [
          [
            m,
            () => {
              e.languageDropdownVisible = !1;
            }
          ]
        ])
      ])) : T("", !0),
      n.largeSize ? (d(), L(a, {
        key: 2,
        theme: e.theme,
        content: e.content,
        "theme-overrides": {
          colors: {
            "--icon-color": (A = e.theme.navigation_color) == null ? void 0 : A.hex,
            "--nav-color": (R = e.theme.navigation_color) == null ? void 0 : R.hex
          }
        },
        item: "searchbutton",
        "screen-size": e.screenSize,
        onToggleSearch: e.toggleSearch
      }, null, 8, ["theme", "content", "theme-overrides", "screen-size", "onToggleSearch"])) : T("", !0)
    ]),
    c("div", oO, [
      M(e.$slots, "default", {}, void 0, !0)
    ]),
    c("div", {
      class: _([[n.largeSize ? "" : "small-bar"], "right button-group"])
    }, [
      e.shouldDisplaySchoolsDropdown && !e.isMobile ? (d(), f("div", iO, [
        j(a, {
          item: "schoolsbutton",
          theme: e.theme,
          content: e.content,
          "theme-overrides": {
            colors: {
              "--fill-color": "transparent",
              "--fill-path-color": n.largeSize ? (P = e.theme.navigation_color) == null ? void 0 : P.hex : (F = e.theme.utility_link_color) == null ? void 0 : F.hex,
              "--nav-color": n.largeSize ? (I = e.theme.navigation_color) == null ? void 0 : I.hex : (D = e.theme.utility_link_color) == null ? void 0 : D.hex
            }
          },
          "dropdown-open": e.isSchoolDropdownVisible || e.isCustomSchoolsMenuVisible,
          onToggleDropdown: e.setDropdownVisibility
        }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"]),
        e.content.hasCustomSchoolsMenu ? T("", !0) : (d(), L(l, {
          key: 0,
          id: "schoolsmenu",
          "data-testid": "schools-menu",
          "aria-labelledby": "schoolsbutton",
          styles: e.theme,
          data: e.content.organizations,
          "is-visible": e.schoolDropdownVisible,
          "is-preview": e.content.isPreview,
          "is-language-menu-hidden": !e.shouldDisplayLanguagesDropdown,
          "is-shrink": e.shrinkCSSClass === "shrink",
          onCloseDropdown: t[2] || (t[2] = (q) => e.schoolDropdownVisible = !1)
        }, null, 8, ["styles", "data", "is-visible", "is-preview", "is-language-menu-hidden", "is-shrink"])),
        j(Le, { name: "slide" }, {
          default: S(() => [
            e.content.hasCustomSchoolsMenu ? (d(), L(u, {
              key: 0,
              id: "schoolsmenu",
              ref: "schoolsmenu",
              "data-testid": "schools-menu",
              "header-theme": e.theme,
              content: e.content.globals.homepage,
              "org-menu-content": e.content.orgMenuContent,
              organizations: e.content.organizations,
              "show-custom-schools-menu": e.isCustomSchoolsMenuVisible,
              "sticky-header": e.shouldBeSticky,
              "shrink-header": e.shouldShrink,
              "is-preview": e.content.isPreview,
              onFocusLost: t[3] || (t[3] = (q) => e.customSchoolsMenuVisible = !1)
            }, null, 8, ["header-theme", "content", "org-menu-content", "organizations", "show-custom-schools-menu", "sticky-header", "shrink-header", "is-preview"])) : T("", !0)
          ]),
          _: 1
        })
      ])) : T("", !0),
      c("div", null, [
        j(a, {
          theme: e.theme,
          content: e.content,
          "dropdown-open": e.content.showMenu,
          "theme-overrides": {
            icon: "HamburgerIcon",
            colors: {
              "--nav-color": n.textColor,
              "--fill-color": "transparent",
              "--fill-path-color": n.largeSize ? (O = e.theme.navigation_color) == null ? void 0 : O.hex : (U = e.theme.utility_link_color) == null ? void 0 : U.hex
            }
          },
          item: "explore-button",
          onToggleDropdown: t[4] || (t[4] = (q) => e.clickedMenu("menubutton"))
        }, null, 8, ["theme", "content", "dropdown-open", "theme-overrides"]),
        e.menuV4Enabled && e.content.showMenu ? (d(), L(l, {
          key: 0,
          id: "explore-menu",
          "data-testid": "explore-menu",
          "aria-labelledby": "explore-button",
          styles: e.theme,
          data: e.content.sitemapMenuItems,
          "menu-v4-enabled": e.menuV4Enabled,
          "is-visible": e.exploreMenuVisible,
          "path-prefix": e.content.pathPrefix,
          "is-shrink": e.shrinkCSSClass === "shrink",
          onCloseDropdown: t[5] || (t[5] = (q) => e.exploreMenuVisible = !1)
        }, null, 8, ["styles", "data", "menu-v4-enabled", "is-visible", "path-prefix", "is-shrink"])) : T("", !0)
      ]),
      e.showSignInButton ? (d(), f("a", {
        key: 1,
        href: e.signInUrl,
        class: "sign-in-button",
        "data-testid": "desktop-signin-button",
        target: "_blank"
      }, k(e.signInText), 9, sO)) : T("", !0)
    ], 2)
  ]);
}
const lO = /* @__PURE__ */ B(eO, [["render", aO], ["__scopeId", "data-v-950897bb"]]);
function K4(e) {
  return ag() ? (s0(e), !0) : !1;
}
const Fl = /* @__PURE__ */ new WeakMap(), uO = (...e) => {
  var t;
  const n = e[0], r = (t = a0()) == null ? void 0 : t.proxy;
  if (r == null && !lg())
    throw new Error("injectLocal must be called in setup");
  return r && Fl.has(r) && n in Fl.get(r) ? Fl.get(r)[n] : I6(...e);
}, dO = typeof window != "undefined" && typeof document != "undefined";
typeof WorkerGlobalScope != "undefined" && globalThis instanceof WorkerGlobalScope;
const cO = Object.prototype.toString, hO = (e) => cO.call(e) === "[object Object]";
function Tm(e) {
  return e.endsWith("rem") ? Number.parseFloat(e) * 16 : Number.parseFloat(e);
}
function mO(e) {
  return a0();
}
function Qi(e) {
  return Array.isArray(e) ? e : [e];
}
function z4(e, t = !0, n) {
  mO() ? Ts(e, n) : t ? e() : ri(e);
}
function fO(e, t, n) {
  return ko(
    e,
    t,
    ge(ae({}, n), {
      immediate: !0
    })
  );
}
const bi = dO ? window : void 0;
function Ir(e) {
  var t;
  const n = Dr(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
function Kc(...e) {
  const t = [], n = () => {
    t.forEach((s) => s()), t.length = 0;
  }, r = (s, l, u, m) => (s.addEventListener(l, u, m), () => s.removeEventListener(l, u, m)), o = Re(() => {
    const s = Qi(Dr(e[0])).filter((l) => l != null);
    return s.every((l) => typeof l != "string") ? s : void 0;
  }), i = fO(
    () => {
      var s, l;
      return [
        (l = (s = o.value) == null ? void 0 : s.map((u) => Ir(u))) != null ? l : [bi].filter((u) => u != null),
        Qi(Dr(o.value ? e[1] : e[0])),
        Qi(po(o.value ? e[2] : e[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        Dr(o.value ? e[3] : e[2])
      ];
    },
    ([s, l, u, m]) => {
      if (n(), !(s != null && s.length) || !(l != null && l.length) || !(u != null && u.length))
        return;
      const v = hO(m) ? ae({}, m) : m;
      t.push(
        ...s.flatMap(
          (g) => l.flatMap(
            (h) => u.map((E) => r(g, h, E, v))
          )
        )
      );
    },
    { flush: "post" }
  ), a = () => {
    i(), n();
  };
  return K4(n), a;
}
function pO() {
  const e = kc(!1), t = a0();
  return t && Ts(() => {
    e.value = !0;
  }, t), e;
}
function Z4(e) {
  const t = pO();
  return Re(() => (t.value, !!e()));
}
const gO = Symbol("vueuse-ssr-width");
function vO() {
  const e = lg() ? uO(gO, null) : null;
  return typeof e == "number" ? e : void 0;
}
function bO(e, t = {}) {
  const { window: n = bi, ssrWidth: r = vO() } = t, o = Z4(() => n && "matchMedia" in n && typeof n.matchMedia == "function"), i = zt(typeof r == "number"), a = kc(), s = kc(!1), l = (u) => {
    s.value = u.matches;
  };
  return L6(() => {
    if (i.value) {
      i.value = !o.value;
      const u = Dr(e).split(",");
      s.value = u.some((m) => {
        const v = m.includes("not all"), g = m.match(/\(\s*min-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/), h = m.match(/\(\s*max-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/);
        let E = !!(g || h);
        return g && E && (E = r >= Tm(g[1])), h && E && (E = r <= Tm(h[1])), v ? !E : E;
      });
      return;
    }
    o.value && (a.value = n.matchMedia(Dr(e)), s.value = a.value.matches);
  }), Kc(a, "change", l, { passive: !0 }), Re(() => s.value);
}
function yO(e, t, n = {}) {
  const v = n, { window: r = bi } = v, o = ia(v, ["window"]);
  let i;
  const a = Z4(() => r && "ResizeObserver" in r), s = () => {
    i && (i.disconnect(), i = void 0);
  }, l = Re(() => {
    const g = Dr(e);
    return Array.isArray(g) ? g.map((h) => Ir(h)) : [Ir(g)];
  }), u = ko(
    l,
    (g) => {
      if (s(), a.value && r) {
        i = new ResizeObserver(t);
        for (const h of g)
          h && i.observe(h, o);
      }
    },
    { immediate: !0, flush: "post" }
  ), m = () => {
    s(), u();
  };
  return K4(m), {
    isSupported: a,
    stop: m
  };
}
function _O(e, t = { width: 0, height: 0 }, n = {}) {
  const { window: r = bi, box: o = "content-box" } = n, i = Re(() => {
    var v, g;
    return (g = (v = Ir(e)) == null ? void 0 : v.namespaceURI) == null ? void 0 : g.includes("svg");
  }), a = zt(t.width), s = zt(t.height), { stop: l } = yO(
    e,
    ([v]) => {
      const g = o === "border-box" ? v.borderBoxSize : o === "content-box" ? v.contentBoxSize : v.devicePixelContentBoxSize;
      if (r && i.value) {
        const h = Ir(e);
        if (h) {
          const E = h.getBoundingClientRect();
          a.value = E.width, s.value = E.height;
        }
      } else if (g) {
        const h = Qi(g);
        a.value = h.reduce((E, { inlineSize: C }) => E + C, 0), s.value = h.reduce((E, { blockSize: C }) => E + C, 0);
      } else
        a.value = v.contentRect.width, s.value = v.contentRect.height;
    },
    n
  );
  z4(() => {
    const v = Ir(e);
    v && (a.value = "offsetWidth" in v ? v.offsetWidth : t.width, s.value = "offsetHeight" in v ? v.offsetHeight : t.height);
  });
  const u = ko(
    () => Ir(e),
    (v) => {
      a.value = v ? t.width : 0, s.value = v ? t.height : 0;
    }
  );
  function m() {
    l(), u();
  }
  return {
    width: a,
    height: s,
    stop: m
  };
}
function CO(e = {}) {
  const {
    window: t = bi,
    initialWidth: n = Number.POSITIVE_INFINITY,
    initialHeight: r = Number.POSITIVE_INFINITY,
    listenOrientation: o = !0,
    includeScrollbar: i = !0,
    type: a = "inner"
  } = e, s = zt(n), l = zt(r), u = () => {
    if (t)
      if (a === "outer")
        s.value = t.outerWidth, l.value = t.outerHeight;
      else if (a === "visual" && t.visualViewport) {
        const { width: v, height: g, scale: h } = t.visualViewport;
        s.value = Math.round(v * h), l.value = Math.round(g * h);
      } else i ? (s.value = t.innerWidth, l.value = t.innerHeight) : (s.value = t.document.documentElement.clientWidth, l.value = t.document.documentElement.clientHeight);
  };
  u(), z4(u);
  const m = { passive: !0 };
  if (Kc("resize", u, m), t && a === "visual" && t.visualViewport && Kc(t.visualViewport, "resize", u, m), o) {
    const v = bO("(orientation: portrait)");
    ko(v, () => u());
  }
  return { width: s, height: l };
}
const wO = {
  name: "Header6",
  components: {
    OrgBanner: fr,
    MobileHeader: Zr,
    HeaderNav: lO
  },
  mixins: [ut],
  setup() {
    const e = D6("headerElement"), { width: t } = _O(e);
    return {
      headerWidth: t
    };
  },
  computed: {
    colors() {
      return ae({
        "--utility-bg-color": this.theme.utility_bg_color.hex,
        "--utility-text-color": this.theme.utility_link_color.hex,
        "--nav-color": this.theme.navigation_color.hex,
        "--bg-color": this.theme.bg_color.hex
      }, this.signInColors);
    }
  }
}, TO = {
  key: 0,
  class: "header-container"
}, kO = { class: "org-banner-wrapper" }, EO = {
  key: 1,
  class: "org-banner-wrapper smaller-screen"
}, SO = {
  key: 2,
  class: "bottom-nav"
}, MO = { class: "mobile-header-top" }, AO = { class: "org-banner-wrapper" }, IO = { class: "bottom-nav" }, LO = ["href"];
function DO(e, t, n, r, o, i) {
  const a = V("OrgBanner"), s = V("HeaderNav"), l = V("MobileHeader");
  return d(), f("div", {
    ref: "headerElement",
    style: Z(i.colors),
    class: "h6"
  }, [
    e.isMobile ? (d(), L(l, {
      key: 1,
      theme: e.theme,
      content: e.content,
      "show-menu-buttons": !1,
      onToggleMobileMenu: t[9] || (t[9] = (u) => e.$emit("toggle-mobile-menu")),
      onToggleSearch: e.toggleSearch,
      onSetLanguage: e.setLanguage,
      onCloseMenu: e.closeAllMenus
    }, {
      default: S(() => [
        c("div", MO, [
          c("div", AO, [
            j(a, {
              "logo-link": e.logoLink,
              theme: e.theme,
              globals: e.content.globals,
              class: "org-banner"
            }, null, 8, ["logo-link", "theme", "globals"])
          ]),
          c("div", IO, [
            j(s, {
              theme: e.theme,
              content: e.content,
              "show-sign-in-button": e.showSignInButton,
              "sign-in-url": e.signInUrl,
              "text-color": e.theme.utility_link_color.hex,
              "bg-color": e.theme.utility_bg_color.hex,
              "is-mobile": "",
              onLanguageChange: t[6] || (t[6] = (u) => e.$emit("language-change", u)),
              onToggleSearch: t[7] || (t[7] = (u) => e.$emit("toggle-search")),
              onToggleMenu: t[8] || (t[8] = (u) => e.$emit("toggle-mobile-menu", !e.content.showMenu))
            }, null, 8, ["theme", "content", "show-sign-in-button", "sign-in-url", "text-color", "bg-color"])
          ])
        ])
      ]),
      "menu-top": S(() => [
        e.showSignInButton && r.headerWidth <= 320 ? (d(), f("a", {
          key: 0,
          href: e.signInUrl,
          class: "sign-in-button",
          target: "_blank",
          "data-testid": "mobile-signin-button"
        }, k(e.signInText), 9, LO)) : T("", !0)
      ]),
      _: 1
    }, 8, ["theme", "content", "onToggleSearch", "onSetLanguage", "onCloseMenu"])) : (d(), f("div", TO, [
      r.headerWidth > 1280 ? (d(), L(s, {
        key: 0,
        theme: e.theme,
        content: e.content,
        "show-sign-in-button": e.showSignInButton,
        "sign-in-url": e.signInUrl,
        "large-size": "",
        "text-color": e.theme.navigation_color.hex,
        onLanguageChange: t[0] || (t[0] = (u) => e.$emit("language-change", u)),
        onToggleSearch: t[1] || (t[1] = (u) => e.$emit("toggle-search")),
        onToggleMenu: t[2] || (t[2] = (u) => e.$emit("toggle-menu", u))
      }, {
        default: S(() => [
          c("div", kO, [
            j(a, {
              "logo-link": e.logoLink,
              theme: e.theme,
              globals: e.content.globals,
              class: "org-banner"
            }, null, 8, ["logo-link", "theme", "globals"])
          ])
        ]),
        _: 1
      }, 8, ["theme", "content", "show-sign-in-button", "sign-in-url", "text-color"])) : (d(), f("div", EO, [
        j(a, {
          "logo-link": e.logoLink,
          theme: e.theme,
          globals: e.content.globals,
          class: "org-banner"
        }, null, 8, ["logo-link", "theme", "globals"])
      ])),
      r.headerWidth <= 1280 ? (d(), f("div", SO, [
        j(s, {
          theme: e.theme,
          content: e.content,
          "show-sign-in-button": e.showSignInButton,
          "sign-in-url": e.signInUrl,
          "text-color": e.theme.utility_link_color.hex,
          onLanguageChange: t[3] || (t[3] = (u) => e.$emit("language-change", u)),
          onToggleSearch: t[4] || (t[4] = (u) => e.$emit("toggle-search")),
          onToggleMenu: t[5] || (t[5] = (u) => e.$emit("toggle-menu", u))
        }, null, 8, ["theme", "content", "show-sign-in-button", "sign-in-url", "text-color"])
      ])) : T("", !0)
    ]))
  ], 4);
}
const $O = /* @__PURE__ */ B(wO, [["render", DO], ["__scopeId", "data-v-e1b257fb"]]), OO = {
  name: "H7TopBar",
  components: { DraggableWrapper: yt, MenuItem: Yt },
  mixins: [ut, Et, Wt],
  props: {
    content: {
      type: Object,
      default: () => ({})
    },
    theme: {
      type: Object,
      default: () => ({})
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["update:utilities", "toggle-mobile-menu"]
}, PO = { class: "right-icons" }, NO = { key: 0 }, HO = ["href"];
function FO(e, t, n, r, o, i) {
  const a = V("MenuItem"), s = V("LanguageDropdown"), l = ze("click-away");
  return d(), f("div", {
    class: "top-bar",
    style: Z({
      "--nav-color": n.theme.utility_link_color.hex
    })
  }, [
    n.content.isEditing || !e.isMobile ? (d(), L(Y(n.wrapperComponent), Se({ key: 0 }, n.wrapperProps, {
      "model-value": n.content.utilities,
      "item-key": "idx",
      class: "utilities-container",
      "data-testid": "utility-bar",
      "onUpdate:modelValue": t[0] || (t[0] = (u) => e.$emit("update:utilities", u))
    }), {
      item: S(({ element: u, index: m }) => [
        (d(), L(Y(n.content.isEditing ? "div" : "a"), {
          class: "utility",
          href: u.link,
          target: u.opens_in_new_tab ? "_blank" : ""
        }, {
          default: S(() => [
            M(e.$slots, "utility", { idx: m }, () => [
              H(k(u.name), 1)
            ], !0)
          ]),
          _: 2
        }, 1032, ["href", "target"]))
      ]),
      _: 3
    }, 16, ["model-value"])) : T("", !0),
    c("div", PO, [
      e.shouldDisplayLanguagesDropdown ? (d(), f("div", NO, [
        j(a, {
          theme: n.theme,
          content: n.content,
          "theme-overrides": {
            colors: {
              "--fill-color": "transparent",
              "--fill-path-color": n.theme.utility_link_color.hex,
              "--bg-color": "transparent",
              "--nav-color": n.theme.utility_link_color.hex
            }
          },
          item: "languagebutton",
          "dropdown-open": e.languageDropdownVisible,
          onToggleDropdown: t[1] || (t[1] = (u) => e.clickedMenu("languagebutton"))
        }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open"]),
        we(j(s, {
          id: "languagesmenu",
          "data-testid": "languages-menu",
          role: "menu",
          data: n.content.languages,
          styles: n.theme,
          "is-visible": e.languageDropdownVisible,
          "current-language": n.content.langCode,
          onSetLanguage: e.setLanguage,
          onCloseDropdown: t[2] || (t[2] = (u) => e.languageDropdownVisible = !1)
        }, null, 8, ["data", "styles", "is-visible", "current-language", "onSetLanguage"]), [
          [
            l,
            () => {
              e.languageDropdownVisible = !1;
            }
          ]
        ])
      ])) : T("", !0),
      j(a, {
        theme: n.theme,
        content: n.content,
        item: "searchbutton",
        "screen-size": e.screenSize,
        onToggleSearch: e.toggleSearch
      }, null, 8, ["theme", "content", "screen-size", "onToggleSearch"]),
      e.showSignInButton && e.screenSize > 320 ? (d(), f("a", {
        key: 1,
        href: e.signInUrl,
        class: "sign-in-button",
        "data-testid": "desktop-signin-button",
        target: "_blank"
      }, k(e.signInText), 9, HO)) : T("", !0),
      e.screenSize <= 320 ? (d(), L(a, {
        key: 2,
        theme: n.theme,
        content: n.content,
        "dropdown-open": n.content.showMenu,
        "theme-overrides": {
          icon: "HamburgerIcon",
          colors: {
            "--fill-color": "transparent",
            "--fill-path-color": n.theme.utility_link_color.hex,
            "--bg-color": "transparent"
          }
        },
        item: "explore-button",
        onToggleDropdown: t[3] || (t[3] = (u) => e.$emit("toggle-mobile-menu", !n.content.showMenu))
      }, null, 8, ["theme", "content", "dropdown-open", "theme-overrides"])) : T("", !0)
    ])
  ], 4);
}
const RO = /* @__PURE__ */ B(OO, [["render", FO], ["__scopeId", "data-v-5fbe6bc7"]]), VO = {
  name: "Header7",
  components: {
    CmsSchoolsMenu: mr,
    OrgBanner: fr,
    MobileHeader: Zr,
    MenuItem: Yt,
    TopBar: RO
  },
  mixins: [ut, Wt],
  props: {
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["update:utilities", "toggle-mobile-menu"],
  computed: {
    colors() {
      return ae({
        "--top-bar-bg-color": this.theme.utility_bg_color.hex,
        "--nav-color": this.theme.navigation_color.hex,
        "--top-bar-text-color": this.theme.utility_link_color.hex,
        "--bg-color": this.theme.bg_color.hex,
        "--text-color": this.theme.bg_color.hex
      }, this.signInColors);
    }
  }
}, BO = {
  key: 1,
  class: "header-container"
}, jO = { class: "header-container-left" }, UO = { class: "header-container-right" }, qO = {
  key: 0,
  class: "schools-menu-container"
}, GO = { class: "mobile-header-top" }, KO = { class: "org-banner-wrapper" }, zO = ["href"];
function ZO(e, t, n, r, o, i) {
  const a = V("TopBar"), s = V("OrgBanner"), l = V("MenuItem"), u = V("HeaderDropdown"), m = V("CmsSchoolsMenu"), v = V("MobileHeader");
  return d(), f("div", {
    style: Z(i.colors),
    class: "h7"
  }, [
    !e.isMobile || e.content.isEditing ? (d(), L(a, {
      key: 0,
      theme: e.theme,
      content: e.content,
      "wrapper-component": n.wrapperComponent,
      "wrapper-props": n.wrapperProps,
      "show-sign-in-button": e.showSignInButton,
      "sign-in-url": e.signInUrl,
      onLanguageChange: e.setLanguage,
      onToggleSearch: e.toggleSearch,
      "onUpdate:utilities": t[0] || (t[0] = (g) => e.$emit("update:utilities", g))
    }, {
      utility: S(({ idx: g }) => [
        M(e.$slots, "utility", { idx: g }, void 0, !0)
      ]),
      _: 3
    }, 8, ["theme", "content", "wrapper-component", "wrapper-props", "show-sign-in-button", "sign-in-url", "onLanguageChange", "onToggleSearch"])) : T("", !0),
    !e.isMobile || e.content.isEditing ? (d(), f("div", BO, [
      c("div", jO, [
        j(s, {
          "logo-link": e.logoLink,
          theme: e.theme,
          globals: e.content.globals
        }, null, 8, ["logo-link", "theme", "globals"])
      ]),
      c("div", UO, [
        e.shouldDisplaySchoolsDropdown ? (d(), f("div", qO, [
          j(l, {
            item: "schoolsbutton",
            theme: e.theme,
            content: e.content,
            "theme-overrides": {
              colors: {
                "--fill-color": "transparent",
                "--fill-path-color": e.theme.navigation_color.hex,
                "--bg-color": "transparent"
              }
            },
            "dropdown-open": e.isSchoolDropdownVisible || e.isCustomSchoolsMenuVisible,
            onToggleDropdown: e.setDropdownVisibility
          }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"]),
          e.content.hasCustomSchoolsMenu ? T("", !0) : (d(), L(u, {
            key: 0,
            id: "schoolsmenu",
            "data-testid": "schools-menu",
            "aria-labelledby": "schoolsbutton",
            styles: e.theme,
            data: e.content.organizations,
            "is-visible": e.schoolDropdownVisible,
            "is-preview": e.content.isPreview,
            "is-language-menu-hidden": !e.shouldDisplayLanguagesDropdown,
            "is-shrink": e.shrinkCSSClass === "shrink",
            onCloseDropdown: t[1] || (t[1] = (g) => e.schoolDropdownVisible = !1)
          }, null, 8, ["styles", "data", "is-visible", "is-preview", "is-language-menu-hidden", "is-shrink"])),
          j(Le, { name: "slide" }, {
            default: S(() => [
              e.content.hasCustomSchoolsMenu ? (d(), L(m, {
                key: 0,
                id: "schoolsmenu",
                ref: "schoolsmenu",
                "data-testid": "schools-menu",
                "header-theme": e.theme,
                content: e.content.globals.homepage,
                "org-menu-content": e.content.orgMenuContent,
                organizations: e.content.organizations,
                "show-custom-schools-menu": e.isCustomSchoolsMenuVisible,
                "sticky-header": e.shouldBeSticky,
                "shrink-header": e.shouldShrink,
                "is-preview": e.content.isPreview,
                onFocusLost: t[2] || (t[2] = (g) => e.customSchoolsMenuVisible = !1)
              }, null, 8, ["header-theme", "content", "org-menu-content", "organizations", "show-custom-schools-menu", "sticky-header", "shrink-header", "is-preview"])) : T("", !0)
            ]),
            _: 1
          })
        ])) : T("", !0),
        c("div", null, [
          j(l, {
            theme: e.theme,
            content: e.content,
            "dropdown-open": e.content.showMenu,
            "theme-overrides": {
              colors: {
                "--fill-color": "transparent",
                "--fill-path-color": e.theme.navigation_color.hex,
                "--bg-color": "transparent"
              }
            },
            item: "explore-button",
            onToggleDropdown: t[3] || (t[3] = (g) => e.clickedMenu("menubutton"))
          }, null, 8, ["theme", "content", "dropdown-open", "theme-overrides"]),
          e.menuV4Enabled && e.content.showMenu ? (d(), L(u, {
            key: 0,
            id: "explore-menu",
            "data-testid": "explore-menu",
            "aria-labelledby": "explore-button",
            styles: e.theme,
            data: e.content.sitemapMenuItems,
            "menu-v4-enabled": e.menuV4Enabled,
            "is-visible": e.exploreMenuVisible,
            "path-prefix": e.content.pathPrefix,
            "is-shrink": e.shrinkCSSClass === "shrink",
            onCloseDropdown: t[4] || (t[4] = (g) => e.exploreMenuVisible = !1)
          }, null, 8, ["styles", "data", "menu-v4-enabled", "is-visible", "path-prefix", "is-shrink"])) : T("", !0)
        ])
      ])
    ])) : (d(), L(v, {
      key: 2,
      theme: e.theme,
      content: e.content,
      "show-tagline": "",
      "show-utilities": "",
      "show-menu-buttons": !1,
      onToggleMobileMenu: t[7] || (t[7] = (g) => e.$emit("toggle-mobile-menu", g)),
      onToggleSearch: e.toggleSearch,
      onSetLanguage: e.setLanguage,
      onCloseMenu: e.closeAllMenus
    }, {
      default: S(() => [
        j(a, {
          theme: e.theme,
          content: e.content,
          "wrapper-component": n.wrapperComponent,
          "wrapper-props": n.wrapperProps,
          "show-sign-in-button": e.showSignInButton,
          "sign-in-url": e.signInUrl,
          "is-mobile": "",
          onToggleMobileMenu: t[5] || (t[5] = (g) => e.$emit("toggle-mobile-menu", g)),
          onToggleSearch: e.toggleSearch
        }, null, 8, ["theme", "content", "wrapper-component", "wrapper-props", "show-sign-in-button", "sign-in-url", "onToggleSearch"]),
        c("div", GO, [
          c("div", KO, [
            j(s, {
              "logo-link": e.logoLink,
              theme: e.theme,
              globals: e.content.globals,
              class: "org-banner"
            }, null, 8, ["logo-link", "theme", "globals"])
          ]),
          e.screenSize > 320 ? (d(), L(l, {
            key: 0,
            theme: e.theme,
            content: e.content,
            "dropdown-open": e.content.showMenu,
            item: "explore-button",
            onToggleDropdown: t[6] || (t[6] = (g) => e.$emit("toggle-mobile-menu", !e.content.showMenu))
          }, null, 8, ["theme", "content", "dropdown-open"])) : T("", !0)
        ])
      ]),
      "menu-top": S(() => [
        e.showSignInButton && e.screenSize <= 320 ? (d(), f("a", {
          key: 0,
          href: e.signInUrl,
          class: "sign-in-button",
          target: "_blank",
          "data-testid": "mobile-signin-button"
        }, k(e.signInText), 9, zO)) : T("", !0)
      ]),
      _: 1
    }, 8, ["theme", "content", "onToggleSearch", "onSetLanguage", "onCloseMenu"]))
  ], 4);
}
const xO = /* @__PURE__ */ B(VO, [["render", ZO], ["__scopeId", "data-v-ef0abdd8"]]), WO = {
  name: "H8TopBar",
  components: { DraggableWrapper: yt, MenuItem: Yt },
  mixins: [ut, Et, Wt],
  props: {
    content: {
      type: Object,
      default: () => ({})
    },
    theme: {
      type: Object,
      default: () => ({})
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["update:utilities", "update:icon-links", "toggle-mobile-menu", "open-icon-modal"]
}, YO = { class: "right-utilities-wrapper" }, XO = ["innerHTML"], QO = { class: "other-utility-options" }, JO = { key: 0 }, eP = ["href"];
function tP(e, t, n, r, o, i) {
  const a = V("MenuItem"), s = V("LanguageDropdown"), l = ze("click-away");
  return d(), f("div", {
    class: "top-bar",
    style: Z({
      "--nav-color": n.theme.utility_link_color.hex
    })
  }, [
    n.content.isEditing || !e.isMobile ? (d(), L(Y(n.wrapperComponent), Se({ key: 0 }, n.wrapperProps, {
      "model-value": n.content.utilities,
      "item-key": "idx",
      class: "utilities-container",
      "data-testid": "utility-bar",
      "onUpdate:modelValue": t[0] || (t[0] = (u) => e.$emit("update:utilities", u))
    }), {
      item: S(({ element: u, index: m }) => [
        (d(), L(Y(n.content.isEditing ? "div" : "a"), {
          class: "utility",
          href: u.link,
          target: u.opens_in_new_tab ? "_blank" : ""
        }, {
          default: S(() => [
            M(e.$slots, "utility", { idx: m }, () => [
              H(k(u.name), 1)
            ], !0)
          ]),
          _: 2
        }, 1032, ["href", "target"]))
      ]),
      _: 3
    }, 16, ["model-value"])) : T("", !0),
    c("div", YO, [
      n.content.isEditing || !e.isMobile ? (d(), L(Y(n.wrapperComponent), Se({ key: 0 }, n.wrapperProps, {
        "model-value": n.content.iconLinks,
        "item-key": "idx",
        class: "icon-links-container",
        "data-testid": "icon-links-section",
        "onUpdate:modelValue": t[2] || (t[2] = (u) => e.$emit("update:icon-links", u))
      }), {
        item: S(({ element: u, index: m }) => [
          n.theme.version === "H8" && n.theme.style === "texas" ? (d(), L(Y(n.content.isEditing ? "div" : "a"), {
            key: 0,
            class: "icon-link",
            href: u.link,
            target: u.opens_in_new_tab ? "_blank" : "",
            "aria-label": u.name
          }, {
            default: S(() => [
              M(e.$slots, "iconLink", { idx: m }, () => [
                c("span", {
                  "data-testid": "svg",
                  onClick: t[1] || (t[1] = (v) => e.$emit("open-icon-modal")),
                  innerHTML: u.icon
                }, null, 8, XO)
              ], !0)
            ]),
            _: 2
          }, 1032, ["href", "target", "aria-label"])) : T("", !0)
        ]),
        _: 3
      }, 16, ["model-value"])) : T("", !0),
      c("div", QO, [
        e.shouldDisplayLanguagesDropdown ? (d(), f("div", JO, [
          j(a, {
            theme: n.theme,
            content: n.content,
            "theme-overrides": {
              colors: {
                "--fill-color": "transparent",
                "--fill-path-color": n.theme.utility_link_color.hex,
                "--bg-color": "transparent",
                "--nav-color": n.theme.utility_link_color.hex
              }
            },
            item: "languagebutton",
            "dropdown-open": e.languageDropdownVisible,
            onToggleDropdown: t[3] || (t[3] = (u) => e.clickedMenu("languagebutton"))
          }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open"]),
          we(j(s, {
            id: "languagesmenu",
            "data-testid": "languages-menu",
            role: "menu",
            data: n.content.languages,
            styles: n.theme,
            "is-visible": e.languageDropdownVisible,
            "current-language": n.content.langCode,
            onSetLanguage: e.setLanguage,
            onCloseDropdown: t[4] || (t[4] = (u) => e.languageDropdownVisible = !1)
          }, null, 8, ["data", "styles", "is-visible", "current-language", "onSetLanguage"]), [
            [
              l,
              () => {
                e.languageDropdownVisible = !1;
              }
            ]
          ])
        ])) : T("", !0),
        j(a, {
          theme: n.theme,
          content: n.content,
          item: "searchbutton",
          "screen-size": e.screenSize,
          onToggleSearch: e.toggleSearch
        }, null, 8, ["theme", "content", "screen-size", "onToggleSearch"]),
        e.showSignInButton && e.screenSize > 320 ? (d(), f("a", {
          key: 1,
          href: e.signInUrl,
          class: "sign-in-button",
          "data-testid": "desktop-signin-button",
          target: "_blank"
        }, k(e.signInText), 9, eP)) : T("", !0),
        e.screenSize <= 320 ? (d(), L(a, {
          key: 2,
          theme: n.theme,
          content: n.content,
          "dropdown-open": n.content.showMenu,
          "theme-overrides": {
            icon: "HamburgerIcon",
            colors: {
              "--fill-color": "transparent",
              "--fill-path-color": n.theme.utility_link_color.hex,
              "--bg-color": "transparent"
            }
          },
          item: "explore-button",
          onToggleDropdown: t[5] || (t[5] = (u) => e.$emit("toggle-mobile-menu", !n.content.showMenu))
        }, null, 8, ["theme", "content", "dropdown-open", "theme-overrides"])) : T("", !0)
      ])
    ])
  ], 4);
}
const nP = /* @__PURE__ */ B(WO, [["render", tP], ["__scopeId", "data-v-50c1cbcc"]]), rP = {
  name: "Header8",
  components: {
    CmsSchoolsMenu: mr,
    OrgBanner: fr,
    MobileHeader: Zr,
    MenuItem: Yt,
    H8TopBar: nP
  },
  mixins: [ut, Wt],
  props: {
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["update:utilities", "update:icon-links", "open-icon-modal", "toggle-mobile-menu"],
  computed: {
    colors() {
      return ae({
        "--top-bar-bg-color": this.theme.utility_bg_color.hex,
        "--nav-color": this.theme.navigation_color.hex,
        "--top-bar-text-color": this.theme.utility_link_color.hex,
        "--bg-color": this.theme.bg_color.hex,
        "--icon-link-color": this.theme.icon_link_color.hex
      }, this.signInColors);
    }
  }
}, oP = {
  key: 1,
  class: "header-container"
}, iP = { class: "header-container-left" }, sP = { class: "header-container-right" }, aP = {
  key: 0,
  class: "schools-menu-container"
}, lP = { class: "mobile-header-top" }, uP = { class: "org-banner-wrapper" }, dP = ["href"];
function cP(e, t, n, r, o, i) {
  const a = V("H8TopBar"), s = V("OrgBanner"), l = V("MenuItem"), u = V("HeaderDropdown"), m = V("CmsSchoolsMenu"), v = V("MobileHeader");
  return d(), f("div", {
    style: Z(i.colors),
    class: "h8"
  }, [
    !e.isMobile || e.content.isEditing ? (d(), L(a, {
      key: 0,
      theme: e.theme,
      content: e.content,
      "wrapper-component": n.wrapperComponent,
      "wrapper-props": n.wrapperProps,
      "show-sign-in-button": e.showSignInButton,
      "sign-in-url": e.signInUrl,
      onLanguageChange: e.setLanguage,
      onOpenIconModal: t[0] || (t[0] = (g) => e.$emit("open-icon-modal", g)),
      onToggleSearch: e.toggleSearch,
      "onUpdate:utilities": t[1] || (t[1] = (g) => e.$emit("update:utilities", g)),
      "onUpdate:iconLinks": t[2] || (t[2] = (g) => e.$emit("update:icon-links", g))
    }, {
      utility: S(({ idx: g }) => [
        M(e.$slots, "utility", { idx: g }, void 0, !0)
      ]),
      iconLink: S(({ idx: g }) => [
        M(e.$slots, "iconLink", { idx: g }, void 0, !0)
      ]),
      _: 3
    }, 8, ["theme", "content", "wrapper-component", "wrapper-props", "show-sign-in-button", "sign-in-url", "onLanguageChange", "onToggleSearch"])) : T("", !0),
    !e.isMobile || e.content.isEditing ? (d(), f("div", oP, [
      c("div", iP, [
        j(s, {
          "logo-link": e.logoLink,
          theme: e.theme,
          globals: e.content.globals
        }, null, 8, ["logo-link", "theme", "globals"])
      ]),
      c("div", sP, [
        e.shouldDisplaySchoolsDropdown ? (d(), f("div", aP, [
          j(l, {
            item: "schoolsbutton",
            theme: e.theme,
            content: e.content,
            "theme-overrides": {
              colors: {
                "--fill-color": "transparent",
                "--fill-path-color": e.theme.navigation_color.hex,
                "--bg-color": "transparent"
              }
            },
            "dropdown-open": e.isSchoolDropdownVisible || e.isCustomSchoolsMenuVisible,
            onToggleDropdown: e.setDropdownVisibility
          }, null, 8, ["theme", "content", "theme-overrides", "dropdown-open", "onToggleDropdown"]),
          e.content.hasCustomSchoolsMenu ? T("", !0) : (d(), L(u, {
            key: 0,
            id: "schoolsmenu",
            "data-testid": "schools-menu",
            "aria-labelledby": "schoolsbutton",
            styles: e.theme,
            data: e.content.organizations,
            "is-visible": e.schoolDropdownVisible,
            "is-preview": e.content.isPreview,
            "is-language-menu-hidden": !e.shouldDisplayLanguagesDropdown,
            "is-shrink": e.shrinkCSSClass === "shrink",
            onCloseDropdown: t[3] || (t[3] = (g) => e.schoolDropdownVisible = !1)
          }, null, 8, ["styles", "data", "is-visible", "is-preview", "is-language-menu-hidden", "is-shrink"])),
          j(Le, { name: "slide" }, {
            default: S(() => [
              e.content.hasCustomSchoolsMenu ? (d(), L(m, {
                key: 0,
                id: "schoolsmenu",
                ref: "schoolsmenu",
                "data-testid": "schools-menu",
                "header-theme": e.theme,
                content: e.content.globals.homepage,
                "org-menu-content": e.content.orgMenuContent,
                organizations: e.content.organizations,
                "show-custom-schools-menu": e.isCustomSchoolsMenuVisible,
                "sticky-header": e.shouldBeSticky,
                "shrink-header": e.shouldShrink,
                "is-preview": e.content.isPreview,
                onFocusLost: t[4] || (t[4] = (g) => e.customSchoolsMenuVisible = !1)
              }, null, 8, ["header-theme", "content", "org-menu-content", "organizations", "show-custom-schools-menu", "sticky-header", "shrink-header", "is-preview"])) : T("", !0)
            ]),
            _: 1
          })
        ])) : T("", !0),
        c("div", null, [
          j(l, {
            theme: e.theme,
            content: e.content,
            "dropdown-open": e.content.showMenu,
            "theme-overrides": {
              colors: {
                "--fill-color": "transparent",
                "--fill-path-color": e.theme.navigation_color.hex,
                "--bg-color": "transparent"
              }
            },
            item: "explore-button",
            onToggleDropdown: t[5] || (t[5] = (g) => e.clickedMenu("menubutton"))
          }, null, 8, ["theme", "content", "dropdown-open", "theme-overrides"]),
          e.menuV4Enabled && e.content.showMenu ? (d(), L(u, {
            key: 0,
            id: "explore-menu",
            "data-testid": "explore-menu",
            "aria-labelledby": "explore-button",
            styles: e.theme,
            data: e.content.sitemapMenuItems,
            "menu-v4-enabled": e.menuV4Enabled,
            "is-visible": e.exploreMenuVisible,
            "path-prefix": e.content.pathPrefix,
            "is-shrink": e.shrinkCSSClass === "shrink",
            onCloseDropdown: t[6] || (t[6] = (g) => e.exploreMenuVisible = !1)
          }, null, 8, ["styles", "data", "menu-v4-enabled", "is-visible", "path-prefix", "is-shrink"])) : T("", !0)
        ])
      ])
    ])) : (d(), L(v, {
      key: 2,
      theme: e.theme,
      content: e.content,
      "show-tagline": "",
      "show-utilities": "",
      "show-menu-buttons": !1,
      onToggleMobileMenu: t[9] || (t[9] = (g) => e.$emit("toggle-mobile-menu", g)),
      onToggleSearch: e.toggleSearch,
      onSetLanguage: e.setLanguage,
      onCloseMenu: e.closeAllMenus
    }, {
      default: S(() => [
        j(a, {
          theme: e.theme,
          content: e.content,
          "wrapper-component": n.wrapperComponent,
          "wrapper-props": n.wrapperProps,
          "show-sign-in-button": e.showSignInButton,
          "sign-in-url": e.signInUrl,
          "is-mobile": "",
          onToggleMobileMenu: t[7] || (t[7] = (g) => e.$emit("toggle-mobile-menu", g)),
          onToggleSearch: e.toggleSearch
        }, null, 8, ["theme", "content", "wrapper-component", "wrapper-props", "show-sign-in-button", "sign-in-url", "onToggleSearch"]),
        c("div", lP, [
          c("div", uP, [
            j(s, {
              "logo-link": e.logoLink,
              theme: e.theme,
              globals: e.content.globals,
              class: "org-banner"
            }, null, 8, ["logo-link", "theme", "globals"])
          ]),
          e.screenSize > 320 ? (d(), L(l, {
            key: 0,
            theme: e.theme,
            content: e.content,
            "dropdown-open": e.content.showMenu,
            item: "explore-button",
            onToggleDropdown: t[8] || (t[8] = (g) => e.$emit("toggle-mobile-menu", !e.content.showMenu))
          }, null, 8, ["theme", "content", "dropdown-open"])) : T("", !0)
        ])
      ]),
      "menu-top": S(() => [
        e.showSignInButton && e.screenSize <= 320 ? (d(), f("a", {
          key: 0,
          href: e.signInUrl,
          class: "sign-in-button",
          target: "_blank",
          "data-testid": "mobile-signin-button"
        }, k(e.signInText), 9, dP)) : T("", !0)
      ]),
      _: 1
    }, 8, ["theme", "content", "onToggleSearch", "onSetLanguage", "onCloseMenu"]))
  ], 4);
}
const hP = /* @__PURE__ */ B(rP, [["render", cP], ["__scopeId", "data-v-919a6f56"]]);
var mP = Object.defineProperty, fP = Object.defineProperties, pP = Object.getOwnPropertyDescriptors, km = Object.getOwnPropertySymbols, gP = Object.prototype.hasOwnProperty, vP = Object.prototype.propertyIsEnumerable, Em = (e, t, n) => t in e ? mP(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, jn = (e, t) => {
  for (var n in t || (t = {}))
    gP.call(t, n) && Em(e, n, t[n]);
  if (km)
    for (var n of km(t))
      vP.call(t, n) && Em(e, n, t[n]);
  return e;
}, H0 = (e, t) => fP(e, pP(t));
function Sm(e) {
  if (e)
    throw e;
}
var Gi = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function Ao(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
var Mm, Am;
function bP() {
  return Am || (Am = 1, Mm = function(e) {
    return e != null && e.constructor != null && typeof e.constructor.isBuffer == "function" && e.constructor.isBuffer(e);
  }), Mm;
}
var yP = bP();
const x4 = /* @__PURE__ */ Ao(yP);
var Rl, Im;
function _P() {
  if (Im) return Rl;
  Im = 1;
  var e = Object.prototype.hasOwnProperty, t = Object.prototype.toString, n = Object.defineProperty, r = Object.getOwnPropertyDescriptor, o = function(l) {
    return typeof Array.isArray == "function" ? Array.isArray(l) : t.call(l) === "[object Array]";
  }, i = function(l) {
    if (!l || t.call(l) !== "[object Object]")
      return !1;
    var u = e.call(l, "constructor"), m = l.constructor && l.constructor.prototype && e.call(l.constructor.prototype, "isPrototypeOf");
    if (l.constructor && !u && !m)
      return !1;
    var v;
    for (v in l)
      ;
    return typeof v == "undefined" || e.call(l, v);
  }, a = function(l, u) {
    n && u.name === "__proto__" ? n(l, u.name, {
      enumerable: !0,
      configurable: !0,
      value: u.newValue,
      writable: !0
    }) : l[u.name] = u.newValue;
  }, s = function(l, u) {
    if (u === "__proto__")
      if (e.call(l, u)) {
        if (r)
          return r(l, u).value;
      } else return;
    return l[u];
  };
  return Rl = function l() {
    var u, m, v, g, h, E, C = arguments[0], A = 1, R = arguments.length, P = !1;
    for (typeof C == "boolean" && (P = C, C = arguments[1] || {}, A = 2), (C == null || typeof C != "object" && typeof C != "function") && (C = {}); A < R; ++A)
      if (u = arguments[A], u != null)
        for (m in u)
          v = s(C, m), g = s(u, m), C !== g && (P && g && (i(g) || (h = o(g))) ? (h ? (h = !1, E = v && o(v) ? v : []) : E = v && i(v) ? v : {}, a(C, { name: m, newValue: l(P, E, g) })) : typeof g != "undefined" && a(C, { name: m, newValue: g }));
    return C;
  }, Rl;
}
var CP = _P();
const Lm = /* @__PURE__ */ Ao(CP);
function zc(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function wP() {
  const e = [], t = { run: n, use: r };
  return t;
  function n(...o) {
    let i = -1;
    const a = o.pop();
    if (typeof a != "function")
      throw new TypeError("Expected function as last argument, not " + a);
    s(null, ...o);
    function s(l, ...u) {
      const m = e[++i];
      let v = -1;
      if (l) {
        a(l);
        return;
      }
      for (; ++v < o.length; )
        (u[v] === null || u[v] === void 0) && (u[v] = o[v]);
      o = u, m ? TP(m, s)(...u) : a(null, ...u);
    }
  }
  function r(o) {
    if (typeof o != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + o
      );
    return e.push(o), t;
  }
}
function TP(e, t) {
  let n;
  return r;
  function r(...a) {
    const s = e.length > a.length;
    let l;
    s && a.push(o);
    try {
      l = e.apply(this, a);
    } catch (u) {
      const m = (
        /** @type {Error} */
        u
      );
      if (s && n)
        throw m;
      return o(m);
    }
    s || (l && l.then && typeof l.then == "function" ? l.then(i, o) : l instanceof Error ? o(l) : i(l));
  }
  function o(a, ...s) {
    n || (n = !0, t(a, ...s));
  }
  function i(a) {
    o(null, a);
  }
}
function kP(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? Dm(e.position) : "start" in e || "end" in e ? Dm(e) : "line" in e || "column" in e ? Zc(e) : "";
}
function Zc(e) {
  return $m(e && e.line) + ":" + $m(e && e.column);
}
function Dm(e) {
  return Zc(e && e.start) + "-" + Zc(e && e.end);
}
function $m(e) {
  return e && typeof e == "number" ? e : 1;
}
class sn extends Error {
  /**
   * Create a message for `reason` at `place` from `origin`.
   *
   * When an error is passed in as `reason`, the `stack` is copied.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   *
   *   > 👉 **Note**: you should use markdown.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // To do: next major: expose `undefined` everywhere instead of `null`.
  constructor(t, n, r) {
    const o = [null, null];
    let i = {
      // @ts-expect-error: we always follows the structure of `position`.
      start: { line: null, column: null },
      // @ts-expect-error: "
      end: { line: null, column: null }
    };
    if (super(), typeof n == "string" && (r = n, n = void 0), typeof r == "string") {
      const a = r.indexOf(":");
      a === -1 ? o[1] = r : (o[0] = r.slice(0, a), o[1] = r.slice(a + 1));
    }
    n && ("type" in n || "position" in n ? n.position && (i = n.position) : "start" in n || "end" in n ? i = n : ("line" in n || "column" in n) && (i.start = n)), this.name = kP(n) || "1:1", this.message = typeof t == "object" ? t.message : t, this.stack = "", typeof t == "object" && t.stack && (this.stack = t.stack), this.reason = this.message, this.fatal, this.line = i.start.line, this.column = i.start.column, this.position = i, this.source = o[0], this.ruleId = o[1], this.file, this.actual, this.expected, this.url, this.note;
  }
}
sn.prototype.file = "";
sn.prototype.name = "";
sn.prototype.reason = "";
sn.prototype.message = "";
sn.prototype.stack = "";
sn.prototype.fatal = null;
sn.prototype.column = null;
sn.prototype.line = null;
sn.prototype.source = null;
sn.prototype.ruleId = null;
sn.prototype.position = null;
const Tn = { basename: EP, dirname: SP, extname: MP, join: AP, sep: "/" };
function EP(e, t) {
  if (t !== void 0 && typeof t != "string")
    throw new TypeError('"ext" argument must be a string');
  yi(e);
  let n = 0, r = -1, o = e.length, i;
  if (t === void 0 || t.length === 0 || t.length > e.length) {
    for (; o--; )
      if (e.charCodeAt(o) === 47) {
        if (i) {
          n = o + 1;
          break;
        }
      } else r < 0 && (i = !0, r = o + 1);
    return r < 0 ? "" : e.slice(n, r);
  }
  if (t === e)
    return "";
  let a = -1, s = t.length - 1;
  for (; o--; )
    if (e.charCodeAt(o) === 47) {
      if (i) {
        n = o + 1;
        break;
      }
    } else
      a < 0 && (i = !0, a = o + 1), s > -1 && (e.charCodeAt(o) === t.charCodeAt(s--) ? s < 0 && (r = o) : (s = -1, r = a));
  return n === r ? r = a : r < 0 && (r = e.length), e.slice(n, r);
}
function SP(e) {
  if (yi(e), e.length === 0)
    return ".";
  let t = -1, n = e.length, r;
  for (; --n; )
    if (e.charCodeAt(n) === 47) {
      if (r) {
        t = n;
        break;
      }
    } else r || (r = !0);
  return t < 0 ? e.charCodeAt(0) === 47 ? "/" : "." : t === 1 && e.charCodeAt(0) === 47 ? "//" : e.slice(0, t);
}
function MP(e) {
  yi(e);
  let t = e.length, n = -1, r = 0, o = -1, i = 0, a;
  for (; t--; ) {
    const s = e.charCodeAt(t);
    if (s === 47) {
      if (a) {
        r = t + 1;
        break;
      }
      continue;
    }
    n < 0 && (a = !0, n = t + 1), s === 46 ? o < 0 ? o = t : i !== 1 && (i = 1) : o > -1 && (i = -1);
  }
  return o < 0 || n < 0 || // We saw a non-dot character immediately before the dot.
  i === 0 || // The (right-most) trimmed path component is exactly `..`.
  i === 1 && o === n - 1 && o === r + 1 ? "" : e.slice(o, n);
}
function AP(...e) {
  let t = -1, n;
  for (; ++t < e.length; )
    yi(e[t]), e[t] && (n = n === void 0 ? e[t] : n + "/" + e[t]);
  return n === void 0 ? "." : IP(n);
}
function IP(e) {
  yi(e);
  const t = e.charCodeAt(0) === 47;
  let n = LP(e, !t);
  return n.length === 0 && !t && (n = "."), n.length > 0 && e.charCodeAt(e.length - 1) === 47 && (n += "/"), t ? "/" + n : n;
}
function LP(e, t) {
  let n = "", r = 0, o = -1, i = 0, a = -1, s, l;
  for (; ++a <= e.length; ) {
    if (a < e.length)
      s = e.charCodeAt(a);
    else {
      if (s === 47)
        break;
      s = 47;
    }
    if (s === 47) {
      if (!(o === a - 1 || i === 1)) if (o !== a - 1 && i === 2) {
        if (n.length < 2 || r !== 2 || n.charCodeAt(n.length - 1) !== 46 || n.charCodeAt(n.length - 2) !== 46) {
          if (n.length > 2) {
            if (l = n.lastIndexOf("/"), l !== n.length - 1) {
              l < 0 ? (n = "", r = 0) : (n = n.slice(0, l), r = n.length - 1 - n.lastIndexOf("/")), o = a, i = 0;
              continue;
            }
          } else if (n.length > 0) {
            n = "", r = 0, o = a, i = 0;
            continue;
          }
        }
        t && (n = n.length > 0 ? n + "/.." : "..", r = 2);
      } else
        n.length > 0 ? n += "/" + e.slice(o + 1, a) : n = e.slice(o + 1, a), r = a - o - 1;
      o = a, i = 0;
    } else s === 46 && i > -1 ? i++ : i = -1;
  }
  return n;
}
function yi(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const DP = { cwd: $P };
function $P() {
  return "/";
}
function xc(e) {
  return e !== null && typeof e == "object" && // @ts-expect-error: indexable.
  e.href && // @ts-expect-error: indexable.
  e.origin;
}
function OP(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!xc(e)) {
    const t = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw t.code = "ERR_INVALID_ARG_TYPE", t;
  }
  if (e.protocol !== "file:") {
    const t = new TypeError("The URL must be of scheme file");
    throw t.code = "ERR_INVALID_URL_SCHEME", t;
  }
  return PP(e);
}
function PP(e) {
  if (e.hostname !== "") {
    const r = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw r.code = "ERR_INVALID_FILE_URL_HOST", r;
  }
  const t = e.pathname;
  let n = -1;
  for (; ++n < t.length; )
    if (t.charCodeAt(n) === 37 && t.charCodeAt(n + 1) === 50) {
      const r = t.charCodeAt(n + 2);
      if (r === 70 || r === 102) {
        const o = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw o.code = "ERR_INVALID_FILE_URL_PATH", o;
      }
    }
  return decodeURIComponent(t);
}
const Vl = ["history", "path", "basename", "stem", "extname", "dirname"];
class NP {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Buffer` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(t) {
    let n;
    t ? typeof t == "string" || HP(t) ? n = { value: t } : xc(t) ? n = { path: t } : n = t : n = {}, this.data = {}, this.messages = [], this.history = [], this.cwd = DP.cwd(), this.value, this.stored, this.result, this.map;
    let r = -1;
    for (; ++r < Vl.length; ) {
      const i = Vl[r];
      i in n && n[i] !== void 0 && n[i] !== null && (this[i] = i === "history" ? [...n[i]] : n[i]);
    }
    let o;
    for (o in n)
      Vl.includes(o) || (this[o] = n[o]);
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {string | URL} path
   */
  set path(t) {
    xc(t) && (t = OP(t)), jl(t, "path"), this.path !== t && this.history.push(t);
  }
  /**
   * Get the parent path (example: `'~'`).
   */
  get dirname() {
    return typeof this.path == "string" ? Tn.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   */
  set dirname(t) {
    Om(this.basename, "dirname"), this.path = Tn.join(t || "", this.basename);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   */
  get basename() {
    return typeof this.path == "string" ? Tn.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */
  set basename(t) {
    jl(t, "basename"), Bl(t, "basename"), this.path = Tn.join(this.dirname || "", t);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   */
  get extname() {
    return typeof this.path == "string" ? Tn.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   */
  set extname(t) {
    if (Bl(t, "extname"), Om(this.dirname, "extname"), t) {
      if (t.charCodeAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (t.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = Tn.join(this.dirname, this.stem + (t || ""));
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   */
  get stem() {
    return typeof this.path == "string" ? Tn.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */
  set stem(t) {
    jl(t, "stem"), Bl(t, "stem"), this.path = Tn.join(this.dirname || "", t + (this.extname || ""));
  }
  /**
   * Serialize the file.
   *
   * @param {BufferEncoding | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Buffer`
   *   (default: `'utf8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(t) {
    return (this.value || "").toString(t || void 0);
  }
  /**
   * Create a warning message associated with the file.
   *
   * Its `fatal` is set to `false` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(t, n, r) {
    const o = new sn(t, n, r);
    return this.path && (o.name = this.path + ":" + o.name, o.file = this.path), o.fatal = !1, this.messages.push(o), o;
  }
  /**
   * Create an info message associated with the file.
   *
   * Its `fatal` is set to `null` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(t, n, r) {
    const o = this.message(t, n, r);
    return o.fatal = null, o;
  }
  /**
   * Create a fatal error associated with the file.
   *
   * Its `fatal` is set to `true` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * > 👉 **Note**: a fatal error means that a file is no longer processable.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Message.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(t, n, r) {
    const o = this.message(t, n, r);
    throw o.fatal = !0, o;
  }
}
function Bl(e, t) {
  if (e && e.includes(Tn.sep))
    throw new Error(
      "`" + t + "` cannot be a path: did not expect `" + Tn.sep + "`"
    );
}
function jl(e, t) {
  if (!e)
    throw new Error("`" + t + "` cannot be empty");
}
function Om(e, t) {
  if (!e)
    throw new Error("Setting `" + t + "` requires `path` to be set too");
}
function HP(e) {
  return x4(e);
}
const Wc = Y4().freeze(), W4 = {}.hasOwnProperty;
function Y4() {
  const e = wP(), t = [];
  let n = {}, r, o = -1;
  return i.data = a, i.Parser = void 0, i.Compiler = void 0, i.freeze = s, i.attachers = t, i.use = l, i.parse = u, i.stringify = m, i.run = v, i.runSync = g, i.process = h, i.processSync = E, i;
  function i() {
    const C = Y4();
    let A = -1;
    for (; ++A < t.length; )
      C.use(...t[A]);
    return C.data(Lm(!0, {}, n)), C;
  }
  function a(C, A) {
    return typeof C == "string" ? arguments.length === 2 ? (Gl("data", r), n[C] = A, i) : W4.call(n, C) && n[C] || null : C ? (Gl("data", r), n = C, i) : n;
  }
  function s() {
    if (r)
      return i;
    for (; ++o < t.length; ) {
      const [C, ...A] = t[o];
      if (A[0] === !1)
        continue;
      A[0] === !0 && (A[0] = void 0);
      const R = C.call(i, ...A);
      typeof R == "function" && e.use(R);
    }
    return r = !0, o = Number.POSITIVE_INFINITY, i;
  }
  function l(C, ...A) {
    let R;
    if (Gl("use", r), C != null) if (typeof C == "function")
      D(C, ...A);
    else if (typeof C == "object")
      Array.isArray(C) ? I(C) : F(C);
    else
      throw new TypeError("Expected usable value, not `" + C + "`");
    return R && (n.settings = Object.assign(n.settings || {}, R)), i;
    function P(O) {
      if (typeof O == "function")
        D(O);
      else if (typeof O == "object")
        if (Array.isArray(O)) {
          const [U, ...q] = O;
          D(U, ...q);
        } else
          F(O);
      else
        throw new TypeError("Expected usable value, not `" + O + "`");
    }
    function F(O) {
      I(O.plugins), O.settings && (R = Object.assign(R || {}, O.settings));
    }
    function I(O) {
      let U = -1;
      if (O != null) if (Array.isArray(O))
        for (; ++U < O.length; ) {
          const q = O[U];
          P(q);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + O + "`");
    }
    function D(O, U) {
      let q = -1, z;
      for (; ++q < t.length; )
        if (t[q][0] === O) {
          z = t[q];
          break;
        }
      z ? (zc(z[1]) && zc(U) && (U = Lm(!0, z[1], U)), z[1] = U) : t.push([...arguments]);
    }
  }
  function u(C) {
    i.freeze();
    const A = jo(C), R = i.Parser;
    return Ul("parse", R), Pm(R, "parse") ? new R(String(A), A).parse() : R(String(A), A);
  }
  function m(C, A) {
    i.freeze();
    const R = jo(A), P = i.Compiler;
    return ql("stringify", P), Nm(C), Pm(P, "compile") ? new P(C, R).compile() : P(C, R);
  }
  function v(C, A, R) {
    if (Nm(C), i.freeze(), !R && typeof A == "function" && (R = A, A = void 0), !R)
      return new Promise(P);
    P(null, R);
    function P(F, I) {
      e.run(C, jo(A), D);
      function D(O, U, q) {
        U = U || C, O ? I(O) : F ? F(U) : R(null, U, q);
      }
    }
  }
  function g(C, A) {
    let R, P;
    return i.run(C, A, F), Hm("runSync", "run", P), R;
    function F(I, D) {
      Sm(I), R = D, P = !0;
    }
  }
  function h(C, A) {
    if (i.freeze(), Ul("process", i.Parser), ql("process", i.Compiler), !A)
      return new Promise(R);
    R(null, A);
    function R(P, F) {
      const I = jo(C);
      i.run(i.parse(I), I, (O, U, q) => {
        if (O || !U || !q)
          D(O);
        else {
          const z = i.stringify(U, q);
          z == null || (VP(z) ? q.value = z : q.result = z), D(O, q);
        }
      });
      function D(O, U) {
        O || !U ? F(O) : P ? P(U) : A(null, U);
      }
    }
  }
  function E(C) {
    let A;
    i.freeze(), Ul("processSync", i.Parser), ql("processSync", i.Compiler);
    const R = jo(C);
    return i.process(R, P), Hm("processSync", "process", A), R;
    function P(F) {
      A = !0, Sm(F);
    }
  }
}
function Pm(e, t) {
  return typeof e == "function" && // Prototypes do exist.
  // type-coverage:ignore-next-line
  e.prototype && // A function with keys in its prototype is probably a constructor.
  // Classes’ prototype methods are not enumerable, so we check if some value
  // exists in the prototype.
  // type-coverage:ignore-next-line
  (FP(e.prototype) || t in e.prototype);
}
function FP(e) {
  let t;
  for (t in e)
    if (W4.call(e, t))
      return !0;
  return !1;
}
function Ul(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `Parser`");
}
function ql(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `Compiler`");
}
function Gl(e, t) {
  if (t)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function Nm(e) {
  if (!zc(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function Hm(e, t, n) {
  if (!n)
    throw new Error(
      "`" + e + "` finished async. Use `" + t + "` instead"
    );
}
function jo(e) {
  return RP(e) ? e : new NP(e);
}
function RP(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function VP(e) {
  return typeof e == "string" || x4(e);
}
var wn = {}, Fm;
function F0() {
  if (Fm) return wn;
  Fm = 1;
  const e = [
    65534,
    65535,
    131070,
    131071,
    196606,
    196607,
    262142,
    262143,
    327678,
    327679,
    393214,
    393215,
    458750,
    458751,
    524286,
    524287,
    589822,
    589823,
    655358,
    655359,
    720894,
    720895,
    786430,
    786431,
    851966,
    851967,
    917502,
    917503,
    983038,
    983039,
    1048574,
    1048575,
    1114110,
    1114111
  ];
  return wn.REPLACEMENT_CHARACTER = "�", wn.CODE_POINTS = {
    EOF: -1,
    NULL: 0,
    TABULATION: 9,
    CARRIAGE_RETURN: 13,
    LINE_FEED: 10,
    FORM_FEED: 12,
    SPACE: 32,
    EXCLAMATION_MARK: 33,
    QUOTATION_MARK: 34,
    NUMBER_SIGN: 35,
    AMPERSAND: 38,
    APOSTROPHE: 39,
    HYPHEN_MINUS: 45,
    SOLIDUS: 47,
    DIGIT_0: 48,
    DIGIT_9: 57,
    SEMICOLON: 59,
    LESS_THAN_SIGN: 60,
    EQUALS_SIGN: 61,
    GREATER_THAN_SIGN: 62,
    QUESTION_MARK: 63,
    LATIN_CAPITAL_A: 65,
    LATIN_CAPITAL_F: 70,
    LATIN_CAPITAL_X: 88,
    LATIN_CAPITAL_Z: 90,
    RIGHT_SQUARE_BRACKET: 93,
    GRAVE_ACCENT: 96,
    LATIN_SMALL_A: 97,
    LATIN_SMALL_F: 102,
    LATIN_SMALL_X: 120,
    LATIN_SMALL_Z: 122,
    REPLACEMENT_CHARACTER: 65533
  }, wn.CODE_POINT_SEQUENCES = {
    DASH_DASH_STRING: [45, 45],
    //--
    DOCTYPE_STRING: [68, 79, 67, 84, 89, 80, 69],
    //DOCTYPE
    CDATA_START_STRING: [91, 67, 68, 65, 84, 65, 91],
    //[CDATA[
    SCRIPT_STRING: [115, 99, 114, 105, 112, 116],
    //script
    PUBLIC_STRING: [80, 85, 66, 76, 73, 67],
    //PUBLIC
    SYSTEM_STRING: [83, 89, 83, 84, 69, 77]
    //SYSTEM
  }, wn.isSurrogate = function(t) {
    return t >= 55296 && t <= 57343;
  }, wn.isSurrogatePair = function(t) {
    return t >= 56320 && t <= 57343;
  }, wn.getSurrogatePairCodePoint = function(t, n) {
    return (t - 55296) * 1024 + 9216 + n;
  }, wn.isControlCodePoint = function(t) {
    return t !== 32 && t !== 10 && t !== 13 && t !== 9 && t !== 12 && t >= 1 && t <= 31 || t >= 127 && t <= 159;
  }, wn.isUndefinedCodePoint = function(t) {
    return t >= 64976 && t <= 65007 || e.indexOf(t) > -1;
  }, wn;
}
var Rm, Vm;
function R0() {
  return Vm || (Vm = 1, Rm = {
    controlCharacterInInputStream: "control-character-in-input-stream",
    noncharacterInInputStream: "noncharacter-in-input-stream",
    surrogateInInputStream: "surrogate-in-input-stream",
    nonVoidHtmlElementStartTagWithTrailingSolidus: "non-void-html-element-start-tag-with-trailing-solidus",
    endTagWithAttributes: "end-tag-with-attributes",
    endTagWithTrailingSolidus: "end-tag-with-trailing-solidus",
    unexpectedSolidusInTag: "unexpected-solidus-in-tag",
    unexpectedNullCharacter: "unexpected-null-character",
    unexpectedQuestionMarkInsteadOfTagName: "unexpected-question-mark-instead-of-tag-name",
    invalidFirstCharacterOfTagName: "invalid-first-character-of-tag-name",
    unexpectedEqualsSignBeforeAttributeName: "unexpected-equals-sign-before-attribute-name",
    missingEndTagName: "missing-end-tag-name",
    unexpectedCharacterInAttributeName: "unexpected-character-in-attribute-name",
    unknownNamedCharacterReference: "unknown-named-character-reference",
    missingSemicolonAfterCharacterReference: "missing-semicolon-after-character-reference",
    unexpectedCharacterAfterDoctypeSystemIdentifier: "unexpected-character-after-doctype-system-identifier",
    unexpectedCharacterInUnquotedAttributeValue: "unexpected-character-in-unquoted-attribute-value",
    eofBeforeTagName: "eof-before-tag-name",
    eofInTag: "eof-in-tag",
    missingAttributeValue: "missing-attribute-value",
    missingWhitespaceBetweenAttributes: "missing-whitespace-between-attributes",
    missingWhitespaceAfterDoctypePublicKeyword: "missing-whitespace-after-doctype-public-keyword",
    missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers: "missing-whitespace-between-doctype-public-and-system-identifiers",
    missingWhitespaceAfterDoctypeSystemKeyword: "missing-whitespace-after-doctype-system-keyword",
    missingQuoteBeforeDoctypePublicIdentifier: "missing-quote-before-doctype-public-identifier",
    missingQuoteBeforeDoctypeSystemIdentifier: "missing-quote-before-doctype-system-identifier",
    missingDoctypePublicIdentifier: "missing-doctype-public-identifier",
    missingDoctypeSystemIdentifier: "missing-doctype-system-identifier",
    abruptDoctypePublicIdentifier: "abrupt-doctype-public-identifier",
    abruptDoctypeSystemIdentifier: "abrupt-doctype-system-identifier",
    cdataInHtmlContent: "cdata-in-html-content",
    incorrectlyOpenedComment: "incorrectly-opened-comment",
    eofInScriptHtmlCommentLikeText: "eof-in-script-html-comment-like-text",
    eofInDoctype: "eof-in-doctype",
    nestedComment: "nested-comment",
    abruptClosingOfEmptyComment: "abrupt-closing-of-empty-comment",
    eofInComment: "eof-in-comment",
    incorrectlyClosedComment: "incorrectly-closed-comment",
    eofInCdata: "eof-in-cdata",
    absenceOfDigitsInNumericCharacterReference: "absence-of-digits-in-numeric-character-reference",
    nullCharacterReference: "null-character-reference",
    surrogateCharacterReference: "surrogate-character-reference",
    characterReferenceOutsideUnicodeRange: "character-reference-outside-unicode-range",
    controlCharacterReference: "control-character-reference",
    noncharacterCharacterReference: "noncharacter-character-reference",
    missingWhitespaceBeforeDoctypeName: "missing-whitespace-before-doctype-name",
    missingDoctypeName: "missing-doctype-name",
    invalidCharacterSequenceAfterDoctypeName: "invalid-character-sequence-after-doctype-name",
    duplicateAttribute: "duplicate-attribute",
    nonConformingDoctype: "non-conforming-doctype",
    missingDoctype: "missing-doctype",
    misplacedDoctype: "misplaced-doctype",
    endTagWithoutMatchingOpenElement: "end-tag-without-matching-open-element",
    closingOfElementWithOpenChildElements: "closing-of-element-with-open-child-elements",
    disallowedContentInNoscriptInHead: "disallowed-content-in-noscript-in-head",
    openElementsLeftAfterEof: "open-elements-left-after-eof",
    abandonedHeadElementChild: "abandoned-head-element-child",
    misplacedStartTagForHeadElement: "misplaced-start-tag-for-head-element",
    nestedNoscriptInHead: "nested-noscript-in-head",
    eofInElementThatCanContainOnlyText: "eof-in-element-that-can-contain-only-text"
  }), Rm;
}
var Kl, Bm;
function BP() {
  if (Bm) return Kl;
  Bm = 1;
  const e = F0(), t = R0(), n = e.CODE_POINTS, r = 65536;
  class o {
    constructor() {
      this.html = null, this.pos = -1, this.lastGapPos = -1, this.lastCharPos = -1, this.gapStack = [], this.skipNextNewLine = !1, this.lastChunkWritten = !1, this.endOfChunkHit = !1, this.bufferWaterline = r;
    }
    _err() {
    }
    _addGap() {
      this.gapStack.push(this.lastGapPos), this.lastGapPos = this.pos;
    }
    _processSurrogate(a) {
      if (this.pos !== this.lastCharPos) {
        const s = this.html.charCodeAt(this.pos + 1);
        if (e.isSurrogatePair(s))
          return this.pos++, this._addGap(), e.getSurrogatePairCodePoint(a, s);
      } else if (!this.lastChunkWritten)
        return this.endOfChunkHit = !0, n.EOF;
      return this._err(t.surrogateInInputStream), a;
    }
    dropParsedChunk() {
      this.pos > this.bufferWaterline && (this.lastCharPos -= this.pos, this.html = this.html.substring(this.pos), this.pos = 0, this.lastGapPos = -1, this.gapStack = []);
    }
    write(a, s) {
      this.html ? this.html += a : this.html = a, this.lastCharPos = this.html.length - 1, this.endOfChunkHit = !1, this.lastChunkWritten = s;
    }
    insertHtmlAtCurrentPos(a) {
      this.html = this.html.substring(0, this.pos + 1) + a + this.html.substring(this.pos + 1, this.html.length), this.lastCharPos = this.html.length - 1, this.endOfChunkHit = !1;
    }
    advance() {
      if (this.pos++, this.pos > this.lastCharPos)
        return this.endOfChunkHit = !this.lastChunkWritten, n.EOF;
      let a = this.html.charCodeAt(this.pos);
      return this.skipNextNewLine && a === n.LINE_FEED ? (this.skipNextNewLine = !1, this._addGap(), this.advance()) : a === n.CARRIAGE_RETURN ? (this.skipNextNewLine = !0, n.LINE_FEED) : (this.skipNextNewLine = !1, e.isSurrogate(a) && (a = this._processSurrogate(a)), a > 31 && a < 127 || a === n.LINE_FEED || a === n.CARRIAGE_RETURN || a > 159 && a < 64976 || this._checkForProblematicCharacters(a), a);
    }
    _checkForProblematicCharacters(a) {
      e.isControlCodePoint(a) ? this._err(t.controlCharacterInInputStream) : e.isUndefinedCodePoint(a) && this._err(t.noncharacterInInputStream);
    }
    retreat() {
      this.pos === this.lastGapPos && (this.lastGapPos = this.gapStack.pop(), this.pos--), this.pos--;
    }
  }
  return Kl = o, Kl;
}
var jm, Um;
function jP() {
  return Um || (Um = 1, jm = new Uint16Array([4, 52, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 106, 303, 412, 810, 1432, 1701, 1796, 1987, 2114, 2360, 2420, 2484, 3170, 3251, 4140, 4393, 4575, 4610, 5106, 5512, 5728, 6117, 6274, 6315, 6345, 6427, 6516, 7002, 7910, 8733, 9323, 9870, 10170, 10631, 10893, 11318, 11386, 11467, 12773, 13092, 14474, 14922, 15448, 15542, 16419, 17666, 18166, 18611, 19004, 19095, 19298, 19397, 4, 16, 69, 77, 97, 98, 99, 102, 103, 108, 109, 110, 111, 112, 114, 115, 116, 117, 140, 150, 158, 169, 176, 194, 199, 210, 216, 222, 226, 242, 256, 266, 283, 294, 108, 105, 103, 5, 198, 1, 59, 148, 1, 198, 80, 5, 38, 1, 59, 156, 1, 38, 99, 117, 116, 101, 5, 193, 1, 59, 167, 1, 193, 114, 101, 118, 101, 59, 1, 258, 4, 2, 105, 121, 182, 191, 114, 99, 5, 194, 1, 59, 189, 1, 194, 59, 1, 1040, 114, 59, 3, 55349, 56580, 114, 97, 118, 101, 5, 192, 1, 59, 208, 1, 192, 112, 104, 97, 59, 1, 913, 97, 99, 114, 59, 1, 256, 100, 59, 1, 10835, 4, 2, 103, 112, 232, 237, 111, 110, 59, 1, 260, 102, 59, 3, 55349, 56632, 112, 108, 121, 70, 117, 110, 99, 116, 105, 111, 110, 59, 1, 8289, 105, 110, 103, 5, 197, 1, 59, 264, 1, 197, 4, 2, 99, 115, 272, 277, 114, 59, 3, 55349, 56476, 105, 103, 110, 59, 1, 8788, 105, 108, 100, 101, 5, 195, 1, 59, 292, 1, 195, 109, 108, 5, 196, 1, 59, 301, 1, 196, 4, 8, 97, 99, 101, 102, 111, 114, 115, 117, 321, 350, 354, 383, 388, 394, 400, 405, 4, 2, 99, 114, 327, 336, 107, 115, 108, 97, 115, 104, 59, 1, 8726, 4, 2, 118, 119, 342, 345, 59, 1, 10983, 101, 100, 59, 1, 8966, 121, 59, 1, 1041, 4, 3, 99, 114, 116, 362, 369, 379, 97, 117, 115, 101, 59, 1, 8757, 110, 111, 117, 108, 108, 105, 115, 59, 1, 8492, 97, 59, 1, 914, 114, 59, 3, 55349, 56581, 112, 102, 59, 3, 55349, 56633, 101, 118, 101, 59, 1, 728, 99, 114, 59, 1, 8492, 109, 112, 101, 113, 59, 1, 8782, 4, 14, 72, 79, 97, 99, 100, 101, 102, 104, 105, 108, 111, 114, 115, 117, 442, 447, 456, 504, 542, 547, 569, 573, 577, 616, 678, 784, 790, 796, 99, 121, 59, 1, 1063, 80, 89, 5, 169, 1, 59, 454, 1, 169, 4, 3, 99, 112, 121, 464, 470, 497, 117, 116, 101, 59, 1, 262, 4, 2, 59, 105, 476, 478, 1, 8914, 116, 97, 108, 68, 105, 102, 102, 101, 114, 101, 110, 116, 105, 97, 108, 68, 59, 1, 8517, 108, 101, 121, 115, 59, 1, 8493, 4, 4, 97, 101, 105, 111, 514, 520, 530, 535, 114, 111, 110, 59, 1, 268, 100, 105, 108, 5, 199, 1, 59, 528, 1, 199, 114, 99, 59, 1, 264, 110, 105, 110, 116, 59, 1, 8752, 111, 116, 59, 1, 266, 4, 2, 100, 110, 553, 560, 105, 108, 108, 97, 59, 1, 184, 116, 101, 114, 68, 111, 116, 59, 1, 183, 114, 59, 1, 8493, 105, 59, 1, 935, 114, 99, 108, 101, 4, 4, 68, 77, 80, 84, 591, 596, 603, 609, 111, 116, 59, 1, 8857, 105, 110, 117, 115, 59, 1, 8854, 108, 117, 115, 59, 1, 8853, 105, 109, 101, 115, 59, 1, 8855, 111, 4, 2, 99, 115, 623, 646, 107, 119, 105, 115, 101, 67, 111, 110, 116, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 1, 8754, 101, 67, 117, 114, 108, 121, 4, 2, 68, 81, 658, 671, 111, 117, 98, 108, 101, 81, 117, 111, 116, 101, 59, 1, 8221, 117, 111, 116, 101, 59, 1, 8217, 4, 4, 108, 110, 112, 117, 688, 701, 736, 753, 111, 110, 4, 2, 59, 101, 696, 698, 1, 8759, 59, 1, 10868, 4, 3, 103, 105, 116, 709, 717, 722, 114, 117, 101, 110, 116, 59, 1, 8801, 110, 116, 59, 1, 8751, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 1, 8750, 4, 2, 102, 114, 742, 745, 59, 1, 8450, 111, 100, 117, 99, 116, 59, 1, 8720, 110, 116, 101, 114, 67, 108, 111, 99, 107, 119, 105, 115, 101, 67, 111, 110, 116, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 1, 8755, 111, 115, 115, 59, 1, 10799, 99, 114, 59, 3, 55349, 56478, 112, 4, 2, 59, 67, 803, 805, 1, 8915, 97, 112, 59, 1, 8781, 4, 11, 68, 74, 83, 90, 97, 99, 101, 102, 105, 111, 115, 834, 850, 855, 860, 865, 888, 903, 916, 921, 1011, 1415, 4, 2, 59, 111, 840, 842, 1, 8517, 116, 114, 97, 104, 100, 59, 1, 10513, 99, 121, 59, 1, 1026, 99, 121, 59, 1, 1029, 99, 121, 59, 1, 1039, 4, 3, 103, 114, 115, 873, 879, 883, 103, 101, 114, 59, 1, 8225, 114, 59, 1, 8609, 104, 118, 59, 1, 10980, 4, 2, 97, 121, 894, 900, 114, 111, 110, 59, 1, 270, 59, 1, 1044, 108, 4, 2, 59, 116, 910, 912, 1, 8711, 97, 59, 1, 916, 114, 59, 3, 55349, 56583, 4, 2, 97, 102, 927, 998, 4, 2, 99, 109, 933, 992, 114, 105, 116, 105, 99, 97, 108, 4, 4, 65, 68, 71, 84, 950, 957, 978, 985, 99, 117, 116, 101, 59, 1, 180, 111, 4, 2, 116, 117, 964, 967, 59, 1, 729, 98, 108, 101, 65, 99, 117, 116, 101, 59, 1, 733, 114, 97, 118, 101, 59, 1, 96, 105, 108, 100, 101, 59, 1, 732, 111, 110, 100, 59, 1, 8900, 102, 101, 114, 101, 110, 116, 105, 97, 108, 68, 59, 1, 8518, 4, 4, 112, 116, 117, 119, 1021, 1026, 1048, 1249, 102, 59, 3, 55349, 56635, 4, 3, 59, 68, 69, 1034, 1036, 1041, 1, 168, 111, 116, 59, 1, 8412, 113, 117, 97, 108, 59, 1, 8784, 98, 108, 101, 4, 6, 67, 68, 76, 82, 85, 86, 1065, 1082, 1101, 1189, 1211, 1236, 111, 110, 116, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 1, 8751, 111, 4, 2, 116, 119, 1089, 1092, 59, 1, 168, 110, 65, 114, 114, 111, 119, 59, 1, 8659, 4, 2, 101, 111, 1107, 1141, 102, 116, 4, 3, 65, 82, 84, 1117, 1124, 1136, 114, 114, 111, 119, 59, 1, 8656, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 8660, 101, 101, 59, 1, 10980, 110, 103, 4, 2, 76, 82, 1149, 1177, 101, 102, 116, 4, 2, 65, 82, 1158, 1165, 114, 114, 111, 119, 59, 1, 10232, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 10234, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 10233, 105, 103, 104, 116, 4, 2, 65, 84, 1199, 1206, 114, 114, 111, 119, 59, 1, 8658, 101, 101, 59, 1, 8872, 112, 4, 2, 65, 68, 1218, 1225, 114, 114, 111, 119, 59, 1, 8657, 111, 119, 110, 65, 114, 114, 111, 119, 59, 1, 8661, 101, 114, 116, 105, 99, 97, 108, 66, 97, 114, 59, 1, 8741, 110, 4, 6, 65, 66, 76, 82, 84, 97, 1264, 1292, 1299, 1352, 1391, 1408, 114, 114, 111, 119, 4, 3, 59, 66, 85, 1276, 1278, 1283, 1, 8595, 97, 114, 59, 1, 10515, 112, 65, 114, 114, 111, 119, 59, 1, 8693, 114, 101, 118, 101, 59, 1, 785, 101, 102, 116, 4, 3, 82, 84, 86, 1310, 1323, 1334, 105, 103, 104, 116, 86, 101, 99, 116, 111, 114, 59, 1, 10576, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10590, 101, 99, 116, 111, 114, 4, 2, 59, 66, 1345, 1347, 1, 8637, 97, 114, 59, 1, 10582, 105, 103, 104, 116, 4, 2, 84, 86, 1362, 1373, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10591, 101, 99, 116, 111, 114, 4, 2, 59, 66, 1384, 1386, 1, 8641, 97, 114, 59, 1, 10583, 101, 101, 4, 2, 59, 65, 1399, 1401, 1, 8868, 114, 114, 111, 119, 59, 1, 8615, 114, 114, 111, 119, 59, 1, 8659, 4, 2, 99, 116, 1421, 1426, 114, 59, 3, 55349, 56479, 114, 111, 107, 59, 1, 272, 4, 16, 78, 84, 97, 99, 100, 102, 103, 108, 109, 111, 112, 113, 115, 116, 117, 120, 1466, 1470, 1478, 1489, 1515, 1520, 1525, 1536, 1544, 1593, 1609, 1617, 1650, 1664, 1668, 1677, 71, 59, 1, 330, 72, 5, 208, 1, 59, 1476, 1, 208, 99, 117, 116, 101, 5, 201, 1, 59, 1487, 1, 201, 4, 3, 97, 105, 121, 1497, 1503, 1512, 114, 111, 110, 59, 1, 282, 114, 99, 5, 202, 1, 59, 1510, 1, 202, 59, 1, 1069, 111, 116, 59, 1, 278, 114, 59, 3, 55349, 56584, 114, 97, 118, 101, 5, 200, 1, 59, 1534, 1, 200, 101, 109, 101, 110, 116, 59, 1, 8712, 4, 2, 97, 112, 1550, 1555, 99, 114, 59, 1, 274, 116, 121, 4, 2, 83, 86, 1563, 1576, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 1, 9723, 101, 114, 121, 83, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 1, 9643, 4, 2, 103, 112, 1599, 1604, 111, 110, 59, 1, 280, 102, 59, 3, 55349, 56636, 115, 105, 108, 111, 110, 59, 1, 917, 117, 4, 2, 97, 105, 1624, 1640, 108, 4, 2, 59, 84, 1631, 1633, 1, 10869, 105, 108, 100, 101, 59, 1, 8770, 108, 105, 98, 114, 105, 117, 109, 59, 1, 8652, 4, 2, 99, 105, 1656, 1660, 114, 59, 1, 8496, 109, 59, 1, 10867, 97, 59, 1, 919, 109, 108, 5, 203, 1, 59, 1675, 1, 203, 4, 2, 105, 112, 1683, 1689, 115, 116, 115, 59, 1, 8707, 111, 110, 101, 110, 116, 105, 97, 108, 69, 59, 1, 8519, 4, 5, 99, 102, 105, 111, 115, 1713, 1717, 1722, 1762, 1791, 121, 59, 1, 1060, 114, 59, 3, 55349, 56585, 108, 108, 101, 100, 4, 2, 83, 86, 1732, 1745, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 1, 9724, 101, 114, 121, 83, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 1, 9642, 4, 3, 112, 114, 117, 1770, 1775, 1781, 102, 59, 3, 55349, 56637, 65, 108, 108, 59, 1, 8704, 114, 105, 101, 114, 116, 114, 102, 59, 1, 8497, 99, 114, 59, 1, 8497, 4, 12, 74, 84, 97, 98, 99, 100, 102, 103, 111, 114, 115, 116, 1822, 1827, 1834, 1848, 1855, 1877, 1882, 1887, 1890, 1896, 1978, 1984, 99, 121, 59, 1, 1027, 5, 62, 1, 59, 1832, 1, 62, 109, 109, 97, 4, 2, 59, 100, 1843, 1845, 1, 915, 59, 1, 988, 114, 101, 118, 101, 59, 1, 286, 4, 3, 101, 105, 121, 1863, 1869, 1874, 100, 105, 108, 59, 1, 290, 114, 99, 59, 1, 284, 59, 1, 1043, 111, 116, 59, 1, 288, 114, 59, 3, 55349, 56586, 59, 1, 8921, 112, 102, 59, 3, 55349, 56638, 101, 97, 116, 101, 114, 4, 6, 69, 70, 71, 76, 83, 84, 1915, 1933, 1944, 1953, 1959, 1971, 113, 117, 97, 108, 4, 2, 59, 76, 1925, 1927, 1, 8805, 101, 115, 115, 59, 1, 8923, 117, 108, 108, 69, 113, 117, 97, 108, 59, 1, 8807, 114, 101, 97, 116, 101, 114, 59, 1, 10914, 101, 115, 115, 59, 1, 8823, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 10878, 105, 108, 100, 101, 59, 1, 8819, 99, 114, 59, 3, 55349, 56482, 59, 1, 8811, 4, 8, 65, 97, 99, 102, 105, 111, 115, 117, 2005, 2012, 2026, 2032, 2036, 2049, 2073, 2089, 82, 68, 99, 121, 59, 1, 1066, 4, 2, 99, 116, 2018, 2023, 101, 107, 59, 1, 711, 59, 1, 94, 105, 114, 99, 59, 1, 292, 114, 59, 1, 8460, 108, 98, 101, 114, 116, 83, 112, 97, 99, 101, 59, 1, 8459, 4, 2, 112, 114, 2055, 2059, 102, 59, 1, 8461, 105, 122, 111, 110, 116, 97, 108, 76, 105, 110, 101, 59, 1, 9472, 4, 2, 99, 116, 2079, 2083, 114, 59, 1, 8459, 114, 111, 107, 59, 1, 294, 109, 112, 4, 2, 68, 69, 2097, 2107, 111, 119, 110, 72, 117, 109, 112, 59, 1, 8782, 113, 117, 97, 108, 59, 1, 8783, 4, 14, 69, 74, 79, 97, 99, 100, 102, 103, 109, 110, 111, 115, 116, 117, 2144, 2149, 2155, 2160, 2171, 2189, 2194, 2198, 2209, 2245, 2307, 2329, 2334, 2341, 99, 121, 59, 1, 1045, 108, 105, 103, 59, 1, 306, 99, 121, 59, 1, 1025, 99, 117, 116, 101, 5, 205, 1, 59, 2169, 1, 205, 4, 2, 105, 121, 2177, 2186, 114, 99, 5, 206, 1, 59, 2184, 1, 206, 59, 1, 1048, 111, 116, 59, 1, 304, 114, 59, 1, 8465, 114, 97, 118, 101, 5, 204, 1, 59, 2207, 1, 204, 4, 3, 59, 97, 112, 2217, 2219, 2238, 1, 8465, 4, 2, 99, 103, 2225, 2229, 114, 59, 1, 298, 105, 110, 97, 114, 121, 73, 59, 1, 8520, 108, 105, 101, 115, 59, 1, 8658, 4, 2, 116, 118, 2251, 2281, 4, 2, 59, 101, 2257, 2259, 1, 8748, 4, 2, 103, 114, 2265, 2271, 114, 97, 108, 59, 1, 8747, 115, 101, 99, 116, 105, 111, 110, 59, 1, 8898, 105, 115, 105, 98, 108, 101, 4, 2, 67, 84, 2293, 2300, 111, 109, 109, 97, 59, 1, 8291, 105, 109, 101, 115, 59, 1, 8290, 4, 3, 103, 112, 116, 2315, 2320, 2325, 111, 110, 59, 1, 302, 102, 59, 3, 55349, 56640, 97, 59, 1, 921, 99, 114, 59, 1, 8464, 105, 108, 100, 101, 59, 1, 296, 4, 2, 107, 109, 2347, 2352, 99, 121, 59, 1, 1030, 108, 5, 207, 1, 59, 2358, 1, 207, 4, 5, 99, 102, 111, 115, 117, 2372, 2386, 2391, 2397, 2414, 4, 2, 105, 121, 2378, 2383, 114, 99, 59, 1, 308, 59, 1, 1049, 114, 59, 3, 55349, 56589, 112, 102, 59, 3, 55349, 56641, 4, 2, 99, 101, 2403, 2408, 114, 59, 3, 55349, 56485, 114, 99, 121, 59, 1, 1032, 107, 99, 121, 59, 1, 1028, 4, 7, 72, 74, 97, 99, 102, 111, 115, 2436, 2441, 2446, 2452, 2467, 2472, 2478, 99, 121, 59, 1, 1061, 99, 121, 59, 1, 1036, 112, 112, 97, 59, 1, 922, 4, 2, 101, 121, 2458, 2464, 100, 105, 108, 59, 1, 310, 59, 1, 1050, 114, 59, 3, 55349, 56590, 112, 102, 59, 3, 55349, 56642, 99, 114, 59, 3, 55349, 56486, 4, 11, 74, 84, 97, 99, 101, 102, 108, 109, 111, 115, 116, 2508, 2513, 2520, 2562, 2585, 2981, 2986, 3004, 3011, 3146, 3167, 99, 121, 59, 1, 1033, 5, 60, 1, 59, 2518, 1, 60, 4, 5, 99, 109, 110, 112, 114, 2532, 2538, 2544, 2548, 2558, 117, 116, 101, 59, 1, 313, 98, 100, 97, 59, 1, 923, 103, 59, 1, 10218, 108, 97, 99, 101, 116, 114, 102, 59, 1, 8466, 114, 59, 1, 8606, 4, 3, 97, 101, 121, 2570, 2576, 2582, 114, 111, 110, 59, 1, 317, 100, 105, 108, 59, 1, 315, 59, 1, 1051, 4, 2, 102, 115, 2591, 2907, 116, 4, 10, 65, 67, 68, 70, 82, 84, 85, 86, 97, 114, 2614, 2663, 2672, 2728, 2735, 2760, 2820, 2870, 2888, 2895, 4, 2, 110, 114, 2620, 2633, 103, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 1, 10216, 114, 111, 119, 4, 3, 59, 66, 82, 2644, 2646, 2651, 1, 8592, 97, 114, 59, 1, 8676, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 8646, 101, 105, 108, 105, 110, 103, 59, 1, 8968, 111, 4, 2, 117, 119, 2679, 2692, 98, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 1, 10214, 110, 4, 2, 84, 86, 2699, 2710, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10593, 101, 99, 116, 111, 114, 4, 2, 59, 66, 2721, 2723, 1, 8643, 97, 114, 59, 1, 10585, 108, 111, 111, 114, 59, 1, 8970, 105, 103, 104, 116, 4, 2, 65, 86, 2745, 2752, 114, 114, 111, 119, 59, 1, 8596, 101, 99, 116, 111, 114, 59, 1, 10574, 4, 2, 101, 114, 2766, 2792, 101, 4, 3, 59, 65, 86, 2775, 2777, 2784, 1, 8867, 114, 114, 111, 119, 59, 1, 8612, 101, 99, 116, 111, 114, 59, 1, 10586, 105, 97, 110, 103, 108, 101, 4, 3, 59, 66, 69, 2806, 2808, 2813, 1, 8882, 97, 114, 59, 1, 10703, 113, 117, 97, 108, 59, 1, 8884, 112, 4, 3, 68, 84, 86, 2829, 2841, 2852, 111, 119, 110, 86, 101, 99, 116, 111, 114, 59, 1, 10577, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10592, 101, 99, 116, 111, 114, 4, 2, 59, 66, 2863, 2865, 1, 8639, 97, 114, 59, 1, 10584, 101, 99, 116, 111, 114, 4, 2, 59, 66, 2881, 2883, 1, 8636, 97, 114, 59, 1, 10578, 114, 114, 111, 119, 59, 1, 8656, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8660, 115, 4, 6, 69, 70, 71, 76, 83, 84, 2922, 2936, 2947, 2956, 2962, 2974, 113, 117, 97, 108, 71, 114, 101, 97, 116, 101, 114, 59, 1, 8922, 117, 108, 108, 69, 113, 117, 97, 108, 59, 1, 8806, 114, 101, 97, 116, 101, 114, 59, 1, 8822, 101, 115, 115, 59, 1, 10913, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 10877, 105, 108, 100, 101, 59, 1, 8818, 114, 59, 3, 55349, 56591, 4, 2, 59, 101, 2992, 2994, 1, 8920, 102, 116, 97, 114, 114, 111, 119, 59, 1, 8666, 105, 100, 111, 116, 59, 1, 319, 4, 3, 110, 112, 119, 3019, 3110, 3115, 103, 4, 4, 76, 82, 108, 114, 3030, 3058, 3070, 3098, 101, 102, 116, 4, 2, 65, 82, 3039, 3046, 114, 114, 111, 119, 59, 1, 10229, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 10231, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 10230, 101, 102, 116, 4, 2, 97, 114, 3079, 3086, 114, 114, 111, 119, 59, 1, 10232, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 10234, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 10233, 102, 59, 3, 55349, 56643, 101, 114, 4, 2, 76, 82, 3123, 3134, 101, 102, 116, 65, 114, 114, 111, 119, 59, 1, 8601, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 8600, 4, 3, 99, 104, 116, 3154, 3158, 3161, 114, 59, 1, 8466, 59, 1, 8624, 114, 111, 107, 59, 1, 321, 59, 1, 8810, 4, 8, 97, 99, 101, 102, 105, 111, 115, 117, 3188, 3192, 3196, 3222, 3227, 3237, 3243, 3248, 112, 59, 1, 10501, 121, 59, 1, 1052, 4, 2, 100, 108, 3202, 3213, 105, 117, 109, 83, 112, 97, 99, 101, 59, 1, 8287, 108, 105, 110, 116, 114, 102, 59, 1, 8499, 114, 59, 3, 55349, 56592, 110, 117, 115, 80, 108, 117, 115, 59, 1, 8723, 112, 102, 59, 3, 55349, 56644, 99, 114, 59, 1, 8499, 59, 1, 924, 4, 9, 74, 97, 99, 101, 102, 111, 115, 116, 117, 3271, 3276, 3283, 3306, 3422, 3427, 4120, 4126, 4137, 99, 121, 59, 1, 1034, 99, 117, 116, 101, 59, 1, 323, 4, 3, 97, 101, 121, 3291, 3297, 3303, 114, 111, 110, 59, 1, 327, 100, 105, 108, 59, 1, 325, 59, 1, 1053, 4, 3, 103, 115, 119, 3314, 3380, 3415, 97, 116, 105, 118, 101, 4, 3, 77, 84, 86, 3327, 3340, 3365, 101, 100, 105, 117, 109, 83, 112, 97, 99, 101, 59, 1, 8203, 104, 105, 4, 2, 99, 110, 3348, 3357, 107, 83, 112, 97, 99, 101, 59, 1, 8203, 83, 112, 97, 99, 101, 59, 1, 8203, 101, 114, 121, 84, 104, 105, 110, 83, 112, 97, 99, 101, 59, 1, 8203, 116, 101, 100, 4, 2, 71, 76, 3389, 3405, 114, 101, 97, 116, 101, 114, 71, 114, 101, 97, 116, 101, 114, 59, 1, 8811, 101, 115, 115, 76, 101, 115, 115, 59, 1, 8810, 76, 105, 110, 101, 59, 1, 10, 114, 59, 3, 55349, 56593, 4, 4, 66, 110, 112, 116, 3437, 3444, 3460, 3464, 114, 101, 97, 107, 59, 1, 8288, 66, 114, 101, 97, 107, 105, 110, 103, 83, 112, 97, 99, 101, 59, 1, 160, 102, 59, 1, 8469, 4, 13, 59, 67, 68, 69, 71, 72, 76, 78, 80, 82, 83, 84, 86, 3492, 3494, 3517, 3536, 3578, 3657, 3685, 3784, 3823, 3860, 3915, 4066, 4107, 1, 10988, 4, 2, 111, 117, 3500, 3510, 110, 103, 114, 117, 101, 110, 116, 59, 1, 8802, 112, 67, 97, 112, 59, 1, 8813, 111, 117, 98, 108, 101, 86, 101, 114, 116, 105, 99, 97, 108, 66, 97, 114, 59, 1, 8742, 4, 3, 108, 113, 120, 3544, 3552, 3571, 101, 109, 101, 110, 116, 59, 1, 8713, 117, 97, 108, 4, 2, 59, 84, 3561, 3563, 1, 8800, 105, 108, 100, 101, 59, 3, 8770, 824, 105, 115, 116, 115, 59, 1, 8708, 114, 101, 97, 116, 101, 114, 4, 7, 59, 69, 70, 71, 76, 83, 84, 3600, 3602, 3609, 3621, 3631, 3637, 3650, 1, 8815, 113, 117, 97, 108, 59, 1, 8817, 117, 108, 108, 69, 113, 117, 97, 108, 59, 3, 8807, 824, 114, 101, 97, 116, 101, 114, 59, 3, 8811, 824, 101, 115, 115, 59, 1, 8825, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 3, 10878, 824, 105, 108, 100, 101, 59, 1, 8821, 117, 109, 112, 4, 2, 68, 69, 3666, 3677, 111, 119, 110, 72, 117, 109, 112, 59, 3, 8782, 824, 113, 117, 97, 108, 59, 3, 8783, 824, 101, 4, 2, 102, 115, 3692, 3724, 116, 84, 114, 105, 97, 110, 103, 108, 101, 4, 3, 59, 66, 69, 3709, 3711, 3717, 1, 8938, 97, 114, 59, 3, 10703, 824, 113, 117, 97, 108, 59, 1, 8940, 115, 4, 6, 59, 69, 71, 76, 83, 84, 3739, 3741, 3748, 3757, 3764, 3777, 1, 8814, 113, 117, 97, 108, 59, 1, 8816, 114, 101, 97, 116, 101, 114, 59, 1, 8824, 101, 115, 115, 59, 3, 8810, 824, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 3, 10877, 824, 105, 108, 100, 101, 59, 1, 8820, 101, 115, 116, 101, 100, 4, 2, 71, 76, 3795, 3812, 114, 101, 97, 116, 101, 114, 71, 114, 101, 97, 116, 101, 114, 59, 3, 10914, 824, 101, 115, 115, 76, 101, 115, 115, 59, 3, 10913, 824, 114, 101, 99, 101, 100, 101, 115, 4, 3, 59, 69, 83, 3838, 3840, 3848, 1, 8832, 113, 117, 97, 108, 59, 3, 10927, 824, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 8928, 4, 2, 101, 105, 3866, 3881, 118, 101, 114, 115, 101, 69, 108, 101, 109, 101, 110, 116, 59, 1, 8716, 103, 104, 116, 84, 114, 105, 97, 110, 103, 108, 101, 4, 3, 59, 66, 69, 3900, 3902, 3908, 1, 8939, 97, 114, 59, 3, 10704, 824, 113, 117, 97, 108, 59, 1, 8941, 4, 2, 113, 117, 3921, 3973, 117, 97, 114, 101, 83, 117, 4, 2, 98, 112, 3933, 3952, 115, 101, 116, 4, 2, 59, 69, 3942, 3945, 3, 8847, 824, 113, 117, 97, 108, 59, 1, 8930, 101, 114, 115, 101, 116, 4, 2, 59, 69, 3963, 3966, 3, 8848, 824, 113, 117, 97, 108, 59, 1, 8931, 4, 3, 98, 99, 112, 3981, 4e3, 4045, 115, 101, 116, 4, 2, 59, 69, 3990, 3993, 3, 8834, 8402, 113, 117, 97, 108, 59, 1, 8840, 99, 101, 101, 100, 115, 4, 4, 59, 69, 83, 84, 4015, 4017, 4025, 4037, 1, 8833, 113, 117, 97, 108, 59, 3, 10928, 824, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 8929, 105, 108, 100, 101, 59, 3, 8831, 824, 101, 114, 115, 101, 116, 4, 2, 59, 69, 4056, 4059, 3, 8835, 8402, 113, 117, 97, 108, 59, 1, 8841, 105, 108, 100, 101, 4, 4, 59, 69, 70, 84, 4080, 4082, 4089, 4100, 1, 8769, 113, 117, 97, 108, 59, 1, 8772, 117, 108, 108, 69, 113, 117, 97, 108, 59, 1, 8775, 105, 108, 100, 101, 59, 1, 8777, 101, 114, 116, 105, 99, 97, 108, 66, 97, 114, 59, 1, 8740, 99, 114, 59, 3, 55349, 56489, 105, 108, 100, 101, 5, 209, 1, 59, 4135, 1, 209, 59, 1, 925, 4, 14, 69, 97, 99, 100, 102, 103, 109, 111, 112, 114, 115, 116, 117, 118, 4170, 4176, 4187, 4205, 4212, 4217, 4228, 4253, 4259, 4292, 4295, 4316, 4337, 4346, 108, 105, 103, 59, 1, 338, 99, 117, 116, 101, 5, 211, 1, 59, 4185, 1, 211, 4, 2, 105, 121, 4193, 4202, 114, 99, 5, 212, 1, 59, 4200, 1, 212, 59, 1, 1054, 98, 108, 97, 99, 59, 1, 336, 114, 59, 3, 55349, 56594, 114, 97, 118, 101, 5, 210, 1, 59, 4226, 1, 210, 4, 3, 97, 101, 105, 4236, 4241, 4246, 99, 114, 59, 1, 332, 103, 97, 59, 1, 937, 99, 114, 111, 110, 59, 1, 927, 112, 102, 59, 3, 55349, 56646, 101, 110, 67, 117, 114, 108, 121, 4, 2, 68, 81, 4272, 4285, 111, 117, 98, 108, 101, 81, 117, 111, 116, 101, 59, 1, 8220, 117, 111, 116, 101, 59, 1, 8216, 59, 1, 10836, 4, 2, 99, 108, 4301, 4306, 114, 59, 3, 55349, 56490, 97, 115, 104, 5, 216, 1, 59, 4314, 1, 216, 105, 4, 2, 108, 109, 4323, 4332, 100, 101, 5, 213, 1, 59, 4330, 1, 213, 101, 115, 59, 1, 10807, 109, 108, 5, 214, 1, 59, 4344, 1, 214, 101, 114, 4, 2, 66, 80, 4354, 4380, 4, 2, 97, 114, 4360, 4364, 114, 59, 1, 8254, 97, 99, 4, 2, 101, 107, 4372, 4375, 59, 1, 9182, 101, 116, 59, 1, 9140, 97, 114, 101, 110, 116, 104, 101, 115, 105, 115, 59, 1, 9180, 4, 9, 97, 99, 102, 104, 105, 108, 111, 114, 115, 4413, 4422, 4426, 4431, 4435, 4438, 4448, 4471, 4561, 114, 116, 105, 97, 108, 68, 59, 1, 8706, 121, 59, 1, 1055, 114, 59, 3, 55349, 56595, 105, 59, 1, 934, 59, 1, 928, 117, 115, 77, 105, 110, 117, 115, 59, 1, 177, 4, 2, 105, 112, 4454, 4467, 110, 99, 97, 114, 101, 112, 108, 97, 110, 101, 59, 1, 8460, 102, 59, 1, 8473, 4, 4, 59, 101, 105, 111, 4481, 4483, 4526, 4531, 1, 10939, 99, 101, 100, 101, 115, 4, 4, 59, 69, 83, 84, 4498, 4500, 4507, 4519, 1, 8826, 113, 117, 97, 108, 59, 1, 10927, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 8828, 105, 108, 100, 101, 59, 1, 8830, 109, 101, 59, 1, 8243, 4, 2, 100, 112, 4537, 4543, 117, 99, 116, 59, 1, 8719, 111, 114, 116, 105, 111, 110, 4, 2, 59, 97, 4555, 4557, 1, 8759, 108, 59, 1, 8733, 4, 2, 99, 105, 4567, 4572, 114, 59, 3, 55349, 56491, 59, 1, 936, 4, 4, 85, 102, 111, 115, 4585, 4594, 4599, 4604, 79, 84, 5, 34, 1, 59, 4592, 1, 34, 114, 59, 3, 55349, 56596, 112, 102, 59, 1, 8474, 99, 114, 59, 3, 55349, 56492, 4, 12, 66, 69, 97, 99, 101, 102, 104, 105, 111, 114, 115, 117, 4636, 4642, 4650, 4681, 4704, 4763, 4767, 4771, 5047, 5069, 5081, 5094, 97, 114, 114, 59, 1, 10512, 71, 5, 174, 1, 59, 4648, 1, 174, 4, 3, 99, 110, 114, 4658, 4664, 4668, 117, 116, 101, 59, 1, 340, 103, 59, 1, 10219, 114, 4, 2, 59, 116, 4675, 4677, 1, 8608, 108, 59, 1, 10518, 4, 3, 97, 101, 121, 4689, 4695, 4701, 114, 111, 110, 59, 1, 344, 100, 105, 108, 59, 1, 342, 59, 1, 1056, 4, 2, 59, 118, 4710, 4712, 1, 8476, 101, 114, 115, 101, 4, 2, 69, 85, 4722, 4748, 4, 2, 108, 113, 4728, 4736, 101, 109, 101, 110, 116, 59, 1, 8715, 117, 105, 108, 105, 98, 114, 105, 117, 109, 59, 1, 8651, 112, 69, 113, 117, 105, 108, 105, 98, 114, 105, 117, 109, 59, 1, 10607, 114, 59, 1, 8476, 111, 59, 1, 929, 103, 104, 116, 4, 8, 65, 67, 68, 70, 84, 85, 86, 97, 4792, 4840, 4849, 4905, 4912, 4972, 5022, 5040, 4, 2, 110, 114, 4798, 4811, 103, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 1, 10217, 114, 111, 119, 4, 3, 59, 66, 76, 4822, 4824, 4829, 1, 8594, 97, 114, 59, 1, 8677, 101, 102, 116, 65, 114, 114, 111, 119, 59, 1, 8644, 101, 105, 108, 105, 110, 103, 59, 1, 8969, 111, 4, 2, 117, 119, 4856, 4869, 98, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 1, 10215, 110, 4, 2, 84, 86, 4876, 4887, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10589, 101, 99, 116, 111, 114, 4, 2, 59, 66, 4898, 4900, 1, 8642, 97, 114, 59, 1, 10581, 108, 111, 111, 114, 59, 1, 8971, 4, 2, 101, 114, 4918, 4944, 101, 4, 3, 59, 65, 86, 4927, 4929, 4936, 1, 8866, 114, 114, 111, 119, 59, 1, 8614, 101, 99, 116, 111, 114, 59, 1, 10587, 105, 97, 110, 103, 108, 101, 4, 3, 59, 66, 69, 4958, 4960, 4965, 1, 8883, 97, 114, 59, 1, 10704, 113, 117, 97, 108, 59, 1, 8885, 112, 4, 3, 68, 84, 86, 4981, 4993, 5004, 111, 119, 110, 86, 101, 99, 116, 111, 114, 59, 1, 10575, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10588, 101, 99, 116, 111, 114, 4, 2, 59, 66, 5015, 5017, 1, 8638, 97, 114, 59, 1, 10580, 101, 99, 116, 111, 114, 4, 2, 59, 66, 5033, 5035, 1, 8640, 97, 114, 59, 1, 10579, 114, 114, 111, 119, 59, 1, 8658, 4, 2, 112, 117, 5053, 5057, 102, 59, 1, 8477, 110, 100, 73, 109, 112, 108, 105, 101, 115, 59, 1, 10608, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8667, 4, 2, 99, 104, 5087, 5091, 114, 59, 1, 8475, 59, 1, 8625, 108, 101, 68, 101, 108, 97, 121, 101, 100, 59, 1, 10740, 4, 13, 72, 79, 97, 99, 102, 104, 105, 109, 111, 113, 115, 116, 117, 5134, 5150, 5157, 5164, 5198, 5203, 5259, 5265, 5277, 5283, 5374, 5380, 5385, 4, 2, 67, 99, 5140, 5146, 72, 99, 121, 59, 1, 1065, 121, 59, 1, 1064, 70, 84, 99, 121, 59, 1, 1068, 99, 117, 116, 101, 59, 1, 346, 4, 5, 59, 97, 101, 105, 121, 5176, 5178, 5184, 5190, 5195, 1, 10940, 114, 111, 110, 59, 1, 352, 100, 105, 108, 59, 1, 350, 114, 99, 59, 1, 348, 59, 1, 1057, 114, 59, 3, 55349, 56598, 111, 114, 116, 4, 4, 68, 76, 82, 85, 5216, 5227, 5238, 5250, 111, 119, 110, 65, 114, 114, 111, 119, 59, 1, 8595, 101, 102, 116, 65, 114, 114, 111, 119, 59, 1, 8592, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 8594, 112, 65, 114, 114, 111, 119, 59, 1, 8593, 103, 109, 97, 59, 1, 931, 97, 108, 108, 67, 105, 114, 99, 108, 101, 59, 1, 8728, 112, 102, 59, 3, 55349, 56650, 4, 2, 114, 117, 5289, 5293, 116, 59, 1, 8730, 97, 114, 101, 4, 4, 59, 73, 83, 85, 5306, 5308, 5322, 5367, 1, 9633, 110, 116, 101, 114, 115, 101, 99, 116, 105, 111, 110, 59, 1, 8851, 117, 4, 2, 98, 112, 5329, 5347, 115, 101, 116, 4, 2, 59, 69, 5338, 5340, 1, 8847, 113, 117, 97, 108, 59, 1, 8849, 101, 114, 115, 101, 116, 4, 2, 59, 69, 5358, 5360, 1, 8848, 113, 117, 97, 108, 59, 1, 8850, 110, 105, 111, 110, 59, 1, 8852, 99, 114, 59, 3, 55349, 56494, 97, 114, 59, 1, 8902, 4, 4, 98, 99, 109, 112, 5395, 5420, 5475, 5478, 4, 2, 59, 115, 5401, 5403, 1, 8912, 101, 116, 4, 2, 59, 69, 5411, 5413, 1, 8912, 113, 117, 97, 108, 59, 1, 8838, 4, 2, 99, 104, 5426, 5468, 101, 101, 100, 115, 4, 4, 59, 69, 83, 84, 5440, 5442, 5449, 5461, 1, 8827, 113, 117, 97, 108, 59, 1, 10928, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 8829, 105, 108, 100, 101, 59, 1, 8831, 84, 104, 97, 116, 59, 1, 8715, 59, 1, 8721, 4, 3, 59, 101, 115, 5486, 5488, 5507, 1, 8913, 114, 115, 101, 116, 4, 2, 59, 69, 5498, 5500, 1, 8835, 113, 117, 97, 108, 59, 1, 8839, 101, 116, 59, 1, 8913, 4, 11, 72, 82, 83, 97, 99, 102, 104, 105, 111, 114, 115, 5536, 5546, 5552, 5567, 5579, 5602, 5607, 5655, 5695, 5701, 5711, 79, 82, 78, 5, 222, 1, 59, 5544, 1, 222, 65, 68, 69, 59, 1, 8482, 4, 2, 72, 99, 5558, 5563, 99, 121, 59, 1, 1035, 121, 59, 1, 1062, 4, 2, 98, 117, 5573, 5576, 59, 1, 9, 59, 1, 932, 4, 3, 97, 101, 121, 5587, 5593, 5599, 114, 111, 110, 59, 1, 356, 100, 105, 108, 59, 1, 354, 59, 1, 1058, 114, 59, 3, 55349, 56599, 4, 2, 101, 105, 5613, 5631, 4, 2, 114, 116, 5619, 5627, 101, 102, 111, 114, 101, 59, 1, 8756, 97, 59, 1, 920, 4, 2, 99, 110, 5637, 5647, 107, 83, 112, 97, 99, 101, 59, 3, 8287, 8202, 83, 112, 97, 99, 101, 59, 1, 8201, 108, 100, 101, 4, 4, 59, 69, 70, 84, 5668, 5670, 5677, 5688, 1, 8764, 113, 117, 97, 108, 59, 1, 8771, 117, 108, 108, 69, 113, 117, 97, 108, 59, 1, 8773, 105, 108, 100, 101, 59, 1, 8776, 112, 102, 59, 3, 55349, 56651, 105, 112, 108, 101, 68, 111, 116, 59, 1, 8411, 4, 2, 99, 116, 5717, 5722, 114, 59, 3, 55349, 56495, 114, 111, 107, 59, 1, 358, 4, 14, 97, 98, 99, 100, 102, 103, 109, 110, 111, 112, 114, 115, 116, 117, 5758, 5789, 5805, 5823, 5830, 5835, 5846, 5852, 5921, 5937, 6089, 6095, 6101, 6108, 4, 2, 99, 114, 5764, 5774, 117, 116, 101, 5, 218, 1, 59, 5772, 1, 218, 114, 4, 2, 59, 111, 5781, 5783, 1, 8607, 99, 105, 114, 59, 1, 10569, 114, 4, 2, 99, 101, 5796, 5800, 121, 59, 1, 1038, 118, 101, 59, 1, 364, 4, 2, 105, 121, 5811, 5820, 114, 99, 5, 219, 1, 59, 5818, 1, 219, 59, 1, 1059, 98, 108, 97, 99, 59, 1, 368, 114, 59, 3, 55349, 56600, 114, 97, 118, 101, 5, 217, 1, 59, 5844, 1, 217, 97, 99, 114, 59, 1, 362, 4, 2, 100, 105, 5858, 5905, 101, 114, 4, 2, 66, 80, 5866, 5892, 4, 2, 97, 114, 5872, 5876, 114, 59, 1, 95, 97, 99, 4, 2, 101, 107, 5884, 5887, 59, 1, 9183, 101, 116, 59, 1, 9141, 97, 114, 101, 110, 116, 104, 101, 115, 105, 115, 59, 1, 9181, 111, 110, 4, 2, 59, 80, 5913, 5915, 1, 8899, 108, 117, 115, 59, 1, 8846, 4, 2, 103, 112, 5927, 5932, 111, 110, 59, 1, 370, 102, 59, 3, 55349, 56652, 4, 8, 65, 68, 69, 84, 97, 100, 112, 115, 5955, 5985, 5996, 6009, 6026, 6033, 6044, 6075, 114, 114, 111, 119, 4, 3, 59, 66, 68, 5967, 5969, 5974, 1, 8593, 97, 114, 59, 1, 10514, 111, 119, 110, 65, 114, 114, 111, 119, 59, 1, 8645, 111, 119, 110, 65, 114, 114, 111, 119, 59, 1, 8597, 113, 117, 105, 108, 105, 98, 114, 105, 117, 109, 59, 1, 10606, 101, 101, 4, 2, 59, 65, 6017, 6019, 1, 8869, 114, 114, 111, 119, 59, 1, 8613, 114, 114, 111, 119, 59, 1, 8657, 111, 119, 110, 97, 114, 114, 111, 119, 59, 1, 8661, 101, 114, 4, 2, 76, 82, 6052, 6063, 101, 102, 116, 65, 114, 114, 111, 119, 59, 1, 8598, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 8599, 105, 4, 2, 59, 108, 6082, 6084, 1, 978, 111, 110, 59, 1, 933, 105, 110, 103, 59, 1, 366, 99, 114, 59, 3, 55349, 56496, 105, 108, 100, 101, 59, 1, 360, 109, 108, 5, 220, 1, 59, 6115, 1, 220, 4, 9, 68, 98, 99, 100, 101, 102, 111, 115, 118, 6137, 6143, 6148, 6152, 6166, 6250, 6255, 6261, 6267, 97, 115, 104, 59, 1, 8875, 97, 114, 59, 1, 10987, 121, 59, 1, 1042, 97, 115, 104, 4, 2, 59, 108, 6161, 6163, 1, 8873, 59, 1, 10982, 4, 2, 101, 114, 6172, 6175, 59, 1, 8897, 4, 3, 98, 116, 121, 6183, 6188, 6238, 97, 114, 59, 1, 8214, 4, 2, 59, 105, 6194, 6196, 1, 8214, 99, 97, 108, 4, 4, 66, 76, 83, 84, 6209, 6214, 6220, 6231, 97, 114, 59, 1, 8739, 105, 110, 101, 59, 1, 124, 101, 112, 97, 114, 97, 116, 111, 114, 59, 1, 10072, 105, 108, 100, 101, 59, 1, 8768, 84, 104, 105, 110, 83, 112, 97, 99, 101, 59, 1, 8202, 114, 59, 3, 55349, 56601, 112, 102, 59, 3, 55349, 56653, 99, 114, 59, 3, 55349, 56497, 100, 97, 115, 104, 59, 1, 8874, 4, 5, 99, 101, 102, 111, 115, 6286, 6292, 6298, 6303, 6309, 105, 114, 99, 59, 1, 372, 100, 103, 101, 59, 1, 8896, 114, 59, 3, 55349, 56602, 112, 102, 59, 3, 55349, 56654, 99, 114, 59, 3, 55349, 56498, 4, 4, 102, 105, 111, 115, 6325, 6330, 6333, 6339, 114, 59, 3, 55349, 56603, 59, 1, 926, 112, 102, 59, 3, 55349, 56655, 99, 114, 59, 3, 55349, 56499, 4, 9, 65, 73, 85, 97, 99, 102, 111, 115, 117, 6365, 6370, 6375, 6380, 6391, 6405, 6410, 6416, 6422, 99, 121, 59, 1, 1071, 99, 121, 59, 1, 1031, 99, 121, 59, 1, 1070, 99, 117, 116, 101, 5, 221, 1, 59, 6389, 1, 221, 4, 2, 105, 121, 6397, 6402, 114, 99, 59, 1, 374, 59, 1, 1067, 114, 59, 3, 55349, 56604, 112, 102, 59, 3, 55349, 56656, 99, 114, 59, 3, 55349, 56500, 109, 108, 59, 1, 376, 4, 8, 72, 97, 99, 100, 101, 102, 111, 115, 6445, 6450, 6457, 6472, 6477, 6501, 6505, 6510, 99, 121, 59, 1, 1046, 99, 117, 116, 101, 59, 1, 377, 4, 2, 97, 121, 6463, 6469, 114, 111, 110, 59, 1, 381, 59, 1, 1047, 111, 116, 59, 1, 379, 4, 2, 114, 116, 6483, 6497, 111, 87, 105, 100, 116, 104, 83, 112, 97, 99, 101, 59, 1, 8203, 97, 59, 1, 918, 114, 59, 1, 8488, 112, 102, 59, 1, 8484, 99, 114, 59, 3, 55349, 56501, 4, 16, 97, 98, 99, 101, 102, 103, 108, 109, 110, 111, 112, 114, 115, 116, 117, 119, 6550, 6561, 6568, 6612, 6622, 6634, 6645, 6672, 6699, 6854, 6870, 6923, 6933, 6963, 6974, 6983, 99, 117, 116, 101, 5, 225, 1, 59, 6559, 1, 225, 114, 101, 118, 101, 59, 1, 259, 4, 6, 59, 69, 100, 105, 117, 121, 6582, 6584, 6588, 6591, 6600, 6609, 1, 8766, 59, 3, 8766, 819, 59, 1, 8767, 114, 99, 5, 226, 1, 59, 6598, 1, 226, 116, 101, 5, 180, 1, 59, 6607, 1, 180, 59, 1, 1072, 108, 105, 103, 5, 230, 1, 59, 6620, 1, 230, 4, 2, 59, 114, 6628, 6630, 1, 8289, 59, 3, 55349, 56606, 114, 97, 118, 101, 5, 224, 1, 59, 6643, 1, 224, 4, 2, 101, 112, 6651, 6667, 4, 2, 102, 112, 6657, 6663, 115, 121, 109, 59, 1, 8501, 104, 59, 1, 8501, 104, 97, 59, 1, 945, 4, 2, 97, 112, 6678, 6692, 4, 2, 99, 108, 6684, 6688, 114, 59, 1, 257, 103, 59, 1, 10815, 5, 38, 1, 59, 6697, 1, 38, 4, 2, 100, 103, 6705, 6737, 4, 5, 59, 97, 100, 115, 118, 6717, 6719, 6724, 6727, 6734, 1, 8743, 110, 100, 59, 1, 10837, 59, 1, 10844, 108, 111, 112, 101, 59, 1, 10840, 59, 1, 10842, 4, 7, 59, 101, 108, 109, 114, 115, 122, 6753, 6755, 6758, 6762, 6814, 6835, 6848, 1, 8736, 59, 1, 10660, 101, 59, 1, 8736, 115, 100, 4, 2, 59, 97, 6770, 6772, 1, 8737, 4, 8, 97, 98, 99, 100, 101, 102, 103, 104, 6790, 6793, 6796, 6799, 6802, 6805, 6808, 6811, 59, 1, 10664, 59, 1, 10665, 59, 1, 10666, 59, 1, 10667, 59, 1, 10668, 59, 1, 10669, 59, 1, 10670, 59, 1, 10671, 116, 4, 2, 59, 118, 6821, 6823, 1, 8735, 98, 4, 2, 59, 100, 6830, 6832, 1, 8894, 59, 1, 10653, 4, 2, 112, 116, 6841, 6845, 104, 59, 1, 8738, 59, 1, 197, 97, 114, 114, 59, 1, 9084, 4, 2, 103, 112, 6860, 6865, 111, 110, 59, 1, 261, 102, 59, 3, 55349, 56658, 4, 7, 59, 69, 97, 101, 105, 111, 112, 6886, 6888, 6891, 6897, 6900, 6904, 6908, 1, 8776, 59, 1, 10864, 99, 105, 114, 59, 1, 10863, 59, 1, 8778, 100, 59, 1, 8779, 115, 59, 1, 39, 114, 111, 120, 4, 2, 59, 101, 6917, 6919, 1, 8776, 113, 59, 1, 8778, 105, 110, 103, 5, 229, 1, 59, 6931, 1, 229, 4, 3, 99, 116, 121, 6941, 6946, 6949, 114, 59, 3, 55349, 56502, 59, 1, 42, 109, 112, 4, 2, 59, 101, 6957, 6959, 1, 8776, 113, 59, 1, 8781, 105, 108, 100, 101, 5, 227, 1, 59, 6972, 1, 227, 109, 108, 5, 228, 1, 59, 6981, 1, 228, 4, 2, 99, 105, 6989, 6997, 111, 110, 105, 110, 116, 59, 1, 8755, 110, 116, 59, 1, 10769, 4, 16, 78, 97, 98, 99, 100, 101, 102, 105, 107, 108, 110, 111, 112, 114, 115, 117, 7036, 7041, 7119, 7135, 7149, 7155, 7219, 7224, 7347, 7354, 7463, 7489, 7786, 7793, 7814, 7866, 111, 116, 59, 1, 10989, 4, 2, 99, 114, 7047, 7094, 107, 4, 4, 99, 101, 112, 115, 7058, 7064, 7073, 7080, 111, 110, 103, 59, 1, 8780, 112, 115, 105, 108, 111, 110, 59, 1, 1014, 114, 105, 109, 101, 59, 1, 8245, 105, 109, 4, 2, 59, 101, 7088, 7090, 1, 8765, 113, 59, 1, 8909, 4, 2, 118, 119, 7100, 7105, 101, 101, 59, 1, 8893, 101, 100, 4, 2, 59, 103, 7113, 7115, 1, 8965, 101, 59, 1, 8965, 114, 107, 4, 2, 59, 116, 7127, 7129, 1, 9141, 98, 114, 107, 59, 1, 9142, 4, 2, 111, 121, 7141, 7146, 110, 103, 59, 1, 8780, 59, 1, 1073, 113, 117, 111, 59, 1, 8222, 4, 5, 99, 109, 112, 114, 116, 7167, 7181, 7188, 7193, 7199, 97, 117, 115, 4, 2, 59, 101, 7176, 7178, 1, 8757, 59, 1, 8757, 112, 116, 121, 118, 59, 1, 10672, 115, 105, 59, 1, 1014, 110, 111, 117, 59, 1, 8492, 4, 3, 97, 104, 119, 7207, 7210, 7213, 59, 1, 946, 59, 1, 8502, 101, 101, 110, 59, 1, 8812, 114, 59, 3, 55349, 56607, 103, 4, 7, 99, 111, 115, 116, 117, 118, 119, 7241, 7262, 7288, 7305, 7328, 7335, 7340, 4, 3, 97, 105, 117, 7249, 7253, 7258, 112, 59, 1, 8898, 114, 99, 59, 1, 9711, 112, 59, 1, 8899, 4, 3, 100, 112, 116, 7270, 7275, 7281, 111, 116, 59, 1, 10752, 108, 117, 115, 59, 1, 10753, 105, 109, 101, 115, 59, 1, 10754, 4, 2, 113, 116, 7294, 7300, 99, 117, 112, 59, 1, 10758, 97, 114, 59, 1, 9733, 114, 105, 97, 110, 103, 108, 101, 4, 2, 100, 117, 7318, 7324, 111, 119, 110, 59, 1, 9661, 112, 59, 1, 9651, 112, 108, 117, 115, 59, 1, 10756, 101, 101, 59, 1, 8897, 101, 100, 103, 101, 59, 1, 8896, 97, 114, 111, 119, 59, 1, 10509, 4, 3, 97, 107, 111, 7362, 7436, 7458, 4, 2, 99, 110, 7368, 7432, 107, 4, 3, 108, 115, 116, 7377, 7386, 7394, 111, 122, 101, 110, 103, 101, 59, 1, 10731, 113, 117, 97, 114, 101, 59, 1, 9642, 114, 105, 97, 110, 103, 108, 101, 4, 4, 59, 100, 108, 114, 7411, 7413, 7419, 7425, 1, 9652, 111, 119, 110, 59, 1, 9662, 101, 102, 116, 59, 1, 9666, 105, 103, 104, 116, 59, 1, 9656, 107, 59, 1, 9251, 4, 2, 49, 51, 7442, 7454, 4, 2, 50, 52, 7448, 7451, 59, 1, 9618, 59, 1, 9617, 52, 59, 1, 9619, 99, 107, 59, 1, 9608, 4, 2, 101, 111, 7469, 7485, 4, 2, 59, 113, 7475, 7478, 3, 61, 8421, 117, 105, 118, 59, 3, 8801, 8421, 116, 59, 1, 8976, 4, 4, 112, 116, 119, 120, 7499, 7504, 7517, 7523, 102, 59, 3, 55349, 56659, 4, 2, 59, 116, 7510, 7512, 1, 8869, 111, 109, 59, 1, 8869, 116, 105, 101, 59, 1, 8904, 4, 12, 68, 72, 85, 86, 98, 100, 104, 109, 112, 116, 117, 118, 7549, 7571, 7597, 7619, 7655, 7660, 7682, 7708, 7715, 7721, 7728, 7750, 4, 4, 76, 82, 108, 114, 7559, 7562, 7565, 7568, 59, 1, 9559, 59, 1, 9556, 59, 1, 9558, 59, 1, 9555, 4, 5, 59, 68, 85, 100, 117, 7583, 7585, 7588, 7591, 7594, 1, 9552, 59, 1, 9574, 59, 1, 9577, 59, 1, 9572, 59, 1, 9575, 4, 4, 76, 82, 108, 114, 7607, 7610, 7613, 7616, 59, 1, 9565, 59, 1, 9562, 59, 1, 9564, 59, 1, 9561, 4, 7, 59, 72, 76, 82, 104, 108, 114, 7635, 7637, 7640, 7643, 7646, 7649, 7652, 1, 9553, 59, 1, 9580, 59, 1, 9571, 59, 1, 9568, 59, 1, 9579, 59, 1, 9570, 59, 1, 9567, 111, 120, 59, 1, 10697, 4, 4, 76, 82, 108, 114, 7670, 7673, 7676, 7679, 59, 1, 9557, 59, 1, 9554, 59, 1, 9488, 59, 1, 9484, 4, 5, 59, 68, 85, 100, 117, 7694, 7696, 7699, 7702, 7705, 1, 9472, 59, 1, 9573, 59, 1, 9576, 59, 1, 9516, 59, 1, 9524, 105, 110, 117, 115, 59, 1, 8863, 108, 117, 115, 59, 1, 8862, 105, 109, 101, 115, 59, 1, 8864, 4, 4, 76, 82, 108, 114, 7738, 7741, 7744, 7747, 59, 1, 9563, 59, 1, 9560, 59, 1, 9496, 59, 1, 9492, 4, 7, 59, 72, 76, 82, 104, 108, 114, 7766, 7768, 7771, 7774, 7777, 7780, 7783, 1, 9474, 59, 1, 9578, 59, 1, 9569, 59, 1, 9566, 59, 1, 9532, 59, 1, 9508, 59, 1, 9500, 114, 105, 109, 101, 59, 1, 8245, 4, 2, 101, 118, 7799, 7804, 118, 101, 59, 1, 728, 98, 97, 114, 5, 166, 1, 59, 7812, 1, 166, 4, 4, 99, 101, 105, 111, 7824, 7829, 7834, 7846, 114, 59, 3, 55349, 56503, 109, 105, 59, 1, 8271, 109, 4, 2, 59, 101, 7841, 7843, 1, 8765, 59, 1, 8909, 108, 4, 3, 59, 98, 104, 7855, 7857, 7860, 1, 92, 59, 1, 10693, 115, 117, 98, 59, 1, 10184, 4, 2, 108, 109, 7872, 7885, 108, 4, 2, 59, 101, 7879, 7881, 1, 8226, 116, 59, 1, 8226, 112, 4, 3, 59, 69, 101, 7894, 7896, 7899, 1, 8782, 59, 1, 10926, 4, 2, 59, 113, 7905, 7907, 1, 8783, 59, 1, 8783, 4, 15, 97, 99, 100, 101, 102, 104, 105, 108, 111, 114, 115, 116, 117, 119, 121, 7942, 8021, 8075, 8080, 8121, 8126, 8157, 8279, 8295, 8430, 8446, 8485, 8491, 8707, 8726, 4, 3, 99, 112, 114, 7950, 7956, 8007, 117, 116, 101, 59, 1, 263, 4, 6, 59, 97, 98, 99, 100, 115, 7970, 7972, 7977, 7984, 7998, 8003, 1, 8745, 110, 100, 59, 1, 10820, 114, 99, 117, 112, 59, 1, 10825, 4, 2, 97, 117, 7990, 7994, 112, 59, 1, 10827, 112, 59, 1, 10823, 111, 116, 59, 1, 10816, 59, 3, 8745, 65024, 4, 2, 101, 111, 8013, 8017, 116, 59, 1, 8257, 110, 59, 1, 711, 4, 4, 97, 101, 105, 117, 8031, 8046, 8056, 8061, 4, 2, 112, 114, 8037, 8041, 115, 59, 1, 10829, 111, 110, 59, 1, 269, 100, 105, 108, 5, 231, 1, 59, 8054, 1, 231, 114, 99, 59, 1, 265, 112, 115, 4, 2, 59, 115, 8069, 8071, 1, 10828, 109, 59, 1, 10832, 111, 116, 59, 1, 267, 4, 3, 100, 109, 110, 8088, 8097, 8104, 105, 108, 5, 184, 1, 59, 8095, 1, 184, 112, 116, 121, 118, 59, 1, 10674, 116, 5, 162, 2, 59, 101, 8112, 8114, 1, 162, 114, 100, 111, 116, 59, 1, 183, 114, 59, 3, 55349, 56608, 4, 3, 99, 101, 105, 8134, 8138, 8154, 121, 59, 1, 1095, 99, 107, 4, 2, 59, 109, 8146, 8148, 1, 10003, 97, 114, 107, 59, 1, 10003, 59, 1, 967, 114, 4, 7, 59, 69, 99, 101, 102, 109, 115, 8174, 8176, 8179, 8258, 8261, 8268, 8273, 1, 9675, 59, 1, 10691, 4, 3, 59, 101, 108, 8187, 8189, 8193, 1, 710, 113, 59, 1, 8791, 101, 4, 2, 97, 100, 8200, 8223, 114, 114, 111, 119, 4, 2, 108, 114, 8210, 8216, 101, 102, 116, 59, 1, 8634, 105, 103, 104, 116, 59, 1, 8635, 4, 5, 82, 83, 97, 99, 100, 8235, 8238, 8241, 8246, 8252, 59, 1, 174, 59, 1, 9416, 115, 116, 59, 1, 8859, 105, 114, 99, 59, 1, 8858, 97, 115, 104, 59, 1, 8861, 59, 1, 8791, 110, 105, 110, 116, 59, 1, 10768, 105, 100, 59, 1, 10991, 99, 105, 114, 59, 1, 10690, 117, 98, 115, 4, 2, 59, 117, 8288, 8290, 1, 9827, 105, 116, 59, 1, 9827, 4, 4, 108, 109, 110, 112, 8305, 8326, 8376, 8400, 111, 110, 4, 2, 59, 101, 8313, 8315, 1, 58, 4, 2, 59, 113, 8321, 8323, 1, 8788, 59, 1, 8788, 4, 2, 109, 112, 8332, 8344, 97, 4, 2, 59, 116, 8339, 8341, 1, 44, 59, 1, 64, 4, 3, 59, 102, 108, 8352, 8354, 8358, 1, 8705, 110, 59, 1, 8728, 101, 4, 2, 109, 120, 8365, 8371, 101, 110, 116, 59, 1, 8705, 101, 115, 59, 1, 8450, 4, 2, 103, 105, 8382, 8395, 4, 2, 59, 100, 8388, 8390, 1, 8773, 111, 116, 59, 1, 10861, 110, 116, 59, 1, 8750, 4, 3, 102, 114, 121, 8408, 8412, 8417, 59, 3, 55349, 56660, 111, 100, 59, 1, 8720, 5, 169, 2, 59, 115, 8424, 8426, 1, 169, 114, 59, 1, 8471, 4, 2, 97, 111, 8436, 8441, 114, 114, 59, 1, 8629, 115, 115, 59, 1, 10007, 4, 2, 99, 117, 8452, 8457, 114, 59, 3, 55349, 56504, 4, 2, 98, 112, 8463, 8474, 4, 2, 59, 101, 8469, 8471, 1, 10959, 59, 1, 10961, 4, 2, 59, 101, 8480, 8482, 1, 10960, 59, 1, 10962, 100, 111, 116, 59, 1, 8943, 4, 7, 100, 101, 108, 112, 114, 118, 119, 8507, 8522, 8536, 8550, 8600, 8697, 8702, 97, 114, 114, 4, 2, 108, 114, 8516, 8519, 59, 1, 10552, 59, 1, 10549, 4, 2, 112, 115, 8528, 8532, 114, 59, 1, 8926, 99, 59, 1, 8927, 97, 114, 114, 4, 2, 59, 112, 8545, 8547, 1, 8630, 59, 1, 10557, 4, 6, 59, 98, 99, 100, 111, 115, 8564, 8566, 8573, 8587, 8592, 8596, 1, 8746, 114, 99, 97, 112, 59, 1, 10824, 4, 2, 97, 117, 8579, 8583, 112, 59, 1, 10822, 112, 59, 1, 10826, 111, 116, 59, 1, 8845, 114, 59, 1, 10821, 59, 3, 8746, 65024, 4, 4, 97, 108, 114, 118, 8610, 8623, 8663, 8672, 114, 114, 4, 2, 59, 109, 8618, 8620, 1, 8631, 59, 1, 10556, 121, 4, 3, 101, 118, 119, 8632, 8651, 8656, 113, 4, 2, 112, 115, 8639, 8645, 114, 101, 99, 59, 1, 8926, 117, 99, 99, 59, 1, 8927, 101, 101, 59, 1, 8910, 101, 100, 103, 101, 59, 1, 8911, 101, 110, 5, 164, 1, 59, 8670, 1, 164, 101, 97, 114, 114, 111, 119, 4, 2, 108, 114, 8684, 8690, 101, 102, 116, 59, 1, 8630, 105, 103, 104, 116, 59, 1, 8631, 101, 101, 59, 1, 8910, 101, 100, 59, 1, 8911, 4, 2, 99, 105, 8713, 8721, 111, 110, 105, 110, 116, 59, 1, 8754, 110, 116, 59, 1, 8753, 108, 99, 116, 121, 59, 1, 9005, 4, 19, 65, 72, 97, 98, 99, 100, 101, 102, 104, 105, 106, 108, 111, 114, 115, 116, 117, 119, 122, 8773, 8778, 8783, 8821, 8839, 8854, 8887, 8914, 8930, 8944, 9036, 9041, 9058, 9197, 9227, 9258, 9281, 9297, 9305, 114, 114, 59, 1, 8659, 97, 114, 59, 1, 10597, 4, 4, 103, 108, 114, 115, 8793, 8799, 8805, 8809, 103, 101, 114, 59, 1, 8224, 101, 116, 104, 59, 1, 8504, 114, 59, 1, 8595, 104, 4, 2, 59, 118, 8816, 8818, 1, 8208, 59, 1, 8867, 4, 2, 107, 108, 8827, 8834, 97, 114, 111, 119, 59, 1, 10511, 97, 99, 59, 1, 733, 4, 2, 97, 121, 8845, 8851, 114, 111, 110, 59, 1, 271, 59, 1, 1076, 4, 3, 59, 97, 111, 8862, 8864, 8880, 1, 8518, 4, 2, 103, 114, 8870, 8876, 103, 101, 114, 59, 1, 8225, 114, 59, 1, 8650, 116, 115, 101, 113, 59, 1, 10871, 4, 3, 103, 108, 109, 8895, 8902, 8907, 5, 176, 1, 59, 8900, 1, 176, 116, 97, 59, 1, 948, 112, 116, 121, 118, 59, 1, 10673, 4, 2, 105, 114, 8920, 8926, 115, 104, 116, 59, 1, 10623, 59, 3, 55349, 56609, 97, 114, 4, 2, 108, 114, 8938, 8941, 59, 1, 8643, 59, 1, 8642, 4, 5, 97, 101, 103, 115, 118, 8956, 8986, 8989, 8996, 9001, 109, 4, 3, 59, 111, 115, 8965, 8967, 8983, 1, 8900, 110, 100, 4, 2, 59, 115, 8975, 8977, 1, 8900, 117, 105, 116, 59, 1, 9830, 59, 1, 9830, 59, 1, 168, 97, 109, 109, 97, 59, 1, 989, 105, 110, 59, 1, 8946, 4, 3, 59, 105, 111, 9009, 9011, 9031, 1, 247, 100, 101, 5, 247, 2, 59, 111, 9020, 9022, 1, 247, 110, 116, 105, 109, 101, 115, 59, 1, 8903, 110, 120, 59, 1, 8903, 99, 121, 59, 1, 1106, 99, 4, 2, 111, 114, 9048, 9053, 114, 110, 59, 1, 8990, 111, 112, 59, 1, 8973, 4, 5, 108, 112, 116, 117, 119, 9070, 9076, 9081, 9130, 9144, 108, 97, 114, 59, 1, 36, 102, 59, 3, 55349, 56661, 4, 5, 59, 101, 109, 112, 115, 9093, 9095, 9109, 9116, 9122, 1, 729, 113, 4, 2, 59, 100, 9102, 9104, 1, 8784, 111, 116, 59, 1, 8785, 105, 110, 117, 115, 59, 1, 8760, 108, 117, 115, 59, 1, 8724, 113, 117, 97, 114, 101, 59, 1, 8865, 98, 108, 101, 98, 97, 114, 119, 101, 100, 103, 101, 59, 1, 8966, 110, 4, 3, 97, 100, 104, 9153, 9160, 9172, 114, 114, 111, 119, 59, 1, 8595, 111, 119, 110, 97, 114, 114, 111, 119, 115, 59, 1, 8650, 97, 114, 112, 111, 111, 110, 4, 2, 108, 114, 9184, 9190, 101, 102, 116, 59, 1, 8643, 105, 103, 104, 116, 59, 1, 8642, 4, 2, 98, 99, 9203, 9211, 107, 97, 114, 111, 119, 59, 1, 10512, 4, 2, 111, 114, 9217, 9222, 114, 110, 59, 1, 8991, 111, 112, 59, 1, 8972, 4, 3, 99, 111, 116, 9235, 9248, 9252, 4, 2, 114, 121, 9241, 9245, 59, 3, 55349, 56505, 59, 1, 1109, 108, 59, 1, 10742, 114, 111, 107, 59, 1, 273, 4, 2, 100, 114, 9264, 9269, 111, 116, 59, 1, 8945, 105, 4, 2, 59, 102, 9276, 9278, 1, 9663, 59, 1, 9662, 4, 2, 97, 104, 9287, 9292, 114, 114, 59, 1, 8693, 97, 114, 59, 1, 10607, 97, 110, 103, 108, 101, 59, 1, 10662, 4, 2, 99, 105, 9311, 9315, 121, 59, 1, 1119, 103, 114, 97, 114, 114, 59, 1, 10239, 4, 18, 68, 97, 99, 100, 101, 102, 103, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 120, 9361, 9376, 9398, 9439, 9444, 9447, 9462, 9495, 9531, 9585, 9598, 9614, 9659, 9755, 9771, 9792, 9808, 9826, 4, 2, 68, 111, 9367, 9372, 111, 116, 59, 1, 10871, 116, 59, 1, 8785, 4, 2, 99, 115, 9382, 9392, 117, 116, 101, 5, 233, 1, 59, 9390, 1, 233, 116, 101, 114, 59, 1, 10862, 4, 4, 97, 105, 111, 121, 9408, 9414, 9430, 9436, 114, 111, 110, 59, 1, 283, 114, 4, 2, 59, 99, 9421, 9423, 1, 8790, 5, 234, 1, 59, 9428, 1, 234, 108, 111, 110, 59, 1, 8789, 59, 1, 1101, 111, 116, 59, 1, 279, 59, 1, 8519, 4, 2, 68, 114, 9453, 9458, 111, 116, 59, 1, 8786, 59, 3, 55349, 56610, 4, 3, 59, 114, 115, 9470, 9472, 9482, 1, 10906, 97, 118, 101, 5, 232, 1, 59, 9480, 1, 232, 4, 2, 59, 100, 9488, 9490, 1, 10902, 111, 116, 59, 1, 10904, 4, 4, 59, 105, 108, 115, 9505, 9507, 9515, 9518, 1, 10905, 110, 116, 101, 114, 115, 59, 1, 9191, 59, 1, 8467, 4, 2, 59, 100, 9524, 9526, 1, 10901, 111, 116, 59, 1, 10903, 4, 3, 97, 112, 115, 9539, 9544, 9564, 99, 114, 59, 1, 275, 116, 121, 4, 3, 59, 115, 118, 9554, 9556, 9561, 1, 8709, 101, 116, 59, 1, 8709, 59, 1, 8709, 112, 4, 2, 49, 59, 9571, 9583, 4, 2, 51, 52, 9577, 9580, 59, 1, 8196, 59, 1, 8197, 1, 8195, 4, 2, 103, 115, 9591, 9594, 59, 1, 331, 112, 59, 1, 8194, 4, 2, 103, 112, 9604, 9609, 111, 110, 59, 1, 281, 102, 59, 3, 55349, 56662, 4, 3, 97, 108, 115, 9622, 9635, 9640, 114, 4, 2, 59, 115, 9629, 9631, 1, 8917, 108, 59, 1, 10723, 117, 115, 59, 1, 10865, 105, 4, 3, 59, 108, 118, 9649, 9651, 9656, 1, 949, 111, 110, 59, 1, 949, 59, 1, 1013, 4, 4, 99, 115, 117, 118, 9669, 9686, 9716, 9747, 4, 2, 105, 111, 9675, 9680, 114, 99, 59, 1, 8790, 108, 111, 110, 59, 1, 8789, 4, 2, 105, 108, 9692, 9696, 109, 59, 1, 8770, 97, 110, 116, 4, 2, 103, 108, 9705, 9710, 116, 114, 59, 1, 10902, 101, 115, 115, 59, 1, 10901, 4, 3, 97, 101, 105, 9724, 9729, 9734, 108, 115, 59, 1, 61, 115, 116, 59, 1, 8799, 118, 4, 2, 59, 68, 9741, 9743, 1, 8801, 68, 59, 1, 10872, 112, 97, 114, 115, 108, 59, 1, 10725, 4, 2, 68, 97, 9761, 9766, 111, 116, 59, 1, 8787, 114, 114, 59, 1, 10609, 4, 3, 99, 100, 105, 9779, 9783, 9788, 114, 59, 1, 8495, 111, 116, 59, 1, 8784, 109, 59, 1, 8770, 4, 2, 97, 104, 9798, 9801, 59, 1, 951, 5, 240, 1, 59, 9806, 1, 240, 4, 2, 109, 114, 9814, 9822, 108, 5, 235, 1, 59, 9820, 1, 235, 111, 59, 1, 8364, 4, 3, 99, 105, 112, 9834, 9838, 9843, 108, 59, 1, 33, 115, 116, 59, 1, 8707, 4, 2, 101, 111, 9849, 9859, 99, 116, 97, 116, 105, 111, 110, 59, 1, 8496, 110, 101, 110, 116, 105, 97, 108, 101, 59, 1, 8519, 4, 12, 97, 99, 101, 102, 105, 106, 108, 110, 111, 112, 114, 115, 9896, 9910, 9914, 9921, 9954, 9960, 9967, 9989, 9994, 10027, 10036, 10164, 108, 108, 105, 110, 103, 100, 111, 116, 115, 101, 113, 59, 1, 8786, 121, 59, 1, 1092, 109, 97, 108, 101, 59, 1, 9792, 4, 3, 105, 108, 114, 9929, 9935, 9950, 108, 105, 103, 59, 1, 64259, 4, 2, 105, 108, 9941, 9945, 103, 59, 1, 64256, 105, 103, 59, 1, 64260, 59, 3, 55349, 56611, 108, 105, 103, 59, 1, 64257, 108, 105, 103, 59, 3, 102, 106, 4, 3, 97, 108, 116, 9975, 9979, 9984, 116, 59, 1, 9837, 105, 103, 59, 1, 64258, 110, 115, 59, 1, 9649, 111, 102, 59, 1, 402, 4, 2, 112, 114, 1e4, 10005, 102, 59, 3, 55349, 56663, 4, 2, 97, 107, 10011, 10016, 108, 108, 59, 1, 8704, 4, 2, 59, 118, 10022, 10024, 1, 8916, 59, 1, 10969, 97, 114, 116, 105, 110, 116, 59, 1, 10765, 4, 2, 97, 111, 10042, 10159, 4, 2, 99, 115, 10048, 10155, 4, 6, 49, 50, 51, 52, 53, 55, 10062, 10102, 10114, 10135, 10139, 10151, 4, 6, 50, 51, 52, 53, 54, 56, 10076, 10083, 10086, 10093, 10096, 10099, 5, 189, 1, 59, 10081, 1, 189, 59, 1, 8531, 5, 188, 1, 59, 10091, 1, 188, 59, 1, 8533, 59, 1, 8537, 59, 1, 8539, 4, 2, 51, 53, 10108, 10111, 59, 1, 8532, 59, 1, 8534, 4, 3, 52, 53, 56, 10122, 10129, 10132, 5, 190, 1, 59, 10127, 1, 190, 59, 1, 8535, 59, 1, 8540, 53, 59, 1, 8536, 4, 2, 54, 56, 10145, 10148, 59, 1, 8538, 59, 1, 8541, 56, 59, 1, 8542, 108, 59, 1, 8260, 119, 110, 59, 1, 8994, 99, 114, 59, 3, 55349, 56507, 4, 17, 69, 97, 98, 99, 100, 101, 102, 103, 105, 106, 108, 110, 111, 114, 115, 116, 118, 10206, 10217, 10247, 10254, 10268, 10273, 10358, 10363, 10374, 10380, 10385, 10406, 10458, 10464, 10470, 10497, 10610, 4, 2, 59, 108, 10212, 10214, 1, 8807, 59, 1, 10892, 4, 3, 99, 109, 112, 10225, 10231, 10244, 117, 116, 101, 59, 1, 501, 109, 97, 4, 2, 59, 100, 10239, 10241, 1, 947, 59, 1, 989, 59, 1, 10886, 114, 101, 118, 101, 59, 1, 287, 4, 2, 105, 121, 10260, 10265, 114, 99, 59, 1, 285, 59, 1, 1075, 111, 116, 59, 1, 289, 4, 4, 59, 108, 113, 115, 10283, 10285, 10288, 10308, 1, 8805, 59, 1, 8923, 4, 3, 59, 113, 115, 10296, 10298, 10301, 1, 8805, 59, 1, 8807, 108, 97, 110, 116, 59, 1, 10878, 4, 4, 59, 99, 100, 108, 10318, 10320, 10324, 10345, 1, 10878, 99, 59, 1, 10921, 111, 116, 4, 2, 59, 111, 10332, 10334, 1, 10880, 4, 2, 59, 108, 10340, 10342, 1, 10882, 59, 1, 10884, 4, 2, 59, 101, 10351, 10354, 3, 8923, 65024, 115, 59, 1, 10900, 114, 59, 3, 55349, 56612, 4, 2, 59, 103, 10369, 10371, 1, 8811, 59, 1, 8921, 109, 101, 108, 59, 1, 8503, 99, 121, 59, 1, 1107, 4, 4, 59, 69, 97, 106, 10395, 10397, 10400, 10403, 1, 8823, 59, 1, 10898, 59, 1, 10917, 59, 1, 10916, 4, 4, 69, 97, 101, 115, 10416, 10419, 10434, 10453, 59, 1, 8809, 112, 4, 2, 59, 112, 10426, 10428, 1, 10890, 114, 111, 120, 59, 1, 10890, 4, 2, 59, 113, 10440, 10442, 1, 10888, 4, 2, 59, 113, 10448, 10450, 1, 10888, 59, 1, 8809, 105, 109, 59, 1, 8935, 112, 102, 59, 3, 55349, 56664, 97, 118, 101, 59, 1, 96, 4, 2, 99, 105, 10476, 10480, 114, 59, 1, 8458, 109, 4, 3, 59, 101, 108, 10489, 10491, 10494, 1, 8819, 59, 1, 10894, 59, 1, 10896, 5, 62, 6, 59, 99, 100, 108, 113, 114, 10512, 10514, 10527, 10532, 10538, 10545, 1, 62, 4, 2, 99, 105, 10520, 10523, 59, 1, 10919, 114, 59, 1, 10874, 111, 116, 59, 1, 8919, 80, 97, 114, 59, 1, 10645, 117, 101, 115, 116, 59, 1, 10876, 4, 5, 97, 100, 101, 108, 115, 10557, 10574, 10579, 10599, 10605, 4, 2, 112, 114, 10563, 10570, 112, 114, 111, 120, 59, 1, 10886, 114, 59, 1, 10616, 111, 116, 59, 1, 8919, 113, 4, 2, 108, 113, 10586, 10592, 101, 115, 115, 59, 1, 8923, 108, 101, 115, 115, 59, 1, 10892, 101, 115, 115, 59, 1, 8823, 105, 109, 59, 1, 8819, 4, 2, 101, 110, 10616, 10626, 114, 116, 110, 101, 113, 113, 59, 3, 8809, 65024, 69, 59, 3, 8809, 65024, 4, 10, 65, 97, 98, 99, 101, 102, 107, 111, 115, 121, 10653, 10658, 10713, 10718, 10724, 10760, 10765, 10786, 10850, 10875, 114, 114, 59, 1, 8660, 4, 4, 105, 108, 109, 114, 10668, 10674, 10678, 10684, 114, 115, 112, 59, 1, 8202, 102, 59, 1, 189, 105, 108, 116, 59, 1, 8459, 4, 2, 100, 114, 10690, 10695, 99, 121, 59, 1, 1098, 4, 3, 59, 99, 119, 10703, 10705, 10710, 1, 8596, 105, 114, 59, 1, 10568, 59, 1, 8621, 97, 114, 59, 1, 8463, 105, 114, 99, 59, 1, 293, 4, 3, 97, 108, 114, 10732, 10748, 10754, 114, 116, 115, 4, 2, 59, 117, 10741, 10743, 1, 9829, 105, 116, 59, 1, 9829, 108, 105, 112, 59, 1, 8230, 99, 111, 110, 59, 1, 8889, 114, 59, 3, 55349, 56613, 115, 4, 2, 101, 119, 10772, 10779, 97, 114, 111, 119, 59, 1, 10533, 97, 114, 111, 119, 59, 1, 10534, 4, 5, 97, 109, 111, 112, 114, 10798, 10803, 10809, 10839, 10844, 114, 114, 59, 1, 8703, 116, 104, 116, 59, 1, 8763, 107, 4, 2, 108, 114, 10816, 10827, 101, 102, 116, 97, 114, 114, 111, 119, 59, 1, 8617, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8618, 102, 59, 3, 55349, 56665, 98, 97, 114, 59, 1, 8213, 4, 3, 99, 108, 116, 10858, 10863, 10869, 114, 59, 3, 55349, 56509, 97, 115, 104, 59, 1, 8463, 114, 111, 107, 59, 1, 295, 4, 2, 98, 112, 10881, 10887, 117, 108, 108, 59, 1, 8259, 104, 101, 110, 59, 1, 8208, 4, 15, 97, 99, 101, 102, 103, 105, 106, 109, 110, 111, 112, 113, 115, 116, 117, 10925, 10936, 10958, 10977, 10990, 11001, 11039, 11045, 11101, 11192, 11220, 11226, 11237, 11285, 11299, 99, 117, 116, 101, 5, 237, 1, 59, 10934, 1, 237, 4, 3, 59, 105, 121, 10944, 10946, 10955, 1, 8291, 114, 99, 5, 238, 1, 59, 10953, 1, 238, 59, 1, 1080, 4, 2, 99, 120, 10964, 10968, 121, 59, 1, 1077, 99, 108, 5, 161, 1, 59, 10975, 1, 161, 4, 2, 102, 114, 10983, 10986, 59, 1, 8660, 59, 3, 55349, 56614, 114, 97, 118, 101, 5, 236, 1, 59, 10999, 1, 236, 4, 4, 59, 105, 110, 111, 11011, 11013, 11028, 11034, 1, 8520, 4, 2, 105, 110, 11019, 11024, 110, 116, 59, 1, 10764, 116, 59, 1, 8749, 102, 105, 110, 59, 1, 10716, 116, 97, 59, 1, 8489, 108, 105, 103, 59, 1, 307, 4, 3, 97, 111, 112, 11053, 11092, 11096, 4, 3, 99, 103, 116, 11061, 11065, 11088, 114, 59, 1, 299, 4, 3, 101, 108, 112, 11073, 11076, 11082, 59, 1, 8465, 105, 110, 101, 59, 1, 8464, 97, 114, 116, 59, 1, 8465, 104, 59, 1, 305, 102, 59, 1, 8887, 101, 100, 59, 1, 437, 4, 5, 59, 99, 102, 111, 116, 11113, 11115, 11121, 11136, 11142, 1, 8712, 97, 114, 101, 59, 1, 8453, 105, 110, 4, 2, 59, 116, 11129, 11131, 1, 8734, 105, 101, 59, 1, 10717, 100, 111, 116, 59, 1, 305, 4, 5, 59, 99, 101, 108, 112, 11154, 11156, 11161, 11179, 11186, 1, 8747, 97, 108, 59, 1, 8890, 4, 2, 103, 114, 11167, 11173, 101, 114, 115, 59, 1, 8484, 99, 97, 108, 59, 1, 8890, 97, 114, 104, 107, 59, 1, 10775, 114, 111, 100, 59, 1, 10812, 4, 4, 99, 103, 112, 116, 11202, 11206, 11211, 11216, 121, 59, 1, 1105, 111, 110, 59, 1, 303, 102, 59, 3, 55349, 56666, 97, 59, 1, 953, 114, 111, 100, 59, 1, 10812, 117, 101, 115, 116, 5, 191, 1, 59, 11235, 1, 191, 4, 2, 99, 105, 11243, 11248, 114, 59, 3, 55349, 56510, 110, 4, 5, 59, 69, 100, 115, 118, 11261, 11263, 11266, 11271, 11282, 1, 8712, 59, 1, 8953, 111, 116, 59, 1, 8949, 4, 2, 59, 118, 11277, 11279, 1, 8948, 59, 1, 8947, 59, 1, 8712, 4, 2, 59, 105, 11291, 11293, 1, 8290, 108, 100, 101, 59, 1, 297, 4, 2, 107, 109, 11305, 11310, 99, 121, 59, 1, 1110, 108, 5, 239, 1, 59, 11316, 1, 239, 4, 6, 99, 102, 109, 111, 115, 117, 11332, 11346, 11351, 11357, 11363, 11380, 4, 2, 105, 121, 11338, 11343, 114, 99, 59, 1, 309, 59, 1, 1081, 114, 59, 3, 55349, 56615, 97, 116, 104, 59, 1, 567, 112, 102, 59, 3, 55349, 56667, 4, 2, 99, 101, 11369, 11374, 114, 59, 3, 55349, 56511, 114, 99, 121, 59, 1, 1112, 107, 99, 121, 59, 1, 1108, 4, 8, 97, 99, 102, 103, 104, 106, 111, 115, 11404, 11418, 11433, 11438, 11445, 11450, 11455, 11461, 112, 112, 97, 4, 2, 59, 118, 11413, 11415, 1, 954, 59, 1, 1008, 4, 2, 101, 121, 11424, 11430, 100, 105, 108, 59, 1, 311, 59, 1, 1082, 114, 59, 3, 55349, 56616, 114, 101, 101, 110, 59, 1, 312, 99, 121, 59, 1, 1093, 99, 121, 59, 1, 1116, 112, 102, 59, 3, 55349, 56668, 99, 114, 59, 3, 55349, 56512, 4, 23, 65, 66, 69, 72, 97, 98, 99, 100, 101, 102, 103, 104, 106, 108, 109, 110, 111, 112, 114, 115, 116, 117, 118, 11515, 11538, 11544, 11555, 11560, 11721, 11780, 11818, 11868, 12136, 12160, 12171, 12203, 12208, 12246, 12275, 12327, 12509, 12523, 12569, 12641, 12732, 12752, 4, 3, 97, 114, 116, 11523, 11528, 11532, 114, 114, 59, 1, 8666, 114, 59, 1, 8656, 97, 105, 108, 59, 1, 10523, 97, 114, 114, 59, 1, 10510, 4, 2, 59, 103, 11550, 11552, 1, 8806, 59, 1, 10891, 97, 114, 59, 1, 10594, 4, 9, 99, 101, 103, 109, 110, 112, 113, 114, 116, 11580, 11586, 11594, 11600, 11606, 11624, 11627, 11636, 11694, 117, 116, 101, 59, 1, 314, 109, 112, 116, 121, 118, 59, 1, 10676, 114, 97, 110, 59, 1, 8466, 98, 100, 97, 59, 1, 955, 103, 4, 3, 59, 100, 108, 11615, 11617, 11620, 1, 10216, 59, 1, 10641, 101, 59, 1, 10216, 59, 1, 10885, 117, 111, 5, 171, 1, 59, 11634, 1, 171, 114, 4, 8, 59, 98, 102, 104, 108, 112, 115, 116, 11655, 11657, 11669, 11673, 11677, 11681, 11685, 11690, 1, 8592, 4, 2, 59, 102, 11663, 11665, 1, 8676, 115, 59, 1, 10527, 115, 59, 1, 10525, 107, 59, 1, 8617, 112, 59, 1, 8619, 108, 59, 1, 10553, 105, 109, 59, 1, 10611, 108, 59, 1, 8610, 4, 3, 59, 97, 101, 11702, 11704, 11709, 1, 10923, 105, 108, 59, 1, 10521, 4, 2, 59, 115, 11715, 11717, 1, 10925, 59, 3, 10925, 65024, 4, 3, 97, 98, 114, 11729, 11734, 11739, 114, 114, 59, 1, 10508, 114, 107, 59, 1, 10098, 4, 2, 97, 107, 11745, 11758, 99, 4, 2, 101, 107, 11752, 11755, 59, 1, 123, 59, 1, 91, 4, 2, 101, 115, 11764, 11767, 59, 1, 10635, 108, 4, 2, 100, 117, 11774, 11777, 59, 1, 10639, 59, 1, 10637, 4, 4, 97, 101, 117, 121, 11790, 11796, 11811, 11815, 114, 111, 110, 59, 1, 318, 4, 2, 100, 105, 11802, 11807, 105, 108, 59, 1, 316, 108, 59, 1, 8968, 98, 59, 1, 123, 59, 1, 1083, 4, 4, 99, 113, 114, 115, 11828, 11832, 11845, 11864, 97, 59, 1, 10550, 117, 111, 4, 2, 59, 114, 11840, 11842, 1, 8220, 59, 1, 8222, 4, 2, 100, 117, 11851, 11857, 104, 97, 114, 59, 1, 10599, 115, 104, 97, 114, 59, 1, 10571, 104, 59, 1, 8626, 4, 5, 59, 102, 103, 113, 115, 11880, 11882, 12008, 12011, 12031, 1, 8804, 116, 4, 5, 97, 104, 108, 114, 116, 11895, 11913, 11935, 11947, 11996, 114, 114, 111, 119, 4, 2, 59, 116, 11905, 11907, 1, 8592, 97, 105, 108, 59, 1, 8610, 97, 114, 112, 111, 111, 110, 4, 2, 100, 117, 11925, 11931, 111, 119, 110, 59, 1, 8637, 112, 59, 1, 8636, 101, 102, 116, 97, 114, 114, 111, 119, 115, 59, 1, 8647, 105, 103, 104, 116, 4, 3, 97, 104, 115, 11959, 11974, 11984, 114, 114, 111, 119, 4, 2, 59, 115, 11969, 11971, 1, 8596, 59, 1, 8646, 97, 114, 112, 111, 111, 110, 115, 59, 1, 8651, 113, 117, 105, 103, 97, 114, 114, 111, 119, 59, 1, 8621, 104, 114, 101, 101, 116, 105, 109, 101, 115, 59, 1, 8907, 59, 1, 8922, 4, 3, 59, 113, 115, 12019, 12021, 12024, 1, 8804, 59, 1, 8806, 108, 97, 110, 116, 59, 1, 10877, 4, 5, 59, 99, 100, 103, 115, 12043, 12045, 12049, 12070, 12083, 1, 10877, 99, 59, 1, 10920, 111, 116, 4, 2, 59, 111, 12057, 12059, 1, 10879, 4, 2, 59, 114, 12065, 12067, 1, 10881, 59, 1, 10883, 4, 2, 59, 101, 12076, 12079, 3, 8922, 65024, 115, 59, 1, 10899, 4, 5, 97, 100, 101, 103, 115, 12095, 12103, 12108, 12126, 12131, 112, 112, 114, 111, 120, 59, 1, 10885, 111, 116, 59, 1, 8918, 113, 4, 2, 103, 113, 12115, 12120, 116, 114, 59, 1, 8922, 103, 116, 114, 59, 1, 10891, 116, 114, 59, 1, 8822, 105, 109, 59, 1, 8818, 4, 3, 105, 108, 114, 12144, 12150, 12156, 115, 104, 116, 59, 1, 10620, 111, 111, 114, 59, 1, 8970, 59, 3, 55349, 56617, 4, 2, 59, 69, 12166, 12168, 1, 8822, 59, 1, 10897, 4, 2, 97, 98, 12177, 12198, 114, 4, 2, 100, 117, 12184, 12187, 59, 1, 8637, 4, 2, 59, 108, 12193, 12195, 1, 8636, 59, 1, 10602, 108, 107, 59, 1, 9604, 99, 121, 59, 1, 1113, 4, 5, 59, 97, 99, 104, 116, 12220, 12222, 12227, 12235, 12241, 1, 8810, 114, 114, 59, 1, 8647, 111, 114, 110, 101, 114, 59, 1, 8990, 97, 114, 100, 59, 1, 10603, 114, 105, 59, 1, 9722, 4, 2, 105, 111, 12252, 12258, 100, 111, 116, 59, 1, 320, 117, 115, 116, 4, 2, 59, 97, 12267, 12269, 1, 9136, 99, 104, 101, 59, 1, 9136, 4, 4, 69, 97, 101, 115, 12285, 12288, 12303, 12322, 59, 1, 8808, 112, 4, 2, 59, 112, 12295, 12297, 1, 10889, 114, 111, 120, 59, 1, 10889, 4, 2, 59, 113, 12309, 12311, 1, 10887, 4, 2, 59, 113, 12317, 12319, 1, 10887, 59, 1, 8808, 105, 109, 59, 1, 8934, 4, 8, 97, 98, 110, 111, 112, 116, 119, 122, 12345, 12359, 12364, 12421, 12446, 12467, 12474, 12490, 4, 2, 110, 114, 12351, 12355, 103, 59, 1, 10220, 114, 59, 1, 8701, 114, 107, 59, 1, 10214, 103, 4, 3, 108, 109, 114, 12373, 12401, 12409, 101, 102, 116, 4, 2, 97, 114, 12382, 12389, 114, 114, 111, 119, 59, 1, 10229, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 10231, 97, 112, 115, 116, 111, 59, 1, 10236, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 10230, 112, 97, 114, 114, 111, 119, 4, 2, 108, 114, 12433, 12439, 101, 102, 116, 59, 1, 8619, 105, 103, 104, 116, 59, 1, 8620, 4, 3, 97, 102, 108, 12454, 12458, 12462, 114, 59, 1, 10629, 59, 3, 55349, 56669, 117, 115, 59, 1, 10797, 105, 109, 101, 115, 59, 1, 10804, 4, 2, 97, 98, 12480, 12485, 115, 116, 59, 1, 8727, 97, 114, 59, 1, 95, 4, 3, 59, 101, 102, 12498, 12500, 12506, 1, 9674, 110, 103, 101, 59, 1, 9674, 59, 1, 10731, 97, 114, 4, 2, 59, 108, 12517, 12519, 1, 40, 116, 59, 1, 10643, 4, 5, 97, 99, 104, 109, 116, 12535, 12540, 12548, 12561, 12564, 114, 114, 59, 1, 8646, 111, 114, 110, 101, 114, 59, 1, 8991, 97, 114, 4, 2, 59, 100, 12556, 12558, 1, 8651, 59, 1, 10605, 59, 1, 8206, 114, 105, 59, 1, 8895, 4, 6, 97, 99, 104, 105, 113, 116, 12583, 12589, 12594, 12597, 12614, 12635, 113, 117, 111, 59, 1, 8249, 114, 59, 3, 55349, 56513, 59, 1, 8624, 109, 4, 3, 59, 101, 103, 12606, 12608, 12611, 1, 8818, 59, 1, 10893, 59, 1, 10895, 4, 2, 98, 117, 12620, 12623, 59, 1, 91, 111, 4, 2, 59, 114, 12630, 12632, 1, 8216, 59, 1, 8218, 114, 111, 107, 59, 1, 322, 5, 60, 8, 59, 99, 100, 104, 105, 108, 113, 114, 12660, 12662, 12675, 12680, 12686, 12692, 12698, 12705, 1, 60, 4, 2, 99, 105, 12668, 12671, 59, 1, 10918, 114, 59, 1, 10873, 111, 116, 59, 1, 8918, 114, 101, 101, 59, 1, 8907, 109, 101, 115, 59, 1, 8905, 97, 114, 114, 59, 1, 10614, 117, 101, 115, 116, 59, 1, 10875, 4, 2, 80, 105, 12711, 12716, 97, 114, 59, 1, 10646, 4, 3, 59, 101, 102, 12724, 12726, 12729, 1, 9667, 59, 1, 8884, 59, 1, 9666, 114, 4, 2, 100, 117, 12739, 12746, 115, 104, 97, 114, 59, 1, 10570, 104, 97, 114, 59, 1, 10598, 4, 2, 101, 110, 12758, 12768, 114, 116, 110, 101, 113, 113, 59, 3, 8808, 65024, 69, 59, 3, 8808, 65024, 4, 14, 68, 97, 99, 100, 101, 102, 104, 105, 108, 110, 111, 112, 115, 117, 12803, 12809, 12893, 12908, 12914, 12928, 12933, 12937, 13011, 13025, 13032, 13049, 13052, 13069, 68, 111, 116, 59, 1, 8762, 4, 4, 99, 108, 112, 114, 12819, 12827, 12849, 12887, 114, 5, 175, 1, 59, 12825, 1, 175, 4, 2, 101, 116, 12833, 12836, 59, 1, 9794, 4, 2, 59, 101, 12842, 12844, 1, 10016, 115, 101, 59, 1, 10016, 4, 2, 59, 115, 12855, 12857, 1, 8614, 116, 111, 4, 4, 59, 100, 108, 117, 12869, 12871, 12877, 12883, 1, 8614, 111, 119, 110, 59, 1, 8615, 101, 102, 116, 59, 1, 8612, 112, 59, 1, 8613, 107, 101, 114, 59, 1, 9646, 4, 2, 111, 121, 12899, 12905, 109, 109, 97, 59, 1, 10793, 59, 1, 1084, 97, 115, 104, 59, 1, 8212, 97, 115, 117, 114, 101, 100, 97, 110, 103, 108, 101, 59, 1, 8737, 114, 59, 3, 55349, 56618, 111, 59, 1, 8487, 4, 3, 99, 100, 110, 12945, 12954, 12985, 114, 111, 5, 181, 1, 59, 12952, 1, 181, 4, 4, 59, 97, 99, 100, 12964, 12966, 12971, 12976, 1, 8739, 115, 116, 59, 1, 42, 105, 114, 59, 1, 10992, 111, 116, 5, 183, 1, 59, 12983, 1, 183, 117, 115, 4, 3, 59, 98, 100, 12995, 12997, 13e3, 1, 8722, 59, 1, 8863, 4, 2, 59, 117, 13006, 13008, 1, 8760, 59, 1, 10794, 4, 2, 99, 100, 13017, 13021, 112, 59, 1, 10971, 114, 59, 1, 8230, 112, 108, 117, 115, 59, 1, 8723, 4, 2, 100, 112, 13038, 13044, 101, 108, 115, 59, 1, 8871, 102, 59, 3, 55349, 56670, 59, 1, 8723, 4, 2, 99, 116, 13058, 13063, 114, 59, 3, 55349, 56514, 112, 111, 115, 59, 1, 8766, 4, 3, 59, 108, 109, 13077, 13079, 13087, 1, 956, 116, 105, 109, 97, 112, 59, 1, 8888, 97, 112, 59, 1, 8888, 4, 24, 71, 76, 82, 86, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 108, 109, 111, 112, 114, 115, 116, 117, 118, 119, 13142, 13165, 13217, 13229, 13247, 13330, 13359, 13414, 13420, 13508, 13513, 13579, 13602, 13626, 13631, 13762, 13767, 13855, 13936, 13995, 14214, 14285, 14312, 14432, 4, 2, 103, 116, 13148, 13152, 59, 3, 8921, 824, 4, 2, 59, 118, 13158, 13161, 3, 8811, 8402, 59, 3, 8811, 824, 4, 3, 101, 108, 116, 13173, 13200, 13204, 102, 116, 4, 2, 97, 114, 13181, 13188, 114, 114, 111, 119, 59, 1, 8653, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8654, 59, 3, 8920, 824, 4, 2, 59, 118, 13210, 13213, 3, 8810, 8402, 59, 3, 8810, 824, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8655, 4, 2, 68, 100, 13235, 13241, 97, 115, 104, 59, 1, 8879, 97, 115, 104, 59, 1, 8878, 4, 5, 98, 99, 110, 112, 116, 13259, 13264, 13270, 13275, 13308, 108, 97, 59, 1, 8711, 117, 116, 101, 59, 1, 324, 103, 59, 3, 8736, 8402, 4, 5, 59, 69, 105, 111, 112, 13287, 13289, 13293, 13298, 13302, 1, 8777, 59, 3, 10864, 824, 100, 59, 3, 8779, 824, 115, 59, 1, 329, 114, 111, 120, 59, 1, 8777, 117, 114, 4, 2, 59, 97, 13316, 13318, 1, 9838, 108, 4, 2, 59, 115, 13325, 13327, 1, 9838, 59, 1, 8469, 4, 2, 115, 117, 13336, 13344, 112, 5, 160, 1, 59, 13342, 1, 160, 109, 112, 4, 2, 59, 101, 13352, 13355, 3, 8782, 824, 59, 3, 8783, 824, 4, 5, 97, 101, 111, 117, 121, 13371, 13385, 13391, 13407, 13411, 4, 2, 112, 114, 13377, 13380, 59, 1, 10819, 111, 110, 59, 1, 328, 100, 105, 108, 59, 1, 326, 110, 103, 4, 2, 59, 100, 13399, 13401, 1, 8775, 111, 116, 59, 3, 10861, 824, 112, 59, 1, 10818, 59, 1, 1085, 97, 115, 104, 59, 1, 8211, 4, 7, 59, 65, 97, 100, 113, 115, 120, 13436, 13438, 13443, 13466, 13472, 13478, 13494, 1, 8800, 114, 114, 59, 1, 8663, 114, 4, 2, 104, 114, 13450, 13454, 107, 59, 1, 10532, 4, 2, 59, 111, 13460, 13462, 1, 8599, 119, 59, 1, 8599, 111, 116, 59, 3, 8784, 824, 117, 105, 118, 59, 1, 8802, 4, 2, 101, 105, 13484, 13489, 97, 114, 59, 1, 10536, 109, 59, 3, 8770, 824, 105, 115, 116, 4, 2, 59, 115, 13503, 13505, 1, 8708, 59, 1, 8708, 114, 59, 3, 55349, 56619, 4, 4, 69, 101, 115, 116, 13523, 13527, 13563, 13568, 59, 3, 8807, 824, 4, 3, 59, 113, 115, 13535, 13537, 13559, 1, 8817, 4, 3, 59, 113, 115, 13545, 13547, 13551, 1, 8817, 59, 3, 8807, 824, 108, 97, 110, 116, 59, 3, 10878, 824, 59, 3, 10878, 824, 105, 109, 59, 1, 8821, 4, 2, 59, 114, 13574, 13576, 1, 8815, 59, 1, 8815, 4, 3, 65, 97, 112, 13587, 13592, 13597, 114, 114, 59, 1, 8654, 114, 114, 59, 1, 8622, 97, 114, 59, 1, 10994, 4, 3, 59, 115, 118, 13610, 13612, 13623, 1, 8715, 4, 2, 59, 100, 13618, 13620, 1, 8956, 59, 1, 8954, 59, 1, 8715, 99, 121, 59, 1, 1114, 4, 7, 65, 69, 97, 100, 101, 115, 116, 13647, 13652, 13656, 13661, 13665, 13737, 13742, 114, 114, 59, 1, 8653, 59, 3, 8806, 824, 114, 114, 59, 1, 8602, 114, 59, 1, 8229, 4, 4, 59, 102, 113, 115, 13675, 13677, 13703, 13725, 1, 8816, 116, 4, 2, 97, 114, 13684, 13691, 114, 114, 111, 119, 59, 1, 8602, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8622, 4, 3, 59, 113, 115, 13711, 13713, 13717, 1, 8816, 59, 3, 8806, 824, 108, 97, 110, 116, 59, 3, 10877, 824, 4, 2, 59, 115, 13731, 13734, 3, 10877, 824, 59, 1, 8814, 105, 109, 59, 1, 8820, 4, 2, 59, 114, 13748, 13750, 1, 8814, 105, 4, 2, 59, 101, 13757, 13759, 1, 8938, 59, 1, 8940, 105, 100, 59, 1, 8740, 4, 2, 112, 116, 13773, 13778, 102, 59, 3, 55349, 56671, 5, 172, 3, 59, 105, 110, 13787, 13789, 13829, 1, 172, 110, 4, 4, 59, 69, 100, 118, 13800, 13802, 13806, 13812, 1, 8713, 59, 3, 8953, 824, 111, 116, 59, 3, 8949, 824, 4, 3, 97, 98, 99, 13820, 13823, 13826, 59, 1, 8713, 59, 1, 8951, 59, 1, 8950, 105, 4, 2, 59, 118, 13836, 13838, 1, 8716, 4, 3, 97, 98, 99, 13846, 13849, 13852, 59, 1, 8716, 59, 1, 8958, 59, 1, 8957, 4, 3, 97, 111, 114, 13863, 13892, 13899, 114, 4, 4, 59, 97, 115, 116, 13874, 13876, 13883, 13888, 1, 8742, 108, 108, 101, 108, 59, 1, 8742, 108, 59, 3, 11005, 8421, 59, 3, 8706, 824, 108, 105, 110, 116, 59, 1, 10772, 4, 3, 59, 99, 101, 13907, 13909, 13914, 1, 8832, 117, 101, 59, 1, 8928, 4, 2, 59, 99, 13920, 13923, 3, 10927, 824, 4, 2, 59, 101, 13929, 13931, 1, 8832, 113, 59, 3, 10927, 824, 4, 4, 65, 97, 105, 116, 13946, 13951, 13971, 13982, 114, 114, 59, 1, 8655, 114, 114, 4, 3, 59, 99, 119, 13961, 13963, 13967, 1, 8603, 59, 3, 10547, 824, 59, 3, 8605, 824, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8603, 114, 105, 4, 2, 59, 101, 13990, 13992, 1, 8939, 59, 1, 8941, 4, 7, 99, 104, 105, 109, 112, 113, 117, 14011, 14036, 14060, 14080, 14085, 14090, 14106, 4, 4, 59, 99, 101, 114, 14021, 14023, 14028, 14032, 1, 8833, 117, 101, 59, 1, 8929, 59, 3, 10928, 824, 59, 3, 55349, 56515, 111, 114, 116, 4, 2, 109, 112, 14045, 14050, 105, 100, 59, 1, 8740, 97, 114, 97, 108, 108, 101, 108, 59, 1, 8742, 109, 4, 2, 59, 101, 14067, 14069, 1, 8769, 4, 2, 59, 113, 14075, 14077, 1, 8772, 59, 1, 8772, 105, 100, 59, 1, 8740, 97, 114, 59, 1, 8742, 115, 117, 4, 2, 98, 112, 14098, 14102, 101, 59, 1, 8930, 101, 59, 1, 8931, 4, 3, 98, 99, 112, 14114, 14157, 14171, 4, 4, 59, 69, 101, 115, 14124, 14126, 14130, 14133, 1, 8836, 59, 3, 10949, 824, 59, 1, 8840, 101, 116, 4, 2, 59, 101, 14141, 14144, 3, 8834, 8402, 113, 4, 2, 59, 113, 14151, 14153, 1, 8840, 59, 3, 10949, 824, 99, 4, 2, 59, 101, 14164, 14166, 1, 8833, 113, 59, 3, 10928, 824, 4, 4, 59, 69, 101, 115, 14181, 14183, 14187, 14190, 1, 8837, 59, 3, 10950, 824, 59, 1, 8841, 101, 116, 4, 2, 59, 101, 14198, 14201, 3, 8835, 8402, 113, 4, 2, 59, 113, 14208, 14210, 1, 8841, 59, 3, 10950, 824, 4, 4, 103, 105, 108, 114, 14224, 14228, 14238, 14242, 108, 59, 1, 8825, 108, 100, 101, 5, 241, 1, 59, 14236, 1, 241, 103, 59, 1, 8824, 105, 97, 110, 103, 108, 101, 4, 2, 108, 114, 14254, 14269, 101, 102, 116, 4, 2, 59, 101, 14263, 14265, 1, 8938, 113, 59, 1, 8940, 105, 103, 104, 116, 4, 2, 59, 101, 14279, 14281, 1, 8939, 113, 59, 1, 8941, 4, 2, 59, 109, 14291, 14293, 1, 957, 4, 3, 59, 101, 115, 14301, 14303, 14308, 1, 35, 114, 111, 59, 1, 8470, 112, 59, 1, 8199, 4, 9, 68, 72, 97, 100, 103, 105, 108, 114, 115, 14332, 14338, 14344, 14349, 14355, 14369, 14376, 14408, 14426, 97, 115, 104, 59, 1, 8877, 97, 114, 114, 59, 1, 10500, 112, 59, 3, 8781, 8402, 97, 115, 104, 59, 1, 8876, 4, 2, 101, 116, 14361, 14365, 59, 3, 8805, 8402, 59, 3, 62, 8402, 110, 102, 105, 110, 59, 1, 10718, 4, 3, 65, 101, 116, 14384, 14389, 14393, 114, 114, 59, 1, 10498, 59, 3, 8804, 8402, 4, 2, 59, 114, 14399, 14402, 3, 60, 8402, 105, 101, 59, 3, 8884, 8402, 4, 2, 65, 116, 14414, 14419, 114, 114, 59, 1, 10499, 114, 105, 101, 59, 3, 8885, 8402, 105, 109, 59, 3, 8764, 8402, 4, 3, 65, 97, 110, 14440, 14445, 14468, 114, 114, 59, 1, 8662, 114, 4, 2, 104, 114, 14452, 14456, 107, 59, 1, 10531, 4, 2, 59, 111, 14462, 14464, 1, 8598, 119, 59, 1, 8598, 101, 97, 114, 59, 1, 10535, 4, 18, 83, 97, 99, 100, 101, 102, 103, 104, 105, 108, 109, 111, 112, 114, 115, 116, 117, 118, 14512, 14515, 14535, 14560, 14597, 14603, 14618, 14643, 14657, 14662, 14701, 14741, 14747, 14769, 14851, 14877, 14907, 14916, 59, 1, 9416, 4, 2, 99, 115, 14521, 14531, 117, 116, 101, 5, 243, 1, 59, 14529, 1, 243, 116, 59, 1, 8859, 4, 2, 105, 121, 14541, 14557, 114, 4, 2, 59, 99, 14548, 14550, 1, 8858, 5, 244, 1, 59, 14555, 1, 244, 59, 1, 1086, 4, 5, 97, 98, 105, 111, 115, 14572, 14577, 14583, 14587, 14591, 115, 104, 59, 1, 8861, 108, 97, 99, 59, 1, 337, 118, 59, 1, 10808, 116, 59, 1, 8857, 111, 108, 100, 59, 1, 10684, 108, 105, 103, 59, 1, 339, 4, 2, 99, 114, 14609, 14614, 105, 114, 59, 1, 10687, 59, 3, 55349, 56620, 4, 3, 111, 114, 116, 14626, 14630, 14640, 110, 59, 1, 731, 97, 118, 101, 5, 242, 1, 59, 14638, 1, 242, 59, 1, 10689, 4, 2, 98, 109, 14649, 14654, 97, 114, 59, 1, 10677, 59, 1, 937, 110, 116, 59, 1, 8750, 4, 4, 97, 99, 105, 116, 14672, 14677, 14693, 14698, 114, 114, 59, 1, 8634, 4, 2, 105, 114, 14683, 14687, 114, 59, 1, 10686, 111, 115, 115, 59, 1, 10683, 110, 101, 59, 1, 8254, 59, 1, 10688, 4, 3, 97, 101, 105, 14709, 14714, 14719, 99, 114, 59, 1, 333, 103, 97, 59, 1, 969, 4, 3, 99, 100, 110, 14727, 14733, 14736, 114, 111, 110, 59, 1, 959, 59, 1, 10678, 117, 115, 59, 1, 8854, 112, 102, 59, 3, 55349, 56672, 4, 3, 97, 101, 108, 14755, 14759, 14764, 114, 59, 1, 10679, 114, 112, 59, 1, 10681, 117, 115, 59, 1, 8853, 4, 7, 59, 97, 100, 105, 111, 115, 118, 14785, 14787, 14792, 14831, 14837, 14841, 14848, 1, 8744, 114, 114, 59, 1, 8635, 4, 4, 59, 101, 102, 109, 14802, 14804, 14817, 14824, 1, 10845, 114, 4, 2, 59, 111, 14811, 14813, 1, 8500, 102, 59, 1, 8500, 5, 170, 1, 59, 14822, 1, 170, 5, 186, 1, 59, 14829, 1, 186, 103, 111, 102, 59, 1, 8886, 114, 59, 1, 10838, 108, 111, 112, 101, 59, 1, 10839, 59, 1, 10843, 4, 3, 99, 108, 111, 14859, 14863, 14873, 114, 59, 1, 8500, 97, 115, 104, 5, 248, 1, 59, 14871, 1, 248, 108, 59, 1, 8856, 105, 4, 2, 108, 109, 14884, 14893, 100, 101, 5, 245, 1, 59, 14891, 1, 245, 101, 115, 4, 2, 59, 97, 14901, 14903, 1, 8855, 115, 59, 1, 10806, 109, 108, 5, 246, 1, 59, 14914, 1, 246, 98, 97, 114, 59, 1, 9021, 4, 12, 97, 99, 101, 102, 104, 105, 108, 109, 111, 114, 115, 117, 14948, 14992, 14996, 15033, 15038, 15068, 15090, 15189, 15192, 15222, 15427, 15441, 114, 4, 4, 59, 97, 115, 116, 14959, 14961, 14976, 14989, 1, 8741, 5, 182, 2, 59, 108, 14968, 14970, 1, 182, 108, 101, 108, 59, 1, 8741, 4, 2, 105, 108, 14982, 14986, 109, 59, 1, 10995, 59, 1, 11005, 59, 1, 8706, 121, 59, 1, 1087, 114, 4, 5, 99, 105, 109, 112, 116, 15009, 15014, 15019, 15024, 15027, 110, 116, 59, 1, 37, 111, 100, 59, 1, 46, 105, 108, 59, 1, 8240, 59, 1, 8869, 101, 110, 107, 59, 1, 8241, 114, 59, 3, 55349, 56621, 4, 3, 105, 109, 111, 15046, 15057, 15063, 4, 2, 59, 118, 15052, 15054, 1, 966, 59, 1, 981, 109, 97, 116, 59, 1, 8499, 110, 101, 59, 1, 9742, 4, 3, 59, 116, 118, 15076, 15078, 15087, 1, 960, 99, 104, 102, 111, 114, 107, 59, 1, 8916, 59, 1, 982, 4, 2, 97, 117, 15096, 15119, 110, 4, 2, 99, 107, 15103, 15115, 107, 4, 2, 59, 104, 15110, 15112, 1, 8463, 59, 1, 8462, 118, 59, 1, 8463, 115, 4, 9, 59, 97, 98, 99, 100, 101, 109, 115, 116, 15140, 15142, 15148, 15151, 15156, 15168, 15171, 15179, 15184, 1, 43, 99, 105, 114, 59, 1, 10787, 59, 1, 8862, 105, 114, 59, 1, 10786, 4, 2, 111, 117, 15162, 15165, 59, 1, 8724, 59, 1, 10789, 59, 1, 10866, 110, 5, 177, 1, 59, 15177, 1, 177, 105, 109, 59, 1, 10790, 119, 111, 59, 1, 10791, 59, 1, 177, 4, 3, 105, 112, 117, 15200, 15208, 15213, 110, 116, 105, 110, 116, 59, 1, 10773, 102, 59, 3, 55349, 56673, 110, 100, 5, 163, 1, 59, 15220, 1, 163, 4, 10, 59, 69, 97, 99, 101, 105, 110, 111, 115, 117, 15244, 15246, 15249, 15253, 15258, 15334, 15347, 15367, 15416, 15421, 1, 8826, 59, 1, 10931, 112, 59, 1, 10935, 117, 101, 59, 1, 8828, 4, 2, 59, 99, 15264, 15266, 1, 10927, 4, 6, 59, 97, 99, 101, 110, 115, 15280, 15282, 15290, 15299, 15303, 15329, 1, 8826, 112, 112, 114, 111, 120, 59, 1, 10935, 117, 114, 108, 121, 101, 113, 59, 1, 8828, 113, 59, 1, 10927, 4, 3, 97, 101, 115, 15311, 15319, 15324, 112, 112, 114, 111, 120, 59, 1, 10937, 113, 113, 59, 1, 10933, 105, 109, 59, 1, 8936, 105, 109, 59, 1, 8830, 109, 101, 4, 2, 59, 115, 15342, 15344, 1, 8242, 59, 1, 8473, 4, 3, 69, 97, 115, 15355, 15358, 15362, 59, 1, 10933, 112, 59, 1, 10937, 105, 109, 59, 1, 8936, 4, 3, 100, 102, 112, 15375, 15378, 15404, 59, 1, 8719, 4, 3, 97, 108, 115, 15386, 15392, 15398, 108, 97, 114, 59, 1, 9006, 105, 110, 101, 59, 1, 8978, 117, 114, 102, 59, 1, 8979, 4, 2, 59, 116, 15410, 15412, 1, 8733, 111, 59, 1, 8733, 105, 109, 59, 1, 8830, 114, 101, 108, 59, 1, 8880, 4, 2, 99, 105, 15433, 15438, 114, 59, 3, 55349, 56517, 59, 1, 968, 110, 99, 115, 112, 59, 1, 8200, 4, 6, 102, 105, 111, 112, 115, 117, 15462, 15467, 15472, 15478, 15485, 15491, 114, 59, 3, 55349, 56622, 110, 116, 59, 1, 10764, 112, 102, 59, 3, 55349, 56674, 114, 105, 109, 101, 59, 1, 8279, 99, 114, 59, 3, 55349, 56518, 4, 3, 97, 101, 111, 15499, 15520, 15534, 116, 4, 2, 101, 105, 15506, 15515, 114, 110, 105, 111, 110, 115, 59, 1, 8461, 110, 116, 59, 1, 10774, 115, 116, 4, 2, 59, 101, 15528, 15530, 1, 63, 113, 59, 1, 8799, 116, 5, 34, 1, 59, 15540, 1, 34, 4, 21, 65, 66, 72, 97, 98, 99, 100, 101, 102, 104, 105, 108, 109, 110, 111, 112, 114, 115, 116, 117, 120, 15586, 15609, 15615, 15620, 15796, 15855, 15893, 15931, 15977, 16001, 16039, 16183, 16204, 16222, 16228, 16285, 16312, 16318, 16363, 16408, 16416, 4, 3, 97, 114, 116, 15594, 15599, 15603, 114, 114, 59, 1, 8667, 114, 59, 1, 8658, 97, 105, 108, 59, 1, 10524, 97, 114, 114, 59, 1, 10511, 97, 114, 59, 1, 10596, 4, 7, 99, 100, 101, 110, 113, 114, 116, 15636, 15651, 15656, 15664, 15687, 15696, 15770, 4, 2, 101, 117, 15642, 15646, 59, 3, 8765, 817, 116, 101, 59, 1, 341, 105, 99, 59, 1, 8730, 109, 112, 116, 121, 118, 59, 1, 10675, 103, 4, 4, 59, 100, 101, 108, 15675, 15677, 15680, 15683, 1, 10217, 59, 1, 10642, 59, 1, 10661, 101, 59, 1, 10217, 117, 111, 5, 187, 1, 59, 15694, 1, 187, 114, 4, 11, 59, 97, 98, 99, 102, 104, 108, 112, 115, 116, 119, 15721, 15723, 15727, 15739, 15742, 15746, 15750, 15754, 15758, 15763, 15767, 1, 8594, 112, 59, 1, 10613, 4, 2, 59, 102, 15733, 15735, 1, 8677, 115, 59, 1, 10528, 59, 1, 10547, 115, 59, 1, 10526, 107, 59, 1, 8618, 112, 59, 1, 8620, 108, 59, 1, 10565, 105, 109, 59, 1, 10612, 108, 59, 1, 8611, 59, 1, 8605, 4, 2, 97, 105, 15776, 15781, 105, 108, 59, 1, 10522, 111, 4, 2, 59, 110, 15788, 15790, 1, 8758, 97, 108, 115, 59, 1, 8474, 4, 3, 97, 98, 114, 15804, 15809, 15814, 114, 114, 59, 1, 10509, 114, 107, 59, 1, 10099, 4, 2, 97, 107, 15820, 15833, 99, 4, 2, 101, 107, 15827, 15830, 59, 1, 125, 59, 1, 93, 4, 2, 101, 115, 15839, 15842, 59, 1, 10636, 108, 4, 2, 100, 117, 15849, 15852, 59, 1, 10638, 59, 1, 10640, 4, 4, 97, 101, 117, 121, 15865, 15871, 15886, 15890, 114, 111, 110, 59, 1, 345, 4, 2, 100, 105, 15877, 15882, 105, 108, 59, 1, 343, 108, 59, 1, 8969, 98, 59, 1, 125, 59, 1, 1088, 4, 4, 99, 108, 113, 115, 15903, 15907, 15914, 15927, 97, 59, 1, 10551, 100, 104, 97, 114, 59, 1, 10601, 117, 111, 4, 2, 59, 114, 15922, 15924, 1, 8221, 59, 1, 8221, 104, 59, 1, 8627, 4, 3, 97, 99, 103, 15939, 15966, 15970, 108, 4, 4, 59, 105, 112, 115, 15950, 15952, 15957, 15963, 1, 8476, 110, 101, 59, 1, 8475, 97, 114, 116, 59, 1, 8476, 59, 1, 8477, 116, 59, 1, 9645, 5, 174, 1, 59, 15975, 1, 174, 4, 3, 105, 108, 114, 15985, 15991, 15997, 115, 104, 116, 59, 1, 10621, 111, 111, 114, 59, 1, 8971, 59, 3, 55349, 56623, 4, 2, 97, 111, 16007, 16028, 114, 4, 2, 100, 117, 16014, 16017, 59, 1, 8641, 4, 2, 59, 108, 16023, 16025, 1, 8640, 59, 1, 10604, 4, 2, 59, 118, 16034, 16036, 1, 961, 59, 1, 1009, 4, 3, 103, 110, 115, 16047, 16167, 16171, 104, 116, 4, 6, 97, 104, 108, 114, 115, 116, 16063, 16081, 16103, 16130, 16143, 16155, 114, 114, 111, 119, 4, 2, 59, 116, 16073, 16075, 1, 8594, 97, 105, 108, 59, 1, 8611, 97, 114, 112, 111, 111, 110, 4, 2, 100, 117, 16093, 16099, 111, 119, 110, 59, 1, 8641, 112, 59, 1, 8640, 101, 102, 116, 4, 2, 97, 104, 16112, 16120, 114, 114, 111, 119, 115, 59, 1, 8644, 97, 114, 112, 111, 111, 110, 115, 59, 1, 8652, 105, 103, 104, 116, 97, 114, 114, 111, 119, 115, 59, 1, 8649, 113, 117, 105, 103, 97, 114, 114, 111, 119, 59, 1, 8605, 104, 114, 101, 101, 116, 105, 109, 101, 115, 59, 1, 8908, 103, 59, 1, 730, 105, 110, 103, 100, 111, 116, 115, 101, 113, 59, 1, 8787, 4, 3, 97, 104, 109, 16191, 16196, 16201, 114, 114, 59, 1, 8644, 97, 114, 59, 1, 8652, 59, 1, 8207, 111, 117, 115, 116, 4, 2, 59, 97, 16214, 16216, 1, 9137, 99, 104, 101, 59, 1, 9137, 109, 105, 100, 59, 1, 10990, 4, 4, 97, 98, 112, 116, 16238, 16252, 16257, 16278, 4, 2, 110, 114, 16244, 16248, 103, 59, 1, 10221, 114, 59, 1, 8702, 114, 107, 59, 1, 10215, 4, 3, 97, 102, 108, 16265, 16269, 16273, 114, 59, 1, 10630, 59, 3, 55349, 56675, 117, 115, 59, 1, 10798, 105, 109, 101, 115, 59, 1, 10805, 4, 2, 97, 112, 16291, 16304, 114, 4, 2, 59, 103, 16298, 16300, 1, 41, 116, 59, 1, 10644, 111, 108, 105, 110, 116, 59, 1, 10770, 97, 114, 114, 59, 1, 8649, 4, 4, 97, 99, 104, 113, 16328, 16334, 16339, 16342, 113, 117, 111, 59, 1, 8250, 114, 59, 3, 55349, 56519, 59, 1, 8625, 4, 2, 98, 117, 16348, 16351, 59, 1, 93, 111, 4, 2, 59, 114, 16358, 16360, 1, 8217, 59, 1, 8217, 4, 3, 104, 105, 114, 16371, 16377, 16383, 114, 101, 101, 59, 1, 8908, 109, 101, 115, 59, 1, 8906, 105, 4, 4, 59, 101, 102, 108, 16394, 16396, 16399, 16402, 1, 9657, 59, 1, 8885, 59, 1, 9656, 116, 114, 105, 59, 1, 10702, 108, 117, 104, 97, 114, 59, 1, 10600, 59, 1, 8478, 4, 19, 97, 98, 99, 100, 101, 102, 104, 105, 108, 109, 111, 112, 113, 114, 115, 116, 117, 119, 122, 16459, 16466, 16472, 16572, 16590, 16672, 16687, 16746, 16844, 16850, 16924, 16963, 16988, 17115, 17121, 17154, 17206, 17614, 17656, 99, 117, 116, 101, 59, 1, 347, 113, 117, 111, 59, 1, 8218, 4, 10, 59, 69, 97, 99, 101, 105, 110, 112, 115, 121, 16494, 16496, 16499, 16513, 16518, 16531, 16536, 16556, 16564, 16569, 1, 8827, 59, 1, 10932, 4, 2, 112, 114, 16505, 16508, 59, 1, 10936, 111, 110, 59, 1, 353, 117, 101, 59, 1, 8829, 4, 2, 59, 100, 16524, 16526, 1, 10928, 105, 108, 59, 1, 351, 114, 99, 59, 1, 349, 4, 3, 69, 97, 115, 16544, 16547, 16551, 59, 1, 10934, 112, 59, 1, 10938, 105, 109, 59, 1, 8937, 111, 108, 105, 110, 116, 59, 1, 10771, 105, 109, 59, 1, 8831, 59, 1, 1089, 111, 116, 4, 3, 59, 98, 101, 16582, 16584, 16587, 1, 8901, 59, 1, 8865, 59, 1, 10854, 4, 7, 65, 97, 99, 109, 115, 116, 120, 16606, 16611, 16634, 16642, 16646, 16652, 16668, 114, 114, 59, 1, 8664, 114, 4, 2, 104, 114, 16618, 16622, 107, 59, 1, 10533, 4, 2, 59, 111, 16628, 16630, 1, 8600, 119, 59, 1, 8600, 116, 5, 167, 1, 59, 16640, 1, 167, 105, 59, 1, 59, 119, 97, 114, 59, 1, 10537, 109, 4, 2, 105, 110, 16659, 16665, 110, 117, 115, 59, 1, 8726, 59, 1, 8726, 116, 59, 1, 10038, 114, 4, 2, 59, 111, 16679, 16682, 3, 55349, 56624, 119, 110, 59, 1, 8994, 4, 4, 97, 99, 111, 121, 16697, 16702, 16716, 16739, 114, 112, 59, 1, 9839, 4, 2, 104, 121, 16708, 16713, 99, 121, 59, 1, 1097, 59, 1, 1096, 114, 116, 4, 2, 109, 112, 16724, 16729, 105, 100, 59, 1, 8739, 97, 114, 97, 108, 108, 101, 108, 59, 1, 8741, 5, 173, 1, 59, 16744, 1, 173, 4, 2, 103, 109, 16752, 16770, 109, 97, 4, 3, 59, 102, 118, 16762, 16764, 16767, 1, 963, 59, 1, 962, 59, 1, 962, 4, 8, 59, 100, 101, 103, 108, 110, 112, 114, 16788, 16790, 16795, 16806, 16817, 16828, 16832, 16838, 1, 8764, 111, 116, 59, 1, 10858, 4, 2, 59, 113, 16801, 16803, 1, 8771, 59, 1, 8771, 4, 2, 59, 69, 16812, 16814, 1, 10910, 59, 1, 10912, 4, 2, 59, 69, 16823, 16825, 1, 10909, 59, 1, 10911, 101, 59, 1, 8774, 108, 117, 115, 59, 1, 10788, 97, 114, 114, 59, 1, 10610, 97, 114, 114, 59, 1, 8592, 4, 4, 97, 101, 105, 116, 16860, 16883, 16891, 16904, 4, 2, 108, 115, 16866, 16878, 108, 115, 101, 116, 109, 105, 110, 117, 115, 59, 1, 8726, 104, 112, 59, 1, 10803, 112, 97, 114, 115, 108, 59, 1, 10724, 4, 2, 100, 108, 16897, 16900, 59, 1, 8739, 101, 59, 1, 8995, 4, 2, 59, 101, 16910, 16912, 1, 10922, 4, 2, 59, 115, 16918, 16920, 1, 10924, 59, 3, 10924, 65024, 4, 3, 102, 108, 112, 16932, 16938, 16958, 116, 99, 121, 59, 1, 1100, 4, 2, 59, 98, 16944, 16946, 1, 47, 4, 2, 59, 97, 16952, 16954, 1, 10692, 114, 59, 1, 9023, 102, 59, 3, 55349, 56676, 97, 4, 2, 100, 114, 16970, 16985, 101, 115, 4, 2, 59, 117, 16978, 16980, 1, 9824, 105, 116, 59, 1, 9824, 59, 1, 8741, 4, 3, 99, 115, 117, 16996, 17028, 17089, 4, 2, 97, 117, 17002, 17015, 112, 4, 2, 59, 115, 17009, 17011, 1, 8851, 59, 3, 8851, 65024, 112, 4, 2, 59, 115, 17022, 17024, 1, 8852, 59, 3, 8852, 65024, 117, 4, 2, 98, 112, 17035, 17062, 4, 3, 59, 101, 115, 17043, 17045, 17048, 1, 8847, 59, 1, 8849, 101, 116, 4, 2, 59, 101, 17056, 17058, 1, 8847, 113, 59, 1, 8849, 4, 3, 59, 101, 115, 17070, 17072, 17075, 1, 8848, 59, 1, 8850, 101, 116, 4, 2, 59, 101, 17083, 17085, 1, 8848, 113, 59, 1, 8850, 4, 3, 59, 97, 102, 17097, 17099, 17112, 1, 9633, 114, 4, 2, 101, 102, 17106, 17109, 59, 1, 9633, 59, 1, 9642, 59, 1, 9642, 97, 114, 114, 59, 1, 8594, 4, 4, 99, 101, 109, 116, 17131, 17136, 17142, 17148, 114, 59, 3, 55349, 56520, 116, 109, 110, 59, 1, 8726, 105, 108, 101, 59, 1, 8995, 97, 114, 102, 59, 1, 8902, 4, 2, 97, 114, 17160, 17172, 114, 4, 2, 59, 102, 17167, 17169, 1, 9734, 59, 1, 9733, 4, 2, 97, 110, 17178, 17202, 105, 103, 104, 116, 4, 2, 101, 112, 17188, 17197, 112, 115, 105, 108, 111, 110, 59, 1, 1013, 104, 105, 59, 1, 981, 115, 59, 1, 175, 4, 5, 98, 99, 109, 110, 112, 17218, 17351, 17420, 17423, 17427, 4, 9, 59, 69, 100, 101, 109, 110, 112, 114, 115, 17238, 17240, 17243, 17248, 17261, 17267, 17279, 17285, 17291, 1, 8834, 59, 1, 10949, 111, 116, 59, 1, 10941, 4, 2, 59, 100, 17254, 17256, 1, 8838, 111, 116, 59, 1, 10947, 117, 108, 116, 59, 1, 10945, 4, 2, 69, 101, 17273, 17276, 59, 1, 10955, 59, 1, 8842, 108, 117, 115, 59, 1, 10943, 97, 114, 114, 59, 1, 10617, 4, 3, 101, 105, 117, 17299, 17335, 17339, 116, 4, 3, 59, 101, 110, 17308, 17310, 17322, 1, 8834, 113, 4, 2, 59, 113, 17317, 17319, 1, 8838, 59, 1, 10949, 101, 113, 4, 2, 59, 113, 17330, 17332, 1, 8842, 59, 1, 10955, 109, 59, 1, 10951, 4, 2, 98, 112, 17345, 17348, 59, 1, 10965, 59, 1, 10963, 99, 4, 6, 59, 97, 99, 101, 110, 115, 17366, 17368, 17376, 17385, 17389, 17415, 1, 8827, 112, 112, 114, 111, 120, 59, 1, 10936, 117, 114, 108, 121, 101, 113, 59, 1, 8829, 113, 59, 1, 10928, 4, 3, 97, 101, 115, 17397, 17405, 17410, 112, 112, 114, 111, 120, 59, 1, 10938, 113, 113, 59, 1, 10934, 105, 109, 59, 1, 8937, 105, 109, 59, 1, 8831, 59, 1, 8721, 103, 59, 1, 9834, 4, 13, 49, 50, 51, 59, 69, 100, 101, 104, 108, 109, 110, 112, 115, 17455, 17462, 17469, 17476, 17478, 17481, 17496, 17509, 17524, 17530, 17536, 17548, 17554, 5, 185, 1, 59, 17460, 1, 185, 5, 178, 1, 59, 17467, 1, 178, 5, 179, 1, 59, 17474, 1, 179, 1, 8835, 59, 1, 10950, 4, 2, 111, 115, 17487, 17491, 116, 59, 1, 10942, 117, 98, 59, 1, 10968, 4, 2, 59, 100, 17502, 17504, 1, 8839, 111, 116, 59, 1, 10948, 115, 4, 2, 111, 117, 17516, 17520, 108, 59, 1, 10185, 98, 59, 1, 10967, 97, 114, 114, 59, 1, 10619, 117, 108, 116, 59, 1, 10946, 4, 2, 69, 101, 17542, 17545, 59, 1, 10956, 59, 1, 8843, 108, 117, 115, 59, 1, 10944, 4, 3, 101, 105, 117, 17562, 17598, 17602, 116, 4, 3, 59, 101, 110, 17571, 17573, 17585, 1, 8835, 113, 4, 2, 59, 113, 17580, 17582, 1, 8839, 59, 1, 10950, 101, 113, 4, 2, 59, 113, 17593, 17595, 1, 8843, 59, 1, 10956, 109, 59, 1, 10952, 4, 2, 98, 112, 17608, 17611, 59, 1, 10964, 59, 1, 10966, 4, 3, 65, 97, 110, 17622, 17627, 17650, 114, 114, 59, 1, 8665, 114, 4, 2, 104, 114, 17634, 17638, 107, 59, 1, 10534, 4, 2, 59, 111, 17644, 17646, 1, 8601, 119, 59, 1, 8601, 119, 97, 114, 59, 1, 10538, 108, 105, 103, 5, 223, 1, 59, 17664, 1, 223, 4, 13, 97, 98, 99, 100, 101, 102, 104, 105, 111, 112, 114, 115, 119, 17694, 17709, 17714, 17737, 17742, 17749, 17754, 17860, 17905, 17957, 17964, 18090, 18122, 4, 2, 114, 117, 17700, 17706, 103, 101, 116, 59, 1, 8982, 59, 1, 964, 114, 107, 59, 1, 9140, 4, 3, 97, 101, 121, 17722, 17728, 17734, 114, 111, 110, 59, 1, 357, 100, 105, 108, 59, 1, 355, 59, 1, 1090, 111, 116, 59, 1, 8411, 108, 114, 101, 99, 59, 1, 8981, 114, 59, 3, 55349, 56625, 4, 4, 101, 105, 107, 111, 17764, 17805, 17836, 17851, 4, 2, 114, 116, 17770, 17786, 101, 4, 2, 52, 102, 17777, 17780, 59, 1, 8756, 111, 114, 101, 59, 1, 8756, 97, 4, 3, 59, 115, 118, 17795, 17797, 17802, 1, 952, 121, 109, 59, 1, 977, 59, 1, 977, 4, 2, 99, 110, 17811, 17831, 107, 4, 2, 97, 115, 17818, 17826, 112, 112, 114, 111, 120, 59, 1, 8776, 105, 109, 59, 1, 8764, 115, 112, 59, 1, 8201, 4, 2, 97, 115, 17842, 17846, 112, 59, 1, 8776, 105, 109, 59, 1, 8764, 114, 110, 5, 254, 1, 59, 17858, 1, 254, 4, 3, 108, 109, 110, 17868, 17873, 17901, 100, 101, 59, 1, 732, 101, 115, 5, 215, 3, 59, 98, 100, 17884, 17886, 17898, 1, 215, 4, 2, 59, 97, 17892, 17894, 1, 8864, 114, 59, 1, 10801, 59, 1, 10800, 116, 59, 1, 8749, 4, 3, 101, 112, 115, 17913, 17917, 17953, 97, 59, 1, 10536, 4, 4, 59, 98, 99, 102, 17927, 17929, 17934, 17939, 1, 8868, 111, 116, 59, 1, 9014, 105, 114, 59, 1, 10993, 4, 2, 59, 111, 17945, 17948, 3, 55349, 56677, 114, 107, 59, 1, 10970, 97, 59, 1, 10537, 114, 105, 109, 101, 59, 1, 8244, 4, 3, 97, 105, 112, 17972, 17977, 18082, 100, 101, 59, 1, 8482, 4, 7, 97, 100, 101, 109, 112, 115, 116, 17993, 18051, 18056, 18059, 18066, 18072, 18076, 110, 103, 108, 101, 4, 5, 59, 100, 108, 113, 114, 18009, 18011, 18017, 18032, 18035, 1, 9653, 111, 119, 110, 59, 1, 9663, 101, 102, 116, 4, 2, 59, 101, 18026, 18028, 1, 9667, 113, 59, 1, 8884, 59, 1, 8796, 105, 103, 104, 116, 4, 2, 59, 101, 18045, 18047, 1, 9657, 113, 59, 1, 8885, 111, 116, 59, 1, 9708, 59, 1, 8796, 105, 110, 117, 115, 59, 1, 10810, 108, 117, 115, 59, 1, 10809, 98, 59, 1, 10701, 105, 109, 101, 59, 1, 10811, 101, 122, 105, 117, 109, 59, 1, 9186, 4, 3, 99, 104, 116, 18098, 18111, 18116, 4, 2, 114, 121, 18104, 18108, 59, 3, 55349, 56521, 59, 1, 1094, 99, 121, 59, 1, 1115, 114, 111, 107, 59, 1, 359, 4, 2, 105, 111, 18128, 18133, 120, 116, 59, 1, 8812, 104, 101, 97, 100, 4, 2, 108, 114, 18143, 18154, 101, 102, 116, 97, 114, 114, 111, 119, 59, 1, 8606, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8608, 4, 18, 65, 72, 97, 98, 99, 100, 102, 103, 104, 108, 109, 111, 112, 114, 115, 116, 117, 119, 18204, 18209, 18214, 18234, 18250, 18268, 18292, 18308, 18319, 18343, 18379, 18397, 18413, 18504, 18547, 18553, 18584, 18603, 114, 114, 59, 1, 8657, 97, 114, 59, 1, 10595, 4, 2, 99, 114, 18220, 18230, 117, 116, 101, 5, 250, 1, 59, 18228, 1, 250, 114, 59, 1, 8593, 114, 4, 2, 99, 101, 18241, 18245, 121, 59, 1, 1118, 118, 101, 59, 1, 365, 4, 2, 105, 121, 18256, 18265, 114, 99, 5, 251, 1, 59, 18263, 1, 251, 59, 1, 1091, 4, 3, 97, 98, 104, 18276, 18281, 18287, 114, 114, 59, 1, 8645, 108, 97, 99, 59, 1, 369, 97, 114, 59, 1, 10606, 4, 2, 105, 114, 18298, 18304, 115, 104, 116, 59, 1, 10622, 59, 3, 55349, 56626, 114, 97, 118, 101, 5, 249, 1, 59, 18317, 1, 249, 4, 2, 97, 98, 18325, 18338, 114, 4, 2, 108, 114, 18332, 18335, 59, 1, 8639, 59, 1, 8638, 108, 107, 59, 1, 9600, 4, 2, 99, 116, 18349, 18374, 4, 2, 111, 114, 18355, 18369, 114, 110, 4, 2, 59, 101, 18363, 18365, 1, 8988, 114, 59, 1, 8988, 111, 112, 59, 1, 8975, 114, 105, 59, 1, 9720, 4, 2, 97, 108, 18385, 18390, 99, 114, 59, 1, 363, 5, 168, 1, 59, 18395, 1, 168, 4, 2, 103, 112, 18403, 18408, 111, 110, 59, 1, 371, 102, 59, 3, 55349, 56678, 4, 6, 97, 100, 104, 108, 115, 117, 18427, 18434, 18445, 18470, 18475, 18494, 114, 114, 111, 119, 59, 1, 8593, 111, 119, 110, 97, 114, 114, 111, 119, 59, 1, 8597, 97, 114, 112, 111, 111, 110, 4, 2, 108, 114, 18457, 18463, 101, 102, 116, 59, 1, 8639, 105, 103, 104, 116, 59, 1, 8638, 117, 115, 59, 1, 8846, 105, 4, 3, 59, 104, 108, 18484, 18486, 18489, 1, 965, 59, 1, 978, 111, 110, 59, 1, 965, 112, 97, 114, 114, 111, 119, 115, 59, 1, 8648, 4, 3, 99, 105, 116, 18512, 18537, 18542, 4, 2, 111, 114, 18518, 18532, 114, 110, 4, 2, 59, 101, 18526, 18528, 1, 8989, 114, 59, 1, 8989, 111, 112, 59, 1, 8974, 110, 103, 59, 1, 367, 114, 105, 59, 1, 9721, 99, 114, 59, 3, 55349, 56522, 4, 3, 100, 105, 114, 18561, 18566, 18572, 111, 116, 59, 1, 8944, 108, 100, 101, 59, 1, 361, 105, 4, 2, 59, 102, 18579, 18581, 1, 9653, 59, 1, 9652, 4, 2, 97, 109, 18590, 18595, 114, 114, 59, 1, 8648, 108, 5, 252, 1, 59, 18601, 1, 252, 97, 110, 103, 108, 101, 59, 1, 10663, 4, 15, 65, 66, 68, 97, 99, 100, 101, 102, 108, 110, 111, 112, 114, 115, 122, 18643, 18648, 18661, 18667, 18847, 18851, 18857, 18904, 18909, 18915, 18931, 18937, 18943, 18949, 18996, 114, 114, 59, 1, 8661, 97, 114, 4, 2, 59, 118, 18656, 18658, 1, 10984, 59, 1, 10985, 97, 115, 104, 59, 1, 8872, 4, 2, 110, 114, 18673, 18679, 103, 114, 116, 59, 1, 10652, 4, 7, 101, 107, 110, 112, 114, 115, 116, 18695, 18704, 18711, 18720, 18742, 18754, 18810, 112, 115, 105, 108, 111, 110, 59, 1, 1013, 97, 112, 112, 97, 59, 1, 1008, 111, 116, 104, 105, 110, 103, 59, 1, 8709, 4, 3, 104, 105, 114, 18728, 18732, 18735, 105, 59, 1, 981, 59, 1, 982, 111, 112, 116, 111, 59, 1, 8733, 4, 2, 59, 104, 18748, 18750, 1, 8597, 111, 59, 1, 1009, 4, 2, 105, 117, 18760, 18766, 103, 109, 97, 59, 1, 962, 4, 2, 98, 112, 18772, 18791, 115, 101, 116, 110, 101, 113, 4, 2, 59, 113, 18784, 18787, 3, 8842, 65024, 59, 3, 10955, 65024, 115, 101, 116, 110, 101, 113, 4, 2, 59, 113, 18803, 18806, 3, 8843, 65024, 59, 3, 10956, 65024, 4, 2, 104, 114, 18816, 18822, 101, 116, 97, 59, 1, 977, 105, 97, 110, 103, 108, 101, 4, 2, 108, 114, 18834, 18840, 101, 102, 116, 59, 1, 8882, 105, 103, 104, 116, 59, 1, 8883, 121, 59, 1, 1074, 97, 115, 104, 59, 1, 8866, 4, 3, 101, 108, 114, 18865, 18884, 18890, 4, 3, 59, 98, 101, 18873, 18875, 18880, 1, 8744, 97, 114, 59, 1, 8891, 113, 59, 1, 8794, 108, 105, 112, 59, 1, 8942, 4, 2, 98, 116, 18896, 18901, 97, 114, 59, 1, 124, 59, 1, 124, 114, 59, 3, 55349, 56627, 116, 114, 105, 59, 1, 8882, 115, 117, 4, 2, 98, 112, 18923, 18927, 59, 3, 8834, 8402, 59, 3, 8835, 8402, 112, 102, 59, 3, 55349, 56679, 114, 111, 112, 59, 1, 8733, 116, 114, 105, 59, 1, 8883, 4, 2, 99, 117, 18955, 18960, 114, 59, 3, 55349, 56523, 4, 2, 98, 112, 18966, 18981, 110, 4, 2, 69, 101, 18973, 18977, 59, 3, 10955, 65024, 59, 3, 8842, 65024, 110, 4, 2, 69, 101, 18988, 18992, 59, 3, 10956, 65024, 59, 3, 8843, 65024, 105, 103, 122, 97, 103, 59, 1, 10650, 4, 7, 99, 101, 102, 111, 112, 114, 115, 19020, 19026, 19061, 19066, 19072, 19075, 19089, 105, 114, 99, 59, 1, 373, 4, 2, 100, 105, 19032, 19055, 4, 2, 98, 103, 19038, 19043, 97, 114, 59, 1, 10847, 101, 4, 2, 59, 113, 19050, 19052, 1, 8743, 59, 1, 8793, 101, 114, 112, 59, 1, 8472, 114, 59, 3, 55349, 56628, 112, 102, 59, 3, 55349, 56680, 59, 1, 8472, 4, 2, 59, 101, 19081, 19083, 1, 8768, 97, 116, 104, 59, 1, 8768, 99, 114, 59, 3, 55349, 56524, 4, 14, 99, 100, 102, 104, 105, 108, 109, 110, 111, 114, 115, 117, 118, 119, 19125, 19146, 19152, 19157, 19173, 19176, 19192, 19197, 19202, 19236, 19252, 19269, 19286, 19291, 4, 3, 97, 105, 117, 19133, 19137, 19142, 112, 59, 1, 8898, 114, 99, 59, 1, 9711, 112, 59, 1, 8899, 116, 114, 105, 59, 1, 9661, 114, 59, 3, 55349, 56629, 4, 2, 65, 97, 19163, 19168, 114, 114, 59, 1, 10234, 114, 114, 59, 1, 10231, 59, 1, 958, 4, 2, 65, 97, 19182, 19187, 114, 114, 59, 1, 10232, 114, 114, 59, 1, 10229, 97, 112, 59, 1, 10236, 105, 115, 59, 1, 8955, 4, 3, 100, 112, 116, 19210, 19215, 19230, 111, 116, 59, 1, 10752, 4, 2, 102, 108, 19221, 19225, 59, 3, 55349, 56681, 117, 115, 59, 1, 10753, 105, 109, 101, 59, 1, 10754, 4, 2, 65, 97, 19242, 19247, 114, 114, 59, 1, 10233, 114, 114, 59, 1, 10230, 4, 2, 99, 113, 19258, 19263, 114, 59, 3, 55349, 56525, 99, 117, 112, 59, 1, 10758, 4, 2, 112, 116, 19275, 19281, 108, 117, 115, 59, 1, 10756, 114, 105, 59, 1, 9651, 101, 101, 59, 1, 8897, 101, 100, 103, 101, 59, 1, 8896, 4, 8, 97, 99, 101, 102, 105, 111, 115, 117, 19316, 19335, 19349, 19357, 19362, 19367, 19373, 19379, 99, 4, 2, 117, 121, 19323, 19332, 116, 101, 5, 253, 1, 59, 19330, 1, 253, 59, 1, 1103, 4, 2, 105, 121, 19341, 19346, 114, 99, 59, 1, 375, 59, 1, 1099, 110, 5, 165, 1, 59, 19355, 1, 165, 114, 59, 3, 55349, 56630, 99, 121, 59, 1, 1111, 112, 102, 59, 3, 55349, 56682, 99, 114, 59, 3, 55349, 56526, 4, 2, 99, 109, 19385, 19389, 121, 59, 1, 1102, 108, 5, 255, 1, 59, 19395, 1, 255, 4, 10, 97, 99, 100, 101, 102, 104, 105, 111, 115, 119, 19419, 19426, 19441, 19446, 19462, 19467, 19472, 19480, 19486, 19492, 99, 117, 116, 101, 59, 1, 378, 4, 2, 97, 121, 19432, 19438, 114, 111, 110, 59, 1, 382, 59, 1, 1079, 111, 116, 59, 1, 380, 4, 2, 101, 116, 19452, 19458, 116, 114, 102, 59, 1, 8488, 97, 59, 1, 950, 114, 59, 3, 55349, 56631, 99, 121, 59, 1, 1078, 103, 114, 97, 114, 114, 59, 1, 8669, 112, 102, 59, 3, 55349, 56683, 99, 114, 59, 3, 55349, 56527, 4, 2, 106, 110, 19498, 19501, 59, 1, 8205, 106, 59, 1, 8204])), jm;
}
var zl, qm;
function Vs() {
  if (qm) return zl;
  qm = 1;
  const e = BP(), t = F0(), n = jP(), r = R0(), o = t.CODE_POINTS, i = t.CODE_POINT_SEQUENCES, a = {
    128: 8364,
    130: 8218,
    131: 402,
    132: 8222,
    133: 8230,
    134: 8224,
    135: 8225,
    136: 710,
    137: 8240,
    138: 352,
    139: 8249,
    140: 338,
    142: 381,
    145: 8216,
    146: 8217,
    147: 8220,
    148: 8221,
    149: 8226,
    150: 8211,
    151: 8212,
    152: 732,
    153: 8482,
    154: 353,
    155: 8250,
    156: 339,
    158: 382,
    159: 376
  }, s = 1, l = 2, u = 4, m = s | l | u, v = "DATA_STATE", g = "RCDATA_STATE", h = "RAWTEXT_STATE", E = "SCRIPT_DATA_STATE", C = "PLAINTEXT_STATE", A = "TAG_OPEN_STATE", R = "END_TAG_OPEN_STATE", P = "TAG_NAME_STATE", F = "RCDATA_LESS_THAN_SIGN_STATE", I = "RCDATA_END_TAG_OPEN_STATE", D = "RCDATA_END_TAG_NAME_STATE", O = "RAWTEXT_LESS_THAN_SIGN_STATE", U = "RAWTEXT_END_TAG_OPEN_STATE", q = "RAWTEXT_END_TAG_NAME_STATE", z = "SCRIPT_DATA_LESS_THAN_SIGN_STATE", te = "SCRIPT_DATA_END_TAG_OPEN_STATE", ee = "SCRIPT_DATA_END_TAG_NAME_STATE", x = "SCRIPT_DATA_ESCAPE_START_STATE", N = "SCRIPT_DATA_ESCAPE_START_DASH_STATE", G = "SCRIPT_DATA_ESCAPED_STATE", X = "SCRIPT_DATA_ESCAPED_DASH_STATE", Q = "SCRIPT_DATA_ESCAPED_DASH_DASH_STATE", re = "SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE", se = "SCRIPT_DATA_ESCAPED_END_TAG_OPEN_STATE", de = "SCRIPT_DATA_ESCAPED_END_TAG_NAME_STATE", me = "SCRIPT_DATA_DOUBLE_ESCAPE_START_STATE", he = "SCRIPT_DATA_DOUBLE_ESCAPED_STATE", _e = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH_STATE", De = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH_STATE", Ae = "SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE", Ze = "SCRIPT_DATA_DOUBLE_ESCAPE_END_STATE", Je = "BEFORE_ATTRIBUTE_NAME_STATE", Mt = "ATTRIBUTE_NAME_STATE", Vt = "AFTER_ATTRIBUTE_NAME_STATE", pn = "BEFORE_ATTRIBUTE_VALUE_STATE", gn = "ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE", vn = "ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE", bn = "ATTRIBUTE_VALUE_UNQUOTED_STATE", Dn = "AFTER_ATTRIBUTE_VALUE_QUOTED_STATE", At = "SELF_CLOSING_START_TAG_STATE", ce = "BOGUS_COMMENT_STATE", It = "MARKUP_DECLARATION_OPEN_STATE", le = "COMMENT_START_STATE", fe = "COMMENT_START_DASH_STATE", Pe = "COMMENT_STATE", Ve = "COMMENT_LESS_THAN_SIGN_STATE", Lt = "COMMENT_LESS_THAN_SIGN_BANG_STATE", xe = "COMMENT_LESS_THAN_SIGN_BANG_DASH_STATE", be = "COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH_STATE", et = "COMMENT_END_DASH_STATE", mt = "COMMENT_END_STATE", Xt = "COMMENT_END_BANG_STATE", yn = "DOCTYPE_STATE", tt = "BEFORE_DOCTYPE_NAME_STATE", ft = "DOCTYPE_NAME_STATE", _n = "AFTER_DOCTYPE_NAME_STATE", Yn = "AFTER_DOCTYPE_PUBLIC_KEYWORD_STATE", Dt = "BEFORE_DOCTYPE_PUBLIC_IDENTIFIER_STATE", Ce = "DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED_STATE", Ne = "DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED_STATE", $n = "AFTER_DOCTYPE_PUBLIC_IDENTIFIER_STATE", Mi = "BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS_STATE", Ai = "AFTER_DOCTYPE_SYSTEM_KEYWORD_STATE", Xn = "BEFORE_DOCTYPE_SYSTEM_IDENTIFIER_STATE", gr = "DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE", vr = "DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE", On = "AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE", dt = "BOGUS_DOCTYPE_STATE", Pn = "CDATA_SECTION_STATE", Ii = "CDATA_SECTION_BRACKET_STATE", Li = "CDATA_SECTION_END_STATE", Qn = "CHARACTER_REFERENCE_STATE", Qt = "NAMED_CHARACTER_REFERENCE_STATE", Di = "AMBIGUOS_AMPERSAND_STATE", $o = "NUMERIC_CHARACTER_REFERENCE_STATE", $i = "HEXADEMICAL_CHARACTER_REFERENCE_START_STATE", Oi = "DECIMAL_CHARACTER_REFERENCE_START_STATE", Pi = "HEXADEMICAL_CHARACTER_REFERENCE_STATE", Ni = "DECIMAL_CHARACTER_REFERENCE_STATE", br = "NUMERIC_CHARACTER_REFERENCE_END_STATE";
  function Me(ve) {
    return ve === o.SPACE || ve === o.LINE_FEED || ve === o.TABULATION || ve === o.FORM_FEED;
  }
  function yr(ve) {
    return ve >= o.DIGIT_0 && ve <= o.DIGIT_9;
  }
  function $t(ve) {
    return ve >= o.LATIN_CAPITAL_A && ve <= o.LATIN_CAPITAL_Z;
  }
  function Nn(ve) {
    return ve >= o.LATIN_SMALL_A && ve <= o.LATIN_SMALL_Z;
  }
  function Ct(ve) {
    return Nn(ve) || $t(ve);
  }
  function Oo(ve) {
    return Ct(ve) || yr(ve);
  }
  function Po(ve) {
    return ve >= o.LATIN_CAPITAL_A && ve <= o.LATIN_CAPITAL_F;
  }
  function Hi(ve) {
    return ve >= o.LATIN_SMALL_A && ve <= o.LATIN_SMALL_F;
  }
  function ta(ve) {
    return yr(ve) || Po(ve) || Hi(ve);
  }
  function Qr(ve) {
    return ve + 32;
  }
  function Ue(ve) {
    return ve <= 65535 ? String.fromCharCode(ve) : (ve -= 65536, String.fromCharCode(ve >>> 10 & 1023 | 55296) + String.fromCharCode(56320 | ve & 1023));
  }
  function Cn(ve) {
    return String.fromCharCode(Qr(ve));
  }
  function No(ve, w) {
    const Te = n[++ve];
    let wt = ++ve, at = wt + Te - 1;
    for (; wt <= at; ) {
      const ct = wt + at >>> 1, nt = n[ct];
      if (nt < w)
        wt = ct + 1;
      else if (nt > w)
        at = ct - 1;
      else
        return n[ct + Te];
    }
    return -1;
  }
  class $e {
    constructor() {
      this.preprocessor = new e(), this.tokenQueue = [], this.allowCDATA = !1, this.state = v, this.returnState = "", this.charRefCode = -1, this.tempBuff = [], this.lastStartTagName = "", this.consumedAfterSnapshot = -1, this.active = !1, this.currentCharacterToken = null, this.currentToken = null, this.currentAttr = null;
    }
    //Errors
    _err() {
    }
    _errOnNextCodePoint(w) {
      this._consume(), this._err(w), this._unconsume();
    }
    //API
    getNextToken() {
      for (; !this.tokenQueue.length && this.active; ) {
        this.consumedAfterSnapshot = 0;
        const w = this._consume();
        this._ensureHibernation() || this[this.state](w);
      }
      return this.tokenQueue.shift();
    }
    write(w, Te) {
      this.active = !0, this.preprocessor.write(w, Te);
    }
    insertHtmlAtCurrentPos(w) {
      this.active = !0, this.preprocessor.insertHtmlAtCurrentPos(w);
    }
    //Hibernation
    _ensureHibernation() {
      if (this.preprocessor.endOfChunkHit) {
        for (; this.consumedAfterSnapshot > 0; this.consumedAfterSnapshot--)
          this.preprocessor.retreat();
        return this.active = !1, this.tokenQueue.push({ type: $e.HIBERNATION_TOKEN }), !0;
      }
      return !1;
    }
    //Consumption
    _consume() {
      return this.consumedAfterSnapshot++, this.preprocessor.advance();
    }
    _unconsume() {
      this.consumedAfterSnapshot--, this.preprocessor.retreat();
    }
    _reconsumeInState(w) {
      this.state = w, this._unconsume();
    }
    _consumeSequenceIfMatch(w, Te, wt) {
      let at = 0, ct = !0;
      const nt = w.length;
      let qe = 0, Jr = Te, Ho;
      for (; qe < nt; qe++) {
        if (qe > 0 && (Jr = this._consume(), at++), Jr === o.EOF) {
          ct = !1;
          break;
        }
        if (Ho = w[qe], Jr !== Ho && (wt || Jr !== Qr(Ho))) {
          ct = !1;
          break;
        }
      }
      if (!ct)
        for (; at--; )
          this._unconsume();
      return ct;
    }
    //Temp buffer
    _isTempBufferEqualToScriptString() {
      if (this.tempBuff.length !== i.SCRIPT_STRING.length)
        return !1;
      for (let w = 0; w < this.tempBuff.length; w++)
        if (this.tempBuff[w] !== i.SCRIPT_STRING[w])
          return !1;
      return !0;
    }
    //Token creation
    _createStartTagToken() {
      this.currentToken = {
        type: $e.START_TAG_TOKEN,
        tagName: "",
        selfClosing: !1,
        ackSelfClosing: !1,
        attrs: []
      };
    }
    _createEndTagToken() {
      this.currentToken = {
        type: $e.END_TAG_TOKEN,
        tagName: "",
        selfClosing: !1,
        attrs: []
      };
    }
    _createCommentToken() {
      this.currentToken = {
        type: $e.COMMENT_TOKEN,
        data: ""
      };
    }
    _createDoctypeToken(w) {
      this.currentToken = {
        type: $e.DOCTYPE_TOKEN,
        name: w,
        forceQuirks: !1,
        publicId: null,
        systemId: null
      };
    }
    _createCharacterToken(w, Te) {
      this.currentCharacterToken = {
        type: w,
        chars: Te
      };
    }
    _createEOFToken() {
      this.currentToken = { type: $e.EOF_TOKEN };
    }
    //Tag attributes
    _createAttr(w) {
      this.currentAttr = {
        name: w,
        value: ""
      };
    }
    _leaveAttrName(w) {
      $e.getTokenAttr(this.currentToken, this.currentAttr.name) === null ? this.currentToken.attrs.push(this.currentAttr) : this._err(r.duplicateAttribute), this.state = w;
    }
    _leaveAttrValue(w) {
      this.state = w;
    }
    //Token emission
    _emitCurrentToken() {
      this._emitCurrentCharacterToken();
      const w = this.currentToken;
      this.currentToken = null, w.type === $e.START_TAG_TOKEN ? this.lastStartTagName = w.tagName : w.type === $e.END_TAG_TOKEN && (w.attrs.length > 0 && this._err(r.endTagWithAttributes), w.selfClosing && this._err(r.endTagWithTrailingSolidus)), this.tokenQueue.push(w);
    }
    _emitCurrentCharacterToken() {
      this.currentCharacterToken && (this.tokenQueue.push(this.currentCharacterToken), this.currentCharacterToken = null);
    }
    _emitEOFToken() {
      this._createEOFToken(), this._emitCurrentToken();
    }
    //Characters emission
    //OPTIMIZATION: specification uses only one type of character tokens (one token per character).
    //This causes a huge memory overhead and a lot of unnecessary parser loops. parse5 uses 3 groups of characters.
    //If we have a sequence of characters that belong to the same group, parser can process it
    //as a single solid character token.
    //So, there are 3 types of character tokens in parse5:
    //1)NULL_CHARACTER_TOKEN - \u0000-character sequences (e.g. '\u0000\u0000\u0000')
    //2)WHITESPACE_CHARACTER_TOKEN - any whitespace/new-line character sequences (e.g. '\n  \r\t   \f')
    //3)CHARACTER_TOKEN - any character sequence which don't belong to groups 1 and 2 (e.g. 'abcdef1234@@#$%^')
    _appendCharToCurrentCharacterToken(w, Te) {
      this.currentCharacterToken && this.currentCharacterToken.type !== w && this._emitCurrentCharacterToken(), this.currentCharacterToken ? this.currentCharacterToken.chars += Te : this._createCharacterToken(w, Te);
    }
    _emitCodePoint(w) {
      let Te = $e.CHARACTER_TOKEN;
      Me(w) ? Te = $e.WHITESPACE_CHARACTER_TOKEN : w === o.NULL && (Te = $e.NULL_CHARACTER_TOKEN), this._appendCharToCurrentCharacterToken(Te, Ue(w));
    }
    _emitSeveralCodePoints(w) {
      for (let Te = 0; Te < w.length; Te++)
        this._emitCodePoint(w[Te]);
    }
    //NOTE: used then we emit character explicitly. This is always a non-whitespace and a non-null character.
    //So we can avoid additional checks here.
    _emitChars(w) {
      this._appendCharToCurrentCharacterToken($e.CHARACTER_TOKEN, w);
    }
    // Character reference helpers
    _matchNamedCharacterReference(w) {
      let Te = null, wt = 1, at = No(0, w);
      for (this.tempBuff.push(w); at > -1; ) {
        const ct = n[at], nt = ct < m;
        nt && ct & s && (Te = ct & l ? [n[++at], n[++at]] : [n[++at]], wt = 0);
        const qe = this._consume();
        if (this.tempBuff.push(qe), wt++, qe === o.EOF)
          break;
        nt ? at = ct & u ? No(at, qe) : -1 : at = qe === ct ? ++at : -1;
      }
      for (; wt--; )
        this.tempBuff.pop(), this._unconsume();
      return Te;
    }
    _isCharacterReferenceInAttribute() {
      return this.returnState === gn || this.returnState === vn || this.returnState === bn;
    }
    _isCharacterReferenceAttributeQuirk(w) {
      if (!w && this._isCharacterReferenceInAttribute()) {
        const Te = this._consume();
        return this._unconsume(), Te === o.EQUALS_SIGN || Oo(Te);
      }
      return !1;
    }
    _flushCodePointsConsumedAsCharacterReference() {
      if (this._isCharacterReferenceInAttribute())
        for (let w = 0; w < this.tempBuff.length; w++)
          this.currentAttr.value += Ue(this.tempBuff[w]);
      else
        this._emitSeveralCodePoints(this.tempBuff);
      this.tempBuff = [];
    }
    // State machine
    // Data state
    //------------------------------------------------------------------
    [v](w) {
      this.preprocessor.dropParsedChunk(), w === o.LESS_THAN_SIGN ? this.state = A : w === o.AMPERSAND ? (this.returnState = v, this.state = Qn) : w === o.NULL ? (this._err(r.unexpectedNullCharacter), this._emitCodePoint(w)) : w === o.EOF ? this._emitEOFToken() : this._emitCodePoint(w);
    }
    //  RCDATA state
    //------------------------------------------------------------------
    [g](w) {
      this.preprocessor.dropParsedChunk(), w === o.AMPERSAND ? (this.returnState = g, this.state = Qn) : w === o.LESS_THAN_SIGN ? this.state = F : w === o.NULL ? (this._err(r.unexpectedNullCharacter), this._emitChars(t.REPLACEMENT_CHARACTER)) : w === o.EOF ? this._emitEOFToken() : this._emitCodePoint(w);
    }
    // RAWTEXT state
    //------------------------------------------------------------------
    [h](w) {
      this.preprocessor.dropParsedChunk(), w === o.LESS_THAN_SIGN ? this.state = O : w === o.NULL ? (this._err(r.unexpectedNullCharacter), this._emitChars(t.REPLACEMENT_CHARACTER)) : w === o.EOF ? this._emitEOFToken() : this._emitCodePoint(w);
    }
    // Script data state
    //------------------------------------------------------------------
    [E](w) {
      this.preprocessor.dropParsedChunk(), w === o.LESS_THAN_SIGN ? this.state = z : w === o.NULL ? (this._err(r.unexpectedNullCharacter), this._emitChars(t.REPLACEMENT_CHARACTER)) : w === o.EOF ? this._emitEOFToken() : this._emitCodePoint(w);
    }
    // PLAINTEXT state
    //------------------------------------------------------------------
    [C](w) {
      this.preprocessor.dropParsedChunk(), w === o.NULL ? (this._err(r.unexpectedNullCharacter), this._emitChars(t.REPLACEMENT_CHARACTER)) : w === o.EOF ? this._emitEOFToken() : this._emitCodePoint(w);
    }
    // Tag open state
    //------------------------------------------------------------------
    [A](w) {
      w === o.EXCLAMATION_MARK ? this.state = It : w === o.SOLIDUS ? this.state = R : Ct(w) ? (this._createStartTagToken(), this._reconsumeInState(P)) : w === o.QUESTION_MARK ? (this._err(r.unexpectedQuestionMarkInsteadOfTagName), this._createCommentToken(), this._reconsumeInState(ce)) : w === o.EOF ? (this._err(r.eofBeforeTagName), this._emitChars("<"), this._emitEOFToken()) : (this._err(r.invalidFirstCharacterOfTagName), this._emitChars("<"), this._reconsumeInState(v));
    }
    // End tag open state
    //------------------------------------------------------------------
    [R](w) {
      Ct(w) ? (this._createEndTagToken(), this._reconsumeInState(P)) : w === o.GREATER_THAN_SIGN ? (this._err(r.missingEndTagName), this.state = v) : w === o.EOF ? (this._err(r.eofBeforeTagName), this._emitChars("</"), this._emitEOFToken()) : (this._err(r.invalidFirstCharacterOfTagName), this._createCommentToken(), this._reconsumeInState(ce));
    }
    // Tag name state
    //------------------------------------------------------------------
    [P](w) {
      Me(w) ? this.state = Je : w === o.SOLIDUS ? this.state = At : w === o.GREATER_THAN_SIGN ? (this.state = v, this._emitCurrentToken()) : $t(w) ? this.currentToken.tagName += Cn(w) : w === o.NULL ? (this._err(r.unexpectedNullCharacter), this.currentToken.tagName += t.REPLACEMENT_CHARACTER) : w === o.EOF ? (this._err(r.eofInTag), this._emitEOFToken()) : this.currentToken.tagName += Ue(w);
    }
    // RCDATA less-than sign state
    //------------------------------------------------------------------
    [F](w) {
      w === o.SOLIDUS ? (this.tempBuff = [], this.state = I) : (this._emitChars("<"), this._reconsumeInState(g));
    }
    // RCDATA end tag open state
    //------------------------------------------------------------------
    [I](w) {
      Ct(w) ? (this._createEndTagToken(), this._reconsumeInState(D)) : (this._emitChars("</"), this._reconsumeInState(g));
    }
    // RCDATA end tag name state
    //------------------------------------------------------------------
    [D](w) {
      if ($t(w))
        this.currentToken.tagName += Cn(w), this.tempBuff.push(w);
      else if (Nn(w))
        this.currentToken.tagName += Ue(w), this.tempBuff.push(w);
      else {
        if (this.lastStartTagName === this.currentToken.tagName) {
          if (Me(w)) {
            this.state = Je;
            return;
          }
          if (w === o.SOLIDUS) {
            this.state = At;
            return;
          }
          if (w === o.GREATER_THAN_SIGN) {
            this.state = v, this._emitCurrentToken();
            return;
          }
        }
        this._emitChars("</"), this._emitSeveralCodePoints(this.tempBuff), this._reconsumeInState(g);
      }
    }
    // RAWTEXT less-than sign state
    //------------------------------------------------------------------
    [O](w) {
      w === o.SOLIDUS ? (this.tempBuff = [], this.state = U) : (this._emitChars("<"), this._reconsumeInState(h));
    }
    // RAWTEXT end tag open state
    //------------------------------------------------------------------
    [U](w) {
      Ct(w) ? (this._createEndTagToken(), this._reconsumeInState(q)) : (this._emitChars("</"), this._reconsumeInState(h));
    }
    // RAWTEXT end tag name state
    //------------------------------------------------------------------
    [q](w) {
      if ($t(w))
        this.currentToken.tagName += Cn(w), this.tempBuff.push(w);
      else if (Nn(w))
        this.currentToken.tagName += Ue(w), this.tempBuff.push(w);
      else {
        if (this.lastStartTagName === this.currentToken.tagName) {
          if (Me(w)) {
            this.state = Je;
            return;
          }
          if (w === o.SOLIDUS) {
            this.state = At;
            return;
          }
          if (w === o.GREATER_THAN_SIGN) {
            this._emitCurrentToken(), this.state = v;
            return;
          }
        }
        this._emitChars("</"), this._emitSeveralCodePoints(this.tempBuff), this._reconsumeInState(h);
      }
    }
    // Script data less-than sign state
    //------------------------------------------------------------------
    [z](w) {
      w === o.SOLIDUS ? (this.tempBuff = [], this.state = te) : w === o.EXCLAMATION_MARK ? (this.state = x, this._emitChars("<!")) : (this._emitChars("<"), this._reconsumeInState(E));
    }
    // Script data end tag open state
    //------------------------------------------------------------------
    [te](w) {
      Ct(w) ? (this._createEndTagToken(), this._reconsumeInState(ee)) : (this._emitChars("</"), this._reconsumeInState(E));
    }
    // Script data end tag name state
    //------------------------------------------------------------------
    [ee](w) {
      if ($t(w))
        this.currentToken.tagName += Cn(w), this.tempBuff.push(w);
      else if (Nn(w))
        this.currentToken.tagName += Ue(w), this.tempBuff.push(w);
      else {
        if (this.lastStartTagName === this.currentToken.tagName) {
          if (Me(w)) {
            this.state = Je;
            return;
          } else if (w === o.SOLIDUS) {
            this.state = At;
            return;
          } else if (w === o.GREATER_THAN_SIGN) {
            this._emitCurrentToken(), this.state = v;
            return;
          }
        }
        this._emitChars("</"), this._emitSeveralCodePoints(this.tempBuff), this._reconsumeInState(E);
      }
    }
    // Script data escape start state
    //------------------------------------------------------------------
    [x](w) {
      w === o.HYPHEN_MINUS ? (this.state = N, this._emitChars("-")) : this._reconsumeInState(E);
    }
    // Script data escape start dash state
    //------------------------------------------------------------------
    [N](w) {
      w === o.HYPHEN_MINUS ? (this.state = Q, this._emitChars("-")) : this._reconsumeInState(E);
    }
    // Script data escaped state
    //------------------------------------------------------------------
    [G](w) {
      w === o.HYPHEN_MINUS ? (this.state = X, this._emitChars("-")) : w === o.LESS_THAN_SIGN ? this.state = re : w === o.NULL ? (this._err(r.unexpectedNullCharacter), this._emitChars(t.REPLACEMENT_CHARACTER)) : w === o.EOF ? (this._err(r.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : this._emitCodePoint(w);
    }
    // Script data escaped dash state
    //------------------------------------------------------------------
    [X](w) {
      w === o.HYPHEN_MINUS ? (this.state = Q, this._emitChars("-")) : w === o.LESS_THAN_SIGN ? this.state = re : w === o.NULL ? (this._err(r.unexpectedNullCharacter), this.state = G, this._emitChars(t.REPLACEMENT_CHARACTER)) : w === o.EOF ? (this._err(r.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : (this.state = G, this._emitCodePoint(w));
    }
    // Script data escaped dash dash state
    //------------------------------------------------------------------
    [Q](w) {
      w === o.HYPHEN_MINUS ? this._emitChars("-") : w === o.LESS_THAN_SIGN ? this.state = re : w === o.GREATER_THAN_SIGN ? (this.state = E, this._emitChars(">")) : w === o.NULL ? (this._err(r.unexpectedNullCharacter), this.state = G, this._emitChars(t.REPLACEMENT_CHARACTER)) : w === o.EOF ? (this._err(r.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : (this.state = G, this._emitCodePoint(w));
    }
    // Script data escaped less-than sign state
    //------------------------------------------------------------------
    [re](w) {
      w === o.SOLIDUS ? (this.tempBuff = [], this.state = se) : Ct(w) ? (this.tempBuff = [], this._emitChars("<"), this._reconsumeInState(me)) : (this._emitChars("<"), this._reconsumeInState(G));
    }
    // Script data escaped end tag open state
    //------------------------------------------------------------------
    [se](w) {
      Ct(w) ? (this._createEndTagToken(), this._reconsumeInState(de)) : (this._emitChars("</"), this._reconsumeInState(G));
    }
    // Script data escaped end tag name state
    //------------------------------------------------------------------
    [de](w) {
      if ($t(w))
        this.currentToken.tagName += Cn(w), this.tempBuff.push(w);
      else if (Nn(w))
        this.currentToken.tagName += Ue(w), this.tempBuff.push(w);
      else {
        if (this.lastStartTagName === this.currentToken.tagName) {
          if (Me(w)) {
            this.state = Je;
            return;
          }
          if (w === o.SOLIDUS) {
            this.state = At;
            return;
          }
          if (w === o.GREATER_THAN_SIGN) {
            this._emitCurrentToken(), this.state = v;
            return;
          }
        }
        this._emitChars("</"), this._emitSeveralCodePoints(this.tempBuff), this._reconsumeInState(G);
      }
    }
    // Script data double escape start state
    //------------------------------------------------------------------
    [me](w) {
      Me(w) || w === o.SOLIDUS || w === o.GREATER_THAN_SIGN ? (this.state = this._isTempBufferEqualToScriptString() ? he : G, this._emitCodePoint(w)) : $t(w) ? (this.tempBuff.push(Qr(w)), this._emitCodePoint(w)) : Nn(w) ? (this.tempBuff.push(w), this._emitCodePoint(w)) : this._reconsumeInState(G);
    }
    // Script data double escaped state
    //------------------------------------------------------------------
    [he](w) {
      w === o.HYPHEN_MINUS ? (this.state = _e, this._emitChars("-")) : w === o.LESS_THAN_SIGN ? (this.state = Ae, this._emitChars("<")) : w === o.NULL ? (this._err(r.unexpectedNullCharacter), this._emitChars(t.REPLACEMENT_CHARACTER)) : w === o.EOF ? (this._err(r.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : this._emitCodePoint(w);
    }
    // Script data double escaped dash state
    //------------------------------------------------------------------
    [_e](w) {
      w === o.HYPHEN_MINUS ? (this.state = De, this._emitChars("-")) : w === o.LESS_THAN_SIGN ? (this.state = Ae, this._emitChars("<")) : w === o.NULL ? (this._err(r.unexpectedNullCharacter), this.state = he, this._emitChars(t.REPLACEMENT_CHARACTER)) : w === o.EOF ? (this._err(r.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : (this.state = he, this._emitCodePoint(w));
    }
    // Script data double escaped dash dash state
    //------------------------------------------------------------------
    [De](w) {
      w === o.HYPHEN_MINUS ? this._emitChars("-") : w === o.LESS_THAN_SIGN ? (this.state = Ae, this._emitChars("<")) : w === o.GREATER_THAN_SIGN ? (this.state = E, this._emitChars(">")) : w === o.NULL ? (this._err(r.unexpectedNullCharacter), this.state = he, this._emitChars(t.REPLACEMENT_CHARACTER)) : w === o.EOF ? (this._err(r.eofInScriptHtmlCommentLikeText), this._emitEOFToken()) : (this.state = he, this._emitCodePoint(w));
    }
    // Script data double escaped less-than sign state
    //------------------------------------------------------------------
    [Ae](w) {
      w === o.SOLIDUS ? (this.tempBuff = [], this.state = Ze, this._emitChars("/")) : this._reconsumeInState(he);
    }
    // Script data double escape end state
    //------------------------------------------------------------------
    [Ze](w) {
      Me(w) || w === o.SOLIDUS || w === o.GREATER_THAN_SIGN ? (this.state = this._isTempBufferEqualToScriptString() ? G : he, this._emitCodePoint(w)) : $t(w) ? (this.tempBuff.push(Qr(w)), this._emitCodePoint(w)) : Nn(w) ? (this.tempBuff.push(w), this._emitCodePoint(w)) : this._reconsumeInState(he);
    }
    // Before attribute name state
    //------------------------------------------------------------------
    [Je](w) {
      Me(w) || (w === o.SOLIDUS || w === o.GREATER_THAN_SIGN || w === o.EOF ? this._reconsumeInState(Vt) : w === o.EQUALS_SIGN ? (this._err(r.unexpectedEqualsSignBeforeAttributeName), this._createAttr("="), this.state = Mt) : (this._createAttr(""), this._reconsumeInState(Mt)));
    }
    // Attribute name state
    //------------------------------------------------------------------
    [Mt](w) {
      Me(w) || w === o.SOLIDUS || w === o.GREATER_THAN_SIGN || w === o.EOF ? (this._leaveAttrName(Vt), this._unconsume()) : w === o.EQUALS_SIGN ? this._leaveAttrName(pn) : $t(w) ? this.currentAttr.name += Cn(w) : w === o.QUOTATION_MARK || w === o.APOSTROPHE || w === o.LESS_THAN_SIGN ? (this._err(r.unexpectedCharacterInAttributeName), this.currentAttr.name += Ue(w)) : w === o.NULL ? (this._err(r.unexpectedNullCharacter), this.currentAttr.name += t.REPLACEMENT_CHARACTER) : this.currentAttr.name += Ue(w);
    }
    // After attribute name state
    //------------------------------------------------------------------
    [Vt](w) {
      Me(w) || (w === o.SOLIDUS ? this.state = At : w === o.EQUALS_SIGN ? this.state = pn : w === o.GREATER_THAN_SIGN ? (this.state = v, this._emitCurrentToken()) : w === o.EOF ? (this._err(r.eofInTag), this._emitEOFToken()) : (this._createAttr(""), this._reconsumeInState(Mt)));
    }
    // Before attribute value state
    //------------------------------------------------------------------
    [pn](w) {
      Me(w) || (w === o.QUOTATION_MARK ? this.state = gn : w === o.APOSTROPHE ? this.state = vn : w === o.GREATER_THAN_SIGN ? (this._err(r.missingAttributeValue), this.state = v, this._emitCurrentToken()) : this._reconsumeInState(bn));
    }
    // Attribute value (double-quoted) state
    //------------------------------------------------------------------
    [gn](w) {
      w === o.QUOTATION_MARK ? this.state = Dn : w === o.AMPERSAND ? (this.returnState = gn, this.state = Qn) : w === o.NULL ? (this._err(r.unexpectedNullCharacter), this.currentAttr.value += t.REPLACEMENT_CHARACTER) : w === o.EOF ? (this._err(r.eofInTag), this._emitEOFToken()) : this.currentAttr.value += Ue(w);
    }
    // Attribute value (single-quoted) state
    //------------------------------------------------------------------
    [vn](w) {
      w === o.APOSTROPHE ? this.state = Dn : w === o.AMPERSAND ? (this.returnState = vn, this.state = Qn) : w === o.NULL ? (this._err(r.unexpectedNullCharacter), this.currentAttr.value += t.REPLACEMENT_CHARACTER) : w === o.EOF ? (this._err(r.eofInTag), this._emitEOFToken()) : this.currentAttr.value += Ue(w);
    }
    // Attribute value (unquoted) state
    //------------------------------------------------------------------
    [bn](w) {
      Me(w) ? this._leaveAttrValue(Je) : w === o.AMPERSAND ? (this.returnState = bn, this.state = Qn) : w === o.GREATER_THAN_SIGN ? (this._leaveAttrValue(v), this._emitCurrentToken()) : w === o.NULL ? (this._err(r.unexpectedNullCharacter), this.currentAttr.value += t.REPLACEMENT_CHARACTER) : w === o.QUOTATION_MARK || w === o.APOSTROPHE || w === o.LESS_THAN_SIGN || w === o.EQUALS_SIGN || w === o.GRAVE_ACCENT ? (this._err(r.unexpectedCharacterInUnquotedAttributeValue), this.currentAttr.value += Ue(w)) : w === o.EOF ? (this._err(r.eofInTag), this._emitEOFToken()) : this.currentAttr.value += Ue(w);
    }
    // After attribute value (quoted) state
    //------------------------------------------------------------------
    [Dn](w) {
      Me(w) ? this._leaveAttrValue(Je) : w === o.SOLIDUS ? this._leaveAttrValue(At) : w === o.GREATER_THAN_SIGN ? (this._leaveAttrValue(v), this._emitCurrentToken()) : w === o.EOF ? (this._err(r.eofInTag), this._emitEOFToken()) : (this._err(r.missingWhitespaceBetweenAttributes), this._reconsumeInState(Je));
    }
    // Self-closing start tag state
    //------------------------------------------------------------------
    [At](w) {
      w === o.GREATER_THAN_SIGN ? (this.currentToken.selfClosing = !0, this.state = v, this._emitCurrentToken()) : w === o.EOF ? (this._err(r.eofInTag), this._emitEOFToken()) : (this._err(r.unexpectedSolidusInTag), this._reconsumeInState(Je));
    }
    // Bogus comment state
    //------------------------------------------------------------------
    [ce](w) {
      w === o.GREATER_THAN_SIGN ? (this.state = v, this._emitCurrentToken()) : w === o.EOF ? (this._emitCurrentToken(), this._emitEOFToken()) : w === o.NULL ? (this._err(r.unexpectedNullCharacter), this.currentToken.data += t.REPLACEMENT_CHARACTER) : this.currentToken.data += Ue(w);
    }
    // Markup declaration open state
    //------------------------------------------------------------------
    [It](w) {
      this._consumeSequenceIfMatch(i.DASH_DASH_STRING, w, !0) ? (this._createCommentToken(), this.state = le) : this._consumeSequenceIfMatch(i.DOCTYPE_STRING, w, !1) ? this.state = yn : this._consumeSequenceIfMatch(i.CDATA_START_STRING, w, !0) ? this.allowCDATA ? this.state = Pn : (this._err(r.cdataInHtmlContent), this._createCommentToken(), this.currentToken.data = "[CDATA[", this.state = ce) : this._ensureHibernation() || (this._err(r.incorrectlyOpenedComment), this._createCommentToken(), this._reconsumeInState(ce));
    }
    // Comment start state
    //------------------------------------------------------------------
    [le](w) {
      w === o.HYPHEN_MINUS ? this.state = fe : w === o.GREATER_THAN_SIGN ? (this._err(r.abruptClosingOfEmptyComment), this.state = v, this._emitCurrentToken()) : this._reconsumeInState(Pe);
    }
    // Comment start dash state
    //------------------------------------------------------------------
    [fe](w) {
      w === o.HYPHEN_MINUS ? this.state = mt : w === o.GREATER_THAN_SIGN ? (this._err(r.abruptClosingOfEmptyComment), this.state = v, this._emitCurrentToken()) : w === o.EOF ? (this._err(r.eofInComment), this._emitCurrentToken(), this._emitEOFToken()) : (this.currentToken.data += "-", this._reconsumeInState(Pe));
    }
    // Comment state
    //------------------------------------------------------------------
    [Pe](w) {
      w === o.HYPHEN_MINUS ? this.state = et : w === o.LESS_THAN_SIGN ? (this.currentToken.data += "<", this.state = Ve) : w === o.NULL ? (this._err(r.unexpectedNullCharacter), this.currentToken.data += t.REPLACEMENT_CHARACTER) : w === o.EOF ? (this._err(r.eofInComment), this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.data += Ue(w);
    }
    // Comment less-than sign state
    //------------------------------------------------------------------
    [Ve](w) {
      w === o.EXCLAMATION_MARK ? (this.currentToken.data += "!", this.state = Lt) : w === o.LESS_THAN_SIGN ? this.currentToken.data += "!" : this._reconsumeInState(Pe);
    }
    // Comment less-than sign bang state
    //------------------------------------------------------------------
    [Lt](w) {
      w === o.HYPHEN_MINUS ? this.state = xe : this._reconsumeInState(Pe);
    }
    // Comment less-than sign bang dash state
    //------------------------------------------------------------------
    [xe](w) {
      w === o.HYPHEN_MINUS ? this.state = be : this._reconsumeInState(et);
    }
    // Comment less-than sign bang dash dash state
    //------------------------------------------------------------------
    [be](w) {
      w !== o.GREATER_THAN_SIGN && w !== o.EOF && this._err(r.nestedComment), this._reconsumeInState(mt);
    }
    // Comment end dash state
    //------------------------------------------------------------------
    [et](w) {
      w === o.HYPHEN_MINUS ? this.state = mt : w === o.EOF ? (this._err(r.eofInComment), this._emitCurrentToken(), this._emitEOFToken()) : (this.currentToken.data += "-", this._reconsumeInState(Pe));
    }
    // Comment end state
    //------------------------------------------------------------------
    [mt](w) {
      w === o.GREATER_THAN_SIGN ? (this.state = v, this._emitCurrentToken()) : w === o.EXCLAMATION_MARK ? this.state = Xt : w === o.HYPHEN_MINUS ? this.currentToken.data += "-" : w === o.EOF ? (this._err(r.eofInComment), this._emitCurrentToken(), this._emitEOFToken()) : (this.currentToken.data += "--", this._reconsumeInState(Pe));
    }
    // Comment end bang state
    //------------------------------------------------------------------
    [Xt](w) {
      w === o.HYPHEN_MINUS ? (this.currentToken.data += "--!", this.state = et) : w === o.GREATER_THAN_SIGN ? (this._err(r.incorrectlyClosedComment), this.state = v, this._emitCurrentToken()) : w === o.EOF ? (this._err(r.eofInComment), this._emitCurrentToken(), this._emitEOFToken()) : (this.currentToken.data += "--!", this._reconsumeInState(Pe));
    }
    // DOCTYPE state
    //------------------------------------------------------------------
    [yn](w) {
      Me(w) ? this.state = tt : w === o.GREATER_THAN_SIGN ? this._reconsumeInState(tt) : w === o.EOF ? (this._err(r.eofInDoctype), this._createDoctypeToken(null), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(r.missingWhitespaceBeforeDoctypeName), this._reconsumeInState(tt));
    }
    // Before DOCTYPE name state
    //------------------------------------------------------------------
    [tt](w) {
      Me(w) || ($t(w) ? (this._createDoctypeToken(Cn(w)), this.state = ft) : w === o.NULL ? (this._err(r.unexpectedNullCharacter), this._createDoctypeToken(t.REPLACEMENT_CHARACTER), this.state = ft) : w === o.GREATER_THAN_SIGN ? (this._err(r.missingDoctypeName), this._createDoctypeToken(null), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this.state = v) : w === o.EOF ? (this._err(r.eofInDoctype), this._createDoctypeToken(null), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._createDoctypeToken(Ue(w)), this.state = ft));
    }
    // DOCTYPE name state
    //------------------------------------------------------------------
    [ft](w) {
      Me(w) ? this.state = _n : w === o.GREATER_THAN_SIGN ? (this.state = v, this._emitCurrentToken()) : $t(w) ? this.currentToken.name += Cn(w) : w === o.NULL ? (this._err(r.unexpectedNullCharacter), this.currentToken.name += t.REPLACEMENT_CHARACTER) : w === o.EOF ? (this._err(r.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.name += Ue(w);
    }
    // After DOCTYPE name state
    //------------------------------------------------------------------
    [_n](w) {
      Me(w) || (w === o.GREATER_THAN_SIGN ? (this.state = v, this._emitCurrentToken()) : w === o.EOF ? (this._err(r.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this._consumeSequenceIfMatch(i.PUBLIC_STRING, w, !1) ? this.state = Yn : this._consumeSequenceIfMatch(i.SYSTEM_STRING, w, !1) ? this.state = Ai : this._ensureHibernation() || (this._err(r.invalidCharacterSequenceAfterDoctypeName), this.currentToken.forceQuirks = !0, this._reconsumeInState(dt)));
    }
    // After DOCTYPE public keyword state
    //------------------------------------------------------------------
    [Yn](w) {
      Me(w) ? this.state = Dt : w === o.QUOTATION_MARK ? (this._err(r.missingWhitespaceAfterDoctypePublicKeyword), this.currentToken.publicId = "", this.state = Ce) : w === o.APOSTROPHE ? (this._err(r.missingWhitespaceAfterDoctypePublicKeyword), this.currentToken.publicId = "", this.state = Ne) : w === o.GREATER_THAN_SIGN ? (this._err(r.missingDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this.state = v, this._emitCurrentToken()) : w === o.EOF ? (this._err(r.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(r.missingQuoteBeforeDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState(dt));
    }
    // Before DOCTYPE public identifier state
    //------------------------------------------------------------------
    [Dt](w) {
      Me(w) || (w === o.QUOTATION_MARK ? (this.currentToken.publicId = "", this.state = Ce) : w === o.APOSTROPHE ? (this.currentToken.publicId = "", this.state = Ne) : w === o.GREATER_THAN_SIGN ? (this._err(r.missingDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this.state = v, this._emitCurrentToken()) : w === o.EOF ? (this._err(r.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(r.missingQuoteBeforeDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState(dt)));
    }
    // DOCTYPE public identifier (double-quoted) state
    //------------------------------------------------------------------
    [Ce](w) {
      w === o.QUOTATION_MARK ? this.state = $n : w === o.NULL ? (this._err(r.unexpectedNullCharacter), this.currentToken.publicId += t.REPLACEMENT_CHARACTER) : w === o.GREATER_THAN_SIGN ? (this._err(r.abruptDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this.state = v) : w === o.EOF ? (this._err(r.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.publicId += Ue(w);
    }
    // DOCTYPE public identifier (single-quoted) state
    //------------------------------------------------------------------
    [Ne](w) {
      w === o.APOSTROPHE ? this.state = $n : w === o.NULL ? (this._err(r.unexpectedNullCharacter), this.currentToken.publicId += t.REPLACEMENT_CHARACTER) : w === o.GREATER_THAN_SIGN ? (this._err(r.abruptDoctypePublicIdentifier), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this.state = v) : w === o.EOF ? (this._err(r.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.publicId += Ue(w);
    }
    // After DOCTYPE public identifier state
    //------------------------------------------------------------------
    [$n](w) {
      Me(w) ? this.state = Mi : w === o.GREATER_THAN_SIGN ? (this.state = v, this._emitCurrentToken()) : w === o.QUOTATION_MARK ? (this._err(r.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), this.currentToken.systemId = "", this.state = gr) : w === o.APOSTROPHE ? (this._err(r.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), this.currentToken.systemId = "", this.state = vr) : w === o.EOF ? (this._err(r.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(r.missingQuoteBeforeDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState(dt));
    }
    // Between DOCTYPE public and system identifiers state
    //------------------------------------------------------------------
    [Mi](w) {
      Me(w) || (w === o.GREATER_THAN_SIGN ? (this._emitCurrentToken(), this.state = v) : w === o.QUOTATION_MARK ? (this.currentToken.systemId = "", this.state = gr) : w === o.APOSTROPHE ? (this.currentToken.systemId = "", this.state = vr) : w === o.EOF ? (this._err(r.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(r.missingQuoteBeforeDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState(dt)));
    }
    // After DOCTYPE system keyword state
    //------------------------------------------------------------------
    [Ai](w) {
      Me(w) ? this.state = Xn : w === o.QUOTATION_MARK ? (this._err(r.missingWhitespaceAfterDoctypeSystemKeyword), this.currentToken.systemId = "", this.state = gr) : w === o.APOSTROPHE ? (this._err(r.missingWhitespaceAfterDoctypeSystemKeyword), this.currentToken.systemId = "", this.state = vr) : w === o.GREATER_THAN_SIGN ? (this._err(r.missingDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this.state = v, this._emitCurrentToken()) : w === o.EOF ? (this._err(r.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(r.missingQuoteBeforeDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState(dt));
    }
    // Before DOCTYPE system identifier state
    //------------------------------------------------------------------
    [Xn](w) {
      Me(w) || (w === o.QUOTATION_MARK ? (this.currentToken.systemId = "", this.state = gr) : w === o.APOSTROPHE ? (this.currentToken.systemId = "", this.state = vr) : w === o.GREATER_THAN_SIGN ? (this._err(r.missingDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this.state = v, this._emitCurrentToken()) : w === o.EOF ? (this._err(r.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(r.missingQuoteBeforeDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._reconsumeInState(dt)));
    }
    // DOCTYPE system identifier (double-quoted) state
    //------------------------------------------------------------------
    [gr](w) {
      w === o.QUOTATION_MARK ? this.state = On : w === o.NULL ? (this._err(r.unexpectedNullCharacter), this.currentToken.systemId += t.REPLACEMENT_CHARACTER) : w === o.GREATER_THAN_SIGN ? (this._err(r.abruptDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this.state = v) : w === o.EOF ? (this._err(r.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.systemId += Ue(w);
    }
    // DOCTYPE system identifier (single-quoted) state
    //------------------------------------------------------------------
    [vr](w) {
      w === o.APOSTROPHE ? this.state = On : w === o.NULL ? (this._err(r.unexpectedNullCharacter), this.currentToken.systemId += t.REPLACEMENT_CHARACTER) : w === o.GREATER_THAN_SIGN ? (this._err(r.abruptDoctypeSystemIdentifier), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this.state = v) : w === o.EOF ? (this._err(r.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : this.currentToken.systemId += Ue(w);
    }
    // After DOCTYPE system identifier state
    //------------------------------------------------------------------
    [On](w) {
      Me(w) || (w === o.GREATER_THAN_SIGN ? (this._emitCurrentToken(), this.state = v) : w === o.EOF ? (this._err(r.eofInDoctype), this.currentToken.forceQuirks = !0, this._emitCurrentToken(), this._emitEOFToken()) : (this._err(r.unexpectedCharacterAfterDoctypeSystemIdentifier), this._reconsumeInState(dt)));
    }
    // Bogus DOCTYPE state
    //------------------------------------------------------------------
    [dt](w) {
      w === o.GREATER_THAN_SIGN ? (this._emitCurrentToken(), this.state = v) : w === o.NULL ? this._err(r.unexpectedNullCharacter) : w === o.EOF && (this._emitCurrentToken(), this._emitEOFToken());
    }
    // CDATA section state
    //------------------------------------------------------------------
    [Pn](w) {
      w === o.RIGHT_SQUARE_BRACKET ? this.state = Ii : w === o.EOF ? (this._err(r.eofInCdata), this._emitEOFToken()) : this._emitCodePoint(w);
    }
    // CDATA section bracket state
    //------------------------------------------------------------------
    [Ii](w) {
      w === o.RIGHT_SQUARE_BRACKET ? this.state = Li : (this._emitChars("]"), this._reconsumeInState(Pn));
    }
    // CDATA section end state
    //------------------------------------------------------------------
    [Li](w) {
      w === o.GREATER_THAN_SIGN ? this.state = v : w === o.RIGHT_SQUARE_BRACKET ? this._emitChars("]") : (this._emitChars("]]"), this._reconsumeInState(Pn));
    }
    // Character reference state
    //------------------------------------------------------------------
    [Qn](w) {
      this.tempBuff = [o.AMPERSAND], w === o.NUMBER_SIGN ? (this.tempBuff.push(w), this.state = $o) : Oo(w) ? this._reconsumeInState(Qt) : (this._flushCodePointsConsumedAsCharacterReference(), this._reconsumeInState(this.returnState));
    }
    // Named character reference state
    //------------------------------------------------------------------
    [Qt](w) {
      const Te = this._matchNamedCharacterReference(w);
      if (this._ensureHibernation())
        this.tempBuff = [o.AMPERSAND];
      else if (Te) {
        const wt = this.tempBuff[this.tempBuff.length - 1] === o.SEMICOLON;
        this._isCharacterReferenceAttributeQuirk(wt) || (wt || this._errOnNextCodePoint(r.missingSemicolonAfterCharacterReference), this.tempBuff = Te), this._flushCodePointsConsumedAsCharacterReference(), this.state = this.returnState;
      } else
        this._flushCodePointsConsumedAsCharacterReference(), this.state = Di;
    }
    // Ambiguos ampersand state
    //------------------------------------------------------------------
    [Di](w) {
      Oo(w) ? this._isCharacterReferenceInAttribute() ? this.currentAttr.value += Ue(w) : this._emitCodePoint(w) : (w === o.SEMICOLON && this._err(r.unknownNamedCharacterReference), this._reconsumeInState(this.returnState));
    }
    // Numeric character reference state
    //------------------------------------------------------------------
    [$o](w) {
      this.charRefCode = 0, w === o.LATIN_SMALL_X || w === o.LATIN_CAPITAL_X ? (this.tempBuff.push(w), this.state = $i) : this._reconsumeInState(Oi);
    }
    // Hexademical character reference start state
    //------------------------------------------------------------------
    [$i](w) {
      ta(w) ? this._reconsumeInState(Pi) : (this._err(r.absenceOfDigitsInNumericCharacterReference), this._flushCodePointsConsumedAsCharacterReference(), this._reconsumeInState(this.returnState));
    }
    // Decimal character reference start state
    //------------------------------------------------------------------
    [Oi](w) {
      yr(w) ? this._reconsumeInState(Ni) : (this._err(r.absenceOfDigitsInNumericCharacterReference), this._flushCodePointsConsumedAsCharacterReference(), this._reconsumeInState(this.returnState));
    }
    // Hexademical character reference state
    //------------------------------------------------------------------
    [Pi](w) {
      Po(w) ? this.charRefCode = this.charRefCode * 16 + w - 55 : Hi(w) ? this.charRefCode = this.charRefCode * 16 + w - 87 : yr(w) ? this.charRefCode = this.charRefCode * 16 + w - 48 : w === o.SEMICOLON ? this.state = br : (this._err(r.missingSemicolonAfterCharacterReference), this._reconsumeInState(br));
    }
    // Decimal character reference state
    //------------------------------------------------------------------
    [Ni](w) {
      yr(w) ? this.charRefCode = this.charRefCode * 10 + w - 48 : w === o.SEMICOLON ? this.state = br : (this._err(r.missingSemicolonAfterCharacterReference), this._reconsumeInState(br));
    }
    // Numeric character reference end state
    //------------------------------------------------------------------
    [br]() {
      if (this.charRefCode === o.NULL)
        this._err(r.nullCharacterReference), this.charRefCode = o.REPLACEMENT_CHARACTER;
      else if (this.charRefCode > 1114111)
        this._err(r.characterReferenceOutsideUnicodeRange), this.charRefCode = o.REPLACEMENT_CHARACTER;
      else if (t.isSurrogate(this.charRefCode))
        this._err(r.surrogateCharacterReference), this.charRefCode = o.REPLACEMENT_CHARACTER;
      else if (t.isUndefinedCodePoint(this.charRefCode))
        this._err(r.noncharacterCharacterReference);
      else if (t.isControlCodePoint(this.charRefCode) || this.charRefCode === o.CARRIAGE_RETURN) {
        this._err(r.controlCharacterReference);
        const w = a[this.charRefCode];
        w && (this.charRefCode = w);
      }
      this.tempBuff = [this.charRefCode], this._flushCodePointsConsumedAsCharacterReference(), this._reconsumeInState(this.returnState);
    }
  }
  return $e.CHARACTER_TOKEN = "CHARACTER_TOKEN", $e.NULL_CHARACTER_TOKEN = "NULL_CHARACTER_TOKEN", $e.WHITESPACE_CHARACTER_TOKEN = "WHITESPACE_CHARACTER_TOKEN", $e.START_TAG_TOKEN = "START_TAG_TOKEN", $e.END_TAG_TOKEN = "END_TAG_TOKEN", $e.COMMENT_TOKEN = "COMMENT_TOKEN", $e.DOCTYPE_TOKEN = "DOCTYPE_TOKEN", $e.EOF_TOKEN = "EOF_TOKEN", $e.HIBERNATION_TOKEN = "HIBERNATION_TOKEN", $e.MODE = {
    DATA: v,
    RCDATA: g,
    RAWTEXT: h,
    SCRIPT_DATA: E,
    PLAINTEXT: C
  }, $e.getTokenAttr = function(ve, w) {
    for (let Te = ve.attrs.length - 1; Te >= 0; Te--)
      if (ve.attrs[Te].name === w)
        return ve.attrs[Te].value;
    return null;
  }, zl = $e, zl;
}
var wr = {}, Gm;
function Io() {
  if (Gm) return wr;
  Gm = 1;
  const e = wr.NAMESPACES = {
    HTML: "http://www.w3.org/1999/xhtml",
    MATHML: "http://www.w3.org/1998/Math/MathML",
    SVG: "http://www.w3.org/2000/svg",
    XLINK: "http://www.w3.org/1999/xlink",
    XML: "http://www.w3.org/XML/1998/namespace",
    XMLNS: "http://www.w3.org/2000/xmlns/"
  };
  wr.ATTRS = {
    TYPE: "type",
    ACTION: "action",
    ENCODING: "encoding",
    PROMPT: "prompt",
    NAME: "name",
    COLOR: "color",
    FACE: "face",
    SIZE: "size"
  }, wr.DOCUMENT_MODE = {
    NO_QUIRKS: "no-quirks",
    QUIRKS: "quirks",
    LIMITED_QUIRKS: "limited-quirks"
  };
  const t = wr.TAG_NAMES = {
    A: "a",
    ADDRESS: "address",
    ANNOTATION_XML: "annotation-xml",
    APPLET: "applet",
    AREA: "area",
    ARTICLE: "article",
    ASIDE: "aside",
    B: "b",
    BASE: "base",
    BASEFONT: "basefont",
    BGSOUND: "bgsound",
    BIG: "big",
    BLOCKQUOTE: "blockquote",
    BODY: "body",
    BR: "br",
    BUTTON: "button",
    CAPTION: "caption",
    CENTER: "center",
    CODE: "code",
    COL: "col",
    COLGROUP: "colgroup",
    DD: "dd",
    DESC: "desc",
    DETAILS: "details",
    DIALOG: "dialog",
    DIR: "dir",
    DIV: "div",
    DL: "dl",
    DT: "dt",
    EM: "em",
    EMBED: "embed",
    FIELDSET: "fieldset",
    FIGCAPTION: "figcaption",
    FIGURE: "figure",
    FONT: "font",
    FOOTER: "footer",
    FOREIGN_OBJECT: "foreignObject",
    FORM: "form",
    FRAME: "frame",
    FRAMESET: "frameset",
    H1: "h1",
    H2: "h2",
    H3: "h3",
    H4: "h4",
    H5: "h5",
    H6: "h6",
    HEAD: "head",
    HEADER: "header",
    HGROUP: "hgroup",
    HR: "hr",
    HTML: "html",
    I: "i",
    IMG: "img",
    IMAGE: "image",
    INPUT: "input",
    IFRAME: "iframe",
    KEYGEN: "keygen",
    LABEL: "label",
    LI: "li",
    LINK: "link",
    LISTING: "listing",
    MAIN: "main",
    MALIGNMARK: "malignmark",
    MARQUEE: "marquee",
    MATH: "math",
    MENU: "menu",
    META: "meta",
    MGLYPH: "mglyph",
    MI: "mi",
    MO: "mo",
    MN: "mn",
    MS: "ms",
    MTEXT: "mtext",
    NAV: "nav",
    NOBR: "nobr",
    NOFRAMES: "noframes",
    NOEMBED: "noembed",
    NOSCRIPT: "noscript",
    OBJECT: "object",
    OL: "ol",
    OPTGROUP: "optgroup",
    OPTION: "option",
    P: "p",
    PARAM: "param",
    PLAINTEXT: "plaintext",
    PRE: "pre",
    RB: "rb",
    RP: "rp",
    RT: "rt",
    RTC: "rtc",
    RUBY: "ruby",
    S: "s",
    SCRIPT: "script",
    SECTION: "section",
    SELECT: "select",
    SOURCE: "source",
    SMALL: "small",
    SPAN: "span",
    STRIKE: "strike",
    STRONG: "strong",
    STYLE: "style",
    SUB: "sub",
    SUMMARY: "summary",
    SUP: "sup",
    TABLE: "table",
    TBODY: "tbody",
    TEMPLATE: "template",
    TEXTAREA: "textarea",
    TFOOT: "tfoot",
    TD: "td",
    TH: "th",
    THEAD: "thead",
    TITLE: "title",
    TR: "tr",
    TRACK: "track",
    TT: "tt",
    U: "u",
    UL: "ul",
    SVG: "svg",
    VAR: "var",
    WBR: "wbr",
    XMP: "xmp"
  };
  return wr.SPECIAL_ELEMENTS = {
    [e.HTML]: {
      [t.ADDRESS]: !0,
      [t.APPLET]: !0,
      [t.AREA]: !0,
      [t.ARTICLE]: !0,
      [t.ASIDE]: !0,
      [t.BASE]: !0,
      [t.BASEFONT]: !0,
      [t.BGSOUND]: !0,
      [t.BLOCKQUOTE]: !0,
      [t.BODY]: !0,
      [t.BR]: !0,
      [t.BUTTON]: !0,
      [t.CAPTION]: !0,
      [t.CENTER]: !0,
      [t.COL]: !0,
      [t.COLGROUP]: !0,
      [t.DD]: !0,
      [t.DETAILS]: !0,
      [t.DIR]: !0,
      [t.DIV]: !0,
      [t.DL]: !0,
      [t.DT]: !0,
      [t.EMBED]: !0,
      [t.FIELDSET]: !0,
      [t.FIGCAPTION]: !0,
      [t.FIGURE]: !0,
      [t.FOOTER]: !0,
      [t.FORM]: !0,
      [t.FRAME]: !0,
      [t.FRAMESET]: !0,
      [t.H1]: !0,
      [t.H2]: !0,
      [t.H3]: !0,
      [t.H4]: !0,
      [t.H5]: !0,
      [t.H6]: !0,
      [t.HEAD]: !0,
      [t.HEADER]: !0,
      [t.HGROUP]: !0,
      [t.HR]: !0,
      [t.HTML]: !0,
      [t.IFRAME]: !0,
      [t.IMG]: !0,
      [t.INPUT]: !0,
      [t.LI]: !0,
      [t.LINK]: !0,
      [t.LISTING]: !0,
      [t.MAIN]: !0,
      [t.MARQUEE]: !0,
      [t.MENU]: !0,
      [t.META]: !0,
      [t.NAV]: !0,
      [t.NOEMBED]: !0,
      [t.NOFRAMES]: !0,
      [t.NOSCRIPT]: !0,
      [t.OBJECT]: !0,
      [t.OL]: !0,
      [t.P]: !0,
      [t.PARAM]: !0,
      [t.PLAINTEXT]: !0,
      [t.PRE]: !0,
      [t.SCRIPT]: !0,
      [t.SECTION]: !0,
      [t.SELECT]: !0,
      [t.SOURCE]: !0,
      [t.STYLE]: !0,
      [t.SUMMARY]: !0,
      [t.TABLE]: !0,
      [t.TBODY]: !0,
      [t.TD]: !0,
      [t.TEMPLATE]: !0,
      [t.TEXTAREA]: !0,
      [t.TFOOT]: !0,
      [t.TH]: !0,
      [t.THEAD]: !0,
      [t.TITLE]: !0,
      [t.TR]: !0,
      [t.TRACK]: !0,
      [t.UL]: !0,
      [t.WBR]: !0,
      [t.XMP]: !0
    },
    [e.MATHML]: {
      [t.MI]: !0,
      [t.MO]: !0,
      [t.MN]: !0,
      [t.MS]: !0,
      [t.MTEXT]: !0,
      [t.ANNOTATION_XML]: !0
    },
    [e.SVG]: {
      [t.TITLE]: !0,
      [t.FOREIGN_OBJECT]: !0,
      [t.DESC]: !0
    }
  }, wr;
}
var Zl, Km;
function UP() {
  if (Km) return Zl;
  Km = 1;
  const e = Io(), t = e.TAG_NAMES, n = e.NAMESPACES;
  function r(s) {
    switch (s.length) {
      case 1:
        return s === t.P;
      case 2:
        return s === t.RB || s === t.RP || s === t.RT || s === t.DD || s === t.DT || s === t.LI;
      case 3:
        return s === t.RTC;
      case 6:
        return s === t.OPTION;
      case 8:
        return s === t.OPTGROUP;
    }
    return !1;
  }
  function o(s) {
    switch (s.length) {
      case 1:
        return s === t.P;
      case 2:
        return s === t.RB || s === t.RP || s === t.RT || s === t.DD || s === t.DT || s === t.LI || s === t.TD || s === t.TH || s === t.TR;
      case 3:
        return s === t.RTC;
      case 5:
        return s === t.TBODY || s === t.TFOOT || s === t.THEAD;
      case 6:
        return s === t.OPTION;
      case 7:
        return s === t.CAPTION;
      case 8:
        return s === t.OPTGROUP || s === t.COLGROUP;
    }
    return !1;
  }
  function i(s, l) {
    switch (s.length) {
      case 2:
        if (s === t.TD || s === t.TH)
          return l === n.HTML;
        if (s === t.MI || s === t.MO || s === t.MN || s === t.MS)
          return l === n.MATHML;
        break;
      case 4:
        if (s === t.HTML)
          return l === n.HTML;
        if (s === t.DESC)
          return l === n.SVG;
        break;
      case 5:
        if (s === t.TABLE)
          return l === n.HTML;
        if (s === t.MTEXT)
          return l === n.MATHML;
        if (s === t.TITLE)
          return l === n.SVG;
        break;
      case 6:
        return (s === t.APPLET || s === t.OBJECT) && l === n.HTML;
      case 7:
        return (s === t.CAPTION || s === t.MARQUEE) && l === n.HTML;
      case 8:
        return s === t.TEMPLATE && l === n.HTML;
      case 13:
        return s === t.FOREIGN_OBJECT && l === n.SVG;
      case 14:
        return s === t.ANNOTATION_XML && l === n.MATHML;
    }
    return !1;
  }
  class a {
    constructor(l, u) {
      this.stackTop = -1, this.items = [], this.current = l, this.currentTagName = null, this.currentTmplContent = null, this.tmplCount = 0, this.treeAdapter = u;
    }
    //Index of element
    _indexOf(l) {
      let u = -1;
      for (let m = this.stackTop; m >= 0; m--)
        if (this.items[m] === l) {
          u = m;
          break;
        }
      return u;
    }
    //Update current element
    _isInTemplate() {
      return this.currentTagName === t.TEMPLATE && this.treeAdapter.getNamespaceURI(this.current) === n.HTML;
    }
    _updateCurrentElement() {
      this.current = this.items[this.stackTop], this.currentTagName = this.current && this.treeAdapter.getTagName(this.current), this.currentTmplContent = this._isInTemplate() ? this.treeAdapter.getTemplateContent(this.current) : null;
    }
    //Mutations
    push(l) {
      this.items[++this.stackTop] = l, this._updateCurrentElement(), this._isInTemplate() && this.tmplCount++;
    }
    pop() {
      this.stackTop--, this.tmplCount > 0 && this._isInTemplate() && this.tmplCount--, this._updateCurrentElement();
    }
    replace(l, u) {
      const m = this._indexOf(l);
      this.items[m] = u, m === this.stackTop && this._updateCurrentElement();
    }
    insertAfter(l, u) {
      const m = this._indexOf(l) + 1;
      this.items.splice(m, 0, u), m === ++this.stackTop && this._updateCurrentElement();
    }
    popUntilTagNamePopped(l) {
      for (; this.stackTop > -1; ) {
        const u = this.currentTagName, m = this.treeAdapter.getNamespaceURI(this.current);
        if (this.pop(), u === l && m === n.HTML)
          break;
      }
    }
    popUntilElementPopped(l) {
      for (; this.stackTop > -1; ) {
        const u = this.current;
        if (this.pop(), u === l)
          break;
      }
    }
    popUntilNumberedHeaderPopped() {
      for (; this.stackTop > -1; ) {
        const l = this.currentTagName, u = this.treeAdapter.getNamespaceURI(this.current);
        if (this.pop(), l === t.H1 || l === t.H2 || l === t.H3 || l === t.H4 || l === t.H5 || l === t.H6 && u === n.HTML)
          break;
      }
    }
    popUntilTableCellPopped() {
      for (; this.stackTop > -1; ) {
        const l = this.currentTagName, u = this.treeAdapter.getNamespaceURI(this.current);
        if (this.pop(), l === t.TD || l === t.TH && u === n.HTML)
          break;
      }
    }
    popAllUpToHtmlElement() {
      this.stackTop = 0, this._updateCurrentElement();
    }
    clearBackToTableContext() {
      for (; this.currentTagName !== t.TABLE && this.currentTagName !== t.TEMPLATE && this.currentTagName !== t.HTML || this.treeAdapter.getNamespaceURI(this.current) !== n.HTML; )
        this.pop();
    }
    clearBackToTableBodyContext() {
      for (; this.currentTagName !== t.TBODY && this.currentTagName !== t.TFOOT && this.currentTagName !== t.THEAD && this.currentTagName !== t.TEMPLATE && this.currentTagName !== t.HTML || this.treeAdapter.getNamespaceURI(this.current) !== n.HTML; )
        this.pop();
    }
    clearBackToTableRowContext() {
      for (; this.currentTagName !== t.TR && this.currentTagName !== t.TEMPLATE && this.currentTagName !== t.HTML || this.treeAdapter.getNamespaceURI(this.current) !== n.HTML; )
        this.pop();
    }
    remove(l) {
      for (let u = this.stackTop; u >= 0; u--)
        if (this.items[u] === l) {
          this.items.splice(u, 1), this.stackTop--, this._updateCurrentElement();
          break;
        }
    }
    //Search
    tryPeekProperlyNestedBodyElement() {
      const l = this.items[1];
      return l && this.treeAdapter.getTagName(l) === t.BODY ? l : null;
    }
    contains(l) {
      return this._indexOf(l) > -1;
    }
    getCommonAncestor(l) {
      let u = this._indexOf(l);
      return --u >= 0 ? this.items[u] : null;
    }
    isRootHtmlElementCurrent() {
      return this.stackTop === 0 && this.currentTagName === t.HTML;
    }
    //Element in scope
    hasInScope(l) {
      for (let u = this.stackTop; u >= 0; u--) {
        const m = this.treeAdapter.getTagName(this.items[u]), v = this.treeAdapter.getNamespaceURI(this.items[u]);
        if (m === l && v === n.HTML)
          return !0;
        if (i(m, v))
          return !1;
      }
      return !0;
    }
    hasNumberedHeaderInScope() {
      for (let l = this.stackTop; l >= 0; l--) {
        const u = this.treeAdapter.getTagName(this.items[l]), m = this.treeAdapter.getNamespaceURI(this.items[l]);
        if ((u === t.H1 || u === t.H2 || u === t.H3 || u === t.H4 || u === t.H5 || u === t.H6) && m === n.HTML)
          return !0;
        if (i(u, m))
          return !1;
      }
      return !0;
    }
    hasInListItemScope(l) {
      for (let u = this.stackTop; u >= 0; u--) {
        const m = this.treeAdapter.getTagName(this.items[u]), v = this.treeAdapter.getNamespaceURI(this.items[u]);
        if (m === l && v === n.HTML)
          return !0;
        if ((m === t.UL || m === t.OL) && v === n.HTML || i(m, v))
          return !1;
      }
      return !0;
    }
    hasInButtonScope(l) {
      for (let u = this.stackTop; u >= 0; u--) {
        const m = this.treeAdapter.getTagName(this.items[u]), v = this.treeAdapter.getNamespaceURI(this.items[u]);
        if (m === l && v === n.HTML)
          return !0;
        if (m === t.BUTTON && v === n.HTML || i(m, v))
          return !1;
      }
      return !0;
    }
    hasInTableScope(l) {
      for (let u = this.stackTop; u >= 0; u--) {
        const m = this.treeAdapter.getTagName(this.items[u]);
        if (this.treeAdapter.getNamespaceURI(this.items[u]) === n.HTML) {
          if (m === l)
            return !0;
          if (m === t.TABLE || m === t.TEMPLATE || m === t.HTML)
            return !1;
        }
      }
      return !0;
    }
    hasTableBodyContextInTableScope() {
      for (let l = this.stackTop; l >= 0; l--) {
        const u = this.treeAdapter.getTagName(this.items[l]);
        if (this.treeAdapter.getNamespaceURI(this.items[l]) === n.HTML) {
          if (u === t.TBODY || u === t.THEAD || u === t.TFOOT)
            return !0;
          if (u === t.TABLE || u === t.HTML)
            return !1;
        }
      }
      return !0;
    }
    hasInSelectScope(l) {
      for (let u = this.stackTop; u >= 0; u--) {
        const m = this.treeAdapter.getTagName(this.items[u]);
        if (this.treeAdapter.getNamespaceURI(this.items[u]) === n.HTML) {
          if (m === l)
            return !0;
          if (m !== t.OPTION && m !== t.OPTGROUP)
            return !1;
        }
      }
      return !0;
    }
    //Implied end tags
    generateImpliedEndTags() {
      for (; r(this.currentTagName); )
        this.pop();
    }
    generateImpliedEndTagsThoroughly() {
      for (; o(this.currentTagName); )
        this.pop();
    }
    generateImpliedEndTagsWithExclusion(l) {
      for (; r(this.currentTagName) && this.currentTagName !== l; )
        this.pop();
    }
  }
  return Zl = a, Zl;
}
var xl, zm;
function qP() {
  if (zm) return xl;
  zm = 1;
  const e = 3;
  class t {
    constructor(r) {
      this.length = 0, this.entries = [], this.treeAdapter = r, this.bookmark = null;
    }
    //Noah Ark's condition
    //OPTIMIZATION: at first we try to find possible candidates for exclusion using
    //lightweight heuristics without thorough attributes check.
    _getNoahArkConditionCandidates(r) {
      const o = [];
      if (this.length >= e) {
        const i = this.treeAdapter.getAttrList(r).length, a = this.treeAdapter.getTagName(r), s = this.treeAdapter.getNamespaceURI(r);
        for (let l = this.length - 1; l >= 0; l--) {
          const u = this.entries[l];
          if (u.type === t.MARKER_ENTRY)
            break;
          const m = u.element, v = this.treeAdapter.getAttrList(m);
          this.treeAdapter.getTagName(m) === a && this.treeAdapter.getNamespaceURI(m) === s && v.length === i && o.push({ idx: l, attrs: v });
        }
      }
      return o.length < e ? [] : o;
    }
    _ensureNoahArkCondition(r) {
      const o = this._getNoahArkConditionCandidates(r);
      let i = o.length;
      if (i) {
        const a = this.treeAdapter.getAttrList(r), s = a.length, l = /* @__PURE__ */ Object.create(null);
        for (let u = 0; u < s; u++) {
          const m = a[u];
          l[m.name] = m.value;
        }
        for (let u = 0; u < s; u++)
          for (let m = 0; m < i; m++) {
            const v = o[m].attrs[u];
            if (l[v.name] !== v.value && (o.splice(m, 1), i--), o.length < e)
              return;
          }
        for (let u = i - 1; u >= e - 1; u--)
          this.entries.splice(o[u].idx, 1), this.length--;
      }
    }
    //Mutations
    insertMarker() {
      this.entries.push({ type: t.MARKER_ENTRY }), this.length++;
    }
    pushElement(r, o) {
      this._ensureNoahArkCondition(r), this.entries.push({
        type: t.ELEMENT_ENTRY,
        element: r,
        token: o
      }), this.length++;
    }
    insertElementAfterBookmark(r, o) {
      let i = this.length - 1;
      for (; i >= 0 && this.entries[i] !== this.bookmark; i--)
        ;
      this.entries.splice(i + 1, 0, {
        type: t.ELEMENT_ENTRY,
        element: r,
        token: o
      }), this.length++;
    }
    removeEntry(r) {
      for (let o = this.length - 1; o >= 0; o--)
        if (this.entries[o] === r) {
          this.entries.splice(o, 1), this.length--;
          break;
        }
    }
    clearToLastMarker() {
      for (; this.length; ) {
        const r = this.entries.pop();
        if (this.length--, r.type === t.MARKER_ENTRY)
          break;
      }
    }
    //Search
    getElementEntryInScopeWithTagName(r) {
      for (let o = this.length - 1; o >= 0; o--) {
        const i = this.entries[o];
        if (i.type === t.MARKER_ENTRY)
          return null;
        if (this.treeAdapter.getTagName(i.element) === r)
          return i;
      }
      return null;
    }
    getElementEntry(r) {
      for (let o = this.length - 1; o >= 0; o--) {
        const i = this.entries[o];
        if (i.type === t.ELEMENT_ENTRY && i.element === r)
          return i;
      }
      return null;
    }
  }
  return t.MARKER_ENTRY = "MARKER_ENTRY", t.ELEMENT_ENTRY = "ELEMENT_ENTRY", xl = t, xl;
}
var Wl, Zm;
function Wn() {
  if (Zm) return Wl;
  Zm = 1;
  class e {
    constructor(n) {
      const r = {}, o = this._getOverriddenMethods(this, r);
      for (const i of Object.keys(o))
        typeof o[i] == "function" && (r[i] = n[i], n[i] = o[i]);
    }
    _getOverriddenMethods() {
      throw new Error("Not implemented");
    }
  }
  return e.install = function(t, n, r) {
    t.__mixins || (t.__mixins = []);
    for (let i = 0; i < t.__mixins.length; i++)
      if (t.__mixins[i].constructor === n)
        return t.__mixins[i];
    const o = new n(t, r);
    return t.__mixins.push(o), o;
  }, Wl = e, Wl;
}
var Yl, xm;
function X4() {
  if (xm) return Yl;
  xm = 1;
  const e = Wn();
  class t extends e {
    constructor(r) {
      super(r), this.preprocessor = r, this.isEol = !1, this.lineStartPos = 0, this.droppedBufferSize = 0, this.offset = 0, this.col = 0, this.line = 1;
    }
    _getOverriddenMethods(r, o) {
      return {
        advance() {
          const i = this.pos + 1, a = this.html[i];
          return r.isEol && (r.isEol = !1, r.line++, r.lineStartPos = i), (a === `
` || a === "\r" && this.html[i + 1] !== `
`) && (r.isEol = !0), r.col = i - r.lineStartPos + 1, r.offset = r.droppedBufferSize + i, o.advance.call(this);
        },
        retreat() {
          o.retreat.call(this), r.isEol = !1, r.col = this.pos - r.lineStartPos + 1;
        },
        dropParsedChunk() {
          const i = this.pos;
          o.dropParsedChunk.call(this);
          const a = i - this.pos;
          r.lineStartPos -= a, r.droppedBufferSize += a, r.offset = r.droppedBufferSize + this.pos;
        }
      };
    }
  }
  return Yl = t, Yl;
}
var Xl, Wm;
function Q4() {
  if (Wm) return Xl;
  Wm = 1;
  const e = Wn(), t = Vs(), n = X4();
  class r extends e {
    constructor(i) {
      super(i), this.tokenizer = i, this.posTracker = e.install(i.preprocessor, n), this.currentAttrLocation = null, this.ctLoc = null;
    }
    _getCurrentLocation() {
      return {
        startLine: this.posTracker.line,
        startCol: this.posTracker.col,
        startOffset: this.posTracker.offset,
        endLine: -1,
        endCol: -1,
        endOffset: -1
      };
    }
    _attachCurrentAttrLocationInfo() {
      this.currentAttrLocation.endLine = this.posTracker.line, this.currentAttrLocation.endCol = this.posTracker.col, this.currentAttrLocation.endOffset = this.posTracker.offset;
      const i = this.tokenizer.currentToken, a = this.tokenizer.currentAttr;
      i.location.attrs || (i.location.attrs = /* @__PURE__ */ Object.create(null)), i.location.attrs[a.name] = this.currentAttrLocation;
    }
    _getOverriddenMethods(i, a) {
      const s = {
        _createStartTagToken() {
          a._createStartTagToken.call(this), this.currentToken.location = i.ctLoc;
        },
        _createEndTagToken() {
          a._createEndTagToken.call(this), this.currentToken.location = i.ctLoc;
        },
        _createCommentToken() {
          a._createCommentToken.call(this), this.currentToken.location = i.ctLoc;
        },
        _createDoctypeToken(l) {
          a._createDoctypeToken.call(this, l), this.currentToken.location = i.ctLoc;
        },
        _createCharacterToken(l, u) {
          a._createCharacterToken.call(this, l, u), this.currentCharacterToken.location = i.ctLoc;
        },
        _createEOFToken() {
          a._createEOFToken.call(this), this.currentToken.location = i._getCurrentLocation();
        },
        _createAttr(l) {
          a._createAttr.call(this, l), i.currentAttrLocation = i._getCurrentLocation();
        },
        _leaveAttrName(l) {
          a._leaveAttrName.call(this, l), i._attachCurrentAttrLocationInfo();
        },
        _leaveAttrValue(l) {
          a._leaveAttrValue.call(this, l), i._attachCurrentAttrLocationInfo();
        },
        _emitCurrentToken() {
          const l = this.currentToken.location;
          this.currentCharacterToken && (this.currentCharacterToken.location.endLine = l.startLine, this.currentCharacterToken.location.endCol = l.startCol, this.currentCharacterToken.location.endOffset = l.startOffset), this.currentToken.type === t.EOF_TOKEN ? (l.endLine = l.startLine, l.endCol = l.startCol, l.endOffset = l.startOffset) : (l.endLine = i.posTracker.line, l.endCol = i.posTracker.col + 1, l.endOffset = i.posTracker.offset + 1), a._emitCurrentToken.call(this);
        },
        _emitCurrentCharacterToken() {
          const l = this.currentCharacterToken && this.currentCharacterToken.location;
          l && l.endOffset === -1 && (l.endLine = i.posTracker.line, l.endCol = i.posTracker.col, l.endOffset = i.posTracker.offset), a._emitCurrentCharacterToken.call(this);
        }
      };
      return Object.keys(t.MODE).forEach((l) => {
        const u = t.MODE[l];
        s[u] = function(m) {
          i.ctLoc = i._getCurrentLocation(), a[u].call(this, m);
        };
      }), s;
    }
  }
  return Xl = r, Xl;
}
var Ql, Ym;
function GP() {
  if (Ym) return Ql;
  Ym = 1;
  const e = Wn();
  class t extends e {
    constructor(r, o) {
      super(r), this.onItemPop = o.onItemPop;
    }
    _getOverriddenMethods(r, o) {
      return {
        pop() {
          r.onItemPop(this.current), o.pop.call(this);
        },
        popAllUpToHtmlElement() {
          for (let i = this.stackTop; i > 0; i--)
            r.onItemPop(this.items[i]);
          o.popAllUpToHtmlElement.call(this);
        },
        remove(i) {
          r.onItemPop(this.current), o.remove.call(this, i);
        }
      };
    }
  }
  return Ql = t, Ql;
}
var Jl, Xm;
function KP() {
  if (Xm) return Jl;
  Xm = 1;
  const e = Wn(), t = Vs(), n = Q4(), r = GP(), o = Io().TAG_NAMES;
  class i extends e {
    constructor(s) {
      super(s), this.parser = s, this.treeAdapter = this.parser.treeAdapter, this.posTracker = null, this.lastStartTagToken = null, this.lastFosterParentingLocation = null, this.currentToken = null;
    }
    _setStartLocation(s) {
      let l = null;
      this.lastStartTagToken && (l = Object.assign({}, this.lastStartTagToken.location), l.startTag = this.lastStartTagToken.location), this.treeAdapter.setNodeSourceCodeLocation(s, l);
    }
    _setEndLocation(s, l) {
      if (this.treeAdapter.getNodeSourceCodeLocation(s) && l.location) {
        const u = l.location, m = this.treeAdapter.getTagName(s), v = l.type === t.END_TAG_TOKEN && m === l.tagName, g = {};
        v ? (g.endTag = Object.assign({}, u), g.endLine = u.endLine, g.endCol = u.endCol, g.endOffset = u.endOffset) : (g.endLine = u.startLine, g.endCol = u.startCol, g.endOffset = u.startOffset), this.treeAdapter.updateNodeSourceCodeLocation(s, g);
      }
    }
    _getOverriddenMethods(s, l) {
      return {
        _bootstrap(u, m) {
          l._bootstrap.call(this, u, m), s.lastStartTagToken = null, s.lastFosterParentingLocation = null, s.currentToken = null;
          const v = e.install(this.tokenizer, n);
          s.posTracker = v.posTracker, e.install(this.openElements, r, {
            onItemPop: function(g) {
              s._setEndLocation(g, s.currentToken);
            }
          });
        },
        _runParsingLoop(u) {
          l._runParsingLoop.call(this, u);
          for (let m = this.openElements.stackTop; m >= 0; m--)
            s._setEndLocation(this.openElements.items[m], s.currentToken);
        },
        //Token processing
        _processTokenInForeignContent(u) {
          s.currentToken = u, l._processTokenInForeignContent.call(this, u);
        },
        _processToken(u) {
          if (s.currentToken = u, l._processToken.call(this, u), u.type === t.END_TAG_TOKEN && (u.tagName === o.HTML || u.tagName === o.BODY && this.openElements.hasInScope(o.BODY)))
            for (let m = this.openElements.stackTop; m >= 0; m--) {
              const v = this.openElements.items[m];
              if (this.treeAdapter.getTagName(v) === u.tagName) {
                s._setEndLocation(v, u);
                break;
              }
            }
        },
        //Doctype
        _setDocumentType(u) {
          l._setDocumentType.call(this, u);
          const m = this.treeAdapter.getChildNodes(this.document), v = m.length;
          for (let g = 0; g < v; g++) {
            const h = m[g];
            if (this.treeAdapter.isDocumentTypeNode(h)) {
              this.treeAdapter.setNodeSourceCodeLocation(h, u.location);
              break;
            }
          }
        },
        //Elements
        _attachElementToTree(u) {
          s._setStartLocation(u), s.lastStartTagToken = null, l._attachElementToTree.call(this, u);
        },
        _appendElement(u, m) {
          s.lastStartTagToken = u, l._appendElement.call(this, u, m);
        },
        _insertElement(u, m) {
          s.lastStartTagToken = u, l._insertElement.call(this, u, m);
        },
        _insertTemplate(u) {
          s.lastStartTagToken = u, l._insertTemplate.call(this, u);
          const m = this.treeAdapter.getTemplateContent(this.openElements.current);
          this.treeAdapter.setNodeSourceCodeLocation(m, null);
        },
        _insertFakeRootElement() {
          l._insertFakeRootElement.call(this), this.treeAdapter.setNodeSourceCodeLocation(this.openElements.current, null);
        },
        //Comments
        _appendCommentNode(u, m) {
          l._appendCommentNode.call(this, u, m);
          const v = this.treeAdapter.getChildNodes(m), g = v[v.length - 1];
          this.treeAdapter.setNodeSourceCodeLocation(g, u.location);
        },
        //Text
        _findFosterParentingLocation() {
          return s.lastFosterParentingLocation = l._findFosterParentingLocation.call(this), s.lastFosterParentingLocation;
        },
        _insertCharacters(u) {
          l._insertCharacters.call(this, u);
          const m = this._shouldFosterParentOnInsertion(), v = m && s.lastFosterParentingLocation.parent || this.openElements.currentTmplContent || this.openElements.current, g = this.treeAdapter.getChildNodes(v), h = m && s.lastFosterParentingLocation.beforeElement ? g.indexOf(s.lastFosterParentingLocation.beforeElement) - 1 : g.length - 1, E = g[h];
          if (this.treeAdapter.getNodeSourceCodeLocation(E)) {
            const { endLine: C, endCol: A, endOffset: R } = u.location;
            this.treeAdapter.updateNodeSourceCodeLocation(E, { endLine: C, endCol: A, endOffset: R });
          } else
            this.treeAdapter.setNodeSourceCodeLocation(E, u.location);
        }
      };
    }
  }
  return Jl = i, Jl;
}
var e1, Qm;
function V0() {
  if (Qm) return e1;
  Qm = 1;
  const e = Wn();
  class t extends e {
    constructor(r, o) {
      super(r), this.posTracker = null, this.onParseError = o.onParseError;
    }
    _setErrorLocation(r) {
      r.startLine = r.endLine = this.posTracker.line, r.startCol = r.endCol = this.posTracker.col, r.startOffset = r.endOffset = this.posTracker.offset;
    }
    _reportError(r) {
      const o = {
        code: r,
        startLine: -1,
        startCol: -1,
        startOffset: -1,
        endLine: -1,
        endCol: -1,
        endOffset: -1
      };
      this._setErrorLocation(o), this.onParseError(o);
    }
    _getOverriddenMethods(r) {
      return {
        _err(o) {
          r._reportError(o);
        }
      };
    }
  }
  return e1 = t, e1;
}
var t1, Jm;
function zP() {
  if (Jm) return t1;
  Jm = 1;
  const e = V0(), t = X4(), n = Wn();
  class r extends e {
    constructor(i, a) {
      super(i, a), this.posTracker = n.install(i, t), this.lastErrOffset = -1;
    }
    _reportError(i) {
      this.lastErrOffset !== this.posTracker.offset && (this.lastErrOffset = this.posTracker.offset, super._reportError(i));
    }
  }
  return t1 = r, t1;
}
var n1, e5;
function ZP() {
  if (e5) return n1;
  e5 = 1;
  const e = V0(), t = zP(), n = Wn();
  class r extends e {
    constructor(i, a) {
      super(i, a);
      const s = n.install(i.preprocessor, t, a);
      this.posTracker = s.posTracker;
    }
  }
  return n1 = r, n1;
}
var r1, t5;
function xP() {
  if (t5) return r1;
  t5 = 1;
  const e = V0(), t = ZP(), n = Q4(), r = Wn();
  class o extends e {
    constructor(a, s) {
      super(a, s), this.opts = s, this.ctLoc = null, this.locBeforeToken = !1;
    }
    _setErrorLocation(a) {
      this.ctLoc && (a.startLine = this.ctLoc.startLine, a.startCol = this.ctLoc.startCol, a.startOffset = this.ctLoc.startOffset, a.endLine = this.locBeforeToken ? this.ctLoc.startLine : this.ctLoc.endLine, a.endCol = this.locBeforeToken ? this.ctLoc.startCol : this.ctLoc.endCol, a.endOffset = this.locBeforeToken ? this.ctLoc.startOffset : this.ctLoc.endOffset);
    }
    _getOverriddenMethods(a, s) {
      return {
        _bootstrap(l, u) {
          s._bootstrap.call(this, l, u), r.install(this.tokenizer, t, a.opts), r.install(this.tokenizer, n);
        },
        _processInputToken(l) {
          a.ctLoc = l.location, s._processInputToken.call(this, l);
        },
        _err(l, u) {
          a.locBeforeToken = u && u.beforeToken, a._reportError(l);
        }
      };
    }
  }
  return r1 = o, r1;
}
var ke = {}, n5;
function WP() {
  if (n5) return ke;
  n5 = 1;
  const { DOCUMENT_MODE: e } = Io();
  ke.createDocument = function() {
    return {
      nodeName: "#document",
      mode: e.NO_QUIRKS,
      childNodes: []
    };
  }, ke.createDocumentFragment = function() {
    return {
      nodeName: "#document-fragment",
      childNodes: []
    };
  }, ke.createElement = function(o, i, a) {
    return {
      nodeName: o,
      tagName: o,
      attrs: a,
      namespaceURI: i,
      childNodes: [],
      parentNode: null
    };
  }, ke.createCommentNode = function(o) {
    return {
      nodeName: "#comment",
      data: o,
      parentNode: null
    };
  };
  const t = function(o) {
    return {
      nodeName: "#text",
      value: o,
      parentNode: null
    };
  }, n = ke.appendChild = function(o, i) {
    o.childNodes.push(i), i.parentNode = o;
  }, r = ke.insertBefore = function(o, i, a) {
    const s = o.childNodes.indexOf(a);
    o.childNodes.splice(s, 0, i), i.parentNode = o;
  };
  return ke.setTemplateContent = function(o, i) {
    o.content = i;
  }, ke.getTemplateContent = function(o) {
    return o.content;
  }, ke.setDocumentType = function(o, i, a, s) {
    let l = null;
    for (let u = 0; u < o.childNodes.length; u++)
      if (o.childNodes[u].nodeName === "#documentType") {
        l = o.childNodes[u];
        break;
      }
    l ? (l.name = i, l.publicId = a, l.systemId = s) : n(o, {
      nodeName: "#documentType",
      name: i,
      publicId: a,
      systemId: s
    });
  }, ke.setDocumentMode = function(o, i) {
    o.mode = i;
  }, ke.getDocumentMode = function(o) {
    return o.mode;
  }, ke.detachNode = function(o) {
    if (o.parentNode) {
      const i = o.parentNode.childNodes.indexOf(o);
      o.parentNode.childNodes.splice(i, 1), o.parentNode = null;
    }
  }, ke.insertText = function(o, i) {
    if (o.childNodes.length) {
      const a = o.childNodes[o.childNodes.length - 1];
      if (a.nodeName === "#text") {
        a.value += i;
        return;
      }
    }
    n(o, t(i));
  }, ke.insertTextBefore = function(o, i, a) {
    const s = o.childNodes[o.childNodes.indexOf(a) - 1];
    s && s.nodeName === "#text" ? s.value += i : r(o, t(i), a);
  }, ke.adoptAttributes = function(o, i) {
    const a = [];
    for (let s = 0; s < o.attrs.length; s++)
      a.push(o.attrs[s].name);
    for (let s = 0; s < i.length; s++)
      a.indexOf(i[s].name) === -1 && o.attrs.push(i[s]);
  }, ke.getFirstChild = function(o) {
    return o.childNodes[0];
  }, ke.getChildNodes = function(o) {
    return o.childNodes;
  }, ke.getParentNode = function(o) {
    return o.parentNode;
  }, ke.getAttrList = function(o) {
    return o.attrs;
  }, ke.getTagName = function(o) {
    return o.tagName;
  }, ke.getNamespaceURI = function(o) {
    return o.namespaceURI;
  }, ke.getTextNodeContent = function(o) {
    return o.value;
  }, ke.getCommentNodeContent = function(o) {
    return o.data;
  }, ke.getDocumentTypeNodeName = function(o) {
    return o.name;
  }, ke.getDocumentTypeNodePublicId = function(o) {
    return o.publicId;
  }, ke.getDocumentTypeNodeSystemId = function(o) {
    return o.systemId;
  }, ke.isTextNode = function(o) {
    return o.nodeName === "#text";
  }, ke.isCommentNode = function(o) {
    return o.nodeName === "#comment";
  }, ke.isDocumentTypeNode = function(o) {
    return o.nodeName === "#documentType";
  }, ke.isElementNode = function(o) {
    return !!o.tagName;
  }, ke.setNodeSourceCodeLocation = function(o, i) {
    o.sourceCodeLocation = i;
  }, ke.getNodeSourceCodeLocation = function(o) {
    return o.sourceCodeLocation;
  }, ke.updateNodeSourceCodeLocation = function(o, i) {
    o.sourceCodeLocation = Object.assign(o.sourceCodeLocation, i);
  }, ke;
}
var r5, o5;
function YP() {
  return o5 || (o5 = 1, r5 = function(e, t) {
    return t = t || /* @__PURE__ */ Object.create(null), [e, t].reduce((n, r) => (Object.keys(r).forEach((o) => {
      n[o] = r[o];
    }), n), /* @__PURE__ */ Object.create(null));
  }), r5;
}
var Uo = {}, i5;
function XP() {
  if (i5) return Uo;
  i5 = 1;
  const { DOCUMENT_MODE: e } = Io(), t = "html", n = "about:legacy-compat", r = "http://www.ibm.com/data/dtd/v11/ibmxhtml1-transitional.dtd", o = [
    "+//silmaril//dtd html pro v0r11 19970101//",
    "-//as//dtd html 3.0 aswedit + extensions//",
    "-//advasoft ltd//dtd html 3.0 aswedit + extensions//",
    "-//ietf//dtd html 2.0 level 1//",
    "-//ietf//dtd html 2.0 level 2//",
    "-//ietf//dtd html 2.0 strict level 1//",
    "-//ietf//dtd html 2.0 strict level 2//",
    "-//ietf//dtd html 2.0 strict//",
    "-//ietf//dtd html 2.0//",
    "-//ietf//dtd html 2.1e//",
    "-//ietf//dtd html 3.0//",
    "-//ietf//dtd html 3.2 final//",
    "-//ietf//dtd html 3.2//",
    "-//ietf//dtd html 3//",
    "-//ietf//dtd html level 0//",
    "-//ietf//dtd html level 1//",
    "-//ietf//dtd html level 2//",
    "-//ietf//dtd html level 3//",
    "-//ietf//dtd html strict level 0//",
    "-//ietf//dtd html strict level 1//",
    "-//ietf//dtd html strict level 2//",
    "-//ietf//dtd html strict level 3//",
    "-//ietf//dtd html strict//",
    "-//ietf//dtd html//",
    "-//metrius//dtd metrius presentational//",
    "-//microsoft//dtd internet explorer 2.0 html strict//",
    "-//microsoft//dtd internet explorer 2.0 html//",
    "-//microsoft//dtd internet explorer 2.0 tables//",
    "-//microsoft//dtd internet explorer 3.0 html strict//",
    "-//microsoft//dtd internet explorer 3.0 html//",
    "-//microsoft//dtd internet explorer 3.0 tables//",
    "-//netscape comm. corp.//dtd html//",
    "-//netscape comm. corp.//dtd strict html//",
    "-//o'reilly and associates//dtd html 2.0//",
    "-//o'reilly and associates//dtd html extended 1.0//",
    "-//o'reilly and associates//dtd html extended relaxed 1.0//",
    "-//sq//dtd html 2.0 hotmetal + extensions//",
    "-//softquad software//dtd hotmetal pro 6.0::19990601::extensions to html 4.0//",
    "-//softquad//dtd hotmetal pro 4.0::19971010::extensions to html 4.0//",
    "-//spyglass//dtd html 2.0 extended//",
    "-//sun microsystems corp.//dtd hotjava html//",
    "-//sun microsystems corp.//dtd hotjava strict html//",
    "-//w3c//dtd html 3 1995-03-24//",
    "-//w3c//dtd html 3.2 draft//",
    "-//w3c//dtd html 3.2 final//",
    "-//w3c//dtd html 3.2//",
    "-//w3c//dtd html 3.2s draft//",
    "-//w3c//dtd html 4.0 frameset//",
    "-//w3c//dtd html 4.0 transitional//",
    "-//w3c//dtd html experimental 19960712//",
    "-//w3c//dtd html experimental 970421//",
    "-//w3c//dtd w3 html//",
    "-//w3o//dtd w3 html 3.0//",
    "-//webtechs//dtd mozilla html 2.0//",
    "-//webtechs//dtd mozilla html//"
  ], i = o.concat([
    "-//w3c//dtd html 4.01 frameset//",
    "-//w3c//dtd html 4.01 transitional//"
  ]), a = ["-//w3o//dtd w3 html strict 3.0//en//", "-/w3c/dtd html 4.0 transitional/en", "html"], s = ["-//w3c//dtd xhtml 1.0 frameset//", "-//w3c//dtd xhtml 1.0 transitional//"], l = s.concat([
    "-//w3c//dtd html 4.01 frameset//",
    "-//w3c//dtd html 4.01 transitional//"
  ]);
  function u(v) {
    const g = v.indexOf('"') !== -1 ? "'" : '"';
    return g + v + g;
  }
  function m(v, g) {
    for (let h = 0; h < g.length; h++)
      if (v.indexOf(g[h]) === 0)
        return !0;
    return !1;
  }
  return Uo.isConforming = function(v) {
    return v.name === t && v.publicId === null && (v.systemId === null || v.systemId === n);
  }, Uo.getDocumentMode = function(v) {
    if (v.name !== t)
      return e.QUIRKS;
    const g = v.systemId;
    if (g && g.toLowerCase() === r)
      return e.QUIRKS;
    let h = v.publicId;
    if (h !== null) {
      if (h = h.toLowerCase(), a.indexOf(h) > -1)
        return e.QUIRKS;
      let E = g === null ? i : o;
      if (m(h, E))
        return e.QUIRKS;
      if (E = g === null ? s : l, m(h, E))
        return e.LIMITED_QUIRKS;
    }
    return e.NO_QUIRKS;
  }, Uo.serializeContent = function(v, g, h) {
    let E = "!DOCTYPE ";
    return v && (E += v), g ? E += " PUBLIC " + u(g) : h && (E += " SYSTEM"), h !== null && (E += " " + u(h)), E;
  }, Uo;
}
var Vn = {}, s5;
function QP() {
  if (s5) return Vn;
  s5 = 1;
  const e = Vs(), t = Io(), n = t.TAG_NAMES, r = t.NAMESPACES, o = t.ATTRS, i = {
    TEXT_HTML: "text/html",
    APPLICATION_XML: "application/xhtml+xml"
  }, a = "definitionurl", s = "definitionURL", l = {
    attributename: "attributeName",
    attributetype: "attributeType",
    basefrequency: "baseFrequency",
    baseprofile: "baseProfile",
    calcmode: "calcMode",
    clippathunits: "clipPathUnits",
    diffuseconstant: "diffuseConstant",
    edgemode: "edgeMode",
    filterunits: "filterUnits",
    glyphref: "glyphRef",
    gradienttransform: "gradientTransform",
    gradientunits: "gradientUnits",
    kernelmatrix: "kernelMatrix",
    kernelunitlength: "kernelUnitLength",
    keypoints: "keyPoints",
    keysplines: "keySplines",
    keytimes: "keyTimes",
    lengthadjust: "lengthAdjust",
    limitingconeangle: "limitingConeAngle",
    markerheight: "markerHeight",
    markerunits: "markerUnits",
    markerwidth: "markerWidth",
    maskcontentunits: "maskContentUnits",
    maskunits: "maskUnits",
    numoctaves: "numOctaves",
    pathlength: "pathLength",
    patterncontentunits: "patternContentUnits",
    patterntransform: "patternTransform",
    patternunits: "patternUnits",
    pointsatx: "pointsAtX",
    pointsaty: "pointsAtY",
    pointsatz: "pointsAtZ",
    preservealpha: "preserveAlpha",
    preserveaspectratio: "preserveAspectRatio",
    primitiveunits: "primitiveUnits",
    refx: "refX",
    refy: "refY",
    repeatcount: "repeatCount",
    repeatdur: "repeatDur",
    requiredextensions: "requiredExtensions",
    requiredfeatures: "requiredFeatures",
    specularconstant: "specularConstant",
    specularexponent: "specularExponent",
    spreadmethod: "spreadMethod",
    startoffset: "startOffset",
    stddeviation: "stdDeviation",
    stitchtiles: "stitchTiles",
    surfacescale: "surfaceScale",
    systemlanguage: "systemLanguage",
    tablevalues: "tableValues",
    targetx: "targetX",
    targety: "targetY",
    textlength: "textLength",
    viewbox: "viewBox",
    viewtarget: "viewTarget",
    xchannelselector: "xChannelSelector",
    ychannelselector: "yChannelSelector",
    zoomandpan: "zoomAndPan"
  }, u = {
    "xlink:actuate": { prefix: "xlink", name: "actuate", namespace: r.XLINK },
    "xlink:arcrole": { prefix: "xlink", name: "arcrole", namespace: r.XLINK },
    "xlink:href": { prefix: "xlink", name: "href", namespace: r.XLINK },
    "xlink:role": { prefix: "xlink", name: "role", namespace: r.XLINK },
    "xlink:show": { prefix: "xlink", name: "show", namespace: r.XLINK },
    "xlink:title": { prefix: "xlink", name: "title", namespace: r.XLINK },
    "xlink:type": { prefix: "xlink", name: "type", namespace: r.XLINK },
    "xml:base": { prefix: "xml", name: "base", namespace: r.XML },
    "xml:lang": { prefix: "xml", name: "lang", namespace: r.XML },
    "xml:space": { prefix: "xml", name: "space", namespace: r.XML },
    xmlns: { prefix: "", name: "xmlns", namespace: r.XMLNS },
    "xmlns:xlink": { prefix: "xmlns", name: "xlink", namespace: r.XMLNS }
  }, m = Vn.SVG_TAG_NAMES_ADJUSTMENT_MAP = {
    altglyph: "altGlyph",
    altglyphdef: "altGlyphDef",
    altglyphitem: "altGlyphItem",
    animatecolor: "animateColor",
    animatemotion: "animateMotion",
    animatetransform: "animateTransform",
    clippath: "clipPath",
    feblend: "feBlend",
    fecolormatrix: "feColorMatrix",
    fecomponenttransfer: "feComponentTransfer",
    fecomposite: "feComposite",
    feconvolvematrix: "feConvolveMatrix",
    fediffuselighting: "feDiffuseLighting",
    fedisplacementmap: "feDisplacementMap",
    fedistantlight: "feDistantLight",
    feflood: "feFlood",
    fefunca: "feFuncA",
    fefuncb: "feFuncB",
    fefuncg: "feFuncG",
    fefuncr: "feFuncR",
    fegaussianblur: "feGaussianBlur",
    feimage: "feImage",
    femerge: "feMerge",
    femergenode: "feMergeNode",
    femorphology: "feMorphology",
    feoffset: "feOffset",
    fepointlight: "fePointLight",
    fespecularlighting: "feSpecularLighting",
    fespotlight: "feSpotLight",
    fetile: "feTile",
    feturbulence: "feTurbulence",
    foreignobject: "foreignObject",
    glyphref: "glyphRef",
    lineargradient: "linearGradient",
    radialgradient: "radialGradient",
    textpath: "textPath"
  }, v = {
    [n.B]: !0,
    [n.BIG]: !0,
    [n.BLOCKQUOTE]: !0,
    [n.BODY]: !0,
    [n.BR]: !0,
    [n.CENTER]: !0,
    [n.CODE]: !0,
    [n.DD]: !0,
    [n.DIV]: !0,
    [n.DL]: !0,
    [n.DT]: !0,
    [n.EM]: !0,
    [n.EMBED]: !0,
    [n.H1]: !0,
    [n.H2]: !0,
    [n.H3]: !0,
    [n.H4]: !0,
    [n.H5]: !0,
    [n.H6]: !0,
    [n.HEAD]: !0,
    [n.HR]: !0,
    [n.I]: !0,
    [n.IMG]: !0,
    [n.LI]: !0,
    [n.LISTING]: !0,
    [n.MENU]: !0,
    [n.META]: !0,
    [n.NOBR]: !0,
    [n.OL]: !0,
    [n.P]: !0,
    [n.PRE]: !0,
    [n.RUBY]: !0,
    [n.S]: !0,
    [n.SMALL]: !0,
    [n.SPAN]: !0,
    [n.STRONG]: !0,
    [n.STRIKE]: !0,
    [n.SUB]: !0,
    [n.SUP]: !0,
    [n.TABLE]: !0,
    [n.TT]: !0,
    [n.U]: !0,
    [n.UL]: !0,
    [n.VAR]: !0
  };
  Vn.causesExit = function(E) {
    const C = E.tagName;
    return C === n.FONT && (e.getTokenAttr(E, o.COLOR) !== null || e.getTokenAttr(E, o.SIZE) !== null || e.getTokenAttr(E, o.FACE) !== null) ? !0 : v[C];
  }, Vn.adjustTokenMathMLAttrs = function(E) {
    for (let C = 0; C < E.attrs.length; C++)
      if (E.attrs[C].name === a) {
        E.attrs[C].name = s;
        break;
      }
  }, Vn.adjustTokenSVGAttrs = function(E) {
    for (let C = 0; C < E.attrs.length; C++) {
      const A = l[E.attrs[C].name];
      A && (E.attrs[C].name = A);
    }
  }, Vn.adjustTokenXMLAttrs = function(E) {
    for (let C = 0; C < E.attrs.length; C++) {
      const A = u[E.attrs[C].name];
      A && (E.attrs[C].prefix = A.prefix, E.attrs[C].name = A.name, E.attrs[C].namespace = A.namespace);
    }
  }, Vn.adjustTokenSVGTagName = function(E) {
    const C = m[E.tagName];
    C && (E.tagName = C);
  };
  function g(E, C) {
    return C === r.MATHML && (E === n.MI || E === n.MO || E === n.MN || E === n.MS || E === n.MTEXT);
  }
  function h(E, C, A) {
    if (C === r.MATHML && E === n.ANNOTATION_XML) {
      for (let R = 0; R < A.length; R++)
        if (A[R].name === o.ENCODING) {
          const P = A[R].value.toLowerCase();
          return P === i.TEXT_HTML || P === i.APPLICATION_XML;
        }
    }
    return C === r.SVG && (E === n.FOREIGN_OBJECT || E === n.DESC || E === n.TITLE);
  }
  return Vn.isIntegrationPoint = function(E, C, A, R) {
    return !!((!R || R === r.HTML) && h(E, C, A) || (!R || R === r.MATHML) && g(E, C));
  }, Vn;
}
var o1, a5;
function JP() {
  if (a5) return o1;
  a5 = 1;
  const e = Vs(), t = UP(), n = qP(), r = KP(), o = xP(), i = Wn(), a = WP(), s = YP(), l = XP(), u = QP(), m = R0(), v = F0(), g = Io(), h = g.TAG_NAMES, E = g.NAMESPACES, C = g.ATTRS, A = {
    scriptingEnabled: !0,
    sourceCodeLocationInfo: !1,
    onParseError: null,
    treeAdapter: a
  }, R = "hidden", P = 8, F = 3, I = "INITIAL_MODE", D = "BEFORE_HTML_MODE", O = "BEFORE_HEAD_MODE", U = "IN_HEAD_MODE", q = "IN_HEAD_NO_SCRIPT_MODE", z = "AFTER_HEAD_MODE", te = "IN_BODY_MODE", ee = "TEXT_MODE", x = "IN_TABLE_MODE", N = "IN_TABLE_TEXT_MODE", G = "IN_CAPTION_MODE", X = "IN_COLUMN_GROUP_MODE", Q = "IN_TABLE_BODY_MODE", re = "IN_ROW_MODE", se = "IN_CELL_MODE", de = "IN_SELECT_MODE", me = "IN_SELECT_IN_TABLE_MODE", he = "IN_TEMPLATE_MODE", _e = "AFTER_BODY_MODE", De = "IN_FRAMESET_MODE", Ae = "AFTER_FRAMESET_MODE", Ze = "AFTER_AFTER_BODY_MODE", Je = "AFTER_AFTER_FRAMESET_MODE", Mt = {
    [h.TR]: re,
    [h.TBODY]: Q,
    [h.THEAD]: Q,
    [h.TFOOT]: Q,
    [h.CAPTION]: G,
    [h.COLGROUP]: X,
    [h.TABLE]: x,
    [h.BODY]: te,
    [h.FRAMESET]: De
  }, Vt = {
    [h.CAPTION]: x,
    [h.COLGROUP]: x,
    [h.TBODY]: x,
    [h.TFOOT]: x,
    [h.THEAD]: x,
    [h.COL]: X,
    [h.TR]: Q,
    [h.TD]: re,
    [h.TH]: re
  }, pn = {
    [I]: {
      [e.CHARACTER_TOKEN]: Xt,
      [e.NULL_CHARACTER_TOKEN]: Xt,
      [e.WHITESPACE_CHARACTER_TOKEN]: fe,
      [e.COMMENT_TOKEN]: Ve,
      [e.DOCTYPE_TOKEN]: mt,
      [e.START_TAG_TOKEN]: Xt,
      [e.END_TAG_TOKEN]: Xt,
      [e.EOF_TOKEN]: Xt
    },
    [D]: {
      [e.CHARACTER_TOKEN]: ft,
      [e.NULL_CHARACTER_TOKEN]: ft,
      [e.WHITESPACE_CHARACTER_TOKEN]: fe,
      [e.COMMENT_TOKEN]: Ve,
      [e.DOCTYPE_TOKEN]: fe,
      [e.START_TAG_TOKEN]: yn,
      [e.END_TAG_TOKEN]: tt,
      [e.EOF_TOKEN]: ft
    },
    [O]: {
      [e.CHARACTER_TOKEN]: Dt,
      [e.NULL_CHARACTER_TOKEN]: Dt,
      [e.WHITESPACE_CHARACTER_TOKEN]: fe,
      [e.COMMENT_TOKEN]: Ve,
      [e.DOCTYPE_TOKEN]: Pe,
      [e.START_TAG_TOKEN]: _n,
      [e.END_TAG_TOKEN]: Yn,
      [e.EOF_TOKEN]: Dt
    },
    [U]: {
      [e.CHARACTER_TOKEN]: $n,
      [e.NULL_CHARACTER_TOKEN]: $n,
      [e.WHITESPACE_CHARACTER_TOKEN]: be,
      [e.COMMENT_TOKEN]: Ve,
      [e.DOCTYPE_TOKEN]: Pe,
      [e.START_TAG_TOKEN]: Ce,
      [e.END_TAG_TOKEN]: Ne,
      [e.EOF_TOKEN]: $n
    },
    [q]: {
      [e.CHARACTER_TOKEN]: Xn,
      [e.NULL_CHARACTER_TOKEN]: Xn,
      [e.WHITESPACE_CHARACTER_TOKEN]: be,
      [e.COMMENT_TOKEN]: Ve,
      [e.DOCTYPE_TOKEN]: Pe,
      [e.START_TAG_TOKEN]: Mi,
      [e.END_TAG_TOKEN]: Ai,
      [e.EOF_TOKEN]: Xn
    },
    [z]: {
      [e.CHARACTER_TOKEN]: On,
      [e.NULL_CHARACTER_TOKEN]: On,
      [e.WHITESPACE_CHARACTER_TOKEN]: be,
      [e.COMMENT_TOKEN]: Ve,
      [e.DOCTYPE_TOKEN]: Pe,
      [e.START_TAG_TOKEN]: gr,
      [e.END_TAG_TOKEN]: vr,
      [e.EOF_TOKEN]: On
    },
    [te]: {
      [e.CHARACTER_TOKEN]: Pn,
      [e.NULL_CHARACTER_TOKEN]: fe,
      [e.WHITESPACE_CHARACTER_TOKEN]: dt,
      [e.COMMENT_TOKEN]: Ve,
      [e.DOCTYPE_TOKEN]: fe,
      [e.START_TAG_TOKEN]: qe,
      [e.END_TAG_TOKEN]: na,
      [e.EOF_TOKEN]: Hn
    },
    [ee]: {
      [e.CHARACTER_TOKEN]: be,
      [e.NULL_CHARACTER_TOKEN]: be,
      [e.WHITESPACE_CHARACTER_TOKEN]: be,
      [e.COMMENT_TOKEN]: fe,
      [e.DOCTYPE_TOKEN]: fe,
      [e.START_TAG_TOKEN]: fe,
      [e.END_TAG_TOKEN]: V8,
      [e.EOF_TOKEN]: B8
    },
    [x]: {
      [e.CHARACTER_TOKEN]: Fn,
      [e.NULL_CHARACTER_TOKEN]: Fn,
      [e.WHITESPACE_CHARACTER_TOKEN]: Fn,
      [e.COMMENT_TOKEN]: Ve,
      [e.DOCTYPE_TOKEN]: fe,
      [e.START_TAG_TOKEN]: ra,
      [e.END_TAG_TOKEN]: oa,
      [e.EOF_TOKEN]: Hn
    },
    [N]: {
      [e.CHARACTER_TOKEN]: Y8,
      [e.NULL_CHARACTER_TOKEN]: fe,
      [e.WHITESPACE_CHARACTER_TOKEN]: W8,
      [e.COMMENT_TOKEN]: Fo,
      [e.DOCTYPE_TOKEN]: Fo,
      [e.START_TAG_TOKEN]: Fo,
      [e.END_TAG_TOKEN]: Fo,
      [e.EOF_TOKEN]: Fo
    },
    [G]: {
      [e.CHARACTER_TOKEN]: Pn,
      [e.NULL_CHARACTER_TOKEN]: fe,
      [e.WHITESPACE_CHARACTER_TOKEN]: dt,
      [e.COMMENT_TOKEN]: Ve,
      [e.DOCTYPE_TOKEN]: fe,
      [e.START_TAG_TOKEN]: X8,
      [e.END_TAG_TOKEN]: Q8,
      [e.EOF_TOKEN]: Hn
    },
    [X]: {
      [e.CHARACTER_TOKEN]: Fi,
      [e.NULL_CHARACTER_TOKEN]: Fi,
      [e.WHITESPACE_CHARACTER_TOKEN]: be,
      [e.COMMENT_TOKEN]: Ve,
      [e.DOCTYPE_TOKEN]: fe,
      [e.START_TAG_TOKEN]: J8,
      [e.END_TAG_TOKEN]: e6,
      [e.EOF_TOKEN]: Hn
    },
    [Q]: {
      [e.CHARACTER_TOKEN]: Fn,
      [e.NULL_CHARACTER_TOKEN]: Fn,
      [e.WHITESPACE_CHARACTER_TOKEN]: Fn,
      [e.COMMENT_TOKEN]: Ve,
      [e.DOCTYPE_TOKEN]: fe,
      [e.START_TAG_TOKEN]: t6,
      [e.END_TAG_TOKEN]: n6,
      [e.EOF_TOKEN]: Hn
    },
    [re]: {
      [e.CHARACTER_TOKEN]: Fn,
      [e.NULL_CHARACTER_TOKEN]: Fn,
      [e.WHITESPACE_CHARACTER_TOKEN]: Fn,
      [e.COMMENT_TOKEN]: Ve,
      [e.DOCTYPE_TOKEN]: fe,
      [e.START_TAG_TOKEN]: r6,
      [e.END_TAG_TOKEN]: o6,
      [e.EOF_TOKEN]: Hn
    },
    [se]: {
      [e.CHARACTER_TOKEN]: Pn,
      [e.NULL_CHARACTER_TOKEN]: fe,
      [e.WHITESPACE_CHARACTER_TOKEN]: dt,
      [e.COMMENT_TOKEN]: Ve,
      [e.DOCTYPE_TOKEN]: fe,
      [e.START_TAG_TOKEN]: i6,
      [e.END_TAG_TOKEN]: s6,
      [e.EOF_TOKEN]: Hn
    },
    [de]: {
      [e.CHARACTER_TOKEN]: be,
      [e.NULL_CHARACTER_TOKEN]: fe,
      [e.WHITESPACE_CHARACTER_TOKEN]: be,
      [e.COMMENT_TOKEN]: Ve,
      [e.DOCTYPE_TOKEN]: fe,
      [e.START_TAG_TOKEN]: gh,
      [e.END_TAG_TOKEN]: vh,
      [e.EOF_TOKEN]: Hn
    },
    [me]: {
      [e.CHARACTER_TOKEN]: be,
      [e.NULL_CHARACTER_TOKEN]: fe,
      [e.WHITESPACE_CHARACTER_TOKEN]: be,
      [e.COMMENT_TOKEN]: Ve,
      [e.DOCTYPE_TOKEN]: fe,
      [e.START_TAG_TOKEN]: a6,
      [e.END_TAG_TOKEN]: l6,
      [e.EOF_TOKEN]: Hn
    },
    [he]: {
      [e.CHARACTER_TOKEN]: Pn,
      [e.NULL_CHARACTER_TOKEN]: fe,
      [e.WHITESPACE_CHARACTER_TOKEN]: dt,
      [e.COMMENT_TOKEN]: Ve,
      [e.DOCTYPE_TOKEN]: fe,
      [e.START_TAG_TOKEN]: u6,
      [e.END_TAG_TOKEN]: d6,
      [e.EOF_TOKEN]: bh
    },
    [_e]: {
      [e.CHARACTER_TOKEN]: Ri,
      [e.NULL_CHARACTER_TOKEN]: Ri,
      [e.WHITESPACE_CHARACTER_TOKEN]: dt,
      [e.COMMENT_TOKEN]: Lt,
      [e.DOCTYPE_TOKEN]: fe,
      [e.START_TAG_TOKEN]: c6,
      [e.END_TAG_TOKEN]: h6,
      [e.EOF_TOKEN]: et
    },
    [De]: {
      [e.CHARACTER_TOKEN]: fe,
      [e.NULL_CHARACTER_TOKEN]: fe,
      [e.WHITESPACE_CHARACTER_TOKEN]: be,
      [e.COMMENT_TOKEN]: Ve,
      [e.DOCTYPE_TOKEN]: fe,
      [e.START_TAG_TOKEN]: m6,
      [e.END_TAG_TOKEN]: f6,
      [e.EOF_TOKEN]: et
    },
    [Ae]: {
      [e.CHARACTER_TOKEN]: fe,
      [e.NULL_CHARACTER_TOKEN]: fe,
      [e.WHITESPACE_CHARACTER_TOKEN]: be,
      [e.COMMENT_TOKEN]: Ve,
      [e.DOCTYPE_TOKEN]: fe,
      [e.START_TAG_TOKEN]: p6,
      [e.END_TAG_TOKEN]: g6,
      [e.EOF_TOKEN]: et
    },
    [Ze]: {
      [e.CHARACTER_TOKEN]: Vi,
      [e.NULL_CHARACTER_TOKEN]: Vi,
      [e.WHITESPACE_CHARACTER_TOKEN]: dt,
      [e.COMMENT_TOKEN]: xe,
      [e.DOCTYPE_TOKEN]: fe,
      [e.START_TAG_TOKEN]: v6,
      [e.END_TAG_TOKEN]: Vi,
      [e.EOF_TOKEN]: et
    },
    [Je]: {
      [e.CHARACTER_TOKEN]: fe,
      [e.NULL_CHARACTER_TOKEN]: fe,
      [e.WHITESPACE_CHARACTER_TOKEN]: dt,
      [e.COMMENT_TOKEN]: xe,
      [e.DOCTYPE_TOKEN]: fe,
      [e.START_TAG_TOKEN]: b6,
      [e.END_TAG_TOKEN]: fe,
      [e.EOF_TOKEN]: et
    }
  };
  class gn {
    constructor(b) {
      this.options = s(A, b), this.treeAdapter = this.options.treeAdapter, this.pendingScript = null, this.options.sourceCodeLocationInfo && i.install(this, r), this.options.onParseError && i.install(this, o, { onParseError: this.options.onParseError });
    }
    // API
    parse(b) {
      const y = this.treeAdapter.createDocument();
      return this._bootstrap(y, null), this.tokenizer.write(b, !0), this._runParsingLoop(null), y;
    }
    parseFragment(b, y) {
      y || (y = this.treeAdapter.createElement(h.TEMPLATE, E.HTML, []));
      const ie = this.treeAdapter.createElement("documentmock", E.HTML, []);
      this._bootstrap(ie, y), this.treeAdapter.getTagName(y) === h.TEMPLATE && this._pushTmplInsertionMode(he), this._initTokenizerForFragmentParsing(), this._insertFakeRootElement(), this._resetInsertionMode(), this._findFormInFragmentContext(), this.tokenizer.write(b, !0), this._runParsingLoop(null);
      const pe = this.treeAdapter.getFirstChild(ie), Oe = this.treeAdapter.createDocumentFragment();
      return this._adoptNodes(pe, Oe), Oe;
    }
    //Bootstrap parser
    _bootstrap(b, y) {
      this.tokenizer = new e(this.options), this.stopped = !1, this.insertionMode = I, this.originalInsertionMode = "", this.document = b, this.fragmentContext = y, this.headElement = null, this.formElement = null, this.openElements = new t(this.document, this.treeAdapter), this.activeFormattingElements = new n(this.treeAdapter), this.tmplInsertionModeStack = [], this.tmplInsertionModeStackTop = -1, this.currentTmplInsertionMode = null, this.pendingCharacterTokens = [], this.hasNonWhitespacePendingCharacterToken = !1, this.framesetOk = !0, this.skipNextNewLine = !1, this.fosterParentingEnabled = !1;
    }
    //Errors
    _err() {
    }
    //Parsing loop
    _runParsingLoop(b) {
      for (; !this.stopped; ) {
        this._setupTokenizerCDATAMode();
        const y = this.tokenizer.getNextToken();
        if (y.type === e.HIBERNATION_TOKEN)
          break;
        if (this.skipNextNewLine && (this.skipNextNewLine = !1, y.type === e.WHITESPACE_CHARACTER_TOKEN && y.chars[0] === `
`)) {
          if (y.chars.length === 1)
            continue;
          y.chars = y.chars.substr(1);
        }
        if (this._processInputToken(y), b && this.pendingScript)
          break;
      }
    }
    runParsingLoopForCurrentChunk(b, y) {
      if (this._runParsingLoop(y), y && this.pendingScript) {
        const ie = this.pendingScript;
        this.pendingScript = null, y(ie);
        return;
      }
      b && b();
    }
    //Text parsing
    _setupTokenizerCDATAMode() {
      const b = this._getAdjustedCurrentElement();
      this.tokenizer.allowCDATA = b && b !== this.document && this.treeAdapter.getNamespaceURI(b) !== E.HTML && !this._isIntegrationPoint(b);
    }
    _switchToTextParsing(b, y) {
      this._insertElement(b, E.HTML), this.tokenizer.state = y, this.originalInsertionMode = this.insertionMode, this.insertionMode = ee;
    }
    switchToPlaintextParsing() {
      this.insertionMode = ee, this.originalInsertionMode = te, this.tokenizer.state = e.MODE.PLAINTEXT;
    }
    //Fragment parsing
    _getAdjustedCurrentElement() {
      return this.openElements.stackTop === 0 && this.fragmentContext ? this.fragmentContext : this.openElements.current;
    }
    _findFormInFragmentContext() {
      let b = this.fragmentContext;
      do {
        if (this.treeAdapter.getTagName(b) === h.FORM) {
          this.formElement = b;
          break;
        }
        b = this.treeAdapter.getParentNode(b);
      } while (b);
    }
    _initTokenizerForFragmentParsing() {
      if (this.treeAdapter.getNamespaceURI(this.fragmentContext) === E.HTML) {
        const b = this.treeAdapter.getTagName(this.fragmentContext);
        b === h.TITLE || b === h.TEXTAREA ? this.tokenizer.state = e.MODE.RCDATA : b === h.STYLE || b === h.XMP || b === h.IFRAME || b === h.NOEMBED || b === h.NOFRAMES || b === h.NOSCRIPT ? this.tokenizer.state = e.MODE.RAWTEXT : b === h.SCRIPT ? this.tokenizer.state = e.MODE.SCRIPT_DATA : b === h.PLAINTEXT && (this.tokenizer.state = e.MODE.PLAINTEXT);
      }
    }
    //Tree mutation
    _setDocumentType(b) {
      const y = b.name || "", ie = b.publicId || "", pe = b.systemId || "";
      this.treeAdapter.setDocumentType(this.document, y, ie, pe);
    }
    _attachElementToTree(b) {
      if (this._shouldFosterParentOnInsertion())
        this._fosterParentElement(b);
      else {
        const y = this.openElements.currentTmplContent || this.openElements.current;
        this.treeAdapter.appendChild(y, b);
      }
    }
    _appendElement(b, y) {
      const ie = this.treeAdapter.createElement(b.tagName, y, b.attrs);
      this._attachElementToTree(ie);
    }
    _insertElement(b, y) {
      const ie = this.treeAdapter.createElement(b.tagName, y, b.attrs);
      this._attachElementToTree(ie), this.openElements.push(ie);
    }
    _insertFakeElement(b) {
      const y = this.treeAdapter.createElement(b, E.HTML, []);
      this._attachElementToTree(y), this.openElements.push(y);
    }
    _insertTemplate(b) {
      const y = this.treeAdapter.createElement(b.tagName, E.HTML, b.attrs), ie = this.treeAdapter.createDocumentFragment();
      this.treeAdapter.setTemplateContent(y, ie), this._attachElementToTree(y), this.openElements.push(y);
    }
    _insertFakeRootElement() {
      const b = this.treeAdapter.createElement(h.HTML, E.HTML, []);
      this.treeAdapter.appendChild(this.openElements.current, b), this.openElements.push(b);
    }
    _appendCommentNode(b, y) {
      const ie = this.treeAdapter.createCommentNode(b.data);
      this.treeAdapter.appendChild(y, ie);
    }
    _insertCharacters(b) {
      if (this._shouldFosterParentOnInsertion())
        this._fosterParentText(b.chars);
      else {
        const y = this.openElements.currentTmplContent || this.openElements.current;
        this.treeAdapter.insertText(y, b.chars);
      }
    }
    _adoptNodes(b, y) {
      for (let ie = this.treeAdapter.getFirstChild(b); ie; ie = this.treeAdapter.getFirstChild(b))
        this.treeAdapter.detachNode(ie), this.treeAdapter.appendChild(y, ie);
    }
    //Token processing
    _shouldProcessTokenInForeignContent(b) {
      const y = this._getAdjustedCurrentElement();
      if (!y || y === this.document)
        return !1;
      const ie = this.treeAdapter.getNamespaceURI(y);
      if (ie === E.HTML || this.treeAdapter.getTagName(y) === h.ANNOTATION_XML && ie === E.MATHML && b.type === e.START_TAG_TOKEN && b.tagName === h.SVG)
        return !1;
      const pe = b.type === e.CHARACTER_TOKEN || b.type === e.NULL_CHARACTER_TOKEN || b.type === e.WHITESPACE_CHARACTER_TOKEN;
      return (b.type === e.START_TAG_TOKEN && b.tagName !== h.MGLYPH && b.tagName !== h.MALIGNMARK || pe) && this._isIntegrationPoint(y, E.MATHML) || (b.type === e.START_TAG_TOKEN || pe) && this._isIntegrationPoint(y, E.HTML) ? !1 : b.type !== e.EOF_TOKEN;
    }
    _processToken(b) {
      pn[this.insertionMode][b.type](this, b);
    }
    _processTokenInBodyMode(b) {
      pn[te][b.type](this, b);
    }
    _processTokenInForeignContent(b) {
      b.type === e.CHARACTER_TOKEN ? _6(this, b) : b.type === e.NULL_CHARACTER_TOKEN ? y6(this, b) : b.type === e.WHITESPACE_CHARACTER_TOKEN ? be(this, b) : b.type === e.COMMENT_TOKEN ? Ve(this, b) : b.type === e.START_TAG_TOKEN ? C6(this, b) : b.type === e.END_TAG_TOKEN && w6(this, b);
    }
    _processInputToken(b) {
      this._shouldProcessTokenInForeignContent(b) ? this._processTokenInForeignContent(b) : this._processToken(b), b.type === e.START_TAG_TOKEN && b.selfClosing && !b.ackSelfClosing && this._err(m.nonVoidHtmlElementStartTagWithTrailingSolidus);
    }
    //Integration points
    _isIntegrationPoint(b, y) {
      const ie = this.treeAdapter.getTagName(b), pe = this.treeAdapter.getNamespaceURI(b), Oe = this.treeAdapter.getAttrList(b);
      return u.isIntegrationPoint(ie, pe, Oe, y);
    }
    //Active formatting elements reconstruction
    _reconstructActiveFormattingElements() {
      const b = this.activeFormattingElements.length;
      if (b) {
        let y = b, ie = null;
        do
          if (y--, ie = this.activeFormattingElements.entries[y], ie.type === n.MARKER_ENTRY || this.openElements.contains(ie.element)) {
            y++;
            break;
          }
        while (y > 0);
        for (let pe = y; pe < b; pe++)
          ie = this.activeFormattingElements.entries[pe], this._insertElement(ie.token, this.treeAdapter.getNamespaceURI(ie.element)), ie.element = this.openElements.current;
      }
    }
    //Close elements
    _closeTableCell() {
      this.openElements.generateImpliedEndTags(), this.openElements.popUntilTableCellPopped(), this.activeFormattingElements.clearToLastMarker(), this.insertionMode = re;
    }
    _closePElement() {
      this.openElements.generateImpliedEndTagsWithExclusion(h.P), this.openElements.popUntilTagNamePopped(h.P);
    }
    //Insertion modes
    _resetInsertionMode() {
      for (let b = this.openElements.stackTop, y = !1; b >= 0; b--) {
        let ie = this.openElements.items[b];
        b === 0 && (y = !0, this.fragmentContext && (ie = this.fragmentContext));
        const pe = this.treeAdapter.getTagName(ie), Oe = Mt[pe];
        if (Oe) {
          this.insertionMode = Oe;
          break;
        } else if (!y && (pe === h.TD || pe === h.TH)) {
          this.insertionMode = se;
          break;
        } else if (!y && pe === h.HEAD) {
          this.insertionMode = U;
          break;
        } else if (pe === h.SELECT) {
          this._resetInsertionModeForSelect(b);
          break;
        } else if (pe === h.TEMPLATE) {
          this.insertionMode = this.currentTmplInsertionMode;
          break;
        } else if (pe === h.HTML) {
          this.insertionMode = this.headElement ? z : O;
          break;
        } else if (y) {
          this.insertionMode = te;
          break;
        }
      }
    }
    _resetInsertionModeForSelect(b) {
      if (b > 0)
        for (let y = b - 1; y > 0; y--) {
          const ie = this.openElements.items[y], pe = this.treeAdapter.getTagName(ie);
          if (pe === h.TEMPLATE)
            break;
          if (pe === h.TABLE) {
            this.insertionMode = me;
            return;
          }
        }
      this.insertionMode = de;
    }
    _pushTmplInsertionMode(b) {
      this.tmplInsertionModeStack.push(b), this.tmplInsertionModeStackTop++, this.currentTmplInsertionMode = b;
    }
    _popTmplInsertionMode() {
      this.tmplInsertionModeStack.pop(), this.tmplInsertionModeStackTop--, this.currentTmplInsertionMode = this.tmplInsertionModeStack[this.tmplInsertionModeStackTop];
    }
    //Foster parenting
    _isElementCausesFosterParenting(b) {
      const y = this.treeAdapter.getTagName(b);
      return y === h.TABLE || y === h.TBODY || y === h.TFOOT || y === h.THEAD || y === h.TR;
    }
    _shouldFosterParentOnInsertion() {
      return this.fosterParentingEnabled && this._isElementCausesFosterParenting(this.openElements.current);
    }
    _findFosterParentingLocation() {
      const b = {
        parent: null,
        beforeElement: null
      };
      for (let y = this.openElements.stackTop; y >= 0; y--) {
        const ie = this.openElements.items[y], pe = this.treeAdapter.getTagName(ie), Oe = this.treeAdapter.getNamespaceURI(ie);
        if (pe === h.TEMPLATE && Oe === E.HTML) {
          b.parent = this.treeAdapter.getTemplateContent(ie);
          break;
        } else if (pe === h.TABLE) {
          b.parent = this.treeAdapter.getParentNode(ie), b.parent ? b.beforeElement = ie : b.parent = this.openElements.items[y - 1];
          break;
        }
      }
      return b.parent || (b.parent = this.openElements.items[0]), b;
    }
    _fosterParentElement(b) {
      const y = this._findFosterParentingLocation();
      y.beforeElement ? this.treeAdapter.insertBefore(y.parent, b, y.beforeElement) : this.treeAdapter.appendChild(y.parent, b);
    }
    _fosterParentText(b) {
      const y = this._findFosterParentingLocation();
      y.beforeElement ? this.treeAdapter.insertTextBefore(y.parent, b, y.beforeElement) : this.treeAdapter.insertText(y.parent, b);
    }
    //Special elements
    _isSpecialElement(b) {
      const y = this.treeAdapter.getTagName(b), ie = this.treeAdapter.getNamespaceURI(b);
      return g.SPECIAL_ELEMENTS[ie][y];
    }
  }
  o1 = gn;
  function vn(p, b) {
    let y = p.activeFormattingElements.getElementEntryInScopeWithTagName(b.tagName);
    return y ? p.openElements.contains(y.element) ? p.openElements.hasInScope(b.tagName) || (y = null) : (p.activeFormattingElements.removeEntry(y), y = null) : ln(p, b), y;
  }
  function bn(p, b) {
    let y = null;
    for (let ie = p.openElements.stackTop; ie >= 0; ie--) {
      const pe = p.openElements.items[ie];
      if (pe === b.element)
        break;
      p._isSpecialElement(pe) && (y = pe);
    }
    return y || (p.openElements.popUntilElementPopped(b.element), p.activeFormattingElements.removeEntry(b)), y;
  }
  function Dn(p, b, y) {
    let ie = b, pe = p.openElements.getCommonAncestor(b);
    for (let Oe = 0, pt = pe; pt !== y; Oe++, pt = pe) {
      pe = p.openElements.getCommonAncestor(pt);
      const Ro = p.activeFormattingElements.getElementEntry(pt), yh = Ro && Oe >= F;
      !Ro || yh ? (yh && p.activeFormattingElements.removeEntry(Ro), p.openElements.remove(pt)) : (pt = At(p, Ro), ie === b && (p.activeFormattingElements.bookmark = Ro), p.treeAdapter.detachNode(ie), p.treeAdapter.appendChild(pt, ie), ie = pt);
    }
    return ie;
  }
  function At(p, b) {
    const y = p.treeAdapter.getNamespaceURI(b.element), ie = p.treeAdapter.createElement(b.token.tagName, y, b.token.attrs);
    return p.openElements.replace(b.element, ie), b.element = ie, ie;
  }
  function ce(p, b, y) {
    if (p._isElementCausesFosterParenting(b))
      p._fosterParentElement(y);
    else {
      const ie = p.treeAdapter.getTagName(b), pe = p.treeAdapter.getNamespaceURI(b);
      ie === h.TEMPLATE && pe === E.HTML && (b = p.treeAdapter.getTemplateContent(b)), p.treeAdapter.appendChild(b, y);
    }
  }
  function It(p, b, y) {
    const ie = p.treeAdapter.getNamespaceURI(y.element), pe = y.token, Oe = p.treeAdapter.createElement(pe.tagName, ie, pe.attrs);
    p._adoptNodes(b, Oe), p.treeAdapter.appendChild(b, Oe), p.activeFormattingElements.insertElementAfterBookmark(Oe, y.token), p.activeFormattingElements.removeEntry(y), p.openElements.remove(y.element), p.openElements.insertAfter(b, Oe);
  }
  function le(p, b) {
    let y;
    for (let ie = 0; ie < P && (y = vn(p, b), !!y); ie++) {
      const pe = bn(p, y);
      if (!pe)
        break;
      p.activeFormattingElements.bookmark = y;
      const Oe = Dn(p, pe, y.element), pt = p.openElements.getCommonAncestor(y.element);
      p.treeAdapter.detachNode(Oe), ce(p, pt, Oe), It(p, pe, y);
    }
  }
  function fe() {
  }
  function Pe(p) {
    p._err(m.misplacedDoctype);
  }
  function Ve(p, b) {
    p._appendCommentNode(b, p.openElements.currentTmplContent || p.openElements.current);
  }
  function Lt(p, b) {
    p._appendCommentNode(b, p.openElements.items[0]);
  }
  function xe(p, b) {
    p._appendCommentNode(b, p.document);
  }
  function be(p, b) {
    p._insertCharacters(b);
  }
  function et(p) {
    p.stopped = !0;
  }
  function mt(p, b) {
    p._setDocumentType(b);
    const y = b.forceQuirks ? g.DOCUMENT_MODE.QUIRKS : l.getDocumentMode(b);
    l.isConforming(b) || p._err(m.nonConformingDoctype), p.treeAdapter.setDocumentMode(p.document, y), p.insertionMode = D;
  }
  function Xt(p, b) {
    p._err(m.missingDoctype, { beforeToken: !0 }), p.treeAdapter.setDocumentMode(p.document, g.DOCUMENT_MODE.QUIRKS), p.insertionMode = D, p._processToken(b);
  }
  function yn(p, b) {
    b.tagName === h.HTML ? (p._insertElement(b, E.HTML), p.insertionMode = O) : ft(p, b);
  }
  function tt(p, b) {
    const y = b.tagName;
    (y === h.HTML || y === h.HEAD || y === h.BODY || y === h.BR) && ft(p, b);
  }
  function ft(p, b) {
    p._insertFakeRootElement(), p.insertionMode = O, p._processToken(b);
  }
  function _n(p, b) {
    const y = b.tagName;
    y === h.HTML ? qe(p, b) : y === h.HEAD ? (p._insertElement(b, E.HTML), p.headElement = p.openElements.current, p.insertionMode = U) : Dt(p, b);
  }
  function Yn(p, b) {
    const y = b.tagName;
    y === h.HEAD || y === h.BODY || y === h.HTML || y === h.BR ? Dt(p, b) : p._err(m.endTagWithoutMatchingOpenElement);
  }
  function Dt(p, b) {
    p._insertFakeElement(h.HEAD), p.headElement = p.openElements.current, p.insertionMode = U, p._processToken(b);
  }
  function Ce(p, b) {
    const y = b.tagName;
    y === h.HTML ? qe(p, b) : y === h.BASE || y === h.BASEFONT || y === h.BGSOUND || y === h.LINK || y === h.META ? (p._appendElement(b, E.HTML), b.ackSelfClosing = !0) : y === h.TITLE ? p._switchToTextParsing(b, e.MODE.RCDATA) : y === h.NOSCRIPT ? p.options.scriptingEnabled ? p._switchToTextParsing(b, e.MODE.RAWTEXT) : (p._insertElement(b, E.HTML), p.insertionMode = q) : y === h.NOFRAMES || y === h.STYLE ? p._switchToTextParsing(b, e.MODE.RAWTEXT) : y === h.SCRIPT ? p._switchToTextParsing(b, e.MODE.SCRIPT_DATA) : y === h.TEMPLATE ? (p._insertTemplate(b, E.HTML), p.activeFormattingElements.insertMarker(), p.framesetOk = !1, p.insertionMode = he, p._pushTmplInsertionMode(he)) : y === h.HEAD ? p._err(m.misplacedStartTagForHeadElement) : $n(p, b);
  }
  function Ne(p, b) {
    const y = b.tagName;
    y === h.HEAD ? (p.openElements.pop(), p.insertionMode = z) : y === h.BODY || y === h.BR || y === h.HTML ? $n(p, b) : y === h.TEMPLATE && p.openElements.tmplCount > 0 ? (p.openElements.generateImpliedEndTagsThoroughly(), p.openElements.currentTagName !== h.TEMPLATE && p._err(m.closingOfElementWithOpenChildElements), p.openElements.popUntilTagNamePopped(h.TEMPLATE), p.activeFormattingElements.clearToLastMarker(), p._popTmplInsertionMode(), p._resetInsertionMode()) : p._err(m.endTagWithoutMatchingOpenElement);
  }
  function $n(p, b) {
    p.openElements.pop(), p.insertionMode = z, p._processToken(b);
  }
  function Mi(p, b) {
    const y = b.tagName;
    y === h.HTML ? qe(p, b) : y === h.BASEFONT || y === h.BGSOUND || y === h.HEAD || y === h.LINK || y === h.META || y === h.NOFRAMES || y === h.STYLE ? Ce(p, b) : y === h.NOSCRIPT ? p._err(m.nestedNoscriptInHead) : Xn(p, b);
  }
  function Ai(p, b) {
    const y = b.tagName;
    y === h.NOSCRIPT ? (p.openElements.pop(), p.insertionMode = U) : y === h.BR ? Xn(p, b) : p._err(m.endTagWithoutMatchingOpenElement);
  }
  function Xn(p, b) {
    const y = b.type === e.EOF_TOKEN ? m.openElementsLeftAfterEof : m.disallowedContentInNoscriptInHead;
    p._err(y), p.openElements.pop(), p.insertionMode = U, p._processToken(b);
  }
  function gr(p, b) {
    const y = b.tagName;
    y === h.HTML ? qe(p, b) : y === h.BODY ? (p._insertElement(b, E.HTML), p.framesetOk = !1, p.insertionMode = te) : y === h.FRAMESET ? (p._insertElement(b, E.HTML), p.insertionMode = De) : y === h.BASE || y === h.BASEFONT || y === h.BGSOUND || y === h.LINK || y === h.META || y === h.NOFRAMES || y === h.SCRIPT || y === h.STYLE || y === h.TEMPLATE || y === h.TITLE ? (p._err(m.abandonedHeadElementChild), p.openElements.push(p.headElement), Ce(p, b), p.openElements.remove(p.headElement)) : y === h.HEAD ? p._err(m.misplacedStartTagForHeadElement) : On(p, b);
  }
  function vr(p, b) {
    const y = b.tagName;
    y === h.BODY || y === h.HTML || y === h.BR ? On(p, b) : y === h.TEMPLATE ? Ne(p, b) : p._err(m.endTagWithoutMatchingOpenElement);
  }
  function On(p, b) {
    p._insertFakeElement(h.BODY), p.insertionMode = te, p._processToken(b);
  }
  function dt(p, b) {
    p._reconstructActiveFormattingElements(), p._insertCharacters(b);
  }
  function Pn(p, b) {
    p._reconstructActiveFormattingElements(), p._insertCharacters(b), p.framesetOk = !1;
  }
  function Ii(p, b) {
    p.openElements.tmplCount === 0 && p.treeAdapter.adoptAttributes(p.openElements.items[0], b.attrs);
  }
  function Li(p, b) {
    const y = p.openElements.tryPeekProperlyNestedBodyElement();
    y && p.openElements.tmplCount === 0 && (p.framesetOk = !1, p.treeAdapter.adoptAttributes(y, b.attrs));
  }
  function Qn(p, b) {
    const y = p.openElements.tryPeekProperlyNestedBodyElement();
    p.framesetOk && y && (p.treeAdapter.detachNode(y), p.openElements.popAllUpToHtmlElement(), p._insertElement(b, E.HTML), p.insertionMode = De);
  }
  function Qt(p, b) {
    p.openElements.hasInButtonScope(h.P) && p._closePElement(), p._insertElement(b, E.HTML);
  }
  function Di(p, b) {
    p.openElements.hasInButtonScope(h.P) && p._closePElement();
    const y = p.openElements.currentTagName;
    (y === h.H1 || y === h.H2 || y === h.H3 || y === h.H4 || y === h.H5 || y === h.H6) && p.openElements.pop(), p._insertElement(b, E.HTML);
  }
  function $o(p, b) {
    p.openElements.hasInButtonScope(h.P) && p._closePElement(), p._insertElement(b, E.HTML), p.skipNextNewLine = !0, p.framesetOk = !1;
  }
  function $i(p, b) {
    const y = p.openElements.tmplCount > 0;
    (!p.formElement || y) && (p.openElements.hasInButtonScope(h.P) && p._closePElement(), p._insertElement(b, E.HTML), y || (p.formElement = p.openElements.current));
  }
  function Oi(p, b) {
    p.framesetOk = !1;
    const y = b.tagName;
    for (let ie = p.openElements.stackTop; ie >= 0; ie--) {
      const pe = p.openElements.items[ie], Oe = p.treeAdapter.getTagName(pe);
      let pt = null;
      if (y === h.LI && Oe === h.LI ? pt = h.LI : (y === h.DD || y === h.DT) && (Oe === h.DD || Oe === h.DT) && (pt = Oe), pt) {
        p.openElements.generateImpliedEndTagsWithExclusion(pt), p.openElements.popUntilTagNamePopped(pt);
        break;
      }
      if (Oe !== h.ADDRESS && Oe !== h.DIV && Oe !== h.P && p._isSpecialElement(pe))
        break;
    }
    p.openElements.hasInButtonScope(h.P) && p._closePElement(), p._insertElement(b, E.HTML);
  }
  function Pi(p, b) {
    p.openElements.hasInButtonScope(h.P) && p._closePElement(), p._insertElement(b, E.HTML), p.tokenizer.state = e.MODE.PLAINTEXT;
  }
  function Ni(p, b) {
    p.openElements.hasInScope(h.BUTTON) && (p.openElements.generateImpliedEndTags(), p.openElements.popUntilTagNamePopped(h.BUTTON)), p._reconstructActiveFormattingElements(), p._insertElement(b, E.HTML), p.framesetOk = !1;
  }
  function br(p, b) {
    const y = p.activeFormattingElements.getElementEntryInScopeWithTagName(h.A);
    y && (le(p, b), p.openElements.remove(y.element), p.activeFormattingElements.removeEntry(y)), p._reconstructActiveFormattingElements(), p._insertElement(b, E.HTML), p.activeFormattingElements.pushElement(p.openElements.current, b);
  }
  function Me(p, b) {
    p._reconstructActiveFormattingElements(), p._insertElement(b, E.HTML), p.activeFormattingElements.pushElement(p.openElements.current, b);
  }
  function yr(p, b) {
    p._reconstructActiveFormattingElements(), p.openElements.hasInScope(h.NOBR) && (le(p, b), p._reconstructActiveFormattingElements()), p._insertElement(b, E.HTML), p.activeFormattingElements.pushElement(p.openElements.current, b);
  }
  function $t(p, b) {
    p._reconstructActiveFormattingElements(), p._insertElement(b, E.HTML), p.activeFormattingElements.insertMarker(), p.framesetOk = !1;
  }
  function Nn(p, b) {
    p.treeAdapter.getDocumentMode(p.document) !== g.DOCUMENT_MODE.QUIRKS && p.openElements.hasInButtonScope(h.P) && p._closePElement(), p._insertElement(b, E.HTML), p.framesetOk = !1, p.insertionMode = x;
  }
  function Ct(p, b) {
    p._reconstructActiveFormattingElements(), p._appendElement(b, E.HTML), p.framesetOk = !1, b.ackSelfClosing = !0;
  }
  function Oo(p, b) {
    p._reconstructActiveFormattingElements(), p._appendElement(b, E.HTML);
    const y = e.getTokenAttr(b, C.TYPE);
    (!y || y.toLowerCase() !== R) && (p.framesetOk = !1), b.ackSelfClosing = !0;
  }
  function Po(p, b) {
    p._appendElement(b, E.HTML), b.ackSelfClosing = !0;
  }
  function Hi(p, b) {
    p.openElements.hasInButtonScope(h.P) && p._closePElement(), p._appendElement(b, E.HTML), p.framesetOk = !1, b.ackSelfClosing = !0;
  }
  function ta(p, b) {
    b.tagName = h.IMG, Ct(p, b);
  }
  function Qr(p, b) {
    p._insertElement(b, E.HTML), p.skipNextNewLine = !0, p.tokenizer.state = e.MODE.RCDATA, p.originalInsertionMode = p.insertionMode, p.framesetOk = !1, p.insertionMode = ee;
  }
  function Ue(p, b) {
    p.openElements.hasInButtonScope(h.P) && p._closePElement(), p._reconstructActiveFormattingElements(), p.framesetOk = !1, p._switchToTextParsing(b, e.MODE.RAWTEXT);
  }
  function Cn(p, b) {
    p.framesetOk = !1, p._switchToTextParsing(b, e.MODE.RAWTEXT);
  }
  function No(p, b) {
    p._switchToTextParsing(b, e.MODE.RAWTEXT);
  }
  function $e(p, b) {
    p._reconstructActiveFormattingElements(), p._insertElement(b, E.HTML), p.framesetOk = !1, p.insertionMode === x || p.insertionMode === G || p.insertionMode === Q || p.insertionMode === re || p.insertionMode === se ? p.insertionMode = me : p.insertionMode = de;
  }
  function ve(p, b) {
    p.openElements.currentTagName === h.OPTION && p.openElements.pop(), p._reconstructActiveFormattingElements(), p._insertElement(b, E.HTML);
  }
  function w(p, b) {
    p.openElements.hasInScope(h.RUBY) && p.openElements.generateImpliedEndTags(), p._insertElement(b, E.HTML);
  }
  function Te(p, b) {
    p.openElements.hasInScope(h.RUBY) && p.openElements.generateImpliedEndTagsWithExclusion(h.RTC), p._insertElement(b, E.HTML);
  }
  function wt(p, b) {
    p.openElements.hasInButtonScope(h.P) && p._closePElement(), p._insertElement(b, E.HTML);
  }
  function at(p, b) {
    p._reconstructActiveFormattingElements(), u.adjustTokenMathMLAttrs(b), u.adjustTokenXMLAttrs(b), b.selfClosing ? p._appendElement(b, E.MATHML) : p._insertElement(b, E.MATHML), b.ackSelfClosing = !0;
  }
  function ct(p, b) {
    p._reconstructActiveFormattingElements(), u.adjustTokenSVGAttrs(b), u.adjustTokenXMLAttrs(b), b.selfClosing ? p._appendElement(b, E.SVG) : p._insertElement(b, E.SVG), b.ackSelfClosing = !0;
  }
  function nt(p, b) {
    p._reconstructActiveFormattingElements(), p._insertElement(b, E.HTML);
  }
  function qe(p, b) {
    const y = b.tagName;
    switch (y.length) {
      case 1:
        y === h.I || y === h.S || y === h.B || y === h.U ? Me(p, b) : y === h.P ? Qt(p, b) : y === h.A ? br(p, b) : nt(p, b);
        break;
      case 2:
        y === h.DL || y === h.OL || y === h.UL ? Qt(p, b) : y === h.H1 || y === h.H2 || y === h.H3 || y === h.H4 || y === h.H5 || y === h.H6 ? Di(p, b) : y === h.LI || y === h.DD || y === h.DT ? Oi(p, b) : y === h.EM || y === h.TT ? Me(p, b) : y === h.BR ? Ct(p, b) : y === h.HR ? Hi(p, b) : y === h.RB ? w(p, b) : y === h.RT || y === h.RP ? Te(p, b) : y !== h.TH && y !== h.TD && y !== h.TR && nt(p, b);
        break;
      case 3:
        y === h.DIV || y === h.DIR || y === h.NAV ? Qt(p, b) : y === h.PRE ? $o(p, b) : y === h.BIG ? Me(p, b) : y === h.IMG || y === h.WBR ? Ct(p, b) : y === h.XMP ? Ue(p, b) : y === h.SVG ? ct(p, b) : y === h.RTC ? w(p, b) : y !== h.COL && nt(p, b);
        break;
      case 4:
        y === h.HTML ? Ii(p, b) : y === h.BASE || y === h.LINK || y === h.META ? Ce(p, b) : y === h.BODY ? Li(p, b) : y === h.MAIN || y === h.MENU ? Qt(p, b) : y === h.FORM ? $i(p, b) : y === h.CODE || y === h.FONT ? Me(p, b) : y === h.NOBR ? yr(p, b) : y === h.AREA ? Ct(p, b) : y === h.MATH ? at(p, b) : y === h.MENU ? wt(p, b) : y !== h.HEAD && nt(p, b);
        break;
      case 5:
        y === h.STYLE || y === h.TITLE ? Ce(p, b) : y === h.ASIDE ? Qt(p, b) : y === h.SMALL ? Me(p, b) : y === h.TABLE ? Nn(p, b) : y === h.EMBED ? Ct(p, b) : y === h.INPUT ? Oo(p, b) : y === h.PARAM || y === h.TRACK ? Po(p, b) : y === h.IMAGE ? ta(p, b) : y !== h.FRAME && y !== h.TBODY && y !== h.TFOOT && y !== h.THEAD && nt(p, b);
        break;
      case 6:
        y === h.SCRIPT ? Ce(p, b) : y === h.CENTER || y === h.FIGURE || y === h.FOOTER || y === h.HEADER || y === h.HGROUP || y === h.DIALOG ? Qt(p, b) : y === h.BUTTON ? Ni(p, b) : y === h.STRIKE || y === h.STRONG ? Me(p, b) : y === h.APPLET || y === h.OBJECT ? $t(p, b) : y === h.KEYGEN ? Ct(p, b) : y === h.SOURCE ? Po(p, b) : y === h.IFRAME ? Cn(p, b) : y === h.SELECT ? $e(p, b) : y === h.OPTION ? ve(p, b) : nt(p, b);
        break;
      case 7:
        y === h.BGSOUND ? Ce(p, b) : y === h.DETAILS || y === h.ADDRESS || y === h.ARTICLE || y === h.SECTION || y === h.SUMMARY ? Qt(p, b) : y === h.LISTING ? $o(p, b) : y === h.MARQUEE ? $t(p, b) : y === h.NOEMBED ? No(p, b) : y !== h.CAPTION && nt(p, b);
        break;
      case 8:
        y === h.BASEFONT ? Ce(p, b) : y === h.FRAMESET ? Qn(p, b) : y === h.FIELDSET ? Qt(p, b) : y === h.TEXTAREA ? Qr(p, b) : y === h.TEMPLATE ? Ce(p, b) : y === h.NOSCRIPT ? p.options.scriptingEnabled ? No(p, b) : nt(p, b) : y === h.OPTGROUP ? ve(p, b) : y !== h.COLGROUP && nt(p, b);
        break;
      case 9:
        y === h.PLAINTEXT ? Pi(p, b) : nt(p, b);
        break;
      case 10:
        y === h.BLOCKQUOTE || y === h.FIGCAPTION ? Qt(p, b) : nt(p, b);
        break;
      default:
        nt(p, b);
    }
  }
  function Jr(p) {
    p.openElements.hasInScope(h.BODY) && (p.insertionMode = _e);
  }
  function Ho(p, b) {
    p.openElements.hasInScope(h.BODY) && (p.insertionMode = _e, p._processToken(b));
  }
  function Jn(p, b) {
    const y = b.tagName;
    p.openElements.hasInScope(y) && (p.openElements.generateImpliedEndTags(), p.openElements.popUntilTagNamePopped(y));
  }
  function O8(p) {
    const b = p.openElements.tmplCount > 0, y = p.formElement;
    b || (p.formElement = null), (y || b) && p.openElements.hasInScope(h.FORM) && (p.openElements.generateImpliedEndTags(), b ? p.openElements.popUntilTagNamePopped(h.FORM) : p.openElements.remove(y));
  }
  function P8(p) {
    p.openElements.hasInButtonScope(h.P) || p._insertFakeElement(h.P), p._closePElement();
  }
  function N8(p) {
    p.openElements.hasInListItemScope(h.LI) && (p.openElements.generateImpliedEndTagsWithExclusion(h.LI), p.openElements.popUntilTagNamePopped(h.LI));
  }
  function H8(p, b) {
    const y = b.tagName;
    p.openElements.hasInScope(y) && (p.openElements.generateImpliedEndTagsWithExclusion(y), p.openElements.popUntilTagNamePopped(y));
  }
  function F8(p) {
    p.openElements.hasNumberedHeaderInScope() && (p.openElements.generateImpliedEndTags(), p.openElements.popUntilNumberedHeaderPopped());
  }
  function ph(p, b) {
    const y = b.tagName;
    p.openElements.hasInScope(y) && (p.openElements.generateImpliedEndTags(), p.openElements.popUntilTagNamePopped(y), p.activeFormattingElements.clearToLastMarker());
  }
  function R8(p) {
    p._reconstructActiveFormattingElements(), p._insertFakeElement(h.BR), p.openElements.pop(), p.framesetOk = !1;
  }
  function ln(p, b) {
    const y = b.tagName;
    for (let ie = p.openElements.stackTop; ie > 0; ie--) {
      const pe = p.openElements.items[ie];
      if (p.treeAdapter.getTagName(pe) === y) {
        p.openElements.generateImpliedEndTagsWithExclusion(y), p.openElements.popUntilElementPopped(pe);
        break;
      }
      if (p._isSpecialElement(pe))
        break;
    }
  }
  function na(p, b) {
    const y = b.tagName;
    switch (y.length) {
      case 1:
        y === h.A || y === h.B || y === h.I || y === h.S || y === h.U ? le(p, b) : y === h.P ? P8(p) : ln(p, b);
        break;
      case 2:
        y === h.DL || y === h.UL || y === h.OL ? Jn(p, b) : y === h.LI ? N8(p) : y === h.DD || y === h.DT ? H8(p, b) : y === h.H1 || y === h.H2 || y === h.H3 || y === h.H4 || y === h.H5 || y === h.H6 ? F8(p) : y === h.BR ? R8(p) : y === h.EM || y === h.TT ? le(p, b) : ln(p, b);
        break;
      case 3:
        y === h.BIG ? le(p, b) : y === h.DIR || y === h.DIV || y === h.NAV || y === h.PRE ? Jn(p, b) : ln(p, b);
        break;
      case 4:
        y === h.BODY ? Jr(p) : y === h.HTML ? Ho(p, b) : y === h.FORM ? O8(p) : y === h.CODE || y === h.FONT || y === h.NOBR ? le(p, b) : y === h.MAIN || y === h.MENU ? Jn(p, b) : ln(p, b);
        break;
      case 5:
        y === h.ASIDE ? Jn(p, b) : y === h.SMALL ? le(p, b) : ln(p, b);
        break;
      case 6:
        y === h.CENTER || y === h.FIGURE || y === h.FOOTER || y === h.HEADER || y === h.HGROUP || y === h.DIALOG ? Jn(p, b) : y === h.APPLET || y === h.OBJECT ? ph(p, b) : y === h.STRIKE || y === h.STRONG ? le(p, b) : ln(p, b);
        break;
      case 7:
        y === h.ADDRESS || y === h.ARTICLE || y === h.DETAILS || y === h.SECTION || y === h.SUMMARY || y === h.LISTING ? Jn(p, b) : y === h.MARQUEE ? ph(p, b) : ln(p, b);
        break;
      case 8:
        y === h.FIELDSET ? Jn(p, b) : y === h.TEMPLATE ? Ne(p, b) : ln(p, b);
        break;
      case 10:
        y === h.BLOCKQUOTE || y === h.FIGCAPTION ? Jn(p, b) : ln(p, b);
        break;
      default:
        ln(p, b);
    }
  }
  function Hn(p, b) {
    p.tmplInsertionModeStackTop > -1 ? bh(p, b) : p.stopped = !0;
  }
  function V8(p, b) {
    b.tagName === h.SCRIPT && (p.pendingScript = p.openElements.current), p.openElements.pop(), p.insertionMode = p.originalInsertionMode;
  }
  function B8(p, b) {
    p._err(m.eofInElementThatCanContainOnlyText), p.openElements.pop(), p.insertionMode = p.originalInsertionMode, p._processToken(b);
  }
  function Fn(p, b) {
    const y = p.openElements.currentTagName;
    y === h.TABLE || y === h.TBODY || y === h.TFOOT || y === h.THEAD || y === h.TR ? (p.pendingCharacterTokens = [], p.hasNonWhitespacePendingCharacterToken = !1, p.originalInsertionMode = p.insertionMode, p.insertionMode = N, p._processToken(b)) : Jt(p, b);
  }
  function j8(p, b) {
    p.openElements.clearBackToTableContext(), p.activeFormattingElements.insertMarker(), p._insertElement(b, E.HTML), p.insertionMode = G;
  }
  function U8(p, b) {
    p.openElements.clearBackToTableContext(), p._insertElement(b, E.HTML), p.insertionMode = X;
  }
  function q8(p, b) {
    p.openElements.clearBackToTableContext(), p._insertFakeElement(h.COLGROUP), p.insertionMode = X, p._processToken(b);
  }
  function G8(p, b) {
    p.openElements.clearBackToTableContext(), p._insertElement(b, E.HTML), p.insertionMode = Q;
  }
  function K8(p, b) {
    p.openElements.clearBackToTableContext(), p._insertFakeElement(h.TBODY), p.insertionMode = Q, p._processToken(b);
  }
  function z8(p, b) {
    p.openElements.hasInTableScope(h.TABLE) && (p.openElements.popUntilTagNamePopped(h.TABLE), p._resetInsertionMode(), p._processToken(b));
  }
  function Z8(p, b) {
    const y = e.getTokenAttr(b, C.TYPE);
    y && y.toLowerCase() === R ? p._appendElement(b, E.HTML) : Jt(p, b), b.ackSelfClosing = !0;
  }
  function x8(p, b) {
    !p.formElement && p.openElements.tmplCount === 0 && (p._insertElement(b, E.HTML), p.formElement = p.openElements.current, p.openElements.pop());
  }
  function ra(p, b) {
    const y = b.tagName;
    switch (y.length) {
      case 2:
        y === h.TD || y === h.TH || y === h.TR ? K8(p, b) : Jt(p, b);
        break;
      case 3:
        y === h.COL ? q8(p, b) : Jt(p, b);
        break;
      case 4:
        y === h.FORM ? x8(p, b) : Jt(p, b);
        break;
      case 5:
        y === h.TABLE ? z8(p, b) : y === h.STYLE ? Ce(p, b) : y === h.TBODY || y === h.TFOOT || y === h.THEAD ? G8(p, b) : y === h.INPUT ? Z8(p, b) : Jt(p, b);
        break;
      case 6:
        y === h.SCRIPT ? Ce(p, b) : Jt(p, b);
        break;
      case 7:
        y === h.CAPTION ? j8(p, b) : Jt(p, b);
        break;
      case 8:
        y === h.COLGROUP ? U8(p, b) : y === h.TEMPLATE ? Ce(p, b) : Jt(p, b);
        break;
      default:
        Jt(p, b);
    }
  }
  function oa(p, b) {
    const y = b.tagName;
    y === h.TABLE ? p.openElements.hasInTableScope(h.TABLE) && (p.openElements.popUntilTagNamePopped(h.TABLE), p._resetInsertionMode()) : y === h.TEMPLATE ? Ne(p, b) : y !== h.BODY && y !== h.CAPTION && y !== h.COL && y !== h.COLGROUP && y !== h.HTML && y !== h.TBODY && y !== h.TD && y !== h.TFOOT && y !== h.TH && y !== h.THEAD && y !== h.TR && Jt(p, b);
  }
  function Jt(p, b) {
    const y = p.fosterParentingEnabled;
    p.fosterParentingEnabled = !0, p._processTokenInBodyMode(b), p.fosterParentingEnabled = y;
  }
  function W8(p, b) {
    p.pendingCharacterTokens.push(b);
  }
  function Y8(p, b) {
    p.pendingCharacterTokens.push(b), p.hasNonWhitespacePendingCharacterToken = !0;
  }
  function Fo(p, b) {
    let y = 0;
    if (p.hasNonWhitespacePendingCharacterToken)
      for (; y < p.pendingCharacterTokens.length; y++)
        Jt(p, p.pendingCharacterTokens[y]);
    else
      for (; y < p.pendingCharacterTokens.length; y++)
        p._insertCharacters(p.pendingCharacterTokens[y]);
    p.insertionMode = p.originalInsertionMode, p._processToken(b);
  }
  function X8(p, b) {
    const y = b.tagName;
    y === h.CAPTION || y === h.COL || y === h.COLGROUP || y === h.TBODY || y === h.TD || y === h.TFOOT || y === h.TH || y === h.THEAD || y === h.TR ? p.openElements.hasInTableScope(h.CAPTION) && (p.openElements.generateImpliedEndTags(), p.openElements.popUntilTagNamePopped(h.CAPTION), p.activeFormattingElements.clearToLastMarker(), p.insertionMode = x, p._processToken(b)) : qe(p, b);
  }
  function Q8(p, b) {
    const y = b.tagName;
    y === h.CAPTION || y === h.TABLE ? p.openElements.hasInTableScope(h.CAPTION) && (p.openElements.generateImpliedEndTags(), p.openElements.popUntilTagNamePopped(h.CAPTION), p.activeFormattingElements.clearToLastMarker(), p.insertionMode = x, y === h.TABLE && p._processToken(b)) : y !== h.BODY && y !== h.COL && y !== h.COLGROUP && y !== h.HTML && y !== h.TBODY && y !== h.TD && y !== h.TFOOT && y !== h.TH && y !== h.THEAD && y !== h.TR && na(p, b);
  }
  function J8(p, b) {
    const y = b.tagName;
    y === h.HTML ? qe(p, b) : y === h.COL ? (p._appendElement(b, E.HTML), b.ackSelfClosing = !0) : y === h.TEMPLATE ? Ce(p, b) : Fi(p, b);
  }
  function e6(p, b) {
    const y = b.tagName;
    y === h.COLGROUP ? p.openElements.currentTagName === h.COLGROUP && (p.openElements.pop(), p.insertionMode = x) : y === h.TEMPLATE ? Ne(p, b) : y !== h.COL && Fi(p, b);
  }
  function Fi(p, b) {
    p.openElements.currentTagName === h.COLGROUP && (p.openElements.pop(), p.insertionMode = x, p._processToken(b));
  }
  function t6(p, b) {
    const y = b.tagName;
    y === h.TR ? (p.openElements.clearBackToTableBodyContext(), p._insertElement(b, E.HTML), p.insertionMode = re) : y === h.TH || y === h.TD ? (p.openElements.clearBackToTableBodyContext(), p._insertFakeElement(h.TR), p.insertionMode = re, p._processToken(b)) : y === h.CAPTION || y === h.COL || y === h.COLGROUP || y === h.TBODY || y === h.TFOOT || y === h.THEAD ? p.openElements.hasTableBodyContextInTableScope() && (p.openElements.clearBackToTableBodyContext(), p.openElements.pop(), p.insertionMode = x, p._processToken(b)) : ra(p, b);
  }
  function n6(p, b) {
    const y = b.tagName;
    y === h.TBODY || y === h.TFOOT || y === h.THEAD ? p.openElements.hasInTableScope(y) && (p.openElements.clearBackToTableBodyContext(), p.openElements.pop(), p.insertionMode = x) : y === h.TABLE ? p.openElements.hasTableBodyContextInTableScope() && (p.openElements.clearBackToTableBodyContext(), p.openElements.pop(), p.insertionMode = x, p._processToken(b)) : (y !== h.BODY && y !== h.CAPTION && y !== h.COL && y !== h.COLGROUP || y !== h.HTML && y !== h.TD && y !== h.TH && y !== h.TR) && oa(p, b);
  }
  function r6(p, b) {
    const y = b.tagName;
    y === h.TH || y === h.TD ? (p.openElements.clearBackToTableRowContext(), p._insertElement(b, E.HTML), p.insertionMode = se, p.activeFormattingElements.insertMarker()) : y === h.CAPTION || y === h.COL || y === h.COLGROUP || y === h.TBODY || y === h.TFOOT || y === h.THEAD || y === h.TR ? p.openElements.hasInTableScope(h.TR) && (p.openElements.clearBackToTableRowContext(), p.openElements.pop(), p.insertionMode = Q, p._processToken(b)) : ra(p, b);
  }
  function o6(p, b) {
    const y = b.tagName;
    y === h.TR ? p.openElements.hasInTableScope(h.TR) && (p.openElements.clearBackToTableRowContext(), p.openElements.pop(), p.insertionMode = Q) : y === h.TABLE ? p.openElements.hasInTableScope(h.TR) && (p.openElements.clearBackToTableRowContext(), p.openElements.pop(), p.insertionMode = Q, p._processToken(b)) : y === h.TBODY || y === h.TFOOT || y === h.THEAD ? (p.openElements.hasInTableScope(y) || p.openElements.hasInTableScope(h.TR)) && (p.openElements.clearBackToTableRowContext(), p.openElements.pop(), p.insertionMode = Q, p._processToken(b)) : (y !== h.BODY && y !== h.CAPTION && y !== h.COL && y !== h.COLGROUP || y !== h.HTML && y !== h.TD && y !== h.TH) && oa(p, b);
  }
  function i6(p, b) {
    const y = b.tagName;
    y === h.CAPTION || y === h.COL || y === h.COLGROUP || y === h.TBODY || y === h.TD || y === h.TFOOT || y === h.TH || y === h.THEAD || y === h.TR ? (p.openElements.hasInTableScope(h.TD) || p.openElements.hasInTableScope(h.TH)) && (p._closeTableCell(), p._processToken(b)) : qe(p, b);
  }
  function s6(p, b) {
    const y = b.tagName;
    y === h.TD || y === h.TH ? p.openElements.hasInTableScope(y) && (p.openElements.generateImpliedEndTags(), p.openElements.popUntilTagNamePopped(y), p.activeFormattingElements.clearToLastMarker(), p.insertionMode = re) : y === h.TABLE || y === h.TBODY || y === h.TFOOT || y === h.THEAD || y === h.TR ? p.openElements.hasInTableScope(y) && (p._closeTableCell(), p._processToken(b)) : y !== h.BODY && y !== h.CAPTION && y !== h.COL && y !== h.COLGROUP && y !== h.HTML && na(p, b);
  }
  function gh(p, b) {
    const y = b.tagName;
    y === h.HTML ? qe(p, b) : y === h.OPTION ? (p.openElements.currentTagName === h.OPTION && p.openElements.pop(), p._insertElement(b, E.HTML)) : y === h.OPTGROUP ? (p.openElements.currentTagName === h.OPTION && p.openElements.pop(), p.openElements.currentTagName === h.OPTGROUP && p.openElements.pop(), p._insertElement(b, E.HTML)) : y === h.INPUT || y === h.KEYGEN || y === h.TEXTAREA || y === h.SELECT ? p.openElements.hasInSelectScope(h.SELECT) && (p.openElements.popUntilTagNamePopped(h.SELECT), p._resetInsertionMode(), y !== h.SELECT && p._processToken(b)) : (y === h.SCRIPT || y === h.TEMPLATE) && Ce(p, b);
  }
  function vh(p, b) {
    const y = b.tagName;
    if (y === h.OPTGROUP) {
      const ie = p.openElements.items[p.openElements.stackTop - 1], pe = ie && p.treeAdapter.getTagName(ie);
      p.openElements.currentTagName === h.OPTION && pe === h.OPTGROUP && p.openElements.pop(), p.openElements.currentTagName === h.OPTGROUP && p.openElements.pop();
    } else y === h.OPTION ? p.openElements.currentTagName === h.OPTION && p.openElements.pop() : y === h.SELECT && p.openElements.hasInSelectScope(h.SELECT) ? (p.openElements.popUntilTagNamePopped(h.SELECT), p._resetInsertionMode()) : y === h.TEMPLATE && Ne(p, b);
  }
  function a6(p, b) {
    const y = b.tagName;
    y === h.CAPTION || y === h.TABLE || y === h.TBODY || y === h.TFOOT || y === h.THEAD || y === h.TR || y === h.TD || y === h.TH ? (p.openElements.popUntilTagNamePopped(h.SELECT), p._resetInsertionMode(), p._processToken(b)) : gh(p, b);
  }
  function l6(p, b) {
    const y = b.tagName;
    y === h.CAPTION || y === h.TABLE || y === h.TBODY || y === h.TFOOT || y === h.THEAD || y === h.TR || y === h.TD || y === h.TH ? p.openElements.hasInTableScope(y) && (p.openElements.popUntilTagNamePopped(h.SELECT), p._resetInsertionMode(), p._processToken(b)) : vh(p, b);
  }
  function u6(p, b) {
    const y = b.tagName;
    if (y === h.BASE || y === h.BASEFONT || y === h.BGSOUND || y === h.LINK || y === h.META || y === h.NOFRAMES || y === h.SCRIPT || y === h.STYLE || y === h.TEMPLATE || y === h.TITLE)
      Ce(p, b);
    else {
      const ie = Vt[y] || te;
      p._popTmplInsertionMode(), p._pushTmplInsertionMode(ie), p.insertionMode = ie, p._processToken(b);
    }
  }
  function d6(p, b) {
    b.tagName === h.TEMPLATE && Ne(p, b);
  }
  function bh(p, b) {
    p.openElements.tmplCount > 0 ? (p.openElements.popUntilTagNamePopped(h.TEMPLATE), p.activeFormattingElements.clearToLastMarker(), p._popTmplInsertionMode(), p._resetInsertionMode(), p._processToken(b)) : p.stopped = !0;
  }
  function c6(p, b) {
    b.tagName === h.HTML ? qe(p, b) : Ri(p, b);
  }
  function h6(p, b) {
    b.tagName === h.HTML ? p.fragmentContext || (p.insertionMode = Ze) : Ri(p, b);
  }
  function Ri(p, b) {
    p.insertionMode = te, p._processToken(b);
  }
  function m6(p, b) {
    const y = b.tagName;
    y === h.HTML ? qe(p, b) : y === h.FRAMESET ? p._insertElement(b, E.HTML) : y === h.FRAME ? (p._appendElement(b, E.HTML), b.ackSelfClosing = !0) : y === h.NOFRAMES && Ce(p, b);
  }
  function f6(p, b) {
    b.tagName === h.FRAMESET && !p.openElements.isRootHtmlElementCurrent() && (p.openElements.pop(), !p.fragmentContext && p.openElements.currentTagName !== h.FRAMESET && (p.insertionMode = Ae));
  }
  function p6(p, b) {
    const y = b.tagName;
    y === h.HTML ? qe(p, b) : y === h.NOFRAMES && Ce(p, b);
  }
  function g6(p, b) {
    b.tagName === h.HTML && (p.insertionMode = Je);
  }
  function v6(p, b) {
    b.tagName === h.HTML ? qe(p, b) : Vi(p, b);
  }
  function Vi(p, b) {
    p.insertionMode = te, p._processToken(b);
  }
  function b6(p, b) {
    const y = b.tagName;
    y === h.HTML ? qe(p, b) : y === h.NOFRAMES && Ce(p, b);
  }
  function y6(p, b) {
    b.chars = v.REPLACEMENT_CHARACTER, p._insertCharacters(b);
  }
  function _6(p, b) {
    p._insertCharacters(b), p.framesetOk = !1;
  }
  function C6(p, b) {
    if (u.causesExit(b) && !p.fragmentContext) {
      for (; p.treeAdapter.getNamespaceURI(p.openElements.current) !== E.HTML && !p._isIntegrationPoint(p.openElements.current); )
        p.openElements.pop();
      p._processToken(b);
    } else {
      const y = p._getAdjustedCurrentElement(), ie = p.treeAdapter.getNamespaceURI(y);
      ie === E.MATHML ? u.adjustTokenMathMLAttrs(b) : ie === E.SVG && (u.adjustTokenSVGTagName(b), u.adjustTokenSVGAttrs(b)), u.adjustTokenXMLAttrs(b), b.selfClosing ? p._appendElement(b, ie) : p._insertElement(b, ie), b.ackSelfClosing = !0;
    }
  }
  function w6(p, b) {
    for (let y = p.openElements.stackTop; y > 0; y--) {
      const ie = p.openElements.items[y];
      if (p.treeAdapter.getNamespaceURI(ie) === E.HTML) {
        p._processToken(b);
        break;
      }
      if (p.treeAdapter.getTagName(ie).toLowerCase() === b.tagName) {
        p.openElements.popUntilElementPopped(ie);
        break;
      }
    }
  }
  return o1;
}
var eN = JP();
const tN = /* @__PURE__ */ Ao(eN);
class _i {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(t, n, r) {
    this.property = t, this.normal = n, r && (this.space = r);
  }
}
_i.prototype.property = {};
_i.prototype.normal = {};
_i.prototype.space = null;
function J4(e, t) {
  const n = {}, r = {};
  let o = -1;
  for (; ++o < e.length; )
    Object.assign(n, e[o].property), Object.assign(r, e[o].normal);
  return new _i(n, r, t);
}
function ci(e) {
  return e.toLowerCase();
}
class an {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(t, n) {
    this.property = t, this.attribute = n;
  }
}
an.prototype.space = null;
an.prototype.boolean = !1;
an.prototype.booleanish = !1;
an.prototype.overloadedBoolean = !1;
an.prototype.number = !1;
an.prototype.commaSeparated = !1;
an.prototype.spaceSeparated = !1;
an.prototype.commaOrSpaceSeparated = !1;
an.prototype.mustUseProperty = !1;
an.prototype.defined = !1;
let nN = 0;
const ye = xr(), rt = xr(), e3 = xr(), oe = xr(), Be = xr(), ho = xr(), jt = xr();
function xr() {
  return 2 ** ++nN;
}
const Yc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: ye,
  booleanish: rt,
  commaOrSpaceSeparated: jt,
  commaSeparated: ho,
  number: oe,
  overloadedBoolean: e3,
  spaceSeparated: Be
}, Symbol.toStringTag, { value: "Module" })), i1 = Object.keys(Yc);
class B0 extends an {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(t, n, r, o) {
    let i = -1;
    if (super(t, n), l5(this, "space", o), typeof r == "number")
      for (; ++i < i1.length; ) {
        const a = i1[i];
        l5(this, i1[i], (r & Yc[a]) === Yc[a]);
      }
  }
}
B0.prototype.defined = !0;
function l5(e, t, n) {
  n && (e[t] = n);
}
const rN = {}.hasOwnProperty;
function Lo(e) {
  const t = {}, n = {};
  let r;
  for (r in e.properties)
    if (rN.call(e.properties, r)) {
      const o = e.properties[r], i = new B0(
        r,
        e.transform(e.attributes || {}, r),
        o,
        e.space
      );
      e.mustUseProperty && e.mustUseProperty.includes(r) && (i.mustUseProperty = !0), t[r] = i, n[ci(r)] = r, n[ci(i.attribute)] = r;
    }
  return new _i(t, n, e.space);
}
const t3 = Lo({
  space: "xlink",
  transform(e, t) {
    return "xlink:" + t.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), n3 = Lo({
  space: "xml",
  transform(e, t) {
    return "xml:" + t.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function r3(e, t) {
  return t in e ? e[t] : t;
}
function o3(e, t) {
  return r3(e, t.toLowerCase());
}
const i3 = Lo({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: o3,
  properties: { xmlns: null, xmlnsXLink: null }
}), s3 = Lo({
  transform(e, t) {
    return t === "role" ? t : "aria-" + t.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: rt,
    ariaAutoComplete: null,
    ariaBusy: rt,
    ariaChecked: rt,
    ariaColCount: oe,
    ariaColIndex: oe,
    ariaColSpan: oe,
    ariaControls: Be,
    ariaCurrent: null,
    ariaDescribedBy: Be,
    ariaDetails: null,
    ariaDisabled: rt,
    ariaDropEffect: Be,
    ariaErrorMessage: null,
    ariaExpanded: rt,
    ariaFlowTo: Be,
    ariaGrabbed: rt,
    ariaHasPopup: null,
    ariaHidden: rt,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: Be,
    ariaLevel: oe,
    ariaLive: null,
    ariaModal: rt,
    ariaMultiLine: rt,
    ariaMultiSelectable: rt,
    ariaOrientation: null,
    ariaOwns: Be,
    ariaPlaceholder: null,
    ariaPosInSet: oe,
    ariaPressed: rt,
    ariaReadOnly: rt,
    ariaRelevant: null,
    ariaRequired: rt,
    ariaRoleDescription: Be,
    ariaRowCount: oe,
    ariaRowIndex: oe,
    ariaRowSpan: oe,
    ariaSelected: rt,
    ariaSetSize: oe,
    ariaSort: null,
    ariaValueMax: oe,
    ariaValueMin: oe,
    ariaValueNow: oe,
    ariaValueText: null,
    role: null
  }
}), oN = Lo({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: o3,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: ho,
    acceptCharset: Be,
    accessKey: Be,
    action: null,
    allow: null,
    allowFullScreen: ye,
    allowPaymentRequest: ye,
    allowUserMedia: ye,
    alt: null,
    as: null,
    async: ye,
    autoCapitalize: null,
    autoComplete: Be,
    autoFocus: ye,
    autoPlay: ye,
    blocking: Be,
    capture: null,
    charSet: null,
    checked: ye,
    cite: null,
    className: Be,
    cols: oe,
    colSpan: null,
    content: null,
    contentEditable: rt,
    controls: ye,
    controlsList: Be,
    coords: oe | ho,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: ye,
    defer: ye,
    dir: null,
    dirName: null,
    disabled: ye,
    download: e3,
    draggable: rt,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: ye,
    formTarget: null,
    headers: Be,
    height: oe,
    hidden: ye,
    high: oe,
    href: null,
    hrefLang: null,
    htmlFor: Be,
    httpEquiv: Be,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: ye,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: ye,
    itemId: null,
    itemProp: Be,
    itemRef: Be,
    itemScope: ye,
    itemType: Be,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: ye,
    low: oe,
    manifest: null,
    max: null,
    maxLength: oe,
    media: null,
    method: null,
    min: null,
    minLength: oe,
    multiple: ye,
    muted: ye,
    name: null,
    nonce: null,
    noModule: ye,
    noValidate: ye,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: ye,
    optimum: oe,
    pattern: null,
    ping: Be,
    placeholder: null,
    playsInline: ye,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: ye,
    referrerPolicy: null,
    rel: Be,
    required: ye,
    reversed: ye,
    rows: oe,
    rowSpan: oe,
    sandbox: Be,
    scope: null,
    scoped: ye,
    seamless: ye,
    selected: ye,
    shadowRootClonable: ye,
    shadowRootDelegatesFocus: ye,
    shadowRootMode: null,
    shape: null,
    size: oe,
    sizes: null,
    slot: null,
    span: oe,
    spellCheck: rt,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: oe,
    step: null,
    style: null,
    tabIndex: oe,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: ye,
    useMap: null,
    value: rt,
    width: oe,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: Be,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: oe,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: oe,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: ye,
    // Lists. Use CSS to reduce space between items instead
    declare: ye,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: oe,
    // `<img>` and `<object>`
    leftMargin: oe,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: oe,
    // `<body>`
    marginWidth: oe,
    // `<body>`
    noResize: ye,
    // `<frame>`
    noHref: ye,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: ye,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: ye,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: oe,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: rt,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: oe,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: oe,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: ye,
    disableRemotePlayback: ye,
    prefix: null,
    property: null,
    results: oe,
    security: null,
    unselectable: null
  }
}), iN = Lo({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: r3,
  properties: {
    about: jt,
    accentHeight: oe,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: oe,
    amplitude: oe,
    arabicForm: null,
    ascent: oe,
    attributeName: null,
    attributeType: null,
    azimuth: oe,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: oe,
    by: null,
    calcMode: null,
    capHeight: oe,
    className: Be,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: oe,
    diffuseConstant: oe,
    direction: null,
    display: null,
    dur: null,
    divisor: oe,
    dominantBaseline: null,
    download: ye,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: oe,
    enableBackground: null,
    end: null,
    event: null,
    exponent: oe,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: oe,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: ho,
    g2: ho,
    glyphName: ho,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: oe,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: oe,
    horizOriginX: oe,
    horizOriginY: oe,
    id: null,
    ideographic: oe,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: oe,
    k: oe,
    k1: oe,
    k2: oe,
    k3: oe,
    k4: oe,
    kernelMatrix: jt,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: oe,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: oe,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: oe,
    overlineThickness: oe,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: oe,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: Be,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: oe,
    pointsAtY: oe,
    pointsAtZ: oe,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: jt,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: jt,
    rev: jt,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: jt,
    requiredFeatures: jt,
    requiredFonts: jt,
    requiredFormats: jt,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: oe,
    specularExponent: oe,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: oe,
    strikethroughThickness: oe,
    string: null,
    stroke: null,
    strokeDashArray: jt,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: oe,
    strokeOpacity: oe,
    strokeWidth: null,
    style: null,
    surfaceScale: oe,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: jt,
    tabIndex: oe,
    tableValues: null,
    target: null,
    targetX: oe,
    targetY: oe,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: jt,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: oe,
    underlineThickness: oe,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: oe,
    values: null,
    vAlphabetic: oe,
    vMathematical: oe,
    vectorEffect: null,
    vHanging: oe,
    vIdeographic: oe,
    version: null,
    vertAdvY: oe,
    vertOriginX: oe,
    vertOriginY: oe,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: oe,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), sN = /^data[-\w.:]+$/i, u5 = /-[a-z]/g, aN = /[A-Z]/g;
function j0(e, t) {
  const n = ci(t);
  let r = t, o = an;
  if (n in e.normal)
    return e.property[e.normal[n]];
  if (n.length > 4 && n.slice(0, 4) === "data" && sN.test(t)) {
    if (t.charAt(4) === "-") {
      const i = t.slice(5).replace(u5, uN);
      r = "data" + i.charAt(0).toUpperCase() + i.slice(1);
    } else {
      const i = t.slice(4);
      if (!u5.test(i)) {
        let a = i.replace(aN, lN);
        a.charAt(0) !== "-" && (a = "-" + a), t = "data" + a;
      }
    }
    o = B0;
  }
  return new o(r, t);
}
function lN(e) {
  return "-" + e.toLowerCase();
}
function uN(e) {
  return e.charAt(1).toUpperCase();
}
const Bs = J4([n3, t3, i3, s3, oN], "html"), Ci = J4([n3, t3, i3, s3, iN], "svg"), d5 = /[#.]/g;
function dN(e, t) {
  const n = e || "", r = {};
  let o = 0, i, a;
  for (; o < n.length; ) {
    d5.lastIndex = o;
    const s = d5.exec(n), l = n.slice(o, s ? s.index : n.length);
    l && (i ? i === "#" ? r.id = l : Array.isArray(r.className) ? r.className.push(l) : r.className = [l] : a = l, o += l.length), s && (i = s[0], o++);
  }
  return {
    type: "element",
    // @ts-expect-error: fine.
    tagName: a || t || "div",
    properties: r,
    children: []
  };
}
function c5(e) {
  const t = String(e || "").trim();
  return t ? t.split(/[ \t\n\r\f]+/g) : [];
}
function cN(e) {
  return e.join(" ").trim();
}
function h5(e) {
  const t = [], n = String(e || "");
  let r = n.indexOf(","), o = 0, i = !1;
  for (; !i; ) {
    r === -1 && (r = n.length, i = !0);
    const a = n.slice(o, r).trim();
    (a || !i) && t.push(a), o = r + 1, r = n.indexOf(",", o);
  }
  return t;
}
function hN(e, t) {
  const n = t || {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (n.padRight ? " " : "") + "," + (n.padLeft === !1 ? "" : " ")
  ).trim();
}
const mN = /* @__PURE__ */ new Set(["menu", "submit", "reset", "button"]), Xc = {}.hasOwnProperty;
function a3(e, t, n) {
  const r = n && vN(n);
  return (
    /**
     * @type {{
     *   (): Root
     *   (selector: null | undefined, ...children: Array<HChild>): Root
     *   (selector: string, properties?: HProperties, ...children: Array<HChild>): Element
     *   (selector: string, ...children: Array<HChild>): Element
     * }}
     */
    /**
     * Hyperscript compatible DSL for creating virtual hast trees.
     *
     * @param {string | null} [selector]
     * @param {HProperties | HChild} [properties]
     * @param {Array<HChild>} children
     * @returns {HResult}
     */
    function(o, i, ...a) {
      let s = -1, l;
      if (o == null)
        l = { type: "root", children: [] }, a.unshift(i);
      else if (l = dN(o, t), l.tagName = l.tagName.toLowerCase(), r && Xc.call(r, l.tagName) && (l.tagName = r[l.tagName]), fN(i, l.tagName)) {
        let u;
        for (u in i)
          Xc.call(i, u) && pN(e, l.properties, u, i[u]);
      } else
        a.unshift(i);
      for (; ++s < a.length; )
        Qc(l.children, a[s]);
      return l.type === "element" && l.tagName === "template" && (l.content = { type: "root", children: l.children }, l.children = []), l;
    }
  );
}
function fN(e, t) {
  return e == null || typeof e != "object" || Array.isArray(e) ? !1 : t === "input" || !e.type || typeof e.type != "string" ? !0 : "children" in e && Array.isArray(e.children) ? !1 : t === "button" ? mN.has(e.type.toLowerCase()) : !("value" in e);
}
function pN(e, t, n, r) {
  const o = j0(e, n);
  let i = -1, a;
  if (r != null) {
    if (typeof r == "number") {
      if (Number.isNaN(r)) return;
      a = r;
    } else typeof r == "boolean" ? a = r : typeof r == "string" ? o.spaceSeparated ? a = c5(r) : o.commaSeparated ? a = h5(r) : o.commaOrSpaceSeparated ? a = c5(h5(r).join(" ")) : a = m5(o, o.property, r) : Array.isArray(r) ? a = r.concat() : a = o.property === "style" ? gN(r) : String(r);
    if (Array.isArray(a)) {
      const s = [];
      for (; ++i < a.length; )
        s[i] = m5(o, o.property, a[i]);
      a = s;
    }
    o.property === "className" && Array.isArray(t.className) && (a = t.className.concat(a)), t[o.property] = a;
  }
}
function Qc(e, t) {
  let n = -1;
  if (t != null) if (typeof t == "string" || typeof t == "number")
    e.push({ type: "text", value: String(t) });
  else if (Array.isArray(t))
    for (; ++n < t.length; )
      Qc(e, t[n]);
  else if (typeof t == "object" && "type" in t)
    t.type === "root" ? Qc(e, t.children) : e.push(t);
  else
    throw new Error("Expected node, nodes, or string, got `" + t + "`");
}
function m5(e, t, n) {
  if (typeof n == "string") {
    if (e.number && n && !Number.isNaN(Number(n)))
      return Number(n);
    if ((e.boolean || e.overloadedBoolean) && (n === "" || ci(n) === ci(t)))
      return !0;
  }
  return n;
}
function gN(e) {
  const t = [];
  let n;
  for (n in e)
    Xc.call(e, n) && t.push([n, e[n]].join(": "));
  return t.join("; ");
}
function vN(e) {
  const t = {};
  let n = -1;
  for (; ++n < e.length; )
    t[e[n].toLowerCase()] = e[n];
  return t;
}
const je = a3(Bs, "div"), bN = [
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feDropShadow",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "solidColor",
  "textArea",
  "textPath"
], yN = a3(Ci, "g", bN);
function _N(e) {
  const t = String(e), n = [], r = /\r?\n|\r/g;
  for (; r.test(t); )
    n.push(r.lastIndex);
  return n.push(t.length + 1), { toPoint: o, toOffset: i };
  function o(a) {
    let s = -1;
    if (typeof a == "number" && a > -1 && a < n[n.length - 1]) {
      for (; ++s < n.length; )
        if (n[s] > a)
          return {
            line: s + 1,
            column: a - (s > 0 ? n[s - 1] : 0) + 1,
            offset: a
          };
    }
    return { line: void 0, column: void 0, offset: void 0 };
  }
  function i(a) {
    const s = a && a.line, l = a && a.column;
    if (typeof s == "number" && typeof l == "number" && !Number.isNaN(s) && !Number.isNaN(l) && s - 1 in n) {
      const u = (n[s - 2] || 0) + l - 1 || 0;
      if (u > -1 && u < n[n.length - 1])
        return u;
    }
    return -1;
  }
}
const CN = {
  svg: "http://www.w3.org/2000/svg"
}, l3 = {}.hasOwnProperty, wN = Object.prototype;
function TN(e, t) {
  const n = t || {};
  let r, o;
  return SN(n) ? (o = n, r = {}) : (o = n.file || void 0, r = n), U0(
    {
      schema: r.space === "svg" ? Ci : Bs,
      file: o,
      verbose: r.verbose,
      location: !1
    },
    e
  );
}
function U0(e, t) {
  let n;
  switch (t.nodeName) {
    case "#comment": {
      const r = (
        /** @type {P5Comment} */
        t
      );
      return n = { type: "comment", value: r.data }, Ji(e, r, n), n;
    }
    case "#document":
    case "#document-fragment": {
      const r = (
        /** @type {P5Document | P5DocumentFragment} */
        t
      ), o = "mode" in r ? r.mode === "quirks" || r.mode === "limited-quirks" : !1;
      if (n = {
        type: "root",
        children: u3(e, t.childNodes),
        data: { quirksMode: o }
      }, e.file && e.location) {
        const i = String(e.file), a = _N(i), s = a.toPoint(0), l = a.toPoint(i.length);
        n.position = { start: s, end: l };
      }
      return n;
    }
    case "#documentType": {
      const r = (
        /** @type {P5DocumentType} */
        t
      );
      return n = { type: "doctype" }, Ji(e, r, n), n;
    }
    case "#text": {
      const r = (
        /** @type {P5Text} */
        t
      );
      return n = { type: "text", value: r.value }, Ji(e, r, n), n;
    }
    // Element.
    default:
      return n = kN(
        e,
        /** @type {P5Element} */
        t
      ), n;
  }
}
function u3(e, t) {
  let n = -1;
  const r = [];
  for (; ++n < t.length; )
    r[n] = U0(e, t[n]);
  return r;
}
function kN(e, t) {
  const n = e.schema;
  e.schema = t.namespaceURI === CN.svg ? Ci : Bs;
  let r = -1;
  const o = {};
  for (; ++r < t.attrs.length; ) {
    const a = t.attrs[r], s = (a.prefix ? a.prefix + ":" : "") + a.name;
    l3.call(wN, s) || (o[s] = a.value);
  }
  const i = (e.schema.space === "svg" ? yN : je)(t.tagName, o, u3(e, t.childNodes));
  if (Ji(e, t, i), i.tagName === "template") {
    const a = (
      /** @type {P5Template} */
      t
    ), s = a.sourceCodeLocation, l = s && s.startTag && ao(s.startTag), u = s && s.endTag && ao(s.endTag), m = U0(e, a.content);
    l && u && e.file && (m.position = { start: l.end, end: u.start }), i.content = m;
  }
  return e.schema = n, i;
}
function Ji(e, t, n) {
  if ("sourceCodeLocation" in t && t.sourceCodeLocation && e.file) {
    const r = EN(e, n, t.sourceCodeLocation);
    r && (e.location = !0, n.position = r);
  }
}
function EN(e, t, n) {
  const r = ao(n);
  if (t.type === "element") {
    const o = t.children[t.children.length - 1];
    if (r && !n.endTag && o && o.position && o.position.end && (r.end = Object.assign({}, o.position.end)), e.verbose) {
      const i = {};
      let a;
      if (n.attrs)
        for (a in n.attrs)
          l3.call(n.attrs, a) && (i[j0(e.schema, a).property] = ao(
            n.attrs[a]
          ));
      t.data = {
        position: {
          // @ts-expect-error: assume not `undefined`.
          opening: ao(n.startTag),
          closing: n.endTag ? ao(n.endTag) : null,
          properties: i
        }
      };
    }
  }
  return r;
}
function ao(e) {
  const t = f5({
    line: e.startLine,
    column: e.startCol,
    offset: e.startOffset
  }), n = f5({
    line: e.endLine,
    column: e.endCol,
    offset: e.endOffset
  });
  return t || n ? { start: t, end: n } : void 0;
}
function f5(e) {
  return e.line && e.column ? e : void 0;
}
function SN(e) {
  return "messages" in e;
}
const MN = {
  abandonedHeadElementChild: {
    reason: "Unexpected metadata element after head",
    description: "Unexpected element after head. Expected the element before `</head>`",
    url: !1
  },
  abruptClosingOfEmptyComment: {
    reason: "Unexpected abruptly closed empty comment",
    description: "Unexpected `>` or `->`. Expected `-->` to close comments"
  },
  abruptDoctypePublicIdentifier: {
    reason: "Unexpected abruptly closed public identifier",
    description: "Unexpected `>`. Expected a closing `\"` or `'` after the public identifier"
  },
  abruptDoctypeSystemIdentifier: {
    reason: "Unexpected abruptly closed system identifier",
    description: "Unexpected `>`. Expected a closing `\"` or `'` after the identifier identifier"
  },
  absenceOfDigitsInNumericCharacterReference: {
    reason: "Unexpected non-digit at start of numeric character reference",
    description: "Unexpected `%c`. Expected `[0-9]` for decimal references or `[0-9a-fA-F]` for hexadecimal references"
  },
  cdataInHtmlContent: {
    reason: "Unexpected CDATA section in HTML",
    description: "Unexpected `<![CDATA[` in HTML. Remove it, use a comment, or encode special characters instead"
  },
  characterReferenceOutsideUnicodeRange: {
    reason: "Unexpected too big numeric character reference",
    description: "Unexpectedly high character reference. Expected character references to be at most hexadecimal 10ffff (or decimal 1114111)"
  },
  closingOfElementWithOpenChildElements: {
    reason: "Unexpected closing tag with open child elements",
    description: "Unexpectedly closing tag. Expected other tags to be closed first",
    url: !1
  },
  controlCharacterInInputStream: {
    reason: "Unexpected control character",
    description: "Unexpected control character `%x`. Expected a non-control code point, 0x00, or ASCII whitespace"
  },
  controlCharacterReference: {
    reason: "Unexpected control character reference",
    description: "Unexpectedly control character in reference. Expected a non-control code point, 0x00, or ASCII whitespace"
  },
  disallowedContentInNoscriptInHead: {
    reason: "Disallowed content inside `<noscript>` in `<head>`",
    description: "Unexpected text character `%c`. Only use text in `<noscript>`s in `<body>`",
    url: !1
  },
  duplicateAttribute: {
    reason: "Unexpected duplicate attribute",
    description: "Unexpectedly double attribute. Expected attributes to occur only once"
  },
  endTagWithAttributes: {
    reason: "Unexpected attribute on closing tag",
    description: "Unexpected attribute. Expected `>` instead"
  },
  endTagWithTrailingSolidus: {
    reason: "Unexpected slash at end of closing tag",
    description: "Unexpected `%c-1`. Expected `>` instead"
  },
  endTagWithoutMatchingOpenElement: {
    reason: "Unexpected unopened end tag",
    description: "Unexpected end tag. Expected no end tag or another end tag",
    url: !1
  },
  eofBeforeTagName: {
    reason: "Unexpected end of file",
    description: "Unexpected end of file. Expected tag name instead"
  },
  eofInCdata: {
    reason: "Unexpected end of file in CDATA",
    description: "Unexpected end of file. Expected `]]>` to close the CDATA"
  },
  eofInComment: {
    reason: "Unexpected end of file in comment",
    description: "Unexpected end of file. Expected `-->` to close the comment"
  },
  eofInDoctype: {
    reason: "Unexpected end of file in doctype",
    description: "Unexpected end of file. Expected a valid doctype (such as `<!doctype html>`)"
  },
  eofInElementThatCanContainOnlyText: {
    reason: "Unexpected end of file in element that can only contain text",
    description: "Unexpected end of file. Expected text or a closing tag",
    url: !1
  },
  eofInScriptHtmlCommentLikeText: {
    reason: "Unexpected end of file in comment inside script",
    description: "Unexpected end of file. Expected `-->` to close the comment"
  },
  eofInTag: {
    reason: "Unexpected end of file in tag",
    description: "Unexpected end of file. Expected `>` to close the tag"
  },
  incorrectlyClosedComment: {
    reason: "Incorrectly closed comment",
    description: "Unexpected `%c-1`. Expected `-->` to close the comment"
  },
  incorrectlyOpenedComment: {
    reason: "Incorrectly opened comment",
    description: "Unexpected `%c`. Expected `<!--` to open the comment"
  },
  invalidCharacterSequenceAfterDoctypeName: {
    reason: "Invalid sequence after doctype name",
    description: "Unexpected sequence at `%c`. Expected `public` or `system`"
  },
  invalidFirstCharacterOfTagName: {
    reason: "Invalid first character in tag name",
    description: "Unexpected `%c`. Expected an ASCII letter instead"
  },
  misplacedDoctype: {
    reason: "Misplaced doctype",
    description: "Unexpected doctype. Expected doctype before head",
    url: !1
  },
  misplacedStartTagForHeadElement: {
    reason: "Misplaced `<head>` start tag",
    description: "Unexpected start tag `<head>`. Expected `<head>` directly after doctype",
    url: !1
  },
  missingAttributeValue: {
    reason: "Missing attribute value",
    description: "Unexpected `%c-1`. Expected an attribute value or no `%c-1` instead"
  },
  missingDoctype: {
    reason: "Missing doctype before other content",
    description: "Expected a `<!doctype html>` before anything else",
    url: !1
  },
  missingDoctypeName: {
    reason: "Missing doctype name",
    description: "Unexpected doctype end at `%c`. Expected `html` instead"
  },
  missingDoctypePublicIdentifier: {
    reason: "Missing public identifier in doctype",
    description: "Unexpected `%c`. Expected identifier for `public` instead"
  },
  missingDoctypeSystemIdentifier: {
    reason: "Missing system identifier in doctype",
    description: 'Unexpected `%c`. Expected identifier for `system` instead (suggested: `"about:legacy-compat"`)'
  },
  missingEndTagName: {
    reason: "Missing name in end tag",
    description: "Unexpected `%c`. Expected an ASCII letter instead"
  },
  missingQuoteBeforeDoctypePublicIdentifier: {
    reason: "Missing quote before public identifier in doctype",
    description: "Unexpected `%c`. Expected `\"` or `'` instead"
  },
  missingQuoteBeforeDoctypeSystemIdentifier: {
    reason: "Missing quote before system identifier in doctype",
    description: "Unexpected `%c`. Expected `\"` or `'` instead"
  },
  missingSemicolonAfterCharacterReference: {
    reason: "Missing semicolon after character reference",
    description: "Unexpected `%c`. Expected `;` instead"
  },
  missingWhitespaceAfterDoctypePublicKeyword: {
    reason: "Missing whitespace after public identifier in doctype",
    description: "Unexpected `%c`. Expected ASCII whitespace instead"
  },
  missingWhitespaceAfterDoctypeSystemKeyword: {
    reason: "Missing whitespace after system identifier in doctype",
    description: "Unexpected `%c`. Expected ASCII whitespace instead"
  },
  missingWhitespaceBeforeDoctypeName: {
    reason: "Missing whitespace before doctype name",
    description: "Unexpected `%c`. Expected ASCII whitespace instead"
  },
  missingWhitespaceBetweenAttributes: {
    reason: "Missing whitespace between attributes",
    description: "Unexpected `%c`. Expected ASCII whitespace instead"
  },
  missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers: {
    reason: "Missing whitespace between public and system identifiers in doctype",
    description: "Unexpected `%c`. Expected ASCII whitespace instead"
  },
  nestedComment: {
    reason: "Unexpected nested comment",
    description: "Unexpected `<!--`. Expected `-->`"
  },
  nestedNoscriptInHead: {
    reason: "Unexpected nested `<noscript>` in `<head>`",
    description: "Unexpected `<noscript>`. Expected a closing tag or a meta element",
    url: !1
  },
  nonConformingDoctype: {
    reason: "Unexpected non-conforming doctype declaration",
    description: 'Expected `<!doctype html>` or `<!doctype html system "about:legacy-compat">`',
    url: !1
  },
  nonVoidHtmlElementStartTagWithTrailingSolidus: {
    reason: "Unexpected trailing slash on start tag of non-void element",
    description: "Unexpected `/`. Expected `>` instead"
  },
  noncharacterCharacterReference: {
    reason: "Unexpected noncharacter code point referenced by character reference",
    description: "Unexpected code point. Do not use noncharacters in HTML"
  },
  noncharacterInInputStream: {
    reason: "Unexpected noncharacter character",
    description: "Unexpected code point `%x`. Do not use noncharacters in HTML"
  },
  nullCharacterReference: {
    reason: "Unexpected NULL character referenced by character reference",
    description: "Unexpected code point. Do not use NULL characters in HTML"
  },
  openElementsLeftAfterEof: {
    reason: "Unexpected end of file",
    description: "Unexpected end of file. Expected closing tag instead",
    url: !1
  },
  surrogateCharacterReference: {
    reason: "Unexpected surrogate character referenced by character reference",
    description: "Unexpected code point. Do not use lone surrogate characters in HTML"
  },
  surrogateInInputStream: {
    reason: "Unexpected surrogate character",
    description: "Unexpected code point `%x`. Do not use lone surrogate characters in HTML"
  },
  unexpectedCharacterAfterDoctypeSystemIdentifier: {
    reason: "Invalid character after system identifier in doctype",
    description: "Unexpected character at `%c`. Expected `>`"
  },
  unexpectedCharacterInAttributeName: {
    reason: "Unexpected character in attribute name",
    description: "Unexpected `%c`. Expected whitespace, `/`, `>`, `=`, or probably an ASCII letter"
  },
  unexpectedCharacterInUnquotedAttributeValue: {
    reason: "Unexpected character in unquoted attribute value",
    description: "Unexpected `%c`. Quote the attribute value to include it"
  },
  unexpectedEqualsSignBeforeAttributeName: {
    reason: "Unexpected equals sign before attribute name",
    description: "Unexpected `%c`. Add an attribute name before it"
  },
  unexpectedNullCharacter: {
    reason: "Unexpected NULL character",
    description: "Unexpected code point `%x`. Do not use NULL characters in HTML"
  },
  unexpectedQuestionMarkInsteadOfTagName: {
    reason: "Unexpected question mark instead of tag name",
    description: "Unexpected `%c`. Expected an ASCII letter instead"
  },
  unexpectedSolidusInTag: {
    reason: "Unexpected slash in tag",
    description: "Unexpected `%c-1`. Expected it followed by `>` or in a quoted attribute value"
  },
  unknownNamedCharacterReference: {
    reason: "Unexpected unknown named character reference",
    description: "Unexpected character reference. Expected known named character references"
  }
}, AN = "https://html.spec.whatwg.org/multipage/parsing.html#parse-error-", IN = { 2: !0, 1: !1, 0: null };
function d3(e) {
  const t = (
    /** @type {Options} */
    this.data("settings")
  ), n = Object.assign({}, t, e);
  Object.assign(this, { Parser: r });
  function r(o, i) {
    const a = n.fragment ? "parseFragment" : "parse", s = n.emitParseErrors ? u : null, l = new tN({
      sourceCodeLocationInfo: !0,
      onParseError: s,
      scriptingEnabled: !1
    });
    return TN(l[a](o), {
      space: n.space,
      file: i,
      verbose: n.verbose
    });
    function u(m) {
      const v = m.code, g = LN(v), h = n[g], E = h == null ? !0 : h, C = typeof E == "number" ? E : E ? 1 : 0, A = {
        line: m.startLine,
        column: m.startCol,
        offset: m.startOffset
      }, R = {
        line: m.endLine,
        column: m.endCol,
        offset: m.endOffset
      };
      if (C) {
        const F = MN[g] || { reason: "", description: "", url: "" }, I = i.message(P(F.reason), { start: A, end: R });
        I.source = "parse-error", I.ruleId = v, I.fatal = IN[C], I.note = P(F.description), I.url = "url" in F && F.url === !1 ? null : AN + v;
      }
      function P(F) {
        return F.replace(/%c(?:-(\d+))?/g, (I, D) => {
          const O = D ? -Number.parseInt(D, 10) : 0, U = o.charAt(m.startOffset + O);
          return U === "`" ? "` ` `" : U;
        }).replace(
          /%x/g,
          () => "0x" + o.charCodeAt(m.startOffset).toString(16).toUpperCase()
        );
      }
    }
  }
}
function LN(e) {
  return e.replace(/-[a-z]/g, (t) => t.charAt(1).toUpperCase());
}
const c3 = {
  strip: ["script"],
  clobberPrefix: "user-content-",
  clobber: ["name", "id"],
  ancestors: {
    tbody: ["table"],
    tfoot: ["table"],
    thead: ["table"],
    td: ["table"],
    th: ["table"],
    tr: ["table"]
  },
  protocols: {
    href: ["http", "https", "mailto", "xmpp", "irc", "ircs"],
    cite: ["http", "https"],
    src: ["http", "https"],
    longDesc: ["http", "https"]
  },
  tagNames: [
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "br",
    "b",
    "i",
    "strong",
    "em",
    "a",
    "pre",
    "code",
    "img",
    "tt",
    "div",
    "ins",
    "del",
    "sup",
    "sub",
    "p",
    "ol",
    "ul",
    "table",
    "thead",
    "tbody",
    "tfoot",
    "blockquote",
    "dl",
    "dt",
    "dd",
    "kbd",
    "q",
    "samp",
    "var",
    "hr",
    "ruby",
    "rt",
    "rp",
    "li",
    "tr",
    "td",
    "th",
    "s",
    "strike",
    "summary",
    "details",
    "caption",
    "figure",
    "figcaption",
    "abbr",
    "bdo",
    "cite",
    "dfn",
    "mark",
    "small",
    "span",
    "time",
    "wbr",
    "input"
  ],
  attributes: {
    a: ["href"],
    img: ["src", "longDesc"],
    input: [
      ["type", "checkbox"],
      ["disabled", !0]
    ],
    li: [["className", "task-list-item"]],
    div: ["itemScope", "itemType"],
    blockquote: ["cite"],
    del: ["cite"],
    ins: ["cite"],
    q: ["cite"],
    "*": [
      "abbr",
      "accept",
      "acceptCharset",
      "accessKey",
      "action",
      "align",
      "alt",
      "ariaDescribedBy",
      "ariaHidden",
      "ariaLabel",
      "ariaLabelledBy",
      "axis",
      "border",
      "cellPadding",
      "cellSpacing",
      "char",
      "charOff",
      "charSet",
      "checked",
      "clear",
      "cols",
      "colSpan",
      "color",
      "compact",
      "coords",
      "dateTime",
      "dir",
      "disabled",
      "encType",
      "htmlFor",
      "frame",
      "headers",
      "height",
      "hrefLang",
      "hSpace",
      "isMap",
      "id",
      "label",
      "lang",
      "maxLength",
      "media",
      "method",
      "multiple",
      "name",
      "noHref",
      "noShade",
      "noWrap",
      "open",
      "prompt",
      "readOnly",
      "rel",
      "rev",
      "rows",
      "rowSpan",
      "rules",
      "scope",
      "selected",
      "shape",
      "size",
      "span",
      "start",
      "summary",
      "tabIndex",
      "target",
      "title",
      "type",
      "useMap",
      "vAlign",
      "value",
      "vSpace",
      "width",
      "itemProp"
    ]
  },
  required: {
    input: {
      type: "checkbox",
      disabled: !0
    }
  }
}, Sn = {}.hasOwnProperty, s1 = {
  root: { children: p5 },
  doctype: $N,
  comment: ON,
  element: {
    tagName: m3,
    properties: PN,
    children: p5
  },
  text: { value: FN },
  "*": { data: g5, position: g5 }
};
function DN(e, t) {
  let n = { type: "root", children: [] };
  if (e && typeof e == "object" && e.type) {
    const r = h3(
      Object.assign({}, c3, t || {}),
      e,
      []
    );
    r && (Array.isArray(r) ? r.length === 1 ? n = r[0] : n.children = r : n = r);
  }
  return n;
}
function h3(e, t, n) {
  const r = t && t.type, o = { type: t.type };
  let i;
  if (Sn.call(s1, r)) {
    let a = s1[r];
    if (typeof a == "function" && (a = a(e, t)), a) {
      const s = Object.assign({}, a, s1["*"]);
      let l;
      i = !0;
      for (l in s)
        if (Sn.call(s, l)) {
          const u = s[l](e, t[l], t, n);
          u === !1 ? (i = void 0, o[l] = t[l]) : u != null && (o[l] = u);
        }
    }
  }
  return i ? o : o.type === "element" && e.strip && !e.strip.includes(o.tagName) ? o.children : void 0;
}
function p5(e, t, n, r) {
  const o = [];
  if (Array.isArray(t)) {
    let i = -1;
    for (n.type === "element" && r.push(n.tagName); ++i < t.length; ) {
      const a = h3(e, t[i], r);
      a && (Array.isArray(a) ? o.push(...a) : o.push(a));
    }
    n.type === "element" && r.pop();
  }
  return o;
}
function $N(e) {
  return e.allowDoctypes ? { name: NN } : void 0;
}
function ON(e) {
  return e.allowComments ? { value: HN } : void 0;
}
function PN(e, t, n, r) {
  const o = m3(e, n.tagName, n, r), i = e.attributes || {}, a = e.required || {}, s = t || {}, l = Object.assign(
    {},
    v5(i["*"]),
    v5(o && Sn.call(i, o) ? i[o] : [])
  ), u = {};
  let m;
  for (m in s)
    if (Sn.call(s, m)) {
      let v = s[m], g;
      if (Sn.call(l, m))
        g = l[m];
      else if (BN(m) && Sn.call(l, "data*"))
        g = l["data*"];
      else
        continue;
      v = Array.isArray(v) ? RN(e, v, m, g) : f3(e, v, m, g), v != null && (u[m] = v);
    }
  if (o && Sn.call(a, o))
    for (m in a[o])
      Sn.call(u, m) || (u[m] = a[o][m]);
  return u;
}
function NN() {
  return "html";
}
function m3(e, t, n, r) {
  const o = typeof t == "string" ? t : "";
  let i = -1;
  if (!o || o === "*" || e.tagNames && !e.tagNames.includes(o))
    return !1;
  if (e.ancestors && Sn.call(e.ancestors, o)) {
    for (; ++i < e.ancestors[o].length; )
      if (r.includes(e.ancestors[o][i]))
        return o;
    return !1;
  }
  return o;
}
function HN(e, t) {
  const n = typeof t == "string" ? t : "", r = n.indexOf("-->");
  return r < 0 ? n : n.slice(0, r);
}
function FN(e, t) {
  return typeof t == "string" ? t : "";
}
function g5(e, t) {
  return t;
}
function RN(e, t, n, r) {
  let o = -1;
  const i = [];
  for (; ++o < t.length; ) {
    const a = f3(e, t[o], n, r);
    a != null && i.push(a);
  }
  return i;
}
function f3(e, t, n, r) {
  if ((typeof t == "boolean" || typeof t == "number" || typeof t == "string") && VN(e, t, n) && (r.length === 0 || r.some(
    (o) => o && typeof o == "object" && "flags" in o ? o.test(String(t)) : o === t
  )))
    return e.clobberPrefix && e.clobber && e.clobber.includes(n) ? e.clobberPrefix + t : t;
}
function VN(e, t, n) {
  const r = String(t), o = r.indexOf(":"), i = r.indexOf("?"), a = r.indexOf("#"), s = r.indexOf("/"), l = e.protocols && Sn.call(e.protocols, n) ? e.protocols[n].concat() : [];
  let u = -1;
  if (l.length === 0 || o < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
  s > -1 && o > s || i > -1 && o > i || a > -1 && o > a)
    return !0;
  for (; ++u < l.length; )
    if (o === l[u].length && r.slice(0, l[u].length) === l[u])
      return !0;
  return !1;
}
function v5(e) {
  const t = {};
  let n = -1;
  for (; ++n < e.length; ) {
    const r = e[n];
    Array.isArray(r) ? t[r[0]] = r.slice(1) : t[r] = [];
  }
  return t;
}
function BN(e) {
  return e.length > 4 && e.slice(0, 4).toLowerCase() === "data";
}
function p3(e = c3) {
  return (t) => DN(t, e);
}
const jN = [
  "area",
  "base",
  "basefont",
  "bgsound",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "image",
  "img",
  "input",
  "isindex",
  "keygen",
  "link",
  "menuitem",
  "meta",
  "nextid",
  "param",
  "source",
  "track",
  "wbr"
], b5 = {}.hasOwnProperty;
function UN(e, t) {
  const n = t || {};
  function r(o, ...i) {
    let a = r.invalid;
    const s = r.handlers;
    if (o && b5.call(o, e)) {
      const l = String(o[e]);
      a = b5.call(s, l) ? s[l] : r.unknown;
    }
    if (a)
      return a.call(this, o, ...i);
  }
  return r.handlers = n.handlers || {}, r.invalid = n.invalid, r.unknown = n.unknown, r;
}
const qN = /["&'<>`]/g, GN = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g, KN = (
  // eslint-disable-next-line no-control-regex, unicorn/no-hex-escape
  /[\x01-\t\v\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g
), zN = /[|\\{}()[\]^$+*?.]/g, y5 = /* @__PURE__ */ new WeakMap();
function ZN(e, t) {
  if (e = e.replace(
    t.subset ? xN(t.subset) : qN,
    r
  ), t.subset || t.escapeOnly)
    return e;
  return e.replace(GN, n).replace(KN, r);
  function n(o, i, a) {
    return t.format(
      (o.charCodeAt(0) - 55296) * 1024 + o.charCodeAt(1) - 56320 + 65536,
      a.charCodeAt(i + 2),
      t
    );
  }
  function r(o, i, a) {
    return t.format(
      o.charCodeAt(0),
      a.charCodeAt(i + 1),
      t
    );
  }
}
function xN(e) {
  let t = y5.get(e);
  return t || (t = WN(e), y5.set(e, t)), t;
}
function WN(e) {
  const t = [];
  let n = -1;
  for (; ++n < e.length; )
    t.push(e[n].replace(zN, "\\$&"));
  return new RegExp("(?:" + t.join("|") + ")", "g");
}
const YN = /[\dA-Fa-f]/;
function XN(e, t, n) {
  const r = "&#x" + e.toString(16).toUpperCase();
  return n && t && !YN.test(String.fromCharCode(t)) ? r : r + ";";
}
const QN = /\d/;
function JN(e, t, n) {
  const r = "&#" + String(e);
  return n && t && !QN.test(String.fromCharCode(t)) ? r : r + ";";
}
const eH = [
  "AElig",
  "AMP",
  "Aacute",
  "Acirc",
  "Agrave",
  "Aring",
  "Atilde",
  "Auml",
  "COPY",
  "Ccedil",
  "ETH",
  "Eacute",
  "Ecirc",
  "Egrave",
  "Euml",
  "GT",
  "Iacute",
  "Icirc",
  "Igrave",
  "Iuml",
  "LT",
  "Ntilde",
  "Oacute",
  "Ocirc",
  "Ograve",
  "Oslash",
  "Otilde",
  "Ouml",
  "QUOT",
  "REG",
  "THORN",
  "Uacute",
  "Ucirc",
  "Ugrave",
  "Uuml",
  "Yacute",
  "aacute",
  "acirc",
  "acute",
  "aelig",
  "agrave",
  "amp",
  "aring",
  "atilde",
  "auml",
  "brvbar",
  "ccedil",
  "cedil",
  "cent",
  "copy",
  "curren",
  "deg",
  "divide",
  "eacute",
  "ecirc",
  "egrave",
  "eth",
  "euml",
  "frac12",
  "frac14",
  "frac34",
  "gt",
  "iacute",
  "icirc",
  "iexcl",
  "igrave",
  "iquest",
  "iuml",
  "laquo",
  "lt",
  "macr",
  "micro",
  "middot",
  "nbsp",
  "not",
  "ntilde",
  "oacute",
  "ocirc",
  "ograve",
  "ordf",
  "ordm",
  "oslash",
  "otilde",
  "ouml",
  "para",
  "plusmn",
  "pound",
  "quot",
  "raquo",
  "reg",
  "sect",
  "shy",
  "sup1",
  "sup2",
  "sup3",
  "szlig",
  "thorn",
  "times",
  "uacute",
  "ucirc",
  "ugrave",
  "uml",
  "uuml",
  "yacute",
  "yen",
  "yuml"
], a1 = {
  nbsp: " ",
  iexcl: "¡",
  cent: "¢",
  pound: "£",
  curren: "¤",
  yen: "¥",
  brvbar: "¦",
  sect: "§",
  uml: "¨",
  copy: "©",
  ordf: "ª",
  laquo: "«",
  not: "¬",
  shy: "­",
  reg: "®",
  macr: "¯",
  deg: "°",
  plusmn: "±",
  sup2: "²",
  sup3: "³",
  acute: "´",
  micro: "µ",
  para: "¶",
  middot: "·",
  cedil: "¸",
  sup1: "¹",
  ordm: "º",
  raquo: "»",
  frac14: "¼",
  frac12: "½",
  frac34: "¾",
  iquest: "¿",
  Agrave: "À",
  Aacute: "Á",
  Acirc: "Â",
  Atilde: "Ã",
  Auml: "Ä",
  Aring: "Å",
  AElig: "Æ",
  Ccedil: "Ç",
  Egrave: "È",
  Eacute: "É",
  Ecirc: "Ê",
  Euml: "Ë",
  Igrave: "Ì",
  Iacute: "Í",
  Icirc: "Î",
  Iuml: "Ï",
  ETH: "Ð",
  Ntilde: "Ñ",
  Ograve: "Ò",
  Oacute: "Ó",
  Ocirc: "Ô",
  Otilde: "Õ",
  Ouml: "Ö",
  times: "×",
  Oslash: "Ø",
  Ugrave: "Ù",
  Uacute: "Ú",
  Ucirc: "Û",
  Uuml: "Ü",
  Yacute: "Ý",
  THORN: "Þ",
  szlig: "ß",
  agrave: "à",
  aacute: "á",
  acirc: "â",
  atilde: "ã",
  auml: "ä",
  aring: "å",
  aelig: "æ",
  ccedil: "ç",
  egrave: "è",
  eacute: "é",
  ecirc: "ê",
  euml: "ë",
  igrave: "ì",
  iacute: "í",
  icirc: "î",
  iuml: "ï",
  eth: "ð",
  ntilde: "ñ",
  ograve: "ò",
  oacute: "ó",
  ocirc: "ô",
  otilde: "õ",
  ouml: "ö",
  divide: "÷",
  oslash: "ø",
  ugrave: "ù",
  uacute: "ú",
  ucirc: "û",
  uuml: "ü",
  yacute: "ý",
  thorn: "þ",
  yuml: "ÿ",
  fnof: "ƒ",
  Alpha: "Α",
  Beta: "Β",
  Gamma: "Γ",
  Delta: "Δ",
  Epsilon: "Ε",
  Zeta: "Ζ",
  Eta: "Η",
  Theta: "Θ",
  Iota: "Ι",
  Kappa: "Κ",
  Lambda: "Λ",
  Mu: "Μ",
  Nu: "Ν",
  Xi: "Ξ",
  Omicron: "Ο",
  Pi: "Π",
  Rho: "Ρ",
  Sigma: "Σ",
  Tau: "Τ",
  Upsilon: "Υ",
  Phi: "Φ",
  Chi: "Χ",
  Psi: "Ψ",
  Omega: "Ω",
  alpha: "α",
  beta: "β",
  gamma: "γ",
  delta: "δ",
  epsilon: "ε",
  zeta: "ζ",
  eta: "η",
  theta: "θ",
  iota: "ι",
  kappa: "κ",
  lambda: "λ",
  mu: "μ",
  nu: "ν",
  xi: "ξ",
  omicron: "ο",
  pi: "π",
  rho: "ρ",
  sigmaf: "ς",
  sigma: "σ",
  tau: "τ",
  upsilon: "υ",
  phi: "φ",
  chi: "χ",
  psi: "ψ",
  omega: "ω",
  thetasym: "ϑ",
  upsih: "ϒ",
  piv: "ϖ",
  bull: "•",
  hellip: "…",
  prime: "′",
  Prime: "″",
  oline: "‾",
  frasl: "⁄",
  weierp: "℘",
  image: "ℑ",
  real: "ℜ",
  trade: "™",
  alefsym: "ℵ",
  larr: "←",
  uarr: "↑",
  rarr: "→",
  darr: "↓",
  harr: "↔",
  crarr: "↵",
  lArr: "⇐",
  uArr: "⇑",
  rArr: "⇒",
  dArr: "⇓",
  hArr: "⇔",
  forall: "∀",
  part: "∂",
  exist: "∃",
  empty: "∅",
  nabla: "∇",
  isin: "∈",
  notin: "∉",
  ni: "∋",
  prod: "∏",
  sum: "∑",
  minus: "−",
  lowast: "∗",
  radic: "√",
  prop: "∝",
  infin: "∞",
  ang: "∠",
  and: "∧",
  or: "∨",
  cap: "∩",
  cup: "∪",
  int: "∫",
  there4: "∴",
  sim: "∼",
  cong: "≅",
  asymp: "≈",
  ne: "≠",
  equiv: "≡",
  le: "≤",
  ge: "≥",
  sub: "⊂",
  sup: "⊃",
  nsub: "⊄",
  sube: "⊆",
  supe: "⊇",
  oplus: "⊕",
  otimes: "⊗",
  perp: "⊥",
  sdot: "⋅",
  lceil: "⌈",
  rceil: "⌉",
  lfloor: "⌊",
  rfloor: "⌋",
  lang: "〈",
  rang: "〉",
  loz: "◊",
  spades: "♠",
  clubs: "♣",
  hearts: "♥",
  diams: "♦",
  quot: '"',
  amp: "&",
  lt: "<",
  gt: ">",
  OElig: "Œ",
  oelig: "œ",
  Scaron: "Š",
  scaron: "š",
  Yuml: "Ÿ",
  circ: "ˆ",
  tilde: "˜",
  ensp: " ",
  emsp: " ",
  thinsp: " ",
  zwnj: "‌",
  zwj: "‍",
  lrm: "‎",
  rlm: "‏",
  ndash: "–",
  mdash: "—",
  lsquo: "‘",
  rsquo: "’",
  sbquo: "‚",
  ldquo: "“",
  rdquo: "”",
  bdquo: "„",
  dagger: "†",
  Dagger: "‡",
  permil: "‰",
  lsaquo: "‹",
  rsaquo: "›",
  euro: "€"
}, tH = [
  "cent",
  "copy",
  "divide",
  "gt",
  "lt",
  "not",
  "para",
  "times"
], g3 = {}.hasOwnProperty, Jc = {};
let Ki;
for (Ki in a1)
  g3.call(a1, Ki) && (Jc[a1[Ki]] = Ki);
const nH = /[^\dA-Za-z]/;
function rH(e, t, n, r) {
  const o = String.fromCharCode(e);
  if (g3.call(Jc, o)) {
    const i = Jc[o], a = "&" + i;
    return n && eH.includes(i) && !tH.includes(i) && (!r || t && t !== 61 && nH.test(String.fromCharCode(t))) ? a : a + ";";
  }
  return "";
}
function oH(e, t, n) {
  let r = XN(e, t, n.omitOptionalSemicolons), o;
  if ((n.useNamedReferences || n.useShortestReferences) && (o = rH(
    e,
    t,
    n.omitOptionalSemicolons,
    n.attribute
  )), (n.useShortestReferences || !o) && n.useShortestReferences) {
    const i = JN(e, t, n.omitOptionalSemicolons);
    i.length < r.length && (r = i);
  }
  return o && (!n.useShortestReferences || o.length < r.length) ? o : r;
}
function mo(e, t) {
  return ZN(e, Object.assign({ format: oH }, t));
}
function iH(e, t, n, r) {
  return r.settings.bogusComments ? "<?" + mo(
    e.value,
    Object.assign({}, r.settings.characterReferences, { subset: [">"] })
  ) + ">" : "<!--" + e.value.replace(/^>|^->|<!--|-->|--!>|<!-$/g, o) + "-->";
  function o(i) {
    return mo(
      i,
      Object.assign({}, r.settings.characterReferences, {
        subset: ["<", ">"]
      })
    );
  }
}
function sH(e, t, n, r) {
  return "<!" + (r.settings.upperDoctype ? "DOCTYPE" : "doctype") + (r.settings.tightDoctype ? "" : " ") + "html>";
}
function _5(e, t) {
  const n = String(e);
  if (typeof t != "string")
    throw new TypeError("Expected character");
  let r = 0, o = n.indexOf(t);
  for (; o !== -1; )
    r++, o = n.indexOf(t, o + t.length);
  return r;
}
function q0(e) {
  const t = (
    // @ts-expect-error looks like a node.
    e && typeof e == "object" && e.type === "text" ? (
      // @ts-expect-error looks like a text.
      e.value || ""
    ) : e
  );
  return typeof t == "string" && t.replace(/[ \t\n\f\r]/g, "") === "";
}
const st = b3(1), v3 = b3(-1);
function b3(e) {
  return t;
  function t(n, r, o) {
    const i = n ? n.children : [];
    let a = (r || 0) + e, s = i && i[a];
    if (!o)
      for (; s && q0(s); )
        a += e, s = i[a];
    return s;
  }
}
const aH = {}.hasOwnProperty;
function y3(e) {
  return t;
  function t(n, r, o) {
    return aH.call(e, n.tagName) && e[n.tagName](n, r, o);
  }
}
const G0 = y3({
  html: lH,
  head: l1,
  body: uH,
  p: dH,
  li: cH,
  dt: hH,
  dd: mH,
  rt: C5,
  rp: C5,
  optgroup: fH,
  option: pH,
  menuitem: gH,
  colgroup: l1,
  caption: l1,
  thead: vH,
  tbody: bH,
  tfoot: yH,
  tr: _H,
  td: w5,
  th: w5
});
function l1(e, t, n) {
  const r = st(n, t, !0);
  return !r || r.type !== "comment" && !(r.type === "text" && q0(r.value.charAt(0)));
}
function lH(e, t, n) {
  const r = st(n, t);
  return !r || r.type !== "comment";
}
function uH(e, t, n) {
  const r = st(n, t);
  return !r || r.type !== "comment";
}
function dH(e, t, n) {
  const r = st(n, t);
  return r ? r.type === "element" && (r.tagName === "address" || r.tagName === "article" || r.tagName === "aside" || r.tagName === "blockquote" || r.tagName === "details" || r.tagName === "div" || r.tagName === "dl" || r.tagName === "fieldset" || r.tagName === "figcaption" || r.tagName === "figure" || r.tagName === "footer" || r.tagName === "form" || r.tagName === "h1" || r.tagName === "h2" || r.tagName === "h3" || r.tagName === "h4" || r.tagName === "h5" || r.tagName === "h6" || r.tagName === "header" || r.tagName === "hgroup" || r.tagName === "hr" || r.tagName === "main" || r.tagName === "menu" || r.tagName === "nav" || r.tagName === "ol" || r.tagName === "p" || r.tagName === "pre" || r.tagName === "section" || r.tagName === "table" || r.tagName === "ul") : !n || // Confusing parent.
  !(n.type === "element" && (n.tagName === "a" || n.tagName === "audio" || n.tagName === "del" || n.tagName === "ins" || n.tagName === "map" || n.tagName === "noscript" || n.tagName === "video"));
}
function cH(e, t, n) {
  const r = st(n, t);
  return !r || r.type === "element" && r.tagName === "li";
}
function hH(e, t, n) {
  const r = st(n, t);
  return r && r.type === "element" && (r.tagName === "dt" || r.tagName === "dd");
}
function mH(e, t, n) {
  const r = st(n, t);
  return !r || r.type === "element" && (r.tagName === "dt" || r.tagName === "dd");
}
function C5(e, t, n) {
  const r = st(n, t);
  return !r || r.type === "element" && (r.tagName === "rp" || r.tagName === "rt");
}
function fH(e, t, n) {
  const r = st(n, t);
  return !r || r.type === "element" && r.tagName === "optgroup";
}
function pH(e, t, n) {
  const r = st(n, t);
  return !r || r.type === "element" && (r.tagName === "option" || r.tagName === "optgroup");
}
function gH(e, t, n) {
  const r = st(n, t);
  return !r || r.type === "element" && (r.tagName === "menuitem" || r.tagName === "hr" || r.tagName === "menu");
}
function vH(e, t, n) {
  const r = st(n, t);
  return r && r.type === "element" && (r.tagName === "tbody" || r.tagName === "tfoot");
}
function bH(e, t, n) {
  const r = st(n, t);
  return !r || r.type === "element" && (r.tagName === "tbody" || r.tagName === "tfoot");
}
function yH(e, t, n) {
  return !st(n, t);
}
function _H(e, t, n) {
  const r = st(n, t);
  return !r || r.type === "element" && r.tagName === "tr";
}
function w5(e, t, n) {
  const r = st(n, t);
  return !r || r.type === "element" && (r.tagName === "td" || r.tagName === "th");
}
const CH = y3({
  html: wH,
  head: TH,
  body: kH,
  colgroup: EH,
  tbody: SH
});
function wH(e) {
  const t = st(e, -1);
  return !t || t.type !== "comment";
}
function TH(e) {
  const t = e.children, n = [];
  let r = -1;
  for (; ++r < t.length; ) {
    const o = t[r];
    if (o.type === "element" && (o.tagName === "title" || o.tagName === "base")) {
      if (n.includes(o.tagName)) return !1;
      n.push(o.tagName);
    }
  }
  return t.length > 0;
}
function kH(e) {
  const t = st(e, -1, !0);
  return !t || t.type !== "comment" && !(t.type === "text" && q0(t.value.charAt(0))) && !(t.type === "element" && (t.tagName === "meta" || t.tagName === "link" || t.tagName === "script" || t.tagName === "style" || t.tagName === "template"));
}
function EH(e, t, n) {
  const r = v3(n, t), o = st(e, -1, !0);
  return n && r && r.type === "element" && r.tagName === "colgroup" && G0(r, n.children.indexOf(r), n) ? !1 : o && o.type === "element" && o.tagName === "col";
}
function SH(e, t, n) {
  const r = v3(n, t), o = st(e, -1);
  return n && r && r.type === "element" && (r.tagName === "thead" || r.tagName === "tbody") && G0(r, n.children.indexOf(r), n) ? !1 : o && o.type === "element" && o.tagName === "tr";
}
const zi = {
  // See: <https://html.spec.whatwg.org/#attribute-name-state>.
  name: [
    [`	
\f\r &/=>`.split(""), `	
\f\r "&'/=>\``.split("")],
    [`\0	
\f\r "&'/<=>`.split(""), `\0	
\f\r "&'/<=>\``.split("")]
  ],
  // See: <https://html.spec.whatwg.org/#attribute-value-(unquoted)-state>.
  unquoted: [
    [`	
\f\r &>`.split(""), `\0	
\f\r "&'<=>\``.split("")],
    [`\0	
\f\r "&'<=>\``.split(""), `\0	
\f\r "&'<=>\``.split("")]
  ],
  // See: <https://html.spec.whatwg.org/#attribute-value-(single-quoted)-state>.
  single: [
    ["&'".split(""), "\"&'`".split("")],
    ["\0&'".split(""), "\0\"&'`".split("")]
  ],
  // See: <https://html.spec.whatwg.org/#attribute-value-(double-quoted)-state>.
  double: [
    ['"&'.split(""), "\"&'`".split("")],
    ['\0"&'.split(""), "\0\"&'`".split("")]
  ]
};
function MH(e, t, n, r) {
  const o = r.schema, i = o.space === "svg" ? !1 : r.settings.omitOptionalTags;
  let a = o.space === "svg" ? r.settings.closeEmptyElements : r.settings.voids.includes(e.tagName.toLowerCase());
  const s = [];
  let l;
  o.space === "html" && e.tagName === "svg" && (r.schema = Ci);
  const u = AH(r, e.properties), m = r.all(
    o.space === "html" && e.tagName === "template" ? e.content : e
  );
  return r.schema = o, m && (a = !1), (u || !i || !CH(e, t, n)) && (s.push("<", e.tagName, u ? " " + u : ""), a && (o.space === "svg" || r.settings.closeSelfClosing) && (l = u.charAt(u.length - 1), (!r.settings.tightSelfClosing || l === "/" || l && l !== '"' && l !== "'") && s.push(" "), s.push("/")), s.push(">")), s.push(m), !a && (!i || !G0(e, t, n)) && s.push("</" + e.tagName + ">"), s.join("");
}
function AH(e, t) {
  const n = [];
  let r = -1, o;
  if (t) {
    for (o in t)
      if (t[o] !== void 0 && t[o] !== null) {
        const i = IH(e, o, t[o]);
        i && n.push(i);
      }
  }
  for (; ++r < n.length; ) {
    const i = e.settings.tightAttributes ? n[r].charAt(n[r].length - 1) : null;
    r !== n.length - 1 && i !== '"' && i !== "'" && (n[r] += " ");
  }
  return n.join("");
}
function IH(e, t, n) {
  const r = j0(e.schema, t), o = e.settings.allowParseErrors && e.schema.space === "html" ? 0 : 1, i = e.settings.allowDangerousCharacters ? 0 : 1;
  let a = e.quote, s;
  if (r.overloadedBoolean && (n === r.attribute || n === "") ? n = !0 : (r.boolean || r.overloadedBoolean && typeof n != "string") && (n = !!n), n == null || n === !1 || typeof n == "number" && Number.isNaN(n))
    return "";
  const l = mo(
    r.attribute,
    Object.assign({}, e.settings.characterReferences, {
      // Always encode without parse errors in non-HTML.
      subset: zi.name[o][i]
    })
  );
  return n === !0 || (n = Array.isArray(n) ? (r.commaSeparated ? hN : cN)(n, {
    padLeft: !e.settings.tightCommaSeparatedLists
  }) : String(n), e.settings.collapseEmptyAttributes && !n) ? l : (e.settings.preferUnquoted && (s = mo(
    n,
    Object.assign({}, e.settings.characterReferences, {
      subset: zi.unquoted[o][i],
      attribute: !0
    })
  )), s !== n && (e.settings.quoteSmart && _5(n, a) > _5(n, e.alternative) && (a = e.alternative), s = a + mo(
    n,
    Object.assign({}, e.settings.characterReferences, {
      // Always encode without parse errors in non-HTML.
      subset: (a === "'" ? zi.single : zi.double)[o][i],
      attribute: !0
    })
  ) + a), l + (s && "=" + s));
}
function _3(e, t, n, r) {
  return n && n.type === "element" && (n.tagName === "script" || n.tagName === "style") ? e.value : mo(
    e.value,
    Object.assign({}, r.settings.characterReferences, {
      subset: ["<", "&"]
    })
  );
}
function LH(e, t, n, r) {
  return r.settings.allowDangerousHtml ? e.value : _3(e, t, n, r);
}
function DH(e, t, n, r) {
  return r.all(e);
}
const $H = UN("type", {
  invalid: OH,
  unknown: PH,
  handlers: { comment: iH, doctype: sH, element: MH, raw: LH, root: DH, text: _3 }
});
function OH(e) {
  throw new Error("Expected node, not `" + e + "`");
}
function PH(e) {
  throw new Error("Cannot compile unknown node `" + e.type + "`");
}
function NH(e, t) {
  const n = t || {}, r = n.quote || '"', o = r === '"' ? "'" : '"';
  if (r !== '"' && r !== "'")
    throw new Error("Invalid quote `" + r + "`, expected `'` or `\"`");
  return {
    one: HH,
    all: FH,
    settings: {
      omitOptionalTags: n.omitOptionalTags || !1,
      allowParseErrors: n.allowParseErrors || !1,
      allowDangerousCharacters: n.allowDangerousCharacters || !1,
      quoteSmart: n.quoteSmart || !1,
      preferUnquoted: n.preferUnquoted || !1,
      tightAttributes: n.tightAttributes || !1,
      upperDoctype: n.upperDoctype || !1,
      tightDoctype: n.tightDoctype || !1,
      bogusComments: n.bogusComments || !1,
      tightCommaSeparatedLists: n.tightCommaSeparatedLists || !1,
      tightSelfClosing: n.tightSelfClosing || !1,
      collapseEmptyAttributes: n.collapseEmptyAttributes || !1,
      allowDangerousHtml: n.allowDangerousHtml || !1,
      voids: n.voids || jN,
      characterReferences: n.characterReferences || n.entities || {},
      closeSelfClosing: n.closeSelfClosing || !1,
      closeEmptyElements: n.closeEmptyElements || !1
    },
    schema: n.space === "svg" ? Ci : Bs,
    quote: r,
    alternative: o
  }.one(
    Array.isArray(e) ? { type: "root", children: e } : e,
    void 0,
    void 0
  );
}
function HH(e, t, n) {
  return $H(e, t, n, this);
}
function FH(e) {
  const t = [], n = e && e.children || [];
  let r = -1;
  for (; ++r < n.length; )
    t[r] = this.one(n[r], r, e);
  return t.join("");
}
function RH(e) {
  const t = (
    /** @type {Options} */
    this.data("settings")
  ), n = Object.assign({}, t, e);
  Object.assign(this, { Compiler: r });
  function r(o) {
    return NH(o, n);
  }
}
var u1, T5;
function js() {
  if (T5) return u1;
  T5 = 1;
  var e = Object.prototype;
  function t(n) {
    var r = n && n.constructor, o = typeof r == "function" && r.prototype || e;
    return n === o;
  }
  return u1 = t, u1;
}
var d1, k5;
function C3() {
  if (k5) return d1;
  k5 = 1;
  function e(t, n) {
    return function(r) {
      return t(n(r));
    };
  }
  return d1 = e, d1;
}
var c1, E5;
function VH() {
  if (E5) return c1;
  E5 = 1;
  var e = C3(), t = e(Object.keys, Object);
  return c1 = t, c1;
}
var h1, S5;
function w3() {
  if (S5) return h1;
  S5 = 1;
  var e = js(), t = VH(), n = Object.prototype, r = n.hasOwnProperty;
  function o(i) {
    if (!e(i))
      return t(i);
    var a = [];
    for (var s in Object(i))
      r.call(i, s) && s != "constructor" && a.push(s);
    return a;
  }
  return h1 = o, h1;
}
var m1, M5;
function T3() {
  if (M5) return m1;
  M5 = 1;
  var e = typeof Gi == "object" && Gi && Gi.Object === Object && Gi;
  return m1 = e, m1;
}
var f1, A5;
function Ln() {
  if (A5) return f1;
  A5 = 1;
  var e = T3(), t = typeof self == "object" && self && self.Object === Object && self, n = e || t || Function("return this")();
  return f1 = n, f1;
}
var p1, I5;
function Us() {
  if (I5) return p1;
  I5 = 1;
  var e = Ln(), t = e.Symbol;
  return p1 = t, p1;
}
var g1, L5;
function BH() {
  if (L5) return g1;
  L5 = 1;
  var e = Us(), t = Object.prototype, n = t.hasOwnProperty, r = t.toString, o = e ? e.toStringTag : void 0;
  function i(a) {
    var s = n.call(a, o), l = a[o];
    try {
      a[o] = void 0;
      var u = !0;
    } catch (v) {
    }
    var m = r.call(a);
    return u && (s ? a[o] = l : delete a[o]), m;
  }
  return g1 = i, g1;
}
var v1, D5;
function jH() {
  if (D5) return v1;
  D5 = 1;
  var e = Object.prototype, t = e.toString;
  function n(r) {
    return t.call(r);
  }
  return v1 = n, v1;
}
var b1, $5;
function wi() {
  if ($5) return b1;
  $5 = 1;
  var e = Us(), t = BH(), n = jH(), r = "[object Null]", o = "[object Undefined]", i = e ? e.toStringTag : void 0;
  function a(s) {
    return s == null ? s === void 0 ? o : r : i && i in Object(s) ? t(s) : n(s);
  }
  return b1 = a, b1;
}
var y1, O5;
function Ti() {
  if (O5) return y1;
  O5 = 1;
  function e(t) {
    var n = typeof t;
    return t != null && (n == "object" || n == "function");
  }
  return y1 = e, y1;
}
var _1, P5;
function k3() {
  if (P5) return _1;
  P5 = 1;
  var e = wi(), t = Ti(), n = "[object AsyncFunction]", r = "[object Function]", o = "[object GeneratorFunction]", i = "[object Proxy]";
  function a(s) {
    if (!t(s))
      return !1;
    var l = e(s);
    return l == r || l == o || l == n || l == i;
  }
  return _1 = a, _1;
}
var C1, N5;
function UH() {
  if (N5) return C1;
  N5 = 1;
  var e = Ln(), t = e["__core-js_shared__"];
  return C1 = t, C1;
}
var w1, H5;
function qH() {
  if (H5) return w1;
  H5 = 1;
  var e = UH(), t = function() {
    var r = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return r ? "Symbol(src)_1." + r : "";
  }();
  function n(r) {
    return !!t && t in r;
  }
  return w1 = n, w1;
}
var T1, F5;
function E3() {
  if (F5) return T1;
  F5 = 1;
  var e = Function.prototype, t = e.toString;
  function n(r) {
    if (r != null) {
      try {
        return t.call(r);
      } catch (o) {
      }
      try {
        return r + "";
      } catch (o) {
      }
    }
    return "";
  }
  return T1 = n, T1;
}
var k1, R5;
function GH() {
  if (R5) return k1;
  R5 = 1;
  var e = k3(), t = qH(), n = Ti(), r = E3(), o = /[\\^$.*+?()[\]{}|]/g, i = /^\[object .+?Constructor\]$/, a = Function.prototype, s = Object.prototype, l = a.toString, u = s.hasOwnProperty, m = RegExp(
    "^" + l.call(u).replace(o, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function v(g) {
    if (!n(g) || t(g))
      return !1;
    var h = e(g) ? m : i;
    return h.test(r(g));
  }
  return k1 = v, k1;
}
var E1, V5;
function KH() {
  if (V5) return E1;
  V5 = 1;
  function e(t, n) {
    return t == null ? void 0 : t[n];
  }
  return E1 = e, E1;
}
var S1, B5;
function Wr() {
  if (B5) return S1;
  B5 = 1;
  var e = GH(), t = KH();
  function n(r, o) {
    var i = t(r, o);
    return e(i) ? i : void 0;
  }
  return S1 = n, S1;
}
var M1, j5;
function zH() {
  if (j5) return M1;
  j5 = 1;
  var e = Wr(), t = Ln(), n = e(t, "DataView");
  return M1 = n, M1;
}
var A1, U5;
function K0() {
  if (U5) return A1;
  U5 = 1;
  var e = Wr(), t = Ln(), n = e(t, "Map");
  return A1 = n, A1;
}
var I1, q5;
function ZH() {
  if (q5) return I1;
  q5 = 1;
  var e = Wr(), t = Ln(), n = e(t, "Promise");
  return I1 = n, I1;
}
var L1, G5;
function xH() {
  if (G5) return L1;
  G5 = 1;
  var e = Wr(), t = Ln(), n = e(t, "Set");
  return L1 = n, L1;
}
var D1, K5;
function WH() {
  if (K5) return D1;
  K5 = 1;
  var e = Wr(), t = Ln(), n = e(t, "WeakMap");
  return D1 = n, D1;
}
var $1, z5;
function qs() {
  if (z5) return $1;
  z5 = 1;
  var e = zH(), t = K0(), n = ZH(), r = xH(), o = WH(), i = wi(), a = E3(), s = "[object Map]", l = "[object Object]", u = "[object Promise]", m = "[object Set]", v = "[object WeakMap]", g = "[object DataView]", h = a(e), E = a(t), C = a(n), A = a(r), R = a(o), P = i;
  return (e && P(new e(new ArrayBuffer(1))) != g || t && P(new t()) != s || n && P(n.resolve()) != u || r && P(new r()) != m || o && P(new o()) != v) && (P = function(F) {
    var I = i(F), D = I == l ? F.constructor : void 0, O = D ? a(D) : "";
    if (O)
      switch (O) {
        case h:
          return g;
        case E:
          return s;
        case C:
          return u;
        case A:
          return m;
        case R:
          return v;
      }
    return I;
  }), $1 = P, $1;
}
var O1, Z5;
function Do() {
  if (Z5) return O1;
  Z5 = 1;
  function e(t) {
    return t != null && typeof t == "object";
  }
  return O1 = e, O1;
}
var P1, x5;
function YH() {
  if (x5) return P1;
  x5 = 1;
  var e = wi(), t = Do(), n = "[object Arguments]";
  function r(o) {
    return t(o) && e(o) == n;
  }
  return P1 = r, P1;
}
var N1, W5;
function S3() {
  if (W5) return N1;
  W5 = 1;
  var e = YH(), t = Do(), n = Object.prototype, r = n.hasOwnProperty, o = n.propertyIsEnumerable, i = e(/* @__PURE__ */ function() {
    return arguments;
  }()) ? e : function(a) {
    return t(a) && r.call(a, "callee") && !o.call(a, "callee");
  };
  return N1 = i, N1;
}
var H1, Y5;
function Yr() {
  if (Y5) return H1;
  Y5 = 1;
  var e = Array.isArray;
  return H1 = e, H1;
}
var F1, X5;
function M3() {
  if (X5) return F1;
  X5 = 1;
  var e = 9007199254740991;
  function t(n) {
    return typeof n == "number" && n > -1 && n % 1 == 0 && n <= e;
  }
  return F1 = t, F1;
}
var R1, Q5;
function z0() {
  if (Q5) return R1;
  Q5 = 1;
  var e = k3(), t = M3();
  function n(r) {
    return r != null && t(r.length) && !e(r);
  }
  return R1 = n, R1;
}
var es = { exports: {} }, V1, J5;
function XH() {
  if (J5) return V1;
  J5 = 1;
  function e() {
    return !1;
  }
  return V1 = e, V1;
}
es.exports;
var e9;
function Z0() {
  return e9 || (e9 = 1, function(e, t) {
    var n = Ln(), r = XH(), o = t && !t.nodeType && t, i = o && !0 && e && !e.nodeType && e, a = i && i.exports === o, s = a ? n.Buffer : void 0, l = s ? s.isBuffer : void 0, u = l || r;
    e.exports = u;
  }(es, es.exports)), es.exports;
}
var B1, t9;
function QH() {
  if (t9) return B1;
  t9 = 1;
  var e = wi(), t = M3(), n = Do(), r = "[object Arguments]", o = "[object Array]", i = "[object Boolean]", a = "[object Date]", s = "[object Error]", l = "[object Function]", u = "[object Map]", m = "[object Number]", v = "[object Object]", g = "[object RegExp]", h = "[object Set]", E = "[object String]", C = "[object WeakMap]", A = "[object ArrayBuffer]", R = "[object DataView]", P = "[object Float32Array]", F = "[object Float64Array]", I = "[object Int8Array]", D = "[object Int16Array]", O = "[object Int32Array]", U = "[object Uint8Array]", q = "[object Uint8ClampedArray]", z = "[object Uint16Array]", te = "[object Uint32Array]", ee = {};
  ee[P] = ee[F] = ee[I] = ee[D] = ee[O] = ee[U] = ee[q] = ee[z] = ee[te] = !0, ee[r] = ee[o] = ee[A] = ee[i] = ee[R] = ee[a] = ee[s] = ee[l] = ee[u] = ee[m] = ee[v] = ee[g] = ee[h] = ee[E] = ee[C] = !1;
  function x(N) {
    return n(N) && t(N.length) && !!ee[e(N)];
  }
  return B1 = x, B1;
}
var j1, n9;
function x0() {
  if (n9) return j1;
  n9 = 1;
  function e(t) {
    return function(n) {
      return t(n);
    };
  }
  return j1 = e, j1;
}
var ts = { exports: {} };
ts.exports;
var r9;
function W0() {
  return r9 || (r9 = 1, function(e, t) {
    var n = T3(), r = t && !t.nodeType && t, o = r && !0 && e && !e.nodeType && e, i = o && o.exports === r, a = i && n.process, s = function() {
      try {
        var l = o && o.require && o.require("util").types;
        return l || a && a.binding && a.binding("util");
      } catch (u) {
      }
    }();
    e.exports = s;
  }(ts, ts.exports)), ts.exports;
}
var U1, o9;
function A3() {
  if (o9) return U1;
  o9 = 1;
  var e = QH(), t = x0(), n = W0(), r = n && n.isTypedArray, o = r ? t(r) : e;
  return U1 = o, U1;
}
var q1, i9;
function JH() {
  if (i9) return q1;
  i9 = 1;
  var e = w3(), t = qs(), n = S3(), r = Yr(), o = z0(), i = Z0(), a = js(), s = A3(), l = "[object Map]", u = "[object Set]", m = Object.prototype, v = m.hasOwnProperty;
  function g(h) {
    if (h == null)
      return !0;
    if (o(h) && (r(h) || typeof h == "string" || typeof h.splice == "function" || i(h) || s(h) || n(h)))
      return !h.length;
    var E = t(h);
    if (E == l || E == u)
      return !h.size;
    if (a(h))
      return !e(h).length;
    for (var C in h)
      if (v.call(h, C))
        return !1;
    return !0;
  }
  return q1 = g, q1;
}
var eF = JH();
const tF = /* @__PURE__ */ Ao(eF);
var G1, s9;
function nF() {
  if (s9) return G1;
  s9 = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return G1 = e, G1;
}
var K1, a9;
function I3() {
  if (a9) return K1;
  a9 = 1;
  function e(t, n) {
    return t === n || t !== t && n !== n;
  }
  return K1 = e, K1;
}
var z1, l9;
function Gs() {
  if (l9) return z1;
  l9 = 1;
  var e = I3();
  function t(n, r) {
    for (var o = n.length; o--; )
      if (e(n[o][0], r))
        return o;
    return -1;
  }
  return z1 = t, z1;
}
var Z1, u9;
function rF() {
  if (u9) return Z1;
  u9 = 1;
  var e = Gs(), t = Array.prototype, n = t.splice;
  function r(o) {
    var i = this.__data__, a = e(i, o);
    if (a < 0)
      return !1;
    var s = i.length - 1;
    return a == s ? i.pop() : n.call(i, a, 1), --this.size, !0;
  }
  return Z1 = r, Z1;
}
var x1, d9;
function oF() {
  if (d9) return x1;
  d9 = 1;
  var e = Gs();
  function t(n) {
    var r = this.__data__, o = e(r, n);
    return o < 0 ? void 0 : r[o][1];
  }
  return x1 = t, x1;
}
var W1, c9;
function iF() {
  if (c9) return W1;
  c9 = 1;
  var e = Gs();
  function t(n) {
    return e(this.__data__, n) > -1;
  }
  return W1 = t, W1;
}
var Y1, h9;
function sF() {
  if (h9) return Y1;
  h9 = 1;
  var e = Gs();
  function t(n, r) {
    var o = this.__data__, i = e(o, n);
    return i < 0 ? (++this.size, o.push([n, r])) : o[i][1] = r, this;
  }
  return Y1 = t, Y1;
}
var X1, m9;
function Ks() {
  if (m9) return X1;
  m9 = 1;
  var e = nF(), t = rF(), n = oF(), r = iF(), o = sF();
  function i(a) {
    var s = -1, l = a == null ? 0 : a.length;
    for (this.clear(); ++s < l; ) {
      var u = a[s];
      this.set(u[0], u[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = t, i.prototype.get = n, i.prototype.has = r, i.prototype.set = o, X1 = i, X1;
}
var Q1, f9;
function aF() {
  if (f9) return Q1;
  f9 = 1;
  var e = Ks();
  function t() {
    this.__data__ = new e(), this.size = 0;
  }
  return Q1 = t, Q1;
}
var J1, p9;
function lF() {
  if (p9) return J1;
  p9 = 1;
  function e(t) {
    var n = this.__data__, r = n.delete(t);
    return this.size = n.size, r;
  }
  return J1 = e, J1;
}
var eu, g9;
function uF() {
  if (g9) return eu;
  g9 = 1;
  function e(t) {
    return this.__data__.get(t);
  }
  return eu = e, eu;
}
var tu, v9;
function dF() {
  if (v9) return tu;
  v9 = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return tu = e, tu;
}
var nu, b9;
function zs() {
  if (b9) return nu;
  b9 = 1;
  var e = Wr(), t = e(Object, "create");
  return nu = t, nu;
}
var ru, y9;
function cF() {
  if (y9) return ru;
  y9 = 1;
  var e = zs();
  function t() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return ru = t, ru;
}
var ou, _9;
function hF() {
  if (_9) return ou;
  _9 = 1;
  function e(t) {
    var n = this.has(t) && delete this.__data__[t];
    return this.size -= n ? 1 : 0, n;
  }
  return ou = e, ou;
}
var iu, C9;
function mF() {
  if (C9) return iu;
  C9 = 1;
  var e = zs(), t = "__lodash_hash_undefined__", n = Object.prototype, r = n.hasOwnProperty;
  function o(i) {
    var a = this.__data__;
    if (e) {
      var s = a[i];
      return s === t ? void 0 : s;
    }
    return r.call(a, i) ? a[i] : void 0;
  }
  return iu = o, iu;
}
var su, w9;
function fF() {
  if (w9) return su;
  w9 = 1;
  var e = zs(), t = Object.prototype, n = t.hasOwnProperty;
  function r(o) {
    var i = this.__data__;
    return e ? i[o] !== void 0 : n.call(i, o);
  }
  return su = r, su;
}
var au, T9;
function pF() {
  if (T9) return au;
  T9 = 1;
  var e = zs(), t = "__lodash_hash_undefined__";
  function n(r, o) {
    var i = this.__data__;
    return this.size += this.has(r) ? 0 : 1, i[r] = e && o === void 0 ? t : o, this;
  }
  return au = n, au;
}
var lu, k9;
function gF() {
  if (k9) return lu;
  k9 = 1;
  var e = cF(), t = hF(), n = mF(), r = fF(), o = pF();
  function i(a) {
    var s = -1, l = a == null ? 0 : a.length;
    for (this.clear(); ++s < l; ) {
      var u = a[s];
      this.set(u[0], u[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = t, i.prototype.get = n, i.prototype.has = r, i.prototype.set = o, lu = i, lu;
}
var uu, E9;
function vF() {
  if (E9) return uu;
  E9 = 1;
  var e = gF(), t = Ks(), n = K0();
  function r() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (n || t)(),
      string: new e()
    };
  }
  return uu = r, uu;
}
var du, S9;
function bF() {
  if (S9) return du;
  S9 = 1;
  function e(t) {
    var n = typeof t;
    return n == "string" || n == "number" || n == "symbol" || n == "boolean" ? t !== "__proto__" : t === null;
  }
  return du = e, du;
}
var cu, M9;
function Zs() {
  if (M9) return cu;
  M9 = 1;
  var e = bF();
  function t(n, r) {
    var o = n.__data__;
    return e(r) ? o[typeof r == "string" ? "string" : "hash"] : o.map;
  }
  return cu = t, cu;
}
var hu, A9;
function yF() {
  if (A9) return hu;
  A9 = 1;
  var e = Zs();
  function t(n) {
    var r = e(this, n).delete(n);
    return this.size -= r ? 1 : 0, r;
  }
  return hu = t, hu;
}
var mu, I9;
function _F() {
  if (I9) return mu;
  I9 = 1;
  var e = Zs();
  function t(n) {
    return e(this, n).get(n);
  }
  return mu = t, mu;
}
var fu, L9;
function CF() {
  if (L9) return fu;
  L9 = 1;
  var e = Zs();
  function t(n) {
    return e(this, n).has(n);
  }
  return fu = t, fu;
}
var pu, D9;
function wF() {
  if (D9) return pu;
  D9 = 1;
  var e = Zs();
  function t(n, r) {
    var o = e(this, n), i = o.size;
    return o.set(n, r), this.size += o.size == i ? 0 : 1, this;
  }
  return pu = t, pu;
}
var gu, $9;
function L3() {
  if ($9) return gu;
  $9 = 1;
  var e = vF(), t = yF(), n = _F(), r = CF(), o = wF();
  function i(a) {
    var s = -1, l = a == null ? 0 : a.length;
    for (this.clear(); ++s < l; ) {
      var u = a[s];
      this.set(u[0], u[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = t, i.prototype.get = n, i.prototype.has = r, i.prototype.set = o, gu = i, gu;
}
var vu, O9;
function TF() {
  if (O9) return vu;
  O9 = 1;
  var e = Ks(), t = K0(), n = L3(), r = 200;
  function o(i, a) {
    var s = this.__data__;
    if (s instanceof e) {
      var l = s.__data__;
      if (!t || l.length < r - 1)
        return l.push([i, a]), this.size = ++s.size, this;
      s = this.__data__ = new n(l);
    }
    return s.set(i, a), this.size = s.size, this;
  }
  return vu = o, vu;
}
var bu, P9;
function kF() {
  if (P9) return bu;
  P9 = 1;
  var e = Ks(), t = aF(), n = lF(), r = uF(), o = dF(), i = TF();
  function a(s) {
    var l = this.__data__ = new e(s);
    this.size = l.size;
  }
  return a.prototype.clear = t, a.prototype.delete = n, a.prototype.get = r, a.prototype.has = o, a.prototype.set = i, bu = a, bu;
}
var yu, N9;
function EF() {
  if (N9) return yu;
  N9 = 1;
  function e(t, n) {
    for (var r = -1, o = t == null ? 0 : t.length; ++r < o && n(t[r], r, t) !== !1; )
      ;
    return t;
  }
  return yu = e, yu;
}
var _u, H9;
function SF() {
  if (H9) return _u;
  H9 = 1;
  var e = Wr(), t = function() {
    try {
      var n = e(Object, "defineProperty");
      return n({}, "", {}), n;
    } catch (r) {
    }
  }();
  return _u = t, _u;
}
var Cu, F9;
function D3() {
  if (F9) return Cu;
  F9 = 1;
  var e = SF();
  function t(n, r, o) {
    r == "__proto__" && e ? e(n, r, {
      configurable: !0,
      enumerable: !0,
      value: o,
      writable: !0
    }) : n[r] = o;
  }
  return Cu = t, Cu;
}
var wu, R9;
function $3() {
  if (R9) return wu;
  R9 = 1;
  var e = D3(), t = I3(), n = Object.prototype, r = n.hasOwnProperty;
  function o(i, a, s) {
    var l = i[a];
    (!(r.call(i, a) && t(l, s)) || s === void 0 && !(a in i)) && e(i, a, s);
  }
  return wu = o, wu;
}
var Tu, V9;
function xs() {
  if (V9) return Tu;
  V9 = 1;
  var e = $3(), t = D3();
  function n(r, o, i, a) {
    var s = !i;
    i || (i = {});
    for (var l = -1, u = o.length; ++l < u; ) {
      var m = o[l], v = a ? a(i[m], r[m], m, i, r) : void 0;
      v === void 0 && (v = r[m]), s ? t(i, m, v) : e(i, m, v);
    }
    return i;
  }
  return Tu = n, Tu;
}
var ku, B9;
function MF() {
  if (B9) return ku;
  B9 = 1;
  function e(t, n) {
    for (var r = -1, o = Array(t); ++r < t; )
      o[r] = n(r);
    return o;
  }
  return ku = e, ku;
}
var Eu, j9;
function AF() {
  if (j9) return Eu;
  j9 = 1;
  var e = 9007199254740991, t = /^(?:0|[1-9]\d*)$/;
  function n(r, o) {
    var i = typeof r;
    return o = o == null ? e : o, !!o && (i == "number" || i != "symbol" && t.test(r)) && r > -1 && r % 1 == 0 && r < o;
  }
  return Eu = n, Eu;
}
var Su, U9;
function O3() {
  if (U9) return Su;
  U9 = 1;
  var e = MF(), t = S3(), n = Yr(), r = Z0(), o = AF(), i = A3(), a = Object.prototype, s = a.hasOwnProperty;
  function l(u, m) {
    var v = n(u), g = !v && t(u), h = !v && !g && r(u), E = !v && !g && !h && i(u), C = v || g || h || E, A = C ? e(u.length, String) : [], R = A.length;
    for (var P in u)
      (m || s.call(u, P)) && !(C && // Safari 9 has enumerable `arguments.length` in strict mode.
      (P == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      h && (P == "offset" || P == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      E && (P == "buffer" || P == "byteLength" || P == "byteOffset") || // Skip index properties.
      o(P, R))) && A.push(P);
    return A;
  }
  return Su = l, Su;
}
var Mu, q9;
function Y0() {
  if (q9) return Mu;
  q9 = 1;
  var e = O3(), t = w3(), n = z0();
  function r(o) {
    return n(o) ? e(o) : t(o);
  }
  return Mu = r, Mu;
}
var Au, G9;
function IF() {
  if (G9) return Au;
  G9 = 1;
  var e = xs(), t = Y0();
  function n(r, o) {
    return r && e(o, t(o), r);
  }
  return Au = n, Au;
}
var Iu, K9;
function LF() {
  if (K9) return Iu;
  K9 = 1;
  function e(t) {
    var n = [];
    if (t != null)
      for (var r in Object(t))
        n.push(r);
    return n;
  }
  return Iu = e, Iu;
}
var Lu, z9;
function DF() {
  if (z9) return Lu;
  z9 = 1;
  var e = Ti(), t = js(), n = LF(), r = Object.prototype, o = r.hasOwnProperty;
  function i(a) {
    if (!e(a))
      return n(a);
    var s = t(a), l = [];
    for (var u in a)
      u == "constructor" && (s || !o.call(a, u)) || l.push(u);
    return l;
  }
  return Lu = i, Lu;
}
var Du, Z9;
function X0() {
  if (Z9) return Du;
  Z9 = 1;
  var e = O3(), t = DF(), n = z0();
  function r(o) {
    return n(o) ? e(o, !0) : t(o);
  }
  return Du = r, Du;
}
var $u, x9;
function $F() {
  if (x9) return $u;
  x9 = 1;
  var e = xs(), t = X0();
  function n(r, o) {
    return r && e(o, t(o), r);
  }
  return $u = n, $u;
}
var ns = { exports: {} };
ns.exports;
var W9;
function OF() {
  return W9 || (W9 = 1, function(e, t) {
    var n = Ln(), r = t && !t.nodeType && t, o = r && !0 && e && !e.nodeType && e, i = o && o.exports === r, a = i ? n.Buffer : void 0, s = a ? a.allocUnsafe : void 0;
    function l(u, m) {
      if (m)
        return u.slice();
      var v = u.length, g = s ? s(v) : new u.constructor(v);
      return u.copy(g), g;
    }
    e.exports = l;
  }(ns, ns.exports)), ns.exports;
}
var Ou, Y9;
function PF() {
  if (Y9) return Ou;
  Y9 = 1;
  function e(t, n) {
    var r = -1, o = t.length;
    for (n || (n = Array(o)); ++r < o; )
      n[r] = t[r];
    return n;
  }
  return Ou = e, Ou;
}
var Pu, X9;
function NF() {
  if (X9) return Pu;
  X9 = 1;
  function e(t, n) {
    for (var r = -1, o = t == null ? 0 : t.length, i = 0, a = []; ++r < o; ) {
      var s = t[r];
      n(s, r, t) && (a[i++] = s);
    }
    return a;
  }
  return Pu = e, Pu;
}
var Nu, Q9;
function P3() {
  if (Q9) return Nu;
  Q9 = 1;
  function e() {
    return [];
  }
  return Nu = e, Nu;
}
var Hu, J9;
function Q0() {
  if (J9) return Hu;
  J9 = 1;
  var e = NF(), t = P3(), n = Object.prototype, r = n.propertyIsEnumerable, o = Object.getOwnPropertySymbols, i = o ? function(a) {
    return a == null ? [] : (a = Object(a), e(o(a), function(s) {
      return r.call(a, s);
    }));
  } : t;
  return Hu = i, Hu;
}
var Fu, ef;
function HF() {
  if (ef) return Fu;
  ef = 1;
  var e = xs(), t = Q0();
  function n(r, o) {
    return e(r, t(r), o);
  }
  return Fu = n, Fu;
}
var Ru, tf;
function N3() {
  if (tf) return Ru;
  tf = 1;
  function e(t, n) {
    for (var r = -1, o = n.length, i = t.length; ++r < o; )
      t[i + r] = n[r];
    return t;
  }
  return Ru = e, Ru;
}
var Vu, nf;
function H3() {
  if (nf) return Vu;
  nf = 1;
  var e = C3(), t = e(Object.getPrototypeOf, Object);
  return Vu = t, Vu;
}
var Bu, rf;
function F3() {
  if (rf) return Bu;
  rf = 1;
  var e = N3(), t = H3(), n = Q0(), r = P3(), o = Object.getOwnPropertySymbols, i = o ? function(a) {
    for (var s = []; a; )
      e(s, n(a)), a = t(a);
    return s;
  } : r;
  return Bu = i, Bu;
}
var ju, of;
function FF() {
  if (of) return ju;
  of = 1;
  var e = xs(), t = F3();
  function n(r, o) {
    return e(r, t(r), o);
  }
  return ju = n, ju;
}
var Uu, sf;
function R3() {
  if (sf) return Uu;
  sf = 1;
  var e = N3(), t = Yr();
  function n(r, o, i) {
    var a = o(r);
    return t(r) ? a : e(a, i(r));
  }
  return Uu = n, Uu;
}
var qu, af;
function RF() {
  if (af) return qu;
  af = 1;
  var e = R3(), t = Q0(), n = Y0();
  function r(o) {
    return e(o, n, t);
  }
  return qu = r, qu;
}
var Gu, lf;
function VF() {
  if (lf) return Gu;
  lf = 1;
  var e = R3(), t = F3(), n = X0();
  function r(o) {
    return e(o, n, t);
  }
  return Gu = r, Gu;
}
var Ku, uf;
function BF() {
  if (uf) return Ku;
  uf = 1;
  var e = Object.prototype, t = e.hasOwnProperty;
  function n(r) {
    var o = r.length, i = new r.constructor(o);
    return o && typeof r[0] == "string" && t.call(r, "index") && (i.index = r.index, i.input = r.input), i;
  }
  return Ku = n, Ku;
}
var zu, df;
function jF() {
  if (df) return zu;
  df = 1;
  var e = Ln(), t = e.Uint8Array;
  return zu = t, zu;
}
var Zu, cf;
function J0() {
  if (cf) return Zu;
  cf = 1;
  var e = jF();
  function t(n) {
    var r = new n.constructor(n.byteLength);
    return new e(r).set(new e(n)), r;
  }
  return Zu = t, Zu;
}
var xu, hf;
function UF() {
  if (hf) return xu;
  hf = 1;
  var e = J0();
  function t(n, r) {
    var o = r ? e(n.buffer) : n.buffer;
    return new n.constructor(o, n.byteOffset, n.byteLength);
  }
  return xu = t, xu;
}
var Wu, mf;
function qF() {
  if (mf) return Wu;
  mf = 1;
  var e = /\w*$/;
  function t(n) {
    var r = new n.constructor(n.source, e.exec(n));
    return r.lastIndex = n.lastIndex, r;
  }
  return Wu = t, Wu;
}
var Yu, ff;
function GF() {
  if (ff) return Yu;
  ff = 1;
  var e = Us(), t = e ? e.prototype : void 0, n = t ? t.valueOf : void 0;
  function r(o) {
    return n ? Object(n.call(o)) : {};
  }
  return Yu = r, Yu;
}
var Xu, pf;
function KF() {
  if (pf) return Xu;
  pf = 1;
  var e = J0();
  function t(n, r) {
    var o = r ? e(n.buffer) : n.buffer;
    return new n.constructor(o, n.byteOffset, n.length);
  }
  return Xu = t, Xu;
}
var Qu, gf;
function zF() {
  if (gf) return Qu;
  gf = 1;
  var e = J0(), t = UF(), n = qF(), r = GF(), o = KF(), i = "[object Boolean]", a = "[object Date]", s = "[object Map]", l = "[object Number]", u = "[object RegExp]", m = "[object Set]", v = "[object String]", g = "[object Symbol]", h = "[object ArrayBuffer]", E = "[object DataView]", C = "[object Float32Array]", A = "[object Float64Array]", R = "[object Int8Array]", P = "[object Int16Array]", F = "[object Int32Array]", I = "[object Uint8Array]", D = "[object Uint8ClampedArray]", O = "[object Uint16Array]", U = "[object Uint32Array]";
  function q(z, te, ee) {
    var x = z.constructor;
    switch (te) {
      case h:
        return e(z);
      case i:
      case a:
        return new x(+z);
      case E:
        return t(z, ee);
      case C:
      case A:
      case R:
      case P:
      case F:
      case I:
      case D:
      case O:
      case U:
        return o(z, ee);
      case s:
        return new x();
      case l:
      case v:
        return new x(z);
      case u:
        return n(z);
      case m:
        return new x();
      case g:
        return r(z);
    }
  }
  return Qu = q, Qu;
}
var Ju, vf;
function ZF() {
  if (vf) return Ju;
  vf = 1;
  var e = Ti(), t = Object.create, n = /* @__PURE__ */ function() {
    function r() {
    }
    return function(o) {
      if (!e(o))
        return {};
      if (t)
        return t(o);
      r.prototype = o;
      var i = new r();
      return r.prototype = void 0, i;
    };
  }();
  return Ju = n, Ju;
}
var ed, bf;
function xF() {
  if (bf) return ed;
  bf = 1;
  var e = ZF(), t = H3(), n = js();
  function r(o) {
    return typeof o.constructor == "function" && !n(o) ? e(t(o)) : {};
  }
  return ed = r, ed;
}
var td, yf;
function WF() {
  if (yf) return td;
  yf = 1;
  var e = qs(), t = Do(), n = "[object Map]";
  function r(o) {
    return t(o) && e(o) == n;
  }
  return td = r, td;
}
var nd, _f;
function YF() {
  if (_f) return nd;
  _f = 1;
  var e = WF(), t = x0(), n = W0(), r = n && n.isMap, o = r ? t(r) : e;
  return nd = o, nd;
}
var rd, Cf;
function XF() {
  if (Cf) return rd;
  Cf = 1;
  var e = qs(), t = Do(), n = "[object Set]";
  function r(o) {
    return t(o) && e(o) == n;
  }
  return rd = r, rd;
}
var od, wf;
function QF() {
  if (wf) return od;
  wf = 1;
  var e = XF(), t = x0(), n = W0(), r = n && n.isSet, o = r ? t(r) : e;
  return od = o, od;
}
var id, Tf;
function JF() {
  if (Tf) return id;
  Tf = 1;
  var e = kF(), t = EF(), n = $3(), r = IF(), o = $F(), i = OF(), a = PF(), s = HF(), l = FF(), u = RF(), m = VF(), v = qs(), g = BF(), h = zF(), E = xF(), C = Yr(), A = Z0(), R = YF(), P = Ti(), F = QF(), I = Y0(), D = X0(), O = 1, U = 2, q = 4, z = "[object Arguments]", te = "[object Array]", ee = "[object Boolean]", x = "[object Date]", N = "[object Error]", G = "[object Function]", X = "[object GeneratorFunction]", Q = "[object Map]", re = "[object Number]", se = "[object Object]", de = "[object RegExp]", me = "[object Set]", he = "[object String]", _e = "[object Symbol]", De = "[object WeakMap]", Ae = "[object ArrayBuffer]", Ze = "[object DataView]", Je = "[object Float32Array]", Mt = "[object Float64Array]", Vt = "[object Int8Array]", pn = "[object Int16Array]", gn = "[object Int32Array]", vn = "[object Uint8Array]", bn = "[object Uint8ClampedArray]", Dn = "[object Uint16Array]", At = "[object Uint32Array]", ce = {};
  ce[z] = ce[te] = ce[Ae] = ce[Ze] = ce[ee] = ce[x] = ce[Je] = ce[Mt] = ce[Vt] = ce[pn] = ce[gn] = ce[Q] = ce[re] = ce[se] = ce[de] = ce[me] = ce[he] = ce[_e] = ce[vn] = ce[bn] = ce[Dn] = ce[At] = !0, ce[N] = ce[G] = ce[De] = !1;
  function It(le, fe, Pe, Ve, Lt, xe) {
    var be, et = fe & O, mt = fe & U, Xt = fe & q;
    if (Pe && (be = Lt ? Pe(le, Ve, Lt, xe) : Pe(le)), be !== void 0)
      return be;
    if (!P(le))
      return le;
    var yn = C(le);
    if (yn) {
      if (be = g(le), !et)
        return a(le, be);
    } else {
      var tt = v(le), ft = tt == G || tt == X;
      if (A(le))
        return i(le, et);
      if (tt == se || tt == z || ft && !Lt) {
        if (be = mt || ft ? {} : E(le), !et)
          return mt ? l(le, o(be, le)) : s(le, r(be, le));
      } else {
        if (!ce[tt])
          return Lt ? le : {};
        be = h(le, tt, et);
      }
    }
    xe || (xe = new e());
    var _n = xe.get(le);
    if (_n)
      return _n;
    xe.set(le, be), F(le) ? le.forEach(function(Ce) {
      be.add(It(Ce, fe, Pe, Ce, le, xe));
    }) : R(le) && le.forEach(function(Ce, Ne) {
      be.set(Ne, It(Ce, fe, Pe, Ne, le, xe));
    });
    var Yn = Xt ? mt ? m : u : mt ? D : I, Dt = yn ? void 0 : Yn(le);
    return t(Dt || le, function(Ce, Ne) {
      Dt && (Ne = Ce, Ce = le[Ne]), n(be, Ne, It(Ce, fe, Pe, Ne, le, xe));
    }), be;
  }
  return id = It, id;
}
var sd, kf;
function eR() {
  if (kf) return sd;
  kf = 1;
  var e = JF(), t = 1, n = 4;
  function r(o) {
    return e(o, t | n);
  }
  return sd = r, sd;
}
var tR = eR();
const V3 = /* @__PURE__ */ Ao(tR), nR = {
  news: {
    cover_image: [
      {
        url: "cover_image",
        alt_text: "image_description",
        image_focal_point_x: "image_focal_point_x",
        image_focal_point_y: "image_focal_point_y"
      }
    ],
    title: "title",
    snippet: "snippet",
    author: "author",
    time_ago: "time_ago",
    date: ["published_at"],
    time: ["published_at"]
  },
  events: {
    title: "title",
    description: "description",
    venue: "venue",
    date: ["formatted_start", "formatted_end", "all_day"],
    time: ["formatted_start", "formatted_end", "all_day"]
  },
  all_events: {
    title: "title",
    description: "description",
    venue: "venue",
    date: ["formatted_start", "formatted_end", "all_day"],
    time: ["formatted_start", "formatted_end", "all_day"]
  },
  live_feed: {
    status: "status",
    author: "author",
    avatar: "avatar",
    time_ago: "time_ago",
    date: ["time"],
    live_feed_images: "live_feed_images",
    time: ["time"]
  },
  athletics: {
    title: "title",
    home_team: "home_team",
    home_score: "home_score",
    away_team: "away_team",
    away_score: "away_score",
    date: ["formatted_date"],
    time: ["formatted_date"],
    address: "address",
    versus: "versus",
    filter_name: "filter_name"
  },
  dining: {
    breakfast: "breakfast",
    lunch: "lunch"
  }
}, e0 = (e, t, n) => {
  const r = Object.entries(t).reduce((o, [i, a]) => (a instanceof Array ? o[i] = Object.values(e0(e, a)) : a instanceof Object ? o[i] = e0(e, a) : a in e && (o[i] = e[a]), o), {});
  return n && ["events", "all_events", "news", "live_feed"].includes(n.DATA_TYPE) ? H0(jn({}, r), { entry_url: oR(e, n) }) : r;
}, rR = (e, t) => {
  if (!e) throw new Error("No data source found.");
  const n = nR[[t.DATA_TYPE]];
  return e.map((r) => e0(r, n, t));
}, oR = (e, t) => {
  const n = {
    all_events: "events",
    news: "article",
    live_feed: "live-feed"
  }[t.DATA_TYPE] || t.DATA_TYPE, r = `${t.PATH_PREFIX}/${n}`;
  switch (n) {
    case "events":
      return `${r}?id=${e.id}`;
    case "article":
      return `${r}/${e.id}`;
    case "live-feed":
      return `${r}#${e.id}`;
    default:
      return r;
  }
}, iR = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, sR = (e, t, n) => {
  let r;
  const o = iR[e];
  return typeof o == "string" ? r = o : t === 1 ? r = o.one : r = o.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function ad(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const aR = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, lR = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, uR = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, dR = {
  date: ad({
    formats: aR,
    defaultWidth: "full"
  }),
  time: ad({
    formats: lR,
    defaultWidth: "full"
  }),
  dateTime: ad({
    formats: uR,
    defaultWidth: "full"
  })
}, cR = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, hR = (e, t, n, r) => cR[e];
function qo(e) {
  return (t, n) => {
    const r = n != null && n.context ? String(n.context) : "standalone";
    let o;
    if (r === "formatting" && e.formattingValues) {
      const a = e.defaultFormattingWidth || e.defaultWidth, s = n != null && n.width ? String(n.width) : a;
      o = e.formattingValues[s] || e.formattingValues[a];
    } else {
      const a = e.defaultWidth, s = n != null && n.width ? String(n.width) : e.defaultWidth;
      o = e.values[s] || e.values[a];
    }
    const i = e.argumentCallback ? e.argumentCallback(t) : t;
    return o[i];
  };
}
const mR = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, fR = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, pR = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, gR = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, vR = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, bR = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, yR = (e, t) => {
  const n = Number(e), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, _R = {
  ordinalNumber: yR,
  era: qo({
    values: mR,
    defaultWidth: "wide"
  }),
  quarter: qo({
    values: fR,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: qo({
    values: pR,
    defaultWidth: "wide"
  }),
  day: qo({
    values: gR,
    defaultWidth: "wide"
  }),
  dayPeriod: qo({
    values: vR,
    defaultWidth: "wide",
    formattingValues: bR,
    defaultFormattingWidth: "wide"
  })
};
function Go(e) {
  return (t, n = {}) => {
    const r = n.width, o = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], i = t.match(o);
    if (!i)
      return null;
    const a = i[0], s = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(s) ? wR(s, (v) => v.test(a)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      CR(s, (v) => v.test(a))
    );
    let u;
    u = e.valueCallback ? e.valueCallback(l) : l, u = n.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      n.valueCallback(u)
    ) : u;
    const m = t.slice(a.length);
    return { value: u, rest: m };
  };
}
function CR(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function wR(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function TR(e) {
  return (t, n = {}) => {
    const r = t.match(e.matchPattern);
    if (!r) return null;
    const o = r[0], i = t.match(e.parsePattern);
    if (!i) return null;
    let a = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    a = n.valueCallback ? n.valueCallback(a) : a;
    const s = t.slice(o.length);
    return { value: a, rest: s };
  };
}
const kR = /^(\d+)(th|st|nd|rd)?/i, ER = /\d+/i, SR = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, MR = {
  any: [/^b/i, /^(a|c)/i]
}, AR = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, IR = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, LR = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, DR = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, $R = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, OR = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, PR = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, NR = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, HR = {
  ordinalNumber: TR({
    matchPattern: kR,
    parsePattern: ER,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Go({
    matchPatterns: SR,
    defaultMatchWidth: "wide",
    parsePatterns: MR,
    defaultParseWidth: "any"
  }),
  quarter: Go({
    matchPatterns: AR,
    defaultMatchWidth: "wide",
    parsePatterns: IR,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Go({
    matchPatterns: LR,
    defaultMatchWidth: "wide",
    parsePatterns: DR,
    defaultParseWidth: "any"
  }),
  day: Go({
    matchPatterns: $R,
    defaultMatchWidth: "wide",
    parsePatterns: OR,
    defaultParseWidth: "any"
  }),
  dayPeriod: Go({
    matchPatterns: PR,
    defaultMatchWidth: "any",
    parsePatterns: NR,
    defaultParseWidth: "any"
  })
}, FR = {
  code: "en-US",
  formatDistance: sR,
  formatLong: dR,
  formatRelative: hR,
  localize: _R,
  match: HR,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
let RR = {};
function Ws() {
  return RR;
}
const B3 = 6048e5, VR = 864e5, j3 = 6e4, U3 = 36e5;
function fn(e) {
  const t = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && t === "[object Date]" ? new e.constructor(+e) : typeof e == "number" || t === "[object Number]" || typeof e == "string" || t === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
function Ef(e) {
  const t = fn(e);
  return t.setHours(0, 0, 0, 0), t;
}
function Sf(e) {
  const t = fn(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function BR(e, t) {
  const n = Ef(e), r = Ef(t), o = +n - Sf(n), i = +r - Sf(r);
  return Math.round((o - i) / VR);
}
function Rr(e, t) {
  return e instanceof Date ? new e.constructor(t) : new Date(t);
}
function jR(e) {
  const t = fn(e), n = Rr(e, 0);
  return n.setFullYear(t.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function UR(e) {
  const t = fn(e);
  return BR(t, jR(t)) + 1;
}
function hi(e, t) {
  var n, r, o, i, a, s, l, u;
  const m = Ws(), v = (u = (l = (i = (o = t == null ? void 0 : t.weekStartsOn) != null ? o : (r = (n = t == null ? void 0 : t.locale) == null ? void 0 : n.options) == null ? void 0 : r.weekStartsOn) != null ? i : m.weekStartsOn) != null ? l : (s = (a = m.locale) == null ? void 0 : a.options) == null ? void 0 : s.weekStartsOn) != null ? u : 0, g = fn(e), h = g.getDay(), E = (h < v ? 7 : 0) + h - v;
  return g.setDate(g.getDate() - E), g.setHours(0, 0, 0, 0), g;
}
function _s(e) {
  return hi(e, { weekStartsOn: 1 });
}
function q3(e) {
  const t = fn(e), n = t.getFullYear(), r = Rr(e, 0);
  r.setFullYear(n + 1, 0, 4), r.setHours(0, 0, 0, 0);
  const o = _s(r), i = Rr(e, 0);
  i.setFullYear(n, 0, 4), i.setHours(0, 0, 0, 0);
  const a = _s(i);
  return t.getTime() >= o.getTime() ? n + 1 : t.getTime() >= a.getTime() ? n : n - 1;
}
function qR(e) {
  const t = q3(e), n = Rr(e, 0);
  return n.setFullYear(t, 0, 4), n.setHours(0, 0, 0, 0), _s(n);
}
function GR(e) {
  const t = fn(e), n = +_s(t) - +qR(t);
  return Math.round(n / B3) + 1;
}
function G3(e, t) {
  var n, r, o, i, a, s, l, u;
  const m = fn(e), v = m.getFullYear(), g = Ws(), h = (u = (l = (i = (o = t == null ? void 0 : t.firstWeekContainsDate) != null ? o : (r = (n = t == null ? void 0 : t.locale) == null ? void 0 : n.options) == null ? void 0 : r.firstWeekContainsDate) != null ? i : g.firstWeekContainsDate) != null ? l : (s = (a = g.locale) == null ? void 0 : a.options) == null ? void 0 : s.firstWeekContainsDate) != null ? u : 1, E = Rr(e, 0);
  E.setFullYear(v + 1, 0, h), E.setHours(0, 0, 0, 0);
  const C = hi(E, t), A = Rr(e, 0);
  A.setFullYear(v, 0, h), A.setHours(0, 0, 0, 0);
  const R = hi(A, t);
  return m.getTime() >= C.getTime() ? v + 1 : m.getTime() >= R.getTime() ? v : v - 1;
}
function KR(e, t) {
  var n, r, o, i, a, s, l, u;
  const m = Ws(), v = (u = (l = (i = (o = t == null ? void 0 : t.firstWeekContainsDate) != null ? o : (r = (n = t == null ? void 0 : t.locale) == null ? void 0 : n.options) == null ? void 0 : r.firstWeekContainsDate) != null ? i : m.firstWeekContainsDate) != null ? l : (s = (a = m.locale) == null ? void 0 : a.options) == null ? void 0 : s.firstWeekContainsDate) != null ? u : 1, g = G3(e, t), h = Rr(e, 0);
  return h.setFullYear(g, 0, v), h.setHours(0, 0, 0, 0), hi(h, t);
}
function zR(e, t) {
  const n = fn(e), r = +hi(n, t) - +KR(n, t);
  return Math.round(r / B3) + 1;
}
function Ie(e, t) {
  const n = e < 0 ? "-" : "", r = Math.abs(e).toString().padStart(t, "0");
  return n + r;
}
const er = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), r = n > 0 ? n : 1 - n;
    return Ie(t === "yy" ? r % 100 : r, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : Ie(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return Ie(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return Ie(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return Ie(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return Ie(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return Ie(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, r = e.getMilliseconds(), o = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return Ie(o, t.length);
  }
}, no = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Mf = {
  // Era
  G: function(e, t, n) {
    const r = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const r = e.getFullYear(), o = r > 0 ? r : 1 - r;
      return n.ordinalNumber(o, { unit: "year" });
    }
    return er.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, r) {
    const o = G3(e, r), i = o > 0 ? o : 1 - o;
    if (t === "YY") {
      const a = i % 100;
      return Ie(a, 2);
    }
    return t === "Yo" ? n.ordinalNumber(i, { unit: "year" }) : Ie(i, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = q3(e);
    return Ie(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return Ie(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "Q":
        return String(r);
      // 01, 02, 03, 04
      case "QQ":
        return Ie(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "q":
        return String(r);
      // 01, 02, 03, 04
      case "qq":
        return Ie(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return er.M(e, t);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      // 1, 2, ..., 12
      case "L":
        return String(r + 1);
      // 01, 02, ..., 12
      case "LL":
        return Ie(r + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, r) {
    const o = zR(e, r);
    return t === "wo" ? n.ordinalNumber(o, { unit: "week" }) : Ie(o, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const r = GR(e);
    return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : Ie(r, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : er.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const r = UR(e);
    return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : Ie(r, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const r = e.getDay();
    switch (t) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, r) {
    const o = e.getDay(), i = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(i);
      // Padded numerical value
      case "ee":
        return Ie(i, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return n.ordinalNumber(i, { unit: "day" });
      case "eee":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, r) {
    const o = e.getDay(), i = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (same as in `e`)
      case "c":
        return String(i);
      // Padded numerical value
      case "cc":
        return Ie(i, t.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return n.ordinalNumber(i, { unit: "day" });
      case "ccc":
        return n.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return n.day(o, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return n.day(o, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return n.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const r = e.getDay(), o = r === 0 ? 7 : r;
    switch (t) {
      // 2
      case "i":
        return String(o);
      // 02
      case "ii":
        return Ie(o, t.length);
      // 2nd
      case "io":
        return n.ordinalNumber(o, { unit: "day" });
      // Tue
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const r = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const r = e.getHours();
    let o;
    switch (r === 12 ? o = no.noon : r === 0 ? o = no.midnight : o = r / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const r = e.getHours();
    let o;
    switch (r >= 17 ? o = no.evening : r >= 12 ? o = no.afternoon : r >= 4 ? o = no.morning : o = no.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let r = e.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return er.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : er.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const r = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : Ie(r, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let r = e.getHours();
    return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : Ie(r, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : er.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : er.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return er.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const r = e.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (t) {
      // Hours and optional minutes
      case "X":
        return If(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return Er(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return Er(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Hours and optional minutes
      case "x":
        return If(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return Er(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return Er(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Af(r, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + Er(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Af(r, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + Er(r, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const r = Math.trunc(e.getTime() / 1e3);
    return Ie(r, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    const r = e.getTime();
    return Ie(r, t.length);
  }
};
function Af(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), o = Math.trunc(r / 60), i = r % 60;
  return i === 0 ? n + String(o) : n + String(o) + t + Ie(i, 2);
}
function If(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + Ie(Math.abs(e) / 60, 2) : Er(e, t);
}
function Er(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), o = Ie(Math.trunc(r / 60), 2), i = Ie(r % 60, 2);
  return n + o + t + i;
}
const Lf = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, K3 = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, ZR = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], r = n[1], o = n[2];
  if (!o)
    return Lf(e, t);
  let i;
  switch (r) {
    case "P":
      i = t.dateTime({ width: "short" });
      break;
    case "PP":
      i = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      i = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      i = t.dateTime({ width: "full" });
      break;
  }
  return i.replace("{{date}}", Lf(r, t)).replace("{{time}}", K3(o, t));
}, xR = {
  p: K3,
  P: ZR
}, WR = /^D+$/, YR = /^Y+$/, XR = ["D", "DD", "YY", "YYYY"];
function QR(e) {
  return WR.test(e);
}
function JR(e) {
  return YR.test(e);
}
function eV(e, t, n) {
  const r = tV(e, t, n);
  if (console.warn(r), XR.includes(e)) throw new RangeError(r);
}
function tV(e, t, n) {
  const r = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
function nV(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function rV(e) {
  if (!nV(e) && typeof e != "number")
    return !1;
  const t = fn(e);
  return !isNaN(Number(t));
}
const oV = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, iV = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, sV = /^'([^]*?)'?$/, aV = /''/g, lV = /[a-zA-Z]/;
function uV(e, t, n) {
  var r, o, i, a, s, l, u, m, v;
  const g = Ws(), h = (r = g.locale) != null ? r : FR, E = (s = (a = g.firstWeekContainsDate) != null ? a : (i = (o = g.locale) == null ? void 0 : o.options) == null ? void 0 : i.firstWeekContainsDate) != null ? s : 1, C = (v = (m = g.weekStartsOn) != null ? m : (u = (l = g.locale) == null ? void 0 : l.options) == null ? void 0 : u.weekStartsOn) != null ? v : 0, A = fn(e);
  if (!rV(A))
    throw new RangeError("Invalid time value");
  let R = t.match(iV).map((F) => {
    const I = F[0];
    if (I === "p" || I === "P") {
      const D = xR[I];
      return D(F, h.formatLong);
    }
    return F;
  }).join("").match(oV).map((F) => {
    if (F === "''")
      return { isToken: !1, value: "'" };
    const I = F[0];
    if (I === "'")
      return { isToken: !1, value: dV(F) };
    if (Mf[I])
      return { isToken: !0, value: F };
    if (I.match(lV))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + I + "`"
      );
    return { isToken: !1, value: F };
  });
  h.localize.preprocessor && (R = h.localize.preprocessor(A, R));
  const P = {
    firstWeekContainsDate: E,
    weekStartsOn: C,
    locale: h
  };
  return R.map((F) => {
    if (!F.isToken) return F.value;
    const I = F.value;
    (JR(I) || QR(I)) && eV(I, t, String(e));
    const D = Mf[I[0]];
    return D(A, I, h.localize, P);
  }).join("");
}
function dV(e) {
  const t = e.match(sV);
  return t ? t[1].replace(aV, "'") : e;
}
function cV(e, t) {
  const n = pV(e);
  let r;
  if (n.date) {
    const s = gV(n.date, 2);
    r = vV(s.restDateString, s.year);
  }
  if (!r || isNaN(r.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  const o = r.getTime();
  let i = 0, a;
  if (n.time && (i = bV(n.time), isNaN(i)))
    return /* @__PURE__ */ new Date(NaN);
  if (n.timezone) {
    if (a = yV(n.timezone), isNaN(a))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    const s = new Date(o + i), l = /* @__PURE__ */ new Date(0);
    return l.setFullYear(
      s.getUTCFullYear(),
      s.getUTCMonth(),
      s.getUTCDate()
    ), l.setHours(
      s.getUTCHours(),
      s.getUTCMinutes(),
      s.getUTCSeconds(),
      s.getUTCMilliseconds()
    ), l;
  }
  return new Date(o + i + a);
}
const Zi = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, hV = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, mV = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, fV = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function pV(e) {
  const t = {}, n = e.split(Zi.dateTimeDelimiter);
  let r;
  if (n.length > 2)
    return t;
  if (/:/.test(n[0]) ? r = n[0] : (t.date = n[0], r = n[1], Zi.timeZoneDelimiter.test(t.date) && (t.date = e.split(Zi.timeZoneDelimiter)[0], r = e.substr(
    t.date.length,
    e.length
  ))), r) {
    const o = Zi.timezone.exec(r);
    o ? (t.time = r.replace(o[1], ""), t.timezone = o[1]) : t.time = r;
  }
  return t;
}
function gV(e, t) {
  const n = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" + (4 + t) + "})|(\\d{2}|[+-]\\d{" + (2 + t) + "})$)"
  ), r = e.match(n);
  if (!r) return { year: NaN, restDateString: "" };
  const o = r[1] ? parseInt(r[1]) : null, i = r[2] ? parseInt(r[2]) : null;
  return {
    year: i === null ? o : i * 100,
    restDateString: e.slice((r[1] || r[2]).length)
  };
}
function vV(e, t) {
  if (t === null) return /* @__PURE__ */ new Date(NaN);
  const n = e.match(hV);
  if (!n) return /* @__PURE__ */ new Date(NaN);
  const r = !!n[4], o = Ko(n[1]), i = Ko(n[2]) - 1, a = Ko(n[3]), s = Ko(n[4]), l = Ko(n[5]) - 1;
  if (r)
    return kV(t, s, l) ? _V(t, s, l) : /* @__PURE__ */ new Date(NaN);
  {
    const u = /* @__PURE__ */ new Date(0);
    return !wV(t, i, a) || !TV(t, o) ? /* @__PURE__ */ new Date(NaN) : (u.setUTCFullYear(t, i, Math.max(o, a)), u);
  }
}
function Ko(e) {
  return e ? parseInt(e) : 1;
}
function bV(e) {
  const t = e.match(mV);
  if (!t) return NaN;
  const n = ld(t[1]), r = ld(t[2]), o = ld(t[3]);
  return EV(n, r, o) ? n * U3 + r * j3 + o * 1e3 : NaN;
}
function ld(e) {
  return e && parseFloat(e.replace(",", ".")) || 0;
}
function yV(e) {
  if (e === "Z") return 0;
  const t = e.match(fV);
  if (!t) return 0;
  const n = t[1] === "+" ? -1 : 1, r = parseInt(t[2]), o = t[3] && parseInt(t[3]) || 0;
  return SV(r, o) ? n * (r * U3 + o * j3) : NaN;
}
function _V(e, t, n) {
  const r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(e, 0, 4);
  const o = r.getUTCDay() || 7, i = (t - 1) * 7 + n + 1 - o;
  return r.setUTCDate(r.getUTCDate() + i), r;
}
const CV = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function z3(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function wV(e, t, n) {
  return t >= 0 && t <= 11 && n >= 1 && n <= (CV[t] || (z3(e) ? 29 : 28));
}
function TV(e, t) {
  return t >= 1 && t <= (z3(e) ? 366 : 365);
}
function kV(e, t, n) {
  return t >= 1 && t <= 53 && n >= 0 && n <= 6;
}
function EV(e, t, n) {
  return e === 24 ? t === 0 && n === 0 : n >= 0 && n < 60 && t >= 0 && t < 60 && e >= 0 && e < 25;
}
function SV(e, t) {
  return t >= 0 && t <= 59;
}
function dn(e, t) {
  const n = e.includes("T") ? e.substring(0, e.lastIndexOf(".")) : e, r = cV(n);
  return uV(r, t);
}
function MV(e, t) {
  return t ? dn(e, "MMM/dd/yyyy") === dn(t, "MMM/dd/yyyy") : !0;
}
var ud, Df;
function eh() {
  if (Df) return ud;
  Df = 1;
  var e = wi(), t = Do(), n = "[object Symbol]";
  function r(o) {
    return typeof o == "symbol" || t(o) && e(o) == n;
  }
  return ud = r, ud;
}
var dd, $f;
function AV() {
  if ($f) return dd;
  $f = 1;
  var e = Yr(), t = eh(), n = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, r = /^\w*$/;
  function o(i, a) {
    if (e(i))
      return !1;
    var s = typeof i;
    return s == "number" || s == "symbol" || s == "boolean" || i == null || t(i) ? !0 : r.test(i) || !n.test(i) || a != null && i in Object(a);
  }
  return dd = o, dd;
}
var cd, Of;
function IV() {
  if (Of) return cd;
  Of = 1;
  var e = L3(), t = "Expected a function";
  function n(r, o) {
    if (typeof r != "function" || o != null && typeof o != "function")
      throw new TypeError(t);
    var i = function() {
      var a = arguments, s = o ? o.apply(this, a) : a[0], l = i.cache;
      if (l.has(s))
        return l.get(s);
      var u = r.apply(this, a);
      return i.cache = l.set(s, u) || l, u;
    };
    return i.cache = new (n.Cache || e)(), i;
  }
  return n.Cache = e, cd = n, cd;
}
var hd, Pf;
function LV() {
  if (Pf) return hd;
  Pf = 1;
  var e = IV(), t = 500;
  function n(r) {
    var o = e(r, function(a) {
      return i.size === t && i.clear(), a;
    }), i = o.cache;
    return o;
  }
  return hd = n, hd;
}
var md, Nf;
function DV() {
  if (Nf) return md;
  Nf = 1;
  var e = LV(), t = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, n = /\\(\\)?/g, r = e(function(o) {
    var i = [];
    return o.charCodeAt(0) === 46 && i.push(""), o.replace(t, function(a, s, l, u) {
      i.push(l ? u.replace(n, "$1") : s || a);
    }), i;
  });
  return md = r, md;
}
var fd, Hf;
function $V() {
  if (Hf) return fd;
  Hf = 1;
  function e(t, n) {
    for (var r = -1, o = t == null ? 0 : t.length, i = Array(o); ++r < o; )
      i[r] = n(t[r], r, t);
    return i;
  }
  return fd = e, fd;
}
var pd, Ff;
function OV() {
  if (Ff) return pd;
  Ff = 1;
  var e = Us(), t = $V(), n = Yr(), r = eh(), o = e ? e.prototype : void 0, i = o ? o.toString : void 0;
  function a(s) {
    if (typeof s == "string")
      return s;
    if (n(s))
      return t(s, a) + "";
    if (r(s))
      return i ? i.call(s) : "";
    var l = s + "";
    return l == "0" && 1 / s == -1 / 0 ? "-0" : l;
  }
  return pd = a, pd;
}
var gd, Rf;
function PV() {
  if (Rf) return gd;
  Rf = 1;
  var e = OV();
  function t(n) {
    return n == null ? "" : e(n);
  }
  return gd = t, gd;
}
var vd, Vf;
function NV() {
  if (Vf) return vd;
  Vf = 1;
  var e = Yr(), t = AV(), n = DV(), r = PV();
  function o(i, a) {
    return e(i) ? i : t(i, a) ? [i] : n(r(i));
  }
  return vd = o, vd;
}
var bd, Bf;
function HV() {
  if (Bf) return bd;
  Bf = 1;
  var e = eh();
  function t(n) {
    if (typeof n == "string" || e(n))
      return n;
    var r = n + "";
    return r == "0" && 1 / n == -1 / 0 ? "-0" : r;
  }
  return bd = t, bd;
}
var yd, jf;
function FV() {
  if (jf) return yd;
  jf = 1;
  var e = NV(), t = HV();
  function n(r, o) {
    o = e(o, r);
    for (var i = 0, a = o.length; r != null && i < a; )
      r = r[t(o[i++])];
    return i && i == a ? r : void 0;
  }
  return yd = n, yd;
}
var _d, Uf;
function RV() {
  if (Uf) return _d;
  Uf = 1;
  var e = FV();
  function t(n, r, o) {
    var i = n == null ? void 0 : e(n, r);
    return i === void 0 ? o : i;
  }
  return _d = t, _d;
}
var VV = RV();
const t0 = /* @__PURE__ */ Ao(VV), BV = (e, t, n = "date") => {
  if (!(n in e.entries[t]))
    return { type: "text", value: "Error: Value date not found" };
  const [r, o] = e.entries[t][n], i = MV(r, o) ? "" : dn(o, "MMM/dd/yyyy"), a = dn(r, "MMM"), s = dn(r, "dd"), l = dn(r, "iiii"), u = je("span.date", [
    je("span.start-month", a),
    je("span.start-date", s),
    je("span.start-weekday", l)
  ]);
  if (i) {
    const m = dn(o, "MMM"), v = dn(o, "dd"), g = dn(o, "iiii");
    u.children = u.children.concat(
      je("span.date-separator", "-"),
      je("span.end-month", m),
      je("span.end-date", v),
      je("span.end-weekday", g)
    );
  }
  return u;
}, jV = (e, t, n = "date") => {
  if (!(n in e.entries[t]))
    return { type: "text", value: "Error: Value time not found" };
  const [r, o, i] = e.entries[t][n];
  let a;
  const s = dn(r, "h:mmaaa");
  if (i)
    return je("span.time", je("span.start-time", "All day"));
  const l = je("span.time", [je("span.start-time", s)]);
  return o && (a = dn(o, "h:mmaaa"), l.children = l.children.concat(je("span.time-separator", "-"), je("span.end-time", a))), l;
}, qf = (e, t, n) => {
  let r = e.entries[t][n];
  return (r.length === 0 || !r[0].url) && (r = [{ url: t0(e, "fallback_image.url", "") }]), je(
    `div.${n.replace(/_/g, "-")}`,
    r.map(
      (o, i) => je(`img.entry-${t}-img-${i}`, {
        src: o.url,
        alt: o.alt_text || "",
        style: o.image_focal_point_x && o.image_focal_point_y ? { "object-position": `${o.image_focal_point_x || 50}% ${o.image_focal_point_y || 50}%` } : void 0
      })
    )
  );
}, UV = (e, t, n) => {
  const r = e.split("|");
  for (let o = 0; o < r.length; o++) {
    const i = r[o], a = t0(t.entries[n], i, t0(t, i, void 0));
    if (a !== void 0) return a;
  }
};
function qV(e) {
  const t = {
    type: "element",
    tagName: "a",
    properties: {
      href: e.link_url,
      target: e.opens_in_new_tab,
      class: "automatic-schools-menu-image-a"
    }
  }, n = {
    type: "element",
    tagName: "img",
    properties: {
      src: e.url,
      class: "automatic-schools-menu-image-img",
      alt: e.alt_text,
      width: `${e.width}`,
      height: `${e.height}`
    }
  };
  return e.action_on_click === "no_action" ? n : (t.children = [n], t);
}
const n0 = "default", Z3 = "children", th = (e, t, n, r = {}, o) => e ? e.tagName === Z3 ? zV(e, t, n, r, o) : KV(e, t, n, r, o) : null, GV = (e) => {
  const t = {
    [n0]: je(null, [new je("div", ["{{name|url}}", new je(Z3)])])
  }, n = { templates: t, children: [] };
  return (e.children || []).forEach((r) => {
    var o, i;
    if (r.tagName === "template") {
      const a = je(null, [...((o = r.content) == null ? void 0 : o.children) || []]), s = ((i = r.properties) == null ? void 0 : i.type) || n0;
      t[s] = a;
    } else
      n.children.push(r);
  }), n;
}, KV = (e, t, n, r, o) => (e.tagName && (e.properties.className = [
  ...Array.isArray(e.properties.className) ? e.properties.className : [],
  `${e.tagName}-${t.class || ""}`
]), Array.isArray(e.children) && (e.children = e.children.map((i) => th(i, t, n, r, o)).filter(Boolean)), e), zV = (e, t, n, r, o) => {
  if (!n || n.length === 0)
    return null;
  const { startRange: i, endRange: a } = xV(e.properties, n.length), { templates: s, children: l } = GV(e), u = jn(jn({}, r), s);
  e.children = l;
  const m = new je(null, []);
  for (let v = i; v < a; v++) {
    const g = jn(jn({}, t), n[v]), h = V3(u[g.type] || u[n0]);
    if (!h) continue;
    ZV(g, t.class), th(h, H0(jn({}, t), { class: g.class }), g.children, u, o);
    const E = o(h, jn(jn({}, t), g));
    E && m.children.push(E);
  }
  return m;
}, ZV = (e, t) => {
  if (Array.isArray(e.children)) {
    const n = `${t}-${(e.name || "").replace(/\W/g, "").toLowerCase()}`;
    e.children.forEach((r) => {
      r.class = n;
    });
  }
}, xV = (e, t) => {
  let n = 0, r = t;
  if (e != null && e.idx)
    n = Number(e.idx), r = n + 1;
  else if (e != null && e.loop) {
    const [o, i] = (e.loop.match(/\d+/g) || []).map(Number);
    n = o || 0, r = i || t;
  }
  return { startRange: n, endRange: r };
}, Gf = "loop", Cd = (e) => parseInt(e, 10), x3 = (e) => e.substr(2, e.length - 4).trim(), WV = (e) => Cd(e) ? [0, Cd(e)] : e.replace(/[()]/g, "").split(", ").map(Cd), Kf = {
  "cms-header-menu": (e, t) => {
    const n = t.menus[e.properties.entity].entries;
    return t.class = e.properties.entity, th(e, t, n, {}, To), To(e, t);
  },
  "cms-sign-in-button": (e, t) => {
    const { signInButtonText: n, showSignInButton: r, signInUrl: o } = t, i = r ? je(
      "a",
      {
        href: o,
        className: ["sign-in"],
        target: "_blank",
        "aria-label": `${n} (opens ${o} in a new tab)`
      },
      n
    ) : je(null);
    return je(null, [i]);
  }
}, tr = {
  DATA_TYPE: "",
  PATH_PREFIX: "",
  reservedTagParser: () => {
  },
  mappingFn: () => {
  }
}, YV = ["cms-media", "cms-header-menu", "cms-sign-in-button"], XV = (e) => {
  const t = {
    "&#x26;lt;": "<",
    "&#x3C;": "<",
    "&#x26;gt;": ">"
  }, n = new RegExp(Object.keys(t).join("|"), "gi");
  return e.replace(n, (r) => t[r]);
}, W3 = (e, t, n) => {
  const r = "{{", o = "}}", i = /{{([^{][\s\S]+?[^}])}}/g, a = e.toString().match(i);
  if (!a)
    return e;
  const s = a.map((l) => {
    const u = l.indexOf(r), m = l.lastIndexOf(o);
    if (u !== 0 && !u || !m || m < u)
      throw new Error(`Syntax error at ${l}`);
    const v = x3(l), g = tr.mappingFn(v, t, n);
    if (g == null)
      throw new Error(`Value ${v} not found`);
    return g;
  });
  return a.reduce((l, u, m) => l.replace(u, s[m]), e);
}, To = (e, t, n = -1) => {
  let r = V3(e);
  const o = (s) => s.type === "text", i = (s) => s.type === "element", a = (s) => s.children && s.children.length > 0;
  if (!a(e) && o(e)) {
    const s = zf(e, t, n);
    s.length === 1 ? i(s[0]) ? r = s[0] : r.value = s[0].value : s.length > 1 && (r = je("span", s));
  }
  if (a(e)) {
    const s = (l) => l.tagName && YV.includes(l.tagName) && l.children;
    r.children = e.children.reduce((l, u) => {
      if (o(u))
        return [...l, ...zf(u, t, n)];
      if (s(u)) {
        if (typeof Kf[u.tagName] == "function") {
          const m = Kf[u.tagName](u, t);
          return [...l, ...m.children];
        }
        return tr.reservedTagParser(l, u, n, t);
      }
      return [...l, To(u, t, n)];
    }, []);
  }
  return ((s) => !tF(s.properties))(e) && (r.properties = Object.fromEntries(
    Object.entries(e.properties).map(([s, l]) => [s, W3(l, t, n)])
  )), r;
}, QV = (e, t, n, r) => {
  let o = n;
  if (t.properties.idx) {
    o = t.properties.idx;
    const i = t.children.map((a) => To(a, r, o));
    return [...e, ...i];
  }
  if (t.properties[Gf]) {
    const [i, a] = WV(t.properties[Gf]);
    let s = 0;
    a > 0 ? s = a > r.entries.length ? r.entries.length : a + i : s = r.entries.length;
    let l = [];
    for (let u = i; u < s; u++)
      l = l.concat(t.children.map((m) => To(m, r, u)));
    return [...e, ...l];
  }
}, Y3 = (e, t, n) => {
  if (!t)
    throw new Error("Data type must be specified, eg. news, live_feed, athletics, events, or dining");
  if (!n)
    throw new Error("Data source is missing.");
  tr.DATA_TYPE = t, tr.PATH_PREFIX = n.path_prefix, tr.reservedTagParser = QV, tr.mappingFn = UV;
  const r = rR(n.entries, tr), o = (l) => l == "all_events" ? "events" : l.replace(/_/g, "-"), i = `${tr.PATH_PREFIX}/${o(t)}`, a = Wc().use(d3, { fragment: !0, emitParseErrors: !0, duplicateAttribute: !1 }).use(p3).parse(e), s = To(a, H0(jn({}, n), { section_page_url: i, entries: r }));
  return XV(Wc().use(RH).stringify(s));
};
function zf(e, t, n) {
  const r = /({{[^{][\s\S]+?[^}]}})/g, o = e.value.trim().split(r).filter((a) => a != ""), i = {
    date: BV,
    time: jV,
    cover_image: qf,
    live_feed_images: qf,
    schoolMenuImage: qV,
    default: function(a, s, l) {
      return { type: "text", value: W3(`{{${l}}}`, a, s) };
    }
  };
  return o.map((a) => {
    if (a.match(r)) {
      const s = x3(a);
      return i[s] ? i[s](t, n, s) : i.default(t, n, s);
    } else
      return { type: "text", value: a };
  });
}
const JV = (e) => Wc().use(d3, { fragment: !0, emitParseErrors: !0 }).use(p3).parse(e), eB = {
  name: "CustomHtml",
  props: {
    theme: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      componentKey: 0
    };
  },
  computed: {
    cssCode() {
      return this.theme.css_code;
    },
    jsCode() {
      return this.theme.js_code;
    },
    htmlCode() {
      return this.theme.html_code;
    }
  },
  watch: {
    cssCode(e, t) {
      this.hasNewValue(e, t) && this.mountCss(e);
    },
    jsCode(e, t) {
      this.hasNewValue(e, t) && this.mountJs(e);
    },
    htmlCode(e, t) {
      this.hasNewValue(e, t) && this.mountJs(this.jsCode);
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.mountCss(this.cssCode), this.mountJs(this.jsCode);
    });
  },
  methods: {
    hasNewValue(e, t) {
      return e && e.localeCompare && e.localeCompare(t) !== 0;
    },
    mountCss(e) {
      if (!e)
        return;
      this.removeElementIfExists("style");
      const t = document.createElement("style");
      t.type = "text/css", t.appendChild(document.createTextNode(e)), this.$refs.container.appendChild(t);
    },
    mountJs(e) {
      this.componentKey += 1, this.$nextTick(() => {
        if (!e || !this.$refs.container)
          return;
        this.removeElementIfExists("script");
        const t = document.createElement("script");
        t.type = "text/javascript", t.appendChild(document.createTextNode(e)), this.$refs.container.appendChild(t);
      });
    },
    removeElementIfExists(e) {
      const t = document.querySelector(`#${this.id} ${e}`);
      t && t.remove();
    }
  }
}, tB = ["id"], nB = ["innerHTML"];
function rB(e, t, n, r, o, i) {
  return d(), f("div", {
    id: n.theme.container_id,
    ref: "container",
    class: "custom-html"
  }, [
    (d(), f("div", {
      ref: "html_code",
      key: o.componentKey,
      innerHTML: i.htmlCode
    }, null, 8, nB))
  ], 8, tB);
}
const Ys = /* @__PURE__ */ B(eB, [["render", rB], ["__scopeId", "data-v-20687f05"]]), oB = {
  name: "Custom",
  components: {
    CustomHtml: Ys
  },
  mixins: [ut],
  props: {
    theme: {
      type: Object,
      default: () => ({})
    },
    content: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    processedTheme() {
      var t, n, r, o;
      let e = "";
      try {
        const i = [], a = {
          schoolName: this.content.globals.info.school_name,
          schoolLogo: this.content.globals.logo.url || "",
          schoolTagline: this.content.globals.info.school_tag_line || "",
          schoolPath: this.content.pathPrefix || "/",
          langCode: this.content.langCode,
          langText: "",
          signInButtonText: this.signInText,
          showSignInButton: this.showSignInButton,
          signInUrl: this.signInUrl
        };
        this.content.languages.forEach((m) => {
          m.code === this.content.langCode && (a.langText = m.language), i.push(ge(ae({}, m), { name: m.language }));
        });
        const s = this.formatItems(this.content.sitemapMenuItems), l = ((o = (r = (n = (t = this.content.globals) == null ? void 0 : t.homepage) == null ? void 0 : n.schools_menu) == null ? void 0 : r.menu) == null ? void 0 : o.flat()) || M4.menu.flat(), u = {
          siteMenu: {
            dataType: "siteMenu",
            entries: s
          },
          schoolsCustomMenu: {
            dataType: "schoolsCustomMenu",
            entries: this.formatItems(l)
          },
          schoolsMenu: {
            dataType: "schoolsMenu",
            entries: this.formatItems(this.content.organizations, "schoolsMenu")
          },
          languages: {
            dataType: "languages",
            entries: i
          }
        };
        e = Y3(this.theme.customData.htmlCode, "header", ge(ae({}, a), { entries: [], menus: u }));
      } catch (i) {
        e = i;
      }
      return ge(ae({}, this.theme), {
        html_code: e,
        css_code: this.theme.customData.cssCode,
        js_code: this.theme.customData.jsCode
      });
    }
  },
  methods: {
    formatItems(e, t) {
      const n = this.formatItems;
      return e.map((r) => {
        let o = ae({}, r);
        const i = {
          SchoolsMenuLink: (s) => (s.opens_in_new_tab = s.opens_in_new_tab ? "_blank" : "_self", s.url = s.link || "", s.url = s.url.toLowerCase().replace(/\s/g, "-"), s),
          SchoolsMenuImage: (s) => (s.opens_in_new_tab = s.open_in_new_tab ? "_blank" : "_self", s.url = s.url.toLowerCase().replace(/\s/g, "-"), s.height = s.preferred_height || "auto", s.width = s.preferred_width || "auto", s.alignment = s.image_alignment, s),
          link: (s) => (s.opens_in_new_tab = s.opens_in_new_tab ? "_blank" : "_self", s.url = s.mailto ? `mailto:${s.email_address}` : s.url, s.url = s.url.toLowerCase().replace(/\s/g, "-"), s.ipAddress = s.ipAddress || "", s.email_address = s.email_address || "", s),
          SchoolsMenuOrg: (s) => (s.alias = s.alias || "", s.link = s.link || "", s.link = s.link.toLowerCase().replace(/\s/g, "-"), s),
          schoolsMenu: (s) => (s.path_prefix = s.path_prefix ? s.path_prefix : "/", s),
          page: (s) => (s.link_path = `${this.content.pathPrefix}/page/${s.slug}`, s)
        }, a = o.type || t;
        return i[a] && (o = i[a](o)), Array.isArray(o.children) && (o.children = n(o.children, t)), o;
      });
    }
  }
}, iB = { class: "header-custom-code" };
function sB(e, t, n, r, o, i) {
  const a = V("CustomHtml");
  return d(), f("div", iB, [
    j(a, { theme: i.processedTheme }, null, 8, ["theme"])
  ]);
}
const aB = /* @__PURE__ */ B(oB, [["render", sB]]), lB = {
  name: "BarNavItemWrapper",
  components: { MenuElementType: U4, DropdownArrowIcon: Mo, HamburgerIcon: $0, PlusIcon: O0 },
  props: {
    item: {
      type: Object,
      default: void 0
    },
    theme: {
      type: Object,
      default: () => {
      }
    },
    content: {
      type: Object,
      default: () => {
      }
    },
    colors: {
      type: Object,
      required: !0
    },
    forceShow: Boolean,
    moreMenuItem: Boolean,
    additionalMenuItem: Boolean,
    moreMenuVisible: Boolean,
    isMoreMenuItem: Boolean,
    activeId: {
      type: [String, Number],
      default: null
    },
    firstItemId: {
      type: Number,
      default: 0
    },
    lastItemId: {
      type: Number,
      default: 0
    }
  },
  emits: [
    "handle-item",
    "handle-enter-event",
    "toggle-drawer",
    "navigate",
    "handle-close",
    "next-tab",
    "focus-sub-menu"
  ],
  computed: {
    isActive() {
      var e;
      return this.moreMenuItem ? this.moreMenuVisible : ((e = this.item) == null ? void 0 : e.id) === this.activeId;
    },
    iconClass() {
      return this.isActive ? "open" : void 0;
    },
    iconColor() {
      return this.isMoreMenuItem ? this.colors["--more-text-color"] : this.colors["--text-color"];
    },
    itemId() {
      return this.moreMenuItem ? "more-menu-item" : this.item ? this.item.id : "";
    },
    hasChildren() {
      var e, t;
      return !!((t = (e = this.item) == null ? void 0 : e.children) != null && t.length);
    },
    buttonTitle() {
      var e, t;
      return ((e = this.item) == null ? void 0 : e.name) || ((t = this.item) == null ? void 0 : t.translatedTitle);
    },
    hasFocusableChildren() {
      var t, n, r;
      const e = (o) => {
        var i;
        return [o, ...((i = o.children) == null ? void 0 : i.map((a) => e(a))) || []].flat();
      };
      return (r = (n = (t = this.item.children) == null ? void 0 : t.map((o) => e(o))) == null ? void 0 : n.flat()) == null ? void 0 : r.filter((o) => o.type !== "header").length;
    },
    isHeader() {
      var e;
      return ((e = this.item) == null ? void 0 : e.type) === "header";
    },
    hasSlug() {
      var e;
      return (e = this.item) == null ? void 0 : e.slug;
    },
    ariaId() {
      return this.moreMenuItem ? "menu-button-more" : `menu-button-${this.item ? this.item.id : ""}`;
    },
    ariaHasPopup() {
      return this.moreMenuItem ? "true" : this.hasChildren ? "dialog" : "false";
    },
    ariaControls() {
      return this.moreMenuItem ? "more-menu-dropdown" : this.hasChildren ? `drawer-${this.item ? this.item.id : ""}` : void 0;
    },
    ariaExpanded() {
      if (this.moreMenuItem)
        return this.moreMenuVisible ? "true" : "false";
      if (this.hasChildren)
        return this.isActive ? "true" : "false";
    }
  },
  methods: {
    handleEnterEvent(e) {
      if (this.moreMenuItem || !this.item) {
        this.$emit("handle-enter-event");
        return;
      }
      if (this.isHeader || this.additionalMenuItem || e) {
        this.$emit("toggle-drawer", this.item);
        return;
      }
      this.$emit("navigate", this.item);
    },
    handleNextTab(e, t) {
      var s, l;
      const n = e.shiftKey, r = this.isActive, o = this.activeId && r, i = ((s = this.item) == null ? void 0 : s.id) === this.firstItemId, a = ((l = this.item) == null ? void 0 : l.id) === this.lastItemId;
      if (n) {
        if (this.isMoreMenuItem && i && !t) {
          this.$emit("handle-close");
          return;
        }
        if (!this.isMoreMenuItem && r) {
          this.$emit("handle-close");
          return;
        }
        if (a && t && this.hasChildren && o) {
          this.$emit("handle-close");
          return;
        }
      } else {
        if (this.moreMenuItem) return;
        if (o && (t && this.hasFocusableChildren || this.isHeader)) {
          this.$emit("focus-sub-menu", this.item);
          return;
        }
        this.hasFocusableChildren === 0 && !this.isMoreMenuItem && r && this.$emit("handle-close"), a && (!this.hasChildren || t && this.hasChildren && !o) && this.$emit("handle-close");
      }
    }
  }
}, uB = ["id"], dB = ["aria-expanded", "aria-haspopup", "aria-controls"], cB = {
  class: "menu-item-focusable",
  tabindex: "-1"
}, hB = { class: "sr-only" }, mB = ["aria-expanded", "aria-haspopup", "aria-controls"], fB = { class: "sr-only" };
function pB(e, t, n, r, o, i) {
  const a = V("MenuElementType"), s = V("DropdownArrowIcon");
  return n.forceShow || n.moreMenuItem || n.additionalMenuItem || n.item ? (d(), f("div", {
    key: 0,
    id: i.itemId,
    ref: i.itemId,
    class: _(["bar-menu-item", {
      "menu-dropdown-item": n.isMoreMenuItem,
      "menu-item-active": !n.isMoreMenuItem && i.isActive
    }]),
    "data-testid": "menu-item",
    onMouseover: t[8] || (t[8] = W((l) => e.$emit("handle-item", n.item), ["stop", "prevent"])),
    onTouchstart: t[9] || (t[9] = W((...l) => i.handleEnterEvent && i.handleEnterEvent(...l), ["exact", "stop", "prevent"]))
  }, [
    j(a, {
      id: i.ariaId,
      class: _(["menu-item-text", {
        "menu-dropdown-item-active": i.isActive,
        [n.theme.style]: !!n.theme.style
      }]),
      "path-prefix": n.content.pathPrefix,
      "more-menu-title": n.theme.translations.more_dropdown_title,
      "more-menu-visible": n.moreMenuVisible,
      "fill-color": n.colors["--dropdown-text-color"],
      item: n.item,
      "aria-expanded": i.ariaExpanded,
      "aria-has-popup": i.ariaHasPopup,
      "aria-controls": i.ariaControls,
      onKeydown: [
        K(i.handleEnterEvent, ["enter"]),
        t[0] || (t[0] = K((l) => i.handleNextTab(l, !1), ["tab"]))
      ],
      onTouchstart: W(i.handleEnterEvent, ["exact", "stop", "prevent"])
    }, null, 8, ["id", "class", "path-prefix", "more-menu-title", "more-menu-visible", "fill-color", "item", "aria-expanded", "aria-has-popup", "aria-controls", "onKeydown", "onTouchstart"]),
    !i.isHeader && i.hasChildren && i.itemId !== "explore-button" && i.itemId !== "schoolsbutton" ? (d(), f("button", {
      key: 0,
      class: "menu-item-icon",
      "aria-expanded": i.ariaExpanded,
      "aria-haspopup": i.ariaHasPopup,
      "aria-controls": i.ariaControls,
      onKeydown: t[1] || (t[1] = K((l) => i.handleNextTab(l, !0), ["tab"])),
      onTouchstart: t[2] || (t[2] = W((l) => i.handleEnterEvent(!0), ["exact", "stop", "prevent"])),
      onClick: t[3] || (t[3] = W((l) => i.handleEnterEvent(!0), ["stop", "prevent"]))
    }, [
      c("span", cB, [
        j(s, {
          "dropdown-class": i.iconClass,
          "fill-color": i.iconColor
        }, null, 8, ["dropdown-class", "fill-color"]),
        c("span", hB, " Show submenu for " + k(i.buttonTitle) + " button", 1)
      ])
    ], 40, dB)) : T("", !0),
    i.isHeader || n.moreMenuItem || n.additionalMenuItem ? (d(), f(J, { key: 1 }, [
      n.moreMenuItem || n.additionalMenuItem || i.hasChildren ? (d(), f("button", {
        key: 0,
        class: _(["menu-item-icon", n.item.id]),
        "aria-expanded": i.ariaExpanded,
        "aria-haspopup": i.ariaHasPopup,
        "aria-controls": i.ariaControls,
        onMouseover: t[4] || (t[4] = W(() => {
        }, ["stop", "prevent"])),
        onTouchstart: t[5] || (t[5] = W((...l) => i.handleEnterEvent && i.handleEnterEvent(...l), ["exact", "stop", "prevent"])),
        onKeydown: t[6] || (t[6] = K((l) => i.handleNextTab(l, !0), ["tab"])),
        onClick: t[7] || (t[7] = W((...l) => i.handleEnterEvent && i.handleEnterEvent(...l), ["exact", "stop", "prevent"]))
      }, [
        n.item.id === "explore-button" ? (d(), L(Y(n.item.icon), {
          key: 0,
          "fill-color": n.item.colors["--bg-color"],
          "fill-path-color": i.iconColor
        }, null, 8, ["fill-color", "fill-path-color"])) : (d(), L(s, {
          key: 1,
          "dropdown-class": i.iconClass,
          "fill-color": i.iconColor
        }, null, 8, ["dropdown-class", "fill-color"])),
        c("span", fB, " Show submenu for " + k(n.item.name || n.item.translatedTitle), 1)
      ], 42, mB)) : T("", !0)
    ], 64)) : T("", !0)
  ], 42, uB)) : T("", !0);
}
const X3 = /* @__PURE__ */ B(lB, [["render", pB], ["__scopeId", "data-v-f89846d5"]]), gB = {
  name: "BarNavDrawer",
  components: { BarNavDrawerItem: q4 },
  mixins: [ut],
  props: {
    activeItem: {
      type: Object,
      default: void 0
    },
    currentDomain: {
      type: String,
      default: null
    },
    isMoreMenuActive: Boolean,
    isOpen: Boolean,
    isTemporarilyHideMenu: Boolean,
    isUnderlapped: Boolean
  },
  emits: ["hide-drawer", "handle-close", "prevent-close", "handle-toggle-parent", "next-tab", "navigate"],
  data() {
    return {
      activeParent: null,
      scrollWidth: !1
    };
  },
  computed: {
    orgsWithIds() {
      return this.content.organizations.map((t, n) => ge(ae({}, t), { id: n + 1 }));
    },
    itemId() {
      return `drawer-${this.activeItem.id}`;
    },
    drawerWidth() {
      return {
        "--drawer-width": this.isUnderlapped ? "100%" : "auto",
        "--left-alignment": this.isUnderlapped ? "46px" : ""
      };
    }
  },
  watch: {
    isOpen(e) {
      if (e) {
        const { scrollWidth: t, clientWidth: n } = this.$refs["drawer-wrapper"];
        t > n && (this.scrollWidth = !0);
      }
    }
  },
  methods: {
    orgLink(e) {
      return zr(e, {
        isPreview: this.content.isPreview,
        currentDomain: this.currentDomain
      });
    },
    hideDrawer() {
      this.$emit("hide-drawer");
    },
    handleNextTab({ itemId: e, isIconButton: t, isBackwardsTab: n }) {
      this.$emit("next-tab", { itemId: e, isIconButton: t, isBackwardsTab: n });
    },
    handleToggleParent(e) {
      if (!e) {
        this.activeParent = null;
        return;
      }
      if (e.id === this.activeParent) {
        this.activeParent = null, this.$emit("handle-toggle-parent", { itemId: e.id });
        return;
      }
      this.activeParent = e.id, this.$emit("handle-toggle-parent", { itemId: e.id });
    },
    targetWindow(e) {
      return e.opens_in_new_tab ? "_blank" : "_self";
    },
    getLink(e) {
      return e && e[0] === "/" ? `${this.content.pathPrefix}${e}` : e;
    }
  }
}, vB = ["id", "aria-labelledby"], bB = {
  key: 0,
  class: "menu-item-active-line"
}, yB = { key: 0 }, _B = { class: "explore-link" }, CB = ["innerHTML"], wB = ["href", "target", "onKeydown"], TB = { key: 1 }, kB = {
  key: 0,
  class: "basic-schools-dropdown"
}, EB = ["href", "target", "onKeydown"], SB = { key: 2 };
function MB(e, t, n, r, o, i) {
  const a = V("BarNavDrawerItem");
  return d(), f("div", {
    id: i.itemId,
    ref: i.itemId,
    "aria-labelledby": `menu-button-${n.activeItem.id}`,
    "aria-modal": "true",
    class: _(["bar-nav-menu--drawer", [n.activeItem.id]]),
    style: Z([i.drawerWidth, { flexDirection: o.scrollWidth ? "column" : "row" }]),
    onMouseleave: t[3] || (t[3] = W((s) => e.$emit("hide-drawer"), ["exact", "stop", "prevent"])),
    onMouseenter: t[4] || (t[4] = (s) => e.$emit("prevent-close"))
  }, [
    c("div", {
      ref: "drawer-wrapper",
      class: _(["bar-nav-menu--drawer-content-wrapper", { scrollWidth: o.scrollWidth }])
    }, [
      j(Le, { name: "slide-fade-up" }, {
        default: S(() => [
          n.isOpen ? (d(), f("div", bB)) : T("", !0)
        ]),
        _: 1
      }),
      n.activeItem.id === "explore-button" ? (d(), f("div", yB, [
        (d(!0), f(J, null, ne(e.content.customMenuItems, (s) => (d(), f("div", {
          key: s.id,
          class: "dropdown-with-icons"
        }, [
          c("div", _B, [
            c("span", {
              innerHTML: s.icon || s.icon_cms
            }, null, 8, CB),
            c("a", {
              href: i.getLink(s.url),
              style: Z({ color: e.theme.explore_menu_text_color }),
              target: i.targetWindow(s),
              onKeydown: K((l) => i.handleNextTab({ itemId: s.id, isIconButton: !1, isBackwardsTab: l.shiftKey }), ["tab"])
            }, k(s.name), 45, wB)
          ])
        ]))), 128))
      ])) : T("", !0),
      n.activeItem.id === "schoolsbutton" ? (d(), f("div", TB, [
        e.content.hasCustomSchoolsMenu ? T("", !0) : (d(), f("ul", kB, [
          (d(!0), f(J, null, ne(i.orgsWithIds, (s) => (d(), f("li", {
            key: s.id
          }, [
            c("a", {
              href: i.orgLink(s),
              class: "school-link",
              target: i.targetWindow(s),
              onKeydown: K((l) => i.handleNextTab({ itemId: s.id, isIconButton: !0, isBackwardsTab: l.shiftKey }), ["tab"])
            }, k(s.name), 41, EB)
          ]))), 128))
        ]))
      ])) : T("", !0),
      n.activeItem.id !== "schoolsbutton" && n.activeItem.id !== "explore-button" ? (d(), f("div", SB, [
        (d(!0), f(J, null, ne(n.activeItem.children, (s) => (d(), L(a, {
          key: s.id,
          "elem-data": s,
          "theme-style": e.theme.style,
          colors: e.colors,
          "active-parent": o.activeParent,
          "path-prefix": e.content.pathPrefix,
          onToggleParent: i.handleToggleParent,
          onHandleClose: t[0] || (t[0] = (l) => e.$emit("handle-close")),
          onNextTab: t[1] || (t[1] = (l) => e.$emit("next-tab", l)),
          onNavigate: t[2] || (t[2] = (l) => e.$emit("navigate", l))
        }, null, 8, ["elem-data", "theme-style", "colors", "active-parent", "path-prefix", "onToggleParent"]))), 128))
      ])) : T("", !0)
    ], 2)
  ], 46, vB);
}
const AB = /* @__PURE__ */ B(gB, [["render", MB], ["__scopeId", "data-v-ab83e199"]]), IB = {
  name: "BarNavMenuDropdown",
  components: { BarNavItemWrapper: X3 },
  props: {
    activeId: {
      type: [String, Number],
      default: null
    },
    isVisible: Boolean,
    moreItems: {
      type: Array,
      default: () => []
    },
    colors: {
      type: Object,
      default: null
    },
    theme: {
      type: Object,
      default: null
    },
    content: {
      type: Object,
      default: null
    }
  },
  emits: [
    "prevent-close",
    "handle-enter-event",
    "toggle-drawer",
    "navigate",
    "open-dropdown",
    "handle-close",
    "temporarily-hide-menu",
    "focus-sub-menu"
  ],
  computed: {
    ariaId() {
      return "more-menu-dropdown";
    },
    ariaLabelledBy() {
      return "menu-button-more";
    },
    ariaExpanded() {
      return this.isVisible ? "true" : "false";
    },
    lastItemId() {
      const e = (n) => {
        var r;
        return n.type !== "header" || ((r = n.children) == null ? void 0 : r.length) > 0;
      }, t = this.moreItems.findLastIndex(e);
      return this.moreItems[t].id;
    },
    firstItemId() {
      const e = (n) => {
        var r;
        return n.type !== "header" || ((r = n.children) == null ? void 0 : r.length) > 0;
      }, t = this.moreItems.findIndex(e);
      return this.moreItems[t].id;
    }
  }
}, LB = ["id", "aria-labelledby", "aria-expanded"];
function DB(e, t, n, r, o, i) {
  const a = V("BarNavItemWrapper");
  return d(), f("div", {
    id: i.ariaId,
    "aria-labelledby": i.ariaLabelledBy,
    "aria-expanded": i.ariaExpanded,
    class: "bar-nav-menu--dropdown-item-wrapper",
    onMouseleave: t[3] || (t[3] = (s) => e.$emit("prevent-close"))
  }, [
    (d(!0), f(J, null, ne(n.moreItems, (s) => (d(), f(J, null, [
      s ? (d(), L(a, {
        ref_for: !0,
        ref: `more-${s.id}`,
        key: s.id,
        item: s,
        "force-show": !0,
        "is-more-menu-item": !0,
        "first-item-id": i.firstItemId,
        "last-item-id": i.lastItemId,
        "active-id": n.activeId,
        theme: n.theme,
        content: n.content,
        colors: n.colors,
        onNavigate: (l) => e.$emit("navigate", s),
        onHandleEnterEvent: (l) => e.$emit("handle-enter-event", s),
        onHandleItem: (l) => e.$emit("open-dropdown", s),
        onToggleDrawer: t[0] || (t[0] = (l) => e.$emit("toggle-drawer", l)),
        onHandleClose: t[1] || (t[1] = (l) => e.$emit("handle-close")),
        onFocusSubMenu: t[2] || (t[2] = (l) => e.$emit("focus-sub-menu", l))
      }, null, 8, ["item", "first-item-id", "last-item-id", "active-id", "theme", "content", "colors", "onNavigate", "onHandleEnterEvent", "onHandleItem"])) : T("", !0)
    ], 64))), 256))
  ], 40, LB);
}
const $B = /* @__PURE__ */ B(IB, [["render", DB], ["__scopeId", "data-v-33993d03"]]), OB = {
  name: "M5",
  components: {
    BarNavItemWrapper: X3,
    BarNavDrawer: AB,
    BarNavMoreDropdown: $B,
    CMSSchoolsMenu: mr,
    MenuItem: Yt
  },
  mixins: [H4, ut],
  emits: ["toggle-search"],
  computed: {
    moreBtnWidth() {
      var e, t;
      return ((t = (e = this.$refs) == null ? void 0 : e["more-wrapper"]) == null ? void 0 : t.clientWidth) || 10;
    },
    exploreButton() {
      var e, t, n, r;
      return {
        id: "explore-button",
        ref: "explore-button",
        class: ["explore", "button-action", "menu", this.theme.style],
        dataTestId: "explore-button",
        ariaExpanded: this.exploreMenuVisible,
        ariaControls: this.exploreMenuVisible ? "explore-menu" : null,
        children: this.content.customMenuItems,
        translatedTitle: ((e = this.theme.translations) == null ? void 0 : e.menu_dropdown_title) || ((n = (t = this.theme.translations) == null ? void 0 : t.header) == null ? void 0 : n.explore_dropdown_title) || "Explore",
        icon: this.theme.menu_icon === "plus" ? "PlusIcon" : "HamburgerIcon",
        colors: {
          "--fill-color": ((r = this.theme.navigation_color) == null ? void 0 : r.hex) || "#000000",
          "--fill-path-color": this.theme.navigation_icon_color.hex,
          "--bg-color": this.theme.bg_color.hex,
          "--dropdown-class": this.exploreMenuVisible ? "open" : "close",
          "--nav-color": this.theme.navigation_color.hex
        }
      };
    },
    schoolsButton() {
      var e;
      return {
        id: "schoolsbutton",
        ref: "schoolsbutton",
        class: ["schools", "button-action", "menu", this.theme.style],
        dataTestId: "schools-button",
        ariaExpanded: this.isSchoolDropdownVisible || this.customSchoolsMenuVisible,
        ariaControls: this.isSchoolDropdownVisible || this.customSchoolsMenuVisible ? "schools-menu-sm1" : null,
        icon: "FilledDropdownArrow",
        translatedTitle: this.content.orgDropdownTitle || "Schools",
        children: this.orgsWithIds,
        colors: {
          "--fill-color": ((e = this.theme.navigation_color) == null ? void 0 : e.hex) || "#000000",
          "--fill-path-color": this.theme.navigation_icon_color.hex,
          "--bg-color": this.theme.bg_color.hex,
          "--dropdown-class": this.isSchoolDropdownVisible || this.customSchoolsMenuVisible ? "open" : "close",
          "--nav-color": this.theme.navigation_color.hex
        }
      };
    },
    orgsWithIds() {
      return this.content.organizations.map((t, n) => ge(ae({}, t), { id: n + 1 }));
    }
  },
  methods: {
    isUnderlapped(e) {
      return e === null ? void 0 : !!this.underLappedItems.find((n) => n.id === e);
    },
    closeCustomSchoolsMenu() {
      this.customSchoolsMenuVisible = !1, this.handleClose();
    }
  }
}, PB = { class: "bar-nav-menu--align-right" }, NB = {
  ref: "bar-nav-item-wrapper",
  class: "bar-nav-item-wrapper"
}, HB = {
  class: "options-wrapper",
  "data-testid": "options-wrapper"
}, FB = {
  class: "options-wrapper",
  "data-testid": "options-wrapper"
}, RB = {
  ref: "more-wrapper",
  class: "bar-dropdown-more-wrapper"
}, VB = {
  ref: "bar-end-options",
  class: "bar-end-options"
}, BB = ["href"];
function jB(e, t, n, r, o, i) {
  const a = V("BarNavItemWrapper"), s = V("BarNavDrawer"), l = V("CMSSchoolsMenu"), u = V("BarNavMoreDropdown"), m = V("MenuItem"), v = ze("click-away");
  return d(), f("div", {
    id: "m5",
    style: Z(e.colors),
    class: _(["bar-nav-menu", { "is-i-frame": e.content.isIFrame }])
  }, [
    c("div", {
      ref: "bar-nav-menu-bar",
      class: "bar-nav-menu-bar",
      onMouseleave: t[21] || (t[21] = (g) => e.mouseLeaveMenu()),
      onMouseenter: t[22] || (t[22] = (g) => e.mouseEnterMenu())
    }, [
      c("div", PB, [
        we((d(), f("div", NB, [
          c("div", HB, [
            j(a, {
              item: i.exploreButton,
              "active-id": e.activeItem ? e.activeItem.id : null,
              theme: e.theme,
              content: e.content,
              colors: e.colors,
              "additional-menu-item": "",
              onNavigate: e.navigate,
              onHandleItem: t[0] || (t[0] = (g) => e.showItem(i.exploreButton)),
              onToggleDrawer: t[1] || (t[1] = (g) => e.handleDrawerToggle(i.exploreButton)),
              onHandleClose: e.handleClose
            }, null, 8, ["item", "active-id", "theme", "content", "colors", "onNavigate", "onHandleClose"]),
            j(Le, { name: "slide-fade-up" }, {
              default: S(() => [
                e.activeItem && e.activeItem.id === i.exploreButton.id ? (d(), L(s, {
                  key: 0,
                  ref: `drawer-${i.exploreButton.id}`,
                  "active-item": i.exploreButton,
                  theme: e.theme,
                  content: e.content,
                  "current-domain": e.currentDomain,
                  "is-open": e.activeItem && e.activeItem.id === i.exploreButton.id,
                  "is-temporarily-hide-menu": e.isTemporarilyHideMenu,
                  onHandleToggleParent: e.toggleParentCollapsible,
                  onNavigate: t[2] || (t[2] = (g) => e.navigate(g)),
                  onHideDrawer: t[3] || (t[3] = (g) => e.hideDrawer("mouseleave")),
                  onHandleClose: e.handleClose,
                  onPreventClose: t[4] || (t[4] = (g) => e.preventClose(e.activeItem)),
                  onNextTab: t[5] || (t[5] = (g) => e.nextTabAction(g, "exploreButton"))
                }, null, 8, ["active-item", "theme", "content", "current-domain", "is-open", "is-temporarily-hide-menu", "onHandleToggleParent", "onHandleClose"])) : T("", !0)
              ]),
              _: 1
            })
          ]),
          c("div", FB, [
            j(a, {
              item: i.schoolsButton,
              "active-id": e.activeItem ? e.activeItem.id : null,
              theme: e.theme,
              content: e.content,
              colors: e.colors,
              "additional-menu-item": "",
              onNavigate: e.navigate,
              onHandleItem: t[6] || (t[6] = (g) => e.showItem(i.schoolsButton)),
              onToggleDrawer: t[7] || (t[7] = (g) => e.handleDrawerToggle(i.schoolsButton)),
              onHandleClose: e.handleClose
            }, null, 8, ["item", "active-id", "theme", "content", "colors", "onNavigate", "onHandleClose"]),
            j(Le, { name: "slide-fade-up" }, {
              default: S(() => [
                e.activeItem && e.activeItem.id === i.schoolsButton.id & !e.content.hasCustomSchoolsMenu ? (d(), L(s, {
                  key: 0,
                  ref: "drawer-schoolsbutton",
                  "active-item": i.schoolsButton,
                  theme: e.theme,
                  content: e.content,
                  "current-domain": e.currentDomain,
                  "is-open": e.activeItem && e.activeItem.id === i.schoolsButton.id,
                  "is-temporarily-hide-menu": e.isTemporarilyHideMenu,
                  onHandleToggleParent: e.toggleParentCollapsible,
                  onNavigate: e.navigate,
                  onHideDrawer: t[8] || (t[8] = (g) => e.hideDrawer("mouseleave")),
                  onHandleClose: e.handleClose,
                  onPreventClose: t[9] || (t[9] = (g) => e.preventClose(e.activeItem)),
                  onNextTab: t[10] || (t[10] = (g) => e.nextTabAction(g, "schoolsButton"))
                }, null, 8, ["active-item", "theme", "content", "current-domain", "is-open", "is-temporarily-hide-menu", "onHandleToggleParent", "onNavigate", "onHandleClose"])) : T("", !0)
              ]),
              _: 1
            }),
            j(Le, { name: "slide" }, {
              default: S(() => [
                e.content.hasCustomSchoolsMenu ? (d(), L(l, {
                  key: 0,
                  id: "schoolsmenu",
                  ref: "schoolsmenu",
                  "data-testid": "custom-schools-menu",
                  role: "menu",
                  "header-theme": e.theme,
                  "org-menu-content": e.content.orgMenuContent,
                  organizations: e.content.organizations,
                  "show-custom-schools-menu": e.isCustomSchoolsMenuVisible,
                  "sticky-header": e.shouldBeSticky,
                  "shrink-header": e.shouldShrink,
                  "is-preview": e.content.isPreview,
                  onFocusLost: i.closeCustomSchoolsMenu,
                  onMouseleave: i.closeCustomSchoolsMenu
                }, null, 8, ["header-theme", "org-menu-content", "organizations", "show-custom-schools-menu", "sticky-header", "shrink-header", "is-preview", "onFocusLost", "onMouseleave"])) : T("", !0)
              ]),
              _: 1
            })
          ]),
          (d(!0), f(J, null, ne(e.content.sitemapMenuItems, (g) => (d(), f("div", {
            key: g.id,
            class: "options-wrapper",
            "data-testid": "options-wrapper"
          }, [
            we(j(a, {
              item: g,
              "active-id": e.activeItem ? e.activeItem.id : null,
              theme: e.theme,
              content: e.content,
              colors: e.colors,
              onNavigate: e.navigate,
              onHandleEnterEvent: e.handleClose,
              onHandleItem: (h) => e.showItem(g),
              onToggleDrawer: (h) => e.handleDrawerToggle(g),
              onHandleClose: e.handleClose
            }, null, 8, ["item", "active-id", "theme", "content", "colors", "onNavigate", "onHandleEnterEvent", "onHandleItem", "onToggleDrawer", "onHandleClose"]), [
              [qn, e.visibleItems.find(({ id: h }) => h === g.id)]
            ]),
            j(Le, { name: "slide-fade-up" }, {
              default: S(() => [
                we(j(s, {
                  ref_for: !0,
                  ref: `drawer-${g.id}`,
                  "active-item": g,
                  theme: e.theme,
                  content: e.content,
                  "current-domain": e.currentDomain,
                  "is-open": e.activeItem && e.activeItem.id === g.id,
                  "is-temporarily-hide-menu": e.isTemporarilyHideMenu,
                  "is-underlapped": i.isUnderlapped(e.activeItem && e.activeItem.id),
                  onHandleToggleParent: e.toggleParentCollapsible,
                  onNavigate: e.navigate,
                  onHideDrawer: t[11] || (t[11] = (h) => e.hideDrawer("hide-drawer")),
                  onHandleClose: e.handleClose,
                  onPreventClose: t[12] || (t[12] = (h) => e.preventClose(e.activeItem)),
                  onNextTab: t[13] || (t[13] = (h) => e.nextTabAction(h))
                }, null, 8, ["active-item", "theme", "content", "current-domain", "is-open", "is-temporarily-hide-menu", "is-underlapped", "onHandleToggleParent", "onNavigate", "onHandleClose"]), [
                  [qn, e.activeItem && e.activeItem.id === g.id && g.children.length > 0]
                ])
              ]),
              _: 2
            }, 1024)
          ]))), 128))
        ])), [
          [v, e.hideDrawer]
        ]),
        we(c("div", RB, [
          j(a, {
            class: "bar-dropdown-button",
            "more-menu-item": "",
            "more-menu-visible": e.isMoreDropdownVisible,
            "force-show": "",
            theme: e.theme,
            item: { name: "more", children: [], id: "more" },
            content: e.content,
            colors: e.colors,
            onNavigate: e.navigate,
            onHandleEnterEvent: t[14] || (t[14] = (g) => e.isMoreDropdownVisible = !e.isMoreDropdownVisible),
            onHandleClose: e.hideMoreMenu,
            onHandleItem: t[15] || (t[15] = (g) => {
              e.handleMoreMenuToggle(e.isMoreDropdownVisible), e.hideDrawer();
            })
          }, null, 8, ["more-menu-visible", "theme", "content", "colors", "onNavigate", "onHandleClose"]),
          j(Le, { name: "slide-fade-up" }, {
            default: S(() => [
              e.underLappedItems && e.isMoreDropdownVisible ? we((d(), L(u, {
                key: 0,
                ref: "moreDropdown",
                "active-id": e.activeItem ? e.activeItem.id : null,
                "is-visible": e.isMoreDropdownVisible,
                "more-items": e.underLappedItems,
                theme: e.theme,
                content: e.content,
                colors: e.colors,
                onNavigate: e.navigate,
                onHandleEnterEvent: e.handleClose,
                onOpenDropdown: t[16] || (t[16] = (g) => e.handleDropdownMenuOpen(g)),
                onToggleDrawer: t[17] || (t[17] = (g) => e.handleDrawerToggle(g)),
                onPreventClose: t[18] || (t[18] = (g) => e.preventClose(e.activeItem)),
                onHandleClose: e.handleClose,
                onFocusSubMenu: t[19] || (t[19] = (g) => e.focusSubMenu(g)),
                onTemporarilyHideMenu: e.temporalHide
              }, null, 8, ["active-id", "is-visible", "more-items", "theme", "content", "colors", "onNavigate", "onHandleEnterEvent", "onHandleClose", "onTemporarilyHideMenu"])), [
                [v, e.hideMoreMenu]
              ]) : T("", !0)
            ]),
            _: 1
          })
        ], 512), [
          [qn, e.displayMoreButton]
        ])
      ]),
      c("div", VB, [
        !e.isMobile || !e.content.newMobileHeader ? (d(), L(m, {
          key: 0,
          item: "searchbutton",
          theme: e.theme,
          content: e.content,
          onToggleSearch: t[20] || (t[20] = (g) => e.$emit("toggle-search"))
        }, null, 8, ["theme", "content"])) : T("", !0),
        e.showSignInButton ? (d(), f("a", {
          key: 1,
          href: e.signInUrl,
          class: "sign-in-button",
          target: "_blank"
        }, k(e.signInText), 9, BB)) : T("", !0)
      ], 512)
    ], 544)
  ], 6);
}
const UB = /* @__PURE__ */ B(OB, [["render", jB], ["__scopeId", "data-v-8b4a97d0"]]), qB = {
  name: "CmsHeader",
  components: {
    /* eslint-disable vue/no-reserved-component-names */
    H1: dD,
    H2: LD,
    H3: OD,
    H4: A$,
    H5: J$,
    H6: $O,
    H7: xO,
    H8: hP,
    /* eslint-enable vue/no-reserved-component-names */
    Custom: aB,
    M4: N0,
    M5: UB
  },
  mixins: [Wt],
  props: {
    theme: {
      type: Object,
      default: () => ({})
    },
    content: {
      validator(e) {
        const t = Object.keys(e);
        return [
          "customMenuItems",
          "globals",
          "hasCustomSchoolsMenu",
          "hasGalleryImages",
          "isIFrame",
          "isEditing",
          "isPreview",
          "isSearchOpen",
          "langCode",
          "langText",
          "languages",
          "menuOptions",
          "newMobileHeader",
          "orgDropdownTitle",
          "orgMenuContent",
          "organizations",
          "pathPrefix",
          "showMenu",
          "sitemapMenuItems",
          "iconLinks",
          "translations",
          "utilities"
        ].every((r) => t.includes(r));
      },
      type: Object,
      required: !0
    },
    isHomepage: Boolean,
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    },
    currentDomain: {
      type: String,
      default: null
    },
    mediaSubdomain: {
      type: String,
      default: ""
    }
  },
  emits: [
    "toggle-mobile-menu",
    "toggle-menu",
    "toggle-search",
    "language-change",
    "close-menu",
    "update:utilities",
    "update:icon-links"
  ],
  data() {
    return {
      headerShouldShrink: !1,
      headerOffsetHeight: 0,
      headerClientHeight: 218,
      ticking: !1,
      debouncedToggleStickyHeaderAdj: () => {
      },
      debouncedCalculateHeaderHeight: () => {
      }
    };
  },
  computed: {
    customSchoolsMenu() {
      return this.content.hasCustomSchoolsMenu || this.theme.custom_schools_dropdown;
    },
    cmsHeaderStickyStyles() {
      const e = this.content.isPreview || !this.headerShouldBeSticky ? 0 : this.headerOffsetHeight, t = this.theme.version === "H3" && !this.isMobile && this.isHomepage && this.content.hasGalleryImages, n = this.theme.version === "H4" && !this.isMobile && this.isHomepage && this.content.hasGalleryImages;
      return {
        paddingBottom: `${e}px`,
        "--header-position": t || n ? "absolute" : "relative",
        "--header-width": t || n ? "100%" : "auto"
      };
    },
    headerShouldBeSticky() {
      var e;
      return ((e = this.theme) == null ? void 0 : e.sticky_header) && this.headerShouldShrink && !this.content.isIFrame;
    },
    // Used only to toggle settings in cms-v2-components example
    themeSettingsToWatch() {
      var e;
      return `${this.theme.version}${(e = this.theme) == null ? void 0 : e.sticky_header}`;
    },
    isBarNavEnabled() {
      var e, t;
      return ((e = this.content.menuOptions) == null ? void 0 : e.version) === "M4" || ((t = this.content.menuOptions) == null ? void 0 : t.version) === "M5";
    },
    menuOptions() {
      return ge(ae(ae({}, this.theme), this.content.menuOptions), {
        translations: this.theme.translations || this.content.menuOptions.translations,
        headerHeight: this.headerClientHeight
      });
    },
    showMenuV4() {
      var e;
      return ((e = this.content.menuOptions) == null ? void 0 : e.version) === "M4" && !this.isMobile && !["Custom", "H5"].includes(this.theme.version);
    },
    showMenuV5() {
      var e;
      return ((e = this.content.menuOptions) == null ? void 0 : e.version) === "M5" && !this.isMobile && !["Custom", "H5"].includes(this.theme.version);
    },
    isMobile() {
      var t;
      if (!this.screenSize)
        return !1;
      let e = this.isBarNavEnabled ? 1023 : 960;
      return ((t = this.content.menuOptions) == null ? void 0 : t.version) === "M6" ? this.screenSize <= 600 : (["H5", "H6"].includes(this.theme.version) && (e = 600), this.screenSize <= e);
    },
    showSignInButton() {
      return !!(this.theme.show_sign_in_button && (this.mediaSubdomain || this.content.isPreview));
    },
    signInUrl() {
      return `https://${this.mediaSubdomain}.id.thrillshare.com`;
    },
    H3gradient() {
      var e;
      return {
        "--bg-color": this.theme.version === "H3" ? this.theme.bg_color.hex : "",
        "--background-opacity": `${(e = this.theme.background_opacity) != null ? e : "80"}%`
      };
    }
  },
  watch: {
    themeSettingsToWatch() {
      this.calculateHeaderHeight();
    }
  },
  mounted() {
    this.$nextTick(() => this.calculateHeaderHeight()), this.debouncedToggleStickyHeaderAdj = go(this.toggleStickyHeaderAdjustments, 10), this.debouncedCalculateHeaderHeight = go(this.calculateHeaderHeight, 100), window.addEventListener("scroll", this.debouncedToggleStickyHeaderAdj), window.addEventListener("resize", this.debouncedCalculateHeaderHeight);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.debouncedToggleStickyHeaderAdj), window.removeEventListener("resize", this.debouncedCalculateHeaderHeight);
  },
  methods: {
    toggleStickyHeaderAdjustments() {
      !this.theme.sticky_header || this.content.isIFrame || this.ticking || (this.ticking = !0, window.requestAnimationFrame(() => {
        const e = window.scrollY > this.$refs.headerWrapper.offsetHeight;
        e !== this.headerShouldShrink && (this.headerShouldShrink = e), this.ticking = !1;
      }));
    },
    async calculateHeaderHeight() {
      if (await this.$nextTick(), this.$refs.headerWrapper) {
        const e = this.$refs.headerWrapper, t = e.clientHeight, n = e.offsetHeight, r = this.isBarNavEnabled && this.screenSize > 1024 ? 54 : 0;
        this.headerOffsetHeight = n + r, t > 0 && t !== this.headerClientHeight && (this.headerClientHeight = t);
      }
    }
  }
};
function GB(e, t, n, r, o, i) {
  const a = V("M4"), s = V("M5");
  return d(), f("div", {
    id: "cms-header",
    ref: "cmsHeader",
    class: "cms-header",
    style: Z(i.cmsHeaderStickyStyles)
  }, [
    c("div", {
      ref: "headerWrapper",
      class: _(["header-bar-wrapper", [i.headerShouldBeSticky ? "sticky" : ""]]),
      style: Z(i.H3gradient)
    }, [
      (d(), L(Y(n.theme.version), {
        ref: "header",
        theme: n.theme,
        content: n.content,
        "should-shrink": o.headerShouldShrink,
        "should-be-sticky": i.headerShouldBeSticky,
        "is-mobile": i.isMobile,
        "is-homepage": n.isHomepage,
        "wrapper-component": n.wrapperComponent,
        "wrapper-props": n.wrapperProps,
        "show-sign-in-button": i.showSignInButton,
        "sign-in-url": i.signInUrl,
        onToggleMenu: t[0] || (t[0] = (l) => e.$emit("toggle-menu", l)),
        onToggleMobileMenu: t[1] || (t[1] = (l) => e.$emit("toggle-mobile-menu", l)),
        onCloseMenu: t[2] || (t[2] = (l) => e.$emit("close-menu")),
        onLanguageChange: t[3] || (t[3] = (l) => e.$emit("language-change", l)),
        onToggleSearch: t[4] || (t[4] = (l) => e.$emit("toggle-search")),
        "onUpdate:utilities": t[5] || (t[5] = (l) => e.$emit("update:utilities", l)),
        "onUpdate:iconLinks": t[6] || (t[6] = (l) => e.$emit("update:icon-links", l))
      }, {
        utility: S(({ idx: l }) => [
          M(e.$slots, "utility", { idx: l }, void 0, !0)
        ]),
        iconLink: S(({ idx: l }) => [
          M(e.$slots, "iconLink", { idx: l }, void 0, !0)
        ]),
        _: 3
      }, 40, ["theme", "content", "should-shrink", "should-be-sticky", "is-mobile", "is-homepage", "wrapper-component", "wrapper-props", "show-sign-in-button", "sign-in-url"])),
      i.showMenuV4 ? (d(), L(a, {
        key: 0,
        theme: i.menuOptions,
        content: n.content,
        "is-mobile": i.isMobile,
        "is-preview": n.content.isPreview,
        onCloseMenu: t[7] || (t[7] = (l) => e.$emit("close-menu"))
      }, null, 8, ["theme", "content", "is-mobile", "is-preview"])) : T("", !0),
      i.showMenuV5 ? (d(), L(s, {
        key: 1,
        theme: i.menuOptions,
        content: n.content,
        "current-domain": n.currentDomain,
        "show-sign-in-button": i.showSignInButton,
        "sign-in-url": i.signInUrl,
        onCloseMenu: t[8] || (t[8] = (l) => e.$emit("toggle-menu", !1)),
        onToggleSearch: t[9] || (t[9] = (l) => e.$emit("toggle-search"))
      }, null, 8, ["theme", "content", "current-domain", "show-sign-in-button", "sign-in-url"])) : T("", !0)
    ], 6)
  ], 4);
}
const KB = /* @__PURE__ */ B(qB, [["render", GB], ["__scopeId", "data-v-34cc8f5d"]]), Q3 = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
function nh(e) {
  return e.replace(Q3, (t, n, r, o) => "#" + n + n + r + r + o + o).substring(1).match(/.{2}/g).map((t) => parseInt(t, 16));
}
function Zf(e, t = 1) {
  return [...e.replace(Q3, (r, o, i, a) => "#" + o + o + i + i + a + a).substring(1).match(/.{2}/g).map((r) => parseInt(r, 16)), t].join(",");
}
const zB = {
  name: "M1",
  mixins: [Rs],
  props: {
    isActive: Boolean
  },
  emits: ["close-menu"],
  data() {
    return {
      parentList: null,
      childList: null,
      grandchildList: null
    };
  },
  computed: {
    columns() {
      if (!this.content.sitemapMenuItems || this.content.sitemapMenuItems.length < 1) return [];
      const e = 3, t = new Array(e).fill(null).map(() => []);
      let n = 0;
      return this.content.sitemapMenuItems.forEach((r) => {
        n > e - 1 && (n = 0), t[n].push(r), n += 1;
      }), t;
    },
    mainMenuRGBColor() {
      const [e, t, n] = nh(this.theme.bg_color.hex);
      return `rgba(${e}, ${t}, ${n}, .96)`;
    }
  },
  mounted() {
    this.$refs.mainmenu.focus();
  },
  methods: {
    handleTabOnCloseButton() {
      this.$refs.mainmenu.focus();
    },
    handleShiftTabOnCloseButton(e) {
      e === 0 && this.$refs["close-menu-button"].focus();
    },
    setHoverColor(e, t) {
      this[e] = t;
    },
    removeHoverColor(e) {
      this[e] = null;
    },
    isSubMenuExpanded(e) {
      return this.activeIds.includes(e.id);
    },
    closeDropdownOnChildReverse(e, t, n) {
      e.id === n[0].id && this.toggleOpen(t.id, !1);
    },
    closeDropdownOnParentReverse(e, t) {
      e && this.toggleOpen(t.id, !1);
    },
    checkForExpandedMenu(e, t, n, r) {
      if (!e) {
        const o = r.length - 1;
        t.id === r[o].id && this.toggleOpen(n.id, !0);
      }
    },
    closeDropdownOnLastGrandchild(e, t, n) {
      const r = n.length - 1, o = t.length - 1, i = n[r].children[o].id;
      e.id === i && this.toggleOpen(e.id, !0);
    },
    closeDropdownOnLastChild(e, t) {
      const n = t.length - 1;
      e.id === t[n].id && e.children.length === 0 && this.toggleOpen(e.id, !0);
    }
  }
}, ZB = {
  id: "m1",
  "data-testid": "m1"
}, xB = { "data-testid": "heading" }, WB = { class: "content" }, YB = { class: "static-links" }, XB = ["onKeydown"], QB = ["id", "target", "href"], JB = ["innerHTML"], ej = {
  key: 0,
  class: "generated-links"
}, tj = ["onMouseover"], nj = ["onKeydown"], rj = ["id", "aria-expanded", "aria-controls", "aria-describedby", "onKeydown", "onClick"], oj = ["onKeydown", "onClick"], ij = ["id", "aria-expanded", "aria-controls", "aria-describedby"], sj = ["id", "aria-labelledby"], aj = ["onMouseover"], lj = ["onKeydown"], uj = ["onKeydown", "onClick"], dj = ["id", "aria-expanded", "aria-controls", "aria-describedby"], cj = ["id", "aria-labelledby"], hj = ["onMouseover", "onKeydown"], mj = ["onKeydown"], fj = {
  class: "button-action-content",
  tabindex: "-1"
}, pj = {
  width: "30px",
  height: "30px",
  viewBox: "0 0 17 17",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}, gj = ["fill"], vj = ["fill"];
function bj(e, t, n, r, o, i) {
  const a = V("MenuElement");
  return d(), f("div", ZB, [
    c("div", {
      id: "mainmenu",
      ref: "mainmenu",
      class: "menu-container",
      "aria-labelledby": "menubutton",
      "aria-modal": "true",
      tabindex: "0",
      style: Z(`background: ${i.mainMenuRGBColor}`),
      onKeydown: [
        t[9] || (t[9] = K(W((s) => e.$emit("close-menu"), ["exact", "prevent"]), ["esc"])),
        t[10] || (t[10] = K(W(() => {
        }, ["exact", "prevent"]), ["space"])),
        t[11] || (t[11] = K(W(() => {
        }, ["exact", "prevent"]), ["up"])),
        t[12] || (t[12] = K(W(() => {
        }, ["exact", "prevent"]), ["down"]))
      ]
    }, [
      c("div", {
        style: Z(`color: ${e.theme.l1_text_color.hex || "#dddddd"};`),
        class: "heading",
        "data-testid": "heading-color"
      }, [
        c("h2", xB, k(e.translations.title), 1)
      ], 4),
      c("div", WB, [
        c("div", YB, [
          c("ul", null, [
            (d(!0), f(J, null, ne(e.content.customMenuItems, (s, l) => (d(), f("li", {
              key: s.id,
              "data-testid": "static-link",
              onKeydown: [
                K(W((u) => e.clickStaticLink(e.getLink(s.url)), ["exact", "prevent"]), ["space"]),
                K(W((u) => i.handleShiftTabOnCloseButton(l), ["shift", "exact"]), ["tab"])
              ]
            }, [
              c("a", {
                id: s.id,
                style: Z(`color: ${e.theme.icon_text_color.hex};`),
                target: s.opens_in_new_tab ? "_blank" : "",
                href: e.getLink(s.url),
                onClick: t[0] || (t[0] = (u) => e.$emit("close-menu"))
              }, [
                c("div", null, [
                  c("div", {
                    class: _(["link-image", { "global-icon": s.cms_icon_id }]),
                    style: Z(`background: ${e.theme.icon_bg_color.hex};`)
                  }, [
                    c("div", {
                      class: "menu-item-icon",
                      "data-testid": "m1-icon-color",
                      style: Z(e.menuIconStyle),
                      "aria-hidden": "true",
                      innerHTML: s.cms_icon_id ? s.icon_cms : s.icon
                    }, null, 12, JB)
                  ], 6),
                  c("span", {
                    "data-testid": "m1-icon-text",
                    style: Z(`color: ${e.theme.icon_text_color.hex};`)
                  }, k(s.name), 5)
                ])
              ], 12, QB)
            ], 40, XB))), 128))
          ])
        ]),
        i.columns.length ? (d(), f("div", ej, [
          c("ul", null, [
            (d(!0), f(J, null, ne(e.content.sitemapMenuItems, (s, l) => (d(), f("li", {
              key: `parent-${l}`,
              "data-testid": "generated-link",
              class: _({
                "has-child": s.children.length,
                open: e.activeIds.includes(s.id)
              }),
              style: Z(
                o.parentList === l ? { color: e.theme.l1_text_hover_color.hex } : { color: e.theme.l1_text_color.hex }
              ),
              onMouseover: (u) => i.setHoverColor("parentList", l),
              onMouseleave: t[6] || (t[6] = (u) => i.removeHoverColor("parentList"))
            }, [
              c("span", {
                class: "parent-menu-element-wrapper",
                onKeydown: [
                  K(W((u) => e.clickGeneratedLink(s, !0), ["exact", "prevent"]), ["enter"]),
                  K(W((u) => e.clickGeneratedLink(s, !0), ["exact", "prevent"]), ["space"])
                ]
              }, [
                j(a, {
                  id: `${s.slug || s.id}-${s.type}`,
                  element: s,
                  "toggle-fn": e.toggleOpen,
                  "path-prefix": e.content.pathPrefix,
                  "is-parent": "",
                  "cursor-pointer": "",
                  onRouterLinkClick: t[1] || (t[1] = (u) => e.$emit("close-menu"))
                }, null, 8, ["id", "element", "toggle-fn", "path-prefix"])
              ], 40, nj),
              s.children.length ? (d(), f("span", {
                key: 0,
                id: `${s.slug || s.id}-${s.type}-parent-button`,
                role: "button",
                tabindex: "-1",
                "aria-expanded": !!e.activeIds.includes(s.id),
                "aria-haspopup": "true",
                "aria-controls": `${s.slug || s.id}-${s.type}-child-list`,
                "aria-label": "Toggle Submenu",
                "aria-describedby": `${s.slug || s.id}-${s.type}`,
                onKeydown: [
                  K(W((u) => e.toggleOpen(s.id, !0), ["exact", "prevent"]), ["enter"]),
                  K(W((u) => e.toggleOpen(s.id, !0), ["exact", "prevent"]), ["space"])
                ],
                onClick: (u) => e.toggleOpen(s.id, !0)
              }, null, 40, rj)) : T("", !0),
              s.children.length ? (d(), f("span", {
                key: 1,
                class: "arrow-box",
                tabindex: "0",
                onKeydown: [
                  K(W((u) => e.toggleOpen(s.id, !0), ["exact", "prevent"]), ["enter"]),
                  K(W((u) => e.toggleOpen(s.id, !0), ["exact", "prevent"]), ["space"]),
                  K(W((u) => i.closeDropdownOnParentReverse(e.activeIds.includes(s.id), s), ["shift", "exact"]), ["tab"])
                ],
                onClick: (u) => e.toggleOpen(s.id, !0)
              }, [
                c("span", {
                  id: `${s.slug || s.id}-${s.type}-parent-button`,
                  role: "button",
                  class: "parent-arrow",
                  tabindex: "-1",
                  "aria-expanded": !!e.activeIds.includes(s.id),
                  "aria-haspopup": "true",
                  "aria-controls": `${s.slug || s.id}-${s.type}-child-list`,
                  "aria-label": "Toggle Submenu",
                  "aria-describedby": `${s.slug || s.id}-${s.type}`
                }, null, 8, ij)
              ], 40, oj)) : T("", !0),
              c("div", {
                class: "dropdown",
                style: Z(`background: ${e.theme.l2_bg_color.hex || "#000000"};`)
              }, [
                s.children.length ? (d(), f("ul", {
                  key: 0,
                  id: `${s.slug || s.id}-${l}-child-list`,
                  "aria-labelledby": `${s.slug || s.id}-${s.type}-parent-button`
                }, [
                  (d(!0), f(J, null, ne(s.children, (u, m) => (d(), f("li", {
                    key: `child-${m}`,
                    style: Z(
                      o.childList === m ? { color: e.theme.l2_text_hover_color.hex } : { color: e.theme.l2_text_color.hex }
                    ),
                    class: _({
                      "has-child": u.children.length,
                      open: e.activeIds.includes(u.id)
                    }),
                    onMouseover: (v) => i.setHoverColor("childList", m),
                    onMouseleave: t[5] || (t[5] = (v) => i.removeHoverColor("childList"))
                  }, [
                    c("span", {
                      class: "child-menu-element-wrapper",
                      onKeydown: [
                        K(W((v) => e.clickGeneratedLink(u, !1), ["exact", "prevent"]), ["enter"]),
                        K(W((v) => e.clickGeneratedLink(u, !1), ["exact", "prevent"]), ["space"]),
                        K(W((v) => i.closeDropdownOnChildReverse(u, s, s.children), ["shift", "exact"]), ["tab"]),
                        K(W((v) => i.closeDropdownOnLastChild(u, s.children), ["exact"]), ["tab"])
                      ]
                    }, [
                      j(a, {
                        id: `${u.slug || u.id}-${u.type}`,
                        element: u,
                        "toggle-fn": e.toggleOpen,
                        "path-prefix": e.content.pathPrefix,
                        "is-sub-parent": "",
                        onRouterLinkClick: t[2] || (t[2] = (v) => e.$emit("close-menu"))
                      }, null, 8, ["id", "element", "toggle-fn", "path-prefix"])
                    ], 40, lj),
                    u.children.length ? (d(), f("span", {
                      key: 0,
                      class: "arrow-box",
                      tabindex: "0",
                      onKeydown: [
                        K(W((v) => e.toggleOpen(u.id, !1), ["exact", "prevent"]), ["enter"]),
                        K(W((v) => e.toggleOpen(u.id, !1), ["exact", "prevent"]), ["space"]),
                        K(W((v) => i.checkForExpandedMenu(i.isSubMenuExpanded(u), u, s, s.children), ["exact"]), ["tab"])
                      ],
                      onClick: (v) => e.toggleOpen(u.id, !1)
                    }, [
                      c("span", {
                        id: `${u.slug || u.id}-${u.type}-child-button`,
                        class: "child-arrow",
                        role: "button",
                        tabindex: "-1",
                        "aria-expanded": !!e.activeIds.includes(u.id),
                        "aria-haspopup": "true",
                        "aria-controls": `${u.slug || u.id}-${m}-grandchild-list`,
                        "aria-label": "Toggle Submenu",
                        "aria-describedby": `${u.slug || u.id}-${u.type}`
                      }, null, 8, dj)
                    ], 40, uj)) : T("", !0),
                    u.children.length ? (d(), f("ul", {
                      key: 1,
                      id: `${u.slug || u.id}-${m}-grandchild-list`,
                      "aria-labelledby": `${u.slug || u.id}-${u.type}-child-button`,
                      style: Z(`border-left: 1px solid ${e.theme.l2_text_color.hex}`)
                    }, [
                      (d(!0), f(J, null, ne(u.children, (v, g) => (d(), f("li", {
                        key: `grandchild-${g}`,
                        style: Z(
                          o.grandchildList === g ? { color: e.theme.l2_text_hover_color.hex } : { color: e.theme.l2_text_color.hex }
                        ),
                        onMouseover: (h) => i.setHoverColor("grandchildList", g),
                        onMouseleave: t[4] || (t[4] = (h) => i.removeHoverColor("grandchildList")),
                        onKeydown: K(W((h) => i.closeDropdownOnLastGrandchild(v, u.children, s.children), ["exact"]), ["tab"])
                      }, [
                        c("span", {
                          class: "grandchild-menu-element-wrapper",
                          onKeydown: [
                            K(W((h) => e.clickGeneratedLink(v, !1), ["exact", "prevent"]), ["enter"]),
                            K(W((h) => e.clickGeneratedLink(v, !1), ["exact", "prevent"]), ["space"])
                          ]
                        }, [
                          j(a, {
                            id: `${v.slug || v.id}-${v.type}`,
                            element: v,
                            "path-prefix": e.content.pathPrefix,
                            onRouterLinkClick: t[3] || (t[3] = (h) => e.$emit("close-menu"))
                          }, null, 8, ["id", "element", "path-prefix"])
                        ], 40, mj)
                      ], 44, hj))), 128))
                    ], 12, cj)) : T("", !0)
                  ], 46, aj))), 128))
                ], 8, sj)) : T("", !0)
              ], 4)
            ], 46, tj))), 128))
          ])
        ])) : T("", !0)
      ]),
      c("button", {
        ref: "close-menu-button",
        "data-testid": "close-menu-button",
        class: "close-menu button-action",
        "aria-label": "close",
        onClick: t[7] || (t[7] = (s) => e.$emit("close-menu")),
        onKeydown: t[8] || (t[8] = K(W((...s) => i.handleTabOnCloseButton && i.handleTabOnCloseButton(...s), ["exact", "prevent"]), ["tab"]))
      }, [
        c("div", fj, [
          (d(), f("svg", pj, [
            c("g", {
              id: "Page-1",
              stroke: "none",
              "stroke-width": "1",
              fill: e.theme.l1_text_color.hex,
              "fill-rule": "evenodd"
            }, [
              c("g", {
                id: "close_modal_icon",
                fill: e.theme.l1_text_color.hex
              }, t[13] || (t[13] = [
                c("path", { d: "M6.8,8.5 L0.01,1.71 L1.71,0.01 L8.5,6.8 L15.29,0.01 L16.99,1.71 L10.2,8.5 L16.99,15.29 L15.29,16.99 L8.5,10.2 L1.71,16.99 L0.01,15.29 L6.8,8.5 Z" }, null, -1)
              ]), 8, vj)
            ], 8, gj)
          ]))
        ])
      ], 544)
    ], 36)
  ]);
}
const yj = /* @__PURE__ */ B(zB, [["render", bj], ["__scopeId", "data-v-66e0ecdc"]]), _j = {
  name: "M2",
  mixins: [Rs],
  emits: ["close-menu"],
  data() {
    return {
      sectionList: null,
      parentList: null,
      childList: null
    };
  },
  computed: {
    mainMenuRGBColor() {
      const [e, t, n] = nh(this.theme.bg_color.hex);
      return `rgba(${e}, ${t}, ${n}, .96)`;
    }
  },
  mounted() {
    this.$refs.mainmenu.focus();
  },
  methods: {
    handleTabOnCloseButton() {
      this.$refs.mainmenu.focus();
    },
    handleShiftTabOnCloseButton(e) {
      e === 0 && this.$refs.closeButton.focus();
    },
    setHoverColor(e, t) {
      this[e] = t;
    },
    removeHoverColor(e) {
      this[e] = null;
    }
  }
}, Cj = { id: "m2" }, wj = { class: "content" }, Tj = { class: "static-links" }, kj = ["onKeydown"], Ej = ["id", "target", "href"], Sj = ["innerHTML"], Mj = { class: "generated-links" }, Aj = ["onKeydown", "onMouseover"], Ij = ["id", "aria-labelledby"], Lj = ["onMouseover"], Dj = ["id", "aria-expanded", "aria-controls", "tabindex", "onKeydown", "onMousedown"], $j = ["fill"], Oj = ["fill", "stroke"], Pj = ["fill", "stroke"], Nj = ["tabindex", "aria-controls", "aria-expanded", "aria-label", "onKeydown", "onClick"], Hj = ["id", "aria-labelledby"], Fj = ["onMouseover"], Rj = ["onKeydown"], Vj = {
  class: "button-action-content",
  tabindex: "-1"
}, Bj = {
  width: "30px",
  height: "30px",
  viewBox: "0 0 17 17",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}, jj = ["fill"], Uj = ["fill"];
function qj(e, t, n, r, o, i) {
  const a = V("MenuElement");
  return d(), f("div", Cj, [
    c("div", {
      id: "mainmenu",
      ref: "mainmenu",
      style: Z(`background: ${i.mainMenuRGBColor}`),
      class: "menu-container",
      "aria-labelledby": "menubutton",
      "aria-modal": "true",
      tabindex: "0",
      onKeydown: [
        t[7] || (t[7] = K(W((s) => e.$emit("close-menu"), ["exact", "prevent"]), ["esc"])),
        t[8] || (t[8] = K(W(() => {
        }, ["exact", "prevent"]), ["space"])),
        t[9] || (t[9] = K(W(() => {
        }, ["exact", "prevent"]), ["up"])),
        t[10] || (t[10] = K(W(() => {
        }, ["exact", "prevent"]), ["down"]))
      ]
    }, [
      c("div", wj, [
        c("div", Tj, [
          c("ul", null, [
            (d(!0), f(J, null, ne(e.content.customMenuItems, (s, l) => (d(), f("li", {
              key: s.id,
              onKeydown: [
                K(W((u) => e.clickStaticLink(e.getLink(s.url)), ["exact", "prevent"]), ["space"]),
                K(W((u) => i.handleShiftTabOnCloseButton(l), ["shift", "exact"]), ["tab"])
              ]
            }, [
              c("a", {
                id: s.id,
                style: Z(`color: ${e.theme.icon_text_color.hex};`),
                target: s.opens_in_new_tab ? "_blank" : "",
                href: e.getLink(s.url)
              }, [
                c("div", null, [
                  c("div", {
                    class: _(["link-image", { "global-icon": s.cms_icon_id }]),
                    style: Z(`background: ${e.theme.icon_bg_color.hex};`)
                  }, [
                    c("div", {
                      class: "menu-item-icon",
                      style: Z(e.menuIconStyle),
                      "aria-hidden": "true",
                      innerHTML: s.cms_icon_id ? s.icon_cms : s.icon
                    }, null, 12, Sj)
                  ], 6),
                  c("span", {
                    style: Z(`color: ${e.theme.icon_text_color.hex};`)
                  }, k(s.name), 5)
                ])
              ], 12, Ej)
            ], 40, kj))), 128))
          ])
        ]),
        c("div", Mj, [
          (d(!0), f(J, null, ne(e.content.sitemapMenuItems, (s, l) => (d(), f("div", {
            key: `section-${l}`,
            style: Z(`border-right-color: ${e.theme.text_color.hex}`),
            class: "col"
          }, [
            c("h2", {
              style: Z(
                o.sectionList === s.id ? { color: e.theme.text_hover_color.hex } : { color: e.theme.text_color.hex }
              ),
              onKeydown: [
                K(W((u) => e.clickGeneratedLink(s, !1), ["exact", "prevent"]), ["enter"]),
                K(W((u) => e.clickGeneratedLink(s, !1), ["exact", "prevent"]), ["space"])
              ],
              onMouseover: (u) => i.setHoverColor("sectionList", s.id),
              onMouseleave: t[1] || (t[1] = (u) => i.removeHoverColor("sectionList"))
            }, [
              j(a, {
                id: `${s.slug || s.id}-${s.type}`,
                element: s,
                class: _({ "has-child": s.children.length }),
                "path-prefix": e.content.pathPrefix,
                "is-parent": "",
                onRouterLinkClick: t[0] || (t[0] = (u) => e.$emit("close-menu"))
              }, null, 8, ["id", "element", "class", "path-prefix"])
            ], 44, Aj),
            s.children.length ? (d(), f("ul", {
              key: 0,
              id: `${s.slug || s.id}-${l}-parent-list`,
              "aria-labelledby": `${s.slug || s.id}-${s.type}`
            }, [
              (d(!0), f(J, null, ne(s.children, (u, m) => (d(), f("li", {
                key: `parent-${m}`,
                style: Z(
                  o.parentList === u.id ? { color: e.theme.text_hover_color.hex } : { color: e.theme.text_color.hex }
                ),
                class: _({
                  "has-child": u.children.length,
                  open: e.activeIds.includes(u.id)
                }),
                onMouseover: (v) => i.setHoverColor("parentList", u.id),
                onMouseleave: t[4] || (t[4] = (v) => i.removeHoverColor("parentList"))
              }, [
                u.children.length ? (d(), f("svg", {
                  key: 0,
                  id: `${u.slug || u.id}-${u.type}-parent-button`,
                  role: "button",
                  "aria-expanded": u.type !== "header" ? !!e.activeIds.includes(u.id) : "",
                  "aria-haspopup": "true",
                  "aria-controls": u.type !== "header" ? `${u.slug || u.id}-${m}-child-list` : "",
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "15",
                  height: "15",
                  viewBox: "0 0 16 16",
                  class: "icon-box",
                  tabindex: u.children.length && u.type !== "header" ? "0" : "-1",
                  onKeydown: [
                    K(W((v) => e.toggleOpen(u.id, !0), ["exact", "prevent"]), ["enter"]),
                    K(W((v) => e.toggleOpen(u.id, !0), ["exact", "prevent"]), ["space"])
                  ],
                  onMousedown: W((v) => e.toggleOpen(u.id, !0), ["prevent"])
                }, [
                  c("title", null, k(`Toggle Submenu for ${u.name}`), 1),
                  c("circle", {
                    class: "icon",
                    tabindex: "-1",
                    fill: e.theme.bg_color.hex,
                    cx: "10",
                    cy: "10",
                    r: "20"
                  }, null, 8, $j),
                  e.activeIds.includes(u.id) ? (d(), f("path", {
                    key: 0,
                    class: "icon",
                    tabindex: "-1",
                    fill: e.theme.text_color.hex,
                    stroke: e.theme.bg_color.hex,
                    d: "M549,659a8,8,0,1,1,8-8A8,8,0,0,1,549,659Zm4-9h-8v2h8v-2Z",
                    transform: "translate(-541 -643)"
                  }, null, 8, Oj)) : (d(), f("path", {
                    key: 1,
                    class: "icon",
                    tabindex: "-1",
                    fill: e.theme.text_color.hex,
                    stroke: e.theme.bg_color.hex,
                    d: "M549,638a8,8,0,1,1,8-8A8,8,0,0,1,549,638Zm4-9h-3v-3h-2v3h-3v2h3v3h2v-3h3v-2Z",
                    transform: "translate(-541 -622)"
                  }, null, 8, Pj))
                ], 40, Dj)) : T("", !0),
                c("span", {
                  class: "parent-menu-element-wrapper",
                  tabindex: u.children.length && u.type === "header" ? "0" : "-1",
                  "aria-controls": u.type === "header" ? `${u.slug || u.id}-${m}-child-list` : "",
                  "aria-expanded": u.type === "header" ? !!e.activeIds.includes(u.id) : "",
                  "aria-label": u.type === "header" ? `Toggle Submenu for ${u.name}` : "",
                  onKeydown: [
                    K(W((v) => e.clickGeneratedLink(u, !0), ["exact", "prevent"]), ["enter"]),
                    K(W((v) => e.clickGeneratedLink(u, !0), ["exact", "prevent"]), ["space"])
                  ],
                  onClick: W((v) => e.clickGeneratedLink(u, !0), ["stop"])
                }, [
                  j(a, {
                    id: `${u.slug || u.id}-${u.type}`,
                    element: u,
                    "path-prefix": e.content.pathPrefix,
                    "is-sub-parent": ""
                  }, null, 8, ["id", "element", "path-prefix"])
                ], 40, Nj),
                u.children.length ? (d(), f("ul", {
                  key: 1,
                  id: `${u.slug || u.id}-${m}-child-list`,
                  "aria-labelledby": `${u.slug || u.id}-${u.type}-parent-button`
                }, [
                  (d(!0), f(J, null, ne(u.children, (v, g) => (d(), f("li", {
                    key: `child-${g}`,
                    style: Z(
                      o.childList === v.id ? { color: e.theme.text_hover_color.hex } : { color: e.theme.text_color.hex }
                    ),
                    onMouseover: (h) => i.setHoverColor("childList", v.id),
                    onMouseleave: t[3] || (t[3] = (h) => i.removeHoverColor("childList"))
                  }, [
                    c("span", {
                      class: "child-menu-element-wrapper",
                      onKeydown: [
                        K(W((h) => e.clickGeneratedLink(v, !1), ["exact", "prevent"]), ["enter"]),
                        K(W((h) => e.clickGeneratedLink(v, !1), ["exact", "prevent"]), ["space"])
                      ]
                    }, [
                      j(a, {
                        id: `${v.slug || v.id}-${v.type}`,
                        element: v,
                        "path-prefix": e.content.pathPrefix,
                        onRouterLinkClick: t[2] || (t[2] = (h) => e.$emit("close-menu"))
                      }, null, 8, ["id", "element", "path-prefix"])
                    ], 40, Rj)
                  ], 44, Fj))), 128))
                ], 8, Hj)) : T("", !0)
              ], 46, Lj))), 128))
            ], 8, Ij)) : T("", !0)
          ], 4))), 128))
        ])
      ]),
      c("button", {
        ref: "closeButton",
        class: "close-menu button-action",
        "aria-label": "close",
        onClick: t[5] || (t[5] = (s) => e.$emit("close-menu")),
        onKeydown: t[6] || (t[6] = K(W((...s) => i.handleTabOnCloseButton && i.handleTabOnCloseButton(...s), ["exact", "prevent"]), ["tab"]))
      }, [
        c("div", Vj, [
          (d(), f("svg", Bj, [
            c("g", {
              id: "Page-1",
              stroke: "none",
              "stroke-width": "1",
              fill: e.theme.l1_text_color.hex,
              "fill-rule": "evenodd"
            }, [
              c("g", {
                id: "close_modal_icon",
                fill: e.theme.text_color.hex
              }, t[11] || (t[11] = [
                c("path", { d: "M6.8,8.5 L0.01,1.71 L1.71,0.01 L8.5,6.8 L15.29,0.01 L16.99,1.71 L10.2,8.5 L16.99,15.29 L15.29,16.99 L8.5,10.2 L1.71,16.99 L0.01,15.29 L6.8,8.5 Z" }, null, -1)
              ]), 8, Uj)
            ], 8, jj)
          ]))
        ])
      ], 544)
    ], 36)
  ]);
}
const Gj = /* @__PURE__ */ B(_j, [["render", qj], ["__scopeId", "data-v-19da20a5"]]), Kj = {
  name: "M3",
  mixins: [Rs, Et],
  emits: ["close-menu"],
  data() {
    return {
      sectionList: null,
      parentList: null,
      childList: null
    };
  },
  mounted() {
    this.$refs.mainmenu.focus();
  },
  methods: {
    handleTabOnCloseButton() {
      this.$refs.mainmenu.focus();
    },
    handleShiftTabOnCloseButton(e) {
      e === 0 && this.$refs["close-menu-button"].focus();
    },
    closeMenuIfOpen() {
      this.content.showMenu && !this.isPreview && this.$emit("close-menu");
    },
    setHoverColor(e, t) {
      this[e] = t;
    },
    removeHoverColor(e) {
      this[e] = null;
    }
  }
}, zj = { id: "m3" }, Zj = { class: "content" }, xj = { class: "static-links" }, Wj = ["onKeydown"], Yj = ["id", "target", "href"], Xj = ["innerHTML"], Qj = { class: "generated-links" }, Jj = ["onKeydown", "onMouseover"], eU = ["id", "aria-labelledby"], tU = ["onMouseover"], nU = ["onKeydown"], rU = ["tabindex", "onKeydown"], oU = ["id", "aria-expanded", "aria-controls", "aria-label", "onClick"], iU = ["id", "aria-labelledby"], sU = ["onMouseover"], aU = ["onKeydown"], lU = {
  class: "button-action-content",
  tabindex: "-1"
}, uU = {
  width: "30px",
  height: "30px",
  viewBox: "0 0 17 17",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}, dU = ["fill"], cU = ["fill"];
function hU(e, t, n, r, o, i) {
  const a = V("MenuElement"), s = ze("click-away");
  return d(), f("div", zj, [
    we((d(), f("div", {
      ref: "mainmenu",
      style: Z(`background: ${e.theme.bg_color.hex}; opacity: 0.96`),
      class: "menu-container",
      "aria-labelledby": "menubutton",
      "aria-modal": "true",
      tabindex: "0",
      onKeydown: t[9] || (t[9] = K(W((l) => e.$emit("close-menu"), ["exact", "prevent"]), ["esc"]))
    }, [
      c("div", {
        style: Z(`color: ${e.theme.text_color.hex || "#dddddd"};`),
        class: "heading"
      }, [
        c("h2", null, k(e.translations.title), 1)
      ], 4),
      c("div", Zj, [
        c("div", xj, [
          c("ul", null, [
            (d(!0), f(J, null, ne(e.content.customMenuItems, (l, u) => (d(), f("li", {
              key: l.id,
              onKeydown: [
                K(W((m) => i.handleShiftTabOnCloseButton(u), ["shift", "exact"]), ["tab"]),
                K(W((m) => e.clickStaticLink(e.getLink(l.url)), ["exact", "prevent"]), ["space"])
              ]
            }, [
              c("a", {
                id: l.id,
                style: Z(`color: ${e.theme.icon_text_color.hex};`),
                target: l.opens_in_new_tab ? "_blank" : "",
                href: e.getLink(l.url),
                onClick: t[0] || (t[0] = (m) => e.$emit("close-menu"))
              }, [
                c("div", null, [
                  c("div", {
                    class: _(["link-image", { "global-icon": l.cms_icon_id }]),
                    style: Z(`background: ${e.theme.icon_bg_color.hex};`)
                  }, [
                    c("div", {
                      class: "menu-item-icon",
                      style: Z(e.menuIconStyle),
                      "aria-hidden": "true",
                      innerHTML: l.cms_icon_id ? l.icon_cms : l.icon
                    }, null, 12, Xj)
                  ], 6),
                  c("span", {
                    style: Z(`color: ${e.theme.icon_text_color.hex};`)
                  }, k(l.name), 5)
                ])
              ], 12, Yj)
            ], 40, Wj))), 128))
          ])
        ]),
        c("div", Qj, [
          c("ul", null, [
            (d(!0), f(J, null, ne(e.content.sitemapMenuItems, (l, u) => (d(), f("li", {
              key: `section-${u}`
            }, [
              c("h2", {
                style: Z(
                  o.sectionList === l.id ? { color: e.theme.text_hover_color.hex } : { color: e.theme.text_color.hex }
                ),
                class: _({ "has-child": l.children.length }),
                onKeydown: [
                  K(W((m) => e.clickGeneratedLink(l, !1), ["exact", "prevent"]), ["enter"]),
                  K(W((m) => e.clickGeneratedLink(l, !1), ["exact", "prevent"]), ["space"])
                ],
                onMouseover: (m) => i.setHoverColor("sectionList", l.id),
                onMouseleave: t[2] || (t[2] = (m) => i.removeHoverColor("sectionList"))
              }, [
                j(a, {
                  id: `${l.slug || l.id}-${l.type}`,
                  element: l,
                  "path-prefix": e.content.pathPrefix,
                  "is-parent": "",
                  onRouterLinkClick: t[1] || (t[1] = (m) => e.$emit("close-menu"))
                }, null, 8, ["id", "element", "path-prefix"])
              ], 46, Jj),
              l.children.length ? (d(), f("ul", {
                key: 0,
                id: `${l.slug || l.id}-${u}-parent-list`,
                "aria-labelledby": `${l.slug || l.id}-${l.type}`
              }, [
                (d(!0), f(J, null, ne(l.children, (m, v) => (d(), f("li", {
                  key: `parent-${v}`,
                  style: Z(
                    o.parentList === m.id ? { color: e.theme.text_hover_color.hex } : { color: e.theme.text_color.hex }
                  ),
                  class: _({
                    "has-child": m.children.length,
                    open: e.activeIds.includes(m.id)
                  }),
                  onMouseover: (g) => i.setHoverColor("parentList", m.id),
                  onMouseleave: t[6] || (t[6] = (g) => i.removeHoverColor("parentList"))
                }, [
                  c("span", {
                    class: "parent-menu-element-wrapper",
                    onKeydown: [
                      K(W((g) => e.clickGeneratedLink(m, !0), ["exact", "prevent"]), ["enter"]),
                      K(W((g) => e.clickGeneratedLink(m, !0), ["exact", "prevent"]), ["space"])
                    ]
                  }, [
                    j(a, {
                      id: `${m.slug || m.id}-${m.type}`,
                      element: m,
                      "toggle-fn": e.toggleOpen,
                      "path-prefix": e.content.pathPrefix,
                      "is-sub-parent": "",
                      onRouterLinkClick: t[3] || (t[3] = (g) => e.$emit("close-menu"))
                    }, null, 8, ["id", "element", "toggle-fn", "path-prefix"])
                  ], 40, nU),
                  c("span", {
                    class: "arrow-box",
                    tabindex: m.children.length ? "0" : "-1",
                    onKeydown: [
                      K(W((g) => e.toggleOpen(m.id, !0), ["exact", "prevent"]), ["enter"]),
                      K(W((g) => e.toggleOpen(m.id, !0), ["exact", "prevent"]), ["space"])
                    ]
                  }, [
                    m.children.length ? (d(), f("span", {
                      key: 0,
                      id: `${m.slug || m.id}-${m.type}-parent-button`,
                      class: "parent-arrow",
                      role: "button",
                      tabindex: "-1",
                      "aria-expanded": !!e.activeIds.includes(m.id),
                      "aria-haspopup": !0,
                      "aria-controls": `${m.slug || m.id}-${v}-child-list`,
                      "aria-label": `Toggle Submenu for ${m.name}`,
                      onClick: (g) => e.toggleOpen(m.id, !0)
                    }, null, 8, oU)) : T("", !0)
                  ], 40, rU),
                  m.children.length ? (d(), f("ul", {
                    key: 0,
                    id: `${m.slug || m.id}-${v}-child-list`,
                    "aria-labelledby": `${m.slug || m.id}-${m.type}-parent-button`
                  }, [
                    (d(!0), f(J, null, ne(m.children, (g, h) => (d(), f("li", {
                      key: `child-${h}`,
                      style: Z(
                        o.childList === g.id ? { color: e.theme.text_hover_color.hex } : { color: e.theme.text_color.hex }
                      ),
                      onMouseover: (E) => i.setHoverColor("childList", g.id),
                      onMouseleave: t[5] || (t[5] = (E) => i.removeHoverColor("childList"))
                    }, [
                      c("span", {
                        class: "child-menu-element-wrapper",
                        onKeydown: [
                          K(W((E) => e.clickGeneratedLink(g, !1), ["exact", "prevent"]), ["enter"]),
                          K(W((E) => e.clickGeneratedLink(g, !1), ["exact", "prevent"]), ["space"])
                        ]
                      }, [
                        j(a, {
                          id: `${g.slug || g.id}-${g.type}`,
                          element: g,
                          "path-prefix": e.content.pathPrefix,
                          onRouterLinkClick: t[4] || (t[4] = (E) => e.$emit("close-menu"))
                        }, null, 8, ["id", "element", "path-prefix"])
                      ], 40, aU)
                    ], 44, sU))), 128))
                  ], 8, iU)) : T("", !0)
                ], 46, tU))), 128))
              ], 8, eU)) : T("", !0)
            ]))), 128))
          ])
        ])
      ]),
      c("button", {
        ref: "close-menu-button",
        class: "close-menu button-action",
        "aria-label": "close",
        onClick: t[7] || (t[7] = (l) => e.$emit("close-menu")),
        onKeydown: t[8] || (t[8] = K(W((...l) => i.handleTabOnCloseButton && i.handleTabOnCloseButton(...l), ["exact", "prevent"]), ["tab"]))
      }, [
        c("div", lU, [
          (d(), f("svg", uU, [
            c("g", {
              id: "Page-1",
              stroke: "none",
              "stroke-width": "1",
              fill: e.theme.text_color.hex,
              "fill-rule": "evenodd"
            }, [
              c("g", {
                id: "close_modal_icon",
                fill: e.theme.text_color.hex
              }, t[10] || (t[10] = [
                c("path", { d: "M6.8,8.5 L0.01,1.71 L1.71,0.01 L8.5,6.8 L15.29,0.01 L16.99,1.71 L10.2,8.5 L16.99,15.29 L15.29,16.99 L8.5,10.2 L1.71,16.99 L0.01,15.29 L6.8,8.5 Z" }, null, -1)
              ]), 8, cU)
            ], 8, dU)
          ]))
        ])
      ], 544)
    ], 36)), [
      [s, i.closeMenuIfOpen]
    ])
  ]);
}
const mU = /* @__PURE__ */ B(Kj, [["render", hU], ["__scopeId", "data-v-0342c808"]]), fU = {
  name: "CMSMenu",
  components: {
    M1: yj,
    M2: Gj,
    M3: mU
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      required: !0
    },
    isPreview: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["close-menu"],
  computed: {
    hasMenu() {
      return ["M1", "M2", "M3"].includes(this.theme.version);
    }
  }
}, pU = { id: "view-menu" };
function gU(e, t, n, r, o, i) {
  return i.hasMenu ? (d(), L(Y(n.content.showMenu ? "nav" : "div"), { key: 0 }, {
    default: S(() => [
      c("div", pU, [
        j(Le, {
          name: `${n.theme.version}-fade`
        }, {
          default: S(() => [
            n.content.showMenu ? (d(), L(Y(n.theme.version), {
              key: 0,
              theme: n.theme,
              content: n.content,
              "is-preview": n.isPreview,
              onCloseMenu: t[0] || (t[0] = (a) => e.$emit("close-menu"))
            }, null, 40, ["theme", "content", "is-preview"])) : T("", !0)
          ]),
          _: 1
        }, 8, ["name"])
      ])
    ]),
    _: 1
  })) : T("", !0);
}
const vU = /* @__PURE__ */ B(fU, [["render", gU], ["__scopeId", "data-v-4d1651d4"]]), bU = {
  name: "FooterHeader",
  props: {
    item: {
      type: Object,
      default: () => {
      }
    },
    theme: {
      type: Object,
      required: !0
    }
  }
};
function yU(e, t, n, r, o, i) {
  return d(), f("h2", {
    style: Z(`color: ${n.theme.heading_color.hex || "#cccccc"};`),
    class: _(n.theme.style === "light" ? "" : "bold")
  }, k(n.item.content), 7);
}
const J3 = /* @__PURE__ */ B(bU, [["render", yU]]), _U = {
  name: "FooterLink",
  props: {
    item: {
      type: Object,
      required: !0
    },
    theme: {
      type: Object,
      required: !0
    }
  },
  computed: {
    getReference() {
      return this.item.mailto ? `mailto:${this.item.email_address}` : this.item.url;
    },
    linkTarget() {
      return this.item.opens_in_new_tab ? "_blank" : "_self";
    }
  }
}, CU = ["href", "target"];
function wU(e, t, n, r, o, i) {
  return d(), f("a", {
    href: i.getReference,
    target: i.linkTarget,
    style: Z({ color: n.theme.text_link_color.hex, textDecoration: "none" })
  }, k(n.item.content), 13, CU);
}
const e8 = /* @__PURE__ */ B(_U, [["render", wU]]), TU = {
  name: "FooterTextField",
  props: {
    item: {
      type: Object,
      default: () => {
      }
    },
    theme: {
      type: Object,
      required: !0
    }
  }
};
function kU(e, t, n, r, o, i) {
  return d(), f("p", {
    style: Z(`color: ${n.theme.text_link_color.hex || "#cccccc"};`),
    class: "textfield"
  }, k(n.item.content), 5);
}
const t8 = /* @__PURE__ */ B(TU, [["render", kU]]), EU = {
  name: "FooterImage",
  props: {
    item: {
      type: Object,
      required: !0
    }
  },
  computed: {
    hasLink() {
      return this.item.action_on_click === "link";
    },
    opensInNewTab() {
      return this.item.open_in_new_tab ? "_blank" : "_self";
    },
    width() {
      return this.item.display === "percentage" ? `${this.item.set_ratio * 100}%` : `${this.item.preferred_width}px`;
    },
    height() {
      let e = `max-height: ${this.item.preferred_height}px`;
      return this.item.display === "percentage" && (e = "auto"), e;
    }
  }
}, SU = ["src", "alt"];
function MU(e, t, n, r, o, i) {
  return d(), f("div", {
    class: _([n.item.image_alignment, "image-container"])
  }, [
    (d(), L(Y(i.hasLink ? "a" : "div"), {
      style: Z({ width: i.width, height: i.height }),
      href: i.hasLink && n.item.link_url,
      target: i.hasLink && i.opensInNewTab,
      class: "image-wrapper"
    }, {
      default: S(() => [
        c("img", {
          src: n.item.url,
          alt: n.item.alt_text
        }, null, 8, SU)
      ]),
      _: 1
    }, 8, ["style", "href", "target"]))
  ], 2);
}
const n8 = /* @__PURE__ */ B(EU, [["render", MU], ["__scopeId", "data-v-37437fa5"]]), AU = /(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}/g, r0 = (e) => {
  if (typeof e != "string")
    throw new Error("Expected a string argument");
  return e.replace(AU, (n) => `<a href="tel:${n}" class="tel-link">${n}</a>`);
}, rh = {
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      default: () => ({})
    },
    organizations: {
      type: Array,
      required: !0
    },
    iosLink: {
      type: String,
      default: ""
    },
    androidLink: {
      type: String,
      default: ""
    },
    isPreview: {
      type: Boolean,
      default: !1
    },
    isIFrame: {
      type: Boolean,
      default: !1
    },
    currentDomain: {
      type: String,
      default: null
    },
    logo: {
      type: String,
      default: ""
    }
  },
  methods: {
    addTelLinksToPhoneNumbers: r0
  },
  computed: {
    logoImage() {
      return this.isPreview ? this.logo : this.content.logo.url;
    },
    logoWidth() {
      return this.content.logo.display === "percentage" ? `${this.content.logo.set_ratio * 100}%` : `${this.content.logo.preferred_width || 150}px`;
    },
    logoHeight() {
      return this.content.logo.display === "percentage" || !this.content.logo.preferred_height ? "100%" : `${this.content.logo.preferred_height}px`;
    },
    logoAlignment() {
      return $(this.content, "logo.image_alignment", "center");
    },
    imageWidth() {
      var e, t, n, r;
      return ((e = this.content.image) == null ? void 0 : e.display) === "percentage" ? `${((t = this.content.image) == null ? void 0 : t.set_ratio) * 100}%` : (n = this.content.image) != null && n.preferred_width ? `${(r = this.content.image) == null ? void 0 : r.preferred_width}px` : "100%";
    },
    imageHeight() {
      var e, t, n;
      return ((e = this.content.image) == null ? void 0 : e.display) === "percentage" || !((t = this.content.image) != null && t.preferred_height) ? "100%" : `${(n = this.content.image) == null ? void 0 : n.preferred_height}px`;
    },
    imageAlignment() {
      return $(this.content, "image.image_alignment", "center");
    },
    firstColumnHeader() {
      return this.content.columns[0].hasHeader || this.isPreview ? this.content.columns[0].header : !1;
    },
    info() {
      return this.content.organization_info;
    },
    currentYear() {
      return (/* @__PURE__ */ new Date()).getFullYear();
    },
    primaryOrg() {
      return this.organizations.filter((e) => e.primary);
    },
    copyrightOrg() {
      return this.organizations.length > 0 && !this.isIFrame ? this.primaryOrg[0].name : "School District";
    },
    translations() {
      return this.theme.translations;
    },
    cssVars() {
      return {
        "--bg-color": $(this.theme, "bg_color.hex", "#ffffff"),
        "--heading-color": $(this.theme, "heading_color.hex", "#cccccc"),
        "--link-color": $(this.theme, "text_link_color.hex", "#000000"),
        "--text-link-color": $(this.theme, "text_link_color.hex", "#000000"),
        "--logo-width": this.logoWidth,
        "--logo-height": this.logoHeight,
        "--logo-alignment": this.logoAlignment,
        "--image-width": this.imageWidth,
        "--image-height": this.imageHeight,
        "--image-alignment": this.imageAlignment
      };
    }
  }
}, r8 = "data:image/svg+xml,%3csvg%20width='135'%20height='40'%20viewBox='0%200%20135%2040'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M0%205C0%202.23858%202.23858%200%205%200H130C132.761%200%20135%202.23858%20135%205V35C135%2037.7614%20132.761%2040%20130%2040H5C2.23857%2040%200%2037.7614%200%2035V5Z'%20fill='black'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M130%201H5C2.79086%201%201%202.79086%201%205V35C1%2037.2091%202.79086%2039%205%2039H130C132.209%2039%20134%2037.2091%20134%2035V5C134%202.79086%20132.209%201%20130%201ZM5%200C2.23858%200%200%202.23858%200%205V35C0%2037.7614%202.23857%2040%205%2040H130C132.761%2040%20135%2037.7614%20135%2035V5C135%202.23858%20132.761%200%20130%200H5Z'%20fill='%23A6A6A6'/%3e%3cpath%20d='M81.5259%2019.2009V21.4919H80.0898V22.9944H81.5259V28.0994C81.5259%2029.8425%2082.3144%2030.5398%2084.2983%2030.5398C84.647%2030.5398%2084.979%2030.4983%2085.2695%2030.4485V28.9626C85.0205%2028.9875%2084.8628%2029.0041%2084.5889%2029.0041C83.7007%2029.0041%2083.3105%2028.5891%2083.3105%2027.6428V22.9944H85.2695V21.4919H83.3105V19.2009H81.5259Z'%20fill='white'/%3e%3cpath%20d='M90.3234%2030.6643C92.963%2030.6643%2094.5817%2028.8962%2094.5817%2025.9661C94.5817%2023.0525%2092.9547%2021.2761%2090.3234%2021.2761C87.6837%2021.2761%2086.0568%2023.0525%2086.0568%2025.9661C86.0568%2028.8962%2087.6754%2030.6643%2090.3234%2030.6643ZM90.3234%2029.0789C88.7711%2029.0789%2087.8995%2027.9416%2087.8995%2025.9661C87.8995%2024.0071%2088.7711%2022.8616%2090.3234%2022.8616C91.8673%2022.8616%2092.7472%2024.0071%2092.7472%2025.9661C92.7472%2027.9333%2091.8673%2029.0789%2090.3234%2029.0789Z'%20fill='white'/%3e%3cpath%20d='M95.9666%2030.49H97.7512V25.1526C97.7512%2023.8826%2098.7058%2023.0276%20100.059%2023.0276C100.374%2023.0276%20100.906%2023.0857%20101.055%2023.1355V21.3757C100.864%2021.3259%20100.524%2021.301%20100.258%2021.301C99.0794%2021.301%2098.075%2021.9485%2097.8176%2022.8367H97.6848V21.4504H95.9666V30.49Z'%20fill='white'/%3e%3cpath%20d='M105.486%2022.7952C106.806%2022.7952%20107.669%2023.7165%20107.711%2025.136H103.145C103.245%2023.7248%20104.166%2022.7952%20105.486%2022.7952ZM107.703%2028.0496C107.371%2028.7551%20106.632%2029.1453%20105.553%2029.1453C104.125%2029.1453%20103.204%2028.1409%20103.145%2026.5554V26.4558H109.529V25.8332C109.529%2022.9944%20108.01%2021.2761%20105.495%2021.2761C102.946%2021.2761%20101.328%2023.1106%20101.328%2025.9993C101.328%2028.8879%20102.913%2030.6643%20105.503%2030.6643C107.57%2030.6643%20109.014%2029.6682%20109.421%2028.0496H107.703Z'%20fill='white'/%3e%3cpath%20d='M69.8223%2027.1518C69.9599%2029.3715%2071.8097%2030.7911%2074.5628%2030.7911C77.5052%2030.7911%2079.3464%2029.3027%2079.3464%2026.9281C79.3464%2025.0612%2078.2967%2024.0287%2075.7501%2023.4351L74.3821%2023.0996C72.7647%2022.721%2072.1108%2022.2134%2072.1108%2021.3272C72.1108%2020.2088%2073.126%2019.4775%2074.6489%2019.4775C76.0942%2019.4775%2077.0923%2020.1916%2077.2729%2021.3358H79.1485C79.0366%2019.2452%2077.1955%2017.774%2074.6747%2017.774C71.9646%2017.774%2070.1578%2019.2452%2070.1578%2021.4563C70.1578%2023.2802%2071.1816%2024.3643%2073.4272%2024.8891L75.0274%2025.2763C76.6707%2025.6634%2077.3934%2026.2312%2077.3934%2027.1776C77.3934%2028.2789%2076.2577%2029.079%2074.7091%2029.079C73.0486%2029.079%2071.8957%2028.3305%2071.7323%2027.1518H69.8223Z'%20fill='white'/%3e%3cpath%20d='M51.3349%2021.301C50.1064%2021.301%2049.0439%2021.9153%2048.4961%2022.9446H48.3633V21.4504H46.645V33.4949H48.4297V29.1204H48.5708C49.0439%2030.0749%2050.0649%2030.6394%2051.3516%2030.6394C53.6343%2030.6394%2055.0869%2028.8381%2055.0869%2025.9661C55.0869%2023.094%2053.6343%2021.301%2051.3349%2021.301ZM50.8286%2029.0373C49.3345%2029.0373%2048.3965%2027.8586%2048.3965%2025.9744C48.3965%2024.0818%2049.3345%2022.9031%2050.8369%2022.9031C52.3476%2022.9031%2053.2524%2024.0569%2053.2524%2025.9661C53.2524%2027.8835%2052.3476%2029.0373%2050.8286%2029.0373Z'%20fill='white'/%3e%3cpath%20d='M61.3317%2021.301C60.1032%2021.301%2059.0407%2021.9153%2058.4929%2022.9446H58.3601V21.4504H56.6418V33.4949H58.4265V29.1204H58.5676C59.0407%2030.0749%2060.0617%2030.6394%2061.3483%2030.6394C63.6311%2030.6394%2065.0837%2028.8381%2065.0837%2025.9661C65.0837%2023.094%2063.6311%2021.301%2061.3317%2021.301ZM60.8254%2029.0373C59.3313%2029.0373%2058.3933%2027.8586%2058.3933%2025.9744C58.3933%2024.0818%2059.3313%2022.9031%2060.8337%2022.9031C62.3444%2022.9031%2063.2492%2024.0569%2063.2492%2025.9661C63.2492%2027.8835%2062.3444%2029.0373%2060.8254%2029.0373Z'%20fill='white'/%3e%3cpath%20d='M43.443%2030.49H45.4906L41.0082%2018.0751H38.9348L34.4523%2030.49H36.4311L37.5754%2027.1948H42.3073L43.443%2030.49ZM39.8725%2020.3292H40.0188L41.8169%2025.5774H38.0658L39.8725%2020.3292Z'%20fill='white'/%3e%3cpath%20d='M35.6511%208.71094V14.7H37.8135C39.5981%2014.7%2040.6316%2013.6001%2040.6316%2011.6868C40.6316%209.80249%2039.5898%208.71094%2037.8135%208.71094H35.6511ZM36.5808%209.55762H37.7097C38.9507%209.55762%2039.6853%2010.3462%2039.6853%2011.6992C39.6853%2013.073%2038.9631%2013.8533%2037.7097%2013.8533H36.5808V9.55762Z'%20fill='white'/%3e%3cpath%20d='M43.7967%2014.7871C45.1165%2014.7871%2045.9258%2013.9031%2045.9258%2012.438C45.9258%2010.9812%2045.1124%2010.093%2043.7967%2010.093C42.4769%2010.093%2041.6634%2010.9812%2041.6634%2012.438C41.6634%2013.9031%2042.4727%2014.7871%2043.7967%2014.7871ZM43.7967%2013.9944C43.0206%2013.9944%2042.5848%2013.4258%2042.5848%2012.438C42.5848%2011.4585%2043.0206%2010.8857%2043.7967%2010.8857C44.5687%2010.8857%2045.0086%2011.4585%2045.0086%2012.438C45.0086%2013.4216%2044.5687%2013.9944%2043.7967%2013.9944Z'%20fill='white'/%3e%3cpath%20d='M52.818%2010.1802H51.9256L51.1205%2013.6292H51.0499L50.1202%2010.1802H49.2652L48.3355%2013.6292H48.2691L47.4598%2010.1802H46.555L47.8001%2014.7H48.7174L49.6471%2011.3713H49.7176L50.6515%2014.7H51.577L52.818%2010.1802Z'%20fill='white'/%3e%3cpath%20d='M53.8456%2014.7H54.7379V12.0562C54.7379%2011.3506%2055.1571%2010.9106%2055.817%2010.9106C56.477%2010.9106%2056.7924%2011.2717%2056.7924%2011.998V14.7H57.6847V11.7739C57.6847%2010.699%2057.1286%2010.093%2056.12%2010.093C55.4394%2010.093%2054.9911%2010.396%2054.7711%2010.8982H54.7047V10.1802H53.8456V14.7Z'%20fill='white'/%3e%3cpath%20d='M59.09%2014.7H59.9824V8.41626H59.09V14.7Z'%20fill='white'/%3e%3cpath%20d='M63.3384%2014.7871C64.6582%2014.7871%2065.4675%2013.9031%2065.4675%2012.438C65.4675%2010.9812%2064.6541%2010.093%2063.3384%2010.093C62.0186%2010.093%2061.2051%2010.9812%2061.2051%2012.438C61.2051%2013.9031%2062.0144%2014.7871%2063.3384%2014.7871ZM63.3384%2013.9944C62.5623%2013.9944%2062.1265%2013.4258%2062.1265%2012.438C62.1265%2011.4585%2062.5623%2010.8857%2063.3384%2010.8857C64.1104%2010.8857%2064.5503%2011.4585%2064.5503%2012.438C64.5503%2013.4216%2064.1104%2013.9944%2063.3384%2013.9944Z'%20fill='white'/%3e%3cpath%20d='M68.1263%2014.0234C67.6407%2014.0234%2067.2879%2013.7869%2067.2879%2013.3801C67.2879%2012.9817%2067.5701%2012.77%2068.1927%2012.7285L69.2967%2012.658V13.0356C69.2967%2013.5959%2068.7986%2014.0234%2068.1263%2014.0234ZM67.898%2014.7747C68.4915%2014.7747%2068.9854%2014.5173%2069.2552%2014.0649H69.3257V14.7H70.1849V11.6121C70.1849%2010.6575%2069.5457%2010.093%2068.4126%2010.093C67.3875%2010.093%2066.657%2010.5911%2066.5657%2011.3672H67.429C67.5286%2011.0476%2067.8731%2010.865%2068.3711%2010.865C68.9812%2010.865%2069.2967%2011.1348%2069.2967%2011.6121V12.0022L68.0723%2012.0728C66.9974%2012.1392%2066.3914%2012.6082%2066.3914%2013.4216C66.3914%2014.2476%2067.0264%2014.7747%2067.898%2014.7747Z'%20fill='white'/%3e%3cpath%20d='M73.213%2014.7747C73.8355%2014.7747%2074.3626%2014.48%2074.6324%2013.9861H74.703V14.7H75.558V8.41626H74.6656V10.8982H74.5992C74.3543%2010.4001%2073.8314%2010.1055%2073.213%2010.1055C72.0716%2010.1055%2071.337%2011.0103%2071.337%2012.438C71.337%2013.8699%2072.0633%2014.7747%2073.213%2014.7747ZM73.4662%2010.9065C74.2132%2010.9065%2074.6822%2011.5%2074.6822%2012.4421C74.6822%2013.3884%2074.2174%2013.9736%2073.4662%2013.9736C72.7108%2013.9736%2072.2584%2013.3967%2072.2584%2012.438C72.2584%2011.4875%2072.7149%2010.9065%2073.4662%2010.9065Z'%20fill='white'/%3e%3cpath%20d='M81.3444%2014.7871C82.6643%2014.7871%2083.4736%2013.9031%2083.4736%2012.438C83.4736%2010.9812%2082.6601%2010.093%2081.3444%2010.093C80.0246%2010.093%2079.2111%2010.9812%2079.2111%2012.438C79.2111%2013.9031%2080.0205%2014.7871%2081.3444%2014.7871ZM81.3444%2013.9944C80.5683%2013.9944%2080.1325%2013.4258%2080.1325%2012.438C80.1325%2011.4585%2080.5683%2010.8857%2081.3444%2010.8857C82.1164%2010.8857%2082.5563%2011.4585%2082.5563%2012.438C82.5563%2013.4216%2082.1164%2013.9944%2081.3444%2013.9944Z'%20fill='white'/%3e%3cpath%20d='M84.6548%2014.7H85.5471V12.0562C85.5471%2011.3506%2085.9663%2010.9106%2086.6262%2010.9106C87.2861%2010.9106%2087.6016%2011.2717%2087.6016%2011.998V14.7H88.4939V11.7739C88.4939%2010.699%2087.9377%2010.093%2086.9292%2010.093C86.2485%2010.093%2085.8003%2010.396%2085.5803%2010.8982H85.5139V10.1802H84.6548V14.7Z'%20fill='white'/%3e%3cpath%20d='M92.6036%209.05542V10.2009H91.8856V10.9521H92.6036V13.5046C92.6036%2014.3762%2092.9979%2014.7249%2093.9898%2014.7249C94.1642%2014.7249%2094.3302%2014.7041%2094.4754%2014.6792V13.9363C94.3509%2013.9487%2094.2721%2013.957%2094.1351%2013.957C93.691%2013.957%2093.4959%2013.7495%2093.4959%2013.2764V10.9521H94.4754V10.2009H93.4959V9.05542H92.6036Z'%20fill='white'/%3e%3cpath%20d='M95.6732%2014.7H96.5656V12.0603C96.5656%2011.3755%2096.9723%2010.9148%2097.7028%2010.9148C98.3336%2010.9148%2098.6698%2011.28%2098.6698%2012.0022V14.7H99.5622V11.7822C99.5622%2010.7073%2098.9687%2010.0972%2098.0058%2010.0972C97.3251%2010.0972%2096.8478%2010.4001%2096.6278%2010.9065H96.5573V8.41626H95.6732V14.7Z'%20fill='white'/%3e%3cpath%20d='M102.781%2010.8525C103.441%2010.8525%20103.873%2011.3132%20103.894%2012.0229H101.611C101.661%2011.3174%20102.121%2010.8525%20102.781%2010.8525ZM103.889%2013.4797C103.723%2013.8325%20103.354%2014.0276%20102.814%2014.0276C102.101%2014.0276%20101.64%2013.5254%20101.611%2012.7327V12.6829H104.802V12.3716C104.802%2010.9521%20104.043%2010.093%20102.785%2010.093C101.511%2010.093%20100.702%2011.0103%20100.702%2012.4546C100.702%2013.8989%20101.495%2014.7871%20102.789%2014.7871C103.823%2014.7871%20104.545%2014.2891%20104.748%2013.4797H103.889Z'%20fill='white'/%3e%3cpath%20d='M24.769%2020.3008C24.7907%2018.6198%2025.6934%2017.0292%2027.1256%2016.1488C26.2221%2014.8584%2024.7088%2014.0403%2023.1344%2013.9911C21.4552%2013.8148%2019.8272%2014.9959%2018.9715%2014.9959C18.0992%2014.9959%2016.7817%2014.0086%2015.363%2014.0378C13.5137%2014.0975%2011.7898%2015.1489%2010.8901%2016.7656C8.95607%2020.1141%2010.3987%2025.0351%2012.2513%2027.7417C13.1782%2029.0671%2014.2615%2030.5475%2015.6789%2030.495C17.066%2030.4375%2017.584%2029.6105%2019.2583%2029.6105C20.9171%2029.6105%2021.4031%2030.495%2022.8493%2030.4616C24.3377%2030.4375%2025.2754%2029.1304%2026.1698%2027.7925C26.8358%2026.8481%2027.3483%2025.8044%2027.6882%2024.7C25.9391%2023.9602%2024.771%2022.2%2024.769%2020.3008Z'%20fill='white'/%3e%3cpath%20d='M22.0373%2012.2111C22.8489%2011.2369%2023.2487%209.98469%2023.1518%208.72046C21.912%208.85068%2020.7668%209.44324%2019.9443%2010.3801C19.14%2011.2954%2018.7214%2012.5255%2018.8006%2013.7415C20.0408%2013.7542%2021.2601%2013.1777%2022.0373%2012.2111Z'%20fill='white'/%3e%3c/svg%3e", o8 = "data:image/svg+xml,%3csvg%20width='135'%20height='40'%20viewBox='0%200%20135%2040'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M0%205C0%202.23858%202.23858%200%205%200H130C132.761%200%20135%202.23858%20135%205V35C135%2037.7614%20132.761%2040%20130%2040H5C2.23857%2040%200%2037.7614%200%2035V5Z'%20fill='black'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M130%201H5C2.79086%201%201%202.79086%201%205V35C1%2037.2091%202.79086%2039%205%2039H130C132.209%2039%20134%2037.2091%20134%2035V5C134%202.79086%20132.209%201%20130%201ZM5%200C2.23858%200%200%202.23858%200%205V35C0%2037.7614%202.23857%2040%205%2040H130C132.761%2040%20135%2037.7614%20135%2035V5C135%202.23858%20132.761%200%20130%200H5Z'%20fill='%23A6A6A6'/%3e%3cpath%20d='M68.136%2020.8861C65.784%2020.8861%2063.867%2022.6751%2063.867%2025.1391C63.867%2027.5881%2065.784%2029.3921%2068.136%2029.3921C70.489%2029.3921%2072.406%2027.5881%2072.406%2025.1391C72.405%2022.6751%2070.488%2020.8861%2068.136%2020.8861ZM68.136%2027.7181C66.847%2027.7181%2065.736%2026.6551%2065.736%2025.1401C65.736%2023.6091%2066.848%2022.5621%2068.136%2022.5621C69.425%2022.5621%2070.536%2023.6091%2070.536%2025.1401C70.536%2026.6541%2069.425%2027.7181%2068.136%2027.7181ZM58.822%2020.8861C56.47%2020.8861%2054.553%2022.6751%2054.553%2025.1391C54.553%2027.5881%2056.47%2029.3921%2058.822%2029.3921C61.175%2029.3921%2063.092%2027.5881%2063.092%2025.1391C63.092%2022.6751%2061.175%2020.8861%2058.822%2020.8861ZM58.822%2027.7181C57.533%2027.7181%2056.422%2026.6551%2056.422%2025.1401C56.422%2023.6091%2057.534%2022.5621%2058.822%2022.5621C60.111%2022.5621%2061.222%2023.6091%2061.222%2025.1401C61.223%2026.6541%2060.111%2027.7181%2058.822%2027.7181ZM47.744%2022.1921V23.9961H52.062C51.933%2025.0111%2051.595%2025.7521%2051.079%2026.2671C50.451%2026.8951%2049.468%2027.5881%2047.744%2027.5881C45.086%2027.5881%2043.008%2025.4451%2043.008%2022.7871C43.008%2020.1291%2045.086%2017.9861%2047.744%2017.9861C49.178%2017.9861%2050.225%2018.5501%2050.998%2019.2751L52.271%2018.0021C51.191%2016.9711%2049.758%2016.1821%2047.744%2016.1821C44.103%2016.1821%2041.042%2019.1461%2041.042%2022.7871C41.042%2026.4281%2044.103%2029.3921%2047.744%2029.3921C49.709%2029.3921%2051.192%2028.7471%2052.351%2027.5391C53.543%2026.3471%2053.914%2024.6711%2053.914%2023.3181C53.914%2022.9001%2053.882%2022.5131%2053.817%2022.1911H47.744V22.1921ZM93.052%2023.5931C92.698%2022.6431%2091.618%2020.8861%2089.411%2020.8861C87.22%2020.8861%2085.399%2022.6101%2085.399%2025.1391C85.399%2027.5231%2087.204%2029.3921%2089.62%2029.3921C91.569%2029.3921%2092.697%2028.2001%2093.165%2027.5071L91.715%2026.5401C91.232%2027.2491%2090.571%2027.7161%2089.62%2027.7161C88.67%2027.7161%2087.993%2027.2811%2087.558%2026.4271L93.245%2024.0751L93.052%2023.5931ZM87.252%2025.0111C87.204%2023.3671%2088.525%2022.5301%2089.476%2022.5301C90.217%2022.5301%2090.845%2022.9011%2091.055%2023.4321L87.252%2025.0111ZM82.629%2029.1351H84.497V16.6341H82.629V29.1351ZM79.567%2021.8371H79.503C79.084%2021.3371%2078.278%2020.8861%2077.264%2020.8861C75.137%2020.8861%2073.188%2022.7551%2073.188%2025.1561C73.188%2027.5401%2075.137%2029.3931%2077.264%2029.3931C78.279%2029.3931%2079.084%2028.9421%2079.503%2028.4271H79.567V29.0391C79.567%2030.6661%2078.697%2031.5361%2077.296%2031.5361C76.152%2031.5361%2075.443%2030.7151%2075.153%2030.0221L73.526%2030.6991C73.993%2031.8261%2075.233%2033.2121%2077.296%2033.2121C79.487%2033.2121%2081.34%2031.9231%2081.34%2028.7811V21.1451H79.568V21.8371H79.567ZM77.425%2027.7181C76.136%2027.7181%2075.057%2026.6381%2075.057%2025.1561C75.057%2023.6571%2076.136%2022.5621%2077.425%2022.5621C78.697%2022.5621%2079.696%2023.6571%2079.696%2025.1561C79.696%2026.6381%2078.697%2027.7181%2077.425%2027.7181ZM101.806%2016.6341H97.335V29.1351H99.2V24.3991H101.805C103.873%2024.3991%20105.907%2022.9021%20105.907%2020.5171C105.907%2018.1321%20103.874%2016.6341%20101.806%2016.6341ZM101.854%2022.6591H99.2V18.3741H101.854C103.249%2018.3741%20104.041%2019.5291%20104.041%2020.5171C104.041%2021.4851%20103.249%2022.6591%20101.854%2022.6591ZM113.386%2020.8641C112.035%2020.8641%20110.636%2021.4591%20110.057%2022.7781L111.713%2023.4691C112.067%2022.7781%20112.727%2022.5521%20113.418%2022.5521C114.383%2022.5521%20115.364%2023.1311%20115.38%2024.1601V24.2891C115.042%2024.0961%20114.318%2023.8071%20113.434%2023.8071C111.649%2023.8071%20109.831%2024.7881%20109.831%2026.6211C109.831%2028.2941%20111.295%2029.3711%20112.935%2029.3711C114.189%2029.3711%20114.881%2028.8081%20115.315%2028.1481H115.379V29.1131H117.181V24.3201C117.182%2022.1021%20115.524%2020.8641%20113.386%2020.8641ZM113.16%2027.7151C112.55%2027.7151%20111.697%2027.4091%20111.697%2026.6531C111.697%2025.6881%20112.759%2025.3181%20113.676%2025.3181C114.495%2025.3181%20114.882%2025.4951%20115.38%2025.7361C115.235%2026.8951%20114.238%2027.7151%20113.16%2027.7151ZM123.743%2021.1371L121.604%2026.5571H121.54L119.32%2021.1371H117.31L120.639%2028.7121L118.741%2032.9261H120.687L125.818%2021.1371H123.743ZM106.937%2029.1351H108.802V16.6341H106.937V29.1351Z'%20fill='white'/%3e%3cpath%20d='M47.418%209.37795C47.418%2010.216%2047.17%2010.883%2046.673%2011.381C46.109%2011.973%2045.3731%2012.269%2044.4691%2012.269C43.6031%2012.269%2042.8661%2011.969%2042.2611%2011.369C41.6551%2010.768%2041.3521%2010.024%2041.3521%209.13595C41.3521%208.24695%2041.6551%207.50295%2042.2611%206.90295C42.8661%206.30195%2043.6031%206.00195%2044.4691%206.00195C44.8991%206.00195%2045.3101%206.08595%2045.7001%206.25295C46.0911%206.42095%2046.4041%206.64395%2046.6381%206.92295L46.111%207.45095C45.714%206.97595%2045.167%206.73895%2044.468%206.73895C43.836%206.73895%2043.29%206.96095%2042.829%207.40495C42.368%207.84895%2042.1381%208.42595%2042.1381%209.13495C42.1381%209.84395%2042.368%2010.421%2042.829%2010.865C43.29%2011.309%2043.836%2011.531%2044.468%2011.531C45.138%2011.531%2045.6971%2011.308%2046.1441%2010.861C46.4341%2010.57%2046.602%2010.165%2046.647%209.64595H44.468V8.92495H47.375C47.405%209.08195%2047.418%209.23295%2047.418%209.37795Z'%20fill='white'/%3e%3cpath%20d='M52.0281%206.87201H49.2961V8.77401H51.7601V9.49501H49.2961V11.397H52.0281V12.135H48.5251V6.13501H52.0281V6.87201Z'%20fill='white'/%3e%3cpath%20d='M55.279%2012.135H54.508V6.87201H52.832V6.13501H56.955V6.87201H55.279V12.135Z'%20fill='white'/%3e%3cpath%20d='M59.938%2012.135V6.13501H60.709V12.135H59.938Z'%20fill='white'/%3e%3cpath%20d='M64.1281%2012.135H63.3572V6.87201H61.6812V6.13501H65.8042V6.87201H64.1281V12.135Z'%20fill='white'/%3e%3cpath%20d='M73.6089%2011.36C73.0189%2011.966%2072.2859%2012.269%2071.4089%2012.269C70.5319%2012.269%2069.7989%2011.966%2069.2099%2011.36C68.6199%2010.754%2068.3259%2010.012%2068.3259%209.135C68.3259%208.258%2068.6199%207.516%2069.2099%206.91C69.7989%206.304%2070.5319%206%2071.4089%206C72.2809%206%2073.0129%206.305%2073.6049%206.914C74.1969%207.523%2074.4929%208.263%2074.4929%209.135C74.4929%2010.012%2074.1979%2010.754%2073.6089%2011.36ZM69.7789%2010.857C70.2229%2011.307%2070.7659%2011.531%2071.4089%2011.531C72.0519%2011.531%2072.5959%2011.306%2073.0389%2010.857C73.4829%2010.407%2073.7059%209.833%2073.7059%209.135C73.7059%208.437%2073.4829%207.863%2073.0389%207.413C72.5959%206.963%2072.0519%206.739%2071.4089%206.739C70.7659%206.739%2070.2229%206.964%2069.7789%207.413C69.3359%207.863%2069.1129%208.437%2069.1129%209.135C69.1129%209.833%2069.3359%2010.407%2069.7789%2010.857Z'%20fill='white'/%3e%3cpath%20d='M75.5749%2012.135V6.13501H76.513L79.429%2010.802H79.4619L79.429%209.64601V6.13501H80.1999V12.135H79.3949L76.344%207.24101H76.3109L76.344%208.39701V12.135H75.5749Z'%20fill='white'/%3e%3cpath%20d='M47.418%209.37795C47.418%2010.216%2047.17%2010.883%2046.673%2011.381C46.109%2011.973%2045.3731%2012.269%2044.4691%2012.269C43.6031%2012.269%2042.8661%2011.969%2042.2611%2011.369C41.6551%2010.768%2041.3521%2010.024%2041.3521%209.13595C41.3521%208.24695%2041.6551%207.50295%2042.2611%206.90295C42.8661%206.30195%2043.6031%206.00195%2044.4691%206.00195C44.8991%206.00195%2045.3101%206.08595%2045.7001%206.25295C46.0911%206.42095%2046.4041%206.64395%2046.6381%206.92295L46.111%207.45095C45.714%206.97595%2045.167%206.73895%2044.468%206.73895C43.836%206.73895%2043.29%206.96095%2042.829%207.40495C42.368%207.84895%2042.1381%208.42595%2042.1381%209.13495C42.1381%209.84395%2042.368%2010.421%2042.829%2010.865C43.29%2011.309%2043.836%2011.531%2044.468%2011.531C45.138%2011.531%2045.6971%2011.308%2046.1441%2010.861C46.4341%2010.57%2046.602%2010.165%2046.647%209.64595H44.468V8.92495H47.375C47.405%209.08195%2047.418%209.23295%2047.418%209.37795Z'%20stroke='white'%20stroke-width='0.2'%20stroke-miterlimit='10'/%3e%3cpath%20d='M52.0281%206.87201H49.2961V8.77401H51.7601V9.49501H49.2961V11.397H52.0281V12.135H48.5251V6.13501H52.0281V6.87201Z'%20stroke='white'%20stroke-width='0.2'%20stroke-miterlimit='10'/%3e%3cpath%20d='M55.279%2012.135H54.508V6.87201H52.832V6.13501H56.955V6.87201H55.279V12.135Z'%20stroke='white'%20stroke-width='0.2'%20stroke-miterlimit='10'/%3e%3cpath%20d='M59.938%2012.135V6.13501H60.709V12.135H59.938Z'%20stroke='white'%20stroke-width='0.2'%20stroke-miterlimit='10'/%3e%3cpath%20d='M64.1281%2012.135H63.3572V6.87201H61.6812V6.13501H65.8042V6.87201H64.1281V12.135Z'%20stroke='white'%20stroke-width='0.2'%20stroke-miterlimit='10'/%3e%3cpath%20d='M73.6089%2011.36C73.0189%2011.966%2072.2859%2012.269%2071.4089%2012.269C70.5319%2012.269%2069.7989%2011.966%2069.2099%2011.36C68.6199%2010.754%2068.3259%2010.012%2068.3259%209.135C68.3259%208.258%2068.6199%207.516%2069.2099%206.91C69.7989%206.304%2070.5319%206%2071.4089%206C72.2809%206%2073.0129%206.305%2073.6049%206.914C74.1969%207.523%2074.4929%208.263%2074.4929%209.135C74.4929%2010.012%2074.1979%2010.754%2073.6089%2011.36ZM69.7789%2010.857C70.2229%2011.307%2070.7659%2011.531%2071.4089%2011.531C72.0519%2011.531%2072.5959%2011.306%2073.0389%2010.857C73.4829%2010.407%2073.7059%209.833%2073.7059%209.135C73.7059%208.437%2073.4829%207.863%2073.0389%207.413C72.5959%206.963%2072.0519%206.739%2071.4089%206.739C70.7659%206.739%2070.2229%206.964%2069.7789%207.413C69.3359%207.863%2069.1129%208.437%2069.1129%209.135C69.1129%209.833%2069.3359%2010.407%2069.7789%2010.857Z'%20stroke='white'%20stroke-width='0.2'%20stroke-miterlimit='10'/%3e%3cpath%20d='M75.5749%2012.135V6.13501H76.513L79.429%2010.802H79.4619L79.429%209.64601V6.13501H80.1999V12.135H79.3949L76.344%207.24101H76.3109L76.344%208.39701V12.135H75.5749Z'%20stroke='white'%20stroke-width='0.2'%20stroke-miterlimit='10'/%3e%3cg%20filter='url(%23filter0_ii)'%3e%3cpath%20d='M10.436%206.67302C10.145%206.98102%209.97302%207.45902%209.97302%208.07802V30.194C9.97302%2030.814%2010.145%2031.291%2010.436%2031.599L10.51%2031.671L22.899%2019.282V19.136V18.99L10.51%206.60002L10.436%206.67302Z'%20fill='url(%23paint0_linear)'/%3e%3cpath%20d='M27.028%2023.413L22.899%2019.282V19.136V18.99L27.029%2014.86L27.122%2014.913L32.015%2017.693C33.412%2018.487%2033.412%2019.786%2032.015%2020.581L27.122%2023.361L27.028%2023.413Z'%20fill='url(%23paint1_linear)'/%3e%3cg%20filter='url(%23filter1_i)'%3e%3cpath%20d='M27.122%2023.36L22.898%2019.136L10.436%2031.599C10.896%2032.087%2011.657%2032.147%2012.514%2031.661L27.122%2023.36Z'%20fill='url(%23paint2_linear)'/%3e%3c/g%3e%3cpath%20d='M27.122%2014.912L12.514%206.61202C11.657%206.12502%2010.896%206.18602%2010.436%206.67402L22.899%2019.137L27.122%2014.912Z'%20fill='url(%23paint3_linear)'/%3e%3c/g%3e%3cdefs%3e%3cfilter%20id='filter0_ii'%20x='9.97302'%20y='6.27594'%20width='23.0898'%20height='25.7208'%20filterUnits='userSpaceOnUse'%20color-interpolation-filters='sRGB'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'/%3e%3cfeBlend%20mode='normal'%20in='SourceGraphic'%20in2='BackgroundImageFix'%20result='shape'/%3e%3cfeColorMatrix%20in='SourceAlpha'%20type='matrix'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%20127%200'%20result='hardAlpha'/%3e%3cfeOffset%20dy='-0.15'/%3e%3cfeComposite%20in2='hardAlpha'%20operator='arithmetic'%20k2='-1'%20k3='1'/%3e%3cfeColorMatrix%20type='matrix'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200.12%200'/%3e%3cfeBlend%20mode='normal'%20in2='shape'%20result='effect1_innerShadow'/%3e%3cfeColorMatrix%20in='SourceAlpha'%20type='matrix'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%20127%200'%20result='hardAlpha'/%3e%3cfeOffset%20dy='0.15'/%3e%3cfeComposite%20in2='hardAlpha'%20operator='arithmetic'%20k2='-1'%20k3='1'/%3e%3cfeColorMatrix%20type='matrix'%20values='0%200%200%200%201%200%200%200%200%201%200%200%200%200%201%200%200%200%200.25%200'/%3e%3cfeBlend%20mode='normal'%20in2='effect1_innerShadow'%20result='effect2_innerShadow'/%3e%3c/filter%3e%3cfilter%20id='filter1_i'%20x='10.436'%20y='19.136'%20width='16.686'%20height='12.8607'%20filterUnits='userSpaceOnUse'%20color-interpolation-filters='sRGB'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'/%3e%3cfeBlend%20mode='normal'%20in='SourceGraphic'%20in2='BackgroundImageFix'%20result='shape'/%3e%3cfeColorMatrix%20in='SourceAlpha'%20type='matrix'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%20127%200'%20result='hardAlpha'/%3e%3cfeOffset%20dy='-0.15'/%3e%3cfeComposite%20in2='hardAlpha'%20operator='arithmetic'%20k2='-1'%20k3='1'/%3e%3cfeColorMatrix%20type='matrix'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200.08%200'/%3e%3cfeBlend%20mode='normal'%20in2='shape'%20result='effect1_innerShadow'/%3e%3c/filter%3e%3clinearGradient%20id='paint0_linear'%20x1='21.8008'%20y1='7.84402'%20x2='5.01882'%20y2='24.626'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%2300A0FF'/%3e%3cstop%20offset='0.0066'%20stop-color='%2300A1FF'/%3e%3cstop%20offset='0.2601'%20stop-color='%2300BEFF'/%3e%3cstop%20offset='0.5122'%20stop-color='%2300D2FF'/%3e%3cstop%20offset='0.7604'%20stop-color='%2300DFFF'/%3e%3cstop%20offset='1'%20stop-color='%2300E3FF'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint1_linear'%20x1='33.8335'%20y1='19.136'%20x2='9.63765'%20y2='19.136'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23FFE000'/%3e%3cstop%20offset='0.4087'%20stop-color='%23FFBD00'/%3e%3cstop%20offset='0.7754'%20stop-color='%23FFA500'/%3e%3cstop%20offset='1'%20stop-color='%23FF9C00'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint2_linear'%20x1='24.8281'%20y1='21.4299'%20x2='2.06964'%20y2='44.1884'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23FF3A44'/%3e%3cstop%20offset='1'%20stop-color='%23C31162'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint3_linear'%20x1='7.29743'%20y1='-0.688184'%20x2='17.4597'%20y2='9.47412'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%2332A071'/%3e%3cstop%20offset='0.0685'%20stop-color='%232DA771'/%3e%3cstop%20offset='0.4762'%20stop-color='%2315CF74'/%3e%3cstop%20offset='0.8009'%20stop-color='%2306E775'/%3e%3cstop%20offset='1'%20stop-color='%2300F076'/%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e", i8 = "data:image/svg+xml,%3csvg%20width='32'%20height='32'%20viewBox='0%200%2032%2032'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20width='32'%20height='32'%20rx='2'%20fill='%233B5998'/%3e%3cpath%20d='M24.625%206.625H7.375C6.96016%206.625%206.625%206.96016%206.625%207.375V24.625C6.625%2025.0398%206.96016%2025.375%207.375%2025.375H24.625C25.0398%2025.375%2025.375%2025.0398%2025.375%2024.625V7.375C25.375%206.96016%2025.0398%206.625%2024.625%206.625ZM22.4594%2012.0977H20.9617C19.7875%2012.0977%2019.5602%2012.6555%2019.5602%2013.4758V15.2828H22.3633L21.9977%2018.1117H19.5602V25.375H16.6375V18.1141H14.193V15.2828H16.6375V13.1969C16.6375%2010.7758%2018.1164%209.45625%2020.2773%209.45625C21.3133%209.45625%2022.2016%209.53359%2022.4617%209.56875V12.0977H22.4594Z'%20fill='white'/%3e%3c/svg%3e", s8 = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='utf-8'?%3e%3c!--%20Generator:%20Adobe%20Illustrator%2028.0.0,%20SVG%20Export%20Plug-In%20.%20SVG%20Version:%206.00%20Build%200)%20--%3e%3csvg%20version='1.1'%20id='Layer_1'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20x='0px'%20y='0px'%20viewBox='0%200%2032%2032'%20style='enable-background:new%200%200%2032%2032;'%20xml:space='preserve'%3e%3cstyle%20type='text/css'%3e%20.st0{fill:%23231F20;}%20.st1{fill:%23FFFFFF;}%20%3c/style%3e%3cpath%20class='st0'%20d='M2,0h28c1.1,0,2,0.9,2,2v28c0,1.1-0.9,2-2,2H2c-1.1,0-2-0.9-2-2V2C0,0.9,0.9,0,2,0z'/%3e%3cpath%20class='st1'%20d='M17.6,14.7L24,7.2h-1.5L17,13.7l-4.4-6.5H7.4l6.7,9.8l-6.7,7.8h1.5l5.9-6.8l4.7,6.8h5.1L17.6,14.7L17.6,14.7z%20M15.6,17.1l-0.7-1L9.5,8.3h2.3l4.4,6.3l0.7,1l5.7,8.1h-2.3L15.6,17.1L15.6,17.1z'/%3e%3c/svg%3e", a8 = "data:image/svg+xml,%3csvg%20width='32'%20height='32'%20viewBox='0%200%2032%2032'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20width='32'%20height='32'%20rx='2'%20fill='%23FF0000'/%3e%3cpath%20d='M26.0617%2010.9398C25.9422%2010.4946%2025.7078%2010.0886%2025.382%209.76243C25.0563%209.43625%2024.6505%209.20136%2024.2055%209.08125C22.5672%208.64063%2016%208.64062%2016%208.64062C16%208.64062%209.43281%208.64062%207.79453%209.07891C7.34927%209.19862%206.94334%209.43339%206.61751%209.75962C6.29169%2010.0859%206.05744%2010.4921%205.93828%2010.9375C5.5%2012.5781%205.5%2016%205.5%2016C5.5%2016%205.5%2019.4219%205.93828%2021.0602C6.17969%2021.9648%206.89219%2022.6773%207.79453%2022.9188C9.43281%2023.3594%2016%2023.3594%2016%2023.3594C16%2023.3594%2022.5672%2023.3594%2024.2055%2022.9188C25.1102%2022.6773%2025.8203%2021.9648%2026.0617%2021.0602C26.5%2019.4219%2026.5%2016%2026.5%2016C26.5%2016%2026.5%2012.5781%2026.0617%2010.9398ZM13.9141%2019.1406V12.8594L19.3516%2015.9766L13.9141%2019.1406Z'%20fill='white'/%3e%3c/svg%3e", l8 = "data:image/svg+xml,%3csvg%20width='32'%20height='32'%20viewBox='0%200%2032%2032'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20width='32'%20height='32'%20rx='2'%20fill='%23E5017B'/%3e%3cpath%20d='M16%2011.193C13.3398%2011.193%2011.193%2013.3398%2011.193%2016C11.193%2018.6602%2013.3398%2020.807%2016%2020.807C18.6601%2020.807%2020.807%2018.6602%2020.807%2016C20.807%2013.3398%2018.6601%2011.193%2016%2011.193ZM16%2019.1242C14.2797%2019.1242%2012.8758%2017.7203%2012.8758%2016C12.8758%2014.2797%2014.2797%2012.8758%2016%2012.8758C17.7203%2012.8758%2019.1242%2014.2797%2019.1242%2016C19.1242%2017.7203%2017.7203%2019.1242%2016%2019.1242ZM21.0039%209.87578C20.3828%209.87578%2019.8812%2010.3773%2019.8812%2010.9984C19.8812%2011.6195%2020.3828%2012.1211%2021.0039%2012.1211C21.625%2012.1211%2022.1266%2011.6219%2022.1266%2010.9984C22.1267%2010.851%2022.0978%2010.7049%2022.0415%2010.5686C21.9851%2010.4323%2021.9024%2010.3085%2021.7981%2010.2042C21.6939%2010.0999%2021.57%2010.0172%2021.4337%209.96086C21.2974%209.90451%2021.1514%209.87559%2021.0039%209.87578ZM25.3703%2016C25.3703%2014.7062%2025.382%2013.4242%2025.3094%2012.1328C25.2367%2010.6328%2024.8945%209.30156%2023.7976%208.20469C22.6984%207.10547%2021.3695%206.76562%2019.8695%206.69297C18.5758%206.62031%2017.2937%206.63203%2016.0023%206.63203C14.7086%206.63203%2013.4266%206.62031%2012.1351%206.69297C10.6351%206.76562%209.3039%207.10781%208.20702%208.20469C7.1078%209.3039%206.76796%2010.6328%206.6953%2012.1328C6.62265%2013.4266%206.63436%2014.7086%206.63436%2016C6.63436%2017.2914%206.62265%2018.5758%206.6953%2019.8672C6.76796%2021.3672%207.11015%2022.6984%208.20702%2023.7953C9.30624%2024.8945%2010.6351%2025.2344%2012.1351%2025.307C13.4289%2025.3797%2014.7109%2025.368%2016.0023%2025.368C17.2961%2025.368%2018.5781%2025.3797%2019.8695%2025.307C21.3695%2025.2344%2022.7008%2024.8922%2023.7976%2023.7953C24.8969%2022.6961%2025.2367%2021.3672%2025.3094%2019.8672C25.3844%2018.5758%2025.3703%2017.2937%2025.3703%2016ZM23.3078%2021.5266C23.1367%2021.9531%2022.9305%2022.2719%2022.6%2022.6C22.2695%2022.9305%2021.9531%2023.1367%2021.5266%2023.3078C20.2937%2023.7977%2017.3664%2023.6875%2016%2023.6875C14.6336%2023.6875%2011.7039%2023.7977%2010.4711%2023.3102C10.0445%2023.1391%209.72577%2022.9328%209.39765%2022.6023C9.06718%2022.2719%208.86093%2021.9555%208.68983%2021.5289C8.20233%2020.2937%208.31249%2017.3664%208.31249%2016C8.31249%2014.6336%208.20233%2011.7039%208.68983%2010.4711C8.86093%2010.0445%209.06718%209.72578%209.39765%209.39765C9.72811%209.06953%2010.0445%208.86094%2010.4711%208.68984C11.7039%208.20234%2014.6336%208.3125%2016%208.3125C17.3664%208.3125%2020.2961%208.20234%2021.5289%208.68984C21.9555%208.86094%2022.2742%209.06719%2022.6023%209.39765C22.9328%209.72812%2023.1391%2010.0445%2023.3101%2010.4711C23.7976%2011.7039%2023.6875%2014.6336%2023.6875%2016C23.6875%2017.3664%2023.7976%2020.2937%2023.3078%2021.5266Z'%20fill='white'/%3e%3c/svg%3e", IU = {
  name: "F1",
  components: {
    FooterHeader: J3,
    FooterLink: e8,
    FooterImage: n8,
    FooterTextField: t8
  },
  mixins: [rh],
  methods: {
    orgLink(e) {
      return zr(e, {
        isPreview: this.isPreview,
        currentDomain: this.currentDomain
      });
    }
  }
}, LU = { class: "row" }, DU = {
  class: "footer-column-main",
  "data-testid": "footer-column"
}, $U = { class: "logo-wrapper" }, OU = ["src"], PU = { key: 0 }, NU = { key: 1 }, HU = { key: 2 }, FU = ["innerHTML"], RU = ["innerHTML"], VU = { key: 5 }, BU = ["innerHTML"], jU = ["href"], UU = {
  class: "footer-column-last",
  "data-testid": "footer-column"
}, qU = ["href"], GU = ["href"], KU = {
  key: 0,
  "data-social-media": "facebook",
  "data-testid": "social-icon"
}, zU = ["href"], ZU = {
  key: 1,
  "data-social-media": "twitter",
  "data-testid": "social-icon"
}, xU = ["href"], WU = {
  key: 2,
  "data-social-media": "youtube",
  "data-testid": "social-icon"
}, YU = ["href"], XU = {
  key: 3,
  "data-social-media": "instagram",
  "data-testid": "social-icon"
}, QU = ["href"], JU = ["innerHTML"];
function eq(e, t, n, r, o, i) {
  return d(), f("footer", {
    id: "footer-f1",
    style: Z(e.cssVars)
  }, [
    c("div", LU, [
      c("div", DU, [
        c("div", $U, [
          e.content.hasLogo || e.isPreview ? (d(), f("img", {
            key: 0,
            src: e.logoImage,
            alt: "",
            class: "footer-logo"
          }, null, 8, OU)) : T("", !0)
        ]),
        e.firstColumnHeader ? (d(), f("h2", {
          key: 0,
          class: _(e.theme.style)
        }, k(e.firstColumnHeader), 3)) : T("", !0),
        c("p", null, [
          e.info.name ? (d(), f("span", PU, k(e.info.name), 1)) : T("", !0),
          e.info.address ? (d(), f("span", NU, k(e.info.address), 1)) : T("", !0),
          e.info.city ? (d(), f("span", HU, k(e.info.city) + ", " + k(e.info.state) + " " + k(e.info.zip), 1)) : T("", !0),
          e.info.phone_number ? (d(), f("span", {
            key: 3,
            innerHTML: e.addTelLinksToPhoneNumbers(e.info.phone_number)
          }, null, 8, FU)) : T("", !0),
          e.info.fax_number ? (d(), f("span", {
            key: 4,
            innerHTML: e.addTelLinksToPhoneNumbers(e.info.fax_number)
          }, null, 8, RU)) : T("", !0),
          e.info.email ? (d(), f("span", VU, k(e.info.email), 1)) : T("", !0)
        ]),
        c("ul", null, [
          (d(!0), f(J, null, ne(e.content.columns[0].items, (a, s) => (d(), f("li", { key: s }, [
            (d(), L(Y(a.type), {
              item: a,
              theme: e.theme,
              class: _(e.theme.style)
            }, null, 8, ["item", "theme", "class"]))
          ]))), 128))
        ]),
        e.content.hasAdditionalText && e.content.additionalTextAlignment === "left" ? (d(), f("div", {
          key: 1,
          class: "additional-text",
          innerHTML: e.content.additionalText
        }, null, 8, BU)) : T("", !0)
      ]),
      (d(!0), f(J, null, ne(e.theme.num_columns - 2, (a, s) => (d(), f("div", {
        key: s,
        class: "footer-columns",
        "data-testid": "footer-column"
      }, [
        e.content.columns[s + 1].hasHeader ? (d(), f("h2", {
          key: 0,
          class: _(e.theme.style)
        }, k(e.content.columns[s + 1].header), 3)) : T("", !0),
        s === 0 && e.content.columns[s + 1].showSchools ? (d(), f("ul", {
          key: 1,
          class: _({ "normal-window": !e.isIFrame })
        }, [
          (d(!0), f(J, null, ne(e.organizations, (l, u) => (d(), f("li", { key: u }, [
            c("a", {
              href: i.orgLink(l)
            }, k(l.name), 9, jU)
          ]))), 128))
        ], 2)) : T("", !0),
        c("ul", {
          class: _({ "normal-window": !e.isIFrame })
        }, [
          (d(!0), f(J, null, ne(e.content.columns[s + 1].items, (l, u) => (d(), f("li", { key: u }, [
            (d(), L(Y(l.type), {
              item: l,
              theme: e.theme,
              class: _(e.theme.style)
            }, null, 8, ["item", "theme", "class"]))
          ]))), 128))
        ], 2)
      ]))), 128)),
      c("div", UU, [
        c("h2", {
          class: _(e.theme.style)
        }, k(e.translations.stay_connected), 3),
        e.iosLink || e.isPreview ? (d(), f("a", {
          key: 0,
          href: e.iosLink,
          target: "_blank",
          "data-mobile-app": "ios"
        }, t[0] || (t[0] = [
          c("img", {
            class: "app-link",
            src: r8,
            alt: "Download our iOS App",
            "data-testid": "app-icon"
          }, null, -1)
        ]), 8, qU)) : T("", !0),
        e.androidLink || e.isPreview ? (d(), f("a", {
          key: 1,
          href: e.androidLink,
          target: "_blank",
          "data-mobile-app": "android"
        }, t[1] || (t[1] = [
          c("img", {
            class: "app-link",
            src: o8,
            alt: "Download our Android App",
            "data-testid": "app-icon"
          }, null, -1)
        ]), 8, GU)) : T("", !0),
        c("ul", {
          class: _(["footer-social-links", { "normal-window": !e.isIFrame }])
        }, [
          e.content.facebook || e.isPreview ? (d(), f("li", KU, [
            c("a", {
              href: e.content.facebook,
              target: "_blank"
            }, t[2] || (t[2] = [
              c("img", {
                src: i8,
                alt: "Visit us on Facebook"
              }, null, -1)
            ]), 8, zU)
          ])) : T("", !0),
          e.content.twitter || e.isPreview ? (d(), f("li", ZU, [
            c("a", {
              href: e.content.twitter,
              target: "_blank"
            }, t[3] || (t[3] = [
              c("img", {
                src: s8,
                alt: "Visit us on X, formerly Twitter"
              }, null, -1)
            ]), 8, xU)
          ])) : T("", !0),
          e.content.youtube || e.isPreview ? (d(), f("li", WU, [
            c("a", {
              href: e.content.youtube,
              target: "_blank"
            }, t[4] || (t[4] = [
              c("img", {
                src: a8,
                alt: "Visit us on Youtube"
              }, null, -1)
            ]), 8, YU)
          ])) : T("", !0),
          e.content.instagram || e.isPreview ? (d(), f("li", XU, [
            c("a", {
              href: e.content.instagram,
              target: "_blank"
            }, t[5] || (t[5] = [
              c("img", {
                src: l8,
                alt: "Visit us on Instagram"
              }, null, -1)
            ]), 8, QU)
          ])) : T("", !0)
        ], 2)
      ])
    ]),
    e.content.hasAdditionalText && e.content.additionalTextAlignment === "center" ? (d(), f("div", {
      key: 0,
      class: "additional-text additional-text-bottom",
      innerHTML: e.content.additionalText
    }, null, 8, JU)) : T("", !0),
    c("div", {
      class: _(`apptegy-copyright ${e.theme.version && e.theme.version.toLowerCase()}`)
    }, [
      c("span", null, k(e.translations.copyright) + " © " + k(e.currentYear) + " " + k(e.copyrightOrg) + ". " + k(e.translations.all_rights_reserved), 1),
      c("span", null, [
        H(k(e.translations.powered_by) + " ", 1),
        t[6] || (t[6] = c("a", {
          href: "https://www.apptegy.com",
          target: "_blank",
          class: "notranslate"
        }, [
          H("Apptegy "),
          c("span", { class: "sr-only" }, "Visit us to learn more")
        ], -1))
      ])
    ], 2)
  ], 4);
}
const tq = /* @__PURE__ */ B(IU, [["render", eq], ["__scopeId", "data-v-e45d0272"]]), nq = {
  name: "F2",
  mixins: [rh],
  computed: {
    showDownloadApps() {
      return this.content.hasApps || this.content.columns[2].showApps || this.isPreview;
    },
    showSocialMedia() {
      return this.content.hasSocial || this.content.columns[0].hasSocial || this.isPreview;
    },
    thirdColumnHeader() {
      return this.isPreview ? this.translations.stay_connected : this.content.columns[2].hasHeader ? this.content.columns[2].header : !1;
    }
  }
}, rq = { class: "footer-wrapper" }, oq = { class: "logo" }, iq = ["src"], sq = {
  class: "download-links",
  "data-testid": "download-links"
}, aq = {
  key: 1,
  class: "links-wrapper"
}, lq = ["href"], uq = ["href"], dq = { class: "contact-data" }, cq = {
  key: 0,
  class: "social-media"
}, hq = {
  key: 0,
  "data-social-media": "facebook",
  "data-testid": "social-icon"
}, mq = ["href"], fq = {
  key: 1,
  "data-social-media": "twitter",
  "data-testid": "social-icon"
}, pq = ["href"], gq = {
  key: 2,
  "data-social-media": "youtube",
  "data-testid": "social-icon"
}, vq = ["href"], bq = {
  key: 3,
  "data-social-media": "instagram",
  "data-testid": "social-icon"
}, yq = ["href"], _q = { key: 0 }, Cq = { key: 1 }, wq = { key: 2 }, Tq = { key: 3 }, kq = ["innerHTML"], Eq = { key: 4 }, Sq = ["innerHTML"], Mq = { key: 5 }, Aq = ["innerHTML"];
function Iq(e, t, n, r, o, i) {
  return d(), f("footer", {
    id: "footer-f2",
    style: Z(e.cssVars)
  }, [
    c("div", rq, [
      c("div", oq, [
        e.content.hasLogo || e.isPreview ? (d(), f("img", {
          key: 0,
          src: e.logoImage,
          alt: "",
          class: "footer-logo"
        }, null, 8, iq)) : T("", !0)
      ]),
      c("div", sq, [
        i.thirdColumnHeader ? (d(), f("h2", {
          key: 0,
          class: _(`header ${e.theme.style}`)
        }, k(i.thirdColumnHeader), 3)) : T("", !0),
        i.showDownloadApps ? (d(), f("div", aq, [
          e.iosLink || e.isPreview ? (d(), f("a", {
            key: 0,
            href: e.iosLink,
            target: "_blank",
            "data-mobile-app": "ios"
          }, t[0] || (t[0] = [
            c("img", {
              class: "app-icon",
              src: r8,
              alt: "Download our iOS App",
              "data-testid": "app-icon"
            }, null, -1)
          ]), 8, lq)) : T("", !0),
          e.androidLink || e.isPreview ? (d(), f("a", {
            key: 1,
            href: e.androidLink,
            target: "_blank",
            "data-mobile-app": "android"
          }, t[1] || (t[1] = [
            c("img", {
              class: "app-icon",
              src: o8,
              alt: "Download our Android App",
              "data-testid": "app-icon"
            }, null, -1)
          ]), 8, uq)) : T("", !0)
        ])) : T("", !0)
      ]),
      c("div", dq, [
        i.showSocialMedia ? (d(), f("ul", cq, [
          e.content.facebook || e.isPreview ? (d(), f("li", hq, [
            c("a", {
              href: e.content.facebook,
              target: "_blank"
            }, t[2] || (t[2] = [
              c("img", {
                src: i8,
                alt: "Visit us on Facebook",
                class: "icon-img"
              }, null, -1)
            ]), 8, mq)
          ])) : T("", !0),
          e.content.twitter || e.isPreview ? (d(), f("li", fq, [
            c("a", {
              href: e.content.twitter,
              target: "_blank"
            }, t[3] || (t[3] = [
              c("img", {
                src: s8,
                alt: "Visit us on X, formerly Twitter",
                class: "icon-img"
              }, null, -1)
            ]), 8, pq)
          ])) : T("", !0),
          e.content.youtube || e.isPreview ? (d(), f("li", gq, [
            c("a", {
              href: e.content.youtube,
              target: "_blank"
            }, t[4] || (t[4] = [
              c("img", {
                src: a8,
                alt: "Visit us on Youtube",
                class: "icon-img"
              }, null, -1)
            ]), 8, vq)
          ])) : T("", !0),
          e.content.instagram || e.isPreview ? (d(), f("li", bq, [
            c("a", {
              href: e.content.instagram,
              target: "_blank"
            }, t[5] || (t[5] = [
              c("img", {
                src: l8,
                alt: "Visit us on Instagram",
                class: "icon-img"
              }, null, -1)
            ]), 8, yq)
          ])) : T("", !0)
        ])) : T("", !0),
        e.firstColumnHeader ? (d(), f("h2", {
          key: 1,
          class: _(`header ${e.theme.style}`)
        }, k(e.firstColumnHeader), 3)) : T("", !0),
        c("div", {
          class: _(`info ${e.theme.style}`)
        }, [
          e.info.name ? (d(), f("span", _q, k(e.info.name), 1)) : T("", !0),
          t[6] || (t[6] = H("  ")),
          e.info.address ? (d(), f("span", Cq, k(e.info.address), 1)) : T("", !0),
          t[7] || (t[7] = H("  ")),
          e.info.city ? (d(), f("span", wq, k(e.info.city) + ", " + k(e.info.state) + " " + k(e.info.zip), 1)) : T("", !0),
          t[8] || (t[8] = c("br", null, null, -1)),
          e.info.phone_number ? (d(), f("span", Tq, [
            H(k(e.translations.phone_number) + ": ", 1),
            c("span", {
              innerHTML: e.addTelLinksToPhoneNumbers(e.info.phone_number)
            }, null, 8, kq)
          ])) : T("", !0),
          t[9] || (t[9] = H("  ")),
          e.info.fax_number ? (d(), f("span", Eq, [
            H(k(e.translations.fax_number) + ": ", 1),
            c("span", {
              innerHTML: e.addTelLinksToPhoneNumbers(e.info.fax_number)
            }, null, 8, Sq)
          ])) : T("", !0),
          t[10] || (t[10] = H("  ")),
          e.info.email ? (d(), f("span", Mq, k(e.translations.email) + ": " + k(e.info.email), 1)) : T("", !0)
        ], 2)
      ])
    ]),
    e.content.hasAdditionalText && !e.isPreview ? (d(), f("div", {
      key: 0,
      class: "additional-text",
      innerHTML: e.content.additionalText
    }, null, 8, Aq)) : T("", !0),
    c("div", {
      class: _(`apptegy-copyright ${e.theme.version && e.theme.version.toLowerCase()}`)
    }, [
      c("span", null, k(e.translations.copyright) + " © " + k(e.currentYear) + " " + k(e.copyrightOrg) + ". " + k(e.translations.all_rights_reserved), 1),
      c("span", null, [
        H(k(e.translations.powered_by) + " ", 1),
        t[11] || (t[11] = c("a", {
          href: "https://www.apptegy.com",
          target: "_blank",
          class: "notranslate"
        }, [
          H("Apptegy "),
          c("span", { class: "sr-only" }, "Visit us to learn more")
        ], -1))
      ])
    ], 2)
  ], 4);
}
const Lq = /* @__PURE__ */ B(nq, [["render", Iq], ["__scopeId", "data-v-b16e74b5"]]), Dq = { class: "contact-info-list" }, $q = { key: 0 }, Oq = { class: "contact-info-item-wrapper" }, Pq = { key: 1 }, Nq = { class: "contact-info-item-wrapper" }, Hq = ["innerHTML"], Fq = { key: 2 }, Rq = { class: "contact-info-item-wrapper" }, Vq = ["innerHTML"], Bq = { key: 3 }, jq = { class: "contact-info-item-wrapper" }, Uq = ["href"], qq = {
  __name: "F3ContactInfo",
  props: {
    info: {
      type: Object,
      required: !0,
      default: () => ({})
    }
  },
  setup(e) {
    const t = e, n = Re(() => !!(t.info.address || t.info.city || t.info.state || t.info.zip)), r = Re(() => n.value ? [t.info.address, t.info.city, t.info.state, t.info.zip].filter(Boolean).join(", ") : "");
    return (o, i) => (d(), f("ul", Dq, [
      n.value ? (d(), f("li", $q, [
        c("div", Oq, [
          i[0] || (i[0] = c("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none"
          }, [
            c("path", {
              d: "M6 10C6 12.8226 9.62765 17.3665 11.321 19.2695C11.6882 19.6821 12.3118 19.6821 12.679 19.2695C14.3723 17.3665 18 12.8226 18 10C18 6.68629 15.3137 4 12 4C8.68629 4 6 6.68629 6 10Z",
              stroke: "currentColor",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }),
            c("path", {
              d: "M9 10C9 8.34315 10.3431 7 12 7C13.6569 7 15 8.34315 15 10C15 11.6569 13.6569 13 12 13C10.3431 13 9 11.6569 9 10Z",
              stroke: "currentColor",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            })
          ], -1)),
          c("span", null, k(r.value), 1)
        ])
      ])) : T("", !0),
      e.info.phone_number ? (d(), f("li", Pq, [
        c("div", Nq, [
          i[1] || (i[1] = c("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none"
          }, [
            c("path", {
              d: "M5.48154 5.8797L8.22211 5.19456C8.67681 5.08088 9.14946 5.29827 9.35907 5.71748L10.678 8.35533C10.8705 8.74032 10.795 9.20529 10.4907 9.50965L10.0003 10C10.0003 10 9.00033 11 11.0003 13C13.0003 15 14.0003 14 14.0003 14L14.4907 13.5097C14.795 13.2053 15.26 13.1298 15.645 13.3223L18.2828 14.6413C18.7021 14.8509 18.9194 15.3235 18.8058 15.7782L18.1206 18.5188C18.0448 18.822 17.8296 19.0716 17.5216 19.125C16.3879 19.3214 13.3073 19.307 9.00033 15C4.69331 10.693 4.67895 7.61245 4.87535 6.4787C4.9287 6.17078 5.17836 5.95549 5.48154 5.8797Z",
              stroke: "currentColor",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            })
          ], -1)),
          c("span", {
            innerHTML: po(r0)(e.info.phone_number)
          }, null, 8, Hq)
        ])
      ])) : T("", !0),
      e.info.fax_number ? (d(), f("li", Fq, [
        c("div", Rq, [
          i[2] || (i[2] = c("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none"
          }, [
            c("path", {
              d: "M7 16H6C5.44772 16 5 15.5523 5 15V8C5 7.44772 5.44772 7 6 7H7M7 16V18C7 18.5523 7.44772 19 8 19H16C16.5523 19 17 18.5523 17 18V16M7 16V13C7 12.4477 7.44772 12 8 12H16C16.5523 12 17 12.4477 17 13V16M17 16H18C18.5523 16 19 15.5523 19 15V8C19 7.44772 18.5523 7 18 7H17M17 7V6C17 5.44772 16.5523 5 16 5H8C7.44772 5 7 5.44772 7 6V7M17 7H7M9 14H15M9 17H15M16.5 10V10C16.7761 10 17 9.77614 17 9.5V9.5C17 9.22386 16.7761 9 16.5 9V9C16.2239 9 16 9.22386 16 9.5V9.5C16 9.77614 16.2239 10 16.5 10Z",
              stroke: "#333333",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            })
          ], -1)),
          c("span", {
            innerHTML: po(r0)(e.info.fax_number)
          }, null, 8, Vq)
        ])
      ])) : T("", !0),
      e.info.email ? (d(), f("li", Bq, [
        c("div", jq, [
          i[3] || (i[3] = c("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none"
          }, [
            c("path", {
              d: "M4 6H20M4 6V17C4 17.5523 4.44772 18 5 18H19C19.5523 18 20 17.5523 20 17V6M4 6L11.3415 12.4238C11.7185 12.7537 12.2815 12.7537 12.6585 12.4238L20 6",
              stroke: "currentColor",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            })
          ], -1)),
          c("a", {
            href: `mailto:${e.info.email}`,
            class: "link"
          }, k(e.info.email), 9, Uq)
        ])
      ])) : T("", !0)
    ]));
  }
}, Gq = /* @__PURE__ */ B(qq, [["__scopeId", "data-v-ce6fae85"]]), Kq = "data:image/svg+xml,%3csvg%20width='120'%20height='40'%20viewBox='0%200%20120%2040'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='0.5'%20y='0.5'%20width='119'%20height='39'%20rx='5.5'%20fill='white'/%3e%3crect%20x='0.5'%20y='0.5'%20width='119'%20height='39'%20rx='5.5'%20stroke='%23E1E1E1'/%3e%3cpath%20d='M24.7045%2020.763C24.7166%2019.8431%2024.9669%2018.9411%2025.4321%2018.141C25.8972%2017.3409%2026.5621%2016.6687%2027.3648%2016.1869C26.8548%2015.4758%2026.1821%2014.8907%2025.4%2014.4779C24.6178%2014.065%2023.7479%2013.836%2022.8592%2013.8088C20.9635%2013.6146%2019.1258%2014.9163%2018.1598%2014.9163C17.1751%2014.9163%2015.6878%2013.8281%2014.0862%2013.8603C13.0502%2013.893%2012.0406%2014.1871%2011.1557%2014.714C10.2708%2015.2408%209.54075%2015.9825%209.03674%2016.8668C6.85352%2020.5571%208.48201%2025.9808%2010.5734%2028.9639C11.6197%2030.4246%2012.8426%2032.0562%2014.4428%2031.9984C16.0086%2031.9349%2016.5934%2031.0235%2018.4835%2031.0235C20.3561%2031.0235%2020.9048%2031.9984%2022.5374%2031.9616C24.2176%2031.9349%2025.2762%2030.4944%2026.2859%2029.0198C27.0377%2027.979%2027.6162%2026.8287%2028%2025.6115C27.0238%2025.2084%2026.1908%2024.5337%2025.6048%2023.6715C25.0187%2022.8093%2024.7056%2021.7977%2024.7045%2020.763Z'%20fill='%231B1B1B'/%3e%3cpath%20d='M21.621%2011.8471C22.5372%2010.7734%2022.9885%209.39335%2022.8792%208C21.4796%208.14352%2020.1867%208.7966%2019.2582%209.82911C18.8043%2010.3335%2018.4566%2010.9203%2018.235%2011.556C18.0135%2012.1917%2017.9224%2012.8638%2017.9671%2013.5338C18.6672%2013.5408%2019.3597%2013.3927%2019.9927%2013.1005C20.6256%2012.8084%2021.1824%2012.3798%2021.621%2011.8471Z'%20fill='%231B1B1B'/%3e%3cpath%20d='M36.791%208.50146H38.8608C40.6494%208.50146%2041.5195%209.56494%2041.5195%2011.4941C41.5195%2013.4233%2040.6406%2014.5%2038.8608%2014.5H36.791V8.50146ZM37.7886%209.34082V13.6606H38.751C39.9375%2013.6606%2040.4956%2012.9443%2040.4956%2011.5073C40.4956%2010.0615%2039.9331%209.34082%2038.751%209.34082H37.7886ZM44.6748%209.77588C45.8877%209.77588%2046.7358%2010.5625%2046.7358%2011.8677V12.4697C46.7358%2013.8188%2045.8877%2014.5791%2044.6748%2014.5791C43.4443%2014.5791%2042.605%2013.8276%2042.605%2012.4741V11.8721C42.605%2010.6021%2043.4575%209.77588%2044.6748%209.77588ZM44.6792%2010.5625C43.9849%2010.5625%2043.5894%2011.1426%2043.5894%2011.9204V12.439C43.5894%2013.2168%2043.9585%2013.7925%2044.6792%2013.7925C45.3911%2013.7925%2045.7559%2013.2212%2045.7559%2012.439V11.9204C45.7559%2011.1426%2045.3735%2010.5625%2044.6792%2010.5625ZM53.8989%209.85498L52.6772%2014.5H51.6841L50.7129%2011.0723H50.6865L49.7329%2014.5H48.7354L47.4609%209.85498H48.5112L49.2583%2013.397H49.3022L50.2383%209.85498H51.1567L52.1191%2013.397H52.1631L52.9233%209.85498H53.8989ZM54.8657%2014.5V9.85498H55.8237V10.6899H55.8721C55.9907%2010.3252%2056.3291%209.78467%2057.2695%209.78467C58.2056%209.78467%2058.834%2010.3032%2058.834%2011.3623V14.5H57.8584V11.6479C57.8584%2010.9404%2057.4893%2010.6152%2056.9399%2010.6152C56.2192%2010.6152%2055.8413%2011.1689%2055.8413%2011.9204V14.5H54.8657ZM60.3105%2014.5V8.18506H61.2861V14.5H60.3105ZM64.6348%209.77588C65.8477%209.77588%2066.6958%2010.5625%2066.6958%2011.8677V12.4697C66.6958%2013.8188%2065.8477%2014.5791%2064.6348%2014.5791C63.4043%2014.5791%2062.5649%2013.8276%2062.5649%2012.4741V11.8721C62.5649%2010.6021%2063.4175%209.77588%2064.6348%209.77588ZM64.6392%2010.5625C63.9448%2010.5625%2063.5493%2011.1426%2063.5493%2011.9204V12.439C63.5493%2013.2168%2063.9185%2013.7925%2064.6392%2013.7925C65.3511%2013.7925%2065.7158%2013.2212%2065.7158%2012.439V11.9204C65.7158%2011.1426%2065.3335%2010.5625%2064.6392%2010.5625ZM69.2227%2014.5703C68.3218%2014.5703%2067.7021%2014.0166%2067.7021%2013.1509C67.7021%2012.3291%2068.2734%2011.7754%2069.3457%2011.7754H70.519V11.3403C70.519%2010.8086%2070.1807%2010.5581%2069.6445%2010.5581C69.1172%2010.5581%2068.8799%2010.7778%2068.8052%2011.0854H67.8779C67.9351%2010.3076%2068.5195%209.78467%2069.6753%209.78467C70.6685%209.78467%2071.4902%2010.1978%2071.4902%2011.3535V14.5H70.563V13.8979H70.519C70.3125%2014.2539%2069.9082%2014.5703%2069.2227%2014.5703ZM69.5259%2013.8145C70.0796%2013.8145%2070.519%2013.4365%2070.519%2012.9312V12.4302H69.4995C68.9326%2012.4302%2068.6821%2012.7158%2068.6821%2013.1025C68.6821%2013.5859%2069.0864%2013.8145%2069.5259%2013.8145ZM74.4961%209.79346C75.1509%209.79346%2075.6519%2010.0835%2075.832%2010.5537H75.8804V8.18506H76.856V14.5H75.9067V13.7573H75.8584C75.7178%2014.2275%2075.1597%2014.5615%2074.4829%2014.5615C73.415%2014.5615%2072.7207%2013.8013%2072.7207%2012.5752V11.7798C72.7207%2010.5537%2073.4282%209.79346%2074.4961%209.79346ZM74.7686%2010.5933C74.1182%2010.5933%2073.7139%2011.0767%2073.7139%2011.9204V12.4302C73.7139%2013.2783%2074.1226%2013.7617%2074.7905%2013.7617C75.4497%2013.7617%2075.8804%2013.2827%2075.8804%2012.4917V11.7886C75.8804%2011.0723%2075.4102%2010.5933%2074.7686%2010.5933ZM82.2129%209.77588C83.4258%209.77588%2084.2739%2010.5625%2084.2739%2011.8677V12.4697C84.2739%2013.8188%2083.4258%2014.5791%2082.2129%2014.5791C80.9824%2014.5791%2080.1431%2013.8276%2080.1431%2012.4741V11.8721C80.1431%2010.6021%2080.9956%209.77588%2082.2129%209.77588ZM82.2173%2010.5625C81.5229%2010.5625%2081.1274%2011.1426%2081.1274%2011.9204V12.439C81.1274%2013.2168%2081.4966%2013.7925%2082.2173%2013.7925C82.9292%2013.7925%2083.2939%2013.2212%2083.2939%2012.439V11.9204C83.2939%2011.1426%2082.9116%2010.5625%2082.2173%2010.5625ZM85.5308%2014.5V9.85498H86.4888V10.6899H86.5371C86.6558%2010.3252%2086.9941%209.78467%2087.9346%209.78467C88.8706%209.78467%2089.499%2010.3032%2089.499%2011.3623V14.5H88.5234V11.6479C88.5234%2010.9404%2088.1543%2010.6152%2087.605%2010.6152C86.8843%2010.6152%2086.5063%2011.1689%2086.5063%2011.9204V14.5H85.5308ZM93.2739%209.88574V8.72559H94.2275V9.88574H95.269V10.6504H94.2275V13.1157C94.2275%2013.6211%2094.4165%2013.7617%2094.9395%2013.7617C95.0713%2013.7617%2095.2471%2013.7529%2095.3218%2013.7441V14.4912C95.2427%2014.5044%2094.9175%2014.5308%2094.6978%2014.5308C93.5684%2014.5308%2093.2607%2014.1265%2093.2607%2013.1948V10.6504H92.5532V9.88574H93.2739ZM96.4995%2014.5V8.18506H97.4707V10.6899H97.519C97.6201%2010.3604%2097.998%209.78467%2098.9297%209.78467C99.835%209.78467%20100.481%2010.3076%20100.481%2011.3667V14.5H99.5098V11.6523C99.5098%2010.9448%2099.1187%2010.6152%2098.5649%2010.6152C97.8662%2010.6152%2097.4707%2011.1646%2097.4707%2011.9204V14.5H96.4995ZM103.755%2014.5791C102.489%2014.5791%20101.703%2013.8013%20101.703%2012.4917V11.8633C101.703%2010.5449%20102.564%209.77588%20103.698%209.77588C104.862%209.77588%20105.684%2010.5845%20105.684%2011.8633V12.4082H102.669V12.6367C102.669%2013.3047%20103.065%2013.7969%20103.75%2013.7969C104.26%2013.7969%20104.612%2013.5552%20104.678%2013.2651H105.631C105.574%2013.8013%20105.007%2014.5791%20103.755%2014.5791ZM102.669%2011.771H104.73V11.7095C104.73%2011.0107%20104.322%2010.5449%20103.702%2010.5449C103.083%2010.5449%20102.669%2011.0107%20102.669%2011.7095V11.771Z'%20fill='%231B1B1B'/%3e%3cpath%20d='M38.2061%2030.5H36.1758L40.3066%2018.5029H42.5391L46.6611%2030.5H44.5518L43.4883%2027.1777H39.2783L38.2061%2030.5ZM41.4316%2020.5771H41.3525L39.7266%2025.6484H43.04L41.4316%2020.5771ZM52.2644%2030.6318C51.0603%2030.6318%2050.1462%2030.0605%2049.654%2029.208H49.5837V33.585H47.6325V21.21H49.531V22.5723H49.6013C50.1111%2021.6846%2051.0603%2021.0869%2052.3083%2021.0869C54.3913%2021.0869%2055.8767%2022.6602%2055.8767%2025.4375V26.2637C55.8767%2029.0234%2054.4089%2030.6318%2052.2644%2030.6318ZM51.8161%2029.0234C53.0554%2029.0234%2053.8991%2028.0303%2053.8991%2026.1582V25.5078C53.8991%2023.7061%2053.1081%2022.6777%2051.781%2022.6777C50.4187%2022.6777%2049.5661%2023.7852%2049.5661%2025.499V26.1582C49.5661%2027.916%2050.4275%2029.0234%2051.8161%2029.0234ZM62.183%2030.6318C60.9789%2030.6318%2060.0649%2030.0605%2059.5727%2029.208H59.5024V33.585H57.5512V21.21H59.4496V22.5723H59.52C60.0297%2021.6846%2060.9789%2021.0869%2062.227%2021.0869C64.31%2021.0869%2065.7954%2022.6602%2065.7954%2025.4375V26.2637C65.7954%2029.0234%2064.3276%2030.6318%2062.183%2030.6318ZM61.7348%2029.0234C62.9741%2029.0234%2063.8178%2028.0303%2063.8178%2026.1582V25.5078C63.8178%2023.7061%2063.0268%2022.6777%2061.6996%2022.6777C60.3373%2022.6777%2059.4848%2023.7852%2059.4848%2025.499V26.1582C59.4848%2027.916%2060.3461%2029.0234%2061.7348%2029.0234ZM69.8387%2027.1689H71.7899C71.8778%2028.2061%2072.7919%2029.0938%2074.4882%2029.0938C76.0438%2029.0938%2076.9667%2028.3643%2076.9667%2027.2305C76.9667%2026.3164%2076.3514%2025.8242%2075.0682%2025.5166L73.0995%2025.0244C71.5526%2024.6641%2070.1639%2023.7412%2070.1639%2021.79C70.1639%2019.4961%2072.1679%2018.2393%2074.497%2018.2393C76.8261%2018.2393%2078.7684%2019.4961%2078.8124%2021.7373H76.8964C76.8085%2020.7178%2076.0262%2019.874%2074.4706%2019.874C73.0995%2019.874%2072.1679%2020.5244%2072.1679%2021.6406C72.1679%2022.4229%2072.7128%2022.9854%2073.829%2023.2402L75.7889%2023.7236C77.5907%2024.1631%2078.9618%2025.0156%2078.9618%2027.0547C78.9618%2029.4102%2077.0546%2030.7373%2074.3387%2030.7373C70.9989%2030.7373%2069.8827%2028.7861%2069.8387%2027.1689ZM81.3395%2021.21V18.9512H83.2555V21.21H85.066V22.7744H83.2555V27.7314C83.2555%2028.7422%2083.6334%2029.0234%2084.6793%2029.0234C84.8463%2029.0234%2085.0045%2029.0234%2085.1188%2029.0059V30.5C84.9605%2030.5264%2084.5914%2030.5615%2084.1959%2030.5615C81.9371%2030.5615%2081.3131%2029.7529%2081.3131%2027.8896V22.7744H80.0299V21.21H81.3395ZM90.3353%2021.0518C93.0071%2021.0518%2094.4573%2022.9326%2094.4573%2025.4639V26.2109C94.4573%2028.8301%2093.0159%2030.6582%2090.3353%2030.6582C87.6546%2030.6582%2086.1956%2028.8301%2086.1956%2026.2109V25.4639C86.1956%2022.9414%2087.6634%2021.0518%2090.3353%2021.0518ZM90.3353%2022.6162C88.8851%2022.6162%2088.1644%2023.8027%2088.1644%2025.4902V26.2021C88.1644%2027.8633%2088.8763%2029.085%2090.3353%2029.085C91.7943%2029.085%2092.4974%2027.8721%2092.4974%2026.2021V25.4902C92.4974%2023.7939%2091.7855%2022.6162%2090.3353%2022.6162ZM96.1055%2030.5V21.21H98.0567V22.4316H98.127C98.3643%2021.8516%2099.0586%2021.0781%20100.351%2021.0781C100.606%2021.0781%20100.825%2021.0957%20101.01%2021.1309V22.8535C100.843%2022.8096%20100.5%2022.7832%20100.175%2022.7832C98.6104%2022.7832%2098.083%2023.75%2098.083%2024.998V30.5H96.1055ZM105.743%2030.6582C103.256%2030.6582%20101.674%2029.0146%20101.674%2026.2637V25.3232C101.674%2022.7305%20103.22%2021.0518%20105.664%2021.0518C108.142%2021.0518%20109.636%2022.792%20109.636%2025.4111V26.2988H103.598V26.5186C103.598%2028.083%20104.442%2029.1201%20105.769%2029.1201C106.762%2029.1201%20107.439%2028.6279%20107.677%2027.8281H109.531C109.25%2029.3311%20108.037%2030.6582%20105.743%2030.6582ZM103.598%2024.9365H107.729V24.9189C107.729%2023.6006%20106.912%2022.5635%20105.673%2022.5635C104.416%2022.5635%20103.598%2023.6006%20103.598%2024.9189V24.9365Z'%20fill='%231B1B1B'/%3e%3c/svg%3e", zq = "data:image/svg+xml,%3csvg%20width='120'%20height='40'%20viewBox='0%200%20120%2040'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='0.5'%20y='0.5'%20width='119'%20height='39'%20rx='5.5'%20fill='white'/%3e%3crect%20x='0.5'%20y='0.5'%20width='119'%20height='39'%20rx='5.5'%20stroke='%23E1E1E1'/%3e%3cpath%20d='M17.8051%2019.4617L8.08984%2030.0059C8.09076%2030.0078%208.09076%2030.0106%208.09167%2030.0125C8.39005%2031.1574%209.41203%2032%2010.6256%2032C11.1111%2032%2011.5664%2031.8656%2011.957%2031.6305L11.988%2031.6118L22.9232%2025.1593L17.8051%2019.4617Z'%20fill='%23EA4335'/%3e%3cpath%20d='M27.6332%2017.6642L27.624%2017.6577L22.9029%2014.8593L17.584%2019.6994L22.922%2025.1562L27.6177%2022.3858C28.4407%2021.9305%2029.0001%2021.0431%2029.0001%2020.0204C29.0001%2019.0033%2028.4489%2018.1205%2027.6332%2017.6642Z'%20fill='%23FBBC04'/%3e%3cpath%20d='M8.08942%209.9952C8.03102%2010.2154%208%2010.4468%208%2010.6857V29.3182C8%2029.5571%208.03102%2029.7885%208.09034%2030.0078L18.1386%2019.7332L8.08942%209.9952Z'%20fill='%234285F4'/%3e%3cpath%20d='M17.8762%2020L22.904%2014.8594L11.9815%208.3836C11.5846%208.14005%2011.1211%208.00009%2010.6256%208.00009C9.41197%208.00009%208.38816%208.84456%208.08978%209.99043C8.08978%209.99136%208.08887%209.9923%208.08887%209.99323L17.8762%2020Z'%20fill='%2334A853'/%3e%3cpath%20d='M43.61%2011.71C43.61%2012.71%2043.3133%2013.5067%2042.72%2014.1C42.0533%2014.8067%2041.1767%2015.16%2040.09%2015.16C39.05%2015.16%2038.17%2014.8%2037.45%2014.08C36.73%2013.36%2036.37%2012.4733%2036.37%2011.42C36.37%2010.3667%2036.73%209.48%2037.45%208.76C38.17%208.04%2039.05%207.68%2040.09%207.68C40.6167%207.68%2041.1133%207.77333%2041.58%207.96C42.0467%208.14667%2042.43%208.41%2042.73%208.75L42.07%209.41C41.85%209.14333%2041.5633%208.93667%2041.21%208.79C40.8633%208.63667%2040.49%208.56%2040.09%208.56C39.31%208.56%2038.65%208.83%2038.11%209.37C37.5767%209.91667%2037.31%2010.6%2037.31%2011.42C37.31%2012.24%2037.5767%2012.9233%2038.11%2013.47C38.65%2014.01%2039.31%2014.28%2040.09%2014.28C40.8033%2014.28%2041.3967%2014.08%2041.87%2013.68C42.3433%2013.28%2042.6167%2012.73%2042.69%2012.03H40.09V11.17H43.56C43.5933%2011.3567%2043.61%2011.5367%2043.61%2011.71ZM48.9078%207.84V8.72H45.6478V10.99H48.5878V11.85H45.6478V14.12H48.9078V15H44.7278V7.84H48.9078ZM52.5877%208.72V15H51.6677V8.72H49.6677V7.84H54.5877V8.72H52.5877ZM58.6654%2015H57.7454V7.84H58.6654V15ZM62.5487%208.72V15H61.6287V8.72H59.6287V7.84H64.5487V8.72H62.5487ZM74.521%2011.42C74.521%2012.48%2074.1677%2013.3667%2073.461%2014.08C72.7477%2014.8%2071.8743%2015.16%2070.841%2015.16C69.801%2015.16%2068.9277%2014.8%2068.221%2014.08C67.5143%2013.3667%2067.161%2012.48%2067.161%2011.42C67.161%2010.36%2067.5143%209.47333%2068.221%208.76C68.9277%208.04%2069.801%207.68%2070.841%207.68C71.881%207.68%2072.7543%208.04333%2073.461%208.77C74.1677%209.48333%2074.521%2010.3667%2074.521%2011.42ZM68.101%2011.42C68.101%2012.2467%2068.361%2012.93%2068.881%2013.47C69.4077%2014.01%2070.061%2014.28%2070.841%2014.28C71.621%2014.28%2072.271%2014.01%2072.791%2013.47C73.3177%2012.9367%2073.581%2012.2533%2073.581%2011.42C73.581%2010.5867%2073.3177%209.90333%2072.791%209.37C72.271%208.83%2071.621%208.56%2070.841%208.56C70.061%208.56%2069.4077%208.83%2068.881%209.37C68.361%209.91%2068.101%2010.5933%2068.101%2011.42ZM76.5267%2015H75.6067V7.84H76.7267L80.2067%2013.41H80.2467L80.2067%2012.03V7.84H81.1267V15H80.1667L76.5267%209.16H76.4867L76.5267%2010.54V15Z'%20fill='%231B1B1B'/%3e%3cpath%20d='M93.5181%2031.4097H95.1469V20.3981H93.5181V31.4097ZM108.189%2024.3646L106.322%2029.1388H106.266L104.328%2024.3646H102.573L105.479%2031.0371L103.823%2034.749H105.521L110%2024.3646H108.189ZM98.9519%2030.1588C98.4176%2030.1588%2097.6739%2029.8902%2097.6739%2029.2234C97.6739%2028.3742%2098.6001%2028.0483%2099.4005%2028.0483C100.116%2028.0483%20100.454%2028.2042%20100.889%2028.4165C100.762%2029.4365%2099.892%2030.1588%2098.9519%2030.1588ZM99.1483%2024.1241C97.969%2024.1241%2096.7469%2024.6482%2096.2424%2025.8101L97.6879%2026.4188C97.9969%2025.8101%2098.5721%2025.611%2099.1762%2025.611C100.019%2025.611%20100.875%2026.121%20100.889%2027.0283V27.1411C100.594%2026.971%2099.9627%2026.7165%2099.1902%2026.7165C97.632%2026.7165%2096.0451%2027.5806%2096.0451%2029.1952C96.0451%2030.6689%2097.323%2031.6184%2098.7546%2031.6184C99.8501%2031.6184%20100.454%2031.1225%20100.833%2030.5411H100.889V31.3912H102.461V27.1692C102.461%2025.2146%20101.015%2024.1241%2099.1483%2024.1241ZM89.0821%2025.7053H86.7655V21.9308H89.0821C90.2998%2021.9308%2090.9911%2022.9482%2090.9911%2023.8176C90.9911%2024.6711%2090.2998%2025.7053%2089.0821%2025.7053ZM89.0402%2020.3981H85.1375V31.4097H86.7655V27.2379H89.0402C90.8453%2027.2379%2092.6199%2025.9184%2092.6199%2023.8176C92.6199%2021.7168%2090.8453%2020.3981%2089.0402%2020.3981ZM67.7583%2030.1606C66.6332%2030.1606%2065.6913%2029.2102%2065.6913%2027.9047C65.6913%2026.5852%2066.6332%2025.6198%2067.7583%2025.6198C68.8695%2025.6198%2069.7406%2026.5852%2069.7406%2027.9047C69.7406%2029.2102%2068.8695%2030.1606%2067.7583%2030.1606ZM69.6289%2024.9812H69.5722C69.2064%2024.5417%2068.5038%2024.1444%2067.6178%2024.1444C65.7611%2024.1444%2064.0599%2025.7898%2064.0599%2027.9047C64.0599%2030.0047%2065.7611%2031.6369%2067.6178%2031.6369C68.5038%2031.6369%2069.2064%2031.2396%2069.5722%2030.7851H69.6289V31.3251C69.6289%2032.7582%2068.8695%2033.5246%2067.6457%2033.5246C66.6471%2033.5246%2066.0282%2032.8005%2065.7751%2032.1901L64.3549%2032.7864C64.7626%2033.78%2065.8458%2035%2067.6457%2035C69.5582%2035%2071.1757%2033.8646%2071.1757%2031.0978V24.3708H69.6289V24.9812ZM72.3008%2031.4097H73.9323V20.3973H72.3008V31.4097ZM76.3362%2027.777C76.2943%2026.3298%2077.4474%2025.5916%2078.2766%2025.5916C78.9243%2025.5916%2079.4725%2025.9176%2079.6549%2026.3862L76.3362%2027.777ZM81.3989%2026.528C81.0899%2025.6912%2080.1472%2024.1444%2078.2208%2024.1444C76.3083%2024.1444%2074.7196%2025.6621%2074.7196%2027.8907C74.7196%2029.9906%2076.2943%2031.6369%2078.4032%2031.6369C80.1053%2031.6369%2081.0899%2030.5869%2081.4976%2029.9765L80.2319%2029.1247C79.8103%2029.7493%2079.2333%2030.1606%2078.4032%2030.1606C77.5739%2030.1606%2076.983%2029.7774%2076.6033%2029.0261L81.5674%2026.9534L81.3989%2026.528ZM41.8501%2025.2939V26.883H45.6184C45.5058%2027.777%2045.2107%2028.4297%2044.7612%2028.8834C44.2121%2029.4374%2043.3541%2030.0479%2041.8501%2030.0479C39.5291%2030.0479%2037.7152%2028.1602%2037.7152%2025.8189C37.7152%2023.4767%2039.5291%2021.5899%2041.8501%2021.5899C43.1018%2021.5899%2044.0157%2022.0867%2044.6905%2022.7254L45.8017%2021.604C44.8589%2020.6959%2043.6081%2020%2041.8501%2020C38.6719%2020%2036%2022.6117%2036%2025.8189C36%2029.0261%2038.6719%2031.6369%2041.8501%2031.6369C43.5653%2031.6369%2044.8589%2031.0688%2045.8715%2030.0047C46.9129%2028.9547%2047.2358%2027.4793%2047.2358%2026.2866C47.2358%2025.9176%2047.2079%2025.5775%2047.1512%2025.2939H41.8501ZM51.5208%2030.1606C50.3957%2030.1606%2049.425%2029.2243%2049.425%2027.8907C49.425%2026.5421%2050.3957%2025.6198%2051.5208%2025.6198C52.6451%2025.6198%2053.6158%2026.5421%2053.6158%2027.8907C53.6158%2029.2243%2052.6451%2030.1606%2051.5208%2030.1606ZM51.5208%2024.1444C49.4669%2024.1444%2047.7936%2025.7194%2047.7936%2027.8907C47.7936%2030.0479%2049.4669%2031.6369%2051.5208%2031.6369C53.5739%2031.6369%2055.2472%2030.0479%2055.2472%2027.8907C55.2472%2025.7194%2053.5739%2024.1444%2051.5208%2024.1444ZM59.65%2030.1606C58.5249%2030.1606%2057.5542%2029.2243%2057.5542%2027.8907C57.5542%2026.5421%2058.5249%2025.6198%2059.65%2025.6198C60.7752%2025.6198%2061.745%2026.5421%2061.745%2027.8907C61.745%2029.2243%2060.7752%2030.1606%2059.65%2030.1606ZM59.65%2024.1444C57.597%2024.1444%2055.9237%2025.7194%2055.9237%2027.8907C55.9237%2030.0479%2057.597%2031.6369%2059.65%2031.6369C61.7031%2031.6369%2063.3764%2030.0479%2063.3764%2027.8907C63.3764%2025.7194%2061.7031%2024.1444%2059.65%2024.1444Z'%20fill='%231B1B1B'/%3e%3c/svg%3e", Zq = { class: "mobile-apps" }, xq = ["href"], Wq = ["href"], Yq = {
  __name: "F3MobileApps",
  props: {
    iosLink: {
      type: String,
      default: ""
    },
    androidLink: {
      type: String,
      default: ""
    },
    isPreview: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return (t, n) => (d(), f("div", Zq, [
      e.iosLink || e.isPreview ? (d(), f("a", {
        key: 0,
        href: e.iosLink,
        target: "_blank",
        "data-mobile-app": "ios"
      }, n[0] || (n[0] = [
        c("img", {
          class: "app-link",
          src: Kq,
          alt: "Download our iOS App",
          "data-testid": "app-icon"
        }, null, -1)
      ]), 8, xq)) : T("", !0),
      e.androidLink || e.isPreview ? (d(), f("a", {
        key: 1,
        href: e.androidLink,
        target: "_blank",
        "data-mobile-app": "android"
      }, n[1] || (n[1] = [
        c("img", {
          class: "app-link",
          src: zq,
          alt: "Download our Android App",
          "data-testid": "app-icon"
        }, null, -1)
      ]), 8, Wq)) : T("", !0)
    ]));
  }
}, Xq = /* @__PURE__ */ B(Yq, [["__scopeId", "data-v-ad4995b9"]]), Qq = { class: "social-links" }, Jq = ["data-social-media"], eG = ["href", "aria-label"], tG = ["innerHTML"], nG = {
  __name: "F3SocialLinks",
  props: {
    content: {
      type: Object,
      required: !0,
      default: () => ({})
    },
    isPreview: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, n = [
      {
        key: "twitter",
        name: "twitter",
        label: "Visit us on X, formerly Twitter",
        icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.84808 3.89844C8.21062 3.89844 8.55016 4.07708 8.75531 4.37598L12.5619 9.9248L17.5375 4.16309C17.6826 3.99506 17.8937 3.89844 18.1157 3.89844C18.7692 3.89854 19.1208 4.66631 18.6938 5.16113L13.4555 11.2275L19.0444 19.376C19.5451 20.1059 19.0223 21.0986 18.1371 21.0986H15.1879C14.8254 21.0986 14.4858 20.92 14.2807 20.6211L10.3246 14.8545L5.16644 20.834C5.02135 21.0019 4.81021 21.0986 4.58832 21.0986C3.93487 21.0984 3.58354 20.3308 4.01019 19.8359L9.43207 13.5518L3.99164 5.62109C3.49093 4.89115 4.01369 3.89844 4.89886 3.89844H7.84808ZM15.1918 19.0908C15.3596 19.3355 15.6374 19.4814 15.934 19.4814H17.1567L7.84418 5.90625C7.67634 5.66157 7.39869 5.51465 7.10199 5.51465H5.88031L15.1918 19.0908Z" fill="white"/></svg>'
      },
      {
        key: "instagram",
        name: "instagram",
        label: "Visit us on Instagram",
        icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 4.75C6.20507 4.75 4.75 6.20507 4.75 8V16C4.75 17.7949 6.20507 19.25 8 19.25H16C17.7949 19.25 19.25 17.7949 19.25 16V8C19.25 6.20507 17.7949 4.75 16 4.75H8ZM3.25 8C3.25 5.37665 5.37665 3.25 8 3.25H16C18.6234 3.25 20.75 5.37665 20.75 8V16C20.75 18.6234 18.6234 20.75 16 20.75H8C5.37665 20.75 3.25 18.6234 3.25 16V8ZM15.65 7.6C15.65 7.18579 15.9858 6.85 16.4 6.85H16.408C16.8222 6.85 17.158 7.18579 17.158 7.6C17.158 8.01421 16.8222 8.35 16.408 8.35H16.4C15.9858 8.35 15.65 8.01421 15.65 7.6ZM12.394 9.54189C11.8842 9.4663 11.3636 9.55337 10.9062 9.79071C10.4488 10.0281 10.0779 10.4036 9.84619 10.8639C9.6145 11.3242 9.53386 11.8458 9.61573 12.3546C9.6976 12.8634 9.93781 13.3334 10.3022 13.6978C10.6666 14.0622 11.1366 14.3024 11.6454 14.3843C12.1542 14.4661 12.6758 14.3855 13.1361 14.1538C13.5964 13.9221 13.9719 13.5512 14.2093 13.0938C14.4466 12.6364 14.5337 12.1158 14.4581 11.606C14.381 11.086 14.1387 10.6047 13.767 10.233C13.3953 9.86128 12.914 9.61899 12.394 9.54189ZM10.2154 8.45928C10.9528 8.07662 11.7922 7.93624 12.614 8.05811C13.4523 8.18242 14.2284 8.57306 14.8277 9.17232C15.4269 9.77157 15.8176 10.5477 15.9419 11.386C16.0638 12.2078 15.9234 13.0472 15.5407 13.7846C15.1581 14.5221 14.5526 15.1201 13.8105 15.4937C13.0684 15.8672 12.2274 15.9972 11.4071 15.8652C10.5868 15.7332 9.82903 15.3459 9.24154 14.7585C8.65406 14.171 8.26677 13.4132 8.13478 12.5929C8.00279 11.7726 8.1328 10.9316 8.50633 10.1895C8.87987 9.44738 9.4779 8.84193 10.2154 8.45928Z" fill="white"/></svg>'
      },
      {
        key: "facebook",
        name: "facebook",
        label: "Visit us on Facebook",
        icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.1409 4.64124C12.0317 3.75044 13.2398 3.25 14.4996 3.25H16.8996C17.3138 3.25 17.6496 3.58579 17.6496 4V7.2C17.6496 7.61421 17.3138 7.95 16.8996 7.95H14.4996C14.4863 7.95 14.4736 7.95527 14.4643 7.96464C14.4549 7.97402 14.4496 7.98674 14.4496 8V9.65H16.8996C17.1306 9.65 17.3486 9.7564 17.4908 9.93844C17.6329 10.1205 17.6832 10.3578 17.6272 10.5819L16.8272 13.7819C16.7437 14.1158 16.4438 14.35 16.0996 14.35H14.4496V20C14.4496 20.4142 14.1138 20.75 13.6996 20.75H10.4996C10.0854 20.75 9.74961 20.4142 9.74961 20V14.35H8.09961C7.6854 14.35 7.34961 14.0142 7.34961 13.6V10.4C7.34961 9.98579 7.6854 9.65 8.09961 9.65H9.74961V8C9.74961 6.74022 10.2501 5.53204 11.1409 4.64124ZM14.4996 4.75C13.6377 4.75 12.811 5.09241 12.2015 5.7019C11.592 6.3114 11.2496 7.13805 11.2496 8V10.4C11.2496 10.8142 10.9138 11.15 10.4996 11.15H8.84961V12.85H10.4996C10.9138 12.85 11.2496 13.1858 11.2496 13.6V19.25H12.9496V13.6C12.9496 13.1858 13.2854 12.85 13.6996 12.85H15.514L15.939 11.15H13.6996C13.2854 11.15 12.9496 10.8142 12.9496 10.4V8C12.9496 7.58891 13.1129 7.19467 13.4036 6.90398C13.6943 6.6133 14.0885 6.45 14.4996 6.45H16.1496V4.75H14.4996Z" fill="white"/></svg>'
      },
      {
        key: "threads",
        name: "threads",
        label: "Visit us on Threads",
        icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.8286 11.4157C15.7597 11.3827 15.6897 11.3509 15.6188 11.3204C15.4953 9.04485 14.2519 7.74208 12.164 7.72875C12.1546 7.72869 12.1451 7.72869 12.1357 7.72869C10.8869 7.72869 9.84828 8.26174 9.20902 9.23173L10.3573 10.0194C10.8348 9.29486 11.5843 9.1404 12.1362 9.1404C12.1426 9.1404 12.149 9.1404 12.1553 9.14046C12.8428 9.14484 13.3615 9.34472 13.6973 9.7345C13.9416 10.0183 14.105 10.4104 14.1859 10.9053C13.5764 10.8017 12.9173 10.7699 12.2126 10.8103C10.2276 10.9246 8.95145 12.0823 9.03715 13.691C9.08065 14.507 9.48716 15.209 10.1818 15.6676C10.7691 16.0553 11.5254 16.2448 12.3115 16.2019C13.3497 16.145 14.1641 15.7489 14.7323 15.0247C15.1638 14.4747 15.4367 13.7619 15.5572 12.8638C16.0519 13.1624 16.4186 13.5553 16.6211 14.0277C16.9654 14.8306 16.9855 16.15 15.9089 17.2257C14.9657 18.168 13.8319 18.5757 12.1183 18.5883C10.2175 18.5742 8.78 17.9646 7.84536 16.7764C6.97015 15.6638 6.51783 14.0568 6.50095 12C6.51783 9.94315 6.97015 8.33613 7.84536 7.22356C8.78 6.03541 10.2175 5.42583 12.1183 5.41171C14.0329 5.42594 15.4954 6.03845 16.4659 7.23233C16.9417 7.8178 17.3004 8.55407 17.5369 9.41253L18.8825 9.05352C18.5959 7.99685 18.1448 7.08631 17.5309 6.33117C16.2869 4.80056 14.4674 4.01626 12.123 4H12.1136C9.77399 4.01621 7.97486 4.80348 6.76621 6.33994C5.69068 7.7072 5.13589 9.60964 5.11725 11.9944L5.11719 12L5.11725 12.0056C5.13589 14.3903 5.69068 16.2928 6.76621 17.6601C7.97486 19.1965 9.77399 19.9838 12.1136 20H12.123C14.203 19.9856 15.6692 19.441 16.877 18.2343C18.4573 16.6555 18.4097 14.6766 17.8889 13.4618C17.5152 12.5906 16.8028 11.883 15.8286 11.4157ZM12.2372 14.7923C11.3672 14.8413 10.4634 14.4508 10.4188 13.6143C10.3858 12.9942 10.8602 12.3022 12.2906 12.2197C12.4544 12.2103 12.6152 12.2057 12.7731 12.2057C13.2927 12.2057 13.7788 12.2561 14.2207 12.3528C14.0559 14.4113 13.089 14.7455 12.2372 14.7923Z" fill="white"/></svg>'
      },
      {
        key: "youtube",
        name: "youtube",
        label: "Visit us on Youtube",
        icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.06475 6.33287C3.86849 6.39253 3.68975 6.49964 3.54446 6.64494C3.39567 6.79372 3.28693 6.97758 3.22817 7.1794C2.55806 10.3582 2.55806 13.6418 3.22817 16.8206C3.28693 17.0224 3.39567 17.2063 3.54446 17.3551C3.68975 17.5004 3.86849 17.6075 4.06475 17.6671C9.31916 18.533 14.6799 18.533 19.9343 17.6671C20.1305 17.6075 20.3093 17.5004 20.4546 17.3551C20.6034 17.2063 20.7121 17.0224 20.7709 16.8206C21.441 13.6418 21.441 10.3582 20.7709 7.1794C20.7121 6.97758 20.6034 6.79372 20.4546 6.64494C20.3093 6.49964 20.1305 6.39253 19.9343 6.33287C14.6799 5.46717 9.31917 5.46717 4.06475 6.33287ZM3.77694 4.86008C9.22155 3.9581 14.7775 3.9581 20.2221 4.86008C20.2476 4.86431 20.2729 4.86985 20.2978 4.87669C20.7582 5.0029 21.1777 5.24676 21.5152 5.58428C21.8528 5.9218 22.0966 6.34136 22.2228 6.80169C22.2267 6.81587 22.2302 6.83015 22.2332 6.84453C22.9535 10.2438 22.9535 13.7562 22.2332 17.1555C22.2302 17.1698 22.2267 17.1841 22.2228 17.1983C22.0966 17.6586 21.8528 18.0782 21.5152 18.4157C21.1777 18.7532 20.7582 18.9971 20.2978 19.1233C20.2729 19.1301 20.2476 19.1357 20.2221 19.1399C14.7775 20.0421 9.22153 20.0421 3.77692 19.1399C3.75141 19.1357 3.72614 19.1301 3.70121 19.1233C3.24087 18.9971 2.82132 18.7532 2.4838 18.4157C2.14628 18.0782 1.90242 17.6586 1.77621 17.1983C1.77232 17.1841 1.76886 17.1698 1.76581 17.1555C1.04551 13.7562 1.04551 10.2438 1.76581 6.84453C1.76886 6.83015 1.77232 6.81587 1.77621 6.80169C1.90242 6.34136 2.14628 5.9218 2.4838 5.58428C2.82131 5.24676 3.24087 5.0029 3.70121 4.87669C3.72615 4.86985 3.75143 4.86431 3.77694 4.86008ZM9.62999 8.34735C9.86513 8.21422 10.1537 8.21786 10.3854 8.35688L15.3854 11.3569C15.6113 11.4924 15.7495 11.7366 15.7495 12C15.7495 12.2634 15.6113 12.5076 15.3854 12.6431L10.3854 15.6431C10.1537 15.7821 9.86513 15.7858 9.62999 15.6526C9.39486 15.5195 9.24952 15.2702 9.24952 15V9C9.24952 8.72979 9.39486 8.48048 9.62999 8.34735ZM10.7495 10.3246V13.6754L13.5418 12L10.7495 10.3246Z" fill="white"/></svg>'
      },
      {
        key: "linkedin",
        name: "linkedin",
        label: "Visit us on LinkedIn",
        icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.22861 4.75C4.69959 4.75 4.28266 5.17484 4.28266 5.68421C4.28266 6.19358 4.69959 6.61842 5.22861 6.61842C5.75762 6.61842 6.17455 6.19358 6.17455 5.68421C6.17455 5.17484 5.75762 4.75 5.22861 4.75ZM2.78906 5.68421C2.78906 4.33325 3.88787 3.25 5.22861 3.25C6.56934 3.25 7.66815 4.33325 7.66815 5.68421C7.66815 7.03517 6.56935 8.11842 5.22861 8.11842C3.88787 8.11842 2.78906 7.03517 2.78906 5.68421ZM15.3851 9.80263C14.2341 9.80263 13.1316 10.2576 12.3198 11.0653C11.5083 11.8728 11.0536 12.9664 11.0536 14.1053V19.25H12.9455V14.1053C12.9455 13.4574 13.2043 12.8375 13.6625 12.3815C14.1206 11.9258 14.7403 11.6711 15.3851 11.6711C16.0299 11.6711 16.6496 11.9258 17.1076 12.3815C17.5659 12.8375 17.8246 13.4574 17.8246 14.1053V19.25H19.7165V14.1053C19.7165 12.9664 19.2619 11.8728 18.4503 11.0653C17.6386 10.2576 16.5361 9.80263 15.3851 9.80263ZM11.2686 9.99971C12.3616 8.91229 13.8424 8.30263 15.3851 8.30263C16.9277 8.30263 18.4086 8.91229 19.5015 9.99971C20.5947 11.0874 21.2101 12.564 21.2101 14.1053V20C21.2101 20.4142 20.8758 20.75 20.4633 20.75H17.0778C16.6654 20.75 16.331 20.4142 16.331 20V14.1053C16.331 13.8598 16.2331 13.6229 16.0564 13.4471C15.8796 13.2712 15.6382 13.1711 15.3851 13.1711C15.132 13.1711 14.8906 13.2712 14.7137 13.4471C14.5371 13.6229 14.4391 13.8598 14.4391 14.1053V20C14.4391 20.4142 14.1048 20.75 13.6923 20.75H10.3068C9.8944 20.75 9.56004 20.4142 9.56004 20V14.1053C9.56004 12.564 10.1755 11.0874 11.2686 9.99971ZM2.78906 9.89474C2.78906 9.48052 3.12342 9.14474 3.53586 9.14474H6.92135C7.3338 9.14474 7.66815 9.48052 7.66815 9.89474V20C7.66815 20.4142 7.3338 20.75 6.92135 20.75H3.53586C3.12342 20.75 2.78906 20.4142 2.78906 20V9.89474ZM4.28266 10.6447V19.25H6.17455V10.6447H4.28266Z" fill="white"/></svg>'
      }
    ], r = Re(() => n.filter((o) => t.content[o.key] || t.isPreview));
    return (o, i) => (d(), f("ul", Qq, [
      (d(!0), f(J, null, ne(r.value, (a) => (d(), f("li", {
        key: a.key,
        "data-social-media": a.name,
        "data-testid": "social-icon"
      }, [
        c("a", {
          href: e.content[a.key],
          target: "_blank",
          "aria-label": a.label
        }, [
          c("span", {
            innerHTML: a.icon
          }, null, 8, tG)
        ], 8, eG)
      ], 8, Jq))), 128))
    ]));
  }
}, rG = /* @__PURE__ */ B(nG, [["__scopeId", "data-v-252ff1aa"]]), oG = {
  href: "https://www.apptegy.com",
  target: "_blank",
  class: "notranslate"
}, iG = { class: "sr-only" }, sG = {
  __name: "F3Copyright",
  props: {
    translations: {
      type: Object,
      required: !0,
      default: () => ({})
    },
    org: {
      type: String,
      required: !0
    },
    theme: {
      type: Object,
      required: !0,
      default: () => ({ version: "" })
    }
  },
  setup(e) {
    const t = e, n = Re(() => (/* @__PURE__ */ new Date()).getFullYear()), r = Re(() => t.theme.version ? t.theme.version.toLowerCase() : "");
    return (o, i) => (d(), f("div", {
      class: _(["apptegy-copyright", r.value])
    }, [
      c("span", null, [
        H(k(e.translations.copyright) + " © " + k(n.value) + ". " + k(e.org) + ". " + k(e.translations.all_rights_reserved) + " " + k(e.translations.powered_by) + " ", 1),
        c("a", oG, [
          i[0] || (i[0] = H(" Apptegy")),
          c("span", iG, k(e.translations.visit_us), 1)
        ]),
        i[1] || (i[1] = H(". "))
      ])
    ], 2));
  }
}, aG = /* @__PURE__ */ B(sG, [["__scopeId", "data-v-37499707"]]), lG = {
  name: "F3",
  components: {
    FooterHeader: J3,
    FooterLink: e8,
    FooterImage: n8,
    FooterTextField: t8,
    F3ContactInfo: Gq,
    F3MobileApps: Xq,
    F3SocialLinks: rG,
    F3Copyright: aG
  },
  mixins: [rh],
  computed: {
    showContactInfo() {
      return Object.values(this.info).some(Boolean);
    },
    showMobileApps() {
      return this.content.hasApps || this.isPreview;
    },
    showSocialLinks() {
      return this.content.hasSocial || this.isPreview;
    },
    enableImage() {
      var e, t;
      return (t = (e = this.theme) == null ? void 0 : e.enable_image) != null ? t : !1;
    },
    numColumns() {
      var e, t;
      return (t = (e = this.theme) == null ? void 0 : e.num_columns) != null ? t : 1;
    },
    wrapperClasses() {
      return [`layout-cols-${this.numColumns}`, this.enableImage ? "with-image" : "no-image"];
    }
  }
}, uG = { class: "columns-wrapper" }, dG = {
  key: 0,
  class: "logo-wrapper"
}, cG = ["src"], hG = { class: "columns-area" }, mG = { class: "column-item-content" }, fG = ["innerHTML"], pG = {
  key: 0,
  class: "column-item-content"
}, gG = {
  key: 0,
  class: "image-area"
}, vG = ["src", "alt"], bG = ["innerHTML"];
function yG(e, t, n, r, o, i) {
  var m, v;
  const a = V("F3ContactInfo"), s = V("F3MobileApps"), l = V("F3SocialLinks"), u = V("F3Copyright");
  return d(), f("footer", {
    id: "footer-f3",
    style: Z(e.cssVars)
  }, [
    c("div", {
      class: _(["content-wrapper", i.wrapperClasses])
    }, [
      c("div", uG, [
        e.content.hasLogo || e.isPreview ? (d(), f("div", dG, [
          c("img", {
            src: e.logoImage,
            alt: "logo",
            class: "footer-logo"
          }, null, 8, cG)
        ])) : T("", !0),
        c("div", hG, [
          (d(!0), f(J, null, ne(i.numColumns, (g) => (d(), f("div", {
            key: `column-${g}`,
            class: "column-item"
          }, [
            g === 1 ? (d(), f(J, { key: 0 }, [
              c("div", mG, [
                e.firstColumnHeader ? (d(), f("h2", {
                  key: 0,
                  class: _(e.theme.style)
                }, k(e.firstColumnHeader), 3)) : T("", !0),
                i.showContactInfo ? (d(), L(a, {
                  key: 1,
                  info: e.info
                }, null, 8, ["info"])) : T("", !0)
              ]),
              i.showMobileApps ? (d(), L(s, {
                key: 0,
                "is-preview": e.isPreview,
                "ios-link": e.iosLink,
                "android-link": e.androidLink
              }, null, 8, ["is-preview", "ios-link", "android-link"])) : T("", !0),
              i.showSocialLinks ? (d(), L(l, {
                key: 1,
                "is-preview": e.isPreview,
                content: e.content
              }, null, 8, ["is-preview", "content"])) : T("", !0),
              e.content.hasAdditionalText && e.content.additionalTextAlignment === "left" ? (d(), f("div", {
                key: 2,
                class: "additional-text",
                innerHTML: e.content.additionalText
              }, null, 8, fG)) : T("", !0)
            ], 64)) : (d(), f(J, { key: 1 }, [
              e.content.columns[g - 1] ? (d(), f("div", pG, [
                e.content.columns[g - 1].hasHeader ? (d(), f("h2", {
                  key: 0,
                  class: _(e.theme.style)
                }, k(e.content.columns[g - 1].header), 3)) : T("", !0),
                c("ul", null, [
                  (d(!0), f(J, null, ne(e.content.columns[g - 1].items, (h, E) => (d(), f("li", { key: E }, [
                    (d(), L(Y(h.type), {
                      item: h,
                      theme: e.theme,
                      class: _(e.theme.style)
                    }, null, 8, ["item", "theme", "class"]))
                  ]))), 128))
                ])
              ])) : T("", !0)
            ], 64))
          ]))), 128))
        ])
      ]),
      i.enableImage ? (d(), f("div", gG, [
        c("img", {
          src: (m = e.content.image) == null ? void 0 : m.url,
          alt: (v = e.content.image) == null ? void 0 : v.alt_text
        }, null, 8, vG)
      ])) : T("", !0)
    ], 2),
    e.content.hasAdditionalText && e.content.additionalTextAlignment === "center" ? (d(), f("div", {
      key: 0,
      class: "additional-text center",
      innerHTML: e.content.additionalText
    }, null, 8, bG)) : T("", !0),
    j(u, {
      translations: e.translations,
      org: e.copyrightOrg,
      theme: e.theme
    }, null, 8, ["translations", "org", "theme"])
  ], 4);
}
const _G = /* @__PURE__ */ B(lG, [["render", yG], ["__scopeId", "data-v-79570736"]]), CG = {
  name: "CmsFooter",
  components: {
    F1: tq,
    F2: Lq,
    F3: _G,
    CustomHtml: Ys
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      default: () => ({})
    },
    organizations: {
      type: Array,
      default: () => []
    },
    iosLink: {
      type: String,
      default: ""
    },
    androidLink: {
      type: String,
      default: ""
    },
    isPreview: Boolean,
    isIFrame: Boolean,
    currentDomain: {
      type: String,
      default: null
    },
    logo: {
      type: String,
      default: ""
    }
  },
  computed: {
    themeVersion() {
      var e, t;
      return ((t = (e = this.theme) == null ? void 0 : e.version) == null ? void 0 : t.toLowerCase()) || "";
    },
    translations() {
      return this.theme.translations;
    },
    cssVars() {
      return {
        "--bg-color": $(this.theme, "bg_color.hex", "#ffffff"),
        "--separator-color": $(this.theme, "separator_color.hex", "#ffffff"),
        "--text-color": $(this.theme, "text_link_color.hex", "#000000"),
        "--apptegy-link-color": $(this.theme, "apptegy_link_color.hex", "#000000"),
        "--social-media-icon-color": $(this.theme, "social_media_icon_color.hex", "#000000")
      };
    }
  }
};
function wG(e, t, n, r, o, i) {
  const a = V("custom-html");
  return d(), f("div", null, [
    n.theme.version !== "CustomFooter" ? (d(), f("div", {
      key: 0,
      id: "cms-footer",
      style: Z(i.cssVars)
    }, [
      (d(), L(Y(n.theme.version), {
        theme: n.theme,
        content: n.content,
        organizations: n.organizations,
        "ios-link": n.iosLink,
        "android-link": n.androidLink,
        "is-preview": n.isPreview,
        "is-i-frame": n.isIFrame,
        "current-domain": n.currentDomain,
        logo: n.logo
      }, null, 8, ["theme", "content", "organizations", "ios-link", "android-link", "is-preview", "is-i-frame", "current-domain", "logo"]))
    ], 4)) : (d(), L(a, {
      key: 1,
      theme: n.theme
    }, null, 8, ["theme"]))
  ]);
}
const TG = /* @__PURE__ */ B(CG, [["render", wG], ["__scopeId", "data-v-182ba638"]]);
var wd, xf;
function kG() {
  if (xf) return wd;
  xf = 1;
  var e = As();
  function t() {
    this.__data__ = new e(), this.size = 0;
  }
  return wd = t, wd;
}
var Td, Wf;
function EG() {
  if (Wf) return Td;
  Wf = 1;
  function e(t) {
    var n = this.__data__, r = n.delete(t);
    return this.size = n.size, r;
  }
  return Td = e, Td;
}
var kd, Yf;
function SG() {
  if (Yf) return kd;
  Yf = 1;
  function e(t) {
    return this.__data__.get(t);
  }
  return kd = e, kd;
}
var Ed, Xf;
function MG() {
  if (Xf) return Ed;
  Xf = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return Ed = e, Ed;
}
var Sd, Qf;
function AG() {
  if (Qf) return Sd;
  Qf = 1;
  var e = As(), t = u0(), n = fg(), r = 200;
  function o(i, a) {
    var s = this.__data__;
    if (s instanceof e) {
      var l = s.__data__;
      if (!t || l.length < r - 1)
        return l.push([i, a]), this.size = ++s.size, this;
      s = this.__data__ = new n(l);
    }
    return s.set(i, a), this.size = s.size, this;
  }
  return Sd = o, Sd;
}
var Md, Jf;
function IG() {
  if (Jf) return Md;
  Jf = 1;
  var e = As(), t = kG(), n = EG(), r = SG(), o = MG(), i = AG();
  function a(s) {
    var l = this.__data__ = new e(s);
    this.size = l.size;
  }
  return a.prototype.clear = t, a.prototype.delete = n, a.prototype.get = r, a.prototype.has = o, a.prototype.set = i, Md = a, Md;
}
var Ad, ep;
function LG() {
  if (ep) return Ad;
  ep = 1;
  function e(t, n) {
    for (var r = -1, o = t == null ? 0 : t.length; ++r < o && n(t[r], r, t) !== !1; )
      ;
    return t;
  }
  return Ad = e, Ad;
}
var Id, tp;
function DG() {
  if (tp) return Id;
  tp = 1;
  var e = jr(), t = function() {
    try {
      var n = e(Object, "defineProperty");
      return n({}, "", {}), n;
    } catch (r) {
    }
  }();
  return Id = t, Id;
}
var Ld, np;
function u8() {
  if (np) return Ld;
  np = 1;
  var e = DG();
  function t(n, r, o) {
    r == "__proto__" && e ? e(n, r, {
      configurable: !0,
      enumerable: !0,
      value: o,
      writable: !0
    }) : n[r] = o;
  }
  return Ld = t, Ld;
}
var Dd, rp;
function d8() {
  if (rp) return Dd;
  rp = 1;
  var e = u8(), t = l0(), n = Object.prototype, r = n.hasOwnProperty;
  function o(i, a, s) {
    var l = i[a];
    (!(r.call(i, a) && t(l, s)) || s === void 0 && !(a in i)) && e(i, a, s);
  }
  return Dd = o, Dd;
}
var $d, op;
function Xs() {
  if (op) return $d;
  op = 1;
  var e = d8(), t = u8();
  function n(r, o, i, a) {
    var s = !i;
    i || (i = {});
    for (var l = -1, u = o.length; ++l < u; ) {
      var m = o[l], v = a ? a(i[m], r[m], m, i, r) : void 0;
      v === void 0 && (v = r[m]), s ? t(i, m, v) : e(i, m, v);
    }
    return i;
  }
  return $d = n, $d;
}
var Od, ip;
function $G() {
  if (ip) return Od;
  ip = 1;
  function e(t, n) {
    for (var r = -1, o = Array(t); ++r < t; )
      o[r] = n(r);
    return o;
  }
  return Od = e, Od;
}
var Pd, sp;
function c8() {
  if (sp) return Pd;
  sp = 1;
  var e = 9007199254740991, t = /^(?:0|[1-9]\d*)$/;
  function n(r, o) {
    var i = typeof r;
    return o = o == null ? e : o, !!o && (i == "number" || i != "symbol" && t.test(r)) && r > -1 && r % 1 == 0 && r < o;
  }
  return Pd = n, Pd;
}
var Nd, ap;
function h8() {
  if (ap) return Nd;
  ap = 1;
  var e = $G(), t = Cg(), n = Br(), r = c0(), o = c8(), i = Tg(), a = Object.prototype, s = a.hasOwnProperty;
  function l(u, m) {
    var v = n(u), g = !v && t(u), h = !v && !g && r(u), E = !v && !g && !h && i(u), C = v || g || h || E, A = C ? e(u.length, String) : [], R = A.length;
    for (var P in u)
      (m || s.call(u, P)) && !(C && // Safari 9 has enumerable `arguments.length` in strict mode.
      (P == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      h && (P == "offset" || P == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      E && (P == "buffer" || P == "byteLength" || P == "byteOffset") || // Skip index properties.
      o(P, R))) && A.push(P);
    return A;
  }
  return Nd = l, Nd;
}
var Hd, lp;
function oh() {
  if (lp) return Hd;
  lp = 1;
  var e = h8(), t = _g(), n = Os();
  function r(o) {
    return n(o) ? e(o) : t(o);
  }
  return Hd = r, Hd;
}
var Fd, up;
function OG() {
  if (up) return Fd;
  up = 1;
  var e = Xs(), t = oh();
  function n(r, o) {
    return r && e(o, t(o), r);
  }
  return Fd = n, Fd;
}
var Rd, dp;
function PG() {
  if (dp) return Rd;
  dp = 1;
  function e(t) {
    var n = [];
    if (t != null)
      for (var r in Object(t))
        n.push(r);
    return n;
  }
  return Rd = e, Rd;
}
var Vd, cp;
function NG() {
  if (cp) return Vd;
  cp = 1;
  var e = dr(), t = Ds(), n = PG(), r = Object.prototype, o = r.hasOwnProperty;
  function i(a) {
    if (!e(a))
      return n(a);
    var s = t(a), l = [];
    for (var u in a)
      u == "constructor" && (s || !o.call(a, u)) || l.push(u);
    return l;
  }
  return Vd = i, Vd;
}
var Bd, hp;
function ih() {
  if (hp) return Bd;
  hp = 1;
  var e = h8(), t = NG(), n = Os();
  function r(o) {
    return n(o) ? e(o, !0) : t(o);
  }
  return Bd = r, Bd;
}
var jd, mp;
function HG() {
  if (mp) return jd;
  mp = 1;
  var e = Xs(), t = ih();
  function n(r, o) {
    return r && e(o, t(o), r);
  }
  return jd = n, jd;
}
var Qo = { exports: {} };
Qo.exports;
var fp;
function FG() {
  return fp || (fp = 1, function(e, t) {
    var n = hn(), r = t && !t.nodeType && t, o = r && !0 && e && !e.nodeType && e, i = o && o.exports === r, a = i ? n.Buffer : void 0, s = a ? a.allocUnsafe : void 0;
    function l(u, m) {
      if (m)
        return u.slice();
      var v = u.length, g = s ? s(v) : new u.constructor(v);
      return u.copy(g), g;
    }
    e.exports = l;
  }(Qo, Qo.exports)), Qo.exports;
}
var Ud, pp;
function RG() {
  if (pp) return Ud;
  pp = 1;
  function e(t, n) {
    var r = -1, o = t.length;
    for (n || (n = Array(o)); ++r < o; )
      n[r] = t[r];
    return n;
  }
  return Ud = e, Ud;
}
var qd, gp;
function VG() {
  if (gp) return qd;
  gp = 1;
  function e(t, n) {
    for (var r = -1, o = t == null ? 0 : t.length, i = 0, a = []; ++r < o; ) {
      var s = t[r];
      n(s, r, t) && (a[i++] = s);
    }
    return a;
  }
  return qd = e, qd;
}
var Gd, vp;
function m8() {
  if (vp) return Gd;
  vp = 1;
  function e() {
    return [];
  }
  return Gd = e, Gd;
}
var Kd, bp;
function sh() {
  if (bp) return Kd;
  bp = 1;
  var e = VG(), t = m8(), n = Object.prototype, r = n.propertyIsEnumerable, o = Object.getOwnPropertySymbols, i = o ? function(a) {
    return a == null ? [] : (a = Object(a), e(o(a), function(s) {
      return r.call(a, s);
    }));
  } : t;
  return Kd = i, Kd;
}
var zd, yp;
function BG() {
  if (yp) return zd;
  yp = 1;
  var e = Xs(), t = sh();
  function n(r, o) {
    return e(r, t(r), o);
  }
  return zd = n, zd;
}
var Zd, _p;
function f8() {
  if (_p) return Zd;
  _p = 1;
  function e(t, n) {
    for (var r = -1, o = n.length, i = t.length; ++r < o; )
      t[i + r] = n[r];
    return t;
  }
  return Zd = e, Zd;
}
var xd, Cp;
function p8() {
  if (Cp) return xd;
  Cp = 1;
  var e = yg(), t = e(Object.getPrototypeOf, Object);
  return xd = t, xd;
}
var Wd, wp;
function g8() {
  if (wp) return Wd;
  wp = 1;
  var e = f8(), t = p8(), n = sh(), r = m8(), o = Object.getOwnPropertySymbols, i = o ? function(a) {
    for (var s = []; a; )
      e(s, n(a)), a = t(a);
    return s;
  } : r;
  return Wd = i, Wd;
}
var Yd, Tp;
function jG() {
  if (Tp) return Yd;
  Tp = 1;
  var e = Xs(), t = g8();
  function n(r, o) {
    return e(r, t(r), o);
  }
  return Yd = n, Yd;
}
var Xd, kp;
function v8() {
  if (kp) return Xd;
  kp = 1;
  var e = f8(), t = Br();
  function n(r, o, i) {
    var a = o(r);
    return t(r) ? a : e(a, i(r));
  }
  return Xd = n, Xd;
}
var Qd, Ep;
function UG() {
  if (Ep) return Qd;
  Ep = 1;
  var e = v8(), t = sh(), n = oh();
  function r(o) {
    return e(o, n, t);
  }
  return Qd = r, Qd;
}
var Jd, Sp;
function qG() {
  if (Sp) return Jd;
  Sp = 1;
  var e = v8(), t = g8(), n = ih();
  function r(o) {
    return e(o, n, t);
  }
  return Jd = r, Jd;
}
var ec, Mp;
function GG() {
  if (Mp) return ec;
  Mp = 1;
  var e = Object.prototype, t = e.hasOwnProperty;
  function n(r) {
    var o = r.length, i = new r.constructor(o);
    return o && typeof r[0] == "string" && t.call(r, "index") && (i.index = r.index, i.input = r.input), i;
  }
  return ec = n, ec;
}
var tc, Ap;
function KG() {
  if (Ap) return tc;
  Ap = 1;
  var e = hn(), t = e.Uint8Array;
  return tc = t, tc;
}
var nc, Ip;
function ah() {
  if (Ip) return nc;
  Ip = 1;
  var e = KG();
  function t(n) {
    var r = new n.constructor(n.byteLength);
    return new e(r).set(new e(n)), r;
  }
  return nc = t, nc;
}
var rc, Lp;
function zG() {
  if (Lp) return rc;
  Lp = 1;
  var e = ah();
  function t(n, r) {
    var o = r ? e(n.buffer) : n.buffer;
    return new n.constructor(o, n.byteOffset, n.byteLength);
  }
  return rc = t, rc;
}
var oc, Dp;
function ZG() {
  if (Dp) return oc;
  Dp = 1;
  var e = /\w*$/;
  function t(n) {
    var r = new n.constructor(n.source, e.exec(n));
    return r.lastIndex = n.lastIndex, r;
  }
  return oc = t, oc;
}
var ic, $p;
function xG() {
  if ($p) return ic;
  $p = 1;
  var e = ks(), t = e ? e.prototype : void 0, n = t ? t.valueOf : void 0;
  function r(o) {
    return n ? Object(n.call(o)) : {};
  }
  return ic = r, ic;
}
var sc, Op;
function WG() {
  if (Op) return sc;
  Op = 1;
  var e = ah();
  function t(n, r) {
    var o = r ? e(n.buffer) : n.buffer;
    return new n.constructor(o, n.byteOffset, n.length);
  }
  return sc = t, sc;
}
var ac, Pp;
function YG() {
  if (Pp) return ac;
  Pp = 1;
  var e = ah(), t = zG(), n = ZG(), r = xG(), o = WG(), i = "[object Boolean]", a = "[object Date]", s = "[object Map]", l = "[object Number]", u = "[object RegExp]", m = "[object Set]", v = "[object String]", g = "[object Symbol]", h = "[object ArrayBuffer]", E = "[object DataView]", C = "[object Float32Array]", A = "[object Float64Array]", R = "[object Int8Array]", P = "[object Int16Array]", F = "[object Int32Array]", I = "[object Uint8Array]", D = "[object Uint8ClampedArray]", O = "[object Uint16Array]", U = "[object Uint32Array]";
  function q(z, te, ee) {
    var x = z.constructor;
    switch (te) {
      case h:
        return e(z);
      case i:
      case a:
        return new x(+z);
      case E:
        return t(z, ee);
      case C:
      case A:
      case R:
      case P:
      case F:
      case I:
      case D:
      case O:
      case U:
        return o(z, ee);
      case s:
        return new x();
      case l:
      case v:
        return new x(z);
      case u:
        return n(z);
      case m:
        return new x();
      case g:
        return r(z);
    }
  }
  return ac = q, ac;
}
var lc, Np;
function XG() {
  if (Np) return lc;
  Np = 1;
  var e = dr(), t = Object.create, n = /* @__PURE__ */ function() {
    function r() {
    }
    return function(o) {
      if (!e(o))
        return {};
      if (t)
        return t(o);
      r.prototype = o;
      var i = new r();
      return r.prototype = void 0, i;
    };
  }();
  return lc = n, lc;
}
var uc, Hp;
function QG() {
  if (Hp) return uc;
  Hp = 1;
  var e = XG(), t = p8(), n = Ds();
  function r(o) {
    return typeof o.constructor == "function" && !n(o) ? e(t(o)) : {};
  }
  return uc = r, uc;
}
var dc, Fp;
function JG() {
  if (Fp) return dc;
  Fp = 1;
  var e = $s(), t = So(), n = "[object Map]";
  function r(o) {
    return t(o) && e(o) == n;
  }
  return dc = r, dc;
}
var cc, Rp;
function eK() {
  if (Rp) return cc;
  Rp = 1;
  var e = JG(), t = h0(), n = m0(), r = n && n.isMap, o = r ? t(r) : e;
  return cc = o, cc;
}
var hc, Vp;
function tK() {
  if (Vp) return hc;
  Vp = 1;
  var e = $s(), t = So(), n = "[object Set]";
  function r(o) {
    return t(o) && e(o) == n;
  }
  return hc = r, hc;
}
var mc, Bp;
function nK() {
  if (Bp) return mc;
  Bp = 1;
  var e = tK(), t = h0(), n = m0(), r = n && n.isSet, o = r ? t(r) : e;
  return mc = o, mc;
}
var fc, jp;
function rK() {
  if (jp) return fc;
  jp = 1;
  var e = IG(), t = LG(), n = d8(), r = OG(), o = HG(), i = FG(), a = RG(), s = BG(), l = jG(), u = UG(), m = qG(), v = $s(), g = GG(), h = YG(), E = QG(), C = Br(), A = c0(), R = eK(), P = dr(), F = nK(), I = oh(), D = ih(), O = 1, U = 2, q = 4, z = "[object Arguments]", te = "[object Array]", ee = "[object Boolean]", x = "[object Date]", N = "[object Error]", G = "[object Function]", X = "[object GeneratorFunction]", Q = "[object Map]", re = "[object Number]", se = "[object Object]", de = "[object RegExp]", me = "[object Set]", he = "[object String]", _e = "[object Symbol]", De = "[object WeakMap]", Ae = "[object ArrayBuffer]", Ze = "[object DataView]", Je = "[object Float32Array]", Mt = "[object Float64Array]", Vt = "[object Int8Array]", pn = "[object Int16Array]", gn = "[object Int32Array]", vn = "[object Uint8Array]", bn = "[object Uint8ClampedArray]", Dn = "[object Uint16Array]", At = "[object Uint32Array]", ce = {};
  ce[z] = ce[te] = ce[Ae] = ce[Ze] = ce[ee] = ce[x] = ce[Je] = ce[Mt] = ce[Vt] = ce[pn] = ce[gn] = ce[Q] = ce[re] = ce[se] = ce[de] = ce[me] = ce[he] = ce[_e] = ce[vn] = ce[bn] = ce[Dn] = ce[At] = !0, ce[N] = ce[G] = ce[De] = !1;
  function It(le, fe, Pe, Ve, Lt, xe) {
    var be, et = fe & O, mt = fe & U, Xt = fe & q;
    if (Pe && (be = Lt ? Pe(le, Ve, Lt, xe) : Pe(le)), be !== void 0)
      return be;
    if (!P(le))
      return le;
    var yn = C(le);
    if (yn) {
      if (be = g(le), !et)
        return a(le, be);
    } else {
      var tt = v(le), ft = tt == G || tt == X;
      if (A(le))
        return i(le, et);
      if (tt == se || tt == z || ft && !Lt) {
        if (be = mt || ft ? {} : E(le), !et)
          return mt ? l(le, o(be, le)) : s(le, r(be, le));
      } else {
        if (!ce[tt])
          return Lt ? le : {};
        be = h(le, tt, et);
      }
    }
    xe || (xe = new e());
    var _n = xe.get(le);
    if (_n)
      return _n;
    xe.set(le, be), F(le) ? le.forEach(function(Ce) {
      be.add(It(Ce, fe, Pe, Ce, le, xe));
    }) : R(le) && le.forEach(function(Ce, Ne) {
      be.set(Ne, It(Ce, fe, Pe, Ne, le, xe));
    });
    var Yn = Xt ? mt ? m : u : mt ? D : I, Dt = yn ? void 0 : Yn(le);
    return t(Dt || le, function(Ce, Ne) {
      Dt && (Ne = Ce, Ce = le[Ne]), n(be, Ne, It(Ce, fe, Pe, Ne, le, xe));
    }), be;
  }
  return fc = It, fc;
}
var pc, Up;
function oK() {
  if (Up) return pc;
  Up = 1;
  var e = rK(), t = 1, n = 4;
  function r(o) {
    return e(o, t | n);
  }
  return pc = r, pc;
}
var iK = oK();
const sK = /* @__PURE__ */ Eo(iK), ki = {
  mixins: [St],
  components: { DraggableWrapper: yt },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    programs: {
      type: Object,
      required: !0
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    isPreview: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    isPurpleStyle() {
      return this.theme.style === "purple";
    },
    isMonterreyStyle() {
      return this.theme.style === "monterrey";
    },
    colors() {
      const e = this.sharedThemeColors(), t = $(this.theme, "box_bg_color.hex", "none"), n = `${t}cc`;
      return ge(ae({}, e), {
        "--accent-color": $(this.theme, "accent_color.hex", "#fff"),
        "--text-color": $(this.theme, "text_color.hex", "#fff"),
        "--hover-text-color": $(this.theme, "hover_text_color.hex", "initial"),
        "--box-bg-color": t,
        "--box-bg-color-opacity": n,
        "--hover-bg-color": $(this.theme, "hover_bg_color.hex", "initial"),
        "--hover-line-color": $(this.theme, "hover_line_color.hex", "initial"),
        "--title-color": $(this.theme, "title_color.hex", "--heading-color", "initial"),
        "--arrow-icon-color": $(this.theme, "arrow_icon_color.hex", "initial"),
        "--arrow-icon-hover-color": $(this.theme, "arrow_icon_hover_color.hex", "initial"),
        "--arrow-background-color": $(this.theme, "arrow_background_color.hex", "initial"),
        "--program-image-border-color": $(
          this.theme,
          "program_image_border_color.hex",
          $(this.theme, "globalThemeSettings.secondaryColor")
        ),
        "--link-color": $(this.theme, "link_color.hex", "#0070E0"),
        "--link-hover-color": $(this.theme, "link_hover_color.hex", "#0070E0")
      });
    },
    translations() {
      return this.theme.translations || {};
    },
    displayHeaderTop() {
      return this.theme.style === "monterrey" && (this.programs.component_header_top || this.isEditing);
    }
  }
}, aK = {
  name: "P1",
  mixins: [ki],
  data() {
    return {
      hoverIndex: -1,
      editIdx: -1,
      descriptionTabIndex: -1
    };
  },
  computed: {
    getLinkFormData() {
      const e = sK(this.programs.content[this.editIdx].link);
      return this.programs.read_more_link || (e.name = this.programs.content[this.editIdx].title), e;
    }
  },
  methods: {
    showLinkButton(e) {
      return this.hoverIndex === e && this.programs.read_more_link;
    },
    setHoverIndex(e) {
      this.hoverIndex = e;
    },
    async toggleVisibility(e, t) {
      var n, r, o, i;
      this.isEditing || (t.preventDefault(), this.programs.details_on_hover && (this.hoverIndex = this.hoverIndex === e ? -1 : e, this.descriptionTabIndex = -1, await this.$nextTick(), ((r = (n = this.$refs.programDescription) == null ? void 0 : n[0]) == null ? void 0 : r.scrollHeight) > ((i = (o = this.$refs.programDescription) == null ? void 0 : o[0]) == null ? void 0 : i.clientHeight) && (this.descriptionTabIndex = 0, this.$refs.programDescription[0].focus({ showFocus: !0 }))));
    },
    closeOnBlur(e) {
      e.currentTarget.contains(e.relatedTarget) || (this.hoverIndex = -1);
    }
  }
}, lK = ["data-testid"], uK = ["data-testid"], dK = ["tabindex", "aria-haspopup", "aria-labelledby", "aria-describedby", "role", "onKeydown", "onFocus", "onMouseover"], cK = ["src", "alt"], hK = {
  key: 1,
  class: "program-image"
}, mK = {
  key: 0,
  class: "hover-content"
}, fK = {
  class: "middle",
  role: "document"
}, pK = ["id"], gK = ["id", "tabindex"], vK = {
  key: 0,
  class: "program-link"
}, bK = {
  key: 1,
  maxlength: "26"
};
function yK(e, t, n, r, o, i) {
  const a = V("SeeAllContainer");
  return d(), f("div", {
    id: "programs-p1",
    class: _(e.theme.style),
    style: Z(e.colors)
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        c("h2", {
          "data-testid": `header-${e.theme.style}`
        }, [
          e.displayHeaderTop ? (d(), f("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            M(e.$slots, "header-top", {}, () => [
              H(k(e.programs.component_header_top), 1)
            ], !0)
          ], 8, uK)) : T("", !0),
          M(e.$slots, "header", {}, () => [
            H(k(e.programs.component_header), 1)
          ], !0)
        ], 8, lK)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    (d(), L(Y(e.wrapperComponent), Se(e.wrapperProps, {
      modelValue: e.programs.content,
      "onUpdate:modelValue": t[7] || (t[7] = (s) => e.programs.content = s),
      "item-key": "index",
      class: "programs-wrapper"
    }), {
      item: S(({ element: s, index: l }) => [
        c("div", {
          class: _([e.programs.num_columns === 3 ? "three-column" : "four-column", "program"])
        }, [
          M(e.$slots, "controls", { idx: l }, void 0, !0),
          c("div", {
            class: "image-wrapper image-border-accent",
            tabindex: e.programs.details_on_hover ? 0 : "",
            "aria-haspopup": !!e.programs.details_on_hover,
            "aria-labelledby": e.programs.details_on_hover && `dialog${l}Title`,
            "aria-describedby": e.programs.details_on_hover && `dialog${l}Desc`,
            role: e.programs.details_on_hover && "dialog",
            "data-testid": "program-content",
            onKeydown: [
              K(W((u) => i.toggleVisibility(l, u), ["exact"]), ["enter"]),
              K(W((u) => i.toggleVisibility(l, u), ["exact"]), ["space"])
            ],
            onFocus: (u) => i.toggleVisibility(l, u),
            onBlur: t[5] || (t[5] = (...u) => i.closeOnBlur && i.closeOnBlur(...u)),
            onMouseover: (u) => o.hoverIndex = l,
            onMouseleave: t[6] || (t[6] = (u) => o.hoverIndex = -1)
          }, [
            s.image.url ? (d(), f("img", {
              key: 0,
              src: s.image.url,
              alt: s.image.alt_text,
              loading: "lazy",
              class: "program-image"
            }, null, 8, cK)) : (d(), f("div", hK)),
            c("div", {
              class: _([[
                e.theme.style,
                e.theme.text_background,
                {
                  "hover-enter": e.programs.details_on_hover && o.hoverIndex === l
                }
              ], "content-box"])
            }, [
              e.programs.details_on_hover && o.hoverIndex === l ? (d(), f("div", mK, [
                t[8] || (t[8] = c("div", { class: "top-bar" }, null, -1)),
                c("div", fK, [
                  c("div", {
                    class: _([e.theme.style, "title"])
                  }, [
                    s.link.url && !e.programs.read_more_link ? (d(), L(Y(e.isEditing ? "div" : "a"), {
                      key: 0,
                      id: `dialog${l}Title`,
                      href: s.link.url,
                      target: s.link.opens_in_new_tab ? "_blank" : "",
                      onKeydown: [
                        t[0] || (t[0] = K((u) => i.setHoverIndex(-1), ["tab"])),
                        t[1] || (t[1] = K(W(() => {
                        }, ["exact", "stop"]), ["enter"]))
                      ]
                    }, {
                      default: S(() => [
                        M(e.$slots, "title", { idx: l }, () => [
                          H(k(s.title), 1)
                        ], !0)
                      ]),
                      _: 2
                    }, 1064, ["id", "href", "target"])) : (d(), f("p", {
                      key: 1,
                      id: `dialog${l}Title`,
                      maxlength: "26"
                    }, [
                      M(e.$slots, "title", { idx: l }, () => [
                        H(k(s.title), 1)
                      ], !0)
                    ], 8, pK))
                  ], 2),
                  c("p", {
                    id: `dialog${l}Desc`,
                    ref: "programDescription",
                    class: _([[{ editing: e.isEditing }, e.theme.style], "program-description"]),
                    tabindex: o.descriptionTabIndex,
                    "aria-label": "program-description"
                  }, [
                    M(e.$slots, "description", { idx: l }, () => [
                      H(k(s.description), 1)
                    ], !0)
                  ], 10, gK),
                  i.showLinkButton(l) ? (d(), f("div", vK, [
                    (d(), L(Y(e.isEditing ? "div" : "a"), {
                      "aria-label": s.link.name,
                      href: s.link.url,
                      target: s.link.opens_in_new_tab ? "_blank" : "",
                      onKeydown: [
                        t[2] || (t[2] = K((u) => i.setHoverIndex(-1), ["tab"])),
                        t[3] || (t[3] = K(W(() => {
                        }, ["exact", "stop"]), ["enter"]))
                      ]
                    }, {
                      default: S(() => [
                        M(e.$slots, "link", { idx: l }, () => [
                          H(k(s.link.name), 1)
                        ], !0)
                      ]),
                      _: 2
                    }, 1064, ["aria-label", "href", "target"]))
                  ])) : T("", !0)
                ])
              ])) : (d(), f("div", {
                key: 1,
                class: _(["normal-content title", e.theme.style])
              }, [
                !e.programs.details_on_hover && s.link.url ? (d(), L(Y(e.isEditing ? "div" : "a"), {
                  key: 0,
                  href: s.link.url,
                  target: s.link.opens_in_new_tab ? "_blank" : "",
                  onKeydown: t[4] || (t[4] = K(W(() => {
                  }, ["exact", "stop"]), ["enter"]))
                }, {
                  default: S(() => [
                    M(e.$slots, "title", { idx: l }, () => [
                      H(k(s.title), 1)
                    ], !0)
                  ]),
                  _: 2
                }, 1064, ["href", "target"])) : (d(), f("p", bK, [
                  M(e.$slots, "title", { idx: l }, () => [
                    H(k(s.title), 1)
                  ], !0)
                ]))
              ], 2))
            ], 2)
          ], 40, dK)
        ], 2)
      ]),
      _: 3
    }, 16, ["modelValue"]))
  ], 6);
}
const _K = /* @__PURE__ */ B(aK, [["render", yK], ["__scopeId", "data-v-37097e37"]]), CK = {
  name: "P2",
  mixins: [ki],
  data() {
    return {
      direction: "forward",
      content: []
    };
  },
  computed: {
    seeAllURL() {
      return $(this.programs, "see_all_link.url", !1);
    },
    seeAll() {
      return this.programs.see_all && (!!this.seeAllURL || this.isEditing);
    },
    programRows() {
      let e = [[]];
      return this.programs.content.length > 0 && (e = this.content.slice(1).reduce(
        (t, n, r) => (this.isEditing || r % 4 !== 0 || r === 0 ? t[t.length - 1].push(n) : t.push([n]), t),
        [[]]
      )), this.programs.slider ? [e[0]] : e;
    },
    opensInNewTab() {
      return this.programs.see_all_link.opens_in_new_tab ? "_blank" : "";
    }
  },
  watch: {
    programs: {
      handler(e) {
        this.content = e.content.map((t, n) => ge(ae({}, t), {
          idx: n
        }));
      },
      deep: !0,
      immediate: !0
    }
  },
  methods: {
    previous() {
      this.direction = "backward", this.$nextTick(() => {
        this.content.splice(0, 0, this.content.pop());
      });
    },
    next() {
      this.direction = "forward", this.$nextTick(() => {
        this.content.push(this.content.shift());
      });
    }
  }
}, wK = ["data-testid"], TK = ["data-testid"], kK = ["target", "href", "data-testid"], EK = { class: "main-program" }, SK = {
  key: 0,
  "data-testid": "component-header-top"
}, MK = ["data-testid"], AK = ["target", "href", "data-testid"], IK = { class: "main-program-text" }, LK = {
  key: 0,
  class: "purple arrows"
}, DK = {
  class: "left-arrow-button",
  role: "button"
}, $K = {
  class: "right-arrow-button",
  role: "button"
}, OK = {
  key: 0,
  class: "light-bold arrows"
}, PK = {
  class: "left-arrow-button",
  role: "button"
}, NK = {
  class: "right-arrow-button",
  role: "button"
}, HK = ["src", "alt"], FK = { class: "stacked-programs" }, RK = { class: "small-first-program" }, VK = { class: "aspect-ratio-box" }, BK = ["src", "alt"], jK = { class: "aspect-ratio-box" }, UK = ["src", "alt"], qK = { class: "aspect-ratio-box" }, GK = ["src", "alt"], KK = ["target", "href", "data-testid"];
function zK(e, t, n, r, o, i) {
  const a = V("SeeAllContainer");
  return e.programs.content.length > 0 ? (d(), f("div", {
    key: 0,
    id: "programs-v2",
    style: Z(e.colors),
    class: _(e.theme.style),
    "data-testid": "p2"
  }, [
    e.screenSize <= 960 || e.theme.style === "purple" ? (d(), L(a, {
      key: 0,
      class: _([e.theme.style, "see-all-above"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        c("h2", {
          class: _({ "no-border": !i.seeAll }),
          "data-testid": `header-${e.theme.style}-above`
        }, [
          e.displayHeaderTop ? (d(), f("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            M(e.$slots, "header-top", {}, () => [
              H(k(e.programs.component_header_top), 1)
            ], !0)
          ], 8, TK)) : T("", !0),
          M(e.$slots, "header", {}, () => [
            H(k(e.programs.component_header), 1)
          ], !0)
        ], 10, wK)
      ]),
      default: S(() => [
        i.seeAll && e.screenSize > 600 && e.theme.style !== "purple" ? (d(), f("a", {
          key: 0,
          target: i.opensInNewTab,
          href: `${e.pathPrefix}${i.seeAllURL}`,
          "data-testid": `see-all-${e.theme.style}-above`,
          onClick: t[0] || (t[0] = (s) => e.$emit("edit-see-all-link", s))
        }, [
          H(k(e.programs.see_all_link.name || e.translations.see_all || "See All Programs") + " ", 1),
          M(e.$slots, "link", {}, void 0, !0)
        ], 8, kK)) : T("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"])) : T("", !0),
    c("div", EK, [
      c("div", {
        class: _(["main-program-left", e.theme.style])
      }, [
        e.screenSize > 960 && e.theme.style !== "purple" ? (d(), L(a, {
          key: 0,
          class: _([e.theme.style, "see-all-top"]),
          "theme-options": e.theme
        }, {
          header: S(() => [
            e.theme.style === "monterrey" && (e.programs.component_header_top || e.isEditing) ? (d(), f("h3", SK, [
              M(e.$slots, "header-top", {}, () => [
                H(k(e.programs.component_header_top), 1)
              ], !0)
            ])) : T("", !0),
            c("h2", {
              class: _({ "no-border": !i.seeAll }),
              "data-testid": `header-${e.theme.style}-top`
            }, [
              M(e.$slots, "header", {}, () => [
                H(k(e.programs.component_header), 1)
              ], !0)
            ], 10, MK)
          ]),
          default: S(() => [
            i.seeAll ? (d(), f("a", {
              key: 0,
              class: "hide-on-xs",
              target: i.opensInNewTab,
              href: `${e.pathPrefix}${i.seeAllURL}`,
              "data-testid": `see-all-${e.theme.style}-top`,
              onClick: t[1] || (t[1] = (s) => e.$emit("edit-see-all-link", s))
            }, [
              H(k(e.programs.see_all_link.name || e.translations.see_all || "See All Programs") + " ", 1),
              M(e.$slots, "link", {}, void 0, !0)
            ], 8, AK)) : T("", !0)
          ]),
          _: 3
        }, 8, ["class", "theme-options"])) : T("", !0),
        c("div", IK, [
          e.theme.style === "purple" && e.programs.slider ? (d(), f("div", LK, [
            c("div", DK, [
              (d(), f("svg", {
                class: "purple-left-arrow",
                width: "31",
                height: "71",
                viewBox: "0 0 31 71",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                onClick: t[2] || (t[2] = (...s) => i.previous && i.previous(...s))
              }, t[7] || (t[7] = [
                c("path", {
                  class: "arrow-stroke",
                  d: "M28 68.2969L3 35.6597L28 3.02245",
                  stroke: "#4C4C4C",
                  "stroke-width": "5",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, null, -1)
              ]))),
              t[8] || (t[8] = c("span", { class: "sr-only" }, "Reverse Slider", -1))
            ]),
            c("div", $K, [
              (d(), f("svg", {
                class: "purple-right-arrow",
                width: "31",
                height: "71",
                viewBox: "0 0 31 71",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                onClick: t[3] || (t[3] = (...s) => i.next && i.next(...s))
              }, t[9] || (t[9] = [
                c("path", {
                  class: "arrow-stroke",
                  d: "M3 3.01953L28 35.6567L3 68.294",
                  stroke: "#4C4C4C",
                  "stroke-width": "5",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, null, -1)
              ]))),
              t[10] || (t[10] = c("span", { class: "sr-only" }, "Advance Slider", -1))
            ])
          ])) : T("", !0),
          j(Le, {
            appear: "",
            mode: "out-in",
            name: "fade-vertical"
          }, {
            default: S(() => [
              (d(), f("h3", {
                key: o.content[0].idx,
                class: _([[e.theme.style, o.direction], "main program-title"])
              }, [
                o.content[0].link && o.content[0].link.url ? (d(), L(Y(e.isEditing ? "div" : "a"), {
                  key: 0,
                  href: o.content[0].link.url,
                  target: o.content[0].link.opens_in_new_tab ? "_blank" : ""
                }, {
                  default: S(() => [
                    M(e.$slots, "title", {
                      idx: o.content[0].idx
                    }, () => [
                      H(k(o.content[0].title), 1)
                    ], !0)
                  ]),
                  _: 3
                }, 8, ["href", "target"])) : M(e.$slots, "title", {
                  key: 1,
                  idx: o.content[0].idx
                }, () => [
                  H(k(o.content[0].title), 1)
                ], !0)
              ], 2))
            ]),
            _: 3
          }),
          j(Le, {
            appear: "",
            mode: "out-in",
            name: "fade-vertical"
          }, {
            default: S(() => [
              (d(), f("p", {
                key: o.content[0].idx,
                class: _([[e.theme.style, o.direction], "main program-description"])
              }, [
                M(e.$slots, "description", {
                  idx: o.content[0].idx
                }, () => [
                  H(k(o.content[0].description), 1)
                ], !0)
              ], 2))
            ]),
            _: 3
          })
        ])
      ], 2),
      c("div", {
        class: _(["main-program-image", { editing: e.isEditing }])
      }, [
        M(e.$slots, "controls", {
          idx: o.content[0].idx
        }, void 0, !0),
        ["light", "bold", "monterrey", "sydney"].includes(e.theme.style) && e.programs.slider ? (d(), f("div", OK, [
          M(e.$slots, "main-controls", {}, () => [
            c("div", PK, [
              (d(), f("svg", {
                class: "left-arrow",
                width: "64",
                height: "64",
                viewBox: "0 0 64 64",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                onClick: t[4] || (t[4] = (...s) => i.previous && i.previous(...s))
              }, t[11] || (t[11] = [
                c("path", {
                  class: "arrow-bg",
                  "fill-rule": "evenodd",
                  "clip-rule": "evenodd",
                  d: "M-6.10352e-05 0L63.9999 0L63.9999 64L-6.10352e-05 64L-6.10352e-05 0Z",
                  fill: "#014990"
                }, null, -1),
                c("path", {
                  class: "arrow-stroke",
                  "fill-rule": "evenodd",
                  "clip-rule": "evenodd",
                  d: "M26 32L38 19.5L36.5 18L22.9999 32.0428L36.5 46L38 44.5L26 32Z",
                  fill: "white"
                }, null, -1)
              ]))),
              t[12] || (t[12] = c("span", { class: "sr-only" }, "Reverse Slider", -1))
            ]),
            c("div", NK, [
              (d(), f("svg", {
                class: "right-arrow",
                width: "64",
                height: "64",
                viewBox: "0 0 64 64",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                onClick: t[5] || (t[5] = (...s) => i.next && i.next(...s))
              }, t[13] || (t[13] = [
                c("path", {
                  class: "arrow-bg",
                  "fill-rule": "evenodd",
                  "clip-rule": "evenodd",
                  d: "M64.0001 64L5.34058e-05 64L5.90008e-05 -1.78036e-06L64.0001 3.8147e-06L64.0001 64Z",
                  fill: "#014990"
                }, null, -1),
                c("path", {
                  class: "arrow-stroke",
                  "fill-rule": "evenodd",
                  "clip-rule": "evenodd",
                  d: "M38 32L26 44.5L27.5 46L41.0001 31.9572L27.5 18L26 19.5L38 32Z",
                  fill: "white"
                }, null, -1)
              ]))),
              t[14] || (t[14] = c("span", { class: "sr-only" }, "Advance Slider", -1))
            ])
          ], !0)
        ])) : T("", !0),
        j(Le, {
          appear: "",
          mode: "out-in",
          name: "fade-vertical"
        }, {
          default: S(() => [
            (d(), f("div", {
              key: o.content[0].idx,
              class: _([o.direction, "aspect-ratio-box main"])
            }, [
              c("img", {
                class: "image-border-accent",
                src: o.content[0].image.url,
                alt: o.content[0].image.alt_text,
                loading: "lazy"
              }, null, 8, HK)
            ], 2))
          ]),
          _: 1
        })
      ], 2)
    ]),
    c("ul", FK, [
      c("li", RK, [
        c("div", VK, [
          c("img", {
            class: "image-border-accent",
            src: o.content[0].image.url,
            alt: o.content[0].image.alt_text,
            loading: "lazy"
          }, null, 8, BK)
        ]),
        c("h3", {
          class: _([e.theme.style, "program-title"])
        }, [
          o.content[0].link && o.content[0].link.url ? (d(), L(Y(e.isEditing ? "div" : "a"), {
            key: 0,
            href: o.content[0].link.url,
            target: o.content[0].link.opens_in_new_tab ? "_blank" : ""
          }, {
            default: S(() => [
              M(e.$slots, "title", {
                idx: o.content[0].idx
              }, () => [
                H(k(o.content[0].title), 1)
              ], !0)
            ]),
            _: 3
          }, 8, ["href", "target"])) : M(e.$slots, "title", {
            key: 1,
            idx: o.content[0].idx
          }, () => [
            H(k(o.content[0].title), 1)
          ], !0)
        ], 2),
        c("p", {
          class: _([e.theme.style, "program-description"])
        }, [
          M(e.$slots, "description", {
            idx: o.content[0].idx
          }, () => [
            H(k(o.content[0].description), 1)
          ], !0)
        ], 2)
      ]),
      (d(!0), f(J, null, ne(o.content.slice(1), (s) => (d(), f("li", {
        key: s.idx,
        "data-testid": "programs-content"
      }, [
        c("div", jK, [
          M(e.$slots, "small-controls", {
            idx: s.idx
          }, void 0, !0),
          c("img", {
            src: s.image.url,
            alt: s.image.alt_text,
            class: "program-image image-border-accent",
            loading: "lazy"
          }, null, 8, UK)
        ]),
        c("h3", {
          class: _([e.theme.style, "program-title"])
        }, [
          s.link && s.link.url ? (d(), L(Y(e.isEditing ? "div" : "a"), {
            key: 0,
            href: s.link.url,
            target: s.link.opens_in_new_tab ? "_blank" : ""
          }, {
            default: S(() => [
              M(e.$slots, "title", {
                idx: o.content[0].idx
              }, () => [
                H(k(s.title), 1)
              ], !0)
            ]),
            _: 2
          }, 1032, ["href", "target"])) : M(e.$slots, "title", {
            key: 1,
            idx: o.content[0].idx
          }, () => [
            H(k(s.title), 1)
          ], !0)
        ], 2),
        c("p", {
          class: _([e.theme.style, "program-description"])
        }, [
          M(e.$slots, "description", {
            idx: o.content[0].idx
          }, () => [
            H(k(s.description), 1)
          ], !0)
        ], 2)
      ]))), 128))
    ]),
    c("div", null, [
      (d(!0), f(J, null, ne(i.programRows, (s, l) => (d(), L(Zn, {
        key: l + 1,
        tag: "ul",
        name: "program-row",
        class: _(["program-row", { "less-than-4": s.length < 4 }])
      }, {
        default: S(() => [
          (d(!0), f(J, null, ne(s, (u) => (d(), f("li", {
            key: u.idx,
            class: _([o.direction, ["row-of-" + s.length]])
          }, [
            M(e.$slots, "controls", {
              idx: u.idx
            }, void 0, !0),
            c("div", qK, [
              c("img", {
                src: u.image.url,
                alt: u.image.alt_text,
                class: "program-image image-border-accent",
                loading: "lazy"
              }, null, 8, GK)
            ]),
            c("h3", {
              class: _([e.theme.style, "program-title"])
            }, [
              u.link && u.link.url ? (d(), L(Y(e.isEditing ? "div" : "a"), {
                key: 0,
                href: u.link.url,
                target: u.link.opens_in_new_tab ? "_blank" : ""
              }, {
                default: S(() => [
                  M(e.$slots, "title", {
                    idx: u.idx
                  }, () => [
                    H(k(u.title), 1)
                  ], !0)
                ]),
                _: 2
              }, 1032, ["href", "target"])) : M(e.$slots, "title", {
                key: 1,
                idx: u.idx
              }, () => [
                H(k(u.title), 1)
              ], !0)
            ], 2),
            c("p", {
              class: _([e.theme.style, "program-description"])
            }, [
              M(e.$slots, "description", {
                idx: u.idx
              }, () => [
                H(k(u.description), 1)
              ], !0)
            ], 2)
          ], 2))), 128))
        ]),
        _: 2
      }, 1032, ["class"]))), 128))
    ]),
    e.programs.see_all ? (d(), L(a, {
      key: 1,
      class: _([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme
    }, {
      default: S(() => [
        i.seeAll && (e.screenSize < 600 || e.theme.style === "purple") ? (d(), f("a", {
          key: 0,
          target: i.opensInNewTab,
          href: `${e.pathPrefix}${i.seeAllURL}`,
          "data-testid": `see-all-${e.theme.style}-bottom`,
          onClick: t[6] || (t[6] = (s) => e.$emit("edit-see-all-link", s))
        }, [
          H(k(e.programs.see_all_link.name || e.translations.see_all || "See All Programs") + " ", 1),
          M(e.$slots, "link", {}, void 0, !0)
        ], 8, KK)) : T("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"])) : T("", !0)
  ], 6)) : T("", !0);
}
const ZK = /* @__PURE__ */ B(CK, [["render", zK], ["__scopeId", "data-v-bfc47d2c"]]), xK = {
  name: "P3",
  components: {
    CardSlider: mn
  },
  mixins: [ki, _t],
  computed: {
    content() {
      return this.programs.content;
    },
    sliderCenterSize() {
      return 600;
    },
    p3Colors() {
      return ge(ae({}, this.colors), {
        "--heading-description-color": $(this.theme, "heading_description_color.hex", "#000000"),
        "--top-heading-color": $(this.theme, "top_heading_color.hex", "#000000"),
        "--card-1-bg-color": $(this.theme, "programs_card_1_bg_color.hex", "#4e0188"),
        "--card-1-heading-color": $(this.theme, "programs_card_1_heading_color.hex", "#ffffff"),
        "--card-1-text-color": $(this.theme, "programs_card_1_text_color.hex", "#ffffff"),
        "--card-1-box-color": $(this.theme, "programs_card_1_box_color.hex", "#ffffff"),
        "--card-2-bg-color": $(this.theme, "programs_card_2_bg_color.hex", "#86259C"),
        "--card-2-heading-color": $(this.theme, "programs_card_2_heading_color.hex", "#ffffff"),
        "--card-2-text-color": $(this.theme, "programs_card_2_text_color.hex", "#ffffff"),
        "--card-2-box-color": $(this.theme, "programs_card_2_box_color.hex", "#ffffff"),
        "--card-3-bg-color": $(this.theme, "programs_card_3_bg_color.hex", "#fcD40b"),
        "--card-3-heading-color": $(this.theme, "programs_card_3_heading_color.hex", "#131313"),
        "--card-3-text-color": $(this.theme, "programs_card_3_text_color.hex", "#131313"),
        "--card-3-box-color": $(this.theme, "programs_card_3_box_color.hex", "#ffffff"),
        "--card-4-bg-color": $(this.theme, "programs_card_4_bg_color.hex", "#b22785"),
        "--card-4-heading-color": $(this.theme, "programs_card_4_heading_color.hex", "#ffffff"),
        "--card-4-text-color": $(this.theme, "programs_card_4_text_color.hex", "#ffffff"),
        "--card-4-box-color": $(this.theme, "programs_card_4_box_color.hex", "#ffffff"),
        "--card-5-bg-color": $(this.theme, "programs_card_5_bg_color.hex", "#5e49ec"),
        "--card-5-heading-color": $(this.theme, "programs_card_5_heading_color.hex", "#ffffff"),
        "--card-5-text-color": $(this.theme, "programs_card_5_text_color.hex", "#000000"),
        "--card-5-box-color": $(this.theme, "programs_card_5_box_color.hex", "#ffffff")
      });
    }
  }
}, WK = { class: "header-wrapper" }, YK = {
  key: 0,
  "data-testid": "component-header-top",
  class: "header-top"
}, XK = {
  key: 0,
  class: "header-description",
  "data-testid": "header-description"
}, QK = ["data-testid", "aria-label"], JK = { class: "program-card-wrapper" }, ez = { class: "program-bottom-card" }, tz = { class: "program-description" }, nz = ["innerHTML"];
function rz(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("CardSlider");
  return d(), f("div", {
    id: "programs-v3",
    "data-testid": "P3",
    style: Z(i.p3Colors),
    class: _([e.theme.style, { editing: e.isEditing }])
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        c("div", WK, [
          c("div", null, [
            c("h2", null, [
              e.displayHeaderTop ? (d(), f("span", YK, [
                M(e.$slots, "header-top", {}, () => [
                  H(k(e.programs.component_header_top), 1)
                ], !0)
              ])) : T("", !0),
              M(e.$slots, "header", {}, () => [
                H(k(e.programs.component_header), 1)
              ], !0)
            ])
          ]),
          e.programs.component_header_description || e.isEditing ? (d(), f("div", XK, [
            M(e.$slots, "header-description", {}, () => [
              H(k(e.programs.component_header_description), 1)
            ], !0)
          ])) : T("", !0)
        ])
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    j(s, {
      "nav-orientation": "bottom",
      "pager-orientation": "right",
      "current-card": e.currentCard,
      "pager-section-count": e.pagerSectionCount,
      "all-cards-visible": e.allCardsVisible,
      "total-cards": i.content.length,
      "theme-styles": e.theme,
      "section-header": e.programs.component_header,
      onScrollRight: e.scrollRight,
      onScrollLeft: e.scrollLeft,
      onGoToSection: e.goToSection
    }, {
      default: S(() => [
        (d(), L(Y(e.wrapperComponent), Se({ ref: "scrollWrapper" }, e.wrapperProps, {
          modelValue: e.programs.content,
          "onUpdate:modelValue": t[0] || (t[0] = (l) => e.programs.content = l),
          class: [{ "all-cards-visible": e.allCardsVisible }, "programs-wrapper"],
          "item-key": "index"
        }), {
          item: S(({ element: l, index: u }) => [
            c("div", {
              ref: `sliderCard-${u}`,
              class: _(["program", `card-${u + 1}`, `card-style-${u % 5 + 1}`]),
              "data-testid": `programCard${u + 1}`,
              "aria-label": `${u + 1} of ${i.content.length}`,
              role: "group",
              "aria-roledescription": "slide",
              "data-attr": "program-content"
            }, [
              M(e.$slots, "controls", { idx: u }, void 0, !0),
              M(e.$slots, "image", { idx: u }, () => [
                (d(), L(Y(l.image ? "img" : "div"), {
                  src: l.image.url,
                  alt: l.image.alt_text,
                  loading: "lazy",
                  class: "program-image"
                }, null, 8, ["src", "alt"]))
              ], !0),
              c("div", JK, [
                c("div", ez, [
                  (d(), L(Y(l.link && l.link.url && !e.isEditing ? "a" : "span"), {
                    href: l.link.url,
                    target: l.link.opens_in_new_tab ? "_blank" : null,
                    class: _(["program-title", { "is-editing": e.isEditing }])
                  }, {
                    default: S(() => [
                      M(e.$slots, "title", {
                        title: l.title,
                        idx: u
                      }, () => [
                        H(k(l.title), 1)
                      ], !0)
                    ]),
                    _: 2
                  }, 1032, ["href", "target", "class"])),
                  c("span", tz, [
                    M(e.$slots, "description", {
                      title: l.description,
                      idx: u
                    }, () => [
                      c("span", {
                        class: "description-link",
                        innerHTML: l.description
                      }, null, 8, nz)
                    ], !0)
                  ])
                ])
              ])
            ], 10, QK)
          ]),
          _: 3
        }, 16, ["modelValue", "class"]))
      ]),
      _: 3
    }, 8, ["current-card", "pager-section-count", "all-cards-visible", "total-cards", "theme-styles", "section-header", "onScrollRight", "onScrollLeft", "onGoToSection"])
  ], 6);
}
const oz = /* @__PURE__ */ B(xK, [["render", rz], ["__scopeId", "data-v-f678074c"]]), iz = {
  name: "P4",
  mixins: [ki],
  data() {
    return {
      activeItem: 0
    };
  },
  computed: {
    programsContent: {
      get() {
        return this.programs.content.slice(0, 5);
      },
      set(e) {
        this.programs.content = e;
      }
    },
    programsLength() {
      return this.programs.content.length;
    },
    cssVars() {
      return ge(ae({}, this.colors), {
        "--active-headline-color": $(this.theme, "active_headline_color.hex", "#000000"),
        "--active-line-color": $(this.theme, "active_line_color.hex", "#000000"),
        "--headline-color": $(this.theme, "headline_color.hex", "#000000"),
        "--card-bg-color": $(this.theme, "card_bg_color.hex", "#FFFFFF"),
        "--card-border-color": $(this.theme, "card_border_color.hex", "#000000")
      });
    }
  },
  methods: {
    activateTab(e) {
      this.activeItem = e;
    },
    onKeyDown(e) {
      if (this.isEditing) return;
      const n = {
        ArrowLeft: this.focusPreviousTab,
        ArrowRight: this.focusNextTab,
        Home: this.focusFirstTab,
        End: this.focusLastTab
      }[e.key];
      n && n.call(this);
    },
    focusActiveTab() {
      this.$refs["tab-" + this.activeItem][0].focus();
    },
    focusPreviousTab() {
      this.activeItem > 0 ? this.activeItem -= 1 : this.activeItem = this.programsLength - 1, this.focusActiveTab();
    },
    focusNextTab() {
      this.activeItem < this.programsLength - 1 ? this.activeItem += 1 : this.activeItem = 0, this.focusActiveTab();
    },
    focusFirstTab() {
      this.activeItem = 0, this.focusActiveTab();
    },
    focusLastTab() {
      this.activeItem = this.programsLength - 1, this.focusActiveTab();
    }
  }
}, sz = { class: "columns-wrapper" }, az = ["data-testid"], lz = { class: "column-1" }, uz = ["data-testid"], dz = ["data-testid"], cz = ["id", "tabindex", "aria-selected", "aria-controls", "onClick"], hz = { class: "column-2" }, mz = ["id", "aria-labelledby"], fz = { class: "program-card" }, pz = { class: "card-title" }, gz = {
  key: 0,
  class: "card-description"
}, vz = ["innerHTML"];
function bz(e, t, n, r, o, i) {
  const a = V("SeeAllContainer");
  return d(), f("div", {
    class: _(["programs-v4", e.theme.style]),
    style: Z(i.cssVars)
  }, [
    c("div", sz, [
      e.programs.has_header && e.isPurpleStyle ? (d(), L(a, {
        key: 0,
        class: _(["see-all-top", e.theme.style]),
        "theme-options": e.theme
      }, {
        header: S(() => [
          c("h2", {
            "data-testid": `header-${e.theme.style}-top`
          }, [
            M(e.$slots, "header", {}, () => [
              H(k(e.programs.component_header), 1)
            ])
          ], 8, az)
        ]),
        _: 3
      }, 8, ["class", "theme-options"])) : T("", !0),
      c("div", lz, [
        e.programs.has_header && !e.isPurpleStyle ? (d(), L(a, {
          key: 0,
          class: _(["see-all-top", e.theme.style]),
          "theme-options": e.theme
        }, {
          header: S(() => [
            c("h2", {
              "data-testid": `header-${e.theme.style}-top`
            }, [
              e.isMonterreyStyle ? (d(), f("span", {
                key: 0,
                "data-testid": `header-${e.theme.style}-top`,
                class: "header-top"
              }, [
                M(e.$slots, "header-top", {}, () => [
                  H(k(e.programs.component_header_top), 1)
                ])
              ], 8, dz)) : T("", !0),
              M(e.$slots, "header", {}, () => [
                H(k(e.programs.component_header), 1)
              ])
            ], 8, uz)
          ]),
          _: 3
        }, 8, ["class", "theme-options"])) : T("", !0),
        (d(), L(Y(e.wrapperComponent), Se(e.wrapperProps, {
          modelValue: i.programsContent,
          "onUpdate:modelValue": t[1] || (t[1] = (s) => i.programsContent = s),
          class: ["programs-tabs", e.theme.style],
          role: "tablist",
          "item-key": "index",
          "aria-label": "programs-tabs"
        }), {
          item: S(({ element: s, index: l }) => [
            c("button", {
              id: `tab-${l}`,
              ref: `tab-${l}`,
              role: "tab",
              tabindex: String(o.activeItem === l ? 0 : -1),
              "aria-selected": String(o.activeItem === l),
              "aria-controls": `tabpanel-${l}`,
              class: _(["tab-button", { active: l === o.activeItem, [e.theme.style]: !0 }]),
              "data-testid": "tab-button",
              onClick: (u) => i.activateTab(l),
              onKeydown: t[0] || (t[0] = (u) => i.onKeyDown(u))
            }, [
              M(e.$slots, "drag"),
              M(e.$slots, "headline", { idx: l }, () => [
                H(k(s.headline), 1)
              ])
            ], 42, cz)
          ]),
          _: 3
        }, 16, ["modelValue", "class"]))
      ]),
      c("div", hz, [
        (d(!0), f(J, null, ne(i.programsContent, (s, l) => (d(), f("div", {
          id: ["tabpanel-" + l],
          key: l,
          "aria-labelledby": l,
          role: "tabpanel",
          class: _([{ active: l === o.activeItem }, "program-slide"]),
          "data-testid": "program-slide"
        }, [
          M(e.$slots, "controls", { idx: l }),
          M(e.$slots, "image", { idx: l }, () => [
            (d(), L(Y(s.image.url ? "img" : "div"), {
              src: s.image.url,
              alt: s.image.alt_text,
              class: "program-image"
            }, null, 8, ["src", "alt"]))
          ]),
          c("div", fz, [
            c("h2", pz, [
              M(e.$slots, "title", { idx: l }, () => [
                H(k(s.title), 1)
              ])
            ]),
            e.programs.has_snippet ? (d(), f("div", gz, [
              M(e.$slots, "description", {
                description: s.description,
                idx: l
              }, () => [
                c("span", {
                  innerHTML: s.description
                }, null, 8, vz)
              ])
            ])) : T("", !0),
            e.programs.read_more_link ? (d(), L(Y(e.isEditing ? "div" : "a"), {
              key: 1,
              class: "card-link",
              href: s.link.url,
              target: s.link.opens_in_new_tab ? "_blank" : ""
            }, {
              default: S(() => [
                M(e.$slots, "link", { idx: l }, () => [
                  H(k(s.link.name), 1)
                ])
              ]),
              _: 2
            }, 1032, ["href", "target"])) : T("", !0)
          ])
        ], 10, mz))), 128))
      ])
    ])
  ], 6);
}
const yz = /* @__PURE__ */ B(iz, [["render", bz], ["__scopeId", "data-v-815d8972"]]), b8 = {
  props: {
    // Index of the item considered active in the carrousel view
    activeIndex: {
      type: Number,
      default: 3
    },
    // Minimum pixel distance to trigger a swipe action
    swipeThreshold: {
      type: Number,
      default: 50
    },
    // Interval time in ms for auto-scrolling
    autoScrollIntervalTime: {
      type: Number,
      default: 6e3
    },
    // Duration in ms for the slide animation
    animationDuration: {
      type: Number,
      default: 500
    },
    // Number of positions to shift the array for the carrousel effect
    carrouselShift: {
      type: Number,
      default: 3
    },
    // Minimum number of items before mirroring is applied
    itemsMirrorLimit: {
      type: Number,
      default: 7
    }
  },
  data() {
    return {
      carrouselItems: [],
      isOnAnimation: !1,
      // provide each item with a unique id in format xxx-{index}
      carrouselActiveIdx: this.activeIndex,
      isAutoScroll: !1,
      autoScrollInterval: null,
      onFocus: !1,
      swipeStartX: 0,
      isSwiping: !1
    };
  },
  computed: {
    isMirrorArray() {
      return this.isEditing ? !1 : this.carrouselItems.length < this.itemsMirrorLimit;
    },
    content() {
      let e = [...this.carrouselItems];
      return this.isEditing || e.length < 3 ? e : (this.isMirrorArray && (e = [...e, ...e]), this.shiftArray(e, this.carrouselShift));
    }
  },
  methods: {
    shiftArray(e, t) {
      const n = e.length - t;
      return [...e.slice(n), ...e.slice(0, n)];
    },
    onAnimation() {
      return new Promise((e) => {
        this.isOnAnimation = !0, setTimeout(() => {
          this.isOnAnimation = !1, e();
        }, this.animationDuration);
      });
    },
    async moveItem({ direction: e = "next", autofocus: t = !1 } = {}) {
      if (this.isOnAnimation) return;
      const n = this.$refs.carrousel;
      if (!n) return;
      const r = n.children;
      this.reorderItems(n, r, e), this.updateTabIndexes(r), t && this.focusActiveItem(r), this.isAutoScroll && this.resetAutoScroll(), await this.onAnimation();
    },
    async setActiveItem(e, t = !1) {
      if (this.isOnAnimation) return;
      const n = this.$refs.carrousel;
      if (!n || n.children.length === 0 || n.children.length < 3 || e < 0 || e >= n.children.length)
        return;
      if (e === this.activeIndex) {
        t && this.focusActiveItem(n.children);
        return;
      }
      const r = e - this.activeIndex, o = r > 0 ? "next" : "prev", i = Math.abs(r);
      for (let a = 0; a < i; a++) {
        const s = a === i - 1 && t;
        await this.moveItem({ direction: o, autofocus: s });
      }
    },
    reorderItems(e, t, n) {
      var r, o;
      n === "next" ? e.appendChild(t[0]) : n === "prev" && e.prepend(t[t.length - 1]), this.carrouselActiveIdx = +((o = (r = t[this.activeIndex]) == null ? void 0 : r.id) == null ? void 0 : o.split("-").at(-1));
    },
    updateTabIndexes(e) {
      Array.from(e).forEach((t) => t.setAttribute("tabindex", "-1")), e[this.activeIndex] && e[this.activeIndex].setAttribute("tabindex", "0");
    },
    focusActiveItem(e) {
      var t;
      (t = e[this.activeIndex]) == null || t.focus();
    },
    getItemNumber(e) {
      let t;
      const n = this.content.length, r = 3;
      if (this.isMirrorArray) {
        const o = n / 2;
        t = (e % o + o - r) % o + 1;
      } else
        t = e - r + 1, t < 1 && (t += n);
      return t;
    },
    handleSwipeStart(e) {
      this.isSwiping = !0, this.swipeStartX = e.touches ? e.touches[0].clientX : e.clientX;
    },
    handleSwipeEnd(e) {
      if (!this.isSwiping) return;
      this.isSwiping = !1;
      const n = (e.changedTouches ? e.changedTouches[0].clientX : e.clientX) - this.swipeStartX;
      n > this.swipeThreshold ? this.moveItem({ direction: "prev" }) : n < -this.swipeThreshold && this.moveItem({ direction: "next" });
    },
    toggleAutoScroll() {
      this.isAutoScroll ? this.stopAutoScroll() : this.startAutoScroll();
    },
    handleFocus() {
      this.onFocus = !0;
    },
    handleBlur() {
      this.onFocus = !1;
    },
    startAutoScroll() {
      this.autoScrollInterval = setInterval(() => {
        this.moveItem({ direction: "next", autofocus: this.onFocus });
      }, this.autoScrollIntervalTime), this.isAutoScroll = !0;
    },
    stopAutoScroll() {
      clearInterval(this.autoScrollInterval), this.isAutoScroll = !1;
    },
    resetAutoScroll() {
      this.stopAutoScroll(), this.startAutoScroll();
    }
  },
  beforeDestroy() {
    this.stopAutoScroll();
  }
}, _z = {
  name: "P5",
  mixins: [ki, b8],
  props: {
    animationDuration: {
      type: Number,
      default: 300
    }
  },
  data() {
    return {
      carrouselItems: this.programs.content || []
    };
  },
  computed: {
    p5Colors() {
      return ge(ae({}, this.colors), {
        "--heading-description-color": $(this.theme, "heading_description_color.hex", "#000"),
        "--icon-bg-color": $(this.theme, "icon_bg_color.hex", "#FFD6D6"),
        "--icon-color": $(this.theme, "icon_color.hex", "#741819")
      });
    },
    nextSlideText() {
      return $(this.theme, "translations.next_slide", "Next slide");
    },
    previousSlideText() {
      return $(this.theme, "translations.previous_slide", "Previous slide");
    }
  },
  methods: {
    handleProgramClick(e) {
      const t = e.currentTarget, n = this.$refs.carrousel, r = Array.from(n.children).indexOf(t);
      this.setActiveItem(r, !0);
    },
    getProgramAriaLabel(e, t) {
      return `${this.getItemNumber(e)} of ${this.content.length}, ${t.title}`;
    }
  }
}, Cz = { class: "programs-wrapper" }, wz = { class: "header-wrapper" }, Tz = {
  key: 0,
  class: "header"
}, kz = {
  key: 1,
  class: "header-description",
  "data-testid": "header-description"
}, Ez = {
  key: 0,
  class: "carrousel-container",
  role: "region",
  "aria-roledescription": "carousel"
}, Sz = ["id", "data-testid", "aria-label", "tabindex", "onClick"], Mz = {
  key: 0,
  class: "icon-wrapper"
}, Az = ["innerHTML"], Iz = { class: "program-content" }, Lz = { class: "program-title" }, Dz = ["innerHTML"], $z = { class: "program" }, Oz = { class: "icon-wrapper" }, Pz = ["innerHTML"], Nz = { class: "program-content" }, Hz = { class: "program-title" }, Fz = { class: "program-title" }, Rz = { class: "program-description" }, Vz = ["innerHTML"], Bz = {
  key: 0,
  class: "card-link"
}, jz = {
  key: 2,
  role: "group",
  "aria-label": "slide controls",
  class: "carrousel-controls"
}, Uz = { class: "nav" }, qz = ["aria-label"], Gz = ["aria-label"];
function Kz(e, t, n, r, o, i) {
  const a = V("SeeAllContainer");
  return d(), f("div", {
    class: _(["programs-v5", [e.theme.style, { editing: e.isEditing }]]),
    "data-testid": "P5",
    style: Z(i.p5Colors)
  }, [
    c("div", Cz, [
      j(a, {
        class: _([e.theme.style, "see-all-top"]),
        "theme-options": e.theme
      }, {
        header: S(() => [
          c("div", wz, [
            e.programs.has_header ? (d(), f("div", Tz, [
              c("h2", null, [
                M(e.$slots, "header", {}, () => [
                  H(k(e.programs.component_header), 1)
                ], !0)
              ])
            ])) : T("", !0),
            e.programs.has_header_description ? (d(), f("div", kz, [
              M(e.$slots, "header-description", {}, () => [
                H(k(e.programs.component_header_description), 1)
              ], !0)
            ])) : T("", !0)
          ])
        ]),
        _: 3
      }, 8, ["class", "theme-options"]),
      e.isEditing ? (d(), L(Y(e.wrapperComponent), Se({ key: 1 }, e.wrapperProps, {
        modelValue: e.programs.content,
        "onUpdate:modelValue": t[8] || (t[8] = (s) => e.programs.content = s),
        "item-key": "id",
        class: "draggable-carrousel"
      }), {
        item: S(({ element: s, index: l }) => [
          c("div", $z, [
            M(e.$slots, "controls", { idx: l }, void 0, !0),
            e.programs.has_visuals ? (d(), f("div", {
              key: 0,
              class: _(["program-header", { "icon-only": e.theme.enable_icons }])
            }, [
              e.theme.enable_icons ? M(e.$slots, "icon", {
                key: 0,
                idx: l
              }, () => [
                c("div", Oz, [
                  s.icon ? (d(), f("span", {
                    key: 0,
                    class: "raw-svg",
                    "data-testid": "program-icon",
                    innerHTML: s.icon
                  }, null, 8, Pz)) : T("", !0)
                ])
              ], !0) : M(e.$slots, "image", {
                key: 1,
                idx: l
              }, () => [
                (d(), L(Y(s.image && s.image.url ? "img" : "div"), {
                  src: s.image && s.image.url,
                  alt: s.image && s.image.alt_text,
                  loading: "lazy",
                  class: "program-image"
                }, null, 8, ["src", "alt"]))
              ], !0)
            ], 2)) : T("", !0),
            c("div", Nz, [
              c("span", Hz, [
                M(e.$slots, "title", {
                  title: s.title,
                  idx: l
                }, () => [
                  c("span", Fz, k(s.title), 1)
                ], !0)
              ]),
              c("span", Rz, [
                M(e.$slots, "description", {
                  description: s.description,
                  idx: l
                }, () => [
                  c("span", {
                    class: "description-link",
                    innerHTML: s.description
                  }, null, 8, Vz)
                ], !0)
              ]),
              e.programs.read_more_link ? (d(), f("div", Bz, [
                M(e.$slots, "link", { idx: l }, () => [
                  H(k(s.link.name), 1)
                ], !0)
              ])) : T("", !0)
            ])
          ])
        ]),
        _: 3
      }, 16, ["modelValue"])) : (d(), f("div", Ez, [
        c("div", {
          ref: "carrousel",
          class: _([
            "carrousel-wrapper",
            {
              swiping: e.isSwiping,
              single: e.content.length === 1,
              small: e.content.length < 5
            }
          ]),
          onTouchstart: t[4] || (t[4] = (...s) => e.handleSwipeStart && e.handleSwipeStart(...s)),
          onTouchend: t[5] || (t[5] = (...s) => e.handleSwipeEnd && e.handleSwipeEnd(...s)),
          onMousedown: t[6] || (t[6] = (...s) => e.handleSwipeStart && e.handleSwipeStart(...s)),
          onMouseup: t[7] || (t[7] = (...s) => e.handleSwipeEnd && e.handleSwipeEnd(...s))
        }, [
          (d(!0), f(J, null, ne(e.content, (s, l) => (d(), f("div", {
            id: `carrousel-item-${l}`,
            key: l,
            class: "program",
            "data-testid": `programCard${l}`,
            "aria-label": i.getProgramAriaLabel(l, s),
            role: "group",
            "aria-roledescription": "slide",
            "data-attr": "program-content",
            tabindex: l === 3 ? 0 : -1,
            onKeyup: [
              t[0] || (t[0] = K((u) => e.moveItem({ direction: "prev", autofocus: !0 }), ["left"])),
              t[1] || (t[1] = K((u) => e.moveItem({ direction: "next", autofocus: !0 }), ["right"]))
            ],
            onFocus: t[2] || (t[2] = (...u) => e.handleFocus && e.handleFocus(...u)),
            onBlur: t[3] || (t[3] = (...u) => e.handleBlur && e.handleBlur(...u)),
            onClick: (u) => i.handleProgramClick(u, l)
          }, [
            e.programs.has_visuals ? (d(), f("div", {
              key: 0,
              class: _(["program-header", { "icon-only": e.theme.enable_icons }])
            }, [
              e.theme.enable_icons ? (d(), f("div", Mz, [
                s.icon ? (d(), f("span", {
                  key: 0,
                  class: "raw-svg",
                  "data-testid": "program-icon",
                  innerHTML: s.icon
                }, null, 8, Az)) : T("", !0)
              ])) : (d(), L(Y(s.image && s.image.url ? "img" : "div"), {
                key: 1,
                src: s.image && s.image.url,
                alt: s.image && s.image.alt_text,
                loading: "lazy",
                class: "program-image"
              }, null, 8, ["src", "alt"]))
            ], 2)) : T("", !0),
            c("div", Iz, [
              c("span", Lz, k(s.title), 1),
              c("span", {
                class: _([
                  "program-description",
                  {
                    full: !e.programs.has_visuals,
                    "with-icons": e.programs.has_visuals && e.theme.enable_icons
                  }
                ])
              }, [
                c("span", {
                  class: "description-link",
                  innerHTML: s.description
                }, null, 8, Dz)
              ], 2),
              e.programs.read_more_link && s.link ? (d(), L(Y(e.isPreview ? "div" : "a"), {
                key: 0,
                class: "card-link",
                href: s.link.url,
                target: s.link.opens_in_new_tab ? "_blank" : "",
                tabindex: e.carrouselActiveIdx === l ? 0 : -1
              }, {
                default: S(() => [
                  H(k(s.link.name), 1)
                ]),
                _: 2
              }, 1032, ["href", "target", "tabindex"])) : T("", !0)
            ])
          ], 40, Sz))), 128))
        ], 34)
      ])),
      e.programs.slider ? (d(), f("div", jz, [
        c("div", Uz, [
          c("button", {
            class: "carrousel-nav prev",
            "aria-label": i.previousSlideText,
            onClick: t[9] || (t[9] = (s) => e.moveItem({ direction: "prev" }))
          }, t[11] || (t[11] = [
            c("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              width: "26",
              height: "14",
              viewBox: "0 0 26 14",
              fill: "none",
              "aria-hidden": "true"
            }, [
              c("path", {
                d: "M1 7L7 13M1 7L7 1M1 7L25 7",
                "stroke-width": "1.5",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              })
            ], -1)
          ]), 8, qz),
          c("button", {
            class: "carrousel-nav next",
            "aria-label": i.nextSlideText,
            onClick: t[10] || (t[10] = (s) => e.moveItem({ direction: "next" }))
          }, t[12] || (t[12] = [
            c("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              width: "26",
              height: "14",
              viewBox: "0 0 26 14",
              fill: "none",
              "aria-hidden": "true"
            }, [
              c("path", {
                d: "M25 7L19 1M25 7L19 13M25 7H1",
                "stroke-width": "1.5",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              })
            ], -1)
          ]), 8, Gz)
        ]),
        t[13] || (t[13] = c("div", { class: "accent-bar" }, null, -1))
      ])) : T("", !0)
    ])
  ], 6);
}
const zz = /* @__PURE__ */ B(_z, [["render", Kz], ["__scopeId", "data-v-f3967577"]]), Zz = {
  name: "Programs",
  components: {
    P1: _K,
    P2: ZK,
    P3: oz,
    P4: yz,
    P5: zz
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      default: () => ({})
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    isPreview: {
      type: Boolean,
      default: !1
    }
  }
};
function xz(e, t, n, r, o, i) {
  return d(), L(Y(n.theme.version), {
    theme: n.theme,
    programs: n.content,
    "wrapper-component": n.wrapperComponent,
    "wrapper-props": n.wrapperProps,
    "is-editing": n.isEditing,
    "is-preview": n.isPreview,
    onEditSeeAllLink: t[0] || (t[0] = (a) => {
      e.$emit("edit-see-all-link", a);
    })
  }, {
    "header-top": S(() => [
      M(e.$slots, "header-top")
    ]),
    header: S(() => [
      M(e.$slots, "header")
    ]),
    "header-description": S(() => [
      M(e.$slots, "header-description")
    ]),
    controls: S(({ idx: a }) => [
      M(e.$slots, "controls", { idx: a })
    ]),
    "main-controls": S(() => [
      M(e.$slots, "main-controls")
    ]),
    "small-controls": S(({ idx: a }) => [
      M(e.$slots, "small-controls", { idx: a })
    ]),
    image: S(({ idx: a }) => [
      M(e.$slots, "image", { idx: a })
    ]),
    icon: S(({ idx: a }) => [
      M(e.$slots, "icon", { idx: a })
    ]),
    link: S(({ idx: a }) => [
      M(e.$slots, "link", { idx: a })
    ]),
    title: S(({ title: a, idx: s }) => [
      M(e.$slots, "title", {
        title: a,
        idx: s
      })
    ]),
    description: S(({ description: a, idx: s }) => [
      M(e.$slots, "description", {
        description: a,
        idx: s
      })
    ]),
    headline: S(({ idx: a }) => [
      M(e.$slots, "headline", { idx: a })
    ]),
    drag: S(() => [
      M(e.$slots, "drag")
    ]),
    _: 3
  }, 40, ["theme", "programs", "wrapper-component", "wrapper-props", "is-editing", "is-preview"]);
}
const Wz = /* @__PURE__ */ B(Zz, [["render", xz]]), Yz = ["regular", "pill"], Xz = (e) => (t) => e.includes(t), Qz = {
  name: "EventTag",
  props: {
    displayText: {
      type: String,
      default: null
    },
    variant: {
      type: String,
      default: "regular",
      validator: Xz(Yz)
    },
    bgColor: {
      type: String,
      default: "#F3F3F3"
    },
    fontColor: {
      type: String,
      default: "#000"
    }
  },
  computed: {
    text() {
      return this.variant === "pill" ? this.displayText : `| ${this.displayText}`;
    },
    cssVars() {
      return {
        "--bg-color": this.bgColor,
        "--font-color": `${this.fontColor}CC`
      };
    }
  }
}, Jz = { class: "tag-tooltip tag-tooltip-bottom" }, eZ = { class: "tag-tooltip-text" };
function tZ(e, t, n, r, o, i) {
  return d(), f("div", Jz, [
    n.displayText ? (d(), f("div", {
      key: 0,
      style: Z(i.cssVars),
      class: _([n.variant, "event-tag"])
    }, k(i.text), 7)) : T("", !0),
    c("div", eZ, k(n.displayText), 1)
  ]);
}
const nZ = /* @__PURE__ */ B(Qz, [["render", tZ], ["__scopeId", "data-v-c536c1f9"]]), Xr = {
  components: { EventTag: nZ },
  mixins: [St],
  props: {
    options: {
      type: Object,
      default: () => ({})
    },
    events: {
      type: Array,
      required: !0
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    isPreview: Boolean,
    eventsConfig: {
      type: Object,
      default: () => ({})
    },
    isEditing: Boolean,
    componentId: {
      type: String,
      required: !0
    }
  },
  computed: {
    theme() {
      return this.options;
    },
    colors() {
      var t, n;
      const e = this.sharedThemeColors();
      return ge(ae({}, e), {
        "--date-color": $(this.theme, "date_color.hex", "initial"),
        "--date-bg-color": $(this.theme, "date_bg_color.hex", "initial"),
        "--time-color": $(this.theme, "time_color.hex", "initial"),
        "--location-color": $(this.theme, "location_color.hex", "initial"),
        "--bg-color": $(this.theme, "bg_color.hex", "#fff"),
        "--event-bg-color": $(this.theme, "event_bg_color.hex", "none"),
        "--event-title-color": $(this.theme, "event_title_color.hex", "initial"),
        "--event-separator-color": $(this.theme, "event_separator_color.hex", "#000"),
        "--event-border-color": $(this.theme, "event_border_color.hex", "#000"),
        event_section_tag_color: $(this.theme, "event_section_tag_color.hex", "#F3F3F3"),
        event_section_tag_text_color: $(this.theme, "event_section_tag_text_color.hex", "#fff"),
        "--arrow-background-color": $(this.theme, "arrow_background_color.hex", "#fff"),
        "--event-arrow-color": $(this.theme, "event_arrow_color.hex", "#fff"),
        "--pager-color": $(this.theme, "pager_color.hex", "#fff"),
        "--event-bg-color-1": $(this.theme, "event_bg_color_1.hex", "#fff"),
        "--event-date-border-color": $(this.theme, "event_date_border_color.hex", "#fff"),
        "--event-bg-color-3": $(this.theme, "event_bg_color_3.hex", "#fff"),
        "--event-text-color-1": $(this.theme, "event_text_color_1.hex", "#fff"),
        "--event-text-color-3": $(this.theme, "event_text_color_3.hex", "#000"),
        "--percentage-date-opacity": `${(t = this.theme.percentage_date_opacity) != null ? t : 0}%`,
        "--percentage-button-opacity": `${(n = this.theme.percentage_button_opacity) != null ? n : 0}%`
      });
    },
    timeColor() {
      return $(this.theme, "time_color.hex", "initial");
    },
    translations() {
      return this.options.translations || {};
    },
    isPurpleStyle() {
      return this.options.style === "purple";
    },
    isMonterreyStyle() {
      return this.options.style === "monterrey";
    },
    seeAllLinkHref() {
      var e;
      return ((e = this.eventsConfig[this.componentId]) == null ? void 0 : e.see_all_link.href) || this.link("events");
    },
    seeAllLinkName() {
      var e;
      return ((e = this.eventsConfig[this.componentId]) == null ? void 0 : e.see_all_link.name) || this.translations.see_all;
    },
    seeAllLinkTarget() {
      var e;
      return ((e = this.eventsConfig[this.componentId]) == null ? void 0 : e.see_all_link.target) || "_self";
    },
    sectionHeader() {
      var e;
      return ((e = this.eventsConfig[this.componentId]) == null ? void 0 : e.component_header) || this.translations.title;
    },
    sectionHeaderTop() {
      var e, t;
      return (t = (e = this.eventsConfig[this.componentId]) == null ? void 0 : e.component_header_top) != null ? t : this.translations.latest;
    },
    visibleItems() {
      var e;
      return ((e = this.eventsConfig[this.componentId]) == null ? void 0 : e.num_rows) || 4;
    }
  },
  methods: {
    /**
     * Parses cms_formatted_date string and returns structured date/time information
     * Handles common formats:
     * - "Nov 29, 2025 from 5:30 PM to 10:45 PM" (single day with time range)
     * - "Nov 29, 2025 from 5:30 PM" (single day with start time only)
     * - "Nov 29, 2025" (single day all day)
     * - "Nov 29, 2025 to Dec 1, 2025 from 5:30 PM to 10:45 PM" (date range with time)
     * - "Nov 29, 2025 to Dec 1, 2025" (date range all day)
     */
    parseCmsFormattedDate(e) {
      if (!e || typeof e != "string")
        return null;
      const t = e.replace(/\s+/g, " ").trim().replace(/\s+from\s*$/i, ""), [n = "", r = ""] = t.split(/\s+from\s+/i), [o = "", i = ""] = n.split(/\s+to\s+/i), a = (v) => {
        if (!v) return null;
        const g = v.match(/^(\w+)\s+(\d{1,2}),?\s*(\d{4})?$/);
        return g ? {
          month: g[1] || "",
          day: g[2] || "",
          year: g[3] || "",
          full: v
        } : null;
      }, s = a(o), l = i ? a(i) : null, u = r ? r.replace(/\s+to\s+/gi, " — ").toUpperCase() : "", m = n.replace(/\s+to\s+/gi, " — ");
      return {
        startDate: s,
        endDate: l,
        time: {
          formatted: u,
          isAllDay: !r
        },
        dateRange: {
          formatted: m
        }
      };
    },
    startDateMonth(e) {
      var n;
      const t = this.parseCmsFormattedDate(e);
      return ((n = t == null ? void 0 : t.startDate) == null ? void 0 : n.month) || "";
    },
    startDateDay(e) {
      var n;
      const t = this.parseCmsFormattedDate(e);
      return ((n = t == null ? void 0 : t.startDate) == null ? void 0 : n.day) || "";
    },
    endDateMonth(e) {
      var n;
      const t = this.parseCmsFormattedDate(e);
      return ((n = t == null ? void 0 : t.endDate) == null ? void 0 : n.month) || "";
    },
    endDateDay(e) {
      var n;
      const t = this.parseCmsFormattedDate(e);
      return ((n = t == null ? void 0 : t.endDate) == null ? void 0 : n.day) || "";
    },
    formatDateAndTime(e, t) {
      const n = this.parseCmsFormattedDate(e);
      return n ? t === "date" ? n.dateRange.formatted : t === "time" ? n.time.isAllDay ? this.translations.all_day : n.time.formatted : "" : "";
    },
    displayEventTags(e) {
      return this.eventsConfig.display_tags && this.eventSectionName(e);
    },
    eventSectionName(e) {
      return e.sectionDisplayName || e.custom_section_name;
    },
    getFormattedDate(e, t = " | ") {
      var l, u, m, v;
      const n = this.parseCmsFormattedDate(e);
      if (!n)
        return "";
      const r = ((l = n.startDate) == null ? void 0 : l.month) || "", o = ((u = n.endDate) == null ? void 0 : u.month) || "", i = ((m = n.startDate) == null ? void 0 : m.day) || "", a = ((v = n.endDate) == null ? void 0 : v.day) || "", s = n.time.isAllDay ? this.translations.all_day : n.time.formatted;
      return !o || !a ? s ? `${r} ${i}${t}${s}` : `${r} ${i}` : r === o && i === a ? s : s ? `${r} ${i} - ${o} ${a}${t}${s}` : `${r} ${i} - ${o} ${a}`;
    }
  }
}, rZ = {
  name: "E1",
  mixins: [Xr],
  computed: {
    eventsOnHomepage() {
      return this.events.slice(0, 4);
    },
    lessThanFourEvents() {
      return this.eventsOnHomepage.length <= 3;
    }
  }
}, oZ = ["data-testid"], iZ = { class: "events-title-wrapper" }, sZ = ["href"], aZ = { class: "sr-only" }, lZ = {
  key: 0,
  class: "event-tag-wrapper"
};
function uZ(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("event-tag");
  return d(), f("div", {
    id: "events-e1",
    style: Z(e.colors),
    class: _([e.theme.style, { "is-editing": e.isEditing }]),
    "data-testid": "e1"
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        e.isMonterreyStyle ? (d(), f("h3", {
          key: 0,
          "data-testid": `header-${e.theme.style}-top`
        }, [
          M(e.$slots, "header-top", {}, () => [
            H(k(e.sectionHeaderTop), 1)
          ], !0)
        ], 8, oZ)) : T("", !0),
        (d(), L(Y(e.isMonterreyStyle ? "h1" : "h2"), {
          "data-testid": `header-${e.theme.style}-top`
        }, {
          default: S(() => [
            M(e.$slots, "header", {}, () => [
              H(k(e.sectionHeader), 1)
            ], !0)
          ]),
          _: 3
        }, 8, ["data-testid"]))
      ]),
      default: S(() => [
        e.theme.style !== "purple" && e.screenSize >= 600 ? (d(), L(Y(e.isEditing ? "button" : "a"), {
          key: 0,
          class: _(["hide-on-xs hide-on-lg-three-cols see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (l) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : T("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    c("div", {
      class: _(["events-info", { "is-editing": e.isEditing }])
    }, [
      (d(!0), f(J, null, ne(i.eventsOnHomepage, (l, u) => (d(), f("div", {
        key: `${u}-${l.title}`,
        class: _(["events-card grow events-accent-border", { "less-than-four-events": i.lessThanFourEvents }]),
        "data-testid": "events-content"
      }, [
        c("p", {
          class: _(["events-date", e.theme.style])
        }, k(e.formatDateAndTime(l.cms_formatted_date, "date")), 3),
        c("p", {
          class: _(["events-time", e.theme.style])
        }, k(e.formatDateAndTime(l.cms_formatted_date, "time")), 3),
        c("div", iZ, [
          c("a", {
            href: e.link(`events?id=${l.id}`),
            "data-testid": "events-title",
            class: "events-title"
          }, [
            H(k(l.title) + " ", 1),
            c("span", aZ, k(e.formatDateAndTime(l.cms_formatted_date, "date")), 1)
          ], 8, sZ)
        ]),
        e.displayEventTags(l) ? (d(), f("div", lZ, [
          j(s, {
            variant: "pill",
            "display-text": e.eventSectionName(l),
            "bg-color": e.colors.event_section_tag_color,
            "font-color": e.colors.event_section_tag_text_color
          }, null, 8, ["display-text", "bg-color", "font-color"])
        ])) : T("", !0)
      ], 2))), 128))
    ], 2),
    e.theme.style === "purple" || e.screenSize < 600 ? (d(), L(a, {
      key: 0,
      class: _([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme,
      "data-testid": `see-all-${e.theme.style}-bottom`
    }, {
      default: S(() => [
        (d(), L(Y(e.isEditing ? "button" : "a"), {
          class: _(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          onClick: t[1] || (t[1] = (l) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options", "data-testid"])) : T("", !0)
  ], 6);
}
const dZ = /* @__PURE__ */ B(rZ, [["render", uZ], ["__scopeId", "data-v-cb66b5e5"]]), cZ = {
  name: "E2",
  mixins: [Xr]
}, hZ = ["data-testid"], mZ = { class: "events-date-and-time" }, fZ = { class: "events-title" }, pZ = ["href"], gZ = { class: "sr-only" }, vZ = {
  key: 0,
  class: "event-tag-wrapper"
};
function bZ(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("event-tag");
  return d(), f("div", {
    id: "events-e2",
    class: _([e.theme.style, { "is-editing": e.isEditing }]),
    style: Z(e.colors),
    "data-testid": "e2"
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        e.isMonterreyStyle ? (d(), f("h3", {
          key: 0,
          "data-testid": `header-${e.theme.style}-top`
        }, [
          M(e.$slots, "header-top", {}, () => [
            H(k(e.sectionHeaderTop), 1)
          ], !0)
        ], 8, hZ)) : T("", !0),
        (d(), L(Y(e.isMonterreyStyle ? "h1" : "h2"), {
          "data-testid": `header-${e.theme.style}-top`
        }, {
          default: S(() => [
            M(e.$slots, "header", {}, () => [
              H(k(e.sectionHeader), 1)
            ], !0)
          ]),
          _: 3
        }, 8, ["data-testid"]))
      ]),
      default: S(() => [
        e.theme.style === "bold" && e.screenSize >= 600 ? (d(), L(Y(e.isEditing ? "button" : "a"), {
          key: 0,
          class: _(["hide-on-xs see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (l) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : T("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    c("div", {
      class: _(["events-info", { "is-editing": e.isEditing }])
    }, [
      (d(!0), f(J, null, ne(e.events.slice(0, 8), (l, u) => (d(), f("div", {
        key: `${u}-${l.title}`,
        class: "events-card",
        "data-testid": "events-content"
      }, [
        c("p", mZ, [
          c("span", {
            class: _(["events-date", e.theme.style])
          }, k(e.formatDateAndTime(l.cms_formatted_date, "date")), 3),
          c("span", {
            class: _(["events-time", e.theme.style])
          }, k(e.formatDateAndTime(l.cms_formatted_date, "time")), 3)
        ]),
        c("h3", fZ, [
          c("a", {
            href: e.isPreview ? void 0 : `${e.pathPrefix}/events?id=${l.id}`
          }, [
            H(k(l.title) + " ", 1),
            c("span", gZ, k(e.formatDateAndTime(l.cms_formatted_date, "date")), 1)
          ], 8, pZ)
        ]),
        e.displayEventTags(l) ? (d(), f("div", vZ, [
          j(s, {
            variant: "pill",
            "display-text": e.eventSectionName(l),
            "bg-color": e.colors.event_section_tag_color,
            "font-color": e.colors.event_section_tag_text_color
          }, null, 8, ["display-text", "bg-color", "font-color"])
        ])) : T("", !0)
      ]))), 128))
    ], 2),
    e.theme.style !== "bold" || e.screenSize < 600 ? (d(), L(a, {
      key: 0,
      class: _([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme,
      "data-testid": `see-all-${e.theme.style}-bottom`
    }, {
      default: S(() => [
        (d(), L(Y(e.isEditing ? "button" : "a"), {
          class: _(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          onClick: t[1] || (t[1] = (l) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options", "data-testid"])) : T("", !0)
  ], 6);
}
const yZ = /* @__PURE__ */ B(cZ, [["render", bZ], ["__scopeId", "data-v-6b81d5a6"]]), _Z = {
  name: "E3",
  mixins: [Xr],
  computed: {
    backgroundStyle() {
      return this.options.show_background_image ? {
        backgroundImage: `linear-gradient(${this.options.bg_color.hex}e6, ${this.options.bg_color.hex}e6), url(${$(
          this.eventsConfig,
          "background_image.url"
        )})`,
        backgroundSize: "cover"
      } : !1;
    }
  }
}, CZ = ["data-testid"], wZ = { class: "events-v3__events" }, TZ = ["href"], kZ = { class: "sr-only" }, EZ = { class: "events-v3__events__event__time" }, SZ = { class: "events-v3__footer" };
function MZ(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("event-tag");
  return d(), f("div", {
    id: "events-v3",
    class: _([e.options.style, { "is-editing": e.isEditing }]),
    style: Z([i.backgroundStyle, e.colors]),
    "data-testid": "e3"
  }, [
    c("div", {
      class: _(["events-v3__header__button", e.options.style])
    }, [
      j(a, {
        class: _([e.options.style, "see-all-top"]),
        "theme-options": e.theme,
        "data-testid": "see-all-top"
      }, {
        header: S(() => [
          e.isMonterreyStyle ? (d(), f("h3", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`
          }, [
            M(e.$slots, "header-top", {}, () => [
              H(k(e.sectionHeaderTop), 1)
            ], !0)
          ], 8, CZ)) : T("", !0),
          (d(), L(Y(e.isMonterreyStyle ? "h1" : "h2"), {
            "data-testid": `header-${e.theme.style}-top`
          }, {
            default: S(() => [
              M(e.$slots, "header", {}, () => [
                H(k(e.sectionHeader), 1)
              ], !0)
            ]),
            _: 3
          }, 8, ["data-testid"]))
        ]),
        default: S(() => [
          e.options.style !== "purple" && e.screenSize >= 600 ? (d(), L(Y(e.isEditing ? "button" : "a"), {
            key: 0,
            class: _(["hide-on-xs see-all-button", e.options.style]),
            href: e.seeAllLinkHref,
            target: e.seeAllLinkTarget,
            "data-testid": `see-all-${e.options.style}-top`,
            onClick: t[0] || (t[0] = (l) => e.$emit("open-modal"))
          }, {
            default: S(() => [
              H(k(e.seeAllLinkName), 1)
            ]),
            _: 1
          }, 8, ["class", "href", "target", "data-testid"])) : T("", !0)
        ]),
        _: 3
      }, 8, ["class", "theme-options"])
    ], 2),
    c("div", wZ, [
      (d(!0), f(J, null, ne(e.events.slice(0, 4), (l, u) => (d(), f("div", {
        key: u,
        class: _(["events-v3__events__event grow", [e.options.style, { "is-editing": e.isEditing }]]),
        "data-testid": "events-content"
      }, [
        c("div", {
          class: _(["events-v3__events__event__date events-date", e.options.style])
        }, k(e.formatDateAndTime(l.cms_formatted_date, "date")), 3),
        c("a", {
          href: e.isPreview ? "#" : `${e.pathPrefix}/events?id=${l.id}`,
          class: "events-v3__events__event__title"
        }, [
          H(k(l.title) + " ", 1),
          c("span", kZ, k(e.formatDateAndTime(l.cms_formatted_date, "date")), 1)
        ], 8, TZ),
        c("div", EZ, [
          H(k(e.formatDateAndTime(l.cms_formatted_date, "time")) + " ", 1),
          e.displayEventTags(l) ? (d(), L(s, {
            key: 0,
            "display-text": e.eventSectionName(l),
            "bg-color": e.timeColor
          }, null, 8, ["display-text", "bg-color"])) : T("", !0)
        ])
      ], 2))), 128))
    ]),
    c("div", SZ, [
      e.options.style === "purple" || e.screenSize < 600 ? (d(), L(a, {
        key: 0,
        class: _([e.options.style, "see-all-bottom"]),
        "theme-options": e.theme,
        "data-testid": `see-all-${e.options.style}-bottom`
      }, {
        default: S(() => [
          (d(), L(Y(e.isEditing ? "button" : "a"), {
            class: _(["see-all-button", e.options.style]),
            href: e.seeAllLinkHref,
            target: e.seeAllLinkTarget,
            onClick: t[1] || (t[1] = (l) => e.$emit("open-modal"))
          }, {
            default: S(() => [
              H(k(e.seeAllLinkName), 1)
            ]),
            _: 1
          }, 8, ["class", "href", "target"]))
        ]),
        _: 1
      }, 8, ["class", "theme-options", "data-testid"])) : T("", !0)
    ])
  ], 6);
}
const AZ = /* @__PURE__ */ B(_Z, [["render", MZ], ["__scopeId", "data-v-a850dc5f"]]), IZ = {
  name: "OriginalSliderButton",
  props: {
    iconColor: {
      type: String,
      default: "#000000"
    },
    translatedAria: {
      type: String,
      default: ""
    },
    direction: {
      type: String,
      default: "left"
    }
  }
}, LZ = { class: "btn_content" }, DZ = {
  class: "normal",
  viewBox: "0 0 30 69",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, $Z = ["fill"], OZ = ["fill"], PZ = {
  class: "hover",
  viewBox: "0 0 33 72",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, NZ = ["fill"], HZ = ["fill"], FZ = { class: "sr-only" };
function RZ(e, t, n, r, o, i) {
  return d(), f("button", {
    class: _(["cards-slider-arrow", n.direction]),
    onClick: t[0] || (t[0] = (a) => e.$emit(`go-${n.direction}`))
  }, [
    c("span", LZ, [
      (d(), f("svg", DZ, [
        n.direction === "left" ? (d(), f("path", {
          key: 0,
          fill: n.iconColor,
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M29.0391 68.4702C27.9511 69.3202 26.38 69.1273 25.5299 68.0392L0.529939 36.0392C-0.176646 35.1348 -0.176646 33.8654 0.529939 32.961L25.5299 0.961001C26.38 -0.127035 27.9511 -0.319974 29.0391 0.530047C30.1271 1.38008 30.3201 2.95119 29.4701 4.03923L5.67249 34.5001L29.4701 64.961C30.3201 66.049 30.1271 67.6201 29.0391 68.4702Z"
        }, null, 8, $Z)) : (d(), f("path", {
          key: 1,
          fill: n.iconColor,
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M1.46088 0.53005C2.54891 -0.319977 4.12002 -0.127034 4.97005 0.961001L29.97 32.961C30.6766 33.8654 30.6766 35.1348 29.97 36.0392L4.97005 68.0392C4.12002 69.1273 2.54891 69.3202 1.46088 68.4702C0.372844 67.6201 0.179901 66.049 1.02993 64.961L24.8275 34.5001L1.02993 4.03922C0.179901 2.95119 0.372844 1.38008 1.46088 0.53005Z"
        }, null, 8, OZ))
      ])),
      (d(), f("svg", PZ, [
        n.direction === "left" ? (d(), f("path", {
          key: 0,
          fill: n.iconColor,
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M31.4626 71.1523C29.7217 72.5123 27.208 72.2036 25.8479 70.4628L0.847911 38.4628C-0.282628 37.0157 -0.282628 34.9847 0.847911 33.5376L25.8479 1.53761C27.208 -0.20324 29.7217 -0.511948 31.4626 0.848091C33.2034 2.20814 33.5122 4.72191 32.1521 6.46277L9.07599 36.0002L32.1521 65.5376C33.5121 67.2785 33.2034 69.7922 31.4626 71.1523Z"
        }, null, 8, NZ)) : (d(), f("path", {
          key: 1,
          fill: n.iconColor,
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M1.5376 0.84808C3.27846 -0.511963 5.79223 -0.203254 7.15228 1.5376L32.1523 33.5376C33.2828 34.9847 33.2828 37.0157 32.1523 38.4628L7.15228 70.4628C5.79223 72.2036 3.27846 72.5123 1.5376 71.1523C-0.203254 69.7922 -0.511963 67.2785 0.84808 65.5376L23.9242 36.0002L0.84808 6.46275C-0.511963 4.7219 -0.203254 2.20812 1.5376 0.84808Z"
        }, null, 8, HZ))
      ])),
      c("span", FZ, k(n.translatedAria), 1)
    ])
  ], 2);
}
const VZ = /* @__PURE__ */ B(IZ, [["render", RZ], ["__scopeId", "data-v-34444ce7"]]), BZ = {
  name: "Slider",
  components: { OriginalSliderButton: VZ },
  props: {
    totalCards: {
      type: Number,
      default: 0
    },
    themeStyles: {
      type: Object,
      default: () => ({})
    },
    currentCard: {
      type: Number,
      default: 0
    },
    allCardsVisible: {
      type: Boolean
    },
    sectionHeader: {
      type: String,
      required: !0
    },
    hideXSmall: {
      type: Boolean,
      default: !0
    }
  },
  computed: {
    buttonStyles() {
      var e, t;
      return {
        "--background-color": ((t = (e = this.themeStyles) == null ? void 0 : e.arrow_background_color) == null ? void 0 : t.hex) || "#fff"
      };
    },
    arrowIconColor() {
      return $(this.themeStyles, "arrow_icon_color.hex", "#000");
    },
    nextSlideText() {
      return $(this.themeStyles, "translations.next_item", "Next Item").split(" ").join(` ${this.sectionHeader} `);
    },
    previousSlideText() {
      return $(this.themeStyles, "translations.previous_item", "Previous Item").split(" ").join(` ${this.sectionHeader} `);
    }
  }
}, jZ = ["aria-label"];
function UZ(e, t, n, r, o, i) {
  const a = V("OriginalSliderButton");
  return d(), f("div", {
    "aria-label": n.sectionHeader,
    style: Z(i.buttonStyles),
    class: _([{ "hide-x-small": n.hideXSmall }, "cards-slider"]),
    role: "region",
    "aria-roledescription": "carousel"
  }, [
    M(e.$slots, "button-left", {}, () => [
      j(a, {
        direction: "left",
        "icon-color": i.arrowIconColor,
        "translated-aria": i.previousSlideText,
        onGoLeft: t[0] || (t[0] = (s) => e.$emit("scroll-left"))
      }, null, 8, ["icon-color", "translated-aria"])
    ]),
    M(e.$slots, "default"),
    M(e.$slots, "button-right", {}, () => [
      j(a, {
        direction: "right",
        "icon-color": i.arrowIconColor,
        "translated-aria": i.nextSlideText,
        onGoRight: t[1] || (t[1] = (s) => e.$emit("scroll-right"))
      }, null, 8, ["icon-color", "translated-aria"])
    ])
  ], 14, jZ);
}
const lh = /* @__PURE__ */ B(BZ, [["render", UZ], ["__scopeId", "data-v-af515ce7"]]), qZ = {
  name: "E4",
  components: { Slider: lh },
  mixins: [Xr, _t],
  computed: {
    content() {
      return this.events;
    },
    eventsContent() {
      return this.isSliderShown ? this.content : this.content.slice(0, 4);
    },
    isSliderShown() {
      return this.screenSize > 960;
    },
    themeStyles() {
      var e, t;
      return ge(ae({}, this.theme), {
        arrow_icon_color: { hex: ((t = (e = this.theme) == null ? void 0 : e.event_arrow_color) == null ? void 0 : t.hex) || "#000" }
      });
    }
  },
  methods: {
    isInRange(e, t) {
      return e >= t - 3 && e <= t + 3;
    },
    isTheLastOneInRange(e, t) {
      return e === t + 3;
    },
    isTheFirstOneInRange(e, t) {
      return e === t;
    },
    cardClassObj(e, t) {
      return {
        "events-card-hidden": !this.isInRange(e, t) && this.isSliderShown,
        "events-card-no-border": this.isTheLastOneInRange(e, t),
        "events-card-first": this.isTheFirstOneInRange(e, t)
      };
    }
  }
}, GZ = ["data-testid"], KZ = ["data-testid"], zZ = { class: "cards-slider-content" }, ZZ = ["aria-label"], xZ = ["href"], WZ = { class: "sr-only" };
function YZ(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("event-tag"), l = V("Slider"), u = ze("touch");
  return d(), f("div", {
    id: "events-e4",
    style: Z(e.colors),
    class: _([e.theme.style, { "is-editing": e.isEditing }]),
    "data-testid": "e4"
  }, [
    e.screenSize >= 600 && e.theme.style === "purple" ? (d(), L(a, {
      key: 0,
      "theme-options": e.theme,
      class: _(["see-all-above hide-on-xs", e.theme.style]),
      "data-testid": `header-${e.theme.style}-above`
    }, {
      header: S(() => [
        e.isMonterreyStyle ? (d(), f("h3", {
          key: 0,
          "data-testid": `header-${e.theme.style}-above`
        }, [
          M(e.$slots, "header-top", {}, () => [
            H(k(e.sectionHeaderTop), 1)
          ], !0)
        ], 8, GZ)) : T("", !0),
        (d(), L(Y(e.isMonterreyStyle ? "h1" : "h2"), {
          "data-testid": `header-${e.theme.style}-above`
        }, {
          default: S(() => [
            M(e.$slots, "header", {}, () => [
              H(k(e.sectionHeader), 1)
            ], !0)
          ]),
          _: 3
        }, 8, ["data-testid"]))
      ]),
      _: 3
    }, 8, ["theme-options", "class", "data-testid"])) : T("", !0),
    c("div", {
      class: _(["events-info", e.theme.style])
    }, [
      e.theme.style !== "purple" || e.screenSize < 600 ? (d(), L(a, {
        key: 0,
        class: _([e.theme.style, "see-all-top"]),
        "theme-options": e.theme,
        "data-testid": `header-${e.theme.style}-top`
      }, {
        header: S(() => [
          e.isMonterreyStyle ? (d(), f("h3", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`
          }, [
            M(e.$slots, "header-top", {}, () => [
              H(k(e.sectionHeaderTop), 1)
            ], !0)
          ], 8, KZ)) : T("", !0),
          (d(), L(Y(e.isMonterreyStyle ? "h1" : "h2"), {
            "data-testid": `header-${e.theme.style}-top`
          }, {
            default: S(() => [
              M(e.$slots, "header", {}, () => [
                H(k(e.sectionHeader), 1)
              ], !0)
            ]),
            _: 3
          }, 8, ["data-testid"]))
        ]),
        default: S(() => [
          e.theme.style !== "purple" && e.screenSize >= 600 ? (d(), L(Y(e.isEditing ? "button" : "a"), {
            key: 0,
            class: _(["hide-on-xs see-all-button", e.theme.style]),
            href: e.seeAllLinkHref,
            target: e.seeAllLinkTarget,
            "data-testid": `see-all-${e.theme.style}-top`,
            onClick: t[0] || (t[0] = (m) => e.$emit("open-modal"))
          }, {
            default: S(() => [
              H(k(e.seeAllLinkName), 1)
            ]),
            _: 1
          }, 8, ["class", "href", "target", "data-testid"])) : T("", !0)
        ]),
        _: 3
      }, 8, ["class", "theme-options", "data-testid"])) : T("", !0),
      j(l, {
        "total-cards": i.content.length,
        "current-card": e.currentCard,
        "all-cards-visible": e.allCardsVisible,
        "section-header": e.sectionHeader,
        "theme-styles": i.themeStyles,
        onScrollRight: e.scrollRight,
        onScrollLeft: e.scrollLeft
      }, {
        default: S(() => [
          c("div", zZ, [
            c("div", {
              ref: "scrollWrapper",
              class: _([{ "all-cards-visible": e.allCardsVisible }, "cards-slider-container"])
            }, [
              (d(!0), f(J, null, ne(i.eventsContent, (m, v) => we((d(), f("div", {
                ref_for: !0,
                ref: `sliderCard-${v}`,
                key: v,
                class: _(["events-card", [e.theme.style, i.cardClassObj(v, e.currentCard), { "is-editing": e.isEditing }]]),
                "aria-label": `${v + 1} of ${i.content.length}`,
                role: "group",
                "aria-roledescription": "slide",
                "data-attr": "event-content",
                "data-testid": "events-content"
              }, [
                c("p", {
                  class: _(["events-date", e.theme.style])
                }, k(e.formatDateAndTime(m.cms_formatted_date, "date")), 3),
                c("a", {
                  class: _(["events-title", e.theme.style]),
                  href: e.isPreview ? "#" : `${e.pathPrefix}/events?id=${m.id}`
                }, [
                  H(k(m.title) + " ", 1),
                  c("span", WZ, k(e.formatDateAndTime(m.cms_formatted_date, "date")), 1)
                ], 10, xZ),
                c("p", {
                  class: _(["events-time", e.theme.style])
                }, [
                  H(k(e.formatDateAndTime(m.cms_formatted_date, "time")) + " ", 1),
                  e.displayEventTags(m) ? (d(), L(s, {
                    key: 0,
                    "display-text": e.eventSectionName(m),
                    "bg-color": e.timeColor
                  }, null, 8, ["display-text", "bg-color"])) : T("", !0)
                ], 2),
                t[2] || (t[2] = c("div", { class: "events-card-mobile-border-top" }, null, -1)),
                t[3] || (t[3] = c("div", { class: "events-card-mobile-border-right" }, null, -1))
              ], 10, ZZ)), [
                [
                  u,
                  e.scrollRight,
                  "swipe",
                  { left: !0 }
                ],
                [
                  u,
                  e.scrollLeft,
                  "swipe",
                  { right: !0 }
                ]
              ])), 128))
            ], 2)
          ])
        ]),
        _: 1
      }, 8, ["total-cards", "current-card", "all-cards-visible", "section-header", "theme-styles", "onScrollRight", "onScrollLeft"]),
      e.theme.style === "purple" || e.screenSize < 600 ? (d(), L(a, {
        key: 1,
        class: _([e.theme.style, "see-all-bottom"]),
        "theme-options": e.theme,
        "data-testid": `see-all-${e.theme.style}-bottom`
      }, {
        default: S(() => [
          (d(), L(Y(e.isEditing ? "button" : "a"), {
            class: _(["see-all-button", e.theme.style]),
            href: e.seeAllLinkHref,
            target: e.seeAllLinkTarget,
            onClick: t[1] || (t[1] = (m) => e.$emit("open-modal"))
          }, {
            default: S(() => [
              H(k(e.seeAllLinkName), 1)
            ]),
            _: 1
          }, 8, ["class", "href", "target"]))
        ]),
        _: 1
      }, 8, ["class", "theme-options", "data-testid"])) : T("", !0)
    ], 2)
  ], 6);
}
const XZ = /* @__PURE__ */ B(qZ, [["render", YZ], ["__scopeId", "data-v-05ce2c28"]]), QZ = {
  name: "E5",
  components: { CardSlider: mn },
  mixins: [Xr, _t],
  computed: {
    content() {
      return this.events.slice(0, 12);
    },
    sliderCenterSize() {
      return 599;
    },
    seeAllStyles() {
      return this.theme.style === "purple" ? "see-all-above" : "see-all-top";
    },
    cssVars() {
      return ge(ae({}, this.colors), {
        "--event-bg-color-2": $(this.theme, "event_bg_color_2.hex", "#fff"),
        "--event-text-color-2": $(this.theme, "event_text_color_2.hex", "#000"),
        "--event-bg-color-4": $(this.theme, "event_bg_color_4.hex", "#fff"),
        "--event-text-color-4": $(this.theme, "event_text_color_4.hex", "#000")
      });
    }
  },
  methods: {
    iconAndTagColor(e) {
      return e + 1 > 4 ? this.cssVars[`--event-text-color-${(e + 1) % 4}`] : this.cssVars[`--event-text-color-${e + 1}`];
    }
  }
}, JZ = ["data-testid"], ex = ["data-testid"], tx = ["aria-label"], nx = { class: "start-date" }, rx = {
  class: "date-month",
  "data-testid": "start-month"
}, ox = {
  class: "date-day",
  "data-testid": "start-day"
}, ix = { key: 0 }, sx = {
  key: 1,
  class: "end-date"
}, ax = {
  class: "date-month",
  "data-testid": "end-month"
}, lx = {
  class: "date-day",
  "data-testid": "end-day"
}, ux = ["href"], dx = { class: "time-section details" }, cx = { class: "icon-wrapper" }, hx = {
  class: "icon",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, mx = ["stroke"], fx = {
  key: 0,
  class: "location-section details"
}, px = { class: "icon-wrapper" }, gx = {
  class: "icon",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, vx = ["fill"], bx = ["stroke"], yx = {
  key: 1,
  class: "section-tag"
};
function _x(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("CardSlider");
  return d(), f("div", {
    id: "events-e5",
    style: Z(i.cssVars),
    class: _([e.theme.style, { "is-editing": e.isEditing }]),
    "data-testid": "e5"
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-above"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        c("h2", {
          "data-testid": `header-${e.theme.style}-top`
        }, [
          e.isMonterreyStyle ? (d(), f("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            M(e.$slots, "header-top", {}, () => [
              H(k(e.sectionHeaderTop), 1)
            ], !0)
          ], 8, ex)) : T("", !0),
          M(e.$slots, "header", {}, () => [
            H(k(e.sectionHeader), 1)
          ], !0)
        ], 8, JZ)
      ]),
      default: S(() => [
        !e.isPurpleStyle && e.screenSize >= 600 ? (d(), L(Y(e.isEditing ? "button" : "a"), {
          key: 0,
          class: _(["see-all-events see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (l) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : T("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    j(s, {
      "nav-orientation": "bottom",
      "pager-orientation": "right",
      "current-card": e.currentCard,
      class: _({ "is-editing": e.isEditing }),
      "pager-section-count": e.pagerSectionCount,
      "total-cards": i.content.length,
      "theme-styles": e.theme,
      "section-header": e.sectionHeader,
      onScrollRight: e.scrollRight,
      onScrollLeft: e.scrollLeft,
      onGoToSection: e.goToSection
    }, {
      default: S(() => [
        c("div", {
          ref: "scrollWrapper",
          class: _(["events-wrapper", { "all-cards-visible": e.allCardsVisible }])
        }, [
          (d(!0), f(J, null, ne(i.content, (l, u) => (d(), f("div", {
            key: u,
            ref_for: !0,
            ref: `sliderCard-${u}`,
            class: _(["card-content", `card-${u}`]),
            "aria-label": `${u + 1} of ${i.content.length}`,
            "data-testid": "events-content",
            role: "group",
            "aria-roledescription": "slide"
          }, [
            (d(), f("div", {
              key: `${u}-${l.title}`,
              class: _(["card events-card card-color", [e.theme.style, `card-color-${u % 4 + 1}`]]),
              "data-testid": "events-content-item"
            }, [
              c("div", {
                class: _(["events-date", e.theme.style])
              }, [
                c("div", nx, [
                  c("div", rx, k(e.startDateMonth(l.cms_formatted_date)), 1),
                  c("div", ox, k(e.startDateDay(l.cms_formatted_date)), 1)
                ]),
                e.endDateMonth(l.cms_formatted_date) ? (d(), f("div", ix, "-")) : T("", !0),
                e.endDateMonth(l.cms_formatted_date) ? (d(), f("div", sx, [
                  c("div", ax, k(e.endDateMonth(l.cms_formatted_date)), 1),
                  c("div", lx, k(e.endDateDay(l.cms_formatted_date)), 1)
                ])) : T("", !0)
              ], 2),
              c("a", {
                class: _(["events-title", e.theme.style]),
                href: e.isPreview ? "#" : `${e.pathPrefix}/events?id=${l.id}`
              }, k(l.title), 11, ux),
              c("div", dx, [
                c("div", cx, [
                  (d(), f("svg", hx, [
                    c("path", {
                      d: "M11.5 12.381C11.5 12.5269 11.5638 12.6656 11.6746 12.7606L14.3413 15.0463C14.5509 15.226 14.8666 15.2017 15.0463 14.9921C15.226 14.7824 15.2017 14.4668 14.9921 14.287L12.5 12.151V8.66667C12.5 8.39052 12.2761 8.16667 12 8.16667C11.7239 8.16667 11.5 8.39052 11.5 8.66667V12.381ZM19.5 12C19.5 16.1421 16.1421 19.5 12 19.5C7.85786 19.5 4.5 16.1421 4.5 12C4.5 7.85786 7.85786 4.5 12 4.5C16.1421 4.5 19.5 7.85786 19.5 12Z",
                      stroke: i.iconAndTagColor(u),
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, null, 8, mx)
                  ]))
                ]),
                c("p", {
                  class: _(["events-time", e.theme.style])
                }, k(e.formatDateAndTime(l.cms_formatted_date, "time")), 3)
              ]),
              l.venue ? (d(), f("div", fx, [
                c("div", px, [
                  (d(), f("svg", gx, [
                    c("rect", {
                      x: "12",
                      y: "11.125",
                      width: "1",
                      height: "9",
                      fill: i.iconAndTagColor(u)
                    }, null, 8, vx),
                    c("circle", {
                      cx: "12.5",
                      cy: "6.625",
                      r: "5",
                      stroke: i.iconAndTagColor(u)
                    }, null, 8, bx)
                  ]))
                ]),
                c("p", {
                  class: _(["events-location", e.theme.style])
                }, k(l.venue), 3)
              ])) : T("", !0),
              e.displayEventTags(l) ? (d(), f("div", yx, k(e.eventSectionName(l)), 1)) : T("", !0),
              t[2] || (t[2] = c("div", { class: "events-card-mobile-border-top" }, null, -1)),
              t[3] || (t[3] = c("div", { class: "events-card-mobile-border-right" }, null, -1))
            ], 2))
          ], 10, tx))), 128))
        ], 2)
      ]),
      _: 1
    }, 8, ["current-card", "class", "pager-section-count", "total-cards", "theme-styles", "section-header", "onScrollRight", "onScrollLeft", "onGoToSection"]),
    e.theme.style === "purple" || e.screenSize < 600 ? (d(), L(a, {
      key: 0,
      class: _([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme,
      "data-testid": `see-all-${e.theme.style}-bottom`
    }, {
      default: S(() => [
        (d(), L(Y(e.isEditing ? "button" : "a"), {
          class: _(["see-all-button see-all-events", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          onClick: t[1] || (t[1] = (l) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options", "data-testid"])) : T("", !0)
  ], 6);
}
const Cx = /* @__PURE__ */ B(QZ, [["render", _x], ["__scopeId", "data-v-45b5b2db"]]), wx = {
  name: "E6",
  mixins: [Xr],
  props: {
    logo: {
      type: String,
      default: ""
    }
  },
  computed: {
    content() {
      return this.events.slice(0, 6);
    },
    isPurpleStyle() {
      return this.theme.style === "purple";
    },
    isMonterreyStyle() {
      return this.theme.style === "monterrey";
    },
    logoStyles() {
      return {
        "--logo-url": `url(${this.logo})`
      };
    }
  }
}, Tx = ["data-testid"], kx = ["data-testid"], Ex = {
  key: 0,
  class: "logo"
}, Sx = { class: "start-date" }, Mx = { class: "month" }, Ax = { class: "date-number" }, Ix = { class: "details" }, Lx = { class: "event-title" }, Dx = ["href"], $x = { class: "event-dates" }, Ox = { class: "event-location" };
function Px(e, t, n, r, o, i) {
  const a = V("SeeAllContainer");
  return d(), f("div", {
    class: _(["events-e6", [e.theme.style, { "is-editing": e.isEditing }]]),
    style: Z(e.colors),
    "data-testid": "e6"
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        c("h2", {
          "data-testid": `header-${e.theme.style}-top`
        }, [
          i.isMonterreyStyle ? (d(), f("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            M(e.$slots, "header-top", {}, () => [
              H(k(e.sectionHeaderTop), 1)
            ], !0)
          ], 8, kx)) : T("", !0),
          M(e.$slots, "header", {}, () => [
            H(k(e.sectionHeader), 1)
          ], !0)
        ], 8, Tx)
      ]),
      default: S(() => [
        !i.isPurpleStyle && e.screenSize >= 600 ? (d(), L(Y(e.isEditing ? "button" : "a"), {
          key: 0,
          class: _(["see-all-events see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (s) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : T("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    c("div", {
      class: "events-container",
      style: Z(i.logoStyles)
    }, [
      n.logo ? (d(), f("div", Ex)) : T("", !0),
      c("div", {
        class: _(["events-wrapper", { "is-editing": e.isEditing }])
      }, [
        (d(!0), f(J, null, ne(i.content, (s, l) => (d(), f("div", {
          key: `${l}-${s.title}`,
          class: "event-card",
          "data-testid": "events-content"
        }, [
          c("div", Sx, [
            c("div", Mx, k(e.startDateMonth(s.cms_formatted_date)), 1),
            c("div", Ax, k(e.startDateDay(s.cms_formatted_date)), 1)
          ]),
          c("div", Ix, [
            c("div", Lx, [
              c("a", {
                class: _(["events-title", e.theme.style]),
                href: e.isPreview ? "#" : `${e.pathPrefix}/events?id=${s.id}`
              }, k(s.title), 11, Dx)
            ]),
            c("div", $x, [
              t[2] || (t[2] = c("br", null, null, -1)),
              H(" " + k(e.getFormattedDate(s.cms_formatted_date, " ")), 1)
            ]),
            c("div", Ox, k(s.venue), 1)
          ])
        ]))), 128))
      ], 2)
    ], 4),
    i.isPurpleStyle || e.screenSize < 600 ? (d(), L(a, {
      key: 0,
      class: _([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme,
      "data-testid": `see-all-${e.theme.style}-bottom`
    }, {
      default: S(() => [
        (d(), L(Y(e.isEditing ? "button" : "a"), {
          class: _(["see-all-events see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          onClick: t[1] || (t[1] = (s) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options", "data-testid"])) : T("", !0)
  ], 6);
}
const Nx = /* @__PURE__ */ B(wx, [["render", Px], ["__scopeId", "data-v-4022f92a"]]), Hx = {
  name: "E7",
  mixins: [Xr],
  emits: ["open-modal"]
}, Fx = ["data-testid"], Rx = ["data-testid"], Vx = { class: "button-text" }, Bx = { class: "month" }, jx = { class: "date-number" }, Ux = { class: "event-title" }, qx = ["href"], Gx = {
  key: 1,
  class: "event-tag"
}, Kx = { class: "button-text" };
function zx(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("EventTag");
  return d(), f("div", {
    class: _(["events-e7", [e.theme.style, { "is-editing": e.isEditing }]]),
    style: Z(e.colors),
    "data-testid": "e7"
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        c("h2", {
          "data-testid": `header-${e.theme.style}-top`
        }, [
          e.isMonterreyStyle ? (d(), f("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            M(e.$slots, "header-top", {}, () => [
              H(k(e.sectionHeaderTop), 1)
            ], !0)
          ], 8, Rx)) : T("", !0),
          M(e.$slots, "header", {}, () => [
            H(k(e.sectionHeader), 1)
          ], !0)
        ], 8, Fx)
      ]),
      default: S(() => [
        !e.isMonterreyStyle && !e.isPurpleStyle && e.screenSize >= 600 ? (d(), L(Y(e.isEditing ? "button" : "a"), {
          key: 0,
          class: _(["see-all-events see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (l) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            c("div", Vx, k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : T("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    c("div", {
      class: _(["events-info", { "is-editing": e.isEditing }])
    }, [
      (d(!0), f(J, null, ne(e.events.slice(0, e.visibleItems), (l) => (d(), f("div", {
        key: l.id,
        class: "events-card",
        "data-testid": "events-content"
      }, [
        c("div", {
          class: _(["events-date", e.theme.style])
        }, [
          c("div", Bx, k(e.startDateMonth(l.cms_formatted_date)), 1),
          c("div", jx, k(e.startDateDay(l.cms_formatted_date)), 1)
        ], 2),
        c("div", {
          class: _(["events-description", e.theme.style])
        }, [
          c("div", Ux, [
            c("a", {
              class: _(["events-title", e.theme.style]),
              href: e.isPreview ? "#" : `${e.pathPrefix}/events?id=${l.id}`
            }, k(l.title), 11, qx)
          ]),
          c("div", {
            class: _(["events-time", e.theme.style])
          }, k(e.getFormattedDate(l.cms_formatted_date)), 3),
          l.venue ? (d(), f("div", {
            key: 0,
            class: _(["events-location", e.theme.style])
          }, k(l.venue), 3)) : T("", !0),
          e.displayEventTags(l) ? (d(), f("div", Gx, [
            j(s, {
              variant: "pill",
              "display-text": e.eventSectionName(l),
              "bg-color": e.colors.event_section_tag_color,
              "font-color": e.colors.event_section_tag_text_color
            }, null, 8, ["display-text", "bg-color", "font-color"])
          ])) : T("", !0)
        ], 2)
      ]))), 128))
    ], 2),
    e.isMonterreyStyle || e.isPurpleStyle || e.screenSize < 600 ? (d(), L(a, {
      key: 0,
      class: _([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme,
      "data-testid": `see-all-${e.theme.style}-bottom`
    }, {
      default: S(() => [
        (d(), L(Y(e.isEditing ? "button" : "a"), {
          class: _(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          onClick: t[1] || (t[1] = (l) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            c("div", Kx, k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options", "data-testid"])) : T("", !0)
  ], 6);
}
const Zx = /* @__PURE__ */ B(Hx, [["render", zx], ["__scopeId", "data-v-fa560b25"]]), xx = {
  name: "CmsEvents",
  components: {
    E1: dZ,
    E2: yZ,
    E3: AZ,
    E4: XZ,
    E5: Cx,
    E6: Nx,
    E7: Zx
  },
  props: {
    options: {
      type: Object,
      required: !0
    },
    content: {
      type: Array,
      default: () => []
    },
    isPreview: Boolean,
    eventsConfig: {
      type: Object,
      required: !0
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    isEditing: Boolean,
    componentId: {
      type: String,
      required: !0
    },
    logo: {
      type: String,
      default: ""
    }
  }
}, Wx = {
  id: "view-events",
  class: "view-events events-versions"
};
function Yx(e, t, n, r, o, i) {
  return d(), f("div", Wx, [
    (d(), L(Y(n.options.version), {
      options: n.options,
      events: n.content,
      "is-preview": n.isPreview,
      "events-config": n.eventsConfig,
      "component-id": n.componentId,
      "path-prefix": n.pathPrefix,
      logo: n.logo,
      "is-editing": n.isEditing,
      onOpenModal: t[0] || (t[0] = (a) => e.$emit("open-modal"))
    }, {
      "header-top": S(() => [
        M(e.$slots, "header-top", {}, void 0, !0)
      ]),
      header: S(() => [
        M(e.$slots, "header", {}, void 0, !0)
      ]),
      _: 3
    }, 40, ["options", "events", "is-preview", "events-config", "component-id", "path-prefix", "logo", "is-editing"]))
  ]);
}
const Xx = /* @__PURE__ */ B(xx, [["render", Yx], ["__scopeId", "data-v-23ed585b"]]), pr = {
  mixins: [St],
  props: {
    theme: {
      type: Object,
      required: !0
    },
    posts: {
      type: Array,
      required: !0
    },
    fallbackImage: {
      type: Object,
      default: () => ({})
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    livefeedConfig: {
      type: Object,
      default: () => ({})
    },
    componentId: {
      type: String,
      default: null
    },
    isPreview: Boolean,
    isIFrame: Boolean,
    isEditing: Boolean
  },
  computed: {
    colors() {
      const e = this.sharedThemeColors();
      let t = $(this.theme, "link_card_bg_color.hex", "#fff");
      return t.startsWith("#") || (t = `#${t}`), ge(ae({}, e), {
        "--top-heading-color": $(this.theme, "top_heading_color.hex", "#fff"),
        "--bottom-heading-color": $(this.theme, "bottom_heading_color.hex", "#fff"),
        "--header-accent-color": $(this.theme, "header_accent_color.hex", "#333"),
        "--button-border-color": $(this.theme, "button_border_color.hex", "#fff"),
        "--link-color": $(this.theme, "post_link_color.hex", "#0000ee"),
        "--time-and-author-color": $(this.theme, "time_and_author_text_color.hex", e["--heading-color"]),
        "--post-bg-color": $(this.theme, "post_bg_color.hex", "#dfdfdf"),
        "--post-text-color": $(this.theme, "post_text_color.hex", "#333"),
        "--panel-bg-color": $(this.theme, "panel_bg_color.hex", "#fff"),
        "--image-border-color": $(
          this.theme,
          "image_border_color.hex",
          this.theme.globalThemeSettings.secondaryColor
        ),
        "--link-card-bg-color": t,
        "--arrow-border-color": $(this.theme, "arrow_border_color.hex", "#fff"),
        "--arrow-background-color": $(this.theme, "arrow_background_color.hex", "#ffffff"),
        "--arrow-icon-color": $(this.theme, "arrow_icon_color.hex", "#ffffff"),
        "--pager-color": $(this.theme, "pager_color.hex", "#000"),
        "--time-color": $(this.theme, "time_color.hex", "#000"),
        "--author-color": $(this.theme, "author_text_color.hex", "#000")
      });
    },
    translations() {
      return this.theme.translations || {};
    },
    isPurpleStyle() {
      return this.theme.style === "purple";
    },
    isMonterreyStyle() {
      return this.theme.style === "monterrey";
    },
    seeAllLinkHref() {
      var e, t;
      return ((t = (e = this.livefeedConfig[this.componentId]) == null ? void 0 : e.see_all_link) == null ? void 0 : t.href) || this.link("live-feed");
    },
    seeAllLinkName() {
      var e, t;
      return ((t = (e = this.livefeedConfig[this.componentId]) == null ? void 0 : e.see_all_link) == null ? void 0 : t.name) || this.translations.see_all;
    },
    seeAllLinkTarget() {
      var e, t;
      return ((t = (e = this.livefeedConfig[this.componentId]) == null ? void 0 : e.see_all_link) == null ? void 0 : t.target) || "_self";
    },
    sectionHeader() {
      var e;
      return ((e = this.livefeedConfig[this.componentId]) == null ? void 0 : e.component_header) || this.translations.title;
    },
    sectionHeaderTop() {
      var e, t;
      return (t = (e = this.livefeedConfig[this.componentId]) == null ? void 0 : e.component_header_top) != null ? t : this.translations.latest;
    },
    readMoreText() {
      return this.translations.read_more || "Read More";
    }
  },
  methods: {
    openLightbox(e) {
      this.isIFrame || this.$emit("openLightbox", e);
    },
    saveFocusElement(e) {
      this.isIFrame || this.$emit("saveFocusElement", e.target);
    },
    onClickImage(e, t, n) {
      this.saveFocusElement(e), this.openLightbox({ images: t, idx: n });
    },
    clickSeeAllButton() {
      this.isIFrame || this.$router.push({ path: `${this.pathPrefix}/live-feed` });
    },
    viewImageText(e) {
      return e.live_feed_images.length > 1 ? this.translations.view_images : this.translations.view_image;
    },
    // Preferably we shouldn't render user-provided HTML
    // https://vuejs.org/v2/guide/syntax.html#Raw-HTML
    getPostContent(e, t) {
      const n = bg(e.status, t), r = `
        <a 
          href="${this.pathPrefix}/live-feed#${e.id}" 
          aria-label="${this.readMoreText} ${e.author}'s post"
        >
          ${this.readMoreText}
        </a>
      `;
      return n.endsWith("...") ? hv(n).concat(r) : n;
    }
  }
}, Qx = {
  name: "LF1",
  mixins: [pr],
  computed: {
    filteredPosts() {
      return this.posts.slice(0, 5);
    }
  },
  methods: {
    thumbnailImages(e) {
      return e.length > 4 ? e.slice(0, 3) : e;
    }
  }
}, Jx = ["data-testid"], eW = { class: "live-feed-post-header" }, tW = ["src"], nW = { class: "live-feed-author" }, rW = ["aria-labelledby", "aria-posinset", "aria-setsize"], oW = ["id", "innerHTML"], iW = ["onKeydown", "onClick"], sW = {
  class: "button-action-content",
  tabindex: "-1"
}, aW = {
  key: 1,
  class: "thumbnails"
}, lW = ["src", "alt", "onKeydown", "onClick"], uW = ["onKeydown", "onClick"];
function dW(e, t, n, r, o, i) {
  const a = V("SeeAllContainer");
  return d(), f("div", {
    id: "LF1",
    class: _(e.theme.style),
    style: Z(e.colors),
    "data-testid": "lf1",
    role: "feed"
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        e.isMonterreyStyle ? (d(), f("h3", {
          key: 0,
          "data-testid": `header-${e.theme.style}-top`
        }, [
          M(e.$slots, "header-top", {}, () => [
            H(k(e.sectionHeaderTop), 1)
          ], !0)
        ], 8, Jx)) : T("", !0),
        (d(), L(Y(e.isMonterreyStyle ? "h1" : "h2"), {
          "data-testid": `header-${e.theme.style}-top`
        }, {
          default: S(() => [
            M(e.$slots, "header", {}, () => [
              H(k(e.sectionHeader), 1)
            ], !0)
          ]),
          _: 3
        }, 8, ["data-testid"]))
      ]),
      default: S(() => [
        e.theme.style === "bold" && e.screenSize >= 600 ? (d(), L(Y(e.isEditing ? "button" : "a"), {
          key: 0,
          class: _(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (s) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : T("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    (d(!0), f(J, null, ne(i.filteredPosts, (s, l) => (d(), f("div", {
      key: `${l}-${s.author}-LF`,
      class: _(["live-feed-post", [e.theme.style, { "is-editing": e.isEditing }]]),
      "data-testid": "live-feed-content"
    }, [
      c("div", eW, [
        c("img", {
          src: s.avatar,
          class: "live-feed-icon",
          alt: "",
          role: "presentation",
          loading: "lazy"
        }, null, 8, tW),
        c("span", nW, k(s.author), 1),
        c("span", {
          class: _(["live-feed-time", e.theme.style])
        }, k(s.time_ago), 3)
      ]),
      c("div", {
        class: _(["live-feed-details", e.theme.style]),
        role: "article",
        tabindex: "0",
        "aria-labelledby": `LF-${s.id}`,
        "aria-posinset": l + 1,
        "aria-setsize": i.filteredPosts.length
      }, [
        c("div", {
          id: `LF-${s.id}`,
          innerHTML: e.getPostContent(s)
        }, null, 8, oW),
        !e.theme.show_thumbnails && s.live_feed_images.length > 0 ? (d(), f("button", {
          key: 0,
          class: "view-images button-action",
          "aria-haspopup": "true",
          onKeydown: [
            K(W((u) => e.onClickImage(u, s.live_feed_images), ["exact", "prevent"]), ["enter"]),
            K(W((u) => e.onClickImage(u, s.live_feed_images), ["exact", "prevent"]), ["space"])
          ],
          onClick: (u) => e.onClickImage(u, s.live_feed_images)
        }, [
          c("div", sW, k(e.viewImageText(s)), 1)
        ], 40, iW)) : T("", !0),
        e.theme.show_thumbnails && s.live_feed_images.length > 0 ? (d(), f("div", aW, [
          (d(!0), f(J, null, ne(i.thumbnailImages(s.live_feed_images), (u, m) => (d(), f("img", {
            key: `${u.id}`,
            tabindex: "0",
            class: "thumbnail",
            loading: "lazy",
            src: u.url,
            alt: u.alt_text,
            onKeydown: [
              K(W((v) => e.onClickImage(v, s.live_feed_images, m), ["exact", "prevent"]), ["enter"]),
              K(W((v) => e.onClickImage(v, s.live_feed_images, m), ["exact", "prevent"]), ["space"])
            ],
            onClick: (v) => e.onClickImage(v, s.live_feed_images, m)
          }, null, 40, lW))), 128)),
          s.live_feed_images.length > 4 ? (d(), f("div", {
            key: 0,
            style: Z({ "--lf-more-bg-image": `url(${s.live_feed_images[3].url})` }),
            tabindex: "0",
            class: "thumbnail more-images",
            onKeydown: [
              K(W((u) => e.onClickImage(u, s.live_feed_images, 3), ["exact", "prevent"]), ["enter"]),
              K(W((u) => e.onClickImage(u, s.live_feed_images, 3), ["exact", "prevent"]), ["space"])
            ],
            onClick: (u) => e.onClickImage(u, s.live_feed_images, 3)
          }, [
            c("span", null, "+ " + k(s.live_feed_images.length - 3), 1)
          ], 44, uW)) : T("", !0)
        ])) : T("", !0)
      ], 10, rW)
    ], 2))), 128)),
    e.theme.style !== "bold" || e.screenSize < 600 ? (d(), L(a, {
      key: 0,
      class: _([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme
    }, {
      default: S(() => [
        (d(), L(Y(e.isEditing ? "button" : "a"), {
          class: _(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-bottom`,
          onClick: t[1] || (t[1] = (s) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options"])) : T("", !0)
  ], 6);
}
const cW = /* @__PURE__ */ B(Qx, [["render", dW], ["__scopeId", "data-v-b6b428e4"]]), hW = {
  name: "LF2",
  mixins: [pr],
  computed: {
    filteredPosts() {
      return this.posts.slice(0, 5);
    }
  }
}, mW = ["data-testid"], fW = { class: "live-feed-post-header" }, pW = ["src"], gW = { class: "live-feed-time-and-author" }, vW = ["aria-labelledby", "aria-posinset", "aria-setsize"], bW = ["id", "innerHTML"], yW = ["onKeydown", "onClick"], _W = {
  class: "button-action-content",
  tabindex: "-1"
};
function CW(e, t, n, r, o, i) {
  const a = V("SeeAllContainer");
  return d(), f("div", {
    id: "LF2",
    style: Z(e.colors),
    class: _(e.theme.style),
    role: "feed"
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        e.isMonterreyStyle ? (d(), f("h3", {
          key: 0,
          "data-testid": `header-${e.theme.style}-top`
        }, [
          M(e.$slots, "header-top", {}, () => [
            H(k(e.sectionHeaderTop), 1)
          ], !0)
        ], 8, mW)) : T("", !0),
        (d(), L(Y(e.isMonterreyStyle ? "h1" : "h2"), {
          "data-testid": `header-${e.theme.style}-top`
        }, {
          default: S(() => [
            M(e.$slots, "header", {}, () => [
              H(k(e.sectionHeader), 1)
            ], !0)
          ]),
          _: 3
        }, 8, ["data-testid"]))
      ]),
      default: S(() => [
        e.theme.style === "bold" && e.screenSize >= 600 ? (d(), L(Y(e.isEditing ? "button" : "a"), {
          key: 0,
          class: _(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (s) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : T("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    (d(!0), f(J, null, ne(i.filteredPosts, (s, l) => (d(), f("div", {
      key: `${l}-${s.author}-LF`,
      class: _(["live-feed-post", { "is-editing": e.isEditing }]),
      "data-testid": "live-feed-content"
    }, [
      c("div", fW, [
        c("img", {
          src: s.avatar,
          class: "live-feed-icon",
          alt: "",
          role: "presentation",
          loading: "lazy"
        }, null, 8, pW),
        c("span", gW, k(s.time_ago) + ", " + k(s.author), 1)
      ]),
      c("div", {
        class: _(["live-feed-details", e.theme.style]),
        role: "article",
        tabindex: "0",
        "aria-labelledby": `LF-${s.id}`,
        "aria-posinset": l + 1,
        "aria-setsize": i.filteredPosts.length
      }, [
        c("div", {
          id: `LF-${s.id}`,
          innerHTML: e.getPostContent(s)
        }, null, 8, bW),
        e.isPreview || s.live_feed_images.length > 0 ? (d(), f("button", {
          key: 0,
          class: "view-images button-action",
          "aria-haspopup": "true",
          onKeydown: [
            K(W((u) => e.onClickImage(u, s.live_feed_images), ["exact", "prevent"]), ["enter"]),
            K(W((u) => e.onClickImage(u, s.live_feed_images), ["exact", "prevent"]), ["space"])
          ],
          onClick: (u) => e.onClickImage(u, s.live_feed_images)
        }, [
          c("div", _W, k(e.viewImageText(s)), 1)
        ], 40, yW)) : T("", !0)
      ], 10, vW)
    ], 2))), 128)),
    e.theme.style !== "bold" || e.screenSize < 600 ? (d(), L(a, {
      key: 0,
      class: _([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme
    }, {
      default: S(() => [
        (d(), L(Y(e.isEditing ? "button" : "a"), {
          class: _(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-bottom`,
          onClick: t[1] || (t[1] = (s) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options"])) : T("", !0)
  ], 6);
}
const wW = /* @__PURE__ */ B(hW, [["render", CW], ["__scopeId", "data-v-a7eaf91b"]]), TW = {
  name: "LF3",
  mixins: [pr],
  computed: {
    filteredPosts() {
      return this.posts.slice(0, 5);
    }
  }
}, kW = ["data-testid"], EW = { class: "live-feed-post-header" }, SW = ["src"], MW = { class: "live-feed-time-and-author" }, AW = ["aria-labelledby", "aria-posinset", "aria-setsize"], IW = ["id", "innerHTML"], LW = ["onKeydown", "onClick"], DW = {
  class: "button-action-content",
  tabindex: "-1"
};
function $W(e, t, n, r, o, i) {
  const a = V("SeeAllContainer");
  return d(), f("div", {
    id: "LF3",
    style: Z(e.colors),
    class: _(e.theme.style),
    role: "feed"
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        e.isMonterreyStyle ? (d(), f("h3", {
          key: 0,
          "data-testid": `header-${e.theme.style}-top`
        }, [
          M(e.$slots, "header-top", {}, () => [
            H(k(e.sectionHeaderTop), 1)
          ], !0)
        ], 8, kW)) : T("", !0),
        (d(), L(Y(e.isMonterreyStyle ? "h1" : "h2"), {
          "data-testid": `header-${e.theme.style}-top`
        }, {
          default: S(() => [
            M(e.$slots, "header", {}, () => [
              H(k(e.sectionHeader), 1)
            ], !0)
          ]),
          _: 3
        }, 8, ["data-testid"]))
      ]),
      default: S(() => [
        e.theme.style === "bold" && e.screenSize >= 600 ? (d(), L(Y(e.isEditing ? "button" : "a"), {
          key: 0,
          class: _(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (s) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : T("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    (d(!0), f(J, null, ne(i.filteredPosts, (s, l) => (d(), f("div", {
      key: `${l}-${s.author}-LF`,
      class: _(["live-feed-post", { "is-editing": e.isEditing }]),
      "data-testid": "live-feed-content"
    }, [
      c("div", EW, [
        c("img", {
          src: s.avatar,
          class: "live-feed-icon",
          alt: "",
          role: "presentation",
          loading: "lazy"
        }, null, 8, SW),
        c("span", MW, k(s.time_ago) + ", " + k(s.author), 1)
      ]),
      c("div", {
        class: _(["live-feed-details", e.theme.style]),
        role: "article",
        tabindex: "0",
        "aria-labelledby": `LF-${s.id}`,
        "aria-posinset": l + 1,
        "aria-setsize": i.filteredPosts.length
      }, [
        c("div", {
          id: `LF-${s.id}`,
          innerHTML: e.getPostContent(s)
        }, null, 8, IW),
        e.isPreview || s.live_feed_images.length > 0 ? (d(), f("button", {
          key: 0,
          class: "view-images button-action",
          "aria-haspopup": "true",
          onKeydown: [
            K(W((u) => e.onClickImage(u, s.live_feed_images), ["exact", "prevent"]), ["enter"]),
            K(W((u) => e.onClickImage(u, s.live_feed_images), ["exact", "prevent"]), ["space"])
          ],
          onClick: (u) => e.onClickImage(u, s.live_feed_images)
        }, [
          c("div", DW, k(e.viewImageText(s)), 1)
        ], 40, LW)) : T("", !0)
      ], 10, AW)
    ], 2))), 128)),
    e.theme.style !== "bold" || e.screenSize < 600 ? (d(), L(a, {
      key: 0,
      class: _([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme
    }, {
      default: S(() => [
        (d(), L(Y(e.isEditing ? "button" : "a"), {
          class: _(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-bottom`,
          onClick: t[1] || (t[1] = (s) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options"])) : T("", !0)
  ], 6);
}
const OW = /* @__PURE__ */ B(TW, [["render", $W], ["__scopeId", "data-v-f35e219d"]]), PW = {
  name: "LF4",
  mixins: [pr],
  data() {
    return {
      displayImage: "",
      displayImageAlt: ""
    };
  },
  computed: {
    filteredPosts() {
      return this.posts.slice(0, 5);
    }
  },
  mounted() {
    this.setDisplayImage();
  },
  methods: {
    setImage(e) {
      if (e.live_feed_images.length >= 1) {
        this.displayImage = e.live_feed_images[0].url, this.displayImageAlt = e.live_feed_images[0].alt_text;
        return;
      }
      this.setDisplayImage();
    },
    setDisplayImage() {
      var e, t, n, r, o, i;
      this.displayImage = ((n = (t = (e = this.filteredPosts[0]) == null ? void 0 : e.live_feed_images) == null ? void 0 : t[0]) == null ? void 0 : n.url) || this.fallbackImage.url, this.displayImageAlt = ((i = (o = (r = this.filteredPosts[0]) == null ? void 0 : r.live_feed_images) == null ? void 0 : o[0]) == null ? void 0 : i.alt_text) || "";
    }
  }
}, NW = { class: "LF4__container" }, HW = ["data-testid"], FW = { class: "LF4__posts__container-images" }, RW = ["src", "alt"], VW = ["onMouseover"], BW = { class: "LF4__posts__container__post__avatar" }, jW = ["src"], UW = { class: "LF4__posts__container__post__info" }, qW = { class: "live-feed-time" }, GW = ["aria-labelledby", "aria-posinset", "aria-setsize"], KW = ["id", "innerHTML"], zW = ["onKeydown", "onClick"], ZW = {
  class: "button-action-content",
  tabindex: "-1"
}, xW = { class: "LF4__posts__image" }, WW = ["src", "alt"];
function YW(e, t, n, r, o, i) {
  const a = V("SeeAllContainer");
  return d(), f("div", {
    id: "LF4",
    style: Z(e.colors),
    class: _(e.theme.style),
    role: "feed"
  }, [
    c("div", NW, [
      c("div", {
        class: _([e.theme.style, "LF4__posts"])
      }, [
        c("div", {
          class: _(["LF4__posts__container", e.theme.style])
        }, [
          j(a, {
            class: _([e.theme.style, "see-all-top"]),
            "theme-options": e.theme
          }, {
            header: S(() => [
              e.isMonterreyStyle ? (d(), f("h3", {
                key: 0,
                "data-testid": `header-${e.theme.style}-top`
              }, [
                M(e.$slots, "header-top", {}, () => [
                  H(k(e.sectionHeaderTop), 1)
                ], !0)
              ], 8, HW)) : T("", !0),
              (d(), L(Y(e.isMonterreyStyle ? "h1" : "h2"), {
                "data-testid": `header-${e.theme.style}-top`
              }, {
                default: S(() => [
                  M(e.$slots, "header", {}, () => [
                    H(k(e.sectionHeader), 1)
                  ], !0)
                ]),
                _: 3
              }, 8, ["data-testid"]))
            ]),
            default: S(() => [
              e.theme.style === "bold" && e.screenSize >= 600 ? (d(), L(Y(e.isEditing ? "button" : "a"), {
                key: 0,
                class: _(["see-all-button", e.theme.style]),
                href: e.seeAllLinkHref,
                target: e.seeAllLinkTarget,
                "data-testid": `see-all-${e.theme.style}-top`,
                onClick: t[0] || (t[0] = (s) => e.$emit("open-modal"))
              }, {
                default: S(() => [
                  H(k(e.seeAllLinkName), 1)
                ]),
                _: 1
              }, 8, ["class", "href", "target", "data-testid"])) : T("", !0)
            ]),
            _: 3
          }, 8, ["class", "theme-options"]),
          c("div", FW, [
            c("img", {
              class: "LF4__posts__container-images__image",
              src: o.displayImage,
              alt: o.displayImageAlt,
              loading: "lazy"
            }, null, 8, RW)
          ]),
          (d(!0), f(J, null, ne(i.filteredPosts, (s, l) => (d(), f("div", {
            key: `${l}-${s.author}-LF`,
            class: _([[e.theme.style, { "is-editing": e.isEditing }], "LF4__posts__container__post"]),
            "data-testid": "live-feed-content",
            onMouseover: (u) => i.setImage(s)
          }, [
            c("div", BW, [
              c("img", {
                src: s.avatar,
                alt: "",
                role: "presentation"
              }, null, 8, jW)
            ]),
            c("div", UW, [
              c("div", {
                class: _([e.theme.style, "LF4__posts__container__post__info__time-author"])
              }, [
                H(k(s.author) + ", ", 1),
                c("span", qW, k(s.time_ago), 1)
              ], 2),
              c("div", {
                class: _([e.theme.style, "live-feed-details"]),
                role: "article",
                tabindex: "0",
                "aria-labelledby": `LF-${s.id}`,
                "aria-posinset": l + 1,
                "aria-setsize": i.filteredPosts.length
              }, [
                c("div", {
                  id: `LF-${s.id}`,
                  class: _(["LF4__posts__container__post__info__text", e.theme.style]),
                  innerHTML: e.getPostContent(s)
                }, null, 10, KW),
                e.isPreview || s.live_feed_images.length > 0 ? (d(), f("button", {
                  key: 0,
                  class: "view-images button-action",
                  "data-testid": "live-feed-images-button",
                  "aria-haspopup": "true",
                  onKeydown: [
                    K(W((u) => e.onClickImage(u, s.live_feed_images), ["exact", "prevent"]), ["enter"]),
                    K(W((u) => e.onClickImage(u, s.live_feed_images), ["exact", "prevent"]), ["space"])
                  ],
                  onClick: (u) => e.onClickImage(u, s.live_feed_images)
                }, [
                  c("div", ZW, k(e.viewImageText(s)), 1)
                ], 40, zW)) : T("", !0)
              ], 10, GW)
            ])
          ], 42, VW))), 128)),
          (e.isEditing || e.posts.length > 4) && (e.theme.style !== "bold" || e.screenSize < 600) ? (d(), L(a, {
            key: 0,
            class: _([e.theme.style, "see-all-bottom"]),
            "theme-options": e.theme,
            "data-testid": "see-all-bottom"
          }, {
            default: S(() => [
              (d(), L(Y(e.isEditing ? "button" : "a"), {
                class: _(["see-all-button", e.theme.style]),
                href: e.seeAllLinkHref,
                target: e.seeAllLinkTarget,
                "data-testid": `see-all-${e.theme.style}-bottom`,
                onClick: t[1] || (t[1] = (s) => e.$emit("open-modal"))
              }, {
                default: S(() => [
                  H(k(e.seeAllLinkName), 1)
                ]),
                _: 1
              }, 8, ["class", "href", "target", "data-testid"]))
            ]),
            _: 1
          }, 8, ["class", "theme-options"])) : T("", !0)
        ], 2),
        c("div", xW, [
          c("img", {
            class: "LF4__posts__image__img",
            src: o.displayImage,
            alt: o.displayImageAlt
          }, null, 8, WW)
        ])
      ], 2)
    ])
  ], 6);
}
const XW = /* @__PURE__ */ B(PW, [["render", YW], ["__scopeId", "data-v-13ae5631"]]), QW = {
  name: "LF5",
  mixins: [pr],
  data() {
    return {
      active: null,
      collapsedSibling: null
    };
  },
  computed: {
    filteredPosts() {
      return this.posts.slice(0, 3);
    }
  },
  methods: {
    setActiveCard(e) {
      this.active = e;
      const t = Math.min(window.innerWidth, document.documentElement.clientWidth);
      if (t > 600 && t < 1281 || this.isPreview && t > 1080 && t < 1441) {
        this.collapsedSibling = e === 0 ? 1 : 0;
        return;
      }
      e < 2 ? this.collapsedSibling = e + 1 : e === 2 && (this.collapsedSibling = 1);
    }
  }
}, JW = ["data-testid"], eY = { class: "live-feed--post-container" }, tY = ["onMouseenter"], nY = { class: "live-feed--card-description" }, rY = { class: "live-feed--card-description--icon" }, oY = ["src"], iY = { class: "live-feed-time" }, sY = ["aria-labelledby", "aria-posinset", "aria-setsize"], aY = ["id", "innerHTML"], lY = ["onKeydown", "onClick"], uY = {
  class: "button-action-content",
  tabindex: "-1"
}, dY = { class: "live-feed--card-image" }, cY = ["src", "alt"];
function hY(e, t, n, r, o, i) {
  const a = V("SeeAllContainer");
  return d(), f("div", {
    id: "live-feed-lf5",
    class: _(e.theme.style),
    style: Z(e.colors),
    role: "feed"
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        e.isMonterreyStyle ? (d(), f("h3", {
          key: 0,
          "data-testid": `header-${e.theme.style}-top`
        }, [
          M(e.$slots, "header-top", {}, () => [
            H(k(e.sectionHeaderTop), 1)
          ], !0)
        ], 8, JW)) : T("", !0),
        (d(), L(Y(e.isMonterreyStyle ? "h1" : "h2"), {
          "data-testid": `header-${e.theme.style}-top`
        }, {
          default: S(() => [
            M(e.$slots, "header", {}, () => [
              H(k(e.sectionHeader), 1)
            ], !0)
          ]),
          _: 3
        }, 8, ["data-testid"]))
      ]),
      default: S(() => [
        e.theme.style !== "purple" && e.screenSize >= 600 ? (d(), L(Y(e.isEditing ? "button" : "a"), {
          key: 0,
          class: _(["hide-on-xs hide-on-lg-three-cols see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (s) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : T("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    c("div", eY, [
      (d(!0), f(J, null, ne(i.filteredPosts, (s, l) => (d(), f("div", {
        key: `${l}-${s.author}-LF`,
        class: _(["live-feed--card", [{ collapsed: l === o.collapsedSibling }, { "is-editing": e.isEditing }]]),
        "data-testid": "live-feed-content",
        onMouseenter: (u) => i.setActiveCard(l),
        onMouseleave: t[1] || (t[1] = (u) => {
          o.active = null, o.collapsedSibling = null;
        })
      }, [
        c("div", nY, [
          c("div", rY, [
            c("img", {
              src: s.avatar,
              alt: "",
              role: "presentation",
              loading: "lazy"
            }, null, 8, oY)
          ]),
          c("div", {
            class: _(["live-feed--card-description--header", e.theme.style])
          }, [
            c("span", null, [
              H(k(s.author) + " - ", 1),
              c("span", iY, k(s.time_ago), 1)
            ])
          ], 2),
          c("div", {
            class: _([e.theme.style, "live-feed-details"]),
            role: "article",
            tabindex: "0",
            "aria-labelledby": `LF-${s.id}`,
            "aria-posinset": l + 1,
            "aria-setsize": i.filteredPosts.length
          }, [
            c("div", {
              id: `LF-${s.id}`,
              class: _(["live-feed--card-description--content", e.theme.style]),
              innerHTML: e.getPostContent(s, 120)
            }, null, 10, aY),
            e.isPreview || s.live_feed_images.length > 0 ? (d(), f("button", {
              key: 0,
              class: "view-images button-action",
              "aria-haspopup": "true",
              onKeydown: [
                K(W((u) => e.onClickImage(u, s.live_feed_images), ["exact", "prevent"]), ["enter"]),
                K(W((u) => e.onClickImage(u, s.live_feed_images), ["exact", "prevent"]), ["space"])
              ],
              onClick: (u) => e.onClickImage(u, s.live_feed_images)
            }, [
              c("div", uY, k(e.viewImageText(s)), 1)
            ], 40, lY)) : T("", !0)
          ], 10, sY)
        ]),
        c("div", dY, [
          c("img", {
            src: s.live_feed_images.length > 0 ? s.live_feed_images[0].url : e.fallbackImage.url,
            alt: s.live_feed_images.length > 0 ? s.live_feed_images[0].alt_text : "",
            loading: "lazy"
          }, null, 8, cY)
        ])
      ], 42, tY))), 128))
    ]),
    e.theme.style === "purple" || e.screenSize < 600 ? (d(), L(a, {
      key: 0,
      class: _([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme
    }, {
      default: S(() => [
        (d(), L(Y(e.isEditing ? "button" : "a"), {
          class: _(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-bottom`,
          onClick: t[2] || (t[2] = (s) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options"])) : T("", !0)
  ], 6);
}
const mY = /* @__PURE__ */ B(QW, [["render", hY], ["__scopeId", "data-v-2034cbed"]]), fY = {
  name: "LF6Buttons",
  props: {
    arrowColor: {
      type: String,
      default: "#fff"
    },
    backgroundColor: {
      type: String,
      default: ""
    },
    borderColor: {
      type: String,
      default: "#fff"
    },
    previousSlideText: {
      type: String,
      default: ""
    },
    nextSlideText: {
      type: String,
      default: ""
    }
  }
}, pY = {
  class: "buttons",
  role: "group",
  "aria-label": "slide controls"
}, gY = ["aria-label"], vY = {
  width: "15",
  height: "12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, bY = ["stroke"], yY = ["aria-label"], _Y = {
  width: "15",
  height: "12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, CY = ["stroke"];
function wY(e, t, n, r, o, i) {
  return d(), f("div", pY, [
    c("button", {
      class: "button",
      style: Z({
        "background-color": n.backgroundColor,
        "border-color": n.borderColor
      }),
      "aria-label": n.previousSlideText,
      onClick: t[0] || (t[0] = (a) => e.$emit("scroll-left")),
      onKeyup: t[1] || (t[1] = K((a) => e.$emit("scroll-left"), ["left"]))
    }, [
      (d(), f("svg", vY, [
        c("path", {
          d: "M1 6h13M1 6l4.79 5M1 6l4.79-5",
          stroke: n.arrowColor,
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, bY)
      ]))
    ], 44, gY),
    c("button", {
      class: "button mirror",
      style: Z({
        "background-color": n.backgroundColor,
        "border-color": n.borderColor
      }),
      "aria-label": n.nextSlideText,
      onClick: t[2] || (t[2] = (a) => e.$emit("scroll-right")),
      onKeyup: t[3] || (t[3] = K((a) => e.$emit("scroll-right"), ["right"]))
    }, [
      (d(), f("svg", _Y, [
        c("path", {
          d: "M1 6h13M1 6l4.79 5M1 6l4.79-5",
          stroke: n.arrowColor,
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, CY)
      ]))
    ], 44, yY)
  ]);
}
const TY = /* @__PURE__ */ B(fY, [["render", wY], ["__scopeId", "data-v-0ee870d6"]]);
var gc, qp;
function kY() {
  if (qp) return gc;
  qp = 1;
  function e(t, n, r) {
    var o = -1, i = t.length;
    n < 0 && (n = -n > i ? 0 : i + n), r = r > i ? i : r, r < 0 && (r += i), i = n > r ? 0 : r - n >>> 0, n >>>= 0;
    for (var a = Array(i); ++o < i; )
      a[o] = t[o + n];
    return a;
  }
  return gc = e, gc;
}
var vc, Gp;
function EY() {
  if (Gp) return vc;
  Gp = 1;
  var e = l0(), t = Os(), n = c8(), r = dr();
  function o(i, a, s) {
    if (!r(s))
      return !1;
    var l = typeof a;
    return (l == "number" ? t(s) && n(a, s.length) : l == "string" && a in s) ? e(s[a], i) : !1;
  }
  return vc = o, vc;
}
var bc, Kp;
function SY() {
  if (Kp) return bc;
  Kp = 1;
  var e = vg(), t = 1 / 0, n = 17976931348623157e292;
  function r(o) {
    if (!o)
      return o === 0 ? o : 0;
    if (o = e(o), o === t || o === -t) {
      var i = o < 0 ? -1 : 1;
      return i * n;
    }
    return o === o ? o : 0;
  }
  return bc = r, bc;
}
var yc, zp;
function MY() {
  if (zp) return yc;
  zp = 1;
  var e = SY();
  function t(n) {
    var r = e(n), o = r % 1;
    return r === r ? o ? r - o : r : 0;
  }
  return yc = t, yc;
}
var _c, Zp;
function AY() {
  if (Zp) return _c;
  Zp = 1;
  var e = kY(), t = EY(), n = MY(), r = Math.ceil, o = Math.max;
  function i(a, s, l) {
    (l ? t(a, s, l) : s === void 0) ? s = 1 : s = o(n(s), 0);
    var u = a == null ? 0 : a.length;
    if (!u || s < 1)
      return [];
    for (var m = 0, v = 0, g = Array(r(u / s)); m < u; )
      g[v++] = e(a, m, m += s);
    return g;
  }
  return _c = i, _c;
}
var IY = AY();
const LY = /* @__PURE__ */ Eo(IY), DY = {
  name: "LF6",
  components: {
    Pager: d0,
    LFButtons: TY
  },
  mixins: [pr, _t],
  props: {
    logo: {
      type: String,
      default: ""
    }
  },
  computed: {
    sliderCenterSize() {
      return this.screenSize;
    },
    logoStyles() {
      return {
        "--logo-url": `url(${this.logo})`
      };
    },
    nextSlideText() {
      var e;
      return ((e = this.theme.translations) == null ? void 0 : e.next_slide) || "Next slide";
    },
    previousSlideText() {
      var e;
      return ((e = this.theme.translations) == null ? void 0 : e.previous_slide) || "Previous slide";
    },
    content() {
      return LY(this.posts, 3);
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.setCardHeight();
    }), window.addEventListener("resize", this.setCardHeight);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.setCardHeight);
  },
  methods: {
    getGalleryType(e) {
      const t = e.live_feed_images.length;
      return t > 4 ? "cols-4 overflow" : `cols-${t}`;
    },
    goToCard(e) {
      this.currentCard = e - 1, this.calculateScroll();
    },
    handleFocusChange(e) {
      e !== this.currentCard && (this.currentCard = e, this.calculateScroll());
    },
    setCardHeight() {
      if (this.isEditing)
        return;
      this.$refs.scrollWrapper.style.minHeight = "auto";
      const e = Math.max(
        ...Array.from(this.content.length).map((n, r) => this.$refs[`sliderCard-${r}`].offsetHeight)
      ), t = this.content.length <= 2 ? 48 : 0;
      this.$refs.scrollWrapper.style.minHeight = `${e + t}px`;
    }
  }
}, $Y = ["data-testid"], OY = ["data-testid"], PY = { class: "controls" }, NY = ["aria-label"], HY = ["id", "aria-label", "onFocusin"], FY = ["id"], RY = { class: "header" }, VY = ["src"], BY = { class: "time-author" }, jY = ["aria-labelledby", "aria-posinset", "aria-setsize"], UY = ["id", "innerHTML"], qY = ["data-see-more", "aria-label", "onClick"], GY = ["src"];
function KY(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("LFButtons"), l = V("Pager");
  return d(), f("div", {
    id: "LF6",
    class: _([e.theme.style, { "is-editing": e.isEditing }]),
    style: Z(e.colors),
    "data-testid": "lf6",
    role: "feed"
  }, [
    j(a, {
      class: _(["see-all-top", e.theme.style]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        c("h2", {
          "data-testid": `header-${e.theme.style}-top`
        }, [
          e.isMonterreyStyle ? (d(), f("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            M(e.$slots, "header-top", {}, () => [
              H(k(e.sectionHeaderTop), 1)
            ], !0)
          ], 8, OY)) : T("", !0),
          M(e.$slots, "header", {}, () => [
            H(k(e.sectionHeader), 1)
          ], !0)
        ], 8, $Y)
      ]),
      default: S(() => [
        e.theme.style === "bold" && e.screenSize >= 600 ? (d(), L(Y(e.isEditing ? "button" : "a"), {
          key: 0,
          class: _(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": "see-all-bold-top",
          onClick: t[0] || (t[0] = (u) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target"])) : T("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    c("div", {
      class: "slider-container",
      style: Z(i.logoStyles)
    }, [
      c("div", PY, [
        j(a, {
          class: _(e.theme.style),
          "theme-options": e.theme,
          "data-testid": "lf-link"
        }, {
          default: S(() => [
            e.theme.style !== "bold" || e.screenSize <= 600 ? (d(), L(Y(e.isEditing ? "button" : "a"), {
              key: 0,
              class: _([e.theme.style, "see-all-button"]),
              href: e.seeAllLinkHref,
              target: e.seeAllLinkTarget,
              "data-testid": `see-all-${e.theme.style}-button`,
              onClick: t[1] || (t[1] = (u) => e.$emit("open-modal"))
            }, {
              default: S(() => [
                H(k(e.seeAllLinkName), 1)
              ]),
              _: 1
            }, 8, ["class", "href", "target", "data-testid"])) : T("", !0)
          ]),
          _: 1
        }, 8, ["class", "theme-options"]),
        c("div", {
          "aria-label": e.sectionHeader,
          role: "region",
          "aria-roledescription": "carousel",
          class: "control-actions-wrapper"
        }, [
          j(s, {
            "arrow-color": e.theme.arrow_icon_color.hex,
            "background-color": e.theme.arrow_background_color.hex,
            "border-color": e.theme.arrow_border_color.hex,
            "previous-slide-text": i.previousSlideText,
            "next-slide-text": i.nextSlideText,
            onScrollLeft: e.scrollLeft,
            onScrollRight: e.scrollRight
          }, null, 8, ["arrow-color", "background-color", "border-color", "previous-slide-text", "next-slide-text", "onScrollLeft", "onScrollRight"]),
          j(l, {
            "total-cards": i.content.length,
            "pager-color": e.theme.pager_color.hex,
            "theme-styles": e.theme,
            "current-card": e.currentCard,
            "pager-section-count": i.content.length,
            class: "pager",
            onGoToSection: i.goToCard
          }, null, 8, ["total-cards", "pager-color", "theme-styles", "current-card", "pager-section-count", "onGoToSection"])
        ], 8, NY)
      ]),
      c("div", {
        ref: "scrollWrapper",
        class: _(["slider", { "is-editing": e.isEditing }])
      }, [
        (d(!0), f(J, null, ne(i.content, (u, m) => (d(), f("div", {
          id: `slide-${m}`,
          key: m,
          ref_for: !0,
          ref: `sliderCard-${m}`,
          class: _(`slide slide-${m} ${m === e.currentCard && "active"}`),
          "aria-label": `${m + 1} of ${i.content.length}`,
          "data-testid": "live-feed-content",
          role: "group",
          "aria-roledescription": "slide",
          onFocusin: (v) => i.handleFocusChange(m)
        }, [
          (d(!0), f(J, null, ne(u, (v, g) => (d(), f("div", {
            id: g,
            key: g,
            class: "post"
          }, [
            c("div", RY, [
              c("img", {
                src: v.avatar,
                class: "avatar",
                alt: "",
                role: "presentation",
                loading: "lazy"
              }, null, 8, VY),
              c("span", BY, k(v.author) + " | " + k(v.time_ago), 1)
            ]),
            c("div", {
              class: "details",
              role: "article",
              tabindex: "0",
              "aria-labelledby": `LF-${v.id}`,
              "aria-posinset": g + 1,
              "aria-setsize": u.length
            }, [
              c("div", {
                id: `LF-${v.id}`,
                class: "post-content",
                innerHTML: e.getPostContent(v, 200)
              }, null, 8, UY),
              v.live_feed_images.length ? (d(), f("div", {
                key: 0,
                class: _(["gallery", i.getGalleryType(v)])
              }, [
                (d(!0), f(J, null, ne(v.live_feed_images, (h, E) => (d(), f("button", {
                  key: `gallery-item-${E}`,
                  "data-see-more": v.live_feed_images.length > 4 && `+ ${v.live_feed_images.length - 4}`,
                  "aria-label": e.translations.open_image_in_modal,
                  class: "gallery-item",
                  onClick: (C) => e.onClickImage(C, v.live_feed_images)
                }, [
                  c("img", {
                    class: "gallery-image",
                    src: h.url,
                    alt: "",
                    loading: "lazy"
                  }, null, 8, GY)
                ], 8, qY))), 128))
              ], 2)) : T("", !0)
            ], 8, jY)
          ], 8, FY))), 128))
        ], 42, HY))), 128))
      ], 2)
    ], 4)
  ], 6);
}
const zY = /* @__PURE__ */ B(DY, [["render", KY], ["__scopeId", "data-v-0723837b"]]), ZY = {
  name: "LF7",
  components: { CardSlider: mn },
  mixins: [pr, _t],
  computed: {
    content() {
      return this.posts.slice(0, 12);
    },
    sliderCenterSize() {
      return 599;
    },
    isPurpleStyle() {
      return this.theme.style === "purple";
    },
    isMonterreyStyle() {
      return this.theme.style === "monterrey";
    }
  },
  methods: {
    extraImagesContent(e) {
      return e.live_feed_images.length > 4 ? `+ ${e.live_feed_images.length - 3}` : "";
    },
    backgroundImage(e, t) {
      return {
        backgroundImage: `url("${e.live_feed_images[t].url}")`
      };
    }
  }
}, xY = ["data-testid"], WY = ["data-testid"], YY = ["aria-label"], XY = { class: "post live-feed-details" }, QY = { class: "post-info" }, JY = ["src"], eX = { class: "author" }, tX = { class: "time-ago" }, nX = ["id", "innerHTML"], rX = { class: "thumbnails-wrapper" }, oX = ["aria-label", "data-before", "data-testid", "onClick"];
function iX(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("CardSlider");
  return d(), f("div", {
    class: _(["live-feed-lf7", [e.theme.style, { "is-editing": e.isEditing }]]),
    style: Z(e.colors),
    "data-testid": "lf7"
  }, [
    j(a, {
      class: _(["see-all-top", e.theme.style]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        c("h2", {
          "data-testid": `header-${e.theme.style}-top`
        }, [
          i.isMonterreyStyle ? (d(), f("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            M(e.$slots, "header-top", {}, () => [
              H(k(e.sectionHeaderTop), 1)
            ], !0)
          ], 8, WY)) : T("", !0),
          M(e.$slots, "header", {}, () => [
            H(k(e.sectionHeader), 1)
          ], !0)
        ], 8, xY)
      ]),
      default: S(() => [
        e.theme.style !== "purple" && e.screenSize >= 600 ? (d(), L(Y(e.isEditing ? "button" : "a"), {
          key: 0,
          class: _(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (l) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : T("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    j(s, {
      "nav-orientation": "bottom",
      "pager-orientation": "right",
      "current-card": e.currentCard,
      class: _({ "is-editing": e.isEditing }),
      "pager-section-count": e.pagerSectionCount,
      "total-cards": i.content.length,
      "theme-styles": e.theme,
      "section-header": e.sectionHeader,
      onScrollRight: e.scrollRight,
      onScrollLeft: e.scrollLeft,
      onGoToSection: e.goToSection
    }, {
      default: S(() => [
        c("div", {
          ref: "scrollWrapper",
          class: _(["posts-wrapper", { "all-cards-visible": e.allCardsVisible }])
        }, [
          (d(!0), f(J, null, ne(i.content, (l, u) => (d(), f("div", {
            key: `${l}-${u}`,
            ref_for: !0,
            ref: `sliderCard-${u}`,
            class: _(["card-content", `card-${u}`]),
            "data-testid": "live-feed-content",
            "aria-label": `${u + 1} of ${i.content.length}`,
            role: "group",
            "aria-roledescription": "slide"
          }, [
            c("div", XY, [
              c("div", QY, [
                c("img", {
                  src: l.avatar,
                  role: "presentation",
                  loading: "lazy"
                }, null, 8, JY),
                c("div", eX, k(l.author), 1),
                t[2] || (t[2] = c("span", null, "|", -1)),
                c("div", tX, k(l.time_ago), 1)
              ]),
              c("div", {
                id: `LF-${l.id}`,
                class: "post-status",
                innerHTML: e.getPostContent(l)
              }, null, 8, nX),
              c("div", rX, [
                (d(!0), f(J, null, ne(l.live_feed_images.slice(0, 4), (m, v) => (d(), f("button", {
                  key: m.id + v,
                  class: "live-feed-image-thumbnail",
                  "aria-label": e.translations.open_image_in_modal,
                  "data-before": i.extraImagesContent(l),
                  style: Z(i.backgroundImage(l, v)),
                  "data-testid": `live-feed-images-button-${v}`,
                  onClick: (g) => e.$emit("openLightbox", { images: l.live_feed_images, idx: v })
                }, null, 12, oX))), 128))
              ])
            ])
          ], 10, YY))), 128))
        ], 2)
      ]),
      _: 1
    }, 8, ["current-card", "class", "pager-section-count", "total-cards", "theme-styles", "section-header", "onScrollRight", "onScrollLeft", "onGoToSection"]),
    e.theme.style === "purple" || e.screenSize < 600 ? (d(), L(a, {
      key: 0,
      class: _([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme,
      "data-testid": `see-all-${e.theme.style}-bottom`
    }, {
      default: S(() => [
        (d(), L(Y(e.isEditing ? "button" : "a"), {
          class: _(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          onClick: t[1] || (t[1] = (l) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options", "data-testid"])) : T("", !0)
  ], 6);
}
const sX = /* @__PURE__ */ B(ZY, [["render", iX], ["__scopeId", "data-v-7551fe7e"]]), aX = {
  name: "ImageGallery",
  props: {
    images: {
      type: Array,
      required: !0
    }
  },
  data() {
    return {
      activeItem: 0
    };
  },
  methods: {
    activateItem(e) {
      this.activeItem = e;
    },
    activateNext() {
      let e = this.activeItem + 1;
      e >= this.images.length && (e = 0), this.activeItem = e;
    },
    activatePrev() {
      let e = this.activeItem - 1;
      e < 0 && (e = this.images.length - 1), this.activeItem = e;
    },
    handleImageClick(e) {
      this.$emit("image-click", { e });
    }
  }
}, lX = {
  class: "image-gallery",
  "data-testid": "image-gallery"
}, uX = {
  key: 0,
  class: "gallery-image"
}, dX = ["src", "alt"], cX = {
  key: 0,
  class: "gallery-controls"
}, hX = { class: "indicators" }, mX = {
  class: "buttons",
  role: "group",
  "aria-label": "slide controls"
};
function fX(e, t, n, r, o, i) {
  return d(), f("div", lX, [
    c("div", {
      class: "gallery-track",
      onClick: t[0] || (t[0] = (a) => i.handleImageClick(a))
    }, [
      t[3] || (t[3] = c("div", {
        class: "gallery-overlay",
        "data-testid": "gallery-overlay"
      }, null, -1)),
      (d(!0), f(J, null, ne(n.images, (a, s) => (d(), f("div", {
        key: a.id + s,
        class: _(["gallery-slide", o.activeItem === s && "is-active"]),
        "data-testid": "gallery-slide"
      }, [
        a.url ? (d(), f("div", uX, [
          c("img", {
            src: a.url,
            alt: a.alt_text
          }, null, 8, dX)
        ])) : T("", !0)
      ], 2))), 128))
    ]),
    n.images.length > 1 ? (d(), f("div", cX, [
      c("div", hX, k(o.activeItem + 1) + " / " + k(n.images.length), 1),
      c("div", mX, [
        c("button", {
          class: "button left",
          "aria-label": "button prev",
          onClick: t[1] || (t[1] = (...a) => i.activatePrev && i.activatePrev(...a))
        }, t[4] || (t[4] = [
          c("svg", null, [
            c("path", { d: "M0.646446 3.64645C0.451185 3.84171 0.451185 4.15829 0.646446 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976311 4.7308 0.659728 4.53553 0.464466C4.34027 0.269204 4.02369 0.269204 3.82843 0.464466L0.646446 3.64645ZM30 3.5L1 3.5V4.5L30 4.5V3.5Z" })
          ], -1)
        ])),
        c("button", {
          class: "button right",
          "aria-label": "button next",
          onClick: t[2] || (t[2] = (...a) => i.activateNext && i.activateNext(...a))
        }, t[5] || (t[5] = [
          c("svg", null, [
            c("path", { d: "M0.646446 3.64645C0.451185 3.84171 0.451185 4.15829 0.646446 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976311 4.7308 0.659728 4.53553 0.464466C4.34027 0.269204 4.02369 0.269204 3.82843 0.464466L0.646446 3.64645ZM30 3.5L1 3.5V4.5L30 4.5V3.5Z" })
          ], -1)
        ]))
      ])
    ])) : T("", !0)
  ]);
}
const pX = /* @__PURE__ */ B(aX, [["render", fX], ["__scopeId", "data-v-49126e1d"]]), gX = {
  name: "LF8",
  components: { Slider: lh, ImageGallery: pX },
  mixins: [pr, _t],
  computed: {
    content() {
      return this.posts;
    },
    sliderCenterSize() {
      return 599;
    },
    cssVars() {
      var e, t;
      return ge(ae({}, this.colors), {
        "--percentage-button-opacity": `${(e = this.theme.percentage_button_opacity) != null ? e : 0}%`,
        "--image-gradient-color": $(this.theme, "image_gradient_color.hex", "#000000"),
        "--image-gradient-opacity": `${(t = this.theme.image_gradient_opacity) != null ? t : 80}%`,
        "--indicators-color": $(this.theme, "indicators_color.hex", "#FFFFFF"),
        "--arrow-color": $(this.theme, "arrow_color.hex", "#FFFFFF"),
        "--button-border-color": $(this.theme, "button_border_color.hex", "#FFFFFF")
      });
    }
  }
}, vX = { class: "wrapper" }, bX = ["data-testid"], yX = ["data-testid"], _X = { class: "button-text" }, CX = {
  ref: "scrollWrapper",
  class: "cards-wrapper"
}, wX = ["aria-label"], TX = ["aria-labelledby", "aria-posinset", "aria-setsize"], kX = { class: "card-header" }, EX = ["src"], SX = { class: "author" }, MX = { class: "time-ago" }, AX = ["id", "innerHTML"], IX = {
  key: 0,
  class: "card-gallery"
}, LX = {
  class: "buttons-container",
  role: "group",
  "aria-label": "slide controls"
}, DX = { class: "button-text" };
function $X(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("ImageGallery"), l = V("Slider");
  return d(), f("div", {
    class: _(["live-feed-lf8", [e.theme.style, { "is-editing": e.isEditing }]]),
    style: Z(i.cssVars),
    "data-testid": "lf8",
    role: "feed"
  }, [
    c("div", vX, [
      j(a, {
        class: _(["see-all-top", e.theme.style]),
        "theme-options": e.theme
      }, {
        header: S(() => [
          c("h2", {
            "data-testid": `header-${e.theme.style}-top`
          }, [
            e.isMonterreyStyle ? (d(), f("span", {
              key: 0,
              "data-testid": `header-${e.theme.style}-top`,
              class: "header-top"
            }, [
              M(e.$slots, "header-top", {}, () => [
                H(k(e.sectionHeaderTop), 1)
              ], !0)
            ], 8, yX)) : T("", !0),
            M(e.$slots, "header", {}, () => [
              H(k(e.sectionHeader), 1)
            ], !0)
          ], 8, bX)
        ]),
        default: S(() => [
          e.theme.style !== "purple" && e.screenSize >= 600 ? (d(), L(Y(e.isEditing ? "button" : "a"), {
            key: 0,
            class: _(["see-all-button", e.theme.style]),
            href: e.seeAllLinkHref,
            target: e.seeAllLinkTarget,
            "data-testid": `see-all-${e.theme.style}-top`,
            onClick: t[0] || (t[0] = (u) => e.$emit("open-modal"))
          }, {
            default: S(() => [
              c("div", _X, k(e.seeAllLinkName), 1)
            ]),
            _: 1
          }, 8, ["class", "href", "target", "data-testid"])) : T("", !0)
        ]),
        _: 3
      }, 8, ["class", "theme-options"]),
      j(l, {
        "current-card": e.currentCard,
        class: _(["slider", { "is-editing": e.isEditing }]),
        "total-cards": i.content.length,
        "theme-styles": e.theme,
        "section-header": e.sectionHeader,
        onScrollRight: e.scrollRight,
        onScrollLeft: e.scrollLeft
      }, {
        "button-left": S(() => [
          c("button", {
            class: "slider-button left",
            "aria-label": "button prev",
            onKeyup: t[1] || (t[1] = K((...u) => e.scrollLeft && e.scrollLeft(...u), ["left"])),
            onClick: t[2] || (t[2] = (...u) => e.scrollLeft && e.scrollLeft(...u))
          }, t[10] || (t[10] = [
            c("svg", null, [
              c("path", { d: "M0.646446 3.64645C0.451185 3.84171 0.451185 4.15829 0.646446 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976311 4.7308 0.659728 4.53553 0.464466C4.34027 0.269204 4.02369 0.269204 3.82843 0.464466L0.646446 3.64645ZM30 3.5L1 3.5V4.5L30 4.5V3.5Z" })
            ], -1)
          ]), 32)
        ]),
        "button-right": S(() => [
          c("button", {
            class: "slider-button right",
            "aria-label": "button next",
            onKeyup: t[3] || (t[3] = K((...u) => e.scrollRight && e.scrollRight(...u), ["right"])),
            onClick: t[4] || (t[4] = (...u) => e.scrollRight && e.scrollRight(...u))
          }, t[11] || (t[11] = [
            c("svg", null, [
              c("path", { d: "M0.646446 3.64645C0.451185 3.84171 0.451185 4.15829 0.646446 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976311 4.7308 0.659728 4.53553 0.464466C4.34027 0.269204 4.02369 0.269204 3.82843 0.464466L0.646446 3.64645ZM30 3.5L1 3.5V4.5L30 4.5V3.5Z" })
            ], -1)
          ]), 32)
        ]),
        default: S(() => [
          c("div", CX, [
            (d(!0), f(J, null, ne(i.content, (u, m) => (d(), f("div", {
              key: `${u}-${m}`,
              ref_for: !0,
              ref: `sliderCard-${m}`,
              class: _(["card", `card-${m}`]),
              "data-testid": "live-feed-content",
              "aria-label": `${m + 1} of ${i.content.length}`,
              role: "group",
              "aria-roledescription": "slide"
            }, [
              c("div", {
                class: "card-content",
                role: "article",
                tabindex: "0",
                "aria-labelledby": `LF-${u.id}`,
                "aria-posinset": m + 1,
                "aria-setsize": i.content.length
              }, [
                c("div", kX, [
                  c("img", {
                    src: u.avatar,
                    role: "presentation",
                    loading: "lazy"
                  }, null, 8, EX),
                  c("div", SX, k(u.author), 1),
                  c("div", MX, k(u.time_ago), 1)
                ]),
                c("div", {
                  id: `LF-${u.id}`,
                  class: "card-description",
                  innerHTML: e.getPostContent(u)
                }, null, 8, AX)
              ], 8, TX),
              u.live_feed_images.length >= 1 && e.screenSize > 600 ? (d(), f("div", IX, [
                j(s, {
                  images: u.live_feed_images,
                  onImageClick: (v) => e.onClickImage(v, u.live_feed_images)
                }, null, 8, ["images", "onImageClick"])
              ])) : T("", !0)
            ], 10, wX))), 128))
          ], 512)
        ]),
        _: 1
      }, 8, ["current-card", "class", "total-cards", "theme-styles", "section-header", "onScrollRight", "onScrollLeft"]),
      c("div", LX, [
        c("button", {
          class: "slider-button left",
          "aria-label": "button prev",
          onKeyup: t[5] || (t[5] = K((...u) => e.scrollLeft && e.scrollLeft(...u), ["left"])),
          onClick: t[6] || (t[6] = (...u) => e.scrollLeft && e.scrollLeft(...u))
        }, t[12] || (t[12] = [
          c("svg", null, [
            c("path", { d: "M0.646446 3.64645C0.451185 3.84171 0.451185 4.15829 0.646446 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976311 4.7308 0.659728 4.53553 0.464466C4.34027 0.269204 4.02369 0.269204 3.82843 0.464466L0.646446 3.64645ZM30 3.5L1 3.5V4.5L30 4.5V3.5Z" })
          ], -1)
        ]), 32),
        c("button", {
          class: "slider-button right",
          "aria-label": "button next",
          onKeyup: t[7] || (t[7] = K((...u) => e.scrollRight && e.scrollRight(...u), ["right"])),
          onClick: t[8] || (t[8] = (...u) => e.scrollRight && e.scrollRight(...u))
        }, t[13] || (t[13] = [
          c("svg", null, [
            c("path", { d: "M0.646446 3.64645C0.451185 3.84171 0.451185 4.15829 0.646446 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976311 4.7308 0.659728 4.53553 0.464466C4.34027 0.269204 4.02369 0.269204 3.82843 0.464466L0.646446 3.64645ZM30 3.5L1 3.5V4.5L30 4.5V3.5Z" })
          ], -1)
        ]), 32)
      ]),
      e.theme.style === "purple" || e.screenSize < 600 ? (d(), L(a, {
        key: 0,
        class: _([e.theme.style, "see-all-bottom"]),
        "theme-options": e.theme,
        "data-testid": `see-all-${e.theme.style}-bottom`
      }, {
        default: S(() => [
          (d(), L(Y(e.isEditing ? "button" : "a"), {
            class: _(["see-all-button", e.theme.style]),
            href: e.seeAllLinkHref,
            target: e.seeAllLinkTarget,
            onClick: t[9] || (t[9] = (u) => e.$emit("open-modal"))
          }, {
            default: S(() => [
              c("div", DX, k(e.seeAllLinkName), 1)
            ]),
            _: 1
          }, 8, ["class", "href", "target"]))
        ]),
        _: 1
      }, 8, ["class", "theme-options", "data-testid"])) : T("", !0)
    ])
  ], 6);
}
const OX = /* @__PURE__ */ B(gX, [["render", $X], ["__scopeId", "data-v-45fd8393"]]), PX = {
  name: "LiveFeed",
  components: {
    LF1: cW,
    LF2: wW,
    LF3: OW,
    LF4: XW,
    LF5: mY,
    LF6: zY,
    LF7: sX,
    LF8: OX
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Array,
      default: () => []
    },
    fallbackImage: {
      type: Object,
      default: () => {
      }
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    isPreview: Boolean,
    isIFrame: Boolean,
    livefeedConfig: {
      type: Object,
      default: () => ({})
    },
    componentId: {
      type: String,
      default: null
    },
    isEditing: Boolean,
    logo: {
      type: String,
      default: ""
    }
  },
  methods: {
    openLightbox(e) {
      this.$emit("toggleLightbox", e);
    },
    saveFocusElement(e) {
      this.$emit("savePrevFocusedElem", e);
    }
  }
}, NX = { id: "cms-live-feed" };
function HX(e, t, n, r, o, i) {
  return d(), f("div", NX, [
    (d(), L(Y(n.theme.version), {
      theme: n.theme,
      posts: n.content,
      "livefeed-config": n.livefeedConfig,
      "component-id": n.componentId,
      "fallback-image": n.fallbackImage,
      "path-prefix": n.pathPrefix,
      "is-preview": n.isPreview,
      "is-i-frame": n.isIFrame,
      "is-editing": n.isEditing,
      logo: n.logo,
      onOpenModal: t[0] || (t[0] = (a) => e.$emit("open-modal")),
      onSaveFocusElement: t[1] || (t[1] = (a) => i.saveFocusElement(a)),
      onOpenLightbox: t[2] || (t[2] = (a) => i.openLightbox(a))
    }, {
      "header-top": S(() => [
        M(e.$slots, "header-top", {}, void 0, !0)
      ]),
      header: S(() => [
        M(e.$slots, "header", {}, void 0, !0)
      ]),
      _: 3
    }, 40, ["theme", "posts", "livefeed-config", "component-id", "fallback-image", "path-prefix", "is-preview", "is-i-frame", "is-editing", "logo"]))
  ]);
}
const FX = /* @__PURE__ */ B(PX, [["render", HX], ["__scopeId", "data-v-cf483d17"]]), Ei = {
  mixins: [St],
  components: { DraggableWrapper: yt },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    stats: {
      type: Object,
      required: !0
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    },
    isEditing: Boolean,
    isPreview: Boolean
  },
  computed: {
    colors() {
      const e = this.sharedThemeColors(), t = e["--heading-color"];
      return ge(ae({}, e), {
        "--accent-color": $(this.theme, "accent_color.hex", "#FFF"),
        "--arrow-color": $(this.theme, "arrow_icon_color.hex", "#FFF"),
        "--card-bg-color": $(this.theme, "card_bg_color.hex", t),
        "--card-2-bg-color": $(this.theme, "card_2_bg_color.hex", "#FCD40B"),
        "--card-3-bg-color": $(this.theme, "card_3_bg_color.hex", "#131313"),
        "--card-border-color": $(this.theme, "card_border_color.hex", this.theme.globalThemeSettings.secondaryColor),
        "--card-top-border": $(this.theme, "card_top_border.hex", t),
        "--color": $(this.theme, "color.hex", t),
        "--color-2": $(this.theme, "color_2.hex", t),
        "--color-3": $(this.theme, "color_3.hex", t),
        "--description-color": $(this.theme, "description_color.hex", t),
        "--headline-color": $(this.theme, "headline_color.hex", "#FFF"),
        "--icon-bg-color": $(this.theme, "icon_bg_color.hex", t),
        "--icon-color": $(this.theme, "icon_color.hex", t),
        "--link-color": $(this.theme, "link_color.hex", "#FFF"),
        "--link-hover-color": $(this.theme, "link_hover_color.hex", "#FFF"),
        "--snippet-color": $(this.theme, "snippet_color.hex", "#333"),
        "--stats-header-color": $(this.theme, "stats_header_color.hex", "#FFF"),
        "--stats-slider-header-width": this.stats.headline && this.stats.slider ? "calc(100%/3 - 16px)" : "calc(25% - 18px)"
      });
    },
    translations() {
      return this.theme.translations;
    },
    displayHeaderTop() {
      return this.theme.style === "monterrey" && (this.stats.component_header_top || this.isEditing);
    },
    backgroundStyle() {
      var t, n;
      if (!((t = this.stats.bg_image) != null && t.url) || !this.theme.show_background_image) return null;
      const e = `${this.theme.bg_color.hex}e6`;
      return {
        backgroundImage: `linear-gradient(${e}, ${e}), url(${((n = this.stats.bg_image) == null ? void 0 : n.url) || ""})`,
        backgroundSize: "cover",
        backgroundPosition: "center center"
      };
    }
  }
}, RX = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, VX = {
  width: "22",
  height: "32",
  viewBox: "0 0 22 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, BX = ["fill"];
function jX(e, t, n, r, o, i) {
  return d(), f("svg", VX, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M17 20.2059V30.9971C17 31.3818 16.779 31.7315 16.434 31.8988C16.296 31.9639 16.148 31.997 16 31.997C15.777 31.997 15.556 31.9219 15.375 31.7776L11 28.278L6.625 31.7776C6.324 32.018 5.915 32.0631 5.566 31.8988C5.221 31.7315 5 31.3818 5 30.9971V20.2059C1.994 18.2402 0 14.8498 0 10.9986C0 4.93325 4.935 0 11 0C17.065 0 22 4.93325 22 10.9986C22 14.8498 20.006 18.2402 17 20.2059ZM7 28.9162L10.375 26.2172C10.74 25.9246 11.26 25.9246 11.625 26.2172L15 28.9162V21.2338C13.758 21.7207 12.412 21.9982 11 21.9982C9.588 21.9982 8.242 21.7207 7 21.2338V28.9162ZM11 1.99875C6.037 1.99875 2 6.03632 2 10.9986C2 15.9599 6.037 19.9975 11 19.9975C15.963 19.9975 20 15.9599 20 10.9986C20 6.03632 15.963 1.99875 11 1.99875ZM13 15.998H9C8.447 15.998 8 15.5502 8 14.9981C8 14.4461 8.447 13.9982 9 13.9982H10V9.41265L8.707 10.7051C8.512 10.9014 8.256 10.9986 8 10.9986C7.744 10.9986 7.488 10.9014 7.293 10.7051C6.902 10.3153 6.902 9.68215 7.293 9.29142L10.292 6.2928C10.385 6.19962 10.495 6.12649 10.618 6.07539C10.733 6.0283 10.855 6.00626 10.977 6.00326C10.985 6.00326 10.992 5.99825 11 5.99825C11.007 5.99825 11.012 6.00225 11.019 6.00225C11.143 6.00526 11.266 6.0283 11.382 6.07539C11.627 6.17758 11.822 6.37195 11.923 6.61741C11.973 6.73863 12 6.86788 12 6.99712C12 6.99812 12 6.99812 12 6.99912V13.9982H13C13.553 13.9982 14 14.4461 14 14.9981C14 15.5502 13.553 15.998 13 15.998Z",
      fill: n.color
    }, null, 8, BX)
  ]);
}
const UX = /* @__PURE__ */ B(RX, [["render", jX]]), qX = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, GX = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, KX = ["fill"];
function zX(e, t, n, r, o, i) {
  return d(), f("svg", GX, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M16 32C7.178 32 0 24.823 0 16C0 7.178 7.178 0 16 0C24.822 0 32 7.178 32 16C32 24.823 24.822 32 16 32ZM4.948 24.542C6.752 22.358 7.753 19.708 7.951 17H2.048C2.25 19.832 3.307 22.425 4.948 24.542ZM7.95 15C7.753 12.293 6.751 9.643 4.946 7.46C3.306 9.577 2.25 12.169 2.048 15H7.95ZM15 2.051C11.622 2.291 8.579 3.739 6.286 5.957C8.517 8.548 9.737 11.741 9.944 15H15V2.051ZM15 17H9.945C9.738 20.259 8.518 23.453 6.288 26.045C8.581 28.262 11.623 29.709 15 29.949V17ZM29.952 17H24.049C24.247 19.708 25.249 22.358 27.053 24.541C28.693 22.424 29.75 19.832 29.952 17ZM17 29.949C20.378 29.709 23.42 28.261 25.713 26.044C23.483 23.452 22.262 20.259 22.055 17H17V29.949ZM17 2.051V15H22.055C22.262 11.741 23.483 8.548 25.713 5.956C23.42 3.739 20.378 2.291 17 2.051ZM27.053 7.458C25.249 9.643 24.247 12.293 24.049 15H29.952C29.75 12.168 28.693 9.576 27.053 7.458Z",
      fill: n.color
    }, null, 8, KX)
  ]);
}
const ZX = /* @__PURE__ */ B(qX, [["render", zX]]), xX = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, WX = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, YX = ["fill"];
function XX(e, t, n, r, o, i) {
  return d(), f("svg", WX, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M30 26H26.85L29.8 30.45C30.1 30.9 30 31.55 29.5 31.85C29.4 31.95 29.2 32 29 32C28.7 32 28.35 31.85 28.15 31.55L24.45 26H17V30C17 30.55 16.55 31 16 31C15.45 31 15 30.55 15 30V26H7.55L3.85 31.55C3.65 31.85 3.3 32 3 32C2.8 32 2.6 31.95 2.45 31.85C2 31.55 1.85 30.9 2.15 30.45L5.1 26H2C0.9 26 0 25.1 0 24V6C0 4.9 0.9 4 2 4H15V1C15 0.45 15.45 0 16 0C16.55 0 17 0.45 17 1V4H30C31.1 4 32 4.9 32 6V24C32 25.1 31.1 26 30 26ZM30 24V10H2V24H30ZM2 6V8H30V6H2Z",
      fill: n.color
    }, null, 8, YX)
  ]);
}
const QX = /* @__PURE__ */ B(xX, [["render", XX]]), JX = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, eQ = {
  width: "28",
  height: "32",
  viewBox: "0 0 28 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, tQ = ["fill"];
function nQ(e, t, n, r, o, i) {
  return d(), f("svg", eQ, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M27 29V31C27 31.552 26.553 32 26 32H20C19.447 32 19 31.552 19 31V29H9V31C9 31.552 8.553 32 8 32H2C1.447 32 1 31.552 1 31V29C0.447 29 0 28.552 0 28V3C0 1.346 1.346 0 3 0H25C26.654 0 28 1.346 28 3V28C28 28.552 27.553 29 27 29ZM21 30H25V29H21V30ZM3 30H7V29H3V30ZM26 3C26 2.449 25.552 2 25 2H3C2.448 2 2 2.449 2 3V7H26V3ZM26 9H2V17H26V9ZM26 19H2V27H26V19ZM6 21C7.102 21 8 21.897 8 23C8 24.103 7.102 25 6 25C4.897 25 4 24.103 4 23C4 21.897 4.897 21 6 21ZM22 21C23.102 21 24 21.897 24 23C24 24.103 23.102 25 22 25C20.897 25 20 24.103 20 23C20 21.897 20.897 21 22 21Z",
      fill: n.color
    }, null, 8, tQ)
  ]);
}
const rQ = /* @__PURE__ */ B(JX, [["render", nQ]]), oQ = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, iQ = {
  width: "26",
  height: "32",
  viewBox: "0 0 26 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, sQ = ["fill"];
function aQ(e, t, n, r, o, i) {
  return d(), f("svg", iQ, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M25.4203 27C26.0792 28.25 26.1806 29.5 25.623 30.45C25.0149 31.45 23.8492 32 22.3794 32H3.62695C2.15716 32 0.940789 31.45 0.383285 30.45C-0.17422 29.5 -0.123538 28.25 0.535331 27L7.98562 13.8V2C7.42812 2 6.97198 1.55 6.97198 1C6.97198 0.45 7.42812 0 7.98562 0H17.97C18.5275 0 18.9837 0.45 18.9837 1C18.9837 1.5 18.5782 1.9 18.1221 2V14L25.4203 27ZM13.0032 7H10.0129V9H13.0032C13.5607 9 14.0168 9.45 14.0168 10C14.0168 10.55 13.5607 11 13.0032 11H10.0129V14.05V14.1C10.0129 14.15 10.0129 14.25 9.96223 14.3C9.96223 14.35 9.91155 14.45 9.91155 14.5V14.55L2.30921 27.95C2.00512 28.55 1.90375 29.05 2.10648 29.4C2.30921 29.75 2.86672 30 3.62695 30H22.3794C23.1396 30 23.6971 29.8 23.8999 29.4C24.1026 29.05 24.0519 28.55 23.6971 27.95L16.0948 14.5C15.9427 14.2 15.9427 13.9 16.0441 13.6V2H9.96223V5H12.9525C13.51 5 13.9661 5.45 13.9661 6C13.9661 6.55 13.5607 7 13.0032 7Z",
      fill: n.color
    }, null, 8, sQ)
  ]);
}
const lQ = /* @__PURE__ */ B(oQ, [["render", aQ]]), uQ = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, dQ = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, cQ = ["fill"];
function hQ(e, t, n, r, o, i) {
  return d(), f("svg", dQ, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M31.7909 3.612L21.9725 16.317L28.6932 23.037C28.6932 23.037 28.6932 23.038 28.6942 23.038L28.6992 23.043C28.7464 23.091 28.7705 23.151 28.8066 23.205C28.8428 23.259 28.89 23.304 28.9151 23.367L28.9181 23.373C28.9181 23.373 28.9181 23.374 28.9191 23.374L31.9235 30.617C32.0791 30.991 31.9927 31.421 31.7066 31.707C31.5148 31.898 31.2597 32 30.9997 32C30.8711 32 30.7396 31.975 30.6171 31.924L23.3753 28.919C23.3743 28.919 23.3733 28.918 23.3712 28.918L23.3672 28.916C23.314 28.894 23.2769 28.853 23.2307 28.824C23.1664 28.784 23.0981 28.755 23.0429 28.699L23.0379 28.695C23.0369 28.694 23.0369 28.694 23.0369 28.693L17.0412 22.698L14.9907 25.352C15.0731 26.699 14.6272 28.048 13.6452 29.203C12.154 30.957 9.70396 32 7.08116 32C7.05706 32 7.03397 32 7.00987 32C4.68529 31.983 2.29847 30.807 0.291199 28.688C0.0100414 28.391 -0.0622564 27.953 0.109451 27.582C0.27915 27.211 0.648671 26.981 1.0674 27.001C3.7394 27.136 4.02256 26.17 4.49652 24.571C4.7114 23.846 4.95541 23.024 5.47354 22.316C6.48972 20.928 8.0622 20.064 9.57041 20L11.8779 17.572L1.29132 6.95C1.26923 6.927 1.26119 6.898 1.24111 6.873C1.21902 6.855 1.19291 6.848 1.17283 6.828C0.416716 6.074 0.00100414 5.069 0 4.001C0 2.933 0.415712 1.928 1.17183 1.171C1.92693 0.416 2.93107 0 3.99947 0C5.06787 0 6.07301 0.416 6.82812 1.171C6.84921 1.193 6.85724 1.222 6.87632 1.245C6.89941 1.264 6.92753 1.272 6.94861 1.293L17.4077 11.751L28.2754 0.311C28.4632 0.112 28.7253 0 28.9994 0C30.5418 0 31.9998 1.458 31.9998 3C31.9998 3.221 31.9265 3.436 31.7909 3.612ZM29.149 29.15L27.6408 25.515L25.5141 27.642L29.149 29.15ZM23.7498 26.578L26.5774 23.75L20.7404 17.912L18.2743 21.103L23.7498 26.578ZM7.08718 23.497C6.7749 23.925 6.59917 24.516 6.41341 25.141C6.02481 26.452 5.52475 28.132 3.42611 28.761C4.60095 29.561 5.83503 29.991 7.02392 30C7.043 30 7.06309 30 7.08216 30C9.12558 30 11.0053 29.22 12.1219 27.908C12.7756 27.139 13.0708 26.265 13.0035 25.418L9.60556 22.02C8.6938 22.064 7.74088 22.604 7.08718 23.497ZM5.53479 2.707C5.5127 2.685 5.50567 2.657 5.48559 2.633C5.4635 2.614 5.43538 2.607 5.41329 2.585C4.65818 1.83 3.34176 1.83 2.58565 2.586C2.20809 2.964 1.99923 3.466 1.99923 4.001C1.99923 4.534 2.20809 5.036 2.58464 5.413C2.60774 5.436 2.61577 5.466 2.63686 5.491C2.65895 5.509 2.68707 5.517 2.70715 5.538L3.99746 6.832L6.82812 4L5.53479 2.707ZM8.24194 5.414L5.40928 8.248L13.2556 16.121L16.03 13.201L8.24194 5.414ZM29.3428 2.092L11.3959 20.982L13.9033 23.489L29.9423 2.733C29.8369 2.474 29.5979 2.222 29.3428 2.092Z",
      fill: n.color
    }, null, 8, cQ)
  ]);
}
const mQ = /* @__PURE__ */ B(uQ, [["render", hQ]]), fQ = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, pQ = {
  width: "32",
  height: "26",
  viewBox: "0 0 32 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, gQ = ["fill"];
function vQ(e, t, n, r, o, i) {
  return d(), f("svg", pQ, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M31 21.9873H29C28.447 21.9873 28 21.5398 28 20.9872C28 20.4366 28.447 19.989 29 19.989H30V2.00429H2V20.0531H15C15.553 20.0531 16 20.4366 16 20.9872C16 21.5398 15.553 21.9873 15 21.9873H1C0.447 21.9873 0 21.5398 0 20.9872V1.00513C0 0.453498 0.447 0.00598145 1 0.00598145H31C31.553 0.00598145 32 0.453498 32 1.00513V20.9872C32 21.5398 31.553 21.9873 31 21.9873ZM22 10.9957C24.757 10.9957 27 13.2372 27 15.9924C27 17.1097 26.618 18.1319 25.995 18.9649C25.995 18.9739 26 18.9809 26 18.9899V24.9848C26 25.3522 25.797 25.6916 25.472 25.8658C25.324 25.9449 25.162 25.984 25 25.984C24.806 25.984 24.612 25.9279 24.445 25.8158L22 24.1869L19.555 25.8158C19.249 26.02 18.853 26.04 18.528 25.8658C18.203 25.6916 18 25.3522 18 24.9848V18.9899C18 18.9809 18.005 18.9739 18.005 18.9649C17.382 18.1319 17 17.1097 17 15.9924C17 13.2372 19.243 10.9957 22 10.9957ZM22 12.995C20.346 12.995 19 14.3395 19 15.9924C19 17.6453 20.346 18.9899 22 18.9899C23.654 18.9899 25 17.6453 25 15.9924C25 14.3395 23.654 12.995 22 12.995ZM21.445 22.1545C21.781 21.9313 22.219 21.9313 22.555 22.1545L24 23.1176V20.5647C23.386 20.833 22.712 20.9872 22 20.9872C21.288 20.9872 20.613 20.833 20 20.5647V23.1176L21.445 22.1545ZM15 10.0416C15.553 10.0416 16 10.445 16 10.9957C16 11.5483 15.553 11.9958 15 11.9958H9C8.447 11.9958 8 11.5483 8 10.9957C8 10.445 8.447 10.0416 9 10.0416H15ZM5 7.9992C4.447 7.9992 4 7.55169 4 7.00005C4 6.44841 4.447 6.03694 5 6.03694H27C27.553 6.03694 28 6.44841 28 7.00005C28 7.55169 27.553 7.9992 27 7.9992H5Z",
      fill: n.color
    }, null, 8, gQ)
  ]);
}
const bQ = /* @__PURE__ */ B(fQ, [["render", vQ]]), yQ = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, _Q = {
  width: "25",
  height: "33",
  viewBox: "0 0 25 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, CQ = ["fill"];
function wQ(e, t, n, r, o, i) {
  return d(), f("svg", _Q, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M5.55567 0C4.69663 0 3.998 0.699099 3.998 1.55839V26.8914C3.998 27.7516 4.69685 28.4492 5.55567 28.4492H22.8797C23.7392 28.4492 24.4373 27.7515 24.4373 26.8914L24.4507 9.09668C24.4507 9.07071 24.4543 9.04756 24.4507 9.02997V9.01535C24.4581 8.98566 24.4507 8.94257 24.4507 8.8917C24.4507 8.59877 24.3093 8.33899 24.0918 8.17674L16.1802 0.260977C15.9739 0.0561669 15.7006 0.00255148 15.4538 0.0325386C15.4031 0.0178254 15.331 0 15.2543 0H5.55567ZM5.7807 26.6664L5.78397 1.74266H14.6593V8.8917C14.6593 9.40065 15.0835 9.75501 15.559 9.75501H22.6547V26.6664H5.7807ZM16.442 8.00033V3.04523L21.3947 8.00033H16.442ZM1.549 4.00017C0.693308 4.00017 0 4.70059 0 5.55789V30.8916C0 31.7509 0.698628 32.45 1.55767 32.45H18.8823C19.2991 32.45 19.6921 32.2858 19.9851 31.9879C20.2784 31.6909 20.4361 31.2951 20.4306 30.8789L20.4206 30.2112C20.4132 29.7031 19.9833 29.3573 19.5315 29.3335L19.5239 29.3331L19.5164 29.3332C19.0237 29.3404 18.6318 29.7454 18.638 30.2374L18.6506 30.6666H1.78259L1.77408 5.78289H2.20567C2.69715 5.78289 3.09667 5.38447 3.09667 4.89153C3.09667 4.3994 2.6973 4.00017 2.20567 4.00017H1.549Z",
      fill: n.color
    }, null, 8, CQ)
  ]);
}
const TQ = /* @__PURE__ */ B(yQ, [["render", wQ]]), kQ = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, EQ = {
  width: "26",
  height: "33",
  viewBox: "0 0 26 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, SQ = ["fill"];
function MQ(e, t, n, r, o, i) {
  return d(), f("svg", EQ, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12 27.9811V30.091H15C15.55 30.091 16 30.4929 16 31.0455C16 31.5981 15.55 32.0502 15 32.0502H7C6.45 32.0502 6 31.5981 6 31.0455C6 30.4929 6.45 30.091 7 30.091H10V27.9811C7.8 27.8304 5.6 27.1271 3.5 25.9215C3 25.6201 2.85 25.0172 3.15 24.5651C3.45 24.0628 4.05 23.9121 4.5 24.2135C6.65 25.4694 8.8 26.0722 11 26.0722C18.15 26.0722 24 20.2449 24 13.0612C24 8.43953 21.6 4.26999 17.5 1.90892C17 1.60751 16.85 1.00468 17.15 0.552564C17.45 0.0502093 18.05 -0.100497 18.5 0.200916C23.2 2.91363 26 7.73624 26 13.0612C26 20.9482 19.8 27.4285 12 27.9811ZM22 13.011C22 19.0895 17.05 24.0125 11 24.0125C4.95 24.0125 0 19.0895 0 13.011C0 6.93247 4.95 2.00939 11 2.00939C17.05 2.00939 22 6.93247 22 13.011ZM11 4.01881C6.05 4.01881 2 8.03765 2 13.011C2 17.9843 6.05 22.0031 11 22.0031C15.95 22.0031 20 17.9843 20 13.011C20 8.03765 15.95 4.01881 11 4.01881Z",
      fill: n.color
    }, null, 8, SQ)
  ]);
}
const AQ = /* @__PURE__ */ B(kQ, [["render", MQ]]), IQ = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, LQ = {
  width: "32",
  height: "24",
  viewBox: "0 0 32 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, DQ = ["fill"];
function $Q(e, t, n, r, o, i) {
  return d(), f("svg", LQ, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M32 17C32 20.86 28.8599 24 25.0005 24C21.1411 24 18 20.86 18 17C18 16.517 18.0492 16.046 18.1426 15.591C17.8543 15.39 17.1452 15 16 15C14.8639 15 14.1557 15.386 13.8584 15.592C13.9508 16.047 14 16.518 14 17C14 20.86 10.8599 24 7.0005 24C3.14114 24 0 20.86 0 17C0 16.75 0.0150678 16.504 0.0401808 16.26C0.00401809 16.125 -0.0100452 15.983 0.0140633 15.836L2.01406 3.836C2.17579 2.535 3.43446 0 7.0005 0C7.55299 0 8 0.448 8 1C8 1.552 7.55299 2 7.0005 2C4.2893 2 4.00301 4.037 3.99297 4.124L2.77549 11.432C3.95078 10.538 5.41236 10 7.0005 10C9.66047 10 11.9779 11.492 13.1622 13.683C13.78 13.346 14.7172 13 16 13C17.2838 13 18.22 13.346 18.8388 13.682C20.0231 11.492 22.3405 10 25.0005 10C26.5876 10 28.0492 10.537 29.2245 11.432L28.0141 4.164C27.9769 3.916 27.6183 2 25.0005 2C24.447 2 24 1.552 24 1C24 0.448 24.447 0 25.0005 0C28.5655 0 29.8242 2.535 29.992 3.876L31.9859 15.836C32.0111 15.983 31.997 16.125 31.9598 16.261C31.9859 16.504 32 16.75 32 17ZM7.0005 12C4.24309 12 2 14.243 2 17C2 19.757 4.24309 22 7.0005 22C9.75691 22 12 19.757 12 17C12 14.243 9.75691 12 7.0005 12ZM25.0005 12C22.2431 12 20 14.243 20 17C20 19.757 22.2431 22 25.0005 22C27.7569 22 30 19.757 30 17C30 14.243 27.7569 12 25.0005 12Z",
      fill: n.color
    }, null, 8, DQ)
  ]);
}
const OQ = /* @__PURE__ */ B(IQ, [["render", $Q]]), PQ = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, NQ = {
  width: "30",
  height: "33",
  viewBox: "0 0 30 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, HQ = ["fill"];
function FQ(e, t, n, r, o, i) {
  return d(), f("svg", NQ, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M28.9995 7.00245H24.9995V11.0037C24.9995 11.5559 24.5517 12.0048 23.9995 12.0048C23.4473 12.0048 22.9995 11.5559 22.9995 11.0037V7.00245H18.9995C18.4473 7.00245 17.9995 6.55463 17.9995 6.00239C17.9995 5.45014 18.4091 5.06759 18.9624 5.06759H22.9995V1.00107C22.9995 0.448823 23.4473 0 23.9995 0C24.5517 0 24.9995 0.448823 24.9995 1.00107V5.06759H29.0025C29.5557 5.06759 29.9995 5.45014 29.9995 6.00239C29.9995 6.55463 29.5517 7.00245 28.9995 7.00245ZM23.3439 31.9488C23.2304 31.991 23.114 32.01 22.9995 32.01C22.5919 32.01 22.2093 31.759 22.0608 31.3544L17.9463 20.1288H6.05272L1.93826 31.3544C1.7475 31.8735 1.17722 32.1386 0.655127 31.9488C0.137055 31.758 -0.12901 31.1837 0.0617534 30.6656L11.0608 0.656668C11.2043 0.262065 11.5798 0 11.9995 0C12.4192 0 12.7947 0.262065 12.9383 0.656668L23.9383 30.6656C24.128 31.1837 23.862 31.758 23.3439 31.9488ZM11.9995 3.90587L6.78967 18.1206H17.2104L11.9995 3.90587Z",
      fill: n.color
    }, null, 8, HQ)
  ]);
}
const RQ = /* @__PURE__ */ B(PQ, [["render", FQ]]), VQ = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, BQ = {
  width: "32",
  height: "28",
  viewBox: "0 0 32 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, jQ = ["fill"];
function UQ(e, t, n, r, o, i) {
  return d(), f("svg", BQ, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M29.9355 23.8376C28.7979 23.8376 27.871 22.904 27.871 21.759C27.871 20.9929 28.289 20.3299 28.9032 19.9687V12.1175L24.7546 14.5042C24.7577 14.5385 24.7742 14.5687 24.7742 14.6031V24.8764C24.7742 24.916 24.7556 24.9503 24.7515 24.9899C24.7432 25.0606 24.7319 25.1273 24.7102 25.1959C24.6895 25.2594 24.6627 25.3167 24.6307 25.375C24.5987 25.4322 24.5646 25.4843 24.5223 25.5363C24.4759 25.5915 24.4253 25.6362 24.3685 25.681C24.3386 25.7049 24.32 25.7382 24.2859 25.7591C24.1404 25.8507 20.6483 27.9938 15.4839 27.9938C10.3195 27.9938 6.82735 25.8507 6.68181 25.7591C6.64774 25.7382 6.62916 25.7049 6.59923 25.681C6.54245 25.6362 6.49187 25.5915 6.44542 25.5353C6.4031 25.4843 6.36903 25.4322 6.33703 25.375C6.30503 25.3167 6.27819 25.2594 6.25755 25.1959C6.23587 25.1273 6.22452 25.0606 6.21626 24.9899C6.21213 24.9513 6.19355 24.917 6.19355 24.8764V14.6031C6.19355 14.5687 6.21006 14.5385 6.21316 14.5042L0.520258 11.2286C0.198194 11.0444 0 10.6998 0 10.3272C0 9.95355 0.198194 9.60902 0.520258 9.42479L14.9719 1.11037C15.2877 0.928217 15.679 0.928217 15.9959 1.11037L30.4475 9.42479C30.7695 9.60902 30.9677 9.95355 30.9677 10.3272C30.9677 10.3449 30.9554 10.3595 30.9543 10.3782C30.9554 10.4022 30.9677 10.423 30.9677 10.4469V19.9687C31.5819 20.3299 32 20.9929 32 21.759C32 22.904 31.0741 23.8376 29.9355 23.8376ZM22.7097 24.2571V15.6804L15.9959 19.543C15.8379 19.6346 15.6604 19.6804 15.4839 19.6804C15.3074 19.6804 15.1298 19.6346 14.9719 19.543L8.25806 15.6804V24.254C9.29445 24.7765 11.9515 25.9162 15.4839 25.9162C19.0369 25.9162 21.6785 24.7796 22.7097 24.2571ZM15.4839 3.20979L3.11329 10.3272L15.4839 17.4436L27.8545 10.3272L15.4839 3.20979Z",
      fill: n.color
    }, null, 8, jQ)
  ]);
}
const qQ = /* @__PURE__ */ B(VQ, [["render", UQ]]), GQ = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, KQ = {
  width: "33",
  height: "29",
  viewBox: "0 0 33 29",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, zQ = ["fill"];
function ZQ(e, t, n, r, o, i) {
  return d(), f("svg", KQ, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M31.0462 2.957H13.8656L8.9928 28.1971C8.89233 28.5986 8.59091 28.8997 8.23926 29C8.18903 29 8.08856 29 8.03832 29C7.73691 29 7.38526 28.8495 7.23455 28.5484L0.201588 18.5627C-0.0998244 18.1111 0.000646586 17.509 0.452766 17.1577C0.904885 16.8566 1.50771 16.957 1.85936 17.4086L7.48573 25.4875L12.0572 1.80288C12.0572 1.7527 12.0572 1.7527 12.0572 1.70252C12.0572 1.65234 12.1074 1.55198 12.1576 1.5018C12.2079 1.45162 12.2079 1.40144 12.2581 1.35126C12.3083 1.30108 12.3586 1.2509 12.4088 1.20073C12.459 1.15055 12.5093 1.15055 12.5595 1.10037C12.6098 1.05019 12.66 1.05019 12.7605 1.00001C12.8107 1.00001 12.8609 0.949829 12.9614 0.949829C13.0116 0.949829 13.0116 0.949829 13.0619 0.949829H31.0964C31.649 0.949829 32.1011 1.40144 32.1011 1.95341C32.1011 2.50538 31.5988 2.957 31.0462 2.957ZM16.4779 7.17205C16.93 6.87098 17.5831 7.02151 17.8342 7.47313L22.0038 14.147L26.1733 7.47313C26.4747 7.02151 27.0776 6.87098 27.5297 7.17205C27.9818 7.47313 28.1325 8.07528 27.8311 8.57707L23.1592 16.0538L27.8311 23.5305C28.1325 23.9821 27.9818 24.6344 27.5297 24.9355C27.379 25.0359 27.178 25.086 26.9771 25.086C26.6254 25.086 26.324 24.9355 26.1231 24.6344L21.9535 18.0108L17.784 24.6344C17.5831 24.9355 17.2816 25.086 16.93 25.086C16.7291 25.086 16.5784 25.0359 16.3774 24.9355C15.9253 24.6344 15.7746 24.0323 16.076 23.5305L20.7479 16.0538L16.1765 8.52689C15.8751 8.07528 16.0258 7.47313 16.4779 7.17205Z",
      fill: n.color
    }, null, 8, zQ)
  ]);
}
const xQ = /* @__PURE__ */ B(GQ, [["render", ZQ]]), WQ = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, YQ = {
  width: "32",
  height: "38",
  viewBox: "0 0 32 38",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, XQ = ["fill"];
function QQ(e, t, n, r, o, i) {
  return d(), f("svg", YQ, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M31.9702 8.89879C31.9829 8.9717 31.9898 9.0423 31.9875 9.11521C31.9863 9.18696 31.9759 9.25525 31.9609 9.327C31.9437 9.4057 31.9217 9.47861 31.8883 9.55268C31.8745 9.58509 31.8745 9.62097 31.8572 9.65337L24.8414 22.3181C25.7754 23.9233 26.2909 25.7218 26.2909 27.5897C26.2909 33.3278 21.6794 37.9977 16.0105 37.9977C10.3416 37.9977 5.73017 33.3278 5.73017 27.5897C5.73017 25.7207 6.24679 23.921 7.17969 22.3181L0.165057 9.65337C0.146607 9.62097 0.146607 9.58509 0.132769 9.55268C0.10048 9.47861 0.0774174 9.4057 0.0612732 9.327C0.0451291 9.25525 0.0347507 9.18696 0.0335976 9.11521C0.0312913 9.0423 0.0393633 8.9717 0.0508949 8.89879C0.0635796 8.82009 0.0831832 8.74718 0.112012 8.67311C0.124697 8.63955 0.12239 8.60367 0.138535 8.57011L3.56571 1.63188C3.57839 1.60526 3.60722 1.59369 3.62221 1.56823C3.69832 1.43977 3.79518 1.33098 3.91396 1.2407C3.95547 1.2083 3.99353 1.17936 4.03965 1.1539C4.17342 1.07868 4.31871 1.03123 4.47785 1.01502C4.50322 1.01271 4.52282 0.994191 4.54819 0.993034C4.55857 0.991877 4.56664 0.995349 4.57702 0.995349C4.58048 0.995349 4.58394 0.993034 4.5874 0.993034H26.8629C26.9793 0.993034 27.0866 1.0266 27.1927 1.06016C27.2872 1.03933 27.3726 0.989562 27.4729 0.993034C27.8915 1.00808 28.2686 1.25343 28.4554 1.63188L31.8825 8.57011C31.8987 8.60367 31.8964 8.63955 31.9102 8.67311C31.939 8.74718 31.9575 8.82009 31.9702 8.89879ZM16.0105 35.6853C20.419 35.6853 24.0065 32.0536 24.0065 27.5897C24.0065 25.9405 23.5164 24.3481 22.587 22.9836C21.4269 21.2834 19.6833 20.1053 17.6757 19.6655C17.1337 19.5532 16.5698 19.4953 16.0105 19.4953C15.4513 19.4953 14.8874 19.5532 14.3315 19.6689C12.34 20.1053 10.5953 21.2834 9.4341 22.9847C8.50581 24.3469 8.01457 25.9405 8.01457 27.5897C8.01457 32.0536 11.602 35.6853 16.0105 35.6853ZM17.309 17.301L21.4073 10.2436H10.6138L14.6971 17.2756C15.5723 17.1645 16.4441 17.1957 17.309 17.301ZM2.45291 9.05619L8.68686 20.3101C9.73392 19.2396 10.9943 18.4109 12.3942 17.8751L4.66927 4.57036L2.45291 9.05619ZM9.27035 7.93126H22.7507L25.4364 3.30539H6.58466L9.27035 7.93126ZM27.3518 4.57036L19.6395 17.8531C21.0394 18.3936 22.2941 19.2315 23.3365 20.3078L29.5682 9.05619L27.3518 4.57036Z",
      fill: n.color
    }, null, 8, XQ)
  ]);
}
const JQ = /* @__PURE__ */ B(WQ, [["render", QQ]]), eJ = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, tJ = {
  width: "32",
  height: "29",
  viewBox: "0 0 32 29",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, nJ = ["fill"];
function rJ(e, t, n, r, o, i) {
  return d(), f("svg", tJ, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M29.452 24H20.22L20.82 27H22.047C22.599 27 23.047 27.447 23.047 28C23.047 28.553 22.599 29 22.047 29H10.047C9.495 29 9.047 28.553 9.047 28C9.047 27.447 9.495 27 10.047 27H11.18L11.78 24H2.548C1.143 24 0 22.857 0 21.452V2.548C0 1.143 1.143 0 2.548 0H29.452C30.857 0 32 1.143 32 2.548V21.452C32 22.857 30.857 24 29.452 24ZM18.78 27L18.18 24H13.82L13.22 27H18.78ZM2.548 22H29.452C29.754 22 30 21.754 30 21.452V20H2V21.452C2 21.754 2.246 22 2.548 22ZM29.452 2H2.548C2.246 2 2 2.246 2 2.548V18H30V2.548C30 2.246 29.754 2 29.452 2Z",
      fill: n.color
    }, null, 8, nJ)
  ]);
}
const oJ = /* @__PURE__ */ B(eJ, [["render", rJ]]), iJ = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, sJ = {
  width: "32",
  height: "30",
  viewBox: "0 0 32 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, aJ = ["fill"];
function lJ(e, t, n, r, o, i) {
  return d(), f("svg", sJ, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M30 30H2C0.898 30 0 29.103 0 28V7C0 5.897 0.898 5 2 5H10V3C10 1.346 11.346 0 13 0H19C20.654 0 22 1.346 22 3V5H30C31.102 5 32 5.897 32 7V28C32 29.103 31.102 30 30 30ZM17 28H29.996L29.998 16H26V17.285C26 18.782 24.654 20 23 20C22.234 20 21.503 19.735 20.94 19.254C20.343 18.742 20 18.024 20 17.285V16H17V28ZM22 17.285C22 17.497 22.151 17.658 22.241 17.735C22.438 17.903 22.715 18 23 18C23.532 18 24 17.666 24 17.285V14H22V17.285ZM2 28H15V16H12V17.285C12 18.782 10.654 20 9 20C8.234 20 7.503 19.735 6.94 19.254C6.343 18.742 6 18.024 6 17.285V16H2V28ZM10 17.285V14H8V17.285C8 17.497 8.151 17.658 8.241 17.735C8.438 17.903 8.715 18 9 18C9.532 18 10 17.666 10 17.285ZM20 3C20 2.448 19.552 2 19 2H13C12.448 2 12 2.448 12 3V5H20V3ZM2 7V14H6V13C6 12.448 6.447 12 7 12H11C11.553 12 12 12.448 12 13V14H20V13C20 12.448 20.447 12 21 12H25C25.553 12 26 12.448 26 13V14H29.999L30 7H2Z",
      fill: n.color
    }, null, 8, aJ)
  ]);
}
const uJ = /* @__PURE__ */ B(iJ, [["render", lJ]]), dJ = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, cJ = {
  width: "32",
  height: "28",
  viewBox: "0 0 32 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, hJ = ["fill"];
function mJ(e, t, n, r, o, i) {
  return d(), f("svg", cJ, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M31.0006 11.9999C30.9956 11.9999 30.9875 11.9999 30.9805 11.9999H26.9838V22.0007H28.9826C29.535 22.0007 29.9811 22.4485 29.9811 23.0006C29.9811 23.5526 29.535 24.0005 28.9826 24.0005H2.99831C2.44596 24.0005 1.99887 23.5526 1.99887 23.0006C1.99887 22.4485 2.44596 22.0007 2.99831 22.0007H4.99718V11.9999H0.999436C0.559363 11.9999 0.171418 11.7113 0.0431051 11.2895C-0.0842053 10.8687 0.079193 10.4129 0.445085 10.1674L15.4356 0.167566C15.7714 -0.0558552 16.2095 -0.0558552 16.5443 0.167566L31.4246 10.0933C31.7644 10.2536 32 10.5992 32 11C32 11.552 31.5529 11.9999 31.0006 11.9999ZM21.9866 22.0007H24.9849V11.9999H21.9866V22.0007ZM16.9894 22.0007H19.9877V11.9999H16.9894V22.0007ZM14.9905 22.0007V11.9999H11.9501V22.0007H14.9905ZM6.93791 22.0007H9.99436V11.9999H6.93791V22.0007ZM15.99 2.2014L4.30048 10.0001H27.6805L15.99 2.2014ZM0.999436 26.0002H30.9805C31.5329 26.0002 31.98 26.4481 31.98 27.0001C31.98 27.5532 31.5329 28 30.9805 28H0.999436C0.44709 28 0 27.5532 0 27.0001C0 26.4481 0.44709 26.0002 0.999436 26.0002Z",
      fill: n.color
    }, null, 8, hJ)
  ]);
}
const fJ = /* @__PURE__ */ B(dJ, [["render", mJ]]), pJ = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, gJ = {
  width: "28",
  height: "33",
  viewBox: "0 0 28 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, vJ = ["fill"];
function bJ(e, t, n, r, o, i) {
  return d(), f("svg", gJ, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M17.219 17.4369C23.242 18.8659 28 24.1269 28 30.0179V31.0169C28 31.5669 27.552 32.0139 27 32.0139H1C0.448 32.0139 0 31.5669 0 31.0169V30.0179C0 24.1269 4.758 18.8659 10.78 17.4369C7.406 16.1399 5 12.8779 5 9.05893C5 4.10593 9.038 0.0759277 14 0.0759277C18.962 0.0759277 23 4.10593 23 9.05893C23 12.8779 20.594 16.1399 17.219 17.4369ZM2 30.0179H26C26 24.1699 20.393 19.0399 14 19.0399C7.607 19.0399 2 24.1699 2 30.0179ZM14 2.07293C10.14 2.07293 7 5.20693 7 9.05893C7 12.9109 10.14 16.0449 14 16.0449C17.86 16.0449 21 12.9109 21 9.05893C21 5.20693 17.86 2.07293 14 2.07293Z",
      fill: n.color
    }, null, 8, vJ)
  ]);
}
const yJ = /* @__PURE__ */ B(pJ, [["render", bJ]]), _J = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, CJ = {
  width: "30",
  height: "32",
  viewBox: "0 0 30 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, wJ = ["fill"];
function TJ(e, t, n, r, o, i) {
  return d(), f("svg", CJ, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M27 20.794V27C27 28.005 26.269 28.962 25.299 29.227L15.263 31.964C15.175 31.988 15.087 32 14.999 32C14.76 32 14.537 31.908 14.359 31.757C14.331 31.759 14.306 31.77 14.278 31.77C14.111 31.77 13.941 31.747 13.772 31.701L4.702 29.227C3.731 28.962 3 28.005 3 27V20.794C1.567 20.288 0 18.835 0 17C0 15.164 1.567 13.711 3 13.206V11C3 10.423 3.247 9.904 3.677 9.576C4.105 9.247 4.669 9.146 5.229 9.299L14.298 11.772C14.483 11.822 14.648 11.918 14.812 12.015L24.772 9.298C25.327 9.147 25.894 9.247 26.323 9.576C26.753 9.904 27 10.423 27 11V13.206C28.433 13.711 30 15.164 30 17C30 18.835 28.433 20.288 27 20.794ZM2 17C2 18.033 3.375 19 4 19C4.408 19 5 18.22 5 17C5 15.779 4.408 15 4 15C3.375 15 2 15.966 2 17ZM14 14C14 13.901 13.867 13.727 13.772 13.701L5 11.309V13.237C6.173 13.777 7 15.229 7 17C7 18.771 6.173 20.223 5 20.763V27C5 27.099 5.133 27.272 5.229 27.298L14 29.69V14ZM25 11.309L15.96 13.774C15.969 13.851 16 13.923 16 14V29.69L24.772 27.298C24.867 27.272 25 27.099 25 27V20.763C23.827 20.223 23 18.771 23 17C23 15.229 23.827 13.777 25 13.237V11.309ZM26 15C25.592 15 25 15.779 25 17C25 18.22 25.592 19 26 19C26.625 19 28 18.033 28 17C28 15.966 26.625 15 26 15ZM15 10C12.243 10 10 7.757 10 5C10 2.243 12.243 0 15 0C17.757 0 20 2.243 20 5C20 7.757 17.757 10 15 10ZM15 2C13.346 2 12 3.346 12 5C12 6.654 13.346 8 15 8C16.654 8 18 6.654 18 5C18 3.346 16.654 2 15 2Z",
      fill: n.color
    }, null, 8, wJ)
  ]);
}
const kJ = /* @__PURE__ */ B(_J, [["render", TJ]]), EJ = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, SJ = {
  width: "33",
  height: "33",
  viewBox: "0 0 33 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, MJ = ["fill"];
function AJ(e, t, n, r, o, i) {
  return d(), f("svg", SJ, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M31.9511 15.2675C31.8112 15.6861 31.4205 15.9511 31.0026 15.9511C30.8969 15.9511 30.7912 15.934 30.6854 15.8989L26.0083 14.335L25.7032 15.2625C25.6196 15.5155 25.4394 15.7253 25.2017 15.8447C25.0618 15.915 24.9067 15.9511 24.7526 15.9511C24.6459 15.9511 24.5402 15.934 24.4375 15.8999L17.0044 13.4256V15.133C18.7242 15.5807 20.004 17.1335 20.004 18.9935C20.004 20.0274 19.5992 20.9629 18.9528 21.6736L22.9321 31.6269C23.1375 32.1408 22.8878 32.722 22.3753 32.9278C22.2535 32.977 22.1276 33 22.0037 33C21.607 33 21.2314 32.7611 21.0754 32.3707L17.241 22.7797C16.8493 22.9082 16.4385 22.9955 16.0045 22.9955C15.5695 22.9955 15.1597 22.9082 14.768 22.7797L10.9326 32.3707C10.7766 32.7611 10.401 33 10.0042 33C9.88039 33 9.75453 32.977 9.63269 32.9278C9.12016 32.722 8.87045 32.1408 9.07586 31.6269L13.0552 21.6746C12.4088 20.9629 12.004 20.0274 12.004 18.9935C12.004 17.1335 13.2838 15.5807 15.0036 15.133V12.991C15.0036 12.9137 15.0308 12.8465 15.0479 12.7752L9.09902 10.7948L8.9651 11.2645C8.83923 11.7042 8.43848 11.9903 8.00449 11.9903C7.91286 11.9903 7.82023 11.9782 7.7286 11.9511L0.729478 9.9506C0.197823 9.79904 -0.110296 9.24496 0.0417497 8.71397L2.0415 1.7107C2.19354 1.17871 2.75138 0.873565 3.278 1.02413L10.2771 3.02463C10.8088 3.1772 11.1169 3.73028 10.9648 4.26127L10.7484 5.01911L26.3184 10.2005C26.842 10.3742 27.1249 10.9393 26.9528 11.4623L26.6336 12.4339L31.3198 14.0018C31.8434 14.1765 32.1253 14.7436 31.9511 15.2675ZM3.68983 3.22237L2.23986 8.30142L7.31677 9.75286L7.41645 9.40255C7.42451 9.33128 7.41947 9.26102 7.44263 9.19075C7.45773 9.14458 7.49096 9.11146 7.51211 9.0703L8.76673 4.67382L3.68983 3.22237ZM14.0037 18.9935C14.0037 20.0967 14.9019 20.994 16.0045 20.994C17.1061 20.994 18.0042 20.0967 18.0042 18.9935C18.0042 17.8894 17.1061 16.992 16.0045 16.992C14.9019 16.992 14.0037 17.8894 14.0037 18.9935ZM10.1986 6.94433L9.6488 8.87055L24.1163 13.6846L24.7406 11.7845L10.1986 6.94433Z",
      fill: n.color
    }, null, 8, MJ)
  ]);
}
const IJ = /* @__PURE__ */ B(EJ, [["render", AJ]]), LJ = {
  props: {
    color: {
      type: String,
      default: "#000"
    }
  }
}, DJ = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, $J = ["fill"];
function OJ(e, t, n, r, o, i) {
  return d(), f("svg", DJ, [
    c("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M26 10.9V14C26 19.176 22.046 23.446 17 23.95V30H23C23.553 30 24 30.448 24 31C24 31.552 23.553 32 23 32H9C8.447 32 8 31.552 8 31C8 30.448 8.447 30 9 30H15V23.95C9.954 23.446 6 19.176 6 14V10.9C2.507 10.272 0 6.454 0 3C0 2.448 0.447 2 1 2H6V1C6 0.448 6.447 0 7 0H25C25.553 0 26 0.448 26 1V2H31C31.553 2 32 2.448 32 3C32 6.454 29.493 10.272 26 10.9ZM6 4H2.094C2.481 6.114 4.029 8.274 6 8.845V4ZM24 2H8V14C8 18.411 11.589 22 16 22C20.411 22 24 18.411 24 14V2ZM26 4V8.845C27.971 8.274 29.519 6.114 29.906 4H26ZM18 17H14C13.447 17 13 16.552 13 16C13 15.448 13.447 15 14 15H15V9.414L13.707 10.707C13.316 11.097 12.684 11.097 12.293 10.707C11.902 10.316 11.902 9.683 12.293 9.293L15.293 6.293C15.579 6.006 16.009 5.922 16.383 6.076C16.757 6.231 17 6.596 17 7V15H18C18.553 15 19 15.448 19 16C19 16.552 18.553 17 18 17Z",
      fill: n.color
    }, null, 8, $J)
  ]);
}
const PJ = /* @__PURE__ */ B(LJ, [["render", OJ]]), NJ = {
  name: "S1",
  components: {
    CmsBadge: UX,
    CmsBasketball: ZX,
    CmsBlackboard: QX,
    CmsBus: rQ,
    CmsChemistry: lQ,
    CmsDesign: mQ,
    CmsDiploma: bQ,
    CmsDocuments: TQ,
    CmsGeography: AQ,
    CmsGlasses: OQ,
    CmsGrade: RQ,
    CmsGraduationCap: qQ,
    CmsMath: xQ,
    CmsMedal: JQ,
    CmsMonitor: oJ,
    CmsSchoolBag: uJ,
    CmsSchoolBuilding: fJ,
    CmsStaff: yJ,
    CmsStudent: kJ,
    CmsTelescope: IJ,
    CmsTrophy: PJ
  },
  mixins: [Ei]
}, HJ = {
  key: 0,
  "data-testid": "component-header-top"
}, FJ = ["data-testid"], RJ = { class: "stats-info" }, VJ = { class: "stats-card-border" }, BJ = {
  class: "stats-card stats-accent-border",
  "data-testid": "stats-accent-border"
}, jJ = { class: "svg-wrapper" }, UJ = ["innerHTML"];
function qJ(e, t, n, r, o, i) {
  const a = V("SeeAllContainer");
  return d(), f("div", {
    id: "stats-s1",
    class: _(e.theme.style),
    style: Z(e.colors),
    "data-testid": "S1"
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        e.displayHeaderTop ? (d(), f("h3", HJ, [
          M(e.$slots, "header-top", {}, () => [
            H(k(e.stats.component_header_top), 1)
          ], !0)
        ])) : T("", !0),
        c("h2", {
          class: "no-border",
          "data-testid": `header-${e.theme.style}-top`
        }, [
          M(e.$slots, "header", {}, () => [
            H(k(e.stats.component_header), 1)
          ], !0)
        ], 8, FJ)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    (d(), L(Y(e.wrapperComponent), Se(e.wrapperProps, {
      modelValue: e.stats.content,
      "onUpdate:modelValue": t[0] || (t[0] = (s) => e.stats.content = s),
      "item-key": "index",
      class: "stats-wrapper"
    }), {
      item: S(({ element: s, index: l }) => [
        c("div", RJ, [
          M(e.$slots, "controls", { idx: l }, void 0, !0),
          c("div", VJ, [
            c("div", BJ, [
              c("div", jJ, [
                M(e.$slots, "icon", { idx: l }, () => [
                  s.icon ? (d(), f("span", {
                    key: 0,
                    class: "raw-svg",
                    "data-testid": "stats-icon",
                    innerHTML: s.icon
                  }, null, 8, UJ)) : s.name ? (d(), L(Y(`cms-${s.name.replace(/\s/g, "-")}`), {
                    key: 1,
                    "data-testid": "stats-icon",
                    color: `${e.theme.icon_color.hex}`
                  }, null, 8, ["color"])) : T("", !0)
                ], !0)
              ])
            ])
          ]),
          e.stats.headline ? (d(), f("h3", {
            key: 0,
            class: _(["stats-headline", e.theme.style]),
            "data-testid": "stats-headline"
          }, [
            M(e.$slots, "headline", { idx: l }, () => [
              H(k(s.headline), 1)
            ], !0)
          ], 2)) : T("", !0),
          e.stats.snippet ? (d(), f("p", {
            key: 1,
            class: _(["stats-snippet", e.theme.style]),
            "data-testid": "stats-snippet"
          }, [
            M(e.$slots, "snippet", { idx: l }, () => [
              H(k(s.snippet), 1)
            ], !0)
          ], 2)) : T("", !0)
        ])
      ]),
      _: 3
    }, 16, ["modelValue"]))
  ], 6);
}
const GJ = /* @__PURE__ */ B(NJ, [["render", qJ], ["__scopeId", "data-v-201e6dff"]]), KJ = {
  methods: {
    isShortList(e) {
      var n;
      return (e || ((n = this.items) == null ? void 0 : n.length)) <= this.sliderCapacity;
    },
    goRight(e) {
      this.isShortList(e) || (this.currentCard + this.sliderCapacity === this.cardsLength ? this.currentCard = 0 : this.currentCard += 1, this.move());
    },
    goLeft(e) {
      this.isShortList(e) || (this.currentCard === 0 ? this.currentCard = this.cardsLength - this.sliderCapacity : this.currentCard -= 1, this.move());
    },
    move() {
      const t = (this.$refs[`slider-card-${this.currentCard}`] ? this : this.getSlot()).$refs[`slider-card-${this.currentCard}`], { slider: n } = this.$refs, { left: r } = this.getRelativePos(t);
      n.$el.style.transform = `translateX(-${r}px)`;
    },
    getSlot() {
      const e = Object.keys(this.$slots)[this.currentCard], [t] = this.$slots[e]();
      return t.context;
    },
    getRelativePos(e) {
      const t = e.parentNode.getBoundingClientRect(), n = e.getBoundingClientRect(), r = {};
      return r.top = n.top - t.top + e.parentNode.scrollTop, r.right = n.right - t.right, r.bottom = n.bottom - t.bottom, r.left = n.left - t.left + e.parentNode.scrollLeft, r;
    }
  }
}, zJ = {
  name: "S2",
  mixins: [Ei, Wt, KJ],
  data() {
    return {
      currentCard: 0,
      cardsLength: 0
    };
  },
  computed: {
    component_header() {
      return this.stats.stats_header;
    },
    stats_header() {
      return this.stats.component_header;
    },
    sliderCapacity() {
      return this.screenSize < 600 ? 1 : this.screenSize >= 1600 && !this.hasHeader ? 4 : this.screenSize >= 960 && this.hasHeader && this.hasSlider ? 3 : 4;
    },
    lowSliderCount() {
      var t;
      const e = ((t = this.stats.content) == null ? void 0 : t.length) || 0;
      return this.hasSlider && e < this.sliderCapacity;
    },
    hasHeader() {
      return this.stats.headline;
    },
    hasSlider() {
      return this.stats.slider && !this.isEditing;
    },
    hasTwoRows() {
      return this.screenSize >= 600 && this.screenSize < 960;
    },
    showArrows() {
      return this.screenSize >= 600 && this.hasSlider && this.stats.content.length > this.sliderCapacity;
    },
    backgroundImage() {
      return this.stats.bg_image && this.stats.bg_image.url ? {
        backgroundImage: `linear-gradient(${this.theme.bg_color.hex}e6, ${this.theme.bg_color.hex}e6), ${`url(${this.stats.bg_image.url})`}`
      } : !1;
    },
    hasDots() {
      return !!(this.hasSlider && this.stats.content.length > this.sliderCapacity);
    },
    dotCount() {
      const e = this.sliderCapacity, t = this.stats.content.length;
      return Math.ceil(t / e);
    },
    activeStatIdx() {
      return Math.ceil(this.currentCard / this.sliderCapacity + 1) === this.dotCount ? this.dotCount : Math.floor(this.currentCard / this.sliderCapacity + 1);
    }
  },
  mounted() {
    this.cardsLength = this.stats.content.length;
  },
  methods: {
    sliderCardOptions(e) {
      return {
        "stats-card-hidden": !this.isInRange(e, this.currentCard) && this.hasSlider,
        "stats-card-no-border": this.isTheLastOneInRange(e, this.currentCard),
        "stats-card-no-header": !this.hasHeader,
        "stats-card-no-slider": !this.hasSlider
      };
    },
    setScreenSize() {
      this.hasSlider && (this.screenSize = document.documentElement.clientWidth, this.lowSliderCount || this.move());
    },
    moveForward() {
      this.isEditing || (this.hasTwoRows ? (this.currentCard + this.sliderCapacity >= this.cardsLength ? this.currentCard = 0 : this.currentCard += 2, this.move()) : this.goRight(this.cardsLength));
    },
    moveBack() {
      this.isEditing || (this.hasTwoRows ? (this.currentCard <= 1 ? this.cardsLength % 2 !== 0 ? this.currentCard = this.cardsLength - this.sliderCapacity + 1 : this.currentCard = this.cardsLength - this.sliderCapacity : this.currentCard -= 2, this.move()) : this.goLeft(this.cardsLength));
    },
    isInRange(e, t) {
      return e >= t && e <= t + this.sliderCapacity - 1;
    },
    isTheLastOneInRange(e, t) {
      return e === t + this.sliderCapacity - 1 && this.hasSlider;
    },
    dotMove(e) {
      const t = this.sliderCapacity, n = this.stats.content.length, r = (e - 1) * t;
      if (e === this.dotCount && n < this.dotCount * t) {
        const o = n - t, i = n % 2 === 0;
        this.currentCard = this.hasTwoRows && !i ? o + 1 : o;
      } else
        this.currentCard = r;
      this.move();
    }
  }
}, ZJ = { key: 0 }, xJ = ["data-testid"], WJ = { class: "stat-content" }, YJ = { class: "slider-nav" }, XJ = ["onClick"], QJ = {
  class: "button-action-content",
  tabindex: "-1",
  role: "button"
}, JJ = {
  width: "64",
  height: "63",
  viewBox: "0 0 64 63",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, eee = ["fill"], tee = ["fill"], nee = {
  class: "button-action-content",
  tabindex: "-1",
  role: "button"
}, ree = {
  width: "64",
  height: "63",
  viewBox: "0 0 64 63",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, oee = ["fill"], iee = ["fill"];
function see(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = ze("touch");
  return d(), f("div", {
    id: "stats-s2",
    class: _([[{ "no-slider": !i.hasSlider }, e.theme.style], "stats-s2"]),
    style: Z([i.backgroundImage, e.colors])
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        e.displayHeaderTop ? (d(), f("h3", ZJ, [
          M(e.$slots, "header-top", {}, () => [
            H(k(e.stats.component_header_top), 1)
          ], !0)
        ])) : T("", !0),
        c("h2", {
          class: "no-border",
          "data-testid": `header-${e.theme.style}-top`
        }, [
          M(e.$slots, "header", {}, () => [
            H(k(i.component_header), 1)
          ], !0)
        ], 8, xJ)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    c("div", {
      class: _(["stats-info", { "stats-info-w-header": i.hasHeader }])
    }, [
      i.hasHeader && i.hasSlider ? (d(), f("div", {
        key: 0,
        class: _([e.theme.style, "stats-header"])
      }, [
        M(e.$slots, "stats-header", {}, () => [
          H(k(i.stats_header), 1)
        ], !0)
      ], 2)) : T("", !0),
      c("div", {
        class: _(["cards-slider", { "cards-slider-no-slider": !i.hasSlider, "cards-slider-w-header": i.hasHeader }])
      }, [
        we((d(), L(Y(e.wrapperComponent), Se(e.wrapperProps, {
          ref: "slider",
          modelValue: e.stats.content,
          "onUpdate:modelValue": t[0] || (t[0] = (l) => e.stats.content = l),
          "item-key": "index",
          class: [{ "cards-slider-container-wrap": !i.hasSlider, "cards-slider-container-center": i.lowSliderCount }, "cards-slider-container"]
        }), {
          header: S(() => [
            i.hasHeader && !i.hasSlider ? (d(), f("div", {
              key: 0,
              class: _([e.theme.style, "stats-card stats-card-no-slider stats-header-card"])
            }, [
              M(e.$slots, "stats-header", {}, () => [
                H(k(i.stats_header), 1)
              ], !0)
            ], 2)) : T("", !0)
          ]),
          item: S(({ element: l, index: u }) => [
            c("div", {
              ref: `slider-card-${u}`,
              class: _(["stats-card", i.sliderCardOptions(u)]),
              "data-testid": "stats-content"
            }, [
              M(e.$slots, "controls", { idx: u }, void 0, !0),
              c("div", WJ, [
                c("p", {
                  class: _(["stat-headline", [{ "no-slider": !i.hasSlider }, e.theme.style]])
                }, [
                  M(e.$slots, "headline", { idx: u }, () => [
                    H(k(l.headline), 1)
                  ], !0)
                ], 2),
                c("p", {
                  class: _(["stat-description", e.theme.style])
                }, [
                  M(e.$slots, "snippet", { idx: u }, () => [
                    H(k(l.snippet), 1)
                  ], !0)
                ], 2)
              ])
            ], 2)
          ]),
          _: 3
        }, 16, ["modelValue", "class"])), [
          [
            s,
            i.moveForward,
            "swipe",
            { left: !0 }
          ],
          [
            s,
            i.moveBack,
            "swipe",
            { right: !0 }
          ]
        ]),
        i.hasDots ? (d(), f("div", {
          key: 0,
          class: _([{ "slider-dots-w-header": i.hasHeader }, "slider-dots"])
        }, [
          c("ul", YJ, [
            (d(!0), f(J, null, ne(i.dotCount, (l) => (d(), f("li", {
              key: l,
              class: _({ activeStatIdx: l === i.activeStatIdx, unactiveStat: l !== i.activeStatIdx }),
              onClick: (u) => i.dotMove(l)
            }, t[5] || (t[5] = [
              c("span", { class: "circle" }, null, -1)
            ]), 10, XJ))), 128))
          ])
        ], 2)) : T("", !0)
      ], 2)
    ], 2),
    i.showArrows ? (d(), f("div", {
      key: 0,
      class: _(["navigation", { "navigation-w-header": i.hasHeader }])
    }, [
      c("div", {
        class: _(["arrows", { "arrows-w-header": i.hasHeader }])
      }, [
        c("button", {
          class: _(["left-arrow button-action", { "left-arrow-w-header": i.hasHeader }]),
          onClick: t[1] || (t[1] = (...l) => i.moveBack && i.moveBack(...l)),
          onKeydown: t[2] || (t[2] = K(W((...l) => i.moveBack && i.moveBack(...l), ["exact", "prevent"]), ["enter"]))
        }, [
          c("div", QJ, [
            (d(), f("svg", JJ, [
              c("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M-0.00012207 0H63.9999V62.9999H-0.00012207V0Z",
                "fill-opacity": "0.9",
                fill: e.theme.icon_bg_color.hex
              }, null, 8, eee),
              c("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M24.7803 31.209L37.1333 43.8414L35.7324 45.265L21.9999 31.2222L35.9117 17L37.2991 18.4104L24.7803 31.209Z",
                fill: e.theme.icon_color.hex
              }, null, 8, tee)
            ])),
            t[6] || (t[6] = c("span", { class: "sr-only" }, "Reverse Slider", -1))
          ])
        ], 34),
        c("button", {
          class: _(["right-arrow button-action", { "right-arrow-w-header": i.hasHeader }]),
          onClick: t[3] || (t[3] = (l) => i.moveForward()),
          onKeydown: t[4] || (t[4] = K((l) => i.moveForward(), ["enter"]))
        }, [
          c("div", nee, [
            (d(), f("svg", ree, [
              c("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M0 0H63.9999V62.9999H0V0Z",
                "fill-opacity": "0.9",
                fill: e.theme.icon_bg_color.hex
              }, null, 8, oee),
              c("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M38.5191 31.209L26.1659 43.8414L27.5668 45.265L41.2995 31.2222L27.3874 17L26 18.4104L38.5191 31.209Z",
                fill: e.theme.icon_color.hex
              }, null, 8, iee)
            ])),
            t[7] || (t[7] = c("span", { class: "sr-only" }, "Advance Slider", -1))
          ])
        ], 34)
      ], 2)
    ], 2)) : T("", !0)
  ], 6);
}
const aee = /* @__PURE__ */ B(zJ, [["render", see], ["__scopeId", "data-v-e1d0f8bd"]]), lee = {
  name: "S3",
  mixins: [Ei]
}, uee = ["data-testid"], dee = {
  key: 0,
  class: "header-top"
}, cee = {
  key: 0,
  class: "stats-card-img"
}, hee = ["src", "alt"], mee = {
  key: 1,
  class: "stats-content-body"
}, fee = ["innerHTML"], pee = { class: "stats-card-body" }, gee = { class: "stats-card-body-snippet-text" };
function vee(e, t, n, r, o, i) {
  const a = V("SeeAllContainer");
  return d(), f("div", {
    class: _(["stats-s3", e.theme.style]),
    "data-testid": "S3",
    style: Z(e.colors)
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        c("h2", {
          "data-testid": `header-${e.theme.style}-top`,
          class: "no-border"
        }, [
          e.displayHeaderTop ? (d(), f("span", dee, [
            M(e.$slots, "header-top", {}, () => [
              H(k(e.stats.component_header_top), 1)
            ], !0)
          ])) : T("", !0),
          M(e.$slots, "header", {}, () => [
            H(k(e.stats.component_header), 1)
          ], !0)
        ], 8, uee)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    (d(), L(Y(e.wrapperComponent), Se(e.wrapperProps, {
      modelValue: e.stats.content,
      "onUpdate:modelValue": t[0] || (t[0] = (s) => e.stats.content = s),
      "item-key": "index",
      class: "stats-container stats-wrapper"
    }), {
      item: S(({ element: s, index: l }) => [
        c("div", {
          class: "stats-card",
          style: Z({ backgroundColor: s.bg_color }),
          "data-testid": "stats-content"
        }, [
          M(e.$slots, "controls", { idx: l }, void 0, !0),
          s.bg_image ? (d(), f("div", cee, [
            M(e.$slots, "image", { idx: l }, () => [
              s.bg_image.url ? (d(), f("img", {
                key: 0,
                class: "stat-card-img",
                src: s.bg_image.url,
                alt: s.bg_image.alt_text
              }, null, 8, hee)) : T("", !0)
            ], !0)
          ])) : (d(), f("div", mee, [
            e.stats.icon ? (d(), f("div", {
              key: 0,
              class: "svg-wrapper",
              style: Z({ fill: s.color })
            }, [
              M(e.$slots, "icon", { idx: l }, () => [
                c("span", {
                  class: "raw-svg",
                  "data-testid": "stats-icon",
                  innerHTML: s.icon
                }, null, 8, fee)
              ], !0)
            ], 4)) : T("", !0),
            c("div", pee, [
              e.stats.headline ? (d(), f("div", {
                key: 0,
                class: "stats-card-body-headline",
                style: Z({ color: s.color })
              }, [
                M(e.$slots, "headline", { idx: l }, () => [
                  c("h3", null, k(s.headline), 1)
                ], !0)
              ], 4)) : T("", !0),
              e.stats.snippet ? (d(), f("div", {
                key: 1,
                class: "stats-card-body-snippet",
                style: Z({ color: s.color })
              }, [
                M(e.$slots, "snippet", { idx: l }, () => [
                  c("p", gee, k(s.snippet), 1)
                ], !0)
              ], 4)) : T("", !0)
            ])
          ]))
        ], 4)
      ]),
      _: 3
    }, 16, ["modelValue"]))
  ], 6);
}
const bee = /* @__PURE__ */ B(lee, [["render", vee], ["__scopeId", "data-v-bf23411e"]]), yee = {
  name: "S4",
  components: {
    Pager: d0
  },
  mixins: [Ei, _t],
  props: {
    startIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      currentStatCardIndex: 0,
      statsImageCards: [],
      scrollInterval: () => {
      },
      sliderOverlayIndex: 0,
      pauseScroll: !1
    };
  },
  computed: {
    statsV4Colors() {
      var e, t, n, r, o, i, a, s;
      return ge(ae({}, this.colors), {
        "--control-border-color": ((t = (e = this.theme) == null ? void 0 : e.button_border_color) == null ? void 0 : t.hex) || "#000",
        "--control-bg-color": ((r = (n = this.theme) == null ? void 0 : n.button_bg_color) == null ? void 0 : r.hex) || "#fff",
        "--pager-color": ((i = (o = this.theme) == null ? void 0 : o.pager_color) == null ? void 0 : i.hex) || "#fff",
        "--overlay-color": ((s = (a = this.theme) == null ? void 0 : a.overlay_color) == null ? void 0 : s.hex) || "#fff",
        "--overlay-opacity": `${this.theme.percentage_opacity || "80"}%`
      });
    },
    content() {
      return this.statsImageCards;
    },
    sliderCenterSize() {
      return this.mobileScreenSize ? 600 : 1e6;
    },
    mobileScreenSize() {
      return this.screenSize < 1023;
    },
    activeStat() {
      return this.mappedStats[this.currentStatCardIndex] || {
        top_stats: { headline: "", snippet: "" },
        bottom_stats: { headline: "", snippet: "" }
      };
    },
    mappedStats() {
      const e = this.startIndex ? this.stats.nested_content.slice(this.startIndex).concat(this.stats.nested_content.slice(0, this.startIndex)) : this.stats.nested_content;
      return (e == null ? void 0 : e.map((t, n) => ge(ae({}, t), {
        left_image: ge(ae({}, t.left_image), {
          internalIdx: n
        }),
        right_image: ge(ae({}, t.right_image), {
          internalIdx: n
        })
      }))) || [];
    }
  },
  created() {
    this.statsImageCards = this.getStatsImageCards(), this.currentStatCardIndex = this.startIndex;
  },
  async mounted() {
    this.currentCard = Math.floor(this.statsImageCards.length / 2), await this.$nextTick(), this.mobileScreenSize && (this.currentCard -= 1), this.startScroll(), this.calculateScroll(!0);
  },
  beforeUnmount() {
    this.clearScroll();
  },
  methods: {
    startScroll() {
      this.isEditing || !this.mappedStats.length || (this.scrollInterval = setInterval(this.handleScroll, 4e3));
    },
    clearScroll() {
      clearInterval(this.scrollInterval);
    },
    getStatsImageCards() {
      var n, r, o, i;
      if (!this.mappedStats.length)
        return [];
      const e = [
        ...this.mappedStats.slice(1, this.mappedStats.length).map((a) => (a == null ? void 0 : a.left_image) || {}),
        ge(ae({}, ((r = (n = this.mappedStats) == null ? void 0 : n[0]) == null ? void 0 : r.left_image) || {}), {
          position: "left_image"
        })
      ], t = [
        ge(ae({}, ((i = (o = this.mappedStats) == null ? void 0 : o[0]) == null ? void 0 : i.right_image) || {}), {
          position: "right_image"
        }),
        ...this.mappedStats.slice(1, this.mappedStats.length).map((a) => (a == null ? void 0 : a.right_image) || {})
      ];
      return [...e, {}, ...t];
    },
    togglePlayPause() {
      if (this.pauseScroll = !this.pauseScroll, this.pauseScroll) {
        this.clearScroll();
        return;
      }
      this.startScroll();
    },
    async handleScroll(e) {
      if (this.isEditing || this.pauseScroll || this.mappedStats.length <= 1)
        return;
      this.currentStatCardIndex = e || (this.currentStatCardIndex + 1) % this.mappedStats.length, this.sliderOverlayIndex = this.currentStatCardIndex, await new Promise((r) => setTimeout(r, 1e3));
      const t = this.mappedStats[this.currentStatCardIndex].left_image;
      this.statsImageCards[this.currentCard] = ae({}, t);
      const n = this.mappedStats.at(this.currentStatCardIndex - 1).right_image;
      this.statsImageCards.push(ae({}, n)), this.statsImageCards.splice(0, 1), this.currentCard -= 1, this.mobileScreenSize && (this.currentCard -= 1), this.$refs.scrollWrapper.style["scroll-behavior"] = "auto", this.calculateScroll(), this.$refs.scrollWrapper.style["scroll-behavior"] = "smooth", await this.$nextTick(), this.scrollRight(), this.mobileScreenSize && (this.currentCard += 1);
    }
  }
}, _ee = ["data-testid"], Cee = ["data-testid"], wee = {
  ref: "scrollWrapper",
  class: "card-wrapper"
}, Tee = { class: "stat-image-wrapper" }, kee = ["src", "alt"], Eee = { class: "stats-pager" }, See = { class: "stat-text-wrapper" }, Mee = { class: "stats-action-button-container" }, Aee = {
  width: "56",
  height: "56",
  viewBox: "0 0 56 56",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Iee = {
  key: 0,
  d: "M38 27.9984L23 36.3123L23 19.6846L38 27.9984Z",
  fill: "#333333"
};
function Lee(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("Pager");
  return d(), f("div", {
    class: _(["stats-v4", { "is-editing": e.isEditing }, e.theme.style]),
    "data-testid": "S4",
    style: Z(i.statsV4Colors)
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        c("h2", {
          "data-testid": `header-${e.theme.style}`
        }, [
          e.displayHeaderTop ? (d(), f("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            M(e.$slots, "header-top", {}, () => [
              H(k(e.stats.component_header_top), 1)
            ], !0)
          ], 8, Cee)) : T("", !0),
          M(e.$slots, "header", {}, () => [
            H(k(e.stats.component_header), 1)
          ], !0)
        ], 8, _ee)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    c("div", wee, [
      (d(!0), f(J, null, ne(o.statsImageCards, (l, u) => (d(), f("div", {
        key: u,
        ref_for: !0,
        ref: `sliderCard-${u}`,
        class: _(["stat-card", e.isEditing && "is-editing"])
      }, [
        c("div", Tee, [
          M(e.$slots, l.position ? "image" : "image-alt", {
            idx: u,
            position: l.position
          }, () => [
            c("img", {
              src: l.url ? l.url : "",
              alt: l.alt_text ? l.alt_text : "",
              class: "stat-image",
              loading: "lazy"
            }, null, 8, kee)
          ], !0),
          c("div", {
            class: _(["stat-image-overlay", { "overlay-visible": o.sliderOverlayIndex === l.internalIdx }])
          }, null, 2)
        ])
      ], 2))), 128)),
      c("div", {
        class: _(["stats-main-card stat-card", { "is-editing": e.isEditing }])
      }, [
        c("div", Eee, [
          j(s, {
            "total-cards": i.mappedStats.length,
            "theme-styles": e.theme,
            "pager-color": e.theme.pager_color ? e.theme.pager_color.hex : "#fff",
            "current-card": o.currentStatCardIndex,
            "pager-section-count": i.mappedStats.length
          }, null, 8, ["total-cards", "theme-styles", "pager-color", "current-card", "pager-section-count"])
        ]),
        c("div", See, [
          (d(), L(Y(e.isEditing ? "div" : "transition-group"), {
            duration: 1e3,
            tag: "div",
            name: "stats-fade",
            class: _(["stats-text-transition stat-top-text", { "no-snippet": !e.stats.snippet, "no-headline": !e.stats.headline }])
          }, {
            default: S(() => [
              e.stats.headline ? (d(), f("div", {
                key: `${o.currentStatCardIndex}-top`,
                class: "stats-top-text"
              }, [
                M(e.$slots, "headline", {}, () => [
                  H(k(i.activeStat.top_stats.headline), 1)
                ], !0)
              ])) : T("", !0),
              e.stats.snippet ? (d(), f("div", {
                key: `${o.currentStatCardIndex}-bottom`,
                class: "stats-bottom-text"
              }, [
                M(e.$slots, "snippet", {}, () => [
                  H(k(i.activeStat.top_stats.snippet), 1)
                ], !0)
              ])) : T("", !0)
            ]),
            _: 3
          }, 8, ["class"])),
          t[1] || (t[1] = c("div", { class: "stats-divider" }, null, -1)),
          (d(), L(Y(e.isEditing ? "div" : "transition-group"), {
            duration: 1e3,
            tag: "div",
            name: "stats-fade",
            class: _(["stats-text-transition stat-bottom-text", { "no-snippet": !e.stats.snippet, "no-headline": !e.stats.headline }])
          }, {
            default: S(() => [
              e.stats.headline ? (d(), f("div", {
                key: `${o.currentStatCardIndex}-top`,
                class: "stats-top-text"
              }, [
                M(e.$slots, "bottom-headline", {}, () => [
                  H(k(i.activeStat.bottom_stats.headline), 1)
                ], !0)
              ])) : T("", !0),
              e.stats.snippet ? (d(), f("div", {
                key: `${o.currentStatCardIndex}-bottom`,
                class: "stats-bottom-text"
              }, [
                M(e.$slots, "bottom-snippet", {}, () => [
                  H(k(i.activeStat.bottom_stats.snippet), 1)
                ], !0)
              ])) : T("", !0)
            ]),
            _: 3
          }, 8, ["class"]))
        ])
      ], 2)
    ], 512),
    c("div", Mee, [
      c("button", {
        class: "stats-action-button",
        onClick: t[0] || (t[0] = (...l) => i.togglePlayPause && i.togglePlayPause(...l))
      }, [
        (d(), f("svg", Aee, [
          c("g", null, [
            t[4] || (t[4] = c("rect", {
              x: "-0.5",
              y: "0.5",
              width: "55",
              height: "55",
              transform: "matrix(-1 0 0 1 55 0)",
              stroke: "#333333"
            }, null, -1)),
            o.pauseScroll ? (d(), f("path", Iee)) : (d(), f(J, { key: 1 }, [
              t[2] || (t[2] = c("path", {
                d: "M24 21.5V33.5",
                stroke: "black",
                "stroke-width": "3",
                "stroke-linecap": "round"
              }, null, -1)),
              t[3] || (t[3] = c("path", {
                d: "M32 21.5V33.5",
                stroke: "black",
                "stroke-width": "3",
                "stroke-linecap": "round"
              }, null, -1))
            ], 64))
          ])
        ]))
      ])
    ])
  ], 6);
}
const Dee = /* @__PURE__ */ B(yee, [["render", Lee], ["__scopeId", "data-v-eea51a61"]]);
/*!
 * strings: 3.13.0
 * https://gsap.com
 *
 * Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/
var $ee = /(?:^\s+|\s+$)/g, Oee = /([\uD800-\uDBFF][\uDC00-\uDFFF](?:[\u200D\uFE0F][\uD800-\uDBFF][\uDC00-\uDFFF]){2,}|\uD83D\uDC69(?:\u200D(?:(?:\uD83D\uDC69\u200D)?\uD83D\uDC67|(?:\uD83D\uDC69\u200D)?\uD83D\uDC66)|\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC69\u200D(?:\uD83D\uDC69\u200D)?\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC69\u200D(?:\uD83D\uDC69\u200D)?\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2642\u2640]\uFE0F|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDD27\uDCBC\uDD2C\uDE80\uDE92])|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC6F\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3C-\uDD3E\uDDD6-\uDDDF])\u200D[\u2640\u2642]\uFE0F|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF6\uD83C\uDDE6|\uD83C\uDDF4\uD83C\uDDF2|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|(?:\u26F9|\uD83C[\uDFCC\uDFCB]|\uD83D\uDD75)(?:\uFE0F\u200D[\u2640\u2642]|(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642])\uFE0F|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2695\u2696\u2708]|\uD83D\uDC69\u200D[\u2695\u2696\u2708]|\uD83D\uDC68(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708]))\uFE0F|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83D\uDC69\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69]))|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|[#\*0-9]\uFE0F\u20E3|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74|\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67)\uDB40\uDC7F|\uD83D\uDC68(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:(?:\uD83D[\uDC68\uDC69])\u200D)?\uD83D\uDC66\u200D\uD83D\uDC66|(?:(?:\uD83D[\uDC68\uDC69])\u200D)?\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92])|(?:\uD83C[\uDFFB-\uDFFF])\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]))|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270A-\u270D]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC70\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDCAA\uDD74\uDD7A\uDD90\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD36\uDDD1-\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC68(?:\u200D(?:(?:(?:\uD83D[\uDC68\uDC69])\u200D)?\uD83D\uDC67|(?:(?:\uD83D[\uDC68\uDC69])\u200D)?\uD83D\uDC66)|\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC69\uDC6E\uDC70-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD18-\uDD1C\uDD1E\uDD1F\uDD26\uDD30-\uDD39\uDD3D\uDD3E\uDDD1-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])?|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDEEB\uDEEC\uDEF4-\uDEF8]|\uD83E[\uDD10-\uDD3A\uDD3C-\uDD3E\uDD40-\uDD45\uDD47-\uDD4C\uDD50-\uDD6B\uDD80-\uDD97\uDDC0\uDDD0-\uDDE6])|(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u2660\u2663\u2665\u2666\u2668\u267B\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEF8]|\uD83E[\uDD10-\uDD3A\uDD3C-\uDD3E\uDD40-\uDD45\uDD47-\uDD4C\uDD50-\uDD6B\uDD80-\uDD97\uDDC0\uDDD0-\uDDE6])\uFE0F)/;
function uh(e) {
  var t = e.nodeType, n = "";
  if (t === 1 || t === 9 || t === 11) {
    if (typeof e.textContent == "string")
      return e.textContent;
    for (e = e.firstChild; e; e = e.nextSibling)
      n += uh(e);
  } else if (t === 3 || t === 4)
    return e.nodeValue;
  return n;
}
function kn(e, t, n, r, o) {
  if (e += "", n && (e = e.trim ? e.trim() : e.replace($ee, "")), t && t !== "")
    return e.replace(/>/g, "&gt;").replace(/</g, "&lt;").split(t);
  for (var i = [], a = e.length, s = 0, l, u; s < a; s++)
    u = e.charAt(s), (u.charCodeAt(0) >= 55296 && u.charCodeAt(0) <= 56319 || e.charCodeAt(s + 1) >= 65024 && e.charCodeAt(s + 1) <= 65039) && (l = ((e.substr(s, 12).split(Oee) || [])[1] || "").length || 2, u = e.substr(s, l), i.emoji = 1, s += l - 1), i.push(o ? u : u === ">" ? "&gt;" : u === "<" ? "&lt;" : r && u === " " && (e.charAt(s - 1) === " " || e.charAt(s + 1) === " ") ? "&nbsp;" : u);
  return i;
}
/*!
 * ScrambleTextPlugin 3.13.0
 * https://gsap.com
 *
 * @license Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/
var rs = /* @__PURE__ */ function() {
  function e(n) {
    this.chars = kn(n), this.sets = [], this.length = 50;
    for (var r = 0; r < 20; r++)
      this.sets[r] = Wp(80, this.chars);
  }
  var t = e.prototype;
  return t.grow = function(r) {
    for (var o = 0; o < 20; o++)
      this.sets[o] += Wp(r - this.length, this.chars);
    this.length = r;
  }, e;
}(), Lr, y8, _8 = function() {
  return Lr || typeof window != "undefined" && (Lr = window.gsap) && Lr.registerPlugin && Lr;
}, Pee = 1, xp = /\s+/g, Wp = function(t, n) {
  for (var r = n.length, o = ""; --t > -1; )
    o += n[~~(Math.random() * r)];
  return o;
}, o0 = "ABCDEFGHIJKLMNOPQRSTUVWXYZ", Yp = o0.toLowerCase(), Nee = {
  upperCase: new rs(o0),
  lowerCase: new rs(Yp),
  upperAndLowerCase: new rs(o0 + Yp)
}, Xp = function() {
  y8 = Lr = _8();
}, Qs = {
  version: "3.13.0",
  name: "scrambleText",
  register: function(t, n, r) {
    Lr = t, Xp();
  },
  init: function(t, n, r, o, i) {
    if (y8 || Xp(), this.prop = "innerHTML" in t ? "innerHTML" : "textContent" in t ? "textContent" : 0, !!this.prop) {
      this.target = t, typeof n != "object" && (n = {
        text: n
      });
      var a = n.text || n.value || "", s = n.trim !== !1, l = this, u, m, v, g;
      return l.delimiter = u = n.delimiter || "", l.original = kn(uh(t).replace(xp, " ").split("&nbsp;").join(""), u, s), (a === "{original}" || a === !0 || a == null) && (a = l.original.join(u)), l.text = kn((a || "").replace(xp, " "), u, s), l.hasClass = !!(n.newClass || n.oldClass), l.newClass = n.newClass, l.oldClass = n.oldClass, g = u === "", l.textHasEmoji = g && !!l.text.emoji, l.charsHaveEmoji = !!n.chars && !!kn(n.chars).emoji, l.length = g ? l.original.length : l.original.join(u).length, l.lengthDif = (g ? l.text.length : l.text.join(u).length) - l.length, l.fillChar = n.fillChar || n.chars && ~n.chars.indexOf(" ") ? "&nbsp;" : "", l.charSet = v = Nee[n.chars || "upperCase"] || new rs(n.chars), l.speed = 0.05 / (n.speed || 1), l.prevScrambleTime = 0, l.setIndex = Math.random() * 20 | 0, m = l.length + Math.max(l.lengthDif, 0), m > v.length && v.grow(m), l.chars = v.sets[l.setIndex], l.revealDelay = n.revealDelay || 0, l.tweenLength = n.tweenLength !== !1, l.tween = r, l.rightToLeft = !!n.rightToLeft, l._props.push("scrambleText", "text"), Pee;
    }
  },
  render: function(t, n) {
    var r = n.target, o = n.prop, i = n.text, a = n.delimiter, s = n.tween, l = n.prevScrambleTime, u = n.revealDelay, m = n.setIndex, v = n.chars, g = n.charSet, h = n.length, E = n.textHasEmoji, C = n.charsHaveEmoji, A = n.lengthDif, R = n.tweenLength, P = n.oldClass, F = n.newClass, I = n.rightToLeft, D = n.fillChar, O = n.speed, U = n.original, q = n.hasClass, z = i.length, te = s._time, ee = te - l, x, N, G, X, Q, re, se, de, me, he, _e;
    u && (s._from && (te = s._dur - te), t = te === 0 ? 0 : te < u ? 1e-6 : te === s._dur ? 1 : s._ease((te - u) / (s._dur - u))), t < 0 ? t = 0 : t > 1 && (t = 1), I && (t = 1 - t), x = ~~(t * z + 0.5), t ? ((ee > O || ee < -O) && (n.setIndex = m = (m + (Math.random() * 19 | 0)) % 20, n.chars = g.sets[m], n.prevScrambleTime += ee), X = v) : X = U.join(a), _e = s._from ? t : 1 - t, he = h + (R ? s._from ? _e * _e * _e : 1 - _e * _e * _e : 1) * A, I ? t === 1 && (s._from || s.data === "isFromStart") ? (G = "", X = U.join(a)) : (se = i.slice(x).join(a), C ? G = kn(X).slice(0, he - (E ? kn(se) : se).length + 0.5 | 0).join("") : G = X.substr(0, he - (E ? kn(se) : se).length + 0.5 | 0), X = se) : (G = i.slice(0, x).join(a), N = (E ? kn(G) : G).length, C ? X = kn(X).slice(N, he + 0.5 | 0).join("") : X = X.substr(N, he - N + 0.5 | 0)), q ? (de = I ? P : F, me = I ? F : P, Q = de && x !== 0, re = me && x !== z, se = (Q ? "<span class='" + de + "'>" : "") + G + (Q ? "</span>" : "") + (re ? "<span class='" + me + "'>" : "") + a + X + (re ? "</span>" : "")) : se = G + a + X, r[o] = D === "&nbsp;" && ~se.indexOf("  ") ? se.split("  ").join("&nbsp;&nbsp;") : se;
  }
};
Qs.emojiSafeSplit = kn;
Qs.getText = uh;
_8() && Lr.registerPlugin(Qs);
const Hee = {
  name: "S5",
  components: {
    CardSlider: mn
  },
  mixins: [Ei, _t],
  data() {
    return {
      usersReducedMotionPreference: !1
    };
  },
  computed: {
    s5Styles() {
      var e;
      return {
        "--content-alignment": ((e = this.stats.alignment) == null ? void 0 : e.value) || "Left"
      };
    },
    content() {
      return this.stats.content;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.setCardHeight(), this.usersReducedMotionPreference = window.matchMedia("(prefers-reduced-motion: reduce)").matches, !this.usersReducedMotionPreference && !this.isEditing && this.updateCounter();
    }), window.addEventListener("resize", this.setCardHeight), nr.registerPlugin(Qs);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.setCardHeight);
  },
  methods: {
    setCardHeight() {
      if (this.isEditing)
        return;
      this.content.forEach((t, n) => {
        this.$refs[`statsCard-${n}`].style.minHeight = "unset";
      });
      const e = Math.max(...this.content.map((t, n) => this.$refs[`statsCard-${n}`].clientHeight));
      this.content.forEach((t, n) => {
        this.$refs[`statsCard-${n}`].style.minHeight = e ? `${e - 64}px` : "unset";
      });
    },
    updateCounter() {
      const e = document.querySelectorAll(".stats-counter"), t = new Intl.NumberFormat("en-US", {
        style: "decimal",
        notation: "compact",
        compactDisplay: "short",
        maximumFractionDigits: 1
      });
      e.forEach((n, r) => {
        nr.timeline(n, {
          defaults: { ease: "none" },
          scrambleText: {
            text: String(this.stats.content[r].counter_start),
            chars: "0123456789"
          },
          duration: 2
        }).to(n, {
          scrambleText: {
            text: t.format(this.stats.content[r].counter_end),
            chars: "0123456789"
          },
          duration: 2
        });
      });
    }
  }
}, Fee = ["data-testid"], Ree = ["data-testid"], Vee = ["aria-label"], Bee = {
  key: 0,
  class: "svg-wrapper"
}, jee = ["innerHTML"], Uee = ["src"], qee = { class: "snippet-link-container" };
function Gee(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("CardSlider");
  return d(), f("div", {
    id: "stats-s5",
    class: _(e.theme.style),
    style: Z([e.backgroundStyle, e.colors, i.s5Styles]),
    "data-testid": "S5"
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        e.stats.headline ? (d(), f("h2", {
          key: 0,
          "data-testid": `header-${e.theme.style}`,
          class: _([e.theme.style, "stat-header"])
        }, [
          M(e.$slots, "header", {}, () => [
            H(k(e.stats.component_header), 1)
          ], !0)
        ], 10, Fee)) : T("", !0)
      ]),
      default: S(() => [
        e.stats.show_description ? (d(), f("h3", {
          key: 0,
          "data-testid": `header-${e.theme.style}-description`,
          class: _([e.theme.style, "stat-description"])
        }, [
          M(e.$slots, "description", {}, () => [
            H(k(e.stats.component_description), 1)
          ], !0)
        ], 10, Ree)) : T("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    j(s, {
      "nav-orientation": "wide",
      "has-pager": !1,
      "has-accent": "",
      "current-card": e.currentCard,
      "pager-section-count": e.pagerSectionCount,
      "all-cards-visible": e.allCardsVisible,
      "screen-size": e.screenSize,
      "total-cards": i.content.length,
      "theme-styles": e.theme,
      "section-header": e.stats.component_header,
      class: "card-slider",
      onScrollRight: e.scrollRight,
      onScrollLeft: e.scrollLeft,
      onGoToSection: e.goToSection
    }, {
      default: S(() => [
        (d(), L(Y(e.wrapperComponent), Se({ ref: "scrollWrapper" }, e.wrapperProps, {
          modelValue: e.stats.content,
          "onUpdate:modelValue": t[0] || (t[0] = (l) => e.stats.content = l),
          "item-key": "index",
          class: ["stats-wrapper", { "all-cards-visible": e.allCardsVisible, "is-editing": e.isEditing }]
        }), {
          item: S(({ element: l, index: u }) => [
            c("div", {
              ref: `sliderCard-${u}`,
              class: _(["stats-info", { "is-editing": e.isEditing }]),
              "aria-label": `${u + 1} of ${i.content.length}`,
              role: "group",
              "aria-roledescription": "slide"
            }, [
              c("div", {
                ref: `statsCard-${u}`,
                "data-testid": "stats-card",
                class: _(["stats-card", e.isEditing])
              }, [
                M(e.$slots, "controls", { idx: u }, void 0, !0),
                e.theme.icons_or_images && e.stats.show_icons_or_images ? (d(), f("div", Bee, [
                  M(e.$slots, "icon", { idx: u }, () => {
                    var m;
                    return [
                      l.icon && e.theme.icons_or_images === "icons" ? (d(), f("span", {
                        key: 0,
                        class: "raw-svg",
                        "data-testid": "stats-icon",
                        innerHTML: l.icon
                      }, null, 8, jee)) : (d(), f("img", {
                        key: 1,
                        class: "stats-image",
                        "data-testid": "stats-image",
                        src: ((m = l.image) == null ? void 0 : m.url) || "",
                        alt: ""
                      }, null, 8, Uee))
                    ];
                  }, !0)
                ])) : T("", !0),
                c("h3", {
                  class: _(["stats-counter", [e.theme.style, `stats-counter-${u}`]]),
                  "data-testid": "stats-counter"
                }, [
                  M(e.$slots, "headline", { idx: u }, () => [
                    H(k(o.usersReducedMotionPreference ? l.counter_end : l.counter_start), 1)
                  ], !0)
                ], 2),
                c("div", qee, [
                  e.stats.snippet ? (d(), f("p", {
                    key: 0,
                    class: _(["stats-snippet", e.theme.style]),
                    "data-testid": "stats-snippet"
                  }, [
                    M(e.$slots, "snippet", { idx: u }, () => [
                      H(k(l.snippet), 1)
                    ], !0)
                  ], 2)) : T("", !0),
                  M(e.$slots, "link", { idx: u }, () => {
                    var m, v;
                    return [
                      e.stats.show_links ? (d(), L(Y(e.isPreview || e.isEditing ? "div" : "a"), {
                        key: 0,
                        href: ((m = l.link) == null ? void 0 : m.href) || "#",
                        class: _(["stat-link", e.theme.style]),
                        target: ((v = l.link) == null ? void 0 : v.target) || "_blank",
                        "data-testid": "stat-link"
                      }, {
                        default: S(() => {
                          var g;
                          return [
                            H(k(((g = l.link) == null ? void 0 : g.name) || ""), 1)
                          ];
                        }),
                        _: 2
                      }, 1032, ["href", "class", "target"])) : T("", !0)
                    ];
                  }, !0)
                ])
              ], 2)
            ], 10, Vee)
          ]),
          _: 3
        }, 16, ["modelValue", "class"]))
      ]),
      _: 3
    }, 8, ["current-card", "pager-section-count", "all-cards-visible", "screen-size", "total-cards", "theme-styles", "section-header", "onScrollRight", "onScrollLeft", "onGoToSection"])
  ], 6);
}
const Kee = /* @__PURE__ */ B(Hee, [["render", Gee], ["__scopeId", "data-v-0a8d4d6d"]]), zee = {
  name: "Stats",
  components: {
    S1: GJ,
    S2: aee,
    S3: bee,
    S4: Dee,
    S5: Kee
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      default: () => ({})
    },
    startIndex: {
      type: Number,
      default: 0
    },
    isEditing: Boolean,
    isPreview: Boolean,
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  }
};
function Zee(e, t, n, r, o, i) {
  return d(), L(Y(n.theme.version), {
    theme: n.theme,
    stats: n.content,
    "wrapper-component": n.wrapperComponent,
    "wrapper-props": n.wrapperProps,
    "is-editing": n.isEditing,
    "is-preview": n.isPreview,
    "start-index": n.startIndex
  }, {
    "header-top": S(() => [
      M(e.$slots, "header-top")
    ]),
    header: S(() => [
      M(e.$slots, "header")
    ]),
    description: S(() => [
      M(e.$slots, "description")
    ]),
    "stats-header": S(() => [
      M(e.$slots, "stats-header")
    ]),
    controls: S(({ idx: a }) => [
      M(e.$slots, "controls", { idx: a })
    ]),
    icon: S(({ idx: a }) => [
      M(e.$slots, "icon", { idx: a })
    ]),
    image: S(({ idx: a, position: s }) => [
      M(e.$slots, "image", {
        idx: a,
        position: s
      })
    ]),
    headline: S(({ idx: a }) => [
      M(e.$slots, "headline", { idx: a })
    ]),
    snippet: S(({ idx: a }) => [
      M(e.$slots, "snippet", { idx: a })
    ]),
    link: S(({ idx: a }) => [
      M(e.$slots, "link", { idx: a })
    ]),
    "bottom-headline": S(({ idx: a }) => [
      M(e.$slots, "bottom-headline", { idx: a })
    ]),
    "bottom-snippet": S(({ idx: a }) => [
      M(e.$slots, "bottom-snippet", { idx: a })
    ]),
    _: 3
  }, 8, ["theme", "stats", "wrapper-component", "wrapper-props", "is-editing", "is-preview", "start-index"]);
}
const xee = /* @__PURE__ */ B(zee, [["render", Zee]]), dh = {
  mixins: [Wt, St],
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      default: () => ({})
    },
    isEditing: Boolean,
    isPlaceholder: Boolean,
    videoSlotsItems: {
      type: Array,
      default: () => []
    },
    currentVideoThrillshare: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      activeItem: 0,
      isPlaying: !1,
      readMoreOpen: !1
    };
  },
  methods: {
    playPause(e, t, n) {
      const r = document.getElementById(e);
      if (!r) return;
      const o = n || (this.isPlaying ? "pause" : "play");
      if (t === "youtube")
        r.contentWindow.postMessage(`{"event":"command","func":"${o}Video","args":""}`, "*");
      else if (t === "vimeo") {
        const i = r.querySelector("iframe");
        i && i.contentWindow.postMessage(`{"method":"${o}"}`, "*");
      }
    },
    setIsPlaying({ isPlaying: e }) {
      this.isPlaying = e;
    },
    parseVideo(e) {
      let t = null;
      return e.match(
        /(http:\/\/|https:\/\/|)(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(&\S+)?/
      ), RegExp.$3.indexOf("youtu") > -1 ? t = "youtube" : RegExp.$3.indexOf("vimeo") > -1 && (t = "vimeo"), {
        type: t,
        id: RegExp.$6
      };
    },
    getThumbnail(e) {
      return `https://vumbnail.com/${e}_large.jpg`;
    }
  },
  watch: {
    currentVideoThrillshare(e, t) {
      t !== e && (this.activeItem = e);
    },
    content() {
      this.activeItem = this.currentVideoThrillshare;
    }
  },
  computed: {
    videoItems() {
      return this.content.videos.map((e) => {
        const { type: t, id: n } = this.parseVideo(e.url), r = this.getThumbnail(n, t);
        return ge(ae({}, e), {
          type: t,
          thumbnail: r,
          videoId: n
        });
      });
    },
    currentItem() {
      return this.videoItems.length === 0 ? {} : this.videoItems[this.activeItem];
    },
    isDesktop() {
      return this.screenSize >= 960;
    },
    colors() {
      const e = this.sharedThemeColors();
      return ge(ae({}, e), {
        "--heading-color": $(this.theme, "heading_color.hex", "#333"),
        "--header-accent-color": $(this.theme, "header_accent_color.hex", "#333"),
        "--video-title-color": $(this.theme, "video_title_color.hex", "#333"),
        "--video-text-color": $(this.theme, "video_text_color.hex", "#333"),
        "--arrow-background-color": $(this.theme, "arrow_background_color.hex", "#333"),
        "--arrow-text-color": $(this.theme, "arrow_text_color.hex", "#fff"),
        "--pager-color": $(this.theme, "pager_color.hex", "#333")
      });
    },
    translations() {
      return this.theme.translations || {};
    },
    displayTopHeader() {
      return this.theme.style === "monterrey" && (this.content.component_header_top || this.isEditing);
    }
  }
};
var xi = { exports: {} }, Qp;
function Wee() {
  if (Qp) return xi.exports;
  Qp = 1;
  var e = typeof Reflect == "object" ? Reflect : null, t = e && typeof e.apply == "function" ? e.apply : function(D, O, U) {
    return Function.prototype.apply.call(D, O, U);
  }, n;
  e && typeof e.ownKeys == "function" ? n = e.ownKeys : Object.getOwnPropertySymbols ? n = function(D) {
    return Object.getOwnPropertyNames(D).concat(Object.getOwnPropertySymbols(D));
  } : n = function(D) {
    return Object.getOwnPropertyNames(D);
  };
  function r(I) {
    console && console.warn && console.warn(I);
  }
  var o = Number.isNaN || function(D) {
    return D !== D;
  };
  function i() {
    i.init.call(this);
  }
  xi.exports = i, xi.exports.once = R, i.EventEmitter = i, i.prototype._events = void 0, i.prototype._eventsCount = 0, i.prototype._maxListeners = void 0;
  var a = 10;
  function s(I) {
    if (typeof I != "function")
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof I);
  }
  Object.defineProperty(i, "defaultMaxListeners", {
    enumerable: !0,
    get: function() {
      return a;
    },
    set: function(I) {
      if (typeof I != "number" || I < 0 || o(I))
        throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + I + ".");
      a = I;
    }
  }), i.init = function() {
    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, i.prototype.setMaxListeners = function(D) {
    if (typeof D != "number" || D < 0 || o(D))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + D + ".");
    return this._maxListeners = D, this;
  };
  function l(I) {
    return I._maxListeners === void 0 ? i.defaultMaxListeners : I._maxListeners;
  }
  i.prototype.getMaxListeners = function() {
    return l(this);
  }, i.prototype.emit = function(D) {
    for (var O = [], U = 1; U < arguments.length; U++) O.push(arguments[U]);
    var q = D === "error", z = this._events;
    if (z !== void 0)
      q = q && z.error === void 0;
    else if (!q)
      return !1;
    if (q) {
      var te;
      if (O.length > 0 && (te = O[0]), te instanceof Error)
        throw te;
      var ee = new Error("Unhandled error." + (te ? " (" + te.message + ")" : ""));
      throw ee.context = te, ee;
    }
    var x = z[D];
    if (x === void 0)
      return !1;
    if (typeof x == "function")
      t(x, this, O);
    else
      for (var N = x.length, G = E(x, N), U = 0; U < N; ++U)
        t(G[U], this, O);
    return !0;
  };
  function u(I, D, O, U) {
    var q, z, te;
    if (s(O), z = I._events, z === void 0 ? (z = I._events = /* @__PURE__ */ Object.create(null), I._eventsCount = 0) : (z.newListener !== void 0 && (I.emit(
      "newListener",
      D,
      O.listener ? O.listener : O
    ), z = I._events), te = z[D]), te === void 0)
      te = z[D] = O, ++I._eventsCount;
    else if (typeof te == "function" ? te = z[D] = U ? [O, te] : [te, O] : U ? te.unshift(O) : te.push(O), q = l(I), q > 0 && te.length > q && !te.warned) {
      te.warned = !0;
      var ee = new Error("Possible EventEmitter memory leak detected. " + te.length + " " + String(D) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      ee.name = "MaxListenersExceededWarning", ee.emitter = I, ee.type = D, ee.count = te.length, r(ee);
    }
    return I;
  }
  i.prototype.addListener = function(D, O) {
    return u(this, D, O, !1);
  }, i.prototype.on = i.prototype.addListener, i.prototype.prependListener = function(D, O) {
    return u(this, D, O, !0);
  };
  function m() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function v(I, D, O) {
    var U = { fired: !1, wrapFn: void 0, target: I, type: D, listener: O }, q = m.bind(U);
    return q.listener = O, U.wrapFn = q, q;
  }
  i.prototype.once = function(D, O) {
    return s(O), this.on(D, v(this, D, O)), this;
  }, i.prototype.prependOnceListener = function(D, O) {
    return s(O), this.prependListener(D, v(this, D, O)), this;
  }, i.prototype.removeListener = function(D, O) {
    var U, q, z, te, ee;
    if (s(O), q = this._events, q === void 0)
      return this;
    if (U = q[D], U === void 0)
      return this;
    if (U === O || U.listener === O)
      --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete q[D], q.removeListener && this.emit("removeListener", D, U.listener || O));
    else if (typeof U != "function") {
      for (z = -1, te = U.length - 1; te >= 0; te--)
        if (U[te] === O || U[te].listener === O) {
          ee = U[te].listener, z = te;
          break;
        }
      if (z < 0)
        return this;
      z === 0 ? U.shift() : C(U, z), U.length === 1 && (q[D] = U[0]), q.removeListener !== void 0 && this.emit("removeListener", D, ee || O);
    }
    return this;
  }, i.prototype.off = i.prototype.removeListener, i.prototype.removeAllListeners = function(D) {
    var O, U, q;
    if (U = this._events, U === void 0)
      return this;
    if (U.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : U[D] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete U[D]), this;
    if (arguments.length === 0) {
      var z = Object.keys(U), te;
      for (q = 0; q < z.length; ++q)
        te = z[q], te !== "removeListener" && this.removeAllListeners(te);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if (O = U[D], typeof O == "function")
      this.removeListener(D, O);
    else if (O !== void 0)
      for (q = O.length - 1; q >= 0; q--)
        this.removeListener(D, O[q]);
    return this;
  };
  function g(I, D, O) {
    var U = I._events;
    if (U === void 0)
      return [];
    var q = U[D];
    return q === void 0 ? [] : typeof q == "function" ? O ? [q.listener || q] : [q] : O ? A(q) : E(q, q.length);
  }
  i.prototype.listeners = function(D) {
    return g(this, D, !0);
  }, i.prototype.rawListeners = function(D) {
    return g(this, D, !1);
  }, i.listenerCount = function(I, D) {
    return typeof I.listenerCount == "function" ? I.listenerCount(D) : h.call(I, D);
  }, i.prototype.listenerCount = h;
  function h(I) {
    var D = this._events;
    if (D !== void 0) {
      var O = D[I];
      if (typeof O == "function")
        return 1;
      if (O !== void 0)
        return O.length;
    }
    return 0;
  }
  i.prototype.eventNames = function() {
    return this._eventsCount > 0 ? n(this._events) : [];
  };
  function E(I, D) {
    for (var O = new Array(D), U = 0; U < D; ++U)
      O[U] = I[U];
    return O;
  }
  function C(I, D) {
    for (; D + 1 < I.length; D++)
      I[D] = I[D + 1];
    I.pop();
  }
  function A(I) {
    for (var D = new Array(I.length), O = 0; O < D.length; ++O)
      D[O] = I[O].listener || I[O];
    return D;
  }
  function R(I, D) {
    return new Promise(function(O, U) {
      function q(te) {
        I.removeListener(D, z), U(te);
      }
      function z() {
        typeof I.removeListener == "function" && I.removeListener("error", q), O([].slice.call(arguments));
      }
      F(I, D, z, { once: !0 }), D !== "error" && P(I, q, { once: !0 });
    });
  }
  function P(I, D, O) {
    typeof I.on == "function" && F(I, "error", D, O);
  }
  function F(I, D, O, U) {
    if (typeof I.on == "function")
      U.once ? I.once(D, O) : I.on(D, O);
    else if (typeof I.addEventListener == "function")
      I.addEventListener(D, function q(z) {
        U.once && I.removeEventListener(D, q), O(z);
      });
    else
      throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof I);
  }
  return xi.exports;
}
/*! load-script2. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
var Cc, Jp;
function Yee() {
  return Jp || (Jp = 1, Cc = function(t, n, r) {
    return new Promise((o, i) => {
      const a = document.createElement("script");
      a.async = !0, a.src = t;
      for (const [l, u] of Object.entries(n || {}))
        a.setAttribute(l, u);
      a.onload = () => {
        a.onerror = a.onload = null, o(a);
      }, a.onerror = () => {
        a.onerror = a.onload = null, i(new Error(`Failed to load ${t}`));
      }, (r || document.head || document.getElementsByTagName("head")[0]).appendChild(a);
    });
  }), Cc;
}
/*! yt-player. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
var wc, eg;
function Xee() {
  if (eg) return wc;
  eg = 1;
  const e = Wee().EventEmitter, t = Yee(), n = "https://www.youtube.com/iframe_api", r = {
    "-1": "unstarted",
    0: "ended",
    1: "playing",
    2: "paused",
    3: "buffering",
    5: "cued"
  }, o = {
    // The request contains an invalid parameter value. For example, this error
    // occurs if you specify a videoId that does not have 11 characters, or if the
    // videoId contains invalid characters, such as exclamation points or asterisks.
    INVALID_PARAM: 2,
    // The requested content cannot be played in an HTML5 player or another error
    // related to the HTML5 player has occurred.
    HTML5_ERROR: 5,
    // The video requested was not found. This error occurs when a video has been
    // removed (for any reason) or has been marked as private.
    NOT_FOUND: 100,
    // The owner of the requested video does not allow it to be played in embedded
    // players.
    UNPLAYABLE_1: 101,
    // This error is the same as 101. It's just a 101 error in disguise!
    UNPLAYABLE_2: 150
  }, i = [];
  class a extends e {
    constructor(l, u) {
      super();
      const m = typeof l == "string" ? document.querySelector(l) : l;
      m.id ? this._id = m.id : this._id = m.id = "ytplayer-" + Math.random().toString(16).slice(2, 8), this._opts = Object.assign({
        width: 640,
        height: 360,
        autoplay: !1,
        captions: void 0,
        controls: !0,
        keyboard: !0,
        fullscreen: !0,
        annotations: !0,
        modestBranding: !1,
        related: !0,
        timeupdateFrequency: 1e3,
        playsInline: !0,
        start: 0
      }, u), this.videoId = null, this.destroyed = !1, this._api = null, this._autoplay = !1, this._player = null, this._ready = !1, this._queue = [], this._interval = null, this._startInterval = this._startInterval.bind(this), this._stopInterval = this._stopInterval.bind(this), this.on("playing", this._startInterval), this.on("unstarted", this._stopInterval), this.on("ended", this._stopInterval), this.on("paused", this._stopInterval), this.on("buffering", this._stopInterval), this._loadIframeAPI((v, g) => {
        if (v) return this._destroy(new Error("YouTube Iframe API failed to load"));
        this._api = g, this.videoId && this.load(this.videoId, this._autoplay, this._start);
      });
    }
    load(l, u = !1, m = 0) {
      if (!this.destroyed && (this.videoId = l, this._autoplay = u, this._start = m, !!this._api)) {
        if (!this._player) {
          this._createPlayer(l);
          return;
        }
        this._ready && (u ? this._player.loadVideoById(l, m) : this._player.cueVideoById(l, m));
      }
    }
    play() {
      this._ready ? this._player.playVideo() : this._queueCommand("play");
    }
    pause() {
      this._ready ? this._player.pauseVideo() : this._queueCommand("pause");
    }
    stop() {
      this._ready ? this._player.stopVideo() : this._queueCommand("stop");
    }
    seek(l) {
      this._ready ? this._player.seekTo(l, !0) : this._queueCommand("seek", l);
    }
    setVolume(l) {
      this._ready ? this._player.setVolume(l) : this._queueCommand("setVolume", l);
    }
    getVolume() {
      return this._ready && this._player.getVolume() || 0;
    }
    mute() {
      this._ready ? this._player.mute() : this._queueCommand("mute");
    }
    unMute() {
      this._ready ? this._player.unMute() : this._queueCommand("unMute");
    }
    isMuted() {
      return this._ready && this._player.isMuted() || !1;
    }
    setSize(l, u) {
      this._ready ? this._player.setSize(l, u) : this._queueCommand("setSize", l, u);
    }
    setPlaybackRate(l) {
      this._ready ? this._player.setPlaybackRate(l) : this._queueCommand("setPlaybackRate", l);
    }
    setPlaybackQuality(l) {
      this._ready ? this._player.setPlaybackQuality(l) : this._queueCommand("setPlaybackQuality", l);
    }
    getPlaybackRate() {
      return this._ready && this._player.getPlaybackRate() || 1;
    }
    getAvailablePlaybackRates() {
      return this._ready && this._player.getAvailablePlaybackRates() || [1];
    }
    getDuration() {
      return this._ready && this._player.getDuration() || 0;
    }
    getProgress() {
      return this._ready && this._player.getVideoLoadedFraction() || 0;
    }
    getState() {
      return this._ready && r[this._player.getPlayerState()] || "unstarted";
    }
    getCurrentTime() {
      return this._ready && this._player.getCurrentTime() || 0;
    }
    destroy() {
      this._destroy();
    }
    _destroy(l) {
      this.destroyed || (this.destroyed = !0, this._player && (this._player.stopVideo && this._player.stopVideo(), this._player.destroy()), this.videoId = null, this._id = null, this._opts = null, this._api = null, this._player = null, this._ready = !1, this._queue = null, this._stopInterval(), this.removeListener("playing", this._startInterval), this.removeListener("paused", this._stopInterval), this.removeListener("buffering", this._stopInterval), this.removeListener("unstarted", this._stopInterval), this.removeListener("ended", this._stopInterval), l && this.emit("error", l));
    }
    _queueCommand(l, ...u) {
      this.destroyed || this._queue.push([l, u]);
    }
    _flushQueue() {
      for (; this._queue.length; ) {
        const l = this._queue.shift();
        this[l[0]].apply(this, l[1]);
      }
    }
    _loadIframeAPI(l) {
      if (window.YT && typeof window.YT.Player == "function")
        return l(null, window.YT);
      i.push(l), Array.from(document.getElementsByTagName("script")).some((g) => g.src === n) || t(n).catch((g) => {
        for (; i.length; )
          i.shift()(g);
      });
      const v = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = () => {
        for (typeof v == "function" && v(); i.length; )
          i.shift()(null, window.YT);
      };
    }
    _createPlayer(l) {
      if (this.destroyed) return;
      const u = this._opts;
      this._player = new this._api.Player(this._id, {
        width: u.width,
        height: u.height,
        videoId: l,
        // (Not part of documented API) This parameter controls the hostname that
        // videos are loaded from. Set to `'https://www.youtube-nocookie.com'`
        // for enhanced privacy.
        host: u.host,
        playerVars: {
          // This parameter specifies whether the initial video will automatically
          // start to play when the player loads. Supported values are 0 or 1. The
          // default value is 0.
          autoplay: u.autoplay ? 1 : 0,
          // Setting the parameter's value to 1 causes closed captions to be shown
          // by default, even if the user has turned captions off. The default
          // behavior is based on user preference.
          cc_load_policy: u.captions != null ? u.captions !== !1 ? 1 : 0 : void 0,
          // default to not setting this option
          // Sets the player's interface language. The parameter value is an ISO
          // 639-1 two-letter language code or a fully specified locale. For
          // example, fr and fr-ca are both valid values. Other language input
          // codes, such as IETF language tags (BCP 47) might also be handled
          // properly.
          hl: u.captions != null && u.captions !== !1 ? u.captions : void 0,
          // default to not setting this option
          // This parameter specifies the default language that the player will
          // use to display captions. Set the parameter's value to an ISO 639-1
          // two-letter language code.
          cc_lang_pref: u.captions != null && u.captions !== !1 ? u.captions : void 0,
          // default to not setting this option
          // This parameter indicates whether the video player controls are
          // displayed. For IFrame embeds that load a Flash player, it also defines
          // when the controls display in the player as well as when the player
          // will load. Supported values are:
          //   - controls=0 – Player controls do not display in the player. For
          //                  IFrame embeds, the Flash player loads immediately.
          //   - controls=1 – (default) Player controls display in the player. For
          //                  IFrame embeds, the controls display immediately and
          //                  the Flash player also loads immediately.
          //   - controls=2 – Player controls display in the player. For IFrame
          //                  embeds, the controls display and the Flash player
          //                  loads after the user initiates the video playback.
          controls: u.controls ? 2 : 0,
          // Setting the parameter's value to 1 causes the player to not respond to
          // keyboard controls. The default value is 0, which means that keyboard
          // controls are enabled.
          disablekb: u.keyboard ? 0 : 1,
          // Setting the parameter's value to 1 enables the player to be
          // controlled via IFrame or JavaScript Player API calls. The default
          // value is 0, which means that the player cannot be controlled using
          // those APIs.
          enablejsapi: 1,
          // Setting this parameter to 0 prevents the fullscreen button from
          // displaying in the player. The default value is 1, which causes the
          // fullscreen button to display.
          fs: u.fullscreen ? 1 : 0,
          // Setting the parameter's value to 1 causes video annotations to be
          // shown by default, whereas setting to 3 causes video annotations to not
          // be shown by default. The default value is 1.
          iv_load_policy: u.annotations ? 1 : 3,
          // This parameter lets you use a YouTube player that does not show a
          // YouTube logo. Set the parameter value to 1 to prevent the YouTube logo
          // from displaying in the control bar. Note that a small YouTube text
          // label will still display in the upper-right corner of a paused video
          // when the user's mouse pointer hovers over the player.
          modestbranding: u.modestBranding ? 1 : 0,
          // This parameter provides an extra security measure for the IFrame API
          // and is only supported for IFrame embeds. If you are using the IFrame
          // API, which means you are setting the enablejsapi parameter value to 1,
          // you should always specify your domain as the origin parameter value.
          origin: window.location.origin,
          // This parameter controls whether videos play inline or fullscreen in an
          // HTML5 player on iOS. Valid values are:
          //   - 0: This value causes fullscreen playback. This is currently the
          //        default value, though the default is subject to change.
          //   - 1: This value causes inline playback for UIWebViews created with
          //        the allowsInlineMediaPlayback property set to TRUE.
          playsinline: u.playsInline ? 1 : 0,
          // This parameter indicates whether the player should show related
          // videos from the same channel (0) or from any channel (1) when
          // playback of the video ends. The default value is 1.
          rel: u.related ? 1 : 0,
          // (Not part of documented API) Allow html elements with higher z-index
          // to be shown on top of the YouTube player.
          wmode: "opaque",
          // This parameter causes the player to begin playing the video at the given number
          // of seconds from the start of the video. The parameter value is a positive integer.
          // Note that similar to the seek function, the player will look for the closest
          // keyframe to the time you specify. This means that sometimes the play head may seek
          // to just before the requested time, usually no more than around two seconds.
          start: u.start
        },
        events: {
          onReady: () => this._onReady(l),
          onStateChange: (m) => this._onStateChange(m),
          onPlaybackQualityChange: (m) => this._onPlaybackQualityChange(m),
          onPlaybackRateChange: (m) => this._onPlaybackRateChange(m),
          onError: (m) => this._onError(m)
        }
      });
    }
    /**
     * This event fires when the player has finished loading and is ready to begin
     * receiving API calls.
     */
    _onReady(l) {
      this.destroyed || (this._ready = !0, this.load(this.videoId, this._autoplay, this._start), this._flushQueue());
    }
    /**
     * Called when the player's state changes. We emit friendly events so the user
     * doesn't need to use YouTube's YT.PlayerState.* event constants.
     */
    _onStateChange(l) {
      if (this.destroyed) return;
      const u = r[l.data];
      if (u)
        ["paused", "buffering", "ended"].includes(u) && this._onTimeupdate(), this.emit(u), ["unstarted", "playing", "cued"].includes(u) && this._onTimeupdate();
      else
        throw new Error("Unrecognized state change: " + l);
    }
    /**
     * This event fires whenever the video playback quality changes. Possible
     * values are: 'small', 'medium', 'large', 'hd720', 'hd1080', 'highres'.
     */
    _onPlaybackQualityChange(l) {
      this.destroyed || this.emit("playbackQualityChange", l.data);
    }
    /**
     * This event fires whenever the video playback rate changes.
     */
    _onPlaybackRateChange(l) {
      this.destroyed || this.emit("playbackRateChange", l.data);
    }
    /**
     * This event fires if an error occurs in the player.
     */
    _onError(l) {
      if (this.destroyed) return;
      const u = Number(l.data);
      if (u !== o.HTML5_ERROR) {
        if (u === o.UNPLAYABLE_1 || u === o.UNPLAYABLE_2 || u === o.NOT_FOUND || u === o.INVALID_PARAM)
          return this.emit("unplayable", this.videoId);
        this._destroy(new Error("YouTube Player Error. Unknown error code: " + u));
      }
    }
    /**
     * This event fires when the time indicated by the `getCurrentTime()` method
     * has been updated.
     */
    _onTimeupdate() {
      this.emit("timeupdate", this.getCurrentTime());
    }
    _startInterval() {
      this._interval = setInterval(() => this._onTimeupdate(), this._opts.timeupdateFrequency);
    }
    _stopInterval() {
      clearInterval(this._interval), this._interval = null;
    }
  }
  return wc = a, wc;
}
var Qee = Xee();
const Jee = /* @__PURE__ */ Eo(Qee);
/*! @vimeo/player v2.25.1 | (c) 2025 Vimeo | MIT License | https://github.com/vimeo/player.js */
function tg(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ng(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? tg(Object(n), !0).forEach(function(r) {
      os(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : tg(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Tt() {
  Tt = function() {
    return e;
  };
  var e = {}, t = Object.prototype, n = t.hasOwnProperty, r = Object.defineProperty || function(x, N, G) {
    x[N] = G.value;
  }, o = typeof Symbol == "function" ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", s = o.toStringTag || "@@toStringTag";
  function l(x, N, G) {
    return Object.defineProperty(x, N, {
      value: G,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), x[N];
  }
  try {
    l({}, "");
  } catch (x) {
    l = function(N, G, X) {
      return N[G] = X;
    };
  }
  function u(x, N, G, X) {
    var Q = N && N.prototype instanceof g ? N : g, re = Object.create(Q.prototype), se = new z(X || []);
    return r(re, "_invoke", {
      value: D(x, G, se)
    }), re;
  }
  function m(x, N, G) {
    try {
      return {
        type: "normal",
        arg: x.call(N, G)
      };
    } catch (X) {
      return {
        type: "throw",
        arg: X
      };
    }
  }
  e.wrap = u;
  var v = {};
  function g() {
  }
  function h() {
  }
  function E() {
  }
  var C = {};
  l(C, i, function() {
    return this;
  });
  var A = Object.getPrototypeOf, R = A && A(A(te([])));
  R && R !== t && n.call(R, i) && (C = R);
  var P = E.prototype = g.prototype = Object.create(C);
  function F(x) {
    ["next", "throw", "return"].forEach(function(N) {
      l(x, N, function(G) {
        return this._invoke(N, G);
      });
    });
  }
  function I(x, N) {
    function G(Q, re, se, de) {
      var me = m(x[Q], x, re);
      if (me.type !== "throw") {
        var he = me.arg, _e = he.value;
        return _e && typeof _e == "object" && n.call(_e, "__await") ? N.resolve(_e.__await).then(function(De) {
          G("next", De, se, de);
        }, function(De) {
          G("throw", De, se, de);
        }) : N.resolve(_e).then(function(De) {
          he.value = De, se(he);
        }, function(De) {
          return G("throw", De, se, de);
        });
      }
      de(me.arg);
    }
    var X;
    r(this, "_invoke", {
      value: function(Q, re) {
        function se() {
          return new N(function(de, me) {
            G(Q, re, de, me);
          });
        }
        return X = X ? X.then(se, se) : se();
      }
    });
  }
  function D(x, N, G) {
    var X = "suspendedStart";
    return function(Q, re) {
      if (X === "executing") throw new Error("Generator is already running");
      if (X === "completed") {
        if (Q === "throw") throw re;
        return ee();
      }
      for (G.method = Q, G.arg = re; ; ) {
        var se = G.delegate;
        if (se) {
          var de = O(se, G);
          if (de) {
            if (de === v) continue;
            return de;
          }
        }
        if (G.method === "next") G.sent = G._sent = G.arg;
        else if (G.method === "throw") {
          if (X === "suspendedStart") throw X = "completed", G.arg;
          G.dispatchException(G.arg);
        } else G.method === "return" && G.abrupt("return", G.arg);
        X = "executing";
        var me = m(x, N, G);
        if (me.type === "normal") {
          if (X = G.done ? "completed" : "suspendedYield", me.arg === v) continue;
          return {
            value: me.arg,
            done: G.done
          };
        }
        me.type === "throw" && (X = "completed", G.method = "throw", G.arg = me.arg);
      }
    };
  }
  function O(x, N) {
    var G = N.method, X = x.iterator[G];
    if (X === void 0) return N.delegate = null, G === "throw" && x.iterator.return && (N.method = "return", N.arg = void 0, O(x, N), N.method === "throw") || G !== "return" && (N.method = "throw", N.arg = new TypeError("The iterator does not provide a '" + G + "' method")), v;
    var Q = m(X, x.iterator, N.arg);
    if (Q.type === "throw") return N.method = "throw", N.arg = Q.arg, N.delegate = null, v;
    var re = Q.arg;
    return re ? re.done ? (N[x.resultName] = re.value, N.next = x.nextLoc, N.method !== "return" && (N.method = "next", N.arg = void 0), N.delegate = null, v) : re : (N.method = "throw", N.arg = new TypeError("iterator result is not an object"), N.delegate = null, v);
  }
  function U(x) {
    var N = {
      tryLoc: x[0]
    };
    1 in x && (N.catchLoc = x[1]), 2 in x && (N.finallyLoc = x[2], N.afterLoc = x[3]), this.tryEntries.push(N);
  }
  function q(x) {
    var N = x.completion || {};
    N.type = "normal", delete N.arg, x.completion = N;
  }
  function z(x) {
    this.tryEntries = [{
      tryLoc: "root"
    }], x.forEach(U, this), this.reset(!0);
  }
  function te(x) {
    if (x) {
      var N = x[i];
      if (N) return N.call(x);
      if (typeof x.next == "function") return x;
      if (!isNaN(x.length)) {
        var G = -1, X = function Q() {
          for (; ++G < x.length; ) if (n.call(x, G)) return Q.value = x[G], Q.done = !1, Q;
          return Q.value = void 0, Q.done = !0, Q;
        };
        return X.next = X;
      }
    }
    return {
      next: ee
    };
  }
  function ee() {
    return {
      value: void 0,
      done: !0
    };
  }
  return h.prototype = E, r(P, "constructor", {
    value: E,
    configurable: !0
  }), r(E, "constructor", {
    value: h,
    configurable: !0
  }), h.displayName = l(E, s, "GeneratorFunction"), e.isGeneratorFunction = function(x) {
    var N = typeof x == "function" && x.constructor;
    return !!N && (N === h || (N.displayName || N.name) === "GeneratorFunction");
  }, e.mark = function(x) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(x, E) : (x.__proto__ = E, l(x, s, "GeneratorFunction")), x.prototype = Object.create(P), x;
  }, e.awrap = function(x) {
    return {
      __await: x
    };
  }, F(I.prototype), l(I.prototype, a, function() {
    return this;
  }), e.AsyncIterator = I, e.async = function(x, N, G, X, Q) {
    Q === void 0 && (Q = Promise);
    var re = new I(u(x, N, G, X), Q);
    return e.isGeneratorFunction(N) ? re : re.next().then(function(se) {
      return se.done ? se.value : re.next();
    });
  }, F(P), l(P, s, "Generator"), l(P, i, function() {
    return this;
  }), l(P, "toString", function() {
    return "[object Generator]";
  }), e.keys = function(x) {
    var N = Object(x), G = [];
    for (var X in N) G.push(X);
    return G.reverse(), function Q() {
      for (; G.length; ) {
        var re = G.pop();
        if (re in N) return Q.value = re, Q.done = !1, Q;
      }
      return Q.done = !0, Q;
    };
  }, e.values = te, z.prototype = {
    constructor: z,
    reset: function(x) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(q), !x) for (var N in this) N.charAt(0) === "t" && n.call(this, N) && !isNaN(+N.slice(1)) && (this[N] = void 0);
    },
    stop: function() {
      this.done = !0;
      var x = this.tryEntries[0].completion;
      if (x.type === "throw") throw x.arg;
      return this.rval;
    },
    dispatchException: function(x) {
      if (this.done) throw x;
      var N = this;
      function G(me, he) {
        return re.type = "throw", re.arg = x, N.next = me, he && (N.method = "next", N.arg = void 0), !!he;
      }
      for (var X = this.tryEntries.length - 1; X >= 0; --X) {
        var Q = this.tryEntries[X], re = Q.completion;
        if (Q.tryLoc === "root") return G("end");
        if (Q.tryLoc <= this.prev) {
          var se = n.call(Q, "catchLoc"), de = n.call(Q, "finallyLoc");
          if (se && de) {
            if (this.prev < Q.catchLoc) return G(Q.catchLoc, !0);
            if (this.prev < Q.finallyLoc) return G(Q.finallyLoc);
          } else if (se) {
            if (this.prev < Q.catchLoc) return G(Q.catchLoc, !0);
          } else {
            if (!de) throw new Error("try statement without catch or finally");
            if (this.prev < Q.finallyLoc) return G(Q.finallyLoc);
          }
        }
      }
    },
    abrupt: function(x, N) {
      for (var G = this.tryEntries.length - 1; G >= 0; --G) {
        var X = this.tryEntries[G];
        if (X.tryLoc <= this.prev && n.call(X, "finallyLoc") && this.prev < X.finallyLoc) {
          var Q = X;
          break;
        }
      }
      Q && (x === "break" || x === "continue") && Q.tryLoc <= N && N <= Q.finallyLoc && (Q = null);
      var re = Q ? Q.completion : {};
      return re.type = x, re.arg = N, Q ? (this.method = "next", this.next = Q.finallyLoc, v) : this.complete(re);
    },
    complete: function(x, N) {
      if (x.type === "throw") throw x.arg;
      return x.type === "break" || x.type === "continue" ? this.next = x.arg : x.type === "return" ? (this.rval = this.arg = x.arg, this.method = "return", this.next = "end") : x.type === "normal" && N && (this.next = N), v;
    },
    finish: function(x) {
      for (var N = this.tryEntries.length - 1; N >= 0; --N) {
        var G = this.tryEntries[N];
        if (G.finallyLoc === x) return this.complete(G.completion, G.afterLoc), q(G), v;
      }
    },
    catch: function(x) {
      for (var N = this.tryEntries.length - 1; N >= 0; --N) {
        var G = this.tryEntries[N];
        if (G.tryLoc === x) {
          var X = G.completion;
          if (X.type === "throw") {
            var Q = X.arg;
            q(G);
          }
          return Q;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function(x, N, G) {
      return this.delegate = {
        iterator: te(x),
        resultName: N,
        nextLoc: G
      }, this.method === "next" && (this.arg = void 0), v;
    }
  }, e;
}
function rg(e, t, n, r, o, i, a) {
  try {
    var s = e[i](a), l = s.value;
  } catch (u) {
    n(u);
    return;
  }
  s.done ? t(l) : Promise.resolve(l).then(r, o);
}
function Sr(e) {
  return function() {
    var t = this, n = arguments;
    return new Promise(function(r, o) {
      var i = e.apply(t, n);
      function a(l) {
        rg(i, r, o, a, s, "next", l);
      }
      function s(l) {
        rg(i, r, o, a, s, "throw", l);
      }
      a(void 0);
    });
  };
}
function C8(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function ete(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, k8(r.key), r);
  }
}
function w8(e, t, n) {
  return t && ete(e.prototype, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function os(e, t, n) {
  return t = k8(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function tte(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && fi(e, t);
}
function mi(e) {
  return mi = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, mi(e);
}
function fi(e, t) {
  return fi = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, o) {
    return r.__proto__ = o, r;
  }, fi(e, t);
}
function T8() {
  if (typeof Reflect == "undefined" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch (e) {
    return !1;
  }
}
function is(e, t, n) {
  return T8() ? is = Reflect.construct.bind() : is = function(o, i, a) {
    var s = [null];
    s.push.apply(s, i);
    var l = Function.bind.apply(o, s), u = new l();
    return a && fi(u, a.prototype), u;
  }, is.apply(null, arguments);
}
function nte(e) {
  return Function.toString.call(e).indexOf("[native code]") !== -1;
}
function i0(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return i0 = function(r) {
    if (r === null || !nte(r)) return r;
    if (typeof r != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof t != "undefined") {
      if (t.has(r)) return t.get(r);
      t.set(r, o);
    }
    function o() {
      return is(r, arguments, mi(this).constructor);
    }
    return o.prototype = Object.create(r.prototype, {
      constructor: {
        value: o,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), fi(o, r);
  }, i0(e);
}
function ss(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function rte(e, t) {
  if (t && (typeof t == "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return ss(e);
}
function ote(e) {
  var t = T8();
  return function() {
    var r = mi(e), o;
    if (t) {
      var i = mi(this).constructor;
      o = Reflect.construct(r, arguments, i);
    } else
      o = r.apply(this, arguments);
    return rte(this, o);
  };
}
function ite(e, t) {
  if (typeof e != "object" || e === null) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function k8(e) {
  var t = ite(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
var E8 = typeof global != "undefined" && {}.toString.call(global) === "[object global]";
function og(e, t) {
  return e.indexOf(t.toLowerCase()) === 0 ? e : "".concat(t.toLowerCase()).concat(e.substr(0, 1).toUpperCase()).concat(e.substr(1));
}
function ste(e) {
  return !!(e && e.nodeType === 1 && "nodeName" in e && e.ownerDocument && e.ownerDocument.defaultView);
}
function ate(e) {
  return !isNaN(parseFloat(e)) && isFinite(e) && Math.floor(e) == e;
}
function Vr(e) {
  return /^(https?:)?\/\/((((player|www)\.)?vimeo\.com)|((player\.)?[a-zA-Z0-9-]+\.(videoji\.(hk|cn)|vimeo\.work)))(?=$|\/)/.test(e);
}
function S8(e) {
  var t = /^https:\/\/player\.((vimeo\.com)|([a-zA-Z0-9-]+\.(videoji\.(hk|cn)|vimeo\.work)))\/video\/\d+/;
  return t.test(e);
}
function lte(e) {
  for (var t = (e || "").match(/^(?:https?:)?(?:\/\/)?([^/?]+)/), n = (t && t[1] || "").replace("player.", ""), r = [".videoji.hk", ".vimeo.work", ".videoji.cn"], o = 0, i = r; o < i.length; o++) {
    var a = i[o];
    if (n.endsWith(a))
      return n;
  }
  return "vimeo.com";
}
function M8() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.id, n = e.url, r = t || n;
  if (!r)
    throw new Error("An id or url must be passed, either in an options object or as a data-vimeo-id or data-vimeo-url attribute.");
  if (ate(r))
    return "https://vimeo.com/".concat(r);
  if (Vr(r))
    return r.replace("http:", "https:");
  throw t ? new TypeError("“".concat(t, "” is not a valid video id.")) : new TypeError("“".concat(r, "” is not a vimeo.com url."));
}
var ig = function(t, n, r) {
  var o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "addEventListener", i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "removeEventListener", a = typeof n == "string" ? [n] : n;
  return a.forEach(function(s) {
    t[o](s, r);
  }), {
    cancel: function() {
      return a.forEach(function(l) {
        return t[i](l, r);
      });
    }
  };
}, ute = typeof Array.prototype.indexOf != "undefined", dte = typeof window != "undefined" && typeof window.postMessage != "undefined";
if (!E8 && (!ute || !dte))
  throw new Error("Sorry, the Vimeo Player API is not available in this browser.");
var fo = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function cte(e, t) {
  return t = { exports: {} }, e(t, t.exports), t.exports;
}
/*!
 * weakmap-polyfill v2.0.4 - ECMAScript6 WeakMap polyfill
 * https://github.com/polygonplanet/weakmap-polyfill
 * Copyright (c) 2015-2021 polygonplanet <polygon.planet.aqua@gmail.com>
 * @license MIT
 */
(function(e) {
  if (e.WeakMap)
    return;
  var t = Object.prototype.hasOwnProperty, n = Object.defineProperty && function() {
    try {
      return Object.defineProperty({}, "x", {
        value: 1
      }).x === 1;
    } catch (i) {
    }
  }(), r = function(i, a, s) {
    n ? Object.defineProperty(i, a, {
      configurable: !0,
      writable: !0,
      value: s
    }) : i[a] = s;
  };
  e.WeakMap = function() {
    function i() {
      if (this === void 0)
        throw new TypeError("Constructor WeakMap requires 'new'");
      if (r(this, "_id", s("_WeakMap")), arguments.length > 0)
        throw new TypeError("WeakMap iterable is not supported");
    }
    r(i.prototype, "delete", function(u) {
      if (a(this, "delete"), !o(u))
        return !1;
      var m = u[this._id];
      return m && m[0] === u ? (delete u[this._id], !0) : !1;
    }), r(i.prototype, "get", function(u) {
      if (a(this, "get"), !!o(u)) {
        var m = u[this._id];
        if (m && m[0] === u)
          return m[1];
      }
    }), r(i.prototype, "has", function(u) {
      if (a(this, "has"), !o(u))
        return !1;
      var m = u[this._id];
      return !!(m && m[0] === u);
    }), r(i.prototype, "set", function(u, m) {
      if (a(this, "set"), !o(u))
        throw new TypeError("Invalid value used as weak map key");
      var v = u[this._id];
      return v && v[0] === u ? (v[1] = m, this) : (r(u, this._id, [u, m]), this);
    });
    function a(u, m) {
      if (!o(u) || !t.call(u, "_id"))
        throw new TypeError(m + " method called on incompatible receiver " + typeof u);
    }
    function s(u) {
      return u + "_" + l() + "." + l();
    }
    function l() {
      return Math.random().toString().substring(2);
    }
    return r(i, "_polyfill", !0), i;
  }();
  function o(i) {
    return Object(i) === i;
  }
})(typeof globalThis != "undefined" ? globalThis : typeof self != "undefined" ? self : typeof window != "undefined" ? window : fo);
var en = cte(function(e) {
  /*! Native Promise Only
      v0.8.1 (c) Kyle Simpson
      MIT License: http://getify.mit-license.org
  */
  (function(n, r, o) {
    r[n] = r[n] || o(), e.exports && (e.exports = r[n]);
  })("Promise", fo, function() {
    var n, r, o, i = Object.prototype.toString, a = typeof setImmediate != "undefined" ? function(F) {
      return setImmediate(F);
    } : setTimeout;
    try {
      Object.defineProperty({}, "x", {}), n = function(F, I, D, O) {
        return Object.defineProperty(F, I, {
          value: D,
          writable: !0,
          configurable: O !== !1
        });
      };
    } catch (P) {
      n = function(I, D, O) {
        return I[D] = O, I;
      };
    }
    o = /* @__PURE__ */ function() {
      var F, I, D;
      function O(U, q) {
        this.fn = U, this.self = q, this.next = void 0;
      }
      return {
        add: function(q, z) {
          D = new O(q, z), I ? I.next = D : F = D, I = D, D = void 0;
        },
        drain: function() {
          var q = F;
          for (F = I = r = void 0; q; )
            q.fn.call(q.self), q = q.next;
        }
      };
    }();
    function s(P, F) {
      o.add(P, F), r || (r = a(o.drain));
    }
    function l(P) {
      var F, I = typeof P;
      return P != null && (I == "object" || I == "function") && (F = P.then), typeof F == "function" ? F : !1;
    }
    function u() {
      for (var P = 0; P < this.chain.length; P++)
        m(this, this.state === 1 ? this.chain[P].success : this.chain[P].failure, this.chain[P]);
      this.chain.length = 0;
    }
    function m(P, F, I) {
      var D, O;
      try {
        F === !1 ? I.reject(P.msg) : (F === !0 ? D = P.msg : D = F.call(void 0, P.msg), D === I.promise ? I.reject(TypeError("Promise-chain cycle")) : (O = l(D)) ? O.call(D, I.resolve, I.reject) : I.resolve(D));
      } catch (U) {
        I.reject(U);
      }
    }
    function v(P) {
      var F, I = this;
      if (!I.triggered) {
        I.triggered = !0, I.def && (I = I.def);
        try {
          (F = l(P)) ? s(function() {
            var D = new E(I);
            try {
              F.call(P, function() {
                v.apply(D, arguments);
              }, function() {
                g.apply(D, arguments);
              });
            } catch (O) {
              g.call(D, O);
            }
          }) : (I.msg = P, I.state = 1, I.chain.length > 0 && s(u, I));
        } catch (D) {
          g.call(new E(I), D);
        }
      }
    }
    function g(P) {
      var F = this;
      F.triggered || (F.triggered = !0, F.def && (F = F.def), F.msg = P, F.state = 2, F.chain.length > 0 && s(u, F));
    }
    function h(P, F, I, D) {
      for (var O = 0; O < F.length; O++)
        (function(q) {
          P.resolve(F[q]).then(function(te) {
            I(q, te);
          }, D);
        })(O);
    }
    function E(P) {
      this.def = P, this.triggered = !1;
    }
    function C(P) {
      this.promise = P, this.state = 0, this.triggered = !1, this.chain = [], this.msg = void 0;
    }
    function A(P) {
      if (typeof P != "function")
        throw TypeError("Not a function");
      if (this.__NPO__ !== 0)
        throw TypeError("Not a promise");
      this.__NPO__ = 1;
      var F = new C(this);
      this.then = function(D, O) {
        var U = {
          success: typeof D == "function" ? D : !0,
          failure: typeof O == "function" ? O : !1
        };
        return U.promise = new this.constructor(function(z, te) {
          if (typeof z != "function" || typeof te != "function")
            throw TypeError("Not a function");
          U.resolve = z, U.reject = te;
        }), F.chain.push(U), F.state !== 0 && s(u, F), U.promise;
      }, this.catch = function(D) {
        return this.then(void 0, D);
      };
      try {
        P.call(void 0, function(D) {
          v.call(F, D);
        }, function(D) {
          g.call(F, D);
        });
      } catch (I) {
        g.call(F, I);
      }
    }
    var R = n(
      {},
      "constructor",
      A,
      /*configurable=*/
      !1
    );
    return A.prototype = R, n(
      R,
      "__NPO__",
      0,
      /*configurable=*/
      !1
    ), n(A, "resolve", function(F) {
      var I = this;
      return F && typeof F == "object" && F.__NPO__ === 1 ? F : new I(function(O, U) {
        if (typeof O != "function" || typeof U != "function")
          throw TypeError("Not a function");
        O(F);
      });
    }), n(A, "reject", function(F) {
      return new this(function(D, O) {
        if (typeof D != "function" || typeof O != "function")
          throw TypeError("Not a function");
        O(F);
      });
    }), n(A, "all", function(F) {
      var I = this;
      return i.call(F) != "[object Array]" ? I.reject(TypeError("Not an array")) : F.length === 0 ? I.resolve([]) : new I(function(O, U) {
        if (typeof O != "function" || typeof U != "function")
          throw TypeError("Not a function");
        var q = F.length, z = Array(q), te = 0;
        h(I, F, function(x, N) {
          z[x] = N, ++te === q && O(z);
        }, U);
      });
    }), n(A, "race", function(F) {
      var I = this;
      return i.call(F) != "[object Array]" ? I.reject(TypeError("Not an array")) : new I(function(O, U) {
        if (typeof O != "function" || typeof U != "function")
          throw TypeError("Not a function");
        h(I, F, function(z, te) {
          O(te);
        }, U);
      });
    }), A;
  });
}), Gn = /* @__PURE__ */ new WeakMap();
function zo(e, t, n) {
  var r = Gn.get(e.element) || {};
  t in r || (r[t] = []), r[t].push(n), Gn.set(e.element, r);
}
function Cs(e, t) {
  var n = Gn.get(e.element) || {};
  return n[t] || [];
}
function ws(e, t, n) {
  var r = Gn.get(e.element) || {};
  if (!r[t])
    return !0;
  if (!n)
    return r[t] = [], Gn.set(e.element, r), !0;
  var o = r[t].indexOf(n);
  return o !== -1 && r[t].splice(o, 1), Gn.set(e.element, r), r[t] && r[t].length === 0;
}
function hte(e, t) {
  var n = Cs(e, t);
  if (n.length < 1)
    return !1;
  var r = n.shift();
  return ws(e, t, r), r;
}
function mte(e, t) {
  var n = Gn.get(e);
  Gn.set(t, n), Gn.delete(e);
}
function Js(e) {
  if (typeof e == "string")
    try {
      e = JSON.parse(e);
    } catch (t) {
      return console.warn(t), {};
    }
  return e;
}
function Tr(e, t, n) {
  if (!(!e.element.contentWindow || !e.element.contentWindow.postMessage)) {
    var r = {
      method: t
    };
    n !== void 0 && (r.value = n);
    var o = parseFloat(navigator.userAgent.toLowerCase().replace(/^.*msie (\d+).*$/, "$1"));
    o >= 8 && o < 10 && (r = JSON.stringify(r)), e.element.contentWindow.postMessage(r, e.origin);
  }
}
function fte(e, t) {
  t = Js(t);
  var n = [], r;
  if (t.event) {
    if (t.event === "error") {
      var o = Cs(e, t.data.method);
      o.forEach(function(a) {
        var s = new Error(t.data.message);
        s.name = t.data.name, a.reject(s), ws(e, t.data.method, a);
      });
    }
    n = Cs(e, "event:".concat(t.event)), r = t.data;
  } else if (t.method) {
    var i = hte(e, t.method);
    i && (n.push(i), r = t.value);
  }
  n.forEach(function(a) {
    try {
      if (typeof a == "function") {
        a.call(e, r);
        return;
      }
      a.resolve(r);
    } catch (s) {
    }
  });
}
var pte = ["airplay", "audio_tracks", "audiotrack", "autopause", "autoplay", "background", "byline", "cc", "chapter_id", "chapters", "chromecast", "color", "colors", "controls", "dnt", "end_time", "fullscreen", "height", "id", "interactive_params", "keyboard", "loop", "maxheight", "maxwidth", "muted", "play_button_position", "playsinline", "portrait", "progress_bar", "quality_selector", "responsive", "speed", "start_time", "texttrack", "title", "transcript", "transparent", "unmute_button", "url", "vimeo_logo", "volume", "watch_full_video", "width"];
function A8(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return pte.reduce(function(n, r) {
    var o = e.getAttribute("data-vimeo-".concat(r));
    return (o || o === "") && (n[r] = o === "" ? 1 : o), n;
  }, t);
}
function ch(e, t) {
  var n = e.html;
  if (!t)
    throw new TypeError("An element must be provided");
  if (t.getAttribute("data-vimeo-initialized") !== null)
    return t.querySelector("iframe");
  var r = document.createElement("div");
  return r.innerHTML = n, t.appendChild(r.firstChild), t.setAttribute("data-vimeo-initialized", "true"), t.querySelector("iframe");
}
function I8(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = arguments.length > 2 ? arguments[2] : void 0;
  return new Promise(function(r, o) {
    if (!Vr(e))
      throw new TypeError("“".concat(e, "” is not a vimeo.com url."));
    var i = lte(e), a = "https://".concat(i, "/api/oembed.json?url=").concat(encodeURIComponent(e));
    for (var s in t)
      t.hasOwnProperty(s) && (a += "&".concat(s, "=").concat(encodeURIComponent(t[s])));
    var l = "XDomainRequest" in window ? new XDomainRequest() : new XMLHttpRequest();
    l.open("GET", a, !0), l.onload = function() {
      if (l.status === 404) {
        o(new Error("“".concat(e, "” was not found.")));
        return;
      }
      if (l.status === 403) {
        o(new Error("“".concat(e, "” is not embeddable.")));
        return;
      }
      try {
        var u = JSON.parse(l.responseText);
        if (u.domain_status_code === 403) {
          ch(u, n), o(new Error("“".concat(e, "” is not embeddable.")));
          return;
        }
        r(u);
      } catch (m) {
        o(m);
      }
    }, l.onerror = function() {
      var u = l.status ? " (".concat(l.status, ")") : "";
      o(new Error("There was an error fetching the embed code from Vimeo".concat(u, ".")));
    }, l.send();
  });
}
function gte() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document, t = [].slice.call(e.querySelectorAll("[data-vimeo-id], [data-vimeo-url]")), n = function(o) {
    "console" in window && console.error && console.error("There was an error creating an embed: ".concat(o));
  };
  t.forEach(function(r) {
    try {
      if (r.getAttribute("data-vimeo-defer") !== null)
        return;
      var o = A8(r), i = M8(o);
      I8(i, o, r).then(function(a) {
        return ch(a, r);
      }).catch(n);
    } catch (a) {
      n(a);
    }
  });
}
function vte() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
  if (!window.VimeoPlayerResizeEmbeds_) {
    window.VimeoPlayerResizeEmbeds_ = !0;
    var t = function(r) {
      if (Vr(r.origin) && !(!r.data || r.data.event !== "spacechange")) {
        for (var o = e.querySelectorAll("iframe"), i = 0; i < o.length; i++)
          if (o[i].contentWindow === r.source) {
            var a = o[i].parentElement;
            a.style.paddingBottom = "".concat(r.data.data[0].bottom, "px");
            break;
          }
      }
    };
    window.addEventListener("message", t);
  }
}
function bte() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
  if (!window.VimeoSeoMetadataAppended) {
    window.VimeoSeoMetadataAppended = !0;
    var t = function(r) {
      if (Vr(r.origin)) {
        var o = Js(r.data);
        if (!(!o || o.event !== "ready"))
          for (var i = e.querySelectorAll("iframe"), a = 0; a < i.length; a++) {
            var s = i[a], l = s.contentWindow === r.source;
            if (S8(s.src) && l) {
              var u = new hh(s);
              u.callMethod("appendVideoMetadata", window.location.href);
            }
          }
      }
    };
    window.addEventListener("message", t);
  }
}
function yte() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
  if (!window.VimeoCheckedUrlTimeParam) {
    window.VimeoCheckedUrlTimeParam = !0;
    var t = function(o) {
      "console" in window && console.error && console.error("There was an error getting video Id: ".concat(o));
    }, n = function(o) {
      if (Vr(o.origin)) {
        var i = Js(o.data);
        if (!(!i || i.event !== "ready"))
          for (var a = e.querySelectorAll("iframe"), s = function() {
            var m = a[l], v = m.contentWindow === o.source;
            if (S8(m.src) && v) {
              var g = new hh(m);
              g.getVideoId().then(function(h) {
                var E = new RegExp("[?&]vimeo_t_".concat(h, "=([^&#]*)")).exec(window.location.href);
                if (E && E[1]) {
                  var C = decodeURI(E[1]);
                  g.setCurrentTime(C);
                }
              }).catch(t);
            }
          }, l = 0; l < a.length; l++)
            s();
      }
    };
    window.addEventListener("message", n);
  }
}
function _te() {
  var e = function() {
    for (var r, o = [
      ["requestFullscreen", "exitFullscreen", "fullscreenElement", "fullscreenEnabled", "fullscreenchange", "fullscreenerror"],
      // New WebKit
      ["webkitRequestFullscreen", "webkitExitFullscreen", "webkitFullscreenElement", "webkitFullscreenEnabled", "webkitfullscreenchange", "webkitfullscreenerror"],
      // Old WebKit
      ["webkitRequestFullScreen", "webkitCancelFullScreen", "webkitCurrentFullScreenElement", "webkitCancelFullScreen", "webkitfullscreenchange", "webkitfullscreenerror"],
      ["mozRequestFullScreen", "mozCancelFullScreen", "mozFullScreenElement", "mozFullScreenEnabled", "mozfullscreenchange", "mozfullscreenerror"],
      ["msRequestFullscreen", "msExitFullscreen", "msFullscreenElement", "msFullscreenEnabled", "MSFullscreenChange", "MSFullscreenError"]
    ], i = 0, a = o.length, s = {}; i < a; i++)
      if (r = o[i], r && r[1] in document) {
        for (i = 0; i < r.length; i++)
          s[o[0][i]] = r[i];
        return s;
      }
    return !1;
  }(), t = {
    fullscreenchange: e.fullscreenchange,
    fullscreenerror: e.fullscreenerror
  }, n = {
    request: function(o) {
      return new Promise(function(i, a) {
        var s = function u() {
          n.off("fullscreenchange", u), i();
        };
        n.on("fullscreenchange", s), o = o || document.documentElement;
        var l = o[e.requestFullscreen]();
        l instanceof Promise && l.then(s).catch(a);
      });
    },
    exit: function() {
      return new Promise(function(o, i) {
        if (!n.isFullscreen) {
          o();
          return;
        }
        var a = function l() {
          n.off("fullscreenchange", l), o();
        };
        n.on("fullscreenchange", a);
        var s = document[e.exitFullscreen]();
        s instanceof Promise && s.then(a).catch(i);
      });
    },
    on: function(o, i) {
      var a = t[o];
      a && document.addEventListener(a, i);
    },
    off: function(o, i) {
      var a = t[o];
      a && document.removeEventListener(a, i);
    }
  };
  return Object.defineProperties(n, {
    isFullscreen: {
      get: function() {
        return !!document[e.fullscreenElement];
      }
    },
    element: {
      enumerable: !0,
      get: function() {
        return document[e.fullscreenElement];
      }
    },
    isEnabled: {
      enumerable: !0,
      get: function() {
        return !!document[e.fullscreenEnabled];
      }
    }
  }), n;
}
var Cte = {
  role: "viewer",
  autoPlayMuted: !0,
  allowedDrift: 0.3,
  maxAllowedDrift: 1,
  minCheckInterval: 0.1,
  maxRateAdjustment: 0.2,
  maxTimeToCatchUp: 1
}, wte = /* @__PURE__ */ function(e) {
  tte(n, e);
  var t = ote(n);
  function n(r, o) {
    var i, a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, s = arguments.length > 3 ? arguments[3] : void 0;
    return C8(this, n), i = t.call(this), os(ss(i), "logger", void 0), os(ss(i), "speedAdjustment", 0), os(ss(i), "adjustSpeed", /* @__PURE__ */ function() {
      var l = Sr(/* @__PURE__ */ Tt().mark(function u(m, v) {
        var g;
        return Tt().wrap(function(E) {
          for (; ; ) switch (E.prev = E.next) {
            case 0:
              if (i.speedAdjustment !== v) {
                E.next = 2;
                break;
              }
              return E.abrupt("return");
            case 2:
              return E.next = 4, m.getPlaybackRate();
            case 4:
              return E.t0 = E.sent, E.t1 = i.speedAdjustment, E.t2 = E.t0 - E.t1, E.t3 = v, g = E.t2 + E.t3, i.log("New playbackRate:  ".concat(g)), E.next = 12, m.setPlaybackRate(g);
            case 12:
              i.speedAdjustment = v;
            case 13:
            case "end":
              return E.stop();
          }
        }, u);
      }));
      return function(u, m) {
        return l.apply(this, arguments);
      };
    }()), i.logger = s, i.init(o, r, ng(ng({}, Cte), a)), i;
  }
  return w8(n, [{
    key: "disconnect",
    value: function() {
      this.dispatchEvent(new Event("disconnect"));
    }
    /**
     * @param {TimingObject} timingObject
     * @param {PlayerControls} player
     * @param {TimingSrcConnectorOptions} options
     * @return {Promise<void>}
     */
  }, {
    key: "init",
    value: function() {
      var r = Sr(/* @__PURE__ */ Tt().mark(function i(a, s, l) {
        var u = this, m, v, g;
        return Tt().wrap(function(E) {
          for (; ; ) switch (E.prev = E.next) {
            case 0:
              return E.next = 2, this.waitForTOReadyState(a, "open");
            case 2:
              if (l.role !== "viewer") {
                E.next = 10;
                break;
              }
              return E.next = 5, this.updatePlayer(a, s, l);
            case 5:
              m = ig(a, "change", function() {
                return u.updatePlayer(a, s, l);
              }), v = this.maintainPlaybackPosition(a, s, l), this.addEventListener("disconnect", function() {
                v.cancel(), m.cancel();
              }), E.next = 14;
              break;
            case 10:
              return E.next = 12, this.updateTimingObject(a, s);
            case 12:
              g = ig(s, ["seeked", "play", "pause", "ratechange"], function() {
                return u.updateTimingObject(a, s);
              }, "on", "off"), this.addEventListener("disconnect", function() {
                return g.cancel();
              });
            case 14:
            case "end":
              return E.stop();
          }
        }, i, this);
      }));
      function o(i, a, s) {
        return r.apply(this, arguments);
      }
      return o;
    }()
    /**
     * Sets the TimingObject's state to reflect that of the player
     *
     * @param {TimingObject} timingObject
     * @param {PlayerControls} player
     * @return {Promise<void>}
     */
  }, {
    key: "updateTimingObject",
    value: function() {
      var r = Sr(/* @__PURE__ */ Tt().mark(function i(a, s) {
        return Tt().wrap(function(u) {
          for (; ; ) switch (u.prev = u.next) {
            case 0:
              return u.t0 = a, u.next = 3, s.getCurrentTime();
            case 3:
              return u.t1 = u.sent, u.next = 6, s.getPaused();
            case 6:
              if (!u.sent) {
                u.next = 10;
                break;
              }
              u.t2 = 0, u.next = 13;
              break;
            case 10:
              return u.next = 12, s.getPlaybackRate();
            case 12:
              u.t2 = u.sent;
            case 13:
              u.t3 = u.t2, u.t4 = {
                position: u.t1,
                velocity: u.t3
              }, u.t0.update.call(u.t0, u.t4);
            case 16:
            case "end":
              return u.stop();
          }
        }, i);
      }));
      function o(i, a) {
        return r.apply(this, arguments);
      }
      return o;
    }()
    /**
     * Sets the player's timing state to reflect that of the TimingObject
     *
     * @param {TimingObject} timingObject
     * @param {PlayerControls} player
     * @param {TimingSrcConnectorOptions} options
     * @return {Promise<void>}
     */
  }, {
    key: "updatePlayer",
    value: function() {
      var r = Sr(/* @__PURE__ */ Tt().mark(function i(a, s, l) {
        var u, m, v;
        return Tt().wrap(function(h) {
          for (; ; ) switch (h.prev = h.next) {
            case 0:
              if (u = a.query(), m = u.position, v = u.velocity, typeof m == "number" && s.setCurrentTime(m), typeof v != "number") {
                h.next = 25;
                break;
              }
              if (v !== 0) {
                h.next = 11;
                break;
              }
              return h.next = 6, s.getPaused();
            case 6:
              if (h.t0 = h.sent, h.t0 !== !1) {
                h.next = 9;
                break;
              }
              s.pause();
            case 9:
              h.next = 25;
              break;
            case 11:
              if (!(v > 0)) {
                h.next = 25;
                break;
              }
              return h.next = 14, s.getPaused();
            case 14:
              if (h.t1 = h.sent, h.t1 !== !0) {
                h.next = 19;
                break;
              }
              return h.next = 18, s.play().catch(/* @__PURE__ */ function() {
                var E = Sr(/* @__PURE__ */ Tt().mark(function C(A) {
                  return Tt().wrap(function(P) {
                    for (; ; ) switch (P.prev = P.next) {
                      case 0:
                        if (!(A.name === "NotAllowedError" && l.autoPlayMuted)) {
                          P.next = 5;
                          break;
                        }
                        return P.next = 3, s.setMuted(!0);
                      case 3:
                        return P.next = 5, s.play().catch(function(F) {
                          return console.error("Couldn't play the video from TimingSrcConnector. Error:", F);
                        });
                      case 5:
                      case "end":
                        return P.stop();
                    }
                  }, C);
                }));
                return function(C) {
                  return E.apply(this, arguments);
                };
              }());
            case 18:
              this.updatePlayer(a, s, l);
            case 19:
              return h.next = 21, s.getPlaybackRate();
            case 21:
              if (h.t2 = h.sent, h.t3 = v, h.t2 === h.t3) {
                h.next = 25;
                break;
              }
              s.setPlaybackRate(v);
            case 25:
            case "end":
              return h.stop();
          }
        }, i, this);
      }));
      function o(i, a, s) {
        return r.apply(this, arguments);
      }
      return o;
    }()
    /**
     * Since video players do not play with 100% time precision, we need to closely monitor
     * our player to be sure it remains in sync with the TimingObject.
     *
     * If out of sync, we use the current conditions and the options provided to determine
     * whether to re-sync via setting currentTime or adjusting the playbackRate
     *
     * @param {TimingObject} timingObject
     * @param {PlayerControls} player
     * @param {TimingSrcConnectorOptions} options
     * @return {{cancel: (function(): void)}}
     */
  }, {
    key: "maintainPlaybackPosition",
    value: function(o, i, a) {
      var s = this, l = a.allowedDrift, u = a.maxAllowedDrift, m = a.minCheckInterval, v = a.maxRateAdjustment, g = a.maxTimeToCatchUp, h = Math.min(g, Math.max(m, u)) * 1e3, E = /* @__PURE__ */ function() {
        var A = Sr(/* @__PURE__ */ Tt().mark(function R() {
          var P, F, I, D, O;
          return Tt().wrap(function(q) {
            for (; ; ) switch (q.prev = q.next) {
              case 0:
                if (q.t0 = o.query().velocity === 0, q.t0) {
                  q.next = 6;
                  break;
                }
                return q.next = 4, i.getPaused();
              case 4:
                q.t1 = q.sent, q.t0 = q.t1 === !0;
              case 6:
                if (!q.t0) {
                  q.next = 8;
                  break;
                }
                return q.abrupt("return");
              case 8:
                return q.t2 = o.query().position, q.next = 11, i.getCurrentTime();
              case 11:
                if (q.t3 = q.sent, P = q.t2 - q.t3, F = Math.abs(P), s.log("Drift: ".concat(P)), !(F > u)) {
                  q.next = 22;
                  break;
                }
                return q.next = 18, s.adjustSpeed(i, 0);
              case 18:
                i.setCurrentTime(o.query().position), s.log("Resync by currentTime"), q.next = 29;
                break;
              case 22:
                if (!(F > l)) {
                  q.next = 29;
                  break;
                }
                return I = F / g, D = v, O = I < D ? (D - I) / 2 : D, q.next = 28, s.adjustSpeed(i, O * Math.sign(P));
              case 28:
                s.log("Resync by playbackRate");
              case 29:
              case "end":
                return q.stop();
            }
          }, R);
        }));
        return function() {
          return A.apply(this, arguments);
        };
      }(), C = setInterval(function() {
        return E();
      }, h);
      return {
        cancel: function() {
          return clearInterval(C);
        }
      };
    }
    /**
     * @param {string} msg
     */
  }, {
    key: "log",
    value: function(o) {
      var i;
      (i = this.logger) === null || i === void 0 || i.call(this, "TimingSrcConnector: ".concat(o));
    }
  }, {
    key: "waitForTOReadyState",
    value: (
      /**
       * @param {TimingObject} timingObject
       * @param {TConnectionState} state
       * @return {Promise<void>}
       */
      function(o, i) {
        return new Promise(function(a) {
          var s = function l() {
            o.readyState === i ? a() : o.addEventListener("readystatechange", l, {
              once: !0
            });
          };
          s();
        });
      }
    )
  }]), n;
}(/* @__PURE__ */ i0(EventTarget)), ro = /* @__PURE__ */ new WeakMap(), Tc = /* @__PURE__ */ new WeakMap(), Ot = {}, hh = /* @__PURE__ */ function() {
  function e(t) {
    var n = this, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (C8(this, e), window.jQuery && t instanceof jQuery && (t.length > 1 && window.console && console.warn && console.warn("A jQuery object with multiple elements was passed, using the first element."), t = t[0]), typeof document != "undefined" && typeof t == "string" && (t = document.getElementById(t)), !ste(t))
      throw new TypeError("You must pass either a valid element or a valid id.");
    if (t.nodeName !== "IFRAME") {
      var o = t.querySelector("iframe");
      o && (t = o);
    }
    if (t.nodeName === "IFRAME" && !Vr(t.getAttribute("src") || ""))
      throw new Error("The player element passed isn’t a Vimeo embed.");
    if (ro.has(t))
      return ro.get(t);
    this._window = t.ownerDocument.defaultView, this.element = t, this.origin = "*";
    var i = new en(function(s, l) {
      if (n._onMessage = function(v) {
        if (!(!Vr(v.origin) || n.element.contentWindow !== v.source)) {
          n.origin === "*" && (n.origin = v.origin);
          var g = Js(v.data), h = g && g.event === "error", E = h && g.data && g.data.method === "ready";
          if (E) {
            var C = new Error(g.data.message);
            C.name = g.data.name, l(C);
            return;
          }
          var A = g && g.event === "ready", R = g && g.method === "ping";
          if (A || R) {
            n.element.setAttribute("data-ready", "true"), s();
            return;
          }
          fte(n, g);
        }
      }, n._window.addEventListener("message", n._onMessage), n.element.nodeName !== "IFRAME") {
        var u = A8(t, r), m = M8(u);
        I8(m, u, t).then(function(v) {
          var g = ch(v, t);
          return n.element = g, n._originalElement = t, mte(t, g), ro.set(n.element, n), v;
        }).catch(l);
      }
    });
    if (Tc.set(this, i), ro.set(this.element, this), this.element.nodeName === "IFRAME" && Tr(this, "ping"), Ot.isEnabled) {
      var a = function() {
        return Ot.exit();
      };
      this.fullscreenchangeHandler = function() {
        Ot.isFullscreen ? zo(n, "event:exitFullscreen", a) : ws(n, "event:exitFullscreen", a), n.ready().then(function() {
          Tr(n, "fullscreenchange", Ot.isFullscreen);
        });
      }, Ot.on("fullscreenchange", this.fullscreenchangeHandler);
    }
    return this;
  }
  return w8(e, [{
    key: "callMethod",
    value: function(n) {
      var r = this, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      return new en(function(i, a) {
        return r.ready().then(function() {
          zo(r, n, {
            resolve: i,
            reject: a
          }), Tr(r, n, o);
        }).catch(a);
      });
    }
    /**
     * Get a promise for the value of a player property.
     *
     * @param {string} name The property name
     * @return {Promise}
     */
  }, {
    key: "get",
    value: function(n) {
      var r = this;
      return new en(function(o, i) {
        return n = og(n, "get"), r.ready().then(function() {
          zo(r, n, {
            resolve: o,
            reject: i
          }), Tr(r, n);
        }).catch(i);
      });
    }
    /**
     * Get a promise for setting the value of a player property.
     *
     * @param {string} name The API method to call.
     * @param {mixed} value The value to set.
     * @return {Promise}
     */
  }, {
    key: "set",
    value: function(n, r) {
      var o = this;
      return new en(function(i, a) {
        if (n = og(n, "set"), r == null)
          throw new TypeError("There must be a value to set.");
        return o.ready().then(function() {
          zo(o, n, {
            resolve: i,
            reject: a
          }), Tr(o, n, r);
        }).catch(a);
      });
    }
    /**
     * Add an event listener for the specified event. Will call the
     * callback with a single parameter, `data`, that contains the data for
     * that event.
     *
     * @param {string} eventName The name of the event.
     * @param {function(*)} callback The function to call when the event fires.
     * @return {void}
     */
  }, {
    key: "on",
    value: function(n, r) {
      if (!n)
        throw new TypeError("You must pass an event name.");
      if (!r)
        throw new TypeError("You must pass a callback function.");
      if (typeof r != "function")
        throw new TypeError("The callback must be a function.");
      var o = Cs(this, "event:".concat(n));
      o.length === 0 && this.callMethod("addEventListener", n).catch(function() {
      }), zo(this, "event:".concat(n), r);
    }
    /**
     * Remove an event listener for the specified event. Will remove all
     * listeners for that event if a `callback` isn’t passed, or only that
     * specific callback if it is passed.
     *
     * @param {string} eventName The name of the event.
     * @param {function} [callback] The specific callback to remove.
     * @return {void}
     */
  }, {
    key: "off",
    value: function(n, r) {
      if (!n)
        throw new TypeError("You must pass an event name.");
      if (r && typeof r != "function")
        throw new TypeError("The callback must be a function.");
      var o = ws(this, "event:".concat(n), r);
      o && this.callMethod("removeEventListener", n).catch(function(i) {
      });
    }
    /**
     * A promise to load a new video.
     *
     * @promise LoadVideoPromise
     * @fulfill {number} The video with this id or url successfully loaded.
     * @reject {TypeError} The id was not a number.
     */
    /**
     * Load a new video into this embed. The promise will be resolved if
     * the video is successfully loaded, or it will be rejected if it could
     * not be loaded.
     *
     * @param {number|string|object} options The id of the video, the url of the video, or an object with embed options.
     * @return {LoadVideoPromise}
     */
  }, {
    key: "loadVideo",
    value: function(n) {
      return this.callMethod("loadVideo", n);
    }
    /**
     * A promise to perform an action when the Player is ready.
     *
     * @todo document errors
     * @promise LoadVideoPromise
     * @fulfill {void}
     */
    /**
     * Trigger a function when the player iframe has initialized. You do not
     * need to wait for `ready` to trigger to begin adding event listeners
     * or calling other methods.
     *
     * @return {ReadyPromise}
     */
  }, {
    key: "ready",
    value: function() {
      var n = Tc.get(this) || new en(function(r, o) {
        o(new Error("Unknown player. Probably unloaded."));
      });
      return en.resolve(n);
    }
    /**
     * A promise to add a cue point to the player.
     *
     * @promise AddCuePointPromise
     * @fulfill {string} The id of the cue point to use for removeCuePoint.
     * @reject {RangeError} the time was less than 0 or greater than the
     *         video’s duration.
     * @reject {UnsupportedError} Cue points are not supported with the current
     *         player or browser.
     */
    /**
     * Add a cue point to the player.
     *
     * @param {number} time The time for the cue point.
     * @param {object} [data] Arbitrary data to be returned with the cue point.
     * @return {AddCuePointPromise}
     */
  }, {
    key: "addCuePoint",
    value: function(n) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      return this.callMethod("addCuePoint", {
        time: n,
        data: r
      });
    }
    /**
     * A promise to remove a cue point from the player.
     *
     * @promise AddCuePointPromise
     * @fulfill {string} The id of the cue point that was removed.
     * @reject {InvalidCuePoint} The cue point with the specified id was not
     *         found.
     * @reject {UnsupportedError} Cue points are not supported with the current
     *         player or browser.
     */
    /**
     * Remove a cue point from the video.
     *
     * @param {string} id The id of the cue point to remove.
     * @return {RemoveCuePointPromise}
     */
  }, {
    key: "removeCuePoint",
    value: function(n) {
      return this.callMethod("removeCuePoint", n);
    }
    /**
     * A representation of a text track on a video.
     *
     * @typedef {Object} VimeoTextTrack
     * @property {string} language The ISO language code.
     * @property {string} kind The kind of track it is (captions or subtitles).
     * @property {string} label The human‐readable label for the track.
     */
    /**
     * A promise to enable a text track.
     *
     * @promise EnableTextTrackPromise
     * @fulfill {VimeoTextTrack} The text track that was enabled.
     * @reject {InvalidTrackLanguageError} No track was available with the
     *         specified language.
     * @reject {InvalidTrackError} No track was available with the specified
     *         language and kind.
     */
    /**
     * Enable the text track with the specified language, and optionally the
     * specified kind (captions or subtitles).
     *
     * When set via the API, the track language will not change the viewer’s
     * stored preference.
     *
     * @param {string} language The two‐letter language code.
     * @param {string} [kind] The kind of track to enable (captions or subtitles).
     * @return {EnableTextTrackPromise}
     */
  }, {
    key: "enableTextTrack",
    value: function(n, r) {
      if (!n)
        throw new TypeError("You must pass a language.");
      return this.callMethod("enableTextTrack", {
        language: n,
        kind: r
      });
    }
    /**
     * A promise to disable the active text track.
     *
     * @promise DisableTextTrackPromise
     * @fulfill {void} The track was disabled.
     */
    /**
     * Disable the currently-active text track.
     *
     * @return {DisableTextTrackPromise}
     */
  }, {
    key: "disableTextTrack",
    value: function() {
      return this.callMethod("disableTextTrack");
    }
    /**
     * A promise to pause the video.
     *
     * @promise PausePromise
     * @fulfill {void} The video was paused.
     */
    /**
     * Pause the video if it’s playing.
     *
     * @return {PausePromise}
     */
  }, {
    key: "pause",
    value: function() {
      return this.callMethod("pause");
    }
    /**
     * A promise to play the video.
     *
     * @promise PlayPromise
     * @fulfill {void} The video was played.
     */
    /**
     * Play the video if it’s paused. **Note:** on iOS and some other
     * mobile devices, you cannot programmatically trigger play. Once the
     * viewer has tapped on the play button in the player, however, you
     * will be able to use this function.
     *
     * @return {PlayPromise}
     */
  }, {
    key: "play",
    value: function() {
      return this.callMethod("play");
    }
    /**
     * Request that the player enters fullscreen.
     * @return {Promise}
     */
  }, {
    key: "requestFullscreen",
    value: function() {
      return Ot.isEnabled ? Ot.request(this.element) : this.callMethod("requestFullscreen");
    }
    /**
     * Request that the player exits fullscreen.
     * @return {Promise}
     */
  }, {
    key: "exitFullscreen",
    value: function() {
      return Ot.isEnabled ? Ot.exit() : this.callMethod("exitFullscreen");
    }
    /**
     * Returns true if the player is currently fullscreen.
     * @return {Promise}
     */
  }, {
    key: "getFullscreen",
    value: function() {
      return Ot.isEnabled ? en.resolve(Ot.isFullscreen) : this.get("fullscreen");
    }
    /**
     * Request that the player enters picture-in-picture.
     * @return {Promise}
     */
  }, {
    key: "requestPictureInPicture",
    value: function() {
      return this.callMethod("requestPictureInPicture");
    }
    /**
     * Request that the player exits picture-in-picture.
     * @return {Promise}
     */
  }, {
    key: "exitPictureInPicture",
    value: function() {
      return this.callMethod("exitPictureInPicture");
    }
    /**
     * Returns true if the player is currently picture-in-picture.
     * @return {Promise}
     */
  }, {
    key: "getPictureInPicture",
    value: function() {
      return this.get("pictureInPicture");
    }
    /**
     * A promise to prompt the viewer to initiate remote playback.
     *
     * @promise RemotePlaybackPromptPromise
     * @fulfill {void}
     * @reject {NotFoundError} No remote playback device is available.
     */
    /**
     * Request to prompt the user to initiate remote playback.
     *
     * @return {RemotePlaybackPromptPromise}
     */
  }, {
    key: "remotePlaybackPrompt",
    value: function() {
      return this.callMethod("remotePlaybackPrompt");
    }
    /**
     * A promise to unload the video.
     *
     * @promise UnloadPromise
     * @fulfill {void} The video was unloaded.
     */
    /**
     * Return the player to its initial state.
     *
     * @return {UnloadPromise}
     */
  }, {
    key: "unload",
    value: function() {
      return this.callMethod("unload");
    }
    /**
     * Cleanup the player and remove it from the DOM
     *
     * It won't be usable and a new one should be constructed
     *  in order to do any operations.
     *
     * @return {Promise}
     */
  }, {
    key: "destroy",
    value: function() {
      var n = this;
      return new en(function(r) {
        if (Tc.delete(n), ro.delete(n.element), n._originalElement && (ro.delete(n._originalElement), n._originalElement.removeAttribute("data-vimeo-initialized")), n.element && n.element.nodeName === "IFRAME" && n.element.parentNode && (n.element.parentNode.parentNode && n._originalElement && n._originalElement !== n.element.parentNode ? n.element.parentNode.parentNode.removeChild(n.element.parentNode) : n.element.parentNode.removeChild(n.element)), n.element && n.element.nodeName === "DIV" && n.element.parentNode) {
          n.element.removeAttribute("data-vimeo-initialized");
          var o = n.element.querySelector("iframe");
          o && o.parentNode && (o.parentNode.parentNode && n._originalElement && n._originalElement !== o.parentNode ? o.parentNode.parentNode.removeChild(o.parentNode) : o.parentNode.removeChild(o));
        }
        n._window.removeEventListener("message", n._onMessage), Ot.isEnabled && Ot.off("fullscreenchange", n.fullscreenchangeHandler), r();
      });
    }
    /**
     * A promise to get the autopause behavior of the video.
     *
     * @promise GetAutopausePromise
     * @fulfill {boolean} Whether autopause is turned on or off.
     * @reject {UnsupportedError} Autopause is not supported with the current
     *         player or browser.
     */
    /**
     * Get the autopause behavior for this player.
     *
     * @return {GetAutopausePromise}
     */
  }, {
    key: "getAutopause",
    value: function() {
      return this.get("autopause");
    }
    /**
     * A promise to set the autopause behavior of the video.
     *
     * @promise SetAutopausePromise
     * @fulfill {boolean} Whether autopause is turned on or off.
     * @reject {UnsupportedError} Autopause is not supported with the current
     *         player or browser.
     */
    /**
     * Enable or disable the autopause behavior of this player.
     *
     * By default, when another video is played in the same browser, this
     * player will automatically pause. Unless you have a specific reason
     * for doing so, we recommend that you leave autopause set to the
     * default (`true`).
     *
     * @param {boolean} autopause
     * @return {SetAutopausePromise}
     */
  }, {
    key: "setAutopause",
    value: function(n) {
      return this.set("autopause", n);
    }
    /**
     * A promise to get the buffered property of the video.
     *
     * @promise GetBufferedPromise
     * @fulfill {Array} Buffered Timeranges converted to an Array.
     */
    /**
     * Get the buffered property of the video.
     *
     * @return {GetBufferedPromise}
     */
  }, {
    key: "getBuffered",
    value: function() {
      return this.get("buffered");
    }
    /**
     * @typedef {Object} CameraProperties
     * @prop {number} props.yaw - Number between 0 and 360.
     * @prop {number} props.pitch - Number between -90 and 90.
     * @prop {number} props.roll - Number between -180 and 180.
     * @prop {number} props.fov - The field of view in degrees.
     */
    /**
     * A promise to get the camera properties of the player.
     *
     * @promise GetCameraPromise
     * @fulfill {CameraProperties} The camera properties.
     */
    /**
     * For 360° videos get the camera properties for this player.
     *
     * @return {GetCameraPromise}
     */
  }, {
    key: "getCameraProps",
    value: function() {
      return this.get("cameraProps");
    }
    /**
     * A promise to set the camera properties of the player.
     *
     * @promise SetCameraPromise
     * @fulfill {Object} The camera was successfully set.
     * @reject {RangeError} The range was out of bounds.
     */
    /**
     * For 360° videos set the camera properties for this player.
     *
     * @param {CameraProperties} camera The camera properties
     * @return {SetCameraPromise}
     */
  }, {
    key: "setCameraProps",
    value: function(n) {
      return this.set("cameraProps", n);
    }
    /**
     * A representation of a chapter.
     *
     * @typedef {Object} VimeoChapter
     * @property {number} startTime The start time of the chapter.
     * @property {object} title The title of the chapter.
     * @property {number} index The place in the order of Chapters. Starts at 1.
     */
    /**
     * A promise to get chapters for the video.
     *
     * @promise GetChaptersPromise
     * @fulfill {VimeoChapter[]} The chapters for the video.
     */
    /**
     * Get an array of all the chapters for the video.
     *
     * @return {GetChaptersPromise}
     */
  }, {
    key: "getChapters",
    value: function() {
      return this.get("chapters");
    }
    /**
     * A promise to get the currently active chapter.
     *
     * @promise GetCurrentChaptersPromise
     * @fulfill {VimeoChapter|undefined} The current chapter for the video.
     */
    /**
     * Get the currently active chapter for the video.
     *
     * @return {GetCurrentChaptersPromise}
     */
  }, {
    key: "getCurrentChapter",
    value: function() {
      return this.get("currentChapter");
    }
    /**
     * A promise to get the accent color of the player.
     *
     * @promise GetColorPromise
     * @fulfill {string} The hex color of the player.
     */
    /**
     * Get the accent color for this player. Note this is deprecated in place of `getColorTwo`.
     *
     * @return {GetColorPromise}
     */
  }, {
    key: "getColor",
    value: function() {
      return this.get("color");
    }
    /**
     * A promise to get all colors for the player in an array.
     *
     * @promise GetColorsPromise
     * @fulfill {string[]} The hex colors of the player.
     */
    /**
     * Get all the colors for this player in an array: [colorOne, colorTwo, colorThree, colorFour]
     *
     * @return {GetColorPromise}
     */
  }, {
    key: "getColors",
    value: function() {
      return en.all([this.get("colorOne"), this.get("colorTwo"), this.get("colorThree"), this.get("colorFour")]);
    }
    /**
     * A promise to set the accent color of the player.
     *
     * @promise SetColorPromise
     * @fulfill {string} The color was successfully set.
     * @reject {TypeError} The string was not a valid hex or rgb color.
     * @reject {ContrastError} The color was set, but the contrast is
     *         outside of the acceptable range.
     * @reject {EmbedSettingsError} The owner of the player has chosen to
     *         use a specific color.
     */
    /**
     * Set the accent color of this player to a hex or rgb string. Setting the
     * color may fail if the owner of the video has set their embed
     * preferences to force a specific color.
     * Note this is deprecated in place of `setColorTwo`.
     *
     * @param {string} color The hex or rgb color string to set.
     * @return {SetColorPromise}
     */
  }, {
    key: "setColor",
    value: function(n) {
      return this.set("color", n);
    }
    /**
     * A promise to set all colors for the player.
     *
     * @promise SetColorsPromise
     * @fulfill {string[]} The colors were successfully set.
     * @reject {TypeError} The string was not a valid hex or rgb color.
     * @reject {ContrastError} The color was set, but the contrast is
     *         outside of the acceptable range.
     * @reject {EmbedSettingsError} The owner of the player has chosen to
     *         use a specific color.
     */
    /**
     * Set the colors of this player to a hex or rgb string. Setting the
     * color may fail if the owner of the video has set their embed
     * preferences to force a specific color.
     * The colors should be passed in as an array: [colorOne, colorTwo, colorThree, colorFour].
     * If a color should not be set, the index in the array can be left as null.
     *
     * @param {string[]} colors Array of the hex or rgb color strings to set.
     * @return {SetColorsPromise}
     */
  }, {
    key: "setColors",
    value: function(n) {
      if (!Array.isArray(n))
        return new en(function(i, a) {
          return a(new TypeError("Argument must be an array."));
        });
      var r = new en(function(i) {
        return i(null);
      }), o = [n[0] ? this.set("colorOne", n[0]) : r, n[1] ? this.set("colorTwo", n[1]) : r, n[2] ? this.set("colorThree", n[2]) : r, n[3] ? this.set("colorFour", n[3]) : r];
      return en.all(o);
    }
    /**
     * A representation of a cue point.
     *
     * @typedef {Object} VimeoCuePoint
     * @property {number} time The time of the cue point.
     * @property {object} data The data passed when adding the cue point.
     * @property {string} id The unique id for use with removeCuePoint.
     */
    /**
     * A promise to get the cue points of a video.
     *
     * @promise GetCuePointsPromise
     * @fulfill {VimeoCuePoint[]} The cue points added to the video.
     * @reject {UnsupportedError} Cue points are not supported with the current
     *         player or browser.
     */
    /**
     * Get an array of the cue points added to the video.
     *
     * @return {GetCuePointsPromise}
     */
  }, {
    key: "getCuePoints",
    value: function() {
      return this.get("cuePoints");
    }
    /**
     * A promise to get the current time of the video.
     *
     * @promise GetCurrentTimePromise
     * @fulfill {number} The current time in seconds.
     */
    /**
     * Get the current playback position in seconds.
     *
     * @return {GetCurrentTimePromise}
     */
  }, {
    key: "getCurrentTime",
    value: function() {
      return this.get("currentTime");
    }
    /**
     * A promise to set the current time of the video.
     *
     * @promise SetCurrentTimePromise
     * @fulfill {number} The actual current time that was set.
     * @reject {RangeError} the time was less than 0 or greater than the
     *         video’s duration.
     */
    /**
     * Set the current playback position in seconds. If the player was
     * paused, it will remain paused. Likewise, if the player was playing,
     * it will resume playing once the video has buffered.
     *
     * You can provide an accurate time and the player will attempt to seek
     * to as close to that time as possible. The exact time will be the
     * fulfilled value of the promise.
     *
     * @param {number} currentTime
     * @return {SetCurrentTimePromise}
     */
  }, {
    key: "setCurrentTime",
    value: function(n) {
      return this.set("currentTime", n);
    }
    /**
     * A promise to get the duration of the video.
     *
     * @promise GetDurationPromise
     * @fulfill {number} The duration in seconds.
     */
    /**
     * Get the duration of the video in seconds. It will be rounded to the
     * nearest second before playback begins, and to the nearest thousandth
     * of a second after playback begins.
     *
     * @return {GetDurationPromise}
     */
  }, {
    key: "getDuration",
    value: function() {
      return this.get("duration");
    }
    /**
     * A promise to get the ended state of the video.
     *
     * @promise GetEndedPromise
     * @fulfill {boolean} Whether or not the video has ended.
     */
    /**
     * Get the ended state of the video. The video has ended if
     * `currentTime === duration`.
     *
     * @return {GetEndedPromise}
     */
  }, {
    key: "getEnded",
    value: function() {
      return this.get("ended");
    }
    /**
     * A promise to get the loop state of the player.
     *
     * @promise GetLoopPromise
     * @fulfill {boolean} Whether or not the player is set to loop.
     */
    /**
     * Get the loop state of the player.
     *
     * @return {GetLoopPromise}
     */
  }, {
    key: "getLoop",
    value: function() {
      return this.get("loop");
    }
    /**
     * A promise to set the loop state of the player.
     *
     * @promise SetLoopPromise
     * @fulfill {boolean} The loop state that was set.
     */
    /**
     * Set the loop state of the player. When set to `true`, the player
     * will start over immediately once playback ends.
     *
     * @param {boolean} loop
     * @return {SetLoopPromise}
     */
  }, {
    key: "setLoop",
    value: function(n) {
      return this.set("loop", n);
    }
    /**
     * A promise to set the muted state of the player.
     *
     * @promise SetMutedPromise
     * @fulfill {boolean} The muted state that was set.
     */
    /**
     * Set the muted state of the player. When set to `true`, the player
     * volume will be muted.
     *
     * @param {boolean} muted
     * @return {SetMutedPromise}
     */
  }, {
    key: "setMuted",
    value: function(n) {
      return this.set("muted", n);
    }
    /**
     * A promise to get the muted state of the player.
     *
     * @promise GetMutedPromise
     * @fulfill {boolean} Whether or not the player is muted.
     */
    /**
     * Get the muted state of the player.
     *
     * @return {GetMutedPromise}
     */
  }, {
    key: "getMuted",
    value: function() {
      return this.get("muted");
    }
    /**
     * A promise to get the paused state of the player.
     *
     * @promise GetLoopPromise
     * @fulfill {boolean} Whether or not the video is paused.
     */
    /**
     * Get the paused state of the player.
     *
     * @return {GetLoopPromise}
     */
  }, {
    key: "getPaused",
    value: function() {
      return this.get("paused");
    }
    /**
     * A promise to get the playback rate of the player.
     *
     * @promise GetPlaybackRatePromise
     * @fulfill {number} The playback rate of the player on a scale from 0 to 2.
     */
    /**
     * Get the playback rate of the player on a scale from `0` to `2`.
     *
     * @return {GetPlaybackRatePromise}
     */
  }, {
    key: "getPlaybackRate",
    value: function() {
      return this.get("playbackRate");
    }
    /**
     * A promise to set the playbackrate of the player.
     *
     * @promise SetPlaybackRatePromise
     * @fulfill {number} The playback rate was set.
     * @reject {RangeError} The playback rate was less than 0 or greater than 2.
     */
    /**
     * Set the playback rate of the player on a scale from `0` to `2`. When set
     * via the API, the playback rate will not be synchronized to other
     * players or stored as the viewer's preference.
     *
     * @param {number} playbackRate
     * @return {SetPlaybackRatePromise}
     */
  }, {
    key: "setPlaybackRate",
    value: function(n) {
      return this.set("playbackRate", n);
    }
    /**
     * A promise to get the played property of the video.
     *
     * @promise GetPlayedPromise
     * @fulfill {Array} Played Timeranges converted to an Array.
     */
    /**
     * Get the played property of the video.
     *
     * @return {GetPlayedPromise}
     */
  }, {
    key: "getPlayed",
    value: function() {
      return this.get("played");
    }
    /**
     * A promise to get the qualities available of the current video.
     *
     * @promise GetQualitiesPromise
     * @fulfill {Array} The qualities of the video.
     */
    /**
     * Get the qualities of the current video.
     *
     * @return {GetQualitiesPromise}
     */
  }, {
    key: "getQualities",
    value: function() {
      return this.get("qualities");
    }
    /**
     * A promise to get the current set quality of the video.
     *
     * @promise GetQualityPromise
     * @fulfill {string} The current set quality.
     */
    /**
     * Get the current set quality of the video.
     *
     * @return {GetQualityPromise}
     */
  }, {
    key: "getQuality",
    value: function() {
      return this.get("quality");
    }
    /**
     * A promise to set the video quality.
     *
     * @promise SetQualityPromise
     * @fulfill {number} The quality was set.
     * @reject {RangeError} The quality is not available.
     */
    /**
     * Set a video quality.
     *
     * @param {string} quality
     * @return {SetQualityPromise}
     */
  }, {
    key: "setQuality",
    value: function(n) {
      return this.set("quality", n);
    }
    /**
     * A promise to get the remote playback availability.
     *
     * @promise RemotePlaybackAvailabilityPromise
     * @fulfill {boolean} Whether remote playback is available.
     */
    /**
     * Get the availability of remote playback.
     *
     * @return {RemotePlaybackAvailabilityPromise}
     */
  }, {
    key: "getRemotePlaybackAvailability",
    value: function() {
      return this.get("remotePlaybackAvailability");
    }
    /**
     * A promise to get the current remote playback state.
     *
     * @promise RemotePlaybackStatePromise
     * @fulfill {string} The state of the remote playback: connecting, connected, or disconnected.
     */
    /**
     * Get the current remote playback state.
     *
     * @return {RemotePlaybackStatePromise}
     */
  }, {
    key: "getRemotePlaybackState",
    value: function() {
      return this.get("remotePlaybackState");
    }
    /**
     * A promise to get the seekable property of the video.
     *
     * @promise GetSeekablePromise
     * @fulfill {Array} Seekable Timeranges converted to an Array.
     */
    /**
     * Get the seekable property of the video.
     *
     * @return {GetSeekablePromise}
     */
  }, {
    key: "getSeekable",
    value: function() {
      return this.get("seekable");
    }
    /**
     * A promise to get the seeking property of the player.
     *
     * @promise GetSeekingPromise
     * @fulfill {boolean} Whether or not the player is currently seeking.
     */
    /**
     * Get if the player is currently seeking.
     *
     * @return {GetSeekingPromise}
     */
  }, {
    key: "getSeeking",
    value: function() {
      return this.get("seeking");
    }
    /**
     * A promise to get the text tracks of a video.
     *
     * @promise GetTextTracksPromise
     * @fulfill {VimeoTextTrack[]} The text tracks associated with the video.
     */
    /**
     * Get an array of the text tracks that exist for the video.
     *
     * @return {GetTextTracksPromise}
     */
  }, {
    key: "getTextTracks",
    value: function() {
      return this.get("textTracks");
    }
    /**
     * A promise to get the embed code for the video.
     *
     * @promise GetVideoEmbedCodePromise
     * @fulfill {string} The `<iframe>` embed code for the video.
     */
    /**
     * Get the `<iframe>` embed code for the video.
     *
     * @return {GetVideoEmbedCodePromise}
     */
  }, {
    key: "getVideoEmbedCode",
    value: function() {
      return this.get("videoEmbedCode");
    }
    /**
     * A promise to get the id of the video.
     *
     * @promise GetVideoIdPromise
     * @fulfill {number} The id of the video.
     */
    /**
     * Get the id of the video.
     *
     * @return {GetVideoIdPromise}
     */
  }, {
    key: "getVideoId",
    value: function() {
      return this.get("videoId");
    }
    /**
     * A promise to get the title of the video.
     *
     * @promise GetVideoTitlePromise
     * @fulfill {number} The title of the video.
     */
    /**
     * Get the title of the video.
     *
     * @return {GetVideoTitlePromise}
     */
  }, {
    key: "getVideoTitle",
    value: function() {
      return this.get("videoTitle");
    }
    /**
     * A promise to get the native width of the video.
     *
     * @promise GetVideoWidthPromise
     * @fulfill {number} The native width of the video.
     */
    /**
     * Get the native width of the currently‐playing video. The width of
     * the highest‐resolution available will be used before playback begins.
     *
     * @return {GetVideoWidthPromise}
     */
  }, {
    key: "getVideoWidth",
    value: function() {
      return this.get("videoWidth");
    }
    /**
     * A promise to get the native height of the video.
     *
     * @promise GetVideoHeightPromise
     * @fulfill {number} The native height of the video.
     */
    /**
     * Get the native height of the currently‐playing video. The height of
     * the highest‐resolution available will be used before playback begins.
     *
     * @return {GetVideoHeightPromise}
     */
  }, {
    key: "getVideoHeight",
    value: function() {
      return this.get("videoHeight");
    }
    /**
     * A promise to get the vimeo.com url for the video.
     *
     * @promise GetVideoUrlPromise
     * @fulfill {number} The vimeo.com url for the video.
     * @reject {PrivacyError} The url isn’t available because of the video’s privacy setting.
     */
    /**
     * Get the vimeo.com url for the video.
     *
     * @return {GetVideoUrlPromise}
     */
  }, {
    key: "getVideoUrl",
    value: function() {
      return this.get("videoUrl");
    }
    /**
     * A promise to get the volume level of the player.
     *
     * @promise GetVolumePromise
     * @fulfill {number} The volume level of the player on a scale from 0 to 1.
     */
    /**
     * Get the current volume level of the player on a scale from `0` to `1`.
     *
     * Most mobile devices do not support an independent volume from the
     * system volume. In those cases, this method will always return `1`.
     *
     * @return {GetVolumePromise}
     */
  }, {
    key: "getVolume",
    value: function() {
      return this.get("volume");
    }
    /**
     * A promise to set the volume level of the player.
     *
     * @promise SetVolumePromise
     * @fulfill {number} The volume was set.
     * @reject {RangeError} The volume was less than 0 or greater than 1.
     */
    /**
     * Set the volume of the player on a scale from `0` to `1`. When set
     * via the API, the volume level will not be synchronized to other
     * players or stored as the viewer’s preference.
     *
     * Most mobile devices do not support setting the volume. An error will
     * *not* be triggered in that situation.
     *
     * @param {number} volume
     * @return {SetVolumePromise}
     */
  }, {
    key: "setVolume",
    value: function(n) {
      return this.set("volume", n);
    }
    /** @typedef {import('./lib/timing-object.types').TimingObject} TimingObject */
    /** @typedef {import('./lib/timing-src-connector.types').TimingSrcConnectorOptions} TimingSrcConnectorOptions */
    /** @typedef {import('./lib/timing-src-connector').TimingSrcConnector} TimingSrcConnector */
    /**
     * Connects a TimingObject to the video player (https://webtiming.github.io/timingobject/)
     *
     * @param {TimingObject} timingObject
     * @param {TimingSrcConnectorOptions} options
     *
     * @return {Promise<TimingSrcConnector>}
     */
  }, {
    key: "setTimingSrc",
    value: function() {
      var t = Sr(/* @__PURE__ */ Tt().mark(function r(o, i) {
        var a = this, s;
        return Tt().wrap(function(u) {
          for (; ; ) switch (u.prev = u.next) {
            case 0:
              if (o) {
                u.next = 2;
                break;
              }
              throw new TypeError("A Timing Object must be provided.");
            case 2:
              return u.next = 4, this.ready();
            case 4:
              return s = new wte(this, o, i), Tr(this, "notifyTimingObjectConnect"), s.addEventListener("disconnect", function() {
                return Tr(a, "notifyTimingObjectDisconnect");
              }), u.abrupt("return", s);
            case 8:
            case "end":
              return u.stop();
          }
        }, r, this);
      }));
      function n(r, o) {
        return t.apply(this, arguments);
      }
      return n;
    }()
  }]), e;
}();
E8 || (Ot = _te(), gte(), vte(), bte(), yte());
const Tte = {
  name: "VideoPlayer",
  props: {
    url: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      default: ""
    },
    typeVideo: {
      type: String,
      default: ""
    },
    elementId: {
      type: String,
      default: "playerVideo"
    },
    autoplay: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      player: {
        vimeo: null,
        youtube: null
      }
    };
  },
  watch: {
    async url() {
      if (this.player.vimeo)
        try {
          await this.player.vimeo.destroy(), this.player.vimeo = null;
        } catch (e) {
          console.error("Error destroying ");
        }
      else this.player.youtube && (this.player.youtube.destroy(), this.player.youtube = null);
      this.typeVideo === "vimeo" ? this.loadVimeoPlayer() : this.loadYoutubePlayer();
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.typeVideo === "vimeo" ? this.loadVimeoPlayer() : this.loadYoutubePlayer();
    });
  },
  created() {
    this.$nextTick(() => {
      this.setStylesToIFrame();
    });
  },
  updated() {
    this.$nextTick(() => {
      this.setStylesToIFrame();
    });
  },
  methods: {
    createVimeoPlayer() {
      return !this.$refs[this.elementId] || !this.$refs[this.elementId].id ? !1 : (this.player.vimeo = new hh(this.$refs[this.elementId], {
        url: this.url,
        responsive: !0
      }), this.player.vimeo.on("play", () => {
        this.$emit("eventToEmit", { id: this.id, isPlaying: !0 });
      }), this.player.vimeo.on("pause", () => {
        this.$emit("eventToEmit", { id: this.id, isPlaying: !1 });
      }), !0);
    },
    createYoutubePlayer() {
      return !this.$refs[this.elementId] || !this.$refs[this.elementId].id ? !1 : (this.player.youtube = new Jee(this.$refs[this.elementId]), this.player.youtube.on("paused", () => {
        this.$emit("eventToEmit", {
          id: this.id,
          isPlaying: !1,
          elementId: this.elementId
        });
      }), this.player.youtube.on("ended", () => {
        this.$emit("eventToEmit", {
          id: this.id,
          isPlaying: !1,
          elementId: this.elementId
        });
      }), this.player.youtube.on("playing", () => {
        this.$emit("eventToEmit", {
          id: this.id,
          isPlaying: !0,
          elementId: this.elementId
        });
      }), !0);
    },
    loadVimeoPlayer() {
      !this.player.vimeo && !this.createVimeoPlayer() || (this.player.vimeo.loadVideo(this.url), this.player.vimeo.play());
    },
    loadYoutubePlayer() {
      !this.player.youtube && !this.createYoutubePlayer() || (this.player.youtube.load(this.id, this.autoplay), this.setStylesToIFrame());
    },
    setStylesToIFrame() {
      const e = this.$refs[this.elementId];
      e && (e.style.left = "0", e.style.top = "0", e.style.width = "100%", e.style.height = "100%", e.style.position = "absolute");
    }
  }
}, kte = {
  class: "video-player",
  "data-testid": "video-player"
}, Ete = ["id"];
function Ste(e, t, n, r, o, i) {
  return d(), f("div", kte, [
    c("div", {
      id: n.elementId,
      ref: n.elementId
    }, null, 8, Ete)
  ]);
}
const L8 = /* @__PURE__ */ B(Tte, [["render", Ste], ["__scopeId", "data-v-5fa63831"]]), Mte = {
  name: "V1",
  components: {
    VideoPlayer: L8
  },
  mixins: [dh],
  props: {
    componentId: {
      type: Number,
      default: 0
    }
  },
  computed: {
    prevItem() {
      let e = this.activeItem - 1;
      return e < 0 && (e = this.videoItems.length - 1), this.videoItems[e];
    },
    nextItem() {
      let e = this.activeItem + 1;
      return e >= this.videoItems.length && (e = 0), this.videoItems[e];
    }
  },
  methods: {
    activateItem(e) {
      this.readMoreOpen = !1, this.activeItem = e, this.$emit("setCurrentVideoThrillshare", e);
    },
    activateNext() {
      let e = this.activeItem + 1;
      e >= this.videoItems.length && (e = 0), this.activateItem(e);
    },
    activatePrev() {
      let e = this.activeItem - 1;
      e < 0 && (e = this.videoItems.length - 1), this.activateItem(e);
    },
    readMoreToggle() {
      this.readMoreOpen = !this.readMoreOpen;
    },
    isOverflow() {
      this.$nextTick(() => this.$refs.description.offsetHeight < this.$refs.description.scrollHeight || this.$refs.description.offsetWidth < this.$refs.description.scrollWidth);
    }
  }
}, Ate = ["data-testid"], Ite = ["data-testid"], Lte = { class: "video-wrapper" }, Dte = {
  key: 0,
  class: "thumbnail"
}, $te = ["src"], Ote = { class: "buttons" }, Pte = ["aria-label"], Nte = ["aria-label"], Hte = { class: "mirrors" }, Fte = { class: "prev" }, Rte = { class: "thumbnail" }, Vte = ["src"], Bte = { class: "title" }, jte = { class: "next" }, Ute = { class: "thumbnail" }, qte = ["src"], Gte = { class: "title" }, Kte = { class: "video-info" }, zte = {
  class: "title",
  "data-testid": "title"
}, Zte = {
  key: 1,
  class: "dots"
}, xte = ["onClick"], Wte = {
  key: 2,
  class: "buttons"
}, Yte = ["aria-label"], Xte = ["aria-label"];
function Qte(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("VideoPlayer");
  return d(), f("div", {
    id: "video-component",
    class: _(e.theme.style),
    style: Z(e.colors),
    "data-testid": "V1"
  }, [
    e.content.show_headline ? (d(), L(a, {
      key: 0,
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        c("h2", {
          "data-testid": `header-${e.theme.style}`,
          class: "no-border"
        }, [
          e.displayTopHeader ? (d(), f("span", {
            key: 0,
            class: "header-top",
            "data-testid": `header-${e.theme.style}-top`
          }, [
            M(e.$slots, "header-top", {}, () => [
              H(k(e.content.component_header_top), 1)
            ], !0)
          ], 8, Ite)) : T("", !0),
          M(e.$slots, "header", {}, () => [
            H(k(e.content.headline), 1)
          ], !0)
        ], 8, Ate)
      ]),
      _: 3
    }, 8, ["class", "theme-options"])) : T("", !0),
    c("div", Lte, [
      c("div", {
        class: "video",
        tabindex: "0",
        onKeyup: [
          t[0] || (t[0] = K((...l) => i.activateNext && i.activateNext(...l), ["right"])),
          t[1] || (t[1] = K((...l) => i.activatePrev && i.activatePrev(...l), ["left"]))
        ]
      }, [
        M(e.$slots, "delete-btn", {
          index: e.currentItem.position
        }, void 0, !0),
        M(e.$slots, `video-item-${e.currentItem.position}`, {}, () => [
          e.isPlaceholder ? (d(), f("div", Dte, [
            c("img", {
              src: e.currentItem.thumbnail,
              alt: "",
              "data-testid": "current-image"
            }, null, 8, $te)
          ])) : (d(), L(s, {
            key: 1,
            id: e.currentItem.videoId,
            ref: "main-video-player",
            "element-id": `${n.componentId}-main-video-player`,
            "video-id": e.currentItem.videoId,
            "type-video": e.currentItem.type,
            url: e.currentItem.url,
            autoplay: !1,
            responsive: !0,
            class: "player",
            onEventToEmit: e.setIsPlaying
          }, null, 8, ["id", "element-id", "video-id", "type-video", "url", "onEventToEmit"]))
        ], !0)
      ], 32),
      e.isDesktop && e.videoItems.length > 1 ? (d(), f(J, { key: 0 }, [
        c("div", Ote, [
          c("button", {
            class: "prev",
            "aria-label": e.translations.left_arrow || "Previous Video",
            onClick: t[2] || (t[2] = (...l) => i.activatePrev && i.activatePrev(...l)),
            onKeyup: t[3] || (t[3] = K((...l) => i.activatePrev && i.activatePrev(...l), ["left"]))
          }, t[11] || (t[11] = [
            c("div", { class: "icon" }, null, -1)
          ]), 40, Pte),
          c("button", {
            class: "next",
            "aria-label": e.translations.right_arrow || "Next Video",
            onClick: t[4] || (t[4] = (...l) => i.activateNext && i.activateNext(...l)),
            onKeyup: t[5] || (t[5] = K((...l) => i.activateNext && i.activateNext(...l), ["right"]))
          }, t[12] || (t[12] = [
            c("div", { class: "icon" }, null, -1)
          ]), 40, Nte)
        ]),
        c("div", Hte, [
          c("div", Fte, [
            M(e.$slots, `video-item-${i.prevItem.position}`, {}, () => [
              c("div", Rte, [
                c("img", {
                  src: i.prevItem.thumbnail,
                  alt: "",
                  "data-testid": "previous-image"
                }, null, 8, Vte)
              ]),
              c("div", Bte, k(i.prevItem.title), 1)
            ], !0)
          ]),
          c("div", jte, [
            M(e.$slots, `video-item-${i.nextItem.position}`, {}, () => [
              c("div", Ute, [
                c("img", {
                  src: i.nextItem.thumbnail,
                  alt: "",
                  "data-testid": "next-image"
                }, null, 8, qte)
              ]),
              c("div", Gte, k(i.nextItem.title), 1)
            ], !0)
          ])
        ])
      ], 64)) : T("", !0)
    ]),
    c("div", Kte, [
      M(e.$slots, "main-video-alt-text", {
        index: e.currentItem.position
      }, void 0, !0),
      c("div", zte, [
        M(e.$slots, "main-video-title", {
          index: e.currentItem.position
        }, () => [
          H(k(e.currentItem.title), 1)
        ], !0)
      ]),
      c("div", {
        ref: "description",
        class: _(["description", { more: e.readMoreOpen }]),
        "data-testid": "description"
      }, [
        M(e.$slots, "main-video-description", {
          index: e.currentItem.position
        }, () => [
          H(k(e.currentItem.description), 1)
        ], !0)
      ], 2),
      i.isOverflow ? (d(), f("button", {
        key: 0,
        class: "read-more",
        onClick: t[6] || (t[6] = (...l) => i.readMoreToggle && i.readMoreToggle(...l))
      }, k(e.readMoreOpen ? "Read less" : "Read more"), 1)) : T("", !0)
    ]),
    e.videoItems.length > 1 ? (d(), f("div", Zte, [
      (d(!0), f(J, null, ne(e.videoItems, (l, u) => (d(), f("div", {
        id: "dot-item",
        key: l.id,
        class: _(["dot", e.activeItem == u ? "active" : ""]),
        onClick: (m) => i.activateItem(u)
      }, null, 10, xte))), 128))
    ])) : T("", !0),
    !e.isDesktop && e.videoItems.length > 1 ? (d(), f("div", Wte, [
      c("button", {
        class: "prev",
        "aria-label": e.translations.left_arrow || "Previous Video",
        onClick: t[7] || (t[7] = (...l) => i.activatePrev && i.activatePrev(...l)),
        onKeyup: t[8] || (t[8] = K((...l) => i.activatePrev && i.activatePrev(...l), ["left"]))
      }, t[13] || (t[13] = [
        c("div", { class: "icon" }, null, -1)
      ]), 40, Yte),
      c("button", {
        class: "next",
        "aria-label": e.translations.right_arrow || "Next Video",
        onClick: t[9] || (t[9] = (...l) => i.activateNext && i.activateNext(...l)),
        onKeyup: t[10] || (t[10] = K((...l) => i.activateNext && i.activateNext(...l), ["right"]))
      }, t[14] || (t[14] = [
        c("div", { class: "icon" }, null, -1)
      ]), 40, Xte)
    ])) : T("", !0)
  ], 6);
}
const Jte = /* @__PURE__ */ B(Mte, [["render", Qte], ["__scopeId", "data-v-860fbe66"]]), ene = {
  name: "V2",
  components: {
    VideoPlayer: L8
  },
  mixins: [dh],
  props: {
    componentId: {
      type: Number,
      default: 0
    }
  },
  methods: {
    activateItem(e) {
      this.activeItem = e, this.playPause(`${this.componentId}-main-video-player`, this.currentItem.type), this.$emit("setCurrentVideoThrillshare", e);
    }
  }
}, tne = ["data-testid"], nne = ["data-testid"], rne = { class: "wrapper" }, one = ["aria-label"], ine = { class: "video" }, sne = {
  key: 0,
  class: "thumbnail"
}, ane = ["src"], lne = { class: "video-info" }, une = {
  class: "title",
  "data-testid": "title"
}, dne = {
  ref: "description",
  class: "description",
  "data-testid": "description"
}, cne = {
  key: 1,
  class: "sidebar"
}, hne = ["id", "alert-label", "onClick", "onKeyup"], mne = { class: "video" }, fne = {
  class: "secondary-title",
  "data-testid": "title"
}, pne = { class: "thumbnail" }, gne = ["src"], vne = {
  key: 0,
  class: "info"
}, bne = { class: "title" }, yne = { class: "description" };
function _ne(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("VideoPlayer");
  return d(), f("div", {
    id: "video-component",
    class: _(e.theme.style),
    style: Z(e.colors),
    "data-testid": "V2"
  }, [
    e.content.show_headline ? (d(), L(a, {
      key: 0,
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        c("h2", {
          "data-testid": `header-${e.theme.style}`,
          class: "no-border"
        }, [
          e.displayTopHeader ? (d(), f("span", {
            key: 0,
            class: "header-top",
            "data-testid": `header-${e.theme.style}-top`
          }, [
            M(e.$slots, "header-top", {}, () => [
              H(k(e.content.component_header_top), 1)
            ], !0)
          ], 8, nne)) : T("", !0),
          M(e.$slots, "header", {}, () => [
            H(k(e.content.headline), 1)
          ], !0)
        ], 8, tne)
      ]),
      _: 3
    }, 8, ["class", "theme-options"])) : T("", !0),
    c("div", rne, [
      e.isDesktop || e.videoItems.length === 1 ? (d(), f("div", {
        key: 0,
        class: "main-video",
        tabindex: "0",
        "aria-label": `${e.translations.video_player || "Video player"}: ${e.currentItem.alt_text}`,
        role: "region"
      }, [
        c("div", ine, [
          M(e.$slots, "delete-btn", {
            index: e.currentItem.position
          }, void 0, !0),
          M(e.$slots, `video-item-${e.currentItem.position}`, {}, () => [
            e.isPlaceholder ? (d(), f("div", sne, [
              c("img", {
                src: e.currentItem.thumbnail,
                alt: "",
                "data-testid": "current-item"
              }, null, 8, ane)
            ])) : (d(), L(s, {
              key: 1,
              id: e.currentItem.videoId,
              ref: "main-video-player",
              class: "player",
              "element-id": `${n.componentId}-main-video-player`,
              "video-id": e.currentItem.videoId,
              "type-video": e.currentItem.type,
              url: e.currentItem.url,
              autoplay: !1,
              responsive: !0,
              onEventToEmit: e.setIsPlaying
            }, null, 8, ["id", "element-id", "video-id", "type-video", "url", "onEventToEmit"]))
          ], !0)
        ]),
        c("div", lne, [
          M(e.$slots, "main-video-alt-text", {
            altText: e.currentItem.alt_text,
            index: e.currentItem.position
          }, void 0, !0),
          c("div", une, [
            M(e.$slots, "main-video-title", {
              index: e.currentItem.position
            }, () => [
              H(k(e.currentItem.title), 1)
            ], !0)
          ]),
          c("div", dne, [
            M(e.$slots, "main-video-description", {
              index: e.currentItem.position
            }, () => [
              H(k(e.currentItem.description), 1)
            ], !0)
          ], 512)
        ])
      ], 8, one)) : T("", !0),
      e.videoItems.length > 1 ? (d(), f("div", cne, [
        (d(!0), f(J, null, ne(e.videoItems, (l, u) => (d(), f("div", {
          id: `sidebar-item-${u}`,
          key: l.id,
          tabindex: 0,
          role: "button",
          class: _(["sidebar-item", e.activeItem === u && "active"]),
          "alert-label": `${e.translations.display_video || "Display video"}: ${l.alt_text}`,
          onClick: (m) => i.activateItem(u),
          onKeyup: K((m) => i.activateItem(u), ["enter"]),
          "on:eventToEmit": t[0] || (t[0] = (...m) => e.setIsPlaying && e.setIsPlaying(...m))
        }, [
          c("div", mne, [
            M(e.$slots, "delete-btn", {
              index: l.position
            }, void 0, !0),
            M(e.$slots, `video-item-${l.position}`, {}, () => [
              c("div", {
                class: _(["video-mask", e.activeItem === u && !e.isDesktop && "hidden"])
              }, [
                c("div", {
                  class: _(["button", e.isPlaying && e.activeItem === u ? "pause" : "play"])
                }, null, 2),
                c("div", fne, k(l.title), 1),
                c("div", pne, [
                  c("img", {
                    src: l.thumbnail,
                    alt: ""
                  }, null, 8, gne)
                ])
              ], 2)
            ], !0),
            e.isDesktop ? T("", !0) : (d(), L(s, {
              key: 0,
              id: l.videoId,
              ref_for: !0,
              ref: `video-player-${u}`,
              class: "player",
              "video-id": l.videoId,
              "type-video": l.type,
              url: l.url,
              autoplay: !1,
              responsive: !0,
              "element-id": `${n.componentId}-video-player-${u}`,
              onEventToEmit: e.setIsPlaying
            }, null, 8, ["id", "video-id", "type-video", "url", "element-id", "onEventToEmit"]))
          ]),
          e.isDesktop ? T("", !0) : (d(), f("div", vne, [
            c("div", bne, k(l.title), 1),
            c("div", yne, k(l.description), 1)
          ]))
        ], 42, hne))), 128))
      ])) : T("", !0)
    ])
  ], 6);
}
const Cne = /* @__PURE__ */ B(ene, [["render", _ne], ["__scopeId", "data-v-4b61d270"]]), wne = {
  name: "CmsVideo",
  components: {
    V1: Jte,
    V2: Cne
  },
  mixins: [dh],
  data() {
    return {
      componentId: Math.floor(Math.random() * 1e5)
    };
  }
}, Tne = { id: "view-video" };
function kne(e, t, n, r, o, i) {
  return d(), f("div", Tne, [
    (d(), L(Y(e.theme.version), {
      theme: e.theme,
      content: e.content,
      "is-editing": e.isEditing,
      "component-id": o.componentId,
      "is-placeholder": e.isPlaceholder,
      "video-slots-items": e.videoSlotsItems,
      "current-video-thrillshare": e.currentVideoThrillshare,
      onSetCurrentVideoThrillshare: t[0] || (t[0] = (a) => e.$emit("setCurrentVideoThrillshare", a)),
      onDeleteVideo: t[1] || (t[1] = (a) => {
        e.$emit("deleteVideo", a);
      })
    }, ug({
      "header-top": S(() => [
        M(e.$slots, "header-top", {}, void 0, !0)
      ]),
      header: S(() => [
        M(e.$slots, "header", {}, void 0, !0)
      ]),
      "main-video-description": S(({ index: a }) => [
        M(e.$slots, "main-video-description", { index: a }, void 0, !0)
      ]),
      "main-video-title": S(({ index: a }) => [
        M(e.$slots, "main-video-title", { index: a }, void 0, !0)
      ]),
      "main-video-alt-text": S(({ index: a }) => [
        M(e.$slots, "main-video-alt-text", { index: a }, void 0, !0)
      ]),
      "delete-btn": S(({ index: a }) => [
        M(e.$slots, "delete-btn", { index: a }, void 0, !0)
      ]),
      "main-video-slot": S(({ index: a }) => [
        M(e.$slots, "main-video-slot", { index: a }, void 0, !0)
      ]),
      _: 2
    }, [
      ne(e.videoSlotsItems, (a) => ({
        name: a.name,
        fn: S(() => [
          M(e.$slots, a.name, {
            index: a.index
          }, void 0, !0)
        ])
      }))
    ]), 1064, ["theme", "content", "is-editing", "component-id", "is-placeholder", "video-slots-items", "current-video-thrillshare"]))
  ]);
}
const Ene = /* @__PURE__ */ B(wne, [["render", kne], ["__scopeId", "data-v-e4f3e80d"]]), Si = {
  mixins: [St],
  components: { DraggableWrapper: yt },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    spotlights: {
      type: Object,
      required: !0
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    },
    isEditing: Boolean
  },
  computed: {
    colors() {
      var t, n;
      const e = this.sharedThemeColors();
      return ge(ae({}, e), {
        "--bg-color": $(this.theme, "bg_color.hex", "#fff"),
        "--top-heading-color": $(this.theme, "top_heading_color.hex", "#000000"),
        "--quote-color": $(this.theme, "quote_color.hex", "#000"),
        "--name-color": $(this.theme, "name_color.hex", "#000"),
        "--arrow-icon-color": $(this.theme, "arrow_icon_color.hex", "initial"),
        "--arrow-background-color": $(this.theme, "arrow_background_color.hex", "initial"),
        "--arrow-background-opacity": `${(t = this.theme.arrow_background_opacity) != null ? t : "0"}%`,
        "--arrow-border-color": $(this.theme, "arrow_border_color.hex", "initial"),
        "--image-border-color": $(
          this.theme,
          "image_border_color.hex",
          this.theme.globalThemeSettings.secondaryColor
        ),
        "--textarea-border-color": $(this.theme, "textarea_border_color.hex", "#00000014"),
        "--textarea-border-accent-color": $(
          this.theme,
          "textarea_border_accent_color.hex",
          this.theme.globalThemeSettings.secondaryColor
        ),
        "--percentage-button-opacity": `${(n = this.theme.percentage_button_opacity) != null ? n : "0"}%`
      });
    },
    translations() {
      return this.theme.translations || {};
    },
    displayHeaderTop() {
      return this.theme.style === "monterrey" && (this.spotlights.component_header_top || this.isEditing);
    },
    isLightStyle() {
      return this.theme.style === "light";
    },
    isBoldStyle() {
      return this.theme.style === "bold";
    },
    isPurpleStyle() {
      return this.theme.style === "purple";
    },
    isMonterreyStyle() {
      return this.theme.style === "monterrey";
    },
    isMobile() {
      return this.screenSize < 600;
    },
    isDesktop() {
      return this.screenSize >= 960;
    }
  }
}, Sne = {
  props: {
    spotlight: {
      type: Object,
      required: !0
    },
    theme: {
      type: Object,
      required: !0
    },
    showName: {
      type: Boolean,
      default: !0
    },
    withSlider: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      sliderClass: this.withSlider ? "with-slider" : "no-slider"
    };
  }
}, Mne = ["src", "alt"], Ane = {
  key: 1,
  class: "no-image"
}, Ine = {
  class: "spotlight-text",
  "data-testid": "spotlight-text"
}, Lne = { key: 0 };
function Dne(e, t, n, r, o, i) {
  return d(), f("div", {
    class: _(o.sliderClass)
  }, [
    M(e.$slots, "controls"),
    c("div", {
      class: _(["spotlight-image rounded-image", o.sliderClass])
    }, [
      M(e.$slots, "image", {}, () => [
        n.spotlight.image.url ? (d(), f("img", {
          key: 0,
          src: n.spotlight.image.url,
          alt: n.spotlight.image.alt_text,
          class: "rounded-image",
          "data-testid": "spotlight-accent-border",
          loading: "lazy"
        }, null, 8, Mne)) : (d(), f("div", Ane))
      ])
    ], 2),
    c("div", Ine, [
      c("div", {
        class: _(["spotlight-quote", [n.theme.style, o.sliderClass]])
      }, [
        c("p", null, [
          M(e.$slots, "quote", {}, () => [
            H(k(n.spotlight.quote), 1)
          ])
        ])
      ], 2),
      n.showName ? (d(), f("div", {
        key: 0,
        class: _(["spotlight-author", o.sliderClass]),
        "data-testid": "spotlight-author-name"
      }, [
        c("p", null, [
          n.spotlight.quote.length > 0 && n.spotlight.author.length > 0 ? (d(), f("span", Lne, "- ")) : T("", !0),
          M(e.$slots, "author", {}, () => [
            H(k(n.spotlight.author), 1)
          ])
        ])
      ], 2)) : T("", !0)
    ])
  ], 2);
}
const $ne = /* @__PURE__ */ B(Sne, [["render", Dne], ["__scopeId", "data-v-8ecd974d"]]), One = {
  name: "SL1",
  components: { Slider: lh, SpotlightCard: $ne },
  mixins: [Si, _t],
  computed: {
    content() {
      return this.spotlights.content;
    },
    showSlider() {
      return this.spotlights.show_slider && !this.isEditing;
    },
    sliderCenterSize() {
      return 599;
    }
  }
}, Pne = { key: 0 }, Nne = ["data-testid"], Hne = { class: "cards-slider-container" }, Fne = ["aria-label"];
function Rne(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("SpotlightCard"), l = V("Slider"), u = ze("touch");
  return d(), f("div", {
    id: "SL1",
    class: _(e.theme.style),
    style: Z(e.colors)
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        e.displayHeaderTop ? (d(), f("h3", Pne, [
          M(e.$slots, "header-top", {}, () => [
            H(k(e.spotlights.component_header_top), 1)
          ], !0)
        ])) : T("", !0),
        c("h2", {
          class: "no-border",
          "data-testid": `header-${e.theme.style}-top`
        }, [
          M(e.$slots, "header", {}, () => [
            H(k(e.spotlights.component_header), 1)
          ], !0)
        ], 8, Nne)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    (d(), L(Y(i.showSlider ? "div" : e.wrapperComponent), Se({
      modelValue: e.spotlights.content,
      "onUpdate:modelValue": t[0] || (t[0] = (m) => e.spotlights.content = m)
    }, e.wrapperProps, {
      class: [{ editing: e.isEditing, "no-slider": !i.showSlider }, "spotlights-content"],
      "item-key": "id"
    }), ug({
      default: S(() => [
        i.showSlider ? (d(), L(l, {
          key: 0,
          "total-cards": i.content.length,
          "current-card": e.currentCard,
          "all-cards-visible": e.allCardsVisible,
          "section-header": e.spotlights.component_header,
          "hide-x-small": !1,
          "theme-styles": e.theme,
          class: "slider-container",
          "data-testid": "spotlight-slider",
          onScrollRight: e.scrollRight,
          onScrollLeft: e.scrollLeft
        }, {
          default: S(() => [
            c("div", {
              ref: "scrollWrapper",
              class: _([{ "all-cards-visible": e.allCardsVisible }, "cards-slider-content"]),
              "item-key": "index"
            }, [
              c("div", Hne, [
                (d(!0), f(J, null, ne(e.spotlights.content, (m, v) => we((d(), f("div", {
                  ref_for: !0,
                  ref: `sliderCard-${v}`,
                  key: v,
                  class: _(["spotlight with-slider", { "is-editing": e.isEditing }]),
                  "aria-label": `${v + 1} of ${e.spotlights.content.length}`,
                  role: "group",
                  "aria-roledescription": "slide",
                  "data-testid": "spotlights-content-item"
                }, [
                  j(s, {
                    theme: e.theme,
                    spotlight: m,
                    "show-name": e.spotlights.show_name,
                    "with-slider": !0
                  }, null, 8, ["theme", "spotlight", "show-name"])
                ], 10, Fne)), [
                  [
                    u,
                    e.scrollRight,
                    "swipe",
                    { left: !0 }
                  ],
                  [
                    u,
                    e.scrollLeft,
                    "swipe",
                    { right: !0 }
                  ]
                ])), 128))
              ])
            ], 2)
          ]),
          _: 1
        }, 8, ["total-cards", "current-card", "all-cards-visible", "section-header", "theme-styles", "onScrollRight", "onScrollLeft"])) : T("", !0)
      ]),
      _: 2
    }, [
      i.showSlider ? void 0 : {
        name: "item",
        fn: S(({ element: m, index: v }) => [
          j(s, {
            class: "spotlight no-slider",
            theme: e.theme,
            spotlight: m,
            "show-name": e.spotlights.show_name
          }, {
            controls: S(() => [
              M(e.$slots, "controls", { idx: v }, void 0, !0)
            ]),
            image: S(() => [
              M(e.$slots, "image", { idx: v }, void 0, !0)
            ]),
            quote: S(() => [
              M(e.$slots, "quote", { idx: v }, void 0, !0)
            ]),
            author: S(() => [
              M(e.$slots, "author", { idx: v }, void 0, !0)
            ]),
            _: 2
          }, 1032, ["theme", "spotlight", "show-name"])
        ]),
        key: "0"
      }
    ]), 1040, ["modelValue", "class"]))
  ], 6);
}
const Vne = /* @__PURE__ */ B(One, [["render", Rne], ["__scopeId", "data-v-73c2e755"]]), Bne = {
  name: "SL2",
  components: {
    CardSlider: mn
  },
  mixins: [Si, _t],
  computed: {
    content() {
      return this.spotlights.content;
    },
    sliderCenterSize() {
      return 599;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.setCardHeight();
    }), window.addEventListener("resize", this.setCardHeight);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.setCardHeight);
  },
  methods: {
    setCardHeight() {
      if (this.isEditing)
        return;
      this.content.forEach((t, n) => {
        this.$refs[`spotlightCard-${n}`].style.minHeight = "unset";
      });
      const e = Math.max(...this.content.map((t, n) => this.$refs[`spotlightCard-${n}`].clientHeight));
      this.content.forEach((t, n) => {
        this.$refs[`spotlightCard-${n}`].style.minHeight = e ? `${e - 64}px` : "unset";
      });
    }
  }
}, jne = ["data-testid"], Une = ["data-testid"], qne = ["aria-label"], Gne = ["src", "alt"], Kne = { class: "card-quote-text" }, zne = {
  key: 0,
  class: "card-author-text",
  "data-testid": "spotlight-author"
};
function Zne(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("CardSlider");
  return d(), f("div", {
    id: "SL2",
    "data-testid": "SL2",
    style: Z(e.colors),
    class: _([e.theme.style, e.isEditing && "editing"])
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        c("h2", {
          "data-testid": `header-${e.theme.style}-top`
        }, [
          e.displayHeaderTop ? (d(), f("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            M(e.$slots, "header-top", {}, () => [
              H(k(e.spotlights.component_header_top), 1)
            ], !0)
          ], 8, Une)) : T("", !0),
          M(e.$slots, "header", {}, () => [
            H(k(e.spotlights.component_header), 1)
          ], !0)
        ], 8, jne)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    j(s, {
      "nav-orientation": e.sliderCenterElements ? "bottom" : "top",
      "current-card": e.currentCard,
      "has-pager": !1,
      "pager-section-count": e.pagerSectionCount,
      "all-cards-visible": e.allCardsVisible,
      "total-cards": i.content.length,
      "theme-styles": e.theme,
      "section-header": e.spotlights.component_header,
      class: _([{ "show-accent-left": e.currentCard === 0, "buttons-top": !e.sliderCenterElements }, "spotlight-container"]),
      "pager-orientation": "left",
      onScrollRight: e.scrollRight,
      onScrollLeft: e.scrollLeft,
      onGoToSection: e.goToSection
    }, {
      default: S(() => [
        (d(), L(Y(e.wrapperComponent), Se({ ref: "scrollWrapper" }, e.wrapperProps, {
          modelValue: e.spotlights.content,
          "onUpdate:modelValue": t[0] || (t[0] = (l) => e.spotlights.content = l),
          class: [{ "all-cards-visible": e.allCardsVisible }, "spotlight-wrapper"],
          "item-key": "id"
        }), {
          item: S(({ element: l, index: u }) => [
            c("div", {
              ref: `sliderCard-${u}`,
              "aria-label": `${u + 1} of ${i.content.length}`,
              role: "group",
              "aria-roledescription": "slide",
              class: "spotlight"
            }, [
              M(e.$slots, "controls", { idx: u }, void 0, !0),
              M(e.$slots, "image", { idx: u }, () => [
                c("img", {
                  src: l.image.url,
                  alt: l.image.alt_text,
                  class: "spotlight-image",
                  loading: "lazy"
                }, null, 8, Gne)
              ], !0),
              c("div", {
                ref: `spotlightCard-${u}`,
                "data-testid": "spotlight-card",
                class: "spotlight-card"
              }, [
                c("div", Kne, [
                  M(e.$slots, "quote", { idx: u }, () => [
                    H(k(l.quote), 1)
                  ], !0)
                ]),
                e.spotlights.show_name ? (d(), f("div", zne, [
                  M(e.$slots, "author", { idx: u }, () => [
                    H(k(l.author), 1)
                  ], !0)
                ])) : T("", !0)
              ], 512)
            ], 8, qne)
          ]),
          _: 3
        }, 16, ["modelValue", "class"]))
      ]),
      _: 3
    }, 8, ["nav-orientation", "current-card", "pager-section-count", "all-cards-visible", "total-cards", "theme-styles", "section-header", "class", "onScrollRight", "onScrollLeft", "onGoToSection"])
  ], 6);
}
const xne = /* @__PURE__ */ B(Bne, [["render", Zne], ["__scopeId", "data-v-241d2edf"]]), Wne = {
  name: "SL3",
  components: {
    CardSlider: mn
  },
  mixins: [Si, _t],
  computed: {
    content() {
      return this.spotlights.content;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.setCardHeight();
    }), window.addEventListener("resize", this.setCardHeight);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.setCardHeight);
  },
  methods: {
    setCardHeight() {
      if (this.isEditing)
        return;
      this.content.forEach((t, n) => {
        this.$refs[`spotlightCard-${n}`].style.minHeight = "unset";
      });
      const e = Math.max(...this.content.map((t, n) => this.$refs[`spotlightCard-${n}`].clientHeight));
      this.content.forEach((t, n) => {
        this.$refs[`spotlightCard-${n}`].style.minHeight = e ? `${e - 64}px` : "unset";
      });
    }
  }
}, Yne = ["data-testid"], Xne = ["data-testid"], Qne = ["aria-label"], Jne = { class: "card-quote-text" }, ere = {
  key: 0,
  class: "card-author-text",
  "data-testid": "spotlight-author"
}, tre = ["src", "alt"];
function nre(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("CardSlider");
  return d(), f("div", {
    id: "SL3",
    "data-testid": "SL3",
    style: Z(e.colors),
    class: _([e.theme.style, { editing: e.isEditing }])
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        c("h2", {
          "data-testid": `header-${e.theme.style}-top`
        }, [
          e.displayHeaderTop ? (d(), f("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            M(e.$slots, "header-top", {}, () => [
              H(k(e.spotlights.component_header_top), 1)
            ], !0)
          ], 8, Xne)) : T("", !0),
          M(e.$slots, "header", {}, () => [
            H(k(e.spotlights.component_header), 1)
          ], !0)
        ], 8, Yne)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    j(s, {
      "nav-orientation": "bottom",
      "pager-orientation": "right",
      "current-card": e.currentCard,
      "pager-section-count": e.pagerSectionCount,
      "all-cards-visible": e.allCardsVisible,
      "total-cards": i.content.length,
      "theme-styles": e.theme,
      "section-header": e.spotlights.component_header,
      onScrollRight: e.scrollRight,
      onScrollLeft: e.scrollLeft,
      onGoToSection: e.goToSection
    }, {
      default: S(() => [
        (d(), L(Y(e.wrapperComponent), Se({ ref: "scrollWrapper" }, e.wrapperProps, {
          modelValue: e.spotlights.content,
          "onUpdate:modelValue": t[0] || (t[0] = (l) => e.spotlights.content = l),
          class: [{ "all-cards-visible": e.allCardsVisible }, "spotlight-wrapper"],
          "item-key": "id"
        }), {
          item: S(({ element: l, index: u }) => [
            c("div", {
              ref: `sliderCard-${u}`,
              "aria-label": `${u + 1} of ${i.content.length}`,
              role: "group",
              "aria-roledescription": "slide",
              class: "spotlight"
            }, [
              M(e.$slots, "controls", { idx: u }, void 0, !0),
              c("div", {
                ref: `spotlightCard-${u}`,
                "data-testid": "spotlight-card",
                class: "spotlight-card"
              }, [
                c("div", Jne, [
                  M(e.$slots, "quote", { idx: u }, () => [
                    H(k(l.quote), 1)
                  ], !0)
                ]),
                e.spotlights.show_name ? (d(), f("div", ere, [
                  M(e.$slots, "author", { idx: u }, () => [
                    H(k(l.author), 1)
                  ], !0)
                ])) : T("", !0)
              ], 512),
              M(e.$slots, "image", { idx: u }, () => [
                c("img", {
                  src: l.image.url,
                  alt: l.image.alt_text,
                  class: "spotlight-image",
                  loading: "lazy"
                }, null, 8, tre)
              ], !0)
            ], 8, Qne)
          ]),
          _: 3
        }, 16, ["modelValue", "class"]))
      ]),
      _: 3
    }, 8, ["current-card", "pager-section-count", "all-cards-visible", "total-cards", "theme-styles", "section-header", "onScrollRight", "onScrollLeft", "onGoToSection"])
  ], 6);
}
const rre = /* @__PURE__ */ B(Wne, [["render", nre], ["__scopeId", "data-v-0c9ba3f8"]]), ore = {
  name: "IconButton",
  props: {
    iconColor: {
      type: String,
      default: "#fff"
    },
    backgroundColor: {
      type: String,
      default: "#000"
    },
    borderColor: {
      type: String,
      default: "#fff"
    },
    opacity: {
      type: String,
      default: "100"
    },
    width: {
      type: String,
      default: "60"
    },
    height: {
      type: String,
      default: "60"
    },
    mirror: {
      type: Boolean,
      default: !1
    },
    onClick: {
      type: Function,
      default: () => {
      }
    }
  },
  computed: {
    cssVars() {
      return {
        "--icon-color": this.iconColor,
        "--bg-color": this.backgroundColor,
        "--border-color": this.borderColor,
        "--opacity": `${this.opacity}%`,
        "--width": `${this.width}px`,
        "--height": `${this.height}px`
      };
    }
  }
};
function ire(e, t, n, r, o, i) {
  return d(), f("button", {
    class: "icon-button",
    style: Z(i.cssVars),
    onClick: t[0] || (t[0] = (a) => e.$emit("on-click"))
  }, [
    c("div", {
      class: _(["icon-wrapper", { mirror: n.mirror }])
    }, [
      M(e.$slots, "icon", {}, void 0, !0)
    ], 2)
  ], 4);
}
const sre = /* @__PURE__ */ B(ore, [["render", ire], ["__scopeId", "data-v-c77efb17"]]), are = {
  name: "SL4",
  components: { IconButton: sre },
  mixins: [Si],
  data() {
    return {
      activeItem: 0,
      autoplayInterval: null,
      autoPlay: !0,
      isOverflow: !1
    };
  },
  computed: {
    content() {
      var e;
      return (e = this.spotlights.content) != null ? e : [];
    },
    currentItem() {
      return this.content.length > 0 ? this.content[this.activeItem] : {
        id: 0,
        author_id: 0,
        quote: "",
        author: "",
        role: "",
        image: { url: "", alt_text: "" },
        link: { name: "", href: "", target: "" }
      };
    },
    borderColor() {
      return ue(this.colors["--bg-color"]).isLight() ? "#000000" : "#FFFFFF";
    },
    cssVars() {
      return ge(ae({}, this.colors), {
        "--image-border-color": this.borderColor
      });
    }
  },
  mounted() {
    this.isEditing || (this.$nextTick(() => {
      this.checkOverflow();
    }), window.addEventListener("resize", this.checkOverflow), this.startAutoplay());
  },
  beforeUnmount() {
    clearInterval(this.autoplayInterval), window.removeEventListener("resize", this.checkOverflow);
  },
  methods: {
    itemSelect(e) {
      this.activeItem = e, !this.isEditing && this.autoPlay && this.restartAutoplay();
    },
    previousItem() {
      this.itemSelect((this.activeItem - 1 + this.content.length) % this.content.length);
    },
    nextItem() {
      this.itemSelect((this.activeItem + 1) % this.content.length);
    },
    startAutoplay() {
      this.autoplayInterval = setInterval(this.nextItem, 8e3);
    },
    stopAutoplay() {
      clearInterval(this.autoplayInterval);
    },
    restartAutoplay() {
      this.stopAutoplay(), this.startAutoplay();
    },
    toggleAutoplay() {
      this.isEditing || (this.autoPlay = !this.autoPlay, this.autoPlay ? this.startAutoplay() : this.stopAutoplay());
    },
    checkOverflow() {
      this.isOverflow = this.isMobile ? !1 : this.$refs.thumbnails && this.$refs.thumbnails.scrollHeight > this.$refs.thumbnails.clientHeight;
    }
  }
}, lre = { class: "spotlight-wrapper" }, ure = ["data-testid"], dre = ["data-testid"], cre = { class: "col-1" }, hre = { class: "spotlight-quote-container" }, mre = { class: "col-2" }, fre = {
  key: 0,
  class: "author-role-container"
}, pre = { class: "gallery-container" }, gre = { class: "gallery-track" }, vre = ["fill"], bre = {
  key: 1,
  width: "56",
  height: "12",
  viewBox: "0 0 6 12",
  xmlns: "http://www.w3.org/2000/svg"
}, yre = ["fill"], _re = {
  width: "22",
  height: "12",
  viewBox: "0 0 22 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Cre = ["stroke"], wre = ["onClick"], Tre = {
  key: 0,
  class: "author-role-container"
}, kre = {
  width: "22",
  height: "12",
  viewBox: "0 0 22 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, Ere = ["stroke"], Sre = { class: "main-image" };
function Mre(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("IconButton");
  return d(), f("div", {
    class: _(["spotlight-v4", [e.theme.style, { editing: e.isEditing }]]),
    "data-testid": "SL4",
    style: Z(i.cssVars)
  }, [
    c("div", lre, [
      j(a, {
        "theme-options": e.theme,
        class: _(["see-all-top", e.theme.style])
      }, {
        header: S(() => [
          c("h2", {
            "data-testid": `header-${e.theme.style}-top`
          }, [
            e.isMonterreyStyle ? (d(), f("span", {
              key: 0,
              "data-testid": `header-${e.theme.style}-top`,
              class: "header-top"
            }, [
              M(e.$slots, "header-top", {}, () => [
                H(k(e.spotlights.component_header_top), 1)
              ], !0)
            ], 8, dre)) : T("", !0),
            M(e.$slots, "header", {}, () => [
              H(k(e.spotlights.component_header), 1)
            ], !0)
          ], 8, ure)
        ]),
        default: S(() => {
          var l, u;
          return [
            e.isBoldStyle && !e.isMobile ? (d(), L(Y(e.isEditing ? "button" : "a"), {
              key: 0,
              class: _(["see-all-button", e.theme.style]),
              href: (l = i.currentItem.link) == null ? void 0 : l.href,
              target: (u = i.currentItem.link) == null ? void 0 : u.target
            }, {
              default: S(() => [
                H(k(i.currentItem.link.name) + " ", 1),
                M(e.$slots, "link", { idx: o.activeItem }, void 0, !0)
              ]),
              _: 3
            }, 8, ["class", "href", "target"])) : T("", !0)
          ];
        }),
        _: 3
      }, 8, ["theme-options", "class"]),
      c("div", cre, [
        c("div", hre, [
          (d(!0), f(J, null, ne(i.content, (l, u) => (d(), f("div", {
            key: u,
            class: _(["spotlight-quote-text", e.theme.style, { active: u === o.activeItem }])
          }, [
            M(e.$slots, "quote", { idx: o.activeItem }, () => [
              H(k(l.quote), 1)
            ], !0)
          ], 2))), 128))
        ]),
        e.isBoldStyle || e.isLightStyle && !e.isDesktop ? T("", !0) : (d(), L(a, {
          key: 0,
          class: _(e.theme.style),
          "theme-options": e.theme
        }, {
          default: S(() => {
            var l, u;
            return [
              (d(), L(Y(e.isEditing ? "button" : "a"), {
                class: _(["see-all-button", e.theme.style]),
                href: (l = i.currentItem.link) == null ? void 0 : l.href,
                target: (u = i.currentItem.link) == null ? void 0 : u.target
              }, {
                default: S(() => {
                  var m;
                  return [
                    H(k((m = i.currentItem.link) == null ? void 0 : m.name) + " ", 1),
                    M(e.$slots, "link", { idx: o.activeItem }, void 0, !0)
                  ];
                }),
                _: 3
              }, 8, ["class", "href", "target"]))
            ];
          }),
          _: 3
        }, 8, ["class", "theme-options"]))
      ]),
      c("div", mre, [
        e.isMobile ? (d(), f("div", fre, [
          (d(!0), f(J, null, ne(i.content, (l, u) => (d(), f("div", {
            key: u,
            class: _(["author-role-text", { active: u === o.activeItem }])
          }, [
            c("div", {
              class: _(["spotlight-author-text", e.theme.style])
            }, [
              M(e.$slots, "author", { idx: o.activeItem }, () => [
                H(k(l.author), 1)
              ], !0)
            ], 2),
            c("div", {
              class: _(["spotlight-role-text", e.theme.style])
            }, [
              M(e.$slots, "role", { idx: o.activeItem }, () => [
                H(k(l.role), 1)
              ], !0)
            ], 2)
          ], 2))), 128))
        ])) : T("", !0),
        c("div", pre, [
          c("div", gre, [
            e.isEditing ? T("", !0) : (d(), L(s, {
              key: 0,
              class: "play-button",
              "background-color": e.theme.arrow_background_color.hex,
              opacity: e.theme.arrow_background_opacity,
              "border-color": e.theme.arrow_border_color.hex,
              onOnClick: i.toggleAutoplay
            }, {
              icon: S(() => [
                o.autoPlay ? (d(), f("svg", {
                  key: 0,
                  width: "56",
                  height: "56",
                  viewBox: "0 0 56 56",
                  fill: e.theme.arrow_icon_color.hex,
                  xmlns: "http://www.w3.org/2000/svg"
                }, t[0] || (t[0] = [
                  c("rect", {
                    x: "21",
                    y: "15",
                    width: "5",
                    height: "24"
                  }, null, -1),
                  c("rect", {
                    x: "30",
                    y: "15",
                    width: "5",
                    height: "24"
                  }, null, -1)
                ]), 8, vre)) : (d(), f("svg", bre, [
                  c("path", {
                    d: "M0 12L6 6L0 0V12Z",
                    fill: e.theme.arrow_icon_color.hex
                  }, null, 8, yre)
                ]))
              ]),
              _: 1
            }, 8, ["background-color", "opacity", "border-color", "onOnClick"])),
            o.isOverflow ? (d(), L(s, {
              key: 1,
              class: "back-button",
              "background-color": e.theme.arrow_background_color.hex,
              opacity: e.theme.arrow_background_opacity,
              "border-color": e.theme.arrow_border_color.hex,
              onOnClick: i.previousItem
            }, {
              icon: S(() => [
                (d(), f("svg", _re, [
                  c("path", {
                    d: "M2 9.85742L10.3279 2.29789C10.7091 1.95181 11.2909 1.95181 11.6721 2.29789L20 9.85742",
                    stroke: e.theme.arrow_icon_color.hex,
                    "stroke-width": "3",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, null, 8, Cre)
                ]))
              ]),
              _: 1
            }, 8, ["background-color", "opacity", "border-color", "onOnClick"])) : T("", !0),
            c("div", {
              ref: "thumbnails",
              class: _(["thumbnails-container", { "is-overflow": o.isOverflow }])
            }, [
              (d(!0), f(J, null, ne(i.content, (l, u) => (d(), f("div", {
                key: u,
                class: _([{ active: u === o.activeItem }, "thumbnail"]),
                onClick: (m) => i.itemSelect(u)
              }, [
                e.isMobile ? T("", !0) : (d(), f("div", Tre, [
                  c("div", {
                    class: _(["spotlight-author-text", e.theme.style])
                  }, [
                    M(e.$slots, "author", { idx: u }, () => [
                      H(k(l.author), 1)
                    ], !0)
                  ], 2),
                  c("div", {
                    class: _(["spotlight-author-text", e.theme.style])
                  }, [
                    M(e.$slots, "role", { idx: u }, () => [
                      H(k(l.role), 1)
                    ], !0)
                  ], 2)
                ])),
                (d(), L(Y(l.image.url ? "img" : "div"), {
                  draggable: "false",
                  src: l.image.url,
                  alt: l.image.alt_text,
                  class: "mini-image"
                }, null, 8, ["src", "alt"]))
              ], 10, wre))), 128))
            ], 2),
            o.isOverflow ? (d(), L(s, {
              key: 2,
              class: "next-button",
              mirror: "",
              "background-color": e.theme.arrow_background_color.hex,
              opacity: e.theme.arrow_background_opacity,
              "border-color": e.theme.arrow_border_color.hex,
              onOnClick: i.nextItem
            }, {
              icon: S(() => [
                (d(), f("svg", kre, [
                  c("path", {
                    d: "M2 9.85742L10.3279 2.29789C10.7091 1.95181 11.2909 1.95181 11.6721 2.29789L20 9.85742",
                    stroke: e.theme.arrow_icon_color.hex,
                    "stroke-width": "3",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, null, 8, Ere)
                ]))
              ]),
              _: 1
            }, 8, ["background-color", "opacity", "border-color", "onOnClick"])) : T("", !0)
          ]),
          c("div", Sre, [
            (d(!0), f(J, null, ne(i.content, (l, u) => (d(), L(Y(l.image.url ? "img" : "div"), {
              key: u,
              draggable: "false",
              src: i.currentItem.image.url,
              alt: i.currentItem.image.alt_text,
              class: _(["active-image", { active: u === o.activeItem }])
            }, null, 8, ["src", "alt", "class"]))), 128)),
            M(e.$slots, "image", { idx: o.activeItem }, void 0, !0)
          ])
        ])
      ]),
      e.isBoldStyle && e.isMobile || e.isLightStyle && !e.isDesktop ? (d(), L(a, {
        key: 0,
        class: _([e.theme.style, "see-all-bottom"]),
        "theme-options": e.theme
      }, {
        default: S(() => {
          var l, u;
          return [
            (d(), L(Y(e.isEditing ? "button" : "a"), {
              class: _(["see-all-button", e.theme.style]),
              href: (l = i.currentItem.link) == null ? void 0 : l.href,
              target: (u = i.currentItem.link) == null ? void 0 : u.target
            }, {
              default: S(() => {
                var m;
                return [
                  H(k((m = i.currentItem.link) == null ? void 0 : m.name) + " ", 1),
                  M(e.$slots, "link", { idx: e.idx }, void 0, !0)
                ];
              }),
              _: 3
            }, 8, ["class", "href", "target"]))
          ];
        }),
        _: 3
      }, 8, ["class", "theme-options"])) : T("", !0)
    ])
  ], 6);
}
const Are = /* @__PURE__ */ B(are, [["render", Mre], ["__scopeId", "data-v-84435ad0"]]), Ire = {
  name: "SL5",
  components: {
    CardSlider: mn
  },
  mixins: [Si, _t],
  data() {
    return {
      activeTabIdx: 0,
      defaultNestedContent: [
        {
          cards: [],
          icon: "",
          label: "",
          show_image_icons: !0,
          show_headline: !0,
          show_snippet: !0
        }
      ]
    };
  },
  computed: {
    nestedContent() {
      var e, t;
      return (t = (e = this.spotlights) == null ? void 0 : e.nested_content) != null ? t : this.defaultNestedContent;
    },
    activeTabData() {
      return this.nestedContent[this.activeTabIdx];
    },
    content() {
      return this.activeTabData.cards;
    },
    cssVars() {
      return ge(ae({}, this.colors), {
        "--button-bg-color": $(this.theme, "button_bg_color.hex", "#5D5FEF"),
        "--button-border-color": $(this.theme, "button_border_color.hex", "#8f91ff"),
        "--button-icon-color": $(this.theme, "button_icon_color.hex", "#8f91ff"),
        "--button-text-color": $(this.theme, "button_text_color.hex", "#8f91ff"),
        "--button-active-bg-color": $(this.theme, "button_active_bg_color.hex", "#5D5FEF"),
        "--button-active-border-color": $(this.theme, "button_active_border_color.hex", "#fff"),
        "--button-active-icon-color": $(this.theme, "button_active_icon_color.hex", "#fff"),
        "--button-active-text-color": $(this.theme, "button_active_text_color.hex", "#fff"),
        "--image-gradient-color": $(this.theme, "image_gradient_color.hex", "#000000"),
        "--quote-icon-color": $(this.theme, "quote_icon_color.hex", "#fff"),
        "--role-color": $(this.theme, "role_color.hex", "#000"),
        "--line-color": $(this.theme, "line_color.hex", "#8f91ff")
      });
    }
  },
  methods: {
    tabActivate(e) {
      this.activeTabIdx = e, this.$emit("update:selectedIdx", this.activeTabIdx);
    }
  }
}, Lre = { class: "spotlight-wrapper" }, Dre = ["data-testid"], $re = ["data-testid"], Ore = ["onClick"], Pre = {
  key: 0,
  class: "icon-wrapper"
}, Nre = ["innerHTML"], Hre = ["aria-label"], Fre = { class: "top" }, Rre = {
  key: 0,
  class: "mask"
}, Vre = ["src", "alt"], Bre = {
  key: 2,
  class: "no-image"
}, jre = { class: "content" }, Ure = {
  key: 0,
  class: "icon-wrapper"
}, qre = ["innerHTML"], Gre = {
  key: 1,
  class: "snippet"
}, Kre = { class: "bottom" }, zre = {
  key: 0,
  "data-testid": "spotlight-card",
  class: "name-role-wrapper"
}, Zre = { class: "role" }, xre = ["aria-label"], Wre = ["aria-label"];
function Yre(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("CardSlider");
  return d(), f("div", {
    class: _(["spotlight-v5", [e.theme.style, { editing: e.isEditing }]]),
    "data-testid": "SL5",
    style: Z(i.cssVars)
  }, [
    c("div", Lre, [
      j(a, {
        class: _([e.theme.style, "see-all-top"]),
        "theme-options": e.theme
      }, {
        header: S(() => [
          c("h2", {
            "data-testid": `header-${e.theme.style}-top`
          }, [
            e.displayHeaderTop ? (d(), f("span", {
              key: 0,
              "data-testid": `header-${e.theme.style}-top`,
              class: "header-top"
            }, [
              M(e.$slots, "header-top", {}, () => [
                H(k(e.spotlights.component_header_top), 1)
              ], !0)
            ], 8, $re)) : T("", !0),
            M(e.$slots, "header", {}, () => [
              H(k(e.spotlights.component_header), 1)
            ], !0)
          ], 8, Dre)
        ]),
        _: 3
      }, 8, ["class", "theme-options"]),
      (d(), L(Y(e.wrapperComponent), Se(e.wrapperProps, {
        modelValue: e.spotlights.nested_content,
        "onUpdate:modelValue": t[0] || (t[0] = (l) => e.spotlights.nested_content = l),
        "item-key": "id",
        class: ["spotlight-tabs", { editing: e.isEditing }]
      }), {
        item: S(({ element: l, index: u }) => [
          c("button", {
            class: _(["tab-button", { active: u === o.activeTabIdx }]),
            onClick: (m) => i.tabActivate(u)
          }, [
            M(e.$slots, "controls", { idx: u }, void 0, !0),
            e.spotlights.show_icons ? (d(), f("div", Pre, [
              M(e.$slots, "tab-icon", { idx: u }, () => [
                c("span", {
                  class: "icon",
                  innerHTML: l.icon
                }, null, 8, Nre)
              ], !0)
            ])) : T("", !0),
            e.spotlights.show_tab_labels ? (d(), f("div", {
              key: 1,
              class: _(["label", [e.theme.style]])
            }, [
              M(e.$slots, "label", { idx: u }, () => [
                H(k(l.label), 1)
              ], !0)
            ], 2)) : T("", !0)
          ], 10, Ore)
        ]),
        _: 3
      }, 16, ["modelValue", "class"])),
      i.activeTabData && i.activeTabData.cards && i.activeTabData.cards.length ? (d(), L(s, {
        key: 0,
        "nav-orientation": "bottom",
        "pager-orientation": "right",
        "current-card": e.currentCard,
        "pager-section-count": e.pagerSectionCount,
        "total-cards": i.activeTabData.cards.length,
        "section-header": e.spotlights.component_header,
        "has-pager": !1,
        "theme-styles": e.theme,
        onScrollRight: e.scrollRight,
        onScrollLeft: e.scrollLeft,
        onGoToSection: e.goToSection
      }, {
        "button-left": S(() => [
          c("button", {
            class: "slider-button left",
            "aria-label": e.translations.previous_item || "Previous Item",
            onKeyup: t[2] || (t[2] = K((...l) => e.scrollLeft && e.scrollLeft(...l), ["left"])),
            onClick: t[3] || (t[3] = (...l) => e.scrollLeft && e.scrollLeft(...l))
          }, t[6] || (t[6] = [
            c("svg", null, [
              c("path", { d: "M0.646446 3.64645C0.451185 3.84171 0.451185 4.15829 0.646446 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976311 4.7308 0.659728 4.53553 0.464466C4.34027 0.269204 4.02369 0.269204 3.82843 0.464466L0.646446 3.64645ZM30 3.5L1 3.5V4.5L30 4.5V3.5Z" })
            ], -1)
          ]), 40, xre)
        ]),
        "button-right": S(() => [
          c("button", {
            class: "slider-button right",
            "aria-label": e.translations.next_item || "Next Item",
            onKeyup: t[4] || (t[4] = K((...l) => e.scrollRight && e.scrollRight(...l), ["right"])),
            onClick: t[5] || (t[5] = (...l) => e.scrollRight && e.scrollRight(...l))
          }, t[7] || (t[7] = [
            c("svg", null, [
              c("path", { d: "M0.646446 3.64645C0.451185 3.84171 0.451185 4.15829 0.646446 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.7308 7.34027 4.7308 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.7308 0.976311 4.7308 0.659728 4.53553 0.464466C4.34027 0.269204 4.02369 0.269204 3.82843 0.464466L0.646446 3.64645ZM30 3.5L1 3.5V4.5L30 4.5V3.5Z" })
            ], -1)
          ]), 40, Wre)
        ]),
        default: S(() => [
          (d(), L(Y(e.wrapperComponent), Se({ ref: "scrollWrapper" }, e.wrapperProps, {
            modelValue: i.activeTabData.cards,
            "onUpdate:modelValue": t[1] || (t[1] = (l) => i.activeTabData.cards = l),
            "item-key": "id",
            class: "cards-wrapper"
          }), {
            item: S(({ element: l, index: u }) => [
              c("div", {
                ref: `sliderCard-${u}`,
                "aria-label": `${u + 1} of ${i.activeTabData.cards.length}`,
                role: "group",
                "aria-roledescription": "slide",
                class: _(["card", { editing: e.isEditing }])
              }, [
                c("div", Fre, [
                  M(e.$slots, "tab-controls", {
                    idx: u,
                    tabIdx: o.activeTabIdx
                  }, void 0, !0),
                  l.image.url ? (d(), f("div", Rre)) : T("", !0),
                  l.image.url ? (d(), f("img", {
                    key: 1,
                    src: l.image.url,
                    alt: l.image.alt_text,
                    class: "image",
                    draggable: "false",
                    loading: "lazy"
                  }, null, 8, Vre)) : T("", !0),
                  !l.image.url && e.isEditing ? (d(), f("div", Bre)) : T("", !0),
                  c("div", jre, [
                    i.activeTabData.show_image_icons ? (d(), f("div", Ure, [
                      M(e.$slots, "icon", {
                        idx: u,
                        tabIdx: o.activeTabIdx
                      }, () => [
                        c("span", {
                          class: "icon",
                          innerHTML: l.icon
                        }, null, 8, qre)
                      ], !0)
                    ])) : T("", !0),
                    i.activeTabData.show_snippet ? (d(), f("p", Gre, [
                      M(e.$slots, "snippet", {
                        idx: u,
                        tabIdx: o.activeTabIdx
                      }, () => [
                        H(k(l.snippet), 1)
                      ], !0)
                    ])) : T("", !0)
                  ])
                ]),
                c("div", Kre, [
                  i.activeTabData.show_headline ? (d(), f("div", zre, [
                    c("div", {
                      class: _(["name", [e.theme.style]]),
                      "data-testid": "spotlight-name"
                    }, [
                      M(e.$slots, "author", {
                        idx: u,
                        tabIdx: o.activeTabIdx
                      }, () => [
                        H(k(l.name), 1)
                      ], !0)
                    ], 2),
                    c("div", Zre, [
                      M(e.$slots, "role", {
                        idx: u,
                        tabIdx: o.activeTabIdx
                      }, () => [
                        H(k(l.role), 1)
                      ], !0)
                    ])
                  ])) : T("", !0)
                ])
              ], 10, Hre)
            ]),
            _: 3
          }, 16, ["modelValue"]))
        ]),
        _: 3
      }, 8, ["current-card", "pager-section-count", "total-cards", "section-header", "theme-styles", "onScrollRight", "onScrollLeft", "onGoToSection"])) : T("", !0)
    ])
  ], 6);
}
const Xre = /* @__PURE__ */ B(Ire, [["render", Yre], ["__scopeId", "data-v-a3f88a2f"]]), Qre = {
  name: "Spotlight",
  components: {
    SL1: Vne,
    SL2: xne,
    SL3: rre,
    SL4: Are,
    SL5: Xre
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      default: () => ({})
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    },
    isEditing: Boolean
  },
  methods: {
    handleSelectedIdx(e) {
      this.$emit("update:selectedIdx", e);
    }
  }
}, Jre = { id: "view-spotlight" };
function eoe(e, t, n, r, o, i) {
  return d(), f("div", Jre, [
    (d(), L(Y(n.theme.version), {
      theme: n.theme,
      spotlights: n.content,
      "wrapper-component": n.wrapperComponent,
      "wrapper-props": n.wrapperProps,
      "is-editing": n.isEditing,
      "onUpdate:selectedIdx": i.handleSelectedIdx
    }, {
      "header-top": S(() => [
        M(e.$slots, "header-top", {}, void 0, !0)
      ]),
      header: S(() => [
        M(e.$slots, "header", {}, void 0, !0)
      ]),
      controls: S(({ idx: a }) => [
        M(e.$slots, "controls", { idx: a }, void 0, !0)
      ]),
      "tab-controls": S(({ idx: a, tabIdx: s }) => [
        M(e.$slots, "tab-controls", {
          idx: a,
          tabIdx: s
        }, void 0, !0)
      ]),
      image: S(({ idx: a }) => [
        M(e.$slots, "image", { idx: a }, void 0, !0)
      ]),
      title: S(({ title: a, idx: s }) => [
        M(e.$slots, "title", {
          title: a,
          idx: s
        }, void 0, !0)
      ]),
      quote: S(({ quote: a, idx: s }) => [
        M(e.$slots, "quote", {
          quote: a,
          idx: s
        }, void 0, !0)
      ]),
      author: S(({ author: a, idx: s, tabIdx: l }) => [
        M(e.$slots, "author", {
          author: a,
          idx: s,
          tabIdx: l
        }, void 0, !0)
      ]),
      role: S(({ role: a, idx: s, tabIdx: l }) => [
        M(e.$slots, "role", {
          role: a,
          idx: s,
          tabIdx: l
        }, void 0, !0)
      ]),
      icon: S(({ idx: a, tabIdx: s }) => [
        M(e.$slots, "icon", {
          idx: a,
          tabIdx: s
        }, void 0, !0)
      ]),
      "tab-icon": S(({ idx: a }) => [
        M(e.$slots, "tab-icon", { idx: a }, void 0, !0)
      ]),
      label: S(({ label: a, idx: s }) => [
        M(e.$slots, "label", {
          label: a,
          idx: s
        }, void 0, !0)
      ]),
      snippet: S(({ idx: a, tabIdx: s }) => [
        M(e.$slots, "snippet", {
          idx: a,
          tabIdx: s
        }, void 0, !0)
      ]),
      link: S(({ idx: a }) => [
        M(e.$slots, "link", { idx: a }, void 0, !0)
      ]),
      _: 3
    }, 40, ["theme", "spotlights", "wrapper-component", "wrapper-props", "is-editing", "onUpdate:selectedIdx"]))
  ]);
}
const toe = /* @__PURE__ */ B(Qre, [["render", eoe], ["__scopeId", "data-v-f0dee26f"]]), noe = {
  mixins: [St],
  props: {
    options: {
      type: Object,
      default: () => ({})
    },
    athletics: {
      type: Array,
      required: !0
    },
    isPreview: {
      type: Boolean,
      default: !1
    },
    athleticsConfig: {
      type: Object,
      default: () => ({})
    },
    componentId: {
      type: String,
      default: null
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    pathPrefix: {
      type: String,
      default: ""
    }
  },
  computed: {
    theme() {
      return this.options;
    },
    colors() {
      const e = this.sharedThemeColors(), t = $(this.theme, "athletic_bg_color.hex", "none"), n = $(this.theme, "athletic_title_color.hex", "initial");
      return ge(ae({}, e), {
        "--athletic-bg-color": t,
        "--athletic-title-color": n,
        "--date-color": $(this.theme, "date_color.hex", "initial"),
        "--time-color": $(this.theme, "time_color.hex", "initial"),
        "--athletic-separator-color": $(this.theme, "athletic_separator_color.hex", "#000"),
        "--athletic-card-border": $(
          this.theme,
          "athletic_card_border.hex",
          this.theme.globalThemeSettings.secondaryColor
        ),
        "--vs-tag-bg-color": $(this.theme, "vs_tag_bg.hex", t),
        "--vs-tag-text-color": $(this.theme, "vs_tag_color.hex", n)
      });
    },
    translations() {
      return this.options.translations;
    },
    isMonterreyStyle() {
      return this.options.style === "monterrey";
    },
    seeAllLinkHref() {
      var e, t;
      return ((t = (e = this.athleticsConfig[this.componentId]) == null ? void 0 : e.see_all_link) == null ? void 0 : t.href) || this.link("athletics");
    },
    seeAllLinkName() {
      var e, t;
      return ((t = (e = this.athleticsConfig[this.componentId]) == null ? void 0 : e.see_all_link) == null ? void 0 : t.name) || this.translations.see_all;
    },
    seeAllLinkTarget() {
      var e, t;
      return ((t = (e = this.athleticsConfig[this.componentId]) == null ? void 0 : e.see_all_link) == null ? void 0 : t.target) || "_self";
    },
    sectionHeader() {
      var e;
      return ((e = this.athleticsConfig[this.componentId]) == null ? void 0 : e.component_header) || this.translations.title;
    },
    sectionHeaderTop() {
      var e, t;
      return (t = (e = this.athleticsConfig[this.componentId]) == null ? void 0 : e.component_header_top) != null ? t : this.translations.latest;
    }
  }
}, roe = {
  name: "A1",
  mixins: [noe]
}, ooe = ["data-testid"], ioe = { class: "athletics-match" }, soe = {
  key: 0,
  "data-testid": "versus"
}, aoe = {
  key: 1,
  "data-testid": "non-versus"
};
function loe(e, t, n, r, o, i) {
  const a = V("SeeAllContainer");
  return d(), f("div", {
    id: "athletics-a1",
    style: Z(e.colors),
    "data-testid": "a1",
    class: _(e.theme.style)
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        e.isMonterreyStyle ? (d(), f("h3", {
          key: 0,
          "data-testid": `header-${e.theme.style}-top`
        }, [
          M(e.$slots, "header-top", {}, () => [
            H(k(e.sectionHeaderTop), 1)
          ], !0)
        ], 8, ooe)) : T("", !0),
        (d(), L(Y(e.isMonterreyStyle ? "h1" : "h2"), {
          "data-testid": `header-${e.theme.style}-top`
        }, {
          default: S(() => [
            M(e.$slots, "header", {}, () => [
              H(k(e.sectionHeader), 1)
            ], !0)
          ]),
          _: 3
        }, 8, ["data-testid"]))
      ]),
      default: S(() => [
        e.options.style !== "purple" && e.screenSize > 600 ? (d(), L(Y(e.isEditing ? "button" : "a"), {
          key: 0,
          class: _(["hide-on-xs see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-top`,
          onClick: t[0] || (t[0] = (s) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"])) : T("", !0)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    c("div", {
      class: _(["athletics-info", { "is-editing": e.isEditing }])
    }, [
      (d(!0), f(J, null, ne(e.athletics.slice(0, 6), (s, l) => (d(), f("div", {
        key: `${l}-${s.title}`,
        class: "athletics-card athletic-accent-border",
        "data-testid": "athletic-accent-border"
      }, [
        c("p", {
          class: _(["athletics-date", e.options.style])
        }, k(s.month) + " " + k(s.day), 3),
        c("div", {
          class: _(["athletics-time", e.options.style])
        }, k(s.time), 3),
        c("div", {
          class: _(["athletics-filter", e.options.style])
        }, k(s.filter_name), 3),
        c("h3", ioe, [
          s.versus ? (d(), f("div", soe, [
            H(k(s.away_team) + " ", 1),
            c("span", null, k(e.translations.at), 1),
            H(" " + k(s.home_team), 1)
          ])) : (d(), f("div", aoe, k(s.title), 1))
        ])
      ]))), 128))
    ], 2),
    e.theme.style === "purple" || e.screenSize < 600 ? (d(), L(a, {
      key: 0,
      class: _([e.theme.style, "see-all-bottom"]),
      "theme-options": e.theme
    }, {
      default: S(() => [
        (d(), L(Y(e.isEditing ? "button" : "a"), {
          class: _(["see-all-button", e.theme.style]),
          href: e.seeAllLinkHref,
          target: e.seeAllLinkTarget,
          "data-testid": `see-all-${e.theme.style}-bottom`,
          onClick: t[1] || (t[1] = (s) => e.$emit("open-modal"))
        }, {
          default: S(() => [
            H(k(e.seeAllLinkName), 1)
          ]),
          _: 1
        }, 8, ["class", "href", "target", "data-testid"]))
      ]),
      _: 1
    }, 8, ["class", "theme-options"])) : T("", !0)
  ], 6);
}
const uoe = /* @__PURE__ */ B(roe, [["render", loe], ["__scopeId", "data-v-ca02bffd"]]), doe = {
  name: "CmsAthletics",
  components: {
    A1: uoe
  },
  props: {
    options: {
      type: Object,
      required: !0
    },
    content: {
      type: Array,
      default: () => []
    },
    pathPrefix: {
      type: String,
      default: ""
    },
    athleticsConfig: {
      type: Object,
      default: () => ({})
    },
    componentId: {
      type: String,
      default: null
    },
    isEditing: {
      type: Boolean,
      default: !1
    }
  }
}, coe = { id: "view-athletics" };
function hoe(e, t, n, r, o, i) {
  return d(), f("div", coe, [
    (d(), L(Y(n.options.version), {
      options: n.options,
      "component-id": n.componentId,
      athletics: n.content,
      "athletics-config": n.athleticsConfig,
      "is-editing": n.isEditing,
      "path-prefix": n.pathPrefix,
      onOpenModal: t[0] || (t[0] = (a) => e.$emit("open-modal"))
    }, {
      "header-top": S(() => [
        M(e.$slots, "header-top", {}, void 0, !0)
      ]),
      header: S(() => [
        M(e.$slots, "header", {}, void 0, !0)
      ]),
      _: 3
    }, 40, ["options", "component-id", "athletics", "athletics-config", "is-editing", "path-prefix"]))
  ]);
}
const moe = /* @__PURE__ */ B(doe, [["render", hoe], ["__scopeId", "data-v-efaab17b"]]), foe = {
  name: "SvgArrow"
}, poe = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 21",
  fill: "none"
};
function goe(e, t, n, r, o, i) {
  return d(), f("svg", poe, t[0] || (t[0] = [
    c("mask", {
      id: "path-1-inside-1_1",
      fill: "white"
    }, [
      c("path", { d: "M15.5 0L26 10.5L15 21L13.5 19.5L22 11.5H0V9.5H22L14 1.5L15.5 0Z" })
    ], -1),
    c("path", {
      d: "M15.5 0L26 10.5L15 21L13.5 19.5L22 11.5H0V9.5H22L14 1.5L15.5 0Z",
      class: "arrow_svg",
      "stroke-width": "4",
      mask: "url(#path-1-inside-1_1)"
    }, null, -1)
  ]));
}
const voe = /* @__PURE__ */ B(foe, [["render", goe]]), ea = {
  mixins: [St],
  components: { DraggableWrapper: yt },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    buttons: {
      type: Object,
      required: !0
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    },
    isEditing: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    colors() {
      const e = this.sharedThemeColors();
      return ge(ae({}, e), {
        "--bg-color": $(this.theme, "bg_color.hex", "#fff"),
        "--text-color": $(this.theme, "text_color.hex", "#000"),
        "--arrow-color": $(this.theme, "arrow_color.hex", "#000"),
        "--arrow-color-hover": $(this.theme, "arrow_color_hover.hex", "#000"),
        "--button-text-color": $(this.theme, "button_text_color.hex", "#fff"),
        "--button-bg-color": $(this.theme, "button_bg_color.hex", "#000"),
        "--border-radius": `${this.theme.border_radius}px`,
        "--percentage-opacity": `${100 - this.theme.percentage_opacity}%`,
        "--icon-and-text-color": $(this.theme, "icon_and_text_color.hex", "#fff")
      });
    },
    translations() {
      return this.theme.translations;
    }
  }
}, boe = {
  name: "B1",
  components: { SvgArrow: voe },
  mixins: [ea]
}, yoe = { "data-testid": "buttons-content" };
function _oe(e, t, n, r, o, i) {
  const a = V("SvgArrow");
  return d(), f("div", {
    id: "buttons-b1",
    "data-testid": "B1",
    class: _(e.theme.style),
    style: Z(e.colors)
  }, [
    (d(), L(Y(e.wrapperComponent), Se(e.wrapperProps, {
      modelValue: e.buttons.content,
      "onUpdate:modelValue": t[0] || (t[0] = (s) => e.buttons.content = s),
      "item-key": "index",
      class: "wrapper"
    }), {
      item: S(({ element: s, index: l }) => [
        c("div", yoe, [
          (d(), L(Y(e.isEditing ? "div" : "a"), {
            href: s.link,
            target: s.opens_in_new_tab ? "_blank" : "",
            class: "button-link"
          }, {
            default: S(() => [
              M(e.$slots, "controls", { idx: l }, void 0, !0),
              M(e.$slots, "title", { idx: l }, () => [
                H(k(s.title), 1)
              ], !0),
              j(a)
            ]),
            _: 2
          }, 1032, ["href", "target"]))
        ])
      ]),
      _: 3
    }, 16, ["modelValue"]))
  ], 6);
}
const Coe = /* @__PURE__ */ B(boe, [["render", _oe], ["__scopeId", "data-v-d157672d"]]), woe = {
  name: "B2",
  mixins: [ea]
};
function Toe(e, t, n, r, o, i) {
  return d(), f("div", {
    id: "buttons-b2",
    "data-testid": "B2",
    class: _([e.theme.style, { uppercase: e.theme.uppercase }]),
    style: Z(e.colors)
  }, [
    (d(), L(Y(e.wrapperComponent), Se(e.wrapperProps, {
      modelValue: e.buttons.content,
      "onUpdate:modelValue": t[0] || (t[0] = (a) => e.buttons.content = a),
      "item-key": "index",
      class: "wrapper"
    }), {
      item: S(({ element: a, index: s }) => [
        c("div", null, [
          (d(), L(Y(e.isEditing ? "div" : "a"), {
            href: a.link,
            target: a.opens_in_new_tab ? "_blank" : "",
            class: "button-link",
            "data-testid": "buttons-content"
          }, {
            default: S(() => [
              M(e.$slots, "controls", { idx: s }, void 0, !0),
              c("span", null, [
                M(e.$slots, "title", { idx: s }, () => [
                  H(k(a.title), 1)
                ], !0)
              ])
            ]),
            _: 2
          }, 1032, ["href", "target"]))
        ])
      ]),
      _: 3
    }, 16, ["modelValue"]))
  ], 6);
}
const koe = /* @__PURE__ */ B(woe, [["render", Toe], ["__scopeId", "data-v-dac6a587"]]), Eoe = {
  name: "B3",
  mixins: [ea],
  computed: {
    buttonCount() {
      return this.buttons.content.length;
    },
    iconsActive() {
      return this.buttons.icons_active;
    },
    buttonClasses() {
      return [`buttons-${this.buttonCount}`, { "can-stack": this.buttonCount > 4 }, this.theme.style];
    },
    borderColor() {
      return ue(this.colors["--button-bg-color"]).isLight() ? "rgba(0, 0, 0, 0.15)" : "rgba(255,255,255, 0.15)";
    },
    cssVars() {
      return ge(ae({}, this.colors), {
        "--button-border": `1px solid ${this.borderColor}`
      });
    }
  }
}, Soe = {
  key: 0,
  class: "icon-wrapper",
  "aria-hidden": "true"
}, Moe = { class: "raw-svg" }, Aoe = ["innerHTML"], Ioe = { class: "button-title" };
function Loe(e, t, n, r, o, i) {
  return d(), f("div", {
    id: "buttons-b3",
    "data-testid": "B3",
    class: _(e.theme.style),
    style: Z(i.cssVars)
  }, [
    (d(), L(Y(e.wrapperComponent), Se(e.wrapperProps, {
      modelValue: e.buttons.content,
      "onUpdate:modelValue": t[0] || (t[0] = (a) => e.buttons.content = a),
      "item-key": "index",
      class: "wrapper"
    }), {
      item: S(({ element: a, index: s }) => [
        c("div", {
          class: _(["button", i.buttonClasses])
        }, [
          (d(), L(Y(e.isEditing ? "div" : "a"), {
            href: a.link,
            class: _([[e.theme.style, !i.iconsActive && "no-icons"], "button-link"]),
            target: a.opens_in_new_tab ? "_blank" : "",
            "data-testid": "buttons-content"
          }, {
            default: S(() => [
              M(e.$slots, "controls", { idx: s }, void 0, !0),
              i.iconsActive ? (d(), f("div", Soe, [
                c("span", Moe, [
                  M(e.$slots, "icon", { idx: s }, () => [
                    c("span", {
                      "data-testid": "svg",
                      innerHTML: a.icon
                    }, null, 8, Aoe)
                  ], !0)
                ])
              ])) : T("", !0),
              c("span", Ioe, [
                M(e.$slots, "title", { idx: s }, () => [
                  H(k(a.title), 1)
                ], !0)
              ])
            ]),
            _: 2
          }, 1032, ["href", "class", "target"]))
        ], 2)
      ]),
      _: 3
    }, 16, ["modelValue"]))
  ], 6);
}
const Doe = /* @__PURE__ */ B(Eoe, [["render", Loe], ["__scopeId", "data-v-2e00171e"]]), $oe = {
  name: "B4",
  mixins: [ea],
  props: {
    logo: {
      type: String,
      required: !0
    }
  },
  computed: {
    content: {
      get() {
        return this.buttons.content.slice(0, 3);
      },
      set(e) {
        this.buttons.content = e;
      }
    },
    b4Colors() {
      return {
        // ...this.cssVars,
        "--button-1-bg-color": $(this.theme, "button_1_bg_color.hex", this.theme.globalThemeSettings.secondaryColor),
        "--button-1-border-color": $(this.theme, "button_1_border_color.hex", "#fff"),
        "--button-1-text-color": $(this.theme, "button_1_text_color.hex", "#fff"),
        "--button-2-bg-color": $(this.theme, "button_2_bg_color.hex", this.theme.globalThemeSettings.primaryColor),
        "--button-2-border-color": $(this.theme, "button_2_border_color.hex", "#fff"),
        "--button-2-text-color": $(this.theme, "button_2_text_color.hex", "#fff"),
        "--button-3-bg-color": $(this.theme, "button_3_bg_color.hex", "#000"),
        "--button-3-border-color": $(this.theme, "button_3_border_color.hex", "#fff"),
        "--button-3-text-color": $(this.theme, "button_3_text_color.hex", "#fff")
      };
    }
  }
}, Ooe = { class: "button-title-wrapper" }, Poe = ["src"];
function Noe(e, t, n, r, o, i) {
  return d(), f("div", {
    "data-testid": "B4",
    class: _(["B4", e.theme.style]),
    style: Z(i.b4Colors)
  }, [
    (d(), L(Y(e.wrapperComponent), Se(e.wrapperProps, {
      modelValue: i.content,
      "onUpdate:modelValue": t[0] || (t[0] = (a) => i.content = a),
      "item-key": "index",
      class: "button-wrapper"
    }), {
      item: S(({ element: a, index: s }) => [
        (d(), L(Y(e.isEditing ? "div" : "a"), {
          class: _(["button", `button-style-${s + 1}`]),
          href: a.link,
          target: a.opens_in_new_tab ? "_blank" : "",
          "data-testid": "button"
        }, {
          default: S(() => [
            M(e.$slots, "controls", { idx: s }, void 0, !0),
            c("div", Ooe, [
              c("div", {
                class: _([e.theme.style, "button-title"])
              }, [
                M(e.$slots, "title", {
                  title: a.title,
                  idx: s
                }, () => [
                  H(k(a.title), 1)
                ], !0)
              ], 2),
              c("img", {
                src: n.logo,
                alt: "",
                "data-testid": "button-image"
              }, null, 8, Poe)
            ])
          ]),
          _: 2
        }, 1032, ["class", "href", "target"]))
      ]),
      _: 3
    }, 16, ["modelValue"]))
  ], 6);
}
const Hoe = /* @__PURE__ */ B($oe, [["render", Noe], ["__scopeId", "data-v-8248f642"]]), Foe = {
  name: "Buttons",
  components: {
    B1: Coe,
    B2: koe,
    B3: Doe,
    B4: Hoe
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      default: () => ({})
    },
    isEditing: Boolean,
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    },
    logo: {
      type: String,
      default: ""
    }
  }
};
function Roe(e, t, n, r, o, i) {
  return d(), L(Y(n.theme.version), {
    theme: n.theme,
    buttons: n.content,
    "wrapper-component": n.wrapperComponent,
    "wrapper-props": n.wrapperProps,
    "is-editing": n.isEditing,
    logo: n.logo
  }, {
    controls: S(({ idx: a }) => [
      M(e.$slots, "controls", { idx: a })
    ]),
    icon: S(({ idx: a }) => [
      M(e.$slots, "icon", { idx: a })
    ]),
    title: S(({ title: a, idx: s }) => [
      M(e.$slots, "title", {
        title: a,
        idx: s
      })
    ]),
    _: 3
  }, 8, ["theme", "buttons", "wrapper-component", "wrapper-props", "is-editing", "logo"]);
}
const Voe = /* @__PURE__ */ B(Foe, [["render", Roe]]), Boe = {
  name: "IconLinkButtons",
  components: { DraggableWrapper: yt },
  props: {
    modelValue: {
      type: Array,
      required: !0
    },
    buttons: {
      type: Array,
      required: !0
    },
    themeStyle: {
      type: String,
      default: "light"
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || e.name === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    },
    buttonBgColor: {
      type: String,
      default: "#000"
    },
    buttonIconAndTextColor: {
      type: String,
      default: "#fff"
    },
    width: {
      type: String,
      default: ""
    },
    isEditing: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    cssVars() {
      return {
        "--iconlink-button-bg-color": this.buttonBgColor,
        "--iconlink-button-icon-text-color": this.buttonIconAndTextColor,
        "--iconlink-container-width": this.width || `${Math.ceil(this.buttons.length / 2) * 182}px`,
        "--iconlink-border-color": `1px solid ${this.borderColor}`
      };
    },
    borderColor() {
      return ue(this.buttonBgColor).isLight() ? "rgba(0, 0, 0, 0.15)" : "rgba(255,255,255, 0.15)";
    },
    buttonModel: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:modelValue", e);
      }
    }
  }
}, joe = { class: "button-container" }, Uoe = {
  key: 0,
  class: "icon-wrapper",
  "aria-hidden": "true"
}, qoe = { class: "raw-svg" }, Goe = ["innerHTML"];
function Koe(e, t, n, r, o, i) {
  return d(), L(Y(n.wrapperComponent), Se(n.wrapperProps, {
    modelValue: i.buttonModel,
    "onUpdate:modelValue": t[0] || (t[0] = (a) => i.buttonModel = a),
    style: i.cssVars,
    "item-key": "index",
    class: "icon-link-buttons"
  }), {
    item: S(({ element: a, index: s }) => [
      (d(), L(Y(!a.href || n.isEditing ? "div" : "a"), {
        href: a.href,
        target: a.target || "_self",
        class: "button",
        "data-testid": "icon-button"
      }, {
        default: S(() => [
          M(e.$slots, "controls", { idx: s }, void 0, !0),
          c("div", joe, [
            a.icon || n.isEditing ? (d(), f("div", Uoe, [
              c("span", qoe, [
                M(e.$slots, "icon", {
                  icon: a.icon,
                  idx: s
                }, () => [
                  c("span", {
                    innerHTML: a.icon
                  }, null, 8, Goe)
                ], !0)
              ])
            ])) : T("", !0),
            c("span", {
              class: _(["button-title", n.themeStyle])
            }, [
              M(e.$slots, "title", {
                title: a.title,
                idx: s
              }, () => [
                H(k(a.title), 1)
              ], !0)
            ], 2)
          ])
        ]),
        _: 2
      }, 1032, ["href", "target"]))
    ]),
    _: 3
  }, 16, ["modelValue", "style"]);
}
const zoe = /* @__PURE__ */ B(Boe, [["render", Koe], ["__scopeId", "data-v-34984675"]]), mh = {
  mixins: [St],
  components: {
    IconLinkButtons: zoe,
    DraggableWrapper: yt
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    about: {
      type: Object,
      required: !0
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    },
    watermark: {
      type: String,
      default: ""
    }
  },
  computed: {
    colors() {
      const e = this.sharedThemeColors();
      return ge(ae({}, e), {
        "--top-heading-color": $(this.theme, "top_heading_color.hex", "#000"),
        "--text-color": $(this.theme, "text_color.hex", "#000"),
        "--text-link-color": $(this.theme, "text_link_color.hex", "#000"),
        "--watermark-url": `url(${this.watermark})`,
        "--card-top-header-color": $(this.theme, "card_top_header_color.hex", "#000"),
        "--card-bottom-header-color": $(this.theme, "card_bottom_header_color.hex", "#000")
      });
    },
    buttonBgColor() {
      return $(this.theme, "button_bg_color.hex", "#000");
    },
    buttonIconAndTextColor() {
      return $(this.theme, "icon_and_text_color.hex", "#fff");
    }
  }
}, Zoe = {
  name: "AboutV1",
  mixins: [mh],
  computed: {
    aboutImageUrl() {
      var e;
      return (e = this.about.image) == null ? void 0 : e.url;
    },
    aboutImageAltText() {
      var e;
      return (e = this.about.image) == null ? void 0 : e.alt_text;
    }
  }
}, xoe = ["data-testid"], Woe = ["data-testid"], Yoe = { class: "main-content" }, Xoe = { class: "left-content" }, Qoe = ["src", "alt"], Joe = ["innerHTML"];
function eie(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("IconLinkButtons");
  return d(), f("div", {
    id: "about-v1",
    class: _([e.theme.style, { editing: e.isEditing }]),
    style: Z(e.colors),
    "data-testid": "AboutV1"
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        c("h2", {
          "data-testid": `header-${e.theme.style}-top`
        }, [
          e.theme.style === "monterrey" && (e.about.component_header_top || e.isEditing) ? (d(), f("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            M(e.$slots, "header-top", {}, () => [
              H(k(e.about.component_header_top), 1)
            ], !0)
          ], 8, Woe)) : T("", !0),
          M(e.$slots, "header", {}, () => [
            H(k(e.about.component_header), 1)
          ], !0)
        ], 8, xoe)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    c("div", Yoe, [
      c("div", Xoe, [
        M(e.$slots, "image", {}, () => [
          e.about.has_image ? (d(), f("img", {
            key: 0,
            src: i.aboutImageUrl,
            alt: i.aboutImageAltText,
            class: "left-image",
            "data-testid": "about-image",
            loading: "lazy"
          }, null, 8, Qoe)) : T("", !0)
        ], !0),
        M(e.$slots, "text", {}, () => [
          c("span", {
            class: "left-text text-block",
            innerHTML: e.about.component_text
          }, null, 8, Joe)
        ], !0)
      ]),
      j(s, {
        modelValue: e.about.links,
        "onUpdate:modelValue": t[0] || (t[0] = (l) => e.about.links = l),
        buttons: e.about.links,
        "wrapper-component": e.wrapperComponent,
        "wrapper-props": e.wrapperProps,
        "theme-style": e.theme.style,
        "button-bg-color": e.buttonBgColor,
        "button-icon-and-text-color": e.buttonIconAndTextColor,
        "is-editing": e.isEditing
      }, {
        controls: S(({ idx: l }) => [
          M(e.$slots, "controls", { idx: l }, void 0, !0)
        ]),
        icon: S(({ idx: l }) => [
          M(e.$slots, "icon", { idx: l }, void 0, !0)
        ]),
        title: S(({ title: l, idx: u }) => [
          M(e.$slots, "title", {
            title: l,
            idx: u
          }, void 0, !0)
        ]),
        _: 3
      }, 8, ["modelValue", "buttons", "wrapper-component", "wrapper-props", "theme-style", "button-bg-color", "button-icon-and-text-color", "is-editing"])
    ])
  ], 6);
}
const tie = /* @__PURE__ */ B(Zoe, [["render", eie], ["__scopeId", "data-v-87352126"]]), nie = {
  name: "AboutV2",
  mixins: [mh, Wt],
  computed: {
    isDesktop() {
      return this.screenSize > 1280;
    }
  }
}, rie = { class: "main-content" }, oie = {
  key: 0,
  class: "image-wrapper"
}, iie = ["src"], sie = ["data-testid"], aie = { class: "main-text" }, lie = ["innerHTML"];
function uie(e, t, n, r, o, i) {
  const a = V("IconLinkButtons");
  return d(), f("div", {
    class: _([{ editing: e.isEditing }, "about-v2"]),
    style: Z(e.colors),
    "data-testid": "AboutV2"
  }, [
    c("div", rie, [
      c("div", {
        class: _([e.theme.style, "top-content"])
      }, [
        e.about.has_accent_logo ? (d(), f("div", oie, [
          t[1] || (t[1] = c("svg", {
            width: "16",
            height: "55",
            viewBox: "0 0 16 55",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "data-testid": "accent-icon"
          }, [
            c("path", {
              "fill-rule": "evenodd",
              "clip-rule": "evenodd",
              d: "M7.67334 11.7812L7.67334 54.7812H8.67334L8.67334 11.7813L7.67334 11.7812Z",
              fill: "#000"
            }),
            c("rect", {
              width: "10.0781",
              height: "9.82776",
              transform: "matrix(0.704554 0.70965 -0.704554 0.70965 7.91162 0)",
              fill: "#000"
            })
          ], -1)),
          e.watermark ? (d(), f("img", {
            key: 0,
            src: e.watermark,
            alt: "",
            class: "left-image",
            loading: "lazy"
          }, null, 8, iie)) : T("", !0)
        ])) : T("", !0),
        e.about.has_header ? (d(), f("h2", {
          key: 1,
          class: "header-text",
          "data-testid": `header-${e.theme.style}-top`
        }, [
          M(e.$slots, "header", {}, () => [
            H(k(e.about.component_header), 1)
          ], !0)
        ], 8, sie)) : T("", !0),
        c("span", aie, [
          M(e.$slots, "text", {}, () => [
            c("span", {
              innerHTML: e.about.component_text
            }, null, 8, lie)
          ], !0)
        ])
      ], 2),
      j(a, {
        modelValue: e.about.links,
        "onUpdate:modelValue": t[0] || (t[0] = (s) => e.about.links = s),
        buttons: e.about.links,
        "wrapper-component": e.wrapperComponent,
        "wrapper-props": e.wrapperProps,
        "theme-style": e.theme.style,
        "button-bg-color": e.buttonBgColor,
        "button-icon-and-text-color": e.buttonIconAndTextColor,
        width: i.isDesktop ? "100%" : "",
        "is-editing": e.isEditing
      }, {
        controls: S(({ idx: s }) => [
          M(e.$slots, "controls", { idx: s }, void 0, !0)
        ]),
        icon: S(({ idx: s }) => [
          M(e.$slots, "icon", { idx: s }, void 0, !0)
        ]),
        title: S(({ title: s, idx: l }) => [
          M(e.$slots, "title", {
            title: s,
            idx: l
          }, void 0, !0)
        ]),
        _: 3
      }, 8, ["modelValue", "buttons", "wrapper-component", "wrapper-props", "theme-style", "button-bg-color", "button-icon-and-text-color", "width", "is-editing"])
    ])
  ], 6);
}
const die = /* @__PURE__ */ B(nie, [["render", uie], ["__scopeId", "data-v-3e2fce17"]]), cie = {
  name: "AboutV3",
  mixins: [mh],
  data() {
    return {
      wrapperHeight: "unset"
    };
  },
  computed: {
    aboutLinks: {
      get() {
        return this.about.links.slice(0, 5);
      },
      set(e) {
        this.about.links = e;
      }
    }
  },
  async mounted() {
    window.addEventListener("resize", this.setHeight), await this.$nextTick(), this.setHeight();
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.setHeight);
  },
  methods: {
    setHeight() {
      const e = this.$refs[`card-${this.aboutLinks.length - 1}`];
      if (!e)
        return;
      const t = this.$refs.cardWrapper, r = e.getBoundingClientRect().top - t.$el.getBoundingClientRect().top + e.clientHeight;
      this.wrapperHeight = `${r}px`;
    }
  }
}, hie = { class: "top-container" }, mie = ["data-testid"], fie = ["data-testid"], pie = ["innerHTML"], gie = { class: "card-top-title" }, vie = { class: "card-title" }, bie = { class: "card-image" }, yie = ["src", "alt"];
function _ie(e, t, n, r, o, i) {
  const a = V("SeeAllContainer");
  return d(), f("div", {
    style: Z(e.colors),
    class: _([e.theme.style, "about-v3"])
  }, [
    c("div", hie, [
      j(a, {
        class: _([e.theme.style, "see-all-top"]),
        "theme-options": e.theme
      }, {
        header: S(() => [
          c("h2", {
            "data-testid": `header-${e.theme.style}`,
            class: "no-border"
          }, [
            e.theme.style === "monterrey" && (e.about.component_header_top || e.isEditing) ? (d(), f("span", {
              key: 0,
              "data-testid": `header-${e.theme.style}-top`,
              class: "header-top"
            }, [
              M(e.$slots, "header-top", {}, () => [
                H(k(e.about.component_header_top), 1)
              ])
            ], 8, fie)) : T("", !0),
            M(e.$slots, "header", {}, () => [
              H(k(e.about.component_header), 1)
            ])
          ], 8, mie)
        ]),
        _: 3
      }, 8, ["class", "theme-options"]),
      M(e.$slots, "text", {}, () => [
        c("span", {
          class: "text-block",
          innerHTML: e.about.component_text
        }, null, 8, pie)
      ])
    ]),
    (d(), L(Y(e.wrapperComponent), Se(e.wrapperProps, {
      ref: "cardWrapper",
      modelValue: i.aboutLinks,
      "onUpdate:modelValue": t[0] || (t[0] = (s) => i.aboutLinks = s),
      style: { height: o.wrapperHeight },
      "item-key": "index",
      class: "card-wrapper"
    }), {
      item: S(({ element: s, index: l }) => [
        (d(), L(Y(e.isEditing || !s.href ? "div" : "a"), {
          ref: `card-${l}`,
          href: s.href,
          target: s.target,
          class: "card",
          "data-testid": "about-card"
        }, {
          default: S(() => [
            M(e.$slots, "controls", { idx: l }),
            c("div", {
              class: _(["card-left", e.theme.style])
            }, [
              c("div", gie, [
                M(e.$slots, "top-title", { idx: l }, () => [
                  H(k(s.top_title), 1)
                ])
              ]),
              c("div", vie, [
                M(e.$slots, "title", { idx: l }, () => [
                  H(k(s.title), 1)
                ])
              ])
            ], 2),
            c("div", bie, [
              M(e.$slots, "image", { idx: l }, () => [
                c("img", {
                  src: s.image && s.image.url,
                  alt: s.image && s.image.alt_text
                }, null, 8, yie)
              ])
            ])
          ]),
          _: 2
        }, 1032, ["href", "target"]))
      ]),
      _: 3
    }, 16, ["modelValue", "style"]))
  ], 6);
}
const Cie = /* @__PURE__ */ B(cie, [["render", _ie], ["__scopeId", "data-v-aebe3b92"]]), wie = {
  name: "About",
  components: {
    AboutV1: tie,
    AboutV2: die,
    AboutV3: Cie
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      default: () => ({})
    },
    isPreview: {
      type: Boolean,
      default: !1
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    },
    watermark: {
      type: String,
      default: ""
    }
  }
}, Tie = { id: "view-about" };
function kie(e, t, n, r, o, i) {
  return d(), f("div", Tie, [
    (d(), L(Y(n.theme.version), {
      theme: n.theme,
      about: n.content,
      "is-editing": n.isEditing,
      "wrapper-component": n.wrapperComponent,
      "wrapper-props": n.wrapperProps,
      watermark: n.watermark
    }, {
      "header-top": S(() => [
        M(e.$slots, "header-top", {}, void 0, !0)
      ]),
      header: S(() => [
        M(e.$slots, "header", {}, void 0, !0)
      ]),
      image: S(({ idx: a }) => [
        M(e.$slots, "image", { idx: a }, void 0, !0)
      ]),
      text: S(() => [
        M(e.$slots, "text", {}, void 0, !0)
      ]),
      controls: S(({ idx: a }) => [
        M(e.$slots, "controls", { idx: a }, void 0, !0)
      ]),
      icon: S(({ idx: a }) => [
        M(e.$slots, "icon", { idx: a }, void 0, !0)
      ]),
      "top-title": S(({ idx: a }) => [
        M(e.$slots, "top-title", { idx: a }, void 0, !0)
      ]),
      title: S(({ idx: a }) => [
        M(e.$slots, "title", { idx: a }, void 0, !0)
      ]),
      _: 3
    }, 8, ["theme", "about", "is-editing", "wrapper-component", "wrapper-props", "watermark"]))
  ]);
}
const Eie = /* @__PURE__ */ B(wie, [["render", kie], ["__scopeId", "data-v-602a1639"]]), D8 = /* @__PURE__ */ $6({
  name: "UseFocusTrap",
  props: ["as", "options"],
  setup(e, { slots: t }) {
    let n;
    const r = zt(), o = () => n && n.activate(), i = () => n && n.deactivate();
    return ko(
      () => A4(r),
      (a) => {
        a && (n = N4(a, e.options || {}), o());
      },
      { flush: "post" }
    ), s0(() => i()), () => {
      if (t.default)
        return oo(e.as || "div", { ref: r }, t.default());
    };
  }
});
function vt(e, ...t) {
  const n = t.find((r) => e[r]);
  return n ? e[n] : { hex: "" };
}
const Sie = { class: "cms-alert-modal__container-wrapper" }, Mie = ["aria-label"], Aie = ["aria-label"], Iie = { class: "cms-alert-modal__body" }, Lie = ["innerHTML"], Die = /* @__PURE__ */ Object.assign({
  name: "CmsAlertModal"
}, {
  __name: "CmsAlertModal",
  props: {
    globals: {
      type: Object,
      default: () => ({})
    },
    alertContent: {
      type: String,
      default: ""
    },
    translations: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    const n = e, r = t, o = zt(!0), i = zt(!0), a = Re(() => n.globals && n.globals.info ? n.globals.info : {}), s = Re(
      () => o.value ? "cms-alert-modal__close--no-focus-outline" : ""
    ), l = Re(() => document.querySelector(".cms-alert-modal__container")), u = (C = !1) => {
      i.value && (i.value = !1, r("close", { closedByKeyboard: C }));
    }, m = Re(() => {
      var C;
      return ((C = vt(a.value, "alert_lightbox_overlay")) == null ? void 0 : C.hex) || "#000";
    }), v = Re(() => {
      var C;
      return ((C = vt(a.value, "alert_text_color")) == null ? void 0 : C.hex) || "#000";
    }), g = Re(() => {
      var C;
      return ((C = vt(a.value, "alert_bg_color")) == null ? void 0 : C.hex) || "#fff";
    }), h = Re(
      () => ue.mostReadable(m.value, [g.value, v.value, "#fff"])
    ), E = Re(() => {
      var C, A;
      return {
        "--overlay-bg-color": ((C = vt(a.value, "alert_lightbox_overlay")) == null ? void 0 : C.hex) || "#000",
        "--container-bg-color": g.value,
        "--body-text-color": v.value,
        "--body-link-color": ((A = vt(a.value, "alert_link_color")) == null ? void 0 : A.hex) || "#000",
        "--focus-outline-color": h.value
      };
    });
    return Ts(() => {
      document.body.style.overflow = "hidden";
    }), dg(() => {
      document.body.style.overflow = "";
    }), (C, A) => (d(), f("div", {
      id: "cms-alert-modal",
      style: Z(E.value)
    }, [
      c("div", Sie, [
        j(po(D8), {
          options: {
            immediate: !0,
            onDeactivate: u,
            initialFocus: () => l.value,
            fallbackFocus: () => l.value
          }
        }, {
          default: S(() => [
            c("section", {
              class: "cms-alert-modal__container",
              "aria-label": e.translations.legacyContainer,
              role: "alertdialog",
              "aria-modal": "true",
              tabindex: "-1"
            }, [
              c("button", {
                ref: "close-button",
                "aria-label": e.translations.legacyBody,
                class: _(["cms-alert-modal__close", s.value]),
                "aria-describedby": "alert-modal-body",
                onClick: A[0] || (A[0] = (R) => u()),
                onKeydown: [
                  A[1] || (A[1] = K(W((R) => u(!0), ["exact", "prevent"]), ["enter"])),
                  A[2] || (A[2] = K(W((R) => u(!0), ["exact", "prevent"]), ["space"])),
                  A[3] || (A[3] = K(W((...R) => C.closeAllModals && C.closeAllModals(...R), ["exact", "prevent"]), ["esc"])),
                  A[4] || (A[4] = K(W((R) => o.value = !1, ["exact"]), ["tab"]))
                ]
              }, [
                j(vi, { "fill-color": h.value }, null, 8, ["fill-color"])
              ], 42, Aie),
              c("div", Iie, [
                c("div", {
                  id: "alert-modal-body",
                  class: "cms-alert-modal__body-content",
                  innerHTML: e.alertContent
                }, null, 8, Lie)
              ])
            ], 8, Mie)
          ]),
          _: 1
        }, 8, ["options"])
      ])
    ], 4));
  }
}), $ie = /* @__PURE__ */ B(Die, [["__scopeId", "data-v-d69c787a"]]), Oie = {
  name: "AlertBanner",
  props: {
    globals: {
      type: Object,
      default: () => ({})
    },
    alertContent: {
      type: String,
      default: ""
    }
  },
  computed: {
    globalsInfo() {
      return this.globals && this.globals.info ? this.globals.info : {};
    },
    colors() {
      return {
        "--banner-bg-color": vt(this.globalsInfo, "alert_bg_color").hex || "#cc314b",
        "--banner-text-color": vt(this.globalsInfo, "alert_text_color").hex || "#fff",
        "--banner-link-color": vt(this.globalsInfo, "alert_link_color").hex || "#fff"
      };
    }
  }
}, Pie = ["innerHTML"];
function Nie(e, t, n, r, o, i) {
  return d(), f("div", {
    id: "alert-banner",
    style: Z(i.colors)
  }, [
    c("div", {
      class: "alert-banner__content",
      innerHTML: n.alertContent
    }, null, 8, Pie)
  ], 4);
}
const Hie = /* @__PURE__ */ B(Oie, [["render", Nie], ["__scopeId", "data-v-ac60c6f3"]]);
function Fie(e, t, n, { maxPadding: r = 25, minPadding: o = 5, smallModalMaxRatioOfViewport: i = 0.3, largeModalMinRatioOfViewport: a = 0.9 } = {}) {
  const s = e / t;
  let l;
  if (s <= i)
    l = r;
  else if (s < a) {
    const m = (s - i) / (a - i);
    l = r - (r - o) * m;
  } else
    l = o;
  const u = Math.min(1, n / t);
  return l = l * u, Math.max(o, Math.min(l, r));
}
function Rie() {
  const { width: e } = CO();
  return {
    screenSize: e
  };
}
const Vie = ["onKeydown"], Bie = ["aria-describedby", "onClick", "onKeydown"], jie = {
  class: "container",
  role: "alertdialog",
  "aria-modal": "true"
}, Uie = {
  key: 0,
  class: "image"
}, qie = ["src", "alt"], Gie = ["id"], Kie = ["innerHTML"], zie = /* @__PURE__ */ Object.assign({
  name: "CmsAlertModalSeparate"
}, {
  __name: "CmsAlertModalSeparate",
  props: {
    globals: {
      type: Object,
      default: () => ({})
    },
    modalArray: {
      type: Array,
      default: () => []
    }
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    const { screenSize: n } = Rie(), r = zt(), o = e, i = t, a = zt(0);
    Ts(() => {
      document.body.style.overflow = "hidden", F(".close");
    }), dg(() => {
      document.body.style.overflow = "";
    });
    const s = Re(() => document.querySelector(".container-wrapper")), l = Re(() => typeof window != "undefined" ? `${Fie(a.value, window.innerHeight, n.value)}vh` : "0vh"), u = Re(() => {
      var I;
      return (I = o.globals.info) != null ? I : {};
    }), m = Re(() => {
      var I;
      return ((I = vt(u.value, "alert_lightbox_overlay")) == null ? void 0 : I.hex) || "#000";
    }), v = Re(() => {
      var I;
      return ((I = vt(u.value, "alert_text_color")) == null ? void 0 : I.hex) || "#000";
    }), g = Re(() => {
      var I;
      return ((I = vt(u.value, "alert_bg_color")) == null ? void 0 : I.hex) || "#fff";
    }), h = Re(
      () => ue.mostReadable(m.value, [g.value, v.value, "#fff"])
    ), E = Re(() => {
      var I, D;
      return {
        "--overlay-bg-color": ((I = vt(u.value, "alert_lightbox_overlay")) == null ? void 0 : I.hex) || "#000",
        "--container-bg-color": g.value,
        "--body-text-color": v.value,
        "--body-link-color": ((D = vt(u.value, "alert_link_color")) == null ? void 0 : D.hex) || "#000",
        "--focus-outline-color": h.value
      };
    }), C = () => {
      ri(() => {
        r.value && (a.value = r.value.clientHeight);
      });
    }, A = (I, D = !1) => {
      const O = o.modalArray.length <= 1;
      i("close", { alertId: I, closedByKeyboard: O && D }), O || (C(), F(".close"));
    }, R = () => {
      o.modalArray.forEach((I, D) => {
        const O = D === o.modalArray.length - 1;
        i("close", { alertId: I.id, closedByKeyboard: O });
      });
    }, P = () => [
      o.modalArray.length > 1 ? "multi-modal" : "single-modal",
      o.modalArray.some((I) => I.image.url) ? "has-image" : "no-image",
      o.modalArray.some((I) => I.content.length > 100) ? "long-text" : "short-text"
    ], F = (I) => {
      ri(() => {
        const D = document.querySelector(I);
        D && D.focus();
      });
    };
    return (I, D) => (d(), L(po(D8), {
      options: {
        immediate: !0,
        onDeactivate: A,
        initialFocus: () => s.value,
        fallbackFocus: () => s.value
      }
    }, {
      default: S(() => [
        c("div", {
          class: "cms-alert-modal",
          style: Z([E.value, { paddingTop: l.value }]),
          onKeydown: K(W(R, ["exact", "prevent"]), ["esc"])
        }, [
          c("div", {
            ref_key: "modalContainer",
            ref: r,
            tabindex: "-1",
            class: "container-wrapper"
          }, [
            (d(!0), f(J, null, ne(e.modalArray, (O, U) => (d(), f("div", {
              key: U,
              class: _(["individual-container-wrapper", ...P()])
            }, [
              c("button", {
                class: "close",
                "aria-describedby": `alert-modal-body-${O.id}`,
                onClick: (q) => A(O.id),
                onKeydown: [
                  K(W((q) => A(O.id, !0), ["exact", "prevent"]), ["enter"]),
                  K(W((q) => A(O.id, !0), ["exact", "prevent"]), ["space"])
                ]
              }, [
                j(vi, { "fill-color": h.value }, null, 8, ["fill-color"])
              ], 40, Bie),
              c("section", jie, [
                O.image.url ? (d(), f("div", Uie, [
                  c("img", {
                    src: O.image.url,
                    alt: O.image.alt_text
                  }, null, 8, qie)
                ])) : T("", !0),
                O.content ? (d(), f("div", {
                  key: 1,
                  id: "alert-modal-body-" + O.id,
                  class: "body"
                }, [
                  c("div", {
                    class: "body-content",
                    innerHTML: O.content
                  }, null, 8, Kie)
                ], 8, Gie)) : T("", !0)
              ])
            ], 2))), 128))
          ], 512)
        ], 44, Vie)
      ]),
      _: 1
    }, 8, ["options"]));
  }
}), Zie = /* @__PURE__ */ B(zie, [["__scopeId", "data-v-5f04c029"]]), xie = {
  name: "CmsAlertBannerSeparate",
  components: {
    SvgClose: vi
  },
  data() {
    return {
      hideCloseBtnFocusOutline: !0
    };
  },
  props: {
    globals: {
      type: Object,
      default: () => ({})
    },
    bannerArray: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    globalsInfo() {
      return this.globals && this.globals.info ? this.globals.info : {};
    },
    colors() {
      return {
        "--banner-bg-color": vt(this.globalsInfo, "alert_bg_color").hex || "#cc314b",
        "--banner-text-color": vt(this.globalsInfo, "alert_text_color").hex || "#fff",
        "--banner-link-color": vt(this.globalsInfo, "alert_link_color").hex || "#fff"
      };
    },
    closeBtnFocusOutlineCSSClass() {
      return this.hideCloseBtnFocusOutline ? "no-focus-outline" : "";
    },
    svgFillColor() {
      return ue(this.colors["--banner-bg-color"]).isLight() ? "#000" : "#fff";
    }
  },
  methods: {
    closeBanner(e) {
      this.$emit("close", { alertId: e });
    }
  }
}, Wie = { class: "alert-banners" }, Yie = { class: "banner-wrapper" }, Xie = ["innerHTML"], Qie = ["onClick", "onKeydown"];
function Jie(e, t, n, r, o, i) {
  const a = V("SvgClose");
  return d(), f("div", Wie, [
    (d(!0), f(J, null, ne(n.bannerArray, (s) => (d(), f("div", {
      key: s.id,
      class: "banner",
      style: Z(i.colors)
    }, [
      c("div", Yie, [
        c("div", {
          class: "content",
          innerHTML: s.content
        }, null, 8, Xie),
        c("button", {
          class: _(["close", i.closeBtnFocusOutlineCSSClass]),
          onClick: (l) => i.closeBanner(s.id),
          onKeydown: [
            K(W((l) => i.closeBanner(s.id), ["exact", "prevent"]), ["enter"]),
            K(W((l) => i.closeBanner(s.id), ["exact", "prevent"]), ["space"]),
            t[0] || (t[0] = K(W((l) => o.hideCloseBtnFocusOutline = !1, ["exact"]), ["tab"]))
          ]
        }, [
          j(a, { "fill-color": i.svgFillColor }, null, 8, ["fill-color"])
        ], 42, Qie)
      ])
    ], 4))), 128))
  ]);
}
const ese = /* @__PURE__ */ B(xie, [["render", Jie], ["__scopeId", "data-v-7140ef94"]]), tse = {
  name: "Parallax",
  props: {
    config: {
      type: Object,
      required: !0
    }
  }
}, nse = { class: "parallax-section" }, rse = {
  ref: "parallax",
  class: "parallax-container"
}, ose = { class: "image-container" }, ise = ["src"];
function sse(e, t, n, r, o, i) {
  return d(), f("div", nse, [
    c("div", rse, [
      c("div", {
        class: "parallax",
        style: Z({ backgroundImage: `url(${n.config.background_image.url})` })
      }, null, 4)
    ], 512),
    c("div", ose, [
      c("img", {
        class: "full-image",
        src: n.config.background_image.url
      }, null, 8, ise)
    ])
  ]);
}
const ase = /* @__PURE__ */ B(tse, [["render", sse], ["__scopeId", "data-v-e745b867"]]), lse = {
  computed: {
    colors() {
      return {
        "--button-one-bg-color": $(this.theme, "button_one.bg_color.hex", "#333"),
        "--button-one-icon-and-text-color": $(this.theme, "button_one.icon_and_text_color.hex", "#fff"),
        "--button-two-bg-color": $(this.theme, "button_two.bg_color.hex", "#fff"),
        "--button-two-icon-and-text-color": $(this.theme, "button_two.icon_and_text_color.hex", "#333"),
        "--button-three-bg-color": $(this.theme, "button_three.bg_color.hex", "#333"),
        "--button-three-icon-and-text-color": $(this.theme, "button_three.icon_and_text_color.hex", "#fff"),
        "--button-four-bg-color": $(this.theme, "button_four.bg_color.hex", "#fff"),
        "--button-four-icon-and-text-color": $(this.theme, "button_four.icon_and_text_color.hex", "#333"),
        "--button-five-bg-color": $(this.theme, "button_five.bg_color.hex", "#333"),
        "--button-five-icon-and-text-color": $(this.theme, "button_five.icon_and_text_color.hex", "#fff"),
        "--button-mobile-bg-color": $(this.theme, "button_mobile.bg_color.hex", "#333"),
        "--button-mobile-icon-and-text-color": $(this.theme, "button_mobile.icon_and_text_color.hex", "#fff")
      };
    },
    translations() {
      return $(this.theme, "translations", {});
    }
  }
}, use = {
  name: "MobileSvgArrow",
  props: {
    fillColor: {
      type: String,
      required: !0
    }
  }
}, dse = {
  width: "17",
  height: "16",
  viewBox: "0 0 19 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, cse = ["fill"];
function hse(e, t, n, r, o, i) {
  return d(), f("svg", dse, [
    c("path", {
      d: "M18 9C18.5523 9 19 8.55228 19 8C19 7.44772 18.5523 7 18 7L18 9ZM0.292892 7.29289C-0.0976315 7.68342 -0.0976315 8.31658 0.292892 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928932C7.68054 0.538408 7.04738 0.538408 6.65685 0.928932L0.292892 7.29289ZM18 7L1 7L1 9L18 9L18 7Z",
      fill: n.fillColor
    }, null, 8, cse)
  ]);
}
const mse = /* @__PURE__ */ B(use, [["render", hse]]), fse = {
  name: "FN1",
  components: {
    mobileNavIcon: mse
  },
  mixins: [lse],
  props: {
    theme: {
      type: Object,
      required: !0
    },
    floatingNav: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      navExpanded: !1,
      pageYOffset: 0
    };
  },
  computed: {
    buttonShape() {
      return this.floatingNav.shape;
    },
    navPosition() {
      return this.floatingNav.is_fixed ? "nav-fixed" : "nav-absolute";
    },
    mobileFill() {
      return $(this.theme, "button_mobile.icon_and_text_color.hex", "#fff");
    },
    isScrolled() {
      return this.pageYOffset > 100;
    }
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    togglePanel() {
      this.navExpanded = !this.navExpanded;
    },
    buttonHref(e) {
      return e.mailto ? `mailto:${e.email_address}` : e.url;
    },
    onScroll() {
      this.pageYOffset = window.pageYOffset;
    }
  }
}, pse = { class: "nav-wrapper" }, gse = { class: "button-link" }, vse = { class: "link-wrapper" }, bse = ["href", "target"], yse = { class: "link-wrapper" }, _se = {
  class: "icon-wrapper",
  "data-testid": "svg",
  "aria-hidden": "true"
}, Cse = { class: "raw-svg" }, wse = ["innerHTML"];
function Tse(e, t, n, r, o, i) {
  const a = V("mobile-nav-icon");
  return d(), f("div", {
    id: "floating-nav",
    "data-testid": "FN1",
    class: _([i.navPosition, { "is-scrolled": i.isScrolled }]),
    style: Z([e.colors])
  }, [
    c("div", pse, [
      c("div", {
        class: _(["mobile-menu-button button", [i.buttonShape, { expanded: o.navExpanded }]]),
        onClick: t[0] || (t[0] = (...s) => i.togglePanel && i.togglePanel(...s))
      }, [
        c("div", gse, [
          c("div", vse, [
            c("div", {
              class: _(["icon-wrapper", { expanded: o.navExpanded }]),
              "data-testid": "svg",
              "aria-hidden": "true"
            }, [
              j(a, { "fill-color": i.mobileFill }, null, 8, ["fill-color"])
            ], 2),
            c("span", {
              class: _(["button-title", n.theme.style])
            }, k(e.translations.mobile_menu_title || "Collapse Menu"), 3)
          ])
        ])
      ], 2),
      c("div", {
        class: _(["button-wrapper", o.navExpanded ? "expanded" : "hiddenButtons"])
      }, [
        (d(!0), f(J, null, ne(n.floatingNav.buttons, (s, l) => (d(), f("div", {
          key: `floating-nav-${l}`,
          class: _(["button", i.buttonShape]),
          "data-testid": "fn1-button"
        }, [
          c("a", {
            class: _(["button-link", n.theme.style]),
            href: i.buttonHref(s),
            target: s.opens_in_new_tab ? "_blank" : "",
            "data-testid": "links"
          }, [
            c("div", yse, [
              c("div", _se, [
                c("span", Cse, [
                  c("span", {
                    "data-testid": "svg",
                    innerHTML: s.icon
                  }, null, 8, wse)
                ])
              ]),
              c("span", {
                class: _(["button-title", n.theme.style])
              }, k(s.title), 3)
            ])
          ], 10, bse)
        ], 2))), 128))
      ], 2)
    ])
  ], 6);
}
const kse = /* @__PURE__ */ B(fse, [["render", Tse], ["__scopeId", "data-v-b318b410"]]), Ese = {
  name: "FloatingNav",
  components: {
    FN1: kse
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    floatingNav: {
      type: Object,
      default: () => ({})
    }
  }
};
function Sse(e, t, n, r, o, i) {
  return d(), L(Y(n.theme.version), {
    theme: n.theme,
    "floating-nav": n.floatingNav
  }, null, 8, ["theme", "floating-nav"]);
}
const Mse = /* @__PURE__ */ B(Ese, [["render", Sse]]), fh = {
  mixins: [St],
  components: { DraggableWrapper: yt },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    blocks: {
      type: Object,
      required: !0
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    },
    isEditing: {
      type: Boolean,
      default: !1
    }
  },
  methods: {
    blockHasLink(e) {
      var t;
      return !this.isEditing && ((t = e.link) == null ? void 0 : t.href);
    }
  },
  computed: {
    colors() {
      const e = this.sharedThemeColors();
      return ge(ae({}, e), {
        "--description-color": $(this.theme, "description_color.hex", "initial"),
        "--arrow-icon-color": $(this.theme, "arrow_icon_color.hex", "initial"),
        "--arrow-background-color": $(this.theme, "arrow_background_color.hex", "initial"),
        "--pager-color": $(this.theme, "pager_color.hex", "#ffffff"),
        "--box-text-color": $(this.theme, "box_text_color.hex", "#000000"),
        "--box-bg-color": $(this.theme, "box_bg_color.hex", "#ffffff"),
        "--box-gradient-color": $(this.theme, "gradient_overlay.hex", "#ffffff")
      });
    },
    translations() {
      return this.theme.translations;
    },
    content() {
      return this.blocks.content;
    }
  }
}, Ase = {
  name: "OS1",
  components: { CardSlider: mn },
  mixins: [_t, fh],
  computed: {
    sliderCenterSize() {
      return 599;
    },
    showDescription() {
      return this.blocks.has_description && !qr(this.blocks.component_header_description) || this.blocks.has_description && this.isEditing;
    },
    hasAccentStyling() {
      return this.theme.globalThemeSettings.accentStyling;
    }
  },
  methods: {
    fourCardColorPattern(e) {
      return `card-style-${e % 5 + 1}`;
    }
  }
}, Ise = { class: "header-wrapper" }, Lse = ["data-testid"], Dse = ["data-testid"], $se = {
  key: 0,
  class: "header-description",
  "data-testid": "component-header-description"
}, Ose = ["data-testid", "aria-label"], Pse = { class: "box" };
function Nse(e, t, n, r, o, i) {
  const a = V("SeeAllContainer"), s = V("CardSlider");
  return d(), f("div", {
    id: "our-schools-v1",
    "data-testid": "OS1",
    class: _([e.theme.style, e.isEditing && "editing"]),
    style: Z(e.colors)
  }, [
    j(a, {
      class: _([e.theme.style, "see-all-top"]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        c("div", Ise, [
          c("h2", {
            "data-testid": `header-${e.theme.style}-top`
          }, [
            e.theme.style === "monterrey" && (e.blocks.component_header_top || e.isEditing) ? (d(), f("span", {
              key: 0,
              class: "header-top",
              "data-testid": `header-${e.theme.style}-top`
            }, [
              M(e.$slots, "header-top", {}, () => [
                H(k(e.blocks.component_header_top), 1)
              ], !0)
            ], 8, Dse)) : T("", !0),
            M(e.$slots, "header", {}, () => [
              H(k(e.blocks.component_header), 1)
            ], !0)
          ], 8, Lse),
          i.showDescription ? (d(), f("div", $se, [
            M(e.$slots, "header-description", {}, () => [
              H(k(e.blocks.component_header_description), 1)
            ], !0)
          ])) : T("", !0)
        ])
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    j(s, {
      class: _({ "all-cards-visible": e.allCardsVisible }),
      "nav-orientation": "wide",
      "pager-orientation": "right",
      "current-card": e.currentCard,
      "pager-section-count": e.pagerSectionCount,
      "total-cards": e.blocks.content.length,
      "theme-styles": e.theme,
      "section-header": e.blocks.component_header,
      onScrollRight: e.scrollRight,
      onScrollLeft: e.scrollLeft,
      onGoToSection: e.goToSection
    }, {
      default: S(() => [
        (d(), L(Y(e.wrapperComponent), Se({
          ref: "scrollWrapper",
          modelValue: e.blocks.content,
          "onUpdate:modelValue": t[0] || (t[0] = (l) => e.blocks.content = l),
          class: ["scroll-wrapper", { "all-cards-visible": e.allCardsVisible }]
        }, e.wrapperProps, {
          "item-key": "index",
          "data-testid": "blocks-array"
        }), {
          item: S(({ element: l, index: u }) => [
            c("div", {
              ref: `sliderCard-${u}`,
              class: _([[`card-${u + 1}`, i.fourCardColorPattern(u)], "our-schools"]),
              "data-testid": `Card${u + 1}`,
              role: "group",
              "aria-roledescription": "slide",
              "aria-label": `${u + 1} of ${e.blocks.content.length}`
            }, [
              M(e.$slots, "controls", { idx: u }, void 0, !0),
              (d(), L(Y(e.blockHasLink(l) ? "a" : "div"), {
                href: e.blockHasLink(l) && l.link.href,
                role: e.blockHasLink(l) && "link",
                target: e.blockHasLink(l) && l.link.target,
                "data-testid": "block-link"
              }, {
                default: S(() => [
                  c("span", Pse, [
                    M(e.$slots, "box", { idx: u }, () => [
                      H(k(l.box), 1)
                    ], !0)
                  ]),
                  M(e.$slots, "image", { idx: u }, () => [
                    (d(), L(Y(l.image ? "img" : "div"), {
                      src: l.image.url,
                      alt: l.link.href ? "" : l.image.alt_text,
                      class: "our-schools-image",
                      "data-testid": "block-image",
                      loading: "lazy"
                    }, null, 8, ["src", "alt"]))
                  ], !0)
                ]),
                _: 2
              }, 1032, ["href", "role", "target"]))
            ], 10, Ose)
          ]),
          _: 3
        }, 16, ["modelValue", "class"]))
      ]),
      _: 3
    }, 8, ["class", "current-card", "pager-section-count", "total-cards", "theme-styles", "section-header", "onScrollRight", "onScrollLeft", "onGoToSection"])
  ], 6);
}
const Hse = /* @__PURE__ */ B(Ase, [["render", Nse], ["__scopeId", "data-v-cd6f874a"]]), Fse = {
  name: "OS2",
  mixins: [fh],
  data() {
    return {
      hoverIndex: -1
    };
  },
  computed: {
    colorsWithOpacity() {
      const e = this.colors["--box-gradient-color"], t = `rgba(${Zf(e, 1)})`, n = `rgba(${Zf(e, 0)})`;
      return ge(ae({}, this.colors), {
        "--box-bg-color-initial-opacity": t,
        "--box-bg-color-final-opacity": n
      });
    },
    columnClass() {
      return this.blocks.content.length <= 3 ? "three-column" : this.blocks.num_columns === 4 ? "four-column" : "three-column";
    }
  }
}, Rse = ["data-testid"], Vse = ["data-testid"], Bse = ["onMouseover"], jse = ["src", "alt"], Use = {
  key: 1,
  class: "our-schools-image"
}, qse = {
  key: 1,
  class: "title-container",
  "data-testid": "no-link-block",
  maxlength: "26"
};
function Gse(e, t, n, r, o, i) {
  const a = V("SeeAllContainer");
  return d(), f("div", {
    class: _(["our-schools-v2", e.theme.style]),
    "data-testid": "OS2",
    style: Z(i.colorsWithOpacity)
  }, [
    j(a, {
      class: _(["see-all-top", e.theme.style]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        c("h2", {
          "data-testid": `header-${e.theme.style}-top`,
          class: _({ "no-border": e.theme.style === "bold" })
        }, [
          e.theme.style === "monterrey" && (e.blocks.component_header_top || e.isEditing) ? (d(), f("span", {
            key: 0,
            "data-testid": `header-${e.theme.style}-top`,
            class: "header-top"
          }, [
            M(e.$slots, "header-top", {}, () => [
              H(k(e.blocks.component_header_top), 1)
            ], !0)
          ], 8, Vse)) : T("", !0),
          M(e.$slots, "header", {
            dataTestid: `header-${e.theme.style}`
          }, () => [
            H(k(e.blocks.component_header), 1)
          ], !0)
        ], 10, Rse)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    (d(), L(Y(e.wrapperComponent), Se(e.wrapperProps, {
      modelValue: e.blocks.content,
      "onUpdate:modelValue": t[1] || (t[1] = (s) => e.blocks.content = s),
      class: "our-schools-wrapper",
      "data-testid": "blocks-array",
      "item-key": "index"
    }), {
      item: S(({ element: s, index: l }) => [
        c("div", {
          class: _(["block", i.columnClass]),
          "data-testid": "our-schools-block-content"
        }, [
          M(e.$slots, "controls", { idx: l }, void 0, !0),
          c("div", {
            class: "image-wrapper image-border-accent",
            role: "dialog",
            onMouseover: (u) => o.hoverIndex = l,
            onMouseleave: t[0] || (t[0] = (u) => o.hoverIndex = -1)
          }, [
            s.image.url ? (d(), f("img", {
              key: 0,
              src: s.image.url,
              alt: s.image.alt_text,
              loading: "lazy",
              class: "our-schools-image"
            }, null, 8, jse)) : (d(), f("div", Use)),
            c("div", {
              class: _([[
                e.theme.style,
                {
                  "hover-enter": o.hoverIndex === l
                }
              ], "content-box gradient"])
            }, null, 2),
            c("div", {
              class: _([e.theme.style, "title"])
            }, [
              s.link.href ? (d(), L(Y(e.isEditing ? "div" : "a"), {
                key: 0,
                class: "title-container",
                "data-testid": "link-block",
                href: s.link.href,
                target: s.link.target || "_self"
              }, {
                default: S(() => [
                  M(e.$slots, "box", { idx: l }, () => [
                    H(k(s.box), 1)
                  ], !0)
                ]),
                _: 2
              }, 1032, ["href", "target"])) : (d(), f("p", qse, [
                M(e.$slots, "box", { idx: l }, () => [
                  H(k(s.box), 1)
                ], !0)
              ]))
            ], 2)
          ], 40, Bse)
        ], 2)
      ]),
      _: 3
    }, 16, ["modelValue"]))
  ], 6);
}
const Kse = /* @__PURE__ */ B(Fse, [["render", Gse], ["__scopeId", "data-v-fe3d0b84"]]), zse = {
  name: "OS3",
  mixins: [fh],
  computed: {
    OS3Colors() {
      var e, t;
      return ge(ae({}, this.colors), {
        "--icon-color": ((e = this.theme.icon_color) == null ? void 0 : e.hex) || "#fff",
        "--icon-bg-color": ((t = this.theme.icon_bg_color) == null ? void 0 : t.hex) || "#000"
      });
    }
  },
  methods: {
    isLink({ link: e }) {
      return !this.isEditing && (e == null ? void 0 : e.href) && this.blocks.has_link;
    }
  }
}, Zse = {
  key: 0,
  class: "header-top"
}, xse = {
  key: 0,
  class: "our-schools-icon"
}, Wse = {
  class: "icon-wrapper",
  "aria-hidden": "true"
}, Yse = { class: "raw-svg" }, Xse = ["innerHTML"];
function Qse(e, t, n, r, o, i) {
  const a = V("SeeAllContainer");
  return d(), f("div", {
    class: _(["our-schools-v3", e.theme.style]),
    style: Z(i.OS3Colors)
  }, [
    j(a, {
      class: _(["see-all-top", e.theme.style]),
      "theme-options": e.theme
    }, {
      header: S(() => [
        c("h2", {
          class: _({ "no-border": e.theme.style === "bold" })
        }, [
          e.theme.style === "monterrey" && (e.blocks.component_header_top || e.isEditing) ? (d(), f("span", Zse, [
            M(e.$slots, "header-top", {}, () => [
              H(k(e.blocks.component_header_top), 1)
            ], !0)
          ])) : T("", !0),
          M(e.$slots, "header", {}, () => [
            H(k(e.blocks.component_header), 1)
          ], !0)
        ], 2)
      ]),
      _: 3
    }, 8, ["class", "theme-options"]),
    (d(), L(Y(e.wrapperComponent), Se(e.wrapperProps, {
      modelValue: e.blocks.content,
      "onUpdate:modelValue": t[0] || (t[0] = (s) => e.blocks.content = s),
      class: "our-schools-wrapper",
      "item-key": "index"
    }), {
      item: S(({ element: s, index: l }) => {
        var u, m;
        return [
          (d(), L(Y(i.isLink(s) ? "a" : "div"), {
            href: i.isLink(s) ? (u = s.link) == null ? void 0 : u.href : void 0,
            target: i.isLink(s) ? (m = s.link) == null ? void 0 : m.target : void 0,
            class: "our-schools-block"
          }, {
            default: S(() => [
              M(e.$slots, "controls", { idx: l }, void 0, !0),
              (d(), L(Y(s.image ? "img" : "div"), {
                src: s.image.url,
                class: "our-schools-image",
                loading: "lazy",
                alt: ""
              }, null, 8, ["src"])),
              c("div", {
                class: _(["our-schools-block-text", e.theme.style])
              }, [
                M(e.$slots, "box", { idx: l }, () => [
                  H(k(s.box), 1)
                ], !0)
              ], 2),
              s.icon || e.isEditing ? (d(), f("div", xse, [
                c("div", Wse, [
                  c("span", Yse, [
                    M(e.$slots, "icon", { idx: l }, () => [
                      c("span", {
                        innerHTML: s.icon
                      }, null, 8, Xse)
                    ], !0)
                  ])
                ])
              ])) : T("", !0)
            ]),
            _: 2
          }, 1032, ["href", "target"]))
        ];
      }),
      _: 3
    }, 16, ["modelValue"]))
  ], 6);
}
const Jse = /* @__PURE__ */ B(zse, [["render", Qse], ["__scopeId", "data-v-75f4750e"]]), eae = {
  name: "CmsOurSchools",
  components: {
    OS1: Hse,
    OS2: Kse,
    OS3: Jse
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      default: () => ({})
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    },
    isEditing: Boolean
  }
}, tae = { class: "our-schools-container" };
function nae(e, t, n, r, o, i) {
  return d(), f("div", tae, [
    (d(), L(Y(n.theme.version), {
      theme: n.theme,
      blocks: n.content,
      "wrapper-component": n.wrapperComponent,
      "wrapper-props": n.wrapperProps,
      "is-editing": n.isEditing
    }, {
      "header-top": S(() => [
        M(e.$slots, "header-top", {}, void 0, !0)
      ]),
      "header-bottom": S(() => [
        M(e.$slots, "header-bottom", {}, void 0, !0)
      ]),
      header: S(() => [
        M(e.$slots, "header", {}, void 0, !0)
      ]),
      "header-description": S(() => [
        M(e.$slots, "header-description", {}, void 0, !0)
      ]),
      controls: S(({ idx: a }) => [
        M(e.$slots, "controls", { idx: a }, void 0, !0)
      ]),
      image: S(({ idx: a }) => [
        M(e.$slots, "image", { idx: a }, void 0, !0)
      ]),
      box: S(({ idx: a }) => [
        M(e.$slots, "box", { idx: a }, void 0, !0)
      ]),
      icon: S(({ idx: a }) => [
        M(e.$slots, "icon", { idx: a }, void 0, !0)
      ]),
      _: 3
    }, 8, ["theme", "blocks", "wrapper-component", "wrapper-props", "is-editing"]))
  ]);
}
const rae = /* @__PURE__ */ B(eae, [["render", nae], ["__scopeId", "data-v-89630ecf"]]), oae = {
  components: {
    CustomHtml: Ys
  },
  props: {
    theme: {
      type: Object,
      default: () => {
      }
    },
    content: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    processedTheme() {
      if (!this.theme.section || this.theme.section.type === "none" || qr(this.content))
        return this.theme;
      let e = "";
      try {
        e = Y3(this.theme.html_code, this.theme.section.type, this.content);
      } catch (t) {
        e = t;
      }
      return ge(ae({}, this.theme), {
        html_code: e
      });
    }
  }
}, iae = { class: "media-custom-code" };
function sae(e, t, n, r, o, i) {
  const a = V("CustomHtml");
  return d(), f("div", iae, [
    j(a, { theme: i.processedTheme }, null, 8, ["theme"])
  ]);
}
const aae = /* @__PURE__ */ B(oae, [["render", sae]]), $8 = {
  mixins: [St],
  components: { DraggableWrapper: yt },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      default: () => ({})
    },
    isPreview: {
      type: Boolean,
      default: !1
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isActive: !1,
      isOverflow: !1,
      debouncedHandleResize: null,
      hasShadowLeft: !1,
      hasShadowRight: !1
    };
  },
  created() {
    this.isActive = this.isPreview || this.isEditing, this.debouncedHandleResize = go(this.handleResize, 100);
  },
  mounted() {
    this.handleResize(), window.addEventListener("resize", this.debouncedHandleResize), window.addEventListener("scroll", this.onWindowScroll);
  },
  unmounted() {
    window.removeEventListener("resize", this.debouncedHandleResize), window.removeEventListener("scroll", this.onWindowScroll);
  },
  methods: {
    handleResize() {
      this.isOverflow = this.$refs.flexWrapper.scrollWidth > this.$refs.scrollWrapper.offsetWidth, this.handleScroll();
    },
    handleScroll() {
      const e = this.$refs.scrollWrapper;
      if (!e || !this.isOverflow) {
        this.hasShadowLeft = !1, this.hasShadowRight = !1;
        return;
      }
      this.hasShadowLeft = e.scrollLeft > 0, this.hasShadowRight = e.scrollWidth - e.scrollLeft - e.clientWidth > 1;
    },
    onScroll(e = "left", t = 120) {
      const o = {
        left: t * (e === "left" ? -1 : 1),
        behavior: "smooth"
      };
      this.$refs.scrollWrapper.scrollBy(ae({}, o));
    },
    stickyFooterActiveToggle() {
      this.isActive = !this.isActive;
    },
    onWindowScroll() {
      window.scrollY > window.innerHeight / 2 && (this.isActive = !0, window.removeEventListener("scroll", this.onWindowScroll));
    }
  },
  computed: {
    toggleButtonText() {
      return this.isActive ? this.content.hide_text_label || "hide" : this.content.show_text_label || "show";
    },
    hasPillButton() {
      return this.content.show_pill_button || this.isPreview;
    },
    hasSocialIcons() {
      return this.content.show_social_icons || this.isPreview;
    },
    cssVars() {
      const e = this.sharedThemeColors();
      return ge(ae({}, e), {
        "--bg-color": $(this.theme, "bg_color.hex", "#333"),
        "--hide-button-and-bar-color": $(this.theme, "hide_button_and_bar_color.hex", "#f8cb43"),
        "--hide-button-text-color": $(this.theme, "hide_button_text_color.hex", "#fff"),
        "--icon-color": $(this.theme, "icon_color.hex", "#fff"),
        "--icon-text-color": $(this.theme, "icon_text_color.hex", "#fff"),
        "--social-media-icon-color": $(this.theme, "social_media_icon_color.hex", "#fff"),
        "--pill-button-color": $(this.theme, "pill_button_color.hex", "#f8cb43"),
        "--pill-button-text-color": $(this.theme, "pill_button_text_color.hex", "#333"),
        "--separator-color": $(this.theme, "separator_color.hex", "#fff"),
        "--scroll-shadow-color": `${nh($(this.theme, "bg_color.hex", "#333")).join(", ")}`
      });
    },
    translations() {
      return this.theme.translations;
    }
  }
}, lae = {
  name: "StickyFooterV1",
  mixins: [$8]
}, uae = { class: "text" }, dae = {
  ref: "scrollWrapper",
  class: "scroll-wrapper"
}, cae = {
  ref: "flexWrapper",
  class: "flex-wrapper"
}, hae = { class: "icon-wrapper" }, mae = ["innerHTML"], fae = { class: "title" }, pae = { class: "icon-wrapper" }, gae = ["innerHTML"];
function vae(e, t, n, r, o, i) {
  return d(), f("div", {
    class: _([
      "sticky-footer-v1",
      e.theme.style,
      {
        "sf-active": e.isActive
      }
    ]),
    style: Z(e.cssVars),
    "data-testid": "StickyFooterV1"
  }, [
    c("div", {
      class: _([
        "sticky-footer-wrapper",
        {
          "sf-active": e.isActive,
          "sf-overflow": e.isOverflow,
          "sf-editing": e.isEditing
        }
      ])
    }, [
      M(e.$slots, "toggle", {}, () => [
        c("button", {
          class: _(["hs-toggle-button", [{ "sf-active": e.isActive }]]),
          onClick: t[0] || (t[0] = (...a) => e.stickyFooterActiveToggle && e.stickyFooterActiveToggle(...a))
        }, [
          c("span", uae, k(e.toggleButtonText), 1),
          c("div", {
            class: _(["icon-arrow", { "sf-active": e.isActive }])
          }, null, 2)
        ], 2)
      ], !0),
      c("div", dae, [
        e.isOverflow ? (d(), f("button", {
          key: 0,
          class: "scroll-button left",
          onClick: t[1] || (t[1] = (a) => e.onScroll("left"))
        }, t[5] || (t[5] = [
          c("div", { class: "icon-arrow" }, null, -1)
        ]))) : T("", !0),
        c("div", cae, [
          e.hasPillButton ? (d(), L(Y(e.isEditing ? "div" : "a"), {
            key: 0,
            class: "pill-button",
            "data-testid": "pill-button",
            href: e.content.pill_button.link,
            target: e.content.pill_button.opens_in_new_tab ? "_blank" : ""
          }, {
            default: S(() => [
              M(e.$slots, "pill-button-controls", {}, void 0, !0),
              M(e.$slots, "pill-button-title", {}, () => [
                H(k(e.content.pill_button.title), 1)
              ], !0)
            ]),
            _: 3
          }, 8, ["href", "target"])) : T("", !0),
          (d(), L(Y(e.wrapperComponent), Se(e.wrapperProps, {
            modelValue: e.content.icon_buttons,
            "onUpdate:modelValue": t[2] || (t[2] = (a) => e.content.icon_buttons = a),
            "item-key": "index",
            class: "icon-buttons"
          }), {
            item: S(({ element: a, index: s }) => [
              (d(), L(Y(e.isEditing ? "div" : "a"), {
                id: a.icon_id,
                class: "button",
                "data-testid": "icon-button",
                href: a.link,
                target: a.opens_in_new_tab ? "_blank" : ""
              }, {
                default: S(() => [
                  M(e.$slots, "icon-button-controls", { idx: s }, void 0, !0),
                  c("div", hae, [
                    M(e.$slots, "icon-button-icon", { idx: s }, () => [
                      c("span", {
                        innerHTML: a.icon
                      }, null, 8, mae)
                    ], !0)
                  ]),
                  c("span", fae, [
                    M(e.$slots, "icon-button-title", { idx: s }, () => [
                      H(k(a.title), 1)
                    ], !0)
                  ])
                ]),
                _: 2
              }, 1032, ["id", "href", "target"]))
            ]),
            _: 3
          }, 16, ["modelValue"])),
          e.hasSocialIcons ? (d(), L(Y(e.wrapperComponent), Se({ key: 1 }, e.wrapperProps, {
            modelValue: e.content.social_media_icons,
            "onUpdate:modelValue": t[3] || (t[3] = (a) => e.content.social_media_icons = a),
            "item-key": "index",
            class: "social-media"
          }), {
            item: S(({ element: a, index: s }) => [
              (d(), L(Y(e.isEditing ? "div" : "a"), {
                id: a.icon_id,
                class: "icons",
                "data-testid": "social-media-button",
                href: a.link,
                target: a.opens_in_new_tab ? "_blank" : ""
              }, {
                default: S(() => [
                  M(e.$slots, "social-media-controls", { idx: s }, void 0, !0),
                  c("div", pae, [
                    M(e.$slots, "social-media-icon", { idx: s }, () => [
                      c("span", {
                        innerHTML: a.icon
                      }, null, 8, gae)
                    ], !0)
                  ])
                ]),
                _: 2
              }, 1032, ["id", "href", "target"]))
            ]),
            _: 3
          }, 16, ["modelValue"])) : T("", !0)
        ], 512),
        e.isOverflow ? (d(), f("button", {
          key: 1,
          class: "scroll-button right",
          onClick: t[4] || (t[4] = (a) => e.onScroll("right"))
        }, t[6] || (t[6] = [
          c("div", { class: "icon-arrow" }, null, -1)
        ]))) : T("", !0)
      ], 512)
    ], 2)
  ], 6);
}
const bae = /* @__PURE__ */ B(lae, [["render", vae], ["__scopeId", "data-v-90ce29f3"]]), yae = {
  name: "StickyFooterV2",
  mixins: [$8]
}, _ae = ["aria-expanded"], Cae = { class: "text" }, wae = { class: "icon-wrapper" }, Tae = ["innerHTML"], kae = { class: "icon-wrapper" }, Eae = ["innerHTML"], Sae = { class: "title" };
function Mae(e, t, n, r, o, i) {
  var a, s;
  return d(), f("div", {
    class: _([
      "sticky-footer-v2",
      e.theme.style,
      {
        "sf-active": e.isActive
      }
    ]),
    style: Z(e.cssVars),
    "data-testid": "StickyFooterV2"
  }, [
    c("div", {
      class: _(["sticky-footer-wrapper", [
        {
          "sf-active": e.isActive,
          "sf-overflow": e.isOverflow,
          "sf-editing": e.isEditing
        }
      ]])
    }, [
      M(e.$slots, "toggle", {}, () => [
        c("button", {
          class: _(["hs-toggle-button", [{ "sf-active": e.isActive }]]),
          "aria-label": "Toggle Footer",
          "aria-expanded": e.isActive,
          onClick: t[0] || (t[0] = (...l) => e.stickyFooterActiveToggle && e.stickyFooterActiveToggle(...l))
        }, [
          c("span", Cae, k(e.toggleButtonText), 1),
          c("span", {
            class: _(["icon-arrow", { "sf-active": e.isActive }])
          }, null, 2)
        ], 10, _ae)
      ], !0),
      c("div", {
        ref: "scrollWrapper",
        class: _(["scroll-wrapper", { "has-shadow-left": e.hasShadowLeft, "has-shadow-right": e.hasShadowRight }]),
        onScrollPassive: t[5] || (t[5] = (...l) => e.handleScroll && e.handleScroll(...l))
      }, [
        e.isOverflow ? (d(), f("button", {
          key: 0,
          "aria-label": "Scroll left",
          class: "scroll-button left",
          onClick: t[1] || (t[1] = (l) => e.onScroll("left"))
        }, t[6] || (t[6] = [
          c("span", { class: "icon-arrow" }, null, -1)
        ]))) : T("", !0),
        c("div", {
          ref: "flexWrapper",
          class: _(["flex-wrapper", { center: !e.hasSocialIcons && !e.hasPillButton }])
        }, [
          e.hasSocialIcons ? (d(), L(Y(e.wrapperComponent), Se({ key: 0 }, e.wrapperProps, {
            modelValue: e.content.social_media_icons,
            "onUpdate:modelValue": t[2] || (t[2] = (l) => e.content.social_media_icons = l),
            "item-key": "index",
            class: "social-media"
          }), {
            item: S(({ element: l, index: u }) => [
              (d(), L(Y(e.isEditing ? "div" : "a"), {
                id: l.icon_id,
                class: "icons",
                "data-testid": "social-media-button",
                href: l.link,
                target: l.opens_in_new_tab ? "_blank" : ""
              }, {
                default: S(() => [
                  c("div", wae, [
                    M(e.$slots, "social-media-icon", { idx: u }, () => [
                      c("span", {
                        innerHTML: l.icon
                      }, null, 8, Tae)
                    ], !0)
                  ]),
                  M(e.$slots, "social-media-controls", { idx: u }, void 0, !0)
                ]),
                _: 2
              }, 1032, ["id", "href", "target"]))
            ]),
            _: 3
          }, 16, ["modelValue"])) : T("", !0),
          (d(), L(Y(e.wrapperComponent), Se(e.wrapperProps, {
            modelValue: e.content.icon_buttons,
            "onUpdate:modelValue": t[3] || (t[3] = (l) => e.content.icon_buttons = l),
            "item-key": "index",
            class: "icon-buttons"
          }), {
            item: S(({ element: l, index: u }) => [
              (d(), L(Y(e.isEditing ? "div" : "a"), {
                id: l.icon_id,
                class: "button",
                "data-testid": "icon-button",
                href: l.link,
                target: l.opens_in_new_tab ? "_blank" : ""
              }, {
                default: S(() => [
                  c("div", kae, [
                    M(e.$slots, "icon-button-icon", { idx: u }, () => [
                      c("span", {
                        innerHTML: l.icon
                      }, null, 8, Eae)
                    ], !0)
                  ]),
                  c("span", Sae, [
                    M(e.$slots, "icon-button-title", { idx: u }, () => [
                      H(k(l.title), 1)
                    ], !0)
                  ]),
                  M(e.$slots, "icon-button-controls", { idx: u }, void 0, !0)
                ]),
                _: 2
              }, 1032, ["id", "href", "target"]))
            ]),
            _: 3
          }, 16, ["modelValue"])),
          e.hasPillButton ? (d(), L(Y(e.isEditing ? "div" : "a"), {
            key: 1,
            class: "pill-button",
            "data-testid": "pill-button",
            href: (a = e.content.pill_button) == null ? void 0 : a.link,
            target: (s = e.content.pill_button) != null && s.opens_in_new_tab ? "_blank" : ""
          }, {
            default: S(() => [
              M(e.$slots, "pill-button-title", {}, () => {
                var l;
                return [
                  H(k((l = e.content.pill_button) == null ? void 0 : l.title), 1)
                ];
              }, !0),
              M(e.$slots, "pill-button-controls", {}, void 0, !0)
            ]),
            _: 3
          }, 8, ["href", "target"])) : T("", !0)
        ], 2),
        e.isOverflow ? (d(), f("button", {
          key: 1,
          "aria-label": "Scroll right",
          class: "scroll-button right",
          onClick: t[4] || (t[4] = (l) => e.onScroll("right"))
        }, t[7] || (t[7] = [
          c("span", { class: "icon-arrow" }, null, -1)
        ]))) : T("", !0)
      ], 34)
    ], 2)
  ], 6);
}
const Aae = /* @__PURE__ */ B(yae, [["render", Mae], ["__scopeId", "data-v-23bc8461"]]), Iae = {
  name: "StickyFooter",
  components: {
    StickyFooterV1: bae,
    StickyFooterV2: Aae
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      default: () => ({})
    },
    isPreview: {
      type: Boolean,
      default: !1
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  }
};
function Lae(e, t, n, r, o, i) {
  return d(), L(Y(n.theme.version), {
    theme: n.theme,
    content: n.content,
    "wrapper-component": n.wrapperComponent,
    "wrapper-props": n.wrapperProps,
    "is-preview": n.isPreview,
    "is-editing": n.isEditing
  }, {
    toggle: S(() => [
      M(e.$slots, "toggle")
    ]),
    "pill-button-controls": S(() => [
      M(e.$slots, "pill-button-controls")
    ]),
    "pill-button-title": S(({ title: a }) => [
      M(e.$slots, "pill-button-title", { title: a })
    ]),
    "icon-button-controls": S(({ idx: a }) => [
      M(e.$slots, "icon-button-controls", { idx: a })
    ]),
    "icon-button-title": S(({ title: a, idx: s }) => [
      M(e.$slots, "icon-button-title", {
        title: a,
        idx: s
      })
    ]),
    "icon-button-icon": S(({ idx: a }) => [
      M(e.$slots, "icon-button-icon", { idx: a })
    ]),
    "social-media-controls": S(({ idx: a }) => [
      M(e.$slots, "social-media-controls", { idx: a })
    ]),
    "social-media-icon": S(({ idx: a }) => [
      M(e.$slots, "social-media-icon", { idx: a })
    ]),
    _: 3
  }, 8, ["theme", "content", "wrapper-component", "wrapper-props", "is-preview", "is-editing"]);
}
const Dae = /* @__PURE__ */ B(Iae, [["render", Lae]]), $ae = {
  name: "CustomComponent",
  components: { DraggableWrapper: yt },
  props: {
    theme: {
      type: Object,
      default: () => ({})
    },
    content: {
      type: Object,
      default: () => ({})
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    isPreview: {
      type: Boolean,
      default: !1
    },
    wrapperComponent: {
      type: Object,
      default: yt,
      validator(e) {
        return (e == null ? void 0 : e.name) === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    }
  },
  computed: {
    cssCode() {
      return this.theme.css_code;
    },
    jsCode() {
      return this.theme.js_code;
    },
    htmlTree() {
      let e = {};
      try {
        e = JV(this.theme.html_code);
      } catch (t) {
        e = "";
      }
      return e;
    }
  },
  watch: {
    cssCode(e, t) {
      this.hasNewValue(e, t) && this.mountCss(e);
    },
    jsCode(e, t) {
      this.hasNewValue(e, t) && this.mountJs(e);
    },
    htmlCode(e, t) {
      this.hasNewValue(e, t) && this.mountJs(this.jsCode);
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.mountCss(this.cssCode), this.mountJs(this.jsCode);
    });
  },
  methods: {
    customComponent(e) {
      return {
        "cms-input": { slotName: "input", tag: "span" },
        "cms-textarea": {
          slotName: "textarea",
          tag: "span",
          style: "white-space: pre-line;"
        },
        "cms-image": { slotName: "image", tag: "span" },
        "cms-icon": { slotName: "icon", tag: "span" },
        "cms-richtextarea": {
          slotName: "richtextarea",
          tag: "span"
        }
      }[e];
    },
    hasNewValue(e, t) {
      return e && e.localeCompare && e.localeCompare(t) !== 0;
    },
    mountCss(e) {
      this.removeElementIfExists("style");
      const t = document.createElement("style");
      t.type = "text/css", t.appendChild(document.createTextNode(e)), this.$el.appendChild(t);
    },
    mountJs(e) {
      this.componentKey += 1, this.$nextTick(() => {
        this.removeElementIfExists("script");
        const t = document.createElement("script");
        t.type = "text/javascript", t.appendChild(document.createTextNode(e)), this.$el.appendChild(t);
      });
    },
    removeElementIfExists(e) {
      const t = document.querySelector(`#${this.id} ${e}`);
      t && t.remove();
    },
    dragHandler(e, t) {
      this.$emit("on-drag", {
        oldIndex: e.oldIndex,
        newIndex: e.newIndex,
        loopName: t
      });
    }
  },
  render() {
    var r;
    const e = (o) => {
      if (!o.properties) return {};
      const i = Object.entries(o.properties).filter(([a]) => a.startsWith("data"));
      return i.length ? i.reduce(
        (a, [s, l]) => ge(ae({}, a), {
          [s.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()]: l
        }),
        {}
      ) : {};
    }, t = (o, i, a) => {
      var l, u, m, v, g, h, E, C, A;
      const s = ae({
        id: (l = o.properties) == null ? void 0 : l.id,
        class: (u = o.properties) == null ? void 0 : u.className,
        style: (m = this.customComponent(o.tagName)) == null ? void 0 : m.style,
        className: (g = (v = o.properties) == null ? void 0 : v.className) == null ? void 0 : g.join(" "),
        name: null,
        link: null,
        limit: null,
        src: (h = o.properties) == null ? void 0 : h.src,
        alt: (E = o.properties) == null ? void 0 : E.alt,
        "aspect-ratio": null
      }, e(o));
      if (o.tagName === "cms-loop") {
        const R = () => {
          var I, D;
          const P = ((I = this.content.loop) == null ? void 0 : I[o.properties.name]) || [];
          return [
            ...Array(this.isPreview ? Number((D = o.properties) == null ? void 0 : D.limit) || 5 : P.length || 1)
          ].map(
            (O, U) => {
              var q, z, te;
              return oo("div", {}, [
                (z = (q = this.$slots).dragControls) == null ? void 0 : z.call(q, {
                  loopName: o.properties.name,
                  loopIndex: U
                })[0],
                ...(te = o.children) == null ? void 0 : te.map((ee) => t(ee, o.properties.name, U))
              ]);
            }
          );
        };
        return oo(
          this.wrapperComponent,
          ge(ae({}, s), {
            itemKey: "index",
            modelValue: R(),
            class: [...(s == null ? void 0 : s.class) || "", this.isEditing ? "custom-component-loop-wrapper" : ""],
            handle: ".drag-handle",
            onUpdate: (P) => this.dragHandler(P, o.properties.name)
          }),
          {
            item: ({ element: P }) => P,
            footer: () => {
              var P, F, I, D, O, U;
              return [
                [
                  !o.properties.limit || !((F = (P = this.content.loop) == null ? void 0 : P[o.properties.name]) != null && F.length) || Number(o.properties.limit) > ((D = (I = this.content.loop) == null ? void 0 : I[o.properties.name]) == null ? void 0 : D.length) ? (U = (O = this.$slots).addLoopElement) == null ? void 0 : U.call(O, {
                    loopName: o.properties.name
                  })[0] : []
                ]
              ];
            }
          }
        );
      }
      return this.customComponent(o.tagName) ? oo(this.customComponent(o.tagName).tag, s, [
        this.$slots[this.customComponent(o.tagName).slotName]({
          customName: o.properties.name,
          link: o.properties.hasOwnProperty("link"),
          aspectRatio: (C = o.properties["aspect-ratio"]) != null ? C : "unset",
          inLoop: !!i,
          loopName: i,
          loopIndex: a
        })[0]
      ]) : o.type === "text" ? o.value : oo(
        o.tagName,
        s,
        (A = o.children) == null ? void 0 : A.map((R) => t(R, i, a))
      );
    }, n = (r = this.htmlTree.children) == null ? void 0 : r.map((o) => t(o));
    return oo("div", { id: this.theme.container_id }, n);
  }
}, Oae = {
  mixins: [St, b8],
  components: { DraggableWrapper: yt },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    timeline: {
      type: Object,
      default: () => ({})
    },
    isPreview: {
      type: Boolean,
      default: !1
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      carrouselItems: this.timeline.items || [],
      isAutoScroll: this.timeline.auto_scroll
    };
  },
  mounted() {
    this.isAutoScroll && !this.isEditing && !this.timeline.hide_component && this.startAutoScroll();
  },
  methods: {
    getAriaLabel(e, t) {
      return `item ${this.getItemNumber(e)} of ${this.carrouselItems.length}, ${t.year}, ${t.title}, ${t.description}, 'Use the left and right arrow keys to navigate'`;
    }
  },
  computed: {
    playPauseAriaLabel() {
      return this.isAutoScroll ? "Pause timeline autoscroll" : "Start timeline autoscroll";
    },
    cssVars() {
      const e = this.sharedThemeColors();
      return ge(ae({}, e), {
        "--bg-color": $(this.theme, "bg_color.hex", "#000"),
        "--button-bg-color": $(this.theme, "button_bg_color.hex", "#fff"),
        "--button-icon-color": $(this.theme, "button_icon_color.hex", "#fff"),
        "--name-color": $(this.theme, "name_color.hex", "#fff"),
        "--wave-line-color": $(this.theme, "wave_line_color.hex", "#fff"),
        "--scroll-text-color": $(this.theme, "scroll_text_color.hex", "#fff"),
        "--year-text-color": $(this.theme, "year_text_color.hex", "#fff"),
        "--year-bg-color": $(this.theme, "year_bg_color.hex", "#000"),
        "--card-text-color": $(this.theme, "card_text_color.hex", "#fff")
      });
    },
    translations() {
      return this.theme.translations;
    }
  }
}, Pae = {
  name: "TimelineV1",
  mixins: [Oae]
}, Nae = { class: "timeline-wrapper" }, Hae = ["data-testid"], Fae = {
  key: 1,
  class: "timeline-box"
}, Rae = {
  class: "buttons-container",
  role: "none"
}, Vae = ["aria-label"], Bae = {
  key: 0,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, jae = {
  key: 1,
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, Uae = ["id", "tabindex", "aria-label"], qae = { class: "item-image" }, Gae = { class: "item-year" }, Kae = { class: "item-body-text" }, zae = { class: "item-description" }, Zae = { class: "item-title" }, xae = {
  class: "navigation-instructions",
  "aria-live": "assertive",
  "aria-atomic": "true"
}, Wae = { key: 0 }, Yae = { class: "item carrousel-item" }, Xae = { class: "item-image edit" }, Qae = { class: "item-year" }, Jae = { class: "item-body-text" }, ele = { class: "item-description" }, tle = { class: "item-title" };
function nle(e, t, n, r, o, i) {
  const a = V("SeeAllContainer");
  return d(), f("div", {
    style: Z(e.cssVars),
    class: _([
      "timeline-v1",
      e.theme.style,
      { "is-editing": e.isEditing },
      { animated: e.theme.wave_animations },
      { hide: e.timeline.hide_component }
    ]),
    "data-testid": "TimelineV1"
  }, [
    c("div", Nae, [
      e.timeline.show_component_header ? (d(), L(a, {
        key: 0,
        class: _(["timeline-header see-all-top", e.theme.style]),
        "theme-options": e.theme
      }, {
        header: S(() => [
          c("h2", {
            "data-testid": `header-${e.theme.style}-top`
          }, [
            M(e.$slots, "header", {}, () => [
              H(k(e.timeline.component_header), 1)
            ], !0)
          ], 8, Hae)
        ]),
        _: 3
      }, 8, ["class", "theme-options"])) : T("", !0),
      e.isEditing ? (d(), L(Y(e.wrapperComponent), Se({ key: 2 }, e.wrapperProps, {
        modelValue: e.timeline.items,
        "onUpdate:modelValue": t[13] || (t[13] = (s) => e.timeline.items = s),
        "item-key": "id",
        class: "draggable-carrousel editable"
      }), {
        item: S(({ element: s, index: l }) => [
          c("div", Yae, [
            c("div", Xae, [
              M(e.$slots, "image", { idx: l }, void 0, !0),
              (d(), L(Y(s.image.url ? "img" : "div"), {
                src: s.image.url,
                alt: s.image.alt_text,
                class: "image"
              }, null, 8, ["src", "alt"])),
              c("span", Qae, [
                M(e.$slots, "year", { idx: l }, () => [
                  H(k(s.year), 1)
                ], !0)
              ]),
              c("div", Jae, [
                c("span", ele, [
                  M(e.$slots, "description", { idx: l }, () => [
                    H(k(s.description), 1)
                  ], !0)
                ]),
                c("span", tle, [
                  M(e.$slots, "title", { idx: l }, () => [
                    H(k(s.title), 1)
                  ], !0)
                ])
              ])
            ])
          ])
        ]),
        _: 3
      }, 16, ["modelValue"])) : (d(), f("div", Fae, [
        t[18] || (t[18] = c("svg", {
          class: "wave-line primary-wave",
          viewBox: "0 24 150 28",
          preserveAspectRatio: "none",
          "shape-rendering": "auto"
        }, [
          c("defs", null, [
            c("path", {
              id: "wave",
              d: "M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
            })
          ]),
          c("use", {
            "xlink:href": "#wave",
            x: "50",
            y: "0"
          })
        ], -1)),
        c("div", Rae, [
          e.timeline.auto_scroll ? T("", !0) : (d(), f("button", {
            key: 0,
            class: "slider-button left prev",
            "aria-label": "previous item",
            role: "none",
            onKeyup: t[0] || (t[0] = K((s) => e.moveItem({ direction: "prev" }), ["left"])),
            onClick: t[1] || (t[1] = (s) => e.moveItem({ direction: "prev" }))
          }, t[14] || (t[14] = [
            c("svg", {
              dth: "15",
              height: "28",
              viewBox: "0 0 15 28",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              c("path", {
                fill: "white",
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M3 14L15 1.5L13.5 -1.31134e-07L-1.30849e-05 14.0428L13.5 28L15 26.5L3 14Z"
              })
            ], -1)
          ]), 32)),
          e.timeline.auto_scroll ? T("", !0) : (d(), f("button", {
            key: 1,
            class: "slider-button right next",
            "aria-label": "next item",
            role: "none",
            onKeyup: t[2] || (t[2] = K((s) => e.moveItem({ direction: "next" }), ["right"])),
            onClick: t[3] || (t[3] = (s) => e.moveItem({ direction: "next" }))
          }, t[15] || (t[15] = [
            c("svg", {
              dth: "15",
              height: "28",
              viewBox: "0 0 15 28",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              c("path", {
                fill: "white",
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M3 14L15 1.5L13.5 -1.31134e-07L-1.30849e-05 14.0428L13.5 28L15 26.5L3 14Z"
              })
            ], -1)
          ]), 32)),
          e.timeline.auto_scroll ? (d(), f("button", {
            key: 2,
            class: "play-pause",
            "aria-label": e.playPauseAriaLabel,
            onClick: t[4] || (t[4] = (...s) => e.toggleAutoScroll && e.toggleAutoScroll(...s))
          }, [
            e.isAutoScroll ? (d(), f("svg", Bae, t[16] || (t[16] = [
              c("g", null, [
                c("path", {
                  d: "M8 6V18",
                  "stroke-linecap": "round"
                }),
                c("path", {
                  d: "M16 6V18",
                  "stroke-linecap": "round"
                })
              ], -1)
            ]))) : (d(), f("svg", jae, t[17] || (t[17] = [
              c("g", null, [
                c("path", { d: "M18.25 11.567C18.5833 11.7594 18.5833 12.2406 18.25 12.433L7.75 18.4952C7.41667 18.6876 7 18.4471 7 18.0622L7 5.93782C7 5.55292 7.41667 5.31236 7.75 5.50481L18.25 11.567Z" })
              ], -1)
            ])))
          ], 8, Vae)) : T("", !0)
        ]),
        c("div", {
          ref: "carrousel",
          role: "none",
          class: "carrousel",
          onTouchstart: t[9] || (t[9] = (...s) => e.handleSwipeStart && e.handleSwipeStart(...s)),
          onTouchend: t[10] || (t[10] = (...s) => e.handleSwipeEnd && e.handleSwipeEnd(...s)),
          onMousedown: t[11] || (t[11] = (...s) => e.handleSwipeStart && e.handleSwipeStart(...s)),
          onMouseup: t[12] || (t[12] = (...s) => e.handleSwipeEnd && e.handleSwipeEnd(...s))
        }, [
          (d(!0), f(J, null, ne(e.content, (s, l) => (d(), f("div", {
            id: `carrousel-item-${l}`,
            key: l,
            tabindex: l === 3 ? 0 : -1,
            class: "item carrousel-item",
            "aria-label": e.getAriaLabel(l, s),
            role: "group",
            onKeyup: [
              t[5] || (t[5] = K((u) => e.moveItem({ direction: "prev", autofocus: !0 }), ["left"])),
              t[6] || (t[6] = K((u) => e.moveItem({ direction: "next", autofocus: !0 }), ["right"]))
            ],
            onFocus: t[7] || (t[7] = (...u) => e.handleFocus && e.handleFocus(...u)),
            onBlur: t[8] || (t[8] = (...u) => e.handleBlur && e.handleBlur(...u))
          }, [
            c("div", qae, [
              (d(), L(Y(s.image.url ? "img" : "div"), {
                src: s.image.url,
                alt: s.image.alt_text,
                class: "image"
              }, null, 8, ["src", "alt"])),
              c("span", Gae, k(s.year), 1),
              c("div", Kae, [
                c("span", zae, k(s.description), 1),
                c("span", Zae, k(s.title), 1)
              ])
            ])
          ], 40, Uae))), 128))
        ], 544),
        t[19] || (t[19] = c("svg", {
          class: "wave-line secondary-wave",
          viewBox: "0 24 150 28",
          preserveAspectRatio: "none",
          "shape-rendering": "auto"
        }, [
          c("defs", null, [
            c("path", {
              id: "wave",
              d: "M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
            })
          ]),
          c("use", {
            "xlink:href": "#wave",
            x: "48",
            y: "3"
          })
        ], -1)),
        c("div", xae, [
          e.onFocus ? (d(), f("span", Wae, "Use the left and right arrow keys to navigate")) : T("", !0)
        ])
      ])),
      e.timeline.show_scroll_text ? (d(), f("div", {
        key: 3,
        class: _(["scroll-text", e.theme.style])
      }, [
        M(e.$slots, "scroll", {}, () => [
          H(k(e.timeline.scroll_text), 1)
        ], !0)
      ], 2)) : T("", !0)
    ])
  ], 6);
}
const rle = /* @__PURE__ */ B(Pae, [["render", nle], ["__scopeId", "data-v-b253921a"]]), ole = {
  name: "Timeline",
  components: {
    TimelineV1: rle
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    timeline: {
      type: Object,
      default: () => ({})
    },
    isPreview: {
      type: Boolean,
      default: !1
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    wrapperComponent: {
      type: [String, Object],
      default: "DraggableWrapper",
      validator(e) {
        return e === "DraggableWrapper" || (e == null ? void 0 : e.name) === "draggable";
      }
    },
    wrapperProps: {
      type: Object,
      default: () => ({})
    }
  }
};
function ile(e, t, n, r, o, i) {
  return d(), L(Y(n.theme.version), {
    theme: n.theme,
    timeline: n.timeline,
    "is-preview": n.isPreview,
    "wrapper-component": n.wrapperComponent,
    "wrapper-props": n.wrapperProps,
    "is-editing": n.isEditing
  }, {
    header: S(() => [
      M(e.$slots, "header")
    ]),
    year: S(({ idx: a }) => [
      M(e.$slots, "year", { idx: a })
    ]),
    title: S(({ idx: a }) => [
      M(e.$slots, "title", { idx: a })
    ]),
    description: S(({ idx: a }) => [
      M(e.$slots, "description", { idx: a })
    ]),
    scroll: S(() => [
      M(e.$slots, "scroll")
    ]),
    image: S(({ idx: a }) => [
      M(e.$slots, "image", { idx: a })
    ]),
    _: 3
  }, 8, ["theme", "timeline", "is-preview", "wrapper-component", "wrapper-props", "is-editing"]);
}
const sle = /* @__PURE__ */ B(ole, [["render", ile]]), ale = {
  mixins: [Wt, St],
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      required: !0
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    isPreview: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    colors() {
      const e = this.sharedThemeColors();
      function t(n) {
        const r = $(n, "cta_color_option") === "solid", o = $(n, "cta_gradient_direction", "down"), i = $(n, "cta_background_color.hex", "initial"), a = r ? i : $(n, "cta_background_secondary_color.hex", i);
        return o == "center" ? {
          "--cta-gradient": `radial-gradient(${i}, ${a})`,
          "--cta-gradient-fancy": `radial-gradient(in oklch, ${i}, ${a})`
        } : {
          "--cta-gradient": `linear-gradient(to ${o}, ${i}, ${a})`,
          "--cta-gradient-fancy": `linear-gradient(in oklch to ${o}, ${i}, ${a})`
        };
      }
      return ge(ae(ae({}, e), t(this.theme)), {
        "--cta-title-color": $(this.theme, "cta_title_color.hex", "initial"),
        "--cta-subtitle-color": $(this.theme, "cta_subtitle_color.hex", "initial"),
        "--cta-divider-color": $(this.theme, "cta_divider_color.hex", "initial"),
        "--cta-text-color": $(this.theme, "cta_text_color.hex", "initial"),
        "--cta-border-color": $(this.theme, "cta_border_color.hex", "initial"),
        "--cta-border-width": $(this.theme, "cta_border_width", "1") + "px",
        "--cta-button-color": $(this.theme, "cta_button_color.hex", "initial"),
        "--cta-button-text-color": $(this.theme, "cta_button_text_color.hex", "initial"),
        "--cta-button-hover": $(this.theme, "cta_button_hover.hex", "initial"),
        "--cta-overlay-color": ue($(this.theme, "cta_overlay_color.hex", "initial")).setAlpha(0.85).toRgbString()
      });
    },
    translations() {
      return this.theme.translations;
    },
    isMobile() {
      return this.screenSize < 601;
    },
    isBordered() {
      return $(this.theme, "cta_border_enabled", !0);
    },
    isImageEnabled() {
      return $(this.theme, "cta_image_enabled", !0);
    },
    isParallaxEnabled() {
      return $(this.theme, "cta_parallax_enabled", !0);
    },
    buttonStyle() {
      return $(this.theme, "cta_button_style", "solid");
    }
  }
}, lle = {
  name: "CTA1",
  mixins: [ale],
  computed: {
    buttonComponent() {
      return this.isEditing ? "div" : this.isPreview ? "button" : "a";
    }
  }
}, ule = {
  key: 0,
  ref: "parallax",
  class: "parallax-container"
}, dle = {
  key: 1,
  class: "image-container"
}, cle = ["src"], hle = {
  key: 1,
  class: "solid-background"
}, mle = { class: "content-container" }, fle = { class: "cta-title" }, ple = {
  key: 0,
  class: "cta-subtitle"
}, gle = {
  key: 1,
  class: "cta-divider"
}, vle = {
  key: 2,
  class: "cta-text-content"
}, ble = { class: "cta-buttons" };
function yle(e, t, n, r, o, i) {
  var a, s, l, u, m, v, g, h, E;
  return d(), f("div", {
    id: "cta-v1",
    class: _([e.theme.style, { isPreview: e.isPreview, isEditing: e.isEditing }]),
    style: Z(e.colors),
    "data-testid": "CTA1"
  }, [
    e.isImageEnabled && ((a = e.content) != null && a.image) && ((l = (s = e.content) == null ? void 0 : s.image) != null && l.url) ? (d(), f(J, { key: 0 }, [
      e.isParallaxEnabled ? (d(), f("div", ule, [
        c("div", {
          class: "parallax",
          style: Z({ backgroundImage: `url(${(m = (u = e.content) == null ? void 0 : u.image) == null ? void 0 : m.url})` })
        }, null, 4),
        t[0] || (t[0] = c("div", { class: "image-overlay" }, null, -1))
      ], 512)) : (d(), f("div", dle, [
        c("img", {
          class: "full-image",
          src: (g = (v = e.content) == null ? void 0 : v.image) == null ? void 0 : g.url,
          alt: ""
        }, null, 8, cle),
        t[1] || (t[1] = c("div", { class: "image-overlay" }, null, -1))
      ]))
    ], 64)) : (d(), f("div", hle)),
    c("div", {
      class: _(["content-overlay", [e.isBordered && "bordered"]])
    }, [
      c("div", mle, [
        c("h2", fle, [
          M(e.$slots, "title", {
            title: e.content.title
          }, () => [
            H(k(e.content.title), 1)
          ], !0)
        ]),
        e.content.subtitle_enabled ? (d(), f("h3", ple, [
          M(e.$slots, "subtitle", {
            subtitle: e.content.subtitle
          }, () => [
            H(k(e.content.subtitle), 1)
          ], !0)
        ])) : T("", !0),
        e.content.paragraph_enabled ? (d(), f("hr", gle)) : T("", !0),
        e.content.paragraph_enabled ? (d(), f("p", vle, [
          M(e.$slots, "text", {
            text: e.content.text
          }, () => [
            H(k(e.content.text), 1)
          ], !0)
        ])) : T("", !0),
        c("div", ble, [
          (h = e.content.button_1) != null && h.enabled ? (d(), L(Y(i.buttonComponent), {
            key: 0,
            class: _(["cta-button cta-button-1", e.buttonStyle]),
            href: e.content.button_1.link,
            target: e.content.button_1.opens_in_new_tab ? "_blank" : ""
          }, {
            default: S(() => [
              M(e.$slots, "button1", {
                button: e.content.button_1
              }, () => [
                H(k(e.content.button_1.label), 1)
              ], !0)
            ]),
            _: 3
          }, 8, ["class", "href", "target"])) : T("", !0),
          (E = e.content.button_2) != null && E.enabled ? (d(), L(Y(i.buttonComponent), {
            key: 1,
            class: _(["cta-button cta-button-2", e.buttonStyle]),
            href: e.content.button_2.link,
            target: e.content.button_2.opens_in_new_tab ? "_blank" : ""
          }, {
            default: S(() => [
              M(e.$slots, "button2", {
                button: e.content.button_2
              }, () => [
                H(k(e.content.button_2.label), 1)
              ], !0)
            ]),
            _: 3
          }, 8, ["class", "href", "target"])) : T("", !0)
        ])
      ])
    ], 2)
  ], 6);
}
const _le = /* @__PURE__ */ B(lle, [["render", yle], ["__scopeId", "data-v-48f57ea5"]]), Cle = {
  name: "CallToAction",
  components: {
    CTA1: _le
  },
  props: {
    theme: {
      type: Object,
      required: !0
    },
    content: {
      type: Object,
      default: () => ({})
    },
    isEditing: {
      type: Boolean,
      default: !1
    },
    isPreview: {
      type: Boolean,
      default: !1
    }
  }
}, wle = { id: "view-call-to-aciton" };
function Tle(e, t, n, r, o, i) {
  return d(), f("div", wle, [
    (d(), L(Y(n.theme.version), {
      theme: n.theme,
      content: n.content,
      "is-editing": n.isEditing,
      "is-preview": n.isPreview
    }, {
      title: S(() => [
        M(e.$slots, "title")
      ]),
      subtitle: S(() => [
        M(e.$slots, "subtitle")
      ]),
      text: S(() => [
        M(e.$slots, "text")
      ]),
      button1: S(() => [
        M(e.$slots, "button1")
      ]),
      button2: S(() => [
        M(e.$slots, "button2")
      ]),
      _: 3
    }, 8, ["theme", "content", "is-editing", "is-preview"]))
  ]);
}
const kle = /* @__PURE__ */ B(Cle, [["render", Tle]]), sg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CmsAbout: Eie,
  CmsAlertBanner: Hie,
  CmsAlertBannerSeparate: ese,
  CmsAlertModal: $ie,
  CmsAlertModalSeparate: Zie,
  CmsAthletics: moe,
  CmsButtons: Voe,
  CmsCallToAction: kle,
  CmsCustomComponent: $ae,
  CmsCustomHtml: Ys,
  CmsEvents: Xx,
  CmsFloatingNav: Mse,
  CmsFooter: TG,
  CmsGallery: WE,
  CmsHeader: KB,
  CmsLiveFeed: FX,
  CmsMediaCustomHtml: aae,
  CmsMenu: vU,
  CmsOurSchools: rae,
  CmsParallax: ase,
  CmsPrograms: Wz,
  CmsSpotlight: toe,
  CmsStats: xee,
  CmsStickyFooter: Dae,
  CmsTimeline: sle,
  CmsVideo: Ene,
  News: dy
}, Symbol.toStringTag, { value: "Module" })), Ele = {
  install(e) {
    e.use(P6), Object.keys(sg).forEach((t) => {
      e.component(t, sg[t]);
    });
  }
}, Ale = Ele;
export {
  Ale as plugin
};
//# sourceMappingURL=cms-components.es.js.map
